/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 914);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(87);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var core = __webpack_require__(39);
var hide = __webpack_require__(31);
var redefine = __webpack_require__(32);
var ctx = __webpack_require__(40);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(762);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var Reflux = __webpack_require__(197);

Reflux.serverMode = typeof window !== 'object';

Reflux.connect = __webpack_require__(855);

Reflux.connectFilter = __webpack_require__(856);

Reflux.ListenerMixin = __webpack_require__(198);

Reflux.listenTo = __webpack_require__(858);

Reflux.listenToMany = __webpack_require__(859);

__webpack_require__(854);

module.exports = Reflux;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /*global define*/
/**
 * Util module
 * This module contains commonly used functions.
 *
 */


var _2 = __webpack_require__(42);

var _3 = _interopRequireDefault(_2);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _handlebars = __webpack_require__(121);

var _handlebars2 = _interopRequireDefault(_handlebars);

__webpack_require__(335);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Util = {
  /** Convert a float data type to a ratio.
   *
   * @params {number} x: The float number that will be converted to a fraction
   */
  floatToRatio: function floatToRatio(x) {
    var tolerance = 1.0E-6;
    var h1 = 1;var h2 = 0;
    var k1 = 0;var k2 = 1;
    var b = x;
    do {
      var a = Math.floor(b);
      var aux = h1;
      h1 = a * h1 + h2;
      h2 = aux;
      aux = k1;
      k1 = a * k1 + k2;
      k2 = aux;
      b = 1 / (b - a);
    } while (Math.abs(x - h1 / k1) > x * tolerance);

    return h1 + '/' + k1;
  },
  toArray: function toArray(obj) {
    return _3.default.isArray(obj) ? obj : [obj];
  },

  /**
   * Load a CSS  file
   * @param {String} nameOfDoc : Name of a file you want the url for, minus the suffix (.js, .css, etc)
   * @param {String} contentToCut: The beginning of the part of the url you'd like to truncate
   * @param {String} appendContent: The string you'd like to append to the end of your URL
   */
  loadCss: function loadCss(nameOfDoc, contentToCut, appendContent) {
    var url = Util._urlFinder(nameOfDoc, contentToCut, appendContent);

    var link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = url;
    (0, _jquery2.default)('head').append(link);
  },
  /**
   * Find the url of the current file, typically called by
   *
   * @param {string} nameOfDoc : name of the file you want
   * the url for, minus the suffix (.js, .css, etc)
   *
   * @param {string} contentToCut: the beginning of the part
   * of the url you'd like to truncate
   *
   * @param {string} appendContent: the string you'd like to append to the end of your URL
   */
  _urlFinder: function _urlFinder(nameOfDoc, contentToCut, appendContent) {
    var currentUrl = void 0;

    var scriptElements = document.getElementsByTagName('script');
    var i = void 0,
        element = void 0,
        myfile = void 0;

    for (i = 0; element = scriptElements[i]; i++) {
      myfile = element.src;

      if (myfile.indexOf(nameOfDoc) >= 0) {
        currentUrl = myfile.substring(0, myfile.indexOf(nameOfDoc));
      }
    }

    // Cut off end of URL and add relative path to css file needed
    var url = currentUrl.substr(0, currentUrl.indexOf(contentToCut)) + appendContent;

    return url;
  },

  mixin: function mixin() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _3.default.extend.apply(null, args.map(_3.default.clone));
  },
  forceRepaint: function forceRepaint(node) {
    node.style.display = 'none';
    Util.nextTick(function () {
      return node.style.display = '';
    });
  },


  /* Returns true if the current device is mobile, else returns false */
  isMobile: function isMobile() {
    return (/android|webos|ipad|iphone|ipod|blackberry|iemobile|opera mini|windows ce|windows phone/i.test(navigator.userAgent.toLowerCase())
    );
  },

  isTouchDevice: function isTouchDevice() {
    return 'ontouchstart' in window || 'onmsgesturechange' in window;
  },

  /** Returns the current environment the code is running on */
  environment: function environment() {
    // All the code below determines the environment and builds the proper string
    var environments = ['proddev', 'staging', 'qa00', 'qa01', 'qa02'];
    var currentEnv = '';

    // Determine environment
    _jquery2.default.each(environments, function (index, value) {
      if (_jquery2.default.inArray(value, window.location.host.split('.')) === 1) {
        currentEnv = value;
      }
    });

    return currentEnv;
  },

  /**
   * Parse query params into an object
   */

  getParams: function getParams(qs_) {
    var qs = qs_ || window.location.search.substring(1);
    if (!qs) return {};

    return _3.default.chain(qs.split('&')).map(function (seg) {
      return _3.default.map(seg.split('='), decodeURIComponent);
    }).zipObject().value();
  },

  urlToJSONP: function urlToJSONP(dataUrl) {
    var _dataUrl$split = dataUrl.split('?'),
        _dataUrl$split2 = _slicedToArray(_dataUrl$split, 2),
        url = _dataUrl$split2[0],
        query = _dataUrl$split2[1];

    if (query) {
      url += '?' + query + '&';
    } else {
      url += '?';
    }
    url += 'callback=?';
    return url;
  },

  /**
   * Alternate Environment Checking Function, Handles all
   * combination of qa/staging/proddev and inserts a period, for
   * direct use in URLs */
  envCheck: function envCheck() {
    var env = '';
    if (window.location.href.indexOf('.staging.') !== -1) {
      if (window.location.href.match(/\.qa\d\d/) !== null) {
        env = '.staging' + window.location.href.match(/\.qa\d\d/)[0];
      } else {
        env = '.staging';
      }
    } else if (window.location.href.indexOf('.proddev.') !== -1) {
      env = '.proddev';
    } else if (window.location.href.match(/\.qa\d\d/) !== null) {
      env = env + window.location.href.match(/\.qa\d\d/)[0];
    }
    return env;
  },

  /**
   * returns the default image server for but also takes an override for when
   * you're testing locally but you want to override and point at a remote.
   */
  imageServer: function imageServer(env) {
    var sub = env ? env : Util.envCheck();
    var prodEnv = ['www.medscape.com', 'www.medscape.org', 'reference.medscape.com', 'education.webmd.com'];
    var isProd = prodEnv.some(function (envUrl) {
      return window.location.host.indexOf(envUrl) !== -1;
    });
    if (isProd) {
      return '//img.medscapestatic.com';
    }
    if (env === 'override') {
      return '';
    } else if (sub === '' && Util.isLocal()) {
      return '//img.qa01.medscapestatic.com';
    } else {
      return '//img' + sub + '.medscapestatic.com';
    }
  },

  isLocal: function isLocal() {
    return window.location.href.match(/localhost/);
  },

  /** Returns true if the current device is Retina display */
  isRetina: function isRetina() {
    return window.devicePixelRatio > 1;
  },

  /** Returns true if the current device is ipad */
  isIpad: function isIpad() {
    return navigator.userAgent.match(/iPad/i) !== null;
  },
  isIOS: function isIOS(version) {
    var isIOS = Util.isIpad() || navigator.userAgent.match(/iPhone/i);
    if (version) {
      isIOS = isIOS && navigator.userAgent.match(new RegExp('OS ' + version));
    }
    return isIOS;
  },
  isSafari: function isSafari() {
    return Util.isIOS() && navigator.userAgent.indexOf('Safari') > -1;
  },
  isApp: function isApp() {
    return !!navigator.userAgent.toLowerCase().match('medscape');
  },
  isValidEmail: function isValidEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  },
  isIEorEDGE: function isIEorEDGE() {
    return navigator.appName == 'Microsoft Internet Explorer' || navigator.appName == "Netscape" && navigator.appVersion.indexOf('Edge') > -1 || navigator.userAgent.indexOf('Trident/') > -1;
  },
  isEdge: function isEdge() {
    return navigator.appVersion.indexOf('Edge') > -1;
  },

  nextTick: function nextTick(f) {
    setTimeout(f, 0);
  },
  getXhr: function getXhr(url) {
    var Promise = __webpack_require__(714);
    return new Promise(function (resolve, reject) {
      var req = new XMLHttpRequest();
      req.open('GET', url);
      req.onload = function () {
        if (req.status === 200) {
          resolve(req.response);
        } else {
          reject(Error(req.statusText));
        }
      };
      req.onerror = function () {
        reject(Error('Network Error'));
      };
      req.send();
    });
  },
  replaceAll: function replaceAll(target, search, replacement) {
    if (typeof target === 'string') {
      return target.replace(new RegExp(search, 'g'), replacement);
    } else {
      throw {
        name: 'replaceAll Exception',
        message: 'Target type is not a String'
      };
    }
  },
  getLocation: function getLocation(href) {
    var match = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    return match && {
      protocol: match[1],
      host: match[2],
      hostname: match[3],
      port: match[4],
      pathname: match[5],
      search: match[6],
      hash: match[7]
    };
  },

  /**
     * @param {string} prettyTime - Time in the format HH::MM:SS
     * @returns {number} - Seconds
     */
  secondsFromPrettyTime: function secondsFromPrettyTime(prettyTime) {
    return _3.default.reduce(prettyTime.split(':').reverse(), function (state, chunk) {
      return {
        seconds: state.seconds + parseInt(chunk, 10) * state.multiplier,
        multiplier: state.multiplier * 60
      };
    }, { seconds: 0, multiplier: 1 }).seconds;
  },
  /**
   * @param {number} seconds
   * @param {number} [places=3] - The number of places to return. E.g. 3 -> '00:00:00' 2 -> '00:00'
   */
  secondsToPrettyTime: function secondsToPrettyTime(seconds, places) {
    var hours = Math.floor(seconds / 3600),
        minutes = Math.floor((seconds - hours * 3600) / 60),
        times = [hours, minutes, Math.floor(seconds - hours * 3600 - minutes * 60)],
        offset = void 0;

    if (places) {
      offset = times.length - places;
    } else {
      offset = seconds > 60 * 60 ? 0 : 1;
    }

    return _3.default.map(times.slice(offset), function (time) {
      if (isNaN(time)) {
        return '00';
      } else if (time < 10) {
        return '0' + time;
      } else {
        return time.toString();
      }
    }).join(':');
  },
  getCompiledHtml: function getCompiledHtml(html) {
    var staticPath = '' + window.medscape.config.staticServer.host + window.medscape.config.staticServer.path;
    var appPath = '' + window.medscape.config.appServer.host + window.medscape.config.appServer.path;
    var user = window.medscape.user;
    var ServerData = {
      app: {
        host: window.medscape.config.appServer.host,
        path: appPath
      },
      static: {
        host: window.medscape.config.staticServer.host,
        path: staticPath
      }
    };
    var ConfigPropData = {
      ServerData: ServerData,
      user: user
    };
    var template = _handlebars2.default.compile(html);
    return template(ConfigPropData);
  },
  getDangerousHtml: function getDangerousHtml(html) {
    var compiledHtml = this.getCompiledHtml(html);
    return { __html: compiledHtml };
  },
  isElementInViewport: function isElementInViewport(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    return top < window.pageYOffset + window.innerHeight && left < window.pageXOffset + window.innerWidth && top + height > window.pageYOffset && left + width > window.pageXOffset;
  }
};

exports.default = Util;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(717)();
}


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(49);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap) {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
  var base64 = new Buffer(JSON.stringify(sourceMap)).toString('base64');
  var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

  return '/*# ' + data + ' */';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(912).Buffer))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [],
	fixUrls = __webpack_require__(865);

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	options.attrs.type = "text/css";

	attachTagAttrs(styleElement, options.attrs);
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	attachTagAttrs(linkElement, options.attrs);
	insertStyleElement(options, linkElement);
	return linkElement;
}

function attachTagAttrs(element, attrs) {
	Object.keys(attrs).forEach(function (key) {
		element.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement, options);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
	and there is no publicPath defined then lets turn convertToAbsoluteUrls
	on by default.  Otherwise default to the convertToAbsoluteUrls option
	directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls){
		css = fixUrls(css);
	}

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(115)('wks');
var uid = __webpack_require__(75);
var Symbol = __webpack_require__(9).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = __webpack_require__(332);

var _store2 = _interopRequireDefault(_store);

var _actions = __webpack_require__(201);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _actions2.default;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(11)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var IE8_DOM_DEFINE = __webpack_require__(220);
var toPrimitive = __webpack_require__(48);
var dP = Object.defineProperty;

exports.f = __webpack_require__(20) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(47);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var DOMProperty = __webpack_require__(85);
var ReactDOMComponentFlags = __webpack_require__(274);

var invariant = __webpack_require__(7);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(45);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// (C) Copyright 2016 Hewlett Packard Enterprise Development LP

var namespace = exports.namespace = 'grommetux-';

exports.default = {
  ACCORDION: namespace + 'accordion',
  ACCORDION_PANEL: namespace + 'accordion-panel',
  ANCHOR: namespace + 'anchor',
  ANIMATE: namespace + 'animate',
  APP: namespace + 'app',
  ARTICLE: namespace + 'article',
  ATTRIBUTE: namespace + 'attribute',
  BACKGROUND_COLOR_INDEX: namespace + 'background-color-index',
  BOX: namespace + 'box',
  BORDER_COLOR_INDEX: namespace + 'border-color-index',
  BRICK: namespace + 'brick',
  BUTTON: namespace + 'button',
  CALENDAR: namespace + 'calendar',
  CARD: namespace + 'card',
  CAROUSEL: namespace + 'carousel',
  CAROUSEL_CONTROLS: namespace + 'carousel-controls',
  CHART: namespace + 'chart',
  CHART_AXIS: namespace + 'chart-axis',
  CHART_BASE: namespace + 'chart-base',
  CHART_GRAPH: namespace + 'chart-graph',
  CHART_GRID: namespace + 'chart-grid',
  CHART_HOT_SPOTS: namespace + 'chart-hot-spots',
  CHART_LAYERS: namespace + 'chart-layers',
  CHART_MARKER: namespace + 'chart-marker',
  CHART_MARKER_LABEL: namespace + 'chart-marker-label',
  CHART_RANGE: namespace + 'chart-range',
  CHECK_BOX: namespace + 'check-box',
  COLLAPSIBLE: namespace + 'collapsible',
  COLOR_INDEX: namespace + 'color-index',
  COLUMNS: namespace + 'columns',
  CONTROL_ICON: namespace + 'control-icon',
  DATE_TIME: namespace + 'date-time',
  DATE_TIME_DROP: namespace + 'date-time-drop',
  DISTRIBUTION: namespace + 'distribution',
  DROP: namespace + 'drop',
  FOOTER: namespace + 'footer',
  FORM: namespace + 'form',
  FORM_FIELD: namespace + 'form-field',
  FORM_FIELDS: namespace + 'form-fields',
  HEADER: namespace + 'header',
  HEADING: namespace + 'heading',
  HEADLINE: namespace + 'headline',
  HERO: namespace + 'hero',
  IMAGE: namespace + 'image',
  IMAGE_FIELD: namespace + 'image-field',
  INPUT: namespace + 'input',
  LABEL: namespace + 'label',
  LAYER: namespace + 'layer',
  LEGEND: namespace + 'legend',
  LIST: namespace + 'list',
  LIST_ITEM: namespace + 'list-item',
  LOGIN: namespace + 'login',
  LOGIN_FORM: namespace + 'login-form',
  LOGO_ICON: namespace + 'logo-icon',
  MAP: namespace + 'map',
  MENU: namespace + 'menu',
  METER: namespace + 'meter',
  NAMESPACE: '' + namespace,
  NOTIFICATION: namespace + 'notification',
  NUMBER_INPUT: namespace + 'number-input',
  OBJECT: namespace + 'object',
  PARAGRAPH: namespace + 'paragraph',
  PASSWORD_INPUT: namespace + 'password-input',
  PULSE: namespace + 'pulse',
  QUOTE: namespace + 'quote',
  RADIO_BUTTON: namespace + 'radio-button',
  SEARCH: namespace + 'search',
  SEARCH_INPUT: namespace + 'search-input',
  SECTION: namespace + 'section',
  SELECT: namespace + 'select',
  SIDEBAR: namespace + 'sidebar',
  SKIP_LINK_ANCHOR: namespace + 'skip-link-anchor',
  SKIP_LINKS: namespace + 'skip-links',
  SPLIT: namespace + 'split',
  SPINNING: namespace + 'icon-spinning',
  STATUS_ICON: namespace + 'status-icon',
  SUN_BURST: namespace + 'sun-burst',
  TAB: namespace + 'tab',
  TABLE: namespace + 'table',
  TABLE_ROW: namespace + 'table-row',
  TABS: namespace + 'tabs',
  TAG: namespace + 'tag',
  TAGS: namespace + 'tags',
  TBD: namespace + 'tbd',
  TEXT_INPUT: namespace + 'text-input',
  TILE: namespace + 'tile',
  TILES: namespace + 'tiles',
  TIMESTAMP: namespace + 'timestamp',
  TIP: namespace + 'tip',
  TITLE: namespace + 'title',
  TOAST: namespace + 'toast',
  TOPOLOGY: namespace + 'topology',
  VALUE: namespace + 'value',
  VIDEO: namespace + 'video',
  WORLD_MAP: namespace + 'world-map'
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// (C) Copyright 2014 Hewlett Packard Enterprise Development LP
exports.default = {
  getMessage: function getMessage(intl, key, values, defaultMessage) {
    if (intl) {
      return intl.formatMessage({
        id: key,
        defaultMessage: defaultMessage || key
      }, values);
    } else {
      return key;
    }
  }
};
module.exports = exports["default"];

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

exports.default = {
  pick: function pick(props, fields) {
    var has = function has(p) {
      return props.hasOwnProperty(p);
    };
    var obj = {};
    (fields || []).forEach(function (field) {
      if (has(field)) obj[field] = props[field];
    });
    return obj;
  },
  omit: function omit(props, fields) {
    var obj = {};
    Object.keys(props).forEach(function (p) {
      if ((fields || []).indexOf(p) === -1) {
        obj[p] = props[p];
      }
    });
    return obj;
  }
};
module.exports = exports["default"];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _shareWidget = __webpack_require__(200);

var _shareWidget2 = _interopRequireDefault(_shareWidget);

var _video = __webpack_require__(339);

var _video2 = _interopRequireDefault(_video);

var _qna = __webpack_require__(331);

var _qna2 = _interopRequireDefault(_qna);

var _giftManager = __webpack_require__(199);

var _giftManager2 = _interopRequireDefault(_giftManager);

var _carousel = __webpack_require__(347);

var _carousel2 = _interopRequireDefault(_carousel);

var _consultWidget = __webpack_require__(316);

var _consultWidget2 = _interopRequireDefault(_consultWidget);

var _isi = __webpack_require__(350);

var _isi2 = _interopRequireDefault(_isi);

var _link = __webpack_require__(351);

var _link2 = _interopRequireDefault(_link);

var _handlebars = __webpack_require__(121);

var _handlebars2 = _interopRequireDefault(_handlebars);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

var _twitterWidget = __webpack_require__(333);

var _twitterWidget2 = _interopRequireDefault(_twitterWidget);

var _zoomImages = __webpack_require__(358);

var _zoomImages2 = _interopRequireDefault(_zoomImages);

var _formulary = __webpack_require__(323);

var _formulary2 = _interopRequireDefault(_formulary);

var _resources = __webpack_require__(357);

var _resources2 = _interopRequireDefault(_resources);

var _additionalResources = __webpack_require__(345);

var _additionalResources2 = _interopRequireDefault(_additionalResources);

var _consult = __webpack_require__(349);

var _consult2 = _interopRequireDefault(_consult);

var _uld = __webpack_require__(334);

var _uld2 = _interopRequireDefault(_uld);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Helpers = {
  setBrowserHistory: function setBrowserHistory(browserHistory) {
    this.browserHistory = browserHistory;
  },
  loadCarouselModules: function loadCarouselModules() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var callbacks = arguments[1];

    if (!el) {
      return;
    }
    var $el = (0, _jquery2.default)(el);
    var infosite = window.infosite;
    // VideoPlayer.init(infosite.config["videos"], $el.find(VideoPlayer.selector));
    _zoomImages2.default.init(infosite.config["zoomImages"], $el.find(_zoomImages2.default.selector), callbacks.ZoomImages);
    // QNA.init(infosite.config["Questionnaires"], $el.find(QNA.selector));
    this.loadRouterLinks($el);
    _tracking2.default.trackContainerLinks(el);
  },
  load: function load() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

    var $el = (0, _jquery2.default)(el);
    var infosite = window.infosite;
    _shareWidget2.default.init(infosite.config["share-widgets"], $el.find(_shareWidget2.default.selector));
    _video2.default.init(infosite.config["videos"], $el.find(_video2.default.selector), this.browserHistory);
    _qna2.default.init(infosite.config["Questionnaires"], $el.find(_qna2.default.selector));
    _giftManager2.default.init(infosite.config["giftManager"], $el.find(_giftManager2.default.selector));
    _consultWidget2.default.init(infosite.config["consult-widget"], $el.find(_consultWidget2.default.selector));
    _isi2.default.init(infosite.config["isi"], $el.find(_isi2.default.selector));
    _twitterWidget2.default.init(infosite.config["twitterTimeLine"], $el.find(_twitterWidget2.default.selector));
    _zoomImages2.default.init(infosite.config["zoomImages"], $el.find(_zoomImages2.default.selector));
    _formulary2.default.init(infosite.config["formulary"], $el.find(_formulary2.default.selector));
    _carousel2.default.init(infosite.config["carousel"], $el.find(_carousel2.default.selector));
    _resources2.default.init(infosite.config["resources"], $el.find(_resources2.default.selector));
    _additionalResources2.default.init(infosite.config["additional-resources"], $el.find(_additionalResources2.default.selector));
    _consult2.default.init(infosite.config["consult-ad"]);
    _uld2.default.init(infosite.config["uld"]);

    if (window.medscape.isMobile) {
      // MobileMenu.init(infosite.config["navigation"]);
    }
    this.loadIsiLink(el);
    this.loadRouterLinks($el);
    _tracking2.default.trackContainerLinks(el);
  },
  loadIsiLink: function loadIsiLink(el) {
    var $el = (0, _jquery2.default)(el);
    var infosite = window.infosite;
    _link2.default.init(infosite.config["isi"], $el.find(_link2.default.selector));
  },
  loadRouterLinks: function loadRouterLinks($el) {
    var _this = this;

    $el.find('[data-module="RouterLink"]').each(function (index, el) {
      var $link = (0, _jquery2.default)(el);
      var path = $link.attr('href');
      $link.attr('href', window.medscape.config.appServer.path + path);
      $link.data('to', path);
    });
    $el.find('[data-module="RouterLink"]').off('click.RouterLink').on('click.RouterLink', function (e) {
      e.preventDefault();
      var $link = (0, _jquery2.default)(e.currentTarget);
      var path = $link.data('to');
      if (_this.browserHistory != null) {
        _this.browserHistory.push(path);
      }
    });
  },
  loadStickyHeader: function loadStickyHeader() {
    var _this2 = this;

    var infosite = window.infosite;
    // const transitionEndEvent = 'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend';
    var $window = (0, _jquery2.default)(window);
    var $infositeApp = (0, _jquery2.default)('#infosite-app');
    var $main = (0, _jquery2.default)($infositeApp.find('main')[0]);
    var $header = (0, _jquery2.default)('header');
    var headerHeight = $header.outerHeight();
    var defaultTop = $main.css('margin-top');
    var triggerPoint = infosite.config.header.desktop.stickyTriggerPoint || '50%'; //infositeConfig.desktop.header["trigger-point"] || '100%' ;
    var scrollTimer = void 0;

    if (this.lockedScrolls.length > 0) {
      return;
    }
    if (triggerPoint.endsWith("%")) {
      triggerPoint = headerHeight * parseFloat(triggerPoint) / 100;
    }

    $window.off('scroll.stickyHeader').on('scroll.stickyHeader', function (e) {
      if (_this2.lockedScrolls.length > 0) {
        return;
      }
      if ($window.scrollTop() > triggerPoint) {
        if (!$header.hasClass("sticky")) {
          headerHeight = $header.outerHeight();
          defaultTop = parseInt($main.css('margin-top'));
          $main.css('margin-top', defaultTop + headerHeight);
          $header.addClass("sticky");
        }
      } else {
        $main.css('margin-top', defaultTop);
        $header.removeClass("sticky");
      }
    });
  },
  pauseVideos: function pauseVideos(el) {
    _video2.default.pause(el);
  },
  unload: function unload(el) {
    if (el == null) {
      // console.warn("React container element is required");
      return;
    }
    (0, _jquery2.default)(el).find('[data-module]').each(function (index, container) {
      _reactDom2.default.unmountComponentAtNode(container);
    });
  },
  updatePage: function updatePage() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var pageTitle = page["meta-data"] && page["meta-data"].h1 ? page["meta-data"].h1 : undefined;;
    if (!pageTitle) {
      pageTitle = page["meta-data"] && page["meta-data"].titleTag ? page["meta-data"].titleTag : undefined;
    }
    var $title = (0, _jquery2.default)('title');
    var $metaTitle = (0, _jquery2.default)('meta[property="og:title"]');
    if (!$title.data('title')) {
      $title.data('title', $title.html());
    }
    if (!$metaTitle.data('title')) {
      $metaTitle.data('title', $metaTitle.attr('content'));
    }
    pageTitle = pageTitle || $title.data('title');
    (0, _jquery2.default)('meta[property="og:url"]').attr("content", document.location.href);
    //$title.html(pageTitle);
    $metaTitle.attr("content", pageTitle);
    window.scrollTo(0, 0);
    _tracking2.default.pageView();
  },

  lockedScrolls: [],
  lockScroll: function lockScroll() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (key == null) {
      return;
    }
    if (this.lockedScrolls.length > 0) {
      if (this.lockedScrolls.indexOf(key) < 0) {
        this.lockedScrolls.push(key);
      }
      return;
    }
    var $app = (0, _jquery2.default)('#infosite-app');
    $app.data('lockScroll', true);
    var $html = (0, _jquery2.default)('html');
    var scrollPosition = [document.documentElement.scrollLeft || document.body.scrollLeft, document.documentElement.scrollTop || document.body.scrollTop];
    $html.data('scroll-position', scrollPosition);
    $html.data('previous-overflow', $html.css('overflow'));
    // lockScroll for mobile devices
    (0, _jquery2.default)('html, body').css({
      overflow: 'hidden',
      height: '100vh',
      width: '100%'
    });
    (0, _jquery2.default)('body').on('touchmove.lockScroll', function (e) {
      e.preventDefault();
    });
    var scrollAreas = ['.content-scroll-area', '.ReactModal__Overlay', '.bm-menu'];
    scrollAreas.forEach(function (scrollClass) {
      (0, _jquery2.default)('body').on('touchmove.lockScroll', scrollClass, function (e) {
        e.stopPropagation();
        return true;
      });
    });
    //console.log("scrollPosition:", scrollPosition);
    window.scrollTo(scrollPosition[0], scrollPosition[1]);

    $app.data('style', $app.attr('style') ? $app.attr('style') : '');
    (0, _jquery2.default)('#infosite-app').css({
      left: -scrollPosition[0],
      top: -scrollPosition[1],
      position: 'relative'
    });
    this.lockedScrolls.push(key);
  },
  unlockScroll: function unlockScroll() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (this.lockedScrolls.length == 0 || key == null) {
      return;
    }
    this.lockedScrolls = this.lockedScrolls.filter(function (lock) {
      return lock != key;
    });
    if (this.lockedScrolls == null) {
      this.lockedScrolls = [];
    }
    if (this.lockedScrolls.length > 0) {
      return;
    }
    var $app = (0, _jquery2.default)('#infosite-app');
    $app.data('lockScroll.lockScroll', false);
    var $html = (0, _jquery2.default)('html');
    var currentOverflow = $html.data('previous-overflow');
    var scrollPosition = $html.data('scroll-position');
    // unlockScroll for mobile devices
    (0, _jquery2.default)('body').off('touchmove.lockScroll');
    (0, _jquery2.default)('html, body').css({
      overflow: currentOverflow,
      height: 'auto'
    });
    $app.attr('style', $app.data('style'));
    window.scrollTo(scrollPosition[0], scrollPosition[1]);
  }
};
(0, _jquery2.default)(document).on('lockScroll', function (e, flag, key) {
  if (flag) {
    Helpers.lockScroll(key);
  } else {
    Helpers.unlockScroll(key);
  }
});

exports.default = Helpers;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(21);
var createDesc = __webpack_require__(71);
module.exports = __webpack_require__(20) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var hide = __webpack_require__(31);
var has = __webpack_require__(34);
var SRC = __webpack_require__(75)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(39).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var fails = __webpack_require__(11);
var defined = __webpack_require__(45);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(94);
var createDesc = __webpack_require__(71);
var toIObject = __webpack_require__(37);
var toPrimitive = __webpack_require__(48);
var has = __webpack_require__(34);
var IE8_DOM_DEFINE = __webpack_require__(220);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(20) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(34);
var toObject = __webpack_require__(24);
var IE_PROTO = __webpack_require__(154)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(93);
var defined = __webpack_require__(45);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(27);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(11);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.11';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63), __webpack_require__(911)(module)))

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(40);
var IObject = __webpack_require__(93);
var toObject = __webpack_require__(24);
var toLength = __webpack_require__(22);
var asc = __webpack_require__(139);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(1);
var core = __webpack_require__(39);
var fails = __webpack_require__(11);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(12);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13),
    _assign = __webpack_require__(19);

var CallbackQueue = __webpack_require__(272);
var PooledClass = __webpack_require__(77);
var ReactFeatureFlags = __webpack_require__(277);
var ReactReconciler = __webpack_require__(86);
var Transaction = __webpack_require__(128);

var invariant = __webpack_require__(7);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.capitalize = capitalize;
exports.callbackName = callbackName;
exports.isObject = isObject;
exports.extend = extend;
exports.isFunction = isFunction;
exports.nextTick = nextTick;
exports.object = object;
exports.isArguments = isArguments;
exports.throwIf = throwIf;
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function callbackName(string, prefix) {
    prefix = prefix || "on";
    return prefix + exports.capitalize(string);
}

/*
 * isObject, extend, isFunction, isArguments are taken from underscore/lodash in
 * order to remove the dependency
 */
function isObject(obj) {
    var type = typeof obj === "undefined" ? "undefined" : _typeof(obj);
    return type === "function" || type === "object" && !!obj;
}

function extend(obj) {
    if (!isObject(obj)) {
        return obj;
    }
    var source, keys, prop;
    for (var i = 1, length = arguments.length; i < length; i++) {
        source = arguments[i];
        keys = Object.keys(source);
        for (var j = 0; j < keys.length; j++) {
            prop = keys[j];
            if (Object.getOwnPropertyDescriptor && Object.defineProperty) {
                var propertyDescriptor = Object.getOwnPropertyDescriptor(source, prop);
                Object.defineProperty(obj, prop, propertyDescriptor);
            } else {
                obj[prop] = source[prop];
            }
        }
    }
    return obj;
}

function isFunction(value) {
    return typeof value === "function";
}

exports.EventEmitter = __webpack_require__(853);

function nextTick(callback) {
    setTimeout(callback, 0);
}

function object(keys, vals) {
    var o = {},
        i = 0;
    for (; i < keys.length; i++) {
        o[keys[i]] = vals[i];
    }
    return o;
}

function isArguments(value) {
    return (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && "callee" in value && typeof value.length === "number";
}

function throwIf(val, msg) {
    if (val) {
        throw Error(msg || val);
    }
}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(241);
var $export = __webpack_require__(1);
var shared = __webpack_require__(115)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(244))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(20)) {
  var LIBRARY = __webpack_require__(59);
  var global = __webpack_require__(9);
  var fails = __webpack_require__(11);
  var $export = __webpack_require__(1);
  var $typed = __webpack_require__(117);
  var $buffer = __webpack_require__(160);
  var ctx = __webpack_require__(40);
  var anInstance = __webpack_require__(66);
  var propertyDesc = __webpack_require__(71);
  var hide = __webpack_require__(31);
  var redefineAll = __webpack_require__(72);
  var toInteger = __webpack_require__(47);
  var toLength = __webpack_require__(22);
  var toIndex = __webpack_require__(239);
  var toAbsoluteIndex = __webpack_require__(74);
  var toPrimitive = __webpack_require__(48);
  var has = __webpack_require__(34);
  var classof = __webpack_require__(92);
  var isObject = __webpack_require__(12);
  var toObject = __webpack_require__(24);
  var isArrayIter = __webpack_require__(146);
  var create = __webpack_require__(68);
  var getPrototypeOf = __webpack_require__(36);
  var gOPN = __webpack_require__(69).f;
  var getIterFn = __webpack_require__(162);
  var uid = __webpack_require__(75);
  var wks = __webpack_require__(17);
  var createArrayMethod = __webpack_require__(44);
  var createArrayIncludes = __webpack_require__(104);
  var speciesConstructor = __webpack_require__(116);
  var ArrayIterators = __webpack_require__(163);
  var Iterators = __webpack_require__(79);
  var $iterDetect = __webpack_require__(110);
  var setSpecies = __webpack_require__(73);
  var arrayFill = __webpack_require__(138);
  var arrayCopyWithin = __webpack_require__(212);
  var $DP = __webpack_require__(21);
  var $GOPD = __webpack_require__(35);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _radium = __webpack_require__(171);

var _radium2 = _interopRequireDefault(_radium);

var _baseStyles = __webpack_require__(739);

var _baseStyles2 = _interopRequireDefault(_baseStyles);

var _BurgerIcon = __webpack_require__(737);

var _BurgerIcon2 = _interopRequireDefault(_BurgerIcon);

var _CrossIcon = __webpack_require__(738);

var _CrossIcon2 = _interopRequireDefault(_CrossIcon);

exports['default'] = function (styles) {
  var Menu = (function (_Component) {
    _inherits(Menu, _Component);

    function Menu(props) {
      _classCallCheck(this, Menu);

      _get(Object.getPrototypeOf(Menu.prototype), 'constructor', this).call(this, props);
      this.state = {
        isOpen: props && typeof props.isOpen !== 'undefined' ? props.isOpen : false
      };
    }

    _createClass(Menu, [{
      key: 'toggleMenu',
      value: function toggleMenu() {
        var _this = this;

        var newState = { isOpen: !this.state.isOpen };

        this.applyWrapperStyles();

        this.setState(newState, function () {
          _this.props.onStateChange(newState);

          // Timeout ensures wrappers are cleared after animation finishes.
          _this.timeoutId && clearTimeout(_this.timeoutId);
          _this.timeoutId = setTimeout(function () {
            _this.timeoutId = null;
            if (!newState.isOpen) {
              _this.clearWrapperStyles();
            }
          }, 500);
        });
      }

      // Applies component-specific styles to external wrapper elements.
    }, {
      key: 'applyWrapperStyles',
      value: function applyWrapperStyles() {
        if (styles.pageWrap && this.props.pageWrapId) {
          this.handleExternalWrapper(this.props.pageWrapId, styles.pageWrap, true);
        }

        if (styles.outerContainer && this.props.outerContainerId) {
          this.handleExternalWrapper(this.props.outerContainerId, styles.outerContainer, true);
        }
      }

      // Removes component-specific styles applied to external wrapper elements.
    }, {
      key: 'clearWrapperStyles',
      value: function clearWrapperStyles() {
        if (styles.pageWrap && this.props.pageWrapId) {
          this.handleExternalWrapper(this.props.pageWrapId, styles.pageWrap, false);
        }

        if (styles.outerContainer && this.props.outerContainerId) {
          this.handleExternalWrapper(this.props.outerContainerId, styles.outerContainer, false);
        }
      }

      // Sets or unsets styles on DOM elements outside the menu component.
      // This is necessary for correct page interaction with some of the menus.
      // Throws and returns if the required external elements don't exist,
      // which means any external page animations won't be applied.
    }, {
      key: 'handleExternalWrapper',
      value: function handleExternalWrapper(id, wrapperStyles, set) {
        var html = document.querySelector('html');
        var body = document.querySelector('body');
        var wrapper = document.getElementById(id);

        if (!wrapper) {
          console.error("Element with ID '" + id + "' not found");
          return;
        }

        var builtStyles = wrapperStyles(this.state.isOpen, this.props.width, this.props.right);

        for (var prop in builtStyles) {
          if (builtStyles.hasOwnProperty(prop)) {
            wrapper.style[prop] = set ? builtStyles[prop] : '';
          }
        }

        // Prevent any horizontal scroll.
        [html, body].forEach(function (element) {
          element.style['overflow-x'] = set ? 'hidden' : '';
        });
      }

      // Builds styles incrementally for a given element.
    }, {
      key: 'getStyles',
      value: function getStyles(el, index, inline) {
        var propName = 'bm' + el.replace(el.charAt(0), el.charAt(0).toUpperCase());

        // Set base styles.
        var output = _baseStyles2['default'][el] ? [_baseStyles2['default'][el](this.state.isOpen, this.props.width, this.props.right)] : [];

        // Add animation-specific styles.
        if (styles[el]) {
          output.push(styles[el](this.state.isOpen, this.props.width, this.props.right, index + 1));
        }

        // Add custom styles.
        if (this.props.styles[propName]) {
          output.push(this.props.styles[propName]);
        }

        // Add element inline styles.
        if (inline) {
          output.push(inline);
        }

        return output;
      }
    }, {
      key: 'listenForClose',
      value: function listenForClose(e) {
        e = e || window.event;

        if (this.state.isOpen && (e.key === 'Escape' || e.keyCode === 27)) {
          this.toggleMenu();
        }
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        if (!styles) {
          throw new Error('No styles supplied');
        }

        // Allow initial open state to be set by props.
        if (this.props.isOpen) {
          this.toggleMenu();
        }
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.onkeydown = this.listenForClose.bind(this);

        // Allow initial open state to be set by props for animations with wrapper elements.
        if (this.props.isOpen) {
          this.toggleMenu();
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.onkeydown = null;

        this.clearWrapperStyles();
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        var _this2 = this;

        if (styles.svg) {
          (function () {
            var morphShape = _reactDom2['default'].findDOMNode(_this2, 'bm-morph-shape');
            var path = styles.svg.lib(morphShape).select('path');

            if (_this2.state.isOpen) {
              // Animate SVG path.
              styles.svg.animate(path);
            } else {
              // Reset path (timeout ensures animation happens off screen).
              setTimeout(function () {
                path.attr('d', styles.svg.pathInitial);
              }, 300);
            }
          })();
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (typeof nextProps.isOpen !== 'undefined' && nextProps.isOpen !== this.state.isOpen) {
          this.toggleMenu();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        return _react2['default'].createElement(
          'div',
          null,
          !this.props.noOverlay ? _react2['default'].createElement('div', { className: 'bm-overlay', onClick: function () {
              return _this3.toggleMenu();
            }, style: this.getStyles('overlay') }) : null,
          _react2['default'].createElement(
            'div',
            { id: this.props.id, className: 'bm-menu-wrap ' + (this.props.className || ''), style: this.getStyles('menuWrap') },
            styles.svg ? _react2['default'].createElement(
              'div',
              { className: 'bm-morph-shape', style: this.getStyles('morphShape') },
              _react2['default'].createElement(
                'svg',
                { width: '100%', height: '100%', viewBox: '0 0 100 800', preserveAspectRatio: 'none' },
                _react2['default'].createElement('path', { d: styles.svg.pathInitial })
              )
            ) : null,
            _react2['default'].createElement(
              'div',
              { className: 'bm-menu', style: this.getStyles('menu') },
              _react2['default'].createElement(
                'nav',
                { className: 'bm-item-list', style: this.getStyles('itemList') },
                _react2['default'].Children.map(this.props.children, function (item, index) {
                  if (item) {
                    var extraProps = {
                      key: index,
                      style: _this3.getStyles('item', index, item.props.style)
                    };
                    return _react2['default'].cloneElement(item, extraProps);
                  }
                })
              )
            ),
            this.props.customCrossIcon !== false ? _react2['default'].createElement(
              'div',
              { style: this.getStyles('closeButton') },
              _react2['default'].createElement(_CrossIcon2['default'], { onClick: function () {
                  return _this3.toggleMenu();
                }, styles: this.props.styles, customIcon: this.props.customCrossIcon })
            ) : null
          ),
          this.props.customBurgerIcon !== false ? _react2['default'].createElement(_BurgerIcon2['default'], { onClick: function () {
              return _this3.toggleMenu();
            }, styles: this.props.styles, customIcon: this.props.customBurgerIcon }) : null
        );
      }
    }]);

    return Menu;
  })(_react.Component);

  Menu.propTypes = {
    className: _propTypes2['default'].string,
    customBurgerIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
    customCrossIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].oneOf([false])]),
    id: _propTypes2['default'].string,
    isOpen: _propTypes2['default'].bool,
    noOverlay: _propTypes2['default'].bool,
    onStateChange: _propTypes2['default'].func,
    outerContainerId: styles && styles.outerContainer ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
    pageWrapId: styles && styles.pageWrap ? _propTypes2['default'].string.isRequired : _propTypes2['default'].string,
    right: _propTypes2['default'].bool,
    styles: _propTypes2['default'].object,
    width: _propTypes2['default'].number
  };

  Menu.defaultProps = {
    id: '',
    noOverlay: false,
    onStateChange: function onStateChange() {},
    outerContainerId: '',
    pageWrapId: '',
    styles: {},
    width: 300
  };

  return (0, _radium2['default'])(Menu);
};

module.exports = exports['default'];

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(19);

var PooledClass = __webpack_require__(77);

var emptyFunction = __webpack_require__(49);
var warning = __webpack_require__(14);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(17)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(31)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(75)('meta');
var isObject = __webpack_require__(12);
var has = __webpack_require__(34);
var setDesc = __webpack_require__(21).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(11)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Converts a camel-case string to a dash-case string
 * @param {string} str - str that gets converted to dash-case
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function (str) {
  return str.replace(/([a-z]|^)([A-Z])/g, function (match, p1, p2) {
    return p1 + '-' + p2.toLowerCase();
  }).replace('ms-', '-ms-');
};

module.exports = exports['default'];

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 63 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
	ChoiceActionsFactory

	Creates Reflux Choice Actions for each Question.
	Prevents choices from multiple Questions from listening and triggering the same actions.
*/
var ChoiceActionsFactory = function () {
	function ChoiceActionsFactory() {
		_classCallCheck(this, ChoiceActionsFactory);

		this.actions = {};
	}

	_createClass(ChoiceActionsFactory, [{
		key: 'get',
		value: function get(questionId) {
			var key = 'question-' + questionId;
			if (!this.actions[key]) {
				this.actions[key] = _reflux2.default.createActions(['change']);
			}
			return this.actions[key];
		}
	}]);

	return ChoiceActionsFactory;
}();

exports.default = new ChoiceActionsFactory();

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _navItem = __webpack_require__(410);

var _navItem2 = _interopRequireDefault(_navItem);

var _Down = __webpack_require__(76);

var _Down2 = _interopRequireDefault(_Down);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavMenu = function (_React$Component) {
    _inherits(NavMenu, _React$Component);

    function NavMenu(props) {
        _classCallCheck(this, NavMenu);

        return _possibleConstructorReturn(this, (NavMenu.__proto__ || Object.getPrototypeOf(NavMenu)).call(this, props));
        //console.log("Nav Menu Constructor:",props);
    }

    _createClass(NavMenu, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return true;
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {

            //console.log("Nav Menu Will Update", nextProps)
        }
    }, {
        key: 'getNavItems',
        value: function getNavItems() {
            var _this2 = this;

            var NavItems = this.props.items;
            var items = NavItems.map(function (Item, index) {
                var itemKey = Item.title + '-' + index;
                var NavItemProps = {
                    key: itemKey,
                    item: Item,
                    settings: _this2.props.settings,
                    route: _this2.props.route,
                    isSubmenuItem: _this2.props.isSubmenu,
                    onItemClick: _this2.props.onItemClick,
                    onMouseEnter: _this2.props.onItemMouseEnter,
                    onMouseLeave: _this2.props.onItemMouseLeave
                };
                return _react2.default.createElement(_navItem2.default, NavItemProps);
            });
            return items;
        } // getNavItems

    }, {
        key: 'render',
        value: function render() {
            var items = this.props.items;
            if (items.length == 0) {
                return false;
            }
            var navItems = this.getNavItems();
            var className = this.props.isSubmenu ? 'sub-menu' : 'nav-menu';
            return _react2.default.createElement(
                'ul',
                { className: className },
                navItems
            );
        }
    }]);

    return NavMenu;
}(_react2.default.Component);

exports.default = NavMenu;

NavMenu.propTypes = {
    items: _react2.default.PropTypes.array,
    settings: _react2.default.PropTypes.object.isRequired,
    route: _react2.default.PropTypes.object.isRequired,
    isSubmenu: _react2.default.PropTypes.bool,
    onItemClick: _react2.default.PropTypes.func,
    onItemMouseEnter: _react2.default.PropTypes.func,
    onItemMouseLeave: _react2.default.PropTypes.func
};
NavMenu.defaultProps = {
    items: [],
    className: '',
    isSubmenu: false,
    onItemClick: function onItemClick() {},
    onMouseLeave: function onMouseLeave() {},
    onMouseEnter: function onMouseEnter() {}
};

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(40);
var call = __webpack_require__(223);
var isArrayIter = __webpack_require__(146);
var anObject = __webpack_require__(8);
var toLength = __webpack_require__(22);
var getIterFn = __webpack_require__(162);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(8);
var dPs = __webpack_require__(229);
var enumBugKeys = __webpack_require__(142);
var IE_PROTO = __webpack_require__(154)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(141)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(144).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(231);
var hiddenKeys = __webpack_require__(142).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(231);
var enumBugKeys = __webpack_require__(142);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(32);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var dP = __webpack_require__(21);
var DESCRIPTORS = __webpack_require__(20);
var SPECIES = __webpack_require__(17)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(47);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 75 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(6);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(25);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(26);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(28);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-down', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'down');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '7.086 3.174 17.086 13.174 7.086 23.174', transform: 'scale(1 -1) rotate(-89 -1.32 0)' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Down';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(13);

var invariant = __webpack_require__(7);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.joinStrict = exports.joinConcat = exports.joinLeading = exports.joinTrailing = exports.fetchInitialState = exports.stopListeningToAll = exports.stopListeningTo = exports.listenTo = exports.validateListening = exports.listenToMany = exports.hasListener = undefined;

var _utils = __webpack_require__(51);

var _ = _interopRequireWildcard(_utils);

var _joins = __webpack_require__(306);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Extract child listenables from a parent from their
 * children property and return them in a keyed Object
 *
 * @param {Object} listenable The parent listenable
 */
var mapChildListenables = function mapChildListenables(listenable) {
    var i = 0,
        children = {},
        childName;
    for (; i < (listenable.children || []).length; ++i) {
        childName = listenable.children[i];
        if (listenable[childName]) {
            children[childName] = listenable[childName];
        }
    }
    return children;
};

/**
 * Make a flat dictionary of all listenables including their
 * possible children (recursively), concatenating names in camelCase.
 *
 * @param {Object} listenables The top-level listenables
 */
var flattenListenables = function flattenListenables(listenables) {
    var flattened = {};
    for (var key in listenables) {
        var listenable = listenables[key];
        var childMap = mapChildListenables(listenable);

        // recursively flatten children
        var children = flattenListenables(childMap);

        // add the primary listenable and chilren
        flattened[key] = listenable;
        for (var childKey in children) {
            var childListenable = children[childKey];
            flattened[key + _.capitalize(childKey)] = childListenable;
        }
    }

    return flattened;
};

/**
 * An internal utility function used by `validateListening`
 *
 * @param {Action|Store} listenable The listenable we want to search for
 * @returns {Boolean} The result of a recursive search among `this.subscriptions`
 */
var hasListener = exports.hasListener = function hasListener(listenable) {
    var i = 0,
        j,
        listener,
        listenables;
    for (; i < (this.subscriptions || []).length; ++i) {
        listenables = [].concat(this.subscriptions[i].listenable);
        for (j = 0; j < listenables.length; j++) {
            listener = listenables[j];
            if (listener === listenable || listener.hasListener && listener.hasListener(listenable)) {
                return true;
            }
        }
    }
    return false;
};

/**
 * A convenience method that listens to all listenables in the given object.
 *
 * @param {Object} listenables An object of listenables. Keys will be used as callback method names.
 */
var listenToMany = exports.listenToMany = function listenToMany(listenables) {
    var allListenables = flattenListenables(listenables);
    for (var key in allListenables) {
        var cbname = _.callbackName(key),
            localname = this[cbname] ? cbname : this[key] ? key : undefined;
        if (localname) {
            this.listenTo(allListenables[key], localname, this[cbname + "Default"] || this[localname + "Default"] || localname);
        }
    }
};

/**
 * Checks if the current context can listen to the supplied listenable
 *
 * @param {Action|Store} listenable An Action or Store that should be
 *  listened to.
 * @returns {String|Undefined} An error message, or undefined if there was no problem.
 */
var validateListening = exports.validateListening = function validateListening(listenable) {
    if (listenable === this) {
        return "Listener is not able to listen to itself";
    }
    if (!_.isFunction(listenable.listen)) {
        return listenable + " is missing a listen method";
    }
    if (listenable.hasListener && listenable.hasListener(this)) {
        return "Listener cannot listen to this listenable because of circular loop";
    }
};

/**
 * Sets up a subscription to the given listenable for the context object
 *
 * @param {Action|Store} listenable An Action or Store that should be
 *  listened to.
 * @param {Function|String} callback The callback to register as event handler
 * @param {Function|String} defaultCallback The callback to register as default handler
 * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is the object being listened to
 */
var listenTo = exports.listenTo = function listenTo(listenable, callback, defaultCallback) {
    var desub,
        unsubscriber,
        subscriptionobj,
        subs = this.subscriptions = this.subscriptions || [];
    _.throwIf(this.validateListening(listenable));
    this.fetchInitialState(listenable, defaultCallback);
    desub = listenable.listen(this[callback] || callback, this);
    unsubscriber = function unsubscriber() {
        var index = subs.indexOf(subscriptionobj);
        _.throwIf(index === -1, "Tried to remove listen already gone from subscriptions list!");
        subs.splice(index, 1);
        desub();
    };
    subscriptionobj = {
        stop: unsubscriber,
        listenable: listenable
    };
    subs.push(subscriptionobj);
    return subscriptionobj;
};

/**
 * Stops listening to a single listenable
 *
 * @param {Action|Store} listenable The action or store we no longer want to listen to
 * @returns {Boolean} True if a subscription was found and removed, otherwise false.
 */
var stopListeningTo = exports.stopListeningTo = function stopListeningTo(listenable) {
    var sub,
        i = 0,
        subs = this.subscriptions || [];
    for (; i < subs.length; i++) {
        sub = subs[i];
        if (sub.listenable === listenable) {
            sub.stop();
            _.throwIf(subs.indexOf(sub) !== -1, "Failed to remove listen from subscriptions list!");
            return true;
        }
    }
    return false;
};

/**
 * Stops all subscriptions and empties subscriptions array
 */
var stopListeningToAll = exports.stopListeningToAll = function stopListeningToAll() {
    var remaining,
        subs = this.subscriptions || [];
    while (remaining = subs.length) {
        subs[0].stop();
        _.throwIf(subs.length !== remaining - 1, "Failed to remove listen from subscriptions list!");
    }
};

/**
 * Used in `listenTo`. Fetches initial data from a publisher if it has a `getInitialState` method.
 * @param {Action|Store} listenable The publisher we want to get initial state from
 * @param {Function|String} defaultCallback The method to receive the data
 */
var fetchInitialState = exports.fetchInitialState = function fetchInitialState(listenable, defaultCallback) {
    defaultCallback = defaultCallback && this[defaultCallback] || defaultCallback;
    var me = this;
    if (_.isFunction(defaultCallback) && _.isFunction(listenable.getInitialState)) {
        var data = listenable.getInitialState();
        if (data && _.isFunction(data.then)) {
            data.then(function () {
                defaultCallback.apply(me, arguments);
            });
        } else {
            defaultCallback.call(this, data);
        }
    }
};

/**
 * The callback will be called once all listenables have triggered at least once.
 * It will be invoked with the last emission from each listenable.
 * @param {...Publishers} publishers Publishers that should be tracked.
 * @param {Function|String} callback The method to call when all publishers have emitted
 * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
 */
var joinTrailing = exports.joinTrailing = (0, _joins.instanceJoinCreator)("last");

/**
 * The callback will be called once all listenables have triggered at least once.
 * It will be invoked with the first emission from each listenable.
 * @param {...Publishers} publishers Publishers that should be tracked.
 * @param {Function|String} callback The method to call when all publishers have emitted
 * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
 */
var joinLeading = exports.joinLeading = (0, _joins.instanceJoinCreator)("first");

/**
 * The callback will be called once all listenables have triggered at least once.
 * It will be invoked with all emission from each listenable.
 * @param {...Publishers} publishers Publishers that should be tracked.
 * @param {Function|String} callback The method to call when all publishers have emitted
 * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
 */
var joinConcat = exports.joinConcat = (0, _joins.instanceJoinCreator)("all");

/**
 * The callback will be called once all listenables have triggered.
 * If a callback triggers twice before that happens, an error is thrown.
 * @param {...Publishers} publishers Publishers that should be tracked.
 * @param {Function|String} callback The method to call when all publishers have emitted
 * @returns {Object} A subscription obj where `stop` is an unsub function and `listenable` is an array of listenables
 */
var joinStrict = exports.joinStrict = (0, _joins.instanceJoinCreator)("strict");

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(21).f;
var has = __webpack_require__(34);
var TAG = __webpack_require__(17)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var defined = __webpack_require__(45);
var fails = __webpack_require__(11);
var spaces = __webpack_require__(158);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(682);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(683);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(684);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(122);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(95);
/* unused harmony reexport parsePath */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__PathUtils__["a"]; });










/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = __webpack_require__(175);
var setInnerHTML = __webpack_require__(130);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(183);
var setTextContent = __webpack_require__(290);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var invariant = __webpack_require__(7);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactRef = __webpack_require__(785);
var ReactInstrumentation = __webpack_require__(43);

var warning = __webpack_require__(14);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(19);

var ReactBaseClasses = __webpack_require__(298);
var ReactChildren = __webpack_require__(840);
var ReactDOMFactories = __webpack_require__(841);
var ReactElement = __webpack_require__(88);
var ReactPropTypes = __webpack_require__(842);
var ReactVersion = __webpack_require__(843);

var createReactClass = __webpack_require__(844);
var onlyChild = __webpack_require__(848);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(19);

var ReactCurrentOwner = __webpack_require__(57);

var warning = __webpack_require__(14);
var canDefineProperty = __webpack_require__(302);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(300);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(['update']);

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _choiceActionsFactory = __webpack_require__(64);

var _choiceActionsFactory2 = _interopRequireDefault(_choiceActionsFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StoreCache = {};

var ChoiceStore = function (_Reflux$Store) {
    _inherits(ChoiceStore, _Reflux$Store);

    function ChoiceStore(props) {
        var allowMultiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var questionId = arguments[2];

        _classCallCheck(this, ChoiceStore);

        var _this = _possibleConstructorReturn(this, (ChoiceStore.__proto__ || Object.getPrototypeOf(ChoiceStore)).call(this));

        var state = _this.getInitialState();
        _this.state = _jquery2.default.extend(state, props);
        _this.props = props;
        _this.questionId = questionId;
        _this.allowMultiple = allowMultiple;
        _this.listenables = _choiceActionsFactory2.default.get(questionId);
        return _this;
    }

    _createClass(ChoiceStore, [{
        key: 'getInitialState',
        value: function getInitialState() {
            return {
                choiceId: null,
                choiceText: '',
                responseText: null,
                displayOrder: 1,
                correct: true,
                selected: false,
                explanation: '',
                totalAbsoluteResponseCount: 0,
                totalResponses: '0'
            };
        }
    }, {
        key: 'onChange',
        value: function onChange(choice, isSelected) {

            // Sets radio button 'selected' to 'false' if it was previously set to 'true'
            if (!this.allowMultiple && this.state.choiceId != choice.choiceId && this.state.selected) {
                this.props.selected = false;
                this.setState({
                    selected: false
                });
            }
            // Sets the radio button that was changed 'selected' to 'true'
            else if (!this.allowMultiple && this.state.choiceId == choice.choiceId && !this.state.selected) {
                    this.props.selected = true;
                    this.setState({
                        selected: true
                    });
                }
                // Sets checkbox changes to the new selected state
                else if (this.allowMultiple && this.state.choiceId == choice.choiceId) {
                        this.props.selected = isSelected;
                        this.setState({
                            selected: isSelected
                        });
                    }
        }
    }]);

    return ChoiceStore;
}(_reflux2.default.Store);

exports.default = ChoiceStore;

ChoiceStore.get = function (choice) {
    var allowMultiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var questionId = arguments[2];

    var key = 'choice[' + choice.choiceId + ']';
    if (StoreCache[key] == null || StoreCache[key].listenables.length == 0 || StoreCache[key].listenables.length == null) {
        StoreCache[key] = new ChoiceStore(choice, allowMultiple, questionId);
    } else {
        StoreCache[key];
    }
    return StoreCache[key];
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentCache = {};

var IsiActions = _reflux2.default.createActions({
  'toggle': {},
  'linkClick': {},
  'toggleAutoScroll': {},
  'toggleSticky': {},
  'accept': {},
  'getContent': {
    children: ['completed', 'failed']
  }
});

IsiActions.getContent.listen(function (path) {
  if (ContentCache[path]) {
    this.completed(ContentCache[path]);
    return;
  }
  var doSuccess = function doSuccess(data) {
    ContentCache[path] = data;
    this.completed(ContentCache[path]);
  };
  var doError = function doError(response) {
    this.failed(response);
  };

  var baseURL = window.medscape.config.appServer.host + window.medscape.config.appServer.path;
  if (window.medscape.config.env == "localhost") {
    baseURL += "/build/localhost/app";
  }

  var url = '' + baseURL + path;
  if (window.medscape.config.env == "localhost") {
    url += ".jsp";
  }
  _jquery2.default.ajax({
    type: 'get',
    url: url,
    data: {},
    dataType: 'html',
    cache: false
  }).then(doSuccess.bind(this), doError.bind(this));
});

exports.default = IsiActions;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(38);
var TAG = __webpack_require__(17)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(38);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var EventPluginRegistry = __webpack_require__(176);
var EventPluginUtils = __webpack_require__(177);
var ReactErrorUtils = __webpack_require__(181);

var accumulateInto = __webpack_require__(283);
var forEachAccumulated = __webpack_require__(284);
var invariant = __webpack_require__(7);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(96);
var EventPluginUtils = __webpack_require__(177);

var accumulateInto = __webpack_require__(283);
var forEachAccumulated = __webpack_require__(284);
var warning = __webpack_require__(14);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(56);

var getEventTarget = __webpack_require__(186);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _actions = __webpack_require__(102);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Helpers = {
  getPostData: function getPostData(state) {
    return {
      formId: state.formId,
      questionResponses: this.getResponseList(state.questions),
      questionnaireId: state.qid,
      siteId: 2001
    };
  },
  getResponseList: function getResponseList(questions) {
    var responseList = [];
    questions.forEach(function (question) {
      var choices = question.choices;
      if (question.displayType == 4 || question.displayType == 5) {
        var responseText = question.responseText ? question.responseText : "";
        var response = {
          questionId: question.questionId,
          responseText: responseText
        };
        responseList.push(response);
        return;
      }
      var selectedChoices = choices.filter(function (choice) {
        return choice.selected;
      });
      if (selectedChoices.length > 0) {
        selectedChoices.forEach(function (choice) {
          var response = {
            choiceId: choice.choiceId,
            questionId: question.questionId
          };
          responseList.push(response);
        });
      }
    });
    return responseList;
  }
};

var ApiEvents = {
  "get": {
    children: ['completed', 'failed']
  },
  "post": {
    children: ['completed', 'failed']
  }
};

var ApiActionsFactory = function () {
  function ApiActionsFactory() {
    _classCallCheck(this, ApiActionsFactory);

    this.actions = {};
  }

  _createClass(ApiActionsFactory, [{
    key: 'get',
    value: function get(key) {
      if (!this.actions[key]) {
        this.actions[key] = _reflux2.default.createActions(ApiEvents);
        this.initListeners(this.actions[key]);
      }
      return this.actions[key];
    }
  }, {
    key: 'clearCache',
    value: function clearCache() {
      var _this = this;

      Object.keys(this.actions).forEach(function (key) {
        delete _this.actions[key];
      });
    }
  }, {
    key: 'initListeners',
    value: function initListeners(ApiActions) {
      ApiActions.get.listen(function (qid, formId) {
        var _this2 = this;

        _actions2.default.update([]);
        var app = window.medscape;
        var path = app.config.apiHost.replace("www", "api") + '/servicegateway/v2/auth/qnaservice/questionnaire';
        var qnaUrl = path + '/' + qid + '/form/' + formId;
        var getData = {
          aggregated: true
        };
        _jquery2.default.ajax({
          type: 'get',
          url: qnaUrl,
          data: getData,
          dataType: 'json',
          cached: false,
          xhrFields: {
            withCredentials: true
          },
          statusCode: {
            '404': function _() {
              console.log('404');
            },
            '403': function _(response) {
              console.error("403 Response");
              //this.completed(response);
              _this2.failed(response);
            }
          }
        }).then(function (response) {
          response.qid = qid;
          _this2.completed(response);
        }, this.failed);
      });
      ApiActions.post.listen(function (postState) {
        var _this3 = this;

        //let postUrl = window.medscape.config.qna.api.post;
        _actions2.default.update([]);
        var app = window.medscape,
            api = '';
        //let api = postState.formTypeId==1 ? 'courseservice/saveUserResponse' : 'activityservice/save/useractivity';
        //http://api.medscape.com/servicegateway/v2/auth/courseservice/saveUserResponse
        if (app.user.isLoggedIn) {
          api = 'qnaservice/save/userresponse';
        } else {
          api = 'qnaservice/save/anonymousresponse';
        }
        var postUrl = app.config.apiHost.replace('www', 'api') + '/servicegateway/v2/auth/' + api + '?aggregated=true';
        var postData = Helpers.getPostData(postState);
        if (postData.questionResponses.length == 0) {
          this.failed({
            "errors": [{
              "status": "400",
              "source": postData,
              "title": "Select a choice",
              "detail": "The questionnaire submitted without any responses."
            }]
          });
          return false;
        }
        var errorStatus = function errorStatus() {
          console.error("403 Response ", window.medscape.config.env);
          if (window.medscape.config.env == 'localhost') {
            console.log("In Localhost", _this3);
            _this3.completed({
              "responseMsg": {
                "code": "1",
                "message": "SUCCESS",
                "nextViewPage": "",
                "data": {
                  "incorrectlyAnsweredQuestionIds": []
                }
              }
            });
          }
        };
        _jquery2.default.ajax({
          type: 'POST',
          contentType: "application/json",
          dataType: "json",
          processData: false,
          url: postUrl,
          data: JSON.stringify(postData),
          xhrFields: {
            withCredentials: true
          },
          statusCode: {
            '401': errorStatus,
            '404': function _() {
              console.error('404');
            },
            '403': errorStatus
          }
        }).then(this.completed, this.failed);
      });
    } // initListeners

  }]);

  return ApiActionsFactory;
}();

exports.default = new ApiActionsFactory();

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(['update']);

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _config = __webpack_require__(336);

var _config2 = _interopRequireDefault(_config);

var _configDefaults = __webpack_require__(337);

var _configDefaults2 = _interopRequireDefault(_configDefaults);

var _ = __webpack_require__(42);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isLocal = window.medscape.config.env == 'localhost';
var ampPath = '/amp-premier/';
var pluginPath = ampPath + 'plugins/';
var imageServerHost = isLocal ? '//img.staging.medscapestatic.com' : window.medscape.config.staticServer.host;

var ampURL = imageServerHost + '/pi/core' + ampPath;
var pluginURL = imageServerHost + '/pi/core' + pluginPath;

var Settings = function Settings(config) {
    _classCallCheck(this, Settings);

    var videoSettings = config;
    var ccInfo = config.ccInfo;
    var STREAM_CDN_HOST = '//webmd-vh.akamaihd.net';
    var MP4_CDN_HOST = '//webmd-a.akamaihd.net';
    var res = '750k';
    var ccFileRoot = '' + imageServerHost + videoSettings.ccFileRoot.replace(/^en\//, '');
    this.isLocal = isLocal;
    this.ampPath = ampPath;
    this.pluginPath = pluginPath;
    this.imageServerHost = imageServerHost;
    this.ampURL = ampURL;
    this.pluginURL = pluginURL;
    this.vConfig = _jquery2.default.extend(true, (0, _config2.default)(pluginURL, ampURL), _configDefaults2.default);
    this.vConfig.autoplay = videoSettings.autoplay;
    //this.vConfig.muted = videoSettings.autoplay ? true : false;
    this.vConfig.muted = videoSettings.muted;
    this.vConfig.media.source = [{
        src: STREAM_CDN_HOST + '/i/delivery' + videoSettings.source + '.csmil/master.m3u8',
        type: 'application/x-mpegURL'
    }, {
        src: STREAM_CDN_HOST + '/z/delivery' + videoSettings.source + '.csmil/manifest.f4m',
        type: 'video/f4m'
    }, {
        src: MP4_CDN_HOST + '/delivery' + videoSettings.source.split(',')[0] + res + '.mp4',
        type: 'video/mp4'
    }];

    this.vConfig.media.track = (0, _.map)(ccInfo, function (path, srcLang) {
        return {
            kind: 'captions',
            type: 'application/ttml+xml',
            srclang: srcLang.toLowerCase(),
            src: '' + ccFileRoot + path
        };
    });

    videoSettings.poster = videoSettings.poster.replace(/^en\//, '');
    videoSettings.poster = _utils2.default.getCompiledHtml(videoSettings.poster);
    this.vConfig.media.poster = videoSettings.poster.startsWith('/build/') || videoSettings.poster.startsWith('http') ? videoSettings.poster : '' + imageServerHost + videoSettings.poster;
};

exports.default = Settings;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(37);
var toLength = __webpack_require__(22);
var toAbsoluteIndex = __webpack_require__(74);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(32);
var redefineAll = __webpack_require__(72);
var meta = __webpack_require__(60);
var forOf = __webpack_require__(67);
var anInstance = __webpack_require__(66);
var isObject = __webpack_require__(12);
var fails = __webpack_require__(11);
var $iterDetect = __webpack_require__(110);
var setToStringTag = __webpack_require__(80);
var inheritIfRequired = __webpack_require__(145);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(31);
var redefine = __webpack_require__(32);
var fails = __webpack_require__(11);
var defined = __webpack_require__(45);
var wks = __webpack_require__(17);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(8);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(38);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(12);
var cof = __webpack_require__(38);
var MATCH = __webpack_require__(17)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(17)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(59) || !__webpack_require__(11)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(9)[K];
});


/***/ }),
/* 112 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(27);
var ctx = __webpack_require__(40);
var forOf = __webpack_require__(67);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(1);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(39);
var global = __webpack_require__(9);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(59) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(8);
var aFunction = __webpack_require__(27);
var SPECIES = __webpack_require__(17)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var hide = __webpack_require__(31);
var uid = __webpack_require__(75);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(6);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(25);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(26);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(28);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-close', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'close');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,3 L21,21 M3,21 L21,3' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Close';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

/**!

 @license
 handlebars v4.0.12

Copyright (C) 2011-2017 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Handlebars"] = factory();
	else
		root["Handlebars"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _handlebarsRuntime = __webpack_require__(2);

	var _handlebarsRuntime2 = _interopRequireDefault(_handlebarsRuntime);

	// Compiler imports

	var _handlebarsCompilerAst = __webpack_require__(35);

	var _handlebarsCompilerAst2 = _interopRequireDefault(_handlebarsCompilerAst);

	var _handlebarsCompilerBase = __webpack_require__(36);

	var _handlebarsCompilerCompiler = __webpack_require__(41);

	var _handlebarsCompilerJavascriptCompiler = __webpack_require__(42);

	var _handlebarsCompilerJavascriptCompiler2 = _interopRequireDefault(_handlebarsCompilerJavascriptCompiler);

	var _handlebarsCompilerVisitor = __webpack_require__(39);

	var _handlebarsCompilerVisitor2 = _interopRequireDefault(_handlebarsCompilerVisitor);

	var _handlebarsNoConflict = __webpack_require__(34);

	var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);

	var _create = _handlebarsRuntime2['default'].create;
	function create() {
	  var hb = _create();

	  hb.compile = function (input, options) {
	    return _handlebarsCompilerCompiler.compile(input, options, hb);
	  };
	  hb.precompile = function (input, options) {
	    return _handlebarsCompilerCompiler.precompile(input, options, hb);
	  };

	  hb.AST = _handlebarsCompilerAst2['default'];
	  hb.Compiler = _handlebarsCompilerCompiler.Compiler;
	  hb.JavaScriptCompiler = _handlebarsCompilerJavascriptCompiler2['default'];
	  hb.Parser = _handlebarsCompilerBase.parser;
	  hb.parse = _handlebarsCompilerBase.parse;

	  return hb;
	}

	var inst = create();
	inst.create = create;

	_handlebarsNoConflict2['default'](inst);

	inst.Visitor = _handlebarsCompilerVisitor2['default'];

	inst['default'] = inst;

	exports['default'] = inst;
	module.exports = exports['default'];

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";

	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	};

	exports.__esModule = true;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireWildcard = __webpack_require__(3)['default'];

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _handlebarsBase = __webpack_require__(4);

	var base = _interopRequireWildcard(_handlebarsBase);

	// Each of these augment the Handlebars object. No need to setup here.
	// (This is done to easily share code between commonjs and browse envs)

	var _handlebarsSafeString = __webpack_require__(21);

	var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);

	var _handlebarsException = __webpack_require__(6);

	var _handlebarsException2 = _interopRequireDefault(_handlebarsException);

	var _handlebarsUtils = __webpack_require__(5);

	var Utils = _interopRequireWildcard(_handlebarsUtils);

	var _handlebarsRuntime = __webpack_require__(22);

	var runtime = _interopRequireWildcard(_handlebarsRuntime);

	var _handlebarsNoConflict = __webpack_require__(34);

	var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);

	// For compatibility and usage outside of module systems, make the Handlebars object a namespace
	function create() {
	  var hb = new base.HandlebarsEnvironment();

	  Utils.extend(hb, base);
	  hb.SafeString = _handlebarsSafeString2['default'];
	  hb.Exception = _handlebarsException2['default'];
	  hb.Utils = Utils;
	  hb.escapeExpression = Utils.escapeExpression;

	  hb.VM = runtime;
	  hb.template = function (spec) {
	    return runtime.template(spec, hb);
	  };

	  return hb;
	}

	var inst = create();
	inst.create = create;

	_handlebarsNoConflict2['default'](inst);

	inst['default'] = inst;

	exports['default'] = inst;
	module.exports = exports['default'];

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	"use strict";

	exports["default"] = function (obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  } else {
	    var newObj = {};

	    if (obj != null) {
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
	      }
	    }

	    newObj["default"] = obj;
	    return newObj;
	  }
	};

	exports.__esModule = true;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.HandlebarsEnvironment = HandlebarsEnvironment;

	var _utils = __webpack_require__(5);

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	var _helpers = __webpack_require__(10);

	var _decorators = __webpack_require__(18);

	var _logger = __webpack_require__(20);

	var _logger2 = _interopRequireDefault(_logger);

	var VERSION = '4.0.12';
	exports.VERSION = VERSION;
	var COMPILER_REVISION = 7;

	exports.COMPILER_REVISION = COMPILER_REVISION;
	var REVISION_CHANGES = {
	  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
	  2: '== 1.0.0-rc.3',
	  3: '== 1.0.0-rc.4',
	  4: '== 1.x.x',
	  5: '== 2.0.0-alpha.x',
	  6: '>= 2.0.0-beta.1',
	  7: '>= 4.0.0'
	};

	exports.REVISION_CHANGES = REVISION_CHANGES;
	var objectType = '[object Object]';

	function HandlebarsEnvironment(helpers, partials, decorators) {
	  this.helpers = helpers || {};
	  this.partials = partials || {};
	  this.decorators = decorators || {};

	  _helpers.registerDefaultHelpers(this);
	  _decorators.registerDefaultDecorators(this);
	}

	HandlebarsEnvironment.prototype = {
	  constructor: HandlebarsEnvironment,

	  logger: _logger2['default'],
	  log: _logger2['default'].log,

	  registerHelper: function registerHelper(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple helpers');
	      }
	      _utils.extend(this.helpers, name);
	    } else {
	      this.helpers[name] = fn;
	    }
	  },
	  unregisterHelper: function unregisterHelper(name) {
	    delete this.helpers[name];
	  },

	  registerPartial: function registerPartial(name, partial) {
	    if (_utils.toString.call(name) === objectType) {
	      _utils.extend(this.partials, name);
	    } else {
	      if (typeof partial === 'undefined') {
	        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
	      }
	      this.partials[name] = partial;
	    }
	  },
	  unregisterPartial: function unregisterPartial(name) {
	    delete this.partials[name];
	  },

	  registerDecorator: function registerDecorator(name, fn) {
	    if (_utils.toString.call(name) === objectType) {
	      if (fn) {
	        throw new _exception2['default']('Arg not supported with multiple decorators');
	      }
	      _utils.extend(this.decorators, name);
	    } else {
	      this.decorators[name] = fn;
	    }
	  },
	  unregisterDecorator: function unregisterDecorator(name) {
	    delete this.decorators[name];
	  }
	};

	var log = _logger2['default'].log;

	exports.log = log;
	exports.createFrame = _utils.createFrame;
	exports.logger = _logger2['default'];

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	exports.extend = extend;
	exports.indexOf = indexOf;
	exports.escapeExpression = escapeExpression;
	exports.isEmpty = isEmpty;
	exports.createFrame = createFrame;
	exports.blockParams = blockParams;
	exports.appendContextPath = appendContextPath;
	var escape = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#x27;',
	  '`': '&#x60;',
	  '=': '&#x3D;'
	};

	var badChars = /[&<>"'`=]/g,
	    possible = /[&<>"'`=]/;

	function escapeChar(chr) {
	  return escape[chr];
	}

	function extend(obj /* , ...source */) {
	  for (var i = 1; i < arguments.length; i++) {
	    for (var key in arguments[i]) {
	      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
	        obj[key] = arguments[i][key];
	      }
	    }
	  }

	  return obj;
	}

	var toString = Object.prototype.toString;

	exports.toString = toString;
	// Sourced from lodash
	// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
	/* eslint-disable func-style */
	var isFunction = function isFunction(value) {
	  return typeof value === 'function';
	};
	// fallback for older versions of Chrome and Safari
	/* istanbul ignore next */
	if (isFunction(/x/)) {
	  exports.isFunction = isFunction = function (value) {
	    return typeof value === 'function' && toString.call(value) === '[object Function]';
	  };
	}
	exports.isFunction = isFunction;

	/* eslint-enable func-style */

	/* istanbul ignore next */
	var isArray = Array.isArray || function (value) {
	  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
	};

	exports.isArray = isArray;
	// Older IE versions do not directly support indexOf so we must implement our own, sadly.

	function indexOf(array, value) {
	  for (var i = 0, len = array.length; i < len; i++) {
	    if (array[i] === value) {
	      return i;
	    }
	  }
	  return -1;
	}

	function escapeExpression(string) {
	  if (typeof string !== 'string') {
	    // don't escape SafeStrings, since they're already safe
	    if (string && string.toHTML) {
	      return string.toHTML();
	    } else if (string == null) {
	      return '';
	    } else if (!string) {
	      return string + '';
	    }

	    // Force a string conversion as this will be done by the append regardless and
	    // the regex test will do this transparently behind the scenes, causing issues if
	    // an object's to string has escaped characters in it.
	    string = '' + string;
	  }

	  if (!possible.test(string)) {
	    return string;
	  }
	  return string.replace(badChars, escapeChar);
	}

	function isEmpty(value) {
	  if (!value && value !== 0) {
	    return true;
	  } else if (isArray(value) && value.length === 0) {
	    return true;
	  } else {
	    return false;
	  }
	}

	function createFrame(object) {
	  var frame = extend({}, object);
	  frame._parent = object;
	  return frame;
	}

	function blockParams(params, ids) {
	  params.path = ids;
	  return params;
	}

	function appendContextPath(contextPath, id) {
	  return (contextPath ? contextPath + '.' : '') + id;
	}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$defineProperty = __webpack_require__(7)['default'];

	exports.__esModule = true;

	var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];

	function Exception(message, node) {
	  var loc = node && node.loc,
	      line = undefined,
	      column = undefined;
	  if (loc) {
	    line = loc.start.line;
	    column = loc.start.column;

	    message += ' - ' + line + ':' + column;
	  }

	  var tmp = Error.prototype.constructor.call(this, message);

	  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
	  for (var idx = 0; idx < errorProps.length; idx++) {
	    this[errorProps[idx]] = tmp[errorProps[idx]];
	  }

	  /* istanbul ignore else */
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, Exception);
	  }

	  try {
	    if (loc) {
	      this.lineNumber = line;

	      // Work around issue under safari where we can't directly set the column value
	      /* istanbul ignore next */
	      if (_Object$defineProperty) {
	        Object.defineProperty(this, 'column', {
	          value: column,
	          enumerable: true
	        });
	      } else {
	        this.column = column;
	      }
	    }
	  } catch (nop) {
	    /* Ignore if the browser is very particular */
	  }
	}

	Exception.prototype = new Error();

	exports['default'] = Exception;
	module.exports = exports['default'];

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(8), __esModule: true };

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(9);
	module.exports = function defineProperty(it, key, desc){
	  return $.setDesc(it, key, desc);
	};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.registerDefaultHelpers = registerDefaultHelpers;

	var _helpersBlockHelperMissing = __webpack_require__(11);

	var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);

	var _helpersEach = __webpack_require__(12);

	var _helpersEach2 = _interopRequireDefault(_helpersEach);

	var _helpersHelperMissing = __webpack_require__(13);

	var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);

	var _helpersIf = __webpack_require__(14);

	var _helpersIf2 = _interopRequireDefault(_helpersIf);

	var _helpersLog = __webpack_require__(15);

	var _helpersLog2 = _interopRequireDefault(_helpersLog);

	var _helpersLookup = __webpack_require__(16);

	var _helpersLookup2 = _interopRequireDefault(_helpersLookup);

	var _helpersWith = __webpack_require__(17);

	var _helpersWith2 = _interopRequireDefault(_helpersWith);

	function registerDefaultHelpers(instance) {
	  _helpersBlockHelperMissing2['default'](instance);
	  _helpersEach2['default'](instance);
	  _helpersHelperMissing2['default'](instance);
	  _helpersIf2['default'](instance);
	  _helpersLog2['default'](instance);
	  _helpersLookup2['default'](instance);
	  _helpersWith2['default'](instance);
	}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	exports['default'] = function (instance) {
	  instance.registerHelper('blockHelperMissing', function (context, options) {
	    var inverse = options.inverse,
	        fn = options.fn;

	    if (context === true) {
	      return fn(this);
	    } else if (context === false || context == null) {
	      return inverse(this);
	    } else if (_utils.isArray(context)) {
	      if (context.length > 0) {
	        if (options.ids) {
	          options.ids = [options.name];
	        }

	        return instance.helpers.each(context, options);
	      } else {
	        return inverse(this);
	      }
	    } else {
	      if (options.data && options.ids) {
	        var data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
	        options = { data: data };
	      }

	      return fn(context, options);
	    }
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	exports['default'] = function (instance) {
	  instance.registerHelper('each', function (context, options) {
	    if (!options) {
	      throw new _exception2['default']('Must pass iterator to #each');
	    }

	    var fn = options.fn,
	        inverse = options.inverse,
	        i = 0,
	        ret = '',
	        data = undefined,
	        contextPath = undefined;

	    if (options.data && options.ids) {
	      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
	    }

	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }

	    if (options.data) {
	      data = _utils.createFrame(options.data);
	    }

	    function execIteration(field, index, last) {
	      if (data) {
	        data.key = field;
	        data.index = index;
	        data.first = index === 0;
	        data.last = !!last;

	        if (contextPath) {
	          data.contextPath = contextPath + field;
	        }
	      }

	      ret = ret + fn(context[field], {
	        data: data,
	        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
	      });
	    }

	    if (context && typeof context === 'object') {
	      if (_utils.isArray(context)) {
	        for (var j = context.length; i < j; i++) {
	          if (i in context) {
	            execIteration(i, i, i === context.length - 1);
	          }
	        }
	      } else {
	        var priorKey = undefined;

	        for (var key in context) {
	          if (context.hasOwnProperty(key)) {
	            // We're running the iterations one step out of sync so we can detect
	            // the last iteration without have to scan the object twice and create
	            // an itermediate keys array.
	            if (priorKey !== undefined) {
	              execIteration(priorKey, i - 1);
	            }
	            priorKey = key;
	            i++;
	          }
	        }
	        if (priorKey !== undefined) {
	          execIteration(priorKey, i - 1, true);
	        }
	      }
	    }

	    if (i === 0) {
	      ret = inverse(this);
	    }

	    return ret;
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	exports['default'] = function (instance) {
	  instance.registerHelper('helperMissing', function () /* [args, ]options */{
	    if (arguments.length === 1) {
	      // A missing field in a {{foo}} construct.
	      return undefined;
	    } else {
	      // Someone is actually trying to call something, blow up.
	      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
	    }
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	exports['default'] = function (instance) {
	  instance.registerHelper('if', function (conditional, options) {
	    if (_utils.isFunction(conditional)) {
	      conditional = conditional.call(this);
	    }

	    // Default behavior is to render the positive path if the value is truthy and not empty.
	    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
	    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
	    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
	      return options.inverse(this);
	    } else {
	      return options.fn(this);
	    }
	  });

	  instance.registerHelper('unless', function (conditional, options) {
	    return instance.helpers['if'].call(this, conditional, { fn: options.inverse, inverse: options.fn, hash: options.hash });
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;

	exports['default'] = function (instance) {
	  instance.registerHelper('log', function () /* message, options */{
	    var args = [undefined],
	        options = arguments[arguments.length - 1];
	    for (var i = 0; i < arguments.length - 1; i++) {
	      args.push(arguments[i]);
	    }

	    var level = 1;
	    if (options.hash.level != null) {
	      level = options.hash.level;
	    } else if (options.data && options.data.level != null) {
	      level = options.data.level;
	    }
	    args[0] = level;

	    instance.log.apply(instance, args);
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;

	exports['default'] = function (instance) {
	  instance.registerHelper('lookup', function (obj, field) {
	    return obj && obj[field];
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	exports['default'] = function (instance) {
	  instance.registerHelper('with', function (context, options) {
	    if (_utils.isFunction(context)) {
	      context = context.call(this);
	    }

	    var fn = options.fn;

	    if (!_utils.isEmpty(context)) {
	      var data = options.data;
	      if (options.data && options.ids) {
	        data = _utils.createFrame(options.data);
	        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
	      }

	      return fn(context, {
	        data: data,
	        blockParams: _utils.blockParams([context], [data && data.contextPath])
	      });
	    } else {
	      return options.inverse(this);
	    }
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.registerDefaultDecorators = registerDefaultDecorators;

	var _decoratorsInline = __webpack_require__(19);

	var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);

	function registerDefaultDecorators(instance) {
	  _decoratorsInline2['default'](instance);
	}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	exports['default'] = function (instance) {
	  instance.registerDecorator('inline', function (fn, props, container, options) {
	    var ret = fn;
	    if (!props.partials) {
	      props.partials = {};
	      ret = function (context, options) {
	        // Create a new partials stack frame prior to exec.
	        var original = container.partials;
	        container.partials = _utils.extend({}, original, props.partials);
	        var ret = fn(context, options);
	        container.partials = original;
	        return ret;
	      };
	    }

	    props.partials[options.args[0]] = options.fn;

	    return ret;
	  });
	};

	module.exports = exports['default'];

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	var logger = {
	  methodMap: ['debug', 'info', 'warn', 'error'],
	  level: 'info',

	  // Maps a given level value to the `methodMap` indexes above.
	  lookupLevel: function lookupLevel(level) {
	    if (typeof level === 'string') {
	      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
	      if (levelMap >= 0) {
	        level = levelMap;
	      } else {
	        level = parseInt(level, 10);
	      }
	    }

	    return level;
	  },

	  // Can be overridden in the host environment
	  log: function log(level) {
	    level = logger.lookupLevel(level);

	    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
	      var method = logger.methodMap[level];
	      if (!console[method]) {
	        // eslint-disable-line no-console
	        method = 'log';
	      }

	      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        message[_key - 1] = arguments[_key];
	      }

	      console[method].apply(console, message); // eslint-disable-line no-console
	    }
	  }
	};

	exports['default'] = logger;
	module.exports = exports['default'];

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	// Build out our basic SafeString type
	'use strict';

	exports.__esModule = true;
	function SafeString(string) {
	  this.string = string;
	}

	SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
	  return '' + this.string;
	};

	exports['default'] = SafeString;
	module.exports = exports['default'];

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _Object$seal = __webpack_require__(23)['default'];

	var _interopRequireWildcard = __webpack_require__(3)['default'];

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.checkRevision = checkRevision;
	exports.template = template;
	exports.wrapProgram = wrapProgram;
	exports.resolvePartial = resolvePartial;
	exports.invokePartial = invokePartial;
	exports.noop = noop;

	var _utils = __webpack_require__(5);

	var Utils = _interopRequireWildcard(_utils);

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	var _base = __webpack_require__(4);

	function checkRevision(compilerInfo) {
	  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
	      currentRevision = _base.COMPILER_REVISION;

	  if (compilerRevision !== currentRevision) {
	    if (compilerRevision < currentRevision) {
	      var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
	          compilerVersions = _base.REVISION_CHANGES[compilerRevision];
	      throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
	    } else {
	      // Use the embedded version info since the runtime doesn't know about this revision yet
	      throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
	    }
	  }
	}

	function template(templateSpec, env) {
	  /* istanbul ignore next */
	  if (!env) {
	    throw new _exception2['default']('No environment passed to template');
	  }
	  if (!templateSpec || !templateSpec.main) {
	    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
	  }

	  templateSpec.main.decorator = templateSpec.main_d;

	  // Note: Using env.VM references rather than local var references throughout this section to allow
	  // for external users to override these as psuedo-supported APIs.
	  env.VM.checkRevision(templateSpec.compiler);

	  function invokePartialWrapper(partial, context, options) {
	    if (options.hash) {
	      context = Utils.extend({}, context, options.hash);
	      if (options.ids) {
	        options.ids[0] = true;
	      }
	    }

	    partial = env.VM.resolvePartial.call(this, partial, context, options);
	    var result = env.VM.invokePartial.call(this, partial, context, options);

	    if (result == null && env.compile) {
	      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
	      result = options.partials[options.name](context, options);
	    }
	    if (result != null) {
	      if (options.indent) {
	        var lines = result.split('\n');
	        for (var i = 0, l = lines.length; i < l; i++) {
	          if (!lines[i] && i + 1 === l) {
	            break;
	          }

	          lines[i] = options.indent + lines[i];
	        }
	        result = lines.join('\n');
	      }
	      return result;
	    } else {
	      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
	    }
	  }

	  // Just add water
	  var container = {
	    strict: function strict(obj, name) {
	      if (!(name in obj)) {
	        throw new _exception2['default']('"' + name + '" not defined in ' + obj);
	      }
	      return obj[name];
	    },
	    lookup: function lookup(depths, name) {
	      var len = depths.length;
	      for (var i = 0; i < len; i++) {
	        if (depths[i] && depths[i][name] != null) {
	          return depths[i][name];
	        }
	      }
	    },
	    lambda: function lambda(current, context) {
	      return typeof current === 'function' ? current.call(context) : current;
	    },

	    escapeExpression: Utils.escapeExpression,
	    invokePartial: invokePartialWrapper,

	    fn: function fn(i) {
	      var ret = templateSpec[i];
	      ret.decorator = templateSpec[i + '_d'];
	      return ret;
	    },

	    programs: [],
	    program: function program(i, data, declaredBlockParams, blockParams, depths) {
	      var programWrapper = this.programs[i],
	          fn = this.fn(i);
	      if (data || depths || blockParams || declaredBlockParams) {
	        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
	      } else if (!programWrapper) {
	        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
	      }
	      return programWrapper;
	    },

	    data: function data(value, depth) {
	      while (value && depth--) {
	        value = value._parent;
	      }
	      return value;
	    },
	    merge: function merge(param, common) {
	      var obj = param || common;

	      if (param && common && param !== common) {
	        obj = Utils.extend({}, common, param);
	      }

	      return obj;
	    },
	    // An empty object to use as replacement for null-contexts
	    nullContext: _Object$seal({}),

	    noop: env.VM.noop,
	    compilerInfo: templateSpec.compiler
	  };

	  function ret(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	    var data = options.data;

	    ret._setup(options);
	    if (!options.partial && templateSpec.useData) {
	      data = initData(context, data);
	    }
	    var depths = undefined,
	        blockParams = templateSpec.useBlockParams ? [] : undefined;
	    if (templateSpec.useDepths) {
	      if (options.depths) {
	        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
	      } else {
	        depths = [context];
	      }
	    }

	    function main(context /*, options*/) {
	      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
	    }
	    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
	    return main(context, options);
	  }
	  ret.isTop = true;

	  ret._setup = function (options) {
	    if (!options.partial) {
	      container.helpers = container.merge(options.helpers, env.helpers);

	      if (templateSpec.usePartial) {
	        container.partials = container.merge(options.partials, env.partials);
	      }
	      if (templateSpec.usePartial || templateSpec.useDecorators) {
	        container.decorators = container.merge(options.decorators, env.decorators);
	      }
	    } else {
	      container.helpers = options.helpers;
	      container.partials = options.partials;
	      container.decorators = options.decorators;
	    }
	  };

	  ret._child = function (i, data, blockParams, depths) {
	    if (templateSpec.useBlockParams && !blockParams) {
	      throw new _exception2['default']('must pass block params');
	    }
	    if (templateSpec.useDepths && !depths) {
	      throw new _exception2['default']('must pass parent depths');
	    }

	    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
	  };
	  return ret;
	}

	function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
	  function prog(context) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	    var currentDepths = depths;
	    if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) {
	      currentDepths = [context].concat(depths);
	    }

	    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
	  }

	  prog = executeDecorators(fn, prog, container, depths, data, blockParams);

	  prog.program = i;
	  prog.depth = depths ? depths.length : 0;
	  prog.blockParams = declaredBlockParams || 0;
	  return prog;
	}

	function resolvePartial(partial, context, options) {
	  if (!partial) {
	    if (options.name === '@partial-block') {
	      partial = options.data['partial-block'];
	    } else {
	      partial = options.partials[options.name];
	    }
	  } else if (!partial.call && !options.name) {
	    // This is a dynamic partial that returned a string
	    options.name = partial;
	    partial = options.partials[partial];
	  }
	  return partial;
	}

	function invokePartial(partial, context, options) {
	  // Use the current closure context to save the partial-block if this partial
	  var currentPartialBlock = options.data && options.data['partial-block'];
	  options.partial = true;
	  if (options.ids) {
	    options.data.contextPath = options.ids[0] || options.data.contextPath;
	  }

	  var partialBlock = undefined;
	  if (options.fn && options.fn !== noop) {
	    (function () {
	      options.data = _base.createFrame(options.data);
	      // Wrapper function to get access to currentPartialBlock from the closure
	      var fn = options.fn;
	      partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
	        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	        // Restore the partial-block from the closure for the execution of the block
	        // i.e. the part inside the block of the partial call.
	        options.data = _base.createFrame(options.data);
	        options.data['partial-block'] = currentPartialBlock;
	        return fn(context, options);
	      };
	      if (fn.partials) {
	        options.partials = Utils.extend({}, options.partials, fn.partials);
	      }
	    })();
	  }

	  if (partial === undefined && partialBlock) {
	    partial = partialBlock;
	  }

	  if (partial === undefined) {
	    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
	  } else if (partial instanceof Function) {
	    return partial(context, options);
	  }
	}

	function noop() {
	  return '';
	}

	function initData(context, data) {
	  if (!data || !('root' in data)) {
	    data = data ? _base.createFrame(data) : {};
	    data.root = context;
	  }
	  return data;
	}

	function executeDecorators(fn, prog, container, depths, data, blockParams) {
	  if (fn.decorator) {
	    var props = {};
	    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
	    Utils.extend(prog, props);
	  }
	  return prog;
	}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(24), __esModule: true };

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(25);
	module.exports = __webpack_require__(30).Object.seal;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(26);

	__webpack_require__(27)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(it) : it;
	  };
	});

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(28)
	  , core    = __webpack_require__(30)
	  , fails   = __webpack_require__(33);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(29)
	  , core      = __webpack_require__(30)
	  , ctx       = __webpack_require__(31)
	  , PROTOTYPE = 'prototype';

	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	};
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	var core = module.exports = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(32);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/* global window */
	'use strict';

	exports.__esModule = true;

	exports['default'] = function (Handlebars) {
	  /* istanbul ignore next */
	  var root = typeof global !== 'undefined' ? global : window,
	      $Handlebars = root.Handlebars;
	  /* istanbul ignore next */
	  Handlebars.noConflict = function () {
	    if (root.Handlebars === Handlebars) {
	      root.Handlebars = $Handlebars;
	    }
	    return Handlebars;
	  };
	};

	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';

	exports.__esModule = true;
	var AST = {
	  // Public API used to evaluate derived attributes regarding AST nodes
	  helpers: {
	    // a mustache is definitely a helper if:
	    // * it is an eligible helper, and
	    // * it has at least one parameter or hash segment
	    helperExpression: function helperExpression(node) {
	      return node.type === 'SubExpression' || (node.type === 'MustacheStatement' || node.type === 'BlockStatement') && !!(node.params && node.params.length || node.hash);
	    },

	    scopedId: function scopedId(path) {
	      return (/^\.|this\b/.test(path.original)
	      );
	    },

	    // an ID is simple if it only has one part, and that part is not
	    // `..` or `this`.
	    simpleId: function simpleId(path) {
	      return path.parts.length === 1 && !AST.helpers.scopedId(path) && !path.depth;
	    }
	  }
	};

	// Must be exported as an object rather than the root of the module as the jison lexer
	// must modify the object to operate properly.
	exports['default'] = AST;
	module.exports = exports['default'];

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	var _interopRequireWildcard = __webpack_require__(3)['default'];

	exports.__esModule = true;
	exports.parse = parse;

	var _parser = __webpack_require__(37);

	var _parser2 = _interopRequireDefault(_parser);

	var _whitespaceControl = __webpack_require__(38);

	var _whitespaceControl2 = _interopRequireDefault(_whitespaceControl);

	var _helpers = __webpack_require__(40);

	var Helpers = _interopRequireWildcard(_helpers);

	var _utils = __webpack_require__(5);

	exports.parser = _parser2['default'];

	var yy = {};
	_utils.extend(yy, Helpers);

	function parse(input, options) {
	  // Just return if an already-compiled AST was passed in.
	  if (input.type === 'Program') {
	    return input;
	  }

	  _parser2['default'].yy = yy;

	  // Altering the shared object here, but this is ok as parser is a sync operation
	  yy.locInfo = function (locInfo) {
	    return new yy.SourceLocation(options && options.srcName, locInfo);
	  };

	  var strip = new _whitespaceControl2['default'](options);
	  return strip.accept(_parser2['default'].parse(input));
	}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	// File ignored in coverage tests via setting in .istanbul.yml
	/* Jison generated parser */
	"use strict";

	exports.__esModule = true;
	var handlebars = (function () {
	    var parser = { trace: function trace() {},
	        yy: {},
	        symbols_: { "error": 2, "root": 3, "program": 4, "EOF": 5, "program_repetition0": 6, "statement": 7, "mustache": 8, "block": 9, "rawBlock": 10, "partial": 11, "partialBlock": 12, "content": 13, "COMMENT": 14, "CONTENT": 15, "openRawBlock": 16, "rawBlock_repetition_plus0": 17, "END_RAW_BLOCK": 18, "OPEN_RAW_BLOCK": 19, "helperName": 20, "openRawBlock_repetition0": 21, "openRawBlock_option0": 22, "CLOSE_RAW_BLOCK": 23, "openBlock": 24, "block_option0": 25, "closeBlock": 26, "openInverse": 27, "block_option1": 28, "OPEN_BLOCK": 29, "openBlock_repetition0": 30, "openBlock_option0": 31, "openBlock_option1": 32, "CLOSE": 33, "OPEN_INVERSE": 34, "openInverse_repetition0": 35, "openInverse_option0": 36, "openInverse_option1": 37, "openInverseChain": 38, "OPEN_INVERSE_CHAIN": 39, "openInverseChain_repetition0": 40, "openInverseChain_option0": 41, "openInverseChain_option1": 42, "inverseAndProgram": 43, "INVERSE": 44, "inverseChain": 45, "inverseChain_option0": 46, "OPEN_ENDBLOCK": 47, "OPEN": 48, "mustache_repetition0": 49, "mustache_option0": 50, "OPEN_UNESCAPED": 51, "mustache_repetition1": 52, "mustache_option1": 53, "CLOSE_UNESCAPED": 54, "OPEN_PARTIAL": 55, "partialName": 56, "partial_repetition0": 57, "partial_option0": 58, "openPartialBlock": 59, "OPEN_PARTIAL_BLOCK": 60, "openPartialBlock_repetition0": 61, "openPartialBlock_option0": 62, "param": 63, "sexpr": 64, "OPEN_SEXPR": 65, "sexpr_repetition0": 66, "sexpr_option0": 67, "CLOSE_SEXPR": 68, "hash": 69, "hash_repetition_plus0": 70, "hashSegment": 71, "ID": 72, "EQUALS": 73, "blockParams": 74, "OPEN_BLOCK_PARAMS": 75, "blockParams_repetition_plus0": 76, "CLOSE_BLOCK_PARAMS": 77, "path": 78, "dataName": 79, "STRING": 80, "NUMBER": 81, "BOOLEAN": 82, "UNDEFINED": 83, "NULL": 84, "DATA": 85, "pathSegments": 86, "SEP": 87, "$accept": 0, "$end": 1 },
	        terminals_: { 2: "error", 5: "EOF", 14: "COMMENT", 15: "CONTENT", 18: "END_RAW_BLOCK", 19: "OPEN_RAW_BLOCK", 23: "CLOSE_RAW_BLOCK", 29: "OPEN_BLOCK", 33: "CLOSE", 34: "OPEN_INVERSE", 39: "OPEN_INVERSE_CHAIN", 44: "INVERSE", 47: "OPEN_ENDBLOCK", 48: "OPEN", 51: "OPEN_UNESCAPED", 54: "CLOSE_UNESCAPED", 55: "OPEN_PARTIAL", 60: "OPEN_PARTIAL_BLOCK", 65: "OPEN_SEXPR", 68: "CLOSE_SEXPR", 72: "ID", 73: "EQUALS", 75: "OPEN_BLOCK_PARAMS", 77: "CLOSE_BLOCK_PARAMS", 80: "STRING", 81: "NUMBER", 82: "BOOLEAN", 83: "UNDEFINED", 84: "NULL", 85: "DATA", 87: "SEP" },
	        productions_: [0, [3, 2], [4, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [7, 1], [13, 1], [10, 3], [16, 5], [9, 4], [9, 4], [24, 6], [27, 6], [38, 6], [43, 2], [45, 3], [45, 1], [26, 3], [8, 5], [8, 5], [11, 5], [12, 3], [59, 5], [63, 1], [63, 1], [64, 5], [69, 1], [71, 3], [74, 3], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [20, 1], [56, 1], [56, 1], [79, 2], [78, 1], [86, 3], [86, 1], [6, 0], [6, 2], [17, 1], [17, 2], [21, 0], [21, 2], [22, 0], [22, 1], [25, 0], [25, 1], [28, 0], [28, 1], [30, 0], [30, 2], [31, 0], [31, 1], [32, 0], [32, 1], [35, 0], [35, 2], [36, 0], [36, 1], [37, 0], [37, 1], [40, 0], [40, 2], [41, 0], [41, 1], [42, 0], [42, 1], [46, 0], [46, 1], [49, 0], [49, 2], [50, 0], [50, 1], [52, 0], [52, 2], [53, 0], [53, 1], [57, 0], [57, 2], [58, 0], [58, 1], [61, 0], [61, 2], [62, 0], [62, 1], [66, 0], [66, 2], [67, 0], [67, 1], [70, 1], [70, 2], [76, 1], [76, 2]],
	        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$
	        /*``*/) {

	            var $0 = $$.length - 1;
	            switch (yystate) {
	                case 1:
	                    return $$[$0 - 1];
	                    break;
	                case 2:
	                    this.$ = yy.prepareProgram($$[$0]);
	                    break;
	                case 3:
	                    this.$ = $$[$0];
	                    break;
	                case 4:
	                    this.$ = $$[$0];
	                    break;
	                case 5:
	                    this.$ = $$[$0];
	                    break;
	                case 6:
	                    this.$ = $$[$0];
	                    break;
	                case 7:
	                    this.$ = $$[$0];
	                    break;
	                case 8:
	                    this.$ = $$[$0];
	                    break;
	                case 9:
	                    this.$ = {
	                        type: 'CommentStatement',
	                        value: yy.stripComment($$[$0]),
	                        strip: yy.stripFlags($$[$0], $$[$0]),
	                        loc: yy.locInfo(this._$)
	                    };

	                    break;
	                case 10:
	                    this.$ = {
	                        type: 'ContentStatement',
	                        original: $$[$0],
	                        value: $$[$0],
	                        loc: yy.locInfo(this._$)
	                    };

	                    break;
	                case 11:
	                    this.$ = yy.prepareRawBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
	                    break;
	                case 12:
	                    this.$ = { path: $$[$0 - 3], params: $$[$0 - 2], hash: $$[$0 - 1] };
	                    break;
	                case 13:
	                    this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], false, this._$);
	                    break;
	                case 14:
	                    this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], true, this._$);
	                    break;
	                case 15:
	                    this.$ = { open: $$[$0 - 5], path: $$[$0 - 4], params: $$[$0 - 3], hash: $$[$0 - 2], blockParams: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 5], $$[$0]) };
	                    break;
	                case 16:
	                    this.$ = { path: $$[$0 - 4], params: $$[$0 - 3], hash: $$[$0 - 2], blockParams: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 5], $$[$0]) };
	                    break;
	                case 17:
	                    this.$ = { path: $$[$0 - 4], params: $$[$0 - 3], hash: $$[$0 - 2], blockParams: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 5], $$[$0]) };
	                    break;
	                case 18:
	                    this.$ = { strip: yy.stripFlags($$[$0 - 1], $$[$0 - 1]), program: $$[$0] };
	                    break;
	                case 19:
	                    var inverse = yy.prepareBlock($$[$0 - 2], $$[$0 - 1], $$[$0], $$[$0], false, this._$),
	                        program = yy.prepareProgram([inverse], $$[$0 - 1].loc);
	                    program.chained = true;

	                    this.$ = { strip: $$[$0 - 2].strip, program: program, chain: true };

	                    break;
	                case 20:
	                    this.$ = $$[$0];
	                    break;
	                case 21:
	                    this.$ = { path: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 2], $$[$0]) };
	                    break;
	                case 22:
	                    this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
	                    break;
	                case 23:
	                    this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
	                    break;
	                case 24:
	                    this.$ = {
	                        type: 'PartialStatement',
	                        name: $$[$0 - 3],
	                        params: $$[$0 - 2],
	                        hash: $$[$0 - 1],
	                        indent: '',
	                        strip: yy.stripFlags($$[$0 - 4], $$[$0]),
	                        loc: yy.locInfo(this._$)
	                    };

	                    break;
	                case 25:
	                    this.$ = yy.preparePartialBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
	                    break;
	                case 26:
	                    this.$ = { path: $$[$0 - 3], params: $$[$0 - 2], hash: $$[$0 - 1], strip: yy.stripFlags($$[$0 - 4], $$[$0]) };
	                    break;
	                case 27:
	                    this.$ = $$[$0];
	                    break;
	                case 28:
	                    this.$ = $$[$0];
	                    break;
	                case 29:
	                    this.$ = {
	                        type: 'SubExpression',
	                        path: $$[$0 - 3],
	                        params: $$[$0 - 2],
	                        hash: $$[$0 - 1],
	                        loc: yy.locInfo(this._$)
	                    };

	                    break;
	                case 30:
	                    this.$ = { type: 'Hash', pairs: $$[$0], loc: yy.locInfo(this._$) };
	                    break;
	                case 31:
	                    this.$ = { type: 'HashPair', key: yy.id($$[$0 - 2]), value: $$[$0], loc: yy.locInfo(this._$) };
	                    break;
	                case 32:
	                    this.$ = yy.id($$[$0 - 1]);
	                    break;
	                case 33:
	                    this.$ = $$[$0];
	                    break;
	                case 34:
	                    this.$ = $$[$0];
	                    break;
	                case 35:
	                    this.$ = { type: 'StringLiteral', value: $$[$0], original: $$[$0], loc: yy.locInfo(this._$) };
	                    break;
	                case 36:
	                    this.$ = { type: 'NumberLiteral', value: Number($$[$0]), original: Number($$[$0]), loc: yy.locInfo(this._$) };
	                    break;
	                case 37:
	                    this.$ = { type: 'BooleanLiteral', value: $$[$0] === 'true', original: $$[$0] === 'true', loc: yy.locInfo(this._$) };
	                    break;
	                case 38:
	                    this.$ = { type: 'UndefinedLiteral', original: undefined, value: undefined, loc: yy.locInfo(this._$) };
	                    break;
	                case 39:
	                    this.$ = { type: 'NullLiteral', original: null, value: null, loc: yy.locInfo(this._$) };
	                    break;
	                case 40:
	                    this.$ = $$[$0];
	                    break;
	                case 41:
	                    this.$ = $$[$0];
	                    break;
	                case 42:
	                    this.$ = yy.preparePath(true, $$[$0], this._$);
	                    break;
	                case 43:
	                    this.$ = yy.preparePath(false, $$[$0], this._$);
	                    break;
	                case 44:
	                    $$[$0 - 2].push({ part: yy.id($$[$0]), original: $$[$0], separator: $$[$0 - 1] });this.$ = $$[$0 - 2];
	                    break;
	                case 45:
	                    this.$ = [{ part: yy.id($$[$0]), original: $$[$0] }];
	                    break;
	                case 46:
	                    this.$ = [];
	                    break;
	                case 47:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 48:
	                    this.$ = [$$[$0]];
	                    break;
	                case 49:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 50:
	                    this.$ = [];
	                    break;
	                case 51:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 58:
	                    this.$ = [];
	                    break;
	                case 59:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 64:
	                    this.$ = [];
	                    break;
	                case 65:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 70:
	                    this.$ = [];
	                    break;
	                case 71:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 78:
	                    this.$ = [];
	                    break;
	                case 79:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 82:
	                    this.$ = [];
	                    break;
	                case 83:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 86:
	                    this.$ = [];
	                    break;
	                case 87:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 90:
	                    this.$ = [];
	                    break;
	                case 91:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 94:
	                    this.$ = [];
	                    break;
	                case 95:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 98:
	                    this.$ = [$$[$0]];
	                    break;
	                case 99:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	                case 100:
	                    this.$ = [$$[$0]];
	                    break;
	                case 101:
	                    $$[$0 - 1].push($$[$0]);
	                    break;
	            }
	        },
	        table: [{ 3: 1, 4: 2, 5: [2, 46], 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 1: [3] }, { 5: [1, 4] }, { 5: [2, 2], 7: 5, 8: 6, 9: 7, 10: 8, 11: 9, 12: 10, 13: 11, 14: [1, 12], 15: [1, 20], 16: 17, 19: [1, 23], 24: 15, 27: 16, 29: [1, 21], 34: [1, 22], 39: [2, 2], 44: [2, 2], 47: [2, 2], 48: [1, 13], 51: [1, 14], 55: [1, 18], 59: 19, 60: [1, 24] }, { 1: [2, 1] }, { 5: [2, 47], 14: [2, 47], 15: [2, 47], 19: [2, 47], 29: [2, 47], 34: [2, 47], 39: [2, 47], 44: [2, 47], 47: [2, 47], 48: [2, 47], 51: [2, 47], 55: [2, 47], 60: [2, 47] }, { 5: [2, 3], 14: [2, 3], 15: [2, 3], 19: [2, 3], 29: [2, 3], 34: [2, 3], 39: [2, 3], 44: [2, 3], 47: [2, 3], 48: [2, 3], 51: [2, 3], 55: [2, 3], 60: [2, 3] }, { 5: [2, 4], 14: [2, 4], 15: [2, 4], 19: [2, 4], 29: [2, 4], 34: [2, 4], 39: [2, 4], 44: [2, 4], 47: [2, 4], 48: [2, 4], 51: [2, 4], 55: [2, 4], 60: [2, 4] }, { 5: [2, 5], 14: [2, 5], 15: [2, 5], 19: [2, 5], 29: [2, 5], 34: [2, 5], 39: [2, 5], 44: [2, 5], 47: [2, 5], 48: [2, 5], 51: [2, 5], 55: [2, 5], 60: [2, 5] }, { 5: [2, 6], 14: [2, 6], 15: [2, 6], 19: [2, 6], 29: [2, 6], 34: [2, 6], 39: [2, 6], 44: [2, 6], 47: [2, 6], 48: [2, 6], 51: [2, 6], 55: [2, 6], 60: [2, 6] }, { 5: [2, 7], 14: [2, 7], 15: [2, 7], 19: [2, 7], 29: [2, 7], 34: [2, 7], 39: [2, 7], 44: [2, 7], 47: [2, 7], 48: [2, 7], 51: [2, 7], 55: [2, 7], 60: [2, 7] }, { 5: [2, 8], 14: [2, 8], 15: [2, 8], 19: [2, 8], 29: [2, 8], 34: [2, 8], 39: [2, 8], 44: [2, 8], 47: [2, 8], 48: [2, 8], 51: [2, 8], 55: [2, 8], 60: [2, 8] }, { 5: [2, 9], 14: [2, 9], 15: [2, 9], 19: [2, 9], 29: [2, 9], 34: [2, 9], 39: [2, 9], 44: [2, 9], 47: [2, 9], 48: [2, 9], 51: [2, 9], 55: [2, 9], 60: [2, 9] }, { 20: 25, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 36, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 37, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 39: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 4: 38, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 13: 40, 15: [1, 20], 17: 39 }, { 20: 42, 56: 41, 64: 43, 65: [1, 44], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 45, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 5: [2, 10], 14: [2, 10], 15: [2, 10], 18: [2, 10], 19: [2, 10], 29: [2, 10], 34: [2, 10], 39: [2, 10], 44: [2, 10], 47: [2, 10], 48: [2, 10], 51: [2, 10], 55: [2, 10], 60: [2, 10] }, { 20: 46, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 47, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 48, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 42, 56: 49, 64: 43, 65: [1, 44], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [2, 78], 49: 50, 65: [2, 78], 72: [2, 78], 80: [2, 78], 81: [2, 78], 82: [2, 78], 83: [2, 78], 84: [2, 78], 85: [2, 78] }, { 23: [2, 33], 33: [2, 33], 54: [2, 33], 65: [2, 33], 68: [2, 33], 72: [2, 33], 75: [2, 33], 80: [2, 33], 81: [2, 33], 82: [2, 33], 83: [2, 33], 84: [2, 33], 85: [2, 33] }, { 23: [2, 34], 33: [2, 34], 54: [2, 34], 65: [2, 34], 68: [2, 34], 72: [2, 34], 75: [2, 34], 80: [2, 34], 81: [2, 34], 82: [2, 34], 83: [2, 34], 84: [2, 34], 85: [2, 34] }, { 23: [2, 35], 33: [2, 35], 54: [2, 35], 65: [2, 35], 68: [2, 35], 72: [2, 35], 75: [2, 35], 80: [2, 35], 81: [2, 35], 82: [2, 35], 83: [2, 35], 84: [2, 35], 85: [2, 35] }, { 23: [2, 36], 33: [2, 36], 54: [2, 36], 65: [2, 36], 68: [2, 36], 72: [2, 36], 75: [2, 36], 80: [2, 36], 81: [2, 36], 82: [2, 36], 83: [2, 36], 84: [2, 36], 85: [2, 36] }, { 23: [2, 37], 33: [2, 37], 54: [2, 37], 65: [2, 37], 68: [2, 37], 72: [2, 37], 75: [2, 37], 80: [2, 37], 81: [2, 37], 82: [2, 37], 83: [2, 37], 84: [2, 37], 85: [2, 37] }, { 23: [2, 38], 33: [2, 38], 54: [2, 38], 65: [2, 38], 68: [2, 38], 72: [2, 38], 75: [2, 38], 80: [2, 38], 81: [2, 38], 82: [2, 38], 83: [2, 38], 84: [2, 38], 85: [2, 38] }, { 23: [2, 39], 33: [2, 39], 54: [2, 39], 65: [2, 39], 68: [2, 39], 72: [2, 39], 75: [2, 39], 80: [2, 39], 81: [2, 39], 82: [2, 39], 83: [2, 39], 84: [2, 39], 85: [2, 39] }, { 23: [2, 43], 33: [2, 43], 54: [2, 43], 65: [2, 43], 68: [2, 43], 72: [2, 43], 75: [2, 43], 80: [2, 43], 81: [2, 43], 82: [2, 43], 83: [2, 43], 84: [2, 43], 85: [2, 43], 87: [1, 51] }, { 72: [1, 35], 86: 52 }, { 23: [2, 45], 33: [2, 45], 54: [2, 45], 65: [2, 45], 68: [2, 45], 72: [2, 45], 75: [2, 45], 80: [2, 45], 81: [2, 45], 82: [2, 45], 83: [2, 45], 84: [2, 45], 85: [2, 45], 87: [2, 45] }, { 52: 53, 54: [2, 82], 65: [2, 82], 72: [2, 82], 80: [2, 82], 81: [2, 82], 82: [2, 82], 83: [2, 82], 84: [2, 82], 85: [2, 82] }, { 25: 54, 38: 56, 39: [1, 58], 43: 57, 44: [1, 59], 45: 55, 47: [2, 54] }, { 28: 60, 43: 61, 44: [1, 59], 47: [2, 56] }, { 13: 63, 15: [1, 20], 18: [1, 62] }, { 15: [2, 48], 18: [2, 48] }, { 33: [2, 86], 57: 64, 65: [2, 86], 72: [2, 86], 80: [2, 86], 81: [2, 86], 82: [2, 86], 83: [2, 86], 84: [2, 86], 85: [2, 86] }, { 33: [2, 40], 65: [2, 40], 72: [2, 40], 80: [2, 40], 81: [2, 40], 82: [2, 40], 83: [2, 40], 84: [2, 40], 85: [2, 40] }, { 33: [2, 41], 65: [2, 41], 72: [2, 41], 80: [2, 41], 81: [2, 41], 82: [2, 41], 83: [2, 41], 84: [2, 41], 85: [2, 41] }, { 20: 65, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 26: 66, 47: [1, 67] }, { 30: 68, 33: [2, 58], 65: [2, 58], 72: [2, 58], 75: [2, 58], 80: [2, 58], 81: [2, 58], 82: [2, 58], 83: [2, 58], 84: [2, 58], 85: [2, 58] }, { 33: [2, 64], 35: 69, 65: [2, 64], 72: [2, 64], 75: [2, 64], 80: [2, 64], 81: [2, 64], 82: [2, 64], 83: [2, 64], 84: [2, 64], 85: [2, 64] }, { 21: 70, 23: [2, 50], 65: [2, 50], 72: [2, 50], 80: [2, 50], 81: [2, 50], 82: [2, 50], 83: [2, 50], 84: [2, 50], 85: [2, 50] }, { 33: [2, 90], 61: 71, 65: [2, 90], 72: [2, 90], 80: [2, 90], 81: [2, 90], 82: [2, 90], 83: [2, 90], 84: [2, 90], 85: [2, 90] }, { 20: 75, 33: [2, 80], 50: 72, 63: 73, 64: 76, 65: [1, 44], 69: 74, 70: 77, 71: 78, 72: [1, 79], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 72: [1, 80] }, { 23: [2, 42], 33: [2, 42], 54: [2, 42], 65: [2, 42], 68: [2, 42], 72: [2, 42], 75: [2, 42], 80: [2, 42], 81: [2, 42], 82: [2, 42], 83: [2, 42], 84: [2, 42], 85: [2, 42], 87: [1, 51] }, { 20: 75, 53: 81, 54: [2, 84], 63: 82, 64: 76, 65: [1, 44], 69: 83, 70: 77, 71: 78, 72: [1, 79], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 26: 84, 47: [1, 67] }, { 47: [2, 55] }, { 4: 85, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 39: [2, 46], 44: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 47: [2, 20] }, { 20: 86, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 4: 87, 6: 3, 14: [2, 46], 15: [2, 46], 19: [2, 46], 29: [2, 46], 34: [2, 46], 47: [2, 46], 48: [2, 46], 51: [2, 46], 55: [2, 46], 60: [2, 46] }, { 26: 88, 47: [1, 67] }, { 47: [2, 57] }, { 5: [2, 11], 14: [2, 11], 15: [2, 11], 19: [2, 11], 29: [2, 11], 34: [2, 11], 39: [2, 11], 44: [2, 11], 47: [2, 11], 48: [2, 11], 51: [2, 11], 55: [2, 11], 60: [2, 11] }, { 15: [2, 49], 18: [2, 49] }, { 20: 75, 33: [2, 88], 58: 89, 63: 90, 64: 76, 65: [1, 44], 69: 91, 70: 77, 71: 78, 72: [1, 79], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 65: [2, 94], 66: 92, 68: [2, 94], 72: [2, 94], 80: [2, 94], 81: [2, 94], 82: [2, 94], 83: [2, 94], 84: [2, 94], 85: [2, 94] }, { 5: [2, 25], 14: [2, 25], 15: [2, 25], 19: [2, 25], 29: [2, 25], 34: [2, 25], 39: [2, 25], 44: [2, 25], 47: [2, 25], 48: [2, 25], 51: [2, 25], 55: [2, 25], 60: [2, 25] }, { 20: 93, 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 75, 31: 94, 33: [2, 60], 63: 95, 64: 76, 65: [1, 44], 69: 96, 70: 77, 71: 78, 72: [1, 79], 75: [2, 60], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 75, 33: [2, 66], 36: 97, 63: 98, 64: 76, 65: [1, 44], 69: 99, 70: 77, 71: 78, 72: [1, 79], 75: [2, 66], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 75, 22: 100, 23: [2, 52], 63: 101, 64: 76, 65: [1, 44], 69: 102, 70: 77, 71: 78, 72: [1, 79], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 20: 75, 33: [2, 92], 62: 103, 63: 104, 64: 76, 65: [1, 44], 69: 105, 70: 77, 71: 78, 72: [1, 79], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [1, 106] }, { 33: [2, 79], 65: [2, 79], 72: [2, 79], 80: [2, 79], 81: [2, 79], 82: [2, 79], 83: [2, 79], 84: [2, 79], 85: [2, 79] }, { 33: [2, 81] }, { 23: [2, 27], 33: [2, 27], 54: [2, 27], 65: [2, 27], 68: [2, 27], 72: [2, 27], 75: [2, 27], 80: [2, 27], 81: [2, 27], 82: [2, 27], 83: [2, 27], 84: [2, 27], 85: [2, 27] }, { 23: [2, 28], 33: [2, 28], 54: [2, 28], 65: [2, 28], 68: [2, 28], 72: [2, 28], 75: [2, 28], 80: [2, 28], 81: [2, 28], 82: [2, 28], 83: [2, 28], 84: [2, 28], 85: [2, 28] }, { 23: [2, 30], 33: [2, 30], 54: [2, 30], 68: [2, 30], 71: 107, 72: [1, 108], 75: [2, 30] }, { 23: [2, 98], 33: [2, 98], 54: [2, 98], 68: [2, 98], 72: [2, 98], 75: [2, 98] }, { 23: [2, 45], 33: [2, 45], 54: [2, 45], 65: [2, 45], 68: [2, 45], 72: [2, 45], 73: [1, 109], 75: [2, 45], 80: [2, 45], 81: [2, 45], 82: [2, 45], 83: [2, 45], 84: [2, 45], 85: [2, 45], 87: [2, 45] }, { 23: [2, 44], 33: [2, 44], 54: [2, 44], 65: [2, 44], 68: [2, 44], 72: [2, 44], 75: [2, 44], 80: [2, 44], 81: [2, 44], 82: [2, 44], 83: [2, 44], 84: [2, 44], 85: [2, 44], 87: [2, 44] }, { 54: [1, 110] }, { 54: [2, 83], 65: [2, 83], 72: [2, 83], 80: [2, 83], 81: [2, 83], 82: [2, 83], 83: [2, 83], 84: [2, 83], 85: [2, 83] }, { 54: [2, 85] }, { 5: [2, 13], 14: [2, 13], 15: [2, 13], 19: [2, 13], 29: [2, 13], 34: [2, 13], 39: [2, 13], 44: [2, 13], 47: [2, 13], 48: [2, 13], 51: [2, 13], 55: [2, 13], 60: [2, 13] }, { 38: 56, 39: [1, 58], 43: 57, 44: [1, 59], 45: 112, 46: 111, 47: [2, 76] }, { 33: [2, 70], 40: 113, 65: [2, 70], 72: [2, 70], 75: [2, 70], 80: [2, 70], 81: [2, 70], 82: [2, 70], 83: [2, 70], 84: [2, 70], 85: [2, 70] }, { 47: [2, 18] }, { 5: [2, 14], 14: [2, 14], 15: [2, 14], 19: [2, 14], 29: [2, 14], 34: [2, 14], 39: [2, 14], 44: [2, 14], 47: [2, 14], 48: [2, 14], 51: [2, 14], 55: [2, 14], 60: [2, 14] }, { 33: [1, 114] }, { 33: [2, 87], 65: [2, 87], 72: [2, 87], 80: [2, 87], 81: [2, 87], 82: [2, 87], 83: [2, 87], 84: [2, 87], 85: [2, 87] }, { 33: [2, 89] }, { 20: 75, 63: 116, 64: 76, 65: [1, 44], 67: 115, 68: [2, 96], 69: 117, 70: 77, 71: 78, 72: [1, 79], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 33: [1, 118] }, { 32: 119, 33: [2, 62], 74: 120, 75: [1, 121] }, { 33: [2, 59], 65: [2, 59], 72: [2, 59], 75: [2, 59], 80: [2, 59], 81: [2, 59], 82: [2, 59], 83: [2, 59], 84: [2, 59], 85: [2, 59] }, { 33: [2, 61], 75: [2, 61] }, { 33: [2, 68], 37: 122, 74: 123, 75: [1, 121] }, { 33: [2, 65], 65: [2, 65], 72: [2, 65], 75: [2, 65], 80: [2, 65], 81: [2, 65], 82: [2, 65], 83: [2, 65], 84: [2, 65], 85: [2, 65] }, { 33: [2, 67], 75: [2, 67] }, { 23: [1, 124] }, { 23: [2, 51], 65: [2, 51], 72: [2, 51], 80: [2, 51], 81: [2, 51], 82: [2, 51], 83: [2, 51], 84: [2, 51], 85: [2, 51] }, { 23: [2, 53] }, { 33: [1, 125] }, { 33: [2, 91], 65: [2, 91], 72: [2, 91], 80: [2, 91], 81: [2, 91], 82: [2, 91], 83: [2, 91], 84: [2, 91], 85: [2, 91] }, { 33: [2, 93] }, { 5: [2, 22], 14: [2, 22], 15: [2, 22], 19: [2, 22], 29: [2, 22], 34: [2, 22], 39: [2, 22], 44: [2, 22], 47: [2, 22], 48: [2, 22], 51: [2, 22], 55: [2, 22], 60: [2, 22] }, { 23: [2, 99], 33: [2, 99], 54: [2, 99], 68: [2, 99], 72: [2, 99], 75: [2, 99] }, { 73: [1, 109] }, { 20: 75, 63: 126, 64: 76, 65: [1, 44], 72: [1, 35], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 5: [2, 23], 14: [2, 23], 15: [2, 23], 19: [2, 23], 29: [2, 23], 34: [2, 23], 39: [2, 23], 44: [2, 23], 47: [2, 23], 48: [2, 23], 51: [2, 23], 55: [2, 23], 60: [2, 23] }, { 47: [2, 19] }, { 47: [2, 77] }, { 20: 75, 33: [2, 72], 41: 127, 63: 128, 64: 76, 65: [1, 44], 69: 129, 70: 77, 71: 78, 72: [1, 79], 75: [2, 72], 78: 26, 79: 27, 80: [1, 28], 81: [1, 29], 82: [1, 30], 83: [1, 31], 84: [1, 32], 85: [1, 34], 86: 33 }, { 5: [2, 24], 14: [2, 24], 15: [2, 24], 19: [2, 24], 29: [2, 24], 34: [2, 24], 39: [2, 24], 44: [2, 24], 47: [2, 24], 48: [2, 24], 51: [2, 24], 55: [2, 24], 60: [2, 24] }, { 68: [1, 130] }, { 65: [2, 95], 68: [2, 95], 72: [2, 95], 80: [2, 95], 81: [2, 95], 82: [2, 95], 83: [2, 95], 84: [2, 95], 85: [2, 95] }, { 68: [2, 97] }, { 5: [2, 21], 14: [2, 21], 15: [2, 21], 19: [2, 21], 29: [2, 21], 34: [2, 21], 39: [2, 21], 44: [2, 21], 47: [2, 21], 48: [2, 21], 51: [2, 21], 55: [2, 21], 60: [2, 21] }, { 33: [1, 131] }, { 33: [2, 63] }, { 72: [1, 133], 76: 132 }, { 33: [1, 134] }, { 33: [2, 69] }, { 15: [2, 12] }, { 14: [2, 26], 15: [2, 26], 19: [2, 26], 29: [2, 26], 34: [2, 26], 47: [2, 26], 48: [2, 26], 51: [2, 26], 55: [2, 26], 60: [2, 26] }, { 23: [2, 31], 33: [2, 31], 54: [2, 31], 68: [2, 31], 72: [2, 31], 75: [2, 31] }, { 33: [2, 74], 42: 135, 74: 136, 75: [1, 121] }, { 33: [2, 71], 65: [2, 71], 72: [2, 71], 75: [2, 71], 80: [2, 71], 81: [2, 71], 82: [2, 71], 83: [2, 71], 84: [2, 71], 85: [2, 71] }, { 33: [2, 73], 75: [2, 73] }, { 23: [2, 29], 33: [2, 29], 54: [2, 29], 65: [2, 29], 68: [2, 29], 72: [2, 29], 75: [2, 29], 80: [2, 29], 81: [2, 29], 82: [2, 29], 83: [2, 29], 84: [2, 29], 85: [2, 29] }, { 14: [2, 15], 15: [2, 15], 19: [2, 15], 29: [2, 15], 34: [2, 15], 39: [2, 15], 44: [2, 15], 47: [2, 15], 48: [2, 15], 51: [2, 15], 55: [2, 15], 60: [2, 15] }, { 72: [1, 138], 77: [1, 137] }, { 72: [2, 100], 77: [2, 100] }, { 14: [2, 16], 15: [2, 16], 19: [2, 16], 29: [2, 16], 34: [2, 16], 44: [2, 16], 47: [2, 16], 48: [2, 16], 51: [2, 16], 55: [2, 16], 60: [2, 16] }, { 33: [1, 139] }, { 33: [2, 75] }, { 33: [2, 32] }, { 72: [2, 101], 77: [2, 101] }, { 14: [2, 17], 15: [2, 17], 19: [2, 17], 29: [2, 17], 34: [2, 17], 39: [2, 17], 44: [2, 17], 47: [2, 17], 48: [2, 17], 51: [2, 17], 55: [2, 17], 60: [2, 17] }],
	        defaultActions: { 4: [2, 1], 55: [2, 55], 57: [2, 20], 61: [2, 57], 74: [2, 81], 83: [2, 85], 87: [2, 18], 91: [2, 89], 102: [2, 53], 105: [2, 93], 111: [2, 19], 112: [2, 77], 117: [2, 97], 120: [2, 63], 123: [2, 69], 124: [2, 12], 136: [2, 75], 137: [2, 32] },
	        parseError: function parseError(str, hash) {
	            throw new Error(str);
	        },
	        parse: function parse(input) {
	            var self = this,
	                stack = [0],
	                vstack = [null],
	                lstack = [],
	                table = this.table,
	                yytext = "",
	                yylineno = 0,
	                yyleng = 0,
	                recovering = 0,
	                TERROR = 2,
	                EOF = 1;
	            this.lexer.setInput(input);
	            this.lexer.yy = this.yy;
	            this.yy.lexer = this.lexer;
	            this.yy.parser = this;
	            if (typeof this.lexer.yylloc == "undefined") this.lexer.yylloc = {};
	            var yyloc = this.lexer.yylloc;
	            lstack.push(yyloc);
	            var ranges = this.lexer.options && this.lexer.options.ranges;
	            if (typeof this.yy.parseError === "function") this.parseError = this.yy.parseError;
	            function popStack(n) {
	                stack.length = stack.length - 2 * n;
	                vstack.length = vstack.length - n;
	                lstack.length = lstack.length - n;
	            }
	            function lex() {
	                var token;
	                token = self.lexer.lex() || 1;
	                if (typeof token !== "number") {
	                    token = self.symbols_[token] || token;
	                }
	                return token;
	            }
	            var symbol,
	                preErrorSymbol,
	                state,
	                action,
	                a,
	                r,
	                yyval = {},
	                p,
	                len,
	                newState,
	                expected;
	            while (true) {
	                state = stack[stack.length - 1];
	                if (this.defaultActions[state]) {
	                    action = this.defaultActions[state];
	                } else {
	                    if (symbol === null || typeof symbol == "undefined") {
	                        symbol = lex();
	                    }
	                    action = table[state] && table[state][symbol];
	                }
	                if (typeof action === "undefined" || !action.length || !action[0]) {
	                    var errStr = "";
	                    if (!recovering) {
	                        expected = [];
	                        for (p in table[state]) if (this.terminals_[p] && p > 2) {
	                            expected.push("'" + this.terminals_[p] + "'");
	                        }
	                        if (this.lexer.showPosition) {
	                            errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
	                        } else {
	                            errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1 ? "end of input" : "'" + (this.terminals_[symbol] || symbol) + "'");
	                        }
	                        this.parseError(errStr, { text: this.lexer.match, token: this.terminals_[symbol] || symbol, line: this.lexer.yylineno, loc: yyloc, expected: expected });
	                    }
	                }
	                if (action[0] instanceof Array && action.length > 1) {
	                    throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
	                }
	                switch (action[0]) {
	                    case 1:
	                        stack.push(symbol);
	                        vstack.push(this.lexer.yytext);
	                        lstack.push(this.lexer.yylloc);
	                        stack.push(action[1]);
	                        symbol = null;
	                        if (!preErrorSymbol) {
	                            yyleng = this.lexer.yyleng;
	                            yytext = this.lexer.yytext;
	                            yylineno = this.lexer.yylineno;
	                            yyloc = this.lexer.yylloc;
	                            if (recovering > 0) recovering--;
	                        } else {
	                            symbol = preErrorSymbol;
	                            preErrorSymbol = null;
	                        }
	                        break;
	                    case 2:
	                        len = this.productions_[action[1]][1];
	                        yyval.$ = vstack[vstack.length - len];
	                        yyval._$ = { first_line: lstack[lstack.length - (len || 1)].first_line, last_line: lstack[lstack.length - 1].last_line, first_column: lstack[lstack.length - (len || 1)].first_column, last_column: lstack[lstack.length - 1].last_column };
	                        if (ranges) {
	                            yyval._$.range = [lstack[lstack.length - (len || 1)].range[0], lstack[lstack.length - 1].range[1]];
	                        }
	                        r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
	                        if (typeof r !== "undefined") {
	                            return r;
	                        }
	                        if (len) {
	                            stack = stack.slice(0, -1 * len * 2);
	                            vstack = vstack.slice(0, -1 * len);
	                            lstack = lstack.slice(0, -1 * len);
	                        }
	                        stack.push(this.productions_[action[1]][0]);
	                        vstack.push(yyval.$);
	                        lstack.push(yyval._$);
	                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
	                        stack.push(newState);
	                        break;
	                    case 3:
	                        return true;
	                }
	            }
	            return true;
	        }
	    };
	    /* Jison generated lexer */
	    var lexer = (function () {
	        var lexer = { EOF: 1,
	            parseError: function parseError(str, hash) {
	                if (this.yy.parser) {
	                    this.yy.parser.parseError(str, hash);
	                } else {
	                    throw new Error(str);
	                }
	            },
	            setInput: function setInput(input) {
	                this._input = input;
	                this._more = this._less = this.done = false;
	                this.yylineno = this.yyleng = 0;
	                this.yytext = this.matched = this.match = '';
	                this.conditionStack = ['INITIAL'];
	                this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 };
	                if (this.options.ranges) this.yylloc.range = [0, 0];
	                this.offset = 0;
	                return this;
	            },
	            input: function input() {
	                var ch = this._input[0];
	                this.yytext += ch;
	                this.yyleng++;
	                this.offset++;
	                this.match += ch;
	                this.matched += ch;
	                var lines = ch.match(/(?:\r\n?|\n).*/g);
	                if (lines) {
	                    this.yylineno++;
	                    this.yylloc.last_line++;
	                } else {
	                    this.yylloc.last_column++;
	                }
	                if (this.options.ranges) this.yylloc.range[1]++;

	                this._input = this._input.slice(1);
	                return ch;
	            },
	            unput: function unput(ch) {
	                var len = ch.length;
	                var lines = ch.split(/(?:\r\n?|\n)/g);

	                this._input = ch + this._input;
	                this.yytext = this.yytext.substr(0, this.yytext.length - len - 1);
	                //this.yyleng -= len;
	                this.offset -= len;
	                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
	                this.match = this.match.substr(0, this.match.length - 1);
	                this.matched = this.matched.substr(0, this.matched.length - 1);

	                if (lines.length - 1) this.yylineno -= lines.length - 1;
	                var r = this.yylloc.range;

	                this.yylloc = { first_line: this.yylloc.first_line,
	                    last_line: this.yylineno + 1,
	                    first_column: this.yylloc.first_column,
	                    last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
	                };

	                if (this.options.ranges) {
	                    this.yylloc.range = [r[0], r[0] + this.yyleng - len];
	                }
	                return this;
	            },
	            more: function more() {
	                this._more = true;
	                return this;
	            },
	            less: function less(n) {
	                this.unput(this.match.slice(n));
	            },
	            pastInput: function pastInput() {
	                var past = this.matched.substr(0, this.matched.length - this.match.length);
	                return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, "");
	            },
	            upcomingInput: function upcomingInput() {
	                var next = this.match;
	                if (next.length < 20) {
	                    next += this._input.substr(0, 20 - next.length);
	                }
	                return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
	            },
	            showPosition: function showPosition() {
	                var pre = this.pastInput();
	                var c = new Array(pre.length + 1).join("-");
	                return pre + this.upcomingInput() + "\n" + c + "^";
	            },
	            next: function next() {
	                if (this.done) {
	                    return this.EOF;
	                }
	                if (!this._input) this.done = true;

	                var token, match, tempMatch, index, col, lines;
	                if (!this._more) {
	                    this.yytext = '';
	                    this.match = '';
	                }
	                var rules = this._currentRules();
	                for (var i = 0; i < rules.length; i++) {
	                    tempMatch = this._input.match(this.rules[rules[i]]);
	                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
	                        match = tempMatch;
	                        index = i;
	                        if (!this.options.flex) break;
	                    }
	                }
	                if (match) {
	                    lines = match[0].match(/(?:\r\n?|\n).*/g);
	                    if (lines) this.yylineno += lines.length;
	                    this.yylloc = { first_line: this.yylloc.last_line,
	                        last_line: this.yylineno + 1,
	                        first_column: this.yylloc.last_column,
	                        last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length };
	                    this.yytext += match[0];
	                    this.match += match[0];
	                    this.matches = match;
	                    this.yyleng = this.yytext.length;
	                    if (this.options.ranges) {
	                        this.yylloc.range = [this.offset, this.offset += this.yyleng];
	                    }
	                    this._more = false;
	                    this._input = this._input.slice(match[0].length);
	                    this.matched += match[0];
	                    token = this.performAction.call(this, this.yy, this, rules[index], this.conditionStack[this.conditionStack.length - 1]);
	                    if (this.done && this._input) this.done = false;
	                    if (token) return token;else return;
	                }
	                if (this._input === "") {
	                    return this.EOF;
	                } else {
	                    return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), { text: "", token: null, line: this.yylineno });
	                }
	            },
	            lex: function lex() {
	                var r = this.next();
	                if (typeof r !== 'undefined') {
	                    return r;
	                } else {
	                    return this.lex();
	                }
	            },
	            begin: function begin(condition) {
	                this.conditionStack.push(condition);
	            },
	            popState: function popState() {
	                return this.conditionStack.pop();
	            },
	            _currentRules: function _currentRules() {
	                return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
	            },
	            topState: function topState() {
	                return this.conditionStack[this.conditionStack.length - 2];
	            },
	            pushState: function begin(condition) {
	                this.begin(condition);
	            } };
	        lexer.options = {};
	        lexer.performAction = function anonymous(yy, yy_, $avoiding_name_collisions, YY_START
	        /*``*/) {

	            function strip(start, end) {
	                return yy_.yytext = yy_.yytext.substr(start, yy_.yyleng - end);
	            }

	            var YYSTATE = YY_START;
	            switch ($avoiding_name_collisions) {
	                case 0:
	                    if (yy_.yytext.slice(-2) === "\\\\") {
	                        strip(0, 1);
	                        this.begin("mu");
	                    } else if (yy_.yytext.slice(-1) === "\\") {
	                        strip(0, 1);
	                        this.begin("emu");
	                    } else {
	                        this.begin("mu");
	                    }
	                    if (yy_.yytext) return 15;

	                    break;
	                case 1:
	                    return 15;
	                    break;
	                case 2:
	                    this.popState();
	                    return 15;

	                    break;
	                case 3:
	                    this.begin('raw');return 15;
	                    break;
	                case 4:
	                    this.popState();
	                    // Should be using `this.topState()` below, but it currently
	                    // returns the second top instead of the first top. Opened an
	                    // issue about it at https://github.com/zaach/jison/issues/291
	                    if (this.conditionStack[this.conditionStack.length - 1] === 'raw') {
	                        return 15;
	                    } else {
	                        yy_.yytext = yy_.yytext.substr(5, yy_.yyleng - 9);
	                        return 'END_RAW_BLOCK';
	                    }

	                    break;
	                case 5:
	                    return 15;
	                    break;
	                case 6:
	                    this.popState();
	                    return 14;

	                    break;
	                case 7:
	                    return 65;
	                    break;
	                case 8:
	                    return 68;
	                    break;
	                case 9:
	                    return 19;
	                    break;
	                case 10:
	                    this.popState();
	                    this.begin('raw');
	                    return 23;

	                    break;
	                case 11:
	                    return 55;
	                    break;
	                case 12:
	                    return 60;
	                    break;
	                case 13:
	                    return 29;
	                    break;
	                case 14:
	                    return 47;
	                    break;
	                case 15:
	                    this.popState();return 44;
	                    break;
	                case 16:
	                    this.popState();return 44;
	                    break;
	                case 17:
	                    return 34;
	                    break;
	                case 18:
	                    return 39;
	                    break;
	                case 19:
	                    return 51;
	                    break;
	                case 20:
	                    return 48;
	                    break;
	                case 21:
	                    this.unput(yy_.yytext);
	                    this.popState();
	                    this.begin('com');

	                    break;
	                case 22:
	                    this.popState();
	                    return 14;

	                    break;
	                case 23:
	                    return 48;
	                    break;
	                case 24:
	                    return 73;
	                    break;
	                case 25:
	                    return 72;
	                    break;
	                case 26:
	                    return 72;
	                    break;
	                case 27:
	                    return 87;
	                    break;
	                case 28:
	                    // ignore whitespace
	                    break;
	                case 29:
	                    this.popState();return 54;
	                    break;
	                case 30:
	                    this.popState();return 33;
	                    break;
	                case 31:
	                    yy_.yytext = strip(1, 2).replace(/\\"/g, '"');return 80;
	                    break;
	                case 32:
	                    yy_.yytext = strip(1, 2).replace(/\\'/g, "'");return 80;
	                    break;
	                case 33:
	                    return 85;
	                    break;
	                case 34:
	                    return 82;
	                    break;
	                case 35:
	                    return 82;
	                    break;
	                case 36:
	                    return 83;
	                    break;
	                case 37:
	                    return 84;
	                    break;
	                case 38:
	                    return 81;
	                    break;
	                case 39:
	                    return 75;
	                    break;
	                case 40:
	                    return 77;
	                    break;
	                case 41:
	                    return 72;
	                    break;
	                case 42:
	                    yy_.yytext = yy_.yytext.replace(/\\([\\\]])/g, '$1');return 72;
	                    break;
	                case 43:
	                    return 'INVALID';
	                    break;
	                case 44:
	                    return 5;
	                    break;
	            }
	        };
	        lexer.rules = [/^(?:[^\x00]*?(?=(\{\{)))/, /^(?:[^\x00]+)/, /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/, /^(?:\{\{\{\{(?=[^\/]))/, /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/, /^(?:[^\x00]*?(?=(\{\{\{\{)))/, /^(?:[\s\S]*?--(~)?\}\})/, /^(?:\()/, /^(?:\))/, /^(?:\{\{\{\{)/, /^(?:\}\}\}\})/, /^(?:\{\{(~)?>)/, /^(?:\{\{(~)?#>)/, /^(?:\{\{(~)?#\*?)/, /^(?:\{\{(~)?\/)/, /^(?:\{\{(~)?\^\s*(~)?\}\})/, /^(?:\{\{(~)?\s*else\s*(~)?\}\})/, /^(?:\{\{(~)?\^)/, /^(?:\{\{(~)?\s*else\b)/, /^(?:\{\{(~)?\{)/, /^(?:\{\{(~)?&)/, /^(?:\{\{(~)?!--)/, /^(?:\{\{(~)?![\s\S]*?\}\})/, /^(?:\{\{(~)?\*?)/, /^(?:=)/, /^(?:\.\.)/, /^(?:\.(?=([=~}\s\/.)|])))/, /^(?:[\/.])/, /^(?:\s+)/, /^(?:\}(~)?\}\})/, /^(?:(~)?\}\})/, /^(?:"(\\["]|[^"])*")/, /^(?:'(\\[']|[^'])*')/, /^(?:@)/, /^(?:true(?=([~}\s)])))/, /^(?:false(?=([~}\s)])))/, /^(?:undefined(?=([~}\s)])))/, /^(?:null(?=([~}\s)])))/, /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/, /^(?:as\s+\|)/, /^(?:\|)/, /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/, /^(?:\[(\\\]|[^\]])*\])/, /^(?:.)/, /^(?:$)/];
	        lexer.conditions = { "mu": { "rules": [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44], "inclusive": false }, "emu": { "rules": [2], "inclusive": false }, "com": { "rules": [6], "inclusive": false }, "raw": { "rules": [3, 4, 5], "inclusive": false }, "INITIAL": { "rules": [0, 1, 44], "inclusive": true } };
	        return lexer;
	    })();
	    parser.lexer = lexer;
	    function Parser() {
	        this.yy = {};
	    }Parser.prototype = parser;parser.Parser = Parser;
	    return new Parser();
	})();exports["default"] = handlebars;
	module.exports = exports["default"];

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _visitor = __webpack_require__(39);

	var _visitor2 = _interopRequireDefault(_visitor);

	function WhitespaceControl() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

	  this.options = options;
	}
	WhitespaceControl.prototype = new _visitor2['default']();

	WhitespaceControl.prototype.Program = function (program) {
	  var doStandalone = !this.options.ignoreStandalone;

	  var isRoot = !this.isRootSeen;
	  this.isRootSeen = true;

	  var body = program.body;
	  for (var i = 0, l = body.length; i < l; i++) {
	    var current = body[i],
	        strip = this.accept(current);

	    if (!strip) {
	      continue;
	    }

	    var _isPrevWhitespace = isPrevWhitespace(body, i, isRoot),
	        _isNextWhitespace = isNextWhitespace(body, i, isRoot),
	        openStandalone = strip.openStandalone && _isPrevWhitespace,
	        closeStandalone = strip.closeStandalone && _isNextWhitespace,
	        inlineStandalone = strip.inlineStandalone && _isPrevWhitespace && _isNextWhitespace;

	    if (strip.close) {
	      omitRight(body, i, true);
	    }
	    if (strip.open) {
	      omitLeft(body, i, true);
	    }

	    if (doStandalone && inlineStandalone) {
	      omitRight(body, i);

	      if (omitLeft(body, i)) {
	        // If we are on a standalone node, save the indent info for partials
	        if (current.type === 'PartialStatement') {
	          // Pull out the whitespace from the final line
	          current.indent = /([ \t]+$)/.exec(body[i - 1].original)[1];
	        }
	      }
	    }
	    if (doStandalone && openStandalone) {
	      omitRight((current.program || current.inverse).body);

	      // Strip out the previous content node if it's whitespace only
	      omitLeft(body, i);
	    }
	    if (doStandalone && closeStandalone) {
	      // Always strip the next node
	      omitRight(body, i);

	      omitLeft((current.inverse || current.program).body);
	    }
	  }

	  return program;
	};

	WhitespaceControl.prototype.BlockStatement = WhitespaceControl.prototype.DecoratorBlock = WhitespaceControl.prototype.PartialBlockStatement = function (block) {
	  this.accept(block.program);
	  this.accept(block.inverse);

	  // Find the inverse program that is involed with whitespace stripping.
	  var program = block.program || block.inverse,
	      inverse = block.program && block.inverse,
	      firstInverse = inverse,
	      lastInverse = inverse;

	  if (inverse && inverse.chained) {
	    firstInverse = inverse.body[0].program;

	    // Walk the inverse chain to find the last inverse that is actually in the chain.
	    while (lastInverse.chained) {
	      lastInverse = lastInverse.body[lastInverse.body.length - 1].program;
	    }
	  }

	  var strip = {
	    open: block.openStrip.open,
	    close: block.closeStrip.close,

	    // Determine the standalone candiacy. Basically flag our content as being possibly standalone
	    // so our parent can determine if we actually are standalone
	    openStandalone: isNextWhitespace(program.body),
	    closeStandalone: isPrevWhitespace((firstInverse || program).body)
	  };

	  if (block.openStrip.close) {
	    omitRight(program.body, null, true);
	  }

	  if (inverse) {
	    var inverseStrip = block.inverseStrip;

	    if (inverseStrip.open) {
	      omitLeft(program.body, null, true);
	    }

	    if (inverseStrip.close) {
	      omitRight(firstInverse.body, null, true);
	    }
	    if (block.closeStrip.open) {
	      omitLeft(lastInverse.body, null, true);
	    }

	    // Find standalone else statments
	    if (!this.options.ignoreStandalone && isPrevWhitespace(program.body) && isNextWhitespace(firstInverse.body)) {
	      omitLeft(program.body);
	      omitRight(firstInverse.body);
	    }
	  } else if (block.closeStrip.open) {
	    omitLeft(program.body, null, true);
	  }

	  return strip;
	};

	WhitespaceControl.prototype.Decorator = WhitespaceControl.prototype.MustacheStatement = function (mustache) {
	  return mustache.strip;
	};

	WhitespaceControl.prototype.PartialStatement = WhitespaceControl.prototype.CommentStatement = function (node) {
	  /* istanbul ignore next */
	  var strip = node.strip || {};
	  return {
	    inlineStandalone: true,
	    open: strip.open,
	    close: strip.close
	  };
	};

	function isPrevWhitespace(body, i, isRoot) {
	  if (i === undefined) {
	    i = body.length;
	  }

	  // Nodes that end with newlines are considered whitespace (but are special
	  // cased for strip operations)
	  var prev = body[i - 1],
	      sibling = body[i - 2];
	  if (!prev) {
	    return isRoot;
	  }

	  if (prev.type === 'ContentStatement') {
	    return (sibling || !isRoot ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(prev.original);
	  }
	}
	function isNextWhitespace(body, i, isRoot) {
	  if (i === undefined) {
	    i = -1;
	  }

	  var next = body[i + 1],
	      sibling = body[i + 2];
	  if (!next) {
	    return isRoot;
	  }

	  if (next.type === 'ContentStatement') {
	    return (sibling || !isRoot ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(next.original);
	  }
	}

	// Marks the node to the right of the position as omitted.
	// I.e. {{foo}}' ' will mark the ' ' node as omitted.
	//
	// If i is undefined, then the first child will be marked as such.
	//
	// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
	// content is met.
	function omitRight(body, i, multiple) {
	  var current = body[i == null ? 0 : i + 1];
	  if (!current || current.type !== 'ContentStatement' || !multiple && current.rightStripped) {
	    return;
	  }

	  var original = current.value;
	  current.value = current.value.replace(multiple ? /^\s+/ : /^[ \t]*\r?\n?/, '');
	  current.rightStripped = current.value !== original;
	}

	// Marks the node to the left of the position as omitted.
	// I.e. ' '{{foo}} will mark the ' ' node as omitted.
	//
	// If i is undefined then the last child will be marked as such.
	//
	// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
	// content is met.
	function omitLeft(body, i, multiple) {
	  var current = body[i == null ? body.length - 1 : i - 1];
	  if (!current || current.type !== 'ContentStatement' || !multiple && current.leftStripped) {
	    return;
	  }

	  // We omit the last node if it's whitespace only and not preceeded by a non-content node.
	  var original = current.value;
	  current.value = current.value.replace(multiple ? /\s+$/ : /[ \t]+$/, '');
	  current.leftStripped = current.value !== original;
	  return current.leftStripped;
	}

	exports['default'] = WhitespaceControl;
	module.exports = exports['default'];

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	function Visitor() {
	  this.parents = [];
	}

	Visitor.prototype = {
	  constructor: Visitor,
	  mutating: false,

	  // Visits a given value. If mutating, will replace the value if necessary.
	  acceptKey: function acceptKey(node, name) {
	    var value = this.accept(node[name]);
	    if (this.mutating) {
	      // Hacky sanity check: This may have a few false positives for type for the helper
	      // methods but will generally do the right thing without a lot of overhead.
	      if (value && !Visitor.prototype[value.type]) {
	        throw new _exception2['default']('Unexpected node type "' + value.type + '" found when accepting ' + name + ' on ' + node.type);
	      }
	      node[name] = value;
	    }
	  },

	  // Performs an accept operation with added sanity check to ensure
	  // required keys are not removed.
	  acceptRequired: function acceptRequired(node, name) {
	    this.acceptKey(node, name);

	    if (!node[name]) {
	      throw new _exception2['default'](node.type + ' requires ' + name);
	    }
	  },

	  // Traverses a given array. If mutating, empty respnses will be removed
	  // for child elements.
	  acceptArray: function acceptArray(array) {
	    for (var i = 0, l = array.length; i < l; i++) {
	      this.acceptKey(array, i);

	      if (!array[i]) {
	        array.splice(i, 1);
	        i--;
	        l--;
	      }
	    }
	  },

	  accept: function accept(object) {
	    if (!object) {
	      return;
	    }

	    /* istanbul ignore next: Sanity code */
	    if (!this[object.type]) {
	      throw new _exception2['default']('Unknown type: ' + object.type, object);
	    }

	    if (this.current) {
	      this.parents.unshift(this.current);
	    }
	    this.current = object;

	    var ret = this[object.type](object);

	    this.current = this.parents.shift();

	    if (!this.mutating || ret) {
	      return ret;
	    } else if (ret !== false) {
	      return object;
	    }
	  },

	  Program: function Program(program) {
	    this.acceptArray(program.body);
	  },

	  MustacheStatement: visitSubExpression,
	  Decorator: visitSubExpression,

	  BlockStatement: visitBlock,
	  DecoratorBlock: visitBlock,

	  PartialStatement: visitPartial,
	  PartialBlockStatement: function PartialBlockStatement(partial) {
	    visitPartial.call(this, partial);

	    this.acceptKey(partial, 'program');
	  },

	  ContentStatement: function ContentStatement() /* content */{},
	  CommentStatement: function CommentStatement() /* comment */{},

	  SubExpression: visitSubExpression,

	  PathExpression: function PathExpression() /* path */{},

	  StringLiteral: function StringLiteral() /* string */{},
	  NumberLiteral: function NumberLiteral() /* number */{},
	  BooleanLiteral: function BooleanLiteral() /* bool */{},
	  UndefinedLiteral: function UndefinedLiteral() /* literal */{},
	  NullLiteral: function NullLiteral() /* literal */{},

	  Hash: function Hash(hash) {
	    this.acceptArray(hash.pairs);
	  },
	  HashPair: function HashPair(pair) {
	    this.acceptRequired(pair, 'value');
	  }
	};

	function visitSubExpression(mustache) {
	  this.acceptRequired(mustache, 'path');
	  this.acceptArray(mustache.params);
	  this.acceptKey(mustache, 'hash');
	}
	function visitBlock(block) {
	  visitSubExpression.call(this, block);

	  this.acceptKey(block, 'program');
	  this.acceptKey(block, 'inverse');
	}
	function visitPartial(partial) {
	  this.acceptRequired(partial, 'name');
	  this.acceptArray(partial.params);
	  this.acceptKey(partial, 'hash');
	}

	exports['default'] = Visitor;
	module.exports = exports['default'];

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.SourceLocation = SourceLocation;
	exports.id = id;
	exports.stripFlags = stripFlags;
	exports.stripComment = stripComment;
	exports.preparePath = preparePath;
	exports.prepareMustache = prepareMustache;
	exports.prepareRawBlock = prepareRawBlock;
	exports.prepareBlock = prepareBlock;
	exports.prepareProgram = prepareProgram;
	exports.preparePartialBlock = preparePartialBlock;

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	function validateClose(open, close) {
	  close = close.path ? close.path.original : close;

	  if (open.path.original !== close) {
	    var errorNode = { loc: open.path.loc };

	    throw new _exception2['default'](open.path.original + " doesn't match " + close, errorNode);
	  }
	}

	function SourceLocation(source, locInfo) {
	  this.source = source;
	  this.start = {
	    line: locInfo.first_line,
	    column: locInfo.first_column
	  };
	  this.end = {
	    line: locInfo.last_line,
	    column: locInfo.last_column
	  };
	}

	function id(token) {
	  if (/^\[.*\]$/.test(token)) {
	    return token.substr(1, token.length - 2);
	  } else {
	    return token;
	  }
	}

	function stripFlags(open, close) {
	  return {
	    open: open.charAt(2) === '~',
	    close: close.charAt(close.length - 3) === '~'
	  };
	}

	function stripComment(comment) {
	  return comment.replace(/^\{\{~?!-?-?/, '').replace(/-?-?~?\}\}$/, '');
	}

	function preparePath(data, parts, loc) {
	  loc = this.locInfo(loc);

	  var original = data ? '@' : '',
	      dig = [],
	      depth = 0;

	  for (var i = 0, l = parts.length; i < l; i++) {
	    var part = parts[i].part,

	    // If we have [] syntax then we do not treat path references as operators,
	    // i.e. foo.[this] resolves to approximately context.foo['this']
	    isLiteral = parts[i].original !== part;
	    original += (parts[i].separator || '') + part;

	    if (!isLiteral && (part === '..' || part === '.' || part === 'this')) {
	      if (dig.length > 0) {
	        throw new _exception2['default']('Invalid path: ' + original, { loc: loc });
	      } else if (part === '..') {
	        depth++;
	      }
	    } else {
	      dig.push(part);
	    }
	  }

	  return {
	    type: 'PathExpression',
	    data: data,
	    depth: depth,
	    parts: dig,
	    original: original,
	    loc: loc
	  };
	}

	function prepareMustache(path, params, hash, open, strip, locInfo) {
	  // Must use charAt to support IE pre-10
	  var escapeFlag = open.charAt(3) || open.charAt(2),
	      escaped = escapeFlag !== '{' && escapeFlag !== '&';

	  var decorator = /\*/.test(open);
	  return {
	    type: decorator ? 'Decorator' : 'MustacheStatement',
	    path: path,
	    params: params,
	    hash: hash,
	    escaped: escaped,
	    strip: strip,
	    loc: this.locInfo(locInfo)
	  };
	}

	function prepareRawBlock(openRawBlock, contents, close, locInfo) {
	  validateClose(openRawBlock, close);

	  locInfo = this.locInfo(locInfo);
	  var program = {
	    type: 'Program',
	    body: contents,
	    strip: {},
	    loc: locInfo
	  };

	  return {
	    type: 'BlockStatement',
	    path: openRawBlock.path,
	    params: openRawBlock.params,
	    hash: openRawBlock.hash,
	    program: program,
	    openStrip: {},
	    inverseStrip: {},
	    closeStrip: {},
	    loc: locInfo
	  };
	}

	function prepareBlock(openBlock, program, inverseAndProgram, close, inverted, locInfo) {
	  if (close && close.path) {
	    validateClose(openBlock, close);
	  }

	  var decorator = /\*/.test(openBlock.open);

	  program.blockParams = openBlock.blockParams;

	  var inverse = undefined,
	      inverseStrip = undefined;

	  if (inverseAndProgram) {
	    if (decorator) {
	      throw new _exception2['default']('Unexpected inverse block on decorator', inverseAndProgram);
	    }

	    if (inverseAndProgram.chain) {
	      inverseAndProgram.program.body[0].closeStrip = close.strip;
	    }

	    inverseStrip = inverseAndProgram.strip;
	    inverse = inverseAndProgram.program;
	  }

	  if (inverted) {
	    inverted = inverse;
	    inverse = program;
	    program = inverted;
	  }

	  return {
	    type: decorator ? 'DecoratorBlock' : 'BlockStatement',
	    path: openBlock.path,
	    params: openBlock.params,
	    hash: openBlock.hash,
	    program: program,
	    inverse: inverse,
	    openStrip: openBlock.strip,
	    inverseStrip: inverseStrip,
	    closeStrip: close && close.strip,
	    loc: this.locInfo(locInfo)
	  };
	}

	function prepareProgram(statements, loc) {
	  if (!loc && statements.length) {
	    var firstLoc = statements[0].loc,
	        lastLoc = statements[statements.length - 1].loc;

	    /* istanbul ignore else */
	    if (firstLoc && lastLoc) {
	      loc = {
	        source: firstLoc.source,
	        start: {
	          line: firstLoc.start.line,
	          column: firstLoc.start.column
	        },
	        end: {
	          line: lastLoc.end.line,
	          column: lastLoc.end.column
	        }
	      };
	    }
	  }

	  return {
	    type: 'Program',
	    body: statements,
	    strip: {},
	    loc: loc
	  };
	}

	function preparePartialBlock(open, program, close, locInfo) {
	  validateClose(open, close);

	  return {
	    type: 'PartialBlockStatement',
	    name: open.path,
	    params: open.params,
	    hash: open.hash,
	    program: program,
	    openStrip: open.strip,
	    closeStrip: close && close.strip,
	    loc: this.locInfo(locInfo)
	  };
	}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable new-cap */

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;
	exports.Compiler = Compiler;
	exports.precompile = precompile;
	exports.compile = compile;

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	var _utils = __webpack_require__(5);

	var _ast = __webpack_require__(35);

	var _ast2 = _interopRequireDefault(_ast);

	var slice = [].slice;

	function Compiler() {}

	// the foundHelper register will disambiguate helper lookup from finding a
	// function in a context. This is necessary for mustache compatibility, which
	// requires that context functions in blocks are evaluated by blockHelperMissing,
	// and then proceed as if the resulting value was provided to blockHelperMissing.

	Compiler.prototype = {
	  compiler: Compiler,

	  equals: function equals(other) {
	    var len = this.opcodes.length;
	    if (other.opcodes.length !== len) {
	      return false;
	    }

	    for (var i = 0; i < len; i++) {
	      var opcode = this.opcodes[i],
	          otherOpcode = other.opcodes[i];
	      if (opcode.opcode !== otherOpcode.opcode || !argEquals(opcode.args, otherOpcode.args)) {
	        return false;
	      }
	    }

	    // We know that length is the same between the two arrays because they are directly tied
	    // to the opcode behavior above.
	    len = this.children.length;
	    for (var i = 0; i < len; i++) {
	      if (!this.children[i].equals(other.children[i])) {
	        return false;
	      }
	    }

	    return true;
	  },

	  guid: 0,

	  compile: function compile(program, options) {
	    this.sourceNode = [];
	    this.opcodes = [];
	    this.children = [];
	    this.options = options;
	    this.stringParams = options.stringParams;
	    this.trackIds = options.trackIds;

	    options.blockParams = options.blockParams || [];

	    // These changes will propagate to the other compiler components
	    var knownHelpers = options.knownHelpers;
	    options.knownHelpers = {
	      'helperMissing': true,
	      'blockHelperMissing': true,
	      'each': true,
	      'if': true,
	      'unless': true,
	      'with': true,
	      'log': true,
	      'lookup': true
	    };
	    if (knownHelpers) {
	      // the next line should use "Object.keys", but the code has been like this a long time and changing it, might
	      // cause backwards-compatibility issues... It's an old library...
	      // eslint-disable-next-line guard-for-in
	      for (var _name in knownHelpers) {
	        this.options.knownHelpers[_name] = knownHelpers[_name];
	      }
	    }

	    return this.accept(program);
	  },

	  compileProgram: function compileProgram(program) {
	    var childCompiler = new this.compiler(),
	        // eslint-disable-line new-cap
	    result = childCompiler.compile(program, this.options),
	        guid = this.guid++;

	    this.usePartial = this.usePartial || result.usePartial;

	    this.children[guid] = result;
	    this.useDepths = this.useDepths || result.useDepths;

	    return guid;
	  },

	  accept: function accept(node) {
	    /* istanbul ignore next: Sanity code */
	    if (!this[node.type]) {
	      throw new _exception2['default']('Unknown type: ' + node.type, node);
	    }

	    this.sourceNode.unshift(node);
	    var ret = this[node.type](node);
	    this.sourceNode.shift();
	    return ret;
	  },

	  Program: function Program(program) {
	    this.options.blockParams.unshift(program.blockParams);

	    var body = program.body,
	        bodyLength = body.length;
	    for (var i = 0; i < bodyLength; i++) {
	      this.accept(body[i]);
	    }

	    this.options.blockParams.shift();

	    this.isSimple = bodyLength === 1;
	    this.blockParams = program.blockParams ? program.blockParams.length : 0;

	    return this;
	  },

	  BlockStatement: function BlockStatement(block) {
	    transformLiteralToPath(block);

	    var program = block.program,
	        inverse = block.inverse;

	    program = program && this.compileProgram(program);
	    inverse = inverse && this.compileProgram(inverse);

	    var type = this.classifySexpr(block);

	    if (type === 'helper') {
	      this.helperSexpr(block, program, inverse);
	    } else if (type === 'simple') {
	      this.simpleSexpr(block);

	      // now that the simple mustache is resolved, we need to
	      // evaluate it by executing `blockHelperMissing`
	      this.opcode('pushProgram', program);
	      this.opcode('pushProgram', inverse);
	      this.opcode('emptyHash');
	      this.opcode('blockValue', block.path.original);
	    } else {
	      this.ambiguousSexpr(block, program, inverse);

	      // now that the simple mustache is resolved, we need to
	      // evaluate it by executing `blockHelperMissing`
	      this.opcode('pushProgram', program);
	      this.opcode('pushProgram', inverse);
	      this.opcode('emptyHash');
	      this.opcode('ambiguousBlockValue');
	    }

	    this.opcode('append');
	  },

	  DecoratorBlock: function DecoratorBlock(decorator) {
	    var program = decorator.program && this.compileProgram(decorator.program);
	    var params = this.setupFullMustacheParams(decorator, program, undefined),
	        path = decorator.path;

	    this.useDecorators = true;
	    this.opcode('registerDecorator', params.length, path.original);
	  },

	  PartialStatement: function PartialStatement(partial) {
	    this.usePartial = true;

	    var program = partial.program;
	    if (program) {
	      program = this.compileProgram(partial.program);
	    }

	    var params = partial.params;
	    if (params.length > 1) {
	      throw new _exception2['default']('Unsupported number of partial arguments: ' + params.length, partial);
	    } else if (!params.length) {
	      if (this.options.explicitPartialContext) {
	        this.opcode('pushLiteral', 'undefined');
	      } else {
	        params.push({ type: 'PathExpression', parts: [], depth: 0 });
	      }
	    }

	    var partialName = partial.name.original,
	        isDynamic = partial.name.type === 'SubExpression';
	    if (isDynamic) {
	      this.accept(partial.name);
	    }

	    this.setupFullMustacheParams(partial, program, undefined, true);

	    var indent = partial.indent || '';
	    if (this.options.preventIndent && indent) {
	      this.opcode('appendContent', indent);
	      indent = '';
	    }

	    this.opcode('invokePartial', isDynamic, partialName, indent);
	    this.opcode('append');
	  },
	  PartialBlockStatement: function PartialBlockStatement(partialBlock) {
	    this.PartialStatement(partialBlock);
	  },

	  MustacheStatement: function MustacheStatement(mustache) {
	    this.SubExpression(mustache);

	    if (mustache.escaped && !this.options.noEscape) {
	      this.opcode('appendEscaped');
	    } else {
	      this.opcode('append');
	    }
	  },
	  Decorator: function Decorator(decorator) {
	    this.DecoratorBlock(decorator);
	  },

	  ContentStatement: function ContentStatement(content) {
	    if (content.value) {
	      this.opcode('appendContent', content.value);
	    }
	  },

	  CommentStatement: function CommentStatement() {},

	  SubExpression: function SubExpression(sexpr) {
	    transformLiteralToPath(sexpr);
	    var type = this.classifySexpr(sexpr);

	    if (type === 'simple') {
	      this.simpleSexpr(sexpr);
	    } else if (type === 'helper') {
	      this.helperSexpr(sexpr);
	    } else {
	      this.ambiguousSexpr(sexpr);
	    }
	  },
	  ambiguousSexpr: function ambiguousSexpr(sexpr, program, inverse) {
	    var path = sexpr.path,
	        name = path.parts[0],
	        isBlock = program != null || inverse != null;

	    this.opcode('getContext', path.depth);

	    this.opcode('pushProgram', program);
	    this.opcode('pushProgram', inverse);

	    path.strict = true;
	    this.accept(path);

	    this.opcode('invokeAmbiguous', name, isBlock);
	  },

	  simpleSexpr: function simpleSexpr(sexpr) {
	    var path = sexpr.path;
	    path.strict = true;
	    this.accept(path);
	    this.opcode('resolvePossibleLambda');
	  },

	  helperSexpr: function helperSexpr(sexpr, program, inverse) {
	    var params = this.setupFullMustacheParams(sexpr, program, inverse),
	        path = sexpr.path,
	        name = path.parts[0];

	    if (this.options.knownHelpers[name]) {
	      this.opcode('invokeKnownHelper', params.length, name);
	    } else if (this.options.knownHelpersOnly) {
	      throw new _exception2['default']('You specified knownHelpersOnly, but used the unknown helper ' + name, sexpr);
	    } else {
	      path.strict = true;
	      path.falsy = true;

	      this.accept(path);
	      this.opcode('invokeHelper', params.length, path.original, _ast2['default'].helpers.simpleId(path));
	    }
	  },

	  PathExpression: function PathExpression(path) {
	    this.addDepth(path.depth);
	    this.opcode('getContext', path.depth);

	    var name = path.parts[0],
	        scoped = _ast2['default'].helpers.scopedId(path),
	        blockParamId = !path.depth && !scoped && this.blockParamIndex(name);

	    if (blockParamId) {
	      this.opcode('lookupBlockParam', blockParamId, path.parts);
	    } else if (!name) {
	      // Context reference, i.e. `{{foo .}}` or `{{foo ..}}`
	      this.opcode('pushContext');
	    } else if (path.data) {
	      this.options.data = true;
	      this.opcode('lookupData', path.depth, path.parts, path.strict);
	    } else {
	      this.opcode('lookupOnContext', path.parts, path.falsy, path.strict, scoped);
	    }
	  },

	  StringLiteral: function StringLiteral(string) {
	    this.opcode('pushString', string.value);
	  },

	  NumberLiteral: function NumberLiteral(number) {
	    this.opcode('pushLiteral', number.value);
	  },

	  BooleanLiteral: function BooleanLiteral(bool) {
	    this.opcode('pushLiteral', bool.value);
	  },

	  UndefinedLiteral: function UndefinedLiteral() {
	    this.opcode('pushLiteral', 'undefined');
	  },

	  NullLiteral: function NullLiteral() {
	    this.opcode('pushLiteral', 'null');
	  },

	  Hash: function Hash(hash) {
	    var pairs = hash.pairs,
	        i = 0,
	        l = pairs.length;

	    this.opcode('pushHash');

	    for (; i < l; i++) {
	      this.pushParam(pairs[i].value);
	    }
	    while (i--) {
	      this.opcode('assignToHash', pairs[i].key);
	    }
	    this.opcode('popHash');
	  },

	  // HELPERS
	  opcode: function opcode(name) {
	    this.opcodes.push({ opcode: name, args: slice.call(arguments, 1), loc: this.sourceNode[0].loc });
	  },

	  addDepth: function addDepth(depth) {
	    if (!depth) {
	      return;
	    }

	    this.useDepths = true;
	  },

	  classifySexpr: function classifySexpr(sexpr) {
	    var isSimple = _ast2['default'].helpers.simpleId(sexpr.path);

	    var isBlockParam = isSimple && !!this.blockParamIndex(sexpr.path.parts[0]);

	    // a mustache is an eligible helper if:
	    // * its id is simple (a single part, not `this` or `..`)
	    var isHelper = !isBlockParam && _ast2['default'].helpers.helperExpression(sexpr);

	    // if a mustache is an eligible helper but not a definite
	    // helper, it is ambiguous, and will be resolved in a later
	    // pass or at runtime.
	    var isEligible = !isBlockParam && (isHelper || isSimple);

	    // if ambiguous, we can possibly resolve the ambiguity now
	    // An eligible helper is one that does not have a complex path, i.e. `this.foo`, `../foo` etc.
	    if (isEligible && !isHelper) {
	      var _name2 = sexpr.path.parts[0],
	          options = this.options;

	      if (options.knownHelpers[_name2]) {
	        isHelper = true;
	      } else if (options.knownHelpersOnly) {
	        isEligible = false;
	      }
	    }

	    if (isHelper) {
	      return 'helper';
	    } else if (isEligible) {
	      return 'ambiguous';
	    } else {
	      return 'simple';
	    }
	  },

	  pushParams: function pushParams(params) {
	    for (var i = 0, l = params.length; i < l; i++) {
	      this.pushParam(params[i]);
	    }
	  },

	  pushParam: function pushParam(val) {
	    var value = val.value != null ? val.value : val.original || '';

	    if (this.stringParams) {
	      if (value.replace) {
	        value = value.replace(/^(\.?\.\/)*/g, '').replace(/\//g, '.');
	      }

	      if (val.depth) {
	        this.addDepth(val.depth);
	      }
	      this.opcode('getContext', val.depth || 0);
	      this.opcode('pushStringParam', value, val.type);

	      if (val.type === 'SubExpression') {
	        // SubExpressions get evaluated and passed in
	        // in string params mode.
	        this.accept(val);
	      }
	    } else {
	      if (this.trackIds) {
	        var blockParamIndex = undefined;
	        if (val.parts && !_ast2['default'].helpers.scopedId(val) && !val.depth) {
	          blockParamIndex = this.blockParamIndex(val.parts[0]);
	        }
	        if (blockParamIndex) {
	          var blockParamChild = val.parts.slice(1).join('.');
	          this.opcode('pushId', 'BlockParam', blockParamIndex, blockParamChild);
	        } else {
	          value = val.original || value;
	          if (value.replace) {
	            value = value.replace(/^this(?:\.|$)/, '').replace(/^\.\//, '').replace(/^\.$/, '');
	          }

	          this.opcode('pushId', val.type, value);
	        }
	      }
	      this.accept(val);
	    }
	  },

	  setupFullMustacheParams: function setupFullMustacheParams(sexpr, program, inverse, omitEmpty) {
	    var params = sexpr.params;
	    this.pushParams(params);

	    this.opcode('pushProgram', program);
	    this.opcode('pushProgram', inverse);

	    if (sexpr.hash) {
	      this.accept(sexpr.hash);
	    } else {
	      this.opcode('emptyHash', omitEmpty);
	    }

	    return params;
	  },

	  blockParamIndex: function blockParamIndex(name) {
	    for (var depth = 0, len = this.options.blockParams.length; depth < len; depth++) {
	      var blockParams = this.options.blockParams[depth],
	          param = blockParams && _utils.indexOf(blockParams, name);
	      if (blockParams && param >= 0) {
	        return [depth, param];
	      }
	    }
	  }
	};

	function precompile(input, options, env) {
	  if (input == null || typeof input !== 'string' && input.type !== 'Program') {
	    throw new _exception2['default']('You must pass a string or Handlebars AST to Handlebars.precompile. You passed ' + input);
	  }

	  options = options || {};
	  if (!('data' in options)) {
	    options.data = true;
	  }
	  if (options.compat) {
	    options.useDepths = true;
	  }

	  var ast = env.parse(input, options),
	      environment = new env.Compiler().compile(ast, options);
	  return new env.JavaScriptCompiler().compile(environment, options);
	}

	function compile(input, options, env) {
	  if (options === undefined) options = {};

	  if (input == null || typeof input !== 'string' && input.type !== 'Program') {
	    throw new _exception2['default']('You must pass a string or Handlebars AST to Handlebars.compile. You passed ' + input);
	  }

	  options = _utils.extend({}, options);
	  if (!('data' in options)) {
	    options.data = true;
	  }
	  if (options.compat) {
	    options.useDepths = true;
	  }

	  var compiled = undefined;

	  function compileInput() {
	    var ast = env.parse(input, options),
	        environment = new env.Compiler().compile(ast, options),
	        templateSpec = new env.JavaScriptCompiler().compile(environment, options, undefined, true);
	    return env.template(templateSpec);
	  }

	  // Template is only compiled on first use and cached after that point.
	  function ret(context, execOptions) {
	    if (!compiled) {
	      compiled = compileInput();
	    }
	    return compiled.call(this, context, execOptions);
	  }
	  ret._setup = function (setupOptions) {
	    if (!compiled) {
	      compiled = compileInput();
	    }
	    return compiled._setup(setupOptions);
	  };
	  ret._child = function (i, data, blockParams, depths) {
	    if (!compiled) {
	      compiled = compileInput();
	    }
	    return compiled._child(i, data, blockParams, depths);
	  };
	  return ret;
	}

	function argEquals(a, b) {
	  if (a === b) {
	    return true;
	  }

	  if (_utils.isArray(a) && _utils.isArray(b) && a.length === b.length) {
	    for (var i = 0; i < a.length; i++) {
	      if (!argEquals(a[i], b[i])) {
	        return false;
	      }
	    }
	    return true;
	  }
	}

	function transformLiteralToPath(sexpr) {
	  if (!sexpr.path.parts) {
	    var literal = sexpr.path;
	    // Casting to string here to make false and 0 literal values play nicely with the rest
	    // of the system.
	    sexpr.path = {
	      type: 'PathExpression',
	      data: false,
	      depth: 0,
	      parts: [literal.original + ''],
	      original: literal.original + '',
	      loc: literal.loc
	    };
	  }
	}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _interopRequireDefault = __webpack_require__(1)['default'];

	exports.__esModule = true;

	var _base = __webpack_require__(4);

	var _exception = __webpack_require__(6);

	var _exception2 = _interopRequireDefault(_exception);

	var _utils = __webpack_require__(5);

	var _codeGen = __webpack_require__(43);

	var _codeGen2 = _interopRequireDefault(_codeGen);

	function Literal(value) {
	  this.value = value;
	}

	function JavaScriptCompiler() {}

	JavaScriptCompiler.prototype = {
	  // PUBLIC API: You can override these methods in a subclass to provide
	  // alternative compiled forms for name lookup and buffering semantics
	  nameLookup: function nameLookup(parent, name /* , type*/) {
	    if (JavaScriptCompiler.isValidJavaScriptVariableName(name)) {
	      return [parent, '.', name];
	    } else {
	      return [parent, '[', JSON.stringify(name), ']'];
	    }
	  },
	  depthedLookup: function depthedLookup(name) {
	    return [this.aliasable('container.lookup'), '(depths, "', name, '")'];
	  },

	  compilerInfo: function compilerInfo() {
	    var revision = _base.COMPILER_REVISION,
	        versions = _base.REVISION_CHANGES[revision];
	    return [revision, versions];
	  },

	  appendToBuffer: function appendToBuffer(source, location, explicit) {
	    // Force a source as this simplifies the merge logic.
	    if (!_utils.isArray(source)) {
	      source = [source];
	    }
	    source = this.source.wrap(source, location);

	    if (this.environment.isSimple) {
	      return ['return ', source, ';'];
	    } else if (explicit) {
	      // This is a case where the buffer operation occurs as a child of another
	      // construct, generally braces. We have to explicitly output these buffer
	      // operations to ensure that the emitted code goes in the correct location.
	      return ['buffer += ', source, ';'];
	    } else {
	      source.appendToBuffer = true;
	      return source;
	    }
	  },

	  initializeBuffer: function initializeBuffer() {
	    return this.quotedString('');
	  },
	  // END PUBLIC API

	  compile: function compile(environment, options, context, asObject) {
	    this.environment = environment;
	    this.options = options;
	    this.stringParams = this.options.stringParams;
	    this.trackIds = this.options.trackIds;
	    this.precompile = !asObject;

	    this.name = this.environment.name;
	    this.isChild = !!context;
	    this.context = context || {
	      decorators: [],
	      programs: [],
	      environments: []
	    };

	    this.preamble();

	    this.stackSlot = 0;
	    this.stackVars = [];
	    this.aliases = {};
	    this.registers = { list: [] };
	    this.hashes = [];
	    this.compileStack = [];
	    this.inlineStack = [];
	    this.blockParams = [];

	    this.compileChildren(environment, options);

	    this.useDepths = this.useDepths || environment.useDepths || environment.useDecorators || this.options.compat;
	    this.useBlockParams = this.useBlockParams || environment.useBlockParams;

	    var opcodes = environment.opcodes,
	        opcode = undefined,
	        firstLoc = undefined,
	        i = undefined,
	        l = undefined;

	    for (i = 0, l = opcodes.length; i < l; i++) {
	      opcode = opcodes[i];

	      this.source.currentLocation = opcode.loc;
	      firstLoc = firstLoc || opcode.loc;
	      this[opcode.opcode].apply(this, opcode.args);
	    }

	    // Flush any trailing content that might be pending.
	    this.source.currentLocation = firstLoc;
	    this.pushSource('');

	    /* istanbul ignore next */
	    if (this.stackSlot || this.inlineStack.length || this.compileStack.length) {
	      throw new _exception2['default']('Compile completed with content left on stack');
	    }

	    if (!this.decorators.isEmpty()) {
	      this.useDecorators = true;

	      this.decorators.prepend('var decorators = container.decorators;\n');
	      this.decorators.push('return fn;');

	      if (asObject) {
	        this.decorators = Function.apply(this, ['fn', 'props', 'container', 'depth0', 'data', 'blockParams', 'depths', this.decorators.merge()]);
	      } else {
	        this.decorators.prepend('function(fn, props, container, depth0, data, blockParams, depths) {\n');
	        this.decorators.push('}\n');
	        this.decorators = this.decorators.merge();
	      }
	    } else {
	      this.decorators = undefined;
	    }

	    var fn = this.createFunctionContext(asObject);
	    if (!this.isChild) {
	      var ret = {
	        compiler: this.compilerInfo(),
	        main: fn
	      };

	      if (this.decorators) {
	        ret.main_d = this.decorators; // eslint-disable-line camelcase
	        ret.useDecorators = true;
	      }

	      var _context = this.context;
	      var programs = _context.programs;
	      var decorators = _context.decorators;

	      for (i = 0, l = programs.length; i < l; i++) {
	        if (programs[i]) {
	          ret[i] = programs[i];
	          if (decorators[i]) {
	            ret[i + '_d'] = decorators[i];
	            ret.useDecorators = true;
	          }
	        }
	      }

	      if (this.environment.usePartial) {
	        ret.usePartial = true;
	      }
	      if (this.options.data) {
	        ret.useData = true;
	      }
	      if (this.useDepths) {
	        ret.useDepths = true;
	      }
	      if (this.useBlockParams) {
	        ret.useBlockParams = true;
	      }
	      if (this.options.compat) {
	        ret.compat = true;
	      }

	      if (!asObject) {
	        ret.compiler = JSON.stringify(ret.compiler);

	        this.source.currentLocation = { start: { line: 1, column: 0 } };
	        ret = this.objectLiteral(ret);

	        if (options.srcName) {
	          ret = ret.toStringWithSourceMap({ file: options.destName });
	          ret.map = ret.map && ret.map.toString();
	        } else {
	          ret = ret.toString();
	        }
	      } else {
	        ret.compilerOptions = this.options;
	      }

	      return ret;
	    } else {
	      return fn;
	    }
	  },

	  preamble: function preamble() {
	    // track the last context pushed into place to allow skipping the
	    // getContext opcode when it would be a noop
	    this.lastContext = 0;
	    this.source = new _codeGen2['default'](this.options.srcName);
	    this.decorators = new _codeGen2['default'](this.options.srcName);
	  },

	  createFunctionContext: function createFunctionContext(asObject) {
	    var varDeclarations = '';

	    var locals = this.stackVars.concat(this.registers.list);
	    if (locals.length > 0) {
	      varDeclarations += ', ' + locals.join(', ');
	    }

	    // Generate minimizer alias mappings
	    //
	    // When using true SourceNodes, this will update all references to the given alias
	    // as the source nodes are reused in situ. For the non-source node compilation mode,
	    // aliases will not be used, but this case is already being run on the client and
	    // we aren't concern about minimizing the template size.
	    var aliasCount = 0;
	    for (var alias in this.aliases) {
	      // eslint-disable-line guard-for-in
	      var node = this.aliases[alias];

	      if (this.aliases.hasOwnProperty(alias) && node.children && node.referenceCount > 1) {
	        varDeclarations += ', alias' + ++aliasCount + '=' + alias;
	        node.children[0] = 'alias' + aliasCount;
	      }
	    }

	    var params = ['container', 'depth0', 'helpers', 'partials', 'data'];

	    if (this.useBlockParams || this.useDepths) {
	      params.push('blockParams');
	    }
	    if (this.useDepths) {
	      params.push('depths');
	    }

	    // Perform a second pass over the output to merge content when possible
	    var source = this.mergeSource(varDeclarations);

	    if (asObject) {
	      params.push(source);

	      return Function.apply(this, params);
	    } else {
	      return this.source.wrap(['function(', params.join(','), ') {\n  ', source, '}']);
	    }
	  },
	  mergeSource: function mergeSource(varDeclarations) {
	    var isSimple = this.environment.isSimple,
	        appendOnly = !this.forceBuffer,
	        appendFirst = undefined,
	        sourceSeen = undefined,
	        bufferStart = undefined,
	        bufferEnd = undefined;
	    this.source.each(function (line) {
	      if (line.appendToBuffer) {
	        if (bufferStart) {
	          line.prepend('  + ');
	        } else {
	          bufferStart = line;
	        }
	        bufferEnd = line;
	      } else {
	        if (bufferStart) {
	          if (!sourceSeen) {
	            appendFirst = true;
	          } else {
	            bufferStart.prepend('buffer += ');
	          }
	          bufferEnd.add(';');
	          bufferStart = bufferEnd = undefined;
	        }

	        sourceSeen = true;
	        if (!isSimple) {
	          appendOnly = false;
	        }
	      }
	    });

	    if (appendOnly) {
	      if (bufferStart) {
	        bufferStart.prepend('return ');
	        bufferEnd.add(';');
	      } else if (!sourceSeen) {
	        this.source.push('return "";');
	      }
	    } else {
	      varDeclarations += ', buffer = ' + (appendFirst ? '' : this.initializeBuffer());

	      if (bufferStart) {
	        bufferStart.prepend('return buffer + ');
	        bufferEnd.add(';');
	      } else {
	        this.source.push('return buffer;');
	      }
	    }

	    if (varDeclarations) {
	      this.source.prepend('var ' + varDeclarations.substring(2) + (appendFirst ? '' : ';\n'));
	    }

	    return this.source.merge();
	  },

	  // [blockValue]
	  //
	  // On stack, before: hash, inverse, program, value
	  // On stack, after: return value of blockHelperMissing
	  //
	  // The purpose of this opcode is to take a block of the form
	  // `{{#this.foo}}...{{/this.foo}}`, resolve the value of `foo`, and
	  // replace it on the stack with the result of properly
	  // invoking blockHelperMissing.
	  blockValue: function blockValue(name) {
	    var blockHelperMissing = this.aliasable('helpers.blockHelperMissing'),
	        params = [this.contextName(0)];
	    this.setupHelperArgs(name, 0, params);

	    var blockName = this.popStack();
	    params.splice(1, 0, blockName);

	    this.push(this.source.functionCall(blockHelperMissing, 'call', params));
	  },

	  // [ambiguousBlockValue]
	  //
	  // On stack, before: hash, inverse, program, value
	  // Compiler value, before: lastHelper=value of last found helper, if any
	  // On stack, after, if no lastHelper: same as [blockValue]
	  // On stack, after, if lastHelper: value
	  ambiguousBlockValue: function ambiguousBlockValue() {
	    // We're being a bit cheeky and reusing the options value from the prior exec
	    var blockHelperMissing = this.aliasable('helpers.blockHelperMissing'),
	        params = [this.contextName(0)];
	    this.setupHelperArgs('', 0, params, true);

	    this.flushInline();

	    var current = this.topStack();
	    params.splice(1, 0, current);

	    this.pushSource(['if (!', this.lastHelper, ') { ', current, ' = ', this.source.functionCall(blockHelperMissing, 'call', params), '}']);
	  },

	  // [appendContent]
	  //
	  // On stack, before: ...
	  // On stack, after: ...
	  //
	  // Appends the string value of `content` to the current buffer
	  appendContent: function appendContent(content) {
	    if (this.pendingContent) {
	      content = this.pendingContent + content;
	    } else {
	      this.pendingLocation = this.source.currentLocation;
	    }

	    this.pendingContent = content;
	  },

	  // [append]
	  //
	  // On stack, before: value, ...
	  // On stack, after: ...
	  //
	  // Coerces `value` to a String and appends it to the current buffer.
	  //
	  // If `value` is truthy, or 0, it is coerced into a string and appended
	  // Otherwise, the empty string is appended
	  append: function append() {
	    if (this.isInline()) {
	      this.replaceStack(function (current) {
	        return [' != null ? ', current, ' : ""'];
	      });

	      this.pushSource(this.appendToBuffer(this.popStack()));
	    } else {
	      var local = this.popStack();
	      this.pushSource(['if (', local, ' != null) { ', this.appendToBuffer(local, undefined, true), ' }']);
	      if (this.environment.isSimple) {
	        this.pushSource(['else { ', this.appendToBuffer("''", undefined, true), ' }']);
	      }
	    }
	  },

	  // [appendEscaped]
	  //
	  // On stack, before: value, ...
	  // On stack, after: ...
	  //
	  // Escape `value` and append it to the buffer
	  appendEscaped: function appendEscaped() {
	    this.pushSource(this.appendToBuffer([this.aliasable('container.escapeExpression'), '(', this.popStack(), ')']));
	  },

	  // [getContext]
	  //
	  // On stack, before: ...
	  // On stack, after: ...
	  // Compiler value, after: lastContext=depth
	  //
	  // Set the value of the `lastContext` compiler value to the depth
	  getContext: function getContext(depth) {
	    this.lastContext = depth;
	  },

	  // [pushContext]
	  //
	  // On stack, before: ...
	  // On stack, after: currentContext, ...
	  //
	  // Pushes the value of the current context onto the stack.
	  pushContext: function pushContext() {
	    this.pushStackLiteral(this.contextName(this.lastContext));
	  },

	  // [lookupOnContext]
	  //
	  // On stack, before: ...
	  // On stack, after: currentContext[name], ...
	  //
	  // Looks up the value of `name` on the current context and pushes
	  // it onto the stack.
	  lookupOnContext: function lookupOnContext(parts, falsy, strict, scoped) {
	    var i = 0;

	    if (!scoped && this.options.compat && !this.lastContext) {
	      // The depthed query is expected to handle the undefined logic for the root level that
	      // is implemented below, so we evaluate that directly in compat mode
	      this.push(this.depthedLookup(parts[i++]));
	    } else {
	      this.pushContext();
	    }

	    this.resolvePath('context', parts, i, falsy, strict);
	  },

	  // [lookupBlockParam]
	  //
	  // On stack, before: ...
	  // On stack, after: blockParam[name], ...
	  //
	  // Looks up the value of `parts` on the given block param and pushes
	  // it onto the stack.
	  lookupBlockParam: function lookupBlockParam(blockParamId, parts) {
	    this.useBlockParams = true;

	    this.push(['blockParams[', blockParamId[0], '][', blockParamId[1], ']']);
	    this.resolvePath('context', parts, 1);
	  },

	  // [lookupData]
	  //
	  // On stack, before: ...
	  // On stack, after: data, ...
	  //
	  // Push the data lookup operator
	  lookupData: function lookupData(depth, parts, strict) {
	    if (!depth) {
	      this.pushStackLiteral('data');
	    } else {
	      this.pushStackLiteral('container.data(data, ' + depth + ')');
	    }

	    this.resolvePath('data', parts, 0, true, strict);
	  },

	  resolvePath: function resolvePath(type, parts, i, falsy, strict) {
	    // istanbul ignore next

	    var _this = this;

	    if (this.options.strict || this.options.assumeObjects) {
	      this.push(strictLookup(this.options.strict && strict, this, parts, type));
	      return;
	    }

	    var len = parts.length;
	    for (; i < len; i++) {
	      /* eslint-disable no-loop-func */
	      this.replaceStack(function (current) {
	        var lookup = _this.nameLookup(current, parts[i], type);
	        // We want to ensure that zero and false are handled properly if the context (falsy flag)
	        // needs to have the special handling for these values.
	        if (!falsy) {
	          return [' != null ? ', lookup, ' : ', current];
	        } else {
	          // Otherwise we can use generic falsy handling
	          return [' && ', lookup];
	        }
	      });
	      /* eslint-enable no-loop-func */
	    }
	  },

	  // [resolvePossibleLambda]
	  //
	  // On stack, before: value, ...
	  // On stack, after: resolved value, ...
	  //
	  // If the `value` is a lambda, replace it on the stack by
	  // the return value of the lambda
	  resolvePossibleLambda: function resolvePossibleLambda() {
	    this.push([this.aliasable('container.lambda'), '(', this.popStack(), ', ', this.contextName(0), ')']);
	  },

	  // [pushStringParam]
	  //
	  // On stack, before: ...
	  // On stack, after: string, currentContext, ...
	  //
	  // This opcode is designed for use in string mode, which
	  // provides the string value of a parameter along with its
	  // depth rather than resolving it immediately.
	  pushStringParam: function pushStringParam(string, type) {
	    this.pushContext();
	    this.pushString(type);

	    // If it's a subexpression, the string result
	    // will be pushed after this opcode.
	    if (type !== 'SubExpression') {
	      if (typeof string === 'string') {
	        this.pushString(string);
	      } else {
	        this.pushStackLiteral(string);
	      }
	    }
	  },

	  emptyHash: function emptyHash(omitEmpty) {
	    if (this.trackIds) {
	      this.push('{}'); // hashIds
	    }
	    if (this.stringParams) {
	      this.push('{}'); // hashContexts
	      this.push('{}'); // hashTypes
	    }
	    this.pushStackLiteral(omitEmpty ? 'undefined' : '{}');
	  },
	  pushHash: function pushHash() {
	    if (this.hash) {
	      this.hashes.push(this.hash);
	    }
	    this.hash = { values: [], types: [], contexts: [], ids: [] };
	  },
	  popHash: function popHash() {
	    var hash = this.hash;
	    this.hash = this.hashes.pop();

	    if (this.trackIds) {
	      this.push(this.objectLiteral(hash.ids));
	    }
	    if (this.stringParams) {
	      this.push(this.objectLiteral(hash.contexts));
	      this.push(this.objectLiteral(hash.types));
	    }

	    this.push(this.objectLiteral(hash.values));
	  },

	  // [pushString]
	  //
	  // On stack, before: ...
	  // On stack, after: quotedString(string), ...
	  //
	  // Push a quoted version of `string` onto the stack
	  pushString: function pushString(string) {
	    this.pushStackLiteral(this.quotedString(string));
	  },

	  // [pushLiteral]
	  //
	  // On stack, before: ...
	  // On stack, after: value, ...
	  //
	  // Pushes a value onto the stack. This operation prevents
	  // the compiler from creating a temporary variable to hold
	  // it.
	  pushLiteral: function pushLiteral(value) {
	    this.pushStackLiteral(value);
	  },

	  // [pushProgram]
	  //
	  // On stack, before: ...
	  // On stack, after: program(guid), ...
	  //
	  // Push a program expression onto the stack. This takes
	  // a compile-time guid and converts it into a runtime-accessible
	  // expression.
	  pushProgram: function pushProgram(guid) {
	    if (guid != null) {
	      this.pushStackLiteral(this.programExpression(guid));
	    } else {
	      this.pushStackLiteral(null);
	    }
	  },

	  // [registerDecorator]
	  //
	  // On stack, before: hash, program, params..., ...
	  // On stack, after: ...
	  //
	  // Pops off the decorator's parameters, invokes the decorator,
	  // and inserts the decorator into the decorators list.
	  registerDecorator: function registerDecorator(paramSize, name) {
	    var foundDecorator = this.nameLookup('decorators', name, 'decorator'),
	        options = this.setupHelperArgs(name, paramSize);

	    this.decorators.push(['fn = ', this.decorators.functionCall(foundDecorator, '', ['fn', 'props', 'container', options]), ' || fn;']);
	  },

	  // [invokeHelper]
	  //
	  // On stack, before: hash, inverse, program, params..., ...
	  // On stack, after: result of helper invocation
	  //
	  // Pops off the helper's parameters, invokes the helper,
	  // and pushes the helper's return value onto the stack.
	  //
	  // If the helper is not found, `helperMissing` is called.
	  invokeHelper: function invokeHelper(paramSize, name, isSimple) {
	    var nonHelper = this.popStack(),
	        helper = this.setupHelper(paramSize, name),
	        simple = isSimple ? [helper.name, ' || '] : '';

	    var lookup = ['('].concat(simple, nonHelper);
	    if (!this.options.strict) {
	      lookup.push(' || ', this.aliasable('helpers.helperMissing'));
	    }
	    lookup.push(')');

	    this.push(this.source.functionCall(lookup, 'call', helper.callParams));
	  },

	  // [invokeKnownHelper]
	  //
	  // On stack, before: hash, inverse, program, params..., ...
	  // On stack, after: result of helper invocation
	  //
	  // This operation is used when the helper is known to exist,
	  // so a `helperMissing` fallback is not required.
	  invokeKnownHelper: function invokeKnownHelper(paramSize, name) {
	    var helper = this.setupHelper(paramSize, name);
	    this.push(this.source.functionCall(helper.name, 'call', helper.callParams));
	  },

	  // [invokeAmbiguous]
	  //
	  // On stack, before: hash, inverse, program, params..., ...
	  // On stack, after: result of disambiguation
	  //
	  // This operation is used when an expression like `{{foo}}`
	  // is provided, but we don't know at compile-time whether it
	  // is a helper or a path.
	  //
	  // This operation emits more code than the other options,
	  // and can be avoided by passing the `knownHelpers` and
	  // `knownHelpersOnly` flags at compile-time.
	  invokeAmbiguous: function invokeAmbiguous(name, helperCall) {
	    this.useRegister('helper');

	    var nonHelper = this.popStack();

	    this.emptyHash();
	    var helper = this.setupHelper(0, name, helperCall);

	    var helperName = this.lastHelper = this.nameLookup('helpers', name, 'helper');

	    var lookup = ['(', '(helper = ', helperName, ' || ', nonHelper, ')'];
	    if (!this.options.strict) {
	      lookup[0] = '(helper = ';
	      lookup.push(' != null ? helper : ', this.aliasable('helpers.helperMissing'));
	    }

	    this.push(['(', lookup, helper.paramsInit ? ['),(', helper.paramsInit] : [], '),', '(typeof helper === ', this.aliasable('"function"'), ' ? ', this.source.functionCall('helper', 'call', helper.callParams), ' : helper))']);
	  },

	  // [invokePartial]
	  //
	  // On stack, before: context, ...
	  // On stack after: result of partial invocation
	  //
	  // This operation pops off a context, invokes a partial with that context,
	  // and pushes the result of the invocation back.
	  invokePartial: function invokePartial(isDynamic, name, indent) {
	    var params = [],
	        options = this.setupParams(name, 1, params);

	    if (isDynamic) {
	      name = this.popStack();
	      delete options.name;
	    }

	    if (indent) {
	      options.indent = JSON.stringify(indent);
	    }
	    options.helpers = 'helpers';
	    options.partials = 'partials';
	    options.decorators = 'container.decorators';

	    if (!isDynamic) {
	      params.unshift(this.nameLookup('partials', name, 'partial'));
	    } else {
	      params.unshift(name);
	    }

	    if (this.options.compat) {
	      options.depths = 'depths';
	    }
	    options = this.objectLiteral(options);
	    params.push(options);

	    this.push(this.source.functionCall('container.invokePartial', '', params));
	  },

	  // [assignToHash]
	  //
	  // On stack, before: value, ..., hash, ...
	  // On stack, after: ..., hash, ...
	  //
	  // Pops a value off the stack and assigns it to the current hash
	  assignToHash: function assignToHash(key) {
	    var value = this.popStack(),
	        context = undefined,
	        type = undefined,
	        id = undefined;

	    if (this.trackIds) {
	      id = this.popStack();
	    }
	    if (this.stringParams) {
	      type = this.popStack();
	      context = this.popStack();
	    }

	    var hash = this.hash;
	    if (context) {
	      hash.contexts[key] = context;
	    }
	    if (type) {
	      hash.types[key] = type;
	    }
	    if (id) {
	      hash.ids[key] = id;
	    }
	    hash.values[key] = value;
	  },

	  pushId: function pushId(type, name, child) {
	    if (type === 'BlockParam') {
	      this.pushStackLiteral('blockParams[' + name[0] + '].path[' + name[1] + ']' + (child ? ' + ' + JSON.stringify('.' + child) : ''));
	    } else if (type === 'PathExpression') {
	      this.pushString(name);
	    } else if (type === 'SubExpression') {
	      this.pushStackLiteral('true');
	    } else {
	      this.pushStackLiteral('null');
	    }
	  },

	  // HELPERS

	  compiler: JavaScriptCompiler,

	  compileChildren: function compileChildren(environment, options) {
	    var children = environment.children,
	        child = undefined,
	        compiler = undefined;

	    for (var i = 0, l = children.length; i < l; i++) {
	      child = children[i];
	      compiler = new this.compiler(); // eslint-disable-line new-cap

	      var existing = this.matchExistingProgram(child);

	      if (existing == null) {
	        this.context.programs.push(''); // Placeholder to prevent name conflicts for nested children
	        var index = this.context.programs.length;
	        child.index = index;
	        child.name = 'program' + index;
	        this.context.programs[index] = compiler.compile(child, options, this.context, !this.precompile);
	        this.context.decorators[index] = compiler.decorators;
	        this.context.environments[index] = child;

	        this.useDepths = this.useDepths || compiler.useDepths;
	        this.useBlockParams = this.useBlockParams || compiler.useBlockParams;
	        child.useDepths = this.useDepths;
	        child.useBlockParams = this.useBlockParams;
	      } else {
	        child.index = existing.index;
	        child.name = 'program' + existing.index;

	        this.useDepths = this.useDepths || existing.useDepths;
	        this.useBlockParams = this.useBlockParams || existing.useBlockParams;
	      }
	    }
	  },
	  matchExistingProgram: function matchExistingProgram(child) {
	    for (var i = 0, len = this.context.environments.length; i < len; i++) {
	      var environment = this.context.environments[i];
	      if (environment && environment.equals(child)) {
	        return environment;
	      }
	    }
	  },

	  programExpression: function programExpression(guid) {
	    var child = this.environment.children[guid],
	        programParams = [child.index, 'data', child.blockParams];

	    if (this.useBlockParams || this.useDepths) {
	      programParams.push('blockParams');
	    }
	    if (this.useDepths) {
	      programParams.push('depths');
	    }

	    return 'container.program(' + programParams.join(', ') + ')';
	  },

	  useRegister: function useRegister(name) {
	    if (!this.registers[name]) {
	      this.registers[name] = true;
	      this.registers.list.push(name);
	    }
	  },

	  push: function push(expr) {
	    if (!(expr instanceof Literal)) {
	      expr = this.source.wrap(expr);
	    }

	    this.inlineStack.push(expr);
	    return expr;
	  },

	  pushStackLiteral: function pushStackLiteral(item) {
	    this.push(new Literal(item));
	  },

	  pushSource: function pushSource(source) {
	    if (this.pendingContent) {
	      this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation));
	      this.pendingContent = undefined;
	    }

	    if (source) {
	      this.source.push(source);
	    }
	  },

	  replaceStack: function replaceStack(callback) {
	    var prefix = ['('],
	        stack = undefined,
	        createdStack = undefined,
	        usedLiteral = undefined;

	    /* istanbul ignore next */
	    if (!this.isInline()) {
	      throw new _exception2['default']('replaceStack on non-inline');
	    }

	    // We want to merge the inline statement into the replacement statement via ','
	    var top = this.popStack(true);

	    if (top instanceof Literal) {
	      // Literals do not need to be inlined
	      stack = [top.value];
	      prefix = ['(', stack];
	      usedLiteral = true;
	    } else {
	      // Get or create the current stack name for use by the inline
	      createdStack = true;
	      var _name = this.incrStack();

	      prefix = ['((', this.push(_name), ' = ', top, ')'];
	      stack = this.topStack();
	    }

	    var item = callback.call(this, stack);

	    if (!usedLiteral) {
	      this.popStack();
	    }
	    if (createdStack) {
	      this.stackSlot--;
	    }
	    this.push(prefix.concat(item, ')'));
	  },

	  incrStack: function incrStack() {
	    this.stackSlot++;
	    if (this.stackSlot > this.stackVars.length) {
	      this.stackVars.push('stack' + this.stackSlot);
	    }
	    return this.topStackName();
	  },
	  topStackName: function topStackName() {
	    return 'stack' + this.stackSlot;
	  },
	  flushInline: function flushInline() {
	    var inlineStack = this.inlineStack;
	    this.inlineStack = [];
	    for (var i = 0, len = inlineStack.length; i < len; i++) {
	      var entry = inlineStack[i];
	      /* istanbul ignore if */
	      if (entry instanceof Literal) {
	        this.compileStack.push(entry);
	      } else {
	        var stack = this.incrStack();
	        this.pushSource([stack, ' = ', entry, ';']);
	        this.compileStack.push(stack);
	      }
	    }
	  },
	  isInline: function isInline() {
	    return this.inlineStack.length;
	  },

	  popStack: function popStack(wrapped) {
	    var inline = this.isInline(),
	        item = (inline ? this.inlineStack : this.compileStack).pop();

	    if (!wrapped && item instanceof Literal) {
	      return item.value;
	    } else {
	      if (!inline) {
	        /* istanbul ignore next */
	        if (!this.stackSlot) {
	          throw new _exception2['default']('Invalid stack pop');
	        }
	        this.stackSlot--;
	      }
	      return item;
	    }
	  },

	  topStack: function topStack() {
	    var stack = this.isInline() ? this.inlineStack : this.compileStack,
	        item = stack[stack.length - 1];

	    /* istanbul ignore if */
	    if (item instanceof Literal) {
	      return item.value;
	    } else {
	      return item;
	    }
	  },

	  contextName: function contextName(context) {
	    if (this.useDepths && context) {
	      return 'depths[' + context + ']';
	    } else {
	      return 'depth' + context;
	    }
	  },

	  quotedString: function quotedString(str) {
	    return this.source.quotedString(str);
	  },

	  objectLiteral: function objectLiteral(obj) {
	    return this.source.objectLiteral(obj);
	  },

	  aliasable: function aliasable(name) {
	    var ret = this.aliases[name];
	    if (ret) {
	      ret.referenceCount++;
	      return ret;
	    }

	    ret = this.aliases[name] = this.source.wrap(name);
	    ret.aliasable = true;
	    ret.referenceCount = 1;

	    return ret;
	  },

	  setupHelper: function setupHelper(paramSize, name, blockHelper) {
	    var params = [],
	        paramsInit = this.setupHelperArgs(name, paramSize, params, blockHelper);
	    var foundHelper = this.nameLookup('helpers', name, 'helper'),
	        callContext = this.aliasable(this.contextName(0) + ' != null ? ' + this.contextName(0) + ' : (container.nullContext || {})');

	    return {
	      params: params,
	      paramsInit: paramsInit,
	      name: foundHelper,
	      callParams: [callContext].concat(params)
	    };
	  },

	  setupParams: function setupParams(helper, paramSize, params) {
	    var options = {},
	        contexts = [],
	        types = [],
	        ids = [],
	        objectArgs = !params,
	        param = undefined;

	    if (objectArgs) {
	      params = [];
	    }

	    options.name = this.quotedString(helper);
	    options.hash = this.popStack();

	    if (this.trackIds) {
	      options.hashIds = this.popStack();
	    }
	    if (this.stringParams) {
	      options.hashTypes = this.popStack();
	      options.hashContexts = this.popStack();
	    }

	    var inverse = this.popStack(),
	        program = this.popStack();

	    // Avoid setting fn and inverse if neither are set. This allows
	    // helpers to do a check for `if (options.fn)`
	    if (program || inverse) {
	      options.fn = program || 'container.noop';
	      options.inverse = inverse || 'container.noop';
	    }

	    // The parameters go on to the stack in order (making sure that they are evaluated in order)
	    // so we need to pop them off the stack in reverse order
	    var i = paramSize;
	    while (i--) {
	      param = this.popStack();
	      params[i] = param;

	      if (this.trackIds) {
	        ids[i] = this.popStack();
	      }
	      if (this.stringParams) {
	        types[i] = this.popStack();
	        contexts[i] = this.popStack();
	      }
	    }

	    if (objectArgs) {
	      options.args = this.source.generateArray(params);
	    }

	    if (this.trackIds) {
	      options.ids = this.source.generateArray(ids);
	    }
	    if (this.stringParams) {
	      options.types = this.source.generateArray(types);
	      options.contexts = this.source.generateArray(contexts);
	    }

	    if (this.options.data) {
	      options.data = 'data';
	    }
	    if (this.useBlockParams) {
	      options.blockParams = 'blockParams';
	    }
	    return options;
	  },

	  setupHelperArgs: function setupHelperArgs(helper, paramSize, params, useRegister) {
	    var options = this.setupParams(helper, paramSize, params);
	    options = this.objectLiteral(options);
	    if (useRegister) {
	      this.useRegister('options');
	      params.push('options');
	      return ['options=', options];
	    } else if (params) {
	      params.push(options);
	      return '';
	    } else {
	      return options;
	    }
	  }
	};

	(function () {
	  var reservedWords = ('break else new var' + ' case finally return void' + ' catch for switch while' + ' continue function this with' + ' default if throw' + ' delete in try' + ' do instanceof typeof' + ' abstract enum int short' + ' boolean export interface static' + ' byte extends long super' + ' char final native synchronized' + ' class float package throws' + ' const goto private transient' + ' debugger implements protected volatile' + ' double import public let yield await' + ' null true false').split(' ');

	  var compilerWords = JavaScriptCompiler.RESERVED_WORDS = {};

	  for (var i = 0, l = reservedWords.length; i < l; i++) {
	    compilerWords[reservedWords[i]] = true;
	  }
	})();

	JavaScriptCompiler.isValidJavaScriptVariableName = function (name) {
	  return !JavaScriptCompiler.RESERVED_WORDS[name] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(name);
	};

	function strictLookup(requireTerminal, compiler, parts, type) {
	  var stack = compiler.popStack(),
	      i = 0,
	      len = parts.length;
	  if (requireTerminal) {
	    len--;
	  }

	  for (; i < len; i++) {
	    stack = compiler.nameLookup(stack, parts[i], type);
	  }

	  if (requireTerminal) {
	    return [compiler.aliasable('container.strict'), '(', stack, ', ', compiler.quotedString(parts[i]), ')'];
	  } else {
	    return stack;
	  }
	}

	exports['default'] = JavaScriptCompiler;
	module.exports = exports['default'];

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/* global define */
	'use strict';

	exports.__esModule = true;

	var _utils = __webpack_require__(5);

	var SourceNode = undefined;

	try {
	  /* istanbul ignore next */
	  if (false) {
	    // We don't support this in AMD environments. For these environments, we asusme that
	    // they are running on the browser and thus have no need for the source-map library.
	    var SourceMap = require('source-map');
	    SourceNode = SourceMap.SourceNode;
	  }
	} catch (err) {}
	/* NOP */

	/* istanbul ignore if: tested but not covered in istanbul due to dist build  */
	if (!SourceNode) {
	  SourceNode = function (line, column, srcFile, chunks) {
	    this.src = '';
	    if (chunks) {
	      this.add(chunks);
	    }
	  };
	  /* istanbul ignore next */
	  SourceNode.prototype = {
	    add: function add(chunks) {
	      if (_utils.isArray(chunks)) {
	        chunks = chunks.join('');
	      }
	      this.src += chunks;
	    },
	    prepend: function prepend(chunks) {
	      if (_utils.isArray(chunks)) {
	        chunks = chunks.join('');
	      }
	      this.src = chunks + this.src;
	    },
	    toStringWithSourceMap: function toStringWithSourceMap() {
	      return { code: this.toString() };
	    },
	    toString: function toString() {
	      return this.src;
	    }
	  };
	}

	function castChunk(chunk, codeGen, loc) {
	  if (_utils.isArray(chunk)) {
	    var ret = [];

	    for (var i = 0, len = chunk.length; i < len; i++) {
	      ret.push(codeGen.wrap(chunk[i], loc));
	    }
	    return ret;
	  } else if (typeof chunk === 'boolean' || typeof chunk === 'number') {
	    // Handle primitives that the SourceNode will throw up on
	    return chunk + '';
	  }
	  return chunk;
	}

	function CodeGen(srcFile) {
	  this.srcFile = srcFile;
	  this.source = [];
	}

	CodeGen.prototype = {
	  isEmpty: function isEmpty() {
	    return !this.source.length;
	  },
	  prepend: function prepend(source, loc) {
	    this.source.unshift(this.wrap(source, loc));
	  },
	  push: function push(source, loc) {
	    this.source.push(this.wrap(source, loc));
	  },

	  merge: function merge() {
	    var source = this.empty();
	    this.each(function (line) {
	      source.add(['  ', line, '\n']);
	    });
	    return source;
	  },

	  each: function each(iter) {
	    for (var i = 0, len = this.source.length; i < len; i++) {
	      iter(this.source[i]);
	    }
	  },

	  empty: function empty() {
	    var loc = this.currentLocation || { start: {} };
	    return new SourceNode(loc.start.line, loc.start.column, this.srcFile);
	  },
	  wrap: function wrap(chunk) {
	    var loc = arguments.length <= 1 || arguments[1] === undefined ? this.currentLocation || { start: {} } : arguments[1];

	    if (chunk instanceof SourceNode) {
	      return chunk;
	    }

	    chunk = castChunk(chunk, this, loc);

	    return new SourceNode(loc.start.line, loc.start.column, this.srcFile, chunk);
	  },

	  functionCall: function functionCall(fn, type, params) {
	    params = this.generateList(params);
	    return this.wrap([fn, type ? '.' + type + '(' : '(', params, ')']);
	  },

	  quotedString: function quotedString(str) {
	    return '"' + (str + '').replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\u2028/g, '\\u2028') // Per Ecma-262 7.3 + 7.8.4
	    .replace(/\u2029/g, '\\u2029') + '"';
	  },

	  objectLiteral: function objectLiteral(obj) {
	    var pairs = [];

	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        var value = castChunk(obj[key], this);
	        if (value !== 'undefined') {
	          pairs.push([this.quotedString(key), ':', value]);
	        }
	      }
	    }

	    var ret = this.generateList(pairs);
	    ret.prepend('{');
	    ret.add('}');
	    return ret;
	  },

	  generateList: function generateList(entries) {
	    var ret = this.empty();

	    for (var i = 0, len = entries.length; i < len; i++) {
	      if (i) {
	        ret.add(',');
	      }

	      ret.add(castChunk(entries[i], this));
	    }

	    return ret;
	  },

	  generateArray: function generateArray(entries) {
	    var ret = this.generateList(entries);
	    ret.prepend('[');
	    ret.add(']');

	    return ret;
	  }
	};

	exports['default'] = CodeGen;
	module.exports = exports['default'];

/***/ })
/******/ ])
});
;

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(95);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["b" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Converts a camel-case string to a dash-case string
 * @param {string} str - str that gets converted to dash-case
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function (str) {
  return str.replace(/([a-z]|^)([A-Z])/g, function (match, p1, p2) {
    return p1 + '-' + p2.toLowerCase();
  }).replace('ms-', '-ms-');
};

module.exports = exports['default'];

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _camelToDashCase = __webpack_require__(124);

var _camelToDashCase2 = _interopRequireDefault(_camelToDashCase);

// returns a style object with a single concated prefixed value string

exports['default'] = function (property, value) {
  var replacer = arguments.length <= 2 || arguments[2] === undefined ? function (prefix, value) {
    return prefix + value;
  } : arguments[2];
  return (function () {
    return _defineProperty({}, property, ['-webkit-', '-moz-', ''].map(function (prefix) {
      return replacer(prefix, value);
    }));
  })();
};

module.exports = exports['default'];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(19);

var EventPluginRegistry = __webpack_require__(176);
var ReactEventEmitterMixin = __webpack_require__(777);
var ViewportMetrics = __webpack_require__(282);

var getVendorPrefixedEventName = __webpack_require__(809);
var isEventSupported = __webpack_require__(187);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(99);
var ViewportMetrics = __webpack_require__(282);

var getEventModifierState = __webpack_require__(185);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(13);

var invariant = __webpack_require__(7);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(29);
var DOMNamespaces = __webpack_require__(175);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(183);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(['open', 'close']);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormActions = _reflux2.default.createActions({
  "reset": {},
  "post": { children: ['completed', 'failed'] }
});

var Helpers = {
  getPostData: function getPostData(postState) {
    var postData = {
      "workflow": "medscape_ba_sharethis",
      "toEmailId": [],
      "params": {
        "senderName": postState.senderName,
        "senderEmail": postState.senderEmail,
        "pubName": "",
        "subject": postState.subject,
        "linkURL": postState.linkUrl,
        "contentTitle": postState.contentTitle,
        "message": postState.message,
        "pubDate": ""
      }
    };
    if (postState.recipient.length > 0) {
      postData.toEmailId.push(postState.recipient);
    }
    if (postState.isCopySender) {
      postData.toEmailId.push(postState.senderEmail);
    }
    return postData;
  }
};
FormActions.post.listen(function (postState) {
  var _this = this;

  var postUrl = window.medscape.config.apiHost.replace("www", "api") + '/servicegateway/v2/auth/notificationservice/emailthis';
  var postData = Helpers.getPostData(postState);
  _jquery2.default.ajax({
    type: 'POST',
    contentType: "application/json",
    dataType: "json",
    processData: false,
    url: postUrl,
    data: JSON.stringify(postData),
    xhrFields: {
      withCredentials: true
    },
    statusCode: {
      '404': function _() {
        console.error('404');
      },
      '403': function _() {
        console.error("403 Response ", window.medscape.config.env);
        if (window.medscape.config.env == 'localhost') {
          //console.log("In Localhost");
          //this.completed({"messages":["successs"]});
        }
      }
    }
  }).then(function (data) {
    _this.completed(data);
  }, this.failed);
  _tracking2.default.track("share-email_submit");
});
exports.default = FormActions;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
  ControlsActionsFactory

  Creates Reflux Actions for each video.
  Prevents multiple videos from listening and triggering the same actions.
*/
var ControlsActionsFactory = function () {
  function ControlsActionsFactory() {
    _classCallCheck(this, ControlsActionsFactory);

    this.actions = {};
  }

  _createClass(ControlsActionsFactory, [{
    key: 'get',
    value: function get(videoId, route) {
      var key = '' + videoId + route.location.pathname;
      if (!this.actions[key]) {
        this.actions[key] = _reflux2.default.createActions(['setCurrentTime', 'setDuration', 'setFullscreen', 'setPause', 'setVolume', 'changeCurrentTime', 'toggleFullscreen', 'togglePlayPause', 'changeVolume', 'toggleMute', 'init', 'show']);
      }
      return this.actions[key];
    }
  }, {
    key: 'clearCache',
    value: function clearCache() {
      var _this = this;

      Object.keys(this.actions).forEach(function (key) {
        delete _this.actions[key];
      });
    }
  }]);

  return ControlsActionsFactory;
}();

exports.default = new ControlsActionsFactory();

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _videoEvents = __webpack_require__(204);

var _videoEvents2 = _interopRequireDefault(_videoEvents);

var _ampPlayerEvents = __webpack_require__(203);

var _ampPlayerEvents2 = _interopRequireDefault(_ampPlayerEvents);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
  VideoActionsFactory

  Creates Reflux Actions for each video.
  Prevents multiple videos from listening and triggering the same actions.
*/
var VideoActionsFactory = function () {
  function VideoActionsFactory() {
    var _this = this;

    _classCallCheck(this, VideoActionsFactory);

    this.actions = {};
    this.VideoPlayerEvents = [].concat(_videoEvents2.default);
    _ampPlayerEvents2.default.forEach(function (playerEvent) {
      if (_this.VideoPlayerEvents.indexOf(playerEvent) < 0) {
        _this.VideoPlayerEvents.push(playerEvent);
      }
    });
  }

  _createClass(VideoActionsFactory, [{
    key: 'get',
    value: function get(videoId, route) {
      var key = '' + videoId + route.location.pathname;
      if (!this.actions[key]) {
        this.actions[key] = _reflux2.default.createActions(this.VideoPlayerEvents);
        this.actions[key].timeStamp = Date.now();
      }
      return this.actions[key];
    }
  }, {
    key: 'clearCache',
    value: function clearCache() {
      var _this2 = this;

      Object.keys(this.actions).forEach(function (key) {
        delete _this2.actions[key];
      });
    }
  }]);

  return VideoActionsFactory;
}();

exports.default = new VideoActionsFactory();

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
   value: true
});

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(['toggle']);

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
   value: true
});
exports.MetaDataActions = undefined;

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MetaDataActions = _reflux2.default.createActions(["setTitle", "setDescription"]);

exports.MetaDataActions = MetaDataActions;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(['open', 'close']);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(24);
var toAbsoluteIndex = __webpack_require__(74);
var toLength = __webpack_require__(22);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(427);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(21);
var createDesc = __webpack_require__(71);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
var document = __webpack_require__(9).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 142 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(17)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(9).document;
module.exports = document && document.documentElement;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
var setPrototypeOf = __webpack_require__(153).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(79);
var ITERATOR = __webpack_require__(17)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(68);
var descriptor = __webpack_require__(71);
var setToStringTag = __webpack_require__(80);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(31)(IteratorPrototype, __webpack_require__(17)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(59);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(32);
var hide = __webpack_require__(31);
var Iterators = __webpack_require__(79);
var $iterCreate = __webpack_require__(147);
var setToStringTag = __webpack_require__(80);
var getPrototypeOf = __webpack_require__(36);
var ITERATOR = __webpack_require__(17)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 149 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 150 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var macrotask = __webpack_require__(159).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(38)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(27);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(12);
var anObject = __webpack_require__(8);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(40)(Function.call, __webpack_require__(35).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(115)('keys');
var uid = __webpack_require__(75);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(47);
var defined = __webpack_require__(45);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(109);
var defined = __webpack_require__(45);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(47);
var defined = __webpack_require__(45);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(40);
var invoke = __webpack_require__(221);
var html = __webpack_require__(144);
var cel = __webpack_require__(141);
var global = __webpack_require__(9);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(38)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var DESCRIPTORS = __webpack_require__(20);
var LIBRARY = __webpack_require__(59);
var $typed = __webpack_require__(117);
var hide = __webpack_require__(31);
var redefineAll = __webpack_require__(72);
var fails = __webpack_require__(11);
var anInstance = __webpack_require__(66);
var toInteger = __webpack_require__(47);
var toLength = __webpack_require__(22);
var toIndex = __webpack_require__(239);
var gOPN = __webpack_require__(69).f;
var dP = __webpack_require__(21).f;
var arrayFill = __webpack_require__(138);
var setToStringTag = __webpack_require__(80);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var core = __webpack_require__(39);
var LIBRARY = __webpack_require__(59);
var wksExt = __webpack_require__(240);
var defineProperty = __webpack_require__(21).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(92);
var ITERATOR = __webpack_require__(17)('iterator');
var Iterators = __webpack_require__(79);
module.exports = __webpack_require__(39).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(58);
var step = __webpack_require__(224);
var Iterators = __webpack_require__(79);
var toIObject = __webpack_require__(37);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(148)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(6);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(25);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(26);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(28);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-next', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'next');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '7 2 17 12 7 22' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Next';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(6);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(25);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(26);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(28);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-previous', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'previous');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '7 2 17 12 7 22', transform: 'matrix(-1 0 0 1 24 0)' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Previous';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function (value) {
  if (Array.isArray(value)) value = value.join(',');

  return value.match(/-webkit-|-moz-|-ms-/) !== null;
};

module.exports = exports['default'];

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cssRuleSetToString;

var _appendPxIfNeeded = __webpack_require__(260);

var _appendPxIfNeeded2 = _interopRequireDefault(_appendPxIfNeeded);

var _camelCasePropsToDashCase = __webpack_require__(720);

var _camelCasePropsToDashCase2 = _interopRequireDefault(_camelCasePropsToDashCase);

var _mapObject = __webpack_require__(265);

var _mapObject2 = _interopRequireDefault(_mapObject);

var _prefixer = __webpack_require__(172);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMarkupForStyles(style) {
  return Object.keys(style).map(function (property) {
    return property + ': ' + style[property] + ';';
  }).join('\n');
}

function cssRuleSetToString(selector, rules, userAgent) {
  if (!rules) {
    return '';
  }

  var rulesWithPx = (0, _mapObject2.default)(rules, function (value, key) {
    return (0, _appendPxIfNeeded2.default)(key, value);
  });
  var prefixedRules = (0, _prefixer.getPrefixedStyle)(rulesWithPx, userAgent);
  var cssPrefixedRules = (0, _camelCasePropsToDashCase2.default)(prefixedRules);
  var serializedRules = createMarkupForStyles(cssPrefixedRules);

  return selector + '{' + serializedRules + '}';
}
module.exports = exports['default'];

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _enhancer = __webpack_require__(261);

var _enhancer2 = _interopRequireDefault(_enhancer);

var _plugins = __webpack_require__(266);

var _plugins2 = _interopRequireDefault(_plugins);

var _style = __webpack_require__(723);

var _style2 = _interopRequireDefault(_style);

var _styleRoot = __webpack_require__(721);

var _styleRoot2 = _interopRequireDefault(_styleRoot);

var _getState = __webpack_require__(263);

var _getState2 = _interopRequireDefault(_getState);

var _keyframes = __webpack_require__(724);

var _keyframes2 = _interopRequireDefault(_keyframes);

var _resolveStyles = __webpack_require__(267);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Radium(ComposedComponent) {
  return (0, _enhancer2.default)(ComposedComponent);
}

Radium.Plugins = _plugins2.default;
Radium.Style = _style2.default;
Radium.StyleRoot = _styleRoot2.default;
Radium.getState = _getState2.default;
Radium.keyframes = _keyframes2.default;

if (false) {
  Radium.TestMode = {
    clearState: _resolveStyles.__clearStateForTests,
    disable: _resolveStyles.__setTestMode.bind(null, false),
    enable: _resolveStyles.__setTestMode.bind(null, true)
  };
}

exports.default = Radium;
module.exports = exports['default'];

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                   * Based on https://github.com/jsstyles/css-vendor, but without having to
                                                                                                                                                                                                                                                   * convert between different cases all the time.
                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                   * 
                                                                                                                                                                                                                                                   */

exports.getPrefixedKeyframes = getPrefixedKeyframes;
exports.getPrefixedStyle = getPrefixedStyle;

var _inlineStylePrefixer = __webpack_require__(697);

var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transformValues(style) {
  return Object.keys(style).reduce(function (newStyle, key) {
    var value = style[key];
    if (Array.isArray(value)) {
      value = value.join(';' + key + ':');
    } else if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof value.toString === 'function') {
      value = value.toString();
    }

    newStyle[key] = value;
    return newStyle;
  }, {});
}

var _hasWarnedAboutUserAgent = false;
var _lastUserAgent = void 0;
var _cachedPrefixer = void 0;

function getPrefixer(userAgent) {
  var actualUserAgent = userAgent || global && global.navigator && global.navigator.userAgent;

  if (false) {
    if (!actualUserAgent && !_hasWarnedAboutUserAgent) {
      /* eslint-disable no-console */
      console.warn('Radium: userAgent should be supplied for server-side rendering. See ' + 'https://github.com/FormidableLabs/radium/tree/master/docs/api#radium ' + 'for more information.');
      /* eslint-enable no-console */
      _hasWarnedAboutUserAgent = true;
    }
  }

  if (!_cachedPrefixer || actualUserAgent !== _lastUserAgent) {
    if (actualUserAgent === 'all') {
      _cachedPrefixer = {
        prefix: _inlineStylePrefixer2.default.prefixAll,
        prefixedKeyframes: 'keyframes'
      };
    } else {
      _cachedPrefixer = new _inlineStylePrefixer2.default({ userAgent: actualUserAgent });
    }
    _lastUserAgent = actualUserAgent;
  }
  return _cachedPrefixer;
}

function getPrefixedKeyframes(userAgent) {
  return getPrefixer(userAgent).prefixedKeyframes;
}

// Returns a new style object with vendor prefixes added to property names
// and values.
function getPrefixedStyle(style, userAgent) {
  var styleWithFallbacks = transformValues(style);
  var prefixer = getPrefixer(userAgent);
  var prefixedStyle = prefixer.prefix(styleWithFallbacks);
  return prefixedStyle;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleKeeper = function () {
  function StyleKeeper(userAgent) {
    _classCallCheck(this, StyleKeeper);

    this._userAgent = userAgent;
    this._listeners = [];
    this._cssSet = {};
  }

  StyleKeeper.prototype.subscribe = function subscribe(listener) {
    var _this = this;

    if (this._listeners.indexOf(listener) === -1) {
      this._listeners.push(listener);
    }

    return {
      // Must be fat arrow to capture `this`
      remove: function remove() {
        var listenerIndex = _this._listeners.indexOf(listener);
        if (listenerIndex > -1) {
          _this._listeners.splice(listenerIndex, 1);
        }
      }
    };
  };

  StyleKeeper.prototype.addCSS = function addCSS(css) {
    var _this2 = this;

    if (!this._cssSet[css]) {
      this._cssSet[css] = true;
      this._emitChange();
    }

    return {
      // Must be fat arrow to capture `this`
      remove: function remove() {
        delete _this2._cssSet[css];
        _this2._emitChange();
      }
    };
  };

  StyleKeeper.prototype.getCSS = function getCSS() {
    return Object.keys(this._cssSet).join('\n');
  };

  StyleKeeper.prototype._emitChange = function _emitChange() {
    this._listeners.forEach(function (listener) {
      return listener();
    });
  };

  return StyleKeeper;
}();

exports.default = StyleKeeper;
module.exports = exports['default'];

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMLazyTree = __webpack_require__(84);
var Danger = __webpack_require__(754);
var ReactDOMComponentTree = __webpack_require__(23);
var ReactInstrumentation = __webpack_require__(43);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(183);
var setInnerHTML = __webpack_require__(130);
var setTextContent = __webpack_require__(290);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(13);

var invariant = __webpack_require__(7);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var ReactErrorUtils = __webpack_require__(181);

var invariant = __webpack_require__(7);
var warning = __webpack_require__(14);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var ReactPropTypesSecret = __webpack_require__(783);
var propTypesFactory = __webpack_require__(258);

var React = __webpack_require__(87);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(7);
var warning = __webpack_require__(14);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(13);

var invariant = __webpack_require__(7);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = function () {
        func(a);
      };
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var ReactCurrentOwner = __webpack_require__(57);
var ReactInstanceMap = __webpack_require__(98);
var ReactInstrumentation = __webpack_require__(43);
var ReactUpdates = __webpack_require__(50);

var invariant = __webpack_require__(7);
var warning = __webpack_require__(14);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(29);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(19);

var emptyFunction = __webpack_require__(49);
var warning = __webpack_require__(14);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(813);



/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(193);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(820);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(821);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(293);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(822);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(823);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(824);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(825);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(191);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(826);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(827);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(828);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_11__generatePath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(829);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_12__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(830);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

// this needs to be set to true before Keep.js starts storing, done via useKeep
var use = false;

var createdStores = [];

var createdActions = [];

function useKeep() {
	var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

	use = bool;
}

function addStore(str) {
	if (use) {
		createdStores.push(str);
	}
}

function addAction(act) {
	if (use) {
		createdActions.push(act);
	}
}

function reset() {
	while (createdStores.length) {
		createdStores.pop();
	}
	while (createdActions.length) {
		createdActions.pop();
	}
}

exports.useKeep = useKeep;
exports.addStore = addStore;
exports.addAction = addAction;
exports.createdStores = createdStores;
exports.createdActions = createdActions;
exports.reset = reset;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deferWith = exports.triggerAsync = exports.trigger = exports.listen = exports.shouldEmit = exports.preEmit = undefined;

var _utils = __webpack_require__(51);

var _ = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * A module of methods for object that you want to be able to listen to.
 * This module is consumed by `createStore` and `createAction`
 */

/**
 * Hook used by the publisher that is invoked before emitting
 * and before `shouldEmit`. The arguments are the ones that the action
 * is invoked with. If this function returns something other than
 * undefined, that will be passed on as arguments for shouldEmit and
 * emission.
 */
var preEmit = exports.preEmit = function preEmit() {};

/**
 * Hook used by the publisher after `preEmit` to determine if the
 * event should be emitted with given arguments. This may be overridden
 * in your application, default implementation always returns true.
 *
 * @returns {Boolean} true if event should be emitted
 */
var shouldEmit = exports.shouldEmit = function shouldEmit() {
    return true;
};

/**
 * Subscribes the given callback for action triggered
 *
 * @param {Function} callback The callback to register as event handler
 * @param {Mixed} [optional] bindContext The context to bind the callback with
 * @returns {Function} Callback that unsubscribes the registered event handler
 */
var listen = exports.listen = function listen(callback, bindContext) {
    bindContext = bindContext || this;
    var eventHandler = function eventHandler(args) {
        if (aborted) {
            return;
        }
        callback.apply(bindContext, args);
    },
        me = this,
        aborted = false;
    this.emitter.addListener(this.eventLabel, eventHandler);
    return function () {
        aborted = true;
        me.emitter.removeListener(me.eventLabel, eventHandler);
    };
};

/**
 * Publishes an event using `this.emitter` (if `shouldEmit` agrees)
 */
var trigger = exports.trigger = function trigger() {
    var args = arguments,
        pre = this.preEmit.apply(this, args);
    args = pre === undefined ? args : _.isArguments(pre) ? pre : [].concat(pre);
    if (this.shouldEmit.apply(this, args)) {
        this.emitter.emit(this.eventLabel, args);
    }
};

/**
 * Tries to publish the event on the next tick
 */
var triggerAsync = exports.triggerAsync = function triggerAsync() {
    var args = arguments,
        me = this;
    _.nextTick(function () {
        me.trigger.apply(me, args);
    });
};

/**
 * Wraps the trigger mechanism with a deferral function.
 *
 * @param {Function} callback the deferral function,
 *        first argument is the resolving function and the
 *        rest are the arguments provided from the previous
 *        trigger invocation
 */
var deferWith = exports.deferWith = function deferWith(callback) {
    var oldTrigger = this.trigger,
        ctx = this,
        resolver = function resolver() {
        oldTrigger.apply(ctx, arguments);
    };
    this.trigger = function () {
        callback.apply(ctx, [resolver].concat([].splice.call(arguments, 0)));
    };
};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.__keep = exports.joinConcat = exports.joinStrict = exports.joinLeading = exports.all = exports.joinTrailing = exports.use = exports.nextTick = exports.setEventEmitter = exports.createActions = exports.createStore = exports.createAction = exports.utils = exports.StoreMethods = exports.PublisherMethods = exports.ListenerMethods = exports.ActionMethods = exports.version = undefined;

var _ActionMethods = __webpack_require__(303);

var ActionMethods = _interopRequireWildcard(_ActionMethods);

var _ListenerMethods = __webpack_require__(78);

var ListenerMethods = _interopRequireWildcard(_ListenerMethods);

var _PublisherMethods = __webpack_require__(196);

var PublisherMethods = _interopRequireWildcard(_PublisherMethods);

var _StoreMethods = __webpack_require__(304);

var StoreMethods = _interopRequireWildcard(_StoreMethods);

var _joins = __webpack_require__(306);

var _utils = __webpack_require__(51);

var _ = _interopRequireWildcard(_utils);

var _createAction = __webpack_require__(851);

var _createStore = __webpack_require__(305);

var _Keep = __webpack_require__(195);

var __keep = _interopRequireWildcard(_Keep);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var version = {
    "reflux-core": "1.0.0"
};

var joinTrailing = (0, _joins.staticJoinCreator)("last");
var all = joinTrailing; // Reflux.all alias for backward compatibility
var joinLeading = (0, _joins.staticJoinCreator)("first");
var joinStrict = (0, _joins.staticJoinCreator)("strict");
var joinConcat = (0, _joins.staticJoinCreator)("all");

var utils = _;


/**
 * Convenience function for creating a set of actions
 *
 * @param definitions the definitions for the actions to be created
 * @returns an object with actions of corresponding action names
 */
var createActions = function () {
    var reducer = function reducer(definitions, actions) {
        Object.keys(definitions).forEach(function (actionName) {
            var val = definitions[actionName];
            actions[actionName] = (0, _createAction.createAction)(val);
        });
    };

    return function (definitions) {
        var actions = {};
        if (definitions instanceof Array) {
            definitions.forEach(function (val) {
                if (_.isObject(val)) {
                    reducer(val, actions);
                } else {
                    actions[val] = (0, _createAction.createAction)(val);
                }
            });
        } else {
            reducer(definitions, actions);
        }
        return actions;
    };
}();

/**
 * Sets the eventmitter that Reflux uses
 */
function setEventEmitter(ctx) {
    _.EventEmitter = ctx;
}

/**
 * Sets the method used for deferring actions and stores
 */
function nextTick(nextTick) {
    _.nextTick = nextTick;
}

function use(pluginCb) {
    pluginCb(this);
}

/**
 * Provides the set of created actions and stores for introspection
 */
/*eslint-disable no-underscore-dangle*/


// export in format that supports syntax: var Reflux = require('reflux-core');
exports.version = version;
exports.ActionMethods = ActionMethods;
exports.ListenerMethods = ListenerMethods;
exports.PublisherMethods = PublisherMethods;
exports.StoreMethods = StoreMethods;
exports.utils = utils;
exports.createAction = _createAction.createAction;
exports.createStore = _createStore.createStore;
exports.createActions = createActions;
exports.setEventEmitter = setEventEmitter;
exports.nextTick = nextTick;
exports.use = use;
exports.joinTrailing = joinTrailing;
exports.all = all;
exports.joinLeading = joinLeading;
exports.joinStrict = joinStrict;
exports.joinConcat = joinConcat;
exports.__keep = __keep;
/*eslint-enable no-underscore-dangle*/

// export in format that supports syntax: import Reflux from 'reflux-core';

Object.defineProperty(exports, "default", {
    get: function get() {
        return exports;
    }
});

/**
 * Warn if Function.prototype.bind not available
 */
if (!Function.prototype.bind) {
    console.error("Function.prototype.bind not available. " + "ES5 shim required. " + "https://github.com/spoike/refluxjs#es5");
}

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(51),
    ListenerMethods = __webpack_require__(78);

/**
 * A module meant to be consumed as a mixin by a React component. Supplies the methods from
 * `ListenerMethods` mixin and takes care of teardown of subscriptions.
 * Note that if you're using the `connect` mixin you don't need this mixin, as connect will
 * import everything this mixin contains!
 */
module.exports = _.extend({

    /**
     * Cleans up all listener previously registered.
     */
    componentWillUnmount: ListenerMethods.stopListeningToAll

}, ListenerMethods);


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(366);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(871);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GiftManager = function GiftManager(config, $modules) {
	_classCallCheck(this, GiftManager);

	var props = {};
	props.packageId = config.packageId;
	props.promoId = config.promoId;
	props.formDisplay = config.formDisplay;
	props.emailHide = config.emailHide;
	props.officeRoadHide = config.officeRoadHide;
	props.officeCityHide = config.officeCityHide;
	props.stateHide = config.stateHide;
	props.zipHide = config.zipHide;
	props.countryHide = config.countryHide;
	var el = $modules;
	if (el === undefined) return;
	$modules.each(function (index, el) {
		_reactDom2.default.render(_react2.default.createElement(_app2.default, props), el);
	});
};

exports.default = GiftManager;


GiftManager.selector = '[data-module="GiftManager"]';
GiftManager.init = function (config, $modules) {
	$modules = $modules || (0, _jquery2.default)(GiftManager.selector);
	new GiftManager(config, $modules);
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(380);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(874);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShareWidget = function () {
	function ShareWidget(config, $ShareWidgets) {
		var _this = this;

		_classCallCheck(this, ShareWidget);

		this.getParentIconType = this.getParentIconType.bind(this);
		this.getIcon = this.getIcon.bind(this);
		var props = {};
		$ShareWidgets.each(function (index, el) {
			var $el = (0, _jquery2.default)(el);
			var shareItem = $el.data('configId');
			var shareItemIndex = window.shareItemsMap.indexOf(shareItem);
			if (shareItemIndex < 0) return;
			var shareItemData = window.dataShareItem[shareItemIndex];
			props["icon-type"] = _this.getParentIconType(shareItemData["config-id"], config).iconType;
			props["itemClassName"] = _this.getParentIconType(shareItemData["config-id"], config).itemClassName;
			props["parent-icon"] = _this.getParentIconType(shareItemData["config-id"], config).icon;
			props["icon-facebook"] = _this.getIcon(shareItemData["facebook"]);
			props["icon-twitter"] = _this.getIcon(shareItemData["twitter"]);
			props["icon-linkedin"] = _this.getIcon(shareItemData["linkedin"]);
			props["icon-google"] = _this.getIcon(shareItemData["google"]);
			props["icon-email"] = _this.getIcon(shareItemData["email"]);
			props["config-id"] = shareItem;
			if (shareItem === 'vertical-right' || shareItem === 'vertical-left' || shareItem === 'horizon') {
				props['pIcon-show'] = false;
			} else {
				props["pIcon-show"] = true;
			}
			_reactDom2.default.render(_react2.default.createElement(_app2.default, props), el);
			(0, _jquery2.default)(el).data('module', '');
		});
	}

	_createClass(ShareWidget, [{
		key: 'getParentIconType',
		value: function getParentIconType(ShareType, config) {
			var parentIcon = { iconType: "", itemClassName: "", icon: "" };
			if (ShareType === 'hover') {
				parentIcon.iconType = this.getParentIcon(config[1]["config-id"]);
				parentIcon.icon = this.getParentIcon(config[1]);
				parentIcon.itemClassName = 'groupSharing';
			}
			if (ShareType === 'email') {
				parentIcon.iconType = this.getParentIcon(config[0]["config-id"]);
				parentIcon.icon = this.getParentIcon(config[0]);
				parentIcon.itemClassName = 'groupEmail';
			}
			return parentIcon;
		}
	}, {
		key: 'getParentIcon',
		value: function getParentIcon(iconData) {
			if (typeof iconData === 'undefined') {
				return "";
			}
			return iconData.icon && iconData.icon.length > 0 ? iconData.icon : "default";
		}
	}, {
		key: 'getIcon',
		value: function getIcon(iconData) {
			if (typeof iconData === 'undefined' || !iconData.isActive) {
				return "";
			}
			return iconData.icon && iconData.icon.length > 0 ? iconData.icon : "default";
		}
	}]);

	return ShareWidget;
}();

exports.default = ShareWidget;

ShareWidget.selector = '[data-module="ShareWidget"]';
ShareWidget.init = function (config, $ShareWidgets) {
	$ShareWidgets = $ShareWidgets || (0, _jquery2.default)(ShareWidget.selector);
	window.dataShareItem = window.dataShareItem || config;
	window.shareItemsType = window.shareItemsType || [];
	window.shareItemsMap = window.dataShareItem.map(function (shareGroup) {
		return shareGroup["config-id"];
	});
	if ($ShareWidgets.length > 0) {
		new ShareWidget(config, $ShareWidgets);
	}
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(['init', 'trackLink', 'trackContainerLinks', 'pageLink', 'updateLinks', 'pageView', 'track']);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cp = {
  init: function init(config) {
    var _this = this;

    this.config = config;
    var staticServer = window.medscape.config.env == 'localhost' ? '//img.proddev.medscapestatic.com' : window.medscape.config.staticServer.host;
    var url = staticServer + '/medscape-core/shared-all/js/cp/cp.js';
    _jquery2.default.getScript(url, function (data, textStatus, jqxhr) {
      (0, _jquery2.default)(document).ready(function () {
        _this.particip(config);
        _this.requestCSD(config);
      });
      window.addEventListener('load', function () {
        _this.load(config);
      });
      var unloadEvent = document.pagehide ? 'pagehide' : 'beforeunload';
      (0, _jquery2.default)(window).on(unloadEvent, function () {
        _this.dropOff(config);
      });
    });
  },
  load: function load(config) {
    var cpData = _jquery2.default.extend({}, config);
    window.postCp(cpData);
  },
  particip: function particip(config) {
    var cpData = _jquery2.default.extend({}, config, {
      activityName: "participation"
    });
    window.postCp(cpData);
  },
  dropOff: function dropOff(config) {
    var cpData = _jquery2.default.extend({}, config, {
      activityName: "drop-off"
    });
    window.postCp(cpData);
  },
  requestCSD: function requestCSD(config) {
    var cpData = _jquery2.default.extend({}, config, {
      activityName: "requestCSD"
    });
    window.postCp(cpData);
  },
  content: function content() {
    var activityName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.config.activityName;


    var event = {
      tacticId: this.config.tacticId,
      activityId: this.config.activityId,
      appname: this.config.appname,
      activityName: activityName
    };
    if (typeof window.postCp !== 'undefined') {
      window.postCp(event);
    }
  }
};
exports.default = cp;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
/*
	AMP Player Events

	https://community.akamai.com/docs/DOC-5549-amp-api#jive_content_id_Player_Events

*/
var AmpPlayerEvents = ['activestatechange', 'canplay', 'canplaythrough', 'displaystatechange', 'durationchange', 'ended', 'error', 'fullscreenchange', 'initialized', 'loadedmeatadata', 'loadstart', 'mediaPlayerID3Updated', 'mediaPlayeronTextData', 'mediasequenceended', 'mediasequencestarted', 'mediumchange', 'mutechange', 'pause', 'play', 'playbacktargetchange', 'playing', 'playrequest', 'playstatechange', 'progress', 'ready', 'seeked', 'seeking', 'started', 'timedmetadata', 'timeupdate', 'volumechange', 'waiting', 'setMedia' // Switch the video with AMP
];

exports.default = AmpPlayerEvents;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var VideoEvents = ['abort', //	Fires when the loading of an audio/video is aborted
'canplay', // Fires when the browser can start playing the audio/video
'canplaythrough', //	Fires when the browser can play through the audio/video without stopping for buffering
'durationchange', //	Fires when the duration of the audio/video is changed
'emptied', //	Fires when the current playlist is empty
'ended', //	Fires when the current playlist is ended
'error', //	Fires when an error occurred during the loading of an audio/video
'fullscreenchange', // Fires when enter or exit fullscreen
'init', 'loadeddata', //	Fires when the browser has loaded the current frame of the audio/video
'loadedmetadata', //	Fires when the browser has loaded meta data for the audio/video
'loadstart', // Fires when the browser starts looking for the audio/video
'pause', // Fires when the audio/video has been paused
'play', // Fires when the audio/video has been started or is no longer paused
'playing', // Fires when the audio/video is playing after having been paused or stopped for buffering
'progress', // Fires when the browser is downloading the audio/video
'ratechange', // Fires when the playing speed of the audio/video is changed
'ready', 'seeked', // Fires when the user is finished moving/skipping to a new position in the audio/video
'seeking', // Fires when the user starts moving/skipping to a new position in the audio/video
'stalled', // Fires when the browser is trying to get media data, but data is not available
'suspend', // Fires when the browser is intentionally not getting media data
'timeupdate', // Fires when the current playback position has changed
'volumechange', // Fires when the volume has been changed
'waiting', // Fires when the video stops because it needs to buffer the next frame
'destroy', 'setMedia' // Switch the video with AMP
];

exports.default = VideoEvents;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SlideActionsFactory = function () {
	function SlideActionsFactory() {
		_classCallCheck(this, SlideActionsFactory);

		this.actions = {};
	}

	_createClass(SlideActionsFactory, [{
		key: 'get',
		value: function get(CarouselId) {
			var key = 'carousel-' + CarouselId;
			if (!this.actions[key]) {
				this.actions[key] = _reflux2.default.createActions(['afterChange', 'beforeChange', 'toggleNotes', 'toggleLinks']);
			}
			return this.actions[key];
		}
	}]);

	return SlideActionsFactory;
}();

exports.default = new SlideActionsFactory();

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _actions = __webpack_require__(135);

var _actions2 = _interopRequireDefault(_actions);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MobileMenuStore = function (_Reflux$Store) {
    _inherits(MobileMenuStore, _Reflux$Store);

    function MobileMenuStore(props) {
        _classCallCheck(this, MobileMenuStore);

        var _this = _possibleConstructorReturn(this, (MobileMenuStore.__proto__ || Object.getPrototypeOf(MobileMenuStore)).call(this));

        var state = _this.getInitialState();
        _this.props = props;
        _this.listenables = [_actions2.default];
        return _this;
    }

    _createClass(MobileMenuStore, [{
        key: 'getInitialState',
        value: function getInitialState() {
            return {
                isOpen: false
            };
        }
    }, {
        key: 'onToggle',
        value: function onToggle(_state) {
            var newState = _state ? _state : !this.state.isOpen;
            this.setState({
                isOpen: newState
            });
        }
    }]);

    return MobileMenuStore;
}(_reflux2.default.Store);

exports.default = MobileMenuStore;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(408);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(884);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _app2.default;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import SlideActions from './slide-actions';
/*
  Renders the Notes and Links Icons
*/
var SlideIcons = function (_Reflux$Component) {
  _inherits(SlideIcons, _Reflux$Component);

  function SlideIcons(props) {
    _classCallCheck(this, SlideIcons);

    var _this = _possibleConstructorReturn(this, (SlideIcons.__proto__ || Object.getPrototypeOf(SlideIcons)).call(this, props));

    _this.state = {};
    _this.store = new SlideIconsStore(props);
    return _this;
  }

  _createClass(SlideIcons, [{
    key: 'getNotesIcon',
    value: function getNotesIcon() {
      var _this2 = this;

      if (!this.state.showNotes) {
        return;
      }
      var ButtonProps = {
        isActive: this.state.isNotesVisible,
        onClick: function onClick(e) {
          e.preventDefault();_this2.props.SlideActions.toggleNotes(_this2.state.index);
        }
      };
      return _react2.default.createElement(this.props.Buttons.Notes, ButtonProps);
    }
  }, {
    key: 'getLinksIcon',
    value: function getLinksIcon() {
      var _this3 = this;

      if (!this.state.showLinks) {
        return;
      }
      var ButtonProps = {
        isActive: this.state.isLinksVisible,
        onClick: function onClick(e) {
          e.preventDefault();_this3.props.SlideActions.toggleLinks();
        }
      };
      return _react2.default.createElement(this.props.Buttons.Links, ButtonProps);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.slides.length == 0) {
        return false;
      }
      var Notes = this.getNotesIcon();
      var Links = this.getLinksIcon();

      return _react2.default.createElement(
        'div',
        { className: 'icons-container' },
        this.getNotesIcon(),
        this.getLinksIcon()
      );
    }
  }]);

  return SlideIcons;
}(_reflux2.default.Component);

exports.default = SlideIcons;


SlideIcons.propTypes = {
  links: _react2.default.PropTypes.object,
  slides: _react2.default.PropTypes.array,
  SlideActions: _react2.default.PropTypes.object,
  Buttons: _react2.default.PropTypes.object
};
SlideIcons.defaultProps = {};

var SlideIconsStore = function (_Reflux$Store) {
  _inherits(SlideIconsStore, _Reflux$Store);

  function SlideIconsStore(props) {
    _classCallCheck(this, SlideIconsStore);

    var _this4 = _possibleConstructorReturn(this, (SlideIconsStore.__proto__ || Object.getPrototypeOf(SlideIconsStore)).call(this));

    _this4.props = props;
    _this4.state = _this4.getInitialState();
    _this4.listenables = props.SlideActions;
    return _this4;
  }

  _createClass(SlideIconsStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var slide = this.props.slides[index];
      return {
        index: index,
        showLinks: this.props.links.content.length > 0,
        showNotes: slide.notes.content.length > 0,
        isLinksVisible: false,
        isNotesVisible: false
      };
    }
  }, {
    key: 'afterChange',
    value: function afterChange(index) {
      var slide = this.props.slides[index];
      this.setState(this.getInitialState(index));
      //this.setState(this.getInitialState());
    }
  }, {
    key: 'beforeChange',
    value: function beforeChange(currIndex, nextIndex) {}
  }, {
    key: 'onToggleNotes',
    value: function onToggleNotes(index) {
      var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !this.state.isNotesVisible;

      this.setState({
        isNotesVisible: flag,
        isLinksVisible: false
      });
    }
  }, {
    key: 'onToggleLinks',
    value: function onToggleLinks() {
      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.state.isLinksVisible;

      this.setState({
        isNotesVisible: false,
        isLinksVisible: flag
      });
    }
  }]);

  return SlideIconsStore;
}(_reflux2.default.Store);

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _helpers = __webpack_require__(30);

var _helpers2 = _interopRequireDefault(_helpers);

var _toggleButton = __webpack_require__(406);

var _toggleButton2 = _interopRequireDefault(_toggleButton);

var _store = __webpack_require__(352);

var _store2 = _interopRequireDefault(_store);

var _actions = __webpack_require__(91);

var _actions2 = _interopRequireDefault(_actions);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

var _lodash = __webpack_require__(42);

__webpack_require__(310);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContentCache = {};
var $window = (0, _jquery2.default)(window);

var ISI = function (_Reflux$Component) {
  _inherits(ISI, _Reflux$Component);

  function ISI(props) {
    _classCallCheck(this, ISI);

    //const pagePosition = props.config["page-position"];
    //const displayType = window.medscape.isMobile ? pagePosition.mobile : pagePosition.desktop;
    var _this = _possibleConstructorReturn(this, (ISI.__proto__ || Object.getPrototypeOf(ISI)).call(this, props));

    _this.state = {
      moduleHeight: '',
      content: ''
    };
    if (!_this.props.config.isExpanded) {
      _this.props.config.collapseEvent.time = 0;
      _this.props.config.collapseEvent.acceptButton = false;
    }
    _this.store = new _store2.default(props);
    _this.collapseTime = null;
    _this.scrollInterval = null;
    _this.isNewArticle = true;
    return _this;
  }

  _createClass(ISI, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.isSticky) {
        (0, _jquery2.default)(window).off('scroll.isi');
        (0, _jquery2.default)(window).off('resize.isi orientationchange.isi');
        (0, _jquery2.default)(document).off("article:load.isi");
      }
      this.store.stopListeningToAll();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      _reflux2.default.Component.prototype.componentWillMount.call(this);
      //this.getContent(this.props.config.path);
      _actions2.default.getContent(this.props.config.path);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
      if (this.props.isSticky) {
        $window.off('scroll.isi').on('scroll.isi', function (e) {
          _this2.checkStickyDisplay();
        });
        (0, _jquery2.default)(window).off('resize.isi orientationchange.isi').on('resize.isi orientationchange.isi', function (e) {
          _this2.checkStickyDisplay();
          _this2.setModuleHeight();
        });
        (0, _jquery2.default)(document).on("article:load.isi", function (e, page) {
          _this2.isNewArticle = true;
          if (_this2.props.config.isAutoScroll) {
            _actions2.default.toggleAutoScroll(true);
          }
        });
      }

      this.doRender();
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      //this.getContent(nextProps.config.path);
      clearInterval(this.scrollInterval);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));

      if (this.state.scrollTo && !this.props.isSticky) {
        this.state.scrollTo = this.store.state.scrollTo = false;
        var isiModule = (0, _jquery2.default)('.isi-module')[0];
        isiModule.scrollIntoView();
        window.scrollBy(0, -(0, _jquery2.default)('header').height() - 20);
      }
      this.doRender();
    }
  }, {
    key: 'checkStickyDisplay',
    value: function checkStickyDisplay() {
      var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
      var docViewTop = $window.scrollTop();
      var docViewBottom = docViewTop + (0, _jquery2.default)(window).height();
      var elemTopScrollPadding = (0, _lodash.get)(this, 'props.config.pageSettings.desktop.scrollPadding', 20);
      var $isiEl = (0, _jquery2.default)('#isi-article-container');
      if ($isiEl.length == 0) {
        return;
      }
      var offset = $isiEl.find('.header-container').height() + elemTopScrollPadding;
      var elemTop = $isiEl.offset().top + offset;
      var elemBottom = elemTop + $isiEl.height();
      var isIsiVisible = elemTop < docViewBottom;
      if (isIsiVisible == this.state.isVisible) {
        _actions2.default.toggleSticky();
      }
    }
  }, {
    key: 'initAutoScroll',
    value: function initAutoScroll() {
      var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
      var $scrollEl = $this.find('.content-scroll-area');
      if (!this.state.isAutoScroll || this.props.isInline || $scrollEl.length == 0) {
        return;
      }
      if (this.isNewArticle) {
        this.isNewArticle = false;
        $scrollEl[0].scrollTop = 0;
      }
      var speed = this.props.config.scrollTimer;

      this.scrollInterval = setInterval(function () {
        $scrollEl[0].scrollTop += 1;
      }, speed || 100);
      $scrollEl.one('DOMMouseScroll mousewheel', function () {
        _actions2.default.toggleAutoScroll(false);
      });
      $scrollEl.one('click.isiScroll', function () {
        _actions2.default.toggleAutoScroll(false);
      });
    }
  }, {
    key: 'doRender',
    value: function doRender() {
      var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
      if (this.props.isSticky && this.state.isExpanded) {
        var collapseEvent = this.props.config.collapseEvent;
        if (!this.state.isTimerFinished && collapseEvent.time && collapseEvent.time > 0) {
          this.collapseTime = setTimeout(function () {
            _actions2.default.toggle(false);
          }, this.props.config.collapseEvent.time * 1000);
        }
        _helpers2.default.lockScroll("isi-module");
      } else if (this.props.isSticky && !this.state.isExpanded) {
        _helpers2.default.unlockScroll("isi-module");
        this.checkStickyDisplay();
      }
      this.initAutoScroll();
      _tracking2.default.trackContainerLinks($this[0]);
      this.setModuleHeight();
    }
  }, {
    key: 'setModuleHeight',
    value: function setModuleHeight() {
      //let $this = $(ReactDOM.findDOMNode(this));
      var moduleHeight = "";
      var screenHeight = (0, _jquery2.default)(window).outerHeight();
      var $headerEl = (0, _jquery2.default)('header');
      if (this.props.isInline) {
        moduleHeight = "";
      } else if (!this.state.isExpanded) {
        var collapseHeight = window.medscape.isMobile ? this.props.config.pageSettings.mobile.height : this.props.config.pageSettings.desktop.height;
        moduleHeight = collapseHeight;
      } else if (this.props.isSticky) {

        //let screenHeight = $(window).outerHeight();
        //let $headerEl = $('header');
        var isHeaderVisible = _utils2.default.isElementInViewport($headerEl[0]);
        var offsetTop = $headerEl.offset()['top'] - (window.pageYOffset + window.innerHeight);
        var visibleHeight = $headerEl.height();
        if (isHeaderVisible) {
          visibleHeight = $headerEl.height() + $headerEl.offset()['top'];
        }
        var headerHeight = isHeaderVisible ? visibleHeight : 0;
        //moduleHeight = screenHeight - headerHeight;
        moduleHeight = screenHeight;
        if (this.state.isExpanded && !this.state.isAccepted && this.props.config.collapseEvent.acceptButton) {
          moduleHeight = screenHeight;
        }
      }
      if (moduleHeight != this.state.moduleHeight) {
        this.setState({
          moduleHeight: moduleHeight
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (!this.state.isVisible || !this.state.content || this.state.content.length == 0) {
        return false;
      }

      var moduleProps = {
        className: (0, _classnames2.default)({
          "isi-module": true,
          "expanded": this.state.isExpanded,
          "inPage": !this.props.isSticky,
          "hidden": !this.state.isVisible && !this.props.isInline
        }),
        style: {
          "height": this.state.moduleHeight
        }
      };

      var content = _utils2.default.getDangerousHtml(this.state.content);
      var renderToggleButton = !this.props.isInline;
      var acceptButton = this.props.config.collapseEvent.acceptButton;

      var toggleProps = {
        render: renderToggleButton,
        showAcceptButton: this.props.isSticky && acceptButton ? acceptButton && !this.state.isAccepted : false,
        isExpanded: this.state.isExpanded,
        onClick: function onClick(e) {
          e.preventDefault();
          clearTimeout(_this3.collapseTime);
          if (_this3.props.isSticky && acceptButton && !_this3.state.isAccepted) {
            _actions2.default.accept();
          } else {
            _actions2.default.toggle();
          }
        }

      };

      return _react2.default.createElement(
        'div',
        moduleProps,
        _react2.default.createElement(
          'div',
          { className: 'header-container' },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h3',
              null,
              this.props.config.header
            ),
            _react2.default.createElement(_toggleButton2.default, toggleProps)
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'content-container' },
          _react2.default.createElement(
            'div',
            { className: 'content-scroll-area' },
            _react2.default.createElement('div', { className: 'container content', dangerouslySetInnerHTML: content })
          )
        )
      );
    }
  }]);

  return ISI;
}(_reflux2.default.Component);

exports.default = ISI;


ISI.propTypes = {
  config: _react2.default.PropTypes.object,
  isInline: _react2.default.PropTypes.bool,
  isExpanded: _react2.default.PropTypes.bool,
  isSticky: _react2.default.PropTypes.bool
};
ISI.defaultProps = {
  isExpanded: false,
  isInline: true,
  isSticky: false
};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _helpers = __webpack_require__(30);

var _helpers2 = _interopRequireDefault(_helpers);

var _reactBurgerMenu = __webpack_require__(268);

var _store = __webpack_require__(206);

var _store2 = _interopRequireDefault(_store);

var _actions = __webpack_require__(135);

var _actions2 = _interopRequireDefault(_actions);

var _navMenu = __webpack_require__(65);

var _navMenu2 = _interopRequireDefault(_navMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SideMenu = function (_Reflux$Component) {
    _inherits(SideMenu, _Reflux$Component);

    function SideMenu(props) {
        _classCallCheck(this, SideMenu);

        var _this = _possibleConstructorReturn(this, (SideMenu.__proto__ || Object.getPrototypeOf(SideMenu)).call(this, props));

        _this.state = {};
        _this.store = _store2.default;
        _this.settings = props.navigation.mobile;
        return _this;
    }

    _createClass(SideMenu, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            //let $this = $(ReactDOM.findDOMNode(this));
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.state.isOpen) {
                _helpers2.default.lockScroll('mobile-menu');
            } else {
                _helpers2.default.unlockScroll('mobile-menu');
            }
        }
    }, {
        key: 'toggle',
        value: function toggle(state) {
            if (state.isOpen != this.state.isOpen) {
                _actions2.default.toggle();
            }
        }
    }, {
        key: 'doItemClick',
        value: function doItemClick(navItem) {
            var itemModule = navItem.props.item.module;
            if (navItem.props.item.submenu != null && navItem.props.item.submenu.length > 0) {
                if (!navItem.state.isExpanded) {
                    this.expandedSubmenu = navItem;
                }
                navItem.setState({
                    isExpanded: !navItem.state.isExpanded
                });
            } else if (this.state.isOpen && (itemModule == "RouterLink" || itemModule == "IsiLink" || itemModule === "default")) {
                _actions2.default.toggle();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var navItems = this.props.navigation.links;
            var _class = (0, _classnames2.default)({
                'menu-container': true,
                'position-right': this.settings.position == 'right'
            });
            var NavMenuProps = {
                items: navItems,
                settings: this.settings,
                route: this.props.route,
                isSubmenu: false,
                onItemClick: this.doItemClick.bind(this)
            };
            var MenuProps = {
                isOpen: this.state.isOpen,
                customBurgorIcon: false,
                right: this.settings.position == "right",
                onStateChange: this.toggle.bind(this)
            };
            return _react2.default.createElement(
                'div',
                { id: 'side-menu' },
                _react2.default.createElement(
                    _reactBurgerMenu.slide,
                    MenuProps,
                    _react2.default.createElement(_navMenu2.default, NavMenuProps)
                )
            );
        }
    }]);

    return SideMenu;
}(_reflux2.default.Component);

exports.default = SideMenu;

SideMenu.propTypes = {
    "navigation": _react2.default.PropTypes.object.isRequired,
    "route": _react2.default.PropTypes.object.isRequired
};
SideMenu.defaultProps = {};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(38);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(24);
var toAbsoluteIndex = __webpack_require__(74);
var toLength = __webpack_require__(22);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(67);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(27);
var toObject = __webpack_require__(24);
var IObject = __webpack_require__(93);
var toLength = __webpack_require__(22);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(27);
var isObject = __webpack_require__(12);
var invoke = __webpack_require__(221);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(21).f;
var create = __webpack_require__(68);
var redefineAll = __webpack_require__(72);
var ctx = __webpack_require__(40);
var anInstance = __webpack_require__(66);
var forOf = __webpack_require__(67);
var $iterDefine = __webpack_require__(148);
var step = __webpack_require__(224);
var setSpecies = __webpack_require__(73);
var DESCRIPTORS = __webpack_require__(20);
var fastKey = __webpack_require__(60).fastKey;
var validate = __webpack_require__(82);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(92);
var from = __webpack_require__(213);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(72);
var getWeak = __webpack_require__(60).getWeak;
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(12);
var anInstance = __webpack_require__(66);
var forOf = __webpack_require__(67);
var createArrayMethod = __webpack_require__(44);
var $has = __webpack_require__(34);
var validate = __webpack_require__(82);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(108);
var isObject = __webpack_require__(12);
var toLength = __webpack_require__(22);
var ctx = __webpack_require__(40);
var IS_CONCAT_SPREADABLE = __webpack_require__(17)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(20) && !__webpack_require__(11)(function () {
  return Object.defineProperty(__webpack_require__(141)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 221 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(12);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(8);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(150);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 226 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 227 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(70);
var gOPS = __webpack_require__(112);
var pIE = __webpack_require__(94);
var toObject = __webpack_require__(24);
var IObject = __webpack_require__(93);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(11)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(21);
var anObject = __webpack_require__(8);
var getKeys = __webpack_require__(70);

module.exports = __webpack_require__(20) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(37);
var gOPN = __webpack_require__(69).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(34);
var toIObject = __webpack_require__(37);
var arrayIndexOf = __webpack_require__(104)(false);
var IE_PROTO = __webpack_require__(154)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(70);
var toIObject = __webpack_require__(37);
var isEnum = __webpack_require__(94).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(69);
var gOPS = __webpack_require__(112);
var anObject = __webpack_require__(8);
var Reflect = __webpack_require__(9).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(9).parseFloat;
var $trim = __webpack_require__(81).trim;

module.exports = 1 / $parseFloat(__webpack_require__(158) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(9).parseInt;
var $trim = __webpack_require__(81).trim;
var ws = __webpack_require__(158);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var isObject = __webpack_require__(12);
var newPromiseCapability = __webpack_require__(152);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(22);
var repeat = __webpack_require__(157);
var defined = __webpack_require__(45);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(47);
var toLength = __webpack_require__(22);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(17);


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(216);
var validate = __webpack_require__(82);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(105)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(20) && /./g.flags != 'g') __webpack_require__(21).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(107)
});


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(216);
var validate = __webpack_require__(82);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(105)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(44)(0);
var redefine = __webpack_require__(32);
var meta = __webpack_require__(60);
var assign = __webpack_require__(228);
var weak = __webpack_require__(218);
var isObject = __webpack_require__(12);
var fails = __webpack_require__(11);
var validate = __webpack_require__(82);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(105)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 245 */
/***/ (function(module, exports) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(19);

var emptyObject = __webpack_require__(119);
var _invariant = __webpack_require__(7);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(246);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(49);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(6);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(25);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(26);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(28);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-up', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'up');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '7.086 1.174 17.086 11.174 7.086 21.174', transform: 'rotate(-89 12.086 11.174)' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Up';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = { "Webkit": { "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "backfaceVisibility": true, "perspective": true, "perspectiveOrigin": true, "transformStyle": true, "transformOriginZ": true, "animation": true, "animationDelay": true, "animationDirection": true, "animationFillMode": true, "animationDuration": true, "animationIterationCount": true, "animationName": true, "animationPlayState": true, "animationTimingFunction": true, "appearance": true, "userSelect": true, "fontKerning": true, "textEmphasisPosition": true, "textEmphasis": true, "textEmphasisStyle": true, "textEmphasisColor": true, "boxDecorationBreak": true, "clipPath": true, "maskImage": true, "maskMode": true, "maskRepeat": true, "maskPosition": true, "maskClip": true, "maskOrigin": true, "maskSize": true, "maskComposite": true, "mask": true, "maskBorderSource": true, "maskBorderMode": true, "maskBorderSlice": true, "maskBorderWidth": true, "maskBorderOutset": true, "maskBorderRepeat": true, "maskBorder": true, "maskType": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "filter": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true, "flex": true, "flexBasis": true, "flexDirection": true, "flexGrow": true, "flexFlow": true, "flexShrink": true, "flexWrap": true, "alignContent": true, "alignItems": true, "alignSelf": true, "justifyContent": true, "order": true, "transition": true, "transitionDelay": true, "transitionDuration": true, "transitionProperty": true, "transitionTimingFunction": true, "backdropFilter": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "shapeImageThreshold": true, "shapeImageMargin": true, "shapeImageOutside": true, "hyphens": true, "flowInto": true, "flowFrom": true, "regionFragment": true, "textSizeAdjust": true, "borderImage": true, "borderImageOutset": true, "borderImageRepeat": true, "borderImageSlice": true, "borderImageSource": true, "borderImageWidth": true, "tabSize": true, "objectFit": true, "objectPosition": true }, "Moz": { "appearance": true, "userSelect": true, "boxSizing": true, "textAlignLast": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "tabSize": true, "hyphens": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true }, "ms": { "flex": true, "flexBasis": false, "flexDirection": true, "flexGrow": false, "flexFlow": true, "flexShrink": false, "flexWrap": true, "alignContent": false, "alignItems": false, "alignSelf": false, "justifyContent": false, "order": false, "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "userSelect": true, "wrapFlow": true, "wrapThrough": true, "wrapMargin": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "touchAction": true, "hyphens": true, "flowInto": true, "flowFrom": true, "breakBefore": true, "breakAfter": true, "breakInside": true, "regionFragment": true, "gridTemplateColumns": true, "gridTemplateRows": true, "gridTemplateAreas": true, "gridTemplate": true, "gridAutoColumns": true, "gridAutoRows": true, "gridAutoFlow": true, "grid": true, "gridRowStart": true, "gridColumnStart": true, "gridRowEnd": true, "gridRow": true, "gridColumn": true, "gridColumnEnd": true, "gridColumnGap": true, "gridRowGap": true, "gridArea": true, "gridGap": true, "textSizeAdjust": true } };
module.exports = exports["default"];

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// helper to capitalize strings


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

module.exports = exports["default"];

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// helper to capitalize strings


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

module.exports = exports["default"];

/***/ }),
/* 256 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(715)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(718);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = appendPxIfNeeded;


// Copied from https://github.com/facebook/react/blob/
// 102cd291899f9942a76c40a0e78920a6fe544dc1/
// src/renderers/dom/shared/CSSProperty.js
var isUnitlessNumber = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

function appendPxIfNeeded(propertyName, value) {
  var needsPxSuffix = !isUnitlessNumber[propertyName] && typeof value === 'number' && value !== 0;
  return needsPxSuffix ? value + 'px' : value;
}
module.exports = exports['default'];

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = enhanceWithRadium;

var _react = __webpack_require__(0);

var _styleKeeper = __webpack_require__(173);

var _styleKeeper2 = _interopRequireDefault(_styleKeeper);

var _resolveStyles = __webpack_require__(267);

var _resolveStyles2 = _interopRequireDefault(_resolveStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEYS_TO_IGNORE_WHEN_COPYING_PROPERTIES = ['arguments', 'callee', 'caller', 'length', 'name', 'prototype', 'type'];

function copyProperties(source, target) {
  Object.getOwnPropertyNames(source).forEach(function (key) {
    if (KEYS_TO_IGNORE_WHEN_COPYING_PROPERTIES.indexOf(key) < 0 && !target.hasOwnProperty(key)) {
      var descriptor = Object.getOwnPropertyDescriptor(source, key);
      Object.defineProperty(target, key, descriptor);
    }
  });
}

function isStateless(component) {
  return !component.render && !(component.prototype && component.prototype.render);
}

function enhanceWithRadium(configOrComposedComponent) {
  var _class, _temp;

  var config = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  if (typeof configOrComposedComponent !== 'function') {
    var _ret = function () {
      var newConfig = _extends({}, config, configOrComposedComponent);
      return {
        v: function v(configOrComponent) {
          return enhanceWithRadium(configOrComponent, newConfig);
        }
      };
    }();

    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
  }

  var component = configOrComposedComponent;
  var ComposedComponent = component;

  // Handle stateless components
  if (isStateless(ComposedComponent)) {
    ComposedComponent = function (_Component) {
      _inherits(ComposedComponent, _Component);

      function ComposedComponent() {
        _classCallCheck(this, ComposedComponent);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ComposedComponent.prototype.render = function render() {
        return component(this.props, this.context);
      };

      return ComposedComponent;
    }(_react.Component);
    ComposedComponent.displayName = component.displayName || component.name;
  }

  var RadiumEnhancer = (_temp = _class = function (_ComposedComponent) {
    _inherits(RadiumEnhancer, _ComposedComponent);

    function RadiumEnhancer() {
      _classCallCheck(this, RadiumEnhancer);

      var _this2 = _possibleConstructorReturn(this, _ComposedComponent.apply(this, arguments));

      _this2.state = _this2.state || {};
      _this2.state._radiumStyleState = {};
      _this2._radiumIsMounted = true;
      return _this2;
    }

    RadiumEnhancer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (_ComposedComponent.prototype.componentWillUnmount) {
        _ComposedComponent.prototype.componentWillUnmount.call(this);
      }

      this._radiumIsMounted = false;

      if (this._radiumMouseUpListener) {
        this._radiumMouseUpListener.remove();
      }

      if (this._radiumMediaQueryListenersByQuery) {
        Object.keys(this._radiumMediaQueryListenersByQuery).forEach(function (query) {
          this._radiumMediaQueryListenersByQuery[query].remove();
        }, this);
      }
    };

    RadiumEnhancer.prototype.getChildContext = function getChildContext() {
      var superChildContext = _ComposedComponent.prototype.getChildContext ? _ComposedComponent.prototype.getChildContext.call(this) : {};

      if (!this.props.radiumConfig) {
        return superChildContext;
      }

      var newContext = _extends({}, superChildContext);

      if (this.props.radiumConfig) {
        newContext._radiumConfig = this.props.radiumConfig;
      }

      return newContext;
    };

    RadiumEnhancer.prototype.render = function render() {
      var renderedElement = _ComposedComponent.prototype.render.call(this);
      var currentConfig = this.props.radiumConfig || this.context._radiumConfig || config;

      if (config && currentConfig !== config) {
        currentConfig = _extends({}, config, currentConfig);
      }

      return (0, _resolveStyles2.default)(this, renderedElement, currentConfig);
    };

    return RadiumEnhancer;
  }(ComposedComponent), _class._isRadiumEnhanced = true, _temp);

  // Class inheritance uses Object.create and because of __proto__ issues
  // with IE <10 any static properties of the superclass aren't inherited and
  // so need to be manually populated.
  // See http://babeljs.io/docs/advanced/caveats/#classes-10-and-below-

  copyProperties(component, RadiumEnhancer);

  if (false) {
    // This also fixes React Hot Loader by exposing the original components top
    // level prototype methods on the Radium enhanced prototype as discussed in
    // https://github.com/FormidableLabs/radium/issues/219.
    copyProperties(ComposedComponent.prototype, RadiumEnhancer.prototype);
  }

  if (RadiumEnhancer.propTypes && RadiumEnhancer.propTypes.style) {
    RadiumEnhancer.propTypes = _extends({}, RadiumEnhancer.propTypes, {
      style: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.object])
    });
  }

  RadiumEnhancer.displayName = component.displayName || component.name || 'Component';

  RadiumEnhancer.contextTypes = _extends({}, RadiumEnhancer.contextTypes, {
    _radiumConfig: _react.PropTypes.object,
    _radiumStyleKeeper: _react.PropTypes.instanceOf(_styleKeeper2.default)
  });

  RadiumEnhancer.childContextTypes = _extends({}, RadiumEnhancer.childContextTypes, {
    _radiumConfig: _react.PropTypes.object,
    _radiumStyleKeeper: _react.PropTypes.instanceOf(_styleKeeper2.default)
  });

  return RadiumEnhancer;
}
module.exports = exports['default'];

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var getStateKey = function getStateKey(elementKey) {
  return elementKey === null || elementKey === undefined ? 'main' : elementKey.toString();
};

exports.default = getStateKey;
module.exports = exports['default'];

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getStateKey = __webpack_require__(262);

var _getStateKey2 = _interopRequireDefault(_getStateKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getState = function getState(state, elementKey, value) {
  var key = (0, _getStateKey2.default)(elementKey);

  return !!state && !!state._radiumStyleState && !!state._radiumStyleState[key] && state._radiumStyleState[key][value];
};

exports.default = getState;
module.exports = exports['default'];

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hash;


// a simple djb2 hash based on hash-string:
// https://github.com/MatthewBarker/hash-string/blob/master/source/hash-string.js
// returns a hex-encoded hash
function hash(text) {
  if (!text) {
    return '';
  }

  var hashValue = 5381;
  var index = text.length - 1;

  while (index) {
    hashValue = hashValue * 33 ^ text.charCodeAt(index);
    index -= 1;
  }

  return (hashValue >>> 0).toString(16);
}
module.exports = exports['default'];

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mapObject;
function mapObject(object, mapper) {
  return Object.keys(object).reduce(function (result, key) {
    result[key] = mapper(object[key], key);
    return result;
  }, {});
}
module.exports = exports["default"];

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checkPropsPlugin = __webpack_require__(726);

var _checkPropsPlugin2 = _interopRequireDefault(_checkPropsPlugin);

var _keyframesPlugin = __webpack_require__(727);

var _keyframesPlugin2 = _interopRequireDefault(_keyframesPlugin);

var _mergeStyleArrayPlugin = __webpack_require__(728);

var _mergeStyleArrayPlugin2 = _interopRequireDefault(_mergeStyleArrayPlugin);

var _prefixPlugin = __webpack_require__(730);

var _prefixPlugin2 = _interopRequireDefault(_prefixPlugin);

var _removeNestedStylesPlugin = __webpack_require__(731);

var _removeNestedStylesPlugin2 = _interopRequireDefault(_removeNestedStylesPlugin);

var _resolveInteractionStylesPlugin = __webpack_require__(732);

var _resolveInteractionStylesPlugin2 = _interopRequireDefault(_resolveInteractionStylesPlugin);

var _resolveMediaQueriesPlugin = __webpack_require__(733);

var _resolveMediaQueriesPlugin2 = _interopRequireDefault(_resolveMediaQueriesPlugin);

var _visitedPlugin = __webpack_require__(734);

var _visitedPlugin2 = _interopRequireDefault(_visitedPlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  checkProps: _checkPropsPlugin2.default,
  keyframes: _keyframesPlugin2.default,
  mergeStyleArray: _mergeStyleArrayPlugin2.default,
  prefix: _prefixPlugin2.default,
  removeNestedStyles: _removeNestedStylesPlugin2.default,
  resolveInteractionStyles: _resolveInteractionStylesPlugin2.default,
  resolveMediaQueries: _resolveMediaQueriesPlugin2.default,
  visited: _visitedPlugin2.default
};
/* eslint-disable block-scoped-const */

module.exports = exports['default'];

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _appendImportantToEachValue = __webpack_require__(719);

var _appendImportantToEachValue2 = _interopRequireDefault(_appendImportantToEachValue);

var _cssRuleSetToString = __webpack_require__(170);

var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);

var _getState = __webpack_require__(263);

var _getState2 = _interopRequireDefault(_getState);

var _getStateKey = __webpack_require__(262);

var _getStateKey2 = _interopRequireDefault(_getStateKey);

var _hash = __webpack_require__(264);

var _hash2 = _interopRequireDefault(_hash);

var _mergeStyles = __webpack_require__(725);

var _plugins = __webpack_require__(266);

var _plugins2 = _interopRequireDefault(_plugins);

var _exenv = __webpack_require__(658);

var _exenv2 = _interopRequireDefault(_exenv);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_CONFIG = {
  plugins: [_plugins2.default.mergeStyleArray, _plugins2.default.checkProps, _plugins2.default.resolveMediaQueries, _plugins2.default.resolveInteractionStyles, _plugins2.default.keyframes, _plugins2.default.visited, _plugins2.default.removeNestedStyles, _plugins2.default.prefix, _plugins2.default.checkProps]
};

// Gross
var globalState = {};

// Declare early for recursive helpers.
var resolveStyles = null;

var _shouldResolveStyles = function _shouldResolveStyles(component) {
  return component.type && !component.type._isRadiumEnhanced;
};

var _resolveChildren = function _resolveChildren(_ref) {
  var children = _ref.children;
  var component = _ref.component;
  var config = _ref.config;
  var existingKeyMap = _ref.existingKeyMap;

  if (!children) {
    return children;
  }

  var childrenType = typeof children === 'undefined' ? 'undefined' : _typeof(children);

  if (childrenType === 'string' || childrenType === 'number') {
    // Don't do anything with a single primitive child
    return children;
  }

  if (childrenType === 'function') {
    // Wrap the function, resolving styles on the result
    return function () {
      var result = children.apply(this, arguments);
      if (_react2.default.isValidElement(result)) {
        return resolveStyles(component, result, config, existingKeyMap, true);
      }
      return result;
    };
  }

  if (_react2.default.Children.count(children) === 1 && children.type) {
    // If a React Element is an only child, don't wrap it in an array for
    // React.Children.map() for React.Children.only() compatibility.
    var onlyChild = _react2.default.Children.only(children);
    return resolveStyles(component, onlyChild, config, existingKeyMap, true);
  }

  return _react2.default.Children.map(children, function (child) {
    if (_react2.default.isValidElement(child)) {
      return resolveStyles(component, child, config, existingKeyMap, true);
    }

    return child;
  });
};

// Recurse over props, just like children
var _resolveProps = function _resolveProps(_ref2) {
  var component = _ref2.component;
  var config = _ref2.config;
  var existingKeyMap = _ref2.existingKeyMap;
  var props = _ref2.props;

  var newProps = props;

  Object.keys(props).forEach(function (prop) {
    // We already recurse over children above
    if (prop === 'children') {
      return;
    }

    var propValue = props[prop];
    if (_react2.default.isValidElement(propValue)) {
      newProps = _extends({}, newProps);
      newProps[prop] = resolveStyles(component, propValue, config, existingKeyMap, true);
    }
  });

  return newProps;
};

var _buildGetKey = function _buildGetKey(_ref3) {
  var componentName = _ref3.componentName;
  var existingKeyMap = _ref3.existingKeyMap;
  var renderedElement = _ref3.renderedElement;

  // We need a unique key to correlate state changes due to user interaction
  // with the rendered element, so we know to apply the proper interactive
  // styles.
  var originalKey = typeof renderedElement.ref === 'string' ? renderedElement.ref : renderedElement.key;
  var key = (0, _getStateKey2.default)(originalKey);

  var alreadyGotKey = false;
  var getKey = function getKey() {
    if (alreadyGotKey) {
      return key;
    }

    alreadyGotKey = true;

    if (existingKeyMap[key]) {
      var elementName = void 0;
      if (typeof renderedElement.type === 'string') {
        elementName = renderedElement.type;
      } else if (renderedElement.type.constructor) {
        elementName = renderedElement.type.constructor.displayName || renderedElement.type.constructor.name;
      }

      throw new Error('Radium requires each element with interactive styles to have a unique ' + 'key, set using either the ref or key prop. ' + (originalKey ? 'Key "' + originalKey + '" is a duplicate.' : 'Multiple elements have no key specified.') + ' ' + 'Component: "' + componentName + '". ' + (elementName ? 'Element: "' + elementName + '".' : ''));
    }

    existingKeyMap[key] = true;

    return key;
  };

  return getKey;
};

var _setStyleState = function _setStyleState(component, key, stateKey, value) {
  if (!component._radiumIsMounted) {
    return;
  }

  var existing = component._lastRadiumState || component.state && component.state._radiumStyleState || {};

  var state = { _radiumStyleState: _extends({}, existing) };
  state._radiumStyleState[key] = _extends({}, state._radiumStyleState[key]);
  state._radiumStyleState[key][stateKey] = value;

  component._lastRadiumState = state._radiumStyleState;
  component.setState(state);
};

var _runPlugins = function _runPlugins(_ref4) {
  var component = _ref4.component;
  var config = _ref4.config;
  var existingKeyMap = _ref4.existingKeyMap;
  var props = _ref4.props;
  var renderedElement = _ref4.renderedElement;

  // Don't run plugins if renderedElement is not a simple ReactDOMElement or has
  // no style.
  if (!_react2.default.isValidElement(renderedElement) || typeof renderedElement.type !== 'string' || !props.style) {
    return props;
  }

  var newProps = props;

  var plugins = config.plugins || DEFAULT_CONFIG.plugins;

  var componentName = component.constructor.displayName || component.constructor.name;
  var getKey = _buildGetKey({ renderedElement: renderedElement, existingKeyMap: existingKeyMap, componentName: componentName });
  var getComponentField = function getComponentField(key) {
    return component[key];
  };
  var getGlobalState = function getGlobalState(key) {
    return globalState[key];
  };
  var componentGetState = function componentGetState(stateKey, elementKey) {
    return (0, _getState2.default)(component.state, elementKey || getKey(), stateKey);
  };
  var setState = function setState(stateKey, value, elementKey) {
    return _setStyleState(component, elementKey || getKey(), stateKey, value);
  };

  var addCSS = function addCSS(css) {
    var styleKeeper = component._radiumStyleKeeper || component.context._radiumStyleKeeper;
    if (!styleKeeper) {
      if (__isTestModeEnabled) {
        return {
          remove: function remove() {}
        };
      }

      throw new Error('To use plugins requiring `addCSS` (e.g. keyframes, media queries), ' + 'please wrap your application in the StyleRoot component. Component ' + 'name: `' + componentName + '`.');
    }

    return styleKeeper.addCSS(css);
  };

  var newStyle = props.style;

  plugins.forEach(function (plugin) {
    var result = plugin({
      ExecutionEnvironment: _exenv2.default,
      addCSS: addCSS,
      appendImportantToEachValue: _appendImportantToEachValue2.default,
      componentName: componentName,
      config: config,
      cssRuleSetToString: _cssRuleSetToString2.default,
      getComponentField: getComponentField,
      getGlobalState: getGlobalState,
      getState: componentGetState,
      hash: _hash2.default,
      mergeStyles: _mergeStyles.mergeStyles,
      props: newProps,
      setState: setState,
      isNestedStyle: _mergeStyles.isNestedStyle,
      style: newStyle
    }) || {};

    newStyle = result.style || newStyle;

    newProps = result.props && Object.keys(result.props).length ? _extends({}, newProps, result.props) : newProps;

    var newComponentFields = result.componentFields || {};
    Object.keys(newComponentFields).forEach(function (fieldName) {
      component[fieldName] = newComponentFields[fieldName];
    });

    var newGlobalState = result.globalState || {};
    Object.keys(newGlobalState).forEach(function (key) {
      globalState[key] = newGlobalState[key];
    });
  });

  if (newStyle !== props.style) {
    newProps = _extends({}, newProps, { style: newStyle });
  }

  return newProps;
};

// Wrapper around React.cloneElement. To avoid processing the same element
// twice, whenever we clone an element add a special prop to make sure we don't
// process this element again.
var _cloneElement = function _cloneElement(renderedElement, newProps, newChildren) {
  // Only add flag if this is a normal DOM element
  if (typeof renderedElement.type === 'string') {
    newProps = _extends({}, newProps, { 'data-radium': true });
  }

  return _react2.default.cloneElement(renderedElement, newProps, newChildren);
};

//
// The nucleus of Radium. resolveStyles is called on the rendered elements
// before they are returned in render. It iterates over the elements and
// children, rewriting props to add event handlers required to capture user
// interactions (e.g. mouse over). It also replaces the style prop because it
// adds in the various interaction styles (e.g. :hover).
//
resolveStyles = function resolveStyles(component, // ReactComponent, flow+eslint complaining
renderedElement) {
  var config = arguments.length <= 2 || arguments[2] === undefined ? DEFAULT_CONFIG : arguments[2];
  var existingKeyMap = arguments[3];
  var shouldCheckBeforeResolve = arguments.length <= 4 || arguments[4] === undefined ? false : arguments[4];
  // ReactElement
  existingKeyMap = existingKeyMap || {};
  if (!renderedElement ||
  // Bail if we've already processed this element. This ensures that only the
  // owner of an element processes that element, since the owner's render
  // function will be called first (which will always be the case, since you
  // can't know what else to render until you render the parent component).
  renderedElement.props && renderedElement.props['data-radium'] ||

  // Bail if this element is a radium enhanced element, because if it is,
  // then it will take care of resolving its own styles.
  shouldCheckBeforeResolve && !_shouldResolveStyles(renderedElement)) {
    return renderedElement;
  }

  var newChildren = _resolveChildren({
    children: renderedElement.props.children,
    component: component,
    config: config,
    existingKeyMap: existingKeyMap
  });

  var newProps = _resolveProps({
    component: component,
    config: config,
    existingKeyMap: existingKeyMap,
    props: renderedElement.props
  });

  newProps = _runPlugins({
    component: component,
    config: config,
    existingKeyMap: existingKeyMap,
    props: newProps,
    renderedElement: renderedElement
  });

  // If nothing changed, don't bother cloning the element. Might be a bit
  // wasteful, as we add the sentinal to stop double-processing when we clone.
  // Assume benign double-processing is better than unneeded cloning.
  if (newChildren === renderedElement.props.children && newProps === renderedElement.props) {
    return renderedElement;
  }

  return _cloneElement(renderedElement, newProps !== renderedElement.props ? newProps : {}, newChildren);
};

// Only for use by tests
var __isTestModeEnabled = false;
if (false) {
  resolveStyles.__clearStateForTests = function () {
    globalState = {};
  };
  resolveStyles.__setTestMode = function (isEnabled) {
    __isTestModeEnabled = isEnabled;
  };
}

exports.default = resolveStyles;
module.exports = exports['default'];

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = {
  slide: __webpack_require__(747),
  stack: __webpack_require__(748),
  elastic: __webpack_require__(741),
  bubble: __webpack_require__(740),
  push: __webpack_require__(743),
  pushRotate: __webpack_require__(744),
  scaleDown: __webpack_require__(745),
  scaleRotate: __webpack_require__(746),
  fallDown: __webpack_require__(742)
};
module.exports = exports['default'];

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function () {
  var Snap = undefined;
  try {
    Snap = __webpack_require__(864);
  } finally {
    return Snap;
  }
};

module.exports = exports['default'];

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function(f) {
  if (true) {
    module.exports = f(__webpack_require__(0));
    /* global define */
  } else if (typeof define === 'function' && define.amd) {
    define(['react'], f);
  } else {
    var g;
    if (typeof window !== 'undefined') {
      g = window;
    } else if (typeof global !== 'undefined') {
      g = global;
    } else if (typeof self !== 'undefined') {
      g = self;
    } else {
      g = this;
    }

    if (typeof g.React === 'undefined') {
      throw Error('React module should be required before ReactDOMFactories');
    }

    g.ReactDOMFactories = f(g.React);
  }
})(function(React) {
  /**
   * Create a factory that creates HTML tag elements.
   */
  function createDOMFactory(type) {
    var factory = React.createElement.bind(null, type);
    // Expose the type on the factory and the prototype so that it can be
    // easily accessed on elements. E.g. `<Foo />.type === Foo`.
    // This should not be named `constructor` since this may not be the function
    // that created the element, and it may not even be a constructor.
    factory.type = type;
    return factory;
  };

  /**
   * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
   */
  var ReactDOMFactories = {
    a: createDOMFactory('a'),
    abbr: createDOMFactory('abbr'),
    address: createDOMFactory('address'),
    area: createDOMFactory('area'),
    article: createDOMFactory('article'),
    aside: createDOMFactory('aside'),
    audio: createDOMFactory('audio'),
    b: createDOMFactory('b'),
    base: createDOMFactory('base'),
    bdi: createDOMFactory('bdi'),
    bdo: createDOMFactory('bdo'),
    big: createDOMFactory('big'),
    blockquote: createDOMFactory('blockquote'),
    body: createDOMFactory('body'),
    br: createDOMFactory('br'),
    button: createDOMFactory('button'),
    canvas: createDOMFactory('canvas'),
    caption: createDOMFactory('caption'),
    cite: createDOMFactory('cite'),
    code: createDOMFactory('code'),
    col: createDOMFactory('col'),
    colgroup: createDOMFactory('colgroup'),
    data: createDOMFactory('data'),
    datalist: createDOMFactory('datalist'),
    dd: createDOMFactory('dd'),
    del: createDOMFactory('del'),
    details: createDOMFactory('details'),
    dfn: createDOMFactory('dfn'),
    dialog: createDOMFactory('dialog'),
    div: createDOMFactory('div'),
    dl: createDOMFactory('dl'),
    dt: createDOMFactory('dt'),
    em: createDOMFactory('em'),
    embed: createDOMFactory('embed'),
    fieldset: createDOMFactory('fieldset'),
    figcaption: createDOMFactory('figcaption'),
    figure: createDOMFactory('figure'),
    footer: createDOMFactory('footer'),
    form: createDOMFactory('form'),
    h1: createDOMFactory('h1'),
    h2: createDOMFactory('h2'),
    h3: createDOMFactory('h3'),
    h4: createDOMFactory('h4'),
    h5: createDOMFactory('h5'),
    h6: createDOMFactory('h6'),
    head: createDOMFactory('head'),
    header: createDOMFactory('header'),
    hgroup: createDOMFactory('hgroup'),
    hr: createDOMFactory('hr'),
    html: createDOMFactory('html'),
    i: createDOMFactory('i'),
    iframe: createDOMFactory('iframe'),
    img: createDOMFactory('img'),
    input: createDOMFactory('input'),
    ins: createDOMFactory('ins'),
    kbd: createDOMFactory('kbd'),
    keygen: createDOMFactory('keygen'),
    label: createDOMFactory('label'),
    legend: createDOMFactory('legend'),
    li: createDOMFactory('li'),
    link: createDOMFactory('link'),
    main: createDOMFactory('main'),
    map: createDOMFactory('map'),
    mark: createDOMFactory('mark'),
    menu: createDOMFactory('menu'),
    menuitem: createDOMFactory('menuitem'),
    meta: createDOMFactory('meta'),
    meter: createDOMFactory('meter'),
    nav: createDOMFactory('nav'),
    noscript: createDOMFactory('noscript'),
    object: createDOMFactory('object'),
    ol: createDOMFactory('ol'),
    optgroup: createDOMFactory('optgroup'),
    option: createDOMFactory('option'),
    output: createDOMFactory('output'),
    p: createDOMFactory('p'),
    param: createDOMFactory('param'),
    picture: createDOMFactory('picture'),
    pre: createDOMFactory('pre'),
    progress: createDOMFactory('progress'),
    q: createDOMFactory('q'),
    rp: createDOMFactory('rp'),
    rt: createDOMFactory('rt'),
    ruby: createDOMFactory('ruby'),
    s: createDOMFactory('s'),
    samp: createDOMFactory('samp'),
    script: createDOMFactory('script'),
    section: createDOMFactory('section'),
    select: createDOMFactory('select'),
    small: createDOMFactory('small'),
    source: createDOMFactory('source'),
    span: createDOMFactory('span'),
    strong: createDOMFactory('strong'),
    style: createDOMFactory('style'),
    sub: createDOMFactory('sub'),
    summary: createDOMFactory('summary'),
    sup: createDOMFactory('sup'),
    table: createDOMFactory('table'),
    tbody: createDOMFactory('tbody'),
    td: createDOMFactory('td'),
    textarea: createDOMFactory('textarea'),
    tfoot: createDOMFactory('tfoot'),
    th: createDOMFactory('th'),
    thead: createDOMFactory('thead'),
    time: createDOMFactory('time'),
    title: createDOMFactory('title'),
    tr: createDOMFactory('tr'),
    track: createDOMFactory('track'),
    u: createDOMFactory('u'),
    ul: createDOMFactory('ul'),
    var: createDOMFactory('var'),
    video: createDOMFactory('video'),
    wbr: createDOMFactory('wbr'),

    // SVG
    circle: createDOMFactory('circle'),
    clipPath: createDOMFactory('clipPath'),
    defs: createDOMFactory('defs'),
    ellipse: createDOMFactory('ellipse'),
    g: createDOMFactory('g'),
    image: createDOMFactory('image'),
    line: createDOMFactory('line'),
    linearGradient: createDOMFactory('linearGradient'),
    mask: createDOMFactory('mask'),
    path: createDOMFactory('path'),
    pattern: createDOMFactory('pattern'),
    polygon: createDOMFactory('polygon'),
    polyline: createDOMFactory('polyline'),
    radialGradient: createDOMFactory('radialGradient'),
    rect: createDOMFactory('rect'),
    stop: createDOMFactory('stop'),
    svg: createDOMFactory('svg'),
    text: createDOMFactory('text'),
    tspan: createDOMFactory('tspan'),
  };

  // due to wrapper and conditionals at the top, this will either become
  // `module.exports ReactDOMFactories` if that is available,
  // otherwise it will be defined via `define(['react'], ReactDOMFactories)`
  // if that is available,
  // otherwise it will be defined as global variable.
  return ReactDOMFactories;
});



/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(13);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(77);

var invariant = __webpack_require__(7);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(85);
var ReactDOMComponentTree = __webpack_require__(23);
var ReactInstrumentation = __webpack_require__(43);

var quoteAttributeValueForBrowser = __webpack_require__(810);
var warning = __webpack_require__(14);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(19);

var LinkedValueUtils = __webpack_require__(179);
var ReactDOMComponentTree = __webpack_require__(23);
var ReactUpdates = __webpack_require__(50);

var warning = __webpack_require__(14);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var invariant = __webpack_require__(7);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMSelection = __webpack_require__(770);

var containsNode = __webpack_require__(661);
var focusNode = __webpack_require__(249);
var getActiveElement = __webpack_require__(250);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var DOMLazyTree = __webpack_require__(84);
var DOMProperty = __webpack_require__(85);
var React = __webpack_require__(87);
var ReactBrowserEventEmitter = __webpack_require__(126);
var ReactCurrentOwner = __webpack_require__(57);
var ReactDOMComponentTree = __webpack_require__(23);
var ReactDOMContainerInfo = __webpack_require__(764);
var ReactDOMFeatureFlags = __webpack_require__(766);
var ReactFeatureFlags = __webpack_require__(277);
var ReactInstanceMap = __webpack_require__(98);
var ReactInstrumentation = __webpack_require__(43);
var ReactMarkupChecksum = __webpack_require__(780);
var ReactReconciler = __webpack_require__(86);
var ReactUpdateQueue = __webpack_require__(182);
var ReactUpdates = __webpack_require__(50);

var emptyObject = __webpack_require__(119);
var instantiateReactComponent = __webpack_require__(288);
var invariant = __webpack_require__(7);
var setInnerHTML = __webpack_require__(130);
var shouldUpdateReactComponent = __webpack_require__(188);
var warning = __webpack_require__(14);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(13);

var React = __webpack_require__(87);

var invariant = __webpack_require__(7);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(13);

var invariant = __webpack_require__(7);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactNodeTypes = __webpack_require__(281);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(29);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(23);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  inst._wrapperState.valueTracker = null;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13),
    _assign = __webpack_require__(19);

var ReactCompositeComponent = __webpack_require__(761);
var ReactEmptyComponent = __webpack_require__(276);
var ReactHostComponent = __webpack_require__(278);

var getNextDebugID = __webpack_require__(846);
var invariant = __webpack_require__(7);
var warning = __webpack_require__(14);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(29);
var escapeTextContentForBrowser = __webpack_require__(129);
var setInnerHTML = __webpack_require__(130);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var ReactCurrentOwner = __webpack_require__(57);
var REACT_ELEMENT_TYPE = __webpack_require__(776);

var getIteratorFn = __webpack_require__(807);
var invariant = __webpack_require__(7);
var KeyEscapeUtils = __webpack_require__(178);
var warning = __webpack_require__(14);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 292 */
/***/ (function(module, exports) {

/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  return (/input|select|textarea|button|object/.test(nodeName) ?
    !element.disabled :
    "a" === nodeName ?
      element.href || isTabIndexNotNaN :
      isTabIndexNotNaN) && visible(element);
}

function hidden(el) {
  return (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
    el.style.display === 'none';
}

function visible(element) {
  while (element) {
    if (element === document.body) break;
    if (hidden(element)) return false;
    element = element.parentNode;
  }
  return true;
}

function tabbable(element) {
  var tabIndex = element.getAttribute('tabindex');
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll('*'), 0).filter(function(el) {
    return tabbable(el);
  });
}

module.exports = findTabbableDescendants;



/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(83);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(295);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(194);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(3));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["Slider"] = factory(require("react"), require("react-dom"));
	else
		root["Slider"] = factory(root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_6__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = __webpack_require__(1);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _innerSlider = __webpack_require__(3);

	var _objectAssign = __webpack_require__(7);

	var _objectAssign2 = _interopRequireDefault(_objectAssign);

	var _json2mq = __webpack_require__(21);

	var _json2mq2 = _interopRequireDefault(_json2mq);

	var _defaultProps = __webpack_require__(10);

	var _defaultProps2 = _interopRequireDefault(_defaultProps);

	var _canUseDom = __webpack_require__(23);

	var _canUseDom2 = _interopRequireDefault(_canUseDom);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var enquire = _canUseDom2.default && __webpack_require__(24);

	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);

	  function Slider(props) {
	    _classCallCheck(this, Slider);

	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
	    return _this;
	  }

	  Slider.prototype.innerSliderRefHandler = function innerSliderRefHandler(ref) {
	    this.innerSlider = ref;
	  };

	  Slider.prototype.media = function media(query, handler) {
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };

	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;

	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });

	      breakpoints.forEach(function (breakpoint, index) {
	        var bQuery;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
	        }
	        _canUseDom2.default && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });

	      // Register media query for full screen. Need to support resize from small to large
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

	      _canUseDom2.default && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };

	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };

	  Slider.prototype.slickPrev = function slickPrev() {
	    this.innerSlider.slickPrev();
	  };

	  Slider.prototype.slickNext = function slickNext() {
	    this.innerSlider.slickNext();
	  };

	  Slider.prototype.slickGoTo = function slickGoTo(slide) {
	    this.innerSlider.slickGoTo(slide);
	  };

	  Slider.prototype.render = function render() {
	    var _this3 = this;

	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, this.props, newProps[0].settings);
	    } else {
	      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
	    }

	    var children = this.props.children;
	    if (!Array.isArray(children)) {
	      children = [children];
	    }

	    // Children may contain false or null, so we should filter them
	    children = children.filter(function (child) {
	      return !!child;
	    });

	    if (settings === 'unslick') {
	      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
	      return _react2.default.createElement(
	        'div',
	        null,
	        children
	      );
	    } else {
	      return _react2.default.createElement(
	        _innerSlider.InnerSlider,
	        _extends({ ref: this.innerSliderRefHandler }, settings),
	        children
	      );
	    }
	  };

	  return Slider;
	}(_react2.default.Component);

	exports.default = Slider;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.InnerSlider = undefined;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _eventHandlers = __webpack_require__(4);

	var _eventHandlers2 = _interopRequireDefault(_eventHandlers);

	var _helpers = __webpack_require__(8);

	var _helpers2 = _interopRequireDefault(_helpers);

	var _initialState = __webpack_require__(9);

	var _initialState2 = _interopRequireDefault(_initialState);

	var _defaultProps = __webpack_require__(10);

	var _defaultProps2 = _interopRequireDefault(_defaultProps);

	var _createReactClass = __webpack_require__(11);

	var _createReactClass2 = _interopRequireDefault(_createReactClass);

	var _classnames = __webpack_require__(17);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _objectAssign = __webpack_require__(7);

	var _objectAssign2 = _interopRequireDefault(_objectAssign);

	var _track = __webpack_require__(18);

	var _dots = __webpack_require__(19);

	var _arrows = __webpack_require__(20);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var InnerSlider = exports.InnerSlider = (0, _createReactClass2.default)({
	  mixins: [_helpers2.default, _eventHandlers2.default],
	  list: null,
	  track: null,
	  listRefHandler: function listRefHandler(ref) {
	    this.list = ref;
	  },
	  trackRefHandler: function trackRefHandler(ref) {
	    this.track = ref;
	  },
	  getInitialState: function getInitialState() {
	    return _extends({}, _initialState2.default, {
	      currentSlide: this.props.initialSlide
	    });
	  },
	  getDefaultProps: function getDefaultProps() {
	    return _defaultProps2.default;
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.init) {
	      this.props.init();
	    }
	    this.setState({
	      mounted: true
	    });
	    var lazyLoadedList = [];
	    for (var i = 0; i < _react2.default.Children.count(this.props.children); i++) {
	      if (i >= this.state.currentSlide && i < this.state.currentSlide + this.props.slidesToShow) {
	        lazyLoadedList.push(i);
	      }
	    }

	    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
	      this.setState({
	        lazyLoadedList: lazyLoadedList
	      });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    // Hack for autoplay -- Inspect Later
	    this.initialize(this.props);
	    this.adaptHeight();

	    // To support server-side rendering
	    if (!window) {
	      return;
	    }
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.onWindowResized);
	    } else {
	      window.attachEvent('onresize', this.onWindowResized);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationEndCallback) {
	      clearTimeout(this.animationEndCallback);
	    }
	    if (window.addEventListener) {
	      window.removeEventListener('resize', this.onWindowResized);
	    } else {
	      window.detachEvent('onresize', this.onWindowResized);
	    }
	    if (this.state.autoPlayTimer) {
	      clearInterval(this.state.autoPlayTimer);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.slickGoTo != nextProps.slickGoTo) {
	      if ((undefined) !== 'production') {
	        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
	      }
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.slickGoTo,
	        currentSlide: this.state.currentSlide
	      });
	    } else if (this.state.currentSlide >= nextProps.children.length) {
	      this.update(nextProps);
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.children.length - nextProps.slidesToShow,
	        currentSlide: this.state.currentSlide
	      });
	    } else {
	      this.update(nextProps);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.adaptHeight();
	  },
	  onWindowResized: function onWindowResized() {
	    this.update(this.props);
	    // animating state should be cleared while resizing, otherwise autoplay stops working
	    this.setState({
	      animating: false
	    });
	    clearTimeout(this.animationEndCallback);
	    delete this.animationEndCallback;
	  },
	  slickPrev: function slickPrev() {
	    this.changeSlide({ message: 'previous' });
	  },
	  slickNext: function slickNext() {
	    this.changeSlide({ message: 'next' });
	  },
	  slickGoTo: function slickGoTo(slide) {
	    typeof slide === 'number' && this.changeSlide({
	      message: 'index',
	      index: slide,
	      currentSlide: this.state.currentSlide
	    });
	  },
	  render: function render() {
	    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
	      'slick-vertical': this.props.vertical
	    });

	    var trackProps = {
	      fade: this.props.fade,
	      cssEase: this.props.cssEase,
	      speed: this.props.speed,
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
	      currentSlide: this.state.currentSlide,
	      lazyLoad: this.props.lazyLoad,
	      lazyLoadedList: this.state.lazyLoadedList,
	      rtl: this.props.rtl,
	      slideWidth: this.state.slideWidth,
	      slidesToShow: this.props.slidesToShow,
	      slidesToScroll: this.props.slidesToScroll,
	      slideCount: this.state.slideCount,
	      trackStyle: this.state.trackStyle,
	      variableWidth: this.props.variableWidth
	    };

	    var dots;

	    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
	      var dotProps = {
	        dotsClass: this.props.dotsClass,
	        slideCount: this.state.slideCount,
	        slidesToShow: this.props.slidesToShow,
	        currentSlide: this.state.currentSlide,
	        slidesToScroll: this.props.slidesToScroll,
	        clickHandler: this.changeSlide,
	        children: this.props.children,
	        customPaging: this.props.customPaging
	      };

	      dots = _react2.default.createElement(_dots.Dots, dotProps);
	    }

	    var prevArrow, nextArrow;

	    var arrowProps = {
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      currentSlide: this.state.currentSlide,
	      slideCount: this.state.slideCount,
	      slidesToShow: this.props.slidesToShow,
	      prevArrow: this.props.prevArrow,
	      nextArrow: this.props.nextArrow,
	      clickHandler: this.changeSlide
	    };

	    if (this.props.arrows) {
	      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	    }

	    var verticalHeightStyle = null;

	    if (this.props.vertical) {
	      verticalHeightStyle = {
	        height: this.state.listHeight
	      };
	    }

	    var centerPaddingStyle = null;

	    if (this.props.vertical === false) {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: '0px ' + this.props.centerPadding
	        };
	      }
	    } else {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: this.props.centerPadding + ' 0px'
	        };
	      }
	    }

	    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);

	    return _react2.default.createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: this.onInnerSliderEnter,
	        onMouseLeave: this.onInnerSliderLeave,
	        onMouseOver: this.onInnerSliderOver
	      },
	      prevArrow,
	      _react2.default.createElement(
	        'div',
	        {
	          ref: this.listRefHandler,
	          className: 'slick-list',
	          style: listStyle,
	          onMouseDown: this.swipeStart,
	          onMouseMove: this.state.dragging ? this.swipeMove : null,
	          onMouseUp: this.swipeEnd,
	          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	          onTouchStart: this.swipeStart,
	          onTouchMove: this.state.dragging ? this.swipeMove : null,
	          onTouchEnd: this.swipeEnd,
	          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
	          onKeyDown: this.props.accessibility ? this.keyHandler : null },
	        _react2.default.createElement(
	          _track.Track,
	          _extends({ ref: this.trackRefHandler }, trackProps),
	          this.props.children
	        )
	      ),
	      nextArrow,
	      dots
	    );
	  }
	});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _trackHelper = __webpack_require__(5);

	var _helpers = __webpack_require__(8);

	var _helpers2 = _interopRequireDefault(_helpers);

	var _objectAssign = __webpack_require__(7);

	var _objectAssign2 = _interopRequireDefault(_objectAssign);

	var _reactDom = __webpack_require__(6);

	var _reactDom2 = _interopRequireDefault(_reactDom);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var EventHandlers = {
	  // Event handler for previous and next
	  changeSlide: function changeSlide(options) {
	    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	    var _props = this.props,
	        slidesToScroll = _props.slidesToScroll,
	        slidesToShow = _props.slidesToShow;
	    var _state = this.state,
	        slideCount = _state.slideCount,
	        currentSlide = _state.currentSlide;

	    unevenOffset = slideCount % slidesToScroll !== 0;
	    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

	    if (options.message === 'previous') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	      targetSlide = currentSlide - slideOffset;
	      if (this.props.lazyLoad) {
	        previousInt = currentSlide - slideOffset;
	        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	      }
	    } else if (options.message === 'next') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	      targetSlide = currentSlide + slideOffset;
	      if (this.props.lazyLoad) {
	        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	      }
	    } else if (options.message === 'dots' || options.message === 'children') {
	      // Click on dots
	      targetSlide = options.index * options.slidesToScroll;
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    } else if (options.message === 'index') {
	      targetSlide = parseInt(options.index);
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    }

	    this.slideHandler(targetSlide);
	  },

	  // Accessiblity handler for previous and next
	  keyHandler: function keyHandler(e) {
	    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	      if (e.keyCode === 37 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'next' : 'previous'
	        });
	      } else if (e.keyCode === 39 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'previous' : 'next'
	        });
	      }
	    }
	  },
	  // Focus on selecting a slide (click handler on track)
	  selectHandler: function selectHandler(options) {
	    this.changeSlide(options);
	  },
	  swipeStart: function swipeStart(e) {
	    var touches, posX, posY;

	    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
	      return;
	    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
	      return;
	    }
	    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	    this.setState({
	      dragging: true,
	      touchObject: {
	        startX: posX,
	        startY: posY,
	        curX: posX,
	        curY: posY
	      }
	    });
	  },
	  swipeMove: function swipeMove(e) {
	    if (!this.state.dragging) {
	      e.preventDefault();
	      return;
	    }
	    if (this.state.animating) {
	      return;
	    }
	    if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
	      e.preventDefault();
	    }
	    var swipeLeft;
	    var curLeft, positionOffset;
	    var touchObject = this.state.touchObject;

	    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: this.state.currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));

	    if (this.props.verticalSwiping) {
	      touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	    }

	    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);

	    if (this.props.verticalSwiping) {
	      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	    }

	    var currentSlide = this.state.currentSlide;
	    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
	    var swipeDirection = this.swipeDirection(this.state.touchObject);
	    var touchSwipeLength = touchObject.swipeLength;

	    if (this.props.infinite === false) {
	      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
	        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;

	        if (this.state.edgeDragged === false && this.props.edgeEvent) {
	          this.props.edgeEvent(swipeDirection);
	          this.setState({ edgeDragged: true });
	        }
	      }
	    }

	    if (this.state.swiped === false && this.props.swipeEvent) {
	      this.props.swipeEvent(swipeDirection);
	      this.setState({ swiped: true });
	    }

	    if (!this.props.vertical) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
	    }

	    if (this.props.verticalSwiping) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    }

	    this.setState({
	      touchObject: touchObject,
	      swipeLeft: swipeLeft,
	      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
	    });

	    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	      return;
	    }
	    if (touchObject.swipeLength > 4) {
	      e.preventDefault();
	    }
	  },
	  getNavigableIndexes: function getNavigableIndexes() {
	    var max = void 0;
	    var breakPoint = 0;
	    var counter = 0;
	    var indexes = [];

	    if (!this.props.infinite) {
	      max = this.state.slideCount;
	    } else {
	      breakPoint = this.props.slidesToShow * -1;
	      counter = this.props.slidesToShow * -1;
	      max = this.state.slideCount * 2;
	    }

	    while (breakPoint < max) {
	      indexes.push(breakPoint);
	      breakPoint = counter + this.props.slidesToScroll;

	      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
	    }

	    return indexes;
	  },
	  checkNavigable: function checkNavigable(index) {
	    var navigables = this.getNavigableIndexes();
	    var prevNavigable = 0;

	    if (index > navigables[navigables.length - 1]) {
	      index = navigables[navigables.length - 1];
	    } else {
	      for (var n in navigables) {
	        if (index < navigables[n]) {
	          index = prevNavigable;
	          break;
	        }

	        prevNavigable = navigables[n];
	      }
	    }

	    return index;
	  },
	  getSlideCount: function getSlideCount() {
	    var _this = this;

	    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;

	    if (this.props.swipeToSlide) {
	      var swipedSlide = void 0;

	      var slickList = _reactDom2.default.findDOMNode(this.list);

	      var slides = slickList.querySelectorAll('.slick-slide');

	      Array.from(slides).every(function (slide) {
	        if (!_this.props.vertical) {
	          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        } else {
	          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        }

	        return true;
	      });

	      var slidesTraversed = Math.abs(swipedSlide.dataset.index - this.state.currentSlide) || 1;

	      return slidesTraversed;
	    } else {
	      return this.props.slidesToScroll;
	    }
	  },

	  swipeEnd: function swipeEnd(e) {
	    if (!this.state.dragging) {
	      if (this.props.swipe) {
	        e.preventDefault();
	      }
	      return;
	    }
	    var touchObject = this.state.touchObject;
	    var minSwipe = this.state.listWidth / this.props.touchThreshold;
	    var swipeDirection = this.swipeDirection(touchObject);

	    if (this.props.verticalSwiping) {
	      minSwipe = this.state.listHeight / this.props.touchThreshold;
	    }

	    // reset the state of touch related state variables.
	    this.setState({
	      dragging: false,
	      edgeDragged: false,
	      swiped: false,
	      swipeLeft: null,
	      touchObject: {}
	    });
	    // Fix for #13
	    if (!touchObject.swipeLength) {
	      return;
	    }
	    if (touchObject.swipeLength > minSwipe) {
	      e.preventDefault();

	      var slideCount = void 0,
	          newSlide = void 0;

	      switch (swipeDirection) {

	        case 'left':
	        case 'down':
	          newSlide = this.state.currentSlide + this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 0;
	          break;

	        case 'right':
	        case 'up':
	          newSlide = this.state.currentSlide - this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 1;
	          break;

	        default:
	          slideCount = this.state.currentSlide;

	      }

	      this.slideHandler(slideCount);
	    } else {
	      // Adjust the track back to it's original position.
	      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, this.props, this.state));

	      this.setState({
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      });
	    }
	  },
	  onInnerSliderEnter: function onInnerSliderEnter(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderOver: function onInnerSliderOver(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderLeave: function onInnerSliderLeave(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.autoPlay();
	    }
	  }
	};

	exports.default = EventHandlers;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;

	var _reactDom = __webpack_require__(6);

	var _reactDom2 = _interopRequireDefault(_reactDom);

	var _objectAssign = __webpack_require__(7);

	var _objectAssign2 = _interopRequireDefault(_objectAssign);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error('Keys Missing', spec);
	};

	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);

	  var trackWidth, trackHeight;

	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

	  if (!spec.vertical) {
	    if (spec.variableWidth) {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    } else if (spec.centerMode) {
	      trackWidth = (spec.slideCount + 2 * (spec.slidesToShow + 1)) * spec.slideWidth;
	    } else {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    }
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }

	  var style = {
	    opacity: 1,
	    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transition: '',
	    WebkitTransition: '',
	    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
	  };

	  if (trackWidth) {
	    (0, _objectAssign2.default)(style, { width: trackWidth });
	  }

	  if (trackHeight) {
	    (0, _objectAssign2.default)(style, { height: trackHeight });
	  }

	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + 'px';
	    } else {
	      style.marginTop = spec.left + 'px';
	    }
	  }

	  return style;
	};

	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);

	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
	  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
	  return style;
	};

	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {

	  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);

	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;

	  if (spec.fade) {
	    return 0;
	  }

	  if (spec.infinite) {
	    if (spec.slideCount >= spec.slidesToShow) {
	      slideOffset = spec.slideWidth * spec.slidesToShow * -1;
	      verticalOffset = spec.slideHeight * spec.slidesToShow * -1;
	    }
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        if (spec.slideIndex > spec.slideCount) {
	          slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
	          verticalOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideHeight * -1;
	        } else {
	          slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
	          verticalOffset = spec.slideCount % spec.slidesToScroll * spec.slideHeight * -1;
	        }
	      }
	    }
	  } else {

	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        var slidesToOffset = spec.slidesToShow - spec.slideCount % spec.slidesToScroll;
	        slideOffset = slidesToOffset * spec.slideWidth;
	      }
	    }
	  }

	  if (spec.centerMode) {
	    if (spec.infinite) {
	      slideOffset += spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    } else {
	      slideOffset = spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    }
	  }

	  if (!spec.vertical) {
	    targetLeft = spec.slideIndex * spec.slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = spec.slideIndex * spec.slideHeight * -1 + verticalOffset;
	  }

	  if (spec.variableWidth === true) {
	    var targetSlideIndex;
	    if (spec.slideCount <= spec.slidesToShow || spec.infinite === false) {
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[spec.slideIndex];
	    } else {
	      targetSlideIndex = spec.slideIndex + spec.slidesToShow;
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[targetSlideIndex];
	    }
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (spec.centerMode === true) {
	      if (spec.infinite === false) {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex];
	      } else {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex + spec.slidesToShow + 1];
	      }

	      if (targetSlide) {
	        targetLeft = targetSlide.offsetLeft * -1 + (spec.listWidth - targetSlide.offsetWidth) / 2;
	      }
	    }
	  }

	  return targetLeft;
	};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/

	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _reactDom = __webpack_require__(6);

	var _reactDom2 = _interopRequireDefault(_reactDom);

	var _trackHelper = __webpack_require__(5);

	var _objectAssign = __webpack_require__(7);

	var _objectAssign2 = _interopRequireDefault(_objectAssign);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var helpers = {
	  initialize: function initialize(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);

	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;

	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }

	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;

	    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;

	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      currentSlide: currentSlide,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {

	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));

	      this.setState({ trackStyle: trackStyle });

	      this.autoPlay(); // once we're set up, trigger the initial autoplay.
	    });
	  },
	  update: function update(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	    // This method has mostly same code as initialize method.
	    // Refactor it
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;

	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }

	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;

	    // pause slider if autoplay is set to false
	    if (props.autoplay) {
	      this.pause();
	    } else {
	      this.autoPlay();
	    }

	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {

	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));

	      this.setState({ trackStyle: trackStyle });
	    });
	  },
	  getWidth: function getWidth(elem) {
	    return elem.getBoundingClientRect().width || elem.offsetWidth || 0;
	  },
	  getHeight: function getHeight(elem) {
	    return elem.getBoundingClientRect().height || elem.offsetHeight || 0;
	  },

	  adaptHeight: function adaptHeight() {
	    if (this.props.adaptiveHeight) {
	      var selector = '[data-index="' + this.state.currentSlide + '"]';
	      if (this.list) {
	        var slickList = _reactDom2.default.findDOMNode(this.list);
	        slickList.style.height = slickList.querySelector(selector).offsetHeight + 'px';
	      }
	    }
	  },
	  canGoNext: function canGoNext(opts) {
	    var canGo = true;
	    if (!opts.infinite) {
	      if (opts.centerMode) {
	        // check if current slide is last slide
	        if (opts.currentSlide >= opts.slideCount - 1) {
	          canGo = false;
	        }
	      } else {
	        // check if all slides are shown in slider
	        if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
	          canGo = false;
	        }
	      }
	    }
	    return canGo;
	  },
	  slideHandler: function slideHandler(index) {
	    var _this = this;

	    // Functionality of animateSlide and postSlide is merged into this function
	    // console.log('slideHandler', index);
	    var targetSlide, currentSlide;
	    var targetLeft, currentLeft;
	    var callback;

	    if (this.props.waitForAnimate && this.state.animating) {
	      return;
	    }

	    if (this.props.fade) {
	      currentSlide = this.state.currentSlide;

	      // Don't change slide if it's not infite and current slide is the first or last slide.
	      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
	        return;
	      }

	      //  Shifting targetSlide back into the range
	      if (index < 0) {
	        targetSlide = index + this.state.slideCount;
	      } else if (index >= this.state.slideCount) {
	        targetSlide = index - this.state.slideCount;
	      } else {
	        targetSlide = index;
	      }

	      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
	        });
	      }

	      callback = function callback() {
	        _this.setState({
	          animating: false
	        });
	        if (_this.props.afterChange) {
	          _this.props.afterChange(targetSlide);
	        }
	        delete _this.animationEndCallback;
	      };

	      this.setState({
	        animating: true,
	        currentSlide: targetSlide
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });

	      if (this.props.beforeChange) {
	        this.props.beforeChange(this.state.currentSlide, targetSlide);
	      }

	      this.autoPlay();
	      return;
	    }

	    targetSlide = index;
	    if (targetSlide < 0) {
	      if (this.props.infinite === false) {
	        currentSlide = 0;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
	      } else {
	        currentSlide = this.state.slideCount + targetSlide;
	      }
	    } else if (targetSlide >= this.state.slideCount) {
	      if (this.props.infinite === false) {
	        currentSlide = this.state.slideCount - this.props.slidesToShow;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = 0;
	      } else {
	        currentSlide = targetSlide - this.state.slideCount;
	      }
	    } else {
	      currentSlide = targetSlide;
	    }

	    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: targetSlide,
	      trackRef: this.track
	    }, this.props, this.state));

	    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));

	    if (this.props.infinite === false) {
	      targetLeft = currentLeft;
	    }

	    if (this.props.beforeChange) {
	      this.props.beforeChange(this.state.currentSlide, currentSlide);
	    }

	    if (this.props.lazyLoad) {
	      var loaded = true;
	      var slidesToLoad = [];
	      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
	        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
	        if (!loaded) {
	          slidesToLoad.push(i);
	        }
	      }
	      if (!loaded) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
	        });
	      }
	    }

	    // Slide Transition happens here.
	    // animated transition happens to target Slide and
	    // non - animated transition happens to current Slide
	    // If CSS transitions are false, directly go the current slide.

	    if (this.props.useCSS === false) {

	      this.setState({
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      }, function () {
	        if (this.props.afterChange) {
	          this.props.afterChange(currentSlide);
	        }
	      });
	    } else {

	      var nextStateChanges = {
	        animating: false,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
	        swipeLeft: null
	      };

	      callback = function callback() {
	        _this.setState(nextStateChanges);
	        if (_this.props.afterChange) {
	          _this.props.afterChange(currentSlide);
	        }
	        delete _this.animationEndCallback;
	      };

	      this.setState({
	        animating: true,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	    }

	    this.autoPlay();
	  },
	  swipeDirection: function swipeDirection(touchObject) {
	    var xDist, yDist, r, swipeAngle;

	    xDist = touchObject.startX - touchObject.curX;
	    yDist = touchObject.startY - touchObject.curY;
	    r = Math.atan2(yDist, xDist);

	    swipeAngle = Math.round(r * 180 / Math.PI);
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	      return this.props.rtl === false ? 'left' : 'right';
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return this.props.rtl === false ? 'right' : 'left';
	    }
	    if (this.props.verticalSwiping === true) {
	      if (swipeAngle >= 35 && swipeAngle <= 135) {
	        return 'down';
	      } else {
	        return 'up';
	      }
	    }

	    return 'vertical';
	  },
	  play: function play() {
	    var nextIndex;

	    if (!this.state.mounted) {
	      return false;
	    }

	    if (this.props.rtl) {
	      nextIndex = this.state.currentSlide - this.props.slidesToScroll;
	    } else {
	      if (this.canGoNext(_extends({}, this.props, this.state))) {
	        nextIndex = this.state.currentSlide + this.props.slidesToScroll;
	      } else {
	        return false;
	      }
	    }

	    this.slideHandler(nextIndex);
	  },
	  autoPlay: function autoPlay() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	    }
	    if (this.props.autoplay) {
	      this.setState({
	        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
	      });
	    }
	  },
	  pause: function pause() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	      this.setState({
	        autoPlayTimer: null
	      });
	    }
	  }
	};

	exports.default = helpers;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";

	var initialState = {
	    animating: false,
	    dragging: false,
	    autoPlayTimer: null,
	    currentDirection: 0,
	    currentLeft: null,
	    currentSlide: 0,
	    direction: 1,
	    listWidth: null,
	    listHeight: null,
	    // loadIndex: 0,
	    slideCount: null,
	    slideWidth: null,
	    slideHeight: null,
	    // sliding: false,
	    // slideOffset: 0,
	    swipeLeft: null,
	    touchObject: {
	        startX: 0,
	        startY: 0,
	        curX: 0,
	        curY: 0
	    },

	    lazyLoadedList: [],

	    // added for react
	    initialized: false,
	    edgeDragged: false,
	    swiped: false, // used by swipeEvent. differentites between touch and swipe.
	    trackStyle: {},
	    trackWidth: 0

	    // Removed
	    // transformsEnabled: false,
	    // $nextArrow: null,
	    // $prevArrow: null,
	    // $dots: null,
	    // $list: null,
	    // $slideTrack: null,
	    // $slides: null,
	};

	module.exports = initialState;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var defaultProps = {
	    className: '',
	    accessibility: true,
	    adaptiveHeight: false,
	    arrows: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    centerMode: false,
	    centerPadding: '50px',
	    cssEase: 'ease',
	    customPaging: function customPaging(i) {
	        return _react2.default.createElement(
	            'button',
	            null,
	            i + 1
	        );
	    },
	    dots: false,
	    dotsClass: 'slick-dots',
	    draggable: true,
	    easing: 'linear',
	    edgeFriction: 0.35,
	    fade: false,
	    focusOnSelect: false,
	    infinite: true,
	    initialSlide: 0,
	    lazyLoad: false,
	    pauseOnHover: true,
	    responsive: null,
	    rtl: false,
	    slide: 'div',
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,
	    swipe: true,
	    swipeToSlide: false,
	    touchMove: true,
	    touchThreshold: 5,
	    useCSS: true,
	    variableWidth: false,
	    vertical: false,
	    waitForAnimate: true,
	    afterChange: null,
	    beforeChange: null,
	    edgeEvent: null,
	    init: null,
	    swipeEvent: null,
	    // nextArrow, prevArrow are react componets
	    nextArrow: null,
	    prevArrow: null
	};

	module.exports = defaultProps;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */

	'use strict';

	var React = __webpack_require__(2);
	var factory = __webpack_require__(12);

	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;

	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */

	'use strict';

	var _assign = __webpack_require__(7);

	var emptyObject = __webpack_require__(13);
	var _invariant = __webpack_require__(14);

	if ((undefined) !== 'production') {
	  var warning = __webpack_require__(15);
	}

	var MIXINS_KEY = 'mixins';

	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}

	var ReactPropTypeLocationNames;
	if ((undefined) !== 'production') {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context',
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}

	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */


	  var injectedMixins = [];

	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {

	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',

	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',

	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',

	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',

	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',

	    // ==== Definition methods ====

	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',

	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',

	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',

	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @nosideeffects
	     * @required
	     */
	    render: 'DEFINE_ONCE',

	    // ==== Delegate methods ====

	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',

	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',

	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',

	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',

	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',

	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',

	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',

	    // ==== Advanced methods ====

	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'

	  };

	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function (Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function (Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function (Constructor, childContextTypes) {
	      if ((undefined) !== 'production') {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	    },
	    contextTypes: function (Constructor, contextTypes) {
	      if ((undefined) !== 'production') {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function (Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function (Constructor, propTypes) {
	      if ((undefined) !== 'production') {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function (Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function () {} };

	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        (undefined) !== 'production' ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	      }
	    }
	  }

	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
	    }

	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
	    }
	  }

	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if ((undefined) !== 'production') {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;

	        (undefined) !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	      }

	      return;
	    }

	    _invariant(typeof spec !== 'function', 'ReactClass: You\'re attempting to ' + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
	    _invariant(!isValidElement(spec), 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.');

	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;

	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }

	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }

	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }

	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);

	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];

	            // These cases should already be caught by validateMethodOverride.
	            _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);

	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if ((undefined) !== 'production') {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }

	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }

	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);

	      var isInherited = name in Constructor;
	      _invariant(!isInherited, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);
	      Constructor[name] = property;
	    }
	  }

	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');

	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }

	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }

	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }

	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if ((undefined) !== 'production') {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function (newThis) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }

	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          (undefined) !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	        } else if (!args.length) {
	          (undefined) !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }

	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }

	  var IsMountedMixin = {
	    componentDidMount: function () {
	      this.__isMounted = true;
	    },
	    componentWillUnmount: function () {
	      this.__isMounted = false;
	    }
	  };

	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {

	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function (newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },

	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function () {
	      if ((undefined) !== 'production') {
	        (undefined) !== 'production' ? warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component') : void 0;
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };

	  var ReactClassComponent = function () {};
	  _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.

	      if ((undefined) !== 'production') {
	        (undefined) !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }

	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }

	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;

	      this.state = null;

	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.

	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if ((undefined) !== 'production') {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');

	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];

	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

	    mixSpecIntoComponent(Constructor, IsMountedMixin);
	    mixSpecIntoComponent(Constructor, spec);

	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }

	    if ((undefined) !== 'production') {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }

	    _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');

	    if ((undefined) !== 'production') {
	      (undefined) !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      (undefined) !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }

	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }

	    return Constructor;
	  }

	  return createClass;
	}

	module.exports = factory;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */

	'use strict';

	var emptyObject = {};

	if ((undefined) !== 'production') {
	  Object.freeze(emptyObject);
	}

	module.exports = emptyObject;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */

	'use strict';

	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */

	var validateFormat = function validateFormat(format) {};

	if ((undefined) !== 'production') {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}

	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);

	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }

	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}

	module.exports = invariant;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */

	'use strict';

	var emptyFunction = __webpack_require__(16);

	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */

	var warning = emptyFunction;

	if ((undefined) !== 'production') {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }

	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };

	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }

	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }

	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }

	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}

	module.exports = warning;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	"use strict";

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */

	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}

	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};

	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};

	module.exports = emptyFunction;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */

	(function () {
		'use strict';

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}

			return classes.join(' ');
		}

		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.Track = undefined;

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _objectAssign = __webpack_require__(7);

	var _objectAssign2 = _interopRequireDefault(_objectAssign);

	var _classnames = __webpack_require__(17);

	var _classnames2 = _interopRequireDefault(_classnames);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;

	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }

	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  return (0, _classnames2.default)({
	    'slick-slide': true,
	    'slick-active': slickActive,
	    'slick-center': slickCenter,
	    'slick-cloned': slickCloned
	  });
	};

	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};

	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }

	  if (spec.fade) {
	    style.position = 'relative';
	    style.left = -spec.index * spec.slideWidth;
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	  }

	  return style;
	};

	var getKey = function getKey(child, fallbackKey) {
	  // key could be a zero
	  return child.key === null || child.key === undefined ? fallbackKey : child.key;
	};

	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var count = _react2.default.Children.count(spec.children);

	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: 'children',
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };

	    if (!spec.lazyLoad | (spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0)) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement('div', null);
	    }
	    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
	    var slickClasses = getSlideClasses((0, _objectAssign2.default)({ index: index }, spec));
	    var cssClasses;

	    if (child.props.className) {
	      cssClasses = (0, _classnames2.default)(slickClasses, child.props.className);
	    } else {
	      cssClasses = slickClasses;
	    }

	    var onClick = function onClick(e) {
	      child.props && child.props.onClick && child.props.onClick(e);
	      if (spec.focusOnSelect) {
	        spec.focusOnSelect(childOnClickOptions);
	      }
	    };

	    slides.push(_react2.default.cloneElement(child, {
	      key: 'original' + getKey(child, index),
	      'data-index': index,
	      className: cssClasses,
	      tabIndex: '-1',
	      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
	      onClick: onClick
	    }));

	    // variableWidth doesn't wrap properly.
	    if (spec.infinite && spec.fade === false) {
	      var infiniteCount = spec.variableWidth ? spec.slidesToShow + 1 : spec.slidesToShow;

	      if (index >= count - infiniteCount) {
	        key = -(count - index);
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'precloned' + getKey(child, key),
	          'data-index': key,
	          className: cssClasses,
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }

	      if (index < infiniteCount) {
	        key = count + index;
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'postcloned' + getKey(child, key),
	          'data-index': key,
	          className: cssClasses,
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	    }
	  });

	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};

	var Track = exports.Track = function (_React$Component) {
	  _inherits(Track, _React$Component);

	  function Track() {
	    _classCallCheck(this, Track);

	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }

	  Track.prototype.render = function render() {
	    var slides = renderSlides.call(this, this.props);
	    return _react2.default.createElement(
	      'div',
	      { className: 'slick-track', style: this.props.trackStyle },
	      slides
	    );
	  };

	  return Track;
	}(_react2.default.Component);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.Dots = undefined;

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _classnames = __webpack_require__(17);

	var _classnames2 = _interopRequireDefault(_classnames);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var getDotCount = function getDotCount(spec) {
	  var dots;
	  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  return dots;
	};

	var Dots = exports.Dots = function (_React$Component) {
	  _inherits(Dots, _React$Component);

	  function Dots() {
	    _classCallCheck(this, Dots);

	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }

	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };

	  Dots.prototype.render = function render() {
	    var _this2 = this;

	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll
	    });

	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {

	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });

	      var dotOptions = {
	        message: 'dots',
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };

	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);

	      return _react2.default.createElement(
	        'li',
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });

	    return _react2.default.createElement(
	      'ul',
	      { className: this.props.dotsClass, style: { display: 'block' } },
	      dots
	    );
	  };

	  return Dots;
	}(_react2.default.Component);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _react = __webpack_require__(2);

	var _react2 = _interopRequireDefault(_react);

	var _classnames = __webpack_require__(17);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _helpers = __webpack_require__(8);

	var _helpers2 = _interopRequireDefault(_helpers);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var PrevArrow = exports.PrevArrow = function (_React$Component) {
	  _inherits(PrevArrow, _React$Component);

	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);

	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }

	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };

	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
	    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });

	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses['slick-disabled'] = true;
	      prevHandler = null;
	    }

	    var prevArrowProps = {
	      key: '0',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: 'block' },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow;

	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '0', type: 'button' }, prevArrowProps),
	        ' Previous'
	      );
	    }

	    return prevArrow;
	  };

	  return PrevArrow;
	}(_react2.default.Component);

	var NextArrow = exports.NextArrow = function (_React$Component2) {
	  _inherits(NextArrow, _React$Component2);

	  function NextArrow() {
	    _classCallCheck(this, NextArrow);

	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }

	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };

	  NextArrow.prototype.render = function render() {
	    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
	    var nextHandler = this.clickHandler.bind(this, { message: 'next' });

	    if (!_helpers2.default.canGoNext(this.props)) {
	      nextClasses['slick-disabled'] = true;
	      nextHandler = null;
	    }

	    var nextArrowProps = {
	      key: '1',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: 'block' },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow;

	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '1', type: 'button' }, nextArrowProps),
	        ' Next'
	      );
	    }

	    return nextArrow;
	  };

	  return NextArrow;
	}(_react2.default.Component);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(22);

	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};

	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};

	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};

	module.exports = json2mq;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};

	module.exports = camel2hyphen;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);

	module.exports = canUseDOM;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(25);
	module.exports = new MediaQueryDispatch();


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(26);
	var Util = __webpack_require__(28);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;

	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }

	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}

	MediaQueryDispatch.prototype = {

	    constructor : MediaQueryDispatch,

	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;

	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }

	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });

	        return this;
	    },

	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];

	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }

	        return this;
	    }
	};

	module.exports = MediaQueryDispatch;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(27);
	var each = __webpack_require__(28).each;

	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);

	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}

	MediaQuery.prototype = {

	    constuctor : MediaQuery,

	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);

	        this.matches() && qh.on();
	    },

	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },

	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },

	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },

	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';

	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};

	module.exports = MediaQuery;


/***/ }),
/* 27 */
/***/ (function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}

	QueryHandler.prototype = {

	    constructor : QueryHandler,

	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },

	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },

	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },

	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },

	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }

	};

	module.exports = QueryHandler;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;

	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}

	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}

	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}

	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ })
/******/ ])
});
;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(100),
    _assign = __webpack_require__(19);

var ReactNoopUpdateQueue = __webpack_require__(301);

var canDefineProperty = __webpack_require__(302);
var emptyObject = __webpack_require__(119);
var invariant = __webpack_require__(7);
var lowPriorityWarning = __webpack_require__(847);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(100);

var ReactCurrentOwner = __webpack_require__(57);

var invariant = __webpack_require__(7);
var warning = __webpack_require__(14);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(14);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createStore = createStore;

var _utils = __webpack_require__(51);

var _ = _interopRequireWildcard(_utils);

var _Keep = __webpack_require__(195);

var Keep = _interopRequireWildcard(_Keep);

var _mixer = __webpack_require__(852);

var _bindMethods = __webpack_require__(850);

var _StoreMethods = __webpack_require__(304);

var StoreMethods = _interopRequireWildcard(_StoreMethods);

var _PublisherMethods = __webpack_require__(196);

var PublisherMethods = _interopRequireWildcard(_PublisherMethods);

var _ListenerMethods = __webpack_require__(78);

var ListenerMethods = _interopRequireWildcard(_ListenerMethods);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allowed = { preEmit: 1, shouldEmit: 1 };

/**
 * Creates an event emitting Data Store. It is mixed in with functions
 * from the `ListenerMethods` and `PublisherMethods` mixins. `preEmit`
 * and `shouldEmit` may be overridden in the definition object.
 *
 * @param {Object} definition The data store object definition
 * @returns {Store} A data store instance
 */
function createStore(definition) {

    definition = definition || {};

    for (var a in StoreMethods) {
        if (!allowed[a] && (PublisherMethods[a] || ListenerMethods[a])) {
            throw new Error("Cannot override API method " + a + " in Reflux.StoreMethods. Use another method name or override it on Reflux.PublisherMethods / Reflux.ListenerMethods instead.");
        }
    }

    for (var d in definition) {
        if (!allowed[d] && (PublisherMethods[d] || ListenerMethods[d])) {
            throw new Error("Cannot override API method " + d + " in store creation. Use another method name or override it on Reflux.PublisherMethods / Reflux.ListenerMethods instead.");
        }
    }

    definition = (0, _mixer.mix)(definition);

    function Store() {
        var i = 0,
            arr;
        this.subscriptions = [];
        this.emitter = new _.EventEmitter();
        this.eventLabel = "change";
        (0, _bindMethods.bindMethods)(this, definition);
        if (this.init && _.isFunction(this.init)) {
            this.init();
        }
        if (this.listenables) {
            arr = [].concat(this.listenables);
            for (; i < arr.length; i++) {
                this.listenToMany(arr[i]);
            }
        }
    }

    _.extend(Store.prototype, ListenerMethods, PublisherMethods, StoreMethods, definition);

    var store = new Store();
    Keep.addStore(store);

    return store;
}

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.staticJoinCreator = staticJoinCreator;
exports.instanceJoinCreator = instanceJoinCreator;

var _createStore = __webpack_require__(305);

var _utils = __webpack_require__(51);

var _ = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Internal module used to create static and instance join methods
 */

var slice = Array.prototype.slice,
    strategyMethodNames = {
    strict: "joinStrict",
    first: "joinLeading",
    last: "joinTrailing",
    all: "joinConcat"
};

/**
 * Used in `index.js` to create the static join methods
 * @param {String} strategy Which strategy to use when tracking listenable trigger arguments
 * @returns {Function} A static function which returns a store with a join listen on the given listenables using the given strategy
 */
function staticJoinCreator(strategy) {
    return function () /* listenables... */{
        var listenables = slice.call(arguments);
        return (0, _createStore.createStore)({
            init: function init() {
                this[strategyMethodNames[strategy]].apply(this, listenables.concat("triggerAsync"));
            }
        });
    };
}

/**
 * Used in `ListenerMethods.js` to create the instance join methods
 * @param {String} strategy Which strategy to use when tracking listenable trigger arguments
 * @returns {Function} An instance method which sets up a join listen on the given listenables using the given strategy
 */
function instanceJoinCreator(strategy) {
    return function () /* listenables..., callback*/{
        _.throwIf(arguments.length < 2, "Cannot create a join with less than 2 listenables!");
        var listenables = slice.call(arguments),
            callback = listenables.pop(),
            numberOfListenables = listenables.length,
            join = {
            numberOfListenables: numberOfListenables,
            callback: this[callback] || callback,
            listener: this,
            strategy: strategy
        },
            i,
            cancels = [],
            subobj;
        for (i = 0; i < numberOfListenables; i++) {
            _.throwIf(this.validateListening(listenables[i]));
        }
        for (i = 0; i < numberOfListenables; i++) {
            cancels.push(listenables[i].listen(newListener(i, join), this));
        }
        reset(join);
        subobj = { listenable: listenables };
        subobj.stop = makeStopper(subobj, cancels, this);
        this.subscriptions = (this.subscriptions || []).concat(subobj);
        return subobj;
    };
}

// ---- internal join functions ----

function makeStopper(subobj, cancels, context) {
    return function () {
        var i,
            subs = context.subscriptions,
            index = subs ? subs.indexOf(subobj) : -1;
        _.throwIf(index === -1, "Tried to remove join already gone from subscriptions list!");
        for (i = 0; i < cancels.length; i++) {
            cancels[i]();
        }
        subs.splice(index, 1);
    };
}

function reset(join) {
    join.listenablesEmitted = new Array(join.numberOfListenables);
    join.args = new Array(join.numberOfListenables);
}

function newListener(i, join) {
    return function () {
        var callargs = slice.call(arguments);
        if (join.listenablesEmitted[i]) {
            switch (join.strategy) {
                case "strict":
                    throw new Error("Strict join failed because listener triggered twice.");
                case "last":
                    join.args[i] = callargs;break;
                case "all":
                    join.args[i].push(callargs);
            }
        } else {
            join.listenablesEmitted[i] = true;
            join.args[i] = join.strategy === "all" ? [callargs] : callargs;
        }
        emitIfAllListenablesEmitted(join);
    };
}

function emitIfAllListenablesEmitted(join) {
    for (var i = 0; i < join.numberOfListenables; i++) {
        if (!join.listenablesEmitted[i]) {
            return;
        }
    }
    join.callback.apply(join.listener, join.args);
    reset(join);
}

/***/ }),
/* 307 */
/***/ (function(module, exports) {

/*!
* screenfull
* v3.3.3 - 2018-09-04
* (c) Sindre Sorhus; MIT License
*/
(function () {
	'use strict';

	var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
	var isCommonjs = typeof module !== 'undefined' && module.exports;
	var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;

	var fn = (function () {
		var val;

		var fnMap = [
			[
				'requestFullscreen',
				'exitFullscreen',
				'fullscreenElement',
				'fullscreenEnabled',
				'fullscreenchange',
				'fullscreenerror'
			],
			// New WebKit
			[
				'webkitRequestFullscreen',
				'webkitExitFullscreen',
				'webkitFullscreenElement',
				'webkitFullscreenEnabled',
				'webkitfullscreenchange',
				'webkitfullscreenerror'

			],
			// Old WebKit (Safari 5.1)
			[
				'webkitRequestFullScreen',
				'webkitCancelFullScreen',
				'webkitCurrentFullScreenElement',
				'webkitCancelFullScreen',
				'webkitfullscreenchange',
				'webkitfullscreenerror'

			],
			[
				'mozRequestFullScreen',
				'mozCancelFullScreen',
				'mozFullScreenElement',
				'mozFullScreenEnabled',
				'mozfullscreenchange',
				'mozfullscreenerror'
			],
			[
				'msRequestFullscreen',
				'msExitFullscreen',
				'msFullscreenElement',
				'msFullscreenEnabled',
				'MSFullscreenChange',
				'MSFullscreenError'
			]
		];

		var i = 0;
		var l = fnMap.length;
		var ret = {};

		for (; i < l; i++) {
			val = fnMap[i];
			if (val && val[1] in document) {
				for (i = 0; i < val.length; i++) {
					ret[fnMap[0][i]] = val[i];
				}
				return ret;
			}
		}

		return false;
	})();

	var eventNameMap = {
		change: fn.fullscreenchange,
		error: fn.fullscreenerror
	};

	var screenfull = {
		request: function (elem) {
			var request = fn.requestFullscreen;

			elem = elem || document.documentElement;

			// Work around Safari 5.1 bug: reports support for
			// keyboard in fullscreen even though it doesn't.
			// Browser sniffing, since the alternative with
			// setTimeout is even worse.
			if (/ Version\/5\.1(?:\.\d+)? Safari\//.test(navigator.userAgent)) {
				elem[request]();
			} else {
				elem[request](keyboardAllowed ? Element.ALLOW_KEYBOARD_INPUT : {});
			}
		},
		exit: function () {
			document[fn.exitFullscreen]();
		},
		toggle: function (elem) {
			if (this.isFullscreen) {
				this.exit();
			} else {
				this.request(elem);
			}
		},
		onchange: function (callback) {
			this.on('change', callback);
		},
		onerror: function (callback) {
			this.on('error', callback);
		},
		on: function (event, callback) {
			var eventName = eventNameMap[event];
			if (eventName) {
				document.addEventListener(eventName, callback, false);
			}
		},
		off: function (event, callback) {
			var eventName = eventNameMap[event];
			if (eventName) {
				document.removeEventListener(eventName, callback, false);
			}
		},
		raw: fn
	};

	if (!fn) {
		if (isCommonjs) {
			module.exports = false;
		} else {
			window.screenfull = false;
		}

		return;
	}

	Object.defineProperties(screenfull, {
		isFullscreen: {
			get: function () {
				return Boolean(document[fn.fullscreenElement]);
			}
		},
		element: {
			enumerable: true,
			get: function () {
				return document[fn.fullscreenElement];
			}
		},
		enabled: {
			enumerable: true,
			get: function () {
				// Coerce to boolean in case of old WebKit
				return Boolean(document[fn.fullscreenEnabled]);
			}
		}
	});

	if (isCommonjs) {
		module.exports = screenfull;
	} else {
		window.screenfull = screenfull;
	}
})();


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(644);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!../../sass-loader/lib/loader.js!./slick-theme.scss", function() {
			var newContent = require("!!../../css-loader/index.js!../../sass-loader/lib/loader.js!./slick-theme.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(645);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!../../sass-loader/lib/loader.js!./slick.scss", function() {
			var newContent = require("!!../../css-loader/index.js!../../sass-loader/lib/loader.js!./slick.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(649);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(425);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _handlebars = __webpack_require__(121);

var _handlebars2 = _interopRequireDefault(_handlebars);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

var _pageContent = __webpack_require__(354);

var _pageContent2 = _interopRequireDefault(_pageContent);

var _shareWidget = __webpack_require__(200);

var _shareWidget2 = _interopRequireDefault(_shareWidget);

var _giftManager = __webpack_require__(199);

var _giftManager2 = _interopRequireDefault(_giftManager);

var _helpers = __webpack_require__(30);

var _helpers2 = _interopRequireDefault(_helpers);

var _metaDataTags = __webpack_require__(355);

var _metaDataTags2 = _interopRequireDefault(_metaDataTags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.$ = window.$ || _jquery2.default;
window.jQuery = window.jQuery || _jquery2.default;
window.Handlebars = window.Handlebars || _handlebars2.default;

(function (app, infosite) {
	infosite = infosite || {};
	infosite.templates = infosite.templates || {};
	var cache = window.medscape.config.cache;

	var staticPath = '' + app.config.staticServer.host + app.config.staticServer.path;
	var cssFile = 'infosite-desktop.css';

	var $infositeApp = (0, _jquery2.default)('#infosite-app');
	var isStylesLoaded = window.medscape.isStylesLoaded || false;
	if (document.location.hostname.indexOf('localhost') > -1 && _utils2.default.isMobile()) {
		cssFile = 'infosite-mobile.css';
		window.medscape.isMobile = true;
	}
	var cssPath = staticPath + '/css/' + cssFile + '?v=' + cache;
	if (!isStylesLoaded) {
		(0, _jquery2.default)("<link/>", {
			rel: "stylesheet",
			type: "text/css",
			href: cssPath,
			onLoad: function onLoad() {}
		}).appendTo("head");
	}

	function getTemplate($el) {
		var template = $el.find('.template').html();
		return _handlebars2.default.compile(template);
	}

	(0, _jquery2.default)(document).ready(function () {
		_tracking2.default.init(infosite.config["tracking"]);
		(0, _jquery2.default)('body').addClass(window.medscape.isMobile ? 'medscape-mobile' : 'medscape-desktop');

		var $headerEl = (0, _jquery2.default)('header');
		var $footerEl = (0, _jquery2.default)('footer');
		var headerConfig = infosite.config.header;
		var footerConfig = infosite.config.footer;
		var ServerData = {
			static: {
				host: app.config.staticServer.host,
				path: staticPath
			}
		};
		var ConfigPropData = {
			ServerData: ServerData
		};

		if (!infosite.config.header.desktop.isResponsive && !_utils2.default.isMobile()) {
			//$('.responsive-component').removeClass('responsive-component');
			(0, _jquery2.default)('body').addClass('not-responsive');
		}

		(function loadHeader() {

			var template = infosite.templates.header = getTemplate($headerEl);
			var featureTemplate = headerConfig.feature.headline;
			var inviteMessageTemplate = headerConfig.feature.inviteMessage;

			for (var prop in headerConfig.medscape) {
				if (headerConfig.medscape.hasOwnProperty(prop)) {
					headerConfig.medscape[prop] = _handlebars2.default.compile(headerConfig.medscape[prop])(ConfigPropData);
				}
			}
			for (var _prop in headerConfig.infosite) {
				if (headerConfig.infosite.hasOwnProperty(_prop)) {
					headerConfig.infosite[_prop] = _handlebars2.default.compile(headerConfig.infosite[_prop])(ConfigPropData);
				}
			}
			headerConfig.ServerData = ServerData;
			headerConfig.feature.headline = _handlebars2.default.compile(featureTemplate)(headerConfig);
			headerConfig.feature.inviteMessage = _handlebars2.default.compile(inviteMessageTemplate)(headerConfig);

			var html = template(headerConfig);
			var $html = (0, _jquery2.default)(html);
			$headerEl.html($html);

			if (headerConfig.feature.backgroundImage && headerConfig.feature.backgroundImage.length > 0) {
				var bgUrl = headerConfig.feature.backgroundImage.startsWith('//') ? headerConfig.feature.backgroundImage : staticPath + headerConfig.feature.backgroundImage;
				var bgImage = 'url(' + bgUrl + ')';

				$html.find('.feature-row').css('background-image', bgImage);
			}

			if (!window.medscape.isMobile && headerConfig.desktop.isSticky) {
				_helpers2.default.loadStickyHeader();
			} else if (window.medscape.isMobile && headerConfig.mobile.isSticky) {
				_helpers2.default.loadStickyHeader();
			}
		})(); // loadHeader
		(function loadFooter() {
			var template = infosite.templates.footer = getTemplate($footerEl);
			for (var prop in footerConfig) {
				if (footerConfig.hasOwnProperty(prop)) {
					footerConfig[prop] = _handlebars2.default.compile(footerConfig[prop])(ConfigPropData);
				}
			}
			footerConfig.ServerData = ServerData;
			var html = template(footerConfig);
			var $html = (0, _jquery2.default)(html);
			$footerEl.html($html);
		})(); // loadFooter

		(function loadModules() {
			if (!infosite.config["comment"].isActive) {
				(0, _jquery2.default)('.social-sharing-widget-container .comments-wrap').hide();
			}
			_metaDataTags2.default.init();
			_pageContent2.default.init(infosite.config["pages"], infosite.config["navigation"], infosite.config["isi"]);
			_helpers2.default.load();
		})(); // loadModules
		//Tracking.trackContainerLinks($('body')[0]);
	}); // document ready

})(window.medscape, window.infosite);

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Animation = {
  updateHeight: function updateHeight(wrapper, content, prevHeight) {
    var shouldGrow = wrapper.offsetHeight < prevHeight;
    wrapper.style.height = prevHeight + 'px';
    var prev = null;
    var applyChange = function applyChange(timestamp) {
      var change = prev ? timestamp - prev : 1,
          h = parseInt(wrapper.style.height, 10) + (shouldGrow ? -change : change);
      prev = timestamp;
      if (shouldGrow && h > content.offsetHeight || !shouldGrow && h < content.offsetHeight) {
        wrapper.style.height = h + 'px';
        document.getElementById('medscape-tver').style.opacity = document.getElementById('medscape-tver').style.opacity + 0.10;
        requestAnimationFrame(applyChange);
      } else {
        document.getElementById('medscape-tver').style.opacity = 1;
        wrapper.style.height = 'auto';
      }
    };
    requestAnimationFrame(applyChange);
  },
  slideFadeIn: function slideFadeIn(element, elementContent) {
    var start = null;
    element.style.display = 'block';
    elementContent.style.opacity = '0';
    var widthModifier = 2;
    if (_utils2.default.isMobile()) {
      widthModifier = 1;
    }
    if (_utils2.default.isIpad()) {
      widthModifier = 1.5;
    }
    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = timestamp - start;
      var width = Math.min(progress / 5, 2000);
      width = width > 100 ? 100 : width;
      elementContent.style.left = 100 - width / widthModifier + '%';
      elementContent.style.opacity = width / 100;
      if (width < 100) {
        requestAnimationFrame(step);
      }
    }
    requestAnimationFrame(step);
  },
  slideFadeOut: function slideFadeOut(element, elementContent) {
    var start = null;
    element.style.display = 'block';
    element.style.opacity = '1';
    var widthModifier = 2;
    if (_utils2.default.isMobile()) {
      widthModifier = 1;
    }
    if (_utils2.default.isIpad()) {
      widthModifier = 1.5;
    }
    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = timestamp - start;
      var width = Math.min(progress / 5, 2000);
      width = width > 100 ? 100 : width;
      width = 100 - width;
      elementContent.style.left = 100 - width / 2 + '%';
      elementContent.style.opacity = width / widthModifier;
      if (width > 0) {
        requestAnimationFrame(step);
      } else {
        element.style.display = 'none';
        elementContent.style.opacity = '0';
      }
    }
    requestAnimationFrame(step);
  }
};
module.exports = Animation;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(361);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(866);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ConsultWidgetModule = function ConsultWidgetModule(config, $modules) {
	_classCallCheck(this, ConsultWidgetModule);

	if (config == null) {
		return;
	}
	$modules.each(function (index, el) {
		var $el = (0, _jquery2.default)(el);
		if ($el.hasClass('module-loaded')) {
			return;
		}
		var configId = $el.data('config-id');
		var moduleData = config.find(function (data) {
			return data['config-id'] == configId;
		});
		if (!moduleData) return;
		var props = _jquery2.default.extend({}, moduleData.settings);
		props.copy = _jquery2.default.extend({}, moduleData.copy);
		props.user = {
			isLoggedIn: window.medscape.user.isLoggedIn,
			professionId: window.medscape.user.professionId
		};
		_reactDom2.default.render(_react2.default.createElement(_app2.default, props), el);
		$el.addClass('module-loaded');
	});
};

exports.default = ConsultWidgetModule;

ConsultWidgetModule.selector = '[data-module="ConsultWidget"]';
ConsultWidgetModule.init = function (config, $modules) {
	$modules = $modules || (0, _jquery2.default)(ConsultWidgetModule.selector);
	if ($modules.length > 0) {
		new ConsultWidgetModule(config, $modules);
	}
};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _app = __webpack_require__(363);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(867);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _app2.default;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _actions = __webpack_require__(89);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorMessagesStore = function (_Reflux$Store) {
  _inherits(ErrorMessagesStore, _Reflux$Store);

  function ErrorMessagesStore() {
    _classCallCheck(this, ErrorMessagesStore);

    var _this = _possibleConstructorReturn(this, (ErrorMessagesStore.__proto__ || Object.getPrototypeOf(ErrorMessagesStore)).call(this));

    _this.state = _this.getInitialState();
    _this.listenables = _actions2.default;
    return _this;
  }

  _createClass(ErrorMessagesStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        "errors": []
      };
    }
  }, {
    key: 'onUpdate',
    value: function onUpdate(messages) {
      this.setState({
        errors: messages
      });
    }
  }]);

  return ErrorMessagesStore;
}(_reflux2.default.Store);

exports.default = ErrorMessagesStore;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _app = __webpack_require__(364);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(868);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _app2.default;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _actions = __webpack_require__(132);

var _actions2 = _interopRequireDefault(_actions);

var _actions3 = __webpack_require__(89);

var _actions4 = _interopRequireDefault(_actions3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormStore = function (_Reflux$Store) {
    _inherits(FormStore, _Reflux$Store);

    function FormStore() {
        _classCallCheck(this, FormStore);

        var _this = _possibleConstructorReturn(this, (FormStore.__proto__ || Object.getPrototypeOf(FormStore)).call(this));

        _this.state = _this.getInitialState();
        _this.listenables = _actions2.default;
        return _this;
    }

    _createClass(FormStore, [{
        key: 'getInitialState',
        value: function getInitialState() {
            return {
                "senderName": "",
                "senderEmail": "",
                "recipient": "",
                "pubName": " ",
                "subject": "",
                "linkURL": "",
                "contentTitle": "",
                "message": "",
                "pubDate": "",
                "toEmailId": [],
                "isCopySender": false,
                "response-messages": []
            };
        }
    }, {
        key: 'onReset',
        value: function onReset() {
            this.setState(this.getInitialState());
        }
    }, {
        key: 'onPostFailed',
        value: function onPostFailed(error) {
            console.error("EmailFailed:", error);
            if (error) {
                _actions4.default.update(["Unable to send email."]);
            }
        }
    }, {
        key: 'onPostCompleted',
        value: function onPostCompleted(response) {
            this.setState({
                "response-messages": response.messages
            });
        }
    }]);

    return FormStore;
}(_reflux2.default.Store);

exports.default = FormStore;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(362);

var _app2 = _interopRequireDefault(_app);

var _actions = __webpack_require__(131);

var _actions2 = _interopRequireDefault(_actions);

__webpack_require__(869);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appId = 'email-modal';
var appElement = document.getElementById(appId);
var senderName = window.medscape.user.name;
var senderEmail = window.medscape.user.email;

if (appElement == null) {
  appElement = document.createElement("div");
  var bodyEl = document.getElementsByTagName("BODY")[0];
  appElement.setAttribute("id", appId);
  bodyEl.appendChild(appElement);
}
var props = {
  senderName: senderName,
  senderEmail: senderEmail
};
var modal = _react2.default.createElement(_app2.default, props);
_reactDom2.default.render(modal, appElement);
exports.default = _actions2.default;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _actions = __webpack_require__(131);

var _actions2 = _interopRequireDefault(_actions);

var _actions3 = __webpack_require__(132);

var _actions4 = _interopRequireDefault(_actions3);

var _actions5 = __webpack_require__(89);

var _actions6 = _interopRequireDefault(_actions5);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmailModalStore = function (_Reflux$Store) {
  _inherits(EmailModalStore, _Reflux$Store);

  function EmailModalStore() {
    _classCallCheck(this, EmailModalStore);

    var _this = _possibleConstructorReturn(this, (EmailModalStore.__proto__ || Object.getPrototypeOf(EmailModalStore)).call(this));

    _this.state = _this.getInitialState();
    _this.listenables = _actions2.default;
    return _this;
  }

  _createClass(EmailModalStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        modalIsOpen: false
      };
    }
  }, {
    key: 'onOpen',
    value: function onOpen() {
      _actions4.default.reset();
      _actions6.default.update([]);
      this.setState({
        modalIsOpen: true
      });
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      _tracking2.default.track("share-email-close");
      this.setState({
        modalIsOpen: false
      });
    }
  }]);

  return EmailModalStore;
}(_reflux2.default.Store);

exports.default = new EmailModalStore();

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(365);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(870);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Formulary = function Formulary(config, $modules) {
  _classCallCheck(this, Formulary);

  var props = {
    path: config.path
  };
  var el = $modules;
  if (el === undefined) return;
  $modules.each(function (index, el) {
    _reactDom2.default.render(_react2.default.createElement(_app2.default, props), el);
  });
};

exports.default = Formulary;

Formulary.selector = '[data-module="Formulary"]';
Formulary.init = function (config, $modules) {
  $modules = $modules || (0, _jquery2.default)(Formulary.selector);
  new Formulary(config, $modules);
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*===========================================================================/
/ Updated on 02/23/17 by MN - AP                                             /
/ Created on 10/19/15 by MN - AP                                             /
/ DEPENDENCIES: jQuery.                                                      /
/ This library is used on Brand Advance 2.0 for Gift Manager Functionality   /
============================================================================*/
var FormBuilder = {
    gm: function gm() {
        var $gmcEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _jquery2.default)('.gift-manager-container');


        if ($gmcEl.length === 0) {
            return;
        }

        if ($gmcEl.data('autoselectgift')) {
            window.packageId = $gmcEl.data('packageid');
            window.promoActivityId = $gmcEl.data('promoactivityid');
            window.tokenId = $gmcEl.data('tokenid');
            window.autoSelectGift = $gmcEl.data('autoselectgift');
            window.defaultAdd = $gmcEl.data('defaultadd');
            window.emailNoProfile = $gmcEl.data('emailnoprofile');
            window.formHide = $gmcEl.data('formhide');
            window.onlyUS = $gmcEl.data('onlyus');
        }

        var officeAddObj = {},
            altAddObj = {},
            emailAddObj = {},
            _domain = "",
            _host = '',
            gmURL = '',
            countryList = {
            "##NULL##": "Select A Country",
            AF: "Afghanistan",
            AL: "Albania",
            DZ: "Algeria",
            AS: "American Samoa",
            AD: "Andorra",
            AO: "Angola",
            AI: "Anguilla",
            AQ: "Antarctica",
            AG: "Antigua and Barbuda",
            AR: "Argentina",
            AM: "Armenia",
            AW: "Aruba",
            AU: "Australia",
            AT: "Austria",
            AZ: "Azerbaijan",
            BS: "Bahamas",
            BH: "Bahrain",
            BD: "Bangladesh",
            BB: "Barbados",
            BY: "Belarus",
            BE: "Belgium",
            BZ: "Belize",
            BJ: "Benin",
            BM: "Bermuda",
            BT: "Bhutan",
            BO: "Bolivia",
            BA: "Bosnia and Herzegovina",
            BW: "Botswana",
            BV: "Bouvet Island",
            BR: "Brazil",
            IO: "British Indian Ocean Territory",
            BN: "Brunei Darussalam",
            BG: "Bulgaria",
            BF: "Burkina Faso",
            BI: "Burundi",
            KH: "Cambodia",
            CM: "Cameroon",
            CA: "Canada",
            CV: "Cape Verde",
            KY: "Cayman Islands",
            CF: "Central African Republic",
            TD: "Chad",
            CL: "Chile",
            CN: "China",
            CX: "Christmas Island",
            CC: "Cocos (Keeling) Islands",
            CO: "Colombia",
            KM: "Comoros",
            CG: "Congo",
            CD: "Congo, the Democratic Republic of the",
            CK: "Cook Islands",
            CR: "Costa Rica",
            CI: "Cote D'Ivoire",
            HR: "Croatia",
            CU: "Cuba",
            CY: "Cyprus",
            CZ: "Czech Republic",
            DK: "Denmark",
            DJ: "Djibouti",
            DM: "Dominica",
            DO: "Dominican Republic",
            EC: "Ecuador",
            EG: "Egypt",
            SV: "El Salvador",
            GQ: "Equatorial Guinea",
            ER: "Eritrea",
            EE: "Estonia",
            ET: "Ethiopia",
            FK: "Falkland Islands (Malvinas)",
            FO: "Faroe Islands",
            FJ: "Fiji",
            FI: "Finland",
            FR: "France",
            GF: "French Guiana",
            PF: "French Polynesia",
            TF: "French Southern Territories",
            GA: "Gabon",
            GM: "Gambia",
            GE: "Georgia",
            DE: "Germany",
            GH: "Ghana",
            GI: "Gibraltar",
            GR: "Greece",
            GL: "Greenland",
            GD: "Grenada",
            GP: "Guadeloupe",
            GU: "Guam",
            GT: "Guatemala",
            GN: "Guinea",
            GW: "Guinea-Bissau",
            GY: "Guyana",
            HT: "Haiti",
            HM: "Heard Island and Mcdonald Islands",
            VA: "Holy See (Vatican City State)",
            HN: "Honduras",
            HK: "Hong Kong",
            HU: "Hungary",
            IS: "Iceland",
            IN: "India",
            ID: "Indonesia",
            IR: "Iran, Islamic Republic of",
            IQ: "Iraq",
            IE: "Ireland",
            IL: "Israel",
            IT: "Italy",
            JM: "Jamaica",
            JP: "Japan",
            JO: "Jordan",
            KZ: "Kazakhstan",
            KE: "Kenya",
            KI: "Kiribati",
            KP: "Korea, Democratic People's Republic of",
            KR: "Korea, Republic of",
            KW: "Kuwait",
            KG: "Kyrgyzstan",
            LA: "Lao People's Democratic Republic",
            LV: "Latvia",
            LB: "Lebanon",
            LS: "Lesotho",
            LR: "Liberia",
            LY: "Libyan Arab Jamahiriya",
            LI: "Liechtenstein",
            LT: "Lithuania",
            LU: "Luxembourg",
            MO: "Macao",
            MK: "Macedonia, the Former Yugoslav Republic of",
            MG: "Madagascar",
            MW: "Malawi",
            MY: "Malaysia",
            MV: "Maldives",
            ML: "Mali",
            MT: "Malta",
            MH: "Marshall Islands",
            MQ: "Martinique",
            MR: "Mauritania",
            MU: "Mauritius",
            YT: "Mayotte",
            MX: "Mexico",
            FM: "Micronesia, Federated States of",
            MD: "Moldova, Republic of",
            MC: "Monaco",
            MN: "Mongolia",
            MS: "Montserrat",
            MA: "Morocco",
            MZ: "Mozambique",
            MM: "Myanmar",
            NA: "Namibia",
            NR: "Nauru",
            NP: "Nepal",
            NL: "Netherlands",
            AN: "Netherlands Antilles",
            NC: "New Caledonia",
            NZ: "New Zealand",
            NI: "Nicaragua",
            NE: "Niger",
            NG: "Nigeria",
            NU: "Niue",
            NF: "Norfolk Island",
            MP: "Northern Mariana Islands",
            NO: "Norway",
            OM: "Oman",
            PK: "Pakistan",
            PW: "Palau",
            PS: "Palestinian Territory, Occupied",
            PA: "Panama",
            PG: "Papua New Guinea",
            PY: "Paraguay",
            PE: "Peru",
            PH: "Philippines",
            PN: "Pitcairn",
            PL: "Poland",
            PT: "Portugal",
            PR: "Puerto Rico",
            QA: "Qatar",
            RE: "Reunion",
            RO: "Romania",
            RU: "Russian Federation",
            RW: "Rwanda",
            SH: "Saint Helena",
            KN: "Saint Kitts and Nevis",
            LC: "Saint Lucia",
            PM: "Saint Pierre and Miquelon",
            VC: "Saint Vincent and the Grenadines",
            WS: "Samoa",
            SM: "San Marino",
            ST: "Sao Tome and Principe",
            SA: "Saudi Arabia",
            SN: "Senegal",
            CS: "Serbia and Montenegro",
            SC: "Seychelles",
            SL: "Sierra Leone",
            SG: "Singapore",
            SK: "Slovakia",
            SI: "Slovenia",
            SB: "Solomon Islands",
            SO: "Somalia",
            ZA: "South Africa",
            GS: "South Georgia and the South Sandwich Islands",
            ES: "Spain",
            LK: "Sri Lanka",
            SD: "Sudan",
            SR: "Suriname",
            SJ: "Svalbard and Jan Mayen",
            SZ: "Swaziland",
            SE: "Sweden",
            CH: "Switzerland",
            SY: "Syrian Arab Republic",
            TW: "Taiwan, Province of China",
            TJ: "Tajikistan",
            TZ: "Tanzania, United Republic of",
            TH: "Thailand",
            TL: "Timor-Leste",
            TG: "Togo",
            TK: "Tokelau",
            TO: "Tonga",
            TT: "Trinidad and Tobago",
            TN: "Tunisia",
            TR: "Turkey",
            TM: "Turkmenistan",
            TC: "Turks and Caicos Islands",
            TV: "Tuvalu",
            UG: "Uganda",
            UA: "Ukraine",
            AE: "United Arab Emirates",
            GB: "United Kingdom",
            US: "United States",
            UM: "United States Minor Outlying Islands",
            UY: "Uruguay",
            UZ: "Uzbekistan",
            VU: "Vanuatu",
            VE: "Venezuela",
            VN: "Viet Nam",
            VG: "Virgin Islands, British",
            VI: "Virgin Islands, U.S.",
            WF: "Wallis and Futuna",
            EH: "Western Sahara",
            YE: "Yemen",
            ZM: "Zambia",
            ZW: "Zimbabwe"
        },
            stateList = {
            "##NULL##": "Select A State",
            AL: "Alabama",
            AK: "Alaska",
            AZ: "Arizona",
            AR: "Arkansas",
            CA: "California",
            CO: "Colorado",
            CT: "Connecticut",
            DE: "Delaware",
            DC: "District Of Columbia",
            FL: "Florida",
            GA: "Georgia",
            HI: "Hawaii",
            ID: "Idaho",
            IL: "Illinois",
            IN: "Indiana",
            IA: "Iowa",
            KS: "Kansas",
            KY: "Kentucky",
            LA: "Louisiana",
            ME: "Maine",
            MD: "Maryland",
            MA: "Massachusetts",
            MI: "Michigan",
            MN: "Minnesota",
            MS: "Mississippi",
            MO: "Missouri",
            MT: "Montana",
            NE: "Nebraska",
            NV: "Nevada",
            NH: "New Hampshire",
            NJ: "New Jersey",
            NM: "New Mexico",
            NY: "New York",
            NC: "North Carolina",
            ND: "North Dakota",
            OH: "Ohio",
            OK: "Oklahoma",
            OR: "Oregon",
            PA: "Pennsylvania",
            RI: "Rhode Island",
            SC: "South Carolina",
            SD: "South Dakota",
            TN: "Tennessee",
            TX: "Texas",
            UT: "Utah",
            VT: "Vermont",
            VA: "Virginia",
            WA: "Washington",
            WV: "West Virginia",
            WI: "Wisconsin",
            WY: "Wyoming"
        },
            autoSelectGiftFlg = autoSelectGift,
            emailUpdateText = 'Please check to update the email on profile.';
        var collectionTypes = [];
        var itemGroups = {};
        var itemGroupsArr = [];

        if (window.location.host.split('.').length > 3) {
            _domain = window.location.host.split('.')[1] + ".";
            _host = window.location.host.split('.')[0] + ".";
        }
        if (_host == 'www.') {
            gmURL = 'medscape.com/gmservice/getitemsandtoken?packageId=';
        } else if (_host === 'wp.') {
            gmURL = 'medscape.com/activity/gmservice/getitems?packageId=';
        }

        //$(document).ready(function() {
        (0, _jquery2.default)('#service-error').hide();
        (0, _jquery2.default)('#giftManagerElm').hide();
        (0, _jquery2.default)('#gm-info-layer').children().hide();
        (0, _jquery2.default)('#thank-you').hide();
        (0, _jquery2.default)('#giftManagerElm').show();
        (0, _jquery2.default)('#gm-main-element').hide();
        (0, _jquery2.default)('#orderForm').children().hide();
        (0, _jquery2.default)('#Giftlist').show();
        if ((0, _jquery2.default)('#giftManagerElm').length > 0) {
            loadGmForm();
        }

        if (typeof formHide != 'undefined') {
            if (formHide) {
                (0, _jquery2.default)('.input-group').addClass('gmHide');
            }
        }
        (0, _jquery2.default)('[data-gmHide]').each(function (index, el) {
            (0, _jquery2.default)(this).addClass('gmHide');
        });

        (0, _jquery2.default)('#hiddenInfo').hide();

        if (window.matchMedia("(max-width: 800px)").matches) {
            (0, _jquery2.default)('.gift-manager-container input').on('focus', function () {
                this.scrollIntoView();
            });
        }

        (0, _jquery2.default)("#orderForm").on('submit', function (evn) {
            //console.log('orderForm submit');
            evn.preventDefault(); // avoid to execute the actual submit of the form.
            if ((0, _jquery2.default)("#Giftlist input[type=radio]").length > 0) {
                if ((0, _jquery2.default)("#Giftlist input[type=radio]:checked").length === 1) {
                    if (autoSelectGiftFlg) {
                        gmFormSubmitFn();
                    } else {
                        gmFormCreateFn();
                        autoSelectGiftFlg = true;
                    }
                } else {
                    alert('Please select one option for Coupon Offer');
                }
            } else {
                if (autoSelectGiftFlg) {
                    gmFormSubmitFn();
                } else {
                    gmFormCreateFn();
                    autoSelectGiftFlg = true;
                }
            }
        });
        //});

        function loadGmForm() {
            var subTokenId = '',
                packageIdVal,
                subpackageIdVal,
                promoActivityVal,
                subpromoActivityVal,
                pageHashVal,
                gmAjaxUrl,
                expirationDate;

            expirationDate = getExpirationDate();

            if (typeof packageId !== 'undefined') {
                packageIdVal = packageId;
                subpackageIdVal = decodeURIComponent(packageIdVal.replace('%3D%3D', ''));
            }
            if (typeof promoActivityId !== 'undefined') {
                promoActivityVal = promoActivityId;
                subpromoActivityVal = decodeURIComponent(promoActivityVal.replace('%3D%3D', ''));
            }
            if (typeof packageId !== 'undefined' && typeof promoActivityId !== 'undefined') {
                pageHashVal = subpromoActivityVal + '_' + subpackageIdVal;
            }

            if (_host === 'www.') {
                gmAjaxUrl = '//' + _host + _domain + gmURL + packageIdVal + '&promoActivityId=' + promoActivityVal + '&testOrder=0&expirationDate=' + expirationDate;
            } else if (_host === 'wp.') {
                gmAjaxUrl = '//' + _host + _domain + gmURL + packageIdVal + '&promoActivityId=' + promoActivityVal + '&tokenId=' + tokenId + '&service=1&testOrder=0';
            } else {
                gmAjaxUrl = '/public/static/assets/json/gift_manager_activia.json';
            }

            _jquery2.default.ajax({
                url: gmAjaxUrl,
                dataType: 'json',
                contentType: 'application/json',
                type: 'GET',
                success: function success(json) {
                    (0, _jquery2.default)('#gm-info-layer').show();
                    (0, _jquery2.default)('#orderForm').show();
                    if (_host === 'www.') {
                        tokenId = json.token;
                        subTokenId = tokenId ? tokenId.replace('%3D%3D', '') : '';
                    }
                    (0, _jquery2.default)("#gm_tokenId").val(decodeURIComponent(subTokenId));
                    (0, _jquery2.default)('#activityHash').attr('name', (0, _jquery2.default)('#activityHash').attr('name') + pageHashVal);
                    (0, _jquery2.default)('#activityHash').attr('value', subpromoActivityVal);
                    (0, _jquery2.default)('#packageHash').attr('name', (0, _jquery2.default)('#packageHash').attr('name') + pageHashVal);
                    (0, _jquery2.default)('#packageHash').attr('value', subpackageIdVal);
                    (0, _jquery2.default)(json.giftItems).each(function () {
                        var giftImg = '',
                            itemText = '';
                        if (this.imgURL !== null) {
                            if (this.imgURL.indexOf("img") !== -1 || this.imgURL.indexOf("images") !== -1) {
                                giftImg = '<img border="0" class="honorimg" alt="" src="' + this.imgURL + '" />';
                            }
                        }
                        if (this.itemDesc !== null) {
                            itemText = this.itemDesc;
                        }

                        if (this.category.id === 1 || this.category.id === 6) {
                            (0, _jquery2.default)('#Giftlist').append('<div class="giftItemRow"><input type="radio" value="' + this.itemIdHash + '" name="gm.giftitem' + pageHashVal + '" /><h4>' + this.itemName + '</h4><p>' + itemText + '</p><p>' + giftImg + '</p><input type="hidden" value="' + this.options[0].idHash + '" name="gm.option' + this.itemIdHash + '_' + pageHashVal + '" id="gm.option' + this.itemIdHash + '_' + pageHashVal + '" />');
                        } else {
                            (0, _jquery2.default)('#Giftlist').append('<div class="giftItemRow"><input type="checkbox" value="' + this.itemIdHash + '" name="gm.item' + pageHashVal + '" /><h4>' + this.itemName + '</h4><p>' + itemText + '</p><p>' + giftImg + '</p><input type="hidden" value="' + this.options[0].idHash + '" name="gm.option' + this.itemIdHash + '_' + pageHashVal + '" id="gm.option' + this.itemIdHash + '_' + pageHashVal + '" />');
                        }
                        var giftItemVal = this.itemIdHash;

                        (0, _jquery2.default)(this.fulfillmentDetails.groups).each(function () {

                            if (jQuery.inArray(this.id, collectionTypes) == -1) {
                                collectionTypes.push(this.id);
                                if (this.groups.length > 0) {
                                    (0, _jquery2.default)(this.groups).each(function () {

                                        (0, _jquery2.default)(this.dataCollectionTypes).each(function () {
                                            var userDataVal;
                                            switch (this.id) {
                                                case 12:
                                                    userDataVal = userDataPrePop(json.giftItems[0].captureFields.emailAddress);
                                                    emailAddObj.email = userDataVal;
                                                    (0, _jquery2.default)('#subGroupTitle-emailAdd').html(userDataVal);
                                                    break;
                                                case 29:
                                                    userDataVal = 1; //save email to profile flag
                                                    break;
                                                case 13:
                                                    userDataVal = userDataPrePop(json.giftItems[0].captureFields.contactInfo[0].street1);
                                                    officeAddObj.str1 = userDataVal;
                                                    (0, _jquery2.default)('#subGroupTitle-officeSt1').html(userDataVal);
                                                    break;
                                                case 14:
                                                    userDataVal = userDataPrePop(json.giftItems[0].captureFields.contactInfo[0].street2);
                                                    officeAddObj.str2 = userDataVal;
                                                    break;
                                                case 15:
                                                    userDataVal = userDataPrePop(json.giftItems[0].captureFields.contactInfo[0].city);
                                                    officeAddObj.city = userDataVal;
                                                    break;
                                                case 16:
                                                    userDataVal = userDataPrePop(json.giftItems[0].captureFields.contactInfo[0].stateAbbreviation);
                                                    userDataVal = userDataVal.toUpperCase();
                                                    officeAddObj.st = userDataVal;
                                                    break;
                                                case 17:
                                                    userDataVal = userDataPrePop(json.giftItems[0].captureFields.contactInfo[0].zipCode);
                                                    officeAddObj.zip = userDataVal;
                                                    break;
                                                case 35:
                                                    userDataVal = userDataPrePop(json.giftItems[0].captureFields.contactInfo[0].countryAbbreviation);
                                                    userDataVal = userDataVal.toUpperCase();
                                                    officeAddObj.ct = userDataVal;
                                                    break;
                                                case 18:
                                                    userDataVal = userDataPrePop(json.giftItems[0].captureFields.contactInfo[1].street1);
                                                    altAddObj.str1 = userDataVal;
                                                    (0, _jquery2.default)('#subGroupTitle-altSt1').html(userDataVal);
                                                    break;
                                                case 19:
                                                    userDataVal = userDataPrePop(json.giftItems[0].captureFields.contactInfo[1].street2);
                                                    altAddObj.str2 = userDataVal;
                                                    break;
                                                case 20:
                                                    userDataVal = userDataPrePop(json.giftItems[0].captureFields.contactInfo[1].city);
                                                    altAddObj.city = userDataVal;
                                                    break;
                                                case 21:
                                                    userDataVal = userDataPrePop(json.giftItems[0].captureFields.contactInfo[1].stateAbbreviation);
                                                    userDataVal = userDataVal.toUpperCase();
                                                    altAddObj.st = userDataVal;
                                                    break;
                                                case 22:
                                                    userDataVal = userDataPrePop(json.giftItems[0].captureFields.contactInfo[1].zipCode);
                                                    altAddObj.zip = userDataVal;
                                                    break;
                                                case 36:
                                                    userDataVal = userDataPrePop(json.giftItems[0].captureFields.contactInfo[1].countryAbbreviation);
                                                    userDataVal = userDataVal.toUpperCase();
                                                    altAddObj.ct = userDataVal;
                                                    break;
                                            }
                                            if (this.id === 16 || this.id === 21) {
                                                var stateField;
                                                if (onlyUS) {
                                                    var selectSt = (0, _jquery2.default)('<select class="gmInput" data-gm-name="' + this.name + '" id="gm_dcType_' + this.id + '" name="gm.dcType_' + this.id + '" value="' + userDataVal + '" />');
                                                    for (var state in stateList) {
                                                        (0, _jquery2.default)('<option />', { value: state, text: stateList[state] }).appendTo(selectSt);
                                                    }
                                                    stateField = selectSt;
                                                } else {
                                                    var inputSt = (0, _jquery2.default)('<input type="text" class="gmInput" data-gm-name="' + this.name + '" id="gm_dcType_' + this.id + '" name="gm.dcType_' + this.id + '" value="' + userDataVal + '" />');
                                                    stateField = inputSt;
                                                }
                                                (0, _jquery2.default)('#hiddenInfo_DCs').append('<label   class="gmLabel" data-gm-name="' + this.name + '" for="gm_dcType_' + this.id + '" name="gm.dcType_' + this.id + '" value="' + userDataVal + '" >' + this.name + '</label>').append(stateField);
                                                var id1 = 'gm_dcType_' + this.id;

                                                document.getElementById(id1).value = userDataVal;
                                            } else if (this.id === 35 || this.id === 36) {
                                                var selectCt = (0, _jquery2.default)('<select class="gmInput" data-gm-name="' + this.name + '" id="gm_dcType_' + this.id + '" name="gm.dcType_' + this.id + '" value="' + userDataVal + '" />');
                                                for (var country in countryList) {
                                                    (0, _jquery2.default)('<option />', { value: country, text: countryList[country] }).appendTo(selectCt);
                                                }
                                                (0, _jquery2.default)('#hiddenInfo_DCs').append('<label   class="gmLabel" data-gm-name="' + this.name + '" for="gm_dcType_' + this.id + '" name="gm.dcType_' + this.id + '" value="' + userDataVal + '" >' + this.name + '</label>').append(selectCt);
                                                var id2 = 'gm_dcType_' + this.id;
                                                document.getElementById(id2).value = userDataVal;
                                            } else {
                                                (0, _jquery2.default)('#hiddenInfo_DCs').append('<label   class="gmLabel" data-gm-name="' + this.name + '" for="gm_dcType_' + this.id + '" name="gm.dcType_' + this.id + '" value="' + userDataVal + '" >' + this.name + '</label><input type="text" class="gmInput" data-gm-name="' + this.name + '" id="gm_dcType_' + this.id + '" name="gm.dcType_' + this.id + '" value="' + userDataVal + '" /><br>');
                                            }
                                        });
                                    });
                                }
                                if (this.dataCollectionTypes.length > 0) {
                                    (0, _jquery2.default)(this.dataCollectionTypes).each(function () {
                                        var userDataVal;
                                        switch (this.id) {
                                            case 23:
                                                userDataVal = userDataPrePop(json.giftItems[0].captureFields.contactInfo[0].phoneNumber);
                                                if (userDataVal === '') {
                                                    (0, _jquery2.default)('#phone_field_14').attr('value', 'XXX-XXX-XXXX');
                                                } else {
                                                    (0, _jquery2.default)('#phone_field_14').attr('value', userDataVal);
                                                }
                                                break;
                                            case 24:
                                                userDataVal = userDataPrePop(json.giftItems[0].captureFields.contactInfo[0].faxNumber);
                                                if (userDataVal === '') {
                                                    (0, _jquery2.default)('#fax_field_15').attr('value', 'XXX-XXX-XXXX');
                                                } else {
                                                    (0, _jquery2.default)('#fax_field_15').attr('value', userDataVal);
                                                }
                                                break;
                                            case 25:
                                                userDataVal = userDataPrePop(json.giftItems[0].captureFields.sln);
                                                (0, _jquery2.default)('#sln_field_16').attr('value', userDataVal);
                                                break;
                                            case 26:
                                                userDataVal = userDataPrePop(json.giftItems[0].captureFields.licenseState);
                                                if (userDataVal !== '') {
                                                    (0, _jquery2.default)('#LicensingState option[value=' + userDataVal + ']').prop('selected', true);
                                                }
                                                break;
                                            case 27:
                                                userDataVal = userDataPrePop(json.giftItems[0].captureFields.dea);
                                                (0, _jquery2.default)('#dea_field_18').attr('value', userDataVal);
                                                break;
                                            case 28:
                                                userDataVal = userDataPrePop(json.giftItems[0].captureFields.dob);
                                                var dobArr = userDataVal.split("-");
                                                userDataVal = dobArr[1] + "." + dobArr[2] + "." + dobArr[0];
                                                if (userDataVal !== '') {
                                                    (0, _jquery2.default)('#DOBMonth option[value=' + dobArr[1] + ']').prop('selected', true);
                                                    (0, _jquery2.default)('#regday_input_19').attr('value', dobArr[2]);
                                                    (0, _jquery2.default)('#regyear_input_19').attr('value', dobArr[0]);
                                                }
                                                break;
                                            case 30:
                                                userDataVal = "##NULL##";
                                                break;
                                            case 31:
                                                userDataVal = "##NULL##";
                                                break;
                                            case 32:
                                                userDataVal = "##NULL##";
                                                break;
                                            case 33:
                                                userDataVal = "##NULL##";
                                                break;
                                            case 34:
                                                userDataVal = "##NULL##";
                                                break;
                                        }
                                        (0, _jquery2.default)('#hiddenInfo_DCs').append('<input type="hidden" id="gm_dcType_' + this.id + '" name="gm.dcType_' + this.id + '" value="' + userDataVal + '" />');
                                    });
                                }
                            }

                            if (!itemGroups.hasOwnProperty(giftItemVal)) {
                                itemGroupsArr = [];
                                itemGroups[giftItemVal] = itemGroupsArr;
                            }

                            if (this.groups.length > 0) {
                                (0, _jquery2.default)(this.groups).each(function () {
                                    var groupId = this.id;
                                    (0, _jquery2.default)(this.dataCollectionTypes).each(function () {
                                        if (jQuery.inArray(groupId, itemGroupsArr) == -1) {
                                            itemGroupsArr.push(groupId);
                                            itemGroups[giftItemVal] = itemGroupsArr;
                                        }
                                    });
                                });
                            }
                            if (this.dataCollectionTypes.length > 0) {
                                var groupId = this.id;
                                (0, _jquery2.default)(this.dataCollectionTypes).each(function () {
                                    if (jQuery.inArray(groupId, itemGroupsArr) == -1) {
                                        itemGroupsArr.push(groupId);
                                        itemGroups[giftItemVal] = itemGroupsArr;
                                    }
                                });
                            }
                        });
                    });

                    (0, _jquery2.default)("#customGroups").append('<input type="radio" id="subGroupValue-3" name="groupValue-1" value="3">');
                    (0, _jquery2.default)("#customGroups").append('<input type="radio" id="subGroupValue-4" name="groupValue-2" value="4">');
                    if (autoSelectGiftFlg) {
                        gmFormCreateFn();
                    }
                    (0, _jquery2.default)('#gm-info-msg').show();
                    gm_global_popups('email');
                    //console.log('submit show');
                    (0, _jquery2.default)('#submit_order_button').show();
                    if (typeof brandAdvance2 == 'undefined') {
                        (0, _jquery2.default)('#cancel-button').show();
                    }
                },
                error: function error(data) {
                    (0, _jquery2.default)('#gm-info-layer').children().hide();
                    (0, _jquery2.default)('#service-error').show();
                    (0, _jquery2.default)('#giftManagerElm').hide();
                },
                complete: function complete() {
                    /*=== Function for hiding ISI on focusing input ===*/
                    if (typeof brandAdvance2 != 'undefined') {
                        brandAdvance2.inputIsiBind();
                    }
                }
            });
        }

        function getExpirationDate() {
            var expirationDate = new Date();
            var dd = expirationDate.getDate();
            var mm = expirationDate.getMonth() + 1; //January is 0!
            var yyyy = expirationDate.getFullYear() + 1;

            if (dd < 10) {
                dd = '0' + dd;
            }

            if (mm < 10) {
                mm = '0' + mm;
            }

            expirationDate = yyyy + '-' + mm + '-' + dd;
            return expirationDate;
        }

        function thankYouNotice() {
            _tracking2.default.pageLink('gm-submit');
            (0, _jquery2.default)('#gm-info-layer').children().hide();
            (0, _jquery2.default)('#giftManagerElm').hide();
            (0, _jquery2.default)('#giftManagerElm').empty();
            (0, _jquery2.default)('#thank-you').show();
        }

        function userDataPrePop(userPass) {
            var CollectTypeVal;
            if (userPass === null) {
                CollectTypeVal = '';
            } else {
                CollectTypeVal = userPass;
            }
            return CollectTypeVal;
        }

        function gmFormCreateFn() {
            (0, _jquery2.default)("div#Giftlist").hide();
            if (autoSelectGift) {
                (0, _jquery2.default)("div#Giftlist input").prop("checked", true);
            }
            (0, _jquery2.default)("#hiddenInfo_Groups").empty();
            (0, _jquery2.default)("div[id^='group-']").hide();
            (0, _jquery2.default)("div#Giftlist input:checked").each(function () {
                var giftTempVal = this.value;
                (0, _jquery2.default)(itemGroups[giftTempVal]).each(function (index) {
                    (0, _jquery2.default)("#group-" + (0, _jquery2.default)(itemGroups[giftTempVal])[index]).show();
                    if ((0, _jquery2.default)('#gm_group_' + (0, _jquery2.default)(itemGroups[giftTempVal])[index]).length === 0) {
                        (0, _jquery2.default)("#hiddenInfo_Groups").append('<input type="hidden" id="gm_group_' + (0, _jquery2.default)(itemGroups[giftTempVal])[index] + '" name="gm.group_' + (0, _jquery2.default)(itemGroups[giftTempVal])[index] + '" value="true">');
                    }
                });
            });
            (0, _jquery2.default)('#customGroups').hide();
            (0, _jquery2.default)("#subGroupValue-3").prop("checked", true);
            (0, _jquery2.default)("#subGroupValue-4").prop("checked", true);
            if (defaultAdd == 1) {
                gm_global_popups('officeadd');
                (0, _jquery2.default)('#gm_group_5').remove();
                if ((0, _jquery2.default)('#gm_group_4').length === 0) {
                    (0, _jquery2.default)("#hiddenInfo_Groups").append('<input type="hidden" id="gm_group_4" name="gm.group_4" value="true">');
                }
            } else if (defaultAdd == 2) {
                gm_global_popups('altadd');
                (0, _jquery2.default)('#gm_group_4').remove();
                if ((0, _jquery2.default)('#gm_group_5').length === 0) {
                    (0, _jquery2.default)("#hiddenInfo_Groups").append('<input type="hidden" id="gm_group_5" name="gm.group_5" value="true">');
                }
            }
            if (onlyUS) {
                (0, _jquery2.default)('.office-country-field').addClass('gmHide');
            } else {
                (0, _jquery2.default)('.officestate_field, .office-zip-field').addClass('gmHide');
            }
        }

        function gmFormSubmitFn() {
            //console.log('Function here!');
            if ((0, _jquery2.default)('#gm_group_3').length === 0) {
                (0, _jquery2.default)("#gm_dcType_12").remove();
                (0, _jquery2.default)("#gm_dcType_29").remove();
            }
            if ((0, _jquery2.default)('#gm_group_4').length === 0) {
                (0, _jquery2.default)("#gm_dcType_13").remove();
                (0, _jquery2.default)("#gm_dcType_14").remove();
                (0, _jquery2.default)("#gm_dcType_15").remove();
                (0, _jquery2.default)("#gm_dcType_16").remove();
                (0, _jquery2.default)("#gm_dcType_17").remove();
                (0, _jquery2.default)("#gm_dcType_35").remove();
            }
            if ((0, _jquery2.default)('#gm_group_5').length === 0) {
                (0, _jquery2.default)("#gm_dcType_18").remove();
                (0, _jquery2.default)("#gm_dcType_19").remove();
                (0, _jquery2.default)("#gm_dcType_20").remove();
                (0, _jquery2.default)("#gm_dcType_21").remove();
                (0, _jquery2.default)("#gm_dcType_22").remove();
                (0, _jquery2.default)("#gm_dcType_36").remove();
            }
            if ((0, _jquery2.default)('#gm_group_6').length === 0) {
                (0, _jquery2.default)("#gm_dcType_23").remove();
            }
            if ((0, _jquery2.default)('#gm_group_7').length === 0) {
                (0, _jquery2.default)("#gm_dcType_24").remove();
            }
            if ((0, _jquery2.default)('#gm_group_8').length === 0) {
                (0, _jquery2.default)("#gm_dcType_25").remove();
            }
            if ((0, _jquery2.default)('#gm_group_9').length === 0) {
                (0, _jquery2.default)("#gm_dcType_26").remove();
            }
            if ((0, _jquery2.default)('#gm_group_10').length === 0) {
                (0, _jquery2.default)("#gm_dcType_27").remove();
            }
            if ((0, _jquery2.default)('#gm_group_11').length === 0) {
                (0, _jquery2.default)("#gm_dcType_28").remove();
            }
            if ((0, _jquery2.default)('#gm_group_12').length === 0) {
                (0, _jquery2.default)("#gm_dcType_30").remove();
            }
            if ((0, _jquery2.default)('#gm_group_13').length === 0) {
                (0, _jquery2.default)("#gm_dcType_31").remove();
            }
            if ((0, _jquery2.default)('#gm_group_14').length === 0) {
                (0, _jquery2.default)("#gm_dcType_32").remove();
            }
            if ((0, _jquery2.default)('#gm_group_15').length === 0) {
                (0, _jquery2.default)("#gm_dcType_33").remove();
            }
            if ((0, _jquery2.default)('#gm_group_16').length === 0) {
                (0, _jquery2.default)("#gm_dcType_34").remove();
            }

            (0, _jquery2.default)("input[id^='gm_dcType_']").each(function () {
                var hideTempId = this.id;
                var hideTempVal = this.value;
                document.getElementById(hideTempId).value = hideTempVal;
            });

            var emailEntered = (0, _jquery2.default)('#text_field_email').val();
            (0, _jquery2.default)("#gm_dcType_12").val(emailEntered);
            if ((0, _jquery2.default)("#checkbox_field_1").is(':checked')) {
                (0, _jquery2.default)("#gm_dcType_29").val('1');
            } else {
                (0, _jquery2.default)("#gm_dcType_29").val('0');
            }

            if (defaultAdd === 1) {
                (0, _jquery2.default)("#gm_dcType_13").val((0, _jquery2.default)('#text_field_office1').val());
                (0, _jquery2.default)("#gm_dcType_14").val((0, _jquery2.default)('#text_field_office2').val());
                (0, _jquery2.default)("#gm_dcType_15").val((0, _jquery2.default)('#text_field_officecity').val());
                (0, _jquery2.default)("#gm_dcType_16").val((0, _jquery2.default)('#officestate_field').val());
                (0, _jquery2.default)("#gm_dcType_17").val((0, _jquery2.default)('#office_zip_field').val());
                (0, _jquery2.default)("#gm_dcType_35").val((0, _jquery2.default)('#office_countries').val());
            } else if (defaultAdd === 2) {
                (0, _jquery2.default)("#gm_dcType_18").val((0, _jquery2.default)('#text_field_alt1').val());
                (0, _jquery2.default)("#gm_dcType_19").val((0, _jquery2.default)('#text_field_alt2').val());
                (0, _jquery2.default)("#gm_dcType_20").val((0, _jquery2.default)('#text_field_altcity').val());
                (0, _jquery2.default)("#gm_dcType_21").val((0, _jquery2.default)('#altstate_field').val());
                (0, _jquery2.default)("#gm_dcType_22").val((0, _jquery2.default)('#alt_zip_field').val());
                (0, _jquery2.default)("#gm_dcType_36").val((0, _jquery2.default)('#alt_countries').val());
            }

            (0, _jquery2.default)('.input-group').removeClass('error');
            var url = (0, _jquery2.default)('#orderForm').attr('action'); // the script where you handle the form input.=
            if (_host == 'www.') {
                url = '/gmservice/processorder';
            }
            _jquery2.default.ajax({
                type: "POST",
                url: url,
                data: (0, _jquery2.default)("#orderForm").serialize(),
                success: function success(Postdata) {
                    if (Postdata.success === false) {
                        var errorResult = [];
                        _jquery2.default.each(Postdata.errormsg, function (i, e) {
                            if (_jquery2.default.inArray(e, errorResult) == -1) errorResult.push(e);
                        });
                        (0, _jquery2.default)('#gm-info-msg').hide();
                        (0, _jquery2.default)('#gm-error-msg').show();
                        (0, _jquery2.default)('#formInfo input, #formInfo select').not('#text_field_office2').not('#text_field_alt2').each(function (index, el) {
                            var gmName = '';
                            gmName = gmName + (0, _jquery2.default)(this).data('gm-name');
                            for (var i = 0; i < errorResult.length; i++) {
                                var errorName = '';
                                errorName = errorName + errorResult[i];
                                if (gmName.indexOf('Email') > -1 && errorName.indexOf('Email') > -1) {
                                    (0, _jquery2.default)(this).parent().addClass('error');
                                } else if (gmName.indexOf('Line') > -1 && errorName.indexOf('Line') > -1) {
                                    (0, _jquery2.default)(this).parent().addClass('error');
                                } else if (gmName.indexOf('City') > -1 && errorName.indexOf('City') > -1) {
                                    (0, _jquery2.default)(this).parent().addClass('error');
                                } else if (gmName.indexOf('State') > -1 && errorName.indexOf('State') > -1) {
                                    (0, _jquery2.default)(this).parent().addClass('error');
                                } else if (gmName.indexOf('Zip') > -1 && errorName.indexOf('Zip') > -1) {
                                    (0, _jquery2.default)(this).parent().addClass('error');
                                } else if (gmName.indexOf('Country') > -1 && errorName.indexOf('Country') > -1) {
                                    (0, _jquery2.default)(this).parent().addClass('error');
                                }
                            }
                        });
                    } else if (Postdata.success === true) {
                        thankYouNotice();
                    }
                },
                error: function error() {
                    (0, _jquery2.default)('#gm-info-layer').children().hide();
                    (0, _jquery2.default)('#service-error').show();
                    (0, _jquery2.default)('#giftManagerElm').hide();
                },
                complete: function complete() {
                    if (typeof brandAdvance2 != 'undefined') {
                        if ((0, _jquery2.default)('.scene').length && (0, _jquery2.default)('#header').length) {
                            (0, _jquery2.default)('.gift-manager-container').closest('.scene')[0].scrollIntoView();
                            document.body.scrollTop -= (0, _jquery2.default)('#header').height();
                            document.documentElement.scrollTop -= (0, _jquery2.default)('#header').height();
                        }
                    }
                }
            });
        }

        function gm_global_popups(popId) {
            if (popId == "email") {
                if ((0, _jquery2.default)('#emailInfo').length > 0) {
                    (0, _jquery2.default)('[data-gm-name="Email Address"]').clone().appendTo('.text_field_email').removeAttr('id').removeAttr('style').attr('id', 'text_field_email');
                    (0, _jquery2.default)('<input type="checkbox" id="checkbox_field_1" value="1" checked="checked" /><label id="prototype_checkbox_1" for="checkbox_field_1">' + emailUpdateText + ' </label>').appendTo('.checkbox_field_1');
                    if (emailNoProfile) {
                        (0, _jquery2.default)('#checkbox_field_1').prop('checked', false);
                        (0, _jquery2.default)("#gm_dcType_29").val('0');
                    }
                    (0, _jquery2.default)('.input-group').children('label').removeAttr('id');
                }
            } else if (popId == "officeadd") {
                if ((0, _jquery2.default)('#formInfo').length > 0) {
                    (0, _jquery2.default)('[data-gm-name="Office Address Line 1"]').clone().appendTo('.text-field-office1').removeAttr('id').removeAttr('style').attr('id', 'text_field_office1');
                    (0, _jquery2.default)('[data-gm-name="Office Address Line 2"]').clone().appendTo('.text-field-office2').removeAttr('id').removeAttr('style').attr('id', 'text_field_office2');
                    (0, _jquery2.default)('[data-gm-name="Office City"]').clone().appendTo('.text-field-officecity').removeAttr('id').removeAttr('style').attr('id', 'text_field_officecity');
                    (0, _jquery2.default)('[data-gm-name="Office State"]').clone().appendTo('.officestate_field').removeAttr('id').removeAttr('style').attr('id', 'officestate_field').val((0, _jquery2.default)('#gm_dcType_16').val());
                    (0, _jquery2.default)('[data-gm-name="Office Zip Code"]').clone().appendTo('.office-zip-field').removeAttr('id').removeAttr('style').attr('id', 'office_zip_field');
                    (0, _jquery2.default)('[data-gm-name="Office Country"]').clone().appendTo('.office-country-field').removeAttr('id').addClass('office_countries').removeAttr('style').attr('id', 'office_countries').val((0, _jquery2.default)('#gm_dcType_35').val());
                    (0, _jquery2.default)('.input-group').children('label').removeAttr('id');
                }
            } else if (popId == "altadd") {
                if ((0, _jquery2.default)('#formInfo').length > 0) {
                    (0, _jquery2.default)('[data-gm-name="Alternate Address Line 1"]').clone().appendTo('.text-field-office1').removeAttr('id').removeAttr('style').attr('id', 'text_field_alt1');
                    (0, _jquery2.default)('[data-gm-name="Alternate Address Line 2"]').clone().appendTo('.text-field-office2').removeAttr('id').removeAttr('style').attr('id', 'text_field_alt2');
                    (0, _jquery2.default)('[data-gm-name="Alternate City"]').clone().appendTo('.text-field-officecity').removeAttr('id').removeAttr('style').attr('id', 'text_field_altcity');
                    (0, _jquery2.default)('[data-gm-name="Alternate State"]').clone().appendTo('.officestate_field').removeAttr('id').removeAttr('style').attr('id', 'altstate_field').val((0, _jquery2.default)('#gm_dcType_21').val());
                    (0, _jquery2.default)('[data-gm-name="Alternate Zip Code"]').clone().appendTo('.office-zip-field').removeAttr('id').removeAttr('style').attr('id', 'alt_zip_field');
                    (0, _jquery2.default)('[data-gm-name="Alternate Country"]').clone().appendTo('.office-country-field').removeAttr('id').addClass('alt_countries').removeAttr('style').attr('id', 'alt_countries').val((0, _jquery2.default)('#gm_dcType_36').val());
                    (0, _jquery2.default)('.input-group').children('label').removeAttr('id');
                }
            }
        }
    }

};

exports.default = FormBuilder;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _store = __webpack_require__(326);

var _store2 = _interopRequireDefault(_store);

var _actionsFactory = __webpack_require__(101);

var _actionsFactory2 = _interopRequireDefault(_actionsFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  store: _store2.default,
  actions: _actionsFactory2.default
};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _actionsFactory = __webpack_require__(101);

var _actionsFactory2 = _interopRequireDefault(_actionsFactory);

var _actions = __webpack_require__(102);

var _actions2 = _interopRequireDefault(_actions);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StoreCache = {};

var ApiStore = function (_Reflux$Store) {
  _inherits(ApiStore, _Reflux$Store);

  function ApiStore(props) {
    _classCallCheck(this, ApiStore);

    var _this = _possibleConstructorReturn(this, (ApiStore.__proto__ || Object.getPrototypeOf(ApiStore)).call(this));

    _this.isSubmitted = false;
    _this.qnaProps = props;
    _this.configId = props.configId;
    _this.state = _this.getInitialState(props.qid, props.formId);
    _this.listenables = _actionsFactory2.default.get(props.qid + '-' + props.formId);
    _this.ApiActions = _actionsFactory2.default.get(props.qid + '-' + props.formId);
    return _this;
  }

  _createClass(ApiStore, [{
    key: 'reset',
    value: function reset(props) {
      this.state = this.getInitialState(props.qid, props.formId);
      this.listenables = _actionsFactory2.default.get(props.qid + '-' + props.formId);
    }
  }, {
    key: 'getInitialState',
    value: function getInitialState() {
      var qid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var formId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var _questionnaire = {
        qid: qid,
        displayOrder: 1,
        expirationDate: null,
        formId: formId,
        formTitle: '',
        formType: 'DEFAULT',
        formTypeId: 1,
        gated: false,
        introduction: null,
        isActive: 1,
        questions: [],
        viewResults: false,
        isSubmitted: this.isSubmitted
      };
      return _questionnaire;
    }
  }, {
    key: 'onGetFailed',
    value: function onGetFailed(error) {
      console.error("Get QNA Failed:", error);
    }
  }, {
    key: 'onPostFailed',
    value: function onPostFailed(error) {
      console.error("Post QNA Failed:", error);
      var errorMsg = error.responseJSON ? error.responseJSON.responseMsg.message : error.statusText;
      _actions2.default.update([errorMsg]);
    }
  }, {
    key: 'getQuestions',
    value: function getQuestions(questions) {
      return questions.map(function (question) {
        return new QuestionStore(question);
      });
    }
  }, {
    key: 'onGetCompleted',
    value: function onGetCompleted(data) {
      this.getQnaData = data;
      var state = this.getInitialState();
      state = _jquery2.default.extend(state, data);
      this.setState(state);
    }
  }, {
    key: 'onPostCompleted',
    value: function onPostCompleted(response) {
      var _this2 = this;

      // TODO: for multiple questions, update code
      if (response.ok && !response.errorMessage) {
        _tracking2.default.track('qna-' + this.configId + '_submit');
        if (window.location.hostname == 'localhost') {
          var testResponses = {
            "qna-38739-4": { "formId": 4, "formTitle": "Q1", "formTypeId": 3, "formType": "INTERNAL", "displayOrder": 2, "introduction": null, "questions": [{ "questionId": 297187, "questionText": "When used in the context of the manufacturing of biologics, which of the following is meant by the term \"drift\"?", "displayType": 1, "poll": true, "required": true, "score": false, "displayOrder": 9, "discussion": "It is important to note that there is already guidance limiting the variation in any reference biologic products that may occur when there are manufacturing changes.<sup>[17]</sup> These manufacturing process modifications may occur when there is a change in sourcing of components in manufacturing or when there are attempts to improve yield. The variation in the product that can occur due to these changes is commonly referred to as \"manufacturing drift\" and the FDA guidance is designed to ensure that these changes don't produce any meaningful differences in the biologic product over time.<sup>[18]</sup> When changes in the products are within acceptable ranges according to this guidance, then the marketed product will not require any change in the label. This demonstration of comparability within a reference product over time is comparable to the comparability exercise needed to demonstrate biosimilarity.<sup type=\"ref\">[19]</sup> In fact, similar words are used in the guidance on manufacturing changes in that \"the demonstration of comparability does not necessarily mean that the quality attributes of the pre-change and post-change product are identical, but that they are highly similar and that the existing knowledge is sufficiently predictive to ensure that any differences in quality attributes have no adverse impact upon safety or efficacy of the drug product.\"<sup>[17]</sup>", "introduction": null, "choices": [{ "choiceText": "Changes in regulations over time", "choiceId": 939349, "displayOrder": 1, "correct": false, "selected": false, "explanation": null, "totalResponses": "24", "totalAbsoluteResponseCount": 517 }, { "choiceText": "Changes in analytics used to monitor biologic agents", "choiceId": 939351, "displayOrder": 2, "correct": false, "selected": false, "explanation": null, "totalResponses": "16", "totalAbsoluteResponseCount": 340 }, { "choiceText": "Changes in the molecular structure of the product that occurs over time due to changes in sourcing or in process to improve yield", "choiceId": 939353, "displayOrder": 3, "correct": false, "selected": false, "explanation": null, "totalResponses": "51", "totalAbsoluteResponseCount": 1080 }, { "choiceText": "Changes in clinical indications for a product", "choiceId": 939355, "displayOrder": 4, "correct": false, "selected": true, "explanation": null, "totalResponses": "10", "totalAbsoluteResponseCount": 218 }], "showAnsTable": true, "showQuestion": true, "showResult": true, "responseText": null, "answered": true, "answeredCorrectly": false, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": null, "totalResponses": 2100.0, "viewResults": false, "specialties": null, "professions": null }], "isActive": 1, "gated": true, "expirationDate": null, "viewResults": false },
            "qna-4000-2": { "formId": 2, "formTitle": "Patient Profiles in Psoriatic Disease: A Case-Based Approach", "formTypeId": 5, "formType": "EVAL", "displayOrder": 1, "introduction": null, "questions": [{ "questionId": 499, "questionText": "This activity supported achievement of each of the learning objectives. [Please use the \"additional comments\" field below to provide further information].", "displayType": 1, "poll": false, "required": false, "score": false, "displayOrder": 1, "discussion": null, "introduction": null, "choices": [{ "choiceText": "Strongly Agree", "choiceId": 1100, "displayOrder": 1, "correct": true, "selected": true, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Agree", "choiceId": 1101, "displayOrder": 2, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "No Opinion", "choiceId": 1102, "displayOrder": 3, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Disagree", "choiceId": 1103, "displayOrder": 4, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Strongly Disagree", "choiceId": 1104, "displayOrder": 5, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": false, "showQuestion": false, "showResult": false, "responseText": null, "answered": true, "answeredCorrectly": true, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 500, "questionText": "The material was organized clearly for learning to occur.", "displayType": 1, "poll": false, "required": false, "score": false, "displayOrder": 2, "discussion": null, "introduction": null, "choices": [{ "choiceText": "Strongly Agree", "choiceId": 1100, "displayOrder": 1, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Agree", "choiceId": 1101, "displayOrder": 2, "correct": true, "selected": true, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "No Opinion", "choiceId": 1102, "displayOrder": 3, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Disagree", "choiceId": 1103, "displayOrder": 4, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Strongly Disagree", "choiceId": 1104, "displayOrder": 5, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": false, "showQuestion": false, "showResult": false, "responseText": null, "answered": true, "answeredCorrectly": true, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 501, "questionText": "The content learned from this activity will impact my practice and/or the healthcare team.", "displayType": 1, "poll": false, "required": false, "score": false, "displayOrder": 3, "discussion": null, "introduction": null, "choices": [{ "choiceText": "Strongly Agree", "choiceId": 1100, "displayOrder": 1, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Agree", "choiceId": 1101, "displayOrder": 2, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "No Opinion", "choiceId": 1102, "displayOrder": 3, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Disagree", "choiceId": 1103, "displayOrder": 4, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Strongly Disagree", "choiceId": 1104, "displayOrder": 5, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "I am not currently in practice", "choiceId": 1105, "displayOrder": 6, "correct": true, "selected": true, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": false, "showQuestion": false, "showResult": false, "responseText": null, "answered": true, "answeredCorrectly": true, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 502, "questionText": "The activity was presented objectively and was free of commercial bias. [Please use the \"additional comments\" field below to provide further information.]", "displayType": 1, "poll": false, "required": false, "score": false, "displayOrder": 4, "discussion": null, "introduction": null, "choices": [{ "choiceText": "Strongly Agree", "choiceId": 1100, "displayOrder": 1, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Agree", "choiceId": 1101, "displayOrder": 2, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "No Opinion", "choiceId": 1102, "displayOrder": 3, "correct": true, "selected": true, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Disagree", "choiceId": 1103, "displayOrder": 4, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Strongly Disagree", "choiceId": 1104, "displayOrder": 5, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": false, "showQuestion": false, "showResult": false, "responseText": null, "answered": true, "answeredCorrectly": true, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 503, "questionText": "I would recommend this activity to others.", "displayType": 1, "poll": false, "required": false, "score": false, "displayOrder": 5, "discussion": null, "introduction": null, "choices": [{ "choiceText": "Strongly Agree", "choiceId": 1100, "displayOrder": 1, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Agree", "choiceId": 1101, "displayOrder": 2, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "No Opinion", "choiceId": 1102, "displayOrder": 3, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Disagree", "choiceId": 1103, "displayOrder": 4, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Strongly Disagree", "choiceId": 1104, "displayOrder": 5, "correct": true, "selected": true, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": false, "showQuestion": false, "showResult": false, "responseText": null, "answered": true, "answeredCorrectly": true, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 504, "questionText": "Please list CE/CME topics that would be of value to you and/or the healthcare team.", "displayType": 5, "poll": false, "required": false, "score": false, "displayOrder": 6, "discussion": null, "introduction": null, "choices": [], "showAnsTable": false, "showQuestion": false, "showResult": false, "responseText": "topic 1, topic 2, topic 3", "answered": true, "answeredCorrectly": true, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 505, "questionText": "Additional Comments:", "displayType": 5, "poll": false, "required": false, "score": false, "displayOrder": 7, "discussion": null, "introduction": null, "choices": [], "showAnsTable": false, "showQuestion": false, "showResult": false, "responseText": "My comment is this. No more comments!", "answered": false, "answeredCorrectly": true, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }], "isActive": 1, "gated": false, "expirationDate": null, "viewResults": false },
            "qna-41899-1": { "formId": 1, "formTitle": "Question 1.", "formTypeId": 1, "formType": "DEFAULT", "displayOrder": 1, "introduction": null, "questions": [{ "questionId": 323749, "questionText": "The primary things you need in an effective office bookkeeping system are:", "displayType": 1, "poll": false, "required": true, "score": true, "displayOrder": 1, "discussion": null, "introduction": null, "choices": [{ "choiceText": "Software program, tax accountant, security and internal controls, and users", "choiceId": 1023124, "displayOrder": 1, "correct": false, "selected": true, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Software program, security and internal controls, a good billing program, and a CPA ", "choiceId": 1023126, "displayOrder": 2, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Software program, data, security and internal controls, and users ", "choiceId": 1023128, "displayOrder": 3, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "CPA, controller, bookkeeper, and a good software system \r\n", "choiceId": 1023130, "displayOrder": 4, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": true, "showQuestion": true, "showResult": true, "responseText": null, "answered": true, "answeredCorrectly": false, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 323751, "questionText": "Internal financial controls for a medical practice include:", "displayType": 1, "poll": false, "required": true, "score": true, "displayOrder": 2, "discussion": null, "introduction": null, "choices": [{ "choiceText": "Policies on the company's accounting records that protect the assets from theft", "choiceId": 1023132, "displayOrder": 1, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Physical controls, including a safe or locked cabinet", "choiceId": 1023134, "displayOrder": 2, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Supervision of staff who have access to company assets ", "choiceId": 1023136, "displayOrder": 3, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "All of the above\r\n", "choiceId": 1023138, "displayOrder": 4, "correct": true, "selected": true, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": true, "showQuestion": true, "showResult": true, "responseText": null, "answered": true, "answeredCorrectly": true, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 323753, "questionText": "Separation of incompatible job functions is based on: ", "displayType": 1, "poll": false, "required": true, "score": true, "displayOrder": 3, "discussion": null, "introduction": null, "choices": [{ "choiceText": "Designing systems where employees watch each other to deter theft", "choiceId": 1023140, "displayOrder": 1, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Not allowing the same staff member to have physical access to assets and be able to record transactions in the books and records of the company ", "choiceId": 1023142, "displayOrder": 2, "correct": true, "selected": true, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Discouraging employees from becoming too friendly with each other and finding ways around the control systems", "choiceId": 1023144, "displayOrder": 3, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Preventing supervisors from making entries into the books and records\r\n", "choiceId": 1023146, "displayOrder": 4, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": true, "showQuestion": true, "showResult": true, "responseText": null, "answered": true, "answeredCorrectly": true, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 323755, "questionText": "The key to turning accounting data into useful information is:", "displayType": 1, "poll": false, "required": true, "score": true, "displayOrder": 4, "discussion": null, "introduction": null, "choices": [{ "choiceText": "Making the reports timely", "choiceId": 1023148, "displayOrder": 1, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Creating reports that measure the drivers of success that are not required in basic financial statements", "choiceId": 1023150, "displayOrder": 2, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Creating reports that show the impact of taxes on the practice", "choiceId": 1023152, "displayOrder": 3, "correct": false, "selected": true, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Making sure that the reports are prepared on an accrual basis\r\n", "choiceId": 1023154, "displayOrder": 4, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": true, "showQuestion": true, "showResult": true, "responseText": null, "answered": true, "answeredCorrectly": false, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 323757, "questionText": "Comparisons in financial statements are powerful. Which comparison would <em>not</em> provide additional data for your practice?", "displayType": 1, "poll": false, "required": true, "score": true, "displayOrder": 5, "discussion": null, "introduction": null, "choices": [{ "choiceText": "Comparison with the practice's budget", "choiceId": 1023156, "displayOrder": 1, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Comparison with the prior year's expenditures and income", "choiceId": 1023158, "displayOrder": 2, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Comparison with industry standards for similar specialty practices", "choiceId": 1023160, "displayOrder": 3, "correct": false, "selected": true, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Comparison with the financial results of a hospital", "choiceId": 1023162, "displayOrder": 4, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": true, "showQuestion": true, "showResult": true, "responseText": null, "answered": true, "answeredCorrectly": false, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 323759, "questionText": "The best time to do tax planning is:", "displayType": 1, "poll": false, "required": true, "score": true, "displayOrder": 6, "discussion": null, "introduction": null, "choices": [{ "choiceText": "When you are seeing your accountant to prepare your personal tax return", "choiceId": 1023164, "displayOrder": 1, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Right after you purchase a significant asset", "choiceId": 1023166, "displayOrder": 2, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Throughout the year, each time you contemplate a significant change in your financial situation", "choiceId": 1023168, "displayOrder": 3, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "None of the above\r\n\r\n", "choiceId": 1023170, "displayOrder": 4, "correct": false, "selected": true, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": true, "showQuestion": true, "showResult": true, "responseText": null, "answered": true, "answeredCorrectly": false, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 323761, "questionText": "The best way to use an aged accounts receivable report is to:", "displayType": 1, "poll": false, "required": true, "score": true, "displayOrder": 7, "discussion": null, "introduction": null, "choices": [{ "choiceText": "Look at every amount due to the practice, and put in place actions to collect balances each week", "choiceId": 1023172, "displayOrder": 1, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Monitor the outstanding amount from 90 days ago and longer, and follow up diligently on any amounts considered significant", "choiceId": 1023174, "displayOrder": 2, "correct": true, "selected": true, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Follow up on one insurance company each month, and don't worry about balances owed by patients", "choiceId": 1023176, "displayOrder": 3, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Don't use it at all\r\n", "choiceId": 1023178, "displayOrder": 4, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": true, "showQuestion": true, "showResult": true, "responseText": null, "answered": true, "answeredCorrectly": true, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 323763, "questionText": "True or false: When the balance sheet is prepared for one year only, it can provide a summary of the financial health of the practice.", "displayType": 1, "poll": false, "required": true, "score": true, "displayOrder": 8, "discussion": null, "introduction": null, "choices": [{ "choiceText": "True", "choiceId": 1023180, "displayOrder": 1, "correct": false, "selected": true, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "False\r\n", "choiceId": 1023182, "displayOrder": 2, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": true, "showQuestion": true, "showResult": true, "responseText": null, "answered": true, "answeredCorrectly": false, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 323765, "questionText": "What important developments can a balance sheet tell you when viewed over time? ", "displayType": 1, "poll": false, "required": true, "score": true, "displayOrder": 9, "discussion": null, "introduction": null, "choices": [{ "choiceText": "When cash drops and a loan made to an officer of the company goes up, this is a serious problem", "choiceId": 1023184, "displayOrder": 1, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "When loans increase and other asset balances increase, this shows a reduction in financial stability", "choiceId": 1023186, "displayOrder": 2, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "When cash balances increase and loans payable increase, this shows an increase in financial stability", "choiceId": 1023188, "displayOrder": 3, "correct": false, "selected": true, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "When cash drops and loan balances drop, this indicates good financial planning\r\n", "choiceId": 1023190, "displayOrder": 4, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": true, "showQuestion": true, "showResult": true, "responseText": null, "answered": true, "answeredCorrectly": false, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 323767, "questionText": "True or false: Reviewing the company balance sheet is just as important to learn about the finances of the company as reviewing the income statement.", "displayType": 1, "poll": false, "required": true, "score": true, "displayOrder": 10, "discussion": null, "introduction": null, "choices": [{ "choiceText": "True", "choiceId": 1023192, "displayOrder": 1, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "False", "choiceId": 1023194, "displayOrder": 2, "correct": false, "selected": true, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": true, "showQuestion": true, "showResult": true, "responseText": null, "answered": true, "answeredCorrectly": false, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }], "isActive": 1, "gated": true, "expirationDate": null, "viewResults": false },
            "qna-3333-1": { "formId": 1, "formTitle": "Question 1", "formTypeId": 1, "formType": "DEFAULT", "displayOrder": 1, "introduction": "Poll", "questions": [{ "questionId": 14095, "questionText": "What level of relative CV risk reduction are we able to achieve with statin therapy? ", "displayType": 1, "poll": true, "required": false, "score": false, "displayOrder": 1, "discussion": "The correct answer is 25% to 40%.", "introduction": "Poll", "choices": [{ "choiceText": "<span>&lt;25%</span>", "choiceId": 55698, "displayOrder": 1, "correct": false, "selected": true, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "<span>&nbsp;&nbsp;25% to 40%</span>", "choiceId": 55699, "displayOrder": 2, "correct": true, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "<span>&gt;40%</span>", "choiceId": 55700, "displayOrder": 3, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": false, "showQuestion": false, "showResult": false, "responseText": null, "answered": true, "answeredCorrectly": false, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }], "isActive": 1, "gated": false, "expirationDate": null, "viewResults": false },
            "qna-43620-1": { "formId": 1, "formTitle": "Question 1", "formTypeId": 1, "formType": "DEFAULT", "displayOrder": 1, "introduction": null, "questions": [{ "questionId": 338971, "questionText": "How familiar are you with neurogenic orthostatic hypotension (<span class=\"norm\">nOH</span>)?", "displayType": 1, "poll": true, "required": false, "score": false, "displayOrder": 1, "discussion": null, "introduction": null, "choices": [{ "choiceText": "Very familiar", "choiceId": 1070482, "displayOrder": 1, "correct": false, "selected": false, "explanation": null, "totalResponses": "25", "totalAbsoluteResponseCount": 2 }, { "choiceText": "Familiar", "choiceId": 1070484, "displayOrder": 2, "correct": false, "selected": true, "explanation": null, "totalResponses": "50", "totalAbsoluteResponseCount": 4 }, { "choiceText": "Somewhat familiar", "choiceId": 1070486, "displayOrder": 3, "correct": false, "selected": false, "explanation": null, "totalResponses": "13", "totalAbsoluteResponseCount": 1 }, { "choiceText": "Unfamiliar", "choiceId": 1070488, "displayOrder": 4, "correct": false, "selected": false, "explanation": null, "totalResponses": "12", "totalAbsoluteResponseCount": 1 }], "showAnsTable": true, "showQuestion": true, "showResult": false, "responseText": null, "answered": true, "answeredCorrectly": false, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 8.0, "viewResults": false, "specialties": [], "professions": [] }], "isActive": 1, "gated": false, "expirationDate": null, "viewResults": false },
            "qna-43912-1": { "formId": 1, "formTitle": "Infosite template form", "formTypeId": 1, "formType": "DEFAULT", "displayOrder": 1, "introduction": null, "questions": [{ "questionId": 340079, "questionText": "This is a radio button question", "displayType": 1, "poll": true, "required": false, "score": false, "displayOrder": 1, "discussion": "The is a sample question explanation", "introduction": null, "choices": [{ "choiceText": "Answer 1", "choiceId": 1073028, "displayOrder": 1, "correct": false, "selected": false, "explanation": null, "totalResponses": "50", "totalAbsoluteResponseCount": 1 }, { "choiceText": "Answer 2", "choiceId": 1073030, "displayOrder": 2, "correct": false, "selected": true, "explanation": null, "totalResponses": "50", "totalAbsoluteResponseCount": 1 }, { "choiceText": "Answer 3", "choiceId": 1073032, "displayOrder": 3, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": true, "showQuestion": true, "showResult": false, "responseText": null, "answered": true, "answeredCorrectly": false, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 2.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 340081, "questionText": "This is a sample check box question", "displayType": 2, "poll": true, "required": false, "score": false, "displayOrder": 2, "discussion": null, "introduction": null, "choices": [{ "choiceText": "Answer 2", "choiceId": 1073036, "displayOrder": 2, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Answer 4", "choiceId": 1073040, "displayOrder": 4, "correct": false, "selected": false, "explanation": null, "totalResponses": "50", "totalAbsoluteResponseCount": 1 }, { "choiceText": "Answer 5", "choiceId": 1073042, "displayOrder": 5, "correct": false, "selected": true, "explanation": null, "totalResponses": "50", "totalAbsoluteResponseCount": 1 }, { "choiceText": "Answer 1", "choiceId": 1073034, "displayOrder": 1, "correct": false, "selected": true, "explanation": null, "totalResponses": "50", "totalAbsoluteResponseCount": 1 }, { "choiceText": "Answer 3", "choiceId": 1073038, "displayOrder": 3, "correct": false, "selected": true, "explanation": null, "totalResponses": "100", "totalAbsoluteResponseCount": 2 }], "showAnsTable": true, "showQuestion": true, "showResult": false, "responseText": null, "answered": true, "answeredCorrectly": false, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 2.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 340083, "questionText": "This is an open ended question with fill in", "displayType": 4, "poll": false, "required": false, "score": false, "displayOrder": 3, "discussion": null, "introduction": null, "choices": [{ "choiceText": "Dummy Choice", "choiceId": 0, "displayOrder": 1, "correct": false, "selected": false, "explanation": "To handle skip and open question functionality", "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": false, "showQuestion": false, "showResult": false, "responseText": "optional answer", "answered": true, "answeredCorrectly": true, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 340085, "questionText": "This is a required open ended question", "displayType": 4, "poll": false, "required": true, "score": false, "displayOrder": 4, "discussion": null, "introduction": null, "choices": [{ "choiceText": "Dummy Choice", "choiceId": 0, "displayOrder": 1, "correct": false, "selected": false, "explanation": "To handle skip and open question functionality", "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": false, "showQuestion": false, "showResult": false, "responseText": "required answer", "answered": true, "answeredCorrectly": true, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 340087, "questionText": "This is a pull down question.  <em>Please pick one from the drop down.</em>", "displayType": 3, "poll": false, "required": false, "score": false, "displayOrder": 5, "discussion": null, "introduction": null, "choices": [{ "choiceText": "Answer 1\r", "choiceId": 1073044, "displayOrder": 1, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Answer 4\r", "choiceId": 1073050, "displayOrder": 4, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Answer 5", "choiceId": 1073052, "displayOrder": 5, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Answer 2\r", "choiceId": 1073046, "displayOrder": 2, "correct": false, "selected": true, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Answer 3\r", "choiceId": 1073048, "displayOrder": 3, "correct": false, "selected": false, "explanation": null, "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": true, "showQuestion": true, "showResult": false, "responseText": null, "answered": true, "answeredCorrectly": false, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 0.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 340089, "questionText": "This is a required check box question", "displayType": 2, "poll": true, "required": true, "score": false, "displayOrder": 6, "discussion": null, "introduction": null, "choices": [{ "choiceText": "You must check this box to enter", "choiceId": 1073054, "displayOrder": 1, "correct": false, "selected": true, "explanation": null, "totalResponses": "100", "totalAbsoluteResponseCount": 2 }], "showAnsTable": true, "showQuestion": true, "showResult": false, "responseText": null, "answered": true, "answeredCorrectly": false, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 2.0, "viewResults": false, "specialties": [], "professions": [] }, { "questionId": 340091, "questionText": "This is a question that tells you if you answer was right or wrong", "displayType": 1, "poll": true, "required": false, "score": false, "displayOrder": 7, "discussion": null, "introduction": null, "choices": [{ "choiceText": "Answer 1", "choiceId": 1073056, "displayOrder": 1, "correct": false, "selected": false, "explanation": "Incorrect", "totalResponses": "0", "totalAbsoluteResponseCount": 0 }, { "choiceText": "Answer 4", "choiceId": 1073062, "displayOrder": 4, "correct": false, "selected": true, "explanation": "Incorrect", "totalResponses": "50", "totalAbsoluteResponseCount": 1 }, { "choiceText": "Answer 2", "choiceId": 1073058, "displayOrder": 2, "correct": true, "selected": false, "explanation": "Correct", "totalResponses": "50", "totalAbsoluteResponseCount": 1 }, { "choiceText": "Answer 3", "choiceId": 1073060, "displayOrder": 3, "correct": false, "selected": false, "explanation": "Incorrect", "totalResponses": "0", "totalAbsoluteResponseCount": 0 }], "showAnsTable": true, "showQuestion": true, "showResult": true, "responseText": null, "answered": true, "answeredCorrectly": false, "questionTypeId": 1, "mutuallyExclusive": false, "matrixQuestions": [], "totalResponses": 2.0, "viewResults": false, "specialties": [], "professions": [] }], "isActive": 1, "gated": false, "expirationDate": null, "viewResults": false }
          };
          var testState = testResponses['qna-' + this.state.qid + '-' + this.state.formId];
          //testState.questions = this.getQuestions(testState.questions);
          console.warn("Set State:\n", testState);
          this.setState(testState);
        } else {
          if (window.medscape.user.isLoggedIn && !_utils2.default.isIEorEDGE()) {
            setTimeout(function () {
              _this2.ApiActions.get(_this2.state.qid, _this2.state.formId);
            }, 1000);
          } else {
            var responseUserCount = [],
                responseTotalCount = [];
            response.data.pollingSummary.pollSummaryQuestionResponses.forEach(function (responses, i) {
              response.data.incorrectlyAnsweredQuestionIds.forEach(function (id) {
                if (responses.questionId == id) {
                  responses.pollSummaryChoiceResponses.forEach(function (choice, j, choices) {
                    responseUserCount.push(choice.totalCount);
                    responseTotalCount.push(choice.questionSum);
                  });
                }
              });
            });
            this.getQnaData.questions.forEach(function (question, i) {
              question.answered = true;
              question.choices.forEach(function (choice, j) {
                choice.totalAbsoluteResponseCount = responseUserCount[i + j];
                choice.totalResponses = Math.round(responseUserCount[i + j] * 100 / responseTotalCount[i + j]);
              });
            });
            this.setState(this.getQnaData);
          }
        }
      }
    }
  }]);

  return ApiStore;
}(_reflux2.default.Store);

exports.default = ApiStore;


ApiStore.get = function (questionnaire) {
  var qid = questionnaire.qid;
  var formId = questionnaire.formId;
  var key = 'qid[' + qid + ']-for[-' + formId + ']';
  if (StoreCache[key] == null) {
    StoreCache[key] = new ApiStore(questionnaire);
    StoreCache[key].timeStamp = Date.now();
  }
  return StoreCache[key];
};

ApiStore.clearCache = function () {
  Object.keys(StoreCache).forEach(function (key) {
    _actionsFactory2.default.clearCache();
    delete StoreCache[key];
  });
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _app = __webpack_require__(368);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(872);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _app2.default;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _actions = __webpack_require__(102);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorMessagesStore = function (_Reflux$Store) {
  _inherits(ErrorMessagesStore, _Reflux$Store);

  function ErrorMessagesStore() {
    _classCallCheck(this, ErrorMessagesStore);

    var _this = _possibleConstructorReturn(this, (ErrorMessagesStore.__proto__ || Object.getPrototypeOf(ErrorMessagesStore)).call(this));

    _this.state = _this.getInitialState();
    _this.listenables = _actions2.default;
    return _this;
  }

  _createClass(ErrorMessagesStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        "errors": []
      };
    }
  }, {
    key: 'onUpdate',
    value: function onUpdate(messages) {
      this.setState({
        errors: messages
      });
    }
  }]);

  return ErrorMessagesStore;
}(_reflux2.default.Store);

exports.default = ErrorMessagesStore;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _checkbox = __webpack_require__(369);

var _checkbox2 = _interopRequireDefault(_checkbox);

var _radio = __webpack_require__(372);

var _radio2 = _interopRequireDefault(_radio);

var _select = __webpack_require__(373);

var _select2 = _interopRequireDefault(_select);

var _pollResults = __webpack_require__(370);

var _pollResults2 = _interopRequireDefault(_pollResults);

var _qnaResults = __webpack_require__(371);

var _qnaResults2 = _interopRequireDefault(_qnaResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	Checkbox: _checkbox2.default,
	Radio: _radio2.default,
	Select: _select2.default,
	PollResults: _pollResults2.default,
	QnaResults: _qnaResults2.default
};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _choiceActionsFactory = __webpack_require__(64);

var _choiceActionsFactory2 = _interopRequireDefault(_choiceActionsFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StoreCache = {};

var SubmitButtonStore = function (_Reflux$Store) {
  _inherits(SubmitButtonStore, _Reflux$Store);

  function SubmitButtonStore(props) {
    _classCallCheck(this, SubmitButtonStore);

    var _this = _possibleConstructorReturn(this, (SubmitButtonStore.__proto__ || Object.getPrototypeOf(SubmitButtonStore)).call(this));

    props.questions.forEach(function (question) {
      var choiceActions = _choiceActionsFactory2.default.get(question.questionId);
      _this.listenTo(choiceActions.change, _this.onChange);
    });
    _this.props = props;
    _this.state = _this.getInitialState();
    _this.state.isDisabled = _this.isDisabled();
    return _this;
  }

  _createClass(SubmitButtonStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        isDisabled: false
      };
    }
  }, {
    key: 'isDisabled',
    value: function isDisabled() {
      var requiredQuestions = this.getRequiredQuestions();
      var requiredResponses = this.getResponses(requiredQuestions);
      var responses = this.getResponses(this.props.questions);
      return responses.length == 0 || requiredResponses.length < requiredQuestions.length;
    }
  }, {
    key: 'getRequiredQuestions',
    value: function getRequiredQuestions() {
      return this.props.questions.filter(function (question) {
        return question.required;
      });
    }
  }, {
    key: 'getResponses',
    value: function getResponses() {
      var questions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var responseList = [];
      return questions.filter(function (question) {
        var choices = question.choices;
        if (question.displayType == 5 || question.displayType == 4 || choices == null || choices.length == 0) {
          var responseText = question.responseText;
          return responseText != null && responseText.length > 0;
        }

        var choice = choices.find(function (choice) {
          return choice.selected;
        });
        return choice != null;
      });
    }
  }, {
    key: 'onChange',
    value: function onChange() {
      this.setState({
        isDisabled: this.isDisabled()
      });
    }
  }]);

  return SubmitButtonStore;
}(_reflux2.default.Store);

exports.default = SubmitButtonStore;


SubmitButtonStore.get = function (questionnaire) {
  var qid = questionnaire.qid;
  var formId = questionnaire.formId;
  var key = 'qid[' + qid + ']-for[-' + formId + ']';
  if (StoreCache[key] == null || StoreCache[key].listenables == null || StoreCache[key].listenables.length == 0 || StoreCache[key].listenables.length == null) {
    StoreCache[key] = new SubmitButtonStore(questionnaire);
  } else {
    StoreCache[key];
  }
  return StoreCache[key];
};

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(367);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(873);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuestionnaireModule = function QuestionnaireModule(config, $modules) {
  _classCallCheck(this, QuestionnaireModule);

  $modules.each(function (index, el) {
    var $el = (0, _jquery2.default)(el);
    if ($el.hasClass('module-loaded')) {
      return;
    }
    var configId = $el.data('config-id');
    var moduleData = config.find(function (data) {
      return data['config-id'] == configId;
    });
    if (!moduleData) return;
    var props = {
      qid: moduleData.id,
      formId: moduleData.form,
      title: moduleData.title,
      questionNumberText: moduleData.questionNumberText,
      flagRequired: moduleData.flagRequired,
      configId: moduleData['config-id']
    };
    _reactDom2.default.render(_react2.default.createElement(_app2.default, props), el);
    $el.addClass('module-loaded');
  });
};

exports.default = QuestionnaireModule;

QuestionnaireModule.selector = '[data-module="Questionnaire"]';
QuestionnaireModule.init = function (config, $modules) {
  $modules = $modules || (0, _jquery2.default)(QuestionnaireModule.selector);
  if ($modules.length > 0) {
    new QuestionnaireModule(config, $modules);
  }
};

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _actions = __webpack_require__(201);

var _actions2 = _interopRequireDefault(_actions);

var _lodash = __webpack_require__(42);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _cp = __webpack_require__(202);

var _cp2 = _interopRequireDefault(_cp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import sa from './sa';

var TrackingStore = function (_Reflux$Store) {
  _inherits(TrackingStore, _Reflux$Store);

  function TrackingStore() {
    _classCallCheck(this, TrackingStore);

    var _this = _possibleConstructorReturn(this, (TrackingStore.__proto__ || Object.getPrototypeOf(TrackingStore)).call(this));

    _this.listenables = _actions2.default;
    _this.s_md = {};
    _this.s_md.contextData = _jquery2.default.extend({}, (0, _lodash.get)(window, 's_md.contextData', {}), true);
    _this.s_md.linkTrackVars = (0, _lodash.get)(window, 's_md.linkTrackVars', '');
    _this.isFirstPageView = true;

    return _this;
  }

  _createClass(TrackingStore, [{
    key: 'initRealTimeSpent',
    value: function initRealTimeSpent() {
      var timer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;

      var intervalTime = timer * 1000;
      var stopTimer = 30 * 60 * 1000; // 30 minutes
      var trackCode = 'pvtime_' + timer;
      var rtsInterval = setInterval(function () {
        window.wmdPageLink(trackCode);
      }, intervalTime);
      setTimeout(function () {
        clearInterval(rtsInterval);
      }, stopTimer);
    }
  }, {
    key: 'trackVP',
    value: function trackVP() {
      var urlStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      if (urlStr.length == 0) {
        return;
      }
      var getData = {
        desturl: urlStr
      };
      _jquery2.default.ajax({
        type: 'get',
        url: '/public/vptrack.wxml',
        data: getData,
        cached: false,
        xhrFields: {
          withCredentials: true
        }
      });
    }
  }, {
    key: 'onInit',
    value: function onInit(config) {
      this.config = config;
      _cp2.default.init(config.CP);
      var ippConfig = _jquery2.default.extend({}, config);
      //sa.init(config)
      this.initRealTimeSpent(config["RTS-timer"]);
    }
  }, {
    key: 'onTrackLink',
    value: function onTrackLink(linkEl) {
      //if(window.medscape.config.env=='localhost') return;
      var $linkEl = (0, _jquery2.default)(linkEl);
      if (window.wmdPageLink == null || $linkEl.hasClass('js-tracking')) {
        return;
      }
      var linkTarget = linkEl.getAttribute('target');
      var linkHref = linkEl.getAttribute('href');
      var linkLocation = _utils2.default.getLocation(linkHref);

      if (linkHref != null) {
        if (linkHref.indexOf(".isarticle") < 0 && linkHref.indexOf(".medscape.") < 0) {
          if (linkHref.startsWith('http') || linkHref.startsWith('www')) {
            if (linkEl.dataset.module === 'RouterLink') return;
            var linkType = 'exturl';
            // PPE-210888: Duplicate Omniture external link calls
            /* 
            if(window.medscape.user.isLoggedIn){
              linkEl.setAttribute('href',`/px/trk.svr/${medscape.user.sfNumber}?${linkType}=${linkHref}`);
            } else {
                linkEl.setAttribute('href',`/px/tracker/${medscape.user.sfNumber}?${linkType}=${linkHref}`);
            }
            */
            linkEl.addEventListener("click", function (e) {
              _actions2.default.pageLink("exturl", linkEl);
            });
            if (linkTarget == null || linkTarget.length == 0) {
              (0, _jquery2.default)(linkEl).attr('target', '_blank');
            }
          }
        }
        /*$linkEl.off('click.js-tracking').on('click.js-tracking', function(e){
          let el = e.currentTarget;
          const trackData = $(el).data('wmdpagelink') ? $(el).data('wmdpagelink') : 'exturl';
          TrackingActions.pageLink(trackData,el);
        });*/
      } else {
          /*$linkEl.off('click.js-tracking').on('click.js-tracking', function(e){
            let el = e.currentTarget;
            let $el = $(el);
            const trackData = $el.data('wmdpagelink') ? $el.data('wmdpagelink') : 'inturl';
            TrackingActions.pageLink(trackData,el);
          });*/
        }
      $linkEl.addClass('js-tracking');
    }
  }, {
    key: 'onTrackContainerLinks',
    value: function onTrackContainerLinks(container) {
      if (!container) return;
      var $container = (0, _jquery2.default)(container);
      $container.find('a[href]:not(.js-tracking)').each(function (index, el) {
        _actions2.default.trackLink(el);
      });
    }
  }, {
    key: 'onPageLink',
    value: function onPageLink() {
      var trackCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var linkEl = arguments[1];

      //console.log("onPageLink:\n",linkEl);
      //console.log("trackCode: ",trackCode);
      if (trackCode.length == 0) {
        return;
      }
      window.wmdPageLink(trackCode, linkEl);
      this.trackVP(document.location.href + '_' + trackCode);
    }
  }, {
    key: 'onPageView',
    value: function onPageView() {
      var pageName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.location.href;

      if (!this.isFirstPageView) {
        window.s_pagename = pageName;
        window._URL = document.location.href;
        //window.s_md.pageName = (document.location.host.replace('www.', '') + document.location.pathname);
        //window.s_md.eVar1 = (document.location.host.replace('www.', '') + document.location.pathname);
        window.s_md.pageURL = document.location.href;
        window.s_md.prop7 = document.location.pathname.substring(1);
        window.s_md.contextData = _jquery2.default.extend({}, this.s_md.contextData, true);
        window.s_md.linkTrackVars = this.s_md.linkTrackVars;
        window.wmdPageview(pageName);
      }
      this.trackVP(document.location.href + '_' + document.location.href);
      this.isFirstPageView = false;
    }
  }, {
    key: 'onTrack',
    value: function onTrack() {
      var trackCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      this.onPageLink(trackCode);
    }
  }]);

  return TrackingStore;
}(_reflux2.default.Store);

exports.default = new TrackingStore();

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(382);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(875);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var twitterWidgetModule = function () {
    function twitterWidgetModule(config, $twitterWidgets) {
        _classCallCheck(this, twitterWidgetModule);

        var props = {
            account: config.accountName,
            limitNumber: this.getLimitNumbers(config.limitTweetsNumbers)
        };
        $twitterWidgets.each(function (index, el) {
            _reactDom2.default.render(_react2.default.createElement(_app2.default, props), el);
        });
    }

    _createClass(twitterWidgetModule, [{
        key: 'getLimitNumbers',
        value: function getLimitNumbers(limitNumber) {
            if (limitNumber === undefined) {
                return "7";
            }
            return limitNumber;
        }
    }]);

    return twitterWidgetModule;
}();

exports.default = twitterWidgetModule;

twitterWidgetModule.selector = '[data-module="Twitter"]';
twitterWidgetModule.init = function (config, $modules) {
    $modules = $modules || (0, _jquery2.default)(twitterWidgetModule.selector);
    if ($modules.length > 0) {
        new twitterWidgetModule(config, $modules);
    }
};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(384);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(876);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UldBannerModule = function () {
	function UldBannerModule(config) {
		_classCallCheck(this, UldBannerModule);

		var uldBannerEle = document.getElementById('uld-banner');
		if (uldBannerEle != null) {
			_reactDom2.default.render(_react2.default.createElement(_app2.default, config), uldBannerEle);
		}
	}

	_createClass(UldBannerModule, null, [{
		key: 'init',
		value: function init(config) {
			return new UldBannerModule(config);
		}
	}]);

	return UldBannerModule;
}();

exports.default = UldBannerModule;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function value(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    }
  });
}

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (pluginUrl, ampURL) {
  return {
    domain: 'webmd.com',
    paths: {
      player: ampURL,
      resources: ampURL
    },
    resources: [],
    params: {},
    controls: { mode: 'auto' },
    fullscreen: {
      enabled: true,
      native: true
    },
    branding: {
      id: 'logo',
      logo: '//nkalaiya.mediadev.edgesuite.net/webmd_overlay.png'
    },
    playoverlay: { enabled: true },
    flash: {
      swf: ampURL + 'AkamaiPremierPlayer.swf',
      debug: ampURL + 'AkamaiPremierPlayer-debug.swf',
      vars: {
        core_ads_enabled: false,
        auto_play_override: false,
        playback_clicktoggle_enabled: true
      },
      xml: flashConfig.replace(/\{baseSkinUrl\}/g, ampURL)
    },

    locales: {
      es: {
        MSG_RECOMMENDATIONS_TITLE: 'Recomendado',
        MSG_CHROMECAST_MESSAGE: 'Video playing on another screen',
        MSG_RU: 'Ruso',
        MSG_IT: 'Italiano',
        MSG_FR: 'Franc\xE9s',
        MSG_DE: 'Alem\xE1n',
        MSG_ES: 'Espa\xF1ol',
        MSG_EN: 'Ingl\xE9s',
        MSG_CC: 'CC',
        MSG_VIDEO: ' v\xEDdeos',
        MSG_VIEW_ALL: 'Ver todos ',
        MSG_RECOMMENDED: 'Recomendado',
        MSG_NEXT_VIDEO: 'El pr\xF3ximo video comienza en: ',
        MSG_REPLAY: 'Repetir',
        MSG_GO_LIVE: 'IR A VIVIR',
        MSG_NOT_AVAILABLE: 'No est\xE1 disponible',
        MSG_MAX_BITRATE_AVAILABLE: 'Tasa de bits m\xE1xima disponible',
        MSG_CURRENT_BITRATE_PLAYING: 'Tasa de bits de reproducci\xF3n actual',
        MSG_CURRENT_WORKING_BANDWIDTH: 'Ancho de banda actual de trabajo',
        MSG_STREAM_NOT_FOUND: 'Stream que no se encuentra',
        MSG_ERROR_PREFIX: 'Se produjo un error:',
        MSG_DEFAULT_ERROR_MESSAGE: 'Lo sentimos, no hemos podido jugar los medios de comunicaci\xF3n seleccionados. Por favor, int\xE9ntelo de nuevo, o seleccionar los medios de comunicaci\xF3n alternativos.',
        MSG_LIVE: 'EN VIVO',
        MSG_SEEK_TO: 'Tratar de',
        MSG_CURRENT: 'corriente',
        MSG_PREVIEW: 'vista previa',
        MSG_PAUSE: 'romper',
        MSG_CUSTOMIZE_CLIP_POINTS: 'Personalizar el inicio y el punto final del video.',
        MSG_BUFFERING_TEXT: 'el almacenamiento en b\xFAfer',
        MSG_VERSION_TEXT: 'versi\xF3n',
        MSG_SHARE_CONTENT_DISABLED: 'Compartir e incrustar est\xE1n desactivados.',
        MSG_SHARE_CONNECT_FAILURE: 'No se puede conectar. Por favor, int\xE9ntelo de nuevo.',
        MSG_LINK_TEXT: 'enlace',
        MSG_EMBED_TEXT: 'incrustar',
        MSG_POST_TEXT: 'enviar',
        MSG_SHARE_VIDEO_TEXT: 'Comparte este v\xEDdeo...',
        MSG_EMAIL_SEND_SUCCESS_MESSAGE: 'Tu email ha sido enviado!',
        MSG_EMAIL_SEND_FAILURE: 'El mensaje no pudo ser enviado.',
        MSG_EMAIL_CHARACTERS_REMAINING_TEXT: 'personajes de la izquierda',
        MSG_EMAIL_MESSAGE_INVALID: 'Por favor limite su mensaje a 500 caracteres o menos.',
        MSG_EMAIL_ADDRESS_INVALID: 'Direcci\xF3n de correo electr\xF3nico no v\xE1lida',
        MSG_EMAIL_MESSAGE: 'mensaje',
        MSG_EMAIL_MESSAGE_DEFAULT: 'Echa un vistazo a este video de xxx',
        MSG_EMAIL_VIDEO: 'Enviar este v\xEDdeo',
        MSG_EMAIL_FROM: 'de',
        MSG_EMAIL_TO: 'a'
      },
      en: {
        MSG_RECOMMENDATIONS_TITLE: 'Recommended',
        MSG_CHROMECAST_MESSAGE: 'Video playing on another screen',
        MSG_RU: 'Russian',
        MSG_IT: 'Italian',
        MSG_FR: 'French',
        MSG_DE: 'German',
        MSG_ES: 'Spanish',
        MSG_EN: 'English',
        MSG_CC_APPLY: 'Apply',
        MSG_CC_CANCEL: 'Cancel',
        MSG_CC_RESET: 'Default',
        MSG_CC_HIDE_ADVANCED: 'Hide Advanced Settings',
        MSG_CC_SHOW_ADVANCED: 'Show Advanced Settings',
        MSG_CC_OPACITY: 'Opacity :',
        MSG_CC_WINDOW: 'Window :',
        MSG_CC_BACKGROUND: 'Background :',
        MSG_CC_COLOR: 'Color :',
        MSG_CC_SCROLL: 'Scroll :',
        MSG_CC_SIZE: 'Size :',
        MSG_CC_EDGE: 'Edge :',
        MSG_CC_FONT: 'Font :',
        MSG_CC_PRESETS: 'Presets :',
        MSG_CC_LANGUAGE: 'Track :',
        MSG_CC_TITLE: 'Captions',
        MSG_CC: 'CC',
        MSG_VIDEO: ' videos',
        MSG_VIEW_ALL: 'View all ',
        MSG_RECOMMENDED: 'Recommended',
        MSG_NEXT_VIDEO: 'Next video starts in: ',
        MSG_REPLAY: 'Replay',
        MSG_GO_LIVE: 'GO LIVE',
        MSG_NOT_AVAILABLE: 'Not Available',
        MSG_MAX_BITRATE_AVAILABLE: 'Max bitrate available',
        MSG_CURRENT_BITRATE_PLAYING: 'Current bitrate playing',
        MSG_CURRENT_WORKING_BANDWIDTH: 'Current working bandwidth',
        MSG_STREAM_NOT_FOUND: 'Stream not found',
        MSG_ERROR_PREFIX: 'Error encountered:',
        MSG_DEFAULT_ERROR_MESSAGE: 'Sorry, we were unable to play the media you selected. Please try again, or select alternate media.',
        MSG_LIVE: 'LIVE',
        MSG_SEEK_TO: 'Seek to',
        MSG_CURRENT: 'Currrent',
        MSG_PREVIEW: 'Preview',
        MSG_PAUSE: 'Pause',
        MSG_CUSTOMIZE_CLIP_POINTS: 'Customize the start and end point of the video.',
        MSG_BUFFERING_TEXT: 'buffering',
        MSG_VERSION_TEXT: 'Version',
        MSG_SHARE_CONTENT_DISABLED: 'Share and embed are disabled.',
        MSG_SHARE_CONNECT_FAILURE: 'Unable to connect. Please try again.',
        MSG_LINK_TEXT: 'Link',
        MSG_EMBED_TEXT: 'Embed',
        MSG_POST_TEXT: 'Post',
        MSG_SHARE_VIDEO_TEXT: 'Share this video...',
        MSG_EMAIL_SEND_SUCCESS_MESSAGE: 'Your email has been sent!',
        MSG_EMAIL_SEND_FAILURE: 'Message could not be sent.',
        MSG_EMAIL_CHARACTERS_REMAINING_TEXT: ' characters left',
        MSG_EMAIL_MESSAGE_INVALID: 'Please limit your message to 500 characters or less.',
        MSG_EMAIL_ADDRESS_INVALID: 'Invalid Email Address',
        MSG_EMAIL_MESSAGE: 'Message',
        MSG_EMAIL_MESSAGE_DEFAULT: 'Check out this video from xxx',
        MSG_EMAIL_VIDEO: 'Email this video',
        MSG_EMAIL_FROM: 'From',
        MSG_EMAIL_TO: 'To'
      }
    }
  };
};

var flashConfig = __webpack_require__(736);

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  media: {
    source: [],
    autoplay: false
  },
  debug: false,
  autoplay: false,
  /* This controls code enable/disable the context menu on right click. In this config we
  are disabling it*/
  controls: {
    native: true,
    'mode': 'none'
  },
  branding: {
    id: 'logo',
    logo: null
  },
  playoverlay: {
    enabled: true
  },
  captioning: {
    enabled: true
  },
  webmd: {
    chapterData: []
  },
  mode: 'html'

};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoHeartbeat = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContextDataVars = ['contextData.a.contentType', 'contextData.a.media.name', 'contextData.a.media.playerName', 'contextData.a.media.pageName', 'contextData.a.media.friendlyName', 'contextData.a.media.length', 'contextData.a.media.channel', 'contextData.a.media.view', 'contextData.a.media.ad.name', 'contextData.a.media.ad.podFriendlyName', 'contextData.a.media.ad.length', 'contextData.a.media.ad.pod', 'contextData.a.media.ad.podPosition', 'contextData.a.media.ad.podSecond', 'contextData.a.media.ad.CPM', 'contextData.a.media.ad.view', 'contextData.a.media.extcampaign', 'contextData.wb.vpgnm', 'contextData.wb.ecd', 'contextData.wb.vdname'];

/*
 * VideoHeartbeat
 * -----------------------------------
 *  Uses VideoHeartbeat.min.js
 *  Returns the module with 'ADB' property.
 */

var VideoHeartbeat = exports.VideoHeartbeat = function (_Reflux$Store) {
  _inherits(VideoHeartbeat, _Reflux$Store);

  function VideoHeartbeat(config, VideoActions) {
    _classCallCheck(this, VideoHeartbeat);

    var _this = _possibleConstructorReturn(this, (VideoHeartbeat.__proto__ || Object.getPrototypeOf(VideoHeartbeat)).call(this));

    _this.listenables = [VideoActions];
    _this._amp = null;
    _this._mediaElement = null;
    _this.config = config;
    _this.ADB = {};
    _this.heartbeat = null;
    _this.isFirstPlay = true;
    _this.loadVideoHeartbeat();
    return _this;
  }

  _createClass(VideoHeartbeat, [{
    key: 'loadVideoHeartbeat',
    value: function loadVideoHeartbeat() {
      // Heartbeat core
      !function (a) {
        if ("undefined" == typeof b) var b = {};if ("undefined" == typeof c) var c = {};if ("undefined" == typeof d) var d = {};if (d.radio || (d.radio = {}), d.plugin || (d.plugin = {}), "undefined" == typeof e) var e = {};e.clock || (e.clock = {}), function (a) {
          "use strict";
          function b(a, b) {
            var c = (65535 & a) + (65535 & b),
                d = (a >> 16) + (b >> 16) + (c >> 16);return d << 16 | 65535 & c;
          }function c(a, b) {
            return a << b | a >>> 32 - b;
          }function d(a, d, e, f, g, h) {
            return b(c(b(b(d, a), b(f, h)), g), e);
          }function e(a, b, c, e, f, g, h) {
            return d(b & c | ~b & e, a, b, f, g, h);
          }function f(a, b, c, e, f, g, h) {
            return d(b & e | c & ~e, a, b, f, g, h);
          }function g(a, b, c, e, f, g, h) {
            return d(b ^ c ^ e, a, b, f, g, h);
          }function h(a, b, c, e, f, g, h) {
            return d(c ^ (b | ~e), a, b, f, g, h);
          }function i(a, c) {
            a[c >> 5] |= 128 << c % 32, a[(c + 64 >>> 9 << 4) + 14] = c;var d,
                i,
                j,
                k,
                l,
                m = 1732584193,
                n = -271733879,
                o = -1732584194,
                p = 271733878;for (d = 0; d < a.length; d += 16) {
              i = m, j = n, k = o, l = p, m = e(m, n, o, p, a[d], 7, -680876936), p = e(p, m, n, o, a[d + 1], 12, -389564586), o = e(o, p, m, n, a[d + 2], 17, 606105819), n = e(n, o, p, m, a[d + 3], 22, -1044525330), m = e(m, n, o, p, a[d + 4], 7, -176418897), p = e(p, m, n, o, a[d + 5], 12, 1200080426), o = e(o, p, m, n, a[d + 6], 17, -1473231341), n = e(n, o, p, m, a[d + 7], 22, -45705983), m = e(m, n, o, p, a[d + 8], 7, 1770035416), p = e(p, m, n, o, a[d + 9], 12, -1958414417), o = e(o, p, m, n, a[d + 10], 17, -42063), n = e(n, o, p, m, a[d + 11], 22, -1990404162), m = e(m, n, o, p, a[d + 12], 7, 1804603682), p = e(p, m, n, o, a[d + 13], 12, -40341101), o = e(o, p, m, n, a[d + 14], 17, -1502002290), n = e(n, o, p, m, a[d + 15], 22, 1236535329), m = f(m, n, o, p, a[d + 1], 5, -165796510), p = f(p, m, n, o, a[d + 6], 9, -1069501632), o = f(o, p, m, n, a[d + 11], 14, 643717713), n = f(n, o, p, m, a[d], 20, -373897302), m = f(m, n, o, p, a[d + 5], 5, -701558691), p = f(p, m, n, o, a[d + 10], 9, 38016083), o = f(o, p, m, n, a[d + 15], 14, -660478335), n = f(n, o, p, m, a[d + 4], 20, -405537848), m = f(m, n, o, p, a[d + 9], 5, 568446438), p = f(p, m, n, o, a[d + 14], 9, -1019803690), o = f(o, p, m, n, a[d + 3], 14, -187363961), n = f(n, o, p, m, a[d + 8], 20, 1163531501), m = f(m, n, o, p, a[d + 13], 5, -1444681467), p = f(p, m, n, o, a[d + 2], 9, -51403784), o = f(o, p, m, n, a[d + 7], 14, 1735328473), n = f(n, o, p, m, a[d + 12], 20, -1926607734), m = g(m, n, o, p, a[d + 5], 4, -378558), p = g(p, m, n, o, a[d + 8], 11, -2022574463), o = g(o, p, m, n, a[d + 11], 16, 1839030562), n = g(n, o, p, m, a[d + 14], 23, -35309556), m = g(m, n, o, p, a[d + 1], 4, -1530992060), p = g(p, m, n, o, a[d + 4], 11, 1272893353), o = g(o, p, m, n, a[d + 7], 16, -155497632), n = g(n, o, p, m, a[d + 10], 23, -1094730640), m = g(m, n, o, p, a[d + 13], 4, 681279174), p = g(p, m, n, o, a[d], 11, -358537222), o = g(o, p, m, n, a[d + 3], 16, -722521979), n = g(n, o, p, m, a[d + 6], 23, 76029189), m = g(m, n, o, p, a[d + 9], 4, -640364487), p = g(p, m, n, o, a[d + 12], 11, -421815835), o = g(o, p, m, n, a[d + 15], 16, 530742520), n = g(n, o, p, m, a[d + 2], 23, -995338651), m = h(m, n, o, p, a[d], 6, -198630844), p = h(p, m, n, o, a[d + 7], 10, 1126891415), o = h(o, p, m, n, a[d + 14], 15, -1416354905), n = h(n, o, p, m, a[d + 5], 21, -57434055), m = h(m, n, o, p, a[d + 12], 6, 1700485571), p = h(p, m, n, o, a[d + 3], 10, -1894986606), o = h(o, p, m, n, a[d + 10], 15, -1051523), n = h(n, o, p, m, a[d + 1], 21, -2054922799), m = h(m, n, o, p, a[d + 8], 6, 1873313359), p = h(p, m, n, o, a[d + 15], 10, -30611744), o = h(o, p, m, n, a[d + 6], 15, -1560198380), n = h(n, o, p, m, a[d + 13], 21, 1309151649), m = h(m, n, o, p, a[d + 4], 6, -145523070), p = h(p, m, n, o, a[d + 11], 10, -1120210379), o = h(o, p, m, n, a[d + 2], 15, 718787259), n = h(n, o, p, m, a[d + 9], 21, -343485551), m = b(m, i), n = b(n, j), o = b(o, k), p = b(p, l);
            }return [m, n, o, p];
          }function j(a) {
            var b,
                c = "";for (b = 0; b < 32 * a.length; b += 8) {
              c += String.fromCharCode(a[b >> 5] >>> b % 32 & 255);
            }return c;
          }function k(a) {
            var b,
                c = [];for (c[(a.length >> 2) - 1] = void 0, b = 0; b < c.length; b += 1) {
              c[b] = 0;
            }for (b = 0; b < 8 * a.length; b += 8) {
              c[b >> 5] |= (255 & a.charCodeAt(b / 8)) << b % 32;
            }return c;
          }function l(a) {
            return j(i(k(a), 8 * a.length));
          }function m(a, b) {
            var c,
                d,
                e = k(a),
                f = [],
                g = [];for (f[15] = g[15] = void 0, e.length > 16 && (e = i(e, 8 * a.length)), c = 0; 16 > c; c += 1) {
              f[c] = 909522486 ^ e[c], g[c] = 1549556828 ^ e[c];
            }return d = i(f.concat(k(b)), 512 + 8 * b.length), j(i(g.concat(d), 640));
          }function n(a) {
            var b,
                c,
                d = "0123456789abcdef",
                e = "";for (c = 0; c < a.length; c += 1) {
              b = a.charCodeAt(c), e += d.charAt(b >>> 4 & 15) + d.charAt(15 & b);
            }return e;
          }function o(a) {
            return unescape(encodeURIComponent(a));
          }function p(a) {
            return l(o(a));
          }function q(a) {
            return n(p(a));
          }function r(a, b) {
            return m(o(a), o(b));
          }function s(a, b) {
            return n(r(a, b));
          }function t(a, b, c) {
            return b ? c ? r(b, a) : s(b, a) : c ? p(a) : q(a);
          }a.md5 = t;
        }(b), function (a) {
          "use strict";
          var b = {};b.startsWith = function (a, b) {
            return 0 == a.indexOf(b);
          }, a.StringUtils = b;
        }(b), function (a) {
          "use strict";
          var b = {};b.clone = function (a) {
            var b = {};for (var c in a) {
              a.hasOwnProperty(c) && (b[c] = a[c]);
            }return b;
          }, b.merge = function (a, c) {
            var d = b.clone(a);for (var e in c) {
              c.hasOwnProperty(e) && (d[e] = c[e]);
            }return d;
          }, a.ObjectUtils = b;
        }(b), function (a) {
          "use strict";
          function b(a, b, c) {
            this.fn = a, this.ctx = b, this.params = c;
          }b.prototype.run = function () {
            this.params ? this.fn.apply(this.ctx, this.params) : this.fn.apply(this.ctx);
          }, a.radio.Command = b;
        }(d), function (a) {
          "use strict";
          function b(a, b) {
            this._queue = [], this._lastTs = 0, this._isSuspended = "undefined" != typeof a ? a : !1, this._delay = "undefined" != typeof b ? b : 0;
          }b.prototype.addCommand = function (a) {
            this._queue.push(a), this._drain();
          }, b.prototype.cancelAllCommands = function () {
            this._queue = [];
          }, b.prototype.isEmpty = function () {
            return 0 === this._queue.length;
          }, b.prototype.suspend = function () {
            this._isSuspended = !0;
          }, b.prototype.resume = function () {
            this._isSuspended = !1, this._drain();
          }, b.prototype.flush = function () {
            this._isSuspended = !1;for (var a = 0; a < this._queue.length; a++) {
              var b = this._queue[a];b.run();
            }this._queue = [];
          }, b.prototype._drain = function () {
            if (!this._isSuspended && !this._drainInProgress) {
              this._drainInProgress = !0;var a = this;!function b() {
                var c = a._queue.shift();c ? a._runCommand(c, function () {
                  a._isSuspended || b();
                }) : a._drainInProgress = !1;
              }();
            }
          }, b.prototype._runCommand = function (a, b) {
            function c() {
              a.run(), null != b && b.call(d);
            }var d = this;if (0 == this._lastTs) c();else {
              var e = new Date().getTime(),
                  f = e - this._lastTs;this._lastTs = e, f < this._delay ? setTimeout(c, this._delay - f) : c();
            }
          }, a.radio.CommandQueue = b;
        }(d), function (a) {
          "use strict";
          function b(a, b) {
            if (this._name = a, !b) throw new Error("Reference to the logger object cannot be NULL");this._logger = b, this._listeners = {}, this._requests = {}, this._commands = {}, this._isShutDown = !1;
          }function c(a, c) {
            if (a === c) return !0;for (var d = (a || "").split(b.SEPARATOR), e = (c || "").split(b.SEPARATOR), f = !0, g = 0; g < d.length; g++) {
              f = f && (d[g] === b.WILDCARD || d[g] === e[g]);
            }return f;
          }b.WILDCARD = "*", b.SEPARATOR = ":", b.prototype.toString = function () {
            return "<channel: " + this._name + ">";
          }, b.prototype.shutdown = function () {
            this._isShutDown || (this._logger.debug(d, "#shutdown > Shutting down"), this.off(), this._requests = {}, this._commands = {}, this._isShutDown = !0);
          }, b.prototype.on = function (a, b, c) {
            this._isShutDown || (this._listeners[a] || (this._listeners[a] = []), this._listeners[a].push({ fn: b, ctx: c }));
          }, b.prototype.off = function (a, b, c) {
            if (!this._isShutDown) {
              if (b = "function" == typeof b ? b : null, !a && null == b && !c) return void (this._listeners = {});if (a) this._removeListener(a, b, c);else for (a in this._listeners) {
                this._listeners.hasOwnProperty(a) && this._removeListener(a, b, c);
              }
            }
          }, b.prototype.trigger = function (a) {
            if (!this._isShutDown) for (var b in this._listeners) {
              if (this._listeners.hasOwnProperty(b) && c(b, a.name)) for (var d = this._listeners[b].slice(0), e = 0; e < d.length; e++) {
                var f = d[e];f.fn.call(f.ctx, a);
              }
            }
          }, b.prototype.comply = function (a, b, c) {
            this._isShutDown || (this._commands[a] = { cmd: b, ctx: c });
          }, b.prototype.command = function (a, b) {
            if (!this._isShutDown) {
              var c = this._commands[a];return c ? void c.cmd.call(c.ctx, b) : void this._logger.warn(d, "#command > No command handler for: " + a);
            }
          }, b.prototype.reply = function (a, b, c) {
            this._isShutDown || (this._requests[a] = { fn: b, ctx: c });
          }, b.prototype.request = function (a) {
            if (!this._isShutDown) {
              var b = this._requests[a];return b ? b.fn.call(b.ctx) : (this._logger.warn(d, "#request > No request handler for: " + a), null);
            }
          }, b.prototype._removeListener = function (a, b, c) {
            b = "function" == typeof b ? b : null;var d = this._listeners[a];if (d) {
              if (!d.length || null == b && !c) return void delete this._listeners[a];for (var e = 0; e < d.length; e++) {
                var f = d[e];null !== b && b !== f.fn || c && c !== f.ctx || this._listeners[a].splice(e, 1);
              }
            }
          };var d = "radio::Channel";a.radio.Channel = b;
        }(d), function (a) {
          "use strict";
          function b(a) {
            if (!a) throw new Error("Reference to the logger object cannot be NULL");this._logger = a, this._channels = {};
          }var c = a.radio.Channel;b.prototype.channel = function (a) {
            return this._channels[a] || (this._channels[a] = new c(a, this._logger)), this._channels[a];
          }, b.prototype.shutdown = function () {
            for (var a in this._channels) {
              this._channels.hasOwnProperty(a) && this._channels[a].shutdown();
            }
          }, a.radio.Radio = b;
        }(d), function (a) {
          "use strict";
          function b(a, b) {
            function c() {
              this.constructor = a;
            }for (var d in b) {
              b.hasOwnProperty(d) && (a[d] = b[d]);
            }return c.prototype = b.prototype, a.prototype = new c(), a.__super__ = b.prototype, a;
          }a.extend = b;
        }(d), function (a) {
          "use strict";
          function b() {}b.prototype.write = function (a) {
            throw new Error("Implementation error: Method must be overridden.");
          }, a.ILogWriter = b;
        }(d), function (a) {
          "use strict";
          function b() {}b.prototype.write = function (a) {
            window.console && window.console.log && window.console.log(a);
          }, a.LogWriter = b;
        }(d, c), function (a) {
          "use strict";
          function b() {}b.prototype.setLogWriter = function (a) {
            throw new Error("Implementation error: Method must be overridden.");
          }, b.prototype.getLogWriter = function () {
            throw new Error("Implementation error: Method must be overridden.");
          }, b.prototype.getEnabled = function () {
            throw new Error("Implementation error: Method must be overridden.");
          }, b.prototype.enable = function () {
            throw new Error("Implementation error: Method must be overridden.");
          }, b.prototype.disable = function () {
            throw new Error("Implementation error: Method must be overridden.");
          }, b.prototype.debug = function (a, b) {
            throw new Error("Implementation error: Method must be overridden.");
          }, b.prototype.info = function (a, b) {
            throw new Error("Implementation error: Method must be overridden.");
          }, b.prototype.warn = function (a, b) {
            throw new Error("Implementation error: Method must be overridden.");
          }, b.prototype.error = function (a, b) {
            throw new Error("Implementation error: Method must be overridden.");
          }, a.ILogger = b;
        }(d), function (a) {
          "use strict";
          function b() {
            this._logWriter = new d();
          }function c(a) {
            return 10 > a ? "00" + a : 100 > a ? "0" + a : "" + a;
          }var d = a.LogWriter;b.prototype.setLogWriter = function (a) {
            if (!a) throw new Error("Reference to the ILogWriter object cannot be NULL");this._logWriter = a, this._enabled = !1;
          }, b.prototype.getLogWriter = function () {
            return this._logWriter;
          }, b.prototype.getEnabled = function () {
            return this._enabled;
          }, b.prototype.enable = function () {
            this._enabled = !0;
          }, b.prototype.disable = function () {
            this._enabled = !1;
          }, b.prototype.debug = function (a, b) {
            this._log(a, f, b);
          }, b.prototype.info = function (a, b) {
            this._log(a, e, b);
          }, b.prototype.warn = function (a, b) {
            this._log(a, g, b);
          }, b.prototype.error = function (a, b) {
            this._log(a, h, b);
          }, b.prototype._log = function (a, b, d) {
            if (b == h || this._enabled) {
              var e = "",
                  f = new Date();e += "[" + f.toTimeString() + "." + c(f.getMilliseconds()) + "] [" + b + "] ", e += "[" + a + "] " + d, this._logWriter.write(e);
            }
          };var e = "INFO",
              f = "DEBUG",
              g = "WARN",
              h = "ERROR";a.Logger = b;
        }(d), function (a) {
          "use strict";
          function b(a, b) {
            this._pluginName = a, this._eventName = b;
          }var c = a.radio.Channel;b.prototype.getPluginName = function () {
            return this._pluginName;
          }, b.prototype.getEventName = function () {
            return this._eventName;
          }, b.prototype.getName = function () {
            return this._pluginName + c.SEPARATOR + this._eventName;
          }, a.Trigger = b;
        }(d), function (a) {
          "use strict";
          function b(a, b) {
            this.name = a, this.data = b;
          }b.SUCCESS = "success", b.ERROR = "error", b.createFromTrigger = function (a) {
            return new b(a.getName());
          }, a.Event = b;
        }(d), function (a) {
          "use strict";
          function b() {
            this._events = {};
          }b.prototype.addEventListener = function (a, b, c) {
            a && b && (c = c || window, this._events[a] = this._events[a] || [], this._events[a].push({ cb: b, ctx: c }));
          }, b.prototype.removeEventListener = function (a, b, c) {
            if (a && b) {
              c = c || window;var d,
                  e,
                  f = !1;for (e in this._events) {
                if (a === e) {
                  f = !0;break;
                }
              }if (f) {
                for (d = this._events[e].length - 1; d >= 0; d--) {
                  var g = this._events[e][d];b === g.cb && c === g.ctx && this._events[e].splice(d, 1);
                }this._events[e].length || delete this._events[e];
              }
            }
          }, b.prototype.dispatchEvent = function (a) {
            if (a.name) {
              var b, c;for (b in this._events) {
                if (this._events.hasOwnProperty(b) && a.name === b) {
                  var d = this._events[b],
                      e = d.slice(0),
                      f = e.length;for (c = 0; f > c; c++) {
                    e[c].cb.call(e[c].ctx, a);
                  }break;
                }
              }
            }
          }, b.prototype.removeAllListeners = function (a) {
            if (a) {
              var b, c;for (c in this._events) {
                if (this._events.hasOwnProperty(c)) {
                  for (b = this._events[c].length - 1; b >= 0; b--) {
                    var d = this._events[c][b];d.ctx === a && this._events[c].splice(b, 1);
                  }this._events[c].length || delete this._events[c];
                }
              }
            } else this._events = {};
          }, a.EventDispatcher = b;
        }(d), function (a) {
          "use strict";
          function b() {}function c(a, b) {
            this.url = a || null, this.method = b, this._xmlhttp = null;
          }function d() {
            d.__super__.constructor.call(this), this._connection = null;
          }var e = a.Event,
              f = a.EventDispatcher;b.GET = "GET", d.RESPONSE = "response", d.INSTANCE = "instance", a.extend(d, f), d.prototype.close = function () {
            this.removeAllListeners(null);
          }, d.prototype.load = function (a) {
            a && a.method && a.url && (a._xmlhttp = this._createCORSRequest(a), a._xmlhttp ? a._xmlhttp.send() : this._loadImage(a));
          }, d.prototype._createCORSRequest = function (a) {
            var b = null;if ("undefined" != typeof window.XMLHttpRequest) {
              var c = new window.XMLHttpRequest();"withCredentials" in c && (b = c, b.open(a.method, a.url, !0));
            }if (null == b && "undefined" != typeof window.XDomainRequest && (b = new window.XDomainRequest(), b.open(a.method, a.url)), b) {
              var f = {};f[d.INSTANCE] = this;var g = this;b.onload = function () {
                return b.status && parseInt(b.status, 10) >= 400 ? this.onerror() : (f[d.RESPONSE] = b.responseText, void g.dispatchEvent(new e(e.SUCCESS, f)));
              }, b.onerror = function () {
                g.dispatchEvent(new e(e.ERROR, f));
              };
            }return b;
          }, d.prototype._loadImage = function (a) {
            this._connection || (this._connection = new Image(), this._connection.alt = ""), this._connection.src = a.url;var b = {};b[d.RESPONSE] = "", b[d.INSTANCE] = this, this.dispatchEvent(new e(e.SUCCESS, b));
          }, a.URLRequestMethod = b, a.URLRequest = c, a.URLLoader = d;
        }(d), function (a) {
          "use strict";
          var b = "js",
              c = "1.5.7.68",
              d = "55a81f",
              e = 4,
              f = {};f.getVersion = function () {
            return b + "-" + c + "-" + d;
          }, f.getMajor = function () {
            return f.getNumberAtPosition(0);
          }, f.getMinor = function () {
            return f.getNumberAtPosition(1);
          }, f.getMicro = function () {
            return f.getNumberAtPosition(2);
          }, f.getPatch = function () {
            return f.getNumberAtPosition(3);
          }, f.getBuild = function () {
            return d;
          }, f.getApiLevel = function () {
            return e;
          }, f.getNumberAtPosition = function (a) {
            return c.split(".")[a];
          }, a.Version = f;
        }(c), function (a) {
          "use strict";
          function b(a, b) {
            this._message = a, this._details = b;
          }b.prototype.getMessage = function () {
            return this._message;
          }, b.prototype.getDetails = function () {
            return this._details;
          }, a.ErrorInfo = b;
        }(c), function (a) {
          "use strict";
          function b() {
            this.debugLogging = !1;
          }a.HeartbeatConfig = b;
        }(c), function (a) {
          "use strict";
          function b() {}b.prototype.onError = function (a) {}, a.HeartbeatDelegate = b;
        }(c), function (a) {
          "use strict";
          function b() {}b.prototype.configure = function (a) {
            throw new Error("Implementation error: Method must be overridden.");
          }, b.prototype.bootstrap = function (a) {
            throw new Error("Implementation error: Method must be overridden.");
          }, b.prototype.setup = function () {
            throw new Error("Implementation error: Method must be overridden.");
          }, b.prototype.destroy = function () {
            throw new Error("Implementation error: Method must be overridden.");
          }, b.prototype.enable = function () {
            throw new Error("Implementation error: Method must be overridden.");
          }, b.prototype.disable = function () {
            throw new Error("Implementation error: Method must be overridden.");
          }, b.prototype.getName = function () {
            throw new Error("Implementation error: Method must be overridden.");
          }, b.prototype.isInitialized = function () {
            throw new Error("Implementation error: Method must be overridden.");
          }, b.prototype.resolveData = function (a) {
            throw new Error("Implementation error: Method must be overridden.");
          }, a.plugin.IPlugin = b;
        }(d), function (a) {
          "use strict";
          function b(a, b, c, d) {
            this.trigger = a, this.action = c, this.plugin = b, this._paramMappings = {}, this.mergeParams(d);
          }var c = a.plugin.ParamMapping;b.prototype.mergeParams = function (a) {
            if (a) for (var b = 0; b < a.length; b++) {
              var c = a[b];this._paramMappings[c.getKeyName()] = c;
            }
          }, b.prototype.getParams = function () {
            var a = [];for (var b in this._paramMappings) {
              this._paramMappings.hasOwnProperty(b) && a.push(this._paramMappings[b]);
            }return a;
          }, b.prototype.addParam = function (a) {
            this._paramMappings[a.getKeyName()] = a;
          }, b.prototype.removeParam = function (a, b) {
            var d = new c(a, b);this._paramMappings.hasOwnProperty(d.getKeyName()) && delete this._paramMappings[d.getKeyName()];
          }, a.plugin.Behaviour = b;
        }(d), function (a) {
          "use strict";
          function b(a, b, d) {
            this._pluginName = a, this._key = b, this._paramName = d || a + c.SEPARATOR + b;
          }var c = a.radio.Channel;b.prototype.getPluginName = function () {
            return this._pluginName;
          }, b.prototype.getKey = function () {
            return this._key;
          }, b.prototype.getKeyName = function () {
            return this._pluginName + c.SEPARATOR + this._key;
          }, b.prototype.getParamName = function () {
            return this._paramName;
          }, a.plugin.ParamMapping = b;
        }(d), function (a) {
          "use strict";
          function b(a) {
            if (!a) throw new Error("Reference to the logger object cannot be NULL");this._logger = a, this._plugins = {}, this._behaviours = {}, this._radio = new d(this._logger), this._dataChannel = this._radio.channel(g), this._ctrlChannel = this._radio.channel(h);
          }var c = a.Event,
              d = a.radio.Radio,
              e = a.radio.Channel,
              f = a.plugin.Behaviour;b.ERROR = "error", b.prototype.addPlugin = function (a) {
            var b = a.getName();this._plugins[b] && this._logger.warn(i, "#addPlugin > Replacing plugin: " + b), this._plugins[b] = a, a.bootstrap(this);
          }, b.prototype.setupPlugins = function () {
            for (var a in this._plugins) {
              this._plugins.hasOwnProperty(a) && this._plugins[a].setup();
            }
          }, b.prototype.pluginExists = function (a) {
            return !!this._plugins[a];
          }, b.prototype.isPluginInitialized = function (a) {
            return this._plugins[a] && this._plugins[a].isInitialized();
          }, b.prototype.on = function (a, b, c, d) {
            this._dataChannel.on(a + e.SEPARATOR + b, c, d);
          }, b.prototype.off = function (a, b, c, d) {
            var f = a && b ? a + e.SEPARATOR + b : null;this._dataChannel.off(f, c, d);
          }, b.prototype.trigger = function (a) {
            var b = a.name,
                c = this._behaviours[b];if (c) {
              var d,
                  e,
                  f,
                  g,
                  h,
                  i = {},
                  j = {};for (d = 0; d < c.length; d++) {
                if (f = c[d], g = f.getParams()) for (e = 0; e < g.length; e++) {
                  h = g[e], i[h.getPluginName()] = i[h.getPluginName()] || [], h.key in i[h.getPluginName()] || i[h.getPluginName()].push(h.getKey());
                }
              }for (var k in i) {
                i.hasOwnProperty(k) && (j[k] = this.request(k, i[k]));
              }for (d = 0; d < c.length; d++) {
                f = c[d];var l = { _behaviour: f, _eventData: a.data || {} };if (g = f.getParams()) {
                  for (e = 0; e < g.length; e++) {
                    h = g[e], l[h.getParamName()] = j[h.getPluginName()] ? j[h.getPluginName()][h.getKey()] : null;
                  }this.command(f.plugin.getName(), f.action, l);
                }
              }
            }this._dataChannel.trigger(a);
          }, b.prototype.request = function (a, b) {
            var c = this._plugins[a];return c && b && 0 != b.length ? c.resolveData(b) : null;
          }, b.prototype.raise = function (a) {
            this._errorInfo = a;var d = new c(b.ERROR, a);this._ctrlChannel.trigger(d);
          }, b.prototype.getErrorInfo = function () {
            return this._errorInfo;
          }, b.prototype.destroy = function () {
            this._radio.shutdown();for (var a in this._plugins) {
              this._plugins.hasOwnProperty(a) && this._plugins[a].destroy();
            }
          }, b.prototype.comply = function (a, b, c) {
            this._dataChannel.comply(a.getName() + e.SEPARATOR + b, c, a);
          }, b.prototype.command = function (a, b, c) {
            this._dataChannel.command(a + e.SEPARATOR + b, c);
          }, b.prototype.registerBehaviour = function (a, b, c, d) {
            var e = a.getName(),
                g = new f(a, b, c, d);this._behaviours[e] = this._behaviours[e] || [], this._behaviours[e].push(g);
          };var g = "data_channel",
              h = "ctrl_channel",
              i = "plugin::PluginManager";a.plugin.PluginManager = b;
        }(d), function (a, b) {
          "use strict";
          function c(a) {
            this._name = a, this._isInitialized = !1, this._isDestroyed = !1, this._isEnabled = !0, this._dataResolver = {}, this._logTag = "plugin::" + this.getName(), this._logger = new d();
          }var d = a.Logger,
              e = a.Trigger,
              f = a.Event,
              g = b.ErrorInfo;c.INITIALIZED = "initialized", c.prototype.configure = function (a) {}, c.prototype.bootstrap = function (a) {
            this._pluginManager = a, this._isDestroyed && this._pluginManager.raise(new g("Invalid state.", "Plugin already destroyed."));
          }, c.prototype.setup = function () {
            this._trigger(c.INITIALIZED), this._isInitialized = !0;
          }, c.prototype.destroy = function () {
            this._isDestroyed || (this._isDestroyed = !0, this._teardown());
          }, c.prototype.enable = function () {
            this._isEnabled = !0, this._enabled();
          }, c.prototype.disable = function () {
            this._isEnabled = !1, this._disabled();
          }, c.prototype.getName = function () {
            return this._name;
          }, c.prototype.getLogger = function () {
            return this._logger;
          }, c.prototype.isInitialized = function () {
            return this._isInitialized;
          }, c.prototype.resolveData = function (a) {
            if (!this._isEnabled || !this._isInitialized) return this._logger.warn(this._logTag, "Unable to retrieve plugin data. Plugin: " + this._name + ". Enabled: " + this._isEnabled + ". Initialized: " + this._isInitialized + "."), null;if ("function" == typeof this._dataResolver) return this._dataResolver.call(this, a);var b = null;if (a) for (var c = 0; c < a.length; c++) {
              var d = a[c];this._dataResolver.hasOwnProperty(d) && (b = b || {}, "function" == typeof this._dataResolver[d] ? b[d] = this._dataResolver[d].call(this) : b[d] = this._dataResolver[d]);
            }return b;
          }, c.prototype.toString = function () {
            return "<plugin: " + this._name + ">";
          }, c.prototype._enabled = function () {}, c.prototype._disabled = function () {}, c.prototype._teardown = function () {}, c.prototype._canProcess = function () {
            return this._isEnabled ? this._isDestroyed ? (this._logger.error(this._logTag, "Plugin destroyed."), !1) : !0 : (this._logger.error(this._logTag, "Plugin disabled."), !1);
          }, c.prototype._trigger = function (a, b) {
            var c = f.createFromTrigger(new e(this.getName(), a));c.data = b, this._pluginManager.trigger(c);
          }, a.plugin.BasePlugin = c;
        }(d, c), function (a) {
          "use strict";
          function b(a, b, c) {
            this.name = a, this.interval = b, this.isActive = !1, this.repeatCount = "undefined" != typeof c ? c : e, this._nextTickTimestamp = 0, this.reset();
          }function c(a, b) {
            if (!a) throw new Error("Reference to the ClockService object cannot be NULL");if (this._service = a, !b) throw new Error("Reference to the logger object cannot be NULL");this._logger = b, this._isDestroyed = !1, this._timers = {};var c = this;this._clock = window.setInterval(function () {
              c._onTick();
            }, 1e3 * f);
          }b.prototype.reset = function () {
            this.tick = 0, this._createdTimestamp = new Date().getTime(), this._updateNextTickTimestamp();
          }, b.prototype.shouldTick = function () {
            var a = new Date().getTime();return a > this._nextTickTimestamp - f / 2 ? (this.tick++, this._updateNextTickTimestamp(), !0) : !1;
          }, b.prototype._updateNextTickTimestamp = function () {
            this._nextTickTimestamp = this._createdTimestamp + 1e3 * this.interval * (this.tick + 1);
          }, c.prototype.createTimer = function (a, c, d) {
            this._timers[a] = new b(a, c, d);
          }, c.prototype.destroyTimer = function (a) {
            delete this._timers[a];
          }, c.prototype.resumeTimer = function (a, b) {
            b = "undefined" != typeof b ? b : !1, this._logger.debug(d, "#resumeTimer(name=" + a + ", reset=" + b + ")");var c = this._timers[a];c && (c.isActive = !0, b && c.reset());
          }, c.prototype.pauseTimer = function (a, b) {
            b = "undefined" != typeof b ? b : !1, this._logger.debug(d, "#pauseTimer(name=" + a + ", reset=" + b + ")");var c = this._timers[a];c && (c.isActive = !1, b && c.reset());
          }, c.prototype.isTimerPaused = function (a) {
            var b = this._timers[a];return b ? !b.isActive : !1;
          }, c.prototype.destroy = function () {
            this._isDestroyed || (this._isDestroyed = !0, this._timers = {}, window.clearInterval(this._clock));
          }, c.prototype._onTick = function () {
            for (var a in this._timers) {
              if (this._timers.hasOwnProperty(a)) {
                var b = this._timers[a];b.isActive && b.shouldTick() && (b.interval > 1 && this._logger.debug(d, "#_onTick() > " + b.name + "(" + b.tick + " | " + b.repeatCount + ")"), 0 != b.repeatCount ? (this._service.onTick(b.name, b.interval, b.tick), b.repeatCount != e && b.repeatCount--) : this.destroyTimer(b.name));
              }
            }
          };var d = "service.clock::TimerManager",
              e = -1,
              f = .25;a.clock.TimerDescriptor = b, a.clock.TimerManager = c;
        }(e), function (a, b, c) {
          "use strict";
          function d(a) {
            if (d.__super__.constructor.call(this, h), !a) throw new Error("Reference to the logger object cannot be NULL");this._logger = a, this._timerManager = new e(this, this._logger), this._setupDataResolver();
          }var e = c.clock.TimerManager,
              f = b.StringUtils,
              g = a.plugin.BasePlugin;a.extend(d, g), d.prototype.bootstrap = function (a) {
            d.__super__.bootstrap.call(this, a), this._pluginManager.comply(this, i, this._cmdCreate), this._pluginManager.comply(this, k, this._cmdResume), this._pluginManager.comply(this, j, this._cmdPause), this._pluginManager.comply(this, l, this._cmdDestroy);
          }, d.prototype._teardown = function () {
            this._timerManager.destroy();
          }, d.prototype._cmdCreate = function (a) {
            var b = a[o] || s;this._timerManager.createTimer(a[m], a[n], b);
          }, d.prototype._cmdPause = function (a) {
            this._timerManager.pauseTimer(a[m], !!a[q]);
          }, d.prototype._cmdResume = function (a) {
            this._timerManager.resumeTimer(a[m], !!a[q]);
          }, d.prototype._cmdDestroy = function (a) {
            this._timerManager.destroyTimer(a[m]);
          }, d.prototype.onTick = function (a, b, c) {
            a += ".tick";var d = {};d[m] = a, d[n] = b, d[p] = c, this._trigger(a, d);
          }, d.prototype._setupDataResolver = function () {
            var a = {},
                b = this._timerManager;a[r] = function (a) {
              return b.isTimerPaused(a);
            }, this._dataResolver = function (b) {
              if (!b || 0 == b.length) return null;for (var c = null, d = 0; d < b.length; d++) {
                var e = b[d];if (c = c || {}, f.startsWith(e, r)) {
                  var g = e.split(r + ".");g.length > 0 && (c[e] = a[r].call(this, g[1]));
                }
              }return c;
            };
          };var h = "service.clock",
              i = "create",
              j = "pause",
              k = "resume",
              l = "destroy",
              m = "name",
              n = "interval",
              o = "repeat_count",
              p = "tick",
              q = "reset",
              r = "is_paused",
              s = -1;c.clock.ClockService = d;
        }(d, b, e), function (a, b, c) {
          "use strict";
          function d(a, b) {
            if (this._logger = new e(), this._pluginManager = new f(this._logger), this._pluginManager.addPlugin(new g(this._logger)), b) for (var c = 0; c < b.length; c++) {
              this._pluginManager.addPlugin(b[c]);
            }this._pluginManager.setupPlugins(), this._isDestroyed = !1;
          }var e = a.Logger,
              f = a.plugin.PluginManager,
              g = b.clock.ClockService;d.prototype.configure = function (a) {
            if (!a) throw new Error("Configuration object cannot be NULL.");a.debugLogging ? this._logger.enable() : this._logger.disable(), this._isDestroyed && this._logger.error(h, "Instance is destroyed.");
          }, d.prototype.destroy = function () {
            this._isDestroyed || (this._pluginManager.destroy(), this._isDestroyed = !0);
          };var h = "Heartbeat";c.Heartbeat = d;
        }(d, e, c), a.ADB || (a.ADB = {}), a.ADB.core || (a.ADB.core = d), a.ADB.va || (a.ADB.va = c), a.ADB.va.utils || (a.ADB.va.utils = b), a.ADB.va.plugins || (a.ADB.va.plugins = {});
      }(this);

      // VideoPlayerPlugin
      !function (a) {
        if ("undefined" == typeof b) var b = {};!function (a) {
          "use strict";
          var b = {};b.ASSET_TYPE_VOD = "vod", b.ASSET_TYPE_LIVE = "live", b.ASSET_TYPE_LINEAR = "linear", a.AssetType = b;
        }(b), function (a) {
          "use strict";
          function b() {
            this.playerName = null, this.name = null, this.position = null, this.startTime = null;
          }b.prototype.toString = function () {
            return "playerName=" + this.playerName + ", name=" + this.name + ", position=" + this.position + ", startTime=" + this.startTime;
          }, a.AdBreakInfo = b;
        }(b), function (a) {
          "use strict";
          function b() {
            this.id = null, this.name = null, this.length = null, this.position = null;
          }b.prototype.toString = function () {
            return "id=" + this.id + ", name=" + this.name + ", length=" + this.length + ", position=" + this.position;
          }, a.AdInfo = b;
        }(b), function (a) {
          "use strict";
          function b() {
            this.name = null, this.length = null, this.position = null, this.startTime = null;
          }b.prototype.toString = function () {
            return "name=" + this.name + ", length=" + this.length + ", position=" + this.position + ", startTime=" + this.startTime;
          }, a.ChapterInfo = b;
        }(b), function (a) {
          "use strict";
          function b() {
            this.bitrate = null, this.fps = null, this.droppedFrames = null, this.startupTime = null;
          }b.prototype.toString = function () {
            return "bitrate=" + this.bitrate + ", fps=" + this.fps + ", droppedFrames=" + this.droppedFrames + ", startupTime=" + this.startupTime;
          }, a.QoSInfo = b;
        }(b), function (a) {
          "use strict";
          function b() {
            this.playerName = null, this.id = null, this.name = null, this.length = null, this.playhead = null, this.streamType = null, this.resumed = !1;
          }b.prototype.toString = function () {
            return "playerName=" + this.playerName + ", id=" + this.id + ", name=" + this.name + ", length=" + this.length + ", playhead=" + this.playhead + ", streamType=" + this.streamType + ", resumed=" + this.resumed;
          }, a.VideoInfo = b;
        }(b), function (a) {
          "use strict";
          function b() {
            this.debugLogging = !1;
          }a.VideoPlayerPluginConfig = b;
        }(b), function (a) {
          "use strict";
          function b() {}b.prototype.getVideoInfo = function () {
            throw new Error("Implementation error: Method must be overridden.");
          }, b.prototype.getAdBreakInfo = function () {
            return null;
          }, b.prototype.getAdInfo = function () {
            return null;
          }, b.prototype.getChapterInfo = function () {
            return null;
          }, b.prototype.getQoSInfo = function () {
            return null;
          }, a.VideoPlayerPluginDelegate = b;
        }(b), function (a, b) {
          "use strict";
          function c(a) {
            if (c.__super__.constructor.call(this, h), !a) throw new Error("PlayerPlugin delegate cannot be NULL.");this._delegate = a, this._isTrackingSessionActive = !1, this._isTrackingSessionStarted = !1, this._isTrackingAd = !1, this._playheadTimer = null, this._previousPlayhead = -1, this._stalledPlayheadCount = 0, this._playheadStalled = !1, this._videoIdle = !1, this._setupDataResolver();
          }var d = a.plugin.ParamMapping,
              e = a.Trigger,
              f = a.plugin.BasePlugin,
              g = b.VideoPlayerPluginConfig;a.extend(c, f), c.prototype.configure = function (a) {
            if (!a) throw new Error("Reference to the configuration data cannot be NULL.");if (!(a instanceof g)) throw new Error("Expected config data to be instance of VideoPlayerPluginConfig.");a.debugLogging ? this._logger.enable() : this._logger.disable(), this._logger.debug(this._logTag, "#configure(debugLogging=" + a.debugLogging + ")");
          }, c.prototype.bootstrap = function (a) {
            c.__super__.bootstrap.call(this, a), this._registerCommands(), this._registerBehaviours();
          }, c.prototype._cmdVideoIdleStart = function (a) {
            this._logger.info(this._logTag, "#_cmdVideoIdleStart()"), this._videoIdle = !0;
          }, c.prototype._cmdVideoIdleResume = function (a) {
            this._logger.info(this._logTag, "#_cmdVideoIdleResume()"), this._videoIdle && (this._trigger(o), this._trigger(p), a.isInChapter && this._trigger(A), a.isInAd && (this._trigger(u), this._isTrackingAd = !0)), this._videoIdle = !1;
          }, c.prototype.trackSessionStart = function () {
            if (this._logger.info(this._logTag, "#trackSessionStart()"), this._canProcess()) {
              if (!this._isTrackingSessionActive) return void this._logger.warn(this._logTag, "#trackSessionStart() > No active tracking session.");if (this._isTrackingSessionStarted) return void this._logger.info(this._logTag, "#trackSessionStart() > Tracking session already started.");this._trigger(o), this._isTrackingSessionStarted = !0;var a = this._dataResolver(["video.resumed"]);a.hasOwnProperty("video.resumed") && a["video.resumed"] && this._trigger(p);
            }
          }, c.prototype.trackVideoLoad = function () {
            this._logger.info(this._logTag, "#trackVideoLoad()"), this._canProcess() && (this._trigger(m), this._isTrackingSessionActive = !0, this._isTrackingSessionStarted = !1);
          }, c.prototype.trackVideoUnload = function () {
            if (this._logger.info(this._logTag, "#trackVideoUnload()"), this._canProcess()) {
              if (!this._isTrackingSessionActive) return void this._logger.warn(this._logTag, "#trackVideoUnload() > No active tracking session.");this._stopPlayheadTimer(), this._trigger(n), this._isTrackingSessionActive = !1, this._isTrackingSessionStarted = !1, this._videoIdle = !1;
            }
          }, c.prototype.trackPlay = function () {
            this._logger.info(this._logTag, "#trackPlay()"), this._canProcess() && this._startSessionIfNeeded("trackPlay") && (this._trigger(s), this._startPlayheadTimer());
          }, c.prototype.trackPause = function () {
            if (this._logger.info(this._logTag, "#trackPause()"), this._canProcess() && this._startSessionIfNeeded("trackPause")) {
              this._stopPlayheadTimer();var a = {};a[H] = !1, this._trigger(t, a);
            }
          }, c.prototype.trackBufferStart = function () {
            this._logger.info(this._logTag, "#trackBufferStart()"), this._canProcess() && this._startSessionIfNeeded("trackBufferStart") && (this._stopPlayheadTimer(), this._trigger(w));
          }, c.prototype.trackBufferComplete = function () {
            this._logger.info(this._logTag, "#trackBufferComplete()"), this._canProcess() && this._startSessionIfNeeded("trackBufferComplete") && (this._trigger(x), this._startPlayheadTimer());
          }, c.prototype.trackSeekStart = function () {
            this._logger.info(this._logTag, "#trackSeekStart()"), this._canProcess() && this._startSessionIfNeeded("trackSeekStart") && (this._stopPlayheadTimer(), this._trigger(y));
          }, c.prototype.trackSeekComplete = function () {
            if (this._logger.info(this._logTag, "#trackSeekComplete()"), this._canProcess() && this._startSessionIfNeeded("trackSeekComplete")) {
              this._trigger(z), this._startPlayheadTimer();var a = this._dataResolver(["ad.isInAd"]);this._isTrackingAd = a.hasOwnProperty("ad.isInAd") && a["ad.isInAd"];
            }
          }, c.prototype.trackComplete = function (a) {
            if (this._logger.info(this._logTag, "#trackComplete()"), this._canProcess() && this._startSessionIfNeeded("trackComplete")) {
              var b = {};b[G] = a, this._stopPlayheadTimer(), this._trigger(q, b);
            }
          }, c.prototype.trackTimedMetadata = function (a) {
            this._logger.info(this._logTag, "#trackComplete()"), this._canProcess() && this._startSessionIfNeeded("trackTimedMetadata") && this._trigger(r, a);
          }, c.prototype.trackChapterStart = function () {
            this._logger.info(this._logTag, "#trackChapterStart()"), this._canProcess() && this._startSessionIfNeeded("#trackChapterStart") && this._trigger(A);
          }, c.prototype.trackChapterComplete = function () {
            this._logger.info(this._logTag, "trackChapterComplete()"), this._canProcess() && this._startSessionIfNeeded("trackChapterComplete") && this._trigger(B);
          }, c.prototype.trackAdStart = function () {
            this._logger.info(this._logTag, "#trackAdStart()"), this._canProcess() && this._startSessionIfNeeded("trackAdStart") && (this._trigger(u), this._isTrackingAd = !0);
          }, c.prototype.trackAdComplete = function () {
            this._logger.info(this._logTag, "#trackAdComplete()"), this._canProcess() && this._startSessionIfNeeded("trackAdComplete") && (this._trigger(v), this._isTrackingAd = !1);
          }, c.prototype.trackBitrateChange = function () {
            this._logger.info(this._logTag, "#trackBitrateChange()"), this._canProcess() && this._startSessionIfNeeded("trackBitrateChange") && this._trigger(C);
          }, c.prototype.trackVideoPlayerError = function (a) {
            if (this._logger.info(this._logTag, "#trackVideoPlayerError(errorId=" + a + ")"), this._startSessionIfNeeded("trackVideoPlayerError")) {
              var b = {};b[I] = l, b[J] = a, this._trigger(D, b);
            }
          }, c.prototype.trackApplicationError = function (a) {
            if (this._logger.info(this._logTag, "#trackApplicationError(errorId=" + a + ")"), this._startSessionIfNeeded("trackApplicationError")) {
              var b = {};b[I] = k, b[J] = a, this._trigger(D, b);
            }
          }, c.prototype._registerCommands = function () {
            this._pluginManager.comply(this, "handleVideoIdleStart", this._cmdVideoIdleStart), this._pluginManager.comply(this, "handleVideoIdleResume", this._cmdVideoIdleResume);
          }, c.prototype._registerBehaviours = function () {
            this._pluginManager.registerBehaviour(new e(j, E), this, "handleVideoIdleStart"), this._pluginManager.registerBehaviour(new e(j, F), this, "handleVideoIdleResume", [new d(i, "ad.isInAd", "isInAd"), new d(i, "chapter.isInChapter", "isInChapter")]);
          }, c.prototype._setupDataResolver = function () {
            function a() {
              return g.video ? g.video : (g.video = h._delegate.getVideoInfo(), h._logger.info(h._logTag, "Data from delegate > VideoInfo: " + g.video), g.video);
            }function b() {
              return g.ad ? g.ad : (g.ad = h._delegate.getAdInfo(), h._logger.info(h._logTag, "Data from delegate > AdInfo: " + g.ad), g.ad);
            }function c() {
              return g.pod ? g.pod : (g.pod = h._delegate.getAdBreakInfo(), h._logger.info(h._logTag, "Data from delegate > AdBreakInfo: " + g.pod), g.pod);
            }function d() {
              return g.chapter ? g.chapter : (g.chapter = h._delegate.getChapterInfo(), h._logger.info(h._logTag, "Data from delegate > ChapterInfo: " + g.chapter), g.chapter);
            }function e() {
              return g.qos ? g.qos : (g.qos = h._delegate.getQoSInfo(), h._logger.info(h._logTag, "Data from delegate > QoSInfo: " + g.qos), g.qos);
            }var f = {},
                g = {},
                h = this;f["video.id"] = function () {
              var b = a(),
                  c = b ? b.id : null;return h._logger.debug(h._logTag, "Resolving video.id: " + c), c;
            }, f["video.name"] = function () {
              var b = a(),
                  c = b ? b.name : null;return h._logger.debug(h._logTag, "Resolving video.name: " + c), c;
            }, f["video.length"] = function () {
              var b = a(),
                  c = b ? b.length : NaN;return h._logger.debug(h._logTag, "Resolving video.length: " + c), c;
            }, f["video.playerName"] = function () {
              var b = a(),
                  c = b ? b.playerName : null;return h._logger.debug(h._logTag, "Resolving video.playerName: " + c), c;
            }, f["video.streamType"] = function () {
              var b = a(),
                  c = b ? b.streamType : null;return h._logger.debug(h._logTag, "Resolving video.streamType: " + c), c;
            }, f["video.playhead"] = function () {
              var b = a(),
                  c = b ? b.playhead : NaN;return h._logger.debug(h._logTag, "Resolving video.playhead: " + c), c;
            }, f["video.resumed"] = function () {
              var b = a(),
                  c = b ? b.resumed : !1;return h._logger.debug(h._logTag, "Resolving video.resumed: " + c), c;
            }, f["video.playheadStalled"] = function () {
              return this._playheadStalled;
            }, f["pod.name"] = function () {
              var a = c(),
                  b = a ? a.name : null;return h._logger.debug(h._logTag, "Resolving pod.name: " + b), b;
            }, f["pod.playerName"] = function () {
              var a = c(),
                  b = a ? a.playerName : null;return h._logger.debug(h._logTag, "Resolving pod.playerName: " + b), b;
            }, f["pod.position"] = function () {
              var a = c(),
                  b = a ? a.position : NaN;return h._logger.debug(h._logTag, "Resolving pod.position: " + b), b;
            }, f["pod.startTime"] = function () {
              var a = c(),
                  b = a ? a.startTime : NaN;return h._logger.debug(h._logTag, "Resolving pod.startTime: " + b), b;
            }, f["ad.isInAd"] = function () {
              var a = b(),
                  c = null != a;return h._logger.debug(h._logTag, "Resolving ad.isInAd: " + c), c;
            }, f["ad.isInAdBreak"] = function () {
              var a = c(),
                  b = null != a;return h._logger.debug(h._logTag, "Resolving ad.isInAdBreak: " + b), b;
            }, f["ad.id"] = function () {
              var a = b(),
                  c = a ? a.id : null;return h._logger.debug(h._logTag, "Resolving ad.id: " + c), c;
            }, f["ad.name"] = function () {
              var a = b(),
                  c = a ? a.name : null;return h._logger.debug(h._logTag, "Resolving ad.name: " + c), c;
            }, f["ad.length"] = function () {
              var a = b(),
                  c = a ? a.length : NaN;return h._logger.debug(h._logTag, "Resolving ad.length: " + c), c;
            }, f["ad.position"] = function () {
              var a = b(),
                  c = a ? a.position : NaN;return h._logger.debug(h._logTag, "Resolving ad.position: " + c), c;
            }, f["chapter.isInChapter"] = function () {
              var a = d(),
                  b = null != a;return h._logger.debug(h._logTag, "Resolving chapter.isInChapter: " + b), b;
            }, f["chapter.name"] = function () {
              var a = d(),
                  b = a ? a.name : null;return h._logger.debug(h._logTag, "Resolving chapter.name: " + b), b;
            }, f["chapter.length"] = function () {
              var a = d(),
                  b = a ? a.length : NaN;return h._logger.debug(h._logTag, "Resolving chapter.length: " + b), b;
            }, f["chapter.position"] = function () {
              var a = d(),
                  b = a ? a.position : NaN;return h._logger.debug(h._logTag, "Resolving chapter.position: " + b), b;
            }, f["chapter.startTime"] = function () {
              var a = d(),
                  b = a ? a.startTime : NaN;return h._logger.debug(h._logTag, "Resolving chapter.startTime: " + b), b;
            }, f["qos.bitrate"] = function () {
              var a = e(),
                  b = a ? a.bitrate : NaN;return h._logger.debug(h._logTag, "Resolving qos.bitrate: " + b), b;
            }, f["qos.fps"] = function () {
              var a = e(),
                  b = a ? a.fps : NaN;return h._logger.debug(h._logTag, "Resolving qos.fps: " + b), b;
            }, f["qos.droppedFrames"] = function () {
              var a = e(),
                  b = a ? a.droppedFrames : NaN;return h._logger.debug(h._logTag, "Resolving qos.droppedFrames: " + b), b;
            }, f["qos.startupTime"] = function () {
              var a = e(),
                  b = a ? 1e3 * a.startupTime : NaN;return h._logger.debug(h._logTag, "Resolving qos.startupTime: " + b), b;
            }, this._dataResolver = function (a) {
              if (!a || 0 == a.length) return null;g = {};for (var b = null, c = 0; c < a.length; c++) {
                var d = a[c];b = b || {}, b[d] = f.hasOwnProperty(d) ? f[d].call(this) : null;
              }return b;
            };
          }, c.prototype._trackPlayheadStall = function () {
            this._canProcess() && (this._playheadStalled || (this._logger.info(this._logTag, "#_trackPlayheadStall()"), this._stalledPlayheadCount = 0, this._playheadStalled = !0, this._trigger(t)));
          }, c.prototype._trackExitStall = function () {
            this._canProcess() && (this._stalledPlayheadCount = 0, this._playheadStalled && (this._logger.info(this._logTag, "#_trackExitStall()"), this._playheadStalled = !1, this.trackPlay()));
          }, c.prototype._startPlayheadTimer = function () {
            var a = this;this._playheadTimer || (this._playheadTimer = setInterval(function () {
              if (a._canProcess()) {
                var b = a._dataResolver(["ad.isInAd", "video.playhead"]);if (a._isTrackingAd) a._playheadStalled && a._trackExitStall(), b.hasOwnProperty("ad.isInAd") && !b["ad.isInAd"] && (a._isTrackingAd = !1);else {
                  var c = b["video.playhead"];c != a._previousPlayhead ? a._trackExitStall() : a._previousPlayhead >= 0 && c == a._previousPlayhead && (a._stalledPlayheadCount++, a._stalledPlayheadCount == L && a._trackPlayheadStall()), a._previousPlayhead = c;
                }
              }
            }, K));
          }, c.prototype._stopPlayheadTimer = function () {
            this._playheadTimer && (clearInterval(this._playheadTimer), this._playheadTimer = null), this._trackExitStall();
          }, c.prototype._startSessionIfNeeded = function (a) {
            return this._isTrackingSessionActive ? (this._isTrackingSessionStarted || (this._logger.info(this._logTag, "#" + a + "() > Tracking session auto-start."), this.trackSessionStart()), !0) : (this._logger.warn(this._logTag, "#" + a + "() > No active tracking session."), !1);
          };var h = "player",
              i = h,
              j = "adobe-heartbeat",
              k = "sourceErrorExternal",
              l = "sourceErrorSDK",
              m = "video_load",
              n = "video_unload",
              o = "video_start",
              p = "video_resume",
              q = "video_complete",
              r = "timed_metadata",
              s = "play",
              t = "pause",
              u = "ad_start",
              v = "ad_complete",
              w = "buffer_start",
              x = "buffer_complete",
              y = "seek_start",
              z = "seek_complete",
              A = "chapter_start",
              B = "chapter_complete",
              C = "bitrate_change",
              D = "track_error",
              E = "video_idle_start",
              F = "video_idle_resume",
              G = "callback",
              H = "filter_report",
              I = "source",
              J = "error_id",
              K = 1001,
              L = 2;b.VideoPlayerPlugin = c;
        }(a.ADB.core, b), a.ADB.va.plugins.videoplayer || (a.ADB.va.plugins.videoplayer = b);
      }(this);

      // AdobeHeartbeatPlugin
      !function (a) {
        if ("undefined" == typeof b) var b = {};b.clock || (b.clock = {}), b.context || (b.context = {}), b.filter || (b.filter = {}), b.model || (b.model = {}), b.network || (b.network = {}), function (a, b) {
          "use strict";
          function c(a, b, c, d, e) {
            if (!b) throw new Error("Reference to the channel object cannot be NULL");if (this._channel = b, !a) throw new Error("Reference to the pluginManager object cannot be NULL");if (this._pluginManager = a, !e) throw new Error("Reference to the logger object cannot be NULL");this._logTag = "ah::Timer." + c, this._logger = e, this._isDestroyed = !1, this._createTimer(c, d), this._installHandlers();
          }var d = a.Event;c.KEY_NAME = "name", c.KEY_INTERVAL = "interval", c.KEY_RESET = "reset", c.prototype.resume = function (a) {
            this._logger.debug(this._logTag, "Starting timer: " + this._name);var b = {};b[c.KEY_NAME] = e + "." + this._name, b[c.KEY_RESET] = a, this._pluginManager.command(f, i, b);
          }, c.prototype.pause = function (a) {
            this._logger.debug(this._logTag, "Stopping timer: " + this._name);var b = {};b[c.KEY_NAME] = e + "." + this._name, b[c.KEY_RESET] = a, this._pluginManager.command(f, h, b);
          }, c.prototype.destroy = function () {
            if (!this._isDestroyed) {
              this._isDestroyed = !0, this._uninstallHandlers();var a = {};a[c.KEY_NAME] = e + "." + this._name, this._pluginManager.command(f, j, a);
            }
          }, c.prototype.setInterval = function (a) {
            var b = k + "." + e + "." + this._name,
                c = this._pluginManager.request(f, [b])[b];this.pause(!0), this._createTimer(this._name, a), c || this.resume(!0);
          }, c.prototype._cmdResume = function (a) {
            var b = !1;null != a && a.hasOwnProperty(c.KEY_RESET) && (b = a[c.KEY_RESET]), this.resume(b);
          }, c.prototype._cmdPause = function (a) {
            var b = !1;null != a && a.hasOwnProperty(c.KEY_RESET) && (b = a[c.KEY_RESET]), this.pause(b);
          }, c.prototype._onTick = function (a, b) {
            this._channel.trigger(new d("clock:" + this._name + ".tick", b));
          }, c.prototype._installHandlers = function () {
            this._channel.comply("clock:" + this._name + ".resume", this._cmdResume, this), this._channel.comply("clock:" + this._name + ".pause", this._cmdPause, this), this._pluginManager.on(f, e + "." + this._name + ".tick", this._onTick, this);
          }, c.prototype._uninstallHandlers = function () {
            this._channel.off(null, null, this), this._pluginManager.off(null, null, null, this);
          }, c.prototype._createTimer = function (a, b) {
            this._name = a, this._interval = b;var d = {};d[c.KEY_NAME] = e + "." + this._name, d[c.KEY_INTERVAL] = this._interval, this._pluginManager.command(f, g, d);
          };var e = "heartbeat",
              f = "service.clock",
              g = "create",
              h = "pause",
              i = "resume",
              j = "destroy",
              k = "is_paused";b.clock.Timer = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c(a, b, d) {
            c.__super__.constructor.call(this, a, b, f, h, d);
          }var d = a.Event,
              e = b.clock.Timer;a.extend(c, e), c.prototype._onCheckStatusComplete = function (a) {
            var b = a.data[l];if (this._logger.debug(this._logTag, "#_onCheckStatusComplete(interval=" + b + ")"), b) {
              if (b == this._interval) return void this._logger.debug(this._logTag, "#_onCheckStatusComplete() > Interval value not changed.");b > g ? (this._logger.warn(this._logTag, "#_onCheckStatusComplete() > Interval value too large: " + b), this.setInterval(g)) : (this._logger.debug(this._logTag, "#_onCheckStatusComplete() > Interval changed to: " + b), this.setInterval(b));
            } else this._logger.warn(this._logTag, "#_onCheckStatusComplete() > Invalid interval value."), this.setInterval(h);
          }, c.prototype._getSettings = function (a) {
            this._logger.debug(this._logTag, "#_getSettings()"), this._channel.trigger(new d(i));
          }, c.prototype._installHandlers = function () {
            c.__super__._installHandlers.call(this), this._channel.on(j, this._getSettings, this), this._channel.on(k, this._onCheckStatusComplete, this), this._channel.reply(l, function () {
              return this._interval;
            }, this);
          };var f = "check_status",
              g = 600,
              h = 60,
              i = "clock:check_status.tick",
              j = "clock:check_status.get_settings",
              k = "net:check_status_complete",
              l = "check_status_interval";b.clock.CheckStatusTimer = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c(a, b, d) {
            c.__super__.constructor.call(this, a, b, e, f, d);
          }var d = b.clock.Timer;a.extend(c, d), c.prototype._onCheckStatusComplete = function (a) {
            var b = a.data[g];if (this._logger.debug(this._logTag, "#_onCheckStatusComplete(interval=" + b + ")"), b) {
              if (b == this._interval) return void this._logger.debug(this._logTag, "#_onCheckStatusComplete() > Interval value not changed.");this._logger.debug(this._logTag, "#_onCheckStatusComplete() > Interval changed to: " + b), this.setInterval(b);
            } else this._logger.warn(this._logTag, "#_onCheckStatusComplete() > Invalid interval value."), this.setInterval(f);
          }, c.prototype._installHandlers = function () {
            c.__super__._installHandlers.call(this), this._channel.on(h, this._onCheckStatusComplete, this), this._channel.reply(g, function () {
              return this._interval;
            }, this);
          };var e = "reporting",
              f = 10,
              g = "reporting_interval",
              h = "net:check_status_complete";b.clock.ReportingTimer = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c(a, b, d) {
            c.__super__.constructor.call(this, a, b, e, f, d);
          }var d = b.clock.Timer;a.extend(c, d);var e = "idle",
              f = 1800;b.clock.IdleTimer = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c(a, b, d) {
            c.__super__.constructor.call(this, a, b, e, f, d);
          }var d = b.clock.Timer;a.extend(c, d);var e = "flush_filter",
              f = .25;b.clock.FlushFilterTimer = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c(a, b, c) {
            if (!a) throw new Error("Reference to the pluginManager object cannot be NULL");if (!b) throw new Error("Reference to the channel object cannot be NULL");if (!c) throw new Error("Reference to the logger object cannot be NULL");this._isDestroyed = !1, this._reportingTimer = new f(a, b, c), this._checkStatusTimer = new d(a, b, c), this._flushFilterTimer = new e(a, b, c), this._idleTimer = new g(a, b, c);
          }var d = b.clock.CheckStatusTimer,
              e = b.clock.FlushFilterTimer,
              f = b.clock.ReportingTimer,
              g = b.clock.IdleTimer;c.prototype.destroy = function () {
            this._isDestroyed || (this._isDestroyed = !0, this._reportingTimer.destroy(), this._checkStatusTimer.destroy(), this._flushFilterTimer.destroy(), this._idleTimer.destroy());
          }, b.clock.Clock = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c(a, b) {
            this.value = a, this.hint = b;
          }function d(a) {
            this.realm = a, this.data = {};
          }c.HINT_SHORT = "short", d.prototype.setField = function (a, b, d) {
            this.data[a] = new c(b, d);
          }, d.prototype._createAccessor = function (a, b, c) {
            var d = this;return function () {
              return arguments.length && (d[a] = arguments[0], d.setField(b, arguments[0], c)), d[a];
            };
          }, b.model.Dao = d, b.model.DaoField = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c() {
            if (c.__super__.constructor.call(this, "asset"), this.adId = this._createAccessor("_adId", "ad_id", null), this.sid = this._createAccessor("_sid", "ad_sid", null), this.resolver = this._createAccessor("_resolver", "resolver", null), this.podId = this._createAccessor("_podId", "pod_id", null), this.podPosition = this._createAccessor("_podPosition", "pod_position", null), this.podOffset = this._createAccessor("_podOffset", "pod_offset", null), this.podName = this._createAccessor("_podName", "pod_name", null), this.adLength = this._createAccessor("_adLength", "ad_length", null), this.adName = this._createAccessor("_adName", "ad_name", null), arguments.length && arguments[0] instanceof c) {
              var a = arguments[0];this.adId(a.adId()), this.sid(a.sid()), this.resolver(a.resolver()), this.podId(a.podId()), this.podPosition(a.podPosition()), this.podOffset(a.podOffset()), this.podName(a.podName()), this.adLength(a.adLength()), this.adName(a.adName());
            } else this.adId(""), this.sid(""), this.resolver(""), this.podId(""), this.podPosition(""), this.podOffset(0), this.podName(""), this.adLength(0), this.adName("");
          }var d = b.model.Dao;a.extend(c, d), b.model.AdDao = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c() {
            if (c.__super__.constructor.call(this, "sc"), this.reportSuiteId = this._createAccessor("_reportSuiteId", "rsid", null), this.trackingServer = this._createAccessor("_trackingServer", "tracking_server", null), this.ssl = this._createAccessor("_ssl", "ssl", e.HINT_SHORT), arguments.length && arguments[0] instanceof c) {
              var a = arguments[0];this.reportSuiteId(a.reportSuiteId()), this.trackingServer(a.trackingServer()), this.ssl(a.ssl());
            } else this.reportSuiteId(""), this.trackingServer(""), this.ssl(0);
          }var d = b.model.Dao,
              e = b.model.DaoField;a.extend(c, d), b.model.AdobeAnalyticsDao = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c() {
            if (c.__super__.constructor.call(this, "stream"), this.id = this._createAccessor("_id", "chapter_id", null), this.sid = this._createAccessor("_sid", "chapter_sid", null), this.name = this._createAccessor("_name", "chapter_name", null), this.position = this._createAccessor("_position", "chapter_pos", null), this.length = this._createAccessor("_length", "chapter_length", null), this.offset = this._createAccessor("_offset", "chapter_offset", null), arguments.length && arguments[0] instanceof c) {
              var a = arguments[0];this.id(a.id()), this.sid(a.sid()), this.name(a.name()), this.position(a.position()), this.length(a.length()), this.offset(a.offset());
            } else this.id(""), this.sid(""), this.name(""), this.position(0), this.length(0), this.offset(0);
          }var d = b.model.Dao;a.extend(c, d), b.model.ChapterDao = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c() {
            if (c.__super__.constructor.call(this, "asset"), this.type = this._createAccessor("_type", "type", null), this.videoId = this._createAccessor("_videoId", "video_id", null), this.publisher = this._createAccessor("_publisher", "publisher", null), this.adData = this._createAccessor("_adData", "ad_data", null), this.chapterData = this._createAccessor("_chapterData", "chapter_data", null), this.length = this._createAccessor("_length", "length", null), this.name = this._createAccessor("_name", "name", null), arguments.length && arguments[0] instanceof c) {
              var a = arguments[0];this.type(a.type()), this.name(a.name()), this.videoId(a.videoId()), this.publisher(a.publisher()), this.length(a.length());var b = a.adData() ? new e(a.adData()) : null;this.adData(b);var d = a.chapterData() ? new f(a.chapterData()) : null;this.chapterData(d);
            } else this.type(""), this.name(""), this.videoId(""), this.publisher(""), this.length(0), this.adData(null), this.chapterData(null);
          }var d = b.model.Dao,
              e = b.model.AdDao,
              f = b.model.ChapterDao;a.extend(c, d), c.TYPE_AD = "ad", c.TYPE_MAIN_CONTENT = "main", b.model.AssetDao = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c() {
            if (c.__super__.constructor.call(this, "event"), this.type = this._createAccessor("_type", "type", null), this.duration = this._createAccessor("_duration", "duration", null), this.playhead = this._createAccessor("_playhead", "playhead", null), this.id = this._createAccessor("_id", "id", null), this.source = this._createAccessor("_source", "source", null), this.ts = this._createAccessor("_ts", "ts", null), this.prevTs = this._createAccessor("_prevTs", "prev_ts", null), arguments.length && arguments[0] instanceof c) {
              var a = arguments[0];this.type(a.type()), this.duration(a.duration()), this.playhead(a.playhead()), this.id(a.id()), this.source(a.source()), this.ts(a.ts()), this.prevTs(a.prevTs());
            } else this.type(""), this.duration(0), this.playhead(0), this.id(""), this.source(""), this.ts(0), this.prevTs(-1);
          }var d = b.model.Dao;a.extend(c, d), c.EVENT_TYPE_AA_START = "aa_start", c.EVENT_TYPE_AA_AD_START = "aa_ad_start", c.EVENT_TYPE_START = "start", c.EVENT_TYPE_RESUME = "resume", c.EVENT_TYPE_CHAPTER_START = "chapter_start", c.EVENT_TYPE_CHAPTER_COMPLETE = "chapter_complete", c.EVENT_TYPE_PLAY = "play", c.EVENT_TYPE_PAUSE = "pause", c.EVENT_TYPE_STALL = "stall", c.EVENT_TYPE_BUFFER = "buffer", c.EVENT_TYPE_BITRATE_CHANGE = "bitrate_change", c.EVENT_TYPE_ERROR = "error", c.EVENT_TYPE_COMPLETE = "complete", b.model.EventDao = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c() {
            if (c.__super__.constructor.call(this, "stream"), this.bitrate = this._createAccessor("_bitrate", "bitrate", null), this.fps = this._createAccessor("_fps", "fps", null), this.droppedFrames = this._createAccessor("_droppedFrames", "dropped_frames", null), this.startupTime = this._createAccessor("_startup_time", "startup_time", null), arguments.length && arguments[0] instanceof c) {
              var a = arguments[0];this.bitrate(a.bitrate()), this.fps(a.fps()), this.droppedFrames(a.droppedFrames()), this.startupTime(a.startupTime()), this.isStartupTimeOverridden = a.isStartupTimeOverridden;
            } else this.bitrate(0), this.fps(0), this.droppedFrames(0), this.startupTime(0), this.isStartupTimeOverridden = !1;
          }var d = b.model.Dao;a.extend(c, d), b.model.QoSDao = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c() {
            if (c.__super__.constructor.call(this, "sp"), this.ovp = this._createAccessor("_ovp", "ovp", null), this.sdk = this._createAccessor("_sdk", "sdk", null), this.channel = this._createAccessor("_channel", "channel", null), this.playerName = this._createAccessor("_playerName", "player_name", null), this.libVersion = this._createAccessor("_libVersion", "hb_version", null), this.apiLevel = this._createAccessor("_apiLevel", "hb_api_lvl", null), arguments.length && arguments[0] instanceof c) {
              var a = arguments[0];this.ovp(a.ovp()), this.sdk(a.sdk()), this.channel(a.channel()), this.playerName(a.playerName()), this.libVersion(a.libVersion()), this.apiLevel(a.apiLevel());
            } else this.ovp(e), this.sdk(e), this.channel(e), this.playerName(""), this.libVersion(""), this.apiLevel(0);
          }var d = b.model.Dao;a.extend(c, d);var e = "unknown";b.model.ServiceProviderDao = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c() {
            if (c.__super__.constructor.call(this, "event"), this.sessionId = this._createAccessor("_sessionId", "sid", null), arguments.length && arguments[0] instanceof c) {
              var a = arguments[0];this.sessionId(a.sessionId());
            } else this.sessionId(null);
          }var d = b.model.Dao;a.extend(c, d), b.model.SessionDao = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c() {
            if (c.__super__.constructor.call(this, "stream"), this.type = this._createAccessor("_type", "type", null), arguments.length && arguments[0] instanceof c) {
              var a = arguments[0];this.type(a.type());
            } else this.type(null);
          }var d = b.model.Dao;a.extend(c, d), b.model.StreamDao = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c() {
            if (c.__super__.constructor.call(this, "user"), this.analyticsVisitorId = this._createAccessor("_analyticsVisitorId", "aid", null), this.marketingCloudVisitorId = this._createAccessor("_marketingCloudVisitorId", "mid", null), this.visitorId = this._createAccessor("_visitorId", "id", null), arguments.length && arguments[0] instanceof c) {
              var a = arguments[0];this.analyticsVisitorId(a.analyticsVisitorId()), this.marketingCloudVisitorId(a.marketingCloudVisitorId()), this.visitorId(a.visitorId());
            } else this.analyticsVisitorId(null), this.marketingCloudVisitorId(null), this.visitorId(null);
          }var d = b.model.Dao;a.extend(c, d), b.model.UserDao = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c() {
            if (c.__super__.constructor.call(this, "aam"), this.audienceManagerBlob = this._createAccessor("_audienceManagerBlob", "blob", null), this.audienceManagerLocationHint = this._createAccessor("_audienceManagerLocationHint", "loc_hint", null), arguments.length && arguments[0] instanceof c) {
              var a = arguments[0];this.audienceManagerBlob(a.audienceManagerBlob()), this.audienceManagerLocationHint(a.audienceManagerLocationHint());
            } else this.audienceManagerBlob(null), this.audienceManagerLocationHint(null);
          }var d = b.model.Dao;a.extend(c, d), b.model.AudienceManagerDao = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c(a, b, c, i, j) {
            this.eventData = new e(), this.eventData.type(b), this.eventData.duration(0), this.eventData.ts(new Date().getTime()), this.eventData.playhead(c), this.assetData = new f(a._assetData), this.streamData = new g(a._streamData), this.qosData = new h(a._qosData), this.cuserData = d.clone(a._cuserData), this.meta = i, this.callback = j, this.filterReport = !0;
          }var d = a.ObjectUtils,
              e = b.model.EventDao,
              f = b.model.AssetDao,
              g = b.model.StreamDao,
              h = b.model.QoSDao;b.model.TrackItem = c;
        }(a.ADB.va.utils, b), function (a, b) {
          "use strict";
          function c(a, b, c, i, j, k) {
            this.adobeAnalyticsData = a, this.userData = b, this.aamData = c, this.serviceProviderData = i, this.sessionData = j, this.eventData = new e(k.eventData), this.assetData = new f(k.assetData), this.streamData = new g(k.streamData), this.qosData = new h(k.qosData), this.cuserData = d.clone(k.cuserData), this.meta = d.clone(k.meta), this.callback = k.callback, this.filterReport = k.filterReport;
          }var d = a.ObjectUtils,
              e = b.model.EventDao,
              f = b.model.AssetDao,
              g = b.model.StreamDao,
              h = b.model.QoSDao;b.model.CUserDao;b.model.Report = c;
        }(a.ADB.va.utils, b), function (a) {
          "use strict";
          function b() {}b.prototype.serializeReport = function (a) {}, b.prototype.serializeDao = function (a) {}, b.prototype.serializeMap = function (a) {}, b.prototype.serializeNumber = function (a, b, c, d) {}, b.prototype.serializeString = function (a, b, c, d) {}, a.model.ISerializer = b;
        }(b), function (a, b) {
          "use strict";
          function c(a) {
            if (!a) throw new Error("Reference to the logger object cannot be NULL");this._logger = a;
          }var d = b.model.Dao,
              e = b.model.DaoField,
              f = b.model.ISerializer;a.extend(c, f), c.prototype.serializeReport = function (a) {
            var b = [];return b.push(this.serializeDao(a.adobeAnalyticsData)), b.push(this.serializeDao(a.userData)), b.push(this.serializeDao(a.aamData)), b.push(this.serializeMap(a.cuserData, "cuser")), b.push(this.serializeDao(a.serviceProviderData)), b.push(this.serializeDao(a.sessionData)), b.push(this.serializeDao(a.eventData)), b.push(this.serializeDao(a.assetData)), b.push(this.serializeDao(a.streamData)), b.push(this.serializeDao(a.qosData)), b.push(this.serializeMap(a.meta, "meta")), { serializedOutput: b.filter(function (a) {
                return !!a;
              }).join("&"), callback: a.callback };
          }, c.prototype.serializeDao = function (a) {
            var b = this._processDao(a);return b.filter(function (a) {
              return !!a;
            }).join("&");
          }, c.prototype.serializeMap = function (a, b) {
            var c = [],
                d = b ? b : "meta";for (var e in a) {
              a.hasOwnProperty(e) && a[e] && c.push("s:" + d + ":" + e + "=" + window.encodeURIComponent(a[e]));
            }return c.join("&");
          }, c.prototype.serializeNumber = function (a, b, c, d) {
            var f = h;return null == b || isNaN(b) ? null : (d === e.HINT_SHORT && (f = i), f + ":" + c + ":" + a + "=" + Math.floor(b));
          }, c.prototype.serializeString = function (a, b, c, d) {
            return b ? j + ":" + c + ":" + a + "=" + window.encodeURIComponent(b) : null;
          }, c.prototype._processDao = function (a) {
            var b = [];for (var c in a.data) {
              if (a.data.hasOwnProperty(c)) {
                var e = a.data[c],
                    f = e.value,
                    h = e.hint,
                    i = null,
                    j = a.realm;if (null == f) continue;"number" == typeof f ? i = this.serializeNumber(c, f, j, h) : "string" == typeof f ? i = this.serializeString(c, f, j, h) : f instanceof d ? i = this.serializeDao(f) : this._logger.warn(g, "#_processDao() > Unable to serialize DAO. Field: " + c + ". Value: " + f + "."), i && b.push(i);
              }
            }return b;
          };var g = "ah::QuerystringSerializer",
              h = "l",
              i = "h",
              j = "s";b.model.QuerystringSerializer = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c(a, b) {
            if (!a) throw new Error("Reference to the data object cannot be NULL");if (this._data = a, !b) throw new Error("Reference to the logger object cannot be NULL");this._logger = b;
          }c.prototype.parse = function () {
            var a, b, c, i, j;if (window.DOMParser) {
              var k = new window.DOMParser();j = k.parseFromString(this._data, "text/xml");
            } else j = new window.ActiveXObject("Microsoft.XMLDOM"), j.async = !1, j.loadXML(this.data);var l;l = parseInt(j.getElementsByTagName("trackingInterval")[0].childNodes[0].nodeValue, 10), l && (a = l), l = parseInt(j.getElementsByTagName("setupCheckInterval")[0].childNodes[0].nodeValue, 10), l && (b = l), l = parseInt(j.getElementsByTagName("trackExternalErrors")[0].childNodes[0].nodeValue, 10), l && (c = 1 == l), j.getElementsByTagName("nielsenEnabled")[0] ? (l = parseInt(j.getElementsByTagName("nielsenEnabled")[0].childNodes[0].nodeValue, 10), i = 1 == l) : i = !0;var m = {};return m[e] = a, m[f] = b, m[g] = c, m[h] = i, this._logger.debug(d, "#parse() > Obtained configuration settings."), m;
          };var d = "ah::SettingsParser",
              e = "reporting_interval",
              f = "check_status_interval",
              g = "track_external_errors",
              h = "nielsen_enabled";b.network.SettingsParser = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c(a, b) {
            if (this._trackingServer = null, this._checkStatusServer = null, this._publisher = null, this._isConfigured = !1, this._isDestroyed = !1, this._quietMode = !1, this._visitorOptedOut = !1, this._prevReportSent = null, !a) throw new Error("Reference to the channel object cannot be NULL");if (this._channel = a, !b) throw new Error("Reference to the logger object cannot be NULL");this._logger = b, this._serializer = new i(b), this._installEventListeners();
          }var d = a.Event,
              e = a.URLRequestMethod,
              f = a.URLRequest,
              g = a.URLLoader,
              h = b.network.SettingsParser,
              i = b.model.QuerystringSerializer;c.prototype.destroy = function () {
            this._isDestroyed || (this._isDestroyed = !0, this._logger.debug(j, "#destroy()"), this._uninstallEventListeners());
          }, c.prototype._onApiConfig = function (a) {
            var b = a.data;this._logger.debug(j, "#_onApiConfig(sb_server=" + b[k] + ", check_status_server=" + b[l] + ", publisher=" + b[m] + ", quiet_mode=" + b[n] + ", ssl=" + b[o] + ")"), this._trackingServer = this._updateRequestProtocol(b[k], b[o]), this._checkStatusServer = this._updateRequestProtocol(b[l], b[o]), this._publisher = b[m], this._quietMode = b[n], this._isConfigured = !0;
          }, c.prototype._onUpdateVisitorOptOut = function (a) {
            var b = a.data;this._logger.debug(j, "#_onUpdateVisitorOptOut(visitor_opt_out=" + b[q] + ")"), this._visitorOptedOut = b[q];
          }, c.prototype._onFilterReportAvailable = function (a) {
            var b = a.data;if (!this._isConfigured) return void this._logger.warn(j, "#_onFilterReportAvailable() > Unable to send request: not configured.");var c = b[p],
                h = this._serializer.serializeReport(c),
                i = this._trackingServer + "/?" + h.serializedOutput;if (this._prevReportSent && this._prevReportSent.eventData && c.eventData && this._prevReportSent.eventData.playhead == c.eventData.playhead && this._prevReportSent.eventData.ts == c.eventData.ts && this._prevReportSent.eventData.prevTs == c.eventData.prevTs && this._prevReportSent.eventData.type == c.eventData.type) return void this._logger.debug(j, "#_onFilterReportAvailable() > Duplicate heartbeat report not sent for URL:\n" + i);this._prevReportSent = c;var k = new f(i, e.GET);this._logger.debug(j, "#_onFilterReportAvailable() > " + k.url);var l = this,
                m = function m(a) {
              o.close(), h.callback && h.callback.call(null);
            },
                n = function n(a) {
              o.close(), l._logger.warn(j, "#_onFilterReportAvailable() > Failed to send heartbeat report."), h.callback && h.callback.call(null);
            };if (!this._quietMode && !this._visitorOptedOut) {
              var o = new g();o.addEventListener(d.SUCCESS, m, this), o.addEventListener(d.ERROR, n, this), o.load(k);
            }
          }, c.prototype._onClockCheckStatusTick = function (a) {
            function b(a) {
              if (a.data) {
                var b = new h(a.data.response, i._logger),
                    c = b.parse();c ? i._channel.trigger(new d(v, c)) : i._logger.warn(j, "#_onClockCheckStatusTick() > Failed to parse the config. settings.");
              }n.close();
            }function c(a) {
              i._logger.warn(j, "#_onClockCheckStatusTick() > Failed to obtain the config. settings."), n.close();
            }if (!this._isConfigured) return void this._logger.warn(j, "#_onClockCheckStatusTick() > Unable to send request: not configured.");if (!this._publisher) return void this._logger.warn(j, "#_onClockCheckStatusTick() > Publisher is NULL.");var i = this,
                k = this._publisher.replace(/[^a-zA-Z0-9]+/, "-").toLocaleLowerCase(),
                l = this._checkStatusServer + k + ".xml?r=" + new Date().getTime(),
                m = new f(l, e.GET),
                n = new g();n.addEventListener(d.SUCCESS, b, this), n.addEventListener(d.ERROR, c, this), this._logger.debug(j, "#_onClockCheckStatusTick() > Get new settings from: " + l), n.load(m);
          }, c.prototype._updateRequestProtocol = function (a, b) {
            var c = a;return 0 === c.indexOf("http://") ? c = c.slice(7) : 0 === c.indexOf("https://") && (c = c.slice(8)), b ? "https://" + c : "http://" + c;
          }, c.prototype._installEventListeners = function () {
            this._channel.on(r, this._onApiConfig, this), this._channel.on(s, this._onUpdateVisitorOptOut, this), this._channel.on(t, this._onFilterReportAvailable, this), this._channel.on(u, this._onClockCheckStatusTick, this);
          }, c.prototype._uninstallEventListeners = function () {
            this._channel.off(null, null, this);
          };var j = "ah::Network",
              k = "tracking_server",
              l = "check_status_server",
              m = "publisher",
              n = "quiet_mode",
              o = "ssl",
              p = "report",
              q = "visitor_opt_out",
              r = "api:config",
              s = "api:update_visitor_optout",
              t = "filter:data_available",
              u = "clock:check_status.tick",
              v = "net:check_status_complete";b.network.Network = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c(a, b) {
            if (!a) throw new Error("Reference to the channel object cannot be NULL");if (this._channel = a, !b) throw new Error("Reference to the logger object cannot be NULL");this._logger = b, this._isDestroyed = !1, this._isBufferingInProgress = !1, this._reportBuffer = {}, this._tsHistory = {}, this._workQueue = new i(), this._installEventListeners();
          }function d(a) {
            var b = [];return a && a.forEach(function (a) {
              a.eventData.type() == k.EVENT_TYPE_PAUSE || a.eventData.type() == k.EVENT_TYPE_STALL ? (!a.filterReport || a.eventData.duration() > u) && b.push(a) : b.push(a);
            }), b;
          }function e(a) {
            var b = -1,
                c = -1,
                d = [];return a.forEach(function (a) {
              a.eventData.type() == k.EVENT_TYPE_START ? a.assetData.type() == l.TYPE_MAIN_CONTENT ? -1 == b ? b = d.push(a) - 1 : (a.eventData.prevTs(-1), d[b] = a) : -1 == c ? c = d.push(a) - 1 : (a.eventData.prevTs(-1), d[c] = a) : d.push(a);
            }), d;
          }function f(a) {
            var b = [];return a.forEach(function (c) {
              if (c.eventData.type() == k.EVENT_TYPE_PLAY) {
                if (c.eventData.duration() > t) b.push(c);else if (0 == c.eventData.duration() && c.assetData.type() == l.TYPE_MAIN_CONTENT) {
                  var d = g(a);d.indexOf(c) == d.length - 1 && b.push(c);
                }
              } else b.push(c);
            }), b;
          }function g(a) {
            var b = [];return a.forEach(function (a) {
              (a.eventData.type() == k.EVENT_TYPE_PLAY || a.eventData.type() == k.EVENT_TYPE_BUFFER || a.eventData.type() == k.EVENT_TYPE_START) && b.push(a);
            }), b;
          }var h = a.radio.Command,
              i = a.radio.CommandQueue,
              j = a.Event,
              k = b.model.EventDao,
              l = b.model.AssetDao;c.prototype.destroy = function () {
            this._isDestroyed || (this._isDestroyed = !0, this._logger.debug(w, "#destroy()"), this._uninstallEventListeners(), this.clear());
          }, c.prototype.clear = function () {
            this._logger.debug(w, "#clear()"), this._workQueue.cancelAllCommands(), this._reportBuffer = {}, this._tsHistory = {}, this._isBufferingInProgress = !1;
          }, c.prototype.flush = function () {
            this._workQueue.addCommand(new h(this._flushBufferReport, this));
          }, c.prototype._bufferReport = function (a) {
            if (!this._isDestroyed) {
              var b = a[q];if (b) {
                var c = b.sessionData.sessionId();this._reportBuffer[c] = this._reportBuffer[c] || [], this._reportBuffer[c].push(b);
              }if (!this._isBufferingInProgress) {
                this._isBufferingInProgress = !0;var d = {};d[p] = !0, d[r] = 1, this._channel.command(s, d);
              }
            }
          }, c.prototype._flushBufferReport = function () {
            function a(a) {
              if (a) for (var c = 0; c < a.length; c++) {
                var d = a[c],
                    e = d.sessionData.sessionId();b._tsHistory[e] = b._tsHistory[e] || {};var f = d.eventData.type() + "." + (d.assetData.type() == l.TYPE_AD ? d.assetData.adData().adId() : d.assetData.videoId());b._tsHistory[e].hasOwnProperty(f) && d.eventData.prevTs(b._tsHistory[e][f]), b._tsHistory[e][f] = d.eventData.ts();
              }
            }if (!this._isDestroyed) {
              var b = this;for (var c in this._reportBuffer) {
                if (this._reportBuffer.hasOwnProperty(c)) {
                  var g = f(e(d(this._reportBuffer[c])));a(g);for (var h = 0; h < g.length; h++) {
                    var i = g[h],
                        k = {};k[q] = i, this._channel.trigger(new j(n, k));
                  }
                }
              }this._reportBuffer = {};var m = this._channel.request(v),
                  o = this._tsHistory[m] || {};this._tsHistory = {}, this._tsHistory[m] = o, this._isBufferingInProgress = !1;
            }
          }, c.prototype._onContextReportAvailable = function (a) {
            var b = a.data;this._workQueue.addCommand(new h(this._bufferReport, this, [b]));
          }, c.prototype._onClockFlushFilterTick = function (a) {
            this.flush();
          }, c.prototype._installEventListeners = function () {
            this._channel.on(m, this._onContextReportAvailable, this), this._channel.on(o, this._onClockFlushFilterTick, this);
          }, c.prototype._uninstallEventListeners = function () {
            this._channel.off(null, null, this);
          };var m = "context:report_available",
              n = "filter:data_available",
              o = "clock:flush_filter.tick",
              p = "reset",
              q = "report",
              r = "repeat_count",
              s = "clock:flush_filter.resume",
              t = 250,
              u = 250,
              v = "session_id",
              w = "ah::ReportFilter";b.filter.ReportFilter = c;
        }(a.ADB.core, b), function (a, b) {
          "use strict";
          function c(a, b) {
            this._onFail = { fn: a, ctx: b };
          }var d = a.ErrorInfo;c.prototype.validateFields = function (a, b) {
            if (!a) return this._fail("Data cannot be null");if (b) for (var c = 0; c < b.length; c++) {
              var d = b[c];switch (d) {case "videoId":
                  if (!a.hasOwnProperty("videoId")) return this._fail("The ID for the main video must be specified.");if ("string" != typeof a.videoId) return this._fail("The ID for the main video must be a String.");if ("" === a.videoId) return this._fail("The ID for the main video cannot be an empty string.");break;case "streamType":
                  if (!a.hasOwnProperty("streamType")) return this._fail("The stream type for the main video must be specified.");if ("string" != typeof a.streamType) return this._fail("The stream type for the main video must be a String.");if ("" === a.streamType) return this._fail("The stream type for the main video cannot be an empty string.");break;case "videoLength":
                  if (!a.hasOwnProperty("videoLength")) return this._fail("The length of the main video must be specified.");if ("number" != typeof a.videoLength) return this._fail("The length of the main video must be a Number.");if (isNaN(a.videoLength)) return this._fail("The length of the main video cannot be NaN.");break;case "playhead":
                  if (!a.hasOwnProperty("playhead")) return this._fail("The playhead for the main video must be specified.");if ("number" != typeof a.playhead) return this._fail("The playhead for the main video must be a Number.");if (isNaN(a.playhead)) return this._fail("The playhead for the main video cannot be NaN.");break;case "playerName":
                  if (!a.hasOwnProperty("playerName")) return this._fail("The player name for the main video must be specified.");if ("string" != typeof a.playerName) return this._fail("The player name for the main video must be a String.");if ("" === a.playerName) return this._fail("The player name for the main video cannot be an empty string.");break;case "rsid":
                  if (!a.hasOwnProperty("rsid")) return this._fail("account (rsid) is required and has to be set in the AppMeasurement instance.");if ("string" != typeof a.rsid) return this._fail("account (rsid) of the AppMeasurement instance must be a String.");if ("" === a.rsid) return this._fail("account (rsid) of the AppMeasurement instance  cannot be an empty string.");break;case "trackingServer":
                  if (!a.hasOwnProperty("trackingServer")) return this._fail("trackingServer is required and has to be set in the AppMeasurement instance.");if ("string" != typeof a.trackingServer) return this._fail("trackingServer of the AppMeasurement instance must be a String.");if ("" === a.trackingServer) return this._fail("trackingServer of the AppMeasurement instance cannot be an empty string.");break;case "podPlayerName":
                  if (!a.hasOwnProperty("podPlayerName")) return this._fail("The player name for the ad-break must be specified.");if ("string" != typeof a.podPlayerName) return this._fail("The player name for the ad-break must be a String.");if ("" === a.podPlayerName) return this._fail("The player name for the ad-break cannot be an empty string.");break;case "podPosition":
                  if (!a.hasOwnProperty("podPosition")) return this._fail("Position (index) of the ad-break must be specified.");if ("number" != typeof a.podPosition) return this._fail("Position (index) of the ad-break must be a Number.");if (isNaN(a.podPosition)) return this._fail("Position (index) of the ad-break cannot be NaN.");break;case "adId":
                  if (!a.hasOwnProperty("adId")) return this._fail("The ad ID must be specified.");if ("string" != typeof a.adId) return this._fail("The ad ID must be a String.");if ("" === a.adId) return this._fail("The ad ID cannot be an empty string.");break;case "adPosition":
                  if (!a.hasOwnProperty("adPosition")) return this._fail("Position (index) of the ad must be specified.");if ("number" != typeof a.adPosition) return this._fail("Position (index) of the ad must be a Number.");if (isNaN(a.adPosition)) return this._fail("Position (index) of the ad cannot be NaN.");break;case "chapterPosition":
                  if (!a.hasOwnProperty("chapterPosition")) return this._fail("Position (index) of the chapter must be specified.");if ("number" != typeof a.chapterPosition) return this._fail("Position (index) of the chapter must be a Number.");if (isNaN(a.chapterPosition)) return this._fail("Position (index) of the chapter cannot be NaN.");break;case "chapterOffset":
                  if (!a.hasOwnProperty("chapterOffset")) return this._fail("Chapter start-time (offset) must be specified.");if ("number" != typeof a.chapterOffset) return this._fail("Chapter start-time (offset) must be a Number.");if (isNaN(a.chapterOffset)) return this._fail("Chapter start-time (offset) cannot be NaN.");break;case "chapterLength":
                  if (!a.hasOwnProperty("chapterLength")) return this._fail("The length of the chapter must be specified.");if ("number" != typeof a.chapterLength) return this._fail("The length of the chapter must be a Number.");if (isNaN(a.chapterLength)) return this._fail("The length of the chapter cannot be NaN.");break;default:
                  return this._fail("Unable to validate unknown parameter: " + d);}
            }return !0;
          }, c.prototype._fail = function (a) {
            var b = new d("Invalid input data", a);return this._onFail.fn && this._onFail.fn.call(this._onFail.ctx, b), !1;
          }, b.context.InputDataValidator = c;
        }(a.ADB.va, b), function (a, b) {
          "use strict";
          function c(a, b) {
            if (!b) throw new Error("Reference to the logger object cannot be NULL");if (this._logger = b, !a) throw new Error("Reference to the context object cannot be NULL");this._context = a;
          }var d = b.model.Report;
          c.prototype.createReportForItem = function (a) {
            return this._logger.debug(e, "Creating report for item: " + a.eventData.type()), new d(this._context._adobeAnalyticsData, this._context._userData, this._context._aamData, this._context._serviceProviderData, this._context._sessionData, a);
          };var e = "ah::ReportFactory";b.context.ReportFactory = c;
        }(a.ADB.core, b), function (a, b, c, d) {
          "use strict";
          function e(a, b) {
            if (!a) throw new Error("Reference to the channel object cannot be NULL");if (this._channel = a, !b) throw new Error("Reference to the logger object cannot be NULL");this._logger = b, this._lastInBandItem = null, this._autoComputedStartupTime = 0, this._reportingInterval = fa, this._assetData = null, this._streamData = null, this._qosData = null, this._sessionData = null, this._cuserData = null, this._adobeAnalyticsData = new j(), this._serviceProviderData = new k(), this._userData = new l(), this._aamData = new m(), this._isTrackingSessionActive = !1, this._isVideoComplete = !1, this._activeAssetId = null, this._isDestroyed = !1, this._doNotOverrideEventDuration = !1, this._reportFactory = new u(this, this._logger), this._inputDataValidator = new v(function (a) {
              this._logger.error(w, a.getMessage() + " | " + a.getDetails()), this._channel.trigger(new h(y, a));
            }, this), this._stashedChapterData = null, this._stashedAdData = null, this._trackExternalErrors = !0, this._installEventListeners();
          }var f = c.md5,
              g = c.ObjectUtils,
              h = a.Event,
              i = d.model.SessionDao,
              j = d.model.AdobeAnalyticsDao,
              k = d.model.ServiceProviderDao,
              l = d.model.UserDao,
              m = d.model.AudienceManagerDao,
              n = d.model.EventDao,
              o = d.model.AssetDao,
              p = d.model.StreamDao,
              q = d.model.QoSDao,
              r = d.model.AdDao,
              s = d.model.ChapterDao,
              t = d.model.TrackItem,
              u = d.context.ReportFactory,
              v = d.context.InputDataValidator;e.prototype.destroy = function () {
            this._isDestroyed || (this._isDestroyed = !0, this._logger.debug(w, "#destroy()"), this._uninstallEventListeners());
          }, e.prototype._onApiAnalyticsStart = function (a) {
            this._logger.debug(w, "#_onApiAnalyticsStart()");var b = a.data;if (this._checkCall("_onApiAnalyticsStart") && this._inputDataValidator.validateFields(b, ["playhead"])) {
              this._userData.visitorId(b.vid), this._userData.analyticsVisitorId(b.aid), this._userData.marketingCloudVisitorId(b.mid), this._aamData.audienceManagerBlob(b.blob), this._aamData.audienceManagerLocationHint(b.loc_hint), b.customerIDs && (this._cuserData = b.customerIDs), this._updateQoSInfo(b);var c = new t(this, n.EVENT_TYPE_AA_START, b.playhead, null, b._eventData[E]);c.assetData.adData(null), c.assetData.type(o.TYPE_MAIN_CONTENT), this._cuserData = null, this._sendHit(c);
            }
          }, e.prototype._onApiAnalyticsAdStart = function (a) {
            this._logger.debug(w, "#_onApiAnalyticsAdStart()");var b = a.data;if (this._checkCall("_onApiAnalyticsAdStart") && this._inputDataValidator.validateFields(b, ["playhead"])) {
              this._updateQoSInfo(b);var c = new t(this, n.EVENT_TYPE_AA_AD_START, b.playhead, null, b._eventData[E]);this._sendHit(c);
            }
          }, e.prototype._onApiVideoLoad = function (a) {
            var b = a.data;this._logger.debug(w, "#_onApiVideoLoad(rsid=" + b.rsid + ", aa_trackingServer=" + b.trackingServer + ")"), this._resetInternalState(), this._inputDataValidator.validateFields(b, ["rsid", "trackingServer"]) && (this._sessionData.sessionId(this._generateSessionId()), this._isTrackingSessionActive = !0);
          }, e.prototype._onApiVideoUnload = function (a) {
            return this._logger.debug(w, "#_onApiVideoUnload()"), this._isTrackingSessionActive ? void (this._isTrackingSessionActive = !1) : void this._logger.debug(w, "#_onApiVideoUnload() > No active tracking session.");
          }, e.prototype._onApiVideoStart = function (a) {
            var b = a.data;if (this._logger.debug(w, "#_onApiVideoStart(id=" + b.videoId + ", name=" + b.videoName + ", length=" + b.videoLength + ", type=" + b.streamType + ", playerName=" + b.playerName + ")"), this._checkCall("_onApiVideoStart") && this._inputDataValidator.validateFields(b, ["videoId", "streamType", "videoLength", "playhead", "playerName"])) {
              this._adobeAnalyticsData.reportSuiteId(b.rsid), this._adobeAnalyticsData.trackingServer(b.trackingServer), this._adobeAnalyticsData.ssl(Number(b.useSsl)), this._serviceProviderData.ovp(b.ovp), this._serviceProviderData.sdk(b.sdk), this._serviceProviderData.channel(b.channel), this._serviceProviderData.libVersion(b.version), this._serviceProviderData.apiLevel(b.apiLvl), this._activeAssetId = b.videoId, this._serviceProviderData.playerName(b.playerName), this._assetData.videoId(this._activeAssetId), this._assetData.length(b.videoLength), this._assetData.type(o.TYPE_MAIN_CONTENT), this._assetData.publisher(b.publisher), this._assetData.name(b.videoName), this._streamData.type(b.streamType), this._updateQoSInfo(b);var c = b.metaNielsen ? g.merge(b.metaVideo, b.metaNielsen) : b.metaVideo,
                  d = new t(this, n.EVENT_TYPE_START, b.playhead, c, b._eventData[E]);this._sendHit(d);
            }
          }, e.prototype._onApiVideoResume = function (a) {
            var b = a.data;if (this._logger.debug(w, "#_onApiVideoResume(id=" + b.videoId + ", name=" + b.videoName + ", length=" + b.videoLength + ", type=" + b.streamType + ", playerName=" + b.playerName + ")"), this._checkCall("_onApiVideoResume") && this._inputDataValidator.validateFields(b, ["videoId", "streamType", "videoLength", "playhead", "playerName"])) {
              this._activeAssetId = b.videoId, this._assetData.videoId(this._activeAssetId), this._assetData.length(b.videoLength), this._assetData.type(o.TYPE_MAIN_CONTENT), this._assetData.name(b.videoName), this._streamData.type(b.streamType);var c = new t(this, n.EVENT_TYPE_RESUME, b.playhead, null, b._eventData[E]);this._sendHit(c);
            }
          }, e.prototype._onApiVideoComplete = function (a) {
            this._logger.debug(w, "#_onApiVideoComplete()");var b = a.data;if (this._checkCall("_onApiVideoComplete")) {
              var c = new t(this, n.EVENT_TYPE_COMPLETE, this._assetData.length(), null, b._eventData[E]);this._sendHit(c), this._isVideoComplete = !0;
            }
          }, e.prototype._onApiPlay = function (a) {
            this._logger.debug(w, "#_onApiPlay()");var b = a.data;if (this._checkCall("_onApiPlay") && this._inputDataValidator.validateFields(b, ["playhead"])) {
              this._updateQoSInfo(b);var c = new t(this, n.EVENT_TYPE_PLAY, b.playhead, null, b._eventData[E]);this._sendHit(c);
            }
          }, e.prototype._onApiPause = function (a) {
            this._logger.debug(w, "#_onApiPause()");var b = a.data;if (this._checkCall("_onApiPause") && this._inputDataValidator.validateFields(b, ["playhead"])) {
              this._updateQoSInfo(b);var c = b.playheadStalled ? n.EVENT_TYPE_STALL : n.EVENT_TYPE_PAUSE,
                  d = new t(this, c, b.playhead, null, b._eventData[E]);b._eventData.hasOwnProperty(F) && (d.filterReport = b._eventData[F]), this._sendHit(d);
            }
          }, e.prototype._onApiBufferStart = function (a) {
            this._logger.debug(w, "#_onApiBufferStart()");var b = a.data;if (this._checkCall("_onApiBufferStart") && this._inputDataValidator.validateFields(b, ["playhead"])) {
              this._updateQoSInfo(b);var c = new t(this, n.EVENT_TYPE_BUFFER, b.playhead, null, b._eventData[E]);this._sendHit(c);
            }
          }, e.prototype._onApiSeekStart = function (a) {
            this._logger.debug(w, "#_onApiSeekStart()"), this._checkCall("_onApiSeekStart") && (this._stashedAdData = this._assetData.adData(), this._stashedChapterData = this._assetData.chapterData(), this._assetData.adData(null), this._assetData.type(o.TYPE_MAIN_CONTENT), this._activeAssetId = this._assetData.videoId(), this._assetData.chapterData(null));
          }, e.prototype._onApiSeekComplete = function (a) {
            this._logger.debug(w, "#_onApiSeekComplete()");var b = a.data;if (this._checkCall("_onApiSeekComplete") && this._inputDataValidator.validateFields(b, ["playhead"])) {
              if (b.isInAd) {
                if (!this._inputDataValidator.validateFields(b, ["adId", "adPosition", "podPosition", "podPlayerName"])) return;var c = f(this._assetData.videoId()) + "_" + b.podPosition;if (this._stashedAdData && this._stashedAdData.podId() == c && parseInt(this._stashedAdData.podPosition(), 10) == b.adPosition) this._assetData.adData(this._stashedAdData), this._activeAssetId = this._stashedAdData.adId();else if (!this._assetData.adData()) {
                  this._activeAssetId = b.adId;var d = new r();d.adId(this._activeAssetId), d.adName(b.adName), d.adLength(b.adLength), d.podId(c), d.resolver(b.podPlayerName), d.podPosition(b.podPosition + ""), d.podName(b.podName), d.podOffset(b.podSecond), d.sid(this._generateSessionId()), this._assetData.adData(d);
                }this._assetData.type(o.TYPE_AD);
              } else this._assetData.adData(null), this._assetData.type(o.TYPE_MAIN_CONTENT), this._activeAssetId = this._assetData.videoId();if (b.isInChapter) {
                if (!this._inputDataValidator.validateFields(b, ["chapterPosition", "chapterLength", "chapterOffset"])) return;if (this._stashedChapterData && b.chapterPosition == this._stashedChapterData.position()) this._assetData.chapterData(this._stashedChapterData);else if (!this._assetData.chapterData()) {
                  var e = new s();e.id(f(this._assetData.videoId()) + "_" + b.chapterPosition), e.name(b.chapterName), e.length(b.chapterLength), e.position(b.chapterPosition), e.offset(b.chapterOffset), e.sid(this._generateSessionId()), this._assetData.chapterData(e);
                }
              } else this._assetData.chapterData(null);this._stashedAdData = null, this._stashedChapterData = null;
            }
          }, e.prototype._onApiAdStart = function (a) {
            var b = a.data;if (this._logger.debug(w, "#_onApiAdStart(id=" + b.adId + ", player_name=" + b.podPlayerName + ", parent_name=" + this._assetData.videoId() + ", pod_pos=" + b.adPosition + ")"), this._checkCall("_onApiAdStart") && this._inputDataValidator.validateFields(b, ["playhead", "podPosition", "podPlayerName", "adId", "adPosition"])) {
              this._activeAssetId = b.adId;var c = new r();c.adId(this._activeAssetId), c.adName(b.adName), c.adLength(b.adLength), c.resolver(b.podPlayerName), c.podId(f(this._assetData.videoId()) + "_" + b.podPosition), c.podPosition(b.adPosition + ""), c.podName(b.podName), c.podOffset(b.podSecond), c.sid(this._generateSessionId()), this._assetData.adData(c), this._assetData.type(o.TYPE_AD), this._updateQoSInfo(b);var d = g.merge(b.metaVideo, b.metaAd);d = b.metaNielsen ? g.merge(d, b.metaNielsen) : d;var e = new t(this, n.EVENT_TYPE_START, b.playhead, d, b._eventData[E]);this._sendHit(e);
            }
          }, e.prototype._onApiAdComplete = function (a) {
            this._logger.debug(w, "#_onApiAdComplete()");var b = a.data;if (this._checkCall("_onApiAdComplete") && this._inputDataValidator.validateFields(b, ["playhead"])) {
              if (this._assetData.type() != o.TYPE_AD) return void this._logger.warn(w, "#_onApiAdComplete() > Ignoring the ad complete event, because we are no longer in an ad.");this._updateQoSInfo(b);var c = new t(this, n.EVENT_TYPE_COMPLETE, b.playhead, null, b._eventData[E]);this._sendHit(c), this._assetData.adData(null), this._assetData.type(o.TYPE_MAIN_CONTENT), this._activeAssetId = this._assetData.videoId();
            }
          }, e.prototype._onApiChapterStart = function (a) {
            var b = a.data;if (this._logger.debug(w, "#_onApiChapterStart(name=" + b.chapterName + ", length=" + b.chapterLength + ", position=" + b.chapterPosition + ", chapter_offset=" + b.chapterOffset + ")"), this._checkCall("_onApiChapterStart") && this._inputDataValidator.validateFields(b, ["playhead", "chapterPosition", "chapterOffset", "chapterLength"])) {
              var c = new s();c.id(f(this._assetData.videoId()) + "_" + b.chapterPosition), c.name(b.chapterName), c.length(b.chapterLength), c.position(b.chapterPosition), c.offset(b.chapterOffset), c.sid(this._generateSessionId()), this._assetData.chapterData(c), this._updateQoSInfo(b);var d = g.merge(b.metaVideo, b.metaChapter),
                  e = new t(this, n.EVENT_TYPE_CHAPTER_START, b.playhead, d, b._eventData[E]);e.assetData.adData(null), e.assetData.type(o.TYPE_MAIN_CONTENT), this._sendHit(e);
            }
          }, e.prototype._onApiChapterComplete = function (a) {
            this._logger.debug(w, "#_onApiChapterComplete()");var b = a.data;if (this._checkCall("_onApiChapterComplete") && this._inputDataValidator.validateFields(b, ["playhead"])) {
              if (!this._assetData.chapterData()) return void this._logger.warn(w, "#_onApiChapterComplete() > Ignoring the chapter complete event, because we are no longer in a chapter.");this._updateQoSInfo(b);var c = new t(this, n.EVENT_TYPE_CHAPTER_COMPLETE, b.playhead, null, b._eventData[E]);c.assetData.adData(null), c.assetData.type(o.TYPE_MAIN_CONTENT), this._sendHit(c), this._assetData.chapterData(null);
            }
          }, e.prototype._onApiBitrateChange = function (a) {
            this._logger.debug(w, "#_onApiBitrateChange()");var b = a.data;if (this._checkCall("_onApiBitrateChange") && this._inputDataValidator.validateFields(b, ["playhead"])) {
              this._updateQoSInfo(b);var c = new t(this, n.EVENT_TYPE_BITRATE_CHANGE, b.playhead, null, b._eventData[E]);this._sendHit(c);
            }
          }, e.prototype._onApiTrackError = function (a) {
            var b = a.data;if (this._logger.debug(w, "#_onApiTrackError(source=" + b._eventData.source + ", err_id=" + b._eventData.error_id + ")"), !this._isTrackingSessionActive) return void this._logger.warn(w, "#_onApiTrackError() > No active tracking session.");if (this._trackExternalErrors || b._eventData.source === x) {
              this._updateQoSInfo(b);var c = new t(this, n.EVENT_TYPE_ERROR, 0, null, b._eventData[E]);c.eventData.id(b._eventData.error_id), c.eventData.source(b._eventData.source), this._sendHit(c);
            }
          }, e.prototype._onApiTrackInternalError = function (a) {
            var b = a.data;this._logger.debug(w, "#_onApiTrackInternalError(source=" + b.source + ", err_id=" + b.error_id + ")"), this._updateQoSInfo(b);var c = new t(this, n.EVENT_TYPE_ERROR, 0);c.eventData.id(b.error_id), c.eventData.source(b.source), this._sendHit(c);
          }, e.prototype._onApiQuantumEnd = function (a) {
            this._logger.debug(w, "#_onApiQuantumEnd(interval=" + this._channel.request(B) + ")");var b = a.data;this._checkCall("_onApiQuantumEnd") && this._inputDataValidator.validateFields(b, ["playhead"]) && (this._lastInBandItem && (this._lastInBandItem.eventData.playhead(b.playhead), this._updateQoSInfo(b), this._lastInBandItem.qosData.bitrate(this._qosData.bitrate()), this._lastInBandItem.qosData.fps(this._qosData.fps()), this._lastInBandItem.qosData.droppedFrames(this._qosData.droppedFrames()), this._lastInBandItem.qosData.startupTime(this._qosData.startupTime())), this._sendHit(this._lastInBandItem));
          }, e.prototype._onNetworkCheckStatusComplete = function (a) {
            var b = a.data;this._trackExternalErrors = b[I], this._reportingInterval = b[J], this._reportingInterval || (this._reportingInterval = fa), this._logger.debug(w, "#_onNetworkCheckStatusComplete(track_ext_err=" + this._trackExternalErrors + ")");
          }, e.prototype._onResetSessionId = function (a) {
            var b = this._generateSessionId();this._sessionData = new i(), this._sessionData.sessionId(b), this._logger.debug(w, "#_resetSessionId(new sessionId=" + b + ")");
          }, e.prototype._installEventListeners = function () {
            this._channel.on(K, this._onApiAnalyticsStart, this), this._channel.on(L, this._onApiAnalyticsAdStart, this), this._channel.on(M, this._onApiVideoLoad, this), this._channel.on(N, this._onApiVideoUnload, this), this._channel.on(O, this._onApiVideoStart, this), this._channel.on(P, this._onApiVideoComplete, this), this._channel.on(Q, this._onApiVideoResume, this), this._channel.on(R, this._onApiAdStart, this), this._channel.on(S, this._onApiAdComplete, this), this._channel.on(T, this._onApiPlay, this), this._channel.on(U, this._onApiPause, this), this._channel.on(V, this._onApiBufferStart, this), this._channel.on(W, this._onApiSeekStart, this), this._channel.on(X, this._onApiSeekComplete, this), this._channel.on(Y, this._onApiChapterStart, this), this._channel.on(Z, this._onApiChapterComplete, this), this._channel.on(aa, this._onApiBitrateChange, this), this._channel.on($, this._onApiTrackError, this), this._channel.on(_, this._onApiTrackInternalError, this), this._channel.on(ba, this._onApiQuantumEnd, this), this._channel.on(da, this._onNetworkCheckStatusComplete, this), this._channel.on(D, this._onResetSessionId, this), this._channel.reply(C, function () {
              return this._sessionData && this._sessionData.sessionId() ? this._sessionData.sessionId() : null;
            }, this);
          }, e.prototype._uninstallEventListeners = function () {
            this._channel.off(null, null, this);
          }, e.prototype._resetInternalState = function () {
            this._logger.debug(w, "#_resetInternalState()"), this._isTrackingSessionActive = !1, this._isVideoComplete = !1, this._autoComputedStartupTime = 0, this._streamData = new p(), this._qosData = new q(), this._sessionData = new i(), this._assetData = new o(), this._cuserData = null, this._stashedAdData = null, this._stashedChapterData = null, this._lastInBandItem = null;
          }, e.prototype._generateSessionId = function () {
            return "" + new Date().getTime() + Math.floor(1e9 * Math.random());
          }, e.prototype._updateQoSInfo = function (a) {
            this._qosData.bitrate(a.bitrate || 0), this._qosData.fps(a.fps || 0), this._qosData.droppedFrames(a.droppedFrames || 0), null == a.startupTime || isNaN(a.startupTime) ? (this._qosData.startupTime(this._autoComputedStartupTime), this._qosData.isStartupTimeOverridden = !1) : (this._qosData.startupTime(a.startupTime), this._qosData.isStartupTimeOverridden = !0);
          }, e.prototype._checkCall = function (a) {
            return this._isTrackingSessionActive ? this._isVideoComplete ? (this._logger.warn(w, "#" + a + "() > The video content already completed."), !1) : !0 : (this._logger.warn(w, "#" + a + "() > No active tracking session."), !1);
          }, e.prototype._updateLastInBandItem = function (a) {
            var b = new Date().getTime(),
                c = 1e3 * Math.abs(a.eventData.playhead() - this._lastInBandItem.eventData.playhead()),
                d = Math.abs(b - this._lastInBandItem.eventData.ts());this._lastInBandItem.eventData.type() != n.EVENT_TYPE_PAUSE && this._lastInBandItem.eventData.type() != n.EVENT_TYPE_STALL ? (d * ea >= c || this._doNotOverrideEventDuration) && d <= this._reportingInterval * ea * 1e3 ? this._lastInBandItem.eventData.duration(b - this._lastInBandItem.eventData.ts()) : (this._logger.warn(w, "[WARNING] Resetting duration in lastInBandItem to 0. playheadDelta:" + c + " tsDelta:" + d + " event type:" + this._lastInBandItem.eventData.type()), this._lastInBandItem.eventData.duration(0)) : this._lastInBandItem.eventData.duration(b - this._lastInBandItem.eventData.ts()), this._doNotOverrideEventDuration && (this._doNotOverrideEventDuration = !1), this._lastInBandItem.eventData.ts(b), this._lastInBandItem.eventData.playhead(a.eventData.playhead()), this._lastInBandItem.qosData.startupTime(a.qosData.startupTime()), this._lastInBandItem.qosData.isStartupTimeOverridden = a.qosData.isStartupTimeOverridden;
          }, e.prototype._sendHit = function (a) {
            function b(a) {
              var b = c._reportFactory.createReportForItem(a);b.qosData.isStartupTimeOverridden || b.qosData.startupTime(c._autoComputedStartupTime);var e = {};e[G] = b, c._channel.trigger(new h(ca, e)), (b.eventData.type() == n.EVENT_TYPE_PLAY || b.eventData.type() == n.EVENT_TYPE_BUFFER || b.eventData.type() == n.EVENT_TYPE_START) && (d = {}, d[H] = !0, c._channel.command(z, d));
            }var c = this,
                d = {};switch (a.eventData.type()) {case n.EVENT_TYPE_START:case n.EVENT_TYPE_PLAY:case n.EVENT_TYPE_PAUSE:case n.EVENT_TYPE_STALL:case n.EVENT_TYPE_BUFFER:
                this._lastInBandItem && (this._updateLastInBandItem(a), this._lastInBandItem.eventData.type() == n.EVENT_TYPE_START && this._lastInBandItem.assetData.type() == o.TYPE_MAIN_CONTENT && (this._autoComputedStartupTime += this._lastInBandItem.eventData.duration()), a != this._lastInBandItem && b(this._lastInBandItem)), b(a), this._lastInBandItem = a, d = {}, d[H] = !0, this._channel.command(z, d);break;case n.EVENT_TYPE_COMPLETE:
                this._lastInBandItem && (a.assetData.type() == o.TYPE_AD && (this._doNotOverrideEventDuration = !0), this._updateLastInBandItem(a), b(this._lastInBandItem)), b(a), a.assetData.type() == o.TYPE_MAIN_CONTENT ? (this._lastInBandItem = null, d = {}, d[H] = !0, this._channel.command(A, d)) : a.assetData.type() == o.TYPE_AD && (this._lastInBandItem.assetData.adData(null), this._lastInBandItem.assetData.type(o.TYPE_MAIN_CONTENT), this._doNotOverrideEventDuration = !0);break;case n.EVENT_TYPE_CHAPTER_START:case n.EVENT_TYPE_CHAPTER_COMPLETE:
                this._lastInBandItem && (this._updateLastInBandItem(a), b(this._lastInBandItem)), b(a), this._lastInBandItem && (this._lastInBandItem.assetData.chapterData(a.eventData.type() == n.EVENT_TYPE_CHAPTER_START ? new s(a.assetData.chapterData()) : null), this._lastInBandItem.eventData.duration(0), b(this._lastInBandItem));break;default:
                b(a);}
          };var w = "ah::Context",
              x = "sourceErrorSDK",
              y = "error",
              z = "clock:reporting.resume",
              A = "clock:reporting.pause",
              B = "reporting_interval",
              C = "session_id",
              D = "reset_session_id",
              E = "callback",
              F = "filter_report",
              G = "report",
              H = "reset",
              I = "track_external_errors",
              J = "reporting_interval",
              K = "api:aa_start",
              L = "api:aa_ad_start",
              M = "api:video_load",
              N = "api:video_unload",
              O = "api:video_start",
              P = "api:video_complete",
              Q = "api:video_resume",
              R = "api:ad_start",
              S = "api:ad_complete",
              T = "api:play",
              U = "api:pause",
              V = "api:buffer_start",
              W = "api:seek_start",
              X = "api:seek_complete",
              Y = "api:chapter_start",
              Z = "api:chapter_complete",
              $ = "api:track_error",
              _ = "api:track_internal_error",
              aa = "api:bitrate_change",
              ba = "api:quantum_end",
              ca = "context:report_available",
              da = "net:check_status_complete",
              ea = 1.5,
              fa = 10;d.context.Context = e;
        }(a.ADB.core, a.ADB.va, a.ADB.va.utils, b), function (a) {
          "use strict";
          function b(a, b) {
            this.trackingServer = a, this.publisher = b, this.ssl = !1, this.ovp = c, this.sdk = c, this.quietMode = !1, this.debugLogging = !1, this.__isPrimetime = !1, this.__psdkVersion = null;
          }var c = "unknown";a.AdobeHeartbeatPluginConfig = b;
        }(b), function (a) {
          "use strict";
          function b() {}b.prototype.onError = function (a) {}, a.AdobeHeartbeatPluginDelegate = b;
        }(b), function (a, b, c) {
          "use strict";
          function d(a) {
            d.__super__.constructor.call(this, q), this._radio = new i(this._logger), this._channel = this._radio.channel(y), this._delegate = a, this._context = new l(this._channel, this._logger), this._filter = new m(this._channel, this._logger), this._network = new n(this._channel, this._logger), this._setupDataResolver();
          }var e = a.Event,
              f = a.Trigger,
              g = a.plugin.BasePlugin,
              h = a.plugin.ParamMapping,
              i = a.radio.Radio,
              j = b.ErrorInfo,
              k = b.Version,
              l = c.context.Context,
              m = c.filter.ReportFilter,
              n = c.network.Network,
              o = c.clock.Clock,
              p = c.AdobeHeartbeatPluginConfig;a.extend(d, g), d.prototype.configure = function (a) {
            if (!a) throw new Error("Reference to the configuration data cannot be NULL.");if (!(a instanceof p)) throw new Error("Expected config data to be instance of AdobeHeartbeatPluginConfig.");this._config = a, this._config.debugLogging ? this._logger.enable() : this._logger.disable(), this._logger.debug(this._logTag, "#configure({trackingServer=" + this._config.trackingServer + ", publisher=" + this._config.publisher + ", quietMode=" + this._config.quietMode + ", ssl=" + this._config.ssl + "})");var b = this._config.trackingServer + "/settings/",
                c = {};c[ba] = this._config.trackingServer, c[ca] = b, c[da] = this._config.publisher, c[ea] = this._config.quietMode, c[fa] = this._config.ssl, this._channel.trigger(new e(ja, c)), this._isConfigured = !0;
          }, d.prototype.bootstrap = function (a) {
            d.__super__.bootstrap.call(this, a), this._channel.on(z, this._onError, this), this._clock = new o(this._pluginManager, this._channel, this._logger), this._channel.command(Ea), this._channel.trigger(new e(La)), this._registerCommands(), this._registerBehaviours();
          }, d.prototype._teardown = function () {
            this._logger.debug(this._logTag, "#_teardown()"), this._radio.shutdown(), this._context.destroy(), this._clock.destroy(), this._filter.destroy(), this._network.destroy();
          }, d.prototype._canProcess = function () {
            return this._isConfigured ? this._errorInfo ? (this._logger.error(this._logTag, "_canProcess() > Plugin in ERROR state."), !1) : d.__super__._canProcess.call(this) : (this._logger.error(this._logTag, "_canProcess() > Plugin not configured."), !1);
          }, d.prototype._cmdAnalyticsError = function (a) {
            this._errorInfo || (this._errorInfo = new j("Internal error", "AdobeAnalyticsPlugin is in ERROR state."), this._trigger(z, this._errorInfo), this._delegate && this._delegate.onError(this._errorInfo));
          }, d.prototype._cmdAnalyticsStart = function (a) {
            if (this._canProcess()) {
              var b = {};b[ga] = a.visitorOptedOut, this._channel.trigger(new e(ka, b)), this._channel.trigger(new e(ha, a));
            }
          }, d.prototype._cmdAnalyticsAdStart = function (a) {
            this._canProcess() && this._channel.trigger(new e(ia, a));
          }, d.prototype._cmdVideoLoad = function (a) {
            this._errorInfo = null, this._canProcess() && (this._isTrackingSessionActive && this._channel.trigger(new e(ma, a)), this._isTrackingSessionActive = !1, this._isPaused = !0, this._isSeeking = !1, this._isBuffering = !1, this._isVideoIdle = !1, this._filter.clear(), this._channel.trigger(new e(la, a)), this._isTrackingSessionActive = !0);
          }, d.prototype._cmdVideoUnload = function (a) {
            this._errorInfo = null, this._canProcess() && (this._channel.trigger(new e(ma, a)), this._filter.flush(), this._runReportingTimer(!1), this._runFlushFilterTimer(!1), this._runIdleTimer(!1), this._isTrackingSessionActive = !1);
          }, d.prototype._cmdVideoStart = function (a) {
            this._canProcess() && this._channel.trigger(new e(na, a));
          }, d.prototype._cmdVideoComplete = function (a) {
            this._canProcess() && this._channel.trigger(new e(oa, a));
          }, d.prototype._cmdVideoResume = function (a) {
            this._canProcess() && this._channel.trigger(new e(pa, a));
          }, d.prototype._cmdPlay = function (a) {
            this._canProcess() && (this._isPaused = !1, this._resumePlaybackIfPossible(a));
          }, d.prototype._cmdPause = function (a) {
            this._canProcess() && (this._channel.trigger(new e(ta, a)), this._isPaused = !0, this._runIdleTimer(!0));
          }, d.prototype._cmdAdStart = function (a) {
            this._canProcess() && (this._channel.trigger(new e(qa, a)), this._resumePlaybackIfPossible(a));
          }, d.prototype._cmdAdComplete = function (a) {
            this._canProcess() && (this._channel.trigger(new e(ra, a)), a.isInAdBreak || this._resumePlaybackIfPossible(a));
          }, d.prototype._cmdBufferStart = function (a) {
            this._canProcess() && (this._channel.trigger(new e(ua, a)), this._isBuffering = !0, this._runIdleTimer(!0));
          }, d.prototype._cmdBufferComplete = function (a) {
            this._canProcess() && (this._isBuffering = !1, this._resumePlaybackIfPossible(a));
          }, d.prototype._cmdSeekStart = function (a) {
            this._canProcess() && (this._channel.trigger(new e(va, a)), this._channel.trigger(new e(ta, a)), this._isSeeking = !0, this._runIdleTimer(!0));
          }, d.prototype._cmdSeekComplete = function (a) {
            this._canProcess() && (this._channel.trigger(new e(wa, a)), this._isSeeking = !1, this._resumePlaybackIfPossible(a));
          }, d.prototype._cmdChapterStart = function (a) {
            this._canProcess() && this._channel.trigger(new e(xa, a));
          }, d.prototype._cmdChapterComplete = function (a) {
            this._canProcess() && this._channel.trigger(new e(ya, a));
          }, d.prototype._cmdBitrateChange = function (a) {
            this._canProcess() && this._channel.trigger(new e(Ba, a));
          }, d.prototype._cmdTrackError = function (a) {
            this._canProcess() && this._channel.trigger(new e(za, a));
          }, d.prototype._cmdClockReportingTick = function (a) {
            this._canProcess() && this._channel.trigger(new e(Ca, a));
          }, d.prototype._cmdIdleTick = function (a) {
            this._canProcess() && (this._isVideoIdle = !0, this._trigger(V), this._filter.flush(), this._runReportingTimer(!1), this._runFlushFilterTimer(!1), this._runIdleTimer(!1), this._trigger(T));
          }, d.prototype._onError = function (a) {
            this._errorInfo = a.data;var b = {};b[_] = Da, b[aa] = this._errorInfo.getMessage() + "|" + this._errorInfo.getDetails(), this._channel.trigger(new e(Aa, b)), this._runReportingTimer(!1), this._trigger(z, this._errorInfo), this._delegate && this._delegate.onError(this._errorInfo);
          }, d.prototype._runIdleTimer = function (a) {
            var b = {};b[$] = !0, a ? this._channel.command(Ja, b) : this._channel.command(Ka, b);
          }, d.prototype._runFlushFilterTimer = function (a) {
            var b = {};b[$] = !0, a ? this._channel.command(Ha, b) : this._channel.command(Ia, b);
          }, d.prototype._runReportingTimer = function (a) {
            var b = {};b[$] = !0, a ? this._channel.command(Fa, b) : this._channel.command(Ga, b);
          }, d.prototype._registerCommands = function () {
            this._pluginManager.comply(this, "handleAnalyticsError", this._cmdAnalyticsError), this._pluginManager.comply(this, "handleAnalyticsStart", this._cmdAnalyticsStart), this._pluginManager.comply(this, "handleAnalyticsAdStart", this._cmdAnalyticsAdStart), this._pluginManager.comply(this, "handleVideoLoad", this._cmdVideoLoad), this._pluginManager.comply(this, "handleVideoUnload", this._cmdVideoUnload), this._pluginManager.comply(this, "handleVideoStart", this._cmdVideoStart), this._pluginManager.comply(this, "handleVideoComplete", this._cmdVideoComplete), this._pluginManager.comply(this, "handleVideoResume", this._cmdVideoResume), this._pluginManager.comply(this, "handlePlay", this._cmdPlay), this._pluginManager.comply(this, "handlePause", this._cmdPause), this._pluginManager.comply(this, "handleAdStart", this._cmdAdStart), this._pluginManager.comply(this, "handleAdComplete", this._cmdAdComplete), this._pluginManager.comply(this, "handleBufferStart", this._cmdBufferStart), this._pluginManager.comply(this, "handleBufferComplete", this._cmdBufferComplete), this._pluginManager.comply(this, "handleSeekStart", this._cmdSeekStart), this._pluginManager.comply(this, "handleSeekComplete", this._cmdSeekComplete), this._pluginManager.comply(this, "handleChapterStart", this._cmdChapterStart), this._pluginManager.comply(this, "handleChapterComplete", this._cmdChapterComplete), this._pluginManager.comply(this, "handleBitrateChange", this._cmdBitrateChange), this._pluginManager.comply(this, "handleTrackError", this._cmdTrackError), this._pluginManager.comply(this, "handleClockReportingTick", this._cmdClockReportingTick), this._pluginManager.comply(this, "handleIdleTick", this._cmdIdleTick);
          }, d.prototype._registerBehaviours = function () {
            this._pluginManager.registerBehaviour(new f(t, C), this, "handleVideoLoad", [new h(s, "rsid", "rsid"), new h(s, "tracking_server", "trackingServer")]), this._pluginManager.registerBehaviour(new f(t, D), this, "handleVideoUnload"), this._pluginManager.registerBehaviour(new f(t, E), this, "handleVideoStart", [new h(t, "video.id", "videoId"), new h(t, "video.name", "videoName"), new h(t, "video.length", "videoLength"), new h(t, "video.playhead", "playhead"), new h(t, "video.playerName", "playerName"), new h(t, "video.streamType", "streamType"), new h(t, "qos.fps", "fps"), new h(t, "qos.droppedFrames", "droppedFrames"), new h(t, "qos.bitrate", "bitrate"), new h(t, "qos.startupTime", "startupTime"), new h(s, "rsid", "rsid"), new h(s, "tracking_server", "trackingServer"), new h(s, "channel", "channel"), new h(s, "meta.video.*", "metaVideo"), new h(s, "ssl", "useSsl"), new h(u, "meta", "metaNielsen"), new h(r, "publisher", "publisher"), new h(r, "sdk", "sdk"), new h(r, "ovp", "ovp"), new h(r, "version", "version"), new h(r, "api_level", "apiLvl")]), this._pluginManager.registerBehaviour(new f(t, G), this, "handleVideoComplete", [new h(t, "qos.fps", "fps"), new h(t, "qos.droppedFrames", "droppedFrames"), new h(t, "qos.bitrate", "bitrate"), new h(t, "qos.startupTime", "startupTime")]), this._pluginManager.registerBehaviour(new f(t, F), this, "handleVideoResume", [new h(t, "video.id", "videoId"), new h(t, "video.name", "videoName"), new h(t, "video.length", "videoLength"), new h(t, "video.playhead", "playhead"), new h(t, "video.playerName", "playerName"), new h(t, "video.streamType", "streamType")]), this._pluginManager.registerBehaviour(new f(t, H), this, "handlePlay", [new h(t, "video.playhead", "playhead"), new h(t, "qos.fps", "fps"), new h(t, "qos.droppedFrames", "droppedFrames"), new h(t, "qos.bitrate", "bitrate"), new h(t, "qos.startupTime", "startupTime")]), this._pluginManager.registerBehaviour(new f(t, I), this, "handlePause", [new h(t, "video.playhead", "playhead"), new h(t, "video.playheadStalled", "playheadStalled"), new h(t, "qos.fps", "fps"), new h(t, "qos.droppedFrames", "droppedFrames"), new h(t, "qos.bitrate", "bitrate"), new h(t, "qos.startupTime", "startupTime")]), this._pluginManager.registerBehaviour(new f(t, J), this, "handleAdStart", [new h(t, "video.playhead", "playhead"), new h(t, "ad.id", "adId"), new h(t, "ad.name", "adName"), new h(t, "ad.length", "adLength"), new h(t, "ad.position", "adPosition"), new h(t, "pod.name", "podName"), new h(t, "pod.playerName", "podPlayerName"), new h(t, "pod.position", "podPosition"), new h(t, "pod.startTime", "podSecond"), new h(t, "qos.fps", "fps"), new h(t, "qos.droppedFrames", "droppedFrames"), new h(t, "qos.bitrate", "bitrate"), new h(t, "qos.startupTime", "startupTime"), new h(s, "meta.video.*", "metaVideo"), new h(s, "meta.ad.*", "metaAd"), new h(u, "meta", "metaNielsen")]), this._pluginManager.registerBehaviour(new f(t, K), this, "handleAdComplete", [new h(t, "video.playhead", "playhead"), new h(t, "ad.isInAdBreak", "isInAdBreak"), new h(t, "qos.fps", "fps"), new h(t, "qos.droppedFrames", "droppedFrames"), new h(t, "qos.bitrate", "bitrate"), new h(t, "qos.startupTime", "startupTime")]), this._pluginManager.registerBehaviour(new f(t, L), this, "handleBufferStart", [new h(t, "video.playhead", "playhead"), new h(t, "qos.fps", "fps"), new h(t, "qos.droppedFrames", "droppedFrames"), new h(t, "qos.bitrate", "bitrate"), new h(t, "qos.startupTime", "startupTime")]), this._pluginManager.registerBehaviour(new f(t, M), this, "handleBufferComplete", [new h(t, "video.playhead", "playhead"), new h(t, "qos.fps", "fps"), new h(t, "qos.droppedFrames", "droppedFrames"), new h(t, "qos.bitrate", "bitrate"), new h(t, "qos.startupTime", "startupTime")]), this._pluginManager.registerBehaviour(new f(t, N), this, "handleSeekStart", [new h(t, "video.playhead", "playhead")]), this._pluginManager.registerBehaviour(new f(t, O), this, "handleSeekComplete", [new h(t, "video.playhead", "playhead"), new h(t, "ad.isInAd", "isInAd"), new h(t, "ad.id", "adId"), new h(t, "ad.position", "adPosition"), new h(t, "pod.playerName", "podPlayerName"), new h(t, "pod.position", "podPosition"), new h(t, "chapter.isInChapter", "isInChapter"), new h(t, "chapter.position", "chapterPosition"), new h(t, "chapter.name", "chapterName"), new h(t, "chapter.length", "chapterLength"), new h(t, "chapter.startTime", "chapterOffset"), new h(t, "qos.fps", "fps"), new h(t, "qos.droppedFrames", "droppedFrames"), new h(t, "qos.bitrate", "bitrate"), new h(t, "qos.startupTime", "startupTime")]), this._pluginManager.registerBehaviour(new f(t, P), this, "handleChapterStart", [new h(t, "video.playhead", "playhead"), new h(t, "chapter.position", "chapterPosition"), new h(t, "chapter.name", "chapterName"), new h(t, "chapter.length", "chapterLength"), new h(t, "chapter.startTime", "chapterOffset"), new h(t, "qos.fps", "fps"), new h(t, "qos.droppedFrames", "droppedFrames"), new h(t, "qos.bitrate", "bitrate"), new h(t, "qos.startupTime", "startupTime"), new h(s, "meta.video.*", "metaVideo"), new h(s, "meta.chapter.*", "metaChapter"), new h(u, "meta", "metaNielsen")]), this._pluginManager.registerBehaviour(new f(t, Q), this, "handleChapterComplete", [new h(t, "video.playhead", "playhead"), new h(t, "qos.fps", "fps"), new h(t, "qos.droppedFrames", "droppedFrames"), new h(t, "qos.bitrate", "bitrate"), new h(t, "qos.startupTime", "startupTime")]), this._pluginManager.registerBehaviour(new f(t, R), this, "handleBitrateChange", [new h(t, "video.playhead", "playhead"), new h(t, "qos.fps", "fps"), new h(t, "qos.droppedFrames", "droppedFrames"), new h(t, "qos.bitrate", "bitrate"), new h(t, "qos.startupTime", "startupTime")]), this._pluginManager.registerBehaviour(new f(t, S), this, "handleTrackError"), this._pluginManager.registerBehaviour(new f(v, X), this, "handleClockReportingTick", [new h(t, "video.playhead", "playhead"), new h(t, "qos.fps", "fps"), new h(t, "qos.droppedFrames", "droppedFrames"), new h(t, "qos.bitrate", "bitrate"), new h(t, "qos.startupTime", "startupTime")]), this._pluginManager.registerBehaviour(new f(v, Z), this, "handleIdleTick", []), this._pluginManager.registerBehaviour(new f(r, V), this, "handleClockReportingTick", [new h(t, "video.playhead", "playhead"), new h(t, "qos.fps", "fps"), new h(t, "qos.droppedFrames", "droppedFrames"), new h(t, "qos.bitrate", "bitrate"), new h(t, "qos.startupTime", "startupTime")]), this._pluginManager.registerBehaviour(new f(s, z), this, "handleAnalyticsError"), this._pluginManager.registerBehaviour(new f(s, A), this, "handleAnalyticsStart", [new h(s, "vid", "vid"), new h(s, "aid", "aid"), new h(s, "mid", "mid"), new h(s, "customerIDs", "customerIDs"), new h(s, "visitorOptedOut", "visitorOptedOut"), new h(s, "blob", "blob"), new h(s, "loc_hint", "loc_hint"), new h(t, "video.playhead", "playhead"), new h(t, "qos.fps", "fps"), new h(t, "qos.droppedFrames", "droppedFrames"), new h(t, "qos.bitrate", "bitrate"), new h(t, "qos.startupTime", "startupTime")]), this._pluginManager.registerBehaviour(new f(s, B), this, "handleAnalyticsAdStart", [new h(t, "video.playhead", "playhead"), new h(t, "qos.fps", "fps"), new h(t, "qos.droppedFrames", "droppedFrames"), new h(t, "qos.bitrate", "bitrate"), new h(t, "qos.startupTime", "startupTime")]);
          }, d.prototype._setupDataResolver = function () {
            var a = {},
                b = this;a.version = function () {
              return k.getVersion();
            }, a.api_level = function () {
              return k.getApiLevel();
            }, a.tracking_server = function () {
              return b._config ? b._config.trackingServer : null;
            }, a.publisher = function () {
              return b._config ? b._config.publisher : null;
            }, a.quiet_mode = function () {
              return b._config ? b._config.quietMode : !1;
            }, a.ovp = function () {
              return b._config ? b._config.ovp : null;
            }, a.sdk = function () {
              return b._config ? b._config.sdk : null;
            }, a.is_primetime = function () {
              return b._config ? b._config.__isPrimetime : !1;
            }, a.psdk_version = function () {
              return b._config ? b._config.__psdkVersion : null;
            }, a.session_id = function () {
              return b._channel.request(w);
            }, this._dataResolver = function (b) {
              if (!b || 0 == b.length) return null;for (var c = null, d = 0; d < b.length; d++) {
                var e = b[d];c = c || {}, c[e] = a.hasOwnProperty(e) ? a[e].call(this) : null;
              }return c;
            };
          }, d.prototype._resumePlaybackIfPossible = function (a) {
            this._errorInfo || this._isPaused || this._isSeeking || this._isBuffering || (this._isVideoIdle && (this._isVideoIdle = !1, this._resumePlaybackFromIdle()), this._runIdleTimer(!1), this._channel.trigger(new e(sa, a)));
          }, d.prototype._resumePlaybackFromIdle = function () {
            this._trigger(V), this._filter.clear(), this._channel.trigger(new e(x)), this._trigger(U), this._runReportingTimer(!0), this._runFlushFilterTimer(!0);
          };var q = "adobe-heartbeat",
              r = q,
              s = "adobe-analytics",
              t = "player",
              u = "nielsen",
              v = "service.clock",
              w = "session_id",
              x = "reset_session_id",
              y = "heartbeat-channel",
              z = "error",
              A = "aa_start",
              B = "sc_ad_start",
              C = "video_load",
              D = "video_unload",
              E = "video_start",
              F = "video_resume",
              G = "video_complete",
              H = "play",
              I = "pause",
              J = "ad_start",
              K = "ad_complete",
              L = "buffer_start",
              M = "buffer_complete",
              N = "seek_start",
              O = "seek_complete",
              P = "chapter_start",
              Q = "chapter_complete",
              R = "bitrate_change",
              S = "track_error",
              T = "video_idle_start",
              U = "video_idle_resume",
              V = "quantum_close",
              W = "heartbeat.reporting",
              X = W + ".tick",
              Y = "heartbeat.idle",
              Z = Y + ".tick",
              $ = "reset",
              _ = "source",
              aa = "error_id",
              ba = "tracking_server",
              ca = "check_status_server",
              da = "publisher",
              ea = "quiet_mode",
              fa = "ssl",
              ga = "visitor_opt_out",
              ha = "api:aa_start",
              ia = "api:aa_ad_start",
              ja = "api:config",
              ka = "api:update_visitor_optout",
              la = "api:video_load",
              ma = "api:video_unload",
              na = "api:video_start",
              oa = "api:video_complete",
              pa = "api:video_resume",
              qa = "api:ad_start",
              ra = "api:ad_complete",
              sa = "api:play",
              ta = "api:pause",
              ua = "api:buffer_start",
              va = "api:seek_start",
              wa = "api:seek_complete",
              xa = "api:chapter_start",
              ya = "api:chapter_complete",
              za = "api:track_error",
              Aa = "api:track_internal_error",
              Ba = "api:bitrate_change",
              Ca = "api:quantum_end",
              Da = "sourceErrorHeartbeat",
              Ea = "clock:check_status.resume",
              Fa = "clock:reporting.resume",
              Ga = "clock:reporting.pause",
              Ha = "clock:flush_filter.resume",
              Ia = "clock:flush_filter.pause",
              Ja = "clock:idle.resume",
              Ka = "clock:idle.pause",
              La = "clock:check_status.get_settings";c.AdobeHeartbeatPlugin = d;
        }(a.ADB.core, a.ADB.va, b), a.ADB.va.plugins.ah || (a.ADB.va.plugins.ah = b);
      }(this);

      // AdobeAnalyticsPlugin
      !function (a) {
        if ("undefined" == typeof b) var b = {};!function (a, b) {
          "use strict";
          function c(a, b) {
            this._onFail = { fn: a, ctx: b };
          }var d = a.ErrorInfo;c.prototype.validateFields = function (a, b) {
            if (!a) return this._fail("Data cannot be null");if (b) for (var c = 0; c < b.length; c++) {
              var d = b[c];switch (d) {case "videoId":
                  if (!a.hasOwnProperty("videoId")) return this._fail("The ID for the main video must be specified.");if ("string" != typeof a.videoId) return this._fail("The ID for the main video must be a String.");if ("" === a.videoId) return this._fail("The ID for the main video cannot be an empty string.");break;case "streamType":
                  if (!a.hasOwnProperty("streamType")) return this._fail("The stream type for the main video must be specified.");if ("string" != typeof a.streamType) return this._fail("The stream type for the main video must be a String.");if ("" === a.streamType) return this._fail("The stream type for the main video cannot be an empty string.");break;case "playerName":
                  if (!a.hasOwnProperty("playerName")) return this._fail("The player name for the main video must be specified.");if ("string" != typeof a.playerName) return this._fail("The player name for the main video must be a String.");if ("" === a.playerName) return this._fail("The player name for the main video cannot be an empty string.");break;case "videoLength":
                  if (!a.hasOwnProperty("videoLength")) return this._fail("The length of the main video must be specified.");if ("number" != typeof a.videoLength) return this._fail("The length of the main video must be a Number.");if (isNaN(a.videoLength)) return this._fail("The length of the main video cannot be NaN.");break;case "podPlayerName":
                  if (!a.hasOwnProperty("podPlayerName")) return this._fail("The player name for the ad-break must be specified.");if ("string" != typeof a.podPlayerName) return this._fail("The player name for the ad-break must be a String.");if ("" === a.podPlayerName) return this._fail("The player name for the ad-break cannot be an empty string.");break;case "podPosition":
                  if (!a.hasOwnProperty("podPosition")) return this._fail("Position (index) of the ad-break must be specified.");if ("number" != typeof a.podPosition) return this._fail("Position (index) of the ad-break must be a Number.");if (isNaN(a.podPosition)) return this._fail("Position (index) of the ad-break cannot be NaN.");break;case "adId":
                  if (!a.hasOwnProperty("adId")) return this._fail("The ad ID must be specified.");if ("string" != typeof a.adId) return this._fail("The ad ID must be a String.");if ("" === a.adId) return this._fail("The ad ID cannot be an empty string.");break;case "adPosition":
                  if (!a.hasOwnProperty("adPosition")) return this._fail("Position (index) of the ad must be specified.");if ("number" != typeof a.adPosition) return this._fail("Position (index) of the ad must be a Number.");if (isNaN(a.adPosition)) return this._fail("Position (index) of the ad cannot be NaN.");break;case "adLength":
                  if (!a.hasOwnProperty("adLength")) return this._fail("The length of the ad must be specified.");if ("number" != typeof a.adLength) return this._fail("The length of the ad must be a Number.");if (isNaN(a.adLength)) return this._fail("The length of the ad cannot be NaN.");break;default:
                  return this._fail("Unable to validate unknown parameter: " + d);}
            }return !0;
          }, c.prototype._fail = function (a) {
            var b = new d("Invalid input data", a);return this._onFail.fn && this._onFail.fn.call(this._onFail.ctx, b), !1;
          }, b.InputDataValidator = c;
        }(a.ADB.va, b), function (a) {
          "use strict";
          function b() {
            this.channel = c, this.debugLogging = !1;
          }var c = "";a.AdobeAnalyticsPluginConfig = b;
        }(b), function (a) {
          "use strict";
          function b() {}b.prototype.onError = function (a) {}, a.AdobeAnalyticsPluginDelegate = b;
        }(b), function (a, b, c, d) {
          "use strict";
          function e(a, b) {
            if (e.__super__.constructor.call(this, r), !a) throw new Error("The reference to the AppMeasurement object cannot be NULL.");this._appMeasurement = a, this._delegate = b, this._customMetaKeys = [], this._videoMetadata = {}, this._adMetadata = {}, this._chapterMetadata = {}, this._errorInfo = null, this._workQueue = new k(!0, w), this._inputDataValidator = new q(function (a) {
              this._errorInfo = a, this._logger.error(this._logTag, a.getMessage() + " | " + a.getDetails());var b = this;setTimeout(function () {
                b._trigger(x, a), b._delegate && b._delegate.onError(b._errorInfo);
              }, 0);
            }, this), this._appMeasurement.isReadyToTrack(), this._setupDataResolver();
          }var f = a.Trigger,
              g = a.plugin.BasePlugin,
              h = a.plugin.ParamMapping,
              i = a.radio.Channel,
              j = a.radio.Command,
              k = a.radio.CommandQueue,
              l = b.ErrorInfo,
              m = c.md5,
              n = c.StringUtils,
              o = c.ObjectUtils,
              p = d.AdobeAnalyticsPluginConfig,
              q = d.InputDataValidator;a.extend(e, g), e.prototype.configure = function (a) {
            if (!a) throw new Error("Reference to the configuration data cannot be NULL.");if (!(a instanceof p)) throw new Error("Expected config data to be instance of AdobeAnalyticsPluginConfig.");this._config = a, this._config.debugLogging ? this._logger.enable() : this._logger.disable(), this._logger.debug(this._logTag, "#configure({trackingServer=" + this._config.debugLogging + ", channel=" + this._config.channel + ", ssl=" + this._appMeasurement.ssl + "})");
          }, e.prototype.bootstrap = function (a) {
            e.__super__.bootstrap.call(this, a), this._registerCommands(), this._registerBehaviours();
          }, e.prototype.setup = function () {
            this._appMeasurement.isReadyToTrack() ? this._onAppMeasurementReady() : this._appMeasurement.callbackWhenReadyToTrack(this, this._onAppMeasurementReady, []), e.__super__.setup.call(this);
          }, e.prototype.setVideoMetadata = function (a) {
            this._videoMetadata = o.clone(a);
          }, e.prototype.setAdMetadata = function (a) {
            this._adMetadata = o.clone(a);
          }, e.prototype.setChapterMetadata = function (a) {
            this._chapterMetadata = o.clone(a);
          }, e.prototype._canProcess = function () {
            return this._errorInfo ? (this._logger.error(this._logTag, "#_canProcess() > In ERROR state."), !1) : e.__super__._canProcess.call(this);
          }, e.prototype._cmdVideoLoad = function (a) {
            this._errorInfo = null;
          }, e.prototype._cmdVideoStart = function (a) {
            this._logger.debug(this._logTag, "#_cmdVideoStart()"), this._canProcess() && this._workQueue.addCommand(new j(this._executeOpen, this, [a]));
          }, e.prototype._cmdAdStart = function (a) {
            this._logger.debug(this._logTag, "#_cmdAdStart()"), this._canProcess() && this._workQueue.addCommand(new j(this._executeOpenAd, this, [a]));
          }, e.prototype._cmdHeartbeatPluginError = function (a) {
            this._errorInfo || (this._errorInfo = new l("Internal error", "HeartbeatPlugin is in ERROR state."), this._trigger(x, this._errorInfo), this._delegate && this._delegate.onError(this._errorInfo));
          }, e.prototype._resetAppMeasurementContextData = function () {
            delete this._appMeasurement.contextData["a.contentType"], delete this._appMeasurement.contextData["a.media.name"], delete this._appMeasurement.contextData["a.media.friendlyName"], delete this._appMeasurement.contextData["a.media.length"], delete this._appMeasurement.contextData["a.media.playerName"], delete this._appMeasurement.contextData["a.media.channel"], delete this._appMeasurement.contextData["a.media.view"], delete this._appMeasurement.contextData["a.media.ad.name"], delete this._appMeasurement.contextData["a.media.ad.friendlyName"], delete this._appMeasurement.contextData["a.media.ad.podFriendlyName"], delete this._appMeasurement.contextData["a.media.ad.length"], delete this._appMeasurement.contextData["a.media.ad.playerName"], delete this._appMeasurement.contextData["a.media.ad.pod"], delete this._appMeasurement.contextData["a.media.ad.podPosition"], delete this._appMeasurement.contextData["a.media.ad.podSecond"], delete this._appMeasurement.contextData["a.media.ad.view"];for (var a = 0; a < this._customMetaKeys.length; a++) {
              var b = this._customMetaKeys[a];delete this._appMeasurement.contextData[b];
            }this._customMetaKeys = [];
          }, e.prototype._executeOpen = function (a) {
            if (this._logger.debug(this._logTag, "#_executeOpen(id=" + a.videoId + ", videoName=" + a.videoName + ", streamType=" + a.streamType + ", length=" + a.videoLength + ", playerName=" + a.playerName + ", channel=" + a.channel + ", isPrimetime=" + a.isPrimetime + ", sessionId=" + a.sessionId + ")"), this._canProcess() && this._inputDataValidator.validateFields(a, ["videoId", "streamType", "videoLength", "playerName"])) {
              this._resetAppMeasurementContextData();for (var b in a.metaVideo) {
                a.metaVideo.hasOwnProperty(b) && (this._appMeasurement.contextData[b] = a.metaVideo[b], this._customMetaKeys.push(b));
              }if (a.metaNielsen) for (var b in a.metaNielsen) {
                a.metaNielsen.hasOwnProperty(b) && (this._appMeasurement.contextData[b] = a.metaNielsen[b], this._customMetaKeys.push(b));
              }this._appMeasurement.contextData["a.contentType"] = a.streamType, this._appMeasurement.contextData["a.media.name"] = a.videoId, this._appMeasurement.contextData["a.media.friendlyName"] = a.videoName || "", this._appMeasurement.contextData["a.media.length"] = Math.floor(a.videoLength) || "0.0", this._appMeasurement.contextData["a.media.playerName"] = a.playerName, this._appMeasurement.contextData["a.media.channel"] = a.channel || "", this._appMeasurement.contextData["a.media.view"] = !0, this._appMeasurement.contextData["a.media.vsid"] = a.sessionId, this._appMeasurement.pev3 = y, this._appMeasurement.pe = a.isPrimetime ? B : A, this._appMeasurement.track();var c = this;setTimeout(function () {
                c._trigger(E, a);
              }, 0);
            }
          }, e.prototype._executeOpenAd = function (a) {
            var b = m(a.videoId) + "_" + a.podPosition;if (this._logger.debug(this._logTag, "#_executeOpenAd(id=" + a.adId + ", streamType=" + a.streamType + ", length=" + a.adLength + ", podPlayerName=" + a.podPlayerName + ", parentId=" + a.videoId + ", podId=" + b + ", parentPodPosition=" + a.adPosition + ", podSecond=" + a.podSecond + ")"), this._canProcess() && this._inputDataValidator.validateFields(a, ["videoId", "streamType", "playerName", "adId", "adLength", "podPlayerName", "adPosition"])) {
              a.podSecond = null == a.podSecond || isNaN(a.podSecond) ? a.playhead : a.podSecond, this._resetAppMeasurementContextData();var c;for (c in a.metaVideo) {
                a.metaVideo.hasOwnProperty(c) && (this._appMeasurement.contextData[c] = a.metaVideo[c], this._customMetaKeys.push(c));
              }for (c in a.metaAd) {
                a.metaAd.hasOwnProperty(c) && (this._appMeasurement.contextData[c] = a.metaAd[c], this._customMetaKeys.push(c));
              }if (a.metaNielsen) for (var c in a.metaNielsen) {
                a.metaNielsen.hasOwnProperty(c) && (this._appMeasurement.contextData[c] = a.metaNielsen[c], this._customMetaKeys.push(c));
              }this._appMeasurement.contextData["a.contentType"] = a.streamType, this._appMeasurement.contextData["a.media.name"] = a.videoId, this._appMeasurement.contextData["a.media.playerName"] = a.playerName, this._appMeasurement.contextData["a.media.channel"] = a.channel || "", this._appMeasurement.contextData["a.media.vsid"] = a.sessionId, this._appMeasurement.contextData["a.media.friendlyName"] = a.videoName || "", this._appMeasurement.contextData["a.media.length"] = Math.floor(a.videoLength) || "0.0", this._appMeasurement.contextData["a.media.ad.name"] = a.adId, this._appMeasurement.contextData["a.media.ad.friendlyName"] = a.adName || "", this._appMeasurement.contextData["a.media.ad.podFriendlyName"] = a.podName || "", this._appMeasurement.contextData["a.media.ad.length"] = Math.floor(a.adLength) || "0.0", this._appMeasurement.contextData["a.media.ad.playerName"] = a.podPlayerName, this._appMeasurement.contextData["a.media.ad.pod"] = b, this._appMeasurement.contextData["a.media.ad.podPosition"] = Math.floor(a.adPosition) || "0.0", this._appMeasurement.contextData["a.media.ad.podSecond"] = Math.floor(a.podSecond) || "0.0", this._appMeasurement.contextData["a.media.ad.view"] = !0, this._appMeasurement.pev3 = z, this._appMeasurement.pe = a.isPrimetime ? D : C, this._appMeasurement.track();var d = this;setTimeout(function () {
                d._trigger(F, a);
              }, 0);
            }
          }, e.prototype._setupDataResolver = function () {
            var a = {},
                b = this;a.rsid = function () {
              return b._appMeasurement.account;
            }, a.tracking_server = function () {
              return b._appMeasurement.ssl && b._appMeasurement.trackingServerSecure ? b._appMeasurement.trackingServerSecure : b._appMeasurement.trackingServer;
            }, a.ssl = function () {
              return b._appMeasurement.ssl;
            }, a.vid = function () {
              return b._appMeasurement.visitorID;
            }, a.aid = function () {
              return b._appMeasurement.analyticsVisitorID;
            }, a.mid = function () {
              return b._appMeasurement.marketingCloudVisitorID;
            }, a.blob = function () {
              return b._appMeasurement.audienceManagerBlob;
            }, a.loc_hint = function () {
              return b._appMeasurement.audienceManagerLocationHint ? parseInt(b._appMeasurement.audienceManagerLocationHint) : "";
            }, a.customerIDs = function () {
              var a = b._appMeasurement.visitor.getCustomerIDs(),
                  c = {};for (var d in a) {
                if (a.hasOwnProperty(d)) {
                  var e = a[d];if ("object" == (typeof e === 'undefined' ? 'undefined' : _typeof(e))) {
                    for (var f in e) {
                      e.hasOwnProperty(f) && ("authState" == f ? c[d + ".as"] = e[f] : c[d + "." + f] = e[f]);
                    }c[d + ".as"] || (c[d + ".as"] = "0");
                  }
                }
              }return c;
            }, a.channel = function () {
              return b._config ? b._config.channel : null;
            }, a.meta = function (a) {
              var c = a.split(".");if (c.length < 2) return null;var d = c.shift();switch (a = c.join("."), d) {case "video":
                  return a == i.WILDCARD ? b._videoMetadata : b._videoMetadata[a];case "ad":
                  return a == i.WILDCARD ? b._adMetadata : b._adMetadata[a];case "chapter":
                  return a == i.WILDCARD ? b._chapterMetadata : b._chapterMetadata[a];default:
                  return null;}
            }, a.visitorOptedOut = function () {
              return void 0 == b._appMeasurement.visitorOptedOut ? !1 : b._appMeasurement.visitorOptedOut;
            }, this._dataResolver = function (b) {
              if (!b || 0 == b.length) return null;for (var c = null, d = 0; d < b.length; d++) {
                var e = b[d];c = c || {}, n.startsWith(e, "meta.") ? c[e] = a.meta(e.split("meta.")[1]) : c[e] = a.hasOwnProperty(e) ? a[e].call(this) : null;
              }return c;
            };
          }, e.prototype._registerCommands = function () {
            this._pluginManager.comply(this, "handleVideoLoad", this._cmdVideoLoad), this._pluginManager.comply(this, "handleVideoStart", this._cmdVideoStart), this._pluginManager.comply(this, "handleAdStart", this._cmdAdStart), this._pluginManager.comply(this, "handleHeartbeatPluginError", this._cmdHeartbeatPluginError);
          }, e.prototype._registerBehaviours = function () {
            this._pluginManager.registerBehaviour(new f(u, G), this, "handleVideoLoad"), this._pluginManager.registerBehaviour(new f(u, H), this, "handleVideoStart", [new h(u, "video.id", "videoId"), new h(u, "video.streamType", "streamType"), new h(u, "video.name", "videoName"), new h(u, "video.length", "videoLength"), new h(u, "video.playerName", "playerName"), new h(u, "video.streamType", "streamType"), new h(v, "is_primetime", "isPrimetime"), new h(v, "session_id", "sessionId"), new h(s, "channel", "channel"), new h(s, "meta.video.*", "metaVideo"), new h(t, "meta", "metaNielsen")]), this._pluginManager.registerBehaviour(new f(u, I), this, "handleAdStart", [new h(u, "video.id", "videoId"), new h(u, "video.streamType", "streamType"), new h(u, "video.playhead", "playhead"), new h(u, "video.playerName", "playerName"), new h(u, "video.name", "videoName"), new h(u, "video.length", "videoLength"), new h(u, "ad.id", "adId"), new h(u, "ad.length", "adLength"), new h(u, "ad.position", "adPosition"), new h(u, "ad.name", "adName"), new h(u, "pod.name", "podName"), new h(u, "pod.position", "podPosition"), new h(u, "pod.playerName", "podPlayerName"), new h(u, "pod.startTime", "podSecond"), new h(v, "is_primetime", "isPrimetime"), new h(v, "session_id", "sessionId"), new h(s, "channel", "channel"), new h(s, "meta.video.*", "metaVideo"), new h(s, "meta.ad.*", "metaAd"), new h(t, "meta", "metaNielsen")]), this._pluginManager.registerBehaviour(new f(v, x), this, "handleHeartbeatPluginError");
          }, e.prototype._onAppMeasurementReady = function () {
            this._workQueue.resume();
          };var r = "adobe-analytics",
              s = r,
              t = "nielsen",
              u = "player",
              v = "adobe-heartbeat",
              w = 2e3,
              x = "error",
              y = "video",
              z = "videoAd",
              A = "ms_s",
              B = "msp_s",
              C = "msa_s",
              D = "mspa_s",
              E = "aa_start",
              F = "sc_ad_start",
              G = "video_load",
              H = "video_start",
              I = "ad_start";d.AdobeAnalyticsPlugin = e;
        }(a.ADB.core, a.ADB.va, a.ADB.va.utils, b), function (a) {
          "use strict";
          var b = { SHOW: "a.media.show", SEASON: "a.media.season", EPISODE: "a.media.episode", ASSET_ID: "a.media.asset", GENRE: "a.media.genre", FIRST_AIR_DATE: "a.media.airDate", FIRST_DIGITAL_DATE: "a.media.digitalDate", RATING: "a.media.rating", ORIGINATOR: "a.media.originator", NETWORK: "a.media.network", SHOW_TYPE: "a.media.type", AD_LOAD: "a.media.adLoad", MVPD: "a.media.pass.mvpd", AUTHORIZED: "a.media.pass.auth", DAY_PART: "a.media.dayPart", FEED: "a.media.feed", STREAM_FORMAT: "a.media.format" },
              c = { ADVERTISER: "a.media.ad.advertiser", CAMPAIGN_ID: "a.media.ad.campaign", CREATIVE_ID: "a.media.ad.creative", PLACEMENT_ID: "a.media.ad.placement", SITE_ID: "a.media.ad.site", CREATIVE_URL: "a.media.ad.creativeURL" };a.VideoMetadataKeys = b, a.AdMetadataKeys = c;
        }(b), a.ADB.va.plugins.aa || (a.ADB.va.plugins.aa = b);
      }(this);
    } // loadHeartbeat

  }, {
    key: 'onReady',
    value: function onReady(mediaApi) {
      this.amp = mediaApi;
      window.amp = mediaApi;
    }
  }, {
    key: 'onDestroy',
    value: function onDestroy() {
      this.stopListeningToAll();
      this.unload();
    }
  }, {
    key: 'onEmptied',
    value: function onEmptied() {
      this.unload();
    }
  }, {
    key: 'onEnded',
    value: function onEnded() {
      if (Math.floor(this.amp.getMediaElement().currentTime) === 0) {
        return;
      }
      if (this.VideoPlayerPlugin) {
        this.VideoPlayerPlugin.trackComplete();
      }
    }
  }, {
    key: 'onLoadeddata',
    value: function onLoadeddata() {}
  }, {
    key: 'onLoadedmetadata',
    value: function onLoadedmetadata(config) {
      this.isFirstPlay = true;
      Object.assign(this.amp.config.media, config.media);
      this.configId = this.amp.media.metadata.videoId;
      this.initHeartbeat();
      if (this.VideoPlayerPlugin) {
        this.VideoPlayerPlugin.trackVideoLoad();
      }
    }
  }, {
    key: 'onPause',
    value: function onPause() {
      if (this.VideoPlayerPlugin && this.VideoPlayerPlugin._isDestroyed !== true) {
        this.VideoPlayerPlugin.trackPause();
      }
    }
  }, {
    key: 'onPlaying',
    value: function onPlaying() {
      if (this.isFirstPlay && this.VideoPlayerPlugin) {
        this.VideoPlayerPlugin.trackSessionStart();
      }
      this.isFirstPlay = false;
      if (this.VideoPlayerPlugin) {
        this.VideoPlayerPlugin.trackPlay();
      }
    }
  }, {
    key: 'onSeeked',
    value: function onSeeked() {
      if (this.VideoPlayerPlugin) {
        this.VideoPlayerPlugin.trackSeekComplete();
      }
    }
  }, {
    key: 'onSeeking',
    value: function onSeeking() {
      if (this.VideoPlayerPlugin) {
        this.VideoPlayerPlugin.trackSeekStart();
      }
    }
  }, {
    key: 'initHeartbeat',
    value: function initHeartbeat() {
      var _this2 = this;

      var HBT = this;

      if (typeof HBT.ADB === 'undefined' || typeof window.s_md === 'undefined') {
        // eslint-disable-line
        return;
      }
      this.addContext();
      // Map values to make code readable;
      var _HBT$ADB$va = HBT.ADB.va,
          plugins = _HBT$ADB$va.plugins,
          HeartbeatDelegate = _HBT$ADB$va.HeartbeatDelegate,
          HeartbeatConfig = _HBT$ADB$va.HeartbeatConfig,
          Heartbeat = _HBT$ADB$va.Heartbeat,
          _plugins$aa = plugins.aa,
          AdobeAnalyticsPluginConfig = _plugins$aa.AdobeAnalyticsPluginConfig,
          AdobeAnalyticsPluginDelegate = _plugins$aa.AdobeAnalyticsPluginDelegate,
          AdobeAnalyticsPlugin = _plugins$aa.AdobeAnalyticsPlugin,
          _plugins$ah = plugins.ah,
          AdobeHeartbeatPluginConfig = _plugins$ah.AdobeHeartbeatPluginConfig,
          AdobeHeartbeatPluginDelegate = _plugins$ah.AdobeHeartbeatPluginDelegate,
          AdobeHeartbeatPlugin = _plugins$ah.AdobeHeartbeatPlugin,
          _plugins$videoplayer = plugins.videoplayer,
          VideoPlayerPluginConfig = _plugins$videoplayer.VideoPlayerPluginConfig,
          VideoPlayerPluginDelegate = _plugins$videoplayer.VideoPlayerPluginDelegate,
          VideoPlayerPlugin = _plugins$videoplayer.VideoPlayerPlugin,
          VideoInfo = _plugins$videoplayer.VideoInfo,
          ChapterInfo = _plugins$videoplayer.ChapterInfo;

      this.VideoPlayerPluginConfig = VideoPlayerPluginConfig;
      var analyticsPluginConfig = new AdobeAnalyticsPluginConfig(),
          analyticsPluginDelegate = new AdobeAnalyticsPluginDelegate(),
          analyticsPlugin = new AdobeAnalyticsPlugin(window.s_md, analyticsPluginDelegate),
          // eslint-disable-line

      heartbeatPluginConfig = new AdobeHeartbeatPluginConfig(document.location.protocol + '//webmd.hb.omtrdc.net', '16AD4362526701720A490D45@AdobeOrg'),
          heartbeatPluginDelegate = new AdobeHeartbeatPluginDelegate(),
          heartbeatPlugin = new AdobeHeartbeatPlugin(heartbeatPluginDelegate),
          heartbeatConfig = new HeartbeatConfig(),
          heartbeatDelegate = new HeartbeatDelegate(),
          videoPlayerPluginConfig = new VideoPlayerPluginConfig(),
          videoPlayerPluginDelegate = new VideoPlayerPluginDelegate(); // VideoStore.mediaApi._v.getMediaElement()

      var videoPlayerPlugin = new VideoPlayerPlugin(videoPlayerPluginDelegate);
      this.VideoPlayerPlugin = videoPlayerPlugin;

      this.analyticsPlugin = analyticsPlugin;
      this.videoPlayerPluginDelegate = videoPlayerPluginDelegate;

      analyticsPluginConfig.channel = window.s_md.prop47;
      heartbeatPluginConfig.sdk = 'Heartbeats V-1.5.7';
      heartbeatPluginConfig.ssl = document.location.protocol == 'https:';

      var doDebug = document.location.hostname.indexOf('localhost') > -1;
      doDebug = false;
      analyticsPluginConfig.debugLogging = doDebug;
      heartbeatPluginConfig.debugLogging = doDebug;
      heartbeatConfig.debugLogging = doDebug;
      videoPlayerPluginConfig.debugLogging = doDebug;
      heartbeatPluginConfig.quietMode = doDebug;

      var videoInfo = new VideoInfo();
      videoPlayerPluginDelegate.getVideoInfo = function () {
        if (videoPlayerPlugin["_isDestroyed"]) {
          return null;
        }
        var mediaElement = _this2.amp.getMediaElement();
        var duration = mediaElement.duration;
        var playhead = mediaElement.currentTime;
        var infoName = _this2.configId;
        var videoName = _this2.amp.config.media.title;

        videoInfo.id = infosite.config.tracking.productName + '/' + medscape.user.sfNumber + '/' + infoName;
        videoInfo.name = videoName;
        videoInfo.playerName = 'microsites video player';
        videoInfo.streamType = 'vod';
        videoInfo.length = duration ? duration : 0;
        videoInfo.playhead = playhead;
        return videoInfo;
      };

      /*
              videoPlayerPluginDelegate.getChapterInfo = () => {
                let mediaElement = HBT.mediaApi.getMediaElement();
                let chapterInfo = new ChapterInfo();
                chapterInfo.name = infoName;
                chapterInfo.startTime = 0;
                  chapterInfo.length = mediaElement.duration;
                  chapterInfo.position = mediaElement.currentTime;
                  return chapterInfo;
              };
      */
      // configure  plugins
      this.setVideoMetadata();
      heartbeatPlugin.configure(heartbeatPluginConfig);
      analyticsPlugin.configure(analyticsPluginConfig);
      this.VideoPlayerPlugin.configure(videoPlayerPluginConfig);
      this.heartbeat = new Heartbeat(heartbeatDelegate, [this.VideoPlayerPlugin, analyticsPlugin, heartbeatPlugin]);
      this.heartbeat.configure(heartbeatConfig);

      //window.heartbeat = this.heartbeat;
      var unloadEvent = document.pagehide ? 'pagehide' : 'beforeunload';
      $(window).on(unloadEvent, function () {
        _this2.unload();
      });
      this.removeContext();
    }
  }, {
    key: 'setVideoMetadata',
    value: function setVideoMetadata() {
      var s_md = window.s_md;
      /*
      s_md.pageName = (document.location.host.replace('www.', '') + document.location.pathname);
      s_md.eVar1 = (document.location.host.replace('www.', '') + document.location.pathname);
      s_md.pageURL = (document.location.href);
      s_md.prop7 = (document.location.pathname.substring(1));
      */
      var metaData = {
        vdname: this.amp.config.media.title,
        chn: s_md.contextData,
        rs: s_md.prop50 || '',
        site: s_md.prop3,
        topic: s_md.eVar4 || s_md.prop4 || '',
        dprofsn: s_md.prop19 || '',
        dspclty: s_md.prop38 || '',
        regid: s_md.prop47 || '',
        dcntry: s_md.prop37 || '',
        toolin: 'video - info',
        pageName: document.location.host.replace('www.', '') + document.location.pathname,
        extcampaign: typeof s_md.contextData['wb.ecd'] !== 'undefined' ? s_md.contextData['wb.ecd'] : ''
      };
      this.analyticsPlugin.setVideoMetadata(metaData);
    }
  }, {
    key: 'addContext',
    value: function addContext() {
      if (typeof window.addLinkTrackVars === 'undefined') {
        return;
      } else {
        window.addLinkTrackVars(ContextDataVars.toString());
      }
    }
  }, {
    key: 'removeContext',
    value: function removeContext() {
      if (typeof window.remLinkTrackVars === 'undefined') {
        return;
      } else {
        window.remLinkTrackVars(ContextDataVars.toString());
      }
    }
  }, {
    key: 'unload',
    value: function unload() {
      if (typeof this.VideoPlayerPlugin === 'undefined') {
        return;
      }
      if (this.VideoPlayerPlugin._isDestroyed === true) {
        return;
      }
      if (this.VideoPlayerPlugin._isTrackingSessionActive === true) {
        this.VideoPlayerPlugin.trackVideoUnload();
      }
      this.VideoPlayerPlugin.destroy();
      this.heartbeat.destroy();
      this.heartbeat = null;
    }
  }, {
    key: 'amp',
    get: function get() {
      return this._amp;
    },
    set: function set(amp) {
      this._amp = amp;
    }
  }, {
    key: 'mediaElement',
    get: function get() {
      if (this._mediaElement == null && this.amp != null) {
        this._mediaElement = this.amp.getMediaElement();
      }
      return this._mediaElement;
    },
    set: function set(el) {
      this._mediaElement = el;
    }
  }]);

  return VideoHeartbeat;
}(_reflux2.default.Store);

exports.default = VideoHeartbeat;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(385);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(878);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VideoElements = {};

var VideoPlayer = function VideoPlayer(config, $Videos, route) {
  _classCallCheck(this, VideoPlayer);

  $Videos.each(function (index, el) {
    var $el = (0, _jquery2.default)(el);
    var configId = $el.data('config-id');
    var playlistData = config.playlists.find(function (playlist) {
      return playlist['config-id'] == configId;
    });
    var videoId = playlistData == null || playlistData.videos.length == 0 ? configId : playlistData.videos[0]["video-config-id"];
    var videoData = config.videos.find(function (video) {
      return video['config-id'] == videoId;
    });
    if (!videoData) return;
    var props = {
      'index': index,
      'config-id': configId,
      'video': videoData,
      'playlist': playlistData,
      'videos': config.videos,
      'route': route
    };
    _reactDom2.default.render(_react2.default.createElement(_app2.default, props), el);
    $el.addClass('module-loaded');
  });
};

exports.default = VideoPlayer;

VideoPlayer.selector = '[data-module="VideoPlayer"]';
VideoPlayer.init = function (config, $Videos, route) {
  $Videos = $Videos || (0, _jquery2.default)(VideoPlayer.selector);
  if ($Videos.length > 0) {
    new VideoPlayer(config, $Videos, route);
  }
};
VideoPlayer.pause = function () {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  var $container = (0, _jquery2.default)(container);
  $container.find('video').each(function (index, videoEl) {
    videoEl.pause();
  });
};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _controlsActionsFactory = __webpack_require__(133);

var _controlsActionsFactory2 = _interopRequireDefault(_controlsActionsFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StoreCache = {};
/*
    ControlStore

    Manages the state of the Video player's controls.
*/

var ControlStore = function (_Reflux$Store) {
  _inherits(ControlStore, _Reflux$Store);

  function ControlStore(props) {
    _classCallCheck(this, ControlStore);

    var _this = _possibleConstructorReturn(this, (ControlStore.__proto__ || Object.getPrototypeOf(ControlStore)).call(this, props));

    _this.state = _this.getInitialState();
    _this.video = props["config-id"];
    _this.ControlsActions = _controlsActionsFactory2.default.get(props["config-id"], props.route);
    _this.listenables = [_this.ControlsActions];
    return _this;
  }

  _createClass(ControlStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        isReady: false,
        isPause: true,
        currentTime: 0,
        duration: 0,
        volume: 0,
        isFullscreen: false
      };
    }
  }, {
    key: 'onInit',
    value: function onInit(state) {
      this.setState(state);
    }
  }, {
    key: 'onSetPause',
    value: function onSetPause(flag) {
      this.setState({
        isPause: flag
      });
    }
  }, {
    key: 'onSetCurrentTime',
    value: function onSetCurrentTime(currentTime) {
      currentTime = isNaN(currentTime) ? this.state.currentTime : currentTime;
      this.setState({
        currentTime: currentTime
      });
    }
  }, {
    key: 'onSetDuration',
    value: function onSetDuration() {
      var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.duration;

      this.setState({
        duration: duration
      });
    }
  }, {
    key: 'onSetFullscreen',
    value: function onSetFullscreen() {
      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.setState({
        isFullscreen: flag
      });
    }
  }, {
    key: 'onSetVolume',
    value: function onSetVolume() {
      var volume = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.setState({
        volume: volume
      });
    }
  }, {
    key: 'onShow',
    value: function onShow() {
      this.setState({
        isReady: true
      });
    }
  }]);

  return ControlStore;
}(_reflux2.default.Store);

ControlStore.get = function (config, route) {
  var key = '' + route.location.pathname + config["config-id"];
  if (StoreCache[key] == null) {
    StoreCache[key] = new ControlStore(config);
  }
  return StoreCache[key];
};
ControlStore.clearCache = function () {
  Object.keys(StoreCache).forEach(function (key) {
    _controlsActionsFactory2.default.clearCache();
    delete StoreCache[key];
  });
};

exports.default = ControlStore;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _controls = __webpack_require__(386);

var _controls2 = _interopRequireDefault(_controls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _controls2.default;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _playlist = __webpack_require__(394);

var _playlist2 = _interopRequireDefault(_playlist);

__webpack_require__(309);

__webpack_require__(308);

__webpack_require__(877);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _playlist2.default;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _screenfull = __webpack_require__(307);

var _screenfull2 = _interopRequireDefault(_screenfull);

var _controlsActionsFactory = __webpack_require__(133);

var _controlsActionsFactory2 = _interopRequireDefault(_controlsActionsFactory);

var _videoActionsFactory = __webpack_require__(134);

var _videoActionsFactory2 = _interopRequireDefault(_videoActionsFactory);

var _videoEvents = __webpack_require__(204);

var _videoEvents2 = _interopRequireDefault(_videoEvents);

var _ampPlayerEvents = __webpack_require__(203);

var _ampPlayerEvents2 = _interopRequireDefault(_ampPlayerEvents);

var _settings = __webpack_require__(103);

var _settings2 = _interopRequireDefault(_settings);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _lodash = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
    VideoStore
    Manages and delegates the events triggered by the media's <video> element object
    and the actions from the player's controls.
    Sets the state to the Akamai's AMP media config JSON object.
    Uses akamai's AMP media api to determine the what the player's controls state should be.
*/
var VideoStore = function (_Reflux$Store) {
  _inherits(VideoStore, _Reflux$Store);

  function VideoStore(config, route) {
    _classCallCheck(this, VideoStore);

    var _this = _possibleConstructorReturn(this, (VideoStore.__proto__ || Object.getPrototypeOf(VideoStore)).call(this));

    _this.VideoActions = _videoActionsFactory2.default.get(config["config-id"], route);
    _this.ControlsActions = _controlsActionsFactory2.default.get(config["config-id"], route);
    _this.config = config;
    _this.isVolumechange = false;
    _this.listenables = [_this.VideoActions, _this.ControlsActions];
    return _this;
  }

  _createClass(VideoStore, [{
    key: 'onInit',
    value: function onInit() {}
  }, {
    key: 'onDestroy',
    value: function onDestroy() {
      var _this2 = this;

      var mediaElement = this.mediaApi.getMediaElement();
      var $mediaElement = (0, _jquery2.default)(mediaElement);
      $mediaElement.off('click.video');
      $mediaElement.off('tap.video');
      (0, _jquery2.default)(document).off(_screenfull2.default.raw.fullscreenchange);
      _videoEvents2.default.forEach(function (videoEvent) {
        var videoEventName = videoEvent + '.VideoStore';
        $mediaElement.off(videoEventName).on(videoEventName, function () {
          _this2.VideoActions[videoEvent]();
        });
      });
      this.mediaApi.destroy();
    }
  }, {
    key: 'onReady',
    value: function onReady(mediaApi) {
      var _this3 = this;

      var mediaElement = mediaApi.getMediaElement();
      var $mediaElement = (0, _jquery2.default)(mediaElement);
      this.mediaApi = mediaApi;
      this.mediaElement = mediaElement;
      window.mediaApi = mediaApi;
      this.$mediaElement = $mediaElement;
      _videoEvents2.default.forEach(function (videoEvent) {
        var videoEventName = videoEvent + '.VideoStore';
        $mediaElement.off(videoEventName).on(videoEventName, function () {
          _this3.VideoActions[videoEvent](mediaApi);
        });
      });
      if (!_utils2.default.isMobile()) {
        _ampPlayerEvents2.default.forEach(function (playerEvent) {
          if (playerEvent === 'fullscreenchange' && _utils2.default.isIEorEDGE() && !_utils2.default.isEdge()) {
            if (!_utils2.default.isMobile() && _screenfull2.default.raw.fullscreenchange) {
              (0, _jquery2.default)(document).on(_screenfull2.default.raw.fullscreenchange, function (e) {
                if (document.msFullscreenElement == null) {
                  _this3.VideoActions[playerEvent](mediaApi);
                  _this3.mediaApi.exitFullScreen();
                } else {
                  _this3.VideoActions[playerEvent](mediaApi);
                  _this3.mediaApi.enterFullScreen();
                }
              });
            }
          } else {
            _this3.mediaApi.addEventListener(playerEvent, function () {
              _this3.VideoActions[playerEvent](mediaApi);
            });
          }
        });
      }
      this.ControlsActions.show();
    }
  }, {
    key: 'onSetMedia',
    value: function onSetMedia(video) {}
    /* Listeners for the Controls */

  }, {
    key: 'onTogglePlayPause',
    value: function onTogglePlayPause() {
      if (this.mediaElement.currentTime === 0 || this.mediaElement.paused) {
        this.mediaApi.play();
      } else {
        this.mediaApi.pause();
      }
    }
  }, {
    key: 'onChangeCurrentTime',
    value: function onChangeCurrentTime(currentTime) {
      this.mediaElement.currentTime = currentTime;
      this.mediaApi.setCurrentTime(currentTime);
      this.ControlsActions.setCurrentTime(this.mediaElement.currentTime);
    }
  }, {
    key: 'onChangeVolume',
    value: function onChangeVolume(volume) {
      this.mediaApi.setVolume(volume);
    }
  }, {
    key: 'onDestroy',
    value: function onDestroy() {
      this.stopListeningToAll();
      this.mediaApi.destroy();
    }
  }, {
    key: 'onEnded',
    value: function onEnded() {
      //this.ControlsActions.setPause(true);
      this.mediaApi.end();
      this.mediaApi.setCurrentTime(0);
    }
  }, {
    key: 'onToggleMute',
    value: function onToggleMute() {
      var flag = !this.mediaApi.getMuted();
      this.mediaApi.setMuted(flag);
    }
    /* Listeners for the Video */

  }, {
    key: 'onDurationchange',
    value: function onDurationchange() {
      this.ControlsActions.setDuration(this.mediaElement.duration);
    }
  }, {
    key: 'onLoadeddata',
    value: function onLoadeddata() {
      var data = {
        currentTime: this.mediaElement.currentTime,
        duration: this.mediaElement.duration,
        isReady: true
      };
      this.ControlsActions.init(data);
      this.ControlsActions.setPause(true);
    }
  }, {
    key: 'onLoadedmetadata',
    value: function onLoadedmetadata() {
      this.state.isEnded = false;
    }
  }, {
    key: 'onPause',
    value: function onPause() {
      this.ControlsActions.setPause(true);
    }
  }, {
    key: 'onPlay',
    value: function onPlay() {
      this.ControlsActions.setPause(false);
    }
  }, {
    key: 'onPlaying',
    value: function onPlaying() {
      this.ControlsActions.setPause(false);
    }
  }, {
    key: 'onSeeking',
    value: function onSeeking() {
      this.ControlsActions.setCurrentTime(this.mediaElement.currentTime);
    }
  }, {
    key: 'onToggleFullscreen',
    value: function onToggleFullscreen() {
      if (this.mediaApi.displayState != "full-screen") {
        this.mediaApi.enterFullScreen();
      } else if (this.mediaApi.displayState == "full-screen") {
        this.mediaApi.exitFullScreen();
      }
    }
  }, {
    key: 'onVolumechange',
    value: function onVolumechange() {
      this.ControlsActions.setVolume(this.mediaApi.getVolume());
    }
  }, {
    key: 'onMutechange',
    value: function onMutechange() {}
  }, {
    key: 'onTimeupdate',
    value: function onTimeupdate() {
      if (this.mediaElement) {
        this.ControlsActions.setCurrentTime(this.mediaElement.currentTime);
      }
    }
  }]);

  return VideoStore;
}(_reflux2.default.Store);

var StoreCache = {};

VideoStore.get = function (config, route) {
  var key = '' + route.location.pathname + config["config-id"];
  if (StoreCache[key] == null) {
    StoreCache[key] = new VideoStore(config, route);
    StoreCache[key].timeStamp = Date.now();
  }
  return StoreCache[key];
};
VideoStore.clearCache = function () {
  Object.keys(StoreCache).forEach(function (key) {
    _videoActionsFactory2.default.clearCache();
    delete StoreCache[key];
  });
};

exports.default = VideoStore;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _md = __webpack_require__(713);

var _md2 = _interopRequireDefault(_md);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _lodash = __webpack_require__(42);

var _videoActionsFactory = __webpack_require__(134);

var _videoActionsFactory2 = _interopRequireDefault(_videoActionsFactory);

var _screenfull = __webpack_require__(307);

var _screenfull2 = _interopRequireDefault(_screenfull);

var _settings = __webpack_require__(103);

var _settings2 = _interopRequireDefault(_settings);

var _heartbeatTracking = __webpack_require__(338);

var _heartbeatTracking2 = _interopRequireDefault(_heartbeatTracking);

var _cp = __webpack_require__(202);

var _cp2 = _interopRequireDefault(_cp);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import sa from 'medscape/tracking/sa';


/*
    VideoTrackingStore

    Listens to the <video> object events and triggers Omniture's api.
*/
var omniPagenameDefault = window.location.href.split('://')[1].split('?')[0].split('#')[0].replace('www.', ''),
    pamProductName = '',
    activityId = infosite.config.tracking.CP.activityId,
    omnitureEnable = true,
    promiseTimeout = function promiseTimeout(VTStore) {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      if (VTStore.isSeeking === true) {
        reject();
      } else {
        resolve();
      }
      VTStore.isSeeking = false;
    }, 100);
  });
};
var StoreCache = {};

var VideoTrackingStore = function (_Reflux$Store) {
  _inherits(VideoTrackingStore, _Reflux$Store);

  function VideoTrackingStore(config, route) {
    _classCallCheck(this, VideoTrackingStore);

    var _this = _possibleConstructorReturn(this, (VideoTrackingStore.__proto__ || Object.getPrototypeOf(VideoTrackingStore)).call(this));

    var VideoActions = _videoActionsFactory2.default.get(config["config-id"], route);
    _this.route = route;
    _this.listenables = [VideoActions];
    _this._mediaApi = null;
    _this._mediaElement = null;
    _this.config = config;
    _this.configId = config["config-id"];
    _this._VideoHeartbeat = null;
    _this.settings = new _settings2.default(config);
    _this.state = _this.getInitialState();
    _this.state.slide = '';
    _this.scrubCall = (0, _lodash.throttle)(function (videoId) {
      _this.pamTrack('vidsvp-' + videoId + '_scrb');
    }, 500, {
      'leading': false,
      'trailing': true
    });
    return _this;
  }

  _createClass(VideoTrackingStore, [{
    key: 'onReady',
    value: function onReady(mediaApi) {
      var _this2 = this;

      var videoId = this.configId;
      var mediaElement = mediaApi.getMediaElement();
      this.mediaApi = mediaApi;
      this.mediaElement = mediaElement;
      this.$mediaElement = (0, _jquery2.default)(mediaElement);
      this.resetDurationTracking();
      (0, _jquery2.default)(mediaElement).on('webkitfullscreenchange mozfullscreenchange fullscreenchange webkitbeginfullscreen webkitendfullscreen MSFullscreenChange', function (e) {
        var isFullScreen = e.type == "webkitbeginfullscreen" || document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
        _this2.onMobileFullscreenchange(isFullScreen);
      });
    }
  }, {
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        isPause: true,
        hasStarted: false,
        hasEnded: false,
        isStartOrReplay: false,
        isFirstPlay: true,
        video_completed: false,
        isMuted: false,
        isFullscreen: false,
        slide: 'SLIDE',
        scene: 'scene'
      };
    }
  }, {
    key: 'onChangeCurrentTime',
    value: function onChangeCurrentTime() {}
  }, {
    key: 'onAbort',
    value: function onAbort() {}
  }, {
    key: 'onCanplay',
    value: function onCanplay() {}
  }, {
    key: 'onCanplaythrough',
    value: function onCanplaythrough() {}
  }, {
    key: 'onDurationchange',
    value: function onDurationchange() {}
  }, {
    key: 'onEmptied',
    value: function onEmptied() {}
  }, {
    key: 'onEnded',
    value: function onEnded() {
      if (Math.floor(this.mediaElement.currentTime) === 0) {
        return;
      }
      if (this.state.hasEnded === false) {
        this.state.hasEnded = true;
        this.state.video_completed = true;
        var prop9_org = s_md.prop9,
            videoId = this.tempVideoId;
        s_md.prop9 = videoId + '-allvideo_100pct';
        addLinkTrackVars('prop9');
        this.pamTrack('vidsvp-' + videoId + '_100pct');
        remLinkTrackVars('prop9');
        s_md.prop9 = prop9_org;
      }
    }
  }, {
    key: 'onError',
    value: function onError() {}
  }, {
    key: 'onFullscreenchange',
    value: function onFullscreenchange() {
      var videoId = this.configId;
      var size = this.mediaApi.displayState === "full-screen" ? "bigr" : "smalr";
      this.pamTrack('vidsvp-' + videoId + '_' + size);
      this.state.isFullscreen = _screenfull2.default.isFullscreen;
    }
  }, {
    key: 'onMobileFullscreenchange',
    value: function onMobileFullscreenchange(isFullScreen) {
      var _this3 = this;

      var videoId = this.configId;
      if (isFullScreen) {
        this.pamTrack('vidsvp-' + videoId + '_bigr');
      } else {
        this.pamTrack('vidsvp-' + videoId + '_smalr');
        if (_utils2.default.isMobile() || window.medscape.isMobile) {
          this.mediaElement.controls = true;
          setTimeout(function () {
            _this3.mediaElement.controls = true;
          }, 500);
        }
      }
    }
  }, {
    key: 'onLoadeddata',
    value: function onLoadeddata() {
      this.state = this.getInitialState();
      this.resetDurationTracking();
    }
  }, {
    key: 'onLoadedmetadata',
    value: function onLoadedmetadata() {
      this.configId = this.mediaApi.media.metadata.videoId;
      this.state.hasEnded = false;
    }
  }, {
    key: 'onLoadStart',
    value: function onLoadStart() {}
  }, {
    key: 'onPause',
    value: function onPause() {
      var _this4 = this;

      if (this.state.isPause) {
        return;
      }
      this.state.isPause = true;
      var videoId = this.configId;
      if (_utils2.default.isMobile() && _utils2.default.isIOS()) {
        promiseTimeout(this).then(function (response) {
          _this4.pamTrack('vidsvp-' + videoId + '_pause');
        }, function (response) {
          _this4.isSeeking = false;
        });
      } else {
        this.pamTrack('vidsvp-' + videoId + '_pause');
      }
    }
  }, {
    key: 'onPlay',
    value: function onPlay() {}
  }, {
    key: 'onPlaying',
    value: function onPlaying() {
      if (!this.state.isPause) {
        return;
      }
      var videoId = this.configId;
      if (!this.state.hasStarted || this.state.hasEnded) {
        var prop9_org = s_md.prop9;
        s_md.prop9 = videoId + '-allvideo_start';
        addLinkTrackVars('prop9');
        this.pamTrack('vidsvp-' + videoId + '_start');
        remLinkTrackVars('prop9');
        s_md.prop9 = prop9_org;
      }
      if (_utils2.default.isMobile() && _utils2.default.isIOS()) {
        if (this.isSeeking === false || typeof this.isSeeking === 'undefined') {
          this.pamTrack('vidsvp-' + videoId + '_play');
        }
      } else {
        this.pamTrack('vidsvp-' + videoId + '_play');
      }
      this.state.isPause = false;
      this.state.video_completed = false;
      this.state.hasStarted = true;
      this.state.hasEnded = false;
      //this.trackStartOrReplay();
      this.state.isFirstPlay = false;
    }
  }, {
    key: 'onProgress',
    value: function onProgress() {}
  }, {
    key: 'onRatechange',
    value: function onRatechange() {}
  }, {
    key: 'onSeeked',
    value: function onSeeked() {
      var videoId = this.configId;
      if (!this.state.hasEnded && !this.state.video_completed && !this.state.isFirstPlay) {
        if (Math.floor(this.mediaElement.currentTime) !== 0) {
          this.scrubCall(videoId);
        }
      }
    }
  }, {
    key: 'onSeeking',
    value: function onSeeking() {
      var _this5 = this;

      if (this.seekingTimeout !== null) {
        clearTimeout(this.seekingTimeout);
        this.seekingTimeout = null;
      }
      this.seekingTimeout = setTimeout(function () {
        _this5.isSeeking = false;
        _this5.seekingTimeout = null;
      }, 500);
      this.isSeeking = true;
    }
  }, {
    key: 'onStalled',
    value: function onStalled() {}
  }, {
    key: 'onSuspend',
    value: function onSuspend() {}
  }, {
    key: 'onTimeupdate',
    value: function onTimeupdate() {
      var _this6 = this;

      if (this.mediaElement == null || this.percentages == null || this.percentages.length == 0) {
        return;
      }
      var percent = this.mediaElement.currentTime / this.mediaElement.duration * 100;
      var percentages = this.percentages;
      percentages.forEach(function (trackPercentage) {
        if (percent >= trackPercentage.value && trackPercentage.isTracked == false) {
          var videoId = _this6.configId;
          _this6.tempVideoId = _this6.configId;
          _this6.pamTrack('vidsvp-' + videoId + '_' + trackPercentage.value + 'pct', _this6.mediaElement);
          trackPercentage.isTracked = true;
          _this6.percentages = percentages.filter(function (tracking) {
            return tracking.isTracked == false;
          });
        }
      });
    }
  }, {
    key: 'onVolumechange',
    value: function onVolumechange() {
      if (!window.medscape.isMobile) {
        return;
      }
      if (this.mediaElement == null) {
        return;
      }
      var videoId = this.configId;
      if (this.mediaElement.muted) {
        this.state.isMuted = true;
        this.pamTrack('vidsvp-' + videoId + '_mute');
      } else {
        this.state.isMuted = false;
        this.pamTrack('vidsvp-' + videoId + '_mutex');
      }
    }
  }, {
    key: 'onMutechange',
    value: function onMutechange() {
      if (window.medscape.isMobile) {
        return;
      }
      if (!this.mediaElement) {
        return;
      }
      var videoId = this.configId;
      if (this.mediaElement.muted) {
        this.pamTrack('vidsvp-' + videoId + '_mute');
      } else {
        this.pamTrack('vidsvp-' + videoId + '_mutex');
      }
    }
  }, {
    key: 'onWaiting',
    value: function onWaiting() {
      var ie = window.navigator.userAgent.indexOf("MSIE ");
      var videoId = this.configId;
      if (ie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        this.pamTrack('vidsvp-' + videoId + '_rep');
        this.pamTrack('vidsvp-' + videoId + '_videostart');
        this.pamTrack('vidsvp-' + videoId + '_play');
      }
    }
  }, {
    key: 'resetDurationTracking',
    value: function resetDurationTracking() {
      this.percentages = [{
        value: 25,
        isTracked: false
      }, {
        value: 50,
        isTracked: false
      }, {
        value: 75,
        isTracked: false
      }];
    }
  }, {
    key: 'trackStartOrReplay',
    value: function trackStartOrReplay() {
      var videoId = this.configId;
      var isMobile = window.medscape.isMobile;
      var isStartOrReplay = !this.state.hasStarted || this.state.hasEnded;
      if (typeof window.brandAdvance2 == 'undefined') {
        var cur_slide = this.$mediaElement.parents('[data-slide]').data('slide');
        this.state.scene = cur_slide;
        this.state.slide = 'SLIDE' + cur_slide;
      } else {
        var cur_scene = this.$mediaElement.parents('[data-scene]').data('scene');
        this.state.scene = cur_scene;
        this.state.slide = 'scene-' + cur_scene;
      }
      if (!this.state.hasStarted) {
        this.pamTrack('vidsvp-' + videoId + '_play');
      }
      if ((isMobile || this.state.isStartOrReplay) && this.state.hasEnded) {
        this.state.video_completed = true;
        this.pamTrack('vidsvp-' + videoId + '_rep');
      }
      if (this.state.isStartOrReplay) {
        var prop9_org = s_md.prop9;
        s_md.prop9 = 'allvideo_start';
        addLinkTrackVars('prop9');
        this.pamTrack('vidsvp-' + videoId + '_start');
        remLinkTrackVars('prop9');
        s_md.prop9 = prop9_org;
        this.resetDurationTracking();
      }
    }
  }, {
    key: 'pamTrack',
    value: function pamTrack(trackingCode) {
      _tracking2.default.track(trackingCode, this.mediaElement);
    }
  }, {
    key: 'mediaElement',
    get: function get() {
      if (this._mediaElement == null && this.mediaApi != null) {
        this._mediaElement = this.mediaApi.getMediaElement();
      }
      return this._mediaElement;
    },
    set: function set(el) {
      this._mediaElement = el;
    }
  }, {
    key: 'VideoHeartbeat',
    get: function get() {
      if (this._VideoHeartbeat == null) {
        var VideoActions = _videoActionsFactory2.default.get(this.configId, this.route);
        this._VideoHeartbeat = new _heartbeatTracking2.default(this.config, VideoActions);
      }
      return this._VideoHeartbeat;
    }
  }, {
    key: 'mediaApi',
    get: function get() {
      return this._mediaApi;
    },
    set: function set(api) {
      this.VideoHeartbeat.amp = api;
      this.mediaElement;
      this._mediaApi = api;
    }
  }]);

  return VideoTrackingStore;
}(_reflux2.default.Store);

;

VideoTrackingStore.get = function (config, route) {
  var key = '' + config["config-id"] + route.location.pathname;
  if (StoreCache[key] == null) {
    StoreCache[key] = new VideoTrackingStore(config, route);
  }
  return StoreCache[key];
};
VideoTrackingStore.clearCache = function () {
  Object.keys(StoreCache).forEach(function (key) {
    _videoActionsFactory2.default.clearCache();
    delete StoreCache[key];
  });
};

exports.default = VideoTrackingStore;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(399);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(880);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdditionalResourcesModule = function AdditionalResourcesModule(config, $modules) {
  _classCallCheck(this, AdditionalResourcesModule);

  $modules.each(function (index, el) {
    var $el = (0, _jquery2.default)(el);
    if ($el.hasClass('module-loaded')) {
      return;
    }
    var configId = $el.data('config-id');
    var moduleData = config.find(function (data) {
      return data['config-id'] == configId;
    });
    if (!moduleData) return;
    var props = moduleData;
    _reactDom2.default.render(_react2.default.createElement(_app2.default, props), el);
    $el.addClass('module-loaded');
  });
};

exports.default = AdditionalResourcesModule;


AdditionalResourcesModule.selector = '[data-module="AdditionalResources"]';
AdditionalResourcesModule.init = function (config, $modules) {
  $modules = (0, _jquery2.default)(AdditionalResourcesModule.selector);
  if ($modules.length > 0) {
    new AdditionalResourcesModule(config, $modules);
  }
};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _slideActionsFactory = __webpack_require__(205);

var _slideActionsFactory2 = _interopRequireDefault(_slideActionsFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CarouselTrackingStore = function (_Reflux$Store) {
    _inherits(CarouselTrackingStore, _Reflux$Store);

    function CarouselTrackingStore(props) {
        _classCallCheck(this, CarouselTrackingStore);

        var _this = _possibleConstructorReturn(this, (CarouselTrackingStore.__proto__ || Object.getPrototypeOf(CarouselTrackingStore)).call(this));

        _this.props = props;
        _this.state = _this.getInitialState();
        _this.listenables = _slideActionsFactory2.default.get(props["config-id"]);
        _this.track();
        return _this;
    }

    _createClass(CarouselTrackingStore, [{
        key: 'getInitialState',
        value: function getInitialState() {
            return {
                index: this.props.settings && this.props.settings.initialSlide ? this.props.settings.initialSlide : 0
            };
        }
    }, {
        key: 'afterChange',
        value: function afterChange(index) {
            this.state.index = index;
            this.track();
        }
    }, {
        key: 'toggleLinks',
        value: function toggleLinks() {
            if ((0, _jquery2.default)(".links-link.active").length > 0) {} else {
                var configId = this.props["config-id"];
                var trackingValue = 'carousel-' + configId + '_links';
                _tracking2.default.track(trackingValue);
            }
        }
    }, {
        key: 'toggleNotes',
        value: function toggleNotes() {
            if ((0, _jquery2.default)(".notes-link.active").length > 0) {} else {
                var index = this.state.index;
                var configId = this.props["config-id"];
                var slideId = this.props.slides[index].slideId;
                var slideIndex = index < 9 ? 's0' + (index + 1) : 's' + (index + 1);
                var trackingValue = 'carousel-' + configId + '-' + slideId + '_note';
                _tracking2.default.track(trackingValue);
            }
        }
    }, {
        key: 'track',
        value: function track() {
            var index = this.state.index;
            var configId = this.props["config-id"];
            var slideId = this.props.slides[index].slideId;
            var slideIndex = index < 9 ? 's0' + (index + 1) : 's' + (index + 1);
            var trackingValue = 'carousel-' + configId + '-' + slideId;
            if (this.props.settings.slidesToShow === 1) {
                _tracking2.default.track(trackingValue);
            };
        }
    }]);

    return CarouselTrackingStore;
}(_reflux2.default.Store);

exports.default = CarouselTrackingStore;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(400);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(309);

__webpack_require__(308);

__webpack_require__(881);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CarouselModule = function CarouselModule(config, $modules) {
	_classCallCheck(this, CarouselModule);

	$modules.each(function (index, el) {
		var $el = (0, _jquery2.default)(el);
		if ($el.hasClass('module-loaded')) {
			return;
		}
		var configId = $el.data('config-id');
		var moduleData = config.find(function (data) {
			return data['config-id'] == configId;
		});
		if (!moduleData) return;
		if (window.medscape.isMobile) {
			moduleData.settings.slidesToShow = 1;
			moduleData.settings.slidesToScroll = 1;
			moduleData.settings.swipeToSlide = true;
		}
		var props = {
			config: moduleData
		};
		_reactDom2.default.render(_react2.default.createElement(_app2.default, props), el);
		$el.addClass('module-loaded');
	});
};

exports.default = CarouselModule;

CarouselModule.selector = '[data-module="Carousel"]';
CarouselModule.init = function (config, $modules) {
	$modules = $modules || (0, _jquery2.default)(CarouselModule.selector);
	if ($modules.length > 0) {
		new CarouselModule(config, $modules);
	}
};

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import Actions from './slide-actions';

var SlideStore = function (_Reflux$Store) {
    _inherits(SlideStore, _Reflux$Store);

    function SlideStore(props) {
        _classCallCheck(this, SlideStore);

        var _this = _possibleConstructorReturn(this, (SlideStore.__proto__ || Object.getPrototypeOf(SlideStore)).call(this));

        _this.state = _this.getInitialState();
        _this.props = props;
        _this.listenables = props.SlideActions;
        return _this;
    }

    _createClass(SlideStore, [{
        key: 'getInitialState',
        value: function getInitialState() {
            return {
                showNotes: false,
                showLinks: false
            };
        }
    }, {
        key: 'afterChange',
        value: function afterChange(index) {}
    }, {
        key: 'beforeChange',
        value: function beforeChange(currIndex, nextIndex) {
            this.setState({
                showLinks: false,
                showNotes: false
            });
        }
    }, {
        key: 'onToggleNotes',
        value: function onToggleNotes(index) {
            var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !this.state.showNotes;

            if (this.props.index == index) {
                this.setState({
                    showLinks: false,
                    showNotes: flag
                });
            }
        }
    }, {
        key: 'onToggleLinks',
        value: function onToggleLinks() {
            var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.state.showLinks;

            this.setState({
                showNotes: false,
                showLinks: flag
            });
        }
    }]);

    return SlideStore;
}(_reflux2.default.Store);

exports.default = SlideStore;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(405);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(882);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ConsultModule = function ConsultModule(config, $modules) {
	_classCallCheck(this, ConsultModule);

	if (!config) {
		console.warn("Consult module requires config");
		return;
	}
	var props = {
		title: config.title,
		items: config.items
	};
	$modules.each(function (index, el) {
		_reactDom2.default.render(_react2.default.createElement(_app2.default, props), el);
		(0, _jquery2.default)(el).data('module', '');
	});
};

exports.default = ConsultModule;


ConsultModule.init = function (config, $modules) {
	$modules = $modules || (0, _jquery2.default)('[data-module="ConsultAd"]');
	if ($modules.length > 0) {
		new ConsultModule(config, $modules);
	}
};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(209);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(310);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IsiModule = function IsiModule(config, $modules) {
	_classCallCheck(this, IsiModule);

	var _config = _jquery2.default.extend({}, config, true);
	var pagePosition = _jquery2.default.extend({}, _config["page-position"]);
	$modules.each(function (index, el) {
		var $module = (0, _jquery2.default)(el);
		if ($module.hasClass('module-loaded')) {
			return;
		}
		var isInline = true;
		if (window.medscape.isMobile) {
			isInline = $module.data("mobile-display") ? $module.data("mobile-display") != "toggle" : true;
		} else {
			isInline = $module.data("desktop-display") ? $module.data("desktop-display") != "toggle" : true;
		}
		var props = {
			config: _config,
			isInline: isInline
		};

		_reactDom2.default.render(_react2.default.createElement(_app2.default, props), el);
		$module.addClass('module-loaded');
	});
};

exports.default = IsiModule;

IsiModule.selector = '[data-module="ISI"]';
IsiModule.init = function (config, route, $module) {
	$module = $module || (0, _jquery2.default)(IsiModule.selector);
	if ($module.length > 0) {
		new IsiModule(config, $module);
	}
};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _actions = __webpack_require__(91);

var _actions2 = _interopRequireDefault(_actions);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IsiLink = function IsiLink(config, $link) {
	_classCallCheck(this, IsiLink);

	var el = $link[0];
	$link.off('click.IsiLink').on('click.IsiLink', function (e) {
		e.preventDefault();
		_tracking2.default.pageLink("isi-link", e.currentTarget);
		_actions2.default.linkClick();
	});
};

exports.default = IsiLink;

IsiLink.selector = '[data-module="IsiLink"]';
IsiLink.init = function (config, $link) {
	$link = $link || (0, _jquery2.default)(IsiLink.selector);
	if ($link.length > 0) {
		new IsiLink(config, $link);
	}
};

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _actions = __webpack_require__(91);

var _actions2 = _interopRequireDefault(_actions);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContentCache = {};
var isFirstVisit = true;
var isAccepted = false;
var isStickyVisible = false;

var IsiStore = function (_Reflux$Store) {
    _inherits(IsiStore, _Reflux$Store);

    function IsiStore(props) {
        _classCallCheck(this, IsiStore);

        var _this = _possibleConstructorReturn(this, (IsiStore.__proto__ || Object.getPrototypeOf(IsiStore)).call(this));

        _this.props = props;
        _this.state = _this.getInitialState();
        if (isFirstVisit && props.isSticky) {
            _this.state.isExpanded = props.isExpanded;
            isFirstVisit = false;
        }
        if (props.isSticky && props.config.isExpanded && props.config.collapseEvent.acceptButton && !isAccepted) {
            _this.state.isVisible = true;
            _this.state.isExpanded = true;
        }
        _this.state.isAutoScroll = props.config.isAutoScroll;
        _this.listenables = [_actions2.default];
        return _this;
    }

    _createClass(IsiStore, [{
        key: 'getInitialState',
        value: function getInitialState() {
            return {
                content: '',
                isExpanded: false,
                scrollTo: false,
                isVisible: true,
                isAccepted: isAccepted,
                isAutoScroll: false,
                isTimerFinished: false
            };
        }
    }, {
        key: 'onGetContentCompleted',
        value: function onGetContentCompleted(content) {
            //const path = props.config.path;
            if (!content) {
                return;
            }

            this.setState({
                content: content
            });
        }
    }, {
        key: 'onGetContentFailed',
        value: function onGetContentFailed(response) {
            //const path = props.config.path;
            console.error("Get ISI Content Error: ", response);
        }
    }, {
        key: 'onAccept',
        value: function onAccept() {
            isAccepted = true;
            if (!this.state.isExpanded) {
                _tracking2.default.pageLink("isi_accept");
            }
            this.setState({
                isAccepted: true,
                isExpanded: false,
                isAutoScroll: false
            });
        }
    }, {
        key: 'onToggle',
        value: function onToggle() {
            var isExpanded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.state.isExpanded;

            if (this.props.isSticky && this.state.isVisible) {
                var tracking = isExpanded ? "expand" : "collapse";
                if (!isExpanded && !this.state.isExpanded) {} else {
                    _tracking2.default.pageLink('isi_' + tracking);
                }
            }
            this.setState({
                isExpanded: isExpanded,
                isTimerFinished: true,
                isAccepted: true,
                isAutoScroll: false
            });
        }
    }, {
        key: 'onToggleAutoScroll',
        value: function onToggleAutoScroll() {
            var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.state.isAutoScroll;

            this.setState({
                isAutoScroll: flag
            });
        }
    }, {
        key: 'onToggleSticky',
        value: function onToggleSticky() {
            var isVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.state.isVisible;

            isStickyVisible = isVisible;
            if (this.props.isSticky) {
                this.setState({
                    isVisible: isVisible
                });
            }
        }
    }, {
        key: 'onLinkClick',
        value: function onLinkClick() {
            if (isStickyVisible) {
                this.setState({
                    isExpanded: true,
                    scrollTo: false
                });
            } else {
                this.setState({
                    isExpanded: false,
                    scrollTo: true
                });
            }
        }
    }]);

    return IsiStore;
}(_reflux2.default.Store);

exports.default = IsiStore;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(407);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(883);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MobileMenu = function MobileMenu(config, route, $module) {
	_classCallCheck(this, MobileMenu);

	var el = $module[0];

	var props = {
		navigation: config,
		route: route
	};
	_reactDom2.default.render(_react2.default.createElement(_app2.default, props), el);
};

exports.default = MobileMenu;


MobileMenu.init = function (config, route, $module) {
	$module = $module || (0, _jquery2.default)('[data-module="MobileMenu"]');
	if ($module.length > 0) {
		new MobileMenu(config, route, $module);
	}
};

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(414);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(885);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PageContent = function PageContent(PageConfig, NavigationConfig, IsiConfig, $module) {
	_classCallCheck(this, PageContent);

	var el = $module[0];
	var props = {
		isi: IsiConfig,
		pages: PageConfig,
		navigation: NavigationConfig
	};
	_reactDom2.default.render(_react2.default.createElement(_app2.default, props), el);
};

exports.default = PageContent;


PageContent.init = function (PageConfig, NavigationConfig, IsiConfig, $module) {
	$module = $module || (0, _jquery2.default)('[data-module="PageContent"]');
	if ($module.length > 0) {
		new PageContent(PageConfig, NavigationConfig, IsiConfig, $module);
	}
};

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _metaTags = __webpack_require__(416);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var metaDataTagsModule = null;

var MetaDataTagsModule = function MetaDataTagsModule() {
  _classCallCheck(this, MetaDataTagsModule);

  var titleEl = document.createElement('div');
  var descriptionEl = document.createElement('div');
  _reactDom2.default.render(_react2.default.createElement(_metaTags.MetaDescriptionTag), descriptionEl);
  _reactDom2.default.render(_react2.default.createElement(_metaTags.MetaTitleTag), titleEl);
};

exports.default = MetaDataTagsModule;


MetaDataTagsModule.init = function (config, $modules) {

  if (metaDataTagsModule == null) {
    metaDataTagsModule = new MetaDataTagsModule();
  }
};

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MetaDataStore = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _actions = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MetaDataStore = exports.MetaDataStore = function (_Reflux$Store) {
    _inherits(MetaDataStore, _Reflux$Store);

    function MetaDataStore() {
        _classCallCheck(this, MetaDataStore);

        var _this = _possibleConstructorReturn(this, (MetaDataStore.__proto__ || Object.getPrototypeOf(MetaDataStore)).call(this));

        _this.state = _this.getInitialState();
        _this.listenables = [_actions.MetaDataActions];
        return _this;
    }

    _createClass(MetaDataStore, [{
        key: 'getInitialState',
        value: function getInitialState() {
            return {
                description: '',
                titleTag: ''
            };
        }
    }, {
        key: 'onSetTitle',
        value: function onSetTitle() {
            var titleTag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            this.setState({
                titleTag: titleTag
            });
        }
    }, {
        key: 'onSetDescription',
        value: function onSetDescription() {
            var description = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            this.setState({
                description: description
            });
        }
    }]);

    return MetaDataStore;
}(_reflux2.default.Store);

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(418);

var _app2 = _interopRequireDefault(_app);

__webpack_require__(886);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResourcesModule = function ResourcesModule(config, $modules) {
	_classCallCheck(this, ResourcesModule);

	$modules.each(function (index, el) {
		var $el = (0, _jquery2.default)(el);
		if ($el.hasClass('module-loaded')) {
			return;
		}
		var configId = $el.data('config-id');
		var moduleData = config.find(function (data) {
			return data['config-id'] == configId;
		});

		if (!moduleData) return;
		var props = moduleData;

		_reactDom2.default.render(_react2.default.createElement(_app2.default, props), el);
		$el.addClass('module-loaded');
	});
};

exports.default = ResourcesModule;


ResourcesModule.selector = '[data-module="Resources"]';
ResourcesModule.init = function (config, $modules) {
	$modules = $modules || (0, _jquery2.default)(ResourcesModule.selector);
	if ($modules.length > 0) {
		new ResourcesModule(config, $modules);
	}
};

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _zoomImage = __webpack_require__(420);

var _zoomImage2 = _interopRequireDefault(_zoomImage);

__webpack_require__(887);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ZoomImagesModule = function ZoomImagesModule(config, $modules, cb) {
	_classCallCheck(this, ZoomImagesModule);

	$modules.each(function (index, el) {
		var $el = (0, _jquery2.default)(el);
		if ($el.hasClass('module-loaded')) {
			return;
		}
		var configId = $el.data('config-id');
		var moduleData = config.find(function (data) {
			return data['config-id'] == configId;
		});
		if (!moduleData) return;
		var props = _jquery2.default.extend({}, cb, moduleData, true);
		_reactDom2.default.render(_react2.default.createElement(_zoomImage2.default, props), el);
		$el.addClass('module-loaded');
	});
};

exports.default = ZoomImagesModule;

ZoomImagesModule.selector = '[data-module="ZoomImages"]';
ZoomImagesModule.init = function (config, $modules, cb) {
	$modules = $modules || (0, _jquery2.default)(ZoomImagesModule.selector);
	if ($modules.length > 0) {
		new ZoomImagesModule(config, $modules, cb);
	}
};

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _app = __webpack_require__(421);

var _app2 = _interopRequireDefault(_app);

var _actions = __webpack_require__(137);

var _actions2 = _interopRequireDefault(_actions);

__webpack_require__(888);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appId = 'zoom-images-modal';
var appElement = document.getElementById(appId);

if (appElement == null) {
	appElement = document.createElement("div");
	var bodyEl = document.getElementsByTagName("BODY")[0];
	appElement.setAttribute("id", appId);
	bodyEl.appendChild(appElement);
}
var props = {};
var modal = _react2.default.createElement(_app2.default, props);
_reactDom2.default.render(modal, appElement);
exports.default = _actions2.default;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _actions = __webpack_require__(137);

var _actions2 = _interopRequireDefault(_actions);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ZoomLayerStore = function (_Reflux$Store) {
    _inherits(ZoomLayerStore, _Reflux$Store);

    function ZoomLayerStore(props) {
        _classCallCheck(this, ZoomLayerStore);

        var _this = _possibleConstructorReturn(this, (ZoomLayerStore.__proto__ || Object.getPrototypeOf(ZoomLayerStore)).call(this));

        _this.state = _this.getInitialState();
        _this.listenables = _actions2.default;
        return _this;
    }

    _createClass(ZoomLayerStore, [{
        key: 'getInitialState',
        value: function getInitialState() {
            return {
                modalIsOpen: false,
                settings: {
                    "image": {
                        "src": "",
                        "title": "",
                        "alt": "",
                        "className": "",
                        "id": ""
                    },
                    "label": "",
                    "caption": ""
                }
            };
        }
    }, {
        key: 'onOpen',
        value: function onOpen() {
            var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.settings;

            _tracking2.default.track("zoom_layer-open");
            this.setState({
                modalIsOpen: true,
                settings: settings
            });
        }
    }, {
        key: 'onClose',
        value: function onClose() {
            _tracking2.default.track("zoom_layer-close");
            this.setState(this.getInitialState());
        }
    }]);

    return ZoomLayerStore;
}(_reflux2.default.Store);

exports.default = ZoomLayerStore;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConsultWidget = function (_React$Component) {
    _inherits(ConsultWidget, _React$Component);

    function ConsultWidget(props) {
        _classCallCheck(this, ConsultWidget);

        //console.warn("TODO: update ConsultWidget isValidUser state");
        //window.s_user_group="Physician";
        //window.s_user_origin="us";
        var _this = _possibleConstructorReturn(this, (ConsultWidget.__proto__ || Object.getPrototypeOf(ConsultWidget)).call(this, props));

        _this.state = {
            isValidUser: props.user.isLoggedIn && props.user.professionId == 10
            //isValidUser: true
        };
        return _this;
    }

    _createClass(ConsultWidget, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadScript();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            this.loadScript();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {}
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.loadCss();
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            this.loadCss();
        }
    }, {
        key: 'loadCss',
        value: function loadCss() {
            if (!this.state.isValidUser) {
                return;
            }
            if ((0, _jquery2.default)('#share-widget-styles').length == 0) {
                var cssUrl = window.medscape.config.staticServer.host + '/medscape-core/consult/css/widget/consult-widget.css';
                (0, _jquery2.default)('head').append((0, _jquery2.default)('<link id="share-widget-styles" rel="stylesheet" type="text/css" />').attr('href', cssUrl));
            }
        }
    }, {
        key: 'loadScript',
        value: function loadScript() {
            if (!this.state.isValidUser) {
                return;
            }
            var scriptUrl = window.medscape.config.staticServer.host + '/medscape-core/consult/js/widget/consult-widget.js';
            _jquery2.default.getScript(scriptUrl, function (data, textStatus, jqxhr) {});
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.isValidUser) {
                return false;
            }
            var JoinDiscussionLink = {
                href: "",
                target: "_blank",
                onClick: function onClick(e) {
                    try {
                        window.wmdTrack('ct-wdgt_btn');
                    } catch (e) {}
                },
                dangerouslySetInnerHTML: _utils2.default.getDangerousHtml(this.props.copy.footer)
            };

            var widgetProps = {
                "className": "cslt-widg-inst",
                "type": "hidden",
                "data-tag": this.props.tag,
                "data-size": this.props.size,
                "data-link-target": "blank"
            };

            return _react2.default.createElement(
                'div',
                { className: 'consult-widget' },
                _react2.default.createElement(
                    'div',
                    { className: 'consult-bucket' },
                    _react2.default.createElement('input', widgetProps),
                    _react2.default.createElement('div', { className: 'consult-bucket-header', dangerouslySetInnerHTML: _utils2.default.getDangerousHtml(this.props.copy.header) }),
                    _react2.default.createElement(
                        'div',
                        { className: 'consult-bucket-content' },
                        _react2.default.createElement('ul', null)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'consult-bucket-footer' },
                        _react2.default.createElement('a', JoinDiscussionLink)
                    )
                )
            );
        }
    }]);

    return ConsultWidget;
}(_react2.default.Component);

exports.default = ConsultWidget;

ConsultWidget.propTypes = {
    tag: _react2.default.PropTypes.string.isRequired,
    size: _react2.default.PropTypes.number,
    user: _react2.default.PropTypes.object
};
ConsultWidget.defaultProps = {
    size: 3,
    user: {
        isLoggedIn: false,
        professionId: -1
    }
};

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _reactModal = __webpack_require__(190);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _form = __webpack_require__(319);

var _form2 = _interopRequireDefault(_form);

var _errorMessages = __webpack_require__(317);

var _errorMessages2 = _interopRequireDefault(_errorMessages);

var _store = __webpack_require__(322);

var _store2 = _interopRequireDefault(_store);

var _actions = __webpack_require__(131);

var _actions2 = _interopRequireDefault(_actions);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmailModal = function (_Reflux$Component) {
  _inherits(EmailModal, _Reflux$Component);

  function EmailModal(props) {
    _classCallCheck(this, EmailModal);

    var _this = _possibleConstructorReturn(this, (EmailModal.__proto__ || Object.getPrototypeOf(EmailModal)).call(this, props));

    _this.state = {};
    _this.store = _store2.default;
    return _this;
  }

  _createClass(EmailModal, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        modalIsOpen: false
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      (0, _jquery2.default)(document).trigger('lockScroll', [this.state.modalIsOpen, "email-modal"]);
    }
  }, {
    key: 'onAfterOpen',
    value: function onAfterOpen() {}
  }, {
    key: 'render',
    value: function render() {
      var contentTitle = document.querySelector('meta[property="og:title"]').getAttribute('content');
      var subject = this.props.senderName + ' sent you a link to ' + contentTitle;
      var linkUrl = document.querySelector('meta[property="og:url"]').getAttribute('content');
      var emailProps = {
        contentTitle: contentTitle,
        subject: subject,
        linkUrl: linkUrl
      };
      var emailFormProps = _jquery2.default.extend({}, this.props, emailProps);
      var customStyles = {
        content: {
          top: 20
        },
        overlay: {
          //position: 'absolute',
          //height: $document.height()
        }
      };
      var modalProps = {
        isOpen: this.state.modalIsOpen,
        onAfterOpen: this.onAfterOpen,
        onRequestClose: _actions2.default.close,
        shouldCloseOnOverlayClick: false,
        className: "email-modal",
        contentLabel: "Email Modal",
        style: customStyles
      };
      return _react2.default.createElement(
        _reactModal2.default,
        modalProps,
        _react2.default.createElement(
          'div',
          { className: 'modal-content-container' },
          _react2.default.createElement(
            'div',
            { className: 'header-container' },
            _react2.default.createElement(
              'h4',
              { className: 'modal-title' },
              'Email This'
            ),
            _react2.default.createElement(
              'div',
              { className: 'close-button-container' },
              _react2.default.createElement(
                'a',
                { className: 'close-button', onClick: _actions2.default.close },
                _react2.default.createElement(
                  'svg',
                  { className: 'close-icon', x: '0px', y: '0px', viewBox: '0 0 96 96', enableBackground: 'new 0 0 96 96' },
                  _react2.default.createElement('polygon', { className: 'icon-symbol', points: '96,14 82,0 48,34 14,0 0,14 34,48 0,82 14,96 48,62 82,96 96,82 62,48 ' })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'email-form-container' },
            _react2.default.createElement(_errorMessages2.default, null),
            _react2.default.createElement(_form2.default, emailFormProps)
          )
        )
      );
    } // render

  }]);

  return EmailModal;
}(_reflux2.default.Component);

exports.default = EmailModal;

EmailModal.propTypes = {
  contentTitle: _react2.default.PropTypes.string,
  subject: _react2.default.PropTypes.string,
  linkUrl: _react2.default.PropTypes.string,
  senderName: _react2.default.PropTypes.string,
  senderEmail: _react2.default.PropTypes.string,
  lockScroll: _react2.default.PropTypes.func,
  unlockScroll: _react2.default.PropTypes.func
};
EmailModal.defaultProps = {
  contentTitle: "",
  subject: "",
  linkUrl: "",
  senderName: "",
  senderEmail: ""
};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _store = __webpack_require__(318);

var _store2 = _interopRequireDefault(_store);

var _actions = __webpack_require__(89);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorMessages = function (_Reflux$Component) {
  _inherits(ErrorMessages, _Reflux$Component);

  function ErrorMessages(props) {
    _classCallCheck(this, ErrorMessages);

    var _this = _possibleConstructorReturn(this, (ErrorMessages.__proto__ || Object.getPrototypeOf(ErrorMessages)).call(this, props));

    _this.state = {};
    _this.store = _store2.default;
    return _this;
  }

  _createClass(ErrorMessages, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {}
  }, {
    key: 'getErrors',
    value: function getErrors() {
      var errors = this.state.errors.map(function (error, index) {
        var errorKey = 'error-' + index;
        return _react2.default.createElement(
          'li',
          { key: errorKey },
          error
        );
      });
      return errors;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.errors.length == 0) {
        return false;
      }
      var errors = this.getErrors();
      return _react2.default.createElement(
        'ul',
        { className: 'error-messages' },
        errors
      );
    } // render

  }]);

  return ErrorMessages;
}(_reflux2.default.Component);

exports.default = ErrorMessages;

ErrorMessages.propTypes = {};
ErrorMessages.defaultProps = {};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _store = __webpack_require__(320);

var _store2 = _interopRequireDefault(_store);

var _actions = __webpack_require__(132);

var _actions2 = _interopRequireDefault(_actions);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _actions3 = __webpack_require__(89);

var _actions4 = _interopRequireDefault(_actions3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmailForm = function (_Reflux$Component) {
  _inherits(EmailForm, _Reflux$Component);

  function EmailForm(props) {
    _classCallCheck(this, EmailForm);

    var _this = _possibleConstructorReturn(this, (EmailForm.__proto__ || Object.getPrototypeOf(EmailForm)).call(this, props));

    _this.state = {};
    _this.store = _store2.default;
    return _this;
  }

  _createClass(EmailForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {}
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (this.state["response-messages"].length > 0) {
        return _react2.default.createElement(
          'h3',
          { className: 'email-sent' },
          'Thank you. An email with this link has been sent.'
        );
      }
      var formProps = {
        id: "email-form",
        noValidate: true,
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          var postState = _jquery2.default.extend(_this2.state, _this2.props);
          var errors = [];
          if (_this2.state.recipient.length === 0 && !_this2.state.isCopySender) {
            errors.push('Please enter a Recipient Address and/or check the Send me a copy checkbox.');
          }
          if (_this2.state.recipient.length > 0 && !_utils2.default.isValidEmail(_this2.state.recipient)) {
            errors.push('Please enter a valid Email Address');
          }
          _actions4.default.update(errors);
          if (errors.length == 0) {
            _actions2.default.post(_this2.state);
          }
        }
      };
      var senderProps = {
        id: 'senderName',
        name: 'senderName',
        value: this.props.senderEmail,
        disabled: true,
        type: 'email',
        onChange: function onChange(e) {
          e.preventDefault();
        }
      };
      var recipientProps = {
        onChange: function onChange(e) {
          var el = e.target;
          var $el = (0, _jquery2.default)(el);
          var state = {};
          state.recipient = _jquery2.default.trim(el.value);
          _this2.setState(state);
        },
        type: 'email',
        noValidate: true,
        placeholder: "Enter recipient's email (limit to one)",
        id: name,
        name: name,
        value: this.state.recipient
      };
      var copyCheckboxProps = {
        id: 'copySender',
        name: 'copySender',
        type: 'checkbox',
        value: this.state.isCopySender,
        checked: this.state.isCopySender,
        onChange: function onChange(e) {
          _this2.setState({
            isCopySender: e.target.checked
          });
        }
      };
      var messageProps = {
        onChange: function onChange(e) {
          _this2.setState({ message: e.target.value });
        },
        value: this.state.message
      };
      return _react2.default.createElement(
        'form',
        formProps,
        _react2.default.createElement(
          'fieldset',
          null,
          _react2.default.createElement(
            'div',
            { className: 'subject-container' },
            _react2.default.createElement(
              'label',
              { className: 'heading' },
              'Subject'
            ),
            _react2.default.createElement(
              'div',
              { className: 'email-title' },
              this.props.contentTitle
            )
          )
        ),
        _react2.default.createElement(
          'fieldset',
          null,
          _react2.default.createElement(
            'div',
            { className: 'sender-container' },
            _react2.default.createElement(
              'label',
              { htmlFor: 'senderName' },
              'From'
            ),
            _react2.default.createElement('input', senderProps)
          )
        ),
        _react2.default.createElement(
          'fieldset',
          null,
          _react2.default.createElement(
            'div',
            { className: 'recipients-container' },
            _react2.default.createElement(
              'div',
              { className: 'recipient-container' },
              _react2.default.createElement(
                'label',
                { htmlFor: 'recipient' },
                'To'
              ),
              _react2.default.createElement('input', recipientProps)
            ),
            _react2.default.createElement(
              'div',
              { className: 'copy-me-container' },
              _react2.default.createElement('input', copyCheckboxProps),
              _react2.default.createElement(
                'label',
                { htmlFor: 'copySender' },
                'Send me a copy'
              )
            )
          )
        ),
        _react2.default.createElement(
          'fieldset',
          null,
          _react2.default.createElement(
            'div',
            { className: 'message-container' },
            _react2.default.createElement(
              'label',
              { className: 'email-heading label', htmlFor: 'email-message' },
              'Optional Message'
            ),
            _react2.default.createElement('textarea', messageProps)
          )
        ),
        _react2.default.createElement(
          'fieldset',
          null,
          _react2.default.createElement(
            'div',
            { className: 'cta-button-container' },
            _react2.default.createElement(
              'button',
              { className: 'button send-button' },
              'Send'
            )
          )
        )
      );
    } // render

  }]);

  return EmailForm;
}(_reflux2.default.Component);

exports.default = EmailForm;

EmailForm.propTypes = {
  contentTitle: _react2.default.PropTypes.string,
  subject: _react2.default.PropTypes.string,
  linkUrl: _react2.default.PropTypes.string,
  senderName: _react2.default.PropTypes.string,
  senderEmail: _react2.default.PropTypes.string
};
EmailForm.defaultProps = {
  contentTitle: "",
  subject: "",
  linkUrl: "",
  senderName: "",
  senderEmail: ""
};

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CachedContent = {};

var Formulary = function (_React$Component) {
  _inherits(Formulary, _React$Component);

  function Formulary(props) {
    _classCallCheck(this, Formulary);

    var _this = _possibleConstructorReturn(this, (Formulary.__proto__ || Object.getPrototypeOf(Formulary)).call(this, props));

    _this.state = {
      content: CachedContent[props.path] ? CachedContent[props.path] : ''
    };
    return _this;
  }

  _createClass(Formulary, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
      if (this.state.content.length == 0) {
        this.getContent();
      }
    }
  }, {
    key: 'getContent',
    value: function getContent() {
      var _this2 = this;

      if (CachedContent[this.props.path]) {
        this.setState({
          content: CachedContent[this.props.path]
        });
      } else {
        var formularyUrl = _utils2.default.getCompiledHtml(this.props.path);
        if (window.medscape.config.env == "localhost") {
          formularyUrl = '/build/localhost/app' + formularyUrl + '/index.jsp';
        }
        _jquery2.default.ajax({
          type: 'get',
          url: formularyUrl,
          cached: false,
          xhrFields: {
            withCredentials: true
          }
        }).then(function (response) {
          CachedContent[_this2.props.path] = response;
          _this2.setState({
            content: CachedContent[_this2.props.path]
          });
        }, function (error) {
          console.error("Formulary Error:", error);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.content.length == 0) {
        return false;
      }
      var content = _utils2.default.getDangerousHtml(this.state.content);
      return _react2.default.createElement('div', { className: 'formulary-content', dangerouslySetInnerHTML: content });
    }
  }]);

  return Formulary;
}(_react2.default.Component);

exports.default = Formulary;


Formulary.propTypes = {
  path: _react2.default.PropTypes.string
};
Formulary.defaultProps = {
  path: null
};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _buildForm = __webpack_require__(324);

var _buildForm2 = _interopRequireDefault(_buildForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GiftForm = function (_React$Component) {
    _inherits(GiftForm, _React$Component);

    function GiftForm(props) {
        _classCallCheck(this, GiftForm);

        return _possibleConstructorReturn(this, (GiftForm.__proto__ || Object.getPrototypeOf(GiftForm)).call(this, props));
    }

    _createClass(GiftForm, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
            _buildForm2.default.gm($this.find('.gift-manager-container'));
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
            _buildForm2.default.gm($this.find('.gift-manager-container'));
        }
    }, {
        key: 'render',
        value: function render() {
            var props = {
                "packageId": this.props.packageId,
                "promoId": this.props.promoId,
                "formDisplay": this.props.formDisplay,
                "emailHide": this.props.emailHide,
                "officeRoadHide": this.props.officeRoadHide,
                "officeCityHide": this.props.officeCityHide,
                "stateHide": this.props.stateHide,
                "zipHide": this.props.zipHide,
                "countryHide": this.props.countryHide
            };
            if (!props.formDisplay) {
                return null;
            }
            return _react2.default.createElement(
                'div',
                { className: 'gift-manager-wrapping' },
                _react2.default.createElement(
                    'h1',
                    null,
                    'Gift Manager'
                ),
                _react2.default.createElement(
                    'h2',
                    null,
                    'Get valuable SALUTRIB',
                    _react2.default.createElement(
                        'sup',
                        null,
                        '\xAE'
                    ),
                    ' coupons for your patients.'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'gift-manager-container', 'data-autoSelectGift': 'true', 'data-defaultAdd': '1', 'data-onlyUS': 'false', 'data-emailNoProfile': 'true', 'data-formHide': 'false', 'data-packageId': props.packageId, 'data-promoActivityId': props.promoId, 'data-tokenId': true },
                    _react2.default.createElement(
                        'div',
                        { id: 'gm-info-layer', className: 'gift-manager-header' },
                        _react2.default.createElement(
                            'div',
                            { id: 'thank-you' },
                            'Thank You.'
                        ),
                        _react2.default.createElement(
                            'div',
                            { id: 'service-error' },
                            'The Gift Manager service is currently unavailable.'
                        ),
                        _react2.default.createElement(
                            'div',
                            { id: 'gm-info-msg' },
                            ' Please confirm your information:'
                        ),
                        _react2.default.createElement(
                            'div',
                            { id: 'gm-error-msg' },
                            'There are errors: Please see fields in red below.'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { id: 'giftManagerElm', className: 'gift-manager-body' },
                        _react2.default.createElement(
                            'div',
                            { id: 'formInfo' },
                            _react2.default.createElement(
                                'div',
                                { id: 'emailInfo' },
                                _react2.default.createElement(GiftInput, { className: 'input-group text_field_email', hide: props.emailHide }),
                                _react2.default.createElement(GiftInput, { className: 'input-group checkbox_field_1', hide: props.emailHide })
                            ),
                            _react2.default.createElement(GiftInput, { className: 'input-group text-field-office1', hide: props.officeRoadHide }),
                            _react2.default.createElement(GiftInput, { className: 'input-group text-field-office2', hide: props.officeRoadHide }),
                            _react2.default.createElement(GiftInput, { className: 'input-group text-field-officecity', hide: props.officeCityHide }),
                            _react2.default.createElement(GiftInput, { className: 'input-group officestate_field', hide: props.stateHide }),
                            _react2.default.createElement(GiftInput, { className: 'input-group office-zip-field', hide: props.zipHide }),
                            _react2.default.createElement(GiftInput, { className: 'input-group office-country-field', hide: props.countryHide })
                        ),
                        _react2.default.createElement(
                            'form',
                            { method: 'post', action: '/activity/gmservice/processorder', id: 'orderForm' },
                            _react2.default.createElement('input', { id: 'activityHash', type: 'hidden', value: '', name: 'gm.program' }),
                            _react2.default.createElement('input', { id: 'packageHash', type: 'hidden', value: '', name: 'gm.package' }),
                            _react2.default.createElement('div', { id: 'Giftlist' }),
                            _react2.default.createElement('div', { id: 'customGroups' }),
                            _react2.default.createElement('input', { type: 'hidden', value: '', name: 'gm.tokenId', id: 'gm_tokenId' }),
                            _react2.default.createElement('input', { type: 'submit', id: 'submit_order_button', value: 'Continue' }),
                            _react2.default.createElement(
                                'div',
                                { id: 'hiddenInfo' },
                                _react2.default.createElement('div', { id: 'hiddenInfo_DCs' }),
                                _react2.default.createElement('div', { id: 'hiddenInfo_Groups' })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return GiftForm;
}(_react2.default.Component);

exports.default = GiftForm;

var GiftInput = function (_React$Component2) {
    _inherits(GiftInput, _React$Component2);

    function GiftInput(props) {
        _classCallCheck(this, GiftInput);

        return _possibleConstructorReturn(this, (GiftInput.__proto__ || Object.getPrototypeOf(GiftInput)).call(this, props));
    }

    _createClass(GiftInput, [{
        key: 'render',
        value: function render() {
            if (this.props.hide) return null;
            return _react2.default.createElement('div', { className: this.props.className });
        }
    }]);

    return GiftInput;
}(_react2.default.Component);

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _actionsFactory = __webpack_require__(101);

var _actionsFactory2 = _interopRequireDefault(_actionsFactory);

var _api = __webpack_require__(325);

var _api2 = _interopRequireDefault(_api);

var _form = __webpack_require__(379);

var _form2 = _interopRequireDefault(_form);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ApiStore = _api2.default.store;
var validFormTypes = [1, 3, 16];

var QuestionnaireComponent = function (_Reflux$Component) {
  _inherits(QuestionnaireComponent, _Reflux$Component);

  function QuestionnaireComponent(props) {
    _classCallCheck(this, QuestionnaireComponent);

    var _this = _possibleConstructorReturn(this, (QuestionnaireComponent.__proto__ || Object.getPrototypeOf(QuestionnaireComponent)).call(this, props));

    _this.state = {};
    _this.store = ApiStore.get(props);
    _this.ApiActions = _actionsFactory2.default.get(props.qid + '-' + props.formId);
    return _this;
  }

  _createClass(QuestionnaireComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.ApiActions.get(this.props.qid, this.props.formId);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      (0, _jquery2.default)(window).trigger('scroll');
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.store.stopListeningToAll();
      _api2.default.store.clearCache();
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.qid == null) {
        return false;
      }
      var formTypeId = this.state.formTypeId;
      if (validFormTypes.indexOf(formTypeId) < 0) {
        console.warn("QNA Form Type ID Not Implemented: ", formTypeId);
        return false;
      }
      var formProps = {
        questionnaire: this.state,
        questionNumberText: this.props.questionNumberText,
        flagRequired: this.props.flagRequired,
        configId: this.props.configId
        // let title = this.props.title.length>0 ? this.props.title : this.state.formTitle;
      };var title = this.props.title;
      if (title.length > 0) {
        var titleProps = {
          dangerouslySetInnerHTML: _utils2.default.getDangerousHtml(title)
        };
        return _react2.default.createElement(
          'div',
          { className: 'questionnaire-component' },
          _react2.default.createElement('h1', titleProps),
          _react2.default.createElement(
            'div',
            { className: 'form-container' },
            _react2.default.createElement(_form2.default, formProps)
          )
        );
      } else {
        return _react2.default.createElement(
          'div',
          { className: 'questionnaire-component' },
          _react2.default.createElement(
            'div',
            { className: 'form-container' },
            _react2.default.createElement(_form2.default, formProps)
          )
        );
      }
    }
  }]);

  return QuestionnaireComponent;
}(_reflux2.default.Component);

exports.default = QuestionnaireComponent;

QuestionnaireComponent.propTypes = {
  title: _react2.default.PropTypes.string,
  qid: _react2.default.PropTypes.string.isRequired,
  formId: _react2.default.PropTypes.string,
  questionNumberText: _react2.default.PropTypes.string,
  flagRequired: _react2.default.PropTypes.bool
};
QuestionnaireComponent.defaultProps = {
  title: '',
  formId: '1',
  questionNumberText: '',
  flagRequired: false
};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _store = __webpack_require__(328);

var _store2 = _interopRequireDefault(_store);

var _actions = __webpack_require__(102);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorMessages = function (_Reflux$Component) {
  _inherits(ErrorMessages, _Reflux$Component);

  function ErrorMessages(props) {
    _classCallCheck(this, ErrorMessages);

    var _this = _possibleConstructorReturn(this, (ErrorMessages.__proto__ || Object.getPrototypeOf(ErrorMessages)).call(this, props));

    _this.state = {};
    _this.store = _store2.default;
    return _this;
  }

  _createClass(ErrorMessages, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {}
  }, {
    key: 'getErrors',
    value: function getErrors() {
      var errors = this.state.errors.map(function (error, index) {
        var errorKey = 'error-' + index;
        return _react2.default.createElement(
          'li',
          { key: errorKey },
          error
        );
      });
      return errors;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.errors.length == 0) {
        return false;
      }
      var errors = this.getErrors();
      return _react2.default.createElement(
        'ul',
        { className: 'error-messages' },
        errors
      );
    } // render

  }]);

  return ErrorMessages;
}(_reflux2.default.Component);

exports.default = ErrorMessages;

ErrorMessages.propTypes = {};
ErrorMessages.defaultProps = {};

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _choiceStore = __webpack_require__(90);

var _choiceStore2 = _interopRequireDefault(_choiceStore);

var _choiceActionsFactory = __webpack_require__(64);

var _choiceActionsFactory2 = _interopRequireDefault(_choiceActionsFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckboxChoices = function (_React$Component) {
    _inherits(CheckboxChoices, _React$Component);

    function CheckboxChoices(props) {
        _classCallCheck(this, CheckboxChoices);

        return _possibleConstructorReturn(this, (CheckboxChoices.__proto__ || Object.getPrototypeOf(CheckboxChoices)).call(this, props));
    }

    _createClass(CheckboxChoices, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            //let $this = $(ReactDOM.findDOMNode(this));
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            //let $this = $(ReactDOM.findDOMNode(this));
        }
    }, {
        key: 'getChoices',
        value: function getChoices() {
            var questionId = this.props.question.questionId;
            var choicesMap = this.props.question.choices.map(function (choice, index) {
                var key = 'choice-' + questionId + '-' + choice.choiceId;
                var componentProps = {
                    key: key,
                    choice: choice,
                    name: "qna-" + questionId,
                    questionId: questionId,
                    choiceId: key
                };
                return _react2.default.createElement(Choice, componentProps);
            });

            return choicesMap;
        }
    }, {
        key: 'render',
        value: function render() {
            var choices = this.getChoices();
            if (choices.length == 0) return false;
            return _react2.default.createElement(
                'ul',
                { className: 'choices-container checkbox-choices' },
                choices
            );
        }
    }]);

    return CheckboxChoices;
}(_react2.default.Component);

exports.default = CheckboxChoices;

CheckboxChoices.propTypes = {
    question: _react2.default.PropTypes.object.isRequired
};
CheckboxChoices.defaultProps = {};

var Choice = function (_Reflux$Component) {
    _inherits(Choice, _Reflux$Component);

    function Choice(props) {
        _classCallCheck(this, Choice);

        var _this2 = _possibleConstructorReturn(this, (Choice.__proto__ || Object.getPrototypeOf(Choice)).call(this, props));

        _this2.state = {};
        _this2.store = _choiceStore2.default.get(props.choice, true, props.questionId);
        _this2.ChoiceActions = _choiceActionsFactory2.default.get(props.questionId);
        return _this2;
    }

    _createClass(Choice, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.bindEvents();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            this.bindEvents();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.store.stopListeningToAll();
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            var _this3 = this;

            var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
            var $checkboxEl = $this.find('input[type="checkbox"]');
            var $labelEl = $this.find('label');
            $checkboxEl.off('change.QNA').on('change.QNA', function (e) {
                e.preventDefault();
                var el = e.currentTarget;
                var isSelected = (0, _jquery2.default)(el).is(':checked');
                _this3.ChoiceActions.change(_this3.state, isSelected);
            });

            $labelEl.off('click.QNA').on('click.QNA', function (e) {
                $checkboxEl.trigger('change.QNA');
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var className = "choice-item";
            className += this.state.selected ? " active" : "";
            var choiceId = this.props.choiceId;
            var inputProps = {
                type: "checkbox",
                checked: this.state.selected,
                name: this.props.name,
                value: this.state.choiceId,
                id: choiceId
            };
            var text = {
                __html: this.state.choiceText
            };
            return _react2.default.createElement(
                'li',
                { className: className },
                _react2.default.createElement(
                    'label',
                    { htmlFor: choiceId },
                    _react2.default.createElement('input', inputProps),
                    _react2.default.createElement(
                        'div',
                        { className: 'inputBorder' },
                        _react2.default.createElement(
                            'span',
                            { className: 'checkbox-button' },
                            _react2.default.createElement('span', null)
                        )
                    ),
                    _react2.default.createElement('span', { className: 'choice-text', dangerouslySetInnerHTML: text })
                )
            );
        }
    }]);

    return Choice;
}(_reflux2.default.Component);

Choice.propTypes = {
    choice: _react2.default.PropTypes.object.isRequired,
    name: _react2.default.PropTypes.string.isRequired,
    questionId: _react2.default.PropTypes.number.isRequired,
    choiceId: _react2.default.PropTypes.string.isRequired
};
Choice.defaultProps = {};

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _2 = __webpack_require__(42);

var _3 = _interopRequireDefault(_2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _choiceStore = __webpack_require__(90);

var _choiceStore2 = _interopRequireDefault(_choiceStore);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PollResults = function (_React$Component) {
    _inherits(PollResults, _React$Component);

    function PollResults(props) {
        _classCallCheck(this, PollResults);

        var _this = _possibleConstructorReturn(this, (PollResults.__proto__ || Object.getPrototypeOf(PollResults)).call(this, props));

        if (window.medscape.user.isLoggedIn) {
            _this.fixChoicesTotalResponse(props.question.choices);
        }
        return _this;
    }

    _createClass(PollResults, [{
        key: 'fixChoicesTotalResponse',
        value: function fixChoicesTotalResponse(choices) {
            function getPercentages(percentages) {
                var numbers = percentages.map(function (percentage, index) {
                    var number = Math.floor(percentage);
                    var decimal = percentage - number;
                    return {
                        number: number,
                        decimal: decimal,
                        index: index
                    };
                });

                var largestDec = numbers.sort(function (number1, number2) {
                    return number1.decimal < number2.decimal;
                });
                var total = 0;
                numbers.forEach(function (number) {
                    total += number.number;
                });
                var counter = 0;
                for (var i = total; i < 100; i++) {
                    var index = largestDec[counter].index;
                    numbers[index].number++;
                    counter++;
                }
                percentages = numbers.map(function (number) {
                    return number.number;
                });
                return percentages;
            }

            var totalResponses = 0;
            choices.forEach(function (choice) {
                if (choice.selected && choice.totalAbsoluteResponseCount == 0) {
                    choice.totalAbsoluteResponseCount = 1;
                }
                totalResponses += choice.totalAbsoluteResponseCount;
            });
            if (totalResponses === 0) return;

            var percentages = choices.map(function (choice) {
                return choice.totalAbsoluteResponseCount / totalResponses * 100;
            });
            percentages = getPercentages(percentages);

            choices.forEach(function (choice, index) {
                choice.totalResponses = percentages[index];
            });
        } //fixChoicesTotalResponse

    }, {
        key: 'getChoices',
        value: function getChoices() {

            var choicesMap = this.props.question.choices.map(function (choice, index) {
                var componentProps = {
                    key: "choice-" + index,
                    choice: choice
                };
                return _react2.default.createElement(Choice, componentProps);
            });
            return choicesMap;
        }
    }, {
        key: 'render',
        value: function render() {
            var choices = this.getChoices();
            if (choices.length == 0) return false;
            return _react2.default.createElement(
                'ul',
                { className: 'poll-results result-choices choices-container' },
                choices
            );
        }
    }]);

    return PollResults;
}(_react2.default.Component);

exports.default = PollResults;

PollResults.propTypes = {
    question: _react2.default.PropTypes.object.isRequired
};

PollResults.defaultProps = {};

var Choice = function (_React$Component2) {
    _inherits(Choice, _React$Component2);

    function Choice(props) {
        _classCallCheck(this, Choice);

        var _this2 = _possibleConstructorReturn(this, (Choice.__proto__ || Object.getPrototypeOf(Choice)).call(this, props));

        _this2.state = props.choice;
        //this.store = ChoiceStore.get(this.props.choice);
        return _this2;
    }

    _createClass(Choice, [{
        key: 'getWidth',
        value: function getWidth() {
            var percentage = parseInt(this.state.totalResponses, 10);
            var width = Math.round(percentage);
            width = width > 100 ? 100 : width;
            width = width < 0 ? 0 : width;
            return width;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
            var $bar = $this.find('.bar');
            var width = this.getWidth();
            setTimeout(function () {
                $bar.css('width', width + '%');
            }, 10);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {}
    }, {
        key: 'render',
        value: function render() {
            var className = "choice-item";
            className += this.state.selected ? " active" : "";
            var choiceId = 'choice-' + this.state.choiceId;
            var percentage = parseInt(this.state.totalResponses, 10);
            var width = this.getWidth();
            var text = {
                __html: this.state.choiceText
            };

            return _react2.default.createElement(
                'li',
                { className: className },
                _react2.default.createElement(
                    'div',
                    { className: 'result-container' },
                    _react2.default.createElement('span', { className: 'choice-text', dangerouslySetInnerHTML: text }),
                    _react2.default.createElement(
                        'span',
                        { className: 'percentage' },
                        width,
                        '%'
                    ),
                    _react2.default.createElement('div', { className: 'bar' })
                )
            );
        }
    }]);

    return Choice;
}(_react2.default.Component);

Choice.propTypes = {
    choice: _react2.default.PropTypes.object.isRequired
};
Choice.defaultProps = {};

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _2 = __webpack_require__(42);

var _3 = _interopRequireDefault(_2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _choiceStore = __webpack_require__(90);

var _choiceStore2 = _interopRequireDefault(_choiceStore);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _Checkmark = __webpack_require__(673);

var _Checkmark2 = _interopRequireDefault(_Checkmark);

var _Close = __webpack_require__(120);

var _Close2 = _interopRequireDefault(_Close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var QnaResults = function (_React$Component) {
    _inherits(QnaResults, _React$Component);

    function QnaResults(props) {
        _classCallCheck(this, QnaResults);

        return _possibleConstructorReturn(this, (QnaResults.__proto__ || Object.getPrototypeOf(QnaResults)).call(this, props));
    }

    _createClass(QnaResults, [{
        key: 'getChoices',
        value: function getChoices() {
            var _this2 = this;

            var hasCorrectChoice = this.props.question.choices.find(function (choice) {
                return choice.correct == true;
            });
            var choices = this.props.question.choices.sort(function (choiceA, choiceB) {
                return choiceA.displayOrder - choiceB.displayOrder;
            });

            var choicesMap = choices.map(function (choice, index) {
                var componentProps = {
                    key: "choice-" + index,
                    choice: choice,
                    score: _this2.props.question.score || hasCorrectChoice != null,
                    answered: _this2.props.question.answered
                    /*
                    if(choice.selected || this.props.question.score){
                        return ( <Choice {...componentProps} /> )
                    }
                    */
                };return _react2.default.createElement(Choice, componentProps);
            });
            return choicesMap;
        }
    }, {
        key: 'render',
        value: function render() {

            //if(choices.length==0 && this.props.question.responseText==null) return false;
            if (this.props.question.displayType == 5 || this.props.question.displayType == 4) {
                return _react2.default.createElement(ResponseText, { text: this.props.question.responseText });
            } else {
                var choices = this.getChoices();
                return _react2.default.createElement(
                    'ul',
                    { className: 'qna-results result-choices choices-container' },
                    choices
                );
            }
        }
    }]);

    return QnaResults;
}(_react2.default.Component);

exports.default = QnaResults;

QnaResults.propTypes = {
    question: _react2.default.PropTypes.object.isRequired
};

QnaResults.defaultProps = {};

var Choice = function (_React$Component2) {
    _inherits(Choice, _React$Component2);

    function Choice(props) {
        _classCallCheck(this, Choice);

        var _this3 = _possibleConstructorReturn(this, (Choice.__proto__ || Object.getPrototypeOf(Choice)).call(this, props));

        _this3.state = props.choice;
        return _this3;
    }

    _createClass(Choice, [{
        key: 'getIcon',
        value: function getIcon() {

            if (this.props.score && this.state.correct) {
                return _react2.default.createElement(
                    'span',
                    { className: 'choice-icon correct-choice' },
                    _react2.default.createElement(_Checkmark2.default, null)
                );
            } else if (this.props.score && this.state.selected && !this.state.correct) {
                return _react2.default.createElement(
                    'span',
                    { className: 'choice-icon wrong-choice' },
                    _react2.default.createElement(_Close2.default, null)
                );
            } else {
                return _react2.default.createElement('span', { className: 'choice-icon' });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var correct = this.state.correct;
            var className = (0, _classnames2.default)({
                "choice-item": true,
                "active": this.state.selected,
                "correct": correct || !this.props.score && this.state.selected,
                "incorrect-choice": this.props.score && this.state.selected && !correct
            });
            var choiceId = 'choice-' + this.state.choiceId;
            var text = {
                __html: this.state.choiceText
            };
            var barStyle = {
                width: "100%"
            };

            var ChoiceIcon = this.getIcon();
            return _react2.default.createElement(
                'li',
                { className: className },
                _react2.default.createElement(
                    'div',
                    { className: 'result-container' },
                    ChoiceIcon,
                    _react2.default.createElement('span', { className: 'choice-text', dangerouslySetInnerHTML: text }),
                    _react2.default.createElement('div', { className: 'bar', style: barStyle })
                )
            );
        }
    }]);

    return Choice;
}(_react2.default.Component);

Choice.propTypes = {
    choice: _react2.default.PropTypes.object.isRequired,
    score: _react2.default.PropTypes.bool
};
Choice.defaultProps = {
    score: false
};

var ResponseText = function (_React$Component3) {
    _inherits(ResponseText, _React$Component3);

    function ResponseText(props) {
        _classCallCheck(this, ResponseText);

        return _possibleConstructorReturn(this, (ResponseText.__proto__ || Object.getPrototypeOf(ResponseText)).call(this, props));
    }

    _createClass(ResponseText, [{
        key: 'render',
        value: function render() {
            var className = (0, _classnames2.default)({
                "choice-item": true,
                "active": true,
                "correct": true
            });
            var barStyle = {
                width: "100%"
            };
            return _react2.default.createElement(
                'ul',
                { className: 'qna-results result-choices choices-container response-text' },
                _react2.default.createElement(
                    'li',
                    { className: className },
                    _react2.default.createElement(
                        'div',
                        { className: 'result-container' },
                        _react2.default.createElement(
                            'span',
                            { className: 'choice-text' },
                            this.props.text
                        ),
                        _react2.default.createElement('div', { className: 'bar', style: barStyle })
                    )
                )
            );
        }
    }]);

    return ResponseText;
}(_react2.default.Component);

ResponseText.propTypes = {
    text: _react2.default.PropTypes.string
};
ResponseText.defaultProps = {};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _choiceStore = __webpack_require__(90);

var _choiceStore2 = _interopRequireDefault(_choiceStore);

var _choiceActionsFactory = __webpack_require__(64);

var _choiceActionsFactory2 = _interopRequireDefault(_choiceActionsFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RadioChoices = function (_React$Component) {
    _inherits(RadioChoices, _React$Component);

    function RadioChoices(props) {
        _classCallCheck(this, RadioChoices);

        return _possibleConstructorReturn(this, (RadioChoices.__proto__ || Object.getPrototypeOf(RadioChoices)).call(this, props));
    }

    _createClass(RadioChoices, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            //let $this = $(ReactDOM.findDOMNode(this));
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            //let $this = $(ReactDOM.findDOMNode(this));
        }
    }, {
        key: 'getChoices',
        value: function getChoices() {
            var questionId = this.props.question.questionId;
            var choicesMap = this.props.question.choices.map(function (choice, index) {
                var key = 'choice-' + questionId + '-' + choice.choiceId;
                var componentProps = {
                    key: key,
                    choice: choice,
                    name: "qna-" + questionId,
                    questionId: questionId,
                    choiceId: key
                };
                return _react2.default.createElement(Choice, componentProps);
            });

            return choicesMap;
        }
    }, {
        key: 'render',
        value: function render() {
            var choices = this.getChoices();
            if (choices.length == 0) return false;
            return _react2.default.createElement(
                'ul',
                { className: 'choices-container radio-choices' },
                choices
            );
        }
    }]);

    return RadioChoices;
}(_react2.default.Component);

exports.default = RadioChoices;

RadioChoices.propTypes = {
    question: _react2.default.PropTypes.object.isRequired
};
RadioChoices.defaultProps = {};

var Choice = function (_Reflux$Component) {
    _inherits(Choice, _Reflux$Component);

    function Choice(props) {
        _classCallCheck(this, Choice);

        var _this2 = _possibleConstructorReturn(this, (Choice.__proto__ || Object.getPrototypeOf(Choice)).call(this, props));

        _this2.state = {};
        _this2.store = _choiceStore2.default.get(props.choice, false, props.questionId);
        _this2.ChoiceActions = _choiceActionsFactory2.default.get(props.questionId);
        return _this2;
    }

    _createClass(Choice, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {}
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.store.stopListeningToAll();
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            //let $this = $(ReactDOM.findDOMNode(this));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var className = "choice-item";
            className += this.state.selected ? " active" : "";
            var choiceId = this.props.choiceId;
            var inputProps = {
                type: "radio",
                checked: this.state.selected,
                name: this.props.name,
                value: this.state.choiceId,
                id: choiceId,
                style: {
                    display: 'none'
                },
                onChange: function onChange(e) {
                    e.preventDefault();
                    var el = e.currentTarget;
                    var isSelected = (0, _jquery2.default)(el).is(':checked');
                    _this3.ChoiceActions.change(_this3.state, isSelected);
                }
            };
            var text = {
                __html: this.state.choiceText
            };

            return _react2.default.createElement(
                'li',
                { className: className },
                _react2.default.createElement('input', inputProps),
                _react2.default.createElement(
                    'label',
                    { htmlFor: choiceId },
                    _react2.default.createElement(
                        'div',
                        { className: 'inputBorder' },
                        _react2.default.createElement(
                            'span',
                            { className: 'radio-button' },
                            _react2.default.createElement('span', null)
                        )
                    ),
                    _react2.default.createElement('span', { className: 'choice-text', dangerouslySetInnerHTML: text })
                )
            );
        }
    }]);

    return Choice;
}(_reflux2.default.Component);

Choice.propTypes = {
    choice: _react2.default.PropTypes.object.isRequired,
    name: _react2.default.PropTypes.string.isRequired,
    questionId: _react2.default.PropTypes.number.isRequired,
    choiceId: _react2.default.PropTypes.string.isRequired
};
Choice.defaultProps = {};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _choiceStore = __webpack_require__(90);

var _choiceStore2 = _interopRequireDefault(_choiceStore);

var _choiceActionsFactory = __webpack_require__(64);

var _choiceActionsFactory2 = _interopRequireDefault(_choiceActionsFactory);

var _reactSelect = __webpack_require__(837);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

__webpack_require__(879);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// Be sure to include styles at some point, probably during your bootstrapping


var SelectChoices = function (_React$Component) {
    _inherits(SelectChoices, _React$Component);

    function SelectChoices(props) {
        _classCallCheck(this, SelectChoices);

        var _this = _possibleConstructorReturn(this, (SelectChoices.__proto__ || Object.getPrototypeOf(SelectChoices)).call(this, props));

        var selectedChoice = props.question.choices.find(function (choice) {
            return choice.selected;
        });
        _this.state = selectedChoice != null ? selectedChoice : _this.getInitialState();
        _this.ChoiceActions = _choiceActionsFactory2.default.get(props.question.questionId);
        return _this;
    }

    _createClass(SelectChoices, [{
        key: 'getInitialState',
        value: function getInitialState() {
            return {
                choiceId: '',
                choiceText: '',
                selected: false
            };
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            //let $this = $(ReactDOM.findDOMNode(this));
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            //let $this = $(ReactDOM.findDOMNode(this));
        }
    }, {
        key: 'getChoices',
        value: function getChoices() {
            var choicesMap = this.props.question.choices.map(function (choice, index) {
                return {
                    value: choice.choiceId,
                    label: choice.choiceText,
                    selected: choice.selected
                };
            });

            return choicesMap;
        }
    }, {
        key: 'doChange',
        value: function doChange(choice) {
            var selectedId = choice != null ? choice.value : '';
            this.props.question.choices.forEach(function (choice) {
                choice.selected = choice.choiceId == selectedId;
            });
            this.ChoiceActions.change();
            if (choice == null) {
                choice = this.getInitialState();
            }
            this.setState(choice);
        }
    }, {
        key: 'render',
        value: function render() {
            var choices = this.getChoices();
            var selectedChoice = choices.find(function (choice) {
                return choice.selected;
            });
            if (choices.length == 0) return false;
            var selectProps = {
                name: 'question-select',
                value: selectedChoice != null ? selectedChoice.value : '',
                options: choices,
                onChange: this.doChange.bind(this)
            };

            return _react2.default.createElement(
                'div',
                { className: 'choices-container select-choices' },
                _react2.default.createElement(_reactSelect2.default, selectProps)
            );
        }
    }]);

    return SelectChoices;
}(_react2.default.Component);

exports.default = SelectChoices;

SelectChoices.propTypes = {
    question: _react2.default.PropTypes.object.isRequired
};
SelectChoices.defaultProps = {};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DiscussionIntroductionField = function (_React$Component) {
  _inherits(DiscussionIntroductionField, _React$Component);

  function DiscussionIntroductionField(props) {
    _classCallCheck(this, DiscussionIntroductionField);

    return _possibleConstructorReturn(this, (DiscussionIntroductionField.__proto__ || Object.getPrototypeOf(DiscussionIntroductionField)).call(this, props));
  }

  _createClass(DiscussionIntroductionField, [{
    key: 'render',
    value: function render() {

      if (this.props.type == 0 || this.props.content == null) {
        return null;
      }

      var classes = (0, _classnames2.default)({
        "discussion-content": this.props.type == DiscussionIntroductionField.types.DISCUSSION,
        "introduction-content": this.props.type == DiscussionIntroductionField.types.INTRODUCTION
      });

      var pProps = {
        className: classes,
        dangerouslySetInnerHTML: _utils2.default.getDangerousHtml(this.props.content)
      };
      return _react2.default.createElement(
        'div',
        { className: 'discission-introduction-field-component' },
        _react2.default.createElement('p', pProps)
      );
    }
  }]);

  return DiscussionIntroductionField;
}(_react2.default.Component);

exports.default = DiscussionIntroductionField;

DiscussionIntroductionField.propTypes = {
  type: _react2.default.PropTypes.number,
  content: _react2.default.PropTypes.string
};
DiscussionIntroductionField.defaultProps = {
  content: "",
  type: 0
};
DiscussionIntroductionField.types = {
  DISCUSSION: 1,
  INTRODUCTION: 2
};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _choiceActionsFactory = __webpack_require__(64);

var _choiceActionsFactory2 = _interopRequireDefault(_choiceActionsFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputFieldChoice = function (_React$Component) {
  _inherits(InputFieldChoice, _React$Component);

  function InputFieldChoice(props) {
    _classCallCheck(this, InputFieldChoice);

    var _this = _possibleConstructorReturn(this, (InputFieldChoice.__proto__ || Object.getPrototypeOf(InputFieldChoice)).call(this, props));

    if (props.question.responseText == null) {
      props.question.responseText = '';
    }
    _this.state = props.question;
    _this.ChoiceActions = _choiceActionsFactory2.default.get(props.question.questionId);
    return _this;
  }

  _createClass(InputFieldChoice, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      //this.bindEvents();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      //this.bindEvents();
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      var _this2 = this;

      var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
      var $inputEl = $this.find('input[type="text"]');
      $inputEl.off('change.QNA').on('change.QNA', function (e) {
        e.preventDefault();
        var el = e.target;
        var value = _jquery2.default.trim(el.value);
        _this2.props.question.responseText = value;
        _this2.setState({
          responseText: value
        });
        _this2.ChoiceActions.change(null, true);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var className = "choice-item input-field-choice";
      var inputId = 'input-field-' + this.props.question.questionId;
      var regex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g;
      var inputProps = {
        type: "text",
        name: inputId,
        placeholder: 'Only English Characters Are Valid',
        value: this.state.responseText,
        id: inputId,
        onChange: function onChange(e) {
          e.preventDefault();
          var el = e.target;
          var value = !regex.test(el.value) ? el.value : '';
          _this3.props.question.responseText = value;
          _this3.setState({
            responseText: value
          });
          _this3.ChoiceActions.change(null, true);
        }
      };
      var text = {
        __html: this.state.questionText
      };
      return _react2.default.createElement(
        'ul',
        { className: 'choices-container' },
        _react2.default.createElement(
          'li',
          { className: className },
          _react2.default.createElement(
            'label',
            { htmlFor: inputId },
            _react2.default.createElement('input', inputProps)
          )
        )
      );
    }
  }]);

  return InputFieldChoice;
}(_react2.default.Component);

exports.default = InputFieldChoice;

InputFieldChoice.propTypes = {
  question: _react2.default.PropTypes.object.isRequired
};
InputFieldChoice.defaultProps = {};

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _choices = __webpack_require__(329);

var _choices2 = _interopRequireDefault(_choices);

var _inputField = __webpack_require__(375);

var _inputField2 = _interopRequireDefault(_inputField);

var _textarea = __webpack_require__(378);

var _textarea2 = _interopRequireDefault(_textarea);

var _discussionIntroductionField = __webpack_require__(374);

var _discussionIntroductionField2 = _interopRequireDefault(_discussionIntroductionField);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Question = function (_React$Component) {
  _inherits(Question, _React$Component);

  function Question(props) {
    _classCallCheck(this, Question);

    var _this = _possibleConstructorReturn(this, (Question.__proto__ || Object.getPrototypeOf(Question)).call(this, props));

    var choices = props.question.choices.sort(function (choiceA, choiceB) {
      return choiceA.displayOrder - choiceB.displayOrder;
    });
    props.question.choices = choices;
    return _this;
  }

  _createClass(Question, [{
    key: 'getChoicesType',
    value: function getChoicesType() {
      var choices = void 0;
      var question = this.props.question;
      if (question.answered) {
        if (question.showAnsTable) {
          if (question.poll) {
            return _choices2.default.PollResults;
          } else {
            return _choices2.default.QnaResults;
          }
        } else {
          if (question.poll) {
            return _choices2.default.QnaResults;
          }
          return _choices2.default.QnaResults;
        }
      }
      switch (question.displayType) {
        case 1:
          choices = _choices2.default.Radio;
          break;
        case 2:
          choices = _choices2.default.Checkbox;
          break;
        case 3:
          choices = _choices2.default.Select;
          break;
        case 4:
          choices = _inputField2.default;
          break;
        case 5:
          choices = _textarea2.default;
          break;
        default:
          choices = null;
      }
      return choices;
    }
  }, {
    key: 'isAnswered',
    value: function isAnswered() {
      var question = this.props.question;
      var isAnswered = question.answered;
      if (isAnswered) return true;
      if (question.displayType == 4 || question.displayType == 5) {
        return question.responseText != null && question.responseText.length > 0;
      } else {
        var choices = question.choices;
        var choice = choices.find(function (choice) {
          return choice.selected;
        });
        return choice != null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var question = this.props.question;
      var fieldsetId = "questions-item-" + question.questionId;
      var isRequired = question.required;
      var isAnswered = this.isAnswered();
      var questionClass = (0, _classnames2.default)({
        "question-item": true,
        "required": isRequired,
        "answered": isAnswered
      });
      var questionDescription = this.props.flagRequired && isRequired && !question.answered ? '<span class="asterisk">*</span> ' + question.questionText : question.questionText;
      var description = _utils2.default.getDangerousHtml(questionDescription);
      var choiceProps = {
        question: question
      };
      var ChoicesType = this.getChoicesType();
      if (ChoicesType == null) {
        return false;
        /*
        return (
            <fieldset>
                <div className="description" dangerouslySetInnerHTML={description}>
                </div>
                <div>(DisplayType: {this.props.question.displayType}) Not Implemented</div>
            </fieldset>
        );
        */
      }

      var discussionIntroFieldProps = {
        content: isAnswered ? question.discussion : question.introduction,
        type: isAnswered ? _discussionIntroductionField2.default.types.DISCUSSION : _discussionIntroductionField2.default.types.INTRODUCTION
      };

      var QuestionCounter = function QuestionCounter() {
        if (_this2.props.questionNumberText.length == 0) {
          return false;
        }
        var questionHtml = _utils2.default.getDangerousHtml(_this2.props.questionNumberText);
        return _react2.default.createElement('h5', { className: 'question-number', dangerouslySetInnerHTML: questionHtml });
      };
      return _react2.default.createElement(
        'fieldset',
        { id: fieldsetId, className: questionClass },
        QuestionCounter(),
        _react2.default.createElement('div', { className: 'description', dangerouslySetInnerHTML: description }),
        _react2.default.createElement(ChoicesType, choiceProps),
        _react2.default.createElement(_discussionIntroductionField2.default, discussionIntroFieldProps)
      );
    }
  }]);

  return Question;
}(_react2.default.Component);

exports.default = Question;

Question.propTypes = {
  question: _react2.default.PropTypes.object.isRequired,
  index: _react2.default.PropTypes.number,
  flagRequired: _react2.default.PropTypes.bool,
  questionNumberText: _react2.default.PropTypes.string
};
Question.defaultProps = {
  index: 0,
  flagRequired: false,
  questionNumberText: ''
};

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _submitButtonStore = __webpack_require__(330);

var _submitButtonStore2 = _interopRequireDefault(_submitButtonStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SubmitButton = function (_Reflux$Component) {
  _inherits(SubmitButton, _Reflux$Component);

  function SubmitButton(props) {
    _classCallCheck(this, SubmitButton);

    var _this = _possibleConstructorReturn(this, (SubmitButton.__proto__ || Object.getPrototypeOf(SubmitButton)).call(this, props));

    _this.state = {};
    _this.store = _submitButtonStore2.default.get(props.questionnaire);
    return _this;
  }

  _createClass(SubmitButton, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.store.stopListeningToAll();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var buttonClass = (0, _classnames2.default)({
        "submit-button": true,
        "button": true,
        "disabled": this.state.isDisabled
      });
      var buttonProps = {
        className: buttonClass,
        onClick: function onClick(e) {
          if (_this2.state.isDisabled) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        }
      };
      return _react2.default.createElement(
        'button',
        buttonProps,
        _react2.default.createElement(
          'span',
          { className: 'title' },
          'Submit'
        )
      );
    }
  }]);

  return SubmitButton;
}(_reflux2.default.Component);

exports.default = SubmitButton;


SubmitButton.propTypes = {
  questionnaire: _react2.default.PropTypes.object.isRequired
};
SubmitButton.defaultProps = {};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _choiceActionsFactory = __webpack_require__(64);

var _choiceActionsFactory2 = _interopRequireDefault(_choiceActionsFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextArea = function (_React$Component) {
    _inherits(TextArea, _React$Component);

    function TextArea(props) {
        _classCallCheck(this, TextArea);

        var _this = _possibleConstructorReturn(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call(this, props));

        if (props.question.responseText == null) {
            props.question.responseText = '';
        }
        _this.state = props.question;
        return _this;
    }

    _createClass(TextArea, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.ChoiceActions = _choiceActionsFactory2.default.get(this.props.question.questionId);
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            nextState.responseText = nextProps.question.responseText;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            this.ChoiceActions = _choiceActionsFactory2.default.get(this.props.question.questionId);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var className = "choice-item input-field-choice";
            var inputId = 'input-field-' + this.props.question.questionId;
            var inputProps = {
                type: "text",
                name: inputId,
                value: this.props.question.responseText,
                id: inputId,
                onChange: function onChange(e) {
                    e.preventDefault();
                    var el = e.target;
                    var value = el.value;
                    _this2.props.question.responseText = value;
                    _this2.setState({
                        responseText: value
                    });
                    _this2.ChoiceActions.change(null, true);
                }
            };

            return _react2.default.createElement(
                'ul',
                { className: 'choices-container' },
                _react2.default.createElement(
                    'li',
                    { className: className },
                    _react2.default.createElement('textarea', inputProps)
                )
            );
        }
    }]);

    return TextArea;
}(_react2.default.Component);

exports.default = TextArea;

TextArea.propTypes = {
    question: _react2.default.PropTypes.object.isRequired
};
TextArea.defaultProps = {};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _question = __webpack_require__(376);

var _question2 = _interopRequireDefault(_question);

var _submitButton = __webpack_require__(377);

var _submitButton2 = _interopRequireDefault(_submitButton);

var _errorMessages = __webpack_require__(327);

var _errorMessages2 = _interopRequireDefault(_errorMessages);

var _actionsFactory = __webpack_require__(101);

var _actionsFactory2 = _interopRequireDefault(_actionsFactory);

var _handlebars = __webpack_require__(121);

var _handlebars2 = _interopRequireDefault(_handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Form = function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form(props) {
    _classCallCheck(this, Form);

    //console.log(this.props.questionnaire)
    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

    _this.ApiActions = _actionsFactory2.default.get(_this.props.questionnaire.qid + '-' + _this.props.questionnaire.formId);
    return _this;
  }

  _createClass(Form, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // let $this = $(ReactDOM.findDOMNode(this));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {}
  }, {
    key: 'getQuestions',
    value: function getQuestions() {
      var _this2 = this;

      var answered = this.props.questionnaire.questions.find(function (question) {
        return question.answered;
      });
      var questions = this.props.questionnaire.questions.sort(function (questionA, questionB) {
        return questionA.displayOrder - questionB.displayOrder;
      });
      if (answered) {
        questions.forEach(function (question) {
          question.answered = true;
        });
      }
      return questions.map(function (question, index) {
        if (answered && !question.answered) {
          return;
        }
        var CountData = {
          counter: index + 1
        };
        var template = _handlebars2.default.compile(_this2.props.questionNumberText);
        var componentProps = {
          key: "question-" + question.questionId,
          question: question,
          flagRequired: _this2.props.flagRequired,
          questionNumberText: template(CountData),
          index: _this2.props.showQuestionNumber ? index + 1 : -1
        };
        return _react2.default.createElement(_question2.default, componentProps);
      });
    }
  }, {
    key: 'getCta',
    value: function getCta() {
      var questions = this.props.questionnaire.questions;
      var answered = questions.find(function (question) {
        return question.answered;
      });
      //if(answered && (answered.poll || this.props.questionnaire.formType!="EVAL")) return;
      if (answered) {
        return;
      }
      return _react2.default.createElement(
        'fieldset',
        { className: 'button-container' },
        _react2.default.createElement(_submitButton2.default, { questionnaire: this.props.questionnaire, configId: this.props.configId })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var questions = this.getQuestions();
      if (questions.length == 0) return false;
      var cta = this.getCta();
      var formProps = {
        method: "post",
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          _this3.ApiActions.post(_this3.props.questionnaire);
        }
      };
      return _react2.default.createElement(
        'form',
        formProps,
        _react2.default.createElement(
          'div',
          { className: 'questions-list' },
          questions
        ),
        cta,
        _react2.default.createElement(
          'div',
          { className: 'error-messages-container' },
          _react2.default.createElement(_errorMessages2.default, null)
        )
      );
    }
  }]);

  return Form;
}(_react2.default.Component);

exports.default = Form;

Form.propTypes = {
  questionnaire: _react2.default.PropTypes.object.isRequired,
  questionNumberText: _react2.default.PropTypes.string,
  flagRequired: _react2.default.PropTypes.bool
};
Form.defaultProps = {
  questionNumberText: '',
  flagRequired: false
};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _icons = __webpack_require__(381);

var _icons2 = _interopRequireDefault(_icons);

var _SocialLinkedinOption = __webpack_require__(679);

var _SocialLinkedinOption2 = _interopRequireDefault(_SocialLinkedinOption);

var _emailModal = __webpack_require__(321);

var _emailModal2 = _interopRequireDefault(_emailModal);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SharingWidget = function (_React$Component) {
    _inherits(SharingWidget, _React$Component);

    function SharingWidget(props) {
        _classCallCheck(this, SharingWidget);

        var _this = _possibleConstructorReturn(this, (SharingWidget.__proto__ || Object.getPrototypeOf(SharingWidget)).call(this, props));

        _this.handleEvent = _this.handleEvent.bind(_this);
        _this.handleOn = _this.handleOn.bind(_this);
        _this.handleOff = _this.handleOff.bind(_this);
        _this.state = {
            "display": false
        };
        var widgetId = Math.floor(Math.random() * 9999999999);
        var eventName = 'shareWidget-' + props["config-id"] + '-' + widgetId;
        _this.eventType = _utils2.default.isMobile() ? 'touchend.' + eventName : 'click.' + eventName;
        _this.eventTimer = null;
        return _this;
    }

    _createClass(SharingWidget, [{
        key: 'handleEvent',
        value: function handleEvent(e) {
            var currentState = this.state.display;

            if (e.target.className === "groupEmail" || e.target.className.baseVal === "groupEmail" || e.target.className.baseVal === "groupEmailText") {
                _tracking2.default.pageLink('share-email');
                _emailModal2.default.open();
            }

            this.setState({ "display": !currentState });
        }
    }, {
        key: 'handleOn',
        value: function handleOn(e) {

            clearTimeout(this.eventTimer);
            this.setState({ "display": true });
        }
    }, {
        key: 'handleOff',
        value: function handleOff(e) {

            this.setState({ "display": false });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
            _tracking2.default.trackContainerLinks($this[0]);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (0, _jquery2.default)(document).off(this.eventType);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _this2 = this;

            if (!prevState.display && this.state.display) {
                (0, _jquery2.default)(document).one(this.eventType, function (e) {
                    if (e.target.className.baseVal == "groupSharing" || e.target.className.baseVal == "groupSharingText") {
                        return;
                    }
                    clearTimeout(_this2.eventTimer);
                    _this2.eventTimer = setTimeout(function () {
                        _this2.handleOff();
                    }, 100);
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var itemProps = {
                "icon-className": this.props['itemClassName'],
                "icon-facebook": this.props["icon-facebook"],
                "icon-twitter": this.props["icon-twitter"],
                "icon-google": this.props["icon-google"],
                "icon-linkedin": this.props["icon-linkedin"],
                "icon-email": this.props["icon-email"],
                "icon-display": this.state.display,
                "handleOff": this.handleOff,
                "handleOn": this.handleOn
            };
            if (this.props["pIcon-show"]) {
                var groupProps = {
                    className: this.props['itemClassName'],
                    icon: this.props['parent-icon'],
                    handleChange: this.handleEvent,
                    turnOn: this.handleOn,
                    turnOff: this.handleOff
                };
                return _react2.default.createElement(
                    'div',
                    { className: 'share-widget' },
                    _react2.default.createElement(ShareItemGroup, groupProps),
                    _react2.default.createElement(ShareItemDisplay, itemProps)
                );
            } else {
                itemProps['icon-display'] = true;
                return _react2.default.createElement(
                    'div',
                    { className: 'share-widget' },
                    _react2.default.createElement(ShareItemDisplay, itemProps)
                );
            }
        }
    }]);

    return SharingWidget;
}(_react2.default.Component);

exports.default = SharingWidget;

SharingWidget.propTypes = {
    "config-id": _react2.default.PropTypes.string,
    "icon-facebook": _react2.default.PropTypes.string,
    "icon-twitter": _react2.default.PropTypes.string,
    "icon-google": _react2.default.PropTypes.string,
    "icon-email": _react2.default.PropTypes.string,
    "icon-linkedin": _react2.default.PropTypes.string,
    "icon-group-sharing": _react2.default.PropTypes.string
};
SharingWidget.defaultProps = {
    "config-id": "share-widget",
    "icon-facebook": "default",
    "icon-twitter": "default",
    "icon-google": "default",
    "icon-email": "default",
    "icon-linkedin": "default",
    "icon-group-sharing": "default"
};

var ShareItemDisplay = function (_React$Component2) {
    _inherits(ShareItemDisplay, _React$Component2);

    function ShareItemDisplay(props) {
        _classCallCheck(this, ShareItemDisplay);

        return _possibleConstructorReturn(this, (ShareItemDisplay.__proto__ || Object.getPrototypeOf(ShareItemDisplay)).call(this, props));
    }

    _createClass(ShareItemDisplay, [{
        key: 'render',
        value: function render() {
            if (!this.props["icon-display"] || this.props['icon-className'] === "groupEmail") {
                return null;
            } else {
                var containerProps = {
                    id: "widgetContainer",
                    className: "listContainer"
                };
                if (!_utils2.default.isMobile()) {
                    containerProps.onMouseLeave = this.props.handleOff;
                    containerProps.onMouseEnter = this.props.handleOn;
                }

                return _react2.default.createElement(
                    'div',
                    containerProps,
                    _react2.default.createElement(
                        'div',
                        { className: 'listWrap' },
                        _react2.default.createElement(
                            'ul',
                            { className: 'share-widget-list' },
                            _react2.default.createElement(ShareItem, { className: 'facebook', 'button-class': 'fb-share-button', icon: this.props['icon-facebook'] }),
                            _react2.default.createElement(ShareItem, { className: 'twitter', icon: this.props['icon-twitter'] }),
                            _react2.default.createElement(ShareItem, { className: 'google', icon: this.props['icon-google'] }),
                            _react2.default.createElement(ShareItem, { className: 'linkedin', icon: this.props['icon-linkedin'] }),
                            _react2.default.createElement(ShareItem, { className: 'email', icon: this.props['icon-email'] })
                        )
                    )
                );
            }
        }
    }]);

    return ShareItemDisplay;
}(_react2.default.Component);

var ShareItemGroup = function (_React$Component3) {
    _inherits(ShareItemGroup, _React$Component3);

    function ShareItemGroup(props) {
        _classCallCheck(this, ShareItemGroup);

        return _possibleConstructorReturn(this, (ShareItemGroup.__proto__ || Object.getPrototypeOf(ShareItemGroup)).call(this, props));
    }

    _createClass(ShareItemGroup, [{
        key: 'render',
        value: function render() {
            if (this.props.icon.length > 0) {
                var icon = this.getIcon();
                var aProps = {
                    onClick: this.props.handleChange
                };
                if (!_utils2.default.isMobile()) {
                    aProps.onMouseLeave = this.props.turnOff;
                    aProps.onMouseEnter = this.props.turnOn;
                }
                return _react2.default.createElement(
                    'div',
                    { className: this.props.className },
                    _react2.default.createElement(
                        'a',
                        aProps,
                        icon
                    )
                );
            }
            return false;
        } // render

    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {} // componentDidMount


    }, {
        key: 'getIcon',
        value: function getIcon() {
            var icon = false;
            if (this.props.icon !== 'default') {

                icon = _react2.default.createElement('img', { className: 'groupEmail', src: _utils2.default.imageServer() + this.props.icon });
            } else {
                switch (this.props.className) {
                    case 'groupEmail':
                        icon = _react2.default.createElement(_icons2.default.groupEmail, null);
                        break;
                    case 'groupSharing':
                        icon = _react2.default.createElement(_icons2.default.groupSharing, null);
                        break;
                    default:
                        icon = false;
                }
            }
            return icon;
        }
    }]);

    return ShareItemGroup;
}(_react2.default.Component); // ShareItem

var ShareItem = function (_React$Component4) {
    _inherits(ShareItem, _React$Component4);

    function ShareItem(props) {
        _classCallCheck(this, ShareItem);

        return _possibleConstructorReturn(this, (ShareItem.__proto__ || Object.getPrototypeOf(ShareItem)).call(this, props));
    }

    _createClass(ShareItem, [{
        key: 'render',
        value: function render() {
            if (this.props.icon.length > 0) {
                var icon = this.getIcon();
                var linkProps = this.getLinkProps();
                return _react2.default.createElement(
                    'li',
                    { className: this.props.className },
                    _react2.default.createElement(
                        'a',
                        linkProps,
                        icon
                    )
                );
            }
            return false;
        } // render

    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {} // componentDidMount

    }, {
        key: 'getLinkProps',
        value: function getLinkProps() {
            var props = {};
            var location = encodeURIComponent(document.querySelector('meta[property="og:url"]').getAttribute('content'));
            var title = encodeURIComponent(document.querySelector('meta[property="og:title"]').getAttribute('content'));
            var pageLink = void 0,
                src = void 0;
            var url = 'javascript:void(0);';
            var onClick = this.props.className == "email" ? this.onClickEmail.bind(this) : this.onClickShare.bind(this);
            switch (this.props.className) {
                case 'facebook':
                    src = encodeURIComponent("stfb");
                    pageLink = 'share-fbook';
                    url = 'https://www.facebook.com/sharer.php?u=' + location + '&title=' + title + '&src=' + src;
                    break;
                case 'twitter':
                    src = encodeURIComponent("sttwit");
                    pageLink = 'share-twitt';
                    url = 'https://twitter.com/share?url=' + location + '&title=' + title + '&src=' + src;
                    break;
                case 'google':
                    src = encodeURIComponent("stgoogle");
                    pageLink = 'share-googl';
                    url = 'https://plusone.google.com/_/+1/confirm?url=' + location + '&title=' + title + '&src=' + src;
                    break;
                case 'linkedin':
                    src = encodeURIComponent("stlinkedin");
                    pageLink = 'share-lnkdn';
                    url = 'https://www.linkedin.com/cws/share?url=' + location + '&title=' + title + '&src=' + src;
                    break;
                case 'email':
                    pageLink = 'share-email';
                    break;
                default:
                    src = null;
            }
            props = {
                href: url,
                target: '_blank',
                "data-pageLink": pageLink,
                className: this.props["button-class"]
            };
            if (_utils2.default.isMobile()) {
                props.onTouchStart = onClick;
            } else {
                props.onClick = onClick;
            }
            return props;
        }
    }, {
        key: 'onClickEmail',
        value: function onClickEmail(e) {
            e.preventDefault();
            _tracking2.default.pageLink('share-email');
            _emailModal2.default.open();
        }
    }, {
        key: 'onClickPrint',
        value: function onClickPrint() {
            //TrackingActions.pageLink('/soc_bpm_print-v');
        }
    }, {
        key: 'onClickShare',
        value: function onClickShare(e) {
            //e.preventDefault();
            var el = e.currentTarget;
            var url = el.getAttribute('href');
            var tracking = el.dataset.pagelink;
            //window.open(url, "_blank", "width=600, height=400, scrollbars=no");
            _tracking2.default.pageLink(tracking);
            return true;
        }
    }, {
        key: 'getIcon',
        value: function getIcon() {
            var icon = false;
            if (this.props.icon !== 'default') {
                icon = _react2.default.createElement('img', { src: _utils2.default.imageServer() + this.props.icon });
            } else {
                switch (this.props.className) {
                    case 'facebook':
                        icon = _react2.default.createElement(_icons2.default.facebook, null);
                        break;
                    case 'twitter':
                        icon = _react2.default.createElement(_icons2.default.twitter, null);
                        break;
                    case 'google':
                        icon = _react2.default.createElement(_icons2.default.google, null);
                        break;
                    case 'linkedin':
                        icon = _react2.default.createElement(_SocialLinkedinOption2.default, null);
                        break;
                    case 'email':
                        if (window.medscape.user.isLoggedIn) {
                            icon = _react2.default.createElement(_icons2.default.email, null);
                        }
                        break;
                    default:
                        icon = false;
                }
            }
            return icon;
        }
    }]);

    return ShareItem;
}(_react2.default.Component); // ShareItem


ShareItem.propTypes = {
    "icon": _react2.default.PropTypes.string,
    "className": _react2.default.PropTypes.string,
    "button-class": _react2.default.PropTypes.string
};
ShareItem.defaultProps = {
    "icon": "default",
    "className": "",
    "button-class": ""
};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
import FacebookIcon from './images/share-facebook.svg';
import TwitterIcon from './images/share-twitter.svg';
import GoogleIcon from './images/share-google.svg';
import EmailIcon from './images/share-email.svg';
*/
exports.default = {
	facebook: function facebook() {
		return _react2.default.createElement(
			'svg',
			{ className: 'facebook-icon' },
			_react2.default.createElement('rect', { className: 'icon-background', rx: '3', y: '0', x: '0', width: '30', height: '30' }),
			_react2.default.createElement(
				'g',
				{ fillRule: 'evenodd' },
				_react2.default.createElement(
					'g',
					null,
					_react2.default.createElement(
						'g',
						null,
						_react2.default.createElement(
							'g',
							null,
							_react2.default.createElement('path', { className: 'icon-symbol',
								d: 'M9.72972973,11.5135795 L11.8128681,11.5135795 L11.8128681,9.52185606 C11.8128681,8.66839962 11.8128681,7.30872159 12.4760833,6.48647727 C13.1392985,5.60083333 14.0859139,5 15.6957446,5 C18.3164671,5 19.4208518,5.37942235 19.4208518,5.37942235 L18.8842416,8.38358902 C18.8842416,8.38358902 18.0320929,8.13096591 17.2111085,8.13096591 C16.4222622,8.13096591 15.6957446,8.41480114 15.6957446,9.20583333 L15.6957446,11.5135795 L19.0108466,11.5135795 L18.7586105,14.4543466 L15.6957446,14.4543466 L15.6957446,24.6665625 L11.8128681,24.6665625 L11.8128681,14.4543466 L9.72972973,14.4543466 L9.72972973,11.5135795' })
						)
					)
				)
			)
		);
	}, // facebook
	twitter: function twitter() {
		return _react2.default.createElement(
			'svg',
			{ className: 'twitter-icon' },
			_react2.default.createElement(
				'g',
				{ fillRule: 'evenodd' },
				_react2.default.createElement(
					'g',
					{ transform: 'translate(-46.000000, 0.000000)' },
					_react2.default.createElement(
						'g',
						null,
						_react2.default.createElement(
							'g',
							{ transform: 'translate(46.000000, 0.000000)' },
							_react2.default.createElement('rect', { className: 'icon-background', x: '0', y: '0', rx: '3', width: '30', height: '30' }),
							_react2.default.createElement(
								'g',
								{ className: 'icon-symbol', transform: 'translate(6.486486, 7.500000)' },
								_react2.default.createElement('path', { d: 'M16.526779,1.76050427 C15.9319971,2.01940787 15.2601672,2.20042404 14.5876173,2.27831148 C15.2860899,1.86435418 15.8290264,1.21673458 16.0616106,0.440023764 C15.4149833,0.828018582 14.6913081,1.08764337 13.9157874,1.24269706 C13.3210055,0.595077455 12.441794,0.207082638 11.4596118,0.207082638 C9.59821818,0.207082638 8.09830213,1.68261683 8.09830213,3.52162573 C8.09830213,3.78052933 8.12422483,4.01347046 8.17607022,4.27237407 C5.3836197,4.1165992 2.87559877,2.82208117 1.22086661,0.802777284 C0.936437021,1.29462202 0.755698217,1.86435418 0.755698217,2.45932765 C0.755698217,3.62475446 1.3504801,4.63512759 2.25489419,5.23010105 C1.7119577,5.20413857 1.19494392,5.04908488 0.72977552,4.81614376 L0.72977552,4.84210623 C0.72977552,6.44745282 1.89341658,7.79389581 3.44445795,8.10472437 C3.16002836,8.1826118 2.84967607,8.2078531 2.53932378,8.2078531 C2.33266228,8.2078531 2.12600078,8.1826118 1.91933928,8.15664933 C2.35858498,9.47712983 3.59999413,10.4348568 5.07326741,10.4608193 C3.90962635,11.34138 2.46227577,11.8591872 0.884591627,11.8591872 C0.600162035,11.8591872 0.341655141,11.8591872 0.0831482461,11.8332248 C1.5571416,12.7657104 3.34076716,13.3094801 5.25400621,13.3094801 C11.4596118,13.3094801 14.8461242,8.25977806 14.8461242,3.88365807 L14.8461242,3.46970077 C15.4927514,3.00309734 16.0875333,2.40812387 16.526779,1.76050427' })
							)
						)
					)
				)
			)
		);
	}, // twitter
	google: function google() {
		return _react2.default.createElement(
			'svg',
			{ className: 'google-icon' },
			_react2.default.createElement(
				'g',
				{ id: 'share-widget-google-symbols', fillRule: 'evenodd' },
				_react2.default.createElement(
					'g',
					{ id: 'share-widget-google-social', transform: 'translate(-92.000000, 0.000000)' },
					_react2.default.createElement(
						'g',
						null,
						_react2.default.createElement(
							'g',
							{ transform: 'translate(92.000000, 0.000000)' },
							_react2.default.createElement(
								'mask',
								{ id: 'share-widget-google-mask', className: 'icon-symbol' },
								_react2.default.createElement('rect', { className: 'icon-symbol', x: '0', y: '0', rx: '3', width: '30', height: '30' })
							),
							_react2.default.createElement('rect', { className: 'icon-symbol', x: '0', y: '0', rx: '3', width: '29', height: '30' }),
							_react2.default.createElement('path', { className: 'icon-background', d: 'M20.2505294,12.744147 C20.2456573,13.2409235 20.2406047,13.7402264 20.2380784,14.2371834 C19.7387756,14.2420555 19.2418186,14.2445818 18.745042,14.2471081 L18.745042,15.7350919 C19.2418186,15.7376182 19.7413019,15.7401445 20.2380784,15.7451971 C20.243131,16.2419736 20.243131,16.7389306 20.2480031,17.2382335 C20.7424338,17.2382335 21.2392104,17.2357072 21.7361674,17.2382335 C21.7386937,16.7389306 21.7410395,16.2419736 21.7460921,15.7426708 C22.2428687,15.7401445 22.7423519,15.7376182 23.2391285,15.7350919 L23.2391285,14.2471081 C22.7423519,14.2445818 22.2428687,14.2420555 21.7460921,14.2371834 C21.7435658,13.7402264 21.7386937,13.2409235 21.7361674,12.744147 L20.2505294,12.744147 Z M6.78342764,14.9911 C6.7384958,17.1732718 8.24145691,19.2554747 10.3086826,19.9346854 C12.25609,20.5888136 14.65047,20.0994354 15.9462754,18.4315438 C16.8925509,17.2631354 17.1072854,15.7051373 17.0047902,14.2496344 C15.337079,14.2346571 13.6691874,14.2397097 12.0040025,14.2420555 C12.0014762,14.8362746 12.0040025,15.4281479 12.0065288,16.022367 C13.0051345,16.0497952 14.0037402,16.0373443 15.0025263,16.0571937 C14.7502584,16.9211843 14.1760691,17.7250853 13.3046801,18.0370819 C11.6219916,18.778728 9.47482696,17.8098964 8.94556956,16.0447427 C8.30641861,14.3544753 9.35248243,12.3146779 11.0801028,11.8227735 C12.151249,11.4458152 13.2548761,11.8702316 14.1710165,12.4270978 C14.6354927,11.9925762 15.0698338,11.5282805 15.4967766,11.0589322 C14.4557653,10.1875432 13.1175543,9.65323318 11.7418098,9.77052514 C9.04283166,9.80300599 6.68093252,12.2946481 6.78342764,14.9911 Z M0.871191143,0.143201197 C1.23064588,0.00100725384 1.62510776,0.0208566622 2.00224652,0.00587938134 C10.7506026,0.0159845347 19.4991391,0.00587938134 28.2474951,0.010931958 C29.2186725,-0.108886289 30.0976404,0.77495373 29.9826943,1.74360486 C30.0027242,10.5744262 29.9902732,19.4077738 29.9902732,28.2411214 C30.1025126,29.2198777 29.2262514,30.0961388 28.2474951,30.001403 C19.4166738,30.0037489 10.5833262,30.0037489 1.75250487,30.001403 C0.773748593,30.0961388 -0.102512561,29.2198777 0.00972682082,28.2385951 C0.00972682082,19.4077738 -0.00525046002,10.5744262 0.0173056858,1.74360486 C-0.0375508609,1.0945292 0.309452887,0.46530296 0.871191143,0.143201197 L0.871191143,0.143201197 Z', mask: 'url(#share-widget-google-mask)' })
						)
					)
				)
			)
		);
	}, // google
	email: function email() {
		return _react2.default.createElement(
			'svg',
			{ className: 'google-icon' },
			_react2.default.createElement(
				'g',
				{ id: 'share-widget-google-symbols', fillRule: 'evenodd' },
				_react2.default.createElement(
					'g',
					{ id: 'share-widget-google-social', transform: 'translate(-92.000000, 5.000000)' },
					_react2.default.createElement(
						'g',
						null,
						_react2.default.createElement(
							'g',
							{ transform: 'translate(92.000000, 0.000000)' },
							_react2.default.createElement(
								'mask',
								{ id: 'share-widget-google-mask', className: 'icon-symbol' },
								_react2.default.createElement('rect', { className: 'icon-symbol', x: '0', y: '0', rx: '3', width: '30', height: '30' })
							),
							_react2.default.createElement('rect', { className: 'icon-symbol', x: '0', y: '0', rx: '3', width: '29', height: '30' }),
							_react2.default.createElement('path', { d: 'M14.4970183,11.4195261 L26.2840632,1.47980203 C26.0935144,1.41786712 25.8846061,1.38883513 25.6417606,1.38883513 C21.9812758,1.39077059 18.3219037,1.39104709 14.663366,1.39104709 L5.2241053,1.39160008 C4.56233059,1.39160008 3.90083405,1.39104709 3.23933752,1.38994111 L3.23544309,1.08662593 L3.23544309,1.38994111 C2.98341791,1.38994111 2.74947402,1.44275168 2.5188682,1.55362623 L14.4970183,11.4195261 Z M1.55249353,2.55232671 C1.44428404,2.79951337 1.39282195,3.05775984 1.39254378,3.34559128 C1.39059656,7.76481323 1.39059656,12.1837587 1.39254378,16.6029806 C1.39282195,16.8833467 1.43482614,17.1277684 1.52272896,17.3506235 L10.2301153,9.69972627 L1.55249353,2.55232671 Z M27.4596243,17.4122819 C27.5653303,17.1587359 27.6156797,16.8775403 27.616236,16.5498935 C27.6181832,15.3653883 27.617905,14.1808831 27.6176269,12.9966544 L27.6173487,9.61373628 C27.6173487,7.56905466 27.6176269,5.52437305 27.6167924,3.47941494 C27.6167924,3.0425526 27.534453,2.68670335 27.3605946,2.38283518 L18.5602983,9.80451793 L27.4596243,17.4122819 Z M2.43903241,18.3921807 C2.72249119,18.5423176 3.03042923,18.6111649 3.39928727,18.6111649 C8.8514875,18.6086764 14.302575,18.6086764 19.7536626,18.6086764 L25.6656836,18.6086764 C25.7427376,18.6086764 25.8242424,18.6078469 25.8993493,18.5992756 C26.1352404,18.5721791 26.3369162,18.5160505 26.5149472,18.4270191 L17.4868269,10.7094865 L16.9299236,11.1789753 C16.3137693,11.6985097 15.7065166,12.2105787 15.0987075,12.7220947 C14.9159476,12.8761025 14.7323531,13.0143501 14.5014691,13.0143501 C14.2722541,13.0143501 14.0853215,12.8761025 13.8986671,12.7223712 C13.683639,12.5454143 13.4680546,12.3690104 13.2527483,12.19233 C12.6276925,11.6799845 11.9812173,11.1499433 11.353658,10.6174137 C11.3375239,10.6035889 11.3241716,10.5930821 11.3138791,10.5856167 C11.3033086,10.5936351 11.2899562,10.6046949 11.2729876,10.6196256 C9.40783446,12.2678132 7.50651871,13.9375674 5.667792,15.5522991 L3.98651149,17.0290596 C3.56340962,17.4006691 3.14114228,17.7733846 2.71247694,18.1513534 L2.43903241,18.3921807 Z M8.18887826,20 C6.60940924,20 5.03021839,20 3.45074936,19.998894 C1.69825643,19.9980645 0.402246183,18.9570603 0.0678816585,17.2820527 C0.0105779214,16.9953272 0.00306723746,16.7025189 0.00306723746,16.4796638 C-0.000270844317,12.4530649 -0.000827191279,8.21135289 0.00112002309,3.51231786 C0.00167637005,1.89316228 0.917979817,0.573450936 2.3352737,0.14986037 C2.65044426,0.0558520198 2.99120677,0.00608289325 3.32112052,0.0058063981 C8.29068976,0.00110598059 13.2605372,0 18.2298282,0 L25.7277162,0.000552990295 C27.4732548,0.000552990295 28.9642647,1.44385766 28.984015,3.15232118 C29.0023745,4.74410374 29.0007054,6.36187685 28.9990364,7.92628639 C28.99848,8.51052064 28.9979237,9.09475489 28.9982019,9.67898913 C28.9998709,11.9426549 28.9995927,14.2063207 28.9982019,16.4702629 C28.9970892,18.6142063 27.6056654,19.999447 25.4537154,19.9997235 L8.18887826,20 Z' })
						)
					)
				)
			)
		);
	}, // email
	groupEmail: function groupEmail() {
		return _react2.default.createElement(
			'svg',
			{ xmlns: 'http://www.w3.org/2000/svg', height: '38', className: 'groupEmail' },
			_react2.default.createElement(
				'g',
				{ fill: 'none', fillRule: 'evenodd' },
				_react2.default.createElement(
					'g',
					{ transform: 'translate(-48)' },
					_react2.default.createElement('path', { d: 'M65.011 13.231L78.843 1.715a2.435 2.435 0 0 0-.754-.106l-12.883.003H54.13c-.776 0-1.553 0-2.329-.002l-.004-.351v.351c-.296 0-.57.062-.841.19L65.01 13.231zM49.821 2.957a2.221 2.221 0 0 0-.187.92c-.002 5.12-.002 10.24 0 15.36 0 .325.05.608.153.866l10.217-8.865-10.182-8.28zm30.401 17.217c.124-.293.183-.62.184-.999.002-1.372.002-2.745.001-4.117v-3.92-7.107c0-.506-.097-.918-.301-1.27L69.779 11.36l10.443 8.814zm-29.36 1.136c.333.174.694.253 1.127.253 6.398-.002 12.794-.002 19.19-.002h6.938a2.158 2.158 0 0 0 .997-.21L68.52 12.407l-.654.544c-.723.602-1.435 1.196-2.149 1.788-.214.179-.43.339-.7.339-.27 0-.489-.16-.708-.338-.252-.206-.505-.41-.758-.615a170.35 170.35 0 0 1-2.275-1.861 2836.883 2836.883 0 0 1-6.625 5.755l-1.973 1.71c-.497.43-.992.863-1.495 1.3l-.321.28zm6.747 1.863c-1.853 0-3.706 0-5.56-.002-2.056 0-3.577-1.207-3.97-3.147a4.748 4.748 0 0 1-.075-.93C48 14.428 47.999 9.514 48 4.069c.001-1.876 1.076-3.405 2.74-3.895.37-.11.769-.167 1.156-.167C57.73 0 63.56 0 69.391 0h8.799c2.048 0 3.798 1.673 3.82 3.652.022 1.845.02 3.72.018 5.532v9.899c-.002 2.484-1.635 4.089-4.16 4.09H57.61z', fill: '#007CB0' })
				),
				_react2.default.createElement(
					'text',
					{ fontFamily: 'ProximaNova-Regular, Proxima Nova', fontSize: '9', fill: '#1B88BF' },
					_react2.default.createElement(
						'tspan',
						{ className: 'groupEmailText', x: '5', y: '35' },
						'EMAIL'
					)
				)
			)
		);
	},
	groupSharing: function groupSharing() {
		return _react2.default.createElement(
			'svg',
			{ xmlns: 'http://www.w3.org/2000/svg', height: '38', className: 'groupSharing' },
			_react2.default.createElement(
				'g',
				{ fill: 'none', fillRule: 'evenodd' },
				_react2.default.createElement('path', { d: 'M9.094 15.423c.464-.015.781-.376.771-.88a8.14 8.14 0 0 1 .506-3.026c.485-1.299 1.258-2.218 2.362-2.811.883-.474 1.895-.706 3.093-.71a1041.481 1041.481 0 0 1 5.636-.004h1.523l-4.014 4.363-.198.216c-.218.235-.442.478-.659.724a.778.778 0 0 0 .059 1.119.786.786 0 0 0 .522.204c.21 0 .418-.089.584-.25.038-.037.075-.077.11-.117l.03-.033 5.847-6.352c.458-.498.44-.912-.06-1.384l-4.4-4.153-.918-.867-.198-.189c-.136-.13-.276-.263-.42-.394a.858.858 0 0 0-.575-.232.784.784 0 0 0-.56.235c-.311.313-.302.788.022 1.128.042.044.086.088.13.13l1.267 1.195 3.251 3.07-1.228-.002-2.064-.002c-1.362 0-2.463.004-3.466.012-.743.006-1.441.071-2.074.193-1.969.379-3.473 1.41-4.471 3.065-.86 1.427-1.262 3.034-1.228 4.911.01.495.335.841.793.841h.027zM5.66 23.835c-.995 0-1.92-.377-2.603-1.061-.686-.687-1.061-1.627-1.057-2.648.014-3.31.013-6.674.012-9.928 0-2.045-.002-4.16.001-6.24.001-.546.045-.981.138-1.371C2.497 1.142 3.87.039 5.344.02 6.637.003 7.945.002 9.174.002h.923A595.925 595.925 0 0 0 12.14 0l1.18.001c.101 0 .21.003.328.026a.76.76 0 0 1 .626.739.758.758 0 0 1-.607.794 1.333 1.333 0 0 1-.308.028h-1.52l-2.938.001c-1.082 0-2.164 0-3.247-.002-.72 0-1.266.259-1.67.791-.258.338-.383.732-.383 1.203v4.225c-.002 4.078-.003 8.296.003 12.444.002 1.169.838 1.986 2.033 1.986l4.435-.002 4.434-.002c3.092 0 5.478.004 7.739.015h.01c.577 0 1.128-.222 1.514-.61.374-.376.57-.886.565-1.475a364.75 364.75 0 0 1-.005-3.65l.002-1.576v-.043c-.001-.05-.002-.113.004-.181a.764.764 0 0 1 .705-.704.755.755 0 0 1 .825.523c.039.115.058.246.058.4l.001.992a853.98 853.98 0 0 1 0 4.253c-.007 1.64-.928 2.963-2.405 3.453a3.86 3.86 0 0 1-1.183.188c-1.625.007-3.236.008-4.457.008l-3.918-.001c-.82 0-1.64-.002-2.46-.005-.82-.003-1.639-.005-2.458-.005-1.288 0-2.346.006-3.328.02H5.66z', fill: '#007CB0' }),
				_react2.default.createElement(
					'text',
					{ fontFamily: 'ProximaNova-Regular, Proxima Nova', fontSize: '9', fill: '#1B88BF' },
					_react2.default.createElement(
						'tspan',
						{ className: 'groupSharingText', x: '0', y: '35' },
						'SHARE'
					)
				)
			)
		);
	},
	comment: function comment() {
		return _react2.default.createElement(
			'svg',
			{ width: '14px', height: '12px', viewBox: '0 0 14 12', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
			_react2.default.createElement(
				'g',
				{ id: 'Page-1', stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd' },
				_react2.default.createElement(
					'g',
					{ id: 'Buttons', transform: 'translate(-114.000000, -741.000000)', fill: '#007CB0' },
					_react2.default.createElement(
						'g',
						{ id: 'CommentsIcon', transform: 'translate(114.000000, 741.000000)' },
						_react2.default.createElement('polygon', { id: 'Fill-1', points: '10.0902481 8 11 12 6 9.23395738' }),
						_react2.default.createElement('polygon', { id: 'Fill-2', points: '0 0 14 0 14 10 0 10' })
					)
				)
			)
		);
	},
	print: function print() {
		return _react2.default.createElement(
			'svg',
			{ width: '14px', height: '13px', viewBox: '0 0 14 13', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
			_react2.default.createElement(
				'defs',
				null,
				_react2.default.createElement('polygon', { id: 'path-1', points: '0 12.1165743 13.9299392 12.1165743 13.9299392 0 0 0' })
			),
			_react2.default.createElement(
				'g',
				{ id: 'Page-1', stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd' },
				_react2.default.createElement(
					'g',
					{ id: 'Buttons', transform: 'translate(-155.000000, -1027.000000)' },
					_react2.default.createElement(
						'g',
						{ id: 'Group-2', transform: 'translate(115.000000, 954.000000)' },
						_react2.default.createElement(
							'g',
							{ id: 'Print', transform: 'translate(40.000000, 73.000000)' },
							_react2.default.createElement('path', { d: 'M11.951723,5.7697973 C11.4965684,5.7697973 11.1274662,5.40069512 11.1274662,4.94554054 C11.1274662,4.49038596 11.4965684,4.12128378 11.951723,4.12128378 C12.4068776,4.12128378 12.7759797,4.49038596 12.7759797,4.94554054 C12.7759797,5.40069512 12.4068776,5.7697973 11.951723,5.7697973 L11.951723,5.7697973 Z M3.95643243,11.1274662 L9.97350676,11.1274662 L9.97350676,6.92375676 L3.95643243,6.92375676 L3.95643243,11.1274662 L3.95643243,11.1274662 Z M13.9299392,2.96732432 L0,2.96732432 L0,8.16014189 L2.96732432,8.16014189 L2.96732432,12.1165743 L10.9626149,12.1165743 L10.9626149,8.16014189 L13.9299392,8.16014189 L13.9299392,2.96732432 L13.9299392,2.96732432 Z', id: 'Fill-1', fill: '#005B81' }),
							_react2.default.createElement(
								'mask',
								{ id: 'mask-2', fill: 'white' },
								_react2.default.createElement('use', { href: '#path-1' })
							),
							_react2.default.createElement('g', { id: 'Clip-4' }),
							_react2.default.createElement('polygon', { id: 'Fill-3', fill: '#005B81', mask: 'url(#mask-2)', points: '2.88489865 2.06064189 11.0450405 2.06064189 11.0450405 0 2.88489865 0' })
						)
					)
				)
			)
		);
	}
};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _icons = __webpack_require__(383);

var _icons2 = _interopRequireDefault(_icons);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var pageLink = 'twitter-widget';

var twitterWidgetModule = function (_React$Component) {
	_inherits(twitterWidgetModule, _React$Component);

	function twitterWidgetModule(props) {
		_classCallCheck(this, twitterWidgetModule);

		return _possibleConstructorReturn(this, (twitterWidgetModule.__proto__ || Object.getPrototypeOf(twitterWidgetModule)).call(this, props));
	}

	_createClass(twitterWidgetModule, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
			_tracking2.default.trackContainerLinks($this[0]);
			_jquery2.default.getScript("https://platform.twitter.com/widgets.js", function (data, textStatus, jqxhr) {
				_this2.initTwitter();
			});
		}
	}, {
		key: 'initTwitter',
		value: function initTwitter() {
			window.twttr.ready(function (twttr) {
				// Track user clicking Twitter's iframe
				window.addEventListener('blur', function () {
					if (document.activeElement.id.startsWith("twitter-widget")) {
						_tracking2.default.pageLink(pageLink);
					}
				});
				/*
    twttr.events.bind('click',function(ev){
    	TrackingActions.pageLink(pageLink);
    });
    */
			});
		}
	}, {
		key: 'getIcon',
		value: function getIcon() {
			var icon = void 0;
			return icon = _react2.default.createElement(_icons2.default.twitter, null);
		}
	}, {
		key: 'render',
		value: function render() {
			var accountName = "https://twitter.com/" + this.props.account;
			var limitNumber = this.props.limitNumber;
			var urlName = this.props.account;
			var icon = this.getIcon();
			var aProps = {
				onClick: function onClick(e) {
					e.preventDefault();
					var url = (0, _jquery2.default)(e.currentTarget).attr('href');
					window.open(url, "shareWindow", "width=600, height=400, scrollbars=no");
					_tracking2.default.pageLink(pageLink);
				},
				href: 'https://twitter.com/' + urlName + '/following'
			};
			var timelineProps = {
				"className": "twitter-timeline",
				"href": accountName,
				"data-chrome": "nofooter noheader transparent",
				"data-tweet-limit": limitNumber
			};
			return _react2.default.createElement(
				'div',
				{ className: 'twitter-container' },
				_react2.default.createElement(
					'div',
					{ className: 'twitter-header' },
					_react2.default.createElement(
						'h4',
						null,
						'Follow us @ ',
						urlName
					),
					_react2.default.createElement(
						'div',
						{ className: 'mysvg' },
						_react2.default.createElement(
							'a',
							aProps,
							icon
						)
					)
				),
				_react2.default.createElement(
					'ul',
					{ className: 'twitter-container' },
					_react2.default.createElement('a', timelineProps)
				)
			);
		}
	}]);

	return twitterWidgetModule;
}(_react2.default.Component);

exports.default = twitterWidgetModule;


twitterWidgetModule.propTypes = {
	"account": _react2.default.PropTypes.string,
	"limitNumber": _react2.default.PropTypes.string
};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	twitter: function twitter() {
		return _react2.default.createElement(
			'svg',
			{ className: 'twitter-icon' },
			_react2.default.createElement(
				'g',
				{ fillRule: 'evenodd' },
				_react2.default.createElement(
					'g',
					{ transform: 'translate(-46.000000, 0.000000)' },
					_react2.default.createElement(
						'g',
						null,
						_react2.default.createElement(
							'g',
							{ transform: 'translate(46.000000, 0.000000)' },
							_react2.default.createElement('rect', { className: 'icon-background', x: '0', y: '0', rx: '3', width: '30', height: '30' }),
							_react2.default.createElement(
								'g',
								{ className: 'icon-symbol', transform: 'translate(6.486486, 7.500000)' },
								_react2.default.createElement('path', { d: 'M16.526779,1.76050427 C15.9319971,2.01940787 15.2601672,2.20042404 14.5876173,2.27831148 C15.2860899,1.86435418 15.8290264,1.21673458 16.0616106,0.440023764 C15.4149833,0.828018582 14.6913081,1.08764337 13.9157874,1.24269706 C13.3210055,0.595077455 12.441794,0.207082638 11.4596118,0.207082638 C9.59821818,0.207082638 8.09830213,1.68261683 8.09830213,3.52162573 C8.09830213,3.78052933 8.12422483,4.01347046 8.17607022,4.27237407 C5.3836197,4.1165992 2.87559877,2.82208117 1.22086661,0.802777284 C0.936437021,1.29462202 0.755698217,1.86435418 0.755698217,2.45932765 C0.755698217,3.62475446 1.3504801,4.63512759 2.25489419,5.23010105 C1.7119577,5.20413857 1.19494392,5.04908488 0.72977552,4.81614376 L0.72977552,4.84210623 C0.72977552,6.44745282 1.89341658,7.79389581 3.44445795,8.10472437 C3.16002836,8.1826118 2.84967607,8.2078531 2.53932378,8.2078531 C2.33266228,8.2078531 2.12600078,8.1826118 1.91933928,8.15664933 C2.35858498,9.47712983 3.59999413,10.4348568 5.07326741,10.4608193 C3.90962635,11.34138 2.46227577,11.8591872 0.884591627,11.8591872 C0.600162035,11.8591872 0.341655141,11.8591872 0.0831482461,11.8332248 C1.5571416,12.7657104 3.34076716,13.3094801 5.25400621,13.3094801 C11.4596118,13.3094801 14.8461242,8.25977806 14.8461242,3.88365807 L14.8461242,3.46970077 C15.4927514,3.00309734 16.0875333,2.40812387 16.526779,1.76050427' })
							)
						)
					)
				)
			)
		);
	}
};

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UldBanner = function (_React$Component) {
	_inherits(UldBanner, _React$Component);

	function UldBanner(props) {
		_classCallCheck(this, UldBanner);

		var _this = _possibleConstructorReturn(this, (UldBanner.__proto__ || Object.getPrototypeOf(UldBanner)).call(this, props));

		_this.state = {
			uldVisible: true,
			textLang: 'en',
			userUpdate: "0",
			nodeHeight: 0
		};
		return _this;
	}

	_createClass(UldBanner, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.setHeaderMargin();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			var _state = this.state,
			    nodeHeight = _state.nodeHeight,
			    uldVisible = _state.uldVisible;

			if (!uldVisible && this.props.feature === "on") {
				_reactDom2.default.findDOMNode(this).parentNode.style.visibility = "hidden";
			}
			(0, _jquery2.default)('header').css('margin-top', nodeHeight);
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.getUserData();
		}
	}, {
		key: 'setHeaderMargin',
		value: function setHeaderMargin() {
			if (this.props.feature === "off") {
				(0, _jquery2.default)('.uld-banner').hide();
				return;
			}
			var nodeHeight = _reactDom2.default.findDOMNode(this).parentNode.offsetHeight;
			if (this.state.uldVisible) {
				this.setState({
					nodeHeight: nodeHeight
				});
			} else {
				_reactDom2.default.findDOMNode(this).parentNode.style.visibility = "hidden";
				this.setState({
					nodeHeight: 0
				});
			}
		}
	}, {
		key: 'onAccept',
		value: function onAccept() {
			_tracking2.default.pageLink('ulr_accept');
			this.postUserData();
			this.setState({
				uldVisible: false,
				nodeHeight: 0
			});
		}
	}, {
		key: 'onDecline',
		value: function onDecline() {
			_tracking2.default.pageLink('ulr_decline');
			this.setState({
				uldVisible: false,
				userUpdate: "0",
				nodeHeight: 0
			});
		}
	}, {
		key: 'getUserData',
		value: function getUserData() {
			var uldFlag = "0";
			if (medscape.user.userUldFlag) {
				uldFlag = medscape.user.userUldFlag;
			}
			if (uldFlag == "0") {
				this.setState({
					uldVisible: true,
					userUpdate: uldFlag
				});
			} else {
				this.setState({
					uldVisible: false,
					userUpdate: uldFlag,
					nodeHeight: 0
				});
			}
		}
	}, {
		key: 'completed',
		value: function completed(data) {
			this.setState({
				userUpdate: "1"
			});
		}
	}, {
		key: 'failed',
		value: function failed(error) {
			console.log(error);
		}
	}, {
		key: 'postUserData',
		value: function postUserData() {
			var postUrl = medscape.config.apiHost.replace("www", "api") + '/regservice/registration/pub/update/userAttributes/' + medscape.user.uldParam,
			    sfNumber = 'uld-' + infosite.config.tracking['SF-Number'];
			var data = {};
			data[sfNumber] = "1";
			_jquery2.default.ajax({
				type: 'POST',
				contentType: 'application/json',
				dataType: 'json',
				headers: { 'isencrypted': false },
				url: postUrl,
				data: JSON.stringify(data),
				xhrFields: {
					withCredentials: true
				}
			}).then(this.completed(data), this.failed);
		}
	}, {
		key: 'selectLanguage',
		value: function selectLanguage() {
			var userLang = null;
			var currentLanguage = userLang ? userLang : 'en';
			var lngContent = this.props.content.map(function (data, index) {
				return data[currentLanguage];
			});
			return lngContent;
		}
	}, {
		key: 'render',
		value: function render() {
			var thisProps = this.selectLanguage(),
			    langProps = thisProps[0],
			    contentProps = {
				className: 'content',
				dangerouslySetInnerHTML: _utils2.default.getDangerousHtml(langProps.mainText)
			},
			    acceptProps = {
				className: 'accept',
				dangerouslySetInnerHTML: _utils2.default.getDangerousHtml(langProps.acceptButtonText),
				onClick: this.onAccept.bind(this)
			},
			    declineProps = {
				className: 'decline',
				dangerouslySetInnerHTML: _utils2.default.getDangerousHtml(langProps.declineButtonText),
				onClick: this.onDecline.bind(this)
			};
			if (this.props.feature === "off") {
				return null;
			};
			return _react2.default.createElement(
				'div',
				{ className: 'uld-container' },
				_react2.default.createElement('div', contentProps),
				_react2.default.createElement(
					'div',
					{ className: 'button-container' },
					_react2.default.createElement('button', acceptProps),
					_react2.default.createElement('button', declineProps)
				)
			);
		}
	}]);

	return UldBanner;
}(_react2.default.Component);

exports.default = UldBanner;


UldBanner.propTypes = {
	"config-id": _react2.default.PropTypes.string,
	feature: _react2.default.PropTypes.string,
	content: _react2.default.PropTypes.array
};

UldBanner.defaultProps = {
	"config-id": '',
	feature: '',
	content: []
};

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _video2 = __webpack_require__(398);

var _video3 = _interopRequireDefault(_video2);

var _playlist = __webpack_require__(342);

var _playlist2 = _interopRequireDefault(_playlist);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _settings = __webpack_require__(103);

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
    Video Module
    Renders the module's title and video from the JSON config object
*/

var VideoModule = function (_React$Component) {
  _inherits(VideoModule, _React$Component);

  function VideoModule(props) {
    _classCallCheck(this, VideoModule);

    var _this = _possibleConstructorReturn(this, (VideoModule.__proto__ || Object.getPrototypeOf(VideoModule)).call(this, props));

    _this.state = {
      'video': _this.props.video,
      'amp': null,
      'isReady': false
    };
    window.VideoModule = _this;
    return _this;
  }

  _createClass(VideoModule, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.playlist != null) {
        this.initPlaylist();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.state.isReady !== nextState.isReady) {
        return true;
      }
      if (this.state.video['config-id'] != nextState.video['config-id']) {
        return true;
      }
      if (this.state.amp) {
        return false;
      } else {
        return true;
      }
    }
  }, {
    key: 'initPlaylist',
    value: function initPlaylist() {
      var _this2 = this;

      var host = window.medscape.config.staticServer.host.length == 0 ? "//img.proddev.medscapestatic.com" : window.medscape.config.staticServer.host;
      this.props.playlist.videos.forEach(function (video, index) {
        var defaultVideo = null;
        if (video.title.length == 0 || video.poster.length == 0) {
          defaultVideo = _this2.props.videos.find(function (_video) {
            return _video["config-id"] == video["video-config-id"];
          });
          video.title = video.title.length > 0 ? video.title : defaultVideo.title;
          video.poster = video.poster.length > 0 ? video.poster : defaultVideo.poster;
        }
        video.watched = false;
        video.playing = _this2.props.video['config-id'] == video['video-config-id'];
      });
    }
  }, {
    key: 'changeVideo',
    value: function changeVideo(videoId) {
      var video = this.props.videos.find(function (video) {
        return video["config-id"] == videoId;
      });
      if (video) {
        this.setState({
          "video": video
        });
      }
    }
  }, {
    key: 'setReady',
    value: function setReady() {
      this.setState({
        isReady: true
      });
    }
  }, {
    key: 'setAmp',
    value: function setAmp(amp) {
      this.setState({
        "amp": amp
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var VideoProps = {
        id: 'video_player_screen-' + this.props.index,
        config: this.state.video,
        setAmp: this.setAmp.bind(this)
      };
      var moduleClass = (0, _classnames2.default)({
        'isMobile': _utils2.default.isMobile(),
        'video-player-module': true
      });
      if (this.props.playlist != null) {
        return _react2.default.createElement(
          'div',
          { className: moduleClass },
          _react2.default.createElement(_video3.default, _extends({}, VideoProps, {
            route: this.props.route,
            setReady: this.setReady.bind(this)
          })),
          _react2.default.createElement(_playlist2.default, {
            video: this.state.video,
            amp: this.state.amp,
            videos: this.props.playlist.videos,
            carousel: this.props.playlist.carousel,
            onChangeVideo: this.changeVideo.bind(this),
            ready: this.state.isReady
          })
        );
      } else {
        return _react2.default.createElement(
          'div',
          { className: moduleClass },
          _react2.default.createElement(_video3.default, _extends({}, VideoProps, { route: this.props.route }))
        );
      }
    }
  }]);

  return VideoModule;
}(_react2.default.Component);

exports.default = VideoModule;


VideoModule.propTypes = {
  "index": _react2.default.PropTypes.number,
  "config-id": _react2.default.PropTypes.string,
  "video": _react2.default.PropTypes.object.isRequired,
  "playlist": _react2.default.PropTypes.object,
  "videos": _react2.default.PropTypes.array
};
VideoModule.defaultProps = {
  "index": 0,
  "config-id": "___",
  "video": null,
  "playlist": null,
  "videos": []
};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _seekSlider = __webpack_require__(390);

var _seekSlider2 = _interopRequireDefault(_seekSlider);

var _playPauseToggleButton = __webpack_require__(389);

var _playPauseToggleButton2 = _interopRequireDefault(_playPauseToggleButton);

var _timeLabel = __webpack_require__(391);

var _timeLabel2 = _interopRequireDefault(_timeLabel);

var _volumeController = __webpack_require__(392);

var _volumeController2 = _interopRequireDefault(_volumeController);

var _controlsStore = __webpack_require__(340);

var _controlsStore2 = _interopRequireDefault(_controlsStore);

var _fullScreenToggleButton = __webpack_require__(387);

var _fullScreenToggleButton2 = _interopRequireDefault(_fullScreenToggleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
  Player Controls

  The player controls are rendered from the current state of the <video> object.

  Each component updates/re-renders only when their property from the component's state changes.
*/

var PlayerControls = function (_Reflux$Component) {
  _inherits(PlayerControls, _Reflux$Component);

  function PlayerControls(props) {
    _classCallCheck(this, PlayerControls);

    var _this = _possibleConstructorReturn(this, (PlayerControls.__proto__ || Object.getPrototypeOf(PlayerControls)).call(this, props));

    _this.state = {};
    _this.store = _controlsStore2.default.get(props, _this.props.route);
    return _this;
  }

  _createClass(PlayerControls, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.isReady != this.state.isReady;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.store.stopListeningToAll();
      _controlsStore2.default.clearCache();
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state.isReady) {
        return false;
      }
      var controlClass = (0, _classnames2.default)({
        'video-controls': true,
        'video-buttons': true
      });
      var controlProps = {
        className: controlClass
      };
      return _react2.default.createElement(
        'div',
        controlProps,
        _react2.default.createElement(_seekSlider2.default, { ControlsStore: this.store }),
        _react2.default.createElement(
          'div',
          { className: 'play-buttons-bar' },
          _react2.default.createElement(_playPauseToggleButton2.default, { ControlsStore: this.store }),
          _react2.default.createElement(_timeLabel2.default, { ControlsStore: this.store }),
          _react2.default.createElement(_volumeController2.default, { ControlsStore: this.store }),
          _react2.default.createElement(_fullScreenToggleButton2.default, { ControlsStore: this.store })
        )
      );
    }
  }]);

  return PlayerControls;
}(_reflux2.default.Component);

exports.default = PlayerControls;


PlayerControls.propTypes = {
  "config-id": _react.PropTypes.string,
  "toggleFullscreen": _react.PropTypes.func
};
PlayerControls.defaultProps = {
  "toggleFullscreen": function toggleFullscreen() {}
};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
  Full Screen Toggle Button

  Controls whether a video player is displayed in full screen mode or not.
*/
var FullScreenToggleButton = function (_Reflux$Component) {
    _inherits(FullScreenToggleButton, _Reflux$Component);

    function FullScreenToggleButton(props) {
        _classCallCheck(this, FullScreenToggleButton);

        var _this = _possibleConstructorReturn(this, (FullScreenToggleButton.__proto__ || Object.getPrototypeOf(FullScreenToggleButton)).call(this, props));

        _this.state = {};
        _this.store = props.ControlsStore;
        _this.ControlsActions = _this.store.ControlsActions;
        return _this;
    }

    _createClass(FullScreenToggleButton, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.bindEvents();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            this.bindEvents();
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            //let $this = $(ReactDOM.findDOMNode(this));
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return nextState.isFullscreen != this.state.isFullscreen;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var ButtonProps = {
                className: (0, _classnames2.default)({
                    'fs-exit': this.state.isFullscreen,
                    'fs': !this.state.isFullscreen
                }),
                onClick: function onClick(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    _this2.ControlsActions.toggleFullscreen();
                }
            };
            return _react2.default.createElement(
                'div',
                { className: 'fullscreen' },
                _react2.default.createElement('button', ButtonProps)
            );
        }
    }]);

    return FullScreenToggleButton;
}(_reflux2.default.Component); // FullScreenToggleButton


exports.default = FullScreenToggleButton;
FullScreenToggleButton.propTypes = {
    ControlsStore: _react2.default.PropTypes.object.isRequired,
    "onClick": _react2.default.PropTypes.func
};
FullScreenToggleButton.defaultProps = {
    "onClick": function onClick() {}
};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
  Mute Toggle Button

  Controls whether the media player's audio is muted or not.
*/
var MuteToggleButton = function (_Reflux$Component) {
  _inherits(MuteToggleButton, _Reflux$Component);

  function MuteToggleButton(props) {
    _classCallCheck(this, MuteToggleButton);

    var _this = _possibleConstructorReturn(this, (MuteToggleButton.__proto__ || Object.getPrototypeOf(MuteToggleButton)).call(this, props));

    _this.state = {};
    _this.store = props.ControlsStore;
    _this.ControlsActions = _this.store.ControlsActions;
    return _this;
  }

  _createClass(MuteToggleButton, [{
    key: 'getMuteButtonClass',
    value: function getMuteButtonClass() {
      return (0, _classnames2.default)({
        'unmute': this.state.volume == 0,
        'volume-low': this.state.volume > 0 && this.state.volume <= 0.33,
        'volume-med': this.state.volume > 0.33 && this.state.volume <= 0.66,
        'volume-high': this.state.volume > 0.66
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.bindEvents();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this.bindEvents();
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      //let $this = $(ReactDOM.findDOMNode(this));
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.volume != this.state.volume;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var muteButtonClass = this.getMuteButtonClass();
      var muteButtonProps = {
        className: muteButtonClass,
        onClick: function onClick(e) {
          e.preventDefault();
          _this2.ControlsActions.toggleMute();
        }
      };
      return _react2.default.createElement(
        'div',
        { className: 'button-mute' },
        _react2.default.createElement('button', muteButtonProps)
      );
    }
  }]);

  return MuteToggleButton;
}(_reflux2.default.Component); // MuteToggleButton


exports.default = MuteToggleButton;
MuteToggleButton.propTypes = {
  ControlsStore: _react2.default.PropTypes.object.isRequired
};
MuteToggleButton.defaultProps = {};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
  Play/Pause Toggle Button

  Controls whether the media player's media is playing or paused.
*/
var PlayPauseToggleButton = function (_Reflux$Component) {
  _inherits(PlayPauseToggleButton, _Reflux$Component);

  function PlayPauseToggleButton(props) {
    _classCallCheck(this, PlayPauseToggleButton);

    var _this = _possibleConstructorReturn(this, (PlayPauseToggleButton.__proto__ || Object.getPrototypeOf(PlayPauseToggleButton)).call(this, props));

    _this.state = {};
    _this.store = props.ControlsStore;
    _this.ControlsActions = _this.store.ControlsActions;
    return _this;
  }

  _createClass(PlayPauseToggleButton, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.isPause != this.state.isPause;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var buttonClass = (0, _classnames2.default)({
        'play': this.state.isPause,
        'pause': !this.state.isPause
      });
      var buttonProps = {
        className: buttonClass,
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopPropagation();
          _this2.ControlsActions.togglePlayPause();
        }
      };
      return _react2.default.createElement(
        'div',
        { className: 'playpause' },
        _react2.default.createElement('button', buttonProps)
      );
    }
  }]);

  return PlayPauseToggleButton;
}(_reflux2.default.Component);

exports.default = PlayPauseToggleButton;


PlayPauseToggleButton.propTypes = {
  ControlsStore: _react2.default.PropTypes.object.isRequired
};
PlayPauseToggleButton.defaultProps = {};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
  Seek Slider
  
  Displays and changes the current time of the playing media.
*/
var SeekSlider = function (_Reflux$Component) {
    _inherits(SeekSlider, _Reflux$Component);

    function SeekSlider(props) {
        _classCallCheck(this, SeekSlider);

        var _this = _possibleConstructorReturn(this, (SeekSlider.__proto__ || Object.getPrototypeOf(SeekSlider)).call(this, props));

        _this.state = {
            isDraggable: false
        };
        _this.store = props.ControlsStore;
        _this.ControlsActions = _this.store.ControlsActions;
        _this.video = _this.store.video;
        _this.timeDebounceTimeout = null;
        return _this;
    }

    _createClass(SeekSlider, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.bindEvents();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            this.bindEvents();
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            var _this2 = this;

            var eventNames = 'mouseup.' + this.video + ' touchend.' + this.video + ' touchcancel.' + this.video;
            (0, _jquery2.default)(document).off(eventNames).on(eventNames, function (e) {
                _this2.state.isDraggable = false;
            });
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return false;
        }
    }, {
        key: 'doDrag',
        value: function doDrag(e) {
            if (!this.state.isDraggable) return;
            var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
            var sliderLeft = $this.offset().left;
            var sliderWidth = $this.width();
            var cursorPageX = e.nativeEvent ? e.nativeEvent.pageX : e.pageX;
            var cursorSliderPos = cursorPageX - sliderLeft;
            var newSliderPos = cursorSliderPos / sliderWidth;
            var newTime = this.state.duration * newSliderPos;
            if (newTime < 0) {
                newTime = 0;
            } else if (newTime > this.state.duration) {
                newTime = this.state.duration;
            }
            this.ControlsActions.changeCurrentTime(newTime);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var SeekSliderWrapperProps = {
                className: (0, _classnames2.default)({
                    'video-progress': true,
                    'on-progress-drag': true
                }),
                onMouseMove: function onMouseMove(e) {
                    _this3.doDrag(e);
                },
                onTouchMove: function onTouchMove(e) {
                    _this3.doDrag(e);
                },
                onMouseLeave: function onMouseLeave(e) {
                    _this3.doDrag(e);
                    _this3.timeDebounceTimeout = setTimeout(function () {
                        _this3.state.isDraggable = false;
                    }, 300);
                },
                onMouseEnter: function onMouseEnter(e) {
                    clearTimeout(_this3.timeDebounceTimeout);
                },
                onClick: function onClick(e) {
                    e.preventDefault();
                    _this3.state.isDraggable = true;
                    _this3.doDrag(e);
                    _this3.state.isDraggable = false;
                }
            };
            var SeekDragButtonProps = {
                ControlsStore: this.store,
                onDraggable: function onDraggable(flag) {
                    _this3.state.isDraggable = flag;
                }
            };

            return _react2.default.createElement(
                'div',
                SeekSliderWrapperProps,
                _react2.default.createElement(
                    'div',
                    { className: 'not-value' },
                    _react2.default.createElement(CurrentTimeBar, { video: this.props.video, ControlsStore: this.props.ControlsStore }),
                    _react2.default.createElement(DragButton, SeekDragButtonProps)
                )
            );
        }
    }]);

    return SeekSlider;
}(_reflux2.default.Component);

exports.default = SeekSlider;


SeekSlider.propTypes = {
    ControlsStore: _react2.default.PropTypes.object.isRequired
};
SeekSlider.defaultProps = {};

var CurrentTimeBar = function (_Reflux$Component2) {
    _inherits(CurrentTimeBar, _Reflux$Component2);

    function CurrentTimeBar(props) {
        _classCallCheck(this, CurrentTimeBar);

        var _this4 = _possibleConstructorReturn(this, (CurrentTimeBar.__proto__ || Object.getPrototypeOf(CurrentTimeBar)).call(this, props));

        _this4.state = {};
        _this4.store = props.ControlsStore;
        _this4.ControlsActions = _this4.store.ControlsActions;
        return _this4;
    }

    _createClass(CurrentTimeBar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            //let $this = $(ReactDOM.findDOMNode(this));
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return nextState.currentTime != this.state.currentTime || nextState.duration != this.state.duration;
        }
    }, {
        key: 'render',
        value: function render() {
            var width = this.state.currentTime / this.state.duration * 100;
            var BarProps = {
                className: "seekslider",
                style: {
                    width: width + '%'
                }
            };
            return _react2.default.createElement('div', BarProps);
        }
    }]);

    return CurrentTimeBar;
}(_reflux2.default.Component);

CurrentTimeBar.propTypes = {
    ControlsStore: _react2.default.PropTypes.object
};
CurrentTimeBar.defaultProps = {};

var DragButton = function (_Reflux$Component3) {
    _inherits(DragButton, _Reflux$Component3);

    function DragButton(props) {
        _classCallCheck(this, DragButton);

        var _this5 = _possibleConstructorReturn(this, (DragButton.__proto__ || Object.getPrototypeOf(DragButton)).call(this, props));

        _this5.state = {};
        _this5.store = props.ControlsStore;
        _this5.ControlsActions = _this5.store.ControlsActions;
        return _this5;
    }

    _createClass(DragButton, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            //let $this = $(ReactDOM.findDOMNode(this));
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return nextState.currentTime != this.state.currentTime || nextState.duration != this.state.duration;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            var leftPos = this.state.currentTime / this.state.duration * 100;
            if (this.state.currentTime >= this.state.duration) {
                leftPos = 100;
            }
            var style = {
                left: leftPos + '%'
            };
            if (leftPos > 50) {
                style = {
                    right: 100 - leftPos + '%'
                };
            }
            var DragProps = {
                className: 'progress-drag',
                style: style,
                onMouseDown: function onMouseDown(e) {
                    _this6.props.onDraggable(true);
                },
                onTouchStart: function onTouchStart(e) {
                    _this6.props.onDraggable(e);
                }
            };
            return _react2.default.createElement('div', DragProps);
        }
    }]);

    return DragButton;
}(_reflux2.default.Component);

DragButton.propTypes = {
    ControlsStore: _react2.default.PropTypes.object.isRequired,
    onDraggable: _react2.default.PropTypes.func.isRequired
};
DragButton.defaultProps = {};

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _2 = __webpack_require__(42);

var _3 = _interopRequireDefault(_2);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
  Time Label

  Displays the current time and the total time of the playing media.
*/
var TimeLabel = function (_React$Component) {
  _inherits(TimeLabel, _React$Component);

  function TimeLabel(props) {
    _classCallCheck(this, TimeLabel);

    var _this = _possibleConstructorReturn(this, (TimeLabel.__proto__ || Object.getPrototypeOf(TimeLabel)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(TimeLabel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var TimeProps = {
        ControlsStore: this.props.ControlsStore,
        getPrettyTime: function getPrettyTime(seconds) {
          return _utils2.default.secondsToPrettyTime(seconds);
        }
      };
      return _react2.default.createElement(
        'div',
        { className: 'duration' },
        _react2.default.createElement(CurrentTime, TimeProps),
        _react2.default.createElement(
          'span',
          { className: 'separator' },
          '/'
        ),
        _react2.default.createElement(DurationTime, TimeProps)
      );
    }
  }]);

  return TimeLabel;
}(_react2.default.Component);

exports.default = TimeLabel;


TimeLabel.propTypes = {
  ControlsStore: _react2.default.PropTypes.object.isRequired
};
TimeLabel.defaultProps = {};

var CurrentTime = function (_Reflux$Component) {
  _inherits(CurrentTime, _Reflux$Component);

  function CurrentTime(props) {
    _classCallCheck(this, CurrentTime);

    var _this2 = _possibleConstructorReturn(this, (CurrentTime.__proto__ || Object.getPrototypeOf(CurrentTime)).call(this, props));

    _this2.state = {};
    _this2.store = props.ControlsStore;
    return _this2;
  }

  _createClass(CurrentTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.currentTime != this.state.currentTime;
    }
  }, {
    key: 'render',
    value: function render() {
      var time = this.props.getPrettyTime(this.state.currentTime);
      return _react2.default.createElement(
        'span',
        { className: 'curtimetext' },
        time
      );
    }
  }]);

  return CurrentTime;
}(_reflux2.default.Component);

CurrentTime.propTypes = {
  ControlsStore: _react2.default.PropTypes.object.isRequired,
  getPrettyTime: _react2.default.PropTypes.func.isRequired
};
CurrentTime.defaultProps = {};

var DurationTime = function (_Reflux$Component2) {
  _inherits(DurationTime, _Reflux$Component2);

  function DurationTime(props) {
    _classCallCheck(this, DurationTime);

    var _this3 = _possibleConstructorReturn(this, (DurationTime.__proto__ || Object.getPrototypeOf(DurationTime)).call(this, props));

    _this3.state = {};
    _this3.store = props.ControlsStore;
    return _this3;
  }

  _createClass(DurationTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.duration != this.state.duration;
    }
  }, {
    key: 'render',
    value: function render() {
      var time = this.props.getPrettyTime(this.state.duration);
      return _react2.default.createElement(
        'span',
        { className: 'durtimetext' },
        time
      );
    }
  }]);

  return DurationTime;
}(_reflux2.default.Component);

DurationTime.propTypes = {
  ControlsStore: _react2.default.PropTypes.object.isRequired,
  getPrettyTime: _react2.default.PropTypes.func.isRequired
};
DurationTime.defaultProps = {};

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _volumeSlider = __webpack_require__(393);

var _volumeSlider2 = _interopRequireDefault(_volumeSlider);

var _muteToggleButton = __webpack_require__(388);

var _muteToggleButton2 = _interopRequireDefault(_muteToggleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
  Volume Controller

  A Wrapper for the Volume Slider and the Mute Toggle Button
*/
var VolumeController = function (_React$Component) {
  _inherits(VolumeController, _React$Component);

  function VolumeController(props) {
    _classCallCheck(this, VolumeController);

    return _possibleConstructorReturn(this, (VolumeController.__proto__ || Object.getPrototypeOf(VolumeController)).call(this, props));
  }

  _createClass(VolumeController, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return false;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var VolumeWrapProps = {
        className: (0, _classnames2.default)({
          'volume-wrap': true,
          'volume-bar-background': true
        })
      };
      return _react2.default.createElement(
        'div',
        VolumeWrapProps,
        _react2.default.createElement(_volumeSlider2.default, { ControlsStore: this.props.ControlsStore }),
        _react2.default.createElement(_muteToggleButton2.default, { ControlsStore: this.props.ControlsStore })
      );
    }
  }]);

  return VolumeController;
}(_react2.default.Component);

exports.default = VolumeController;


VolumeController.propTypes = {
  ControlsStore: _react2.default.PropTypes.object.isRequired
};
VolumeController.defaultProps = {};

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
  Volume Slider
  
  Changes the current volume of the playing media.
*/
var VolumeSlider = function (_React$Component) {
  _inherits(VolumeSlider, _React$Component);

  function VolumeSlider(props) {
    _classCallCheck(this, VolumeSlider);

    var _this = _possibleConstructorReturn(this, (VolumeSlider.__proto__ || Object.getPrototypeOf(VolumeSlider)).call(this, props));

    _this.state = {
      isDraggable: false
    };
    _this.ControlsActions = props.ControlsStore.ControlsActions;
    return _this;
  }

  _createClass(VolumeSlider, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return false;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var eventName = 'mouseup.VideoVolumeSlider-' + this.props.video;
      (0, _jquery2.default)(document).off(eventName).on(eventName, function (e) {
        _this2.setState({
          isDraggable: false
        });
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var eventName = 'mouseup.VideoVolumeSlider-' + this.props.video;
      (0, _jquery2.default)(document).off(eventName);
    }
  }, {
    key: 'doDrag',
    value: function doDrag(e) {
      if (!this.state.isDraggable) return;
      var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
      var cursorPageY = e.nativeEvent.pageY;
      var $dragEl = (0, _jquery2.default)(this.dragEl);
      var $volumeEl = $this.find('.volume');
      var thisTop = $this.offset().top;
      var volumeTop = $volumeEl.offset().top;
      var volumeHeight = $volumeEl.height();
      var dragElHeight = $dragEl.height();
      var offsetTop = cursorPageY - volumeTop - dragElHeight / 2;
      var volume = 1 - offsetTop / volumeHeight;
      if (volume > 1) {
        volume = 1;
      } else if (volume < 0) {
        volume = 0;
      }
      this.ControlsActions.changeVolume(volume);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var VolumeSliderProps = {
        className: (0, _classnames2.default)({
          'volume-bar-wrap': true
        }),
        onMouseMove: function onMouseMove(e) {
          _this3.doDrag(e);
        }
      };
      var DragButtonProps = {
        ControlsStore: this.props.ControlsStore,
        onDraggable: function onDraggable(e) {
          e.preventDefault();
          _this3.dragEl = e.target;
          _this3.state.isDraggable = true;
        }
      };

      return _react2.default.createElement(
        'div',
        VolumeSliderProps,
        _react2.default.createElement(
          'div',
          { className: 'volume-bar' },
          _react2.default.createElement(
            'div',
            { className: 'volume-inner' },
            _react2.default.createElement('div', { className: 'not-volume' }),
            _react2.default.createElement(
              'div',
              { className: 'volume' },
              _react2.default.createElement(VolumeDragButton, DragButtonProps)
            )
          )
        )
      );
    }
  }]);

  return VolumeSlider;
}(_react2.default.Component);

exports.default = VolumeSlider;


VolumeSlider.propTypes = {
  ControlsStore: _react2.default.PropTypes.object
};
VolumeSlider.defaultProps = {};

var VolumeDragButton = function (_Reflux$Component) {
  _inherits(VolumeDragButton, _Reflux$Component);

  function VolumeDragButton(props) {
    _classCallCheck(this, VolumeDragButton);

    var _this4 = _possibleConstructorReturn(this, (VolumeDragButton.__proto__ || Object.getPrototypeOf(VolumeDragButton)).call(this, props));

    _this4.state = {};
    _this4.store = props.ControlsStore;
    return _this4;
  }

  _createClass(VolumeDragButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      //let $this = $(ReactDOM.findDOMNode(this));
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.volume != this.state.volume;
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {}
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var topPos = (1 - this.state.volume) * 100;
      var volumeDragProps = {
        className: "volume-drag",
        style: {
          top: topPos + '%'
        },
        onMouseDown: function onMouseDown(e) {
          _this5.props.onDraggable(e);
        },
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopPropagation();
        }
      };
      return _react2.default.createElement('div', volumeDragProps);
    }
  }]);

  return VolumeDragButton;
}(_reflux2.default.Component);

VolumeDragButton.propTypes = {
  ControlsStore: _react2.default.PropTypes.object.isRequired,
  onDraggable: _react2.default.PropTypes.func.isRequired
};
VolumeDragButton.defaultProps = {};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _Previous = __webpack_require__(166);

var _Previous2 = _interopRequireDefault(_Previous);

var _Next = __webpack_require__(165);

var _Next2 = _interopRequireDefault(_Next);

var _Up = __webpack_require__(251);

var _Up2 = _interopRequireDefault(_Up);

var _Down = __webpack_require__(76);

var _Down2 = _interopRequireDefault(_Down);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _reactSlick = __webpack_require__(297);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _videoItem = __webpack_require__(395);

var _videoItem2 = _interopRequireDefault(_videoItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Playlist = function (_React$Component) {
  _inherits(Playlist, _React$Component);

  function Playlist(props) {
    _classCallCheck(this, Playlist);

    var _this = _possibleConstructorReturn(this, (Playlist.__proto__ || Object.getPrototypeOf(Playlist)).call(this, props));

    _this.state = {
      index: props.carousel.initialSlide,
      playIndex: props.carousel.initialSlide,
      ended: false
    };
    _this.amp = null;
    return _this;
  }

  _createClass(Playlist, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.playlist = this.refs.slider;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.playlist = null;
      if (this.amp != null) {
        var mediaElement = this.amp.getMediaElement();
        (0, _jquery2.default)(mediaElement).off('ended.playlist');
        (0, _jquery2.default)(mediaElement).off('playing.playlist');
        this.amp = null;
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      var _this2 = this;

      if (nextProps.ready === true) {
        this.amp = nextProps.amp;
        var mediaElement = this.amp.getMediaElement();
        (0, _jquery2.default)(mediaElement).off('ended.playlist').on('ended.playlist', function () {
          _this2.doWatched();
        });
        (0, _jquery2.default)(mediaElement).off('playing.playlist').on('playing.playlist', function () {
          if (_this2.state.ended) {
            _this2.setState({
              ended: false
            });
          }
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var slideTo = this.state.playIndex - this.props.carousel.slidesToShow + 1;
      if (this.state.playIndex < this.state.index || this.state.playIndex > this.state.index + this.props.carousel.slidesToShow - 1) {
        this.refs.slider.slickGoTo(slideTo);
      }
    }
  }, {
    key: 'doAfterChange',
    value: function doAfterChange(index) {
      this.state.index = index;
    }
  }, {
    key: 'doBeforeChange',
    value: function doBeforeChange(currIndex, nextIndex) {}
  }, {
    key: 'doWatched',
    value: function doWatched() {

      var nextIndex = 0;
      for (var i = 0; i < this.props.videos.length; i++) {
        if (this.props.videos[i]["video-config-id"] == this.props.video["config-id"]) {
          nextIndex = i + 1;
          this.props.videos[i].watched = true;
          break;
        }
      }

      if (nextIndex < this.props.videos.length) {
        var nextVideo = this.props.videos[nextIndex];
        this.props.onChangeVideo(nextVideo["video-config-id"]);
      } else {
        this.setState({
          ended: true
        });
      }
    }
  }, {
    key: 'getSlides',
    value: function getSlides() {
      var _this3 = this;

      var slides = this.props.videos.map(function (video, index) {
        var key = 'playlist-slide-' + video["video-config-id"];
        video.playing = !_this3.state.ended && _this3.props.video["config-id"] == video["video-config-id"];
        if (video.playing) {
          _this3.state.playIndex = index;
        }
        return _react2.default.createElement(
          'div',
          { key: key, className: 'playlist-slider-item' },
          _react2.default.createElement(_videoItem2.default, _extends({}, video, { onClick: _this3.props.onChangeVideo }))
        );
      });
      return slides;
    }
  }, {
    key: 'isVertical',
    value: function isVertical() {
      var isVertical = this.props.carousel.vertical;
      if (this.refs.slider && this.refs.slider.state.breakpoint != null) {
        var slider = this.refs.slider;
        var breakpoint = this.props.carousel.responsive.find(function (responsive) {
          return responsive.breakpoint == slider.state.breakpoint;
        });
        if (breakpoint != null && breakpoint.settings.vertical != null) {
          isVertical = breakpoint.settings.vertical;
        }
      }
      return isVertical;
    }
  }, {
    key: 'render',
    value: function render() {
      var Settings = {
        ref: 'slider',
        prevArrow: _react2.default.createElement(PrevArrow, { isVertical: this.isVertical.bind(this) }),
        nextArrow: _react2.default.createElement(NextArrow, { isVertical: this.isVertical.bind(this) }),
        afterChange: this.doAfterChange.bind(this),
        beforeChange: this.doBeforeChange.bind(this)
      };
      var slider = _jquery2.default.extend({}, Settings, this.props.carousel);
      return _react2.default.createElement(
        'div',
        { className: 'playlist-component' },
        _react2.default.createElement(
          _reactSlick2.default,
          slider,
          this.getSlides()
        )
      );
    }
  }]);

  return Playlist;
}(_react2.default.Component);

exports.default = Playlist;


Playlist.propTypes = {
  "video": _react.PropTypes.object,
  "videos": _react.PropTypes.array,
  "carousel": _react.PropTypes.object,
  "onChangeVideo": _react.PropTypes.func,
  "amp": _react.PropTypes.object
};
Playlist.defaultProps = {
  "videos": [],
  "carousel": {},
  "onChangeVideo": function onChangeVideo() {},
  "amp": null
};

var PrevArrow = function (_React$Component2) {
  _inherits(PrevArrow, _React$Component2);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, (PrevArrow.__proto__ || Object.getPrototypeOf(PrevArrow)).apply(this, arguments));
  }

  _createClass(PrevArrow, [{
    key: 'render',
    value: function render() {
      var classNames = (0, _classnames2.default)({
        'carousel-arrow': true,
        'previous-button': true
      });
      var buttonProps = {
        className: classNames + ' ' + this.props.className,
        onClick: this.props.onClick,
        title: "Previous"
      };
      if (this.props.isVertical()) {
        return _react2.default.createElement(
          'button',
          buttonProps,
          _react2.default.createElement(
            'span',
            { className: 'icon-container' },
            _react2.default.createElement(_Up2.default, null)
          )
        );
      }
      return _react2.default.createElement(
        'button',
        buttonProps,
        _react2.default.createElement(
          'span',
          { className: 'icon-container' },
          _react2.default.createElement(_Previous2.default, null)
        )
      );
    }
  }]);

  return PrevArrow;
}(_react2.default.Component);

PrevArrow.propTypes = {
  "isVertical": _react.PropTypes.func
};
PrevArrow.defaultProps = {
  "isVertical": function isVertical() {
    return false;
  }
};

var NextArrow = function (_React$Component3) {
  _inherits(NextArrow, _React$Component3);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, (NextArrow.__proto__ || Object.getPrototypeOf(NextArrow)).apply(this, arguments));
  }

  _createClass(NextArrow, [{
    key: 'render',
    value: function render() {
      var classNames = (0, _classnames2.default)({
        'carousel-arrow': true,
        'next-button': true
      });
      var buttonProps = {
        className: classNames + ' ' + this.props.className,
        onClick: this.props.onClick,
        title: "Next"
      };
      if (this.props.isVertical()) {
        return _react2.default.createElement(
          'button',
          buttonProps,
          _react2.default.createElement(
            'span',
            { className: 'icon-container' },
            _react2.default.createElement(_Down2.default, null)
          )
        );
      }
      return _react2.default.createElement(
        'button',
        buttonProps,
        _react2.default.createElement(
          'span',
          { className: 'icon-container' },
          _react2.default.createElement(_Next2.default, null)
        )
      );
    }
  }]);

  return NextArrow;
}(_react2.default.Component);

NextArrow.propTypes = {
  "isVertical": _react.PropTypes.func
};
NextArrow.defaultProps = {
  "isVertical": function isVertical() {
    return false;
  }
};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _CirclePlay = __webpack_require__(675);

var _CirclePlay2 = _interopRequireDefault(_CirclePlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isLocal = window.medscape.config.env == 'localhost';
var imageServerHost = isLocal ? '//img.proddev.medscapestatic.com' : window.medscape.config.staticServer.host;

var VideoItem = function (_React$Component) {
  _inherits(VideoItem, _React$Component);

  function VideoItem(props) {
    _classCallCheck(this, VideoItem);

    var _this = _possibleConstructorReturn(this, (VideoItem.__proto__ || Object.getPrototypeOf(VideoItem)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(VideoItem, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {}
  }, {
    key: 'getPosterContainer',
    value: function getPosterContainer() {
      var poster = this.props.poster.replace(/^en\//, '');
      poster = _utils2.default.getCompiledHtml(poster);
      poster = poster.startsWith('/build/') || poster.startsWith('http') ? poster : '' + imageServerHost + poster;
      return {
        className: (0, _classnames2.default)({
          "poster-container": true
        }),
        style: {
          backgroundImage: 'url(' + poster + ')'
        }
      };
    }
  }, {
    key: 'getVideoItemContainer',
    value: function getVideoItemContainer() {
      var _this2 = this;

      return {
        className: (0, _classnames2.default)({
          "video-item-container": true,
          "watched": this.props.watched,
          "playing": this.props.playing
        }),
        onClick: function onClick(e) {
          e.preventDefault();
          if (!_this2.props.playing) {
            _this2.props.onClick(_this2.props["video-config-id"]);
          }
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var title = _utils2.default.getDangerousHtml(this.props.title);
      var description = _utils2.default.getDangerousHtml(this.props.description);
      return _react2.default.createElement(
        'div',
        this.getVideoItemContainer(),
        _react2.default.createElement(
          'div',
          this.getPosterContainer(),
          _react2.default.createElement(
            'span',
            { className: 'play-icon' },
            _react2.default.createElement(_CirclePlay2.default, null)
          ),
          _react2.default.createElement(Label, { watched: this.props.watched, playing: this.props.playing })
        ),
        _react2.default.createElement(
          'div',
          { className: 'description' },
          _react2.default.createElement('span', { dangerouslySetInnerHTML: description })
        ),
        _react2.default.createElement(
          'div',
          { className: 'title' },
          _react2.default.createElement('span', { dangerouslySetInnerHTML: title })
        )
      );
    }
  }]);

  return VideoItem;
}(_react2.default.Component);

exports.default = VideoItem;


VideoItem.propTypes = {
  "video-config-id": _react.PropTypes.string.isRequired,
  "title": _react.PropTypes.string,
  "poster": _react.PropTypes.string,
  "description": _react.PropTypes.string,
  "watched": _react.PropTypes.bool,
  "playing": _react.PropTypes.bool,
  "onClick": _react.PropTypes.func
};
VideoItem.defaultProps = {
  "label": "",
  "title": "",
  "poster": "",
  "description": "",
  "watched": false,
  "playing": false,
  "onClick": function onClick() {}
};

var Label = function (_React$Component2) {
  _inherits(Label, _React$Component2);

  function Label() {
    _classCallCheck(this, Label);

    return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
  }

  _createClass(Label, [{
    key: 'render',
    value: function render() {
      if (this.props.playing) {
        return _react2.default.createElement(
          'div',
          { className: 'label playing' },
          'Now Playing'
        );
      } else if (this.props.watched) {
        return _react2.default.createElement(
          'div',
          { className: 'label watched' },
          'Watched'
        );
      }
      return false;
    }
  }]);

  return Label;
}(_react2.default.Component);

Label.propTypes = {
  "watched": _react.PropTypes.bool,
  "playing": _react.PropTypes.bool
};
Label.defaultProps = {
  "watched": false,
  "playing": false
};

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _tapForSoundStore = __webpack_require__(397);

var _tapForSoundStore2 = _interopRequireDefault(_tapForSoundStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TapForSoundLayer = function (_Reflux$Component) {
    _inherits(TapForSoundLayer, _Reflux$Component);

    function TapForSoundLayer(props) {
        _classCallCheck(this, TapForSoundLayer);

        var _this = _possibleConstructorReturn(this, (TapForSoundLayer.__proto__ || Object.getPrototypeOf(TapForSoundLayer)).call(this, props));

        _this.state = {};
        _this.store = new _tapForSoundStore2.default(props);
        return _this;
    }

    _createClass(TapForSoundLayer, [{
        key: 'initEvents',
        value: function initEvents() {
            var _this2 = this;

            $(this.refs['tap-' + this.props.config]).on('click.TapForSound', function (e) {
                _this2.props.onSetMuted(false);
            });
            /*
            $(document).on('scroll.TapForSound', (e) => {
                this.props.onSetMuted(false);
            });
            */
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return nextState.isVisible != this.state.isVisible || this.props.mediaApi == null && nextProps.mediaApi != null;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.initEvents();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.state.isVisible == false) {
                $(document).off('click.TapForSound');
                //$(document).off('scroll.TapForSound');
            }
        }
    }, {
        key: 'doClick',
        value: function doClick(e) {
            this.setState({ isVisible: false });
            e.preventDefault();
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            this.props.onSetMuted(false);
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.isVisible == false) {
                return null;
            }
            return _react2.default.createElement(
                'div',
                { onClick: this.doClick.bind(this), ref: 'tap-' + this.props.config, className: 'tap-for-sound-layer' },
                _react2.default.createElement(
                    'div',
                    { className: 'tap-for-sound-button', role: 'button' },
                    _react2.default.createElement('span', { className: 'video-player-volume-muted-button' }),
                    _react2.default.createElement(
                        'span',
                        { className: 'label' },
                        ' Tap for Sound '
                    )
                )
            );
        }
    }]);

    return TapForSoundLayer;
}(_reflux2.default.Component);

exports.default = TapForSoundLayer;


TapForSoundLayer.propTypes = {
    'config': _react.PropTypes.string,
    'onSetMuted': _react.PropTypes.func

};

TapForSoundLayer.defaultProps = {
    'config': '',
    'onSetMuted': function onSetMuted() {}
};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _videoActionsFactory = __webpack_require__(134);

var _videoActionsFactory2 = _interopRequireDefault(_videoActionsFactory);

var _controlsActionsFactory = __webpack_require__(133);

var _controlsActionsFactory2 = _interopRequireDefault(_controlsActionsFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import TapForSoundActions from './tap-for-sound-actions';


var TapForSoundStore = function (_Reflux$Store) {
  _inherits(TapForSoundStore, _Reflux$Store);

  function TapForSoundStore(props) {
    _classCallCheck(this, TapForSoundStore);

    var _this = _possibleConstructorReturn(this, (TapForSoundStore.__proto__ || Object.getPrototypeOf(TapForSoundStore)).call(this, props));

    _this.videoActions = _videoActionsFactory2.default.get(props.config, props.route);
    _this.controlsActions = _controlsActionsFactory2.default.get(props.config, props.route);
    _this.state = _this.getInitialState();
    _this.listenTo(_this.videoActions.volumechange, 'onVideoVolumeChange');
    return _this;
  }

  _createClass(TapForSoundStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        isVisible: true
      };
    }
  }, {
    key: 'onVideoVolumeChange',
    value: function onVideoVolumeChange(mediaApi) {
      this.controlsActions.setVolume(mediaApi.getVolume());
      if (mediaApi.getMuted() == false || mediaApi.getVolume() > 0) {
        this.stopListeningTo(this.videoActions.volumechange);
        this.setState({
          isVisible: false
        });
      }
    }
  }]);

  return TapForSoundStore;
}(_reflux2.default.Store);

exports.default = TapForSoundStore;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(862);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _playerControls = __webpack_require__(341);

var _playerControls2 = _interopRequireDefault(_playerControls);

var _videoStore = __webpack_require__(343);

var _videoStore2 = _interopRequireDefault(_videoStore);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _settings = __webpack_require__(103);

var _settings2 = _interopRequireDefault(_settings);

var _videoTrackingStore = __webpack_require__(344);

var _videoTrackingStore2 = _interopRequireDefault(_videoTrackingStore);

var _tapForSoundLayer = __webpack_require__(396);

var _tapForSoundLayer2 = _interopRequireDefault(_tapForSoundLayer);

var _reactRouterDom = __webpack_require__(192);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
    Video Reflux/React Component

    Wrapper for Akamai's AMP video player.
    Disables custom Player Controls for mobile devices
*/
var Video = function (_Reflux$Component) {
  _inherits(Video, _Reflux$Component);

  function Video(props) {
    _classCallCheck(this, Video);

    var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, props));

    _this.state = {};
    _this.mediaEl = null;
    _this.store = _videoStore2.default.get(props.config, _this.props.route);
    _this.tracking = _videoTrackingStore2.default.get(props.config, _this.props.route);

    _this.VideoActions = _this.store.VideoActions;
    _this.ControlsActions = _this.store.ControlsActions;
    _this.mediaApi = null;

    return _this;
  }

  _createClass(Video, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextProps.config["config-id"] != this.props.config["config-id"];
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.create();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this.create();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.store.stopListeningToAll();
      this.VideoActions.destroy();
      this.tracking.stopListeningToAll();
      _videoStore2.default.clearCache();
      _videoTrackingStore2.default.clearCache();
    }
  }, {
    key: 'getAmpConfig',
    value: function getAmpConfig(video) {
      var config = video;
      var Config = {
        media: {
          autoplay: false
        },
        playsinline: true,
        controls: {
          mode: _utils2.default.isMobile() ? "auto" : "none",
          native: _utils2.default.isMobile()
        },
        captioning: {
          enabled: true
        },
        mode: 'auto'
      };
      var settings = new _settings2.default(config);
      var _config = _jquery2.default.extend(true, Config, settings.vConfig);
      var isFF = !(window.mozInnerScreenX == null),
          isIE = window.navigator.userAgent.indexOf('MSIE ') > 0 || !!window.navigator.userAgent.match(/Trident.*rv\:11\./),
          imgSvrPath = window.image_server_url || '//img.preview.webmd.com/dtmcms/preview',
          basePluginUrl = window.location.host.indexOf("localhost") > -1 ? '/resources/plugins/' : imgSvrPath + '/webmd/consumer_assets/site_images/amd_modules/video2/1/lib/',
          baseSkinUrl = window.location.host.indexOf("localhost") > -1 ? '/amp/' : imgSvrPath + '/webmd/consumer_assets/site_images/amd_modules/video2/1/lib/',
          coreConfig = settings.vConfig;
      coreConfig.flash.vars.auto_play_override = settings.autoplay || false;
      // NOTE: this is still temporary, the default plugin and skin url will be hard coded in the wxml file
      while (coreConfig.flash.xml.indexOf('{basePluginUrl}') !== -1) {
        coreConfig.flash.xml = coreConfig.flash.xml.replace('{basePluginUrl}', basePluginUrl);
      }
      while (coreConfig.flash.xml.indexOf('{baseSkinUrl}') !== -1) {
        coreConfig.flash.xml = coreConfig.flash.xml.replace('{baseSkinUrl}', baseSkinUrl);
      }
      coreConfig = _jquery2.default.extend(true, coreConfig, _config);
      if (isFF === true || isIE === true) {
        coreConfig['flash']['params'] = {
          'wmode': 'transparent'
        };
      }
      coreConfig.media.title = video.title ? video.title : '';
      coreConfig.media.metadata = coreConfig.media.metadata || {};
      coreConfig.media.metadata.videoId = video["config-id"];
      return coreConfig;
    }
  }, {
    key: 'create',
    value: function create() {
      var _this2 = this;

      var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
      // Delay loading akamai media player, otherwise it will break React's event listeners
      var playerEl = $this.find('.player-container')[0];
      var ampConfig = this.getAmpConfig(this.props.config);
      this.store = _videoStore2.default.get(this.props.config, this.props.route);
      this.tracking = _videoTrackingStore2.default.get(this.props.config, this.props.route);
      this.VideoActions = this.store.VideoActions;
      this.ControlsActions = this.store.ControlsActions;
      var mediaApi = this.mediaApi;
      this.tracking.mediaApi = mediaApi;
      if (mediaApi) {
        var isMuted = mediaApi.getMuted();
        mediaApi.setMedia(ampConfig.media);
        setTimeout(function () {
          mediaApi.setMuted(isMuted);
        }, 250);
      } else {
        setTimeout(function () {
          _this2.mediaApi = window.akamai.amp.AMP.create(playerEl, ampConfig, function () {
            var mediaElement = _this2.mediaApi.getMediaElement();
            if (!_utils2.default.isMobile()) {
              mediaElement.controls = false;
            }
            _this2.VideoActions.ready(_this2.mediaApi);
            if (typeof _this2.props.setReady !== 'undefined') {
              _this2.props.setReady();
            }
          });
          _this2.props.setAmp(_this2.mediaApi);
        }, 500);
      }
    }
  }, {
    key: 'getControls',
    value: function getControls() {
      if (_utils2.default.isMobile()) {
        return false;
      } else {
        return _react2.default.createElement(_playerControls2.default, { 'config-id': this.props.config["config-id"], route: this.props.route });
      }
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      if (this.props.config.title.length == 0) {
        return false;
      }
      return _react2.default.createElement(
        'h1',
        null,
        this.props.config.title
      );
    }
  }, {
    key: 'getPageTitle',
    value: function getPageTitle() {
      if (this.props.config["page-title"].length == 0) {
        return _utils2.default.getDangerousHtml('');
      }
      var pageTitle = _utils2.default.getDangerousHtml(this.props.config["page-title"]);
      return pageTitle;
    }
  }, {
    key: 'doSetMuted',
    value: function doSetMuted() {
      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.mediaApi.getMuted();

      if (this.mediaApi != null) {
        if (this.mediaApi.playState === 'ready') {
          this.mediaApi.play();
        }
        if (flag != this.mediaApi.getMuted()) {
          this.mediaApi.setMuted(flag);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = this.getPageTitle(),
          className = (0, _classnames2.default)({
        'video-container': true,
        'isMobile': _utils2.default.isMobile()
      });
      var Props = {
        id: this.props.id,
        className: className
      },
          TapForSoundProps = {
        config: this.props.config["config-id"],
        onSetMuted: this.doSetMuted.bind(this),
        route: this.props.route
      };
      return _react2.default.createElement(
        'div',
        { className: 'video-component' },
        _react2.default.createElement('h1', { dangerouslySetInnerHTML: title }),
        _react2.default.createElement(
          'div',
          { className: 'player-container' },
          _react2.default.createElement(
            'div',
            Props,
            _react2.default.createElement(_tapForSoundLayer2.default, TapForSoundProps),
            this.getControls()
          )
        )
      );
    } // render

  }]);

  return Video;
}(_reflux2.default.Component);

exports.default = Video;


Video.propTypes = {
  'id': _react.PropTypes.string,
  'config': _react.PropTypes.object,
  'onVideoEnded': _react.PropTypes.func
};
Video.defaultProps = {
  'onVideoEnded': function onVideoEnded() {}
};

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _externalLinkIcon = __webpack_require__(908);

var _externalLinkIcon2 = _interopRequireDefault(_externalLinkIcon);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AdditionalResourcesComponent = function (_React$Component) {
  _inherits(AdditionalResourcesComponent, _React$Component);

  function AdditionalResourcesComponent(props) {
    _classCallCheck(this, AdditionalResourcesComponent);

    return _possibleConstructorReturn(this, (AdditionalResourcesComponent.__proto__ || Object.getPrototypeOf(AdditionalResourcesComponent)).call(this, props));
  }

  _createClass(AdditionalResourcesComponent, [{
    key: 'render',
    value: function render() {
      var titleProps = {
        dangerouslySetInnerHTML: _utils2.default.getDangerousHtml(this.props.title)
      };
      var resources = this.getResources();
      return _react2.default.createElement(
        'div',
        { className: 'additional-resources-component' },
        _react2.default.createElement('h4', titleProps),
        _react2.default.createElement(
          'ul',
          { className: 'resources-container' },
          resources
        )
      );
    } // render

  }, {
    key: 'getResources',
    value: function getResources() {
      var _this2 = this;

      var _resources = this.props.resources;
      var resources = _resources.map(function (data, index) {
        var itemKey = "resource-" + index;
        return _react2.default.createElement(ResourceItem, _extends({ key: itemKey, moduleId: _this2.props["config-id"] }, data));
      });
      return resources;
    } // getReources

  }]);

  return AdditionalResourcesComponent;
}(_react2.default.Component);

exports.default = AdditionalResourcesComponent;

AdditionalResourcesComponent.propTypes = {
  "title": _react2.default.PropTypes.string,
  "resources": _react2.default.PropTypes.array
};
AdditionalResourcesComponent.defaultProps = {
  "title": "Resources",
  "resources": []
};

var ResourceItem = function (_React$Component2) {
  _inherits(ResourceItem, _React$Component2);

  function ResourceItem(props) {
    _classCallCheck(this, ResourceItem);

    return _possibleConstructorReturn(this, (ResourceItem.__proto__ || Object.getPrototypeOf(ResourceItem)).call(this, props));
  }

  _createClass(ResourceItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var image = this.props.image;
      var title = this.props.title;
      var description = this.props.description;
      var linkProps = this.props.link;
      return _react2.default.createElement(
        'li',
        { className: 'resource-item' },
        _react2.default.createElement('span', { className: 'description', dangerouslySetInnerHTML: _utils2.default.getDangerousHtml(description) }),
        _react2.default.createElement(Link, _extends({}, linkProps, { linkId: this.props["config-id"], moduleId: this.props.moduleId }))
      );
    } // render

  }]);

  return ResourceItem;
}(_react2.default.Component);

ResourceItem.propTypes = {
  "description": _react2.default.PropTypes.string,
  "link": _react2.default.PropTypes.object
};
ResourceItem.defaultProps = {
  "description": "",
  "link": {}
};

var Link = function (_React$Component3) {
  _inherits(Link, _React$Component3);

  function Link(props) {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));
  }

  _createClass(Link, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var $this = $(_reactDom2.default.findDOMNode(this));
      _tracking2.default.trackLink($this[0]);
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      var url = this.props.url.startsWith('http') || this.props.url.startsWith('www') ? this.props.url : '' + window.medscape.config.staticServer.host + this.props.url;
      if (url.indexOf(".medscape.") < 0) {
        return;
      }
      var module = 'addres-' + this.props.moduleId + '-' + this.props.linkId;
      _tracking2.default.pageLink(module);
    }
  }, {
    key: 'render',
    value: function render() {
      var title = this.props.title;
      var type = this.props.type;
      var url = this.props.url.startsWith('http') || this.props.url.startsWith('www') ? this.props.url : '' + window.medscape.config.staticServer.host + this.props.url;
      var linkProps = {
        href: url,
        className: type === 'iconCopy' ? 'external-link' : 'button',
        target: this.props.target
      };
      var titleHtml = _utils2.default.getDangerousHtml(title);
      if (type === 'iconCopy') {
        return _react2.default.createElement(
          'a',
          _extends({}, linkProps, { onClick: this.handleClick.bind(this) }),
          _react2.default.createElement('span', { className: 'title', dangerouslySetInnerHTML: titleHtml }),
          ' ',
          _react2.default.createElement(
            'span',
            { className: 'icon' },
            _react2.default.createElement('img', { src: _externalLinkIcon2.default })
          )
        );
      }
      return _react2.default.createElement(
        'a',
        _extends({}, linkProps, { onClick: this.handleClick.bind(this) }),
        _react2.default.createElement('span', { className: 'title', dangerouslySetInnerHTML: titleHtml })
      );
    } // render

  }]);

  return Link;
}(_react2.default.Component);

Link.propTypes = {
  "url": _react2.default.PropTypes.string,
  "title": _react2.default.PropTypes.string,
  "type": _react2.default.PropTypes.string,
  "target": _react2.default.PropTypes.string
};
Link.defaultProps = {
  "url": "",
  "title": "",
  "type": "link",
  "target": ""
};

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactSlick = __webpack_require__(297);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _slideContent = __webpack_require__(403);

var _slideContent2 = _interopRequireDefault(_slideContent);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _lodash = __webpack_require__(42);

var _helpers = __webpack_require__(30);

var _helpers2 = _interopRequireDefault(_helpers);

var _slideIcons = __webpack_require__(208);

var _slideIcons2 = _interopRequireDefault(_slideIcons);

var _sliderLinks = __webpack_require__(404);

var _sliderLinks2 = _interopRequireDefault(_sliderLinks);

var _slideActionsFactory = __webpack_require__(205);

var _slideActionsFactory2 = _interopRequireDefault(_slideActionsFactory);

var _buttons = __webpack_require__(401);

var _buttons2 = _interopRequireDefault(_buttons);

var _carouselTrackingStore = __webpack_require__(346);

var _carouselTrackingStore2 = _interopRequireDefault(_carouselTrackingStore);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

window.infosite = window.infosite || {};
window.infosite.modules = window.infosite.modules || {};
window.infosite.modules.sliders = window.infosite.modules.sliders || {};

var Carousel = function (_React$Component) {
  _inherits(Carousel, _React$Component);

  function Carousel(props) {
    _classCallCheck(this, Carousel);

    var _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

    _this.state = {
      caption: props.config.slides[0].caption,
      label: props.config.slides[0].label,
      slideIndex: 0
    };
    _this.currentSlide = 0;
    _this.Buttons = new _buttons2.default(props.config.icons);
    _this.SlideActions = _slideActionsFactory2.default.get(props.config["config-id"]);
    _this.TrackingStore = null;
    var moduleId = Math.floor(Math.random() * new Date().getTime());
    _this.autoPlayResetEvents = 'scroll.carousel-' + moduleId + ' resize.carousel-' + moduleId + ' orientationchange.carousel-' + moduleId;
    _this.autoPlayTimeout = null;
    return _this;
  }

  _createClass(Carousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
      this.TrackingStore = new _carouselTrackingStore2.default(this.props.config);
      _tracking2.default.trackContainerLinks($this[0]);
      if (this.refs.slider) {
        window.infosite.modules.sliders[this.props.config["config-id"]] = this.refs.slider;
      }
      /*
        "Fix" Auto Play issue with Mobile scroll and orientation change events
      */
      if (_utils2.default.isMobile() && this.refs.slider && this.refs.slider.props.autoplay) {
        var slider = this.refs.slider;
        slider.innerSlider.autoPlay();
        (0, _jquery2.default)(window).on(this.autoPlayResetEvents, function (e) {
          var slider = _this2.refs.slider;
          //console.log("AutoPlay Reset Event: ",e)
          //console.log("AutoPlay Reset State: ",slider.innerSlider.state);
          if (slider.innerSlider.state.autoPlayTimer != null) {
            clearTimeout(_this2.autoPlayTimeout);
            _this2.autoPlayTimeout = setTimeout(function () {
              _this2.refs.slider.innerSlider.autoPlay();
            }, slider.innerSlider.state.autoPlayTimer);
          }
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.TrackingStore) {
        this.TrackingStore.stopListeningToAll();
      }
      window.infosite.modules.sliders[this.props.config["config-id"]] = null;
      var autoPlayResetEvents = this.autoPlayResetEvents.split(" ");
      autoPlayResetEvents.forEach(function (resetEvent) {
        (0, _jquery2.default)(window).off(resetEvent);
      });
    }
  }, {
    key: 'doPause',
    value: function doPause() {
      if (this.refs.slider) {
        var slider = this.refs.slider;
        slider.innerSlider.pause();
      }
    }
  }, {
    key: 'getSlides',
    value: function getSlides() {
      var _this3 = this;

      // Move first item to the end hack to fix issue with Slick Slider
      // rendering last item first when slidesToShow is greater than 1
      if (this.props.config.settings.slidesToShow > 1) {
        var firstSlide = this.props.config.slides.shift();
        this.props.config.slides.push(firstSlide);
      }
      var slides = this.props.config.slides.map(function (slide, index) {
        var props = _jquery2.default.extend({}, slide);
        var key = 'slide-' + index;
        props.index = index;
        props.SlideActions = _this3.SlideActions;
        props.Buttons = _this3.Buttons;
        props.pause = _this3.doPause.bind(_this3);
        return _react2.default.createElement(
          'div',
          { key: key },
          _react2.default.createElement(_slideContent2.default, props),
          _react2.default.createElement(_sliderLinks2.default, { content: _this3.props.config.links.content, SlideActions: _this3.SlideActions, Buttons: _this3.Buttons })
        );
      });
      return slides;
    }
  }, {
    key: 'pauseVideos',
    value: function pauseVideos() {
      var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
      _helpers2.default.pauseVideos($this[0]);
    }
  }, {
    key: 'slideCount',
    value: function slideCount() {
      var slideCount = null;
      if (this.props.config.slideCount) {
        slideCount = _react2.default.createElement(
          'div',
          { className: 'slide-total' },
          this.state.slideIndex + 1 + ' of ' + this.props.config.slides.length
        );
      }
      return slideCount;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var Settings = {
        afterChange: function afterChange(index) {
          _this4.SlideActions.afterChange(index);
          _this4.currentSlide = index;
          _this4.setState({ slideIndex: index });
        },
        beforeChange: function beforeChange(e) {
          _this4.pauseVideos();
          _this4.SlideActions.beforeChange(e);
        },
        prevArrow: _react2.default.createElement(this.Buttons.PrevArrow, null),
        nextArrow: _react2.default.createElement(this.Buttons.NextArrow, null),
        totalSlides: this.props.config.slides.length,
        ref: 'slider'
      };
      if (this.props.config.settings.customPaging && this.props.config.settings.customPaging.length > 0) {
        Settings.customPaging = function (i) {
          var _html = _utils2.default.getDangerousHtml(_this4.props.config.settings.customPaging);
          var props = {
            className: "custom-paging",
            dangerouslySetInnerHTML: _html
          };
          return _react2.default.createElement('button', props);
        };
      } else {
        delete this.props.config.settings.customPaging;
      }
      var settings = _jquery2.default.extend({}, this.props.config.settings, Settings);
      var IconsProps = _jquery2.default.extend({}, this.props.config);
      IconsProps.SlideActions = this.SlideActions;
      IconsProps.Buttons = this.Buttons;
      return _react2.default.createElement(
        'div',
        { className: 'carousel-module' },
        _react2.default.createElement(_slideIcons2.default, IconsProps),
        _react2.default.createElement(
          _reactSlick2.default,
          settings,
          this.getSlides()
        ),
        _react2.default.createElement(
          'div',
          null,
          this.slideCount()
        )
      );
    }
  }]);

  return Carousel;
}(_react2.default.Component);

exports.default = Carousel;


Carousel.propTypes = {
  config: _react2.default.PropTypes.object
};
Carousel.defaultProps = {};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _Previous = __webpack_require__(166);

var _Previous2 = _interopRequireDefault(_Previous);

var _Next = __webpack_require__(165);

var _Next2 = _interopRequireDefault(_Next);

var _Close = __webpack_require__(120);

var _Close2 = _interopRequireDefault(_Close);

var _CircleInformation = __webpack_require__(674);

var _CircleInformation2 = _interopRequireDefault(_CircleInformation);

var _LinkTop = __webpack_require__(677);

var _LinkTop2 = _interopRequireDefault(_LinkTop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buttons = function Buttons() {
  var icons = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, Buttons);

  /* Buttons */
  var Close = function (_React$Component) {
    _inherits(Close, _React$Component);

    function Close() {
      _classCallCheck(this, Close);

      return _possibleConstructorReturn(this, (Close.__proto__ || Object.getPrototypeOf(Close)).apply(this, arguments));
    }

    _createClass(Close, [{
      key: 'render',
      value: function render() {
        var _this2 = this;

        var classNames = (0, _classnames2.default)({
          'close-button': true
        });
        var buttonProps = {
          className: classNames,
          onClick: function onClick(e) {
            e.preventDefault();_this2.props.onClick(e);
          },
          title: "Links"
        };
        if (icons.close && icons.close.length > 0) {
          buttonProps.html = icons.close;
        } else {
          buttonProps.icon = _Close2.default;
        }
        return _react2.default.createElement(CustomButton, buttonProps);
      }
    }]);

    return Close;
  }(_react2.default.Component);

  var Links = function (_React$Component2) {
    _inherits(Links, _React$Component2);

    function Links() {
      _classCallCheck(this, Links);

      return _possibleConstructorReturn(this, (Links.__proto__ || Object.getPrototypeOf(Links)).apply(this, arguments));
    }

    _createClass(Links, [{
      key: 'render',
      value: function render() {
        var _this4 = this;

        var classNames = (0, _classnames2.default)({
          'links-link': true,
          'active': this.props.isActive
        });
        var buttonProps = {
          className: classNames,
          onClick: function onClick(e) {
            e.preventDefault();_this4.props.onClick(e);
          },
          title: "Links"
        };
        if (icons.links && icons.links.length > 0) {
          buttonProps.html = icons.links;
        } else {
          buttonProps.icon = _LinkTop2.default;
        }
        return _react2.default.createElement(CustomButton, buttonProps);
      }
    }]);

    return Links;
  }(_react2.default.Component);

  var Notes = function (_React$Component3) {
    _inherits(Notes, _React$Component3);

    function Notes() {
      _classCallCheck(this, Notes);

      return _possibleConstructorReturn(this, (Notes.__proto__ || Object.getPrototypeOf(Notes)).apply(this, arguments));
    }

    _createClass(Notes, [{
      key: 'render',
      value: function render() {
        var _this6 = this;

        var classNames = (0, _classnames2.default)({
          'notes-link': true,
          'active': this.props.isActive
        });
        var buttonProps = {
          className: classNames,
          onClick: function onClick(e) {
            e.preventDefault();_this6.props.onClick(e);
          },
          title: "Notes"
        };
        if (icons.notes && icons.notes.length > 0) {
          buttonProps.html = icons.notes;
        } else {
          buttonProps.icon = _CircleInformation2.default;
        }
        return _react2.default.createElement(CustomButton, buttonProps);
      }
    }]);

    return Notes;
  }(_react2.default.Component);

  var PrevArrow = function (_React$Component4) {
    _inherits(PrevArrow, _React$Component4);

    function PrevArrow() {
      _classCallCheck(this, PrevArrow);

      return _possibleConstructorReturn(this, (PrevArrow.__proto__ || Object.getPrototypeOf(PrevArrow)).apply(this, arguments));
    }

    _createClass(PrevArrow, [{
      key: 'render',
      value: function render() {
        var _this8 = this;

        var classNames = (0, _classnames2.default)({
          'carousel-arrow': true,
          'previous-button': true
        });
        var buttonProps = {
          className: classNames,
          onClick: function onClick(e) {
            e.preventDefault();_this8.props.onClick(e);
          },
          title: "Previous"
        };
        if (icons.prevArrow && icons.prevArrow.length > 0) {
          buttonProps.html = icons.prevArrow;
        } else {
          buttonProps.icon = _Previous2.default;
        }
        return _react2.default.createElement(CustomButton, buttonProps);
      }
    }]);

    return PrevArrow;
  }(_react2.default.Component);

  var NextArrow = function (_React$Component5) {
    _inherits(NextArrow, _React$Component5);

    function NextArrow() {
      _classCallCheck(this, NextArrow);

      return _possibleConstructorReturn(this, (NextArrow.__proto__ || Object.getPrototypeOf(NextArrow)).apply(this, arguments));
    }

    _createClass(NextArrow, [{
      key: 'render',
      value: function render() {
        var _this10 = this;

        var classNames = (0, _classnames2.default)({
          'carousel-arrow': true,
          'next-button': true
        });
        var buttonProps = {
          className: classNames,
          onClick: function onClick(e) {
            e.preventDefault();_this10.props.onClick(e);
          },
          title: "Next"
        };
        if (icons.nextArrow && icons.nextArrow.length > 0) {
          buttonProps.html = icons.nextArrow;
        } else {
          buttonProps.icon = _Next2.default;
        }
        return _react2.default.createElement(CustomButton, buttonProps);
      }
    }]);

    return NextArrow;
  }(_react2.default.Component);

  var CustomButton = function (_React$Component6) {
    _inherits(CustomButton, _React$Component6);

    function CustomButton() {
      _classCallCheck(this, CustomButton);

      return _possibleConstructorReturn(this, (CustomButton.__proto__ || Object.getPrototypeOf(CustomButton)).apply(this, arguments));
    }

    _createClass(CustomButton, [{
      key: 'render',
      value: function render() {
        if (this.props.icon == null && this.props.html.length == 0) {
          return false;
        } else if (this.props.html.length > 0) {
          var html = _utils2.default.getDangerousHtml(this.props.html);
          return _react2.default.createElement(
            'button',
            { onClick: this.props.onClick, className: this.props.className },
            _react2.default.createElement('span', { className: 'icon-container', dangerouslySetInnerHTML: html })
          );
        } else {
          return _react2.default.createElement(
            'button',
            { onClick: this.props.onClick, className: this.props.className },
            _react2.default.createElement(
              'span',
              { className: 'icon-container' },
              _react2.default.createElement(this.props.icon, null)
            )
          );
        }
      }
    }]);

    return CustomButton;
  }(_react2.default.Component);

  CustomButton.propTypes = {
    className: _react2.default.PropTypes.string,
    onClick: _react2.default.PropTypes.func,
    title: _react2.default.PropTypes.string,
    html: _react2.default.PropTypes.string,
    icon: _react2.default.PropTypes.func
  };
  CustomButton.defaultProps = {
    title: "",
    html: "",
    icon: null

    /* End Buttons */

  };this.Close = Close;
  this.PrevArrow = PrevArrow;
  this.NextArrow = NextArrow;
  this.Notes = Notes;
  this.Links = Links;
};

exports.default = Buttons;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Notes = function (_React$Component) {
  _inherits(Notes, _React$Component);

  function Notes(props) {
    _classCallCheck(this, Notes);

    var _this = _possibleConstructorReturn(this, (Notes.__proto__ || Object.getPrototypeOf(Notes)).call(this, props));

    _this.state = {
      isActive: props.isActive
    };
    return _this;
  }

  _createClass(Notes, [{
    key: 'doClose',
    value: function doClose(e) {
      e.preventDefault();
      this.props.SlideActions.toggleNotes(this.props.slideIndex, false);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.content.length == 0) {
        return false;
      }
      var contentWrapper = {
        className: (0, _classnames2.default)({
          'active': this.props.isActive,
          'note-content-wrapper': true
        })
      };
      var notes = _utils2.default.getDangerousHtml(this.props.content);
      return _react2.default.createElement(
        'div',
        { className: 'notes-container' },
        _react2.default.createElement(
          'div',
          contentWrapper,
          _react2.default.createElement(
            'div',
            { className: 'slide-notes' },
            _react2.default.createElement(this.props.Buttons.Close, { onClick: this.doClose.bind(this) }),
            _react2.default.createElement('div', { className: 'notes-content', dangerouslySetInnerHTML: notes })
          )
        )
      );
    }
  }]);

  return Notes;
}(_react2.default.Component);

exports.default = Notes;


Notes.propTypes = {
  slideIndex: _react2.default.PropTypes.number,
  icon: _react2.default.PropTypes.string,
  content: _react2.default.PropTypes.string,
  isActive: _react2.default.PropTypes.bool,
  SlideActions: _react2.default.PropTypes.object,
  Buttons: _react2.default.PropTypes.object
};
Notes.defaultProps = {
  icon: '',
  content: '',
  isActive: false

};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _helpers = __webpack_require__(30);

var _helpers2 = _interopRequireDefault(_helpers);

var _notes = __webpack_require__(402);

var _notes2 = _interopRequireDefault(_notes);

var _slideIcons = __webpack_require__(208);

var _slideIcons2 = _interopRequireDefault(_slideIcons);

var _slideStore = __webpack_require__(348);

var _slideStore2 = _interopRequireDefault(_slideStore);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SlideContent = function (_Reflux$Component) {
  _inherits(SlideContent, _Reflux$Component);

  function SlideContent(props) {
    _classCallCheck(this, SlideContent);

    var _this = _possibleConstructorReturn(this, (SlideContent.__proto__ || Object.getPrototypeOf(SlideContent)).call(this, props));

    _this.state = {};
    _this.store = new _slideStore2.default(props);
    return _this;
  }

  _createClass(SlideContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
      var callbacks = {
        ZoomImages: {
          onZoom: function onZoom(e) {
            _this2.props.pause();
          }
        }
      };
      _helpers2.default.loadCarouselModules($this[0], callbacks);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var content = _utils2.default.getDangerousHtml(this.props.html);

      var notes = _jquery2.default.extend({
        slideIndex: this.props.index,
        isActive: this.state.showNotes,
        SlideActions: this.props.SlideActions,
        Buttons: this.props.Buttons
      }, this.props.notes);

      var containerProps = {
        className: 'slide-content-container ' + this.props.className,
        onClick: function onClick(e) {
          _this3.props.pause();
        }
      };
      if (this.props.label.length == 0 && this.props.caption.length == 0) {
        return _react2.default.createElement(
          'div',
          containerProps,
          _react2.default.createElement(
            'div',
            { className: 'content-wrapper' },
            _react2.default.createElement('div', { className: 'slide-content', dangerouslySetInnerHTML: content })
          ),
          _react2.default.createElement(_notes2.default, notes)
        );
      }
      var label = _utils2.default.getDangerousHtml(this.props.label);
      var caption = _utils2.default.getDangerousHtml(this.props.caption);
      return _react2.default.createElement(
        'div',
        containerProps,
        _react2.default.createElement(
          'div',
          { className: 'content-label-caption-wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'slide-content-flex' },
            _react2.default.createElement('div', { className: 'slide-content', dangerouslySetInnerHTML: content })
          ),
          _react2.default.createElement(
            'div',
            { className: 'label-caption-flex' },
            _react2.default.createElement(
              'div',
              { className: 'label-caption-container' },
              _react2.default.createElement('div', { className: 'slide-label', dangerouslySetInnerHTML: label }),
              _react2.default.createElement('div', { className: 'slide-caption', dangerouslySetInnerHTML: caption })
            )
          )
        ),
        _react2.default.createElement(_notes2.default, notes)
      );
    }
  }]);

  return SlideContent;
}(_reflux2.default.Component);

exports.default = SlideContent;


SlideContent.propTypes = {
  index: _react2.default.PropTypes.number,
  html: _react2.default.PropTypes.string,
  label: _react2.default.PropTypes.string,
  caption: _react2.default.PropTypes.string,
  className: _react2.default.PropTypes.string,
  notes: _react2.default.PropTypes.object,
  SlideActions: _react2.default.PropTypes.object,
  Buttons: _react2.default.PropTypes.object
};
SlideContent.defaultProps = {
  html: '',
  label: '',
  caption: '',
  className: '',
  notes: {
    content: '',
    icon: ''
  }

};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _Info = __webpack_require__(676);

var _Info2 = _interopRequireDefault(_Info);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _Close = __webpack_require__(120);

var _Close2 = _interopRequireDefault(_Close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SliderLinks = function (_Reflux$Component) {
  _inherits(SliderLinks, _Reflux$Component);

  function SliderLinks(props) {
    _classCallCheck(this, SliderLinks);

    var _this = _possibleConstructorReturn(this, (SliderLinks.__proto__ || Object.getPrototypeOf(SliderLinks)).call(this, props));

    _this.state = {};
    _this.store = new SliderLinksStore(props);
    return _this;
  }

  _createClass(SliderLinks, [{
    key: 'doClose',
    value: function doClose(e) {
      e.preventDefault();
      this.props.SlideActions.toggleLinks(false);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.content.length == 0) {
        return false;
      }

      var sliderClass = (0, _classnames2.default)({
        'active': this.state.isActive,
        'slider-links': true
      });
      var wrapperClass = (0, _classnames2.default)({
        'links-content-wrapper': true
      });
      var links = _utils2.default.getDangerousHtml(this.props.content);
      return _react2.default.createElement(
        'div',
        { className: sliderClass },
        _react2.default.createElement(
          'div',
          { className: wrapperClass },
          _react2.default.createElement(this.props.Buttons.Close, { onClick: this.doClose.bind(this) }),
          _react2.default.createElement('div', { className: 'slide-links', dangerouslySetInnerHTML: links })
        )
      );
    }
  }]);

  return SliderLinks;
}(_reflux2.default.Component);

exports.default = SliderLinks;

SliderLinks.propTypes = {
  content: _react2.default.PropTypes.string,
  SlideActions: _react2.default.PropTypes.object,
  Buttons: _react2.default.PropTypes.object
};
SliderLinks.defaultProps = {
  content: ''
};

var SliderLinksStore = function (_Reflux$Store) {
  _inherits(SliderLinksStore, _Reflux$Store);

  function SliderLinksStore(props) {
    _classCallCheck(this, SliderLinksStore);

    var _this2 = _possibleConstructorReturn(this, (SliderLinksStore.__proto__ || Object.getPrototypeOf(SliderLinksStore)).call(this));

    _this2.props = props;
    _this2.state = _this2.getInitialState();
    _this2.listenables = props.SlideActions;
    return _this2;
  }

  _createClass(SliderLinksStore, [{
    key: 'getInitialState',
    value: function getInitialState() {
      return {
        isActive: false
      };
    }
  }, {
    key: 'beforeChange',
    value: function beforeChange(currIndex, nextIndex) {
      this.setState({
        isActive: false
      });
    }
  }, {
    key: 'onToggleLinks',
    value: function onToggleLinks() {
      var flag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.state.isActive;

      this.setState({
        isActive: flag
      });
    }
  }, {
    key: 'onToggleNotes',
    value: function onToggleNotes() {
      this.setState({
        isActive: false
      });
    }
  }]);

  return SliderLinksStore;
}(_reflux2.default.Store);

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConsultComponent = function (_React$Component) {
    _inherits(ConsultComponent, _React$Component);

    function ConsultComponent(props) {
        _classCallCheck(this, ConsultComponent);

        return _possibleConstructorReturn(this, (ConsultComponent.__proto__ || Object.getPrototypeOf(ConsultComponent)).call(this, props));
    }

    _createClass(ConsultComponent, [{
        key: 'render',
        value: function render() {
            var titleProps = {
                dangerouslySetInnerHTML: _utils2.default.getDangerousHtml(this.props.title)
            };
            var resources = this.getItems();
            return _react2.default.createElement(
                'div',
                { className: 'consult-component' },
                _react2.default.createElement('h4', titleProps),
                _react2.default.createElement(
                    'ul',
                    { className: 'items-container' },
                    resources
                )
            );
        } // render

    }, {
        key: 'getItems',
        value: function getItems() {
            var items = this.props.items;
            return items.map(function (data, index) {
                var itemKey = "resource-" + index;
                return _react2.default.createElement(ConsultItem, _extends({ key: itemKey }, data));
            });
        } // getReources

    }]);

    return ConsultComponent;
}(_react2.default.Component);

exports.default = ConsultComponent;

ConsultComponent.propTypes = {
    "title": _react2.default.PropTypes.string,
    "items": _react2.default.PropTypes.array
};
ConsultComponent.defaultProps = {
    "title": "More Resources",
    "items": []
};

var ConsultItem = function (_React$Component2) {
    _inherits(ConsultItem, _React$Component2);

    function ConsultItem(props) {
        _classCallCheck(this, ConsultItem);

        return _possibleConstructorReturn(this, (ConsultItem.__proto__ || Object.getPrototypeOf(ConsultItem)).call(this, props));
    }

    _createClass(ConsultItem, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'render',
        value: function render() {
            var image = this.props.image;
            image = image.startsWith('//') ? image : window.medscape.config.staticServer.host + window.medscape.config.staticServer.path + image;
            var link = this.props.link;

            var titleProps = {
                className: 'title',
                dangerouslySetInnerHTML: _utils2.default.getDangerousHtml(this.props.title + ": ")
            };
            var descriptionProps = {
                className: 'description',
                dangerouslySetInnerHTML: _utils2.default.getDangerousHtml(this.props.description)
            };
            return _react2.default.createElement(
                'li',
                { className: 'consult-item' },
                _react2.default.createElement(
                    'div',
                    { className: 'image-container' },
                    _react2.default.createElement('img', { src: image })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'content-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'content' },
                        _react2.default.createElement('span', titleProps),
                        _react2.default.createElement('span', descriptionProps)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'link-container' },
                        _react2.default.createElement(Link, _extends({}, link, { moduleId: this.props["config-id"] }))
                    )
                )
            );
        } // render

    }]);

    return ConsultItem;
}(_react2.default.Component);

ConsultItem.propTypes = {
    "image": _react2.default.PropTypes.string,
    "title": _react2.default.PropTypes.string,
    "description": _react2.default.PropTypes.string,
    "link": _react2.default.PropTypes.object
};
ConsultItem.defaultProps = {
    "image": "",
    "title": "",
    "description": "",
    "link": {}
};

var Link = function (_React$Component3) {
    _inherits(Link, _React$Component3);

    function Link(props) {
        _classCallCheck(this, Link);

        return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));
    }

    _createClass(Link, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            if (this.props.url.startsWith('//') && this.props.url.indexOf(".medscape.") < 0) {
                return;
            }
            _tracking2.default.pageLink('consa-' + this.props.moduleId);
        }
    }, {
        key: 'render',
        value: function render() {
            var link = this.props.url;
            var titleProps = {
                className: 'sub-title',
                dangerouslySetInnerHTML: _utils2.default.getDangerousHtml(this.props.title)
            };
            return _react2.default.createElement(
                'a',
                { target: '_blank', href: link, onClick: this.handleClick.bind(this) },
                _react2.default.createElement('span', titleProps)
            );
        } // render

    }]);

    return Link;
}(_react2.default.Component);

Link.propTypes = {
    "url": _react2.default.PropTypes.string,
    "title": _react2.default.PropTypes.string
};
Link.defaultProps = {
    "url": "",
    "title": ""
};

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _AddCircle = __webpack_require__(672);

var _AddCircle2 = _interopRequireDefault(_AddCircle);

var _SubtractCircle = __webpack_require__(680);

var _SubtractCircle2 = _interopRequireDefault(_SubtractCircle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ToggleButton = function (_React$Component) {
  _inherits(ToggleButton, _React$Component);

  function ToggleButton(props) {
    _classCallCheck(this, ToggleButton);

    var _this = _possibleConstructorReturn(this, (ToggleButton.__proto__ || Object.getPrototypeOf(ToggleButton)).call(this, props));

    _this.state = {
      content: '',
      isExpanded: _this.props.isExpanded
    };
    return _this;
  }

  _createClass(ToggleButton, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      //this.getContent(nextProps.config.path); 
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.props.render) {
        return false;
      }
      var content = _utils2.default.getDangerousHtml(this.state.content);
      var ToggleContentIcon = this.props.isExpanded ? _SubtractCircle2.default : _AddCircle2.default;
      var buttonProps = {
        className: this.props.showAcceptButton ? 'accept-button' : 'toggle-button',
        onClick: function onClick(e) {
          e.preventDefault();
          _this2.props.onClick(e);
        }

      };
      if (this.props.showAcceptButton) {
        return _react2.default.createElement(
          'span',
          { className: 'toggle-button-container' },
          _react2.default.createElement(
            'button',
            buttonProps,
            'Accept'
          )
        );
      }
      return _react2.default.createElement(
        'span',
        { className: 'toggle-button-container' },
        _react2.default.createElement(
          'button',
          buttonProps,
          _react2.default.createElement(ToggleContentIcon, null)
        )
      );
    }
  }]);

  return ToggleButton;
}(_react2.default.Component);

exports.default = ToggleButton;


ToggleButton.propTypes = {
  onClick: _react2.default.PropTypes.func,
  isExpanded: _react2.default.PropTypes.bool,
  render: _react2.default.PropTypes.bool,
  showAcceptButton: _react2.default.PropTypes.bool
};
ToggleButton.defaultProps = {
  onClick: function onClick() {},
  isExpanded: false,
  render: false,
  showAcceptButton: false
};

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _sideMenu = __webpack_require__(210);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

var _helpers = __webpack_require__(30);

var _helpers2 = _interopRequireDefault(_helpers);

var _Menu = __webpack_require__(678);

var _Menu2 = _interopRequireDefault(_Menu);

var _store = __webpack_require__(206);

var _store2 = _interopRequireDefault(_store);

var _actions = __webpack_require__(135);

var _actions2 = _interopRequireDefault(_actions);

var _reactBurgerMenu = __webpack_require__(268);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MobileMenuModule = function (_React$Component) {
  _inherits(MobileMenuModule, _React$Component);

  function MobileMenuModule(props) {
    _classCallCheck(this, MobileMenuModule);

    var _this = _possibleConstructorReturn(this, (MobileMenuModule.__proto__ || Object.getPrototypeOf(MobileMenuModule)).call(this, props));

    _this.state = {};
    _this.settings = props.navigation.mobile;
    return _this;
  }

  _createClass(MobileMenuModule, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      //let $this = $(ReactDOM.findDOMNode(this));
    }
  }, {
    key: 'render',
    value: function render() {
      var menuProps = {
        className: 'menu-icon-wrapper',
        onClick: function onClick(e) {
          e.preventDefault();
          _actions2.default.toggle();
        }
      };
      if (!this.settings.image || this.settings.image.length == 0) {
        return _react2.default.createElement(
          'div',
          menuProps,
          _react2.default.createElement(_Menu2.default, null)
        );
      } else {
        var url = this.props.url.startsWith('//') ? this.props.url : '' + window.medscape.config.staticServer.host + this.props.url;
        return _react2.default.createElement(
          'a',
          menuProps,
          _react2.default.createElement('img', { src: '{url}' })
        );
      }
    }
  }]);

  return MobileMenuModule;
}(_react2.default.Component);

exports.default = MobileMenuModule;


MobileMenuModule.propTypes = {
  "navigation": _react2.default.PropTypes.object.isRequired,
  "route": _react2.default.PropTypes.object.isRequired
};
MobileMenuModule.defaultProps = {};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _navMenu = __webpack_require__(65);

var _navMenu2 = _interopRequireDefault(_navMenu);

var _Down = __webpack_require__(76);

var _Down2 = _interopRequireDefault(_Down);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _sideNavInlineMenu = __webpack_require__(411);

var _sideNavInlineMenu2 = _interopRequireDefault(_sideNavInlineMenu);

var _sideNavLayerMenu = __webpack_require__(412);

var _sideNavLayerMenu2 = _interopRequireDefault(_sideNavLayerMenu);

var _topNavLayerMenu = __webpack_require__(413);

var _topNavLayerMenu2 = _interopRequireDefault(_topNavLayerMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Navigation = function (_React$Component) {
    _inherits(Navigation, _React$Component);

    function Navigation(props) {
        _classCallCheck(this, Navigation);

        var _this = _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call(this, props));

        _this.settings = props.isMobile ? props.navigation.mobile : props.navigation.desktop;
        return _this;
    }

    _createClass(Navigation, [{
        key: 'render',
        value: function render() {
            //console.log("Render Nav");

            if (this.settings.position == 'top') {
                //console.log("Loading Top Nav Layered Menu");
                return _react2.default.createElement(_topNavLayerMenu2.default, this.props);
            } else if (this.settings.submenuType == 'layer') {
                //console.log("Loading Side Nav Layered Menu");
                return _react2.default.createElement(_sideNavLayerMenu2.default, this.props);
            } else {
                //console.log("Loading Side Nav Inline Menu");
                return _react2.default.createElement(_sideNavInlineMenu2.default, this.props);
            }
        }
    }]);

    return Navigation;
}(_react2.default.Component);

exports.default = Navigation;


Navigation.propTypes = {
    "navigation": _react2.default.PropTypes.object.isRequired,
    "route": _react2.default.PropTypes.object.isRequired,
    "isMobile": _react2.default.PropTypes.bool
};
Navigation.defaultProps = {
    "isMobile": window.medscape.isMobile ? window.medscape.isMobile : false
};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _navMenu = __webpack_require__(65);

var _navMenu2 = _interopRequireDefault(_navMenu);

var _Down = __webpack_require__(76);

var _Down2 = _interopRequireDefault(_Down);

var _Up = __webpack_require__(251);

var _Up2 = _interopRequireDefault(_Up);

var _Previous = __webpack_require__(166);

var _Previous2 = _interopRequireDefault(_Previous);

var _Next = __webpack_require__(165);

var _Next2 = _interopRequireDefault(_Next);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _reactRouterDom = __webpack_require__(192);

var _helpers = __webpack_require__(30);

var _helpers2 = _interopRequireDefault(_helpers);

var _actions = __webpack_require__(91);

var _actions2 = _interopRequireDefault(_actions);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Link = function (_React$Component) {
    _inherits(Link, _React$Component);

    function Link(props) {
        _classCallCheck(this, Link);

        return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));
    }

    _createClass(Link, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
            var $link = $this.find('a');
            $link.off('click.route');
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            //let $this = $(ReactDOM.findDOMNode(this));

        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {}
    }, {
        key: 'getArrowIcon',
        value: function getArrowIcon() {
            var data = this.props.item;
            var hasSubmenu = data.submenu && data.submenu.length > 0;
            var ArrowIcon = _Down2.default;
            if (hasSubmenu) {
                if (this.props.position == "left" && this.props.submenuType != "inline") {
                    ArrowIcon = _Next2.default;
                } else if (this.props.position == "right" && this.props.submenuType != "inline") {
                    ArrowIcon = _Previous2.default;
                } else if (this.props.isExpandedSubmenu) {
                    ArrowIcon = _Up2.default;
                } else {
                    ArrowIcon = _Down2.default;
                }

                return _react2.default.createElement(
                    'span',
                    { className: 'arrow-container' },
                    _react2.default.createElement(ArrowIcon, null)
                );
            } else {
                return _react2.default.createElement('span', { className: 'arrow-container' });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var data = this.props.item;
            var _target = data.target || '';
            var linkLabel = _utils2.default.getDangerousHtml(data.label);
            var hasSubmenu = data.submenu && data.submenu.length > 0;
            var arrowIcon = this.getArrowIcon();
            var pageLink = "nav-link";
            var isiLink = this.props.item.module == "IsiLink";

            if (isiLink) {
                pageLink = "nav-isi_link";
            } else if (data.url.length == 0) {
                pageLink = "nav-submenu";
            }

            var linkContainerProps = {
                className: 'link-container',
                onClick: function onClick(e) {
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    _this2.props.onToggleSubmenu(e, data);
                }
            };
            var isRouterLink = data.module == "RouterLink";

            var linkClass = (0, _classnames2.default)({
                "title": true,
                "default-link": !isRouterLink,
                "router-link": isRouterLink,
                "js-tracking": isiLink || isRouterLink
            });

            var linkProps = {
                to: isRouterLink ? data.url : null,
                target: !isRouterLink && data.url.length > 0 ? data.target : null,
                className: linkClass,
                dangerouslySetInnerHTML: linkLabel,
                "data-wmdpagelink": pageLink,
                onClick: function onClick(e) {
                    var el = e.currentTarget;

                    _tracking2.default.pageLink(pageLink, el);

                    if (_this2.props.item.module == "IsiLink") {
                        e.preventDefault();
                        _actions2.default.linkClick();
                    }
                }
            };

            if (!isRouterLink && data.url.length > 0) {
                // Remove protocol on external URLs
                linkProps.href = data.url;
            }

            if (isRouterLink) {
                return _react2.default.createElement(
                    'span',
                    linkContainerProps,
                    _react2.default.createElement(_reactRouterDom.Link, linkProps),
                    arrowIcon
                );
            } else {
                // PPE-174979
                // Use <div> to allow Dev App Navigation to not redirect to error page when href is 'unknown'
                return _react2.default.createElement(
                    'span',
                    linkContainerProps,
                    _react2.default.createElement('a', linkProps),
                    arrowIcon
                );
            }
        }
    }]);

    return Link;
}(_react2.default.Component); // ListItem


exports.default = Link;
Link.propTypes = {
    item: _react2.default.PropTypes.object.isRequired,
    onToggleSubmenu: _react2.default.PropTypes.func,
    isMouseEnterEvent: _react2.default.PropTypes.bool,
    isExpandedSubmenu: _react2.default.PropTypes.bool,
    position: _react2.default.PropTypes.string,
    submenuType: _react2.default.PropTypes.string
};
Link.defaultProps = {
    isExpandedSubmenu: false,
    position: "top",
    submenuType: "inline"

};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _navMenu = __webpack_require__(65);

var _navMenu2 = _interopRequireDefault(_navMenu);

var _Down = __webpack_require__(76);

var _Down2 = _interopRequireDefault(_Down);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _link = __webpack_require__(409);

var _link2 = _interopRequireDefault(_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavItem = function (_React$Component) {
    _inherits(NavItem, _React$Component);

    function NavItem(props) {
        _classCallCheck(this, NavItem);

        var _this = _possibleConstructorReturn(this, (NavItem.__proto__ || Object.getPrototypeOf(NavItem)).call(this, props));

        _this.state = {
            isExpanded: false
        };
        _this.hasSubmenu = props.item.submenu && props.item.submenu.length > 0;
        return _this;
    }

    _createClass(NavItem, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            //let $this = $(ReactDOM.findDOMNode(this));
            this.checkItem();
        } // componentDidMount

    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.checkItem();
        }
    }, {
        key: 'checkItem',
        value: function checkItem() {
            if (this.hasSubmenu && this.props.settings.submenuType && this.props.settings.submenuType == "default" && this.props.settings.position != "top") {
                var hasActive = false;
                var routeLocation = this.props.route.location.pathname;
                var routeItem = this.props.item.submenu.find(function (navItem) {
                    return navItem.url == routeLocation;
                });
                if (routeItem != null) {
                    this.setState({
                        isExpanded: true
                    });
                }
            }
        }
    }, {
        key: 'toggleSubmenu',
        value: function toggleSubmenu(e, itemData) {
            var hash = window.location.hash;
            if (hash) {
                var element = document.querySelector(hash);
                if (element) {
                    (0, _jquery2.default)('html, body').animate({
                        scrollTop: (0, _jquery2.default)(element).offset().top
                    }, 2000);
                }
            }
            this.props.onItemClick(this);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var data = this.props.item;
            var route = this.props.route;
            var itemName = this.props['item-name'];
            var isActive = route.location.pathname == data.url;
            var _itemClass = (0, _classnames2.default)({
                'submenu-parent': this.hasSubmenu,
                'active-page': isActive,
                'expand-submenu': this.state.isExpanded,
                'layered-submenu': this.hasSubmenu && this.props.settings.submenuType == 'layer'
            });
            var LinkProps = {
                item: this.props.item,
                onToggleSubmenu: this.toggleSubmenu.bind(this),
                isExpandedSubmenu: this.state.isExpanded,
                position: this.props.settings.position,
                submenuType: this.props.settings.submenuType
            };
            if (this.hasSubmenu) {
                var itemProps = {
                    className: _itemClass,
                    onMouseEnter: function onMouseEnter(e) {
                        _this2.props.onMouseEnter(_this2);
                    },
                    onMouseLeave: function onMouseLeave(e) {
                        _this2.props.onMouseLeave(_this2);
                    }

                };

                var NavMenuProps = {
                    items: data.submenu,
                    settings: this.props.settings,
                    route: this.props.route,
                    isSubmenu: true,
                    onItemClick: this.props.onItemClick
                };

                return _react2.default.createElement(
                    'li',
                    itemProps,
                    _react2.default.createElement(_link2.default, LinkProps),
                    _react2.default.createElement(_navMenu2.default, NavMenuProps)
                );
            } else {
                return _react2.default.createElement(
                    'li',
                    { className: _itemClass },
                    _react2.default.createElement(_link2.default, LinkProps)
                );
            }
        } // render()

    }]);

    return NavItem;
}(_react2.default.Component); // ListItem


exports.default = NavItem;
NavItem.propTypes = {
    item: _react2.default.PropTypes.object.isRequired,
    settings: _react2.default.PropTypes.object.isRequired,
    route: _react2.default.PropTypes.object.isRequired,
    isSubmenuItem: _react2.default.PropTypes.bool,
    onItemClick: _react2.default.PropTypes.func,
    onMouseEnter: _react2.default.PropTypes.func,
    onMouseLeave: _react2.default.PropTypes.func
};
NavItem.defaultProps = {
    isSubmenuItem: false,
    onItemClick: function onItemClick() {},
    onMouseLeave: function onMouseLeave() {},
    onMouseEnter: function onMouseEnter() {}
};

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _navMenu = __webpack_require__(65);

var _navMenu2 = _interopRequireDefault(_navMenu);

var _Down = __webpack_require__(76);

var _Down2 = _interopRequireDefault(_Down);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SideNavInlineMenu = function (_React$Component) {
    _inherits(SideNavInlineMenu, _React$Component);

    function SideNavInlineMenu(props) {
        _classCallCheck(this, SideNavInlineMenu);

        var _this = _possibleConstructorReturn(this, (SideNavInlineMenu.__proto__ || Object.getPrototypeOf(SideNavInlineMenu)).call(this, props));

        _this.settings = props.isMobile ? props.navigation.mobile : props.navigation.desktop;
        _this.expandedSubmenu = null;
        return _this;
    }

    _createClass(SideNavInlineMenu, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            //console.log("Nav Unmount");
            //$('body').off('click.nav');
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            //console.log("Nav Mount");
            //this.bindEvents();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            //this.bindEvents();
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            var _this2 = this;

            if (this.settings.toggleSubmenu == 'onClick' && this.settings.submenuType == 'layer') {
                (0, _jquery2.default)('body').on('click.nav', function (e) {
                    if ((0, _jquery2.default)(e.target).closest('.submenu-parent').length == 0) {
                        _this2.hideExpandedSubmenuLayer();
                    }
                });
            }
        }
    }, {
        key: 'getTemplate',
        value: function getTemplate(route) {}
    }, {
        key: 'doItemClick',
        value: function doItemClick(navItem) {
            if (navItem.props.item.submenu != null && navItem.props.item.submenu.length > 0) {
                if (!navItem.state.isExpanded) {
                    this.expandedSubmenu = navItem;
                }
                navItem.setState({
                    isExpanded: !navItem.state.isExpanded
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            console.log("Render Nav");

            var navItems = this.props.navigation.links;
            var _class = (0, _classnames2.default)({
                'menu-container': true,
                'position-right': this.settings.position == 'right'
            });
            var NavMenuProps = {
                items: navItems,
                settings: this.settings,
                route: this.props.route,
                isSubmenu: false,
                onItemClick: this.doItemClick.bind(this)
            };

            return _react2.default.createElement(
                'nav',
                { id: 'navigation-module', className: _class },
                _react2.default.createElement(_navMenu2.default, NavMenuProps)
            );
        }
    }]);

    return SideNavInlineMenu;
}(_react2.default.Component);

exports.default = SideNavInlineMenu;


SideNavInlineMenu.propTypes = {
    "navigation": _react2.default.PropTypes.object.isRequired,
    "route": _react2.default.PropTypes.object.isRequired,
    "isMobile": _react2.default.PropTypes.bool
};
SideNavInlineMenu.defaultProps = {
    "isMobile": window.medscape.isMobile ? window.medscape.isMobile : false
};

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _navMenu = __webpack_require__(65);

var _navMenu2 = _interopRequireDefault(_navMenu);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SideNavLayerMenu = function (_React$Component) {
    _inherits(SideNavLayerMenu, _React$Component);

    function SideNavLayerMenu(props) {
        _classCallCheck(this, SideNavLayerMenu);

        var _this = _possibleConstructorReturn(this, (SideNavLayerMenu.__proto__ || Object.getPrototypeOf(SideNavLayerMenu)).call(this, props));

        _this.settings = props.isMobile ? props.navigation.mobile : props.navigation.desktop;
        _this.expandedSubmenu = null;
        return _this;
    }

    _createClass(SideNavLayerMenu, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            //console.log("Nav Unmount");
            //$('body').off('click.nav');
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            //console.log("Nav Mount");
            this.bindEvents();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            //console.log("Nav Update");
            this.bindEvents();
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            var _this2 = this;

            if (this.settings.toggleSubmenu == 'onClick' && this.settings.submenuType == 'layer') {
                (0, _jquery2.default)('body').off('click.nav').on('click.nav', function (e) {
                    if ((0, _jquery2.default)(e.target).closest('.submenu-parent').length == 0) {
                        _this2.hideExpandedSubmenuLayer();
                    }
                });
                (0, _jquery2.default)('body').off('touchstart.nav').on('touchstart.nav', function (e) {
                    if ((0, _jquery2.default)(e.target).closest('.submenu-parent').length == 0) {
                        _this2.hideExpandedSubmenuLayer();
                    }
                });
            }
        }
    }, {
        key: 'getTemplate',
        value: function getTemplate(route) {}
    }, {
        key: 'hideExpandedSubmenuLayer',
        value: function hideExpandedSubmenuLayer() {
            if (this.expandedSubmenu != null) {
                this.expandedSubmenu.setState({
                    isExpanded: false
                });
                this.expandedSubmenu = null;
            }
        }
    }, {
        key: 'doItemClick',
        value: function doItemClick(navItem) {
            if (this.settings.toggleSubmenu == 'onClick') {
                this.hideExpandedSubmenuLayer();
                if (navItem.props.item.submenu != null && navItem.props.item.submenu.length > 0) {
                    if (!navItem.state.isExpanded) {
                        this.expandedSubmenu = navItem;
                    }
                    navItem.setState({
                        isExpanded: !navItem.state.isExpanded
                    });
                }
            }
        }
    }, {
        key: 'doItemMouseEnter',
        value: function doItemMouseEnter(navItem) {
            //console.log("Item Mouse Enter:",navItem);
            if (this.settings.toggleSubmenu == 'onMouseEnter') {
                this.hideExpandedSubmenuLayer();
                navItem.setState({
                    isExpanded: true
                });
            }
        }
    }, {
        key: 'doItemMouseLeave',
        value: function doItemMouseLeave(navItem) {
            //console.log("Item Mouse Leave:",navItem);
            if (this.settings.toggleSubmenu == 'onMouseEnter') {
                navItem.setState({
                    isExpanded: false
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var navItems = this.props.navigation.links;
            var _class = (0, _classnames2.default)({
                'menu-container': true,
                'position-right': this.settings.position == 'right'
            });
            var NavMenuProps = {
                items: navItems,
                settings: this.settings,
                route: this.props.route,
                isSubmenu: false,
                onItemClick: this.doItemClick.bind(this),
                onItemMouseEnter: this.doItemMouseEnter.bind(this),
                onItemMouseLeave: this.doItemMouseLeave.bind(this)
            };
            return _react2.default.createElement(
                'nav',
                { id: 'navigation-module', className: _class },
                _react2.default.createElement(_navMenu2.default, NavMenuProps)
            );
        }
    }]);

    return SideNavLayerMenu;
}(_react2.default.Component);

exports.default = SideNavLayerMenu;


SideNavLayerMenu.propTypes = {
    "navigation": _react2.default.PropTypes.object.isRequired,
    "route": _react2.default.PropTypes.object.isRequired,
    "isMobile": _react2.default.PropTypes.bool
};
SideNavLayerMenu.defaultProps = {
    "isMobile": window.medscape.isMobile ? window.medscape.isMobile : false
};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _navMenu = __webpack_require__(65);

var _navMenu2 = _interopRequireDefault(_navMenu);

var _Down = __webpack_require__(76);

var _Down2 = _interopRequireDefault(_Down);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TopNavLayerMenu = function (_React$Component) {
    _inherits(TopNavLayerMenu, _React$Component);

    function TopNavLayerMenu(props) {
        _classCallCheck(this, TopNavLayerMenu);

        var _this = _possibleConstructorReturn(this, (TopNavLayerMenu.__proto__ || Object.getPrototypeOf(TopNavLayerMenu)).call(this, props));

        _this.settings = props.isMobile ? props.navigation.mobile : props.navigation.desktop;
        _this.expandedSubmenu = null;
        return _this;
    }

    _createClass(TopNavLayerMenu, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (0, _jquery2.default)(document).off('click.nav');
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            //console.log("Nav Mount");
            this.bindEvents();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            //console.log("Nav Update");
            this.bindEvents();
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            var _this2 = this;

            if (this.settings.toggleSubmenu == 'onClick' && this.settings.submenuType == 'layer') {
                (0, _jquery2.default)(document).off('click.nav').on('click.nav', function (e) {
                    if ((0, _jquery2.default)(e.target).closest('.submenu-parent').length == 0) {
                        _this2.hideExpandedSubmenuLayer();
                    }
                });
            }
        }
    }, {
        key: 'getTemplate',
        value: function getTemplate(route) {}
    }, {
        key: 'hideExpandedSubmenuLayer',
        value: function hideExpandedSubmenuLayer() {
            if (this.expandedSubmenu != null) {
                //console.log("Hide Nav Menu:",this.expandedSubmenu);
                this.expandedSubmenu.setState({
                    isExpanded: false
                });
                this.expandedSubmenu = null;
            }
        }
    }, {
        key: 'doItemClick',
        value: function doItemClick(navItem) {
            if (this.settings.toggleSubmenu == 'onClick') {
                this.hideExpandedSubmenuLayer();
                if (navItem.props.item.submenu != null && navItem.props.item.submenu.length > 0) {
                    if (!navItem.state.isExpanded) {
                        this.expandedSubmenu = navItem;
                    }
                    navItem.setState({
                        isExpanded: !navItem.state.isExpanded
                    });
                }
            }
        }
    }, {
        key: 'doItemMouseEnter',
        value: function doItemMouseEnter(navItem) {
            //console.log("Item Mouse Enter:",navItem);
            if (this.settings.toggleSubmenu == 'onMouseEnter') {
                this.hideExpandedSubmenuLayer();
                navItem.setState({
                    isExpanded: true
                });
            }
        }
    }, {
        key: 'doItemMouseLeave',
        value: function doItemMouseLeave(navItem) {
            //console.log("Item Mouse Leave:",navItem);
            if (this.settings.toggleSubmenu == 'onMouseEnter') {
                navItem.setState({
                    isExpanded: false
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var navItems = this.props.navigation.links;
            var _class = (0, _classnames2.default)({
                'menu-container': true,
                'position-top': true
            });
            var NavMenuProps = {
                items: navItems,
                settings: this.settings,
                route: this.props.route,
                isSubmenu: false,
                onItemClick: this.doItemClick.bind(this),
                onItemMouseEnter: this.doItemMouseEnter.bind(this),
                onItemMouseLeave: this.doItemMouseLeave.bind(this)
            };
            return _react2.default.createElement(
                'nav',
                { id: 'navigation-module', className: _class },
                _react2.default.createElement(_navMenu2.default, NavMenuProps)
            );
        }
    }]);

    return TopNavLayerMenu;
}(_react2.default.Component);

exports.default = TopNavLayerMenu;


TopNavLayerMenu.propTypes = {
    "navigation": _react2.default.PropTypes.object.isRequired,
    "route": _react2.default.PropTypes.object.isRequired,
    "isMobile": _react2.default.PropTypes.bool
};
TopNavLayerMenu.defaultProps = {
    "isMobile": window.medscape.isMobile ? window.medscape.isMobile : false
};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _template = __webpack_require__(417);

var _template2 = _interopRequireDefault(_template);

var _mobileMenu = __webpack_require__(353);

var _mobileMenu2 = _interopRequireDefault(_mobileMenu);

var _reactRouterDom = __webpack_require__(192);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageContentModule = function (_React$Component) {
  _inherits(PageContentModule, _React$Component);

  function PageContentModule(props) {
    _classCallCheck(this, PageContentModule);

    return _possibleConstructorReturn(this, (PageContentModule.__proto__ || Object.getPrototypeOf(PageContentModule)).call(this, props));
  }

  _createClass(PageContentModule, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
      var isMobile = window.medscape.isMobile ? window.medscape.isMobile : false;
      if (isMobile) {
        _mobileMenu2.default.init(this.props.navigation, this.route);
      }
    }
  }, {
    key: 'getTemplate',
    value: function getTemplate(route) {
      //console.log("Route:",route);
      this.route = route;
      var routePath = route.location.pathname;
      var page = this.props.pages.find(function (page) {
        return page.route == routePath;
      });
      page = page || this.props.pages[0];
      var TemplateProps = {
        page: page,
        navigation: this.props.navigation,
        route: route,
        isi: this.props.isi
      };
      return _react2.default.createElement(_template2.default, TemplateProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var basename = window.medscape.config.appServer ? window.medscape.config.appServer.path + '/' : '';
      //console.log("Route Basename: ",basename);
      console.log("Route Render");
      var RouteProps = {
        path: '/',
        component: this.getTemplate.bind(this)
      };
      return _react2.default.createElement(
        _reactRouterDom.BrowserRouter,
        { basename: basename },
        _react2.default.createElement(
          'div',
          { id: 'page-content-module' },
          _react2.default.createElement(_reactRouterDom.Route, RouteProps)
        )
      );
    }
  }]);

  return PageContentModule;
}(_react2.default.Component);

exports.default = PageContentModule;


PageContentModule.propTypes = {
  "pages": _react2.default.PropTypes.array.isRequired,
  "navigation": _react2.default.PropTypes.object.isRequired,
  "isi": _react2.default.PropTypes.object
};
PageContentModule.defaultProps = {
  "isi": null
};

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _navigation = __webpack_require__(207);

var _navigation2 = _interopRequireDefault(_navigation);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(42);

var _helpers = __webpack_require__(30);

var _helpers2 = _interopRequireDefault(_helpers);

var _app = __webpack_require__(209);

var _app2 = _interopRequireDefault(_app);

var _actions = __webpack_require__(91);

var _actions2 = _interopRequireDefault(_actions);

var _Spinning = __webpack_require__(671);

var _Spinning2 = _interopRequireDefault(_Spinning);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

var _animation = __webpack_require__(315);

var _animation2 = _interopRequireDefault(_animation);

var _actions3 = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContentCache = {};

var Article = function (_React$Component) {
    _inherits(Article, _React$Component);

    function Article(props) {
        _classCallCheck(this, Article);

        var _this = _possibleConstructorReturn(this, (Article.__proto__ || Object.getPrototypeOf(Article)).call(this, props));

        _this.state = {
            content: '',
            hideIsi: false
        };
        _this.isFirstPageView = true;
        return _this;
    }

    _createClass(Article, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props$page$metaData = this.props.page["meta-data"],
                titleTag = _props$page$metaData.titleTag,
                description = _props$page$metaData.description;

            _actions3.MetaDataActions.setTitle(titleTag);
            _actions3.MetaDataActions.setDescription(description);
            this.getContent(this.props.page);
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return this.state.content.length == 0 || nextProps.page.path != this.props.page.path || nextState.content != this.state.content || nextState.hideIsi != this.state.hideIsi;
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            if ((0, _lodash.isUndefined)(this.props.page) === false && this.state.content.length > 0 && nextProps.page != this.props.page) {
                var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
                try {
                    _helpers2.default.unload($this[0]);
                    (0, _jquery2.default)(document).trigger('article:unload', [this.props.page, $this[0]]);
                } catch (e) {
                    console.log("Some Error:", e.message);
                }
            }
            if (nextProps.page.path != this.props.page.path) {
                var _nextProps$page$meta = nextProps.page["meta-data"],
                    titleTag = _nextProps$page$meta.titleTag,
                    description = _nextProps$page$meta.description;

                _actions3.MetaDataActions.setTitle(titleTag);
                _actions3.MetaDataActions.setDescription(description);
                this.getContent(nextProps.page);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.onRendered();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (prevProps.page == this.props.page) {
                this.onRendered();
                this.comment();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
            _helpers2.default.unload($this[0]);
            (0, _jquery2.default)(document).trigger('article:unload', [this.props.page, $this[0]]);
        }
    }, {
        key: 'onRendered',
        value: function onRendered() {
            var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
            if (this.state.content.length > 0) {
                var $h1 = $this.find('h1');
                var page = _jquery2.default.extend({}, this.props.page, true);
                page["meta-data"].h1 = $h1.length > 0 ? $h1[0].innerText : "";
                _helpers2.default.updatePage(page);
                _helpers2.default.load($this[0]);
                (0, _jquery2.default)(document).trigger('article:load', [page, $this[0]]);
                var hash = window.location.hash;
                if (_utils2.default.isApp() && _utils2.default.isIOS()) {
                    (0, _jquery2.default)('#page-content-module a').click(function (e) {
                        if (e.target.getAttribute('href').indexOf('#') === 0) {
                            e.preventDefault();
                            window.location = e.target.getAttribute('href');
                        }
                    });
                }
                if (hash) {
                    var element = document.querySelector(hash);
                    if (element) {
                        element.scrollIntoView();
                    }
                }
            }
        }
    }, {
        key: 'comment',
        value: function comment() {
            if (infosite.config["comment"].icon) {
                (0, _jquery2.default)('.comments-wrap').css('background-image', config.icon);
            }
            if (infosite.config.comment.isActive && (0, _jquery2.default)('.comments-wrap').length > 0) {
                (0, _jquery2.default)('.comments-wrap').one('click', function () {
                    var src = window.location.href.split('?')[0] + '/articles/comments';
                    (0, _jquery2.default)('.infosite-comments iframe').attr('src', src);
                });
            }
            (0, _jquery2.default)('.comments-wrap').click(function (event) {
                window.scrollTo(0, 0);
                _tracking2.default.track('comments_open');
                _animation2.default.slideFadeIn(document.getElementById('infosite-comments'), document.getElementsByClassName('infosite-comments')[0]);
            });
            (0, _jquery2.default)('.close-btn').click(function (event) {
                _tracking2.default.track('comments_close');
                _animation2.default.slideFadeOut(document.getElementById('infosite-comments'), document.getElementsByClassName('infosite-comments')[0]);
            });
        }
    }, {
        key: 'getContent',
        value: function getContent(page) {
            var _this2 = this;

            if (ContentCache[page.path]) {
                this.setState({
                    content: ContentCache[page.path]
                });
                return;
            }
            var doSuccess = function doSuccess(data) {
                ContentCache[page.path] = data;
                _this2.setState({
                    content: data
                });
            };
            var doError = function doError(response) {
                alert("Ajax Error");
                console.error("Error: PageContent.getContent()", page);
            };
            var baseURL = window.medscape.config.appServer.host + window.medscape.config.appServer.path;
            if (window.medscape.config.env == "localhost") {
                baseURL += "/build/localhost/app";
            }

            var url = '' + baseURL + page.path;
            if (window.medscape.config.env == "localhost") {
                url += ".jsp";
            }
            _jquery2.default.ajax({
                type: 'get',
                url: url,
                data: {},
                dataType: 'html',
                cache: false
            }).then(doSuccess, doError);
        }
    }, {
        key: 'getISI',
        value: function getISI() {
            if (!this.props.isi || !this.props.page.showIsiModule) {
                return false;
            } else {
                var pageSettings = window.medscape.isMobile ? this.props.isi.pageSettings.mobile : this.props.isi.pageSettings.desktop;
                var inlineIsi = _jquery2.default.extend({}, this.props.isi);
                if (pageSettings.isSticky) {
                    var containerClass = (0, _classnames2.default)({
                        "isi-container": true,
                        "sticky": pageSettings.isSticky,
                        //"position-top": position=='top',
                        "position-bottom": true,
                        "hidden": this.state.hideIsi
                    });
                    return _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            { id: 'isi-article-container', className: 'isi-container' },
                            _react2.default.createElement(_app2.default, { config: inlineIsi })
                        ),
                        _react2.default.createElement(
                            'div',
                            { id: 'isi-sticky-container', className: containerClass },
                            _react2.default.createElement(_app2.default, { config: this.props.isi, isSticky: true, isInline: false, isExpanded: this.props.isi.isExpanded })
                        )
                    );
                } else {
                    return _react2.default.createElement(
                        'div',
                        { id: 'isi-article-container', className: 'isi-container' },
                        _react2.default.createElement(_app2.default, { config: inlineIsi })
                    );
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.content.length == 0) {
                var CircleProps = {
                    cx: "50",
                    cy: "50",
                    r: "40",
                    "strokeDasharray": "125 126",
                    "stroke": "#000",
                    "fill": "none",
                    "strokeWidth": "20",
                    "style": {
                        stroke: "rgb(173, 158, 158)",
                        strokeWidth: "20px",
                        strokeDasharray: "163.363, 87.9646",
                        transfrom: "rotate(126 50 50)"
                    }
                };

                var BkProps = {
                    className: "bk",
                    x: "0",
                    y: "0",
                    width: "100",
                    height: "100",
                    fill: "#fff",
                    style: {
                        fill: "fill: rgb(255, 255, 255)"
                    }
                };
                return _react2.default.createElement(
                    'article',
                    { className: 'main-content' },
                    _react2.default.createElement(
                        'div',
                        { className: 'article-content' },
                        _react2.default.createElement(
                            'div',
                            { className: 'spinner-container' },
                            _react2.default.createElement(
                                'div',
                                { className: 'spinner' },
                                _react2.default.createElement(
                                    'svg',
                                    { width: '100%', height: '100%', viewBox: '0 0 100 100', preserveAspectRatio: 'xMidYMid', className: 'uil-ring' },
                                    _react2.default.createElement('rect', BkProps),
                                    _react2.default.createElement('circle', CircleProps)
                                )
                            )
                        )
                    )
                );
            }

            var content = _utils2.default.getDangerousHtml(this.state.content);
            var isiModule = this.getISI();
            //alert("Update Content: \n"+this.state.content);
            return _react2.default.createElement(
                'article',
                { className: 'main-content' },
                _react2.default.createElement('div', { className: 'article-content', dangerouslySetInnerHTML: content }),
                isiModule
            );
        }
    }]);

    return Article;
}(_react2.default.Component);

exports.default = Article;


Article.propTypes = {
    "page": _react2.default.PropTypes.object.isRequired,
    "isi": _react2.default.PropTypes.object
};
Article.defaultProps = {};

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MetaDescriptionTag = exports.MetaTitleTag = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _store = __webpack_require__(356);

var _actions = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MetaTitleTag = exports.MetaTitleTag = function (_Reflux$Component) {
  _inherits(MetaTitleTag, _Reflux$Component);

  function MetaTitleTag(props) {
    _classCallCheck(this, MetaTitleTag);

    var _this2 = _possibleConstructorReturn(this, (MetaTitleTag.__proto__ || Object.getPrototypeOf(MetaTitleTag)).call(this, props));

    _this2.state = {
      titleTag: ''
    };
    _this2.store = new _store.MetaDataStore();
    return _this2;
  }

  _createClass(MetaTitleTag, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.titleTag != this.state.titleTag;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this = _reactDom2.default.findDOMNode(this);
      if (document.head.querySelector('title') != null) {
        $(document.head.querySelector('title')).remove();
      }
      var firstChild = document.head.firstChild;
      document.head.insertBefore(_this, firstChild);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'title',
        null,
        this.state.titleTag
      );
    }
  }]);

  return MetaTitleTag;
}(_reflux2.default.Component);

var MetaDescriptionTag = exports.MetaDescriptionTag = function (_Reflux$Component2) {
  _inherits(MetaDescriptionTag, _Reflux$Component2);

  function MetaDescriptionTag(props) {
    _classCallCheck(this, MetaDescriptionTag);

    var _this3 = _possibleConstructorReturn(this, (MetaDescriptionTag.__proto__ || Object.getPrototypeOf(MetaDescriptionTag)).call(this, props));

    _this3.state = {
      description: ''
    };
    _this3.store = new _store.MetaDataStore();
    return _this3;
  }

  _createClass(MetaDescriptionTag, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.descrption != this.state.description;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this = _reactDom2.default.findDOMNode(this);
      if (document.head.querySelector('meta[name="description"]') != null) {
        $(document.head.querySelector('meta[name="description"]')).remove();
      }
      var firstChild = document.head.firstChild;
      document.head.insertBefore(_this, firstChild);
    }
  }, {
    key: 'render',
    value: function render() {
      var description = this.state.description.replace(/"/g, '&quote;');
      return _react2.default.createElement('meta', { name: 'description', content: description });
    }
  }]);

  return MetaDescriptionTag;
}(_reflux2.default.Component);

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _navigation = __webpack_require__(207);

var _navigation2 = _interopRequireDefault(_navigation);

var _helpers = __webpack_require__(30);

var _helpers2 = _interopRequireDefault(_helpers);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

var _article = __webpack_require__(415);

var _article2 = _interopRequireDefault(_article);

var _sideMenu = __webpack_require__(210);

var _sideMenu2 = _interopRequireDefault(_sideMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Template = function (_React$Component) {
    _inherits(Template, _React$Component);

    function Template(props) {
        _classCallCheck(this, Template);

        var _this = _possibleConstructorReturn(this, (Template.__proto__ || Object.getPrototypeOf(Template)).call(this, props));

        _this.state = {};
        _helpers2.default.setBrowserHistory(props.route.history);
        return _this;
    }

    _createClass(Template, [{
        key: 'getTemplate',
        value: function getTemplate() {
            var template = void 0;
            var templateType = this.props.page.template;

            if (window.medscape.isMobile) {
                templateType = "mobile";
            }
            if (this.props.navigation.links.length == 0) {
                templateType = "default";
            }
            switch (templateType) {
                case "navigation":
                    template = NavTemplate(this.props);
                    break;
                case "mobile":
                    template = MobileTemplate(this.props);
                    break;
                default:
                    template = DefaultTemplate(this.props);
            }
            return template;
        }
    }, {
        key: 'render',
        value: function render() {

            var template = this.getTemplate();
            var className = (0, _classnames2.default)({
                'page-template-wrapper': true,
                'flow-invert': !this.props.isMobile && this.props.navigation.desktop.position == 'right',
                'flow-column': !this.props.isMobile && this.props.navigation.desktop.position == 'top'

            });
            return _react2.default.createElement(
                'section',
                { className: className },
                template
            );
        }
    }]);

    return Template;
}(_react2.default.Component);

exports.default = Template;


Template.propTypes = {
    "page": _react2.default.PropTypes.object.isRequired,
    "navigation": _react2.default.PropTypes.object.isRequired,
    "route": _react2.default.PropTypes.object.isRequired,
    "isMobile": _react2.default.PropTypes.bool,
    "isi": _react2.default.PropTypes.object
};
Template.defaultProps = {
    "isMobile": window.medscape.isMobile ? window.medscape.isMobile : false
};

var DefaultTemplate = function DefaultTemplate(props) {
    return _react2.default.createElement(
        'section',
        { className: 'main-content default-template' },
        _react2.default.createElement(_article2.default, { key: 'infosite-article', page: props.page, isi: props.isi })
    );
};

var NavTemplate = function NavTemplate(props) {
    return _react2.default.createElement(
        'section',
        { className: 'main-content nav-template' },
        _react2.default.createElement(_navigation2.default, { navigation: props.navigation, route: props.route }),
        _react2.default.createElement(_article2.default, { key: 'infosite-article', page: props.page, isi: props.isi })
    );
};

var MobileTemplate = function MobileTemplate(props) {
    return _react2.default.createElement(
        'section',
        { className: 'mobile-template' },
        _react2.default.createElement(_sideMenu2.default, { navigation: props.navigation, route: props.route }),
        _react2.default.createElement(
            'section',
            { className: 'main-content default-template', id: 'page-wrap' },
            _react2.default.createElement(_article2.default, { key: 'infosite-article', page: props.page, isi: props.isi })
        )
    );
};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResourcesComponent = function (_React$Component) {
    _inherits(ResourcesComponent, _React$Component);

    function ResourcesComponent(props) {
        _classCallCheck(this, ResourcesComponent);

        return _possibleConstructorReturn(this, (ResourcesComponent.__proto__ || Object.getPrototypeOf(ResourcesComponent)).call(this, props));
    }

    _createClass(ResourcesComponent, [{
        key: 'render',
        value: function render() {
            var titleProps = {
                dangerouslySetInnerHTML: _utils2.default.getDangerousHtml(this.props.title)
            };
            var resources = this.getResources();
            return _react2.default.createElement(
                'div',
                { className: 'more-resources-component' },
                _react2.default.createElement('h1', titleProps),
                _react2.default.createElement(
                    'ul',
                    { className: 'resources-container' },
                    resources
                )
            );
        } // render

    }, {
        key: 'getResources',
        value: function getResources() {
            var _this2 = this;

            var _resources = this.props.resources;
            var resources = _resources.map(function (data, index) {
                var itemKey = "resource-" + index;
                return _react2.default.createElement(ResourceItem, _extends({ key: itemKey, moduleId: _this2.props["config-id"] }, data));
            });

            return resources;
        } // getReources

    }]);

    return ResourcesComponent;
}(_react2.default.Component);

exports.default = ResourcesComponent;

ResourcesComponent.propTypes = {
    "title": _react2.default.PropTypes.string,
    "resources": _react2.default.PropTypes.array
};
ResourcesComponent.defaultProps = {
    "title": "More Resources",
    "resources": []
};

var ResourceItem = function (_React$Component2) {
    _inherits(ResourceItem, _React$Component2);

    function ResourceItem(props) {
        _classCallCheck(this, ResourceItem);

        return _possibleConstructorReturn(this, (ResourceItem.__proto__ || Object.getPrototypeOf(ResourceItem)).call(this, props));
    }

    _createClass(ResourceItem, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'render',
        value: function render() {
            var image = this.props.image;
            image = image.startsWith('http') ? image : window.medscape.config.staticServer.host + window.medscape.config.staticServer.path + image;

            var button = this.props.button;

            var titleProps = {
                className: 'title',
                dangerouslySetInnerHTML: _utils2.default.getDangerousHtml(this.props.title)
            };
            var descriptionProps = {
                className: 'description',
                dangerouslySetInnerHTML: _utils2.default.getDangerousHtml(this.props.description)
            };

            return _react2.default.createElement(
                'li',
                { className: 'resource-item' },
                _react2.default.createElement(
                    'div',
                    { className: 'image-container' },
                    _react2.default.createElement('img', { src: image })
                ),
                _react2.default.createElement('h5', titleProps),
                _react2.default.createElement('p', descriptionProps),
                _react2.default.createElement(Button, _extends({}, button, { linkId: this.props["config-id"], moduleId: this.props.moduleId }))
            );
        } // render

    }]);

    return ResourceItem;
}(_react2.default.Component);

ResourceItem.propTypes = {
    "image": _react2.default.PropTypes.string,
    "title": _react2.default.PropTypes.string,
    "description": _react2.default.PropTypes.string,
    "button": _react2.default.PropTypes.object
};
ResourceItem.defaultProps = {
    "image": "",
    "title": "",
    "description": "",
    "button": {}
};

var Button = function (_React$Component3) {
    _inherits(Button, _React$Component3);

    function Button(props) {
        _classCallCheck(this, Button);

        return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));
    }

    _createClass(Button, [{
        key: 'componentDidMount',
        value: function componentDidMount() {}
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var url = this.props.link.startsWith('http') || this.props.link.startsWith('www') ? this.props.link : '' + window.medscape.config.staticServer.host + this.props.link;
            if (url.indexOf(".medscape.") < 0) {
                return;
            }
            var module = 'res-' + this.props.moduleId + '_' + this.props.linkId;
            _tracking2.default.pageLink(module);
        }
    }, {
        key: 'render',
        value: function render() {
            var titleProps = {
                className: 'title',
                dangerouslySetInnerHTML: _utils2.default.getDangerousHtml(this.props.title)
            };
            var url = this.props.link.startsWith('http') || this.props.link.startsWith('www') ? this.props.link : '' + window.medscape.config.staticServer.host + this.props.link;
            var linkProps = {
                className: 'button',
                href: url,
                target: this.props.target
            };
            return _react2.default.createElement(
                'a',
                _extends({}, linkProps, { onClick: this.handleClick.bind(this) }),
                _react2.default.createElement('span', titleProps)
            );
        } // render

    }]);

    return Button;
}(_react2.default.Component);

Button.propTypes = {
    "link": _react2.default.PropTypes.string,
    "title": _react2.default.PropTypes.string,
    "target": _react2.default.PropTypes.string
};
Button.defaultProps = {
    "link": "",
    "title": "",
    "target": "_self"
};

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ZoomIn = __webpack_require__(681);

var _ZoomIn2 = _interopRequireDefault(_ZoomIn);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ZoomButton = function (_React$Component) {
  _inherits(ZoomButton, _React$Component);

  function ZoomButton(props) {
    _classCallCheck(this, ZoomButton);

    var _this = _possibleConstructorReturn(this, (ZoomButton.__proto__ || Object.getPrototypeOf(ZoomButton)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(ZoomButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'render',
    value: function render() {
      if (this.props.icon.length == 0) {
        return _react2.default.createElement(
          'button',
          { className: 'zoom-button', onClick: this.props.onClick },
          _react2.default.createElement(_ZoomIn2.default, null)
        );
      } else {
        return _react2.default.createElement('button', { className: 'zoom-button', onClick: this.props.onClick, dangerouslySetInnerHTML: iconHtml });
      }
    }
  }]);

  return ZoomButton;
}(_react2.default.Component);

exports.default = ZoomButton;


ZoomButton.propTypes = {
  "onClick": _react2.default.PropTypes.func,
  "icon": _react2.default.PropTypes.string
};
ZoomButton.defaultProps = {
  "onClick": function onClick() {},
  "icon": ""
};

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _tracking = __webpack_require__(18);

var _tracking2 = _interopRequireDefault(_tracking);

var _zoomButton = __webpack_require__(419);

var _zoomButton2 = _interopRequireDefault(_zoomButton);

var _zoomLayer = __webpack_require__(359);

var _zoomLayer2 = _interopRequireDefault(_zoomLayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ZoomImage = function (_React$Component) {
  _inherits(ZoomImage, _React$Component);

  function ZoomImage(props) {
    _classCallCheck(this, ZoomImage);

    var _this = _possibleConstructorReturn(this, (ZoomImage.__proto__ || Object.getPrototypeOf(ZoomImage)).call(this, props));

    props.default.image.src = _utils2.default.getCompiledHtml(props.default.image.src);
    _this.state = {};

    return _this;
  }

  _createClass(ZoomImage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'doZoom',
    value: function doZoom(e) {
      this.props.onZoom(e);
      _zoomLayer2.default.open(this.props.enlarged);
    }
  }, {
    key: 'render',
    value: function render() {
      var config = window.medscape.isMobile ? this.props.mobile : this.props.desktop;
      if (config.isActive) {
        if (config.showIcon) {
          return _react2.default.createElement(
            'div',
            { className: 'module-wrapper' },
            _react2.default.createElement('img', _extends({}, this.props.default.image, { onClick: this.doZoom.bind(this) })),
            _react2.default.createElement(_zoomButton2.default, { onClick: this.doZoom.bind(this) })
          );
        } else {
          return _react2.default.createElement(
            'div',
            { className: 'module-wrapper' },
            _react2.default.createElement('img', _extends({}, this.props.default.image, { onClick: this.doZoom.bind(this) }))
          );
        }
      } else {
        return _react2.default.createElement(
          'div',
          { className: 'module-wrapper no-zoom' },
          _react2.default.createElement('img', this.props.default.image)
        );
      }
    }
  }]);

  return ZoomImage;
}(_react2.default.Component);

exports.default = ZoomImage;


ZoomImage.propTypes = {
  "config-id": _react2.default.PropTypes.string,
  "default": _react2.default.PropTypes.object,
  "enlarged": _react2.default.PropTypes.object,
  "mobile": _react2.default.PropTypes.object,
  "desktop": _react2.default.PropTypes.object,
  "onZoom": _react2.default.PropTypes.func
};
ZoomImage.defaultProps = {
  onZoom: function onZoom() {}
};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _reactModal = __webpack_require__(190);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _helpers = __webpack_require__(30);

var _helpers2 = _interopRequireDefault(_helpers);

var _actions = __webpack_require__(137);

var _actions2 = _interopRequireDefault(_actions);

var _store = __webpack_require__(360);

var _store2 = _interopRequireDefault(_store);

var _zoomContent = __webpack_require__(424);

var _zoomContent2 = _interopRequireDefault(_zoomContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ZoomLayer = function (_Reflux$Component) {
  _inherits(ZoomLayer, _Reflux$Component);

  function ZoomLayer(props) {
    _classCallCheck(this, ZoomLayer);

    var _this = _possibleConstructorReturn(this, (ZoomLayer.__proto__ || Object.getPrototypeOf(ZoomLayer)).call(this, props));

    _this.state = {};
    _this.store = _store2.default;
    return _this;
  }

  _createClass(ZoomLayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      //let $this = $(ReactDOM.findDOMNode(this));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {}
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var $this = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this));
      if (this.state.modalIsOpen) {
        _helpers2.default.lockScroll("zoom-images-modal");
      } else {
        _helpers2.default.unlockScroll("zoom-images-modal");
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'onAfterOpen',
    value: function onAfterOpen() {}
  }, {
    key: 'doClose',
    value: function doClose(e) {
      _actions2.default.close(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var customStyles = {
        content: {
          //top: 20
        },
        overlay: {
          backgroundColor: 'none'
          //position: 'absolute',
          //height: $document.height()
        }
      };
      var modalProps = {
        key: 'zoom-layer',
        isOpen: this.state.modalIsOpen && this.state.settings != null,
        onAfterOpen: this.onAfterOpen,
        onRequestClose: _actions2.default.close,
        shouldCloseOnOverlayClick: false,
        className: "zoom-images-modal",
        contentLabel: "Zoom Images Modal",
        style: customStyles
      };
      return _react2.default.createElement(
        _reactModal2.default,
        modalProps,
        _react2.default.createElement(_zoomContent2.default, _extends({}, this.state.settings, { onClose: this.doClose }))
      );
    } // render

  }]);

  return ZoomLayer;
}(_reflux2.default.Component);

exports.default = ZoomLayer;


ZoomLayer.propTypes = {};
ZoomLayer.defaultProps = {};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _helpers = __webpack_require__(30);

var _helpers2 = _interopRequireDefault(_helpers);

var _Close = __webpack_require__(120);

var _Close2 = _interopRequireDefault(_Close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var img = document.createElement('img');
var hasObjectFit = img.style.hasOwnProperty('objectFit');

var CloseButton = function (_React$Component) {
  _inherits(CloseButton, _React$Component);

  function CloseButton(props) {
    _classCallCheck(this, CloseButton);

    var _this = _possibleConstructorReturn(this, (CloseButton.__proto__ || Object.getPrototypeOf(CloseButton)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(CloseButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      //let $this = $(ReactDOM.findDOMNode(this));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {}
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'button',
        { className: 'close-button', onClick: this.props.onClick },
        _react2.default.createElement(_Close2.default, null)
      );
    } // render

  }]);

  return CloseButton;
}(_react2.default.Component);

exports.default = CloseButton;


CloseButton.propTypes = {
  "onClick": _react2.default.PropTypes.func.isRequired
};

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _helpers = __webpack_require__(30);

var _helpers2 = _interopRequireDefault(_helpers);

var _classnames = __webpack_require__(6);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var img = document.createElement('img');
var hasObjectFit = img.style.hasOwnProperty('objectFit');

var Image = function (_React$Component) {
  _inherits(Image, _React$Component);

  function Image(props) {
    _classCallCheck(this, Image);

    var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));

    _this.state = {};
    props.image.src = _utils2.default.getCompiledHtml(props.image.src);

    return _this;
  }

  _createClass(Image, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      //let $this = $(ReactDOM.findDOMNode(this));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      nextProps.image.src = _utils2.default.getCompiledHtml(nextProps.image.src);
    }
  }, {
    key: 'render',
    value: function render() {
      if (hasObjectFit) {
        return _react2.default.createElement('img', _extends({}, this.props.image, { className: 'image-container' }));
      } else {
        var imageStyle = {
          'backgroundImage': 'url(' + this.props.image.src + ')'
        };
        return _react2.default.createElement(
          'div',
          { className: 'image-container' },
          _react2.default.createElement('div', { className: 'object-fit image', style: imageStyle })
        );
      }
    } // render

  }]);

  return Image;
}(_react2.default.Component);

exports.default = Image;


Image.propTypes = {
  "image": _react2.default.PropTypes.object.isRequired
};

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(3);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reflux = __webpack_require__(4);

var _reflux2 = _interopRequireDefault(_reflux);

var _reactModal = __webpack_require__(190);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _utils = __webpack_require__(5);

var _utils2 = _interopRequireDefault(_utils);

var _helpers = __webpack_require__(30);

var _helpers2 = _interopRequireDefault(_helpers);

var _image = __webpack_require__(423);

var _image2 = _interopRequireDefault(_image);

var _closeButton = __webpack_require__(422);

var _closeButton2 = _interopRequireDefault(_closeButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ZoomContent = function (_React$Component) {
  _inherits(ZoomContent, _React$Component);

  function ZoomContent(props) {
    _classCallCheck(this, ZoomContent);

    var _this = _possibleConstructorReturn(this, (ZoomContent.__proto__ || Object.getPrototypeOf(ZoomContent)).call(this, props));

    _this.state = {};
    //props.image.src = Utils.getCompiledHtml(props.image.src)
    //console.log("ZoomContent Constructed",props);
    return _this;
  }

  _createClass(ZoomContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      //let $this = $(ReactDOM.findDOMNode(this));
      //console.log("Zoom Layer Mounted!",$this[0]);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      //nextProps.image.src = Utils.getCompiledHtml(nextProps.image.src)
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.label.length == 0 && this.props.caption.length == 0) {
        return _react2.default.createElement(
          'div',
          { className: 'zoom-content-container' },
          _react2.default.createElement(
            'div',
            { className: 'close-button-container' },
            _react2.default.createElement(_closeButton2.default, { onClick: this.props.onClose })
          ),
          _react2.default.createElement(_image2.default, { image: this.props.image })
        );
      } else {
        var label = _utils2.default.getDangerousHtml(this.props.label);
        var caption = _utils2.default.getDangerousHtml(this.props.caption);
        return _react2.default.createElement(
          'div',
          { className: 'zoom-content-container label-caption' },
          _react2.default.createElement(
            'div',
            { className: 'close-button-container' },
            _react2.default.createElement(_closeButton2.default, { onClick: this.props.onClose })
          ),
          _react2.default.createElement(_image2.default, { image: this.props.image }),
          _react2.default.createElement(
            'div',
            { className: 'label-caption-container' },
            _react2.default.createElement('div', { className: 'zoom-label', dangerouslySetInnerHTML: label }),
            _react2.default.createElement('div', { className: 'zoom-caption', dangerouslySetInnerHTML: caption })
          )
        );
      }
    } // render

  }]);

  return ZoomContent;
}(_react2.default.Component);

exports.default = ZoomContent;


ZoomContent.propTypes = {
  "image": _react2.default.PropTypes.object.isRequired,
  "label": _react2.default.PropTypes.string,
  "caption": _react2.default.PropTypes.string,
  "onClose": _react2.default.PropTypes.func

};
ZoomContent.defaultProps = {
  "label": "",
  "caption": "",
  "onClose": function onClose() {}
};

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(625);

__webpack_require__(626);

__webpack_require__(426);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(433);
module.exports = __webpack_require__(39).RegExp.escape;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(12);
var isArray = __webpack_require__(108);
var SPECIES = __webpack_require__(17)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(11);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(8);
var toPrimitive = __webpack_require__(48);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(70);
var gOPS = __webpack_require__(112);
var pIE = __webpack_require__(94);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 432 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(1);
var $re = __webpack_require__(431)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { copyWithin: __webpack_require__(212) });

__webpack_require__(58)('copyWithin');


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $every = __webpack_require__(44)(4);

$export($export.P + $export.F * !__webpack_require__(41)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { fill: __webpack_require__(138) });

__webpack_require__(58)('fill');


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $filter = __webpack_require__(44)(2);

$export($export.P + $export.F * !__webpack_require__(41)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(44)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(58)(KEY);


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(1);
var $find = __webpack_require__(44)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(58)(KEY);


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $forEach = __webpack_require__(44)(0);
var STRICT = __webpack_require__(41)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(40);
var $export = __webpack_require__(1);
var toObject = __webpack_require__(24);
var call = __webpack_require__(223);
var isArrayIter = __webpack_require__(146);
var toLength = __webpack_require__(22);
var createProperty = __webpack_require__(140);
var getIterFn = __webpack_require__(162);

$export($export.S + $export.F * !__webpack_require__(110)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $indexOf = __webpack_require__(104)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(41)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(1);

$export($export.S, 'Array', { isArray: __webpack_require__(108) });


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(1);
var toIObject = __webpack_require__(37);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(93) != Object || !__webpack_require__(41)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(37);
var toInteger = __webpack_require__(47);
var toLength = __webpack_require__(22);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(41)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $map = __webpack_require__(44)(1);

$export($export.P + $export.F * !__webpack_require__(41)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var createProperty = __webpack_require__(140);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(11)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(214);

$export($export.P + $export.F * !__webpack_require__(41)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $reduce = __webpack_require__(214);

$export($export.P + $export.F * !__webpack_require__(41)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var html = __webpack_require__(144);
var cof = __webpack_require__(38);
var toAbsoluteIndex = __webpack_require__(74);
var toLength = __webpack_require__(22);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(11)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $some = __webpack_require__(44)(3);

$export($export.P + $export.F * !__webpack_require__(41)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var aFunction = __webpack_require__(27);
var toObject = __webpack_require__(24);
var fails = __webpack_require__(11);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(41)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(73)('Array');


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(1);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(1);
var toISOString = __webpack_require__(428);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(24);
var toPrimitive = __webpack_require__(48);

$export($export.P + $export.F * __webpack_require__(11)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(17)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(31)(proto, TO_PRIMITIVE, __webpack_require__(429));


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(32)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(1);

$export($export.P, 'Function', { bind: __webpack_require__(215) });


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(12);
var getPrototypeOf = __webpack_require__(36);
var HAS_INSTANCE = __webpack_require__(17)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(21).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(21).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(20) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(1);
var log1p = __webpack_require__(226);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(1);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(1);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(1);
var sign = __webpack_require__(150);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(1);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(1);
var $expm1 = __webpack_require__(149);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { fround: __webpack_require__(225) });


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(1);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(1);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(11)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { log1p: __webpack_require__(226) });


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { sign: __webpack_require__(150) });


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(149);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(11)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(149);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var has = __webpack_require__(34);
var cof = __webpack_require__(38);
var inheritIfRequired = __webpack_require__(145);
var toPrimitive = __webpack_require__(48);
var fails = __webpack_require__(11);
var gOPN = __webpack_require__(69).f;
var gOPD = __webpack_require__(35).f;
var dP = __webpack_require__(21).f;
var $trim = __webpack_require__(81).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(68)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(20) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(32)(global, NUMBER, $Number);
}


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(1);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(1);
var _isFinite = __webpack_require__(9).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', { isInteger: __webpack_require__(222) });


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(1);
var isInteger = __webpack_require__(222);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(234);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(235);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toInteger = __webpack_require__(47);
var aNumberValue = __webpack_require__(211);
var repeat = __webpack_require__(157);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(11)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $fails = __webpack_require__(11);
var aNumberValue = __webpack_require__(211);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(1);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(228) });


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(68) });


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(20), 'Object', { defineProperties: __webpack_require__(229) });


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(20), 'Object', { defineProperty: __webpack_require__(21).f });


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(12);
var meta = __webpack_require__(60).onFreeze;

__webpack_require__(46)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(37);
var $getOwnPropertyDescriptor = __webpack_require__(35).f;

__webpack_require__(46)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(46)('getOwnPropertyNames', function () {
  return __webpack_require__(230).f;
});


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(24);
var $getPrototypeOf = __webpack_require__(36);

__webpack_require__(46)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(12);

__webpack_require__(46)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(12);

__webpack_require__(46)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(12);

__webpack_require__(46)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { is: __webpack_require__(432) });


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(24);
var $keys = __webpack_require__(70);

__webpack_require__(46)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(12);
var meta = __webpack_require__(60).onFreeze;

__webpack_require__(46)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(12);
var meta = __webpack_require__(60).onFreeze;

__webpack_require__(46)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(153).set });


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(92);
var test = {};
test[__webpack_require__(17)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(32)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(234);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(235);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(59);
var global = __webpack_require__(9);
var ctx = __webpack_require__(40);
var classof = __webpack_require__(92);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(12);
var aFunction = __webpack_require__(27);
var anInstance = __webpack_require__(66);
var forOf = __webpack_require__(67);
var speciesConstructor = __webpack_require__(116);
var task = __webpack_require__(159).set;
var microtask = __webpack_require__(151)();
var newPromiseCapabilityModule = __webpack_require__(152);
var perform = __webpack_require__(236);
var userAgent = __webpack_require__(118);
var promiseResolve = __webpack_require__(237);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(17)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(72)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(80)($Promise, PROMISE);
__webpack_require__(73)(PROMISE);
Wrapper = __webpack_require__(39)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(110)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(27);
var anObject = __webpack_require__(8);
var rApply = (__webpack_require__(9).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(11)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(1);
var create = __webpack_require__(68);
var aFunction = __webpack_require__(27);
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(12);
var fails = __webpack_require__(11);
var bind = __webpack_require__(215);
var rConstruct = (__webpack_require__(9).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(21);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(8);
var toPrimitive = __webpack_require__(48);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(11)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(1);
var gOPD = __webpack_require__(35).f;
var anObject = __webpack_require__(8);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(8);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(147)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(35);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(8);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(1);
var getProto = __webpack_require__(36);
var anObject = __webpack_require__(8);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(35);
var getPrototypeOf = __webpack_require__(36);
var has = __webpack_require__(34);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(12);
var anObject = __webpack_require__(8);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(8);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(233) });


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(8);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(1);
var setProto = __webpack_require__(153);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(21);
var gOPD = __webpack_require__(35);
var getPrototypeOf = __webpack_require__(36);
var has = __webpack_require__(34);
var $export = __webpack_require__(1);
var createDesc = __webpack_require__(71);
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(12);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var inheritIfRequired = __webpack_require__(145);
var dP = __webpack_require__(21).f;
var gOPN = __webpack_require__(69).f;
var isRegExp = __webpack_require__(109);
var $flags = __webpack_require__(107);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(20) && (!CORRECT_NEW || __webpack_require__(11)(function () {
  re2[__webpack_require__(17)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(32)(global, 'RegExp', $RegExp);
}

__webpack_require__(73)('RegExp');


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(106)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(106)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(106)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(106)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(109);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(242);
var anObject = __webpack_require__(8);
var $flags = __webpack_require__(107);
var DESCRIPTORS = __webpack_require__(20);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(32)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(11)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(33)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(33)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(33)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(33)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $at = __webpack_require__(155)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(22);
var context = __webpack_require__(156);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(143)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(33)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(33)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(33)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(74);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(1);
var context = __webpack_require__(156);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(143)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(33)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(155)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(148)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(33)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(37);
var toLength = __webpack_require__(22);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(157)
});


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(33)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(1);
var toLength = __webpack_require__(22);
var context = __webpack_require__(156);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(143)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(33)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(33)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(33)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(81)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(9);
var has = __webpack_require__(34);
var DESCRIPTORS = __webpack_require__(20);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(32);
var META = __webpack_require__(60).KEY;
var $fails = __webpack_require__(11);
var shared = __webpack_require__(115);
var setToStringTag = __webpack_require__(80);
var uid = __webpack_require__(75);
var wks = __webpack_require__(17);
var wksExt = __webpack_require__(240);
var wksDefine = __webpack_require__(161);
var enumKeys = __webpack_require__(430);
var isArray = __webpack_require__(108);
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(12);
var toIObject = __webpack_require__(37);
var toPrimitive = __webpack_require__(48);
var createDesc = __webpack_require__(71);
var _create = __webpack_require__(68);
var gOPNExt = __webpack_require__(230);
var $GOPD = __webpack_require__(35);
var $DP = __webpack_require__(21);
var $keys = __webpack_require__(70);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(69).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(94).f = $propertyIsEnumerable;
  __webpack_require__(112).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(59)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(31)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var $typed = __webpack_require__(117);
var buffer = __webpack_require__(160);
var anObject = __webpack_require__(8);
var toAbsoluteIndex = __webpack_require__(74);
var toLength = __webpack_require__(22);
var isObject = __webpack_require__(12);
var ArrayBuffer = __webpack_require__(9).ArrayBuffer;
var speciesConstructor = __webpack_require__(116);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(11)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(73)(ARRAY_BUFFER);


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
$export($export.G + $export.W + $export.F * !__webpack_require__(117).ABV, {
  DataView: __webpack_require__(160).DataView
});


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(53)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(53)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(53)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(53)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(53)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(53)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(53)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(53)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(53)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(218);
var validate = __webpack_require__(82);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(105)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(219);
var toObject = __webpack_require__(24);
var toLength = __webpack_require__(22);
var aFunction = __webpack_require__(27);
var arraySpeciesCreate = __webpack_require__(139);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(58)('flatMap');


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(219);
var toObject = __webpack_require__(24);
var toLength = __webpack_require__(22);
var toInteger = __webpack_require__(47);
var arraySpeciesCreate = __webpack_require__(139);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(58)('flatten');


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(1);
var $includes = __webpack_require__(104)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(58)('includes');


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(1);
var microtask = __webpack_require__(151)();
var process = __webpack_require__(9).process;
var isNode = __webpack_require__(38)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(1);
var cof = __webpack_require__(38);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.G, { global: __webpack_require__(9) });


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(113)('Map');


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(114)('Map');


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(217)('Map') });


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var scale = __webpack_require__(227);
var fround = __webpack_require__(225);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { scale: __webpack_require__(227) });


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(1);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(24);
var aFunction = __webpack_require__(27);
var $defineProperty = __webpack_require__(21);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(20) && $export($export.P + __webpack_require__(111), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(24);
var aFunction = __webpack_require__(27);
var $defineProperty = __webpack_require__(21);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(20) && $export($export.P + __webpack_require__(111), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $entries = __webpack_require__(232)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(1);
var ownKeys = __webpack_require__(233);
var toIObject = __webpack_require__(37);
var gOPD = __webpack_require__(35);
var createProperty = __webpack_require__(140);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(24);
var toPrimitive = __webpack_require__(48);
var getPrototypeOf = __webpack_require__(36);
var getOwnPropertyDescriptor = __webpack_require__(35).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(20) && $export($export.P + __webpack_require__(111), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(1);
var toObject = __webpack_require__(24);
var toPrimitive = __webpack_require__(48);
var getPrototypeOf = __webpack_require__(36);
var getOwnPropertyDescriptor = __webpack_require__(35).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(20) && $export($export.P + __webpack_require__(111), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $values = __webpack_require__(232)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(1);
var global = __webpack_require__(9);
var core = __webpack_require__(39);
var microtask = __webpack_require__(151)();
var OBSERVABLE = __webpack_require__(17)('observable');
var aFunction = __webpack_require__(27);
var anObject = __webpack_require__(8);
var anInstance = __webpack_require__(66);
var redefineAll = __webpack_require__(72);
var hide = __webpack_require__(31);
var forOf = __webpack_require__(67);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(73)('Observable');


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(1);
var core = __webpack_require__(39);
var global = __webpack_require__(9);
var speciesConstructor = __webpack_require__(116);
var promiseResolve = __webpack_require__(237);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(1);
var newPromiseCapability = __webpack_require__(152);
var perform = __webpack_require__(236);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(52);
var anObject = __webpack_require__(8);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(52);
var anObject = __webpack_require__(8);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(243);
var from = __webpack_require__(213);
var metadata = __webpack_require__(52);
var anObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(36);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(52);
var anObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(36);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(52);
var anObject = __webpack_require__(8);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(52);
var anObject = __webpack_require__(8);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(52);
var anObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(36);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(52);
var anObject = __webpack_require__(8);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(52);
var anObject = __webpack_require__(8);
var aFunction = __webpack_require__(27);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(113)('Set');


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(114)('Set');


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(217)('Set') });


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(1);
var $at = __webpack_require__(155)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(1);
var defined = __webpack_require__(45);
var toLength = __webpack_require__(22);
var isRegExp = __webpack_require__(109);
var getFlags = __webpack_require__(107);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(147)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(238);
var userAgent = __webpack_require__(118);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(1);
var $pad = __webpack_require__(238);
var userAgent = __webpack_require__(118);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(81)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(81)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(161)('asyncIterator');


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(161)('observable');


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.S, 'System', { global: __webpack_require__(9) });


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(113)('WeakMap');


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(114)('WeakMap');


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(113)('WeakSet');


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(114)('WeakSet');


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(163);
var getKeys = __webpack_require__(70);
var redefine = __webpack_require__(32);
var global = __webpack_require__(9);
var hide = __webpack_require__(31);
var Iterators = __webpack_require__(79);
var wks = __webpack_require__(17);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $task = __webpack_require__(159);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(9);
var $export = __webpack_require__(1);
var userAgent = __webpack_require__(118);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(553);
__webpack_require__(492);
__webpack_require__(494);
__webpack_require__(493);
__webpack_require__(496);
__webpack_require__(498);
__webpack_require__(503);
__webpack_require__(497);
__webpack_require__(495);
__webpack_require__(505);
__webpack_require__(504);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(499);
__webpack_require__(491);
__webpack_require__(502);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(459);
__webpack_require__(461);
__webpack_require__(460);
__webpack_require__(509);
__webpack_require__(508);
__webpack_require__(479);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(540);
__webpack_require__(545);
__webpack_require__(552);
__webpack_require__(543);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(541);
__webpack_require__(546);
__webpack_require__(548);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(534);
__webpack_require__(537);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(542);
__webpack_require__(544);
__webpack_require__(547);
__webpack_require__(549);
__webpack_require__(550);
__webpack_require__(551);
__webpack_require__(454);
__webpack_require__(456);
__webpack_require__(455);
__webpack_require__(458);
__webpack_require__(457);
__webpack_require__(443);
__webpack_require__(441);
__webpack_require__(447);
__webpack_require__(444);
__webpack_require__(450);
__webpack_require__(452);
__webpack_require__(440);
__webpack_require__(446);
__webpack_require__(437);
__webpack_require__(451);
__webpack_require__(435);
__webpack_require__(449);
__webpack_require__(448);
__webpack_require__(442);
__webpack_require__(445);
__webpack_require__(434);
__webpack_require__(436);
__webpack_require__(439);
__webpack_require__(438);
__webpack_require__(453);
__webpack_require__(163);
__webpack_require__(525);
__webpack_require__(530);
__webpack_require__(242);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(510);
__webpack_require__(241);
__webpack_require__(243);
__webpack_require__(244);
__webpack_require__(565);
__webpack_require__(554);
__webpack_require__(555);
__webpack_require__(560);
__webpack_require__(563);
__webpack_require__(564);
__webpack_require__(558);
__webpack_require__(561);
__webpack_require__(559);
__webpack_require__(562);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(518);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(524);
__webpack_require__(523);
__webpack_require__(568);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(609);
__webpack_require__(612);
__webpack_require__(611);
__webpack_require__(613);
__webpack_require__(614);
__webpack_require__(610);
__webpack_require__(615);
__webpack_require__(616);
__webpack_require__(590);
__webpack_require__(593);
__webpack_require__(589);
__webpack_require__(587);
__webpack_require__(588);
__webpack_require__(591);
__webpack_require__(592);
__webpack_require__(574);
__webpack_require__(608);
__webpack_require__(573);
__webpack_require__(607);
__webpack_require__(619);
__webpack_require__(621);
__webpack_require__(572);
__webpack_require__(606);
__webpack_require__(618);
__webpack_require__(620);
__webpack_require__(571);
__webpack_require__(617);
__webpack_require__(570);
__webpack_require__(575);
__webpack_require__(576);
__webpack_require__(577);
__webpack_require__(578);
__webpack_require__(579);
__webpack_require__(581);
__webpack_require__(580);
__webpack_require__(582);
__webpack_require__(583);
__webpack_require__(584);
__webpack_require__(586);
__webpack_require__(585);
__webpack_require__(595);
__webpack_require__(596);
__webpack_require__(597);
__webpack_require__(598);
__webpack_require__(600);
__webpack_require__(599);
__webpack_require__(602);
__webpack_require__(601);
__webpack_require__(603);
__webpack_require__(604);
__webpack_require__(605);
__webpack_require__(569);
__webpack_require__(594);
__webpack_require__(624);
__webpack_require__(623);
__webpack_require__(622);
module.exports = __webpack_require__(39);


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) __webpack_require__(910)(name, definition)
  else root[name] = definition()
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)(o|0)s/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/Whale/i.test(ua)) {
      result = {
        name: 'NAVER Whale browser'
        , whale: t
        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/MZBrowser/i.test(ua)) {
      result = {
        name: 'MZ Browser'
        , mzbrowser: t
        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/focus/i.test(ua)) {
      result = {
        name: 'Focus'
        , focus: t
        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , osname: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , osname: 'Chrome OS'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/edg([ea]|ios)/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , osname: 'Sailfish OS'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
        result.osname = 'Firefox OS'
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , osname: 'BlackBerry OS'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , osname: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , osname: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , osname: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && (android || result.silk)) {
      result.android = t
      result.osname = 'Android'
    } else if (!result.windowsphone && iosdevice) {
      result[iosdevice] = t
      result.ios = t
      result.osname = 'iOS'
    } else if (mac) {
      result.mac = t
      result.osname = 'macOS'
    } else if (xbox) {
      result.xbox = t
      result.osname = 'Xbox'
    } else if (windows) {
      result.windows = t
      result.osname = 'Windows'
    } else if (linux) {
      result.linux = t
      result.osname = 'Linux'
    }

    function getWindowsVersion (s) {
      switch (s) {
        case 'NT': return 'NT'
        case 'XP': return 'XP'
        case 'NT 5.0': return '2000'
        case 'NT 5.1': return 'XP'
        case 'NT 5.2': return '2003'
        case 'NT 6.0': return 'Vista'
        case 'NT 6.1': return '7'
        case 'NT 6.2': return '8'
        case 'NT 6.3': return '8.1'
        case 'NT 10.0': return '10'
        default: return undefined
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  /*
   * Set our detect public method to the main bowser object
   * This is needed to implement bowser in server side
   */
  bowser.detect = detect;
  return bowser
});


/***/ }),
/* 629 */
/***/ (function(module, exports) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, "[data-module=ConsultWidget] .consult-bucket{margin-top:0}", ""]);

// exports


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, "ul.error-messages li{color:#c00}", ""]);

// exports


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, "form#email-form{display:flex;flex-direction:column}form#email-form fieldset{border:none;padding:.5rem 0}form#email-form fieldset>div{display:flex;flex-direction:column}form#email-form fieldset>div label{font-size:18px;font-weight:700;color:#4a4a4a}form#email-form fieldset>div input[type=email],form#email-form fieldset>div textarea{padding:.25em;border:1px solid #000;width:50%}form#email-form fieldset>div input[type=email].error,form#email-form fieldset>div textarea.error{border-color:#c00}@media (max-width:400px){form#email-form fieldset>div input[type=email],form#email-form fieldset>div textarea{width:100%}}form#email-form fieldset>div.recipients-container{display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:flex-end}form#email-form fieldset>div.recipients-container .recipient-container{display:flex;flex:1;flex-direction:column;width:50%}form#email-form fieldset>div.recipients-container .recipient-container input[type=email]{width:100%}form#email-form fieldset>div.recipients-container .copy-me-container{display:flex;width:50%;flex:1;flex-direction:row;align-items:center;justify-content:center}form#email-form fieldset>div.recipients-container .copy-me-container label{margin-top:0;margin-left:.25rem}@media (max-width:400px){form#email-form fieldset>div.recipients-container{flex-flow:column;align-items:flex-start}form#email-form fieldset>div.recipients-container .recipient-container{width:100%}form#email-form fieldset>div.recipients-container .copy-me-container{padding:.5rem 0}}form#email-form fieldset>div.message-container textarea{height:3.4rem;width:100%;transition:height .3s ease-in-out}form#email-form fieldset>div.message-container textarea:focus{height:6.8rem}form#email-form fieldset>div.cta-button-container{display:inline-block;text-align:center;width:100%}form#email-form fieldset>div.cta-button-container .button{padding-left:25px;padding-right:25px}", ""]);

// exports


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".ReactModal__Overlay{z-index:1200;overflow-y:scroll}.email-modal{position:relative;top:0;margin:10px auto;z-index:1300;border:none;width:90%;max-width:750px}.email-modal .modal-content-container{background-color:#fff;border:1px solid #000;border-radius:5px;width:100%;display:flex;flex-direction:column}.email-modal .modal-content-container .header-container{display:flex;flex-direction:row;background-color:#2f2148;padding:1rem 1.5625rem}.email-modal .modal-content-container .header-container h4.modal-title{font-size:1.375rem;color:#fff;display:flex;flex:1;padding:0;margin:0}.email-modal .modal-content-container .header-container .close-button-container{display:flex;flex:1;justify-content:flex-end}.email-modal .modal-content-container .header-container .close-button-container a:hover{cursor:pointer}.email-modal .modal-content-container .header-container .close-button-container svg{width:24px;height:24px}.email-modal .modal-content-container .header-container .close-button-container svg .icon-symbol{fill:#fff}.email-modal .modal-content-container .email-form-container{padding:.5rem 1.5625rem}", ""]);

// exports


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, "[data-module=Formulary] .formulary-content{width:100%}[data-module=Formulary] .formulary-content table{width:100%;border:none;padding:0;margin:0}[data-module=Formulary] .formulary-content table thead tr{background-color:#17a8ff}[data-module=Formulary] .formulary-content table thead th{color:#fff;text-align:center;font-size:18px;font-weight:600;padding:5px}[data-module=Formulary] .formulary-content table thead th:first-child{width:75%}[data-module=Formulary] .formulary-content table thead th:nth-child(n+1){border-left:1px solid #fff}[data-module=Formulary] .formulary-content table tbody td{color:#000;font-size:14px;text-align:center;padding:5px}[data-module=Formulary] .formulary-content table tbody td:first-child{width:75%;text-align:left}[data-module=Formulary] .formulary-content table tbody td:nth-child(n+1){border-left:1px solid #fff}[data-module=Formulary] .formulary-content table tbody tr:nth-child(2n){background-color:#ccc}[data-module=Formulary] .formulary-content table tbody tr:nth-child(odd){background-color:#fff}", ""]);

// exports


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, "[data-module=GiftManager]{display:block;min-height:650px}.gift-manager-wrapping{width:100%}.gift-manager-container{border-radius:8px;border:1px solid #ddd;box-shadow:0 3px 1px #ccc;overflow:hidden;background:#fff}.gift-manager-container input,.gift-manager-container label{display:block}.gift-manager-container input[type=checkbox]{display:inline-block}.gift-manager-container .input-group{margin-bottom:20px}.gift-manager-container input[type=text]{background:#efeeee;font-size:20px}.gift-manager-container input[type=text],.gift-manager-container select{display:block;border:1px solid #ccc;padding:6px;color:#999;font-weight:300;width:100%}.gift-manager-container select{font-size:18px;background-image:linear-gradient(#fff,#ddd)}.gift-manager-container label{color:#666}.gift-manager-container .error input,.gift-manager-container .error select{border-color:red}.gift-manager-container .error label{color:red}.gift-manager-header{color:#fff;background:#4d4184}.gift-manager-body,.gift-manager-header{width:100%;padding:15px 35px}.input-group.checkbox_field_1 label{display:inline-block;margin-left:5px}input[type=button],input[type=submit]{-webkit-appearance:none;box-sizing:border-box;border-radius:4px;-webkit-border-radius:4px;background-image:none;display:inline-block;width:100px;text-align:center;line-height:24px;font-size:16px;border:none;margin-right:6px}input[type=submit]{background:#36cb79;color:#fff;transition:all .2s}input[type=submit]:hover{background:#2aa461}input[type=button]{background:#fff;box-shadow:inset 0 0 0 1px #000;color:#000;transition:all .1s}input[type=button]:hover{background:#2aa461;color:#fff;box-shadow:inset 0 0 0 1px #2aa461}.gmHide{height:0;width:0;visibility:hidden;display:none}", ""]);

// exports


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, "ul.error-messages li{color:#c00}", ""]);

// exports


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, "[data-module=Questionnaire] .questionnaire-component{display:flex;flex-flow:column;text-align:left}[data-module=Questionnaire] .questionnaire-component h4{font-size:24px;margin:0;padding:0}[data-module=Questionnaire] .questionnaire-component h5.question-number{font-size:24px;margin:20px 0 0;padding:0;color:#0897ad}[data-module=Questionnaire] .questionnaire-component .question-item .description{display:inline;width:100%;font-family:proxima_nova_ltsemibold,arial,sans-serif;font-size:20px;font-weight:600;line-height:1.3;letter-spacing:normal;color:#000;margin-top:15px;margin-bottom:15px}[data-module=Questionnaire] .questionnaire-component .question-item.required:not(.answered) .description .asterisk{color:#c00}[data-module=Questionnaire] .questionnaire-component form{display:inline-flex;flex-flow:column;width:100%}[data-module=Questionnaire] .questionnaire-component form fieldset{display:flex;flex-direction:column;border:none;padding:0;margin:0}[data-module=Questionnaire] .questionnaire-component form fieldset.button-container{display:inline-block}[data-module=Questionnaire] .questionnaire-component form fieldset textarea{width:100%;height:10em;padding:15px;background-color:#fff;box-shadow:0 1px 1px 0 rgba(0,0,0,.15);border:1px solid #edf0f5}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container{display:flex;flex-flow:column;width:100%}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item{position:relative}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item.input-field-choice label{align-items:center}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item.input-field-choice label .choice-text{margin-left:0;max-width:50%}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item.input-field-choice:hover label{background-color:#fff}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item.input-field-choice input[type=text]{margin-left:15px;width:80%;padding:2px 5px}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item label{display:flex;cursor:pointer;position:relative;width:100%;padding:15px;background-color:#fff;box-shadow:0 1px 1px 0 rgba(0,0,0,.15);border:1px solid #edf0f5;margin-bottom:15px;vertical-align:middle}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item label input[type=checkbox],[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item label input[type=radio]{display:none;background-color:#fff;vertical-align:middle}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item label .checkbox-button,[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item label .radio-button{border:1px solid rgba(0,0,0,.7);display:inline-flex;width:18px;height:18px;position:relative;padding:1px;background-color:#fff;transition:opacity .8s ease;margin-top:2px;justify-content:center;align-items:center}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item label .checkbox-button>span,[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item label .radio-button>span{width:6px;height:6px;opacity:0;transition:opacity .8s ease}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item label .radio-button{border-radius:50%}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item label .radio-button>span{border-radius:50%;background:#000}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item label .checkbox-button>span{position:relative}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item label .checkbox-button>span:before{position:absolute;top:-8px;left:-4px;color:#57973c;font-weight:700;content:\"\\2713   \"}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item label .choice-text{display:inline-flex;margin-left:15px;font-family:proxima_nova_ltlight,arial,sans-serif;font-size:20px;font-weight:300;color:#000;max-width:90%;vertical-align:top}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item.active label{border:1px solid #57973c}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item.active .choice-text{display:inline-flex;margin-left:15px;font-family:proxima_nova_ltsemibold,arial,sans-serif;font-size:20px;font-weight:300;color:#000;max-width:90%;vertical-align:top}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item.active .checkbox-button>span,[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item.active .radio-button>span{opacity:1}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container li.choice-item:hover label{background-color:#f2f9f7}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container.result-choices.qna-results li.choice-item.active .result-container{border:1px solid #f25568}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container.result-choices.qna-results li.choice-item.active.correct .result-container,[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container.result-choices.qna-results li.choice-item.correct .result-container,[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container.result-choices li.choice-item.active .result-container{border:1px solid #57973c}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container.result-choices li.choice-item .result-container{position:relative;top:0;bottom:0;left:0;width:100%;display:flex;flex-flow:row;padding:15px;background-color:#fff;border:1px solid #edf0f5;margin-bottom:15px;font-size:20px;font-weight:300;color:#000}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container.result-choices li.choice-item .result-container .choice-icon{display:flex;width:24px;height:24px;z-index:50;border-radius:50%;align-items:center;justify-content:center}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container.result-choices li.choice-item .result-container .choice-icon svg{width:65%;height:65%}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container.result-choices li.choice-item .result-container .choice-icon.correct-choice{border:1px solid #57973c}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container.result-choices li.choice-item .result-container .choice-icon.correct-choice svg polyline{stroke:#57973c}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container.result-choices li.choice-item .result-container .choice-icon.wrong-choice{border:1px solid #f25568}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container.result-choices li.choice-item .result-container .choice-icon.wrong-choice svg path{stroke:#f25568}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container.result-choices li.choice-item .result-container .choice-text{display:inline-flex;z-index:20;margin-left:15px;max-width:90%;align-item:center;justify-content:flex-start;flex:4;font-family:proxima_nova_ltlight,arial,sans-serif}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container.result-choices li.choice-item .result-container .percentage{display:inline-flex;z-index:20;flex:1;align-item:center;justify-content:flex-end;margin-right:15px}[data-module=Questionnaire] .questionnaire-component form fieldset ul.choices-container.result-choices li.choice-item .result-container .bar{position:absolute;display:block;top:0;bottom:0;left:0;width:0;transition:width 1s linear .5s;background-color:#f7f7f7;z-index:10}[data-module=Questionnaire] .questionnaire-component form .submit-button.disabled{background-color:rgba(0,0,0,.25);cursor:default}", ""]);

// exports


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".share-widget{display:flex;position:relative;flex-direction:column;max-width:83px;height:50px}.share-widget:first-child{width:auto;height:auto}.share-widget #widgetContainer{position:absolute;z-index:500;top:40px;right:-10%;-webkit-border-radius:7px;-moz-border-radius:7px;border-radius:7px;-webkit-box-shadow:0 1px 3px #666;-moz-box-shadow:0 1px 3px #666;box-shadow:0 1px 3px #666;color:#fff;padding:5px;background-color:#fff}.share-widget #widgetContainer>.triangle{right:12%}.share-widget .listContainer>.triangle,.share-widget .listContainer>.triangle:after{position:absolute;display:block;width:0;height:0;border-top-width:0;border:10px solid transparent}.share-widget .listContainer>.triangle{top:-10px;border-bottom-color:#dee2e8}.share-widget .listContainer>.triangle:after{top:11px;margin:-10px;content:\" \";border-bottom-color:#fff}.share-widget svg{transition:opacity .3s ease-in;display:inline-block;width:100%;height:100%}.share-widget svg .icon-background{width:30px;height:30px}.share-widget svg .icon-symbol{fill:#fff}.share-widget svg.facebook-icon .icon-background{fill:#3c5a99}.share-widget svg.google-icon .icon-background{fill:#cc4a41}.share-widget svg.google-icon .icon-symbol{width:100%;height:100%}.share-widget svg.twitter-icon .icon-background{fill:#78c2f5}.share-widget svg.email-icon .icon-background{fill:#transparent}.share-widget svg.email .icon-background{fill:#fff}.share-widget svg.email .icon-symbol{fill:#78c2f5}.share-widget svg.groupEmail,.share-widget svg.groupSharing{cursor:pointer;height:38px;max-width:41.5px}.share-widget svg:hover{-webkit-transform:scale(1.3);-ms-transform:scale(1.3);transform:scale(1.3)}@media (max-width:768px){.share-widget svg:hover{-webkit-transform:scale(1.1);-ms-transform:scale(1.1);transform:scale(1.1)}}.share-widget svg:hover.groupEmail,.share-widget svg:hover.groupSharing{-webkit-transform:scale(1.1);-ms-transform:scale(1.1);transform:scale(1.1)}.share-widget .groupIcon{padding:0;margin:0;display:flex;flex-flow:row;align-items:stretch;height:35px}.share-widget .groupEmail a img{cursor:pointer}.share-widget ul{padding:0;margin:0;display:flex;flex-flow:row;align-items:stretch;height:35px}.share-widget ul li{display:inline-flex;flex:1 1 100%;padding:0 8px;text-align:center;min-width:45px}.share-widget ul li>a{width:30px;height:30px;cursor:pointer;align-content:center;margin-left:auto;margin-right:auto;border-radius:5px}.share-widget ul li>a svg{margin:auto}.share-widget ul li.linkedin>a{color:#fff}", ""]);

// exports


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, "[data-module=Twitter] ul.twitter-container{margin-top:20px;display:flex;flex-direction:column;flex-wrap:wrap;justify-content:space-between}[data-module=Twitter] .twitter-header{padding-top:40px;border-top:3px solid #eceff1;display:flex}[data-module=Twitter] .twitter-header h4{display:inline-block;line-height:30px;vertical-align:middle;padding:0;margin:0}[data-module=Twitter] .twitter-header .mysvg{width:30px;height:30px;display:inline-block;margin-left:10px;vertical-align:middle}[data-module=Twitter] .twitter-header .mysvg svg{width:100%;height:100%}[data-module=Twitter] .twitter-header .mysvg svg .icon-background{width:30px;height:30px}[data-module=Twitter] .twitter-header .mysvg svg .icon-symbol{fill:#fff}[data-module=Twitter] .twitter-header .mysvg svg.twitter-icon .icon-background{fill:#78c2f5}", ""]);

// exports


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".uld-banner{position:fixed;top:0;left:0;z-index:10000;width:100%;font-family:Helvetica,Arial,sans-serif;font-size:16px;font-weight:400;color:#fff;line-height:1.43;background:#565656;padding-bottom:20px}.uld-banner .uld-container{display:flex;justify-content:space-around;flex-wrap:wrap;text-align:center}.uld-banner button{background:rgba(86,86,86,.95);margin:0 10px;border:3px solid #fff;padding:9px 12px;text-transform:uppercase}.medscape-mobile .uld-banner{font-size:12px;padding-bottom:10px}.medscape-mobile .uld-banner .content{padding:10px}.show-gdpr .isgdprct header{margin-top:0!important}", ""]);

// exports


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".playlist-component{width:100%;margin-top:20px;position:relative}.playlist-component .slick-slider{position:relative}.playlist-component .slick-slider button.carousel-arrow{display:inline-block;position:absolute;z-index:100;padding:5px;top:50%;margin-top:-25px;border-radius:50%;background-color:hsla(0,0%,88%,.5);width:auto;height:auto}.playlist-component .slick-slider button.carousel-arrow:before{display:none}.playlist-component .slick-slider button.carousel-arrow:hover{background-color:#e1e1e1}.playlist-component .slick-slider button.carousel-arrow.slick-disabled{display:none}.playlist-component .slick-slider button.carousel-arrow .icon-container{position:relative;display:inline-block}.playlist-component .slick-slider button.carousel-arrow .icon-container svg{width:24px;height:24px}.playlist-component .slick-slider button.carousel-arrow.next-button,.playlist-component .slick-slider button.carousel-arrow.slick-next{right:0}.playlist-component .slick-slider button.carousel-arrow.previous-button,.playlist-component .slick-slider button.carousel-arrow.slick-prev{left:0}.playlist-component .slick-slider.slick-vertical{position:absolute;bottom:0;z-index:2}.playlist-component .slick-slider.slick-vertical .slick-list{margin-top:25px;margin-bottom:25px}.playlist-component .slick-slider.slick-vertical button.carousel-arrow{left:50%;top:auto;right:auto;margin:0 0 0 -25px}.playlist-component .slick-slider.slick-vertical button.carousel-arrow.slick-next{top:100%}.playlist-component .slick-slider.slick-vertical button.carousel-arrow.slick-prev{top:0}.playlist-component .slick-slider.slick-vertical .playlist-slider-item{min-height:190px}.playlist-component .slick-slider.slick-vertical .playlist-slider-item .video-item-container .poster-container{padding-bottom:50%}.playlist-component .playlist-slider-item{cursor:pointer}.playlist-component .playlist-slider-item .video-item-container{width:100%;padding:10px}.playlist-component .playlist-slider-item .video-item-container:hover .poster-container .play-icon{display:block}.playlist-component .playlist-slider-item .video-item-container .poster-container{width:100%;height:0;margin-bottom:10px;padding-bottom:60%;background-repeat:no-repeat;background-position:50%;background-size:cover;position:relative}.playlist-component .playlist-slider-item .video-item-container .poster-container .play-icon{position:absolute;top:50%;left:50%;display:none;width:50px;height:50px;margin:-25px 0 0 -25px}.playlist-component .playlist-slider-item .video-item-container .poster-container .play-icon svg{width:100%;height:100%}.playlist-component .playlist-slider-item .video-item-container .poster-container .play-icon svg path{stroke:rgba(0,0,0,.5);fill:hsla(0,0%,100%,.5)}.playlist-component .playlist-slider-item .video-item-container .poster-container .label{display:block;position:absolute;top:0;left:0;padding:5px;font-size:12px;font-weight:700;text-transform:uppercase;color:#fff}.playlist-component .playlist-slider-item .video-item-container .poster-container .label.playing{background-color:rgba(0,90,129,.8)}.playlist-component .playlist-slider-item .video-item-container .poster-container .label.watched{background-color:hsla(0,0%,67%,.8)}.playlist-component .playlist-slider-item .video-item-container .description{font-size:12px}.playlist-component .playlist-slider-item .video-item-container .title{font-weight:700;font-size:14px}", ""]);

// exports


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, "[data-module=VideoPlayer]{width:100%}@media only screen and (-webkit-min-device-pixel-ratio:1){[data-module=VideoPlayer] .akamai-play akamai-overlay{display:none}}[data-module=VideoPlayer] .video-player-module{display:flex;flex-direction:column}[data-module=VideoPlayer] .video-player-module.isMobile .akamai-controls-native .akamai-overlays.akamai-layer{display:none}[data-module=VideoPlayer] .player-container{width:100%;height:auto;position:relative}[data-module=VideoPlayer] .player-container .video-container{width:70%}[data-module=VideoPlayer] .player-container .chapters-container{width:30%}[data-module=VideoPlayer] .player-container video{width:100%!important;height:100%!important}[data-module=VideoPlayer] .player-container.akamai-full-screen{height:100%;padding:0;margin:0}[data-module=VideoPlayer] .player-container.akamai-full-screen .video-container{height:100%;padding-bottom:0}[data-module=VideoPlayer] .video-component{width:100%}[data-module=VideoPlayer] .video-component .video-container{position:relative;padding-bottom:56.25%;padding-top:0;height:0;width:100%;background-color:#000}[data-module=VideoPlayer] .video-component .video-container .tap-for-sound-layer{position:absolute;top:0;bottom:0;left:0;right:0;z-index:1000;background:none}[data-module=VideoPlayer] .video-component .video-container .tap-for-sound-button{box-sizing:border-box;position:absolute;cursor:pointer;top:30px;left:10px;z-Index:1010;padding:10px 20px;border-radius:40px;border-color:rgba(0,0,0,.8);background-color:rgba(0,0,0,.8);vertical-align:middle;display:inline-block;overflow:hidden}[data-module=VideoPlayer] .video-component .video-container .tap-for-sound-button .video-player-volume-muted-button{transition:all .5s;background-image:url(" + __webpack_require__(312) + ");background-repeat:no-repeat;background-position:50%}[data-module=VideoPlayer] .video-component .video-container .tap-for-sound-button .video-player-volume-muted-button:hover{background-image:url(" + __webpack_require__(311) + ")}[data-module=VideoPlayer] .video-component .video-container .tap-for-sound-button.is-hidden{display:none}[data-module=VideoPlayer] .video-component .video-container .tap-for-sound-button span.video-player-volume-muted-button{box-sizing:border-box;background-position:top;cursor:pointer;width:20px;height:16px;line-height:16px;vertical-align:middle;display:inline-block;padding:0;margin:0;overflow:hidden}[data-module=VideoPlayer] .video-component .video-container .tap-for-sound-button span.label{box-sizing:border-box;cursor:pointer;display:inline-block;margin:0 0 0 10px;padding:0;font-size:14px;line-height:16px;height:16px;vertical-align:middle;font-weight:600;text-align:left;color:#ccc;overflow:hidden}[data-module=VideoPlayer] .video-component .video-container.isMobile .akamai-overlays.akamai-layer{display:none}[data-module=VideoPlayer] .video-component .video-container video{position:absolute;top:0;left:0;width:100%;height:100%}[data-module=VideoPlayer] .video-scene{position:relative}[data-module=VideoPlayer] .video-scene:before{display:block;content:\"\";width:100%;padding-top:56.25%}[data-module=VideoPlayer] .video-scene>.video-container{position:absolute;top:0;left:0;right:0;bottom:0}[data-module=VideoPlayer] .akamai-branding,[data-module=VideoPlayer] .akamai-controls,[data-module=VideoPlayer] .akamai-replay{display:none!important}[data-module=VideoPlayer] .akamai-play{background:url(" + __webpack_require__(896) + ") 50% no-repeat!important;height:30%!important;margin-bottom:-10%!important;background-size:auto auto!important}[data-module=VideoPlayer] button:focus{outline:none}[data-module=VideoPlayer] .control-container{position:absolute;bottom:-10px;height:40px;width:100%}[data-module=VideoPlayer] .video-controls{background-color:rgba(0,0,0,.6);position:absolute;margin:auto;width:100%;height:40px;bottom:0;-webkit-transition:opacity .3s;-moz-transition:opacity .3s;-o-transition:opacity .3s;-ms-transition:opacity .3s;transition:opacity .3s;z-index:200}[data-module=VideoPlayer] .is-idle{height:10px!important}[data-module=VideoPlayer] .progress-drag,[data-module=VideoPlayer] .volume-drag{cursor:move;cursor:grab;cursor:-webkit-grab;position:absolute}[data-module=VideoPlayer] .video-progress{position:relative;bottom:14px;cursor:pointer}@-moz-document url-prefix(){[data-module=VideoPlayer] .video-progress{bottom:16px}}[data-module=VideoPlayer] .not-value,[data-module=VideoPlayer] .seekslider{height:4px;display:inline-block}[data-module=VideoPlayer] .seekslider{transition:width .2s;width:0;position:absolute;z-index:10;top:0;left:0}[data-module=VideoPlayer] .not-value{width:100%;position:relative;background-color:#fff}[data-module=VideoPlayer] .seekslider{background-color:#007cb0}[data-module=VideoPlayer] .progress-drag{width:10px;height:10px;border-radius:100%;top:-3px;display:inline-block;background-color:#007cb0;border:5px solid #007cb0}[data-module=VideoPlayer] .on-progress-drag{z-index:1}[data-module=VideoPlayer] .play-buttons-bar{position:absolute;height:30px;width:100%;bottom:15%;left:0;padding:0}[data-module=VideoPlayer] .play-buttons-bar:after{content:\"\";display:table;clear:both}[data-module=VideoPlayer] .duration,[data-module=VideoPlayer] .playpause{position:absolute;bottom:0}[data-module=VideoPlayer] .playpause{left:10px}[data-module=VideoPlayer] .duration{left:50px}[data-module=VideoPlayer] .fullscreen{position:absolute;right:10px;z-index:10;bottom:0}[data-module=VideoPlayer] .playpause{width:24px}[data-module=VideoPlayer] .volume-wrap{position:absolute;bottom:0;height:20px;width:35px;right:60px;overflow:hidden}[data-module=VideoPlayer] .volume-wrap:hover{opacity:1;overflow:visible;height:180px;background-color:rgba(0,0,0,.3)}[data-module=VideoPlayer] .volume-wrap:hover .volume-bar-wrap{opacity:1}[data-module=VideoPlayer] .volume-wrap .button-mute{position:absolute;bottom:0;z-index:200}[data-module=VideoPlayer] .volume-bar-wrap{height:170px;position:absolute;opacity:0;transition:opacity .3s;bottom:20px;width:100%;z-index:90}[data-module=VideoPlayer] .volume-bar{position:relative;width:4px;height:125px;margin:25px auto 0}[data-module=VideoPlayer] .volume-inner{width:4px;height:125px;cursor:pointer}[data-module=VideoPlayer] .volume{height:100%;width:50%}[data-module=VideoPlayer] .not-volume{height:0%;width:50%}[data-module=VideoPlayer] .volume-drag{width:11px;height:11px;border-radius:100%;background-color:#007cb0;left:-5px}[data-module=VideoPlayer] .volume{background-color:#c8c8c8}[data-module=VideoPlayer] .not-volume{background-color:#595959}[data-module=VideoPlayer] .curtimetext,[data-module=VideoPlayer] .durtimetext,[data-module=VideoPlayer] .separator{color:#9a9a9a;font-size:12px;display:inline-block;padding:2px}[data-module=VideoPlayer] .curtimetext{text-align:right}[data-module=VideoPlayer] .separator{margin:0 3px;text-align:center}[data-module=VideoPlayer] .durtimetext{text-align:left}[data-module=VideoPlayer] .fs,[data-module=VideoPlayer] .fs-exit,[data-module=VideoPlayer] .pause,[data-module=VideoPlayer] .play,[data-module=VideoPlayer] .unmute,[data-module=VideoPlayer] .volume-high,[data-module=VideoPlayer] .volume-low,[data-module=VideoPlayer] .volume-med{width:16px;height:16px;cursor:pointer;border:0;background-size:100% 100%!important}[data-module=VideoPlayer] .button-mute{padding-left:25%;position:relative}[data-module=VideoPlayer] .play{background:url(" + __webpack_require__(897) + ") 50% no-repeat}[data-module=VideoPlayer] .play:hover{background:url(" + __webpack_require__(895) + ") 50% no-repeat}[data-module=VideoPlayer] .pause{background:url(" + __webpack_require__(894) + ") 50% no-repeat}[data-module=VideoPlayer] .pause:hover{background:url(" + __webpack_require__(893) + ") 50% no-repeat}[data-module=VideoPlayer] .volume-high{background:url(" + __webpack_require__(899) + ") 50% no-repeat}[data-module=VideoPlayer] .volume-high:hover{background:url(" + __webpack_require__(898) + ") 50% no-repeat}[data-module=VideoPlayer] .volume-med{background:url(" + __webpack_require__(903) + ") 50% no-repeat}[data-module=VideoPlayer] .volume-med:hover{background:url(" + __webpack_require__(902) + ") 50% no-repeat}[data-module=VideoPlayer] .volume-low{background:url(" + __webpack_require__(901) + ") 50% no-repeat}[data-module=VideoPlayer] .volume-low:hover{background:url(" + __webpack_require__(900) + ") 50% no-repeat}[data-module=VideoPlayer] .unmute{background:url(" + __webpack_require__(312) + ") 50% no-repeat}[data-module=VideoPlayer] .unmute:hover{background:url(" + __webpack_require__(311) + ") 50% no-repeat}[data-module=VideoPlayer] .fs{background:url(" + __webpack_require__(890) + ") 50% no-repeat}[data-module=VideoPlayer] .fs:hover{background:url(" + __webpack_require__(889) + ") 50% no-repeat}[data-module=VideoPlayer] .fs-exit{background:url(" + __webpack_require__(892) + ") 50% no-repeat}[data-module=VideoPlayer] .fs-exit:hover{background:url(" + __webpack_require__(891) + ") 50% no-repeat}", ""]);

// exports


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".Select{position:relative}.Select input::-webkit-contacts-auto-fill-button,.Select input::-webkit-credentials-auto-fill-button{display:none!important}.Select input::-ms-clear,.Select input::-ms-reveal{display:none!important}.Select,.Select div,.Select input,.Select span{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.Select.is-disabled .Select-arrow-zone{cursor:default;pointer-events:none;opacity:.35}.Select.is-disabled>.Select-control{background-color:#f9f9f9}.Select.is-disabled>.Select-control:hover{box-shadow:none}.Select.is-open>.Select-control{border-bottom-right-radius:0;border-bottom-left-radius:0;background:#fff;border-color:#b3b3b3 #ccc #d9d9d9}.Select.is-open>.Select-control .Select-arrow{top:-2px;border-color:transparent transparent #999;border-width:0 5px 5px}.Select.is-searchable.is-focused:not(.is-open)>.Select-control,.Select.is-searchable.is-open>.Select-control{cursor:text}.Select.is-focused>.Select-control{background:#fff}.Select.is-focused:not(.is-open)>.Select-control{border-color:#007eff;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 0 3px rgba(0,126,255,.1);background:#fff}.Select.has-value.is-clearable.Select--single>.Select-control .Select-value{padding-right:42px}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value .Select-value-label,.Select.has-value.Select--single>.Select-control .Select-value .Select-value-label{color:#333}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label{cursor:pointer;text-decoration:none}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:hover,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:hover{color:#007eff;outline:none;text-decoration:underline}.Select.has-value.is-pseudo-focused.Select--single>.Select-control .Select-value a.Select-value-label:focus,.Select.has-value.Select--single>.Select-control .Select-value a.Select-value-label:focus{background:#fff}.Select.has-value.is-pseudo-focused .Select-input{opacity:0}.Select.is-open .Select-arrow,.Select .Select-arrow-zone:hover>.Select-arrow{border-top-color:#666}.Select.Select--rtl{direction:rtl;text-align:right}.Select-control{background-color:#fff;border-color:#d9d9d9 #ccc #b3b3b3;border-radius:4px;border:1px solid #ccc;color:#333;cursor:default;display:table;border-spacing:0;border-collapse:separate;height:36px;outline:none;overflow:hidden;position:relative;width:100%}.Select-control:hover{box-shadow:0 1px 0 rgba(0,0,0,.06)}.Select-control .Select-input:focus{outline:none;background:#fff}.Select--single>.Select-control .Select-value,.Select-placeholder{bottom:0;color:#aaa;left:0;line-height:34px;padding-left:10px;padding-right:10px;position:absolute;right:0;top:0;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.Select-input{height:34px;padding-left:10px;padding-right:10px;vertical-align:middle}.Select-input>input{width:100%;background:none transparent;border:0 none;box-shadow:none;cursor:default;display:inline-block;font-family:inherit;font-size:inherit;margin:0;outline:none;line-height:17px;padding:8px 0 12px;-webkit-appearance:none}.is-focused .Select-input>input{cursor:text}.has-value.is-pseudo-focused .Select-input{opacity:0}.Select-control:not(.is-searchable)>.Select-input{outline:none}.Select-loading-zone{cursor:pointer;display:table-cell;text-align:center}.Select-loading,.Select-loading-zone{position:relative;vertical-align:middle;width:16px}.Select-loading{-webkit-animation:Select-animation-spin .4s infinite linear;-o-animation:Select-animation-spin .4s infinite linear;animation:Select-animation-spin .4s infinite linear;height:16px;box-sizing:border-box;border-radius:50%;border:2px solid #ccc;border-right-color:#333;display:inline-block}.Select-clear-zone{-webkit-animation:Select-animation-fadeIn .2s;-o-animation:Select-animation-fadeIn .2s;animation:Select-animation-fadeIn .2s;color:#999;cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:17px}.Select-clear-zone:hover{color:#d0021b}.Select-clear{display:inline-block;font-size:18px;line-height:1}.Select--multi .Select-clear-zone{width:17px}.Select-arrow-zone{cursor:pointer;display:table-cell;position:relative;text-align:center;vertical-align:middle;width:25px;padding-right:5px}.Select--rtl .Select-arrow-zone{padding-right:0;padding-left:5px}.Select-arrow{border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 2.5px;display:inline-block;height:0;width:0;position:relative}.Select-control>:last-child{padding-right:5px}.Select--multi .Select-multi-value-wrapper{display:inline-block}.Select .Select-aria-only{position:absolute;display:inline-block;height:1px;width:1px;margin:-1px;clip:rect(0,0,0,0);overflow:hidden;float:left}@-webkit-keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}@keyframes Select-animation-fadeIn{0%{opacity:0}to{opacity:1}}.Select-menu-outer{border-bottom-right-radius:4px;border-bottom-left-radius:4px;background-color:#fff;border:1px solid #ccc;border-top-color:#e6e6e6;box-shadow:0 1px 0 rgba(0,0,0,.06);box-sizing:border-box;margin-top:-1px;max-height:200px;position:absolute;left:0;top:100%;width:100%;z-index:1;-webkit-overflow-scrolling:touch}.Select-menu{max-height:198px;overflow-y:auto}.Select-option{box-sizing:border-box;background-color:#fff;color:#666;cursor:pointer;display:block;padding:8px 10px}.Select-option:last-child{border-bottom-right-radius:4px;border-bottom-left-radius:4px}.Select-option.is-selected{background-color:#f5faff;background-color:rgba(0,126,255,.04);color:#333}.Select-option.is-focused{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);color:#333}.Select-option.is-disabled{color:#ccc;cursor:default}.Select-noresults{box-sizing:border-box;color:#999;cursor:default;display:block;padding:8px 10px}.Select--multi .Select-input{vertical-align:middle;margin-left:10px;padding:0}.Select--multi.Select--rtl .Select-input{margin-left:0;margin-right:10px}.Select--multi.has-value .Select-input{margin-left:5px}.Select--multi .Select-value{background-color:#ebf5ff;background-color:rgba(0,126,255,.08);border-radius:2px;border:1px solid #c2e0ff;border:1px solid rgba(0,126,255,.24);color:#007eff;display:inline-block;font-size:.9em;line-height:1.4;margin-left:5px;margin-top:5px;vertical-align:top}.Select--multi .Select-value-icon,.Select--multi .Select-value-label{display:inline-block;vertical-align:middle}.Select--multi .Select-value-label{border-bottom-right-radius:2px;border-top-right-radius:2px;cursor:default;padding:2px 5px}.Select--multi a.Select-value-label{color:#007eff;cursor:pointer;text-decoration:none}.Select--multi a.Select-value-label:hover{text-decoration:underline}.Select--multi .Select-value-icon{cursor:pointer;border-bottom-left-radius:2px;border-top-left-radius:2px;border-right:1px solid #c2e0ff;border-right:1px solid rgba(0,126,255,.24);padding:1px 5px 3px}.Select--multi .Select-value-icon:focus,.Select--multi .Select-value-icon:hover{background-color:#d8eafd;background-color:rgba(0,113,230,.08);color:#0071e6}.Select--multi .Select-value-icon:active{background-color:#c2e0ff;background-color:rgba(0,126,255,.24)}.Select--multi.Select--rtl .Select-value{margin-left:0;margin-right:5px}.Select--multi.Select--rtl .Select-value-icon{border-right:none;border-left:1px solid #c2e0ff;border-left:1px solid rgba(0,126,255,.24)}.Select--multi.is-disabled .Select-value{background-color:#fcfcfc;border:1px solid #e3e3e3;color:#333}.Select--multi.is-disabled .Select-value-icon{cursor:not-allowed;border-right:1px solid #e3e3e3}.Select--multi.is-disabled .Select-value-icon:active,.Select--multi.is-disabled .Select-value-icon:focus,.Select--multi.is-disabled .Select-value-icon:hover{background-color:#fcfcfc}@keyframes Select-animation-spin{to{transform:rotate(1turn)}}@-webkit-keyframes Select-animation-spin{to{-webkit-transform:rotate(1turn)}}", ""]);

// exports


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".slick-loading .slick-list{background:#fff url(" + __webpack_require__(904) + ") 50% no-repeat}@font-face{font-family:slick;src:url(" + __webpack_require__(313) + ");src:url(" + __webpack_require__(313) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(907) + ") format(\"woff\"),url(" + __webpack_require__(906) + ") format(\"truetype\"),url(" + __webpack_require__(905) + "#slick) format(\"svg\");font-weight:400;font-style:normal}.slick-next,.slick-prev{position:absolute;display:block;height:20px;width:20px;line-height:0;font-size:0;cursor:pointer;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);padding:0;border:none}.slick-next,.slick-next:focus,.slick-next:hover,.slick-prev,.slick-prev:focus,.slick-prev:hover{background:transparent;color:transparent;outline:none}.slick-next:focus:before,.slick-next:hover:before,.slick-prev:focus:before,.slick-prev:hover:before{opacity:1}.slick-next.slick-disabled:before,.slick-prev.slick-disabled:before{opacity:.25}.slick-next:before,.slick-prev:before{font-family:slick;font-size:20px;line-height:1;color:#fff;opacity:.75;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-prev{left:-25px}[dir=rtl] .slick-prev{left:auto;right:-25px}.slick-prev:before{content:\"\\2190\"}[dir=rtl] .slick-prev:before{content:\"\\2192\"}.slick-next{right:-25px}[dir=rtl] .slick-next{left:-25px;right:auto}.slick-next:before{content:\"\\2192\"}[dir=rtl] .slick-next:before{content:\"\\2190\"}.slick-dotted.slick-slider{margin-bottom:30px}.slick-dots{position:absolute;bottom:-25px;list-style:none;display:block;text-align:center;padding:0;margin:0;width:100%}.slick-dots li{position:relative;display:inline-block;margin:0 5px;padding:0}.slick-dots li,.slick-dots li button{height:20px;width:20px;cursor:pointer}.slick-dots li button{border:0;background:transparent;display:block;outline:none;line-height:0;font-size:0;color:transparent;padding:5px}.slick-dots li button:focus,.slick-dots li button:hover{outline:none}.slick-dots li button:focus:before,.slick-dots li button:hover:before{opacity:1}.slick-dots li button:before{position:absolute;top:0;left:0;content:\"\\2022\";width:20px;height:20px;font-family:slick;font-size:6px;line-height:20px;text-align:center;color:#000;opacity:.25;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-dots li.slick-active button:before{color:#000;opacity:.75}", ""]);

// exports


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".slick-slider{box-sizing:border-box;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-tap-highlight-color:transparent}.slick-list,.slick-slider{position:relative;display:block}.slick-list{overflow:hidden;margin:0;padding:0}.slick-list:focus{outline:none}.slick-list.dragging{cursor:pointer;cursor:hand}.slick-slider .slick-list,.slick-slider .slick-track{-webkit-transform:translateZ(0);-moz-transform:translateZ(0);-ms-transform:translateZ(0);-o-transform:translateZ(0);transform:translateZ(0)}.slick-track{position:relative;left:0;top:0;display:block;margin-left:auto;margin-right:auto}.slick-track:after,.slick-track:before{content:\"\";display:table}.slick-track:after{clear:both}.slick-loading .slick-track{visibility:hidden}.slick-slide{float:left;height:100%;min-height:1px;display:none}[dir=rtl] .slick-slide{float:right}.slick-slide img{display:block}.slick-slide.slick-loading img{display:none}.slick-slide.dragging img{pointer-events:none}.slick-initialized .slick-slide{display:block}.slick-loading .slick-slide{visibility:hidden}.slick-vertical .slick-slide{display:block;height:auto;border:1px solid transparent}.slick-arrow.slick-hidden{display:none}", ""]);

// exports


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, "[data-module=AdditionalResources] .description{margin-right:10px;font-size:20px;color:#000}[data-module=AdditionalResources] .icon{display:inline-block}[data-module=AdditionalResources] .icon img{display:inline-block;width:11px;height:12px}[data-module=AdditionalResources] .external-link{white-space:nowrap}[data-module=AdditionalResources] .external-link .title{font-family:proxima_nova_ltlight,arial,sans-serif;font-size:20px;font-weight:300;color:#007cb0}[data-module=AdditionalResources] .button:hover{text-decoration:none}[data-module=AdditionalResources] .button .title{font-size:16px;line-height:1.13;color:#fff;text-decoration:none}[data-module=AdditionalResources] ul.resources-container li.resource-item{margin-top:24px}", ""]);

// exports


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, "[data-module=Carousel]{position:relative;width:100%;background-color:#fff;box-shadow:0 1px 1px 0 rgba(0,0,0,.15);border:1px solid #edf0f5;padding:35px 0}[data-module=Carousel] .slick-slider{position:relative}[data-module=Carousel] .slide-total{display:block;text-align:center}[data-module=Carousel] .carousel-arrow,[data-module=Carousel] .slick-arrow{display:inline-block;position:absolute;z-index:100;padding:5px;top:50%;margin-top:-25px}[data-module=Carousel] .carousel-arrow:before,[data-module=Carousel] .slick-arrow:before{color:#000;font-size:50px}[data-module=Carousel] .carousel-arrow.next-button,[data-module=Carousel] .carousel-arrow.slick-next,[data-module=Carousel] .slick-arrow.next-button,[data-module=Carousel] .slick-arrow.slick-next{right:0}[data-module=Carousel] .carousel-arrow.previous-button,[data-module=Carousel] .carousel-arrow.slick-prev,[data-module=Carousel] .slick-arrow.previous-button,[data-module=Carousel] .slick-arrow.slick-prev{left:0}[data-module=Carousel] .slick-list{overflow-x:hidden}[data-module=Carousel] .slick-slide{position:relative}[data-module=Carousel] .slick-slide .slide-content-container{position:relative;text-align:center}[data-module=Carousel] .slick-slide img{display:inline-block;max-width:100%}[data-module=Carousel] .slick-slide .slide-content{width:100%;height:100%}[data-module=Carousel] .slick-slide .slide-label{font-weight:600;font-size:24px}[data-module=Carousel] .slick-slide .slide-caption{font-weight:300;font-size:18px}[data-module=Carousel] .slick-slide .links-container,[data-module=Carousel] .slick-slide .notes-container{position:absolute;top:0;bottom:0;left:0;width:100%;overflow:visible}[data-module=Carousel] .slick-slide .note-content-wrapper{position:absolute;width:100%;top:0;left:0;bottom:0;background:#fff;height:100%;display:none;overflow:hidden}[data-module=Carousel] .slick-slide .note-content-wrapper.active{display:block}[data-module=Carousel] .slick-slide .slide-notes{position:relative;text-align:left;width:80%;height:80%;margin:50px auto 10%;border:1px solid #000}[data-module=Carousel] .icons-container{position:absolute;z-index:100;top:10px;right:10px;display:flex}[data-module=Carousel] .icons-container .links-link,[data-module=Carousel] .icons-container .notes-link{background-color:#ccc;border:1px solid #000;border-radius:2px;padding:5px;display:inline-block;cursor:pointer;margin:0 0 0 10px}[data-module=Carousel] .icons-container .links-link svg,[data-module=Carousel] .icons-container .notes-link svg{vertical-align:middle}[data-module=Carousel] .icons-container .links-link.active,[data-module=Carousel] .icons-container .notes-link.active{background-color:#eee;border-color:red}[data-module=Carousel] .icons-container .links-link.active svg path,[data-module=Carousel] .icons-container .notes-link.active svg path{stroke:red}[data-module=Carousel] .slider-links{position:absolute;top:0;left:0;width:100%;bottom:0;display:none;background-color:#fff}[data-module=Carousel] .slider-links.active{display:block}[data-module=Carousel] .slider-links .links-content-wrapper{text-align:left;width:80%;height:80%;margin:50px auto 10%;border:1px solid #000;position:relative}[data-module=Carousel] .notes-content,[data-module=Carousel] .slide-links{overflow-y:auto;width:100%;height:100%;padding:20px}[data-module=Carousel] .close-button{position:absolute;top:5px;right:20px;display:block;padding:0;margin:0;border-radius:50%;width:34px;height:34px;background-color:#fff;border:2px solid #000}[data-module=Carousel] .close-button svg{display:inline-block;vertical-align:middle}[data-module=Carousel] .close-button:hover{background-color:#ccc}[data-module=Carousel] .content-label-caption-wrapper{display:flex;flex-direction:column;text-align:center;justify-content:space-between;align-items:center}[data-module=Carousel] .content-label-caption-wrapper .label-caption-container{display:flex;flex-direction:column}[data-module=Carousel] [data-module]{width:90%;margin:0 auto}", ""]);

// exports


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, "[data-module=ConsultAd] .content-container{min-width:70%!important}[data-module=ConsultAd] ul.items-container{margin-top:20px;display:flex;flex-direction:column;flex-wrap:wrap;justify-content:space-between}[data-module=ConsultAd] ul.items-container li.consult-item{display:flex;width:100%;flex-direction:row;align-items:stretch;background-color:#f8f8f8}[data-module=ConsultAd] ul.items-container li.consult-item .image-container{display:inline-flex;width:45%;align-items:center}[data-module=ConsultAd] ul.items-container li.consult-item .content-container{display:inline-flex;flex-direction:column;width:55%;font-size:16px;color:#000;padding:10px;justify-content:center}[data-module=ConsultAd] ul.items-container li.consult-item .link-container{width:100%;display:inline-flex;align-items:flex-start}[data-module=ConsultAd] ul.items-container li.consult-item img{width:100%;height:auto;object-fit:cover}[data-module=ConsultAd] ul.items-container li.consult-item .title{font-family:proxima_nova_ltsemibold,arial,sans-serif;font-weight:600}[data-module=ConsultAd] ul.items-container li.consult-item .sub-title{font-weight:600;color:#007cb0}[data-module=ConsultAd] ul.items-container li.consult-item .description{font-family:proxima_nova_ltlight,arial,sans-serif}[data-module=ConsultAd] ul.items-container li.consult-item a{display:inline;text-decoration:none}[data-module=ConsultAd] ul.items-container li.consult-item a:hover{text-decoration:underline}", ""]);

// exports


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, "#isi-article-container .isi-module{height:100%}.isi-module{background-color:#fff;width:100%;height:auto;transition:height .35s;-ms-transition:height .35s;padding-bottom:40px}.isi-module.inPage.expanded{height:50vh}.isi-module .toggle-button{padding:0}.isi-module .header-container{background-color:#1b88bf;padding:0 10px}.isi-module .header-container .container{position:relative;display:flex;flex-direction:row;align-items:center;height:40px}.isi-module .header-container h3{display:inline-block;flex:5;padding:0}.isi-module .header-container .toggle-button-container{align-items:flex-end;flex:1;text-align:right}.isi-module .header-container .toggle-button-container .toggle-button{display:inline-block;width:24px;height:24px;background-color:transparent;border:none}.isi-module .content-container{word-wrap:break-word;height:100%;overflow-y:hidden;padding:0}.isi-module .content-container .content-scroll-area{display:block;width:100%;height:100%;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:0}.isi-module .content-container .content-scroll-area .content{padding:10px;background-color:#fff}", ""]);

// exports


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, "#side-menu{position:fixed;top:0;left:0;z-index:5000}#side-menu .bm-overlay{background:rgba(0,0,0,.3);left:0}#side-menu .bm-menu-wrap,#side-menu .bm-overlay{position:absolute;top:0}#side-menu .bm-menu{background:#fff;padding:0;font-size:1.15em}#side-menu .bm-morph-shape{fill:#373a47}#side-menu .bm-item-list{color:#b8b7ad;padding:.8em}#side-menu .bm-item-list div.title{color:#fff}#side-menu nav.bm-item-list{padding:0;min-width:300px;font-size:20px}#side-menu nav.bm-item-list ul.sub-menu .link-container{padding-left:40px}#side-menu nav.bm-item-list ul.sub-menu .arrow-container{display:none}#side-menu nav.bm-item-list>ul{background-color:#17a8ff;width:100%;margin:0 auto;display:flex;flex-flow:column}#side-menu nav.bm-item-list>ul>li:first-child{border-top:none}#side-menu nav.bm-item-list>ul li{width:100%;border-top:1px solid #fff}#side-menu nav.bm-item-list>ul li.active-page{background-color:#007eca}#side-menu nav.bm-item-list>ul li.active-page a{color:#000}#side-menu nav.bm-item-list>ul li>span.link-container{padding:20px;display:flex;display:-ms-flex;align-items:center;flex-flow:row;width:100%}#side-menu nav.bm-item-list>ul li>span.link-container a.title{color:#fff;width:100%;display:inline-flex;display:-ms-inline-flex;flex:5;order:1}#side-menu nav.bm-item-list>ul li>span.link-container a.title:hover{text-decoration:none}#side-menu nav.bm-item-list>ul li>span.link-container .arrow-container{flex:1;order:2;justify-content:center;text-align:right;cursor:pointer}#side-menu nav.bm-item-list>ul li>span.link-container .arrow-container>svg{fill:transparent;stroke:#fff;width:18px;height:18px}#side-menu nav.bm-item-list>ul li>span.link-container .arrow-container>svg polyline{stroke:#fff}#side-menu nav.bm-item-list>ul li>ul{width:100%;background-color:#17a8ff;max-height:0;transition:max-height 0s;overflow:hidden}#side-menu nav.bm-item-list>ul li>ul>li>span{padding:10px 10px 10px 40px}#side-menu nav.bm-item-list>ul li.expand-submenu{background-color:#005e97}#side-menu nav.bm-item-list>ul li.expand-submenu>ul{max-height:1000px;transition:max-height 1s}#side-menu nav.bm-item-list>ul li.expand-submenu.layered-submenu{position:relative}#side-menu nav.bm-item-list>ul li.expand-submenu.layered-submenu ul.sub-menu{position:absolute;left:100%;top:0;z-index:1000}", ""]);

// exports


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, "nav#navigation-module{flex:1 1 20%;order:1;margin:10px;padding:5px;min-width:300px;font-size:20px}nav#navigation-module a:hover{text-decoration:none}nav#navigation-module ul.sub-menu .link-container{padding-left:40px}nav#navigation-module ul.sub-menu .arrow-container{display:none}nav#navigation-module>ul{background-color:#17a8ff;width:100%;margin:0 auto;display:flex;flex-flow:column}nav#navigation-module>ul>li:first-child{border-top:none}nav#navigation-module>ul li{width:100%;border-top:1px solid #fff}nav#navigation-module>ul li.active-page{background-color:#007eca}nav#navigation-module>ul li.active-page a{color:#000}nav#navigation-module>ul li>span.link-container{padding:20px;display:flex;display:-ms-flex;align-items:center;flex-flow:row;width:100%}nav#navigation-module>ul li>span.link-container a.title,nav#navigation-module>ul li>span.link-container div.title{cursor:pointer;color:#fff;width:100%;display:inline-flex;display:-ms-inline-flex;flex:5;order:1}nav#navigation-module>ul li>span.link-container a.title:hover,nav#navigation-module>ul li>span.link-container div.title:hover{text-decoration:none}nav#navigation-module>ul li>span.link-container .arrow-container{flex:1;order:2;justify-content:center;text-align:right}nav#navigation-module>ul li>span.link-container .arrow-container>a{display:inline-block;cursor:pointer}nav#navigation-module>ul li>span.link-container .arrow-container>a>svg{fill:transparent;stroke:#fff;width:18px;height:18px}nav#navigation-module>ul li>span.link-container .arrow-container>a>svg polyline{stroke:#fff}nav#navigation-module>ul li>ul{width:100%;background-color:#17a8ff;max-height:0;transition:max-height 0s;overflow:hidden}nav#navigation-module>ul li>ul>li>span{padding:10px 10px 10px 40px}nav#navigation-module>ul li.expand-submenu{background-color:#005e97}nav#navigation-module>ul li.expand-submenu>ul{max-height:1000px;transition:max-height 1s}nav#navigation-module>ul li.expand-submenu.layered-submenu{position:relative}nav#navigation-module>ul li.expand-submenu.layered-submenu ul.sub-menu{position:absolute;left:100%;top:0;z-index:1001}nav#navigation-module.position-right>ul>li ul.sub-menu .arrow-container{display:block}nav#navigation-module.position-right>ul>li span.link-container a.title{order:2}nav#navigation-module.position-right>ul>li span.link-container .arrow-container{order:1;text-align:left}nav#navigation-module.position-right>ul>li.expand-submenu.layered-submenu ul.sub-menu{left:inherit;right:100%}nav#navigation-module.position-right>ul>li.expand-submenu.layered-submenu ul.sub-menu>li span.link-container .arrow-container{display:none}nav#navigation-module.position-top{margin:0;padding:0;width:100%;flex:1 0 auto}nav#navigation-module.position-top>ul{flex-flow:row}nav#navigation-module.position-top>ul>li{position:relative;flex:1;align-items:center;border-left:1px solid #fff;border-top:none;display:inline-flex;display:-ms-inline-flex}nav#navigation-module.position-top>ul>li:first-child{border-left:none}nav#navigation-module.position-top>ul>li span.link-container{display:inline-flex}nav#navigation-module.position-top>ul>li span.link-container a{display:inline;width:100px}nav#navigation-module.position-top>ul>li>ul.sub-menu{position:absolute;width:200%;top:100%}nav#navigation-module.position-top>ul>li.expand-submenu:last-child ul.sub-menu{right:0;left:inherit;top:100%}nav#navigation-module.position-top>ul>li.expand-submenu ul.sub-menu{top:100%;left:0;right:inherit}", ""]);

// exports


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, "[data-module=PageContent]{width:100%}[data-module=PageContent] #page-content-module .page-template-wrapper .main-content{margin:0;padding:0}[data-module=PageContent] #page-content-module .page-template-wrapper .main-content.nav-template{display:flex;flex-flow:row}[data-module=PageContent] #page-content-module .page-template-wrapper .main-content article{position:relative;margin:4px;padding:5px;flex:3 1 auto;order:2;width:auto}[data-module=PageContent] #page-content-module .page-template-wrapper .main-content.nav-template article{max-width:70%}[data-module=PageContent] #page-content-module .page-template-wrapper.flow-invert .main-content nav{order:2}[data-module=PageContent] #page-content-module .page-template-wrapper.flow-invert .main-content article{order:1}[data-module=PageContent] #page-content-module .page-template-wrapper.flow-column .main-content{flex-flow:column}[data-module=PageContent] #page-content-module .page-template-wrapper.flow-column .main-content article{width:100%;max-width:100%;flex:1 0 auto}[data-module=PageContent] #page-content-module .content-container{word-wrap:break-word}[data-module=PageContent] #page-content-module .isi-container{width:100%;margin-top:20px}[data-module=PageContent] #page-content-module .isi-container.sticky{position:fixed;z-index:1100;bottom:0;left:0;padding:10px}[data-module=PageContent] #page-content-module .isi-container.sticky .isi-module{position:absolute;bottom:0;left:0;padding-bottom:40px}[data-module=PageContent] #page-content-module .isi-container.sticky.position-top,[data-module=PageContent] #page-content-module .isi-container.sticky.position-top .isi-module{top:0;bottom:none}[data-module=PageContent] .spinner-container{display:block;padding:50px;width:100%;height:220px;position:relative}[data-module=PageContent] .spinner{position:absolute;top:50%;left:50%;width:120px;height:120px;margin:-60px 0 0 -60px;-webkit-animation:spin 2s linear infinite;-moz-animation:spin 2s linear infinite;animation:spin 2s linear infinite}@-moz-keyframes spin{to{-moz-transform:rotate(1turn)}}@-webkit-keyframes spin{to{-webkit-transform:rotate(1turn)}}@keyframes spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);

// exports


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, "[data-module=Resources] ul.resources-container{margin-top:20px;display:flex;flex-direction:row;flex-wrap:wrap;justify-content:space-between}[data-module=Resources] ul.resources-container li.resource-item{display:inline-block;width:48%;max-width:48%}[data-module=Resources] ul.resources-container li.resource-item img{width:100%}[data-module=Resources] ul.resources-container li.resource-item .title{font-size:24px;font-weight:400;color:#25853b;margin:16px 0 5px;padding:0}[data-module=Resources] ul.resources-container li.resource-item .description{margin:0;padding:0;font-size:20px;color:#000;line-height:1.2em}[data-module=Resources] ul.resources-container li.resource-item .button{padding:12px 18px;margin:18px 0;text-decoration:none}[data-module=Resources] ul.resources-container li.resource-item .button:hover{text-decoration:none}[data-module=Resources] ul.resources-container li.resource-item .button .title{color:#fff;text-decoration:none;font-size:18px;font-weight:600}", ""]);

// exports


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, "[data-module=ZoomImages]{display:inline-block}[data-module=ZoomImages] .module-wrapper{width:auto;position:relative;cursor:pointer;cursor:zoom-in}[data-module=ZoomImages] .module-wrapper.no-zoom{cursor:default}[data-module=ZoomImages] button.zoom-button{position:absolute;top:10px;right:10px;padding:0;margin:0;background:none;border:none;opacity:.5;transition:opacity .3s}[data-module=ZoomImages] button.zoom-button:hover{opacity:1}p [data-module=ZoomImages]{float:left;margin-right:10px;max-width:50%}", ""]);

// exports


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(15)(undefined);
// imports


// module
exports.push([module.i, ".zoom-images-modal{position:fixed;display:block;width:100%;height:100%;overflow-y:auto;z-index:1000;background-color:rgba(0,0,0,.75)}.zoom-images-modal .close-button-container{position:absolute;z-index:1200;top:5px;right:5px}.zoom-images-modal .close-button-container button.close-button{display:flex;justify-content:center;align-items:center;text-align:center;padding:0;margin:0;background-color:hsla(0,0%,71%,.75);width:40px;height:40px;border-radius:50%;border:1px solid transparent}.zoom-images-modal .close-button-container button.close-button:hover{background-color:#b4b4b4}.zoom-images-modal .close-button-container button.close-button svg{display:inline-block;margin:0 auto}.zoom-images-modal .close-button-container button.close-button svg path{stroke:#fff}.zoom-images-modal .zoom-content-container{position:relative;z-index:1100;margin:0 auto;top:2.5vh;width:95vw;height:95%;background-color:#fff;border:1px solid #fff;border-radius:5px;display:flex;flex-direction:column}.zoom-images-modal .zoom-content-container.label-caption .image-container{flex:1 1 auto;flex-shrink:0;max-height:80%;object-fit:contain}.zoom-images-modal .zoom-content-container.label-caption .label-caption-container{display:flex;flex-flow:column;align-items:center;justify-content:flex-start;flex:1 1 auto;flex-shrink:0;max-height:20%;padding:0 10px;text-align:center;overflow-y:auto}.zoom-images-modal .zoom-content-container.label-caption .label-caption-container .zoom-label{font-weight:700;font-weight:600}.zoom-images-modal .zoom-content-container img.image-container{object-fit:contain}.zoom-images-modal .zoom-content-container .image-container{width:100%;height:100%;padding:10px}.zoom-images-modal .zoom-content-container .image-container img{width:100%;height:100%}.zoom-images-modal .zoom-content-container .image-container .image.object-fit{display:inline-block;width:100%;height:100%;background-size:contain;background-repeat:no-repeat;background-position:50%}", ""]);

// exports


/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = function(opts) {
  return new ElementClass(opts)
}

function indexOf(arr, prop) {
  if (arr.indexOf) return arr.indexOf(prop)
  for (var i = 0, len = arr.length; i < len; i++)
    if (arr[i] === prop) return i
  return -1
}

function ElementClass(opts) {
  if (!(this instanceof ElementClass)) return new ElementClass(opts)
  var self = this
  if (!opts) opts = {}

  // similar doing instanceof HTMLElement but works in IE8
  if (opts.nodeType) opts = {el: opts}

  this.opts = opts
  this.el = opts.el || document.body
  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
}

ElementClass.prototype.add = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return el.className = className
  var classes = el.className.split(' ')
  if (indexOf(classes, className) > -1) return classes
  classes.push(className)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.remove = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return
  var classes = el.className.split(' ')
  var idx = indexOf(classes, className)
  if (idx > -1) classes.splice(idx, 1)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.has = function(className) {
  var el = this.el
  if (!el) return
  var classes = el.className.split(' ')
  return indexOf(classes, className) > -1
}

ElementClass.prototype.toggle = function(className) {
  var el = this.el
  if (!el) return
  if (this.has(className)) this.remove(className)
  else this.add(className)
}


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ┌────────────────────────────────────────────────────────────┐ \\
// │ Eve 0.4.2 - JavaScript Events Library                      │ \\
// ├────────────────────────────────────────────────────────────┤ \\
// │ Author Dmitry Baranovskiy (http://dmitry.baranovskiy.com/) │ \\
// └────────────────────────────────────────────────────────────┘ \\

(function (glob) {
    var version = "0.4.2",
        has = "hasOwnProperty",
        separator = /[\.\/]/,
        comaseparator = /\s*,\s*/,
        wildcard = "*",
        fun = function () {},
        numsort = function (a, b) {
            return a - b;
        },
        current_event,
        stop,
        events = {n: {}},
        firstDefined = function () {
            for (var i = 0, ii = this.length; i < ii; i++) {
                if (typeof this[i] != "undefined") {
                    return this[i];
                }
            }
        },
        lastDefined = function () {
            var i = this.length;
            while (--i) {
                if (typeof this[i] != "undefined") {
                    return this[i];
                }
            }
        },
    /*\
     * eve
     [ method ]

     * Fires event with given `name`, given scope and other parameters.

     > Arguments

     - name (string) name of the *event*, dot (`.`) or slash (`/`) separated
     - scope (object) context for the event handlers
     - varargs (...) the rest of arguments will be sent to event handlers

     = (object) array of returned values from the listeners. Array has two methods `.firstDefined()` and `.lastDefined()` to get first or last not `undefined` value.
    \*/
        eve = function (name, scope) {
            name = String(name);
            var e = events,
                oldstop = stop,
                args = Array.prototype.slice.call(arguments, 2),
                listeners = eve.listeners(name),
                z = 0,
                f = false,
                l,
                indexed = [],
                queue = {},
                out = [],
                ce = current_event,
                errors = [];
            out.firstDefined = firstDefined;
            out.lastDefined = lastDefined;
            current_event = name;
            stop = 0;
            for (var i = 0, ii = listeners.length; i < ii; i++) if ("zIndex" in listeners[i]) {
                indexed.push(listeners[i].zIndex);
                if (listeners[i].zIndex < 0) {
                    queue[listeners[i].zIndex] = listeners[i];
                }
            }
            indexed.sort(numsort);
            while (indexed[z] < 0) {
                l = queue[indexed[z++]];
                out.push(l.apply(scope, args));
                if (stop) {
                    stop = oldstop;
                    return out;
                }
            }
            for (i = 0; i < ii; i++) {
                l = listeners[i];
                if ("zIndex" in l) {
                    if (l.zIndex == indexed[z]) {
                        out.push(l.apply(scope, args));
                        if (stop) {
                            break;
                        }
                        do {
                            z++;
                            l = queue[indexed[z]];
                            l && out.push(l.apply(scope, args));
                            if (stop) {
                                break;
                            }
                        } while (l)
                    } else {
                        queue[l.zIndex] = l;
                    }
                } else {
                    out.push(l.apply(scope, args));
                    if (stop) {
                        break;
                    }
                }
            }
            stop = oldstop;
            current_event = ce;
            return out;
        };
        // Undocumented. Debug only.
        eve._events = events;
    /*\
     * eve.listeners
     [ method ]

     * Internal method which gives you array of all event handlers that will be triggered by the given `name`.

     > Arguments

     - name (string) name of the event, dot (`.`) or slash (`/`) separated

     = (array) array of event handlers
    \*/
    eve.listeners = function (name) {
        var names = name.split(separator),
            e = events,
            item,
            items,
            k,
            i,
            ii,
            j,
            jj,
            nes,
            es = [e],
            out = [];
        for (i = 0, ii = names.length; i < ii; i++) {
            nes = [];
            for (j = 0, jj = es.length; j < jj; j++) {
                e = es[j].n;
                items = [e[names[i]], e[wildcard]];
                k = 2;
                while (k--) {
                    item = items[k];
                    if (item) {
                        nes.push(item);
                        out = out.concat(item.f || []);
                    }
                }
            }
            es = nes;
        }
        return out;
    };
    
    /*\
     * eve.on
     [ method ]
     **
     * Binds given event handler with a given name. You can use wildcards “`*`” for the names:
     | eve.on("*.under.*", f);
     | eve("mouse.under.floor"); // triggers f
     * Use @eve to trigger the listener.
     **
     > Arguments
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     = (function) returned function accepts a single numeric parameter that represents z-index of the handler. It is an optional feature and only used when you need to ensure that some subset of handlers will be invoked in a given order, despite of the order of assignment. 
     > Example:
     | eve.on("mouse", eatIt)(2);
     | eve.on("mouse", scream);
     | eve.on("mouse", catchIt)(1);
     * This will ensure that `catchIt` function will be called before `eatIt`.
     *
     * If you want to put your handler before non-indexed handlers, specify a negative value.
     * Note: I assume most of the time you don’t need to worry about z-index, but it’s nice to have this feature “just in case”.
    \*/
    eve.on = function (name, f) {
        name = String(name);
        if (typeof f != "function") {
            return function () {};
        }
        var names = name.split(comaseparator);
        for (var i = 0, ii = names.length; i < ii; i++) {
            (function (name) {
                var names = name.split(separator),
                    e = events,
                    exist;
                for (var i = 0, ii = names.length; i < ii; i++) {
                    e = e.n;
                    e = e.hasOwnProperty(names[i]) && e[names[i]] || (e[names[i]] = {n: {}});
                }
                e.f = e.f || [];
                for (i = 0, ii = e.f.length; i < ii; i++) if (e.f[i] == f) {
                    exist = true;
                    break;
                }
                !exist && e.f.push(f);
            }(names[i]));
        }
        return function (zIndex) {
            if (+zIndex == +zIndex) {
                f.zIndex = +zIndex;
            }
        };
    };
    /*\
     * eve.f
     [ method ]
     **
     * Returns function that will fire given event with optional arguments.
     * Arguments that will be passed to the result function will be also
     * concated to the list of final arguments.
     | el.onclick = eve.f("click", 1, 2);
     | eve.on("click", function (a, b, c) {
     |     console.log(a, b, c); // 1, 2, [event object]
     | });
     > Arguments
     - event (string) event name
     - varargs (…) and any other arguments
     = (function) possible event handler function
    \*/
    eve.f = function (event) {
        var attrs = [].slice.call(arguments, 1);
        return function () {
            eve.apply(null, [event, null].concat(attrs).concat([].slice.call(arguments, 0)));
        };
    };
    /*\
     * eve.stop
     [ method ]
     **
     * Is used inside an event handler to stop the event, preventing any subsequent listeners from firing.
    \*/
    eve.stop = function () {
        stop = 1;
    };
    /*\
     * eve.nt
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     > Arguments
     **
     - subname (string) #optional subname of the event
     **
     = (string) name of the event, if `subname` is not specified
     * or
     = (boolean) `true`, if current event’s name contains `subname`
    \*/
    eve.nt = function (subname) {
        if (subname) {
            return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(current_event);
        }
        return current_event;
    };
    /*\
     * eve.nts
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     **
     = (array) names of the event
    \*/
    eve.nts = function () {
        return current_event.split(separator);
    };
    /*\
     * eve.off
     [ method ]
     **
     * Removes given function from the list of event listeners assigned to given name.
     * If no arguments specified all the events will be cleared.
     **
     > Arguments
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
    \*/
    /*\
     * eve.unbind
     [ method ]
     **
     * See @eve.off
    \*/
    eve.off = eve.unbind = function (name, f) {
        if (!name) {
            eve._events = events = {n: {}};
            return;
        }
        var names = name.split(comaseparator);
        if (names.length > 1) {
            for (var i = 0, ii = names.length; i < ii; i++) {
                eve.off(names[i], f);
            }
            return;
        }
        names = name.split(separator);
        var e,
            key,
            splice,
            i, ii, j, jj,
            cur = [events];
        for (i = 0, ii = names.length; i < ii; i++) {
            for (j = 0; j < cur.length; j += splice.length - 2) {
                splice = [j, 1];
                e = cur[j].n;
                if (names[i] != wildcard) {
                    if (e[names[i]]) {
                        splice.push(e[names[i]]);
                    }
                } else {
                    for (key in e) if (e[has](key)) {
                        splice.push(e[key]);
                    }
                }
                cur.splice.apply(cur, splice);
            }
        }
        for (i = 0, ii = cur.length; i < ii; i++) {
            e = cur[i];
            while (e.n) {
                if (f) {
                    if (e.f) {
                        for (j = 0, jj = e.f.length; j < jj; j++) if (e.f[j] == f) {
                            e.f.splice(j, 1);
                            break;
                        }
                        !e.f.length && delete e.f;
                    }
                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
                        var funcs = e.n[key].f;
                        for (j = 0, jj = funcs.length; j < jj; j++) if (funcs[j] == f) {
                            funcs.splice(j, 1);
                            break;
                        }
                        !funcs.length && delete e.n[key].f;
                    }
                } else {
                    delete e.f;
                    for (key in e.n) if (e.n[has](key) && e.n[key].f) {
                        delete e.n[key].f;
                    }
                }
                e = e.n;
            }
        }
    };
    /*\
     * eve.once
     [ method ]
     **
     * Binds given event handler with a given name to only run once then unbind itself.
     | eve.once("login", f);
     | eve("login"); // triggers f
     | eve("login"); // no listeners
     * Use @eve to trigger the listener.
     **
     > Arguments
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     = (function) same return function as @eve.on
    \*/
    eve.once = function (name, f) {
        var f2 = function () {
            eve.unbind(name, f2);
            return f.apply(this, arguments);
        };
        return eve.on(name, f2);
    };
    /*\
     * eve.version
     [ property (string) ]
     **
     * Current version of the library.
    \*/
    eve.version = version;
    eve.toString = function () {
        return "You are running Eve " + version;
    };
    (typeof module != "undefined" && module.exports) ? (module.exports = eve) : ( true ? (!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() { return eve; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))) : (glob.eve = eve));
})(this);


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(659);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(669);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(7);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(29);

var createArrayFromMixed = __webpack_require__(662);
var getMarkupWrap = __webpack_require__(664);
var invariant = __webpack_require__(7);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(29);

var invariant = __webpack_require__(7);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(666);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(668);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(6);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(25);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(26);

var _Intl2 = _interopRequireDefault(_Intl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.SPINNING;

var Spinning = function (_Component) {
  _inherits(Spinning, _Component);

  function Spinning() {
    _classCallCheck(this, Spinning);

    return _possibleConstructorReturn(this, (Spinning.__proto__ || Object.getPrototypeOf(Spinning)).apply(this, arguments));
  }

  _createClass(Spinning, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          a11yTitle = _props.a11yTitle,
          className = _props.className,
          small = _props.small,
          size = _props.size,
          responsive = _props.responsive,
          props = _objectWithoutProperties(_props, ['a11yTitle', 'className', 'small', 'size', 'responsive']);

      var intl = this.context.intl;


      var sizeOverride = small ? 'small' : size;

      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + sizeOverride, sizeOverride), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _classnames), className);

      return _react2.default.createElement(
        'svg',
        _extends({}, props, { className: classes, viewBox: '0 0 48 48', version: '1.1',
          role: 'img', 'aria-label': a11yTitle || _Intl2.default.getMessage(intl, 'Spinning') }),
        _react2.default.createElement('circle', { cx: '24', cy: '24', r: '21',
          stroke: '#979797', strokeWidth: '6', fill: 'none' })
      );
    }
  }]);

  return Spinning;
}(_react.Component);

Spinning.displayName = 'Spinning';
exports.default = Spinning;


Spinning.contextTypes = {
  intl: _propTypes2.default.object
};

Spinning.defaultProps = {
  responsive: true
};

Spinning.propTypes = {
  a11yTitle: _propTypes2.default.string,
  className: _propTypes2.default.string,
  small: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(6);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(25);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(26);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(28);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-add-circle', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'add-circle');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,18 L12,6 M6,12 L18,12' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'AddCircle';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(6);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(25);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(26);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(28);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-checkmark', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'checkmark');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '2 14 9 20 22 4' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Checkmark';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(6);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(25);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(26);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(28);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-circle-information', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'circle-information');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,10 L12,18 M12,6 L12,8' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'CircleInformation';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(6);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(25);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(26);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(28);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-circle-play', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'circle-play');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M9.5,15.5 L15.5,12 L9.5,8.5 L9.5,15.5 Z M10.5,13.5 L12.5,12 L10.5,10.5 L10.5,13.5 Z' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'CirclePlay';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(6);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(25);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(26);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(28);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-info', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'info');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M15,17.0002864 C15,14.0000003 19,12.0005727 19,8.00028636 C19,4.00000002 16,1.00028636 12,1.00028636 C8,1.00028636 5,4.00000002 5,8.00028636 C5,12.0005727 9,14.0000003 9,17.0002864 C9,20.0005725 9,20 9,20 C9,22.0000003 10,22.9999997 12,23 C14,23.0000003 15,22.0000003 15,20 C15,20 15,20.0005725 15,17.0002864 Z M9,18 L15,18' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Info';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(6);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(25);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(26);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(28);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-link-top', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'link-top');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,5 L12,23 M4,13 L12,5 L20,13 M2,2 L22,2' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'LinkTop';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(6);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(25);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(26);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(28);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-menu', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'menu');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,19 L22,19 M2,5 L22,5 M2,12 L22,12' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Menu';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(6);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(25);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(26);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(28);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-social-linkedin-option', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'social-linkedin-option');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: '#0077B5', fillRule: 'evenodd', d: 'M22.0367422,22 L17.8848745,22 L17.8848745,15.5036305 C17.8848745,13.9543347 17.85863,11.9615082 15.7275829,11.9615082 C13.5676669,11.9615082 13.237862,13.6498994 13.237862,15.3925291 L13.237862,22 L9.0903683,22 L9.0903683,8.64071385 L13.0707725,8.64071385 L13.0707725,10.4673257 L13.1276354,10.4673257 C13.6813927,9.41667396 15.0356049,8.3091593 17.0555507,8.3091593 C21.2599073,8.3091593 22.0367422,11.0753215 22.0367422,14.6734319 L22.0367422,22 Z M4.40923804,6.81585163 C3.07514653,6.81585163 2,5.73720584 2,4.40748841 C2,3.07864579 3.07514653,2 4.40923804,2 C5.73720584,2 6.81585163,3.07864579 6.81585163,4.40748841 C6.81585163,5.73720584 5.73720584,6.81585163 4.40923804,6.81585163 L4.40923804,6.81585163 Z M6.48604672,22 L2.32980492,22 L2.32980492,8.64071385 L6.48604672,8.64071385 L6.48604672,22 Z', stroke: 'none' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'SocialLinkedinOption';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(6);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(25);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(26);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(28);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-subtract-circle', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'subtract-circle');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M6,12 L18,12' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'SubtractCircle';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(6);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(25);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(26);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(28);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-zoom-in', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'zoom-in');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16,16 L23,23 L16,16 Z M10,18 C14.418278,18 18,14.418278 18,10 C18,5.581722 14.418278,2 10,2 C5.581722,2 2,5.581722 2,10 C2,14.418278 5.581722,18 10,18 Z M10,15 L10,5 M5,10 L15,10' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'ZoomIn';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(252);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsHistory */])();
  var needsHashChangeListener = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripTrailingSlash */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["d" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripBasename */])(path, basename);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(252);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["d" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["d" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["d" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripTrailingSlash */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["d" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripBasename */])(path, basename);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(167);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["a" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 686 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = calc;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utilsJoinPrefixedRules = __webpack_require__(125);

var _utilsJoinPrefixedRules2 = _interopRequireDefault(_utilsJoinPrefixedRules);

var _utilsIsPrefixedValue = __webpack_require__(168);

var _utilsIsPrefixedValue2 = _interopRequireDefault(_utilsIsPrefixedValue);

function calc(property, value) {
  if (typeof value === 'string' && value.indexOf('calc(') > -1) {
    if ((0, _utilsIsPrefixedValue2['default'])(value)) return;

    return (0, _utilsJoinPrefixedRules2['default'])(property, value, function (prefix, value) {
      return value.replace(/calc\(/g, prefix + 'calc(');
    });
  }
}

module.exports = exports['default'];

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = cursor;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utilsJoinPrefixedRules = __webpack_require__(125);

var _utilsJoinPrefixedRules2 = _interopRequireDefault(_utilsJoinPrefixedRules);

var values = {
  'zoom-in': true,
  'zoom-out': true,
  'grab': true,
  'grabbing': true
};

function cursor(property, value) {
  if (property === 'cursor' && values[value]) {
    return (0, _utilsJoinPrefixedRules2['default'])(property, value);
  }
}

module.exports = exports['default'];

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = flex;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utilsCamelToDashCase = __webpack_require__(124);

var _utilsCamelToDashCase2 = _interopRequireDefault(_utilsCamelToDashCase);

var values = { flex: true, 'inline-flex': true };

function flex(property, value) {
  if (property === 'display' && values[value]) {
    return {
      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = flexboxIE;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msPreferredSize'
};

function flexboxIE(property, value) {
  if (alternativeProps[property]) {
    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
  }
}

module.exports = exports['default'];

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = flexboxOld;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _utilsCamelToDashCase = __webpack_require__(124);

var _utilsCamelToDashCase2 = _interopRequireDefault(_utilsCamelToDashCase);

var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

function flexboxOld(property, value) {
  if (property === 'flexDirection') {
    return {
      WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
      WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
    };
  }
  if (alternativeProps[property]) {
    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
  }
}

module.exports = exports['default'];

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = gradient;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utilsJoinPrefixedRules = __webpack_require__(125);

var _utilsJoinPrefixedRules2 = _interopRequireDefault(_utilsJoinPrefixedRules);

var _utilsIsPrefixedValue = __webpack_require__(168);

var _utilsIsPrefixedValue2 = _interopRequireDefault(_utilsIsPrefixedValue);

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(property, value) {
  if (typeof value === 'string' && value.match(values) !== null) {
    if ((0, _utilsIsPrefixedValue2['default'])(value)) return;

    return (0, _utilsJoinPrefixedRules2['default'])(property, value);
  }
}

module.exports = exports['default'];

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = sizing;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utilsJoinPrefixedRules = __webpack_require__(125);

var _utilsJoinPrefixedRules2 = _interopRequireDefault(_utilsJoinPrefixedRules);

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties[property] && values[value]) {
    return (0, _utilsJoinPrefixedRules2['default'])(property, value);
  }
}

module.exports = exports['default'];

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = transition;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _utilsCamelToDashCase = __webpack_require__(124);

var _utilsCamelToDashCase2 = _interopRequireDefault(_utilsCamelToDashCase);

var _utilsCapitalizeString = __webpack_require__(254);

var _utilsCapitalizeString2 = _interopRequireDefault(_utilsCapitalizeString);

var _utilsIsPrefixedValue = __webpack_require__(168);

var _utilsIsPrefixedValue2 = _interopRequireDefault(_utilsIsPrefixedValue);

var _prefixProps = __webpack_require__(253);

var _prefixProps2 = _interopRequireDefault(_prefixProps);

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true
};

function transition(property, value) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties[property]) {
    var _ref2;

    var outputValue = prefixValue(value);
    var webkitOutput = outputValue.split(',').filter(function (value) {
      return value.match(/-moz-|-ms-/) === null;
    }).join(',');

    // if the property is already prefixed
    if (property.indexOf('Webkit') > -1) {
      return _defineProperty({}, property, webkitOutput);
    }

    return _ref2 = {}, _defineProperty(_ref2, 'Webkit' + (0, _utilsCapitalizeString2['default'])(property), webkitOutput), _defineProperty(_ref2, property, outputValue), _ref2;
  }
}

function prefixValue(value) {
  if ((0, _utilsIsPrefixedValue2['default'])(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  // iterate each single value and check for transitioned properties
  // that need to be prefixed as well
  multipleValues.forEach(function (val, index) {
    multipleValues[index] = Object.keys(_prefixProps2['default']).reduce(function (out, prefix) {
      var dashCasePrefix = '-' + prefix.toLowerCase() + '-';

      Object.keys(_prefixProps2['default'][prefix]).forEach(function (prop) {
        var dashCaseProperty = (0, _utilsCamelToDashCase2['default'])(prop);

        if (val.indexOf(dashCaseProperty) > -1) {
          // join all prefixes and create a new value
          out = val.replace(dashCaseProperty, dashCasePrefix + dashCaseProperty) + ',' + out;
        }
      });
      return out;
    }, val);
  });

  return multipleValues.join(',');
}
module.exports = exports['default'];

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = prefixAll;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _prefixProps = __webpack_require__(253);

var _prefixProps2 = _interopRequireDefault(_prefixProps);

var _utilsCapitalizeString = __webpack_require__(254);

var _utilsCapitalizeString2 = _interopRequireDefault(_utilsCapitalizeString);

var _utilsAssign = __webpack_require__(696);

var _utilsAssign2 = _interopRequireDefault(_utilsAssign);

var _pluginsCalc = __webpack_require__(687);

var _pluginsCalc2 = _interopRequireDefault(_pluginsCalc);

var _pluginsCursor = __webpack_require__(688);

var _pluginsCursor2 = _interopRequireDefault(_pluginsCursor);

var _pluginsFlex = __webpack_require__(689);

var _pluginsFlex2 = _interopRequireDefault(_pluginsFlex);

var _pluginsSizing = __webpack_require__(693);

var _pluginsSizing2 = _interopRequireDefault(_pluginsSizing);

var _pluginsGradient = __webpack_require__(692);

var _pluginsGradient2 = _interopRequireDefault(_pluginsGradient);

var _pluginsTransition = __webpack_require__(694);

var _pluginsTransition2 = _interopRequireDefault(_pluginsTransition);

// special flexbox specifications

var _pluginsFlexboxIE = __webpack_require__(690);

var _pluginsFlexboxIE2 = _interopRequireDefault(_pluginsFlexboxIE);

var _pluginsFlexboxOld = __webpack_require__(691);

var _pluginsFlexboxOld2 = _interopRequireDefault(_pluginsFlexboxOld);

var plugins = [_pluginsCalc2['default'], _pluginsCursor2['default'], _pluginsSizing2['default'], _pluginsGradient2['default'], _pluginsTransition2['default'], _pluginsFlexboxIE2['default'], _pluginsFlexboxOld2['default'], _pluginsFlex2['default']];

/**
 * Returns a prefixed version of the style object using all vendor prefixes
 * @param {Object} styles - Style object that gets prefixed properties added
 * @returns {Object} - Style object with prefixed properties and values
 */

function prefixAll(styles) {
  return Object.keys(styles).reduce(function (prefixedStyles, property) {
    var value = styles[property];
    if (value instanceof Object && !Array.isArray(value)) {
      // recurse through nested style objects
      prefixedStyles[property] = prefixAll(value);
    } else {
      Object.keys(_prefixProps2['default']).forEach(function (prefix) {
        var properties = _prefixProps2['default'][prefix];
        // add prefixes if needed
        if (properties[property]) {
          prefixedStyles[prefix + (0, _utilsCapitalizeString2['default'])(property)] = value;
        }
      });

      // resolve every special plugins
      plugins.forEach(function (plugin) {
        return (0, _utilsAssign2['default'])(prefixedStyles, plugin(property, value));
      });
    }

    return prefixedStyles;
  }, styles);
}

module.exports = exports['default'];

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// leight polyfill for Object.assign


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (base) {
  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  return Object.keys(extend).reduce(function (out, key) {
    base[key] = extend[key];
    return out;
  }, {});
};

module.exports = exports["default"];

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _inlineStylePrefixAll = __webpack_require__(695);

var _inlineStylePrefixAll2 = _interopRequireDefault(_inlineStylePrefixAll);

var _utilsGetBrowserInformation = __webpack_require__(708);

var _utilsGetBrowserInformation2 = _interopRequireDefault(_utilsGetBrowserInformation);

var _utilsGetPrefixedKeyframes = __webpack_require__(709);

var _utilsGetPrefixedKeyframes2 = _interopRequireDefault(_utilsGetPrefixedKeyframes);

var _utilsCapitalizeString = __webpack_require__(255);

var _utilsCapitalizeString2 = _interopRequireDefault(_utilsCapitalizeString);

var _utilsAssign = __webpack_require__(707);

var _utilsAssign2 = _interopRequireDefault(_utilsAssign);

var _prefixProps = __webpack_require__(706);

var _prefixProps2 = _interopRequireDefault(_prefixProps);

var _pluginsCalc = __webpack_require__(698);

var _pluginsCalc2 = _interopRequireDefault(_pluginsCalc);

var _pluginsCursor = __webpack_require__(699);

var _pluginsCursor2 = _interopRequireDefault(_pluginsCursor);

var _pluginsFlex = __webpack_require__(700);

var _pluginsFlex2 = _interopRequireDefault(_pluginsFlex);

var _pluginsSizing = __webpack_require__(704);

var _pluginsSizing2 = _interopRequireDefault(_pluginsSizing);

var _pluginsGradient = __webpack_require__(703);

var _pluginsGradient2 = _interopRequireDefault(_pluginsGradient);

var _pluginsTransition = __webpack_require__(705);

var _pluginsTransition2 = _interopRequireDefault(_pluginsTransition);

// special flexbox specifications

var _pluginsFlexboxIE = __webpack_require__(701);

var _pluginsFlexboxIE2 = _interopRequireDefault(_pluginsFlexboxIE);

var _pluginsFlexboxOld = __webpack_require__(702);

var _pluginsFlexboxOld2 = _interopRequireDefault(_pluginsFlexboxOld);

var plugins = [_pluginsCalc2['default'], _pluginsCursor2['default'], _pluginsSizing2['default'], _pluginsGradient2['default'], _pluginsTransition2['default'], _pluginsFlexboxIE2['default'], _pluginsFlexboxOld2['default'],
// this must be run AFTER the flexbox specs
_pluginsFlex2['default']];

var Prefixer = (function () {
  /**
   * Instantiante a new prefixer
   * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
   * @param {string} keepUnprefixed - keeps unprefixed properties and values
   */

  function Prefixer() {
    var _this = this;

    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    _classCallCheck(this, Prefixer);

    var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;

    this._userAgent = options.userAgent || defaultUserAgent;
    this._keepUnprefixed = options.keepUnprefixed || false;

    this._browserInfo = (0, _utilsGetBrowserInformation2['default'])(this._userAgent);

    // Checks if the userAgent was resolved correctly
    if (this._browserInfo && this._browserInfo.prefix) {
      // set additional prefix information
      this.cssPrefix = this._browserInfo.prefix.css;
      this.jsPrefix = this._browserInfo.prefix.inline;
      this.prefixedKeyframes = (0, _utilsGetPrefixedKeyframes2['default'])(this._browserInfo);
    } else {
      this._usePrefixAllFallback = true;
      return false;
    }

    var data = this._browserInfo.browser && _prefixProps2['default'][this._browserInfo.browser];
    if (data) {
      this._requiresPrefix = Object.keys(data).filter(function (key) {
        return data[key] >= _this._browserInfo.version;
      }).reduce(function (result, name) {
        result[name] = true;
        return result;
      }, {});
      this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
    } else {
      this._usePrefixAllFallback = true;
    }
  }

  /**
   * Returns a prefixed version of the style object
   * @param {Object} styles - Style object that gets prefixed properties added
   * @returns {Object} - Style object with prefixed properties and values
   */

  _createClass(Prefixer, [{
    key: 'prefix',
    value: function prefix(styles) {
      var _this2 = this;

      // use prefixAll as fallback if userAgent can not be resolved
      if (this._usePrefixAllFallback) {
        return (0, _inlineStylePrefixAll2['default'])(styles);
      }

      // only add prefixes if needed
      if (!this._hasPropsRequiringPrefix) {
        return styles;
      }

      styles = (0, _utilsAssign2['default'])({}, styles);

      Object.keys(styles).forEach(function (property) {
        var value = styles[property];
        if (value instanceof Object) {
          // recurse through nested style objects
          styles[property] = _this2.prefix(value);
        } else {
          // add prefixes if needed
          if (_this2._requiresPrefix[property]) {
            styles[_this2.jsPrefix + (0, _utilsCapitalizeString2['default'])(property)] = value;
            if (!_this2._keepUnprefixed) {
              delete styles[property];
            }
          }

          // resolve plugins
          plugins.forEach(function (plugin) {
            // generates a new plugin interface with current data
            var resolvedStyles = plugin({
              property: property,
              value: value,
              styles: styles,
              browserInfo: _this2._browserInfo,
              prefix: {
                js: _this2.jsPrefix,
                css: _this2.cssPrefix,
                keyframes: _this2.prefixedKeyframes
              },
              keepUnprefixed: _this2._keepUnprefixed,
              requiresPrefix: _this2._requiresPrefix
            });
            (0, _utilsAssign2['default'])(styles, resolvedStyles);
          });
        }
      });

      return styles;
    }

    /**
     * Returns a prefixed version of the style object using all vendor prefixes
     * @param {Object} styles - Style object that gets prefixed properties added
     * @returns {Object} - Style object with prefixed properties and values
     */
  }], [{
    key: 'prefixAll',
    value: function prefixAll(styles) {
      return (0, _inlineStylePrefixAll2['default'])(styles);
    }
  }]);

  return Prefixer;
})();

exports['default'] = Prefixer;
module.exports = exports['default'];

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = calc;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _utilsCamelToDashCase = __webpack_require__(61);

var _utilsCamelToDashCase2 = _interopRequireDefault(_utilsCamelToDashCase);

function calc(_ref2) {
  var property = _ref2.property;
  var value = _ref2.value;
  var _ref2$browserInfo = _ref2.browserInfo;
  var browser = _ref2$browserInfo.browser;
  var version = _ref2$browserInfo.version;
  var css = _ref2.prefix.css;
  var keepUnprefixed = _ref2.keepUnprefixed;

  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browser === 'firefox' && version < 15 || browser === 'chrome' && version < 25 || browser === 'safari' && version < 6.1 || browser === 'ios_saf' && version < 7)) {
    return _defineProperty({}, property, value.replace(/calc\(/g, css + 'calc(') + (keepUnprefixed ? ';' + (0, _utilsCamelToDashCase2['default'])(property) + ':' + value : ''));
  }
}

module.exports = exports['default'];

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = cursor;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utilsCamelToDashCase = __webpack_require__(61);

var _utilsCamelToDashCase2 = _interopRequireDefault(_utilsCamelToDashCase);

var values = {
  'zoom-in': true,
  'zoom-out': true,
  'grab': true,
  'grabbing': true
};

function cursor(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if (property === 'cursor' && values[value] && (browser === 'firefox' && version < 24 || browser === 'chrome' && version < 37 || browser === 'safari' && version < 9 || browser === 'opera' && version < 24)) {
    return {
      cursor: css + value + (keepUnprefixed ? ';' + (0, _utilsCamelToDashCase2['default'])(property) + ':' + value : '')
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = flex;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utilsCamelToDashCase = __webpack_require__(61);

var _utilsCamelToDashCase2 = _interopRequireDefault(_utilsCamelToDashCase);

var values = {
  'flex': true,
  'inline-flex': true
};

function flex(_ref) {
  var property = _ref.property;
  var value = _ref.value;
  var _ref$browserInfo = _ref.browserInfo;
  var browser = _ref$browserInfo.browser;
  var version = _ref$browserInfo.version;
  var css = _ref.prefix.css;
  var keepUnprefixed = _ref.keepUnprefixed;

  if (property === 'display' && values[value] && (browser === 'chrome' && version < 29 && version > 20 || (browser === 'safari' || browser === 'ios_saf') && version < 9 && version > 6 || browser === 'opera' && (version == 15 || version == 16))) {
    return {
      display: css + value + (keepUnprefixed ? ';' + (0, _utilsCamelToDashCase2['default'])(property) + ':' + value : '')
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = flexboxIE;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _utilsCamelToDashCase = __webpack_require__(61);

var _utilsCamelToDashCase2 = _interopRequireDefault(_utilsCamelToDashCase);

var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  flex: 'flexbox',
  'inline-flex': 'inline-flexbox'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msPreferredSize'
};

var properties = Object.keys(alternativeProps).reduce(function (result, prop) {
  result[prop] = true;
  return result;
}, {});

function flexboxIE(_ref2) {
  var property = _ref2.property;
  var value = _ref2.value;
  var styles = _ref2.styles;
  var _ref2$browserInfo = _ref2.browserInfo;
  var browser = _ref2$browserInfo.browser;
  var version = _ref2$browserInfo.version;
  var css = _ref2.prefix.css;
  var keepUnprefixed = _ref2.keepUnprefixed;

  if ((properties[property] || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'ie_mob' || browser === 'ie') && version == 10) {
    if (!keepUnprefixed) {
      delete styles[property];
    }
    if (property === 'display' && alternativeValues[value]) {
      return {
        display: css + alternativeValues[value] + (keepUnprefixed ? ';' + (0, _utilsCamelToDashCase2['default'])(property) + ':' + value : '')
      };
    }
    if (alternativeProps[property]) {
      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = flexboxOld;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _utilsCamelToDashCase = __webpack_require__(61);

var _utilsCamelToDashCase2 = _interopRequireDefault(_utilsCamelToDashCase);

var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple',
  flex: 'box',
  'inline-flex': 'inline-box'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines'
};

var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];

var properties = Object.keys(alternativeProps).concat(otherProps).reduce(function (result, prop) {
  result[prop] = true;
  return result;
}, {});

function flexboxOld(_ref2) {
  var property = _ref2.property;
  var value = _ref2.value;
  var styles = _ref2.styles;
  var _ref2$browserInfo = _ref2.browserInfo;
  var browser = _ref2$browserInfo.browser;
  var version = _ref2$browserInfo.version;
  var css = _ref2.prefix.css;
  var keepUnprefixed = _ref2.keepUnprefixed;

  if ((properties[property] || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'firefox' && version < 22 || browser === 'chrome' && version < 21 || (browser === 'safari' || browser === 'ios_saf') && version <= 6.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
    if (!keepUnprefixed) {
      delete styles[property];
    }
    if (property === 'flexDirection') {
      return {
        WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
        WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
      };
    }
    if (property === 'display' && alternativeValues[value]) {
      return {
        display: css + alternativeValues[value] + (keepUnprefixed ? ';' + (0, _utilsCamelToDashCase2['default'])(property) + ':' + value : '')
      };
    }
    if (alternativeProps[property]) {
      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = gradient;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _utilsCamelToDashCase = __webpack_require__(61);

var _utilsCamelToDashCase2 = _interopRequireDefault(_utilsCamelToDashCase);

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;

function gradient(_ref2) {
  var property = _ref2.property;
  var value = _ref2.value;
  var _ref2$browserInfo = _ref2.browserInfo;
  var browser = _ref2$browserInfo.browser;
  var version = _ref2$browserInfo.version;
  var css = _ref2.prefix.css;
  var keepUnprefixed = _ref2.keepUnprefixed;

  if (typeof value === 'string' && value.match(values) !== null && (browser === 'firefox' && version < 16 || browser === 'chrome' && version < 26 || (browser === 'safari' || browser === 'ios_saf') && version < 7 || (browser === 'opera' || browser === 'op_mini') && version < 12.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
    return _defineProperty({}, property, css + value + (keepUnprefixed ? ';' + (0, _utilsCamelToDashCase2['default'])(property) + ':' + value : ''));
  }
}

module.exports = exports['default'];

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = sizing;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _utilsCamelToDashCase = __webpack_require__(61);

var _utilsCamelToDashCase2 = _interopRequireDefault(_utilsCamelToDashCase);

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(_ref2) {
  var property = _ref2.property;
  var value = _ref2.value;
  var css = _ref2.prefix.css;
  var keepUnprefixed = _ref2.keepUnprefixed;

  // This might change in the future
  // Keep an eye on it
  if (properties[property] && values[value]) {
    return _defineProperty({}, property, css + value + (keepUnprefixed ? ';' + (0, _utilsCamelToDashCase2['default'])(property) + ':' + value : ''));
  }
}

module.exports = exports['default'];

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = transition;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _utilsCamelToDashCase = __webpack_require__(61);

var _utilsCamelToDashCase2 = _interopRequireDefault(_utilsCamelToDashCase);

var _utilsCapitalizeString = __webpack_require__(255);

var _utilsCapitalizeString2 = _interopRequireDefault(_utilsCapitalizeString);

var _utilsUnprefixProperty = __webpack_require__(710);

var _utilsUnprefixProperty2 = _interopRequireDefault(_utilsUnprefixProperty);

var properties = { transition: true, transitionProperty: true };

function transition(_ref2) {
  var property = _ref2.property;
  var value = _ref2.value;
  var css = _ref2.prefix.css;
  var requiresPrefix = _ref2.requiresPrefix;
  var keepUnprefixed = _ref2.keepUnprefixed;

  // also check for already prefixed transitions
  var unprefixedProperty = (0, _utilsUnprefixProperty2['default'])(property);
  if (typeof value === 'string' && properties[unprefixedProperty]) {
    var _ret = (function () {
      var requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
        return (0, _utilsCamelToDashCase2['default'])(prop);
      });

      // only split multi values, not cubic beziers
      var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

      requiresPrefixDashCased.forEach(function (property) {
        multipleValues.forEach(function (val, index) {
          if (val.indexOf(property) > -1) {
            multipleValues[index] = val.replace(property, css + property) + (keepUnprefixed ? ',' + val : '');
          }
        });
      });

      return {
        v: _defineProperty({}, property, multipleValues.join(','))
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  }
}

module.exports = exports['default'];

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 52, "userSelect": 52, "fontKerning": 32, "textEmphasisPosition": 52, "textEmphasis": 52, "textEmphasisStyle": 52, "textEmphasisColor": 52, "boxDecorationBreak": 52, "clipPath": 52, "maskImage": 52, "maskMode": 52, "maskRepeat": 52, "maskPosition": 52, "maskClip": 52, "maskOrigin": 52, "maskSize": 52, "maskComposite": 52, "mask": 52, "maskBorderSource": 52, "maskBorderMode": 52, "maskBorderSlice": 52, "maskBorderWidth": 52, "maskBorderOutset": 52, "maskBorderRepeat": 52, "maskBorder": 52, "maskType": 52, "textDecorationStyle": 52, "textDecorationSkip": 52, "textDecorationLine": 52, "textDecorationColor": 52, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 52, "breakBefore": 52, "breakInside": 52, "columnCount": 52, "columnFill": 52, "columnGap": 52, "columnRule": 52, "columnRuleColor": 52, "columnRuleStyle": 52, "columnRuleWidth": 52, "columns": 52, "columnSpan": 52, "columnWidth": 52 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 9.1, "userSelect": 9.1, "backdropFilter": 9.1, "fontKerning": 9.1, "scrollSnapType": 9.1, "scrollSnapPointsX": 9.1, "scrollSnapPointsY": 9.1, "scrollSnapDestination": 9.1, "scrollSnapCoordinate": 9.1, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 9.1, "clipPath": 9.1, "maskImage": 9.1, "maskMode": 9.1, "maskRepeat": 9.1, "maskPosition": 9.1, "maskClip": 9.1, "maskOrigin": 9.1, "maskSize": 9.1, "maskComposite": 9.1, "mask": 9.1, "maskBorderSource": 9.1, "maskBorderMode": 9.1, "maskBorderSlice": 9.1, "maskBorderWidth": 9.1, "maskBorderOutset": 9.1, "maskBorderRepeat": 9.1, "maskBorder": 9.1, "maskType": 9.1, "textDecorationStyle": 9.1, "textDecorationSkip": 9.1, "textDecorationLine": 9.1, "textDecorationColor": 9.1, "shapeImageThreshold": 9.1, "shapeImageMargin": 9.1, "shapeImageOutside": 9.1, "filter": 9, "hyphens": 9.1, "flowInto": 9.1, "flowFrom": 9.1, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 9.1, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 47, "userSelect": 47, "boxSizing": 28, "textAlignLast": 47, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 47, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 47, "breakBefore": 47, "breakInside": 47, "columnCount": 47, "columnFill": 47, "columnGap": 47, "columnRule": 47, "columnRuleColor": 47, "columnRuleStyle": 47, "columnRuleWidth": 47, "columns": 47, "columnSpan": 47, "columnWidth": 47 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 37, "userSelect": 37, "fontKerning": 19, "textEmphasisPosition": 37, "textEmphasis": 37, "textEmphasisStyle": 37, "textEmphasisColor": 37, "boxDecorationBreak": 37, "clipPath": 37, "maskImage": 37, "maskMode": 37, "maskRepeat": 37, "maskPosition": 37, "maskClip": 37, "maskOrigin": 37, "maskSize": 37, "maskComposite": 37, "mask": 37, "maskBorderSource": 37, "maskBorderMode": 37, "maskBorderSlice": 37, "maskBorderWidth": 37, "maskBorderOutset": 37, "maskBorderRepeat": 37, "maskBorder": 37, "maskType": 37, "filter": 37, "fontFeatureSettings": 37, "breakAfter": 37, "breakBefore": 37, "breakInside": 37, "columnCount": 37, "columnFill": 37, "columnGap": 37, "columnRule": 37, "columnRuleColor": 37, "columnRuleStyle": 37, "columnRuleWidth": 37, "columns": 37, "columnSpan": 37, "columnWidth": 37 }, "ie": { "gridTemplateRows": 11, "breakInside": 11, "transformOriginY": 9, "gridRowStart": 11, "gridColumn": 11, "regionFragment": 11, "breakBefore": 11, "userSelect": 11, "gridColumnEnd": 11, "gridRowEnd": 11, "gridTemplateColumns": 11, "gridColumnStart": 11, "gridArea": 11, "flexDirection": 10, "gridRowGap": 11, "gridTemplateAreas": 11, "gridAutoRows": 11, "gridRow": 11, "scrollSnapDestination": 11, "scrollSnapPointsY": 11, "touchAction": 10, "gridGap": 11, "gridColumnGap": 11, "wrapFlow": 11, "scrollSnapPointsX": 11, "flowFrom": 11, "transform": 9, "breakAfter": 11, "wrapMargin": 11, "scrollSnapCoordinate": 11, "flexWrap": 10, "scrollSnapType": 11, "flex": 10, "wrapThrough": 11, "gridAutoColumns": 11, "flexFlow": 10, "gridTemplate": 11, "hyphens": 11, "grid": 11, "transformOriginX": 9, "flowInto": 11, "transformOrigin": 9, "gridAutoFlow": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 14, "wrapFlow": 14, "wrapThrough": 14, "wrapMargin": 14, "scrollSnapType": 14, "scrollSnapPointsX": 14, "scrollSnapPointsY": 14, "scrollSnapDestination": 14, "scrollSnapCoordinate": 14, "hyphens": 14, "flowInto": 14, "flowFrom": 14, "breakBefore": 14, "breakAfter": 14, "breakInside": 14, "regionFragment": 14, "gridTemplateColumns": 14, "gridTemplateRows": 14, "gridTemplateAreas": 14, "gridTemplate": 14, "gridAutoColumns": 14, "gridAutoRows": 14, "gridAutoFlow": 14, "grid": 14, "gridRowStart": 14, "gridColumnStart": 14, "gridRowEnd": 14, "gridRow": 14, "gridColumn": 14, "gridColumnEnd": 14, "gridColumnGap": 14, "gridRowGap": 14, "gridArea": 14, "gridGap": 14 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 9.3, "userSelect": 9.3, "backdropFilter": 9.3, "fontKerning": 9.3, "scrollSnapType": 9.3, "scrollSnapPointsX": 9.3, "scrollSnapPointsY": 9.3, "scrollSnapDestination": 9.3, "scrollSnapCoordinate": 9.3, "boxDecorationBreak": 9.3, "clipPath": 9.3, "maskImage": 9.3, "maskMode": 9.3, "maskRepeat": 9.3, "maskPosition": 9.3, "maskClip": 9.3, "maskOrigin": 9.3, "maskSize": 9.3, "maskComposite": 9.3, "mask": 9.3, "maskBorderSource": 9.3, "maskBorderMode": 9.3, "maskBorderSlice": 9.3, "maskBorderWidth": 9.3, "maskBorderOutset": 9.3, "maskBorderRepeat": 9.3, "maskBorder": 9.3, "maskType": 9.3, "textSizeAdjust": 9.3, "textDecorationStyle": 9.3, "textDecorationSkip": 9.3, "textDecorationLine": 9.3, "textDecorationColor": 9.3, "shapeImageThreshold": 9.3, "shapeImageMargin": 9.3, "shapeImageOutside": 9.3, "filter": 9, "hyphens": 9.3, "flowInto": 9.3, "flowFrom": 9.3, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 9.3, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "borderImage": 4.2, "borderImageOutset": 4.2, "borderImageRepeat": 4.2, "borderImageSlice": 4.2, "borderImageSource": 4.2, "borderImageWidth": 4.2, "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 47, "userSelect": 47, "fontKerning": 4.4, "textEmphasisPosition": 47, "textEmphasis": 47, "textEmphasisStyle": 47, "textEmphasisColor": 47, "boxDecorationBreak": 47, "clipPath": 47, "maskImage": 47, "maskMode": 47, "maskRepeat": 47, "maskPosition": 47, "maskClip": 47, "maskOrigin": 47, "maskSize": 47, "maskComposite": 47, "mask": 47, "maskBorderSource": 47, "maskBorderMode": 47, "maskBorderSlice": 47, "maskBorderWidth": 47, "maskBorderOutset": 47, "maskBorderRepeat": 47, "maskBorder": 47, "maskType": 47, "filter": 47, "fontFeatureSettings": 47, "breakAfter": 47, "breakBefore": 47, "breakInside": 47, "columnCount": 47, "columnFill": 47, "columnGap": 47, "columnRule": 47, "columnRuleColor": 47, "columnRuleStyle": 47, "columnRuleWidth": 47, "columns": 47, "columnSpan": 47, "columnWidth": 47 }, "and_chr": { "appearance": 47, "userSelect": 47, "textEmphasisPosition": 47, "textEmphasis": 47, "textEmphasisStyle": 47, "textEmphasisColor": 47, "boxDecorationBreak": 47, "clipPath": 47, "maskImage": 47, "maskMode": 47, "maskRepeat": 47, "maskPosition": 47, "maskClip": 47, "maskOrigin": 47, "maskSize": 47, "maskComposite": 47, "mask": 47, "maskBorderSource": 47, "maskBorderMode": 47, "maskBorderSlice": 47, "maskBorderWidth": 47, "maskBorderOutset": 47, "maskBorderRepeat": 47, "maskBorder": 47, "maskType": 47, "textDecorationStyle": 47, "textDecorationSkip": 47, "textDecorationLine": 47, "textDecorationColor": 47, "filter": 47, "fontFeatureSettings": 47, "breakAfter": 47, "breakBefore": 47, "breakInside": 47, "columnCount": 47, "columnFill": 47, "columnGap": 47, "columnRule": 47, "columnRuleColor": 47, "columnRuleStyle": 47, "columnRuleWidth": 47, "columns": 47, "columnSpan": 47, "columnWidth": 47 }, "and_uc": { "flex": 9.9, "flexBasis": 9.9, "flexDirection": 9.9, "flexGrow": 9.9, "flexFlow": 9.9, "flexShrink": 9.9, "flexWrap": 9.9, "alignContent": 9.9, "alignItems": 9.9, "alignSelf": 9.9, "justifyContent": 9.9, "order": 9.9, "transition": 9.9, "transitionDelay": 9.9, "transitionDuration": 9.9, "transitionProperty": 9.9, "transitionTimingFunction": 9.9, "transform": 9.9, "transformOrigin": 9.9, "transformOriginX": 9.9, "transformOriginY": 9.9, "backfaceVisibility": 9.9, "perspective": 9.9, "perspectiveOrigin": 9.9, "transformStyle": 9.9, "transformOriginZ": 9.9, "animation": 9.9, "animationDelay": 9.9, "animationDirection": 9.9, "animationFillMode": 9.9, "animationDuration": 9.9, "animationIterationCount": 9.9, "animationName": 9.9, "animationPlayState": 9.9, "animationTimingFunction": 9.9, "appearance": 9.9, "userSelect": 9.9, "fontKerning": 9.9, "textEmphasisPosition": 9.9, "textEmphasis": 9.9, "textEmphasisStyle": 9.9, "textEmphasisColor": 9.9, "maskImage": 9.9, "maskMode": 9.9, "maskRepeat": 9.9, "maskPosition": 9.9, "maskClip": 9.9, "maskOrigin": 9.9, "maskSize": 9.9, "maskComposite": 9.9, "mask": 9.9, "maskBorderSource": 9.9, "maskBorderMode": 9.9, "maskBorderSlice": 9.9, "maskBorderWidth": 9.9, "maskBorderOutset": 9.9, "maskBorderRepeat": 9.9, "maskBorder": 9.9, "maskType": 9.9, "textSizeAdjust": 9.9, "filter": 9.9, "hyphens": 9.9, "flowInto": 9.9, "flowFrom": 9.9, "breakBefore": 9.9, "breakAfter": 9.9, "breakInside": 9.9, "regionFragment": 9.9, "fontFeatureSettings": 9.9, "columnCount": 9.9, "columnFill": 9.9, "columnGap": 9.9, "columnRule": 9.9, "columnRuleColor": 9.9, "columnRuleStyle": 9.9, "columnRuleWidth": 9.9, "columns": 9.9, "columnSpan": 9.9, "columnWidth": 9.9 }, "op_mini": { "borderImage": 5, "borderImageOutset": 5, "borderImageRepeat": 5, "borderImageSlice": 5, "borderImageSource": 5, "borderImageWidth": 5, "tabSize": 5, "objectFit": 5, "objectPosition": 5 } };
module.exports = exports["default"];

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// leight polyfill for Object.assign


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (base) {
  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  Object.keys(extend).forEach(function (key) {
    return base[key] = extend[key];
  });
  return base;
};

module.exports = exports["default"];

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _bowser = __webpack_require__(628);

var _bowser2 = _interopRequireDefault(_bowser);

var vendorPrefixes = {
  Webkit: ['chrome', 'safari', 'ios', 'android', 'phantom', 'opera', 'webos', 'blackberry', 'bada', 'tizen'],
  Moz: ['firefox', 'seamonkey', 'sailfish'],
  ms: ['msie', 'msedge']
};

var browsers = {
  chrome: [['chrome']],
  safari: [['safari']],
  firefox: [['firefox']],
  ie: [['msie']],
  edge: [['msedge']],
  opera: [['opera']],
  ios_saf: [['ios', 'mobile'], ['ios', 'tablet']],
  ie_mob: [['windowsphone', 'mobile', 'msie'], ['windowsphone', 'tablet', 'msie'], ['windowsphone', 'mobile', 'msedge'], ['windowsphone', 'tablet', 'msedge']],
  op_mini: [['opera', 'mobile'], ['opera', 'tablet']],
  and_uc: [['android', 'mobile'], ['android', 'tablet']],
  android: [['android', 'mobile'], ['android', 'tablet']]
};

/**
 * Uses bowser to get default browser information such as version and name
 * Evaluates bowser info and adds vendorPrefix information
 * @param {string} userAgent - userAgent that gets evaluated
 */

exports['default'] = function (userAgent) {
  if (!userAgent) {
    return false;
  }

  var info = _bowser2['default']._detect(userAgent);

  Object.keys(vendorPrefixes).forEach(function (prefix) {
    vendorPrefixes[prefix].forEach(function (browser) {
      if (info[browser]) {
        info.prefix = {
          inline: prefix,
          css: '-' + prefix.toLowerCase() + '-'
        };
      }
    });
  });

  var name = '';
  Object.keys(browsers).forEach(function (browser) {
    browsers[browser].forEach(function (condition) {
      var match = 0;
      condition.forEach(function (single) {
        if (info[single]) {
          match += 1;
        }
      });
      if (condition.length === match) {
        name = browser;
      }
    });
  });

  info.browser = name;
  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
  info.version = info.version ? parseFloat(info.version) : parseInt(parseFloat(info.osversion), 10);

  // seperate native android chrome
  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
  if (info.browser === 'android' && info.chrome && info.version > 37) {
    info.browser = 'and_chr';
  }
  info.version = parseFloat(info.version);
  info.osversion = parseFloat(info.osversion);
  // For android < 4.4 we want to check the osversion
  // not the chrome version, see issue #26
  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
  if (info.browser === 'android' && info.osversion < 5) {
    info.version = info.osversion;
  }

  return info;
};

module.exports = exports['default'];

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function (_ref) {
  var browser = _ref.browser;
  var version = _ref.version;
  var prefix = _ref.prefix;

  var prefixedKeyframes = 'keyframes';

  if (browser === 'chrome' && version < 43 || (browser === 'safari' || browser === 'ios_saf') && version < 9 || browser === 'opera' && version < 30 || browser === 'android' && version <= 4.4 || browser === 'and_uc') {
    prefixedKeyframes = prefix.css + prefixedKeyframes;
  }
  return prefixedKeyframes;
};

module.exports = exports['default'];

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function (property) {
  var unprefixed = property.replace(/^(ms|Webkit|Moz|O)/, '');
  return unprefixed.charAt(0).toLowerCase() + unprefixed.slice(1);
};

module.exports = exports['default'];

/***/ }),
/* 711 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 712 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

(function(){
  var crypt = __webpack_require__(629),
      utf8 = __webpack_require__(245).utf8,
      isBuffer = __webpack_require__(711),
      bin = __webpack_require__(245).bin,

  // The core
  md5 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message))
      message = message.toString();
    // else, assume byte array already

    var m = crypt.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  module.exports = function (message, options) {
    if (message === undefined || message === null)
      throw new Error('Illegal argument ' + message);

    var digestbytes = crypt.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

})();


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/

(function UMD(name,context,definition){
	// special form of UMD for polyfilling across evironments
	context[name] = context[name] || definition();
	if (typeof module != "undefined" && module.exports) { module.exports = context[name]; }
	else if (true) { !(__WEBPACK_AMD_DEFINE_RESULT__ = function $AMD$(){ return context[name]; }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); }
})("Promise",typeof global != "undefined" ? global : this,function DEF(){
	/*jshint validthis:true */
	"use strict";

	var builtInProp, cycle, scheduling_queue,
		ToString = Object.prototype.toString,
		timer = (typeof setImmediate != "undefined") ?
			function timer(fn) { return setImmediate(fn); } :
			setTimeout
	;

	// dammit, IE8.
	try {
		Object.defineProperty({},"x",{});
		builtInProp = function builtInProp(obj,name,val,config) {
			return Object.defineProperty(obj,name,{
				value: val,
				writable: true,
				configurable: config !== false
			});
		};
	}
	catch (err) {
		builtInProp = function builtInProp(obj,name,val) {
			obj[name] = val;
			return obj;
		};
	}

	// Note: using a queue instead of array for efficiency
	scheduling_queue = (function Queue() {
		var first, last, item;

		function Item(fn,self) {
			this.fn = fn;
			this.self = self;
			this.next = void 0;
		}

		return {
			add: function add(fn,self) {
				item = new Item(fn,self);
				if (last) {
					last.next = item;
				}
				else {
					first = item;
				}
				last = item;
				item = void 0;
			},
			drain: function drain() {
				var f = first;
				first = last = cycle = void 0;

				while (f) {
					f.fn.call(f.self);
					f = f.next;
				}
			}
		};
	})();

	function schedule(fn,self) {
		scheduling_queue.add(fn,self);
		if (!cycle) {
			cycle = timer(scheduling_queue.drain);
		}
	}

	// promise duck typing
	function isThenable(o) {
		var _then, o_type = typeof o;

		if (o != null &&
			(
				o_type == "object" || o_type == "function"
			)
		) {
			_then = o.then;
		}
		return typeof _then == "function" ? _then : false;
	}

	function notify() {
		for (var i=0; i<this.chain.length; i++) {
			notifyIsolated(
				this,
				(this.state === 1) ? this.chain[i].success : this.chain[i].failure,
				this.chain[i]
			);
		}
		this.chain.length = 0;
	}

	// NOTE: This is a separate function to isolate
	// the `try..catch` so that other code can be
	// optimized better
	function notifyIsolated(self,cb,chain) {
		var ret, _then;
		try {
			if (cb === false) {
				chain.reject(self.msg);
			}
			else {
				if (cb === true) {
					ret = self.msg;
				}
				else {
					ret = cb.call(void 0,self.msg);
				}

				if (ret === chain.promise) {
					chain.reject(TypeError("Promise-chain cycle"));
				}
				else if (_then = isThenable(ret)) {
					_then.call(ret,chain.resolve,chain.reject);
				}
				else {
					chain.resolve(ret);
				}
			}
		}
		catch (err) {
			chain.reject(err);
		}
	}

	function resolve(msg) {
		var _then, self = this;

		// already triggered?
		if (self.triggered) { return; }

		self.triggered = true;

		// unwrap
		if (self.def) {
			self = self.def;
		}

		try {
			if (_then = isThenable(msg)) {
				schedule(function(){
					var def_wrapper = new MakeDefWrapper(self);
					try {
						_then.call(msg,
							function $resolve$(){ resolve.apply(def_wrapper,arguments); },
							function $reject$(){ reject.apply(def_wrapper,arguments); }
						);
					}
					catch (err) {
						reject.call(def_wrapper,err);
					}
				})
			}
			else {
				self.msg = msg;
				self.state = 1;
				if (self.chain.length > 0) {
					schedule(notify,self);
				}
			}
		}
		catch (err) {
			reject.call(new MakeDefWrapper(self),err);
		}
	}

	function reject(msg) {
		var self = this;

		// already triggered?
		if (self.triggered) { return; }

		self.triggered = true;

		// unwrap
		if (self.def) {
			self = self.def;
		}

		self.msg = msg;
		self.state = 2;
		if (self.chain.length > 0) {
			schedule(notify,self);
		}
	}

	function iteratePromises(Constructor,arr,resolver,rejecter) {
		for (var idx=0; idx<arr.length; idx++) {
			(function IIFE(idx){
				Constructor.resolve(arr[idx])
				.then(
					function $resolver$(msg){
						resolver(idx,msg);
					},
					rejecter
				);
			})(idx);
		}
	}

	function MakeDefWrapper(self) {
		this.def = self;
		this.triggered = false;
	}

	function MakeDef(self) {
		this.promise = self;
		this.state = 0;
		this.triggered = false;
		this.chain = [];
		this.msg = void 0;
	}

	function Promise(executor) {
		if (typeof executor != "function") {
			throw TypeError("Not a function");
		}

		if (this.__NPO__ !== 0) {
			throw TypeError("Not a promise");
		}

		// instance shadowing the inherited "brand"
		// to signal an already "initialized" promise
		this.__NPO__ = 1;

		var def = new MakeDef(this);

		this["then"] = function then(success,failure) {
			var o = {
				success: typeof success == "function" ? success : true,
				failure: typeof failure == "function" ? failure : false
			};
			// Note: `then(..)` itself can be borrowed to be used against
			// a different promise constructor for making the chained promise,
			// by substituting a different `this` binding.
			o.promise = new this.constructor(function extractChain(resolve,reject) {
				if (typeof resolve != "function" || typeof reject != "function") {
					throw TypeError("Not a function");
				}

				o.resolve = resolve;
				o.reject = reject;
			});
			def.chain.push(o);

			if (def.state !== 0) {
				schedule(notify,def);
			}

			return o.promise;
		};
		this["catch"] = function $catch$(failure) {
			return this.then(void 0,failure);
		};

		try {
			executor.call(
				void 0,
				function publicResolve(msg){
					resolve.call(def,msg);
				},
				function publicReject(msg) {
					reject.call(def,msg);
				}
			);
		}
		catch (err) {
			reject.call(def,err);
		}
	}

	var PromisePrototype = builtInProp({},"constructor",Promise,
		/*configurable=*/false
	);

	// Note: Android 4 cannot use `Object.defineProperty(..)` here
	Promise.prototype = PromisePrototype;

	// built-in "brand" to signal an "uninitialized" promise
	builtInProp(PromisePrototype,"__NPO__",0,
		/*configurable=*/false
	);

	builtInProp(Promise,"resolve",function Promise$resolve(msg) {
		var Constructor = this;

		// spec mandated checks
		// note: best "isPromise" check that's practical for now
		if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
			return msg;
		}

		return new Constructor(function executor(resolve,reject){
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			resolve(msg);
		});
	});

	builtInProp(Promise,"reject",function Promise$reject(msg) {
		return new this(function executor(resolve,reject){
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			reject(msg);
		});
	});

	builtInProp(Promise,"all",function Promise$all(arr) {
		var Constructor = this;

		// spec mandated checks
		if (ToString.call(arr) != "[object Array]") {
			return Constructor.reject(TypeError("Not an array"));
		}
		if (arr.length === 0) {
			return Constructor.resolve([]);
		}

		return new Constructor(function executor(resolve,reject){
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			var len = arr.length, msgs = Array(len), count = 0;

			iteratePromises(Constructor,arr,function resolver(idx,msg) {
				msgs[idx] = msg;
				if (++count === len) {
					resolve(msgs);
				}
			},reject);
		});
	});

	builtInProp(Promise,"race",function Promise$race(arr) {
		var Constructor = this;

		// spec mandated checks
		if (ToString.call(arr) != "[object Array]") {
			return Constructor.reject(TypeError("Not an array"));
		}

		return new Constructor(function executor(resolve,reject){
			if (typeof resolve != "function" || typeof reject != "function") {
				throw TypeError("Not a function");
			}

			iteratePromises(Constructor,arr,function resolver(idx,msg){
				resolve(msg);
			},reject);
		});
	});

	return Promise;
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63), __webpack_require__(913).setImmediate))

/***/ }),
/* 715 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          )

        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(259);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var assign = __webpack_require__(19);

var ReactPropTypesSecret = __webpack_require__(259);
var checkPropTypes = __webpack_require__(716);

var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? printWarning('Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = appendImportantToEachValue;

var _appendPxIfNeeded = __webpack_require__(260);

var _appendPxIfNeeded2 = _interopRequireDefault(_appendPxIfNeeded);

var _mapObject = __webpack_require__(265);

var _mapObject2 = _interopRequireDefault(_mapObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function appendImportantToEachValue(style) {
  return (0, _mapObject2.default)(style, function (result, key) {
    return (0, _appendPxIfNeeded2.default)(key, style[key]) + ' !important';
  });
}
module.exports = exports['default'];

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var _camelCaseRegex = /([a-z])?([A-Z])/g;

var _camelCaseReplacer = function _camelCaseReplacer(match, p1, p2) {
  return (p1 || '') + '-' + p2.toLowerCase();
};

var _camelCaseToDashCase = function _camelCaseToDashCase(s) {
  return s.replace(_camelCaseRegex, _camelCaseReplacer);
};

var camelCasePropsToDashCase = function camelCasePropsToDashCase(prefixedStyle) {
  // Since prefix is expected to work on inline style objects, we must
  // translate the keys to dash case for rendering to CSS.
  return Object.keys(prefixedStyle).reduce(function (result, key) {
    var dashCaseKey = _camelCaseToDashCase(key);

    // Fix IE vendor prefix
    if (/^ms-/.test(dashCaseKey)) {
      dashCaseKey = '-' + dashCaseKey;
    }

    result[dashCaseKey] = prefixedStyle[key];
    return result;
  }, {});
};

exports.default = camelCasePropsToDashCase;
module.exports = exports['default'];

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _enhancer = __webpack_require__(261);

var _enhancer2 = _interopRequireDefault(_enhancer);

var _styleKeeper = __webpack_require__(173);

var _styleKeeper2 = _interopRequireDefault(_styleKeeper);

var _styleSheet = __webpack_require__(722);

var _styleSheet2 = _interopRequireDefault(_styleSheet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _getStyleKeeper(instance) {
  if (!instance._radiumStyleKeeper) {
    var userAgent = instance.props.radiumConfig && instance.props.radiumConfig.userAgent || instance.context._radiumConfig && instance.context._radiumConfig.userAgent;
    instance._radiumStyleKeeper = new _styleKeeper2.default(userAgent);
  }

  return instance._radiumStyleKeeper;
}

var StyleRoot = function (_Component) {
  _inherits(StyleRoot, _Component);

  function StyleRoot() {
    _classCallCheck(this, StyleRoot);

    var _this = _possibleConstructorReturn(this, _Component.apply(this, arguments));

    _getStyleKeeper(_this);
    return _this;
  }

  StyleRoot.prototype.getChildContext = function getChildContext() {
    return { _radiumStyleKeeper: _getStyleKeeper(this) };
  };

  StyleRoot.prototype.render = function render() {
    /* eslint-disable no-unused-vars */
    // Pass down all props except config to the rendered div.
    var _props = this.props;
    var radiumConfig = _props.radiumConfig;

    var otherProps = _objectWithoutProperties(_props, ['radiumConfig']);
    /* eslint-enable no-unused-vars */

    return _react2.default.createElement(
      'div',
      otherProps,
      this.props.children,
      _react2.default.createElement(_styleSheet2.default, null)
    );
  };

  return StyleRoot;
}(_react.Component);

StyleRoot.contextTypes = {
  _radiumConfig: _react.PropTypes.object,
  _radiumStyleKeeper: _react.PropTypes.instanceOf(_styleKeeper2.default)
};

StyleRoot.childContextTypes = {
  _radiumStyleKeeper: _react.PropTypes.instanceOf(_styleKeeper2.default)
};

StyleRoot = (0, _enhancer2.default)(StyleRoot);

exports.default = StyleRoot;
module.exports = exports['default'];

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styleKeeper = __webpack_require__(173);

var _styleKeeper2 = _interopRequireDefault(_styleKeeper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StyleSheet = (_temp = _class = function (_Component) {
  _inherits(StyleSheet, _Component);

  function StyleSheet() {
    _classCallCheck(this, StyleSheet);

    var _this = _possibleConstructorReturn(this, _Component.apply(this, arguments));

    _this.state = _this._getCSSState();

    _this._onChange = _this._onChange.bind(_this);
    return _this;
  }

  StyleSheet.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._subscription = this.context._radiumStyleKeeper.subscribe(this._onChange);
    this._onChange();
  };

  StyleSheet.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    if (this._subscription) {
      this._subscription.remove();
    }
  };

  StyleSheet.prototype._getCSSState = function _getCSSState() {
    return { css: this.context._radiumStyleKeeper.getCSS() };
  };

  StyleSheet.prototype._onChange = function _onChange() {
    var _this2 = this;

    setTimeout(function () {
      _this2._isMounted && _this2.setState(_this2._getCSSState());
    }, 0);
  };

  StyleSheet.prototype.render = function render() {
    return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: this.state.css } });
  };

  return StyleSheet;
}(_react.Component), _class.contextTypes = {
  _radiumStyleKeeper: _react2.default.PropTypes.instanceOf(_styleKeeper2.default)
}, _temp);
exports.default = StyleSheet;
module.exports = exports['default'];

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _cssRuleSetToString = __webpack_require__(170);

var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Style = _react2.default.createClass({
  displayName: 'Style',

  propTypes: {
    radiumConfig: _react.PropTypes.object,
    rules: _react.PropTypes.object,
    scopeSelector: _react.PropTypes.string
  },

  contextTypes: {
    _radiumConfig: _react.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      scopeSelector: ''
    };
  },
  _buildStyles: function _buildStyles(styles) {
    var _this = this;

    var userAgent = this.props.radiumConfig && this.props.radiumConfig.userAgent || this.context && this.context._radiumConfig && this.context._radiumConfig.userAgent;

    var scopeSelector = this.props.scopeSelector;

    var rootRules = Object.keys(styles).reduce(function (accumulator, selector) {
      if (_typeof(styles[selector]) !== 'object') {
        accumulator[selector] = styles[selector];
      }

      return accumulator;
    }, {});
    var rootStyles = Object.keys(rootRules).length ? (0, _cssRuleSetToString2.default)(scopeSelector || '', rootRules, userAgent) : '';

    return rootStyles + Object.keys(styles).reduce(function (accumulator, selector) {
      var rules = styles[selector];

      if (selector === 'mediaQueries') {
        accumulator += _this._buildMediaQueryString(rules);
      } else if (_typeof(styles[selector]) === 'object') {
        var completeSelector = scopeSelector ? selector.split(',').map(function (part) {
          return scopeSelector + ' ' + part.trim();
        }).join(',') : selector;

        accumulator += (0, _cssRuleSetToString2.default)(completeSelector, rules, userAgent);
      }

      return accumulator;
    }, '');
  },
  _buildMediaQueryString: function _buildMediaQueryString(stylesByMediaQuery) {
    var _this2 = this;

    var mediaQueryString = '';

    Object.keys(stylesByMediaQuery).forEach(function (query) {
      mediaQueryString += '@media ' + query + '{' + _this2._buildStyles(stylesByMediaQuery[query]) + '}';
    });

    return mediaQueryString;
  },
  render: function render() {
    if (!this.props.rules) {
      return null;
    }

    var styles = this._buildStyles(this.props.rules);

    return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: styles } });
  }
});

exports.default = Style;
module.exports = exports['default'];

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = keyframes;

var _cssRuleSetToString = __webpack_require__(170);

var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);

var _hash = __webpack_require__(264);

var _hash2 = _interopRequireDefault(_hash);

var _prefixer = __webpack_require__(172);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function keyframes(keyframeRules, name) {
  return {
    __radiumKeyframes: true,
    __process: function __process(userAgent) {
      var keyframesPrefixed = (0, _prefixer.getPrefixedKeyframes)(userAgent);
      var rules = Object.keys(keyframeRules).map(function (percentage) {
        return (0, _cssRuleSetToString2.default)(percentage, keyframeRules[percentage], userAgent);
      }).join('\n');
      var animationName = (name ? name + '-' : '') + 'radium-animation-' + (0, _hash2.default)(rules);
      var css = '@' + keyframesPrefixed + ' ' + animationName + ' {\n' + rules + '\n}\n';
      return { css: css, animationName: animationName };
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.isNestedStyle = isNestedStyle;
exports.mergeStyles = mergeStyles;
function isNestedStyle(value) {
  // Don't merge objects overriding toString, since they should be converted
  // to string values.
  return value && value.constructor === Object && value.toString === Object.prototype.toString;
}

// Merge style objects. Deep merge plain object values.
function mergeStyles(styles) {
  var result = {};

  styles.forEach(function (style) {
    if (!style || (typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object') {
      return;
    }

    if (Array.isArray(style)) {
      style = mergeStyles(style);
    }

    Object.keys(style).forEach(function (key) {
      // Simple case, nothing nested
      if (!isNestedStyle(style[key]) || !isNestedStyle(result[key])) {
        result[key] = style[key];
        return;
      }

      // If nested media, don't merge the nested styles, append a space to the
      // end (benign when converted to CSS). This way we don't end up merging
      // media queries that appear later in the chain with those that appear
      // earlier.
      if (key.indexOf('@media') === 0) {
        var newKey = key;
        while (true) {
          // eslint-disable-line no-constant-condition
          newKey += ' ';
          if (!result[newKey]) {
            result[newKey] = style[key];
            return;
          }
        }
      }

      // Merge all other nested styles recursively
      result[key] = mergeStyles([result[key], style[key]]);
    });
  });

  return result;
}

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _checkProps = function checkProps() {};

if (false) {
  (function () {
    // Warn if you use longhand and shorthand properties in the same style
    // object.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties

    var shorthandPropertyExpansions = {
      'background': ['backgroundAttachment', 'backgroundBlendMode', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPosition', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundRepeatX', 'backgroundRepeatY', 'backgroundSize'],
      'border': ['borderBottom', 'borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderColor', 'borderLeft', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRight', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderStyle', 'borderTop', 'borderTopColor', 'borderTopStyle', 'borderTopWidth', 'borderWidth'],
      'borderImage': ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
      'borderRadius': ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
      'font': ['fontFamily', 'fontKerning', 'fontSize', 'fontStretch', 'fontStyle', 'fontVariant', 'fontVariantLigatures', 'fontWeight', 'lineHeight'],
      'listStyle': ['listStyleImage', 'listStylePosition', 'listStyleType'],
      'margin': ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
      'padding': ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
      'transition': ['transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction']
    };

    _checkProps = function checkProps(config) {
      var componentName = config.componentName;
      var style = config.style;

      if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object' || !style) {
        return;
      }

      var styleKeys = Object.keys(style);
      styleKeys.forEach(function (styleKey) {
        if (Array.isArray(shorthandPropertyExpansions[styleKey]) && shorthandPropertyExpansions[styleKey].some(function (sp) {
          return styleKeys.indexOf(sp) !== -1;
        })) {
          if (process.env.NODE_ENV !== 'production') {
            /* eslint-disable no-console */
            console.warn('Radium: property "' + styleKey + '" in style object', style, ': do not mix longhand and ' + 'shorthand properties in the same style object. Check the render ' + 'method of ' + componentName + '.', 'See https://github.com/FormidableLabs/radium/issues/95 for more ' + 'information.');
            /* eslint-enable no-console */
          }
        }
      });

      styleKeys.forEach(function (k) {
        return _checkProps(_extends({}, config, { style: style[k] }));
      });
      return;
    };
  })();
}

exports.default = _checkProps;
module.exports = exports['default'];

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = keyframesPlugin;
function keyframesPlugin(_ref // eslint-disable-line no-shadow
) {
  var addCSS = _ref.addCSS;
  var config = _ref.config;
  var style = _ref.style;

  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
    var value = style[key];
    if (key === 'animationName' && value && value.__radiumKeyframes) {
      var keyframesValue = value;

      var _keyframesValue$__pro = keyframesValue.__process(config.userAgent);

      var animationName = _keyframesValue$__pro.animationName;
      var css = _keyframesValue$__pro.css;

      addCSS(css);
      value = animationName;
    }

    newStyleInProgress[key] = value;
    return newStyleInProgress;
  }, {});
  return { style: newStyle };
}
module.exports = exports['default'];

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


// Convenient syntax for multiple styles: `style={[style1, style2, etc]}`
// Ignores non-objects, so you can do `this.state.isCool && styles.cool`.
var mergeStyleArrayPlugin = function mergeStyleArrayPlugin(_ref) {
  var style = _ref.style;
  var mergeStyles = _ref.mergeStyles;
  // eslint-disable-line no-shadow
  var newStyle = Array.isArray(style) ? mergeStyles(style) : style;
  return { style: newStyle };
};

exports.default = mergeStyleArrayPlugin;
module.exports = exports['default'];

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var _callbacks = [];
var _mouseUpListenerIsActive = false;

function _handleMouseUp() {
  _callbacks.forEach(function (callback) {
    callback();
  });
}

var subscribe = function subscribe(callback) {
  if (_callbacks.indexOf(callback) === -1) {
    _callbacks.push(callback);
  }

  if (!_mouseUpListenerIsActive) {
    window.addEventListener('mouseup', _handleMouseUp);
    _mouseUpListenerIsActive = true;
  }

  return {
    remove: function remove() {
      var index = _callbacks.indexOf(callback);
      _callbacks.splice(index, 1);

      if (_callbacks.length === 0 && _mouseUpListenerIsActive) {
        window.removeEventListener('mouseup', _handleMouseUp);
        _mouseUpListenerIsActive = false;
      }
    }
  };
};

exports.default = {
  subscribe: subscribe,
  __triggerForTests: _handleMouseUp
};
module.exports = exports['default'];

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixPlugin;

var _prefixer = __webpack_require__(172);

function prefixPlugin(_ref // eslint-disable-line no-shadow
) {
  var config = _ref.config;
  var style = _ref.style;

  var newStyle = (0, _prefixer.getPrefixedStyle)(style, config.userAgent);
  return { style: newStyle };
}
module.exports = exports['default'];

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeNestedStyles;
function removeNestedStyles(_ref) {
  var isNestedStyle = _ref.isNestedStyle;
  var style = _ref.style;
  // eslint-disable-line no-shadow
  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
    var value = style[key];
    if (!isNestedStyle(value)) {
      newStyleInProgress[key] = value;
    }
    return newStyleInProgress;
  }, {});

  return {
    style: newStyle
  };
}
module.exports = exports['default'];

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mouseUpListener = __webpack_require__(729);

var _mouseUpListener2 = _interopRequireDefault(_mouseUpListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _isInteractiveStyleField = function _isInteractiveStyleField(styleFieldName) {
  return styleFieldName === ':hover' || styleFieldName === ':active' || styleFieldName === ':focus';
};

var resolveInteractionStyles = function resolveInteractionStyles(config) {
  var ExecutionEnvironment = config.ExecutionEnvironment;
  var getComponentField = config.getComponentField;
  var getState = config.getState;
  var mergeStyles = config.mergeStyles;
  var props = config.props;
  var setState = config.setState;
  var style = config.style;


  var newComponentFields = {};
  var newProps = {};

  // Only add handlers if necessary
  if (style[':hover']) {
    (function () {
      // Always call the existing handler if one is already defined.
      // This code, and the very similar ones below, could be abstracted a bit
      // more, but it hurts readability IMO.
      var existingOnMouseEnter = props.onMouseEnter;
      newProps.onMouseEnter = function (e) {
        existingOnMouseEnter && existingOnMouseEnter(e);
        setState(':hover', true);
      };

      var existingOnMouseLeave = props.onMouseLeave;
      newProps.onMouseLeave = function (e) {
        existingOnMouseLeave && existingOnMouseLeave(e);
        setState(':hover', false);
      };
    })();
  }

  if (style[':active']) {
    (function () {
      var existingOnMouseDown = props.onMouseDown;
      newProps.onMouseDown = function (e) {
        existingOnMouseDown && existingOnMouseDown(e);
        newComponentFields._lastMouseDown = Date.now();
        setState(':active', 'viamousedown');
      };

      var existingOnKeyDown = props.onKeyDown;
      newProps.onKeyDown = function (e) {
        existingOnKeyDown && existingOnKeyDown(e);
        if (e.key === ' ' || e.key === 'Enter') {
          setState(':active', 'viakeydown');
        }
      };

      var existingOnKeyUp = props.onKeyUp;
      newProps.onKeyUp = function (e) {
        existingOnKeyUp && existingOnKeyUp(e);
        if (e.key === ' ' || e.key === 'Enter') {
          setState(':active', false);
        }
      };
    })();
  }

  if (style[':focus']) {
    (function () {
      var existingOnFocus = props.onFocus;
      newProps.onFocus = function (e) {
        existingOnFocus && existingOnFocus(e);
        setState(':focus', true);
      };

      var existingOnBlur = props.onBlur;
      newProps.onBlur = function (e) {
        existingOnBlur && existingOnBlur(e);
        setState(':focus', false);
      };
    })();
  }

  if (style[':active'] && !getComponentField('_radiumMouseUpListener') && ExecutionEnvironment.canUseEventListeners) {
    newComponentFields._radiumMouseUpListener = _mouseUpListener2.default.subscribe(function () {
      Object.keys(getComponentField('state')._radiumStyleState).forEach(function (key) {
        if (getState(':active', key) === 'viamousedown') {
          setState(':active', false, key);
        }
      });
    });
  }

  // Merge the styles in the order they were defined
  var interactionStyles = props.disabled ? [style[':disabled']] : Object.keys(style).filter(function (name) {
    return _isInteractiveStyleField(name) && getState(name);
  }).map(function (name) {
    return style[name];
  });

  var newStyle = mergeStyles([style].concat(interactionStyles));

  // Remove interactive styles
  newStyle = Object.keys(newStyle).reduce(function (styleWithoutInteractions, name) {
    if (!_isInteractiveStyleField(name) && name !== ':disabled') {
      styleWithoutInteractions[name] = newStyle[name];
    }
    return styleWithoutInteractions;
  }, {});

  return {
    componentFields: newComponentFields,
    props: newProps,
    style: newStyle
  };
};

exports.default = resolveInteractionStyles;
module.exports = exports['default'];

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = resolveMediaQueries;


var _windowMatchMedia = void 0;
function _getWindowMatchMedia(ExecutionEnvironment) {
  if (_windowMatchMedia === undefined) {
    _windowMatchMedia = !!ExecutionEnvironment.canUseDOM && !!window && !!window.matchMedia && function (mediaQueryString) {
      return window.matchMedia(mediaQueryString);
    } || null;
  }
  return _windowMatchMedia;
}

function _filterObject(obj, predicate) {
  return Object.keys(obj).filter(function (key) {
    return predicate(obj[key], key);
  }).reduce(function (result, key) {
    result[key] = obj[key];
    return result;
  }, {});
}

function _removeMediaQueries(style) {
  return Object.keys(style).reduce(function (styleWithoutMedia, key) {
    if (key.indexOf('@media') !== 0) {
      styleWithoutMedia[key] = style[key];
    }
    return styleWithoutMedia;
  }, {});
}

function _topLevelRulesToCSS(_ref) {
  var addCSS = _ref.addCSS;
  var appendImportantToEachValue = _ref.appendImportantToEachValue;
  var cssRuleSetToString = _ref.cssRuleSetToString;
  var hash = _ref.hash;
  var isNestedStyle = _ref.isNestedStyle;
  var style = _ref.style;
  var userAgent = _ref.userAgent;

  var className = '';
  Object.keys(style).filter(function (name) {
    return name.indexOf('@media') === 0;
  }).map(function (query) {
    var topLevelRules = appendImportantToEachValue(_filterObject(style[query], function (value) {
      return !isNestedStyle(value);
    }));

    if (!Object.keys(topLevelRules).length) {
      return;
    }

    var ruleCSS = cssRuleSetToString('', topLevelRules, userAgent);

    // CSS classes cannot start with a number
    var mediaQueryClassName = 'rmq-' + hash(query + ruleCSS);
    var css = query + '{ .' + mediaQueryClassName + ruleCSS + '}';

    addCSS(css);

    className += (className ? ' ' : '') + mediaQueryClassName;
  });
  return className;
}

function _subscribeToMediaQuery(_ref2) {
  var listener = _ref2.listener;
  var listenersByQuery = _ref2.listenersByQuery;
  var matchMedia = _ref2.matchMedia;
  var mediaQueryListsByQuery = _ref2.mediaQueryListsByQuery;
  var query = _ref2.query;

  query = query.replace('@media ', '');

  var mql = mediaQueryListsByQuery[query];
  if (!mql && matchMedia) {
    mediaQueryListsByQuery[query] = mql = matchMedia(query);
  }

  if (!listenersByQuery || !listenersByQuery[query]) {
    mql.addListener(listener);

    listenersByQuery[query] = {
      remove: function remove() {
        mql.removeListener(listener);
      }
    };
  }
  return mql;
}

function resolveMediaQueries(_ref3) {
  var ExecutionEnvironment = _ref3.ExecutionEnvironment;
  var addCSS = _ref3.addCSS;
  var appendImportantToEachValue = _ref3.appendImportantToEachValue;
  var config = _ref3.config;
  var cssRuleSetToString = _ref3.cssRuleSetToString;
  var getComponentField = _ref3.getComponentField;
  var getGlobalState = _ref3.getGlobalState;
  var hash = _ref3.hash;
  var isNestedStyle = _ref3.isNestedStyle;
  var mergeStyles = _ref3.mergeStyles;
  var props = _ref3.props;
  var setState = _ref3.setState;
  var style = _ref3.style;
  // eslint-disable-line no-shadow
  var newStyle = _removeMediaQueries(style);
  var mediaQueryClassNames = _topLevelRulesToCSS({
    addCSS: addCSS,
    appendImportantToEachValue: appendImportantToEachValue,
    cssRuleSetToString: cssRuleSetToString,
    hash: hash,
    isNestedStyle: isNestedStyle,
    style: style,
    userAgent: config.userAgent
  });

  var newProps = mediaQueryClassNames ? {
    className: mediaQueryClassNames + (props.className ? ' ' + props.className : '')
  } : null;

  var matchMedia = config.matchMedia || _getWindowMatchMedia(ExecutionEnvironment);

  if (!matchMedia) {
    return {
      props: newProps,
      style: newStyle
    };
  }

  var listenersByQuery = _extends({}, getComponentField('_radiumMediaQueryListenersByQuery'));
  var mediaQueryListsByQuery = getGlobalState('mediaQueryListsByQuery') || {};

  Object.keys(style).filter(function (name) {
    return name.indexOf('@media') === 0;
  }).map(function (query) {
    var nestedRules = _filterObject(style[query], isNestedStyle);

    if (!Object.keys(nestedRules).length) {
      return;
    }

    var mql = _subscribeToMediaQuery({
      listener: function listener() {
        return setState(query, mql.matches, '_all');
      },
      listenersByQuery: listenersByQuery,
      matchMedia: matchMedia,
      mediaQueryListsByQuery: mediaQueryListsByQuery,
      query: query
    });

    // Apply media query states
    if (mql.matches) {
      newStyle = mergeStyles([newStyle, nestedRules]);
    }
  });

  return {
    componentFields: {
      _radiumMediaQueryListenersByQuery: listenersByQuery
    },
    globalState: { mediaQueryListsByQuery: mediaQueryListsByQuery },
    props: newProps,
    style: newStyle
  };
}
module.exports = exports['default'];

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = visited;
function visited(_ref) {
  var addCSS = _ref.addCSS;
  var appendImportantToEachValue = _ref.appendImportantToEachValue;
  var config = _ref.config;
  var cssRuleSetToString = _ref.cssRuleSetToString;
  var hash = _ref.hash;
  var props = _ref.props;
  var style = _ref.style;
  // eslint-disable-line no-shadow
  var className = props.className;

  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
    var value = style[key];
    if (key === ':visited') {
      value = appendImportantToEachValue(value);
      var ruleCSS = cssRuleSetToString('', value, config.userAgent);
      var visitedClassName = 'rad-' + hash(ruleCSS);
      var css = '.' + visitedClassName + ':visited' + ruleCSS;

      addCSS(css);
      className = (className ? className + ' ' : '') + visitedClassName;
    } else {
      newStyleInProgress[key] = value;
    }

    return newStyleInProgress;
  }, {});

  return {
    props: className === props.className ? null : { className: className },
    style: newStyle
  };
}
module.exports = exports['default'];

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports = "(function(n){function i(a,d){this.setNotifyMethod(a);this.setNotifyContext(d)}function j(a,d,b){this.name=a;this.body=d;this.type=b}function k(){}function m(){}function l(){this.subCommands=[];this.initializeMacroCommand()}function g(a,d){this.mediatorName=a||this.constructor.NAME;this.viewComponent=d}function h(a,d){this.proxyName=a||this.constructor.NAME;null!=d&&this.setData(d)}function b(a){if(null!=b.instanceMap[a])throw Error(b.MULTITON_MSG);this.initializeNotifier(a);b.instanceMap[a]=this;\nthis.initializeFacade()}function c(a){if(null!=c.instanceMap[a])throw Error(c.MULTITON_MSG);this.multitonKey=a;c.instanceMap[this.multitonKey]=this;this.mediatorMap=[];this.observerMap=[];this.initializeView()}function e(a){if(e.instanceMap[a])throw Error(e.MULTITON_MSG);this.multitonKey=a;e.instanceMap[a]=this;this.proxyMap=[];this.initializeModel()}function f(a){if(null!=f.instanceMap[a])throw Error(f.MULTITON_MSG);this.multitonKey=a;f.instanceMap[this.multitonKey]=this;this.commandMap=[];this.initializeController()}\nfunction p(a,d,b){for(var a=a.split(\".\"),b=b||o.global,c,e,f=0,g=a.length;f<g;f++)c=b,e=a[f],b=null==b[e]?b[e]={}:b[e];return null==d?b:c[e]=d}null==n&&(n=window);if(!n.puremvc){i.prototype.setNotifyMethod=function(a){this.notify=a};i.prototype.setNotifyContext=function(a){this.context=a};i.prototype.getNotifyMethod=function(){return this.notify};i.prototype.getNotifyContext=function(){return this.context};i.prototype.notifyObserver=function(a){this.getNotifyMethod().call(this.getNotifyContext(),\na)};i.prototype.compareNotifyContext=function(a){return a===this.context};i.prototype.notify=null;i.prototype.context=null;j.prototype.getName=function(){return this.name};j.prototype.setBody=function(a){this.body=a};j.prototype.getBody=function(){return this.body};j.prototype.setType=function(a){this.type=a};j.prototype.getType=function(){return this.type};j.prototype.toString=function(){var a=\"Notification Name: \"+this.getName(),a=a+(\"\\nBody:\"+(null==this.body?\"null\":this.body.toString()));return a+=\n\"\\nType:\"+(null==this.type?\"null\":this.type)};j.prototype.name=null;j.prototype.type=null;j.prototype.body=null;k.prototype.sendNotification=function(a,d,b){var c=this.getFacade();c&&c.sendNotification(a,d,b)};k.prototype.initializeNotifier=function(a){this.multitonKey=\"\"+a;this.facade=this.getFacade()};k.prototype.getFacade=function(){if(null==this.multitonKey)throw Error(k.MULTITON_MSG);return b.getInstance(this.multitonKey)};k.prototype.multitonKey=null;k.MULTITON_MSG=\"multitonKey for this Notifier not yet initialized!\";\nm.prototype=new k;m.prototype.constructor=m;m.prototype.execute=function(){};l.prototype=new k;l.prototype.constructor=l;l.prototype.subCommands=null;l.prototype.initializeMacroCommand=function(){};l.prototype.addSubCommand=function(a){this.subCommands.push(a)};l.prototype.execute=function(a){for(;0<this.subCommands.length;){var d=new (this.subCommands.shift());d.initializeNotifier(this.multitonKey);d.execute(a)}};g.NAME=\"Mediator\";g.prototype=new k;g.prototype.constructor=g;g.prototype.getMediatorName=\nfunction(){return this.mediatorName};g.prototype.setViewComponent=function(a){this.viewComponent=a};g.prototype.getViewComponent=function(){return this.viewComponent};g.prototype.listNotificationInterests=function(){return[]};g.prototype.handleNotification=function(){};g.prototype.onRegister=function(){};g.prototype.onRemove=function(){};g.prototype.mediatorName=null;g.prototype.viewComponent=null;h.NAME=\"Proxy\";h.prototype=new k;h.prototype.constructor=h;h.prototype.getProxyName=function(){return this.proxyName};\nh.prototype.setData=function(a){this.data=a};h.prototype.getData=function(){return this.data};h.prototype.onRegister=function(){};h.prototype.onRemove=function(){};h.prototype.proxyName=null;h.prototype.data=null;b.prototype.initializeFacade=function(){this.initializeModel();this.initializeController();this.initializeView()};b.getInstance=function(a){if(null==a)return null;null==b.instanceMap[a]&&(b.instanceMap[a]=new b(a));return b.instanceMap[a]};b.prototype.initializeController=function(){if(null==\nthis.controller)this.controller=f.getInstance(this.multitonKey)};b.prototype.initializeModel=function(){if(null==this.model)this.model=e.getInstance(this.multitonKey)};b.prototype.initializeView=function(){if(null==this.view)this.view=c.getInstance(this.multitonKey)};b.prototype.registerCommand=function(a,d){this.controller.registerCommand(a,d)};b.prototype.removeCommand=function(a){this.controller.removeCommand(a)};b.prototype.hasCommand=function(a){return this.controller.hasCommand(a)};b.prototype.registerProxy=\nfunction(a){this.model.registerProxy(a)};b.prototype.retrieveProxy=function(a){return this.model.retrieveProxy(a)};b.prototype.removeProxy=function(a){var d=null;null!=this.model&&(d=this.model.removeProxy(a));return d};b.prototype.hasProxy=function(a){return this.model.hasProxy(a)};b.prototype.registerMediator=function(a){null!=this.view&&this.view.registerMediator(a)};b.prototype.retrieveMediator=function(a){return this.view.retrieveMediator(a)};b.prototype.removeMediator=function(a){var d=null;\nnull!=this.view&&(d=this.view.removeMediator(a));return d};b.prototype.hasMediator=function(a){return this.view.hasMediator(a)};b.prototype.sendNotification=function(a,d,b){this.notifyObservers(new j(a,d,b))};b.prototype.notifyObservers=function(a){null!=this.view&&this.view.notifyObservers(a)};b.prototype.initializeNotifier=function(a){this.multitonKey=a};b.hasCore=function(a){return null!=b.instanceMap[a]};b.removeCore=function(a){null!=b.instanceMap[a]&&(e.removeModel(a),c.removeView(a),f.removeController(a),\ndelete b.instanceMap[a])};b.prototype.controller=null;b.prototype.model=null;b.prototype.view=null;b.prototype.multitonKey=null;b.instanceMap=[];b.MULTITON_MSG=\"Facade instance for this Multiton key already constructed!\";c.prototype.initializeView=function(){};c.getInstance=function(a){if(null==a)return null;null==c.instanceMap[a]&&(c.instanceMap[a]=new c(a));return c.instanceMap[a]};c.prototype.registerObserver=function(a,d){null!=this.observerMap[a]?this.observerMap[a].push(d):this.observerMap[a]=\n[d]};c.prototype.notifyObservers=function(a){if(null!=this.observerMap[a.getName()]){for(var d=this.observerMap[a.getName()],b=[],c,e=0;e<d.length;e++)c=d[e],b.push(c);for(e=0;e<b.length;e++)c=b[e],c.notifyObserver(a)}};c.prototype.removeObserver=function(a,d){for(var b=this.observerMap[a],c=0;c<b.length;c++)if(!0==b[c].compareNotifyContext(d)){b.splice(c,1);break}0==b.length&&delete this.observerMap[a]};c.prototype.registerMediator=function(a){if(null==this.mediatorMap[a.getMediatorName()]){a.initializeNotifier(this.multitonKey);\nthis.mediatorMap[a.getMediatorName()]=a;var d=a.listNotificationInterests();if(0<d.length)for(var b=new i(a.handleNotification,a),c=0;c<d.length;c++)this.registerObserver(d[c],b);a.onRegister()}};c.prototype.retrieveMediator=function(a){return this.mediatorMap[a]};c.prototype.removeMediator=function(a){var d=this.mediatorMap[a];if(d){for(var b=d.listNotificationInterests(),c=0;c<b.length;c++)this.removeObserver(b[c],d);delete this.mediatorMap[a];d.onRemove()}return d};c.prototype.hasMediator=function(a){return null!=\nthis.mediatorMap[a]};c.removeView=function(a){delete c.instanceMap[a]};c.prototype.mediatorMap=null;c.prototype.observerMap=null;c.instanceMap=[];c.prototype.multitonKey=null;c.MULTITON_MSG=\"View instance for this Multiton key already constructed!\";e.prototype.initializeModel=function(){};e.getInstance=function(a){if(null==a)return null;null==e.instanceMap[a]&&(e.instanceMap[a]=new e(a));return e.instanceMap[a]};e.prototype.registerProxy=function(a){a.initializeNotifier(this.multitonKey);this.proxyMap[a.getProxyName()]=\na;a.onRegister()};e.prototype.retrieveProxy=function(a){return this.proxyMap[a]};e.prototype.hasProxy=function(a){return null!=this.proxyMap[a]};e.prototype.removeProxy=function(a){var b=this.proxyMap[a];b&&(this.proxyMap[a]=null,b.onRemove());return b};e.removeModel=function(a){delete e.instanceMap[a]};e.prototype.proxyMap=null;e.instanceMap=[];e.MULTITON_MSG=\"Model instance for this Multiton key already constructed!\";f.prototype.initializeController=function(){this.view=c.getInstance(this.multitonKey)};\nf.getInstance=function(a){if(null==a)return null;null==this.instanceMap[a]&&(this.instanceMap[a]=new this(a));return this.instanceMap[a]};f.prototype.executeCommand=function(a){var b=this.commandMap[a.getName()];null!=b&&(b=new b,b.initializeNotifier(this.multitonKey),b.execute(a))};f.prototype.registerCommand=function(a,b){null==this.commandMap[a]&&this.view.registerObserver(a,new i(this.executeCommand,this));this.commandMap[a]=b};f.prototype.hasCommand=function(a){return null!=this.commandMap[a]};\nf.prototype.removeCommand=function(a){this.hasCommand(a)&&(this.view.removeObserver(a,this),this.commandMap[a]=null)};f.removeController=function(a){delete this.instanceMap[a]};f.prototype.view=null;f.prototype.commandMap=null;f.prototype.multitonKey=null;f.instanceMap=[];f.MULTITON_MSG=\"controller key for this Multiton key already constructed\";var o={global:function(){return this}(),extend:function(a,b){if(\"function\"!==typeof a)throw new TypeError(\"#extend- child should be Function\");if(\"function\"!==\ntypeof b)throw new TypeError(\"#extend- parent should be Function\");if(b!==a){var c=new Function;c.prototype=b.prototype;a.prototype=new c;return a.prototype.constructor=a}},decorate:function(a,b){for(var c in b)a[c]=b[c];return a}};n.puremvc={View:c,Model:e,Controller:f,SimpleCommand:m,MacroCommand:l,Facade:b,Mediator:g,Observer:i,Notification:j,Notifier:k,Proxy:h,define:function(a,b,c){a||(a={});var e=a.name,f=a.parent,g=\"function\"===typeof f,h=a.scope||null;if(\"parent\"in a&&!g)throw new TypeError(\"Class parent must be Function\");\nif(a.hasOwnProperty(\"constructor\")){if(a=a.constructor,\"function\"!==typeof a)throw new TypeError(\"Class constructor must be Function\");}else a=g?function(){f.apply(this,arguments)}:new Function;g&&o.extend(a,f);if(b)g=a.prototype,o.decorate(g,b),g.constructor=a;c&&o.decorate(a,c);if(e){if(\"string\"!==typeof e)throw new TypeError(\"Class name must be primitive string\");p(e,a,h)}return a},declare:p}}})(this);\ntry{var ce=new window.CustomEvent(\"test\");ce.preventDefault();if(!0!==ce.defaultPrevented)throw Error(\"Could not prevent default\");}catch(e){var CustomEvent=function(d,a){var b,c;a=a||{bubbles:!1,cancelable:!1,detail:void 0};b=document.createEvent(\"CustomEvent\");b.initCustomEvent(d,a.bubbles,a.cancelable,a.detail);c=b.preventDefault;b.preventDefault=function(){c.call(this);try{Object.defineProperty(this,\"defaultPrevented\",{get:function(){return!0}})}catch(f){this.defaultPrevented=!0}};return b};CustomEvent.prototype=\nwindow.Event.prototype;window.CustomEvent=CustomEvent};\n!function(e){var r=e.babelHelpers={};r.typeof=\"function\"==typeof Symbol&&\"symbol\"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&\"function\"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?\"symbol\":typeof e},r.jsx=function(){var e=\"function\"==typeof Symbol&&Symbol.for&&Symbol.for(\"react.element\")||60103;return function(r,t,n,o){var i=r&&r.defaultProps,u=arguments.length-3;if(t||0===u||(t={}),t&&i)for(var a in i)void 0===t[a]&&(t[a]=i[a]);else t||(t=i||{});if(1===u)t.children=o;else if(u>1){for(var f=Array(u),l=0;l<u;l++)f[l]=arguments[l+3];t.children=f}return{$$typeof:e,type:r,key:void 0===n?null:\"\"+n,ref:null,props:t,_owner:null}}}(),r.asyncIterator=function(e){if(\"function\"==typeof Symbol){if(Symbol.asyncIterator){var r=e[Symbol.asyncIterator];if(null!=r)return r.call(e)}if(Symbol.iterator)return e[Symbol.iterator]()}throw new TypeError(\"Object is not async iterable\")},r.asyncGenerator=function(){function e(e){this.value=e}function r(r){function t(e,r){return new Promise(function(t,o){var a={key:e,arg:r,resolve:t,reject:o,next:null};u?u=u.next=a:(i=u=a,n(e,r))})}function n(t,i){try{var u=r[t](i),a=u.value;a instanceof e?Promise.resolve(a.value).then(function(e){n(\"next\",e)},function(e){n(\"throw\",e)}):o(u.done?\"return\":\"normal\",u.value)}catch(e){o(\"throw\",e)}}function o(e,r){switch(e){case\"return\":i.resolve({value:r,done:!0});break;case\"throw\":i.reject(r);break;default:i.resolve({value:r,done:!1})}i=i.next,i?n(i.key,i.arg):u=null}var i,u;this._invoke=t,\"function\"!=typeof r.return&&(this.return=void 0)}return\"function\"==typeof Symbol&&Symbol.asyncIterator&&(r.prototype[Symbol.asyncIterator]=function(){return this}),r.prototype.next=function(e){return this._invoke(\"next\",e)},r.prototype.throw=function(e){return this._invoke(\"throw\",e)},r.prototype.return=function(e){return this._invoke(\"return\",e)},{wrap:function(e){return function(){return new r(e.apply(this,arguments))}},await:function(r){return new e(r)}}}(),r.asyncGeneratorDelegate=function(e,r){function t(t,n){return o=!0,n=new Promise(function(r){r(e[t](n))}),{done:!1,value:r(n)}}var n={},o=!1;return\"function\"==typeof Symbol&&Symbol.iterator&&(n[Symbol.iterator]=function(){return this}),n.next=function(e){return o?(o=!1,e):t(\"next\",e)},\"function\"==typeof e.throw&&(n.throw=function(e){if(o)throw o=!1,e;return t(\"throw\",e)}),\"function\"==typeof e.return&&(n.return=function(e){return t(\"return\",e)}),n},r.asyncToGenerator=function(e){return function(){var r=e.apply(this,arguments);return new Promise(function(e,t){function n(o,i){try{var u=r[o](i),a=u.value}catch(e){return void t(e)}return u.done?void e(a):Promise.resolve(a).then(function(e){n(\"next\",e)},function(e){n(\"throw\",e)})}return n(\"next\")})}},r.classCallCheck=function(e,r){if(!(e instanceof r))throw new TypeError(\"Cannot call a class as a function\")},r.createClass=function(){function e(e,r){for(var t=0;t<r.length;t++){var n=r[t];n.enumerable=n.enumerable||!1,n.configurable=!0,\"value\"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(r,t,n){return t&&e(r.prototype,t),n&&e(r,n),r}}(),r.defineEnumerableProperties=function(e,r){for(var t in r){var n=r[t];n.configurable=n.enumerable=!0,\"value\"in n&&(n.writable=!0),Object.defineProperty(e,t,n)}return e},r.defaults=function(e,r){for(var t=Object.getOwnPropertyNames(r),n=0;n<t.length;n++){var o=t[n],i=Object.getOwnPropertyDescriptor(r,o);i&&i.configurable&&void 0===e[o]&&Object.defineProperty(e,o,i)}return e},r.defineProperty=function(e,r,t){return r in e?Object.defineProperty(e,r,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[r]=t,e},r.extends=Object.assign||function(e){for(var r=1;r<arguments.length;r++){var t=arguments[r];for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])}return e},r.get=function e(r,t,n){null===r&&(r=Function.prototype);var o=Object.getOwnPropertyDescriptor(r,t);if(void 0===o){var i=Object.getPrototypeOf(r);return null===i?void 0:e(i,t,n)}if(\"value\"in o)return o.value;var u=o.get;if(void 0!==u)return u.call(n)},r.inherits=function(e,r){if(\"function\"!=typeof r&&null!==r)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof r);e.prototype=Object.create(r&&r.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),r&&(Object.setPrototypeOf?Object.setPrototypeOf(e,r):e.__proto__=r)},r.instanceof=function(e,r){return null!=r&&\"undefined\"!=typeof Symbol&&r[Symbol.hasInstance]?r[Symbol.hasInstance](e):e instanceof r},r.interopRequireDefault=function(e){return e&&e.__esModule?e:{default:e}},r.interopRequireWildcard=function(e){if(e&&e.__esModule)return e;var r={};if(null!=e)for(var t in e)Object.prototype.hasOwnProperty.call(e,t)&&(r[t]=e[t]);return r.default=e,r},r.newArrowCheck=function(e,r){if(e!==r)throw new TypeError(\"Cannot instantiate an arrow function\")},r.objectDestructuringEmpty=function(e){if(null==e)throw new TypeError(\"Cannot destructure undefined\")},r.objectWithoutProperties=function(e,r){var t={};for(var n in e)r.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t},r.possibleConstructorReturn=function(e,r){if(!e)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!r||\"object\"!=typeof r&&\"function\"!=typeof r?e:r},r.selfGlobal=\"undefined\"==typeof e?self:e,r.set=function e(r,t,n,o){var i=Object.getOwnPropertyDescriptor(r,t);if(void 0===i){var u=Object.getPrototypeOf(r);null!==u&&e(u,t,n,o)}else if(\"value\"in i&&i.writable)i.value=n;else{var a=i.set;void 0!==a&&a.call(o,n)}return n},r.slicedToArray=function(){function e(e,r){var t=[],n=!0,o=!1,i=void 0;try{for(var u,a=e[Symbol.iterator]();!(n=(u=a.next()).done)&&(t.push(u.value),!r||t.length!==r);n=!0);}catch(e){o=!0,i=e}finally{try{!n&&a.return&&a.return()}finally{if(o)throw i}}return t}return function(r,t){if(Array.isArray(r))return r;if(Symbol.iterator in Object(r))return e(r,t);throw new TypeError(\"Invalid attempt to destructure non-iterable instance\")}}(),r.slicedToArrayLoose=function(e,r){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e)){for(var t,n=[],o=e[Symbol.iterator]();!(t=o.next()).done&&(n.push(t.value),!r||n.length!==r););return n}throw new TypeError(\"Invalid attempt to destructure non-iterable instance\")},r.taggedTemplateLiteral=function(e,r){return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(r)}}))},r.taggedTemplateLiteralLoose=function(e,r){return e.raw=r,e},r.temporalRef=function(e,r,t){if(e===t)throw new ReferenceError(r+\" is not defined - temporal dead zone\");return e},r.temporalUndefined={},r.toArray=function(e){return Array.isArray(e)?e:Array.from(e)},r.toConsumableArray=function(e){if(Array.isArray(e)){for(var r=0,t=Array(e.length);r<e.length;r++)t[r]=e[r];return t}return Array.from(e)}}(\"undefined\"==typeof global?self:global);\n/*! DOMTokenlist shim | Copyright 2016 Jonathan Wilsson and Bogdan Chadkin. */\n\"undefined\"!=typeof window&&function(e){\"use strict\";if(e.DOMTokenList){var t=document.createElement(\"a\").classList,n=DOMTokenList.prototype,i=n.add,o=n.remove,r=n.toggle;t.add(\"c1\",\"c2\");var s=function(e){return function(){var t,n=arguments;for(t=0;t<n.length;t+=1)e.call(this,n[t])}};t.contains(\"c2\")||(n.add=s(i),n.remove=s(o)),t.toggle(\"c1\",!0)||(n.toggle=function(e,t){return void 0===t?r.call(this,e):((t?i:o).call(this,e),!!t)})}}(window),\"undefined\"!=typeof window&&function(e){\"use strict\";var t=[],n=function(e,n){var i;if(t.indexOf)return t.indexOf.call(e,n);for(i=0;i<e.length;i++)if(e[i]===n)return i;return-1},i=function(e){var t=/[\\u0009\\u000A\\u000C\\u000D\\u0020]/;if(\"\"===e||t.test(e))throw new Error(\"Token must not be empty or contain whitespace.\")},o=function(e,t){var n,i=this,o=[];if(e&&t&&(i.element=e,i.prop=t,e[t]))for(o=e[t].replace(/^\\s+|\\s+$/g,\"\").split(/\\s+/),n=0;n<o.length;n++)i[n]=o[n];i.length=o.length};o.prototype={add:function(){var e,n=this,o=arguments;for(e=0;e<o.length;e++)i(o[e]),n.contains(o[e])||t.push.call(n,o[e]);n.element&&(n.element[n.prop]=n)},contains:function(e){return i(e),-1!==n(this,e)},item:function(e){return this[e]||null},remove:function(){var e,o,r=arguments,s=this;for(o=0;o<r.length;o++)i(r[o]),e=n(s,r[o]),-1!==e&&t.splice.call(s,e,1);s.element&&(s.element[s.prop]=s)},toggle:function(e,t){var n=this;return n.contains(e)?t?!0:(n.remove(e),!1):t===!1?!1:(n.add(e),!0)},toString:function(){return t.join.call(this,\" \")}},e.DOMTokenList=o}(window),\"undefined\"!=typeof window&&function(){\"use strict\";\"classList\"in document.createElement(\"a\")||Object.defineProperty(Element.prototype,\"classList\",{get:function(){return new DOMTokenList(this,\"className\")}})}(),\"undefined\"!=typeof window&&function(){\"use strict\";if(!(\"relList\"in document.createElement(\"a\"))){var e,t=[HTMLAnchorElement,HTMLAreaElement,HTMLLinkElement],n=function(){return new DOMTokenList(this,\"rel\")};for(e=0;e<t.length;e++)Object.defineProperty(t[e].prototype,\"relList\",{get:n})}}(),\"undefined\"!=typeof window&&function(){\"use strict\";if(\"undefined\"!=typeof SVGElement){var e=document.createElementNS(\"http://www.w3.org/2000/svg\",\"svg\");\"classList\"in e&&!window.QUnit||Object.defineProperty(SVGElement.prototype,\"classList\",{get:function(){return\"string\"==typeof this.className?new DOMTokenList(this,\"className\"):\"string\"==typeof this.className.baseVal?new DOMTokenList(this.className,\"baseVal\"):void 0}})}}();\n\n\"function\"!=typeof Object.assign&&(Object.assign=function(c){if(null==c)throw new TypeError(\"Cannot convert undefined or null to object\");c=Object(c);for(var e=1;e<arguments.length;e++){var b=arguments[e];if(null!=b)for(var d in b)Object.prototype.hasOwnProperty.call(b,d)&&(c[d]=b[d])}return c});\nArray.prototype.findIndex||Object.defineProperty(Array.prototype,\"findIndex\",{value:function(c,e){if(null==this)throw new TypeError('\"this\" is null or not defined');var b=Object(this),d=b.length>>>0;if(\"function\"!==typeof c)throw new TypeError(\"predicate must be a function\");for(var a=0;a<d;){if(c.call(e,b[a],a,b))return a;a++}return-1}});\nArray.prototype.includes||Object.defineProperty(Array.prototype,\"includes\",{value:function(c,e){if(null==this)throw new TypeError('\"this\" is null or not defined');var b=Object(this),d=b.length>>>0;if(0===d)return!1;var a=e|0;for(a=Math.max(0<=a?a:d-Math.abs(a),0);a<d;){var f=b[a],g=c;if(f===g||\"number\"===typeof f&&\"number\"===typeof g&&isNaN(f)&&isNaN(g))return!0;a++}return!1}});\n\n/*!\n * Bowser - a browser detector\n * https://github.com/ded/bowser\n * MIT License | (c) Dustin Diaz 2015\n */\n!function(e,t,n){typeof module!=\"undefined\"&&module.exports?module.exports=n():typeof define==\"function\"&&define.amd?define(t,n):e[t]=n()}(this,\"bowser\",function(){function t(t){function n(e){var n=t.match(e);return n&&n.length>1&&n[1]||\"\"}function r(e){var n=t.match(e);return n&&n.length>1&&n[2]||\"\"}function N(e){switch(e){case\"NT\":return\"NT\";case\"XP\":return\"XP\";case\"NT 5.0\":return\"2000\";case\"NT 5.1\":return\"XP\";case\"NT 5.2\":return\"2003\";case\"NT 6.0\":return\"Vista\";case\"NT 6.1\":return\"7\";case\"NT 6.2\":return\"8\";case\"NT 6.3\":return\"8.1\";case\"NT 10.0\":return\"10\";default:return undefined}}var i=n(/(ipod|iphone|ipad)/i).toLowerCase(),s=/like android/i.test(t),o=!s&&/android/i.test(t),u=/nexus\\s*[0-6]\\s*/i.test(t),a=!u&&/nexus\\s*[0-9]+/i.test(t),f=/CrOS/.test(t),l=/silk/i.test(t),c=/sailfish/i.test(t),h=/tizen/i.test(t),p=/(web|hpw)os/i.test(t),d=/windows phone/i.test(t),v=/SamsungBrowser/i.test(t),m=!d&&/windows/i.test(t),g=!i&&!l&&/macintosh/i.test(t),y=!o&&!c&&!h&&!p&&/linux/i.test(t),b=r(/edg([ea]|ios)\\/(\\d+(\\.\\d+)?)/i),w=n(/version\\/(\\d+(\\.\\d+)?)/i),E=/tablet/i.test(t)&&!/tablet pc/i.test(t),S=!E&&/[^-]mobi/i.test(t),x=/xbox/i.test(t),T;/opera/i.test(t)?T={name:\"Opera\",opera:e,version:w||n(/(?:opera|opr|opios)[\\s\\/](\\d+(\\.\\d+)?)/i)}:/opr\\/|opios/i.test(t)?T={name:\"Opera\",opera:e,version:n(/(?:opr|opios)[\\s\\/](\\d+(\\.\\d+)?)/i)||w}:/SamsungBrowser/i.test(t)?T={name:\"Samsung Internet for Android\",samsungBrowser:e,version:w||n(/(?:SamsungBrowser)[\\s\\/](\\d+(\\.\\d+)?)/i)}:/coast/i.test(t)?T={name:\"Opera Coast\",coast:e,version:w||n(/(?:coast)[\\s\\/](\\d+(\\.\\d+)?)/i)}:/yabrowser/i.test(t)?T={name:\"Yandex Browser\",yandexbrowser:e,version:w||n(/(?:yabrowser)[\\s\\/](\\d+(\\.\\d+)?)/i)}:/ucbrowser/i.test(t)?T={name:\"UC Browser\",ucbrowser:e,version:n(/(?:ucbrowser)[\\s\\/](\\d+(?:\\.\\d+)+)/i)}:/mxios/i.test(t)?T={name:\"Maxthon\",maxthon:e,version:n(/(?:mxios)[\\s\\/](\\d+(?:\\.\\d+)+)/i)}:/epiphany/i.test(t)?T={name:\"Epiphany\",epiphany:e,version:n(/(?:epiphany)[\\s\\/](\\d+(?:\\.\\d+)+)/i)}:/puffin/i.test(t)?T={name:\"Puffin\",puffin:e,version:n(/(?:puffin)[\\s\\/](\\d+(?:\\.\\d+)?)/i)}:/sleipnir/i.test(t)?T={name:\"Sleipnir\",sleipnir:e,version:n(/(?:sleipnir)[\\s\\/](\\d+(?:\\.\\d+)+)/i)}:/k-meleon/i.test(t)?T={name:\"K-Meleon\",kMeleon:e,version:n(/(?:k-meleon)[\\s\\/](\\d+(?:\\.\\d+)+)/i)}:d?(T={name:\"Windows Phone\",osname:\"Windows Phone\",windowsphone:e},b?(T.msedge=e,T.version=b):(T.msie=e,T.version=n(/iemobile\\/(\\d+(\\.\\d+)?)/i))):/msie|trident/i.test(t)?T={name:\"Internet Explorer\",msie:e,version:n(/(?:msie |rv:)(\\d+(\\.\\d+)?)/i)}:f?T={name:\"Chrome\",osname:\"Chrome OS\",chromeos:e,chromeBook:e,chrome:e,version:n(/(?:chrome|crios|crmo)\\/(\\d+(\\.\\d+)?)/i)}:/edg([ea]|ios)/i.test(t)?T={name:\"Microsoft Edge\",msedge:e,version:b}:/vivaldi/i.test(t)?T={name:\"Vivaldi\",vivaldi:e,version:n(/vivaldi\\/(\\d+(\\.\\d+)?)/i)||w}:c?T={name:\"Sailfish\",osname:\"Sailfish OS\",sailfish:e,version:n(/sailfish\\s?browser\\/(\\d+(\\.\\d+)?)/i)}:/seamonkey\\//i.test(t)?T={name:\"SeaMonkey\",seamonkey:e,version:n(/seamonkey\\/(\\d+(\\.\\d+)?)/i)}:/firefox|iceweasel|fxios/i.test(t)?(T={name:\"Firefox\",firefox:e,version:n(/(?:firefox|iceweasel|fxios)[ \\/](\\d+(\\.\\d+)?)/i)},/\\((mobile|tablet);[^\\)]*rv:[\\d\\.]+\\)/i.test(t)&&(T.firefoxos=e,T.osname=\"Firefox OS\")):l?T={name:\"Amazon Silk\",silk:e,version:n(/silk\\/(\\d+(\\.\\d+)?)/i)}:/phantom/i.test(t)?T={name:\"PhantomJS\",phantom:e,version:n(/phantomjs\\/(\\d+(\\.\\d+)?)/i)}:/slimerjs/i.test(t)?T={name:\"SlimerJS\",slimer:e,version:n(/slimerjs\\/(\\d+(\\.\\d+)?)/i)}:/blackberry|\\bbb\\d+/i.test(t)||/rim\\stablet/i.test(t)?T={name:\"BlackBerry\",osname:\"BlackBerry OS\",blackberry:e,version:w||n(/blackberry[\\d]+\\/(\\d+(\\.\\d+)?)/i)}:p?(T={name:\"WebOS\",osname:\"WebOS\",webos:e,version:w||n(/w(?:eb)?osbrowser\\/(\\d+(\\.\\d+)?)/i)},/touchpad\\//i.test(t)&&(T.touchpad=e)):/bada/i.test(t)?T={name:\"Bada\",osname:\"Bada\",bada:e,version:n(/dolfin\\/(\\d+(\\.\\d+)?)/i)}:h?T={name:\"Tizen\",osname:\"Tizen\",tizen:e,version:n(/(?:tizen\\s?)?browser\\/(\\d+(\\.\\d+)?)/i)||w}:/qupzilla/i.test(t)?T={name:\"QupZilla\",qupzilla:e,version:n(/(?:qupzilla)[\\s\\/](\\d+(?:\\.\\d+)+)/i)||w}:/chromium/i.test(t)?T={name:\"Chromium\",chromium:e,version:n(/(?:chromium)[\\s\\/](\\d+(?:\\.\\d+)?)/i)||w}:/chrome|crios|crmo/i.test(t)?T={name:\"Chrome\",chrome:e,version:n(/(?:chrome|crios|crmo)\\/(\\d+(\\.\\d+)?)/i)}:o?T={name:\"Android\",version:w}:/safari|applewebkit/i.test(t)?(T={name:\"Safari\",safari:e},w&&(T.version=w)):i?(T={name:i==\"iphone\"?\"iPhone\":i==\"ipad\"?\"iPad\":\"iPod\"},w&&(T.version=w)):/googlebot/i.test(t)?T={name:\"Googlebot\",googlebot:e,version:n(/googlebot\\/(\\d+(\\.\\d+))/i)||w}:T={name:n(/^(.*)\\/(.*) /),version:r(/^(.*)\\/(.*) /)},!T.msedge&&/(apple)?webkit/i.test(t)?(/(apple)?webkit\\/537\\.36/i.test(t)?(T.name=T.name||\"Blink\",T.blink=e):(T.name=T.name||\"Webkit\",T.webkit=e),!T.version&&w&&(T.version=w)):!T.opera&&/gecko\\//i.test(t)&&(T.name=T.name||\"Gecko\",T.gecko=e,T.version=T.version||n(/gecko\\/(\\d+(\\.\\d+)?)/i)),!T.windowsphone&&(o||T.silk)?(T.android=e,T.osname=\"Android\"):!T.windowsphone&&i?(T[i]=e,T.ios=e,T.osname=\"iOS\"):g?(T.mac=e,T.osname=\"macOS\"):x?(T.xbox=e,T.osname=\"Xbox\"):m?(T.windows=e,T.osname=\"Windows\"):y&&(T.linux=e,T.osname=\"Linux\");var C=\"\";T.windows?C=N(n(/Windows ((NT|XP)( \\d\\d?.\\d)?)/i)):T.windowsphone?C=n(/windows phone (?:os)?\\s?(\\d+(\\.\\d+)*)/i):T.mac?(C=n(/Mac OS X (\\d+([_\\.\\s]\\d+)*)/i),C=C.replace(/[_\\s]/g,\".\")):i?(C=n(/os (\\d+([_\\s]\\d+)*) like mac os x/i),C=C.replace(/[_\\s]/g,\".\")):o?C=n(/android[ \\/-](\\d+(\\.\\d+)*)/i):T.webos?C=n(/(?:web|hpw)os\\/(\\d+(\\.\\d+)*)/i):T.blackberry?C=n(/rim\\stablet\\sos\\s(\\d+(\\.\\d+)*)/i):T.bada?C=n(/bada\\/(\\d+(\\.\\d+)*)/i):T.tizen&&(C=n(/tizen[\\/\\s](\\d+(\\.\\d+)*)/i)),C&&(T.osversion=C);var k=!T.windows&&C.split(\".\")[0];if(E||a||i==\"ipad\"||o&&(k==3||k>=4&&!S)||T.silk)T.tablet=e;else if(S||i==\"iphone\"||i==\"ipod\"||o||u||T.blackberry||T.webos||T.bada)T.mobile=e;return T.msedge||T.msie&&T.version>=10||T.yandexbrowser&&T.version>=15||T.vivaldi&&T.version>=1||T.chrome&&T.version>=20||T.samsungBrowser&&T.version>=4||T.firefox&&T.version>=20||T.safari&&T.version>=6||T.opera&&T.version>=10||T.ios&&T.osversion&&T.osversion.split(\".\")[0]>=6||T.blackberry&&T.version>=10.1||T.chromium&&T.version>=20?T.a=e:T.msie&&T.version<10||T.chrome&&T.version<20||T.firefox&&T.version<20||T.safari&&T.version<6||T.opera&&T.version<10||T.ios&&T.osversion&&T.osversion.split(\".\")[0]<6||T.chromium&&T.version<20?T.c=e:T.x=e,T}function r(e){return e.split(\".\").length}function i(e,t){var n=[],r;if(Array.prototype.map)return Array.prototype.map.call(e,t);for(r=0;r<e.length;r++)n.push(t(e[r]));return n}function s(e){var t=Math.max(r(e[0]),r(e[1])),n=i(e,function(e){var n=t-r(e);return e+=(new Array(n+1)).join(\".0\"),i(e.split(\".\"),function(e){return(new Array(20-e.length)).join(\"0\")+e}).reverse()});while(--t>=0){if(n[0][t]>n[1][t])return 1;if(n[0][t]!==n[1][t])return-1;if(t===0)return 0}}function o(e,r,i){var o=n;typeof r==\"string\"&&(i=r,r=void 0),r===void 0&&(r=!1),i&&(o=t(i));var u=\"\"+o.version;for(var a in e)if(e.hasOwnProperty(a)&&o[a]){if(typeof e[a]!=\"string\")throw new Error(\"Browser version in the minVersion map should be a string: \"+a+\": \"+String(e));return s([u,e[a]])<0}return r}function u(e,t,n){return!o(e,t,n)}var e=!0,n=t(typeof navigator!=\"undefined\"?navigator.userAgent||\"\":\"\");return n.test=function(e){for(var t=0;t<e.length;++t){var r=e[t];if(typeof r==\"string\"&&r in n)return!0}return!1},n.isUnsupportedBrowser=o,n.compareVersions=s,n.check=u,n._detect=t,n.detect=t,n})\n!function(t,e){if(!t.ES6Promise){t.ES6Promise=e();t.ES6Promise.polyfill()}}(this,function(){\"use strict\";function t(t){return\"function\"==typeof t||\"object\"==typeof t&&null!==t}function e(t){return\"function\"==typeof t}function n(t){I=t}function r(t){J=t}function o(){return function(){return process.nextTick(a)}}function i(){return\"undefined\"!=typeof H?function(){H(a)}:c()}function s(){var t=0,e=new V(a),n=document.createTextNode(\"\");return e.observe(n,{characterData:!0}),function(){n.data=t=++t%2}}function u(){var t=new MessageChannel;return t.port1.onmessage=a,function(){return t.port2.postMessage(0)}}function c(){var t=setTimeout;return function(){return t(a,1)}}function a(){for(var t=0;t<G;t+=2){var e=$[t],n=$[t+1];e(n),$[t]=void 0,$[t+1]=void 0}G=0}function f(){try{var t=require,e=t(\"vertx\");return H=e.runOnLoop||e.runOnContext,i()}catch(n){return c()}}function l(t,e){var n=arguments,r=this,o=new this.constructor(p);void 0===o[et]&&k(o);var i=r._state;return i?!function(){var t=n[i-1];J(function(){return x(i,o,t,r._result)})}():E(r,o,t,e),o}function h(t){var e=this;if(t&&\"object\"==typeof t&&t.constructor===e)return t;var n=new e(p);return g(n,t),n}function p(){}function v(){return new TypeError(\"You cannot resolve a promise with itself\")}function d(){return new TypeError(\"A promises callback cannot return that same promise.\")}function _(t){try{return t.then}catch(e){return it.error=e,it}}function y(t,e,n,r){try{t.call(e,n,r)}catch(o){return o}}function m(t,e,n){J(function(t){var r=!1,o=y(n,e,function(n){r||(r=!0,e!==n?g(t,n):S(t,n))},function(e){r||(r=!0,j(t,e))},\"Settle: \"+(t._label||\" unknown promise\"));!r&&o&&(r=!0,j(t,o))},t)}function b(t,e){e._state===rt?S(t,e._result):e._state===ot?j(t,e._result):E(e,void 0,function(e){return g(t,e)},function(e){return j(t,e)})}function w(t,n,r){n.constructor===t.constructor&&r===l&&n.constructor.resolve===h?b(t,n):r===it?j(t,it.error):void 0===r?S(t,n):e(r)?m(t,n,r):S(t,n)}function g(e,n){e===n?j(e,v()):t(n)?w(e,n,_(n)):S(e,n)}function A(t){t._onerror&&t._onerror(t._result),P(t)}function S(t,e){t._state===nt&&(t._result=e,t._state=rt,0!==t._subscribers.length&&J(P,t))}function j(t,e){t._state===nt&&(t._state=ot,t._result=e,J(A,t))}function E(t,e,n,r){var o=t._subscribers,i=o.length;t._onerror=null,o[i]=e,o[i+rt]=n,o[i+ot]=r,0===i&&t._state&&J(P,t)}function P(t){var e=t._subscribers,n=t._state;if(0!==e.length){for(var r=void 0,o=void 0,i=t._result,s=0;s<e.length;s+=3)r=e[s],o=e[s+n],r?x(n,r,o,i):o(i);t._subscribers.length=0}}function T(){this.error=null}function M(t,e){try{return t(e)}catch(n){return st.error=n,st}}function x(t,n,r,o){var i=e(r),s=void 0,u=void 0,c=void 0,a=void 0;if(i){if(s=M(r,o),s===st?(a=!0,u=s.error,s=null):c=!0,n===s)return void j(n,d())}else s=o,c=!0;n._state!==nt||(i&&c?g(n,s):a?j(n,u):t===rt?S(n,s):t===ot&&j(n,s))}function C(t,e){try{e(function(e){g(t,e)},function(e){j(t,e)})}catch(n){j(t,n)}}function O(){return ut++}function k(t){t[et]=ut++,t._state=void 0,t._result=void 0,t._subscribers=[]}function Y(t,e){this._instanceConstructor=t,this.promise=new t(p),this.promise[et]||k(this.promise),B(e)?(this._input=e,this.length=e.length,this._remaining=e.length,this._result=new Array(this.length),0===this.length?S(this.promise,this._result):(this.length=this.length||0,this._enumerate(),0===this._remaining&&S(this.promise,this._result))):j(this.promise,q())}function q(){return new Error(\"Array Methods must be provided an Array\")}function F(t){return new Y(this,t).promise}function D(t){var e=this;return new e(B(t)?function(n,r){for(var o=t.length,i=0;i<o;i++)e.resolve(t[i]).then(n,r)}:function(t,e){return e(new TypeError(\"You must pass an array to race.\"))})}function K(t){var e=this,n=new e(p);return j(n,t),n}function L(){throw new TypeError(\"You must pass a resolver function as the first argument to the promise constructor\")}function N(){throw new TypeError(\"Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.\")}function U(t){this[et]=O(),this._result=this._state=void 0,this._subscribers=[],p!==t&&(\"function\"!=typeof t&&L(),this instanceof U?C(this,t):N())}function W(){var t=void 0;if(\"undefined\"!=typeof global)t=global;else if(\"undefined\"!=typeof self)t=self;else try{t=Function(\"return this\")()}catch(e){throw new Error(\"polyfill failed because global object is unavailable in this environment\")}var n=t.Promise;if(n){var r=null;try{r=Object.prototype.toString.call(n.resolve())}catch(e){}if(\"[object Promise]\"===r&&!n.cast)return}t.Promise=U}var z=void 0;z=Array.isArray?Array.isArray:function(t){return\"[object Array]\"===Object.prototype.toString.call(t)};var B=z,G=0,H=void 0,I=void 0,J=function(t,e){$[G]=t,$[G+1]=e,G+=2,2===G&&(I?I(a):tt())},Q=\"undefined\"!=typeof window?window:void 0,R=Q||{},V=R.MutationObserver||R.WebKitMutationObserver,X=\"undefined\"==typeof self&&\"undefined\"!=typeof process&&\"[object process]\"==={}.toString.call(process),Z=\"undefined\"!=typeof Uint8ClampedArray&&\"undefined\"!=typeof importScripts&&\"undefined\"!=typeof MessageChannel,$=new Array(1e3),tt=void 0;tt=X?o():V?s():Z?u():void 0===Q&&\"function\"==typeof require?f():c();var et=Math.random().toString(36).substring(16),nt=void 0,rt=1,ot=2,it=new T,st=new T,ut=0;return Y.prototype._enumerate=function(){for(var t=this.length,e=this._input,n=0;this._state===nt&&n<t;n++)this._eachEntry(e[n],n)},Y.prototype._eachEntry=function(t,e){var n=this._instanceConstructor,r=n.resolve;if(r===h){var o=_(t);if(o===l&&t._state!==nt)this._settledAt(t._state,e,t._result);else if(\"function\"!=typeof o)this._remaining--,this._result[e]=t;else if(n===U){var i=new n(p);w(i,t,o),this._willSettleAt(i,e)}else this._willSettleAt(new n(function(e){return e(t)}),e)}else this._willSettleAt(r(t),e)},Y.prototype._settledAt=function(t,e,n){var r=this.promise;r._state===nt&&(this._remaining--,t===ot?j(r,n):this._result[e]=n),0===this._remaining&&S(r,this._result)},Y.prototype._willSettleAt=function(t,e){var n=this;E(t,void 0,function(t){return n._settledAt(rt,e,t)},function(t){return n._settledAt(ot,e,t)})},U.all=F,U.race=D,U.resolve=h,U.reject=K,U._setScheduler=n,U._setAsap=r,U._asap=J,U.prototype={constructor:U,then:l,\"catch\":function(t){return this.then(null,t)}},U.polyfill=W,U.Promise=U,U});\n\n(function() {\nvar  global, version, _ref;\n\n\n  function AkamaiSDKManager() {\n    var legacyCheck, sdk, versions,\n      _this = this;\n    sdk = null;\n    this.getSDK = function() {\n      return sdk;\n    };\n    this.setSDK = function(newSDK) {\n      var key, value;\n      sdk = newSDK;\n      legacyCheck();\n      for (key in sdk) {\n        value = sdk[key];\n        window[key] = value;\n      }\n      return sdk;\n    };\n    this.saveSDK = function(version, object) {\n      var key, value, _ref;\n      if (!(object != null) || !(version != null) || version === \"\") {\n        return;\n      }\n      if (!(object.main != null)) {\n        for (key in object) {\n          value = object[key];\n          if (!((value != null ? value.VERSION : void 0) === version)) {\n            continue;\n          }\n          object.main = value;\n          break;\n        }\n      }\n      if ((_ref = object.version) == null) {\n        object.version = version;\n      }\n      versions.push(object);\n      this[version] = object;\n      return object;\n    };\n    versions = [];\n    this.getVersions = function() {\n      return versions.slice();\n    };\n    this.getVersion = function(version) {\n      return this[version];\n    };\n    this.setVersion = function(version) {\n      sdk = this.getVersion(version);\n      if (!(sdk != null)) {\n        return null;\n      }\n      this.setSDK(sdk);\n      return sdk;\n    };\n    this.revert = function() {\n      return this.setSDK(versions[0]);\n    };\n    this.noConflict = function() {\n      var current;\n      current = this.getSDK();\n      this.revert();\n      return current;\n    };\n    this.create = (function() {\n      var Creator;\n      Creator = function(cls, args) {\n        this.prototype = cls.prototype;\n        return cls.apply(this, args);\n      };\n      return function(args) {\n        return new Creator(sdk.main, arguments);\n      };\n    })();\n    legacyCheck = function() {\n      var key, obj, value, _ref, _ref1;\n      if ((_ref = window.com) != null ? (_ref1 = _ref.akamai) != null ? _ref1.amp : void 0 : void 0) {\n        for (key in window) {\n          value = window[key];\n          if ((value === window.AMP || value === window.AMPremier) && ((value != null ? value.VERSION : void 0) != null) && value.VERSION !== \"\" && value.VERSION !== (sdk != null ? sdk.version : void 0) && (!(_this[value.VERSION] != null))) {\n            obj = {};\n            obj.main = value;\n            obj.com = window.com;\n            if (window.AMP) {\n              obj.AMP = window.AMP;\n            }\n            if (window.AMPPremier) {\n              obj.AMPremier = window.AMPPremier;\n            }\n            if (window.Utils) {\n              obj.Utils = window.Utils;\n            }\n            if (window.QueryString) {\n              obj.QueryString = window.QueryString;\n            }\n            if (window.QueryParams) {\n              obj.QueryParams = window.QueryParams;\n            }\n            _this.saveSDK(value.VERSION, obj);\n            break;\n          }\n        }\n      }\n    };\n    legacyCheck();\n  }\n\n  \nif ((_ref = window.AKAMAI_MEDIA_PLAYER) == null) {\n  window.AKAMAI_MEDIA_PLAYER = new AkamaiSDKManager();\n}\nversion = \"AMP - Premier : WebMD v2.99.6\";\nif (!(window.AKAMAI_MEDIA_PLAYER[version] != null)) {\n  global = window.AKAMAI_MEDIA_PLAYER[version] = {};\n  /* Start JS Lib\n  */\n  function __hasProp(prop) {\n\treturn {}[\"hasOwnProperty\"](prop);\n}\n\nfunction __extends(child, parent) {\n\tfor (var key in parent) {\n\t\tif (__hasProp[\"call\"](parent, key))\n\t\t\tchild[key] = parent[key];\n\t}\n\tfunction ctor() {\n\t\tthis.constructor = child;\n\t}\n\n\tctor.prototype = parent.prototype;\n\tchild.prototype = new ctor;\n\tchild.__super__ = parent.prototype;\n\treturn child;\n}\n\nfunction __indexOf(item) {\n\tfor (var i = 0, l = this.length; i < l; i++) {\n\t\tif ( i in this && this[i] === item)\n\t\t\treturn i;\n\t}\n\treturn -1;\n}\n\nfunction __bind(fn, me) {\n\treturn function() {\n\t\treturn fn[\"apply\"](me, arguments);\n\t};\n}\n\nfunction QueryString() {}\n\nQueryString.construct = function() {\n  var key, value, vars;\n  vars = this.decode(window.location.search);\n  QueryString.typed = {};\n  for (key in vars) {\n    value = vars[key];\n    QueryString[key] = value;\n    QueryString.typed[key] = this.parse(value);\n  }\n  return true;\n};\n\nQueryString.encode = function(obj, prefix) {\n  var k, p, str, v;\n  str = [];\n  for (p in obj) {\n    v = obj[p];\n    if (!(v != null)) {\n      continue;\n    }\n    k = (prefix ? prefix + \"[\" + p + \"]\" : p);\n    str.push((typeof v === \"object\" ? this.encode(v, k) : k + \"=\" + encodeURIComponent(v)));\n  }\n  return str.join(\"&\");\n};\n\nQueryString.decode = function(uri) {\n  var results,\n    _this = this;\n  if (uri != null) {\n    results = {};\n    uri = uri.replace(/^[^?]*\\?/, \"\");\n    uri.replace(new RegExp(\"([^?=&]+)(=([^&]*))?\", \"g\"), function($0, $1, $2, $3) {\n      var key, obj, value;\n      key = decodeURIComponent($1);\n      value = decodeURIComponent($3);\n      if (/~/.test(value)) {\n        value = _this.decodeObject(value);\n      }\n      if (/\\[/.test(key)) {\n        obj = key.match(/[^\\[]+/)[0];\n        key = key.match(/\\[([A-Za-z]+)\\]/)[1];\n        if (results[obj] == null) {\n          results[obj] = {};\n        }\n        results[obj][key] = value;\n        return;\n      }\n      results[key] = value;\n    });\n  }\n  return results;\n};\n\nQueryString.decodeObject = function(uri) {\n  var results,\n    _this = this;\n  if (uri != null) {\n    results = {};\n    uri.replace(/([^:~]+)(:([^~]*))?/g, function($0, $1, $2, $3) {\n      results[decodeURIComponent($1)] = _this.parse(decodeURIComponent($3));\n    });\n  }\n  return results;\n};\n\nQueryString.parse = function(value) {\n  var temp;\n  if (typeof value === \"object\") {\n    return value;\n  }\n  if (value === \"undefined\") {\n    return true;\n  }\n  temp = value.toLowerCase();\n  if (temp === \"true\" || temp === \"false\") {\n    return temp === \"true\";\n  }\n  if (temp === \"null\") {\n    return null;\n  }\n  temp = parseFloat(value);\n  if (!isNaN(temp)) {\n    return temp;\n  }\n  try {\n    temp = JSON.parse(value);\n    return temp;\n  } catch (error) {\n    return value;\n  }\n};\n\nQueryString.constructed = QueryString.construct();\n\n/**\n * The Config class\n *\n * @param Object} overrides\n *    Config overrides\n *\n * @constructor\n*/\nfunction Config(overrides) {\n  var config, key, react, value;\n  if (overrides == null) {\n    overrides = {};\n  }\n  if (!(akamai.amp.AMP.plugins.controls != null)) {\n    react = {\n      plugins: {\n        react: {\n          resources: [\n            {\n              src: \"${paths.plugins}react/libs/react.min.js\",\n              debug: \"${paths.plugins}react/libs/react.js\",\n              type: \"text/javascript\"\n            }, {\n              src: \"${paths.plugins}react/React.min.css\",\n              debug: \"${paths.plugins}react/React.css\",\n              type: \"text/css\"\n            }, {\n              src: \"${paths.plugins}react/React.min.js\",\n              debug: \"${paths.plugins}react/React.js\",\n              type: \"text/javascript\"\n            }\n          ],\n          autoHide: 3\n        }\n      }\n    };\n    overrides = Utils.override(react, overrides);\n  }\n  config = Utils.override(Config.defaults, overrides);\n  if (/amp\\-debug\\=true/.test(location.search.toLowerCase()) === true) {\n    config.debug = true;\n  }\n  if (typeof QueryString.amp === \"object\") {\n    config = Utils.override(config, QueryString.amp);\n  }\n  config.mode = Utils.getPlaybackMode(config.mode);\n  if (Utils.getIEVersion() === 9) {\n    config.plugins.react = null;\n    config.flash.view = Utils.override(config.flash.view, Config.flashView);\n  }\n  config.version = AMP.getVersion();\n  for (key in config) {\n    value = config[key];\n    this[key] = value;\n  }\n}\n\nConfig.create = function(overrides) {\n  return new Config(overrides);\n};\n\nConfig.defaults = {\n  paths: {\n    base: \"../\",\n    root: \"../\",\n    player: \"../amp.premier/\",\n    plugins: \"../akamai/amp/\",\n    resources: \"../resources/\"\n  },\n  resources: [\n    {\n      src: '#{paths.player}amp.premier.css',\n      type: \"text/css\",\n      async: true\n    }\n  ],\n  rules: {\n    android_4_gets_m3u8: {\n      regexp: \"Android 4\"\n    }\n  },\n  attributes: {},\n  settings: {},\n  autoplay: true,\n  loop: false,\n  playsinline: null,\n  muted: null,\n  target: \"_blank\",\n  domain: \"akamai.com\",\n  fullscreen: {},\n  contextmenu: {},\n  captioning: {},\n  controls: {},\n  playoverlay: {},\n  hls: {\n    resources: [\n      {\n        type: \"text/javascript\",\n        src: '#{paths.resources}js/hls.min.js',\n        debug: '#{paths.resources}js/hls.js'\n      }\n    ],\n    quality: {\n      startLevel: -1\n    },\n    data: {\n      enableWorker: true\n    }\n  },\n  dash: {\n    resources: [\n      {\n        type: \"text/javascript\",\n        src: \"//cdn.dashjs.org/v2.6.8/dash.all.min.js\",\n        debug: \"//cdn.dashjs.org/v2.6.8/dash.all.debug.js\"\n      }\n    ],\n    buffer: 1\n  },\n  flash: {\n    swf: '#{paths.player}AkamaiPremierPlayer.swf',\n    debug: '#{paths.player}AkamaiPremierPlayer-debug.swf',\n    expressInstallSWF: '#{paths.player}playerProductInstall.swf',\n    \"static\": {\n      enabled: false,\n      swf: '#{paths.player}AkamaiPremierPlayer-static.swf',\n      debug: '#{paths.player}AkamaiPremierPlayer-static-debug.swf'\n    },\n    vars: {\n      core_player_name: \"amp.premier\",\n      mbr_starting_index: 2,\n      use_last_known_bitrate: false,\n      use_netsession_client: false,\n      netsession_install_prompt_frequency_secs: -1,\n      ad_server_timeout: 20,\n      ad_control_enabled: true,\n      dvr_enabled: 1,\n      branding_preload: \"none\",\n      hds_live_low_latency: true,\n      fullscreen_enabled: true,\n      show_feature_bar: false,\n      suppress_events: \"mediaPlayerViewInitialized\",\n      hds_fragment_retry_data_gap_threshold: 20\n    },\n    view: {\n      attributes: {\n        skin: '#{paths.player}amp.chromeless.assets.swf'\n      },\n      elements: {\n        controls: {},\n        adOptions: {\n          attributes: {\n            style: \"backgroundColor: 'rgba(0, 0, 0, 0)'\"\n          },\n          elements: {\n            adChoices: null,\n            adCountdown: null,\n            adCount: null\n          }\n        },\n        endSlate: {\n          attributes: {\n            enabled: false,\n            hideElements: \"brandingLogo|viewAll\"\n          }\n        },\n        loadingView: {\n          attributes: {\n            enabled: false,\n            style: \"backgroundColor: 'rgba(0, 0, 0, 0)'; color: 'rgba(0, 0, 0, 0)'\",\n            radius: 0\n          }\n        }\n      }\n    }\n  },\n  locales: {\n    en: {\n      MSG_TIME_SEPARATOR: \" / \",\n      MSG_EMAIL_TO: \"To\",\n      MSG_EMAIL_FROM: \"From\",\n      MSG_EMAIL_VIDEO: \"Email this video\",\n      MSG_EMAIL_MESSAGE_DEFAULT: \"Check out this video from xxx\",\n      MSG_EMAIL_MESSAGE: \"Message\",\n      MSG_EMAIL_ADDRESS_INVALID: \"Invalid Email Address\",\n      MSG_EMAIL_MESSAGE_INVALID: \"Please limit your message to 500 characters or less.\",\n      MSG_EMAIL_CHARACTERS_REMAINING_TEXT: \" characters left\",\n      MSG_EMAIL_SEND_FAILURE: \"Message could not be sent.\",\n      MSG_EMAIL_SEND_SUCCESS_MESSAGE: \"Your email has been sent!\",\n      MSG_SHARE_VIDEO_TEXT: \"Share this video...\",\n      MSG_POST_TEXT: \"Post\",\n      MSG_EMBED_TEXT: \"Embed\",\n      MSG_LINK_TEXT: \"Link\",\n      MSG_SHARE_CONNECT_FAILURE: \"Unable to connect. Please try again.\",\n      MSG_SHARE_CONTENT_DISABLED: \"Share and embed are disabled.\",\n      MSG_VERSION_TEXT: \"Version\",\n      MSG_BUFFERING_TEXT: \"buffering\",\n      MSG_CUSTOMIZE_CLIP_POINTS: \"Customize the start and end point of the video.\",\n      MSG_PAUSE: \"Pause\",\n      MSG_PLAY: \"Play\",\n      MSG_REWIND: \"Rewind\",\n      MSG_PLAYBACK_RATE: \"Playback Rate\",\n      MSG_FULLSCREEN: \"Fullscreen\",\n      MSG_ENTER_FULLSCREEN: \"Enter Fullscreen\",\n      MSG_EXIT_FULLSCREEN: \"Exit Fullscreen\",\n      MSG_MUTE: \"Mute\",\n      MSG_UNMUTE: \"Unmute\",\n      MSG_JUMP_BACK: \"Jump Back\",\n      MSG_JUMP_AHEAD: \"Jump Ahead\",\n      MSG_VOLUME: \"Volume\",\n      MSG_REPLAY: \"Replay\",\n      MSG_SETTINGS: \"Settings\",\n      MSG_SHARE: \"Share\",\n      MSG_CLOSED_CAPTIONING: \"Closed Captioning\",\n      MSG_SLIDER: \"Slider\",\n      MSG_SEEK: \"Seek\",\n      MSG_OF: \"of\",\n      MSG_AD: \"Ad\",\n      MSG_PREVIEW: \"Preview\",\n      MSG_CURRENT: \"Current\",\n      MSG_SEEK_TO: \"Seek to\",\n      MSG_LIVE: \"LIVE\",\n      MSG_ERROR: \"Error\",\n      MSG_ERROR_ABORTED: \"Media Aborted\",\n      MSG_ERROR_DECODE: \"Decode Error\",\n      MSG_ERROR_NETWORK: \"Network Error\",\n      MSG_ERROR_SRC: \"Source not supported\",\n      MSG_ERROR_DEFAULT: \"An error has occurred\",\n      MSG_STREAM_NOT_FOUND: \"Stream not found\",\n      MSG_CURRENT_WORKING_BANDWIDTH: \"Current working bandwidth\",\n      MSG_CURRENT_BITRATE_PLAYING: \"Current bitrate playing\",\n      MSG_MAX_BITRATE_AVAILABLE: \"Max bitrate available\",\n      MSG_NOT_AVAILABLE: \"Not Available\",\n      MSG_GO_LIVE: \"GO LIVE\",\n      MSG_NEXT_VIDEO: \"Video starts in: \",\n      MSG_RECOMMENDED: \"Recommended\",\n      MSG_VIEW_ALL: \"View all \",\n      MSG_VIDEO: \" videos\",\n      MSG_CC: \"CC\",\n      MSG_CC_TITLE: \"Caption\",\n      MSG_CC_LANGUAGE: \"Track :\",\n      MSG_CC_PRESETS: \"Presets :\",\n      MSG_CC_FONT: \"Font :\",\n      MSG_CC_EDGE: \"Edge :\",\n      MSG_CC_SIZE: \"Size :\",\n      MSG_CC_SCROLL: \"Scroll :\",\n      MSG_CC_COLOR: \"Color :\",\n      MSG_CC_BACKGROUND: \"Background :\",\n      MSG_CC_WINDOW: \"Window :\",\n      MSG_CC_OPACITY: \"Opacity :\",\n      MSG_CC_SHOW_ADVANCED: \"Show Advanced Settings\",\n      MSG_CC_HIDE_ADVANCED: \"Hide Advanced Settings\",\n      MSG_NEXT_AD: \"Next ad starts in: \",\n      MSG_CC_RESET: \"Default\",\n      MSG_CC_CANCEL: \"Cancel\",\n      MSG_CC_APPLY: \"Apply\",\n      MSG_CC_PREVIEW_TEXT: \"Lorem ipsum dolor sit amet..\",\n      MSG_EN: \"English\",\n      MSG_ENG: \"English\",\n      MSG_ES: \"Spanish\",\n      MSG_SPA: \"Spanish\",\n      MSG_DE: \"German\",\n      MSG_DEU: \"German\",\n      MSG_GER: \"German\",\n      MSG_FR: \"French\",\n      MSG_FRE: \"French\",\n      MSG_FRA: \"French\",\n      MSG_IT: \"Italian\",\n      MSG_ITA: \"Italian\",\n      MSG_RU: \"Russian\",\n      MSG_RUS: \"Russian\",\n      MSG_ZH: \"Chinese\",\n      MSG_ZHO: \"Chinese\",\n      MSG_CHI: \"Chinese\",\n      MSG_JA: \"Japanese\",\n      MSG_JPN: \"Japanese\",\n      MSG_KO: \"Korean\",\n      MSG_KOR: \"Korean\",\n      MSG_CHROMECAST_MESSAGE: \"Video playing on ${device}\",\n      MSG_RETRY_MESSAGE: \"Content not yet available, retrying in\",\n      MSG_SECONDS: \"seconds\",\n      MSG_RETRY_FAILED: \"Retry failed\",\n      MSG_RECOMMENDATIONS_TITLE: \"Recommended\",\n      MSG_VIEWER_ID: \"Viewer ID: \",\n      MSG_SIGN_IN: \"Sign In\",\n      MSG_PREVIEW_INFO: \"Free Preview\",\n      MSG_PREVIEW_EXPIRES: \"Expires in\",\n      MSG_UNKNOWN: \"Unknown\"\n    },\n    es: '#{paths.player}es.json',\n    fr: '#{paths.player}fr.json'\n  }\n};\n\nConfig.flashView = {\n  attributes: {\n    skin: '#{paths.player}premier.assets.swf'\n  },\n  elements: {\n    infoOverlay: {\n      attributes: {\n        style: \"top: 0px;\"\n      }\n    },\n    adOptions: {\n      attributes: {\n        style: \"backgroundColor: 'rgba(0, 0, 0, 1)'\"\n      },\n      elements: {\n        adChoices: {\n          attributes: {\n            target: \"http://www.akamai.com/\"\n          }\n        },\n        adCountdown: {},\n        adCount: {}\n      }\n    },\n    endSlate: {\n      attributes: {\n        enabled: true,\n        hideElements: \"brandingLogo|viewAll\"\n      }\n    },\n    replayView: {},\n    bufferingView: {},\n    controls: {\n      attributes: {\n        height: \"28\",\n        itemMargin: \"5\",\n        scrubPosition: \"inline\"\n      },\n      elements: {\n        replayBtn: {},\n        playPauseBtn: {},\n        streamTimeIndicator: {\n          attributes: {\n            exclude: \"live\"\n          },\n          elements: {\n            streamTime: {},\n            streamDuration: {}\n          }\n        },\n        rewindBtn: {},\n        scrubBar: {\n          attributes: {\n            style: \"height: 18px;\"\n          }\n        },\n        progressBar: {\n          attributes: {\n            style: \"background: linear-gradient(90deg, #FF0000, #1B1B1B);\"\n          }\n        },\n        loadedBar: {\n          attributes: {\n            style: \"background: linear-gradient(90deg, #00FF00, #1B1B1B);\"\n          }\n        },\n        liveIndicator: {},\n        timeLocationIndicator: {},\n        goLiveBtn: {},\n        statsBtn: {},\n        volumeBar: {\n          attributes: {\n            color: \"#CA2127\"\n          }\n        },\n        volumeBtn: {},\n        fullscreenBtn: {}\n      }\n    }\n  }\n};\n\n/**\n * Creates a new instance of MediaProxy. Used to track player configuration settings.\n * \n * @param {Object} data The config object.\n * @constructor\n * @private\n * @extends {puremvc.Proxy}\n*/\nfunction ModuleProxy(data, name) {\n  this.config = data;\n  ModuleProxy.__super__.constructor.call(this, name);\n}\n\n\n__extends(ModuleProxy, puremvc.Proxy);\n\n\n/** @static\n*/\nModuleProxy.NAME = \"ModuleProxy\";\n\n/** @private\n*/\nModuleProxy.prototype.defaults = null;\n\nModuleProxy.prototype.config = null;\n\n/** @override\n*/\nModuleProxy.prototype.initializeNotifier = function(key) {\n  ModuleProxy.__super__.initializeNotifier.call(this, key);\n  this.createData();\n};\n\n/**\n*/\nModuleProxy.prototype.createData = function() {\n  this.setData(this.config);\n};\n\n/**\n*/\nModuleProxy.prototype.getDefaults = function() {\n  return this.defaults || {};\n};\n\n/**\n * Sets the data for this proxy.\n * \n * @param {Object} value \n *    The new data for this proxy\n * @override\n*/\nModuleProxy.prototype.setData = function(data) {\n  var dflt, key, obj, value, _ref;\n  if (data == null) {\n    data = {};\n  }\n  obj = {};\n  _ref = this.getDefaults();\n  for (key in _ref) {\n    dflt = _ref[key];\n    value = key in data ? data[key] : dflt;\n    obj[key] = value;\n  }\n  ModuleProxy.__super__.setData.call(this, obj);\n  return data;\n};\n\n/**\n*/\nModuleProxy.prototype.destroy = function() {};\n\n/**\n * The Module class.\n *\n * @param {Object}  config        The configuration object\n * @param {Object}  viewComponent The player's container element\n * @constructor\n * @private\n * @extends {puremvc.Facade}\n*/\nfunction Module(viewComponent) {\n  this.viewComponent = viewComponent;\n  this.performance = {\n    init: Date.now()\n  };\n  Module.__super__.constructor.call(this, this.getModuleName() + \"-\" + Utils.createUID());\n  this.dispatcher = new EventDispatcher(this);\n  this.transformer = new Transformer();\n  this.logger = Logger.instance;\n  this.moduleMap = {};\n}\n\n\n__extends(Module, puremvc.Facade);\n\n\nModule.prototype.logger = null;\n\nModule.prototype.config = null;\n\nModule.prototype.moduleName = null;\n\nModule.prototype.moduleMap = null;\n\nModule.prototype.viewComponent = null;\n\nModule.prototype.dispatcher = null;\n\nModule.prototype.oninitialized = null;\n\nModule.prototype.onerror = null;\n\nModule.prototype.parentModule = null;\n\nModule.prototype.performance = null;\n\nModule.prototype.transformer = null;\n\n/**\n * Initialization function.\n *\n * @param {Object}  config  The plugin's configuration object.\n*/\nModule.prototype.initialize = function(config, parentModule) {\n  this.config = config;\n  this.parentModule = parentModule;\n  this.loadModuleResources().then(this.resourcesLoaded.bind(this))[\"catch\"](this.resourcesError.bind(this));\n};\n\n/**\n*/\nModule.prototype.loadModuleResources = function(resources) {\n  if (resources == null) {\n    resources = this.config.resources;\n  }\n  if (!(resources != null ? resources.length : void 0) > 0) {\n    return Promise.resolve();\n  }\n  return AMP.addResources(this.evaluatePaths(resources));\n};\n\n/**\n*/\nModule.prototype.evaluatePaths = function(path) {\n  var paths, _ref, _ref1;\n  if (!(path != null)) {\n    return;\n  }\n  paths = this.config.paths || ((_ref = this.parentModule) != null ? (_ref1 = _ref.config) != null ? _ref1.paths : void 0 : void 0);\n  if (paths != null) {\n    path = DataBinding.evaluateBindings(path, {\n      paths: paths\n    });\n  }\n  return path;\n};\n\n/**\n * The resources failed to load.\n *\n * @private\n*/\nModule.prototype.resourcesError = function(error) {\n  if (typeof this.onerror === \"function\") {\n    this.onerror(this);\n  }\n};\n\n/**\n * The resources have finished loaded, load the extensions.\n *\n * @private\n*/\nModule.prototype.resourcesLoaded = function() {\n  this.createFramework();\n  if (typeof this.oninitialized === \"function\") {\n    this.oninitialized(this);\n  }\n};\n\n/**\n * Framework based initialization function for defining default\n * mvc classes. Meant to be overwritten by base classes.\n*/\nModule.prototype.createFramework = function() {\n  this.createModel();\n  this.createController();\n  this.createView();\n};\n\n/**\n*/\nModule.prototype.createModel = function() {\n  this.registerProxy(new ModuleProxy(this.config));\n};\n\n/**\n*/\nModule.prototype.createView = function() {};\n\n/**\n*/\nModule.prototype.createController = function() {\n  this.registerCommand(Notifications.DISPATCH_EVENT, DispatchEventCommand);\n};\n\n/**\n*/\nModule.prototype.getModuleName = function() {\n  return this.moduleName;\n};\n\n/**\n * @return {Object} The configuration object.\n * @expose\n*/\nModule.prototype.getConfig = function() {\n  return this.config;\n};\n\n/**\n*/\nModule.prototype.hasModule = function(moduleName) {\n  return this.moduleMap[moduleName] != null;\n};\n\n/**\n*/\nModule.prototype.getModules = function() {\n  var key, modules, value, _ref;\n  modules = {};\n  _ref = this.moduleMap;\n  for (key in _ref) {\n    value = _ref[key];\n    modules[key] = value.module;\n  }\n  return modules;\n};\n\n/**\n*/\nModule.prototype.registerModule = function(module) {\n  var adaptor, moduleName;\n  moduleName = module.getModuleName();\n  if (!(module != null) || (this.moduleMap[moduleName] != null)) {\n    return;\n  }\n  adaptor = new ModuleAdapter(module);\n  this.moduleMap[moduleName] = adaptor;\n  this.registerMediator(adaptor);\n  module.onRegister();\n};\n\n/**\n*/\nModule.prototype.retrieveModule = function(moduleName) {\n  return this.moduleMap[moduleName].module;\n};\n\n/**\n*/\nModule.prototype.removeModule = function(moduleName) {\n  var adaptor, module;\n  adaptor = this.moduleMap[moduleName];\n  if (!(adaptor != null)) {\n    return;\n  }\n  delete this.moduleMap[moduleName];\n  this.removeMediator(moduleName);\n  module = adaptor.module;\n  module.onRemove.call(module);\n  return module;\n};\n\n/** List INotification interests.\n*/\nModule.prototype.listNotificationInterests = function() {\n  return [];\n};\n\n/** List Notification publications\n*/\nModule.prototype.listNotificationPublications = function() {\n  return [];\n};\n\n/** Get the IMediator's view component.\n*/\nModule.prototype.getViewComponent = function() {\n  return this.viewComponent;\n};\n\n/** Set the IMediator's view component.\n*/\nModule.prototype.setViewComponent = function(viewComponent) {\n  this.viewComponent = viewComponent;\n  return viewComponent;\n};\n\n/** Called by the parent module when the Module is registered\n*/\nModule.prototype.onRegister = function() {};\n\n/** Called by the parent module when the Module is removed\n*/\nModule.prototype.onRemove = function() {};\n\n/** Destroys the module\n*/\nModule.prototype.destroy = function() {\n  var key, value, _ref, _ref1;\n  if (this.getModules() != null) {\n    _ref = this.getModules();\n    for (key in _ref) {\n      value = _ref[key];\n      this.removeModule(key);\n      value.destroy();\n    }\n  }\n  if ((_ref1 = this.retrieveProxy(ModuleProxy.NAME)) != null) {\n    if (typeof _ref1.destroy === \"function\") {\n      _ref1.destroy();\n    }\n  }\n  puremvc.Facade.removeCore(this.multitonKey);\n  if (this.viewComponent != null) {\n    this.viewComponent.innerHTML = \"\";\n    this.viewComponent.className = \"\";\n  }\n  for (key in this) {\n    try {\n      this[key] = null;\n    } catch (error) {\n\n    }\n    delete this[key];\n  }\n};\n\n/**\n * Adds a listener for a given event type.\n *\n * @param {!string}  type  A string representing the event's type.\n * @param {!Function} func  A function to call when the event is triggered.\n * @expose\n*/\nModule.prototype.addEventListener = function(type, func) {\n  this.dispatcher.addEventListener(type, func);\n};\n\n/**\n * Adds a listener for a given event type and removes it after it has been triggered once.\n*/\nModule.prototype.once = function(type, func) {\n  this.dispatcher.once(type, func);\n};\n\n/**\n*/\nModule.prototype.logEvent = function(event) {\n  var prefix;\n  if (/(timeupdate|progress|fragmentloaded|fragmentloadstart)/.test(event.type) === true) {\n    return;\n  }\n  prefix = this.getModuleName().toUpperCase();\n  if (event.dispatcher) {\n    prefix += \" \" + event.dispatcher;\n  }\n  this.logger.log(\"[\" + prefix + \" EVENT] \" + event.type, event);\n};\n\n/**\n * Dispathes and event, triggering all event listener of the event's type.\n *\n * @param {!IEvent} event The event to dispatch.\n * @expose\n*/\nModule.prototype.dispatchEvent = function(event) {\n  this.logEvent(event);\n  this.dispatcher.dispatchEvent(event);\n};\n\n/**\n * Dispathes an event, triggering all event listener of the event's type.\n *\n * @param {!String} type    The type of event to dispatch.\n * @param {Object=} detail  Data to pass along with the event.\n*/\nModule.prototype.dispatch = function(type, detail) {\n  this.dispatchEvent(new Event(type, detail));\n};\n\n/**\n * Removes a listener for a given event type.\n *\n * @param {!string}  type  A string representing the event's type.\n * @param {!Function} func  A function to call when the event is triggered.\n * @return {?Function} the handler that was removed if any\n * @expose\n*/\nModule.prototype.removeEventListener = function(type, func) {\n  this.dispatcher.removeEventListener(type, func);\n};\n\n/**\n * Adds a transform for a given type.\n *\n * @param {!string}  type  A string representing the event's type.\n * @param {!Function} func  A function to call when the event is triggered.\n*/\nModule.prototype.addTransform = function(type, transform) {\n  return this.transformer.addTransform(type, transform);\n};\n\n/**\n * Sorts the transform list by priority. Higher priority Transforms\n * are executed first.\n *\n * @param {!String} type The transform type\n * @param {Function=} sort An optional sort function\n * @returns {Array.<Function|akamai.amp.Transform>} The sorted list of transforms\n*/\nModule.prototype.sortTransforms = function(type, sort) {\n  return this.transformer.sortTransforms(type, sort);\n};\n\n/**\n * Performs a transform for a given type\n *\n * @param {!String} type The transform type\n * @param {!Object} value The value to be transformed\n*/\nModule.prototype.transform = function(type, value) {\n  return this.transformer.transform(type, value);\n};\n\n/**\n * Removes a transform for a given type.\n *\n * @param {!string}  type  A string representing the transform's type.\n * @param {!Function} transform  A function or Transform object to call when the type is triggered.\n * @return {?Function} the transform that was removed if any\n*/\nModule.prototype.removeTransform = function(type, transform) {\n  return this.transformer.removeTransform(type, transform);\n};\n\n/**\n * Creates a new EventDispatcher\n *\n * @constructor\n * @private\n * @implements {IEventDispatcher}\n*/\nfunction EventDispatcher(_target) {\n  this._target = _target != null ? _target : this;\n  this._listenerMap = {};\n}\n\n/**\n * Adds a listener for a given event type.\n *\n * @param {!string}  type  A string representing the event's type.\n * @param {!Function} func  A function to call when the event is triggered.\n * @param {boolean=} capture\n*/\nEventDispatcher.prototype.addEventListener = function(type, func, capture) {\n  if (!(func != null) || !(type != null)) {\n    return;\n  }\n  if (!(this._listenerMap[type] != null)) {\n    this._listenerMap[type] = [];\n  }\n  if (this._listenerMap[type].indexOf(func) !== -1) {\n    return;\n  }\n  this._listenerMap[type].push(func);\n};\n\n/**\n * Adds a listener for a given event type and removes it after it has been triggered once.\n*/\nEventDispatcher.prototype.once = function(type, func) {\n  func.once = true;\n  this.addEventListener(type, func);\n};\n\n/**\n * Dispathes an event, triggering all event listener of the event's type.\n *\n * @param {!IEvent} event The event to dispatch.\n*/\nEventDispatcher.prototype.dispatchEvent = function(event) {\n  var index, listener, listeners, _i, _len, _ref;\n  listeners = this._listenerMap[event.type];\n  listener = this._target[\"on\" + event.type];\n  event.target = this._target;\n  if (listener != null) {\n    listener.apply(this._target, [event]);\n  }\n  if (!(listeners != null)) {\n    return;\n  }\n  _ref = listeners.slice();\n  for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {\n    listener = _ref[index];\n    listener.apply(this._target, [event]);\n    if (listener.once === true) {\n      listeners.splice(index, 1);\n    }\n  }\n};\n\n/**\n * Dispathes an event, triggering all event listener of the event's type.\n *\n * @param {!String} type    The type of event to dispatch.\n * @param {Object=} detail  Data to pass along with the event.\n*/\nEventDispatcher.prototype.dispatch = function(type, detail) {\n  this.dispatchEvent(new Event(type, detail));\n};\n\n/**\n * Removes a listener for a given event type.\n *\n * @param {!string}  type  A string representing the event's type.\n * @param {!Function} func  A function to call when the event is triggered.\n * @return {?Function} the handler that was removed if any\n * @param {boolean=} capture\n*/\nEventDispatcher.prototype.removeEventListener = function(type, func, capture) {\n  var index, listeners;\n  if (!(func != null) || !(type != null)) {\n    return;\n  }\n  listeners = this._listenerMap[type];\n  if (!(listeners != null)) {\n    return;\n  }\n  index = listeners != null ? listeners.indexOf(func) : void 0;\n  if (index === -1) {\n    return;\n  }\n  return listeners.splice(index, 1);\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction TrackList(list) {\n  this.list = list != null ? list : [];\n  TrackList.__super__.constructor.call(this);\n  this.dispatcher = new EventDispatcher(this);\n  this.handlers = {\n    change: this.changeHandler.bind(this)\n  };\n}\n\n\n__extends(TrackList, Array);\n\n\nTrackList.prototype.onchange = null;\n\n/**\n*/\nTrackList.prototype.changeHandler = function(event) {\n  this.dispatchEvent(event);\n};\n\n/**\n*/\nTrackList.prototype.addEventListener = function(type, func, capture) {\n  this.dispatcher.addEventListener(type, func, capture);\n};\n\n/**\n*/\nTrackList.prototype.dispatchEvent = function(event) {\n  this.dispatcher.dispatchEvent(event);\n};\n\n/**\n*/\nTrackList.prototype.removeEventListener = function(type, func, capture) {\n  return this.dispatcher.removeEventListener(type, func, capture);\n};\n\n/**\n * @param {string} key\n *     The key\n *\n * @param {Object} value\n *     The value\n*/\nTrackList.prototype.add = function(track, dispatch) {\n  if (dispatch == null) {\n    dispatch = true;\n  }\n  this.push(track);\n  track.addEventListener(\"change\", this.handlers.change);\n  if (dispatch === true) {\n    this.dispatchEvent({\n      type: \"addtrack\"\n    });\n  }\n};\n\n/**\n * @param {string} key\n *     The module's key\n *\n * @return {Object}\n *     The item.\n*/\nTrackList.prototype.remove = function(track, dispatch) {\n  var index;\n  if (dispatch == null) {\n    dispatch = true;\n  }\n  index = this.indexOf(track);\n  if (index === -1) {\n    return;\n  }\n  this.splice(index, 1);\n  track.removeEventListener(\"change\", this.handlers.change);\n  if (dispatch === true) {\n    this.dispatchEvent({\n      type: \"removetrack\"\n    });\n  }\n  return track;\n};\n\nTrackList.prototype.clear = function() {\n  var index, _i, _len;\n  if (this.length === 0) {\n    return;\n  }\n  for (_i = 0, _len = this.length; _i < _len; _i++) {\n    index = this[_i];\n    this.remove(this[this.length - 1], false);\n  }\n  this.dispatchEvent({\n    type: \"removetrack\"\n  });\n};\n\nTrackList.prototype.getTrackById = function(id) {\n  var track, _i, _len;\n  for (_i = 0, _len = this.length; _i < _len; _i++) {\n    track = this[_i];\n    if (track.id === id) {\n      return track;\n    }\n  }\n};\n\n/** \n * The InstallPlayer class.\n *   \n * @constructor\n * @private \n * @param {Object} viewComponent\n*/\nfunction InstallPlayer(viewComponent) {\n  var anchor, div, img, message;\n  viewComponent.className = Namespace.PREFIX + \"player\";\n  div = UI.create(\"install-flash\", viewComponent);\n  message = UI.create(null, div, \"p\", \"To view this page ensure that Adobe Flash Player version 10.2.0 or greater is installed.\");\n  anchor = UI.create(null, div, \"a\");\n  anchor.href = 'http://www.adobe.com/go/getflashplayer';\n  img = UI.create(null, anchor, \"img\");\n  img.src = \"//www.adobe.com/images/shared/download_buttons/get_flash_player.gif\";\n  img.alt = \"Get Adobe Flash player\";\n}\n\nInstallPlayer.prototype.initialize = function() {};\n\n/**\n*/\nInstallPlayer.prototype.getModules = function() {\n  return [];\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction Manager() {\n  this.map = {};\n}\n\n/** \n * @type {Object.<string, Object>}\n * @private\n*/\nManager.prototype.map = null;\n\n/**\n * @param {string} key\n *     The key\n * \n * @param {Object} value\n *     The value\n*/\nManager.prototype.add = function(key, value) {\n  this.map[key] = value;\n};\n\n/**\n * @param {string} key\n *     The module's key\n * \n * @return {Object}\n *     The item at the given key.\n*/\nManager.prototype.item = function(key) {\n  return this.map[key];\n};\n\n/**\n * @param {string} key\n *     The module's key\n * \n * @return {Object}\n *     The item.\n*/\nManager.prototype.remove = function(key) {\n  var item;\n  item = this.map[key];\n  if (item != null) {\n    this.map[key] = null;\n    delete this.map[key];\n  }\n  return item;\n};\n\nfunction URL() {}\n\n/**\n * The URL to send the request to.\n *\n * @type {String}\n*/\nURL.prototype.url = null;\n\n/**\n * The HTTP method to use, such as \"GET\", \"POST\", \"PUT\", \"DELETE\", etc. \n * Ignored for non-HTTP(S) URLs.\n *\n * @type {String}\n*/\nURL.prototype.method = null;\n\n/**\n * A Boolean that indicates whether or not cross-site Access-Control \n * requests should be made using credentials such as cookies or authorization \n * headers.\n *\n * @type {Boolean}\n*/\nURL.prototype.withCredentials = null;\n\n/**\n * A key value map of http headers to include in the reques\n * \n * @type {Object}\n*/\nURL.prototype.headers = null;\n\n/**\n * Data to send with a POST request  \n * \n * @type {Object}\n*/\nURL.prototype.data = null;\n\nfunction Authorization(key, token, expiration) {\n  this.key = key;\n  this.token = token;\n  this.expiration = expiration;\n}\n\nAuthorization.prototype.key = null;\n\nAuthorization.prototype.token = null;\n\nAuthorization.prototype.expiration = null;\n\n/**\n * @constructor\n * @extends {Manager}\n*/\nfunction ResourceManager() {\n  ResourceManager.__super__.constructor.call(this);\n}\n\n\n__extends(ResourceManager, Manager);\n\n\nResourceManager.prototype.js = function(src, resource) {\n  return Utils.loadScript(src, document.body);\n};\n\nResourceManager.prototype.css = function(src, resource) {\n  var _this = this;\n  return new Promise(function(resolve, reject) {\n    try {\n      Utils.loadStyleSheet(src);\n    } catch (error) {\n      reject();\n    }\n    resolve(resource);\n  });\n};\n\nResourceManager.prototype.json = function(src, resource) {\n  var _this = this;\n  return Utils.requestJson(resource.src).then(function(data) {\n    resource.data = data;\n    return resource;\n  });\n};\n\n/**\n * @override\n*/\nResourceManager.prototype.require = function(id) {\n  var item,\n    _this = this;\n  item = this.item(id);\n  if (!(item != null)) {\n    if (typeof id === \"string\") {\n      return this.add({\n        src: id\n      });\n    } else if (id.src != null) {\n      return this.add(id);\n    } else {\n      return Promise.resolve(id);\n    }\n  } else if (typeof item === \"function\") {\n    Manager.prototype.add.call(this, id, null);\n    return Promise.resolve().then(function() {\n      return item();\n    });\n  } else if (typeof item.then === \"function\") {\n    return item;\n  } else {\n    return Promise.resolve(item);\n  }\n};\n\n/**\n * @override\n*/\nResourceManager.prototype.add = function(resource) {\n  var id, item, promise, src, type,\n    _this = this;\n  if (resource.enabled === false) {\n    return Promise.resolve();\n  }\n  src = Logger.instance.enabled && (resource.debug != null) ? resource.debug : resource.src;\n  id = resource.id || src;\n  if (resource.defer === true) {\n    resource.defer = false;\n    ResourceManager.__super__.add.call(this, id, this.add.bind(this, resource));\n    return Promise.resolve();\n  }\n  item = this.item(id);\n  if (item != null) {\n    if (typeof item.then === \"function\") {\n      return item;\n    } else {\n      return Promise.resolve(item);\n    }\n  }\n  type = resource.type || Utils.getMimeType(src);\n  if (type === Utils.mimeTypes.js || /javascript/.test(type)) {\n    promise = this.js(src, resource);\n  } else if (type === Utils.mimeTypes.css) {\n    promise = this.css(src, resource);\n  } else if (type === Utils.mimeTypes.json || /json/.test(type)) {\n    promise = this.json(src, resource);\n  } else if (type !== Utils.mimeTypes.swf) {\n    promise = Utils.request(src);\n  }\n  if (!(promise != null)) {\n    return Promise.resolve();\n  }\n  promise = promise.then(function(resource) {\n    Manager.prototype.add.call(_this, id, resource);\n    return resource;\n  });\n  ResourceManager.__super__.add.call(this, id, promise);\n  return promise;\n};\n\n/**\n * @param {Array.<akamai.amp.Resource>} resource\n *    The resource\n *\n * @param {Function} callback\n*/\nResourceManager.prototype.addResources = function(resources) {\n  var asyncs, promise, promises, resource, _i, _len,\n    _this = this;\n  if (!(resources != null ? resources.length : void 0) > 0) {\n    return Promise.resolve();\n  }\n  promises = [];\n  asyncs = [];\n  for (_i = 0, _len = resources.length; _i < _len; _i++) {\n    resource = resources[_i];\n    if (resource instanceof Array) {\n      promises.push(this.addResources.bind(this, resource));\n    } else if (resource.async === true) {\n      asyncs.push(this.add(resource));\n    } else {\n      promises.push(this.add.bind(this, resource));\n    }\n  }\n  if (asyncs.length > 0) {\n    promise = Promise.all(asyncs);\n  } else {\n    promise = Promise.resolve();\n  }\n  return promise.then(function() {\n    return Utils.chain(promises);\n  });\n};\n\n/**\n * The PluginsInitializedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction PluginsInitializedCommand() {\n  PluginsInitializedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PluginsInitializedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nPluginsInitializedCommand.prototype.execute = function(notification) {\n  this.sendNotification(Notifications.READY, this.facade.config);\n};\n\n/**\n * The PlayerCommand class. Base class for commands that need access\n * to the application state or the media\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction PlayerCommand() {\n  PlayerCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PlayerCommand, puremvc.SimpleCommand);\n\n\nPlayerCommand.prototype.applicationState = null;\n\nPlayerCommand.prototype.media = null;\n\nPlayerCommand.prototype.player = null;\n\nPlayerCommand.prototype.playback = null;\n\nPlayerCommand.prototype.config = null;\n\nPlayerCommand.prototype.logger = null;\n\nPlayerCommand.prototype.bindings = null;\n\nPlayerCommand.prototype.params = null;\n\nPlayerCommand.prototype.playerCore = null;\n\nPlayerCommand.prototype.security = null;\n\nPlayerCommand.prototype.tracks = null;\n\n/** @override\n*/\nPlayerCommand.prototype.initializeNotifier = function(key) {\n  var _ref;\n  PlayerCommand.__super__.initializeNotifier.call(this, key);\n  this.player = this.facade.player || this.facade;\n  this.applicationState = this.player.appState;\n  this.media = this.player.mediaProxy;\n  this.config = this.player.configuration;\n  this.logger = this.player.logger;\n  this.bindings = this.player.bindings;\n  this.params = this.player.params;\n  this.playerCore = this.player.playerCore;\n  this.security = this.player.security;\n  this.tracks = this.player.tracks;\n  this.playback = ((_ref = this.player.playerCore) != null ? _ref.getActivePlaybackCore() : void 0) || this.player.playback;\n};\n\n/**\n * The TogglePlayPauseCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction TogglePlayPauseCommand() {\n  TogglePlayPauseCommand.__super__.constructor.call(this);\n}\n\n\n__extends(TogglePlayPauseCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nTogglePlayPauseCommand.prototype.execute = function(notification) {\n  var note;\n  if (this.applicationState.getSeeking()) {\n    return;\n  }\n  switch (this.applicationState.getPlayState()) {\n    case PlayState.ENDED:\n      note = Notifications.REPLAY;\n      break;\n    case PlayState.PAUSED:\n    case PlayState.READY:\n      note = Notifications.PLAY;\n      break;\n    case PlayState.PLAYING:\n      note = Notifications.PAUSE;\n  }\n  if (this.applicationState.getWaiting()) {\n    if (this.facade.getMediaElement().paused === true) {\n      note = Notifications.PLAY;\n    }\n  }\n  this.sendNotification(note, true);\n};\n\n/**\n * The ToggleFullScreenCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ToggleFullScreenCommand() {\n  ToggleFullScreenCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ToggleFullScreenCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nToggleFullScreenCommand.prototype.execute = function(notification) {\n  var state;\n  state = this.applicationState.getDisplayState() === DisplayState.FULL_SCREEN ? DisplayState.NORMAL : DisplayState.FULL_SCREEN;\n  this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, state);\n};\n\n/**\n * The PlayerCommand class. Base class for commands that need access\n * to the application state or the media\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction PlayerEventCommand() {\n  PlayerEventCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PlayerEventCommand, PlayerCommand);\n\n\n/**\n *\n*/\nPlayerEventCommand.prototype.dispatchEvent = function(type, detail) {\n  var event;\n  if (typeof type !== \"string\") {\n    detail = type.getBody() != null ? type.getBody() : {};\n    type = type.getName();\n  }\n  event = new Event(type.toLowerCase(), detail);\n  this.sendNotification(Notifications.DISPATCH_EVENT, event);\n};\n\n/**\n *\n*/\nPlayerEventCommand.prototype.dispatchEventAfterCommand = function(type, detail) {\n  var _this = this;\n  return new Promise(function(resolve, reject) {\n    var callback;\n    callback = function() {\n      try {\n        _this.dispatchEvent(type, detail);\n        resolve();\n      } catch (error) {\n        _this.facade.logger.error(error);\n        reject(error);\n      }\n    };\n    return setTimeout(callback, 0);\n  });\n};\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nPlayerEventCommand.prototype.execute = function(notification) {\n  this.dispatchEvent(notification);\n};\n\n/**\n * The PlayCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.MacroCommand}\n*/\nfunction PlayingCommand() {\n  PlayingCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PlayingCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nPlayingCommand.prototype.execute = function(notification) {\n  if (this.applicationState.getIsUserActive() === true) {\n    return;\n  }\n  if (this.facade.getMediaElement().currentTime === 0 && this.media.started === false && this.applicationState.getSeeking() === false) {\n    this.media.started = true;\n    this.sendNotification(Notifications.MEDIA_SEQUENCE_STARTED);\n  }\n  if (this.applicationState.getPlayState() === PlayState.PLAYING) {\n    PlayingCommand.__super__.execute.call(this, notification);\n  } else {\n    this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PLAYING);\n  }\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar FullscreenMode = {\n  /**\n   *\n  */\n\n  EXTERNAL: \"external\"\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar ControlsMode = {\n  /**\n   * Constant representing auto controls mode\n  */\n\n  AUTO: \"auto\",\n  /**\n   * Constant representing the persistent controls mode\n  */\n\n  PERSISTENT: \"persistent\",\n  /**\n   * Constant representing none controls mode\n  */\n\n  NONE: \"none\"\n};\n\n/**\n * The PauseCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction PauseCommand() {\n  PauseCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PauseCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nPauseCommand.prototype.execute = function(notification) {\n  this.playback.pause();\n  this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n  PauseCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The ChangeAutoplayCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangeAutoplayCommand() {\n  ChangeAutoplayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeAutoplayCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nChangeAutoplayCommand.prototype.execute = function(notification) {\n  this.config.setAutoplay(notification.getBody());\n};\n\n/**\n * The ChangeLoopCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangeLoopCommand() {\n  ChangeLoopCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeLoopCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nChangeLoopCommand.prototype.execute = function(notification) {\n  this.config.setLoop(notification.getBody());\n};\n\n/**\n * The ChangeVolumeCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangeVolumeCommand() {\n  ChangeVolumeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeVolumeCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChangeVolumeCommand.prototype.execute = function(notification) {\n  var volume;\n  volume = Utils.clamp(notification.getBody(), 0, 1);\n  if (this.playback.getVolume() !== volume) {\n    this.playback.setVolume(volume);\n  }\n};\n\n/**\n * The MediaValidatedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaValidatedCommand() {\n  MediaValidatedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaValidatedCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMediaValidatedCommand.prototype.execute = function(notification) {\n  var canAutoPlay, container, media, mediaElement, muted, playsinline, unmute,\n    _this = this;\n  media = notification.getBody();\n  mediaElement = this.facade.getMediaElement();\n  this.sendNotification(Notifications.MEDIA_CHANGE, media);\n  if (this.applicationState.getPlaybackTarget() !== \"amp\") {\n    return;\n  }\n  canAutoPlay = this.applicationState.getLocked() === false && this.facade.getAutoplay() === true;\n  playsinline = this.config.getPlaysInline();\n  if ((playsinline != null)) {\n    mediaElement.playsInline = playsinline;\n  }\n  muted = this.config.getMuted();\n  if (muted != null) {\n    this.playback.setMuted(muted);\n  }\n  if (canAutoPlay && muted) {\n    container = this.facade.getContainer();\n    unmute = function() {\n      _this.config.setMuted(false);\n      _this.facade.setMuted(false);\n      container.removeEventListener(\"click\", unmute);\n    };\n    container.addEventListener(\"click\", unmute);\n  }\n  if (canAutoPlay) {\n    setTimeout(this.sendNotification.bind(this, Notifications.PLAY, true), 0);\n  }\n};\n\n/**\n * The SeekCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction SeekCommand() {\n  SeekCommand.__super__.constructor.call(this);\n}\n\n\n__extends(SeekCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nSeekCommand.prototype.execute = function(notification) {\n  var time,\n    _this = this;\n  time = notification.getBody();\n  this.facade.transform(TransformType.SEEK, time).then(function(time) {\n    var video;\n    if (time === 0 && _this.media.getType() === Utils.mimeTypes.m3u8) {\n      time = 0.25;\n    }\n    if (time === _this.playback.getCurrentTime()) {\n      return;\n    }\n    if (_this.playback.getStarted() === true) {\n      _this.sendNotification(Notifications.WAITING);\n    }\n    _this.sendNotification(Notifications.DISPLAY_TIME, {\n      currentTime: time,\n      duration: _this.playback.getDuration()\n    });\n    _this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n    video = _this.facade.getMediaElement();\n    _this.playback.setCurrentTime(time);\n    if (_this.playback.getStarted() !== true) {\n      _this.sendNotification(Notifications.TIME_CHANGE, time);\n    }\n  });\n};\n\n/**\n * The SeekingCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction SeekingCommand() {\n  SeekingCommand.__super__.constructor.call(this);\n}\n\n\n__extends(SeekingCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nSeekingCommand.prototype.execute = function(notification) {\n  if (this.applicationState.getSeeking() === true) {\n    this.applicationState.setSeekRequested(true);\n    return;\n  }\n  if (this.applicationState.getEnded()) {\n    this.applicationState.setEnded(false);\n  }\n  if (this.facade.getMediaElement().currentTime === 0) {\n    this.media.started = false;\n  }\n  this.applicationState.setSeeking(true);\n  SeekingCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The SeekedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction SeekedCommand() {\n  SeekedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(SeekedCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nSeekedCommand.prototype.execute = function(notification) {\n  var _this = this;\n  if (this.applicationState.getIsUserActive() === true) {\n    setTimeout(this.sendNotification.bind(this, notification.getName(), notification.getBody()), 100);\n    return;\n  }\n  setTimeout(function() {\n    var state;\n    _this.applicationState.setSeeking(false);\n    _this.dispatchEvent(notification);\n    _this.applicationState.setSeekRequested(false);\n    _this.sendNotification(UserNotifications.SEEKED, notification.getBody());\n    if (_this.applicationState.getPlayState() === PlayState.READY) {\n      return;\n    }\n    if (_this.applicationState.displayState === \"full-screen\" && _this.applicationState.device === \"ipad\" && _this.facade.retrieveProxy(PlaybackProxy.NAME).getPaused() !== _this.facade.getMediaElement().paused) {\n      state = _this.facade.getMediaElement().paused === true ? PlayState.PAUSED : PlayState.PLAYING;\n    }\n    if ((state != null) && state !== \"undefined\") {\n      _this.sendNotification(Notifications.CHANGE_PLAY_STATE, state);\n    }\n  }, 1);\n};\n\n/**\n * The ReplayCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ReplayCommand() {\n  ReplayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ReplayCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nReplayCommand.prototype.execute = function(notification) {\n  if (typeof this.playback.replay === \"function\") {\n    this.playback.replay();\n    return;\n  }\n  this.sendNotification(Notifications.SET_MEDIA, this.media.getData());\n};\n\n/**\n * The EndCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction EndCommand() {\n  EndCommand.__super__.constructor.call(this);\n}\n\n\n__extends(EndCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nEndCommand.prototype.execute = function(notification) {\n  if (this.applicationState.getEnded()) {\n    return;\n  }\n  this.playback.setEnabled(false);\n  this.playback.pause();\n  this.playback.seek(this.playback.getDuration()).then(this.sendNotification.bind(this, Notifications.ENDED));\n};\n\n/**\n * The EndedCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction EndedCommand() {\n  EndedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(EndedCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nEndedCommand.prototype.execute = function(notification) {\n  if (this.applicationState.getEnded()) {\n    return;\n  }\n  this.applicationState.setEnded(true);\n  EndedCommand.__super__.execute.call(this, notification);\n  if (this.config.getLoop() === true) {\n    this.sendNotification(Notifications.REPLAY);\n  } else if (this.applicationState.getHasPostContent() === false) {\n    this.sendNotification(Notifications.MEDIA_SEQUENCE_ENDED);\n  }\n};\n\n/**\n * The StartCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction StartCommand() {\n  StartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(StartCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nStartCommand.prototype.execute = function(notification) {\n  this.sendNotification(Notifications.PLAY_REQUEST);\n  this.sendNotification(Notifications.DISPLAY_TIME, {\n    currentTime: 0,\n    duration: this.media.getDuration()\n  });\n  this.sendNotification(Notifications.STARTED, notification.getBody());\n};\n\n/**\n * The IsUserActiveCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction IsUserActiveCommand() {\n  IsUserActiveCommand.__super__.constructor.call(this);\n}\n\n\n__extends(IsUserActiveCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nIsUserActiveCommand.prototype.execute = function(notification) {\n  this.applicationState.setIsUserActive(notification.getBody());\n};\n\n/**\n * The WaitingCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction WaitingCommand() {\n  WaitingCommand.__super__.constructor.call(this);\n}\n\n\n__extends(WaitingCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nWaitingCommand.prototype.execute = function(notification) {\n  if (this.applicationState.getWaiting()) {\n    return;\n  }\n  this.applicationState.setWaiting(true);\n  WaitingCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The ChangeMutedCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangeMutedCommand() {\n  ChangeMutedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeMutedCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nChangeMutedCommand.prototype.execute = function(notification) {\n  this.playback.setMuted(notification.getBody());\n};\n\n/**\n * The AuthorizedCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction AuthorizedCommand() {\n  AuthorizedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AuthorizedCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAuthorizedCommand.prototype.execute = function(notification) {\n  if (this.security.getSession() != null) {\n    return;\n  }\n  this.security.setSession(Utils.createUID());\n  this.sendNotification(Notifications.MEDIA_VALIDATED, this.media.getData());\n  AuthorizedCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The InitializedCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction InitializedCommand() {\n  InitializedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(InitializedCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nInitializedCommand.prototype.execute = function(notification) {\n  this.playback.initialized = true;\n};\n\n/**\n * The RegisterPlaybackCoreCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction RegisterPlaybackCoreCommand() {\n  RegisterPlaybackCoreCommand.__super__.constructor.call(this);\n}\n\n\n__extends(RegisterPlaybackCoreCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nRegisterPlaybackCoreCommand.prototype.execute = function(notification) {\n  this.playerCore.registerPlaybackCore(notification.getBody());\n};\n\n/**\n * The RecordContentChangeCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction RecordContentChangeCommand() {\n  RecordContentChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(RecordContentChangeCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nRecordContentChangeCommand.prototype.execute = function(notification) {\n  var content;\n  content = notification.getBody();\n  this.sendNotification(Notifications.CHANGE_CONTENT, {\n    from: this.media.getData(),\n    to: content\n  });\n  this.media.updateData(content);\n  this.sendNotification(Notifications.UPDATE_DATA_BINDINGS);\n  this.sendNotification(Notifications.CHANGE_CONTENT, this.media.getData());\n};\n\n/**\n * The TimeupdateCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction TimeUpdateCommand() {\n  TimeUpdateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(TimeUpdateCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nTimeUpdateCommand.prototype.execute = function(notification) {\n  this.sendNotification(Notifications.DISPLAY_TIME, {\n    currentTime: this.applicationState.getCurrentTime(),\n    duration: this.applicationState.getDuration()\n  });\n  TimeUpdateCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The ToggleMutedCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ToggleMutedCommand() {\n  ToggleMutedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ToggleMutedCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nToggleMutedCommand.prototype.execute = function(notification) {\n  this.playback.setMuted(!this.playback.getMuted());\n};\n\n/**\n * The PlayRequestCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction PlayRequestCommand() {\n  PlayRequestCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PlayRequestCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nPlayRequestCommand.prototype.execute = function(notification) {\n  if (this.media.started === true) {\n    return;\n  }\n  this.media.started = true;\n  PlayRequestCommand.__super__.execute.call(this, notification);\n  this.sendNotification(Notifications.WAITING);\n  this.sendNotification(Notifications.MEDIA_SEQUENCE_STARTED);\n};\n\n/**\n * The EnableVideoEventsCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction EnableVideoEventsCommand() {\n  EnableVideoEventsCommand.__super__.constructor.call(this);\n}\n\n\n__extends(EnableVideoEventsCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nEnableVideoEventsCommand.prototype.execute = function(notification) {\n  var event, events, video, _i, _len;\n  video = this.player.getMediaElement();\n  events = notification.getBody();\n  for (_i = 0, _len = events.length; _i < _len; _i++) {\n    event = events[_i];\n    video.addEventListener(event, this.playback.handlers[event]);\n  }\n};\n\n/**\n * The DisableVideoEventsCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction DisableVideoEventsCommand() {\n  DisableVideoEventsCommand.__super__.constructor.call(this);\n}\n\n\n__extends(DisableVideoEventsCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nDisableVideoEventsCommand.prototype.execute = function(notification) {\n  var event, events, video, _i, _len;\n  video = this.player.getMediaElement();\n  events = notification.getBody();\n  for (_i = 0, _len = events.length; _i < _len; _i++) {\n    event = events[_i];\n    video.removeEventListener(event, this.playback.handlers[event]);\n  }\n};\n\n/**\n * The PauseCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction VolumeChangeCommand() {\n  VolumeChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(VolumeChangeCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nVolumeChangeCommand.prototype.execute = function(notification) {\n  this.applicationState.setVolume(notification.getBody());\n  VolumeChangeCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The HasPostContentCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction HasPostContentCommand() {\n  HasPostContentCommand.__super__.constructor.call(this);\n}\n\n\n__extends(HasPostContentCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nHasPostContentCommand.prototype.execute = function(notification) {\n  this.applicationState.setHasPostContent(notification.getBody());\n};\n\n/**\n * The EndedCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction MediaSequenceEndedCommand() {\n  MediaSequenceEndedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaSequenceEndedCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nMediaSequenceEndedCommand.prototype.execute = function(notification) {\n  if (this.config.getLoop() === true) {\n    MediaSequenceEndedCommand.__super__.execute.call(this, notification);\n    this.sendNotification(Notifications.REPLAY);\n  } else {\n    this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.ENDED);\n    this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n    MediaSequenceEndedCommand.__super__.execute.call(this, notification);\n  }\n};\n\n/**\n * The LockCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction LockCommand() {\n  LockCommand.__super__.constructor.call(this);\n}\n\n\n__extends(LockCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nLockCommand.prototype.execute = function(notification) {\n  var locked, note;\n  locked = notification.getBody();\n  note = locked ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;\n  this.sendNotification(note, \"locked\");\n  this.applicationState.setLocked(locked);\n};\n\n/**\n * The SeekCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction GoLiveCommand() {\n  GoLiveCommand.__super__.constructor.call(this);\n}\n\n\n__extends(GoLiveCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nGoLiveCommand.prototype.execute = function(notification) {\n  var _base;\n  if (typeof (_base = this.playback).goLive === \"function\") {\n    _base.goLive();\n  }\n};\n\n/**\n * The TimeChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction TimeChangeCommand() {\n  TimeChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(TimeChangeCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nTimeChangeCommand.prototype.execute = function(notification) {\n  var time,\n    _this = this;\n  time = notification.getBody();\n  if (time.currentTime != null) {\n    this.facade.transform(TransformType.TIME, time.currentTime).then(function(time) {\n      return _this.applicationState.setCurrentTime(time);\n    });\n  }\n  if (time.duration != null) {\n    this.facade.transform(TransformType.TIME, time.duration).then(function(time) {\n      return _this.applicationState.setDuration(time);\n    });\n  }\n};\n\n/**\n * The TimedMetadataCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction TimedMetadataCommand() {\n  TimedMetadataCommand.__super__.constructor.call(this);\n}\n\n\n__extends(TimedMetadataCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nTimedMetadataCommand.prototype.execute = function(notification) {\n  var body, detail, type, value;\n  type = notification.getName();\n  body = notification.getBody();\n  detail = {\n    startTime: body.startTime,\n    endTime: body.endTime,\n    type: body.type,\n    track: body.track,\n    value: {\n      key: body.value.key,\n      data: body.value.data,\n      info: body.value.info\n    }\n  };\n  value = detail.value;\n  try {\n    if (!(value.info != null)) {\n      if (typeof value.data === \"string\") {\n        value.info = value.data;\n      } else if (value.data instanceof ArrayBuffer) {\n        value.info = Utils.arrayBufferToString(value.data);\n      }\n    }\n  } catch (error) {\n    this.facade.logger.log(\"[AMP ERROR]: Could not parse timed metadata\");\n  }\n  notification.body = detail;\n  TimedMetadataCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The ChangeActiveStateCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangeActiveStateCommand() {\n  ChangeActiveStateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeActiveStateCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nChangeActiveStateCommand.prototype.execute = function(notification) {\n  var state;\n  state = this.config.getControls().mode !== ControlsMode.PERSISTENT ? notification.getBody() : ActiveState.ACTIVE;\n  this.applicationState.setActiveState(state);\n};\n\n/**\n * The ChangeDisplayStateCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction ChangeDisplayStateCommand() {\n  ChangeDisplayStateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeDisplayStateCommand, PlayerEventCommand);\n\n\nChangeDisplayStateCommand.interval = null;\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChangeDisplayStateCommand.prototype.execute = function(notification) {\n  var core, fullscreen, state, view,\n    _this = this;\n  state = notification.getBody();\n  if (state === this.applicationState.getDisplayState()) {\n    return;\n  }\n  this.applicationState.setDisplayState(state);\n  if (this.config.getFullscreen().mode === FullscreenMode.EXTERNAL) {\n    this.sendNotifications(state);\n    return;\n  }\n  core = this.facade.getMediaElement();\n  view = this.facade.getViewComponent();\n  fullscreen = Utils.getFullScreenApi(view, core);\n  if (state === DisplayState.FULL_SCREEN) {\n    if (fullscreen.event != null) {\n      if (view.mozRequestFullScreen != null) {\n        document[fullscreen.event] = function(event) {\n          if (!document.mozFullScreen) {\n            return _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n          }\n        };\n      } else {\n        view[fullscreen.event] = function(event) {\n          if (!(document[fullscreen.element] != null)) {\n            return _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n          }\n        };\n      }\n    } else {\n      clearInterval(ChangeDisplayStateCommand.interval);\n      ChangeDisplayStateCommand.interval = setInterval(function() {\n        if (core.webkitDisplayingFullscreen !== true) {\n          _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n          clearInterval(ChangeDisplayStateCommand.interval);\n        }\n      }, 100);\n    }\n    if (fullscreen.error != null) {\n      document.addEventListener(fullscreen.error, this.facade.logger.error.bind(this.facade.logger));\n    }\n    fullscreen.enter();\n  } else if (state === DisplayState.NORMAL) {\n    if (fullscreen != null) {\n      if (typeof fullscreen.exit === \"function\") {\n        fullscreen.exit();\n      }\n    }\n    core[fullscreen.event] = null;\n    clearInterval(ChangeDisplayStateCommand.interval);\n  }\n  this.sendNotifications(state);\n};\n\nChangeDisplayStateCommand.prototype.sendNotifications = function(state) {\n  setTimeout(this.sendNotification.bind(this, Notifications.FULL_SCREEN_CHANGE, state), 100);\n  this.dispatchEvent(\"fullscreenchange\", state === DisplayState.FULL_SCREEN);\n};\n\n/**\n * The PlayCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction PlayCommand() {\n  PlayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PlayCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nPlayCommand.prototype.execute = function(notification) {\n  var userInitiated;\n  if (this.applicationState.getLocked() === true) {\n    return;\n  }\n  userInitiated = notification.getBody();\n  if (userInitiated && this.playback.initialized !== true) {\n    this.sendNotification(Notifications.INITIALIZED);\n  }\n  if (this.playback.initialized !== true || (!this.media.getSrc() && !this.media.getSource())) {\n    return;\n  }\n  if (!this.playback.getStarted()) {\n    this.sendNotification(Notifications.START);\n  }\n  this.playback.play();\n  PlayCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The ToggleActiveCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ToggleActiveCommand() {\n  ToggleActiveCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ToggleActiveCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nToggleActiveCommand.prototype.execute = function(notification) {\n  var state;\n  state = this.applicationState.getActiveState() === ActiveState.ACTIVE ? ActiveState.INACTIVE : ActiveState.ACTIVE;\n  this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, state);\n};\n\nfunction Track(data) {\n  this.data = data != null ? data : {};\n  Track.__super__.constructor.call(this);\n  Object.defineProperties(this, {\n    kind: {\n      get: this.getKind,\n      enumerable: true,\n      configurable: false\n    },\n    label: {\n      get: this.getLabel,\n      enumerable: true,\n      configurable: false\n    },\n    language: {\n      get: this.getLanguage,\n      enumerable: true,\n      configurable: false\n    },\n    id: {\n      get: this.getId,\n      enumerable: true,\n      configurable: false\n    },\n    enabled: {\n      get: this.getEnabled,\n      set: this.setEnabled,\n      enumerable: true,\n      configurable: false\n    }\n  });\n}\n\n\n__extends(Track, EventDispatcher);\n\n\nTrack.prototype.getKind = function() {\n  return this.data.kind;\n};\n\nTrack.prototype.getLabel = function() {\n  return this.data.label;\n};\n\nTrack.prototype.getLanguage = function() {\n  return this.data.language;\n};\n\nTrack.prototype.getId = function() {\n  return this.data.id;\n};\n\nTrack.prototype.setEnabled = function(value) {\n  if (value === this.data.enabled) {\n    return;\n  }\n  this.data.enabled = value;\n  this.changeEnabled(value);\n  this.dispatchEvent(\"change\");\n};\n\nTrack.prototype.changeEnabled = function(value) {};\n\nTrack.prototype.getEnabled = function() {\n  return this.data.enabled;\n};\n\nTrack.prototype.flatten = function() {\n  return {\n    kind: this.getKind(),\n    label: this.getLabel(),\n    language: this.getLanguage(),\n    id: this.getId(),\n    enabled: this.getEnabled()\n  };\n};\n\nfunction XMLUtils() {}\n\nXMLUtils.createTextContent = function(xml, text) {\n  var node;\n  node = /[\\&<>]/.test(text) ? xml.createCDATASection(text) : xml.createTextNode(text);\n  return node;\n};\n\nXMLUtils.updateTextContent = function(node, str) {\n  var text;\n  text = XMLUtils.createTextContent(node.ownerDocument, str);\n  node.removeChild(node.childNodes[0]);\n  node.appendChild(text);\n  return node;\n};\n\nXMLUtils.serialize = function(xml) {\n  var serializer;\n  if (!(xml != null)) {\n    return;\n  }\n  if (typeof xml === \"string\") {\n    return xml;\n  }\n  try {\n    serializer = new XMLSerializer();\n    return serializer.serializeToString(xml);\n  } catch (err1) {\n    try {\n      serializer = document.implementation.createLSSerializer();\n      return xmlSerializer.writeToString(xml);\n    } catch (err3) {\n      try {\n        return xml.xml;\n      } catch (err2) {\n\n      }\n    }\n  }\n};\n\nXMLUtils.parse = function(text) {\n  var parser, xmlDoc;\n  if (window.DOMParser) {\n    parser = new DOMParser();\n    xmlDoc = parser.parseFromString(text, \"text/xml\");\n  } else {\n    xmlDoc = new ActiveXObject(\"Microsoft.XMLDOM\");\n    xmlDoc.async = false;\n    xmlDoc.loadXML(text);\n  }\n  return xmlDoc;\n};\n\n/**\n * Creates a new instance of TracksProxy.\n * \n * @constructor\n * @private\n * @extends {DataBindingContext}\n*/\nfunction TracksProxy() {\n  TracksProxy.__super__.constructor.call(this, null, {});\n  this.data.audioTracks = new TrackList();\n  this.data.videoTracks = new TrackList();\n  this.data.textTracks = new TrackList();\n}\n\n\n__extends(TracksProxy, puremvc.Proxy);\n\n\n/** @static\n*/\nTracksProxy.NAME = \"TracksProxy\";\n\nTracksProxy.prototype.clear = function() {\n  this.data.audioTracks.clear();\n  this.data.videoTracks.clear();\n  this.data.textTracks.clear();\n};\n\nTracksProxy.prototype.getAudioTracks = function() {\n  return this.data.audioTracks;\n};\n\nTracksProxy.prototype.getVideoTracks = function() {\n  return this.data.videoTracks;\n};\n\nTracksProxy.prototype.getTextTracks = function() {\n  return this.data.textTracks;\n};\n\n/**\n * The base player class.\n *\n * @param {Object} config\n * @param {Object} viewComponent\n * @constructor\n * @private\n * @extends {Module}\n*/\nfunction Player(viewComponent) {\n  var _this = this;\n  Player.__super__.constructor.call(this, viewComponent);\n  this.ads = new EventDispatcher();\n  this.ads.enabled = false;\n  this.ads.getEnabled = function() {\n    return false;\n  };\n  this.ads.inprogress = false;\n  this.ads.getInProgress = function() {\n    return false;\n  };\n}\n\n\n__extends(Player, Module);\n\n\nPlayer.prototype.moduleName = \"amp\";\n\nPlayer.prototype.playerType = null;\n\nPlayer.prototype.hidden = false;\n\nPlayer.prototype.l10n = null;\n\nPlayer.prototype.appState = null;\n\nPlayer.prototype.mediaProxy = null;\n\nPlayer.prototype.bindings = null;\n\nPlayer.prototype.configuration = null;\n\nPlayer.prototype.params = null;\n\nPlayer.prototype.security = null;\n\nPlayer.prototype.createModel = function() {\n  this.appState = new ApplicationStateProxy();\n  this.registerProxy(this.appState);\n  this.bindings = new DataBindingProxy();\n  this.registerProxy(this.bindings);\n  this.security = new SecurityProxy();\n  this.registerProxy(this.security);\n  this.mediaProxy = new MediaProxy(this.config);\n  this.registerProxy(this.mediaProxy);\n  this.params = new ParamsProxy(this.config.params);\n  this.registerProxy(this.params);\n  this.configuration = new ConfigurationProxy(this.config);\n  this.registerProxy(this.configuration);\n};\n\n/** @override\n*/\nPlayer.prototype.resourcesLoaded = function() {\n  Player.__super__.resourcesLoaded.call(this);\n  Object.defineProperties(this, {\n    src: {\n      get: this.getSrc,\n      set: this.setSrc,\n      enumerable: true,\n      configurable: false\n    },\n    media: {\n      get: this.getMedia,\n      set: this.setMedia,\n      enumerable: true,\n      configurable: false\n    },\n    currentTime: {\n      get: this.getCurrentTime,\n      set: this.setCurrentTime,\n      enumerable: true,\n      configurable: false\n    },\n    autoplay: {\n      get: this.getAutoplay,\n      set: this.setAutoplay,\n      enumerable: true,\n      configurable: false\n    },\n    duration: {\n      get: this.getDuration,\n      enumerable: true,\n      configurable: false\n    },\n    playState: {\n      get: this.getPlayState,\n      enumerable: true,\n      configurable: false\n    },\n    seeking: {\n      get: this.getSeeking,\n      enumerable: true,\n      configurable: false\n    },\n    paused: {\n      get: this.getPaused,\n      enumerable: true,\n      configurable: false\n    },\n    ended: {\n      get: this.getEnded,\n      enumerable: true,\n      configurable: false\n    },\n    volume: {\n      get: this.getVolume,\n      set: this.setVolume,\n      enumerable: true,\n      configurable: false\n    },\n    muted: {\n      get: this.getMuted,\n      set: this.setMuted,\n      enumerable: true,\n      configurable: false\n    },\n    mediaElement: {\n      get: this.getMediaElement,\n      enumerable: true,\n      configurable: false\n    },\n    textTracks: {\n      get: (function() {\n        return this.getMediaElement().textTracks;\n      }),\n      enumerable: true,\n      configurable: false\n    },\n    audioTracks: {\n      get: this.getAudioTracks,\n      enumerable: true,\n      configurable: false\n    },\n    container: {\n      get: this.getContainer,\n      enumerable: true,\n      configurable: false\n    },\n    loop: {\n      get: this.getLoop,\n      set: this.setLoop,\n      enumerable: true,\n      configurable: false\n    },\n    displayState: {\n      get: this.getDisplayState,\n      set: this.setDisplayState,\n      enumerable: true,\n      configurable: false\n    },\n    playbackRate: {\n      get: this.getPlaybackRate,\n      set: this.setPlaybackRate,\n      enumerable: true,\n      configurable: false\n    },\n    language: {\n      get: this.getLanguage,\n      set: this.setLanguage,\n      enumerable: true,\n      configurable: false\n    },\n    localization: {\n      get: (function() {\n        return this.retrieveProxy(LocalizationProxy.NAME);\n      }),\n      enumerable: true,\n      configurable: false\n    },\n    version: {\n      get: this.getVersion,\n      enumerable: true,\n      configurable: false\n    },\n    error: {\n      get: this.getError,\n      enumerable: true,\n      configurable: false\n    },\n    hidden: {\n      get: this.getHidden,\n      set: this.setHidden,\n      enumerable: true,\n      configurable: false\n    },\n    waiting: {\n      get: this.getWaiting,\n      set: this.setWaiting,\n      enumerable: true,\n      configurable: false\n    },\n    busy: {\n      get: this.getBusy,\n      set: this.setBusy,\n      enumerable: true,\n      configurable: false\n    },\n    cues: {\n      get: this.getCues,\n      set: this.setCues,\n      enumerable: true,\n      configurable: false\n    },\n    quality: {\n      get: this.getQuality,\n      set: this.setQuality,\n      enumerable: true,\n      configurable: false\n    },\n    qualityMode: {\n      get: this.getQualityMode,\n      set: this.setQualityMode,\n      enumerable: true,\n      configurable: false\n    },\n    qualityLevels: {\n      get: this.getQualityLevels,\n      enumerable: true,\n      configurable: false\n    },\n    debug: {\n      get: this.getDebug,\n      enumerable: true,\n      configurable: false\n    },\n    settings: {\n      get: this.getSettings,\n      enumerable: true,\n      configurable: false\n    },\n    mode: {\n      get: this.getMode,\n      enumerable: true,\n      configurable: false\n    },\n    buffering: {\n      get: this.getBuffering,\n      enumerable: true,\n      configurable: false\n    },\n    width: {\n      get: this.getWidth,\n      enumerable: true,\n      configurable: false\n    },\n    height: {\n      get: this.getHeight,\n      enumerable: true,\n      configurable: false\n    },\n    videoWidth: {\n      get: this.getVideoWidth,\n      enumerable: true,\n      configurable: false\n    },\n    videoHeight: {\n      get: this.getVideoHeight,\n      enumerable: true,\n      configurable: false\n    },\n    defaultMediaTransform: {\n      get: this.mediaProxy.transform,\n      enumerable: true,\n      configurable: false\n    },\n    absoluteCurrentTime: {\n      get: this.getAbsoluteCurrentTime,\n      set: this.setAbsoluteCurrentTime,\n      enumerable: true,\n      configurable: false\n    },\n    absoluteDuration: {\n      get: this.getAbsoluteDuration,\n      enumerable: true,\n      configurable: false\n    },\n    playbackTarget: {\n      get: this.getPlaybackTarget,\n      set: this.setPlaybackTarget,\n      enumerable: true,\n      configurable: false\n    }\n  });\n};\n\n/** @override\n*/\nPlayer.prototype.createView = function() {\n  this._settings = new SettingsMediator();\n  this.registerMediator(this._settings);\n};\n\n/** @override\n*/\nPlayer.prototype.createController = function() {\n  Player.__super__.createController.call(this);\n  this.registerCommand(Notifications.CHANGE_SETTINGS, ChangeSettingsCommand);\n  this.registerCommand(Notifications.SETTINGS_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.CUES_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.DESTROY, PlayerEventCommand);\n};\n\n/** @override\n*/\nPlayer.prototype.setViewComponent = function(viewComponent) {\n  viewComponent[\"amp\"] = this;\n  return Player.__super__.setViewComponent.call(this, viewComponent);\n};\n\n/**\n*/\nPlayer.prototype.getPlayerType = function() {\n  return this.playerType;\n};\n\n/**\n*/\nPlayer.prototype.getVersion = function() {\n  return AMP.getVersion();\n};\n\n/**\n*/\nPlayer.prototype.getDebug = function() {\n  return this.config.debug;\n};\n\n/**\n*/\nPlayer.prototype.getMode = function() {\n  return this.config.mode;\n};\n\n/**\n*/\nPlayer.prototype.createPlugins = function() {\n  this.sendNotification(PluginNotifications.REGISTER_PLUGINS, this.config);\n};\n\n/**\n*/\nPlayer.prototype.createMediaElement = function() {\n  return null;\n};\n\n/** @override\n*/\nPlayer.prototype.createFramework = function() {\n  Player.__super__.createFramework.call(this);\n  this.setMediaElement(this.createMediaElement());\n  this.createPlugins();\n};\n\n/**\n*/\nPlayer.prototype.getLanguage = function() {\n  return this.retrieveProxy(LocalizationProxy.NAME).getLanguage();\n};\n\n/**\n*/\nPlayer.prototype.setLanguage = function(value) {\n  this.retrieveProxy(LocalizationProxy.NAME).setLanguage(value);\n  return value;\n};\n\n/**\n*/\nPlayer.prototype.getLocalizedString = function(value, context) {\n  try {\n    return this.retrieveProxy(LocalizationProxy.NAME).getString(value, context);\n  } catch (error) {\n    return value;\n  }\n};\n\n/**\n * @return {HTMLObject|HTMLMediaElement} The media playback DOM element.\n*/\nPlayer.prototype.getMediaElement = function() {\n  return this.appState.getMediaElement();\n};\n\n/**\n*/\nPlayer.prototype.setMediaElement = function(value) {\n  this.appState.setMediaElement(value);\n  if (!(value.once != null)) {\n    value.once = function(type, listener) {\n      var handler, id;\n      id = Utils.createUID();\n      handler = function(id, type, listener, event) {\n        this.removeEventListener(type, this[id]);\n        delete this[id];\n        listener(event);\n      };\n      this[id] = handler.bind(this, id, type, listener);\n      this.addEventListener(type, this[id]);\n    };\n    value.once = value.once.bind(value);\n  }\n  value.amp = this;\n  return value;\n};\n\n/**\n * @return {HTMLElement} The container div.\n*/\nPlayer.prototype.getContainer = function() {\n  return this.getViewComponent();\n};\n\n/**\n * @return {HTMLElement} The container div.\n*/\nPlayer.prototype.getAudioTracks = function() {};\n\n/**\n * @param   {Object}  binding\n *    A data bound object to evaluate.\n *\n * @param   {?Object}  context\n *    Context object to pass to the bindings\n *\n * @return {Object}\n *    The evaluated result\n*/\nPlayer.prototype.evaluateBindings = function(binding, context) {\n  return DataBinding.evaluateBindings(binding, Utils.override(this.bindings.data, context));\n};\n\n/**\n * Determines if the core can play a given mimeType.\n *\n * @param   {string}  type\n *    The mimetype to check.\n *\n * @return  {string}  \"\"\n *    if the core can't play the mimeType\n*/\nPlayer.prototype.canPlayType = function(type) {};\n\n/**\n * Loads the video.\n*/\nPlayer.prototype.load = function() {};\n\n/**\n * Plays the currently loaded video.\n*/\nPlayer.prototype.play = function() {};\n\n/**\n * Plays the currently loaded video from its start time.\n*/\nPlayer.prototype.replay = function() {};\n\n/**\n * Pauses the currently loaded video.\n*/\nPlayer.prototype.pause = function() {};\n\n/**\n * Ends video playback.\n*/\nPlayer.prototype.end = function() {};\n\n/**\n * Sets user params.\n *\n * @param {Object} value The user params object.\n*/\nPlayer.prototype.setParams = function(value) {};\n\n/**\n * Gets user params.\n *\n * @return {Object} The user params object.\n*/\nPlayer.prototype.getParams = function() {};\n\n/**\n * Sets auto play flag.\n *\n * @param {boolean} value The autoplay flash.\n*/\nPlayer.prototype.setAutoplay = function(value) {};\n\n/**\n * Gets auto play flag.\n *\n * @return {boolean} The autoplay flash.\n*/\nPlayer.prototype.getAutoplay = function() {};\n\n/**\n * Sets player's loop flag.\n *\n * @param {boolean} value The loop flag.\n*/\nPlayer.prototype.setLoop = function(value) {};\n\n/**\n * Gets player's loop flag.\n *\n * @return {boolean} The loop flag.\n*/\nPlayer.prototype.getLoop = function() {};\n\n/**\n * Sets player's muted value.\n *\n * @param {boolean} value The muted value.\n*/\nPlayer.prototype.setMuted = function(value) {};\n\n/**\n * Gets player's muted value.\n *\n * @return {boolean} The muted value.\n*/\nPlayer.prototype.getMuted = function() {};\n\n/**\n * Mutes the player.\n*/\nPlayer.prototype.mute = function() {\n  return this.setMuted(true);\n};\n\n/**\n * Unmutes the player.\n*/\nPlayer.prototype.unmute = function() {\n  return this.setMuted(false);\n};\n\n/**\n * Sets the media object.\n *\n * @param {Object} value The media object for the video to play.\n*/\nPlayer.prototype.setMedia = function(value) {};\n\n/**\n * Gets the media object.\n *\n * @return {Object} The media object for the video to play.\n*/\nPlayer.prototype.getMedia = function() {};\n\n/**\n * Sets the current time of the video.\n *\n * @param {number} value The desired time to seek to.\n*/\nPlayer.prototype.setCurrentTime = function(value) {};\n\n/**\n * Gets the current time of the video.\n *\n * @return {number} The current playhead time.\n*/\nPlayer.prototype.getCurrentTime = function() {};\n\n/**\n * Sets the current time of the video.\n *\n * @param {number} value The desired time to seek to.\n*/\nPlayer.prototype.setAbsoluteCurrentTime = function(value) {\n  return this.setCurrentTime(value);\n};\n\n/**\n * Gets the current time of the video.\n *\n * @return {number} The current playhead time.\n*/\nPlayer.prototype.getAbsoluteCurrentTime = function() {\n  return this.getCurrentTime();\n};\n\n/**\n * Gets the current time of the video as a UTC timestamp.\n *\n * @return {number} The current playhead time as a UTC timestamp.\n*/\nPlayer.prototype.getCurrentTimeUTC = function() {};\n\n/**\n * Gets the current time of the video.\n *\n * @return {number} The current time of the video.\n*/\nPlayer.prototype.getDuration = function() {};\n\n/**\n * Gets the current time of the video.\n *\n * @return {number} The current time of the video.\n*/\nPlayer.prototype.getAbsoluteDuration = function() {\n  return this.getDuration();\n};\n\n/**\n * Sets the source url of video.\n *\n * @param {string} value The source url of the video to play.\n*/\nPlayer.prototype.setSrc = function(value) {};\n\n/**\n * Gets the source url of video.\n *\n * @return {string} The source url of the video to play.\n*/\nPlayer.prototype.getSrc = function() {};\n\n/**\n * Sets the source url of video.\n *\n * @param {Array.<Object>} value An array of source objects to choose from.\n*/\nPlayer.prototype.setSource = function(value) {};\n\n/**\n * Gets the source url of video.\n *\n * @return {Array.<Object>} An array of source objects to choose from.\n*/\nPlayer.prototype.getSource = function() {};\n\n/**\n * Sets the source url of video.\n *\n * @param {number} value The source url of the video to play.\n*/\nPlayer.prototype.setVolume = function(value) {};\n\n/**\n * Gets the source url of video.\n *\n * @return {number} The volume a number between 0 and 1.\n*/\nPlayer.prototype.getVolume = function() {};\n\n/**\n * The seeking flag.\n *\n * @return {boolean} The seeking flag.\n*/\nPlayer.prototype.getSeeking = function() {};\n\n/**\n * The paused flag.\n *\n * @return {boolean} The paused flag.\n*/\nPlayer.prototype.getPaused = function() {};\n\n/**\n * The ended flag.\n *\n * @return {boolean} The ended flag.\n*/\nPlayer.prototype.getEnded = function() {};\n\n/**\n * The buffering flag.\n *\n * @return {boolean} The buffering flag.\n*/\nPlayer.prototype.getBuffering = function() {\n  return this.appState.getBuffering();\n};\n\n/**\n * Sets the player's display state.\n *\n * @param {DisplayState} value\n *    The display state.\n*/\nPlayer.prototype.setDisplayState = function(value) {};\n\n/**\n * Returns the player's display state.\n *\n * @return {DisplayState}\n *    The display state.\n*/\nPlayer.prototype.getDisplayState = function() {};\n\n/**\n * Returns the player's waiting state.\n *\n * @return {boolean}\n *    The waiting state.\n*/\nPlayer.prototype.getWaiting = function() {\n  return this.appState.getWaiting();\n};\n\n/**\n * Sets the player's waiting state.\n *\n * @param {boolean} value\n *    The waiting state.\n*/\nPlayer.prototype.setWaiting = function(value) {\n  return this.appState.setWaiting(value);\n};\n\n/**\n * Returns the player's busy state.\n *\n * @return {boolean}\n *    The busy state.\n*/\nPlayer.prototype.getBusy = function() {\n  return this.appState.getBusy();\n};\n\n/**\n * Sets the player's busy state.\n *\n * @param {boolean} value\n *    The busy state.\n*/\nPlayer.prototype.setBusy = function(value) {\n  return this.appState.setBusy(value);\n};\n\n/**\n * Returns the player error.\n *\n * @return {Error}\n *    The Error\n*/\nPlayer.prototype.getError = function() {};\n\n/**\n * Enters the player into full screen mode.\n*/\nPlayer.prototype.enterFullScreen = function() {};\n\n/**\n * Exits the player out of full screen mode.\n*/\nPlayer.prototype.exitFullScreen = function() {};\n\n/**\n * Show the player\n*/\nPlayer.prototype.setHidden = function(value) {\n  var style;\n  if (value === this.appState.getHidden()) {\n    return;\n  }\n  this.appState.setHidden(value);\n  style = this.viewComponent.style;\n  if (value === true) {\n    this.hiddenData = {\n      width: style.width,\n      height: style.height,\n      paused: this.getPaused()\n    };\n    style.width = style.height = \"0px\";\n    if (this.hiddenData.paused === false) {\n      this.pause();\n    }\n  } else {\n    style.width = this.hiddenData.width;\n    style.height = this.hiddenData.height;\n    if (this.hiddenData.paused === false) {\n      this.play();\n    }\n    this.hiddenData = null;\n  }\n};\n\n/**\n * Hide the player\n*/\nPlayer.prototype.getHidden = function() {\n  return this.appState.getHidden();\n};\n\n/**\n * The player's width\n*/\nPlayer.prototype.getWidth = function() {\n  var _ref;\n  return (_ref = this.getViewComponent()) != null ? _ref.offsetWidth : void 0;\n};\n\n/**\n * The player's height\n*/\nPlayer.prototype.getHeight = function() {\n  var _ref;\n  return (_ref = this.getViewComponent()) != null ? _ref.offsetWidth : void 0;\n};\n\n/**\n * The media's source width\n*/\nPlayer.prototype.getVideoWidth = function() {\n  var _ref;\n  return (_ref = this.getMediaElement()) != null ? _ref.videoWidth : void 0;\n};\n\n/**\n * The media's source height\n*/\nPlayer.prototype.getVideoHeight = function() {\n  var _ref;\n  return (_ref = this.getMediaElement()) != null ? _ref.videoHeight : void 0;\n};\n\n/**\n * Records a content change\n *\n * @param {Object} content\n *    An object representing the new content\n*/\nPlayer.prototype.recordContentChange = function(content) {};\n\n/**\n * Sets the rate of playback.\n*/\nPlayer.prototype.setPlaybackRate = function() {};\n\n/**\n * Gets the rate of playback.\n*/\nPlayer.prototype.getPlaybackRate = function() {};\n\n/**\n * Sets the list of cues.\n*/\nPlayer.prototype.setCues = function(value) {\n  this.mediaProxy.setCues(value);\n  return value;\n};\n\n/**\n * Gets the list of cues.\n*/\nPlayer.prototype.getCues = function() {\n  return this.mediaProxy.getCues();\n};\n\n/**\n *\n*/\nPlayer.prototype.setQuality = function(value) {};\n\n/**\n *\n*/\nPlayer.prototype.getQuality = function() {};\n\n/**\n *\n*/\nPlayer.prototype.getQualityLevels = function() {};\n\n/**\n *\n*/\nPlayer.prototype.getQualityMode = function() {};\n\n/**\n *\n*/\nPlayer.prototype.setQualityMode = function(value) {};\n\n/**\n * Gets the play state.\n*/\nPlayer.prototype.getPlaystate = function() {};\n\n/**\n *\n*/\nPlayer.prototype.getPlaybackTarget = function() {\n  return this.appState.getPlaybackTarget();\n};\n\n/**\n *\n*/\nPlayer.prototype.setPlaybackTarget = function(value) {\n  this.appState.setPlaybackTarget(value);\n};\n\n/**\n * Gets the list of media transforms\n*/\nPlayer.prototype.getMediaTransforms = function() {\n  return this.mediaProxy.getTransforms();\n};\n\n/**\n * Authorizes a protected stream\n*/\nPlayer.prototype.authorize = function(authorization) {\n  this.security.authorize(authorization);\n};\n\n/**\n * Force the player into live mode during DVR playback\n*/\nPlayer.prototype.goLive = function() {};\n\n/**\n *\n*/\nPlayer.prototype.appendChild = function(element) {\n  this.mediator.addLayer(element);\n};\n\n/**\n *\n*/\nPlayer.prototype.removeChild = function(element) {\n  this.mediator.removeLayer(element);\n};\n\n/**\n *\n*/\nPlayer.prototype.getSettings = function() {\n  var _ref;\n  return ((_ref = this._settings) != null ? _ref.getSettings() : void 0) || {\n    change: function() {}\n  };\n};\n\n/**\n * @override\n*/\nPlayer.prototype.destroy = function() {\n  this.sendNotification(Notifications.DESTROY);\n  Player.__super__.destroy.call(this);\n};\n\n/**\n * The HTMLPlayer class.\n *\n * @param {Object} viewComponent\n * @constructor\n * @private\n * @extends {Player}\n*/\nfunction HTMLPlayer(viewComponent) {\n  HTMLPlayer.__super__.constructor.call(this, viewComponent);\n}\n\n\n__extends(HTMLPlayer, Player);\n\n\nHTMLPlayer.prototype.playerType = \"html\";\n\nHTMLPlayer.prototype.playerCore = null;\n\nHTMLPlayer.prototype.tracks = null;\n\nHTMLPlayer.prototype.mediator = null;\n\n/** @override\n*/\nHTMLPlayer.prototype.createMediaElement = function() {\n  var viewComponent;\n  this.mediator = new MediaElementMediator(\"html5\", \"video\");\n  this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, this.mediator);\n  viewComponent = this.mediator.getViewComponent();\n  if (viewComponent.dataset == null) {\n    viewComponent.dataset = {};\n  }\n  return viewComponent;\n};\n\n/** @override\n*/\nHTMLPlayer.prototype.createModel = function() {\n  var playbackProxy;\n  HTMLPlayer.__super__.createModel.call(this);\n  this.registerProxy(new LocalizationProxy(this.config));\n  playbackProxy = new PlaybackCoreProxy();\n  this.registerProxy(playbackProxy);\n  this.playerCore = new PlayerProxy(playbackProxy, this.config.getPlaybackOrder);\n  this.registerProxy(this.playerCore);\n  this.tracks = new TracksProxy();\n  this.registerProxy(this.tracks);\n  this.appState.setRenderMode(RenderMode.HTML);\n  this.bindings.initialize();\n  this.fps = Utils.override(FPS, this.config.fps);\n};\n\n/** @override\n*/\nHTMLPlayer.prototype.createView = function() {\n  HTMLPlayer.__super__.createView.call(this);\n  this.mediator = new PlayerMediator(\"html5\", this.getViewComponent());\n  this.registerMediator(this.mediator);\n  this.registerMediator(new PluginAdapter());\n  this.registerMediator(new VideoLayerMediator());\n  this.registerMediator(new OverlayLayerMediator());\n};\n\n/** @override\n*/\nHTMLPlayer.prototype.createController = function() {\n  HTMLPlayer.__super__.createController.call(this);\n  this.registerCommand(PluginNotifications.PLUGINS_INITIALIZED, PluginsInitializedCommand);\n  this.registerCommand(Notifications.PLAY, PlayCommand);\n  this.registerCommand(Notifications.PLAYING, PlayingCommand);\n  this.registerCommand(Notifications.PAUSE, PauseCommand);\n  this.registerCommand(Notifications.CHANGE_PLAY_STATE, ChangePlayStateCommand);\n  this.registerCommand(Notifications.TOGGLE_FULL_SCREEN, ToggleFullScreenCommand);\n  this.registerCommand(Notifications.CHANGE_DISPLAY_STATE, ChangeDisplayStateCommand);\n  this.registerCommand(Notifications.TOGGLE_ACTIVE, ToggleActiveCommand);\n  this.registerCommand(Notifications.CHANGE_ACTIVE_STATE, ChangeActiveStateCommand);\n  this.registerCommand(Notifications.SET_MEDIA, SetMediaCommand);\n  this.registerCommand(Notifications.CHANGE_MEDIA, ChangeMediaCommand);\n  this.registerCommand(Notifications.MEDIA_VALIDATED, MediaValidatedCommand);\n  this.registerCommand(Notifications.MEDIA_CHANGE, MediaChangeCommand);\n  this.registerCommand(Notifications.UPDATE_DATA_BINDINGS, UpdateDataBindingsCommand);\n  this.registerCommand(Notifications.START, StartCommand);\n  this.registerCommand(Notifications.TIME_CHANGE, TimeChangeCommand);\n  this.registerCommand(Notifications.SEEK, SeekCommand);\n  this.registerCommand(Notifications.SEEKING, SeekingCommand);\n  this.registerCommand(Notifications.SEEKED, SeekedCommand);\n  this.registerCommand(Notifications.CHANGE_VOLUME, ChangeVolumeCommand);\n  this.registerCommand(Notifications.CHANGE_MUTED, ChangeMutedCommand);\n  this.registerCommand(Notifications.CHANGE_AUTOPLAY, ChangeAutoplayCommand);\n  this.registerCommand(Notifications.CHANGE_LOOP, ChangeLoopCommand);\n  this.registerCommand(Notifications.END, EndCommand);\n  this.registerCommand(Notifications.ENDED, EndedCommand);\n  this.registerCommand(Notifications.REPLAY, ReplayCommand);\n  this.registerCommand(Notifications.ERROR, ErrorCommand);\n  this.registerCommand(Notifications.READY, ReadyCommand);\n  this.registerCommand(Notifications.WAITING, WaitingCommand);\n  this.registerCommand(Notifications.CHANGE_DURATION, ChangeDurationCommand);\n  this.registerCommand(Notifications.CHANGE_PARAMS, ChangeParamsCommand);\n  this.registerCommand(Notifications.IS_USER_ACTIVE, IsUserActiveCommand);\n  this.registerCommand(SecurityNotifications.AUTHORIZED, AuthorizedCommand);\n  this.registerCommand(Notifications.INITIALIZED, InitializedCommand);\n  this.registerCommand(Notifications.REGISTER_PLAYBACK_CORE, RegisterPlaybackCoreCommand);\n  this.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, TogglePlayPauseCommand);\n  this.registerCommand(UserNotifications.SEEK, SeekCommand);\n  this.registerCommand(Notifications.PLAYBACK_TARGET_CHANGE, PlaybackTargetChangeCommand);\n  this.registerCommand(Notifications.RECORD_CONTENT_CHANGE, RecordContentChangeCommand);\n  this.registerCommand(Notifications.TIME_UPDATE, TimeUpdateCommand);\n  this.registerCommand(Notifications.TOGGLE_MUTED, ToggleMutedCommand);\n  this.registerCommand(Notifications.VOLUME_CHANGE, VolumeChangeCommand);\n  this.registerCommand(Notifications.PLAY_REQUEST, PlayRequestCommand);\n  this.registerCommand(Notifications.HAS_POST_CONTENT, HasPostContentCommand);\n  this.registerCommand(Notifications.LOCK, LockCommand);\n  this.registerCommand(UserNotifications.GO_LIVE, GoLiveCommand);\n  this.registerCommand(Notifications.BUFFERING_CHANGE, BufferingChangeCommand);\n  this.registerCommand(Notifications.TIMED_METADATA, TimedMetadataCommand);\n  this.registerCommand(Notifications.PLAY_STATE_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.PROGRESS, PlayerEventCommand);\n  this.registerCommand(Notifications.CAN_PLAY, PlayerEventCommand);\n  this.registerCommand(Notifications.CAN_PLAY_THROUGH, PlayerEventCommand);\n  this.registerCommand(Notifications.LOAD_START, PlayerEventCommand);\n  this.registerCommand(Notifications.STARTED, PlayerEventCommand);\n  this.registerCommand(Notifications.LOADED_METADATA, PlayerEventCommand);\n  this.registerCommand(Notifications.DURATION_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.MEDIUM_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.TEMPORAL_TYPE_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.LANGUAGE_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.PLAYBACK_TARGET_AVAILABILITY_CHANGE, PlayerEventCommand);\n  this.registerCommand(SecurityNotifications.AUTHORIZE, PlayerEventCommand);\n  this.registerCommand(SecurityNotifications.AUTHORIZATION_FAILED, PlayerEventCommand);\n  this.registerCommand(SecurityNotifications.AUTHENTICATION_FAILED, PlayerEventCommand);\n  this.registerCommand(SecurityNotifications.AUTHORIZATION_EXPIRED, PlayerEventCommand);\n  this.registerCommand(Notifications.FAIL_OVER_ATTEMPT, PlayerEventCommand);\n  this.registerCommand(Notifications.IS_LIVE, PlayerEventCommand);\n  this.registerCommand(Notifications.PAUSED, PlayerEventCommand);\n  this.registerCommand(Notifications.STALLED, PlayerEventCommand);\n  this.registerCommand(Notifications.QUALITY_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.QUALITY_SWITCHED, PlayerEventCommand);\n  this.registerCommand(Notifications.QUALITY_CHANGING, PlayerEventCommand);\n  this.registerCommand(Notifications.QUALITY_LEVELS_LOADED, PlayerEventCommand);\n  this.registerCommand(Notifications.MUTE_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.RESUME, PlayerEventCommand);\n  this.registerCommand(Notifications.FRAGMENT_LOAD_START, PlayerEventCommand);\n  this.registerCommand(Notifications.FRAGMENT_LOADED, PlayerEventCommand);\n  this.registerCommand(Notifications.AUTOPLAY_BLOCKED, PlayerEventCommand);\n  this.registerCommand(Notifications.AUDIO_TRACK_SWITCH, PlayerEventCommand);\n  this.registerCommand(Notifications.MEDIA_SEQUENCE_STARTED, PlayerEventCommand);\n  this.registerCommand(Notifications.MEDIA_SEQUENCE_ENDED, MediaSequenceEndedCommand);\n  this.registerCommand(Notifications.ENABLE_VIDEO_EVENTS, EnableVideoEventsCommand);\n  this.registerCommand(Notifications.DISABLE_VIDEO_EVENTS, DisableVideoEventsCommand);\n};\n\n/** @override\n*/\nHTMLPlayer.prototype.setMediaElement = function(value) {\n  var mediaElement;\n  mediaElement = this.getMediaElement();\n  if (mediaElement != null) {\n    mediaElement.removeEventListener(\"webkitpresentationmodechanged\", this.presentationModeChanged);\n  }\n  value.addEventListener(\"webkitpresentationmodechanged\", this.presentationModeChanged);\n  HTMLPlayer.__super__.setMediaElement.call(this, value);\n  return value;\n};\n\n/**\n * HACK: Fix for iOS 10 manipulating controls property incorrectly after leaving fullscreen\n*/\nHTMLPlayer.prototype.presentationModeChanged = function(event) {\n  if (\"inline\" === event.target.webkitPresentationMode) {\n    event.target.controls = false;\n  }\n};\n\nHTMLPlayer.prototype.recordContentChange = function(content) {\n  this.sendNotification(Notifications.RECORD_CONTENT_CHANGE, content);\n};\n\nHTMLPlayer.prototype.canPlayType = function(type) {\n  return this.retrieveProxy(PlaybackProxy.NAME).canPlayType(type);\n};\n\nHTMLPlayer.prototype.getAudioTracks = function() {\n  return this.retrieveProxy(TracksProxy.NAME).getAudioTracks();\n};\n\nHTMLPlayer.prototype.load = function() {\n  this.sendNotification(Notifications.LOAD);\n};\n\nHTMLPlayer.prototype.play = function() {\n  this.sendNotification(Notifications.PLAY, true);\n};\n\nHTMLPlayer.prototype.replay = function() {\n  this.sendNotification(Notifications.REPLAY);\n};\n\nHTMLPlayer.prototype.pause = function() {\n  this.sendNotification(Notifications.PAUSE);\n};\n\nHTMLPlayer.prototype.end = function() {\n  this.sendNotification(Notifications.END);\n};\n\nHTMLPlayer.prototype.setParams = function(value) {\n  this.sendNotification(Notifications.CHANGE_PARAMS, value);\n  return value;\n};\n\nHTMLPlayer.prototype.getParams = function() {\n  return this.params.getData();\n};\n\nHTMLPlayer.prototype.setAutoplay = function(value) {\n  this.sendNotification(Notifications.CHANGE_AUTOPLAY, value);\n  return value;\n};\n\nHTMLPlayer.prototype.getAutoplay = function() {\n  var autoPlay, playbackProxy, _ref;\n  playbackProxy = this.retrieveProxy(PlaybackProxy.NAME);\n  autoPlay = ((Utils.isAutoplaySupported() && this.configuration.getMuted()) || playbackProxy.initialized) && (this.configuration.getAutoplay() || ((_ref = this.getMedia()) != null ? _ref.autoplay : void 0) === true);\n  return autoPlay;\n};\n\nHTMLPlayer.prototype.setLoop = function(value) {\n  this.sendNotification(Notifications.CHANGE_LOOP, value);\n  return value;\n};\n\nHTMLPlayer.prototype.getLoop = function() {\n  return this.configuration.getLoop();\n};\n\nHTMLPlayer.prototype.setMuted = function(value) {\n  this.sendNotification(Notifications.CHANGE_MUTED, value);\n  return value;\n};\n\nHTMLPlayer.prototype.getMuted = function() {\n  return this.retrieveProxy(PlaybackProxy.NAME).getMuted();\n};\n\nHTMLPlayer.prototype.setMedia = function(value) {\n  this.sendNotification(Notifications.SET_MEDIA, value);\n  return value;\n};\n\nHTMLPlayer.prototype.getMedia = function() {\n  return this.mediaProxy.getData();\n};\n\nHTMLPlayer.prototype.setCurrentTime = function(value) {\n  this.sendNotification(Notifications.SEEK, value);\n  return value;\n};\n\nHTMLPlayer.prototype.getCurrentTime = function() {\n  return this.appState.getCurrentTime();\n};\n\nHTMLPlayer.prototype.setAbsoluteCurrentTime = function(value) {\n  this.sendNotification(Notifications.SEEK, value);\n  return value;\n};\n\nHTMLPlayer.prototype.getAbsoluteCurrentTime = function() {\n  return this.retrieveProxy(PlaybackProxy.NAME).getCurrentTime();\n};\n\nHTMLPlayer.prototype.getDuration = function() {\n  return this.appState.getDuration();\n};\n\nHTMLPlayer.prototype.getAbsoluteDuration = function() {\n  return this.mediaProxy.getDuration();\n};\n\nHTMLPlayer.prototype.setSrc = function(value) {\n  this.sendNotification(Notifications.SET_MEDIA, {\n    src: value\n  });\n  return value;\n};\n\nHTMLPlayer.prototype.getSrc = function() {\n  return this.mediaProxy.getSrc();\n};\n\nHTMLPlayer.prototype.setSource = function(value) {\n  this.sendNotification(Notifications.SET_MEDIA, {\n    source: value\n  });\n  return value;\n};\n\nHTMLPlayer.prototype.getSource = function() {\n  return this.mediaProxy.getSource();\n};\n\nHTMLPlayer.prototype.setVolume = function(value) {\n  this.sendNotification(Notifications.CHANGE_VOLUME, value);\n  return value;\n};\n\nHTMLPlayer.prototype.getVolume = function() {\n  return this.retrieveProxy(PlaybackProxy.NAME).getVolume();\n};\n\nHTMLPlayer.prototype.getSeeking = function() {\n  return this.retrieveProxy(PlaybackProxy.NAME).getSeeking();\n};\n\nHTMLPlayer.prototype.getPaused = function() {\n  return this.retrieveProxy(PlaybackProxy.NAME).getPaused();\n};\n\nHTMLPlayer.prototype.getEnded = function() {\n  return this.appState.getEnded();\n};\n\nHTMLPlayer.prototype.getError = function() {\n  return this.getMediaElement().error;\n};\n\nHTMLPlayer.prototype.setDisplayState = function(value) {\n  this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, value);\n};\n\nHTMLPlayer.prototype.getDisplayState = function(value) {\n  return this.appState.getDisplayState();\n};\n\nHTMLPlayer.prototype.enterFullScreen = function() {\n  this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.FULL_SCREEN);\n};\n\nHTMLPlayer.prototype.exitFullScreen = function() {\n  this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n};\n\nHTMLPlayer.prototype.setPlaybackRate = function(value) {\n  var _ref;\n  if (((_ref = this.ads) != null ? _ref.inProgress : void 0) === true || value === this.getMediaElement().playbackRate) {\n    return;\n  }\n  this.appState.setPlaybackRate(value);\n  this.getMediaElement().playbackRate = value;\n  this.dispatchEvent(new Event(Events.PLAYBACK_RATE_CHANGE, value));\n};\n\nHTMLPlayer.prototype.getPlaybackRate = function() {\n  return this.getMediaElement().playbackRate;\n};\n\nHTMLPlayer.prototype.getQualityLevels = function() {\n  return this.retrieveProxy(PlaybackProxy.NAME).getQualityLevels();\n};\n\nHTMLPlayer.prototype.setQuality = function(value) {\n  return this.retrieveProxy(PlaybackProxy.NAME).setQuality(value);\n};\n\nHTMLPlayer.prototype.getQuality = function() {\n  return this.retrieveProxy(PlaybackProxy.NAME).getQuality();\n};\n\nHTMLPlayer.prototype.getQualityMode = function() {\n  return this.retrieveProxy(PlaybackProxy.NAME).getQualityMode();\n};\n\nHTMLPlayer.prototype.setQualityMode = function(value) {\n  return this.retrieveProxy(PlaybackProxy.NAME).setQualityMode(value);\n};\n\n/**\n * Gets the play state.\n*/\nHTMLPlayer.prototype.getPlayState = function() {\n  return this.appState.getPlayState();\n};\n\n/**\n * Force the player into live mode during DVR playback\n*/\nHTMLPlayer.prototype.goLive = function() {\n  return this.retrieveProxy(PlaybackProxy.NAME).goLive();\n};\n\n/**\n * @override\n*/\nHTMLPlayer.prototype.destroy = function() {\n  var _ref, _ref1;\n  if ((_ref = this.retrieveProxy(PlayerProxy.NAME)) != null) {\n    if ((_ref1 = _ref.activePlaybackCore) != null) {\n      if (typeof _ref1.destroy === \"function\") {\n        _ref1.destroy();\n      }\n    }\n  }\n  HTMLPlayer.__super__.destroy.call(this);\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar FlashNotifications = {\n  READY: \"jsApiReady\",\n  RESET: \"mediaPlayerReset\",\n  LOADING: \"mediaPlayerLoading\",\n  PLAYER_ERROR: \"mediaPlayerError\",\n  MEDIA_ERROR: \"mediaError\",\n  ERROR_STREAM_NOT_FOUND: \"mediaPlayerErrorStreamNotFound\",\n  CAPABILITY_CHANGE: \"mediaPlayerCapabilityChange\",\n  PLAYBACK_OPEN: \"mediaPlayerPlaybackOpen\",\n  PLAYBACK_CLOSE: \"mediaPlayerPlaybackClose\",\n  PLAYING: \"mediaPlayerPlaying\",\n  ENDED: \"mediaPlayerPlaybackClose\",\n  MEDIA_SEQUENCE_ENDED: \"mediaPlayerPlaybackSequenceComplete\",\n  PAUSED: \"mediaPlayerPaused\",\n  BUFFERING: \"mediaPlayerBuffering\",\n  DURATION_CHANGE: \"mediaPlayerDurationChange\",\n  TIME_UPDATE: \"mediaPlayerPlayheadUpdate\",\n  SEEKING_CHANGE: \"mediaPlayerSeekingChange\",\n  ERROR: \"error\",\n  VOLUME_CHANGE: \"mediaPlayerVolumeChanged\",\n  PLAY_STATE_CHANGE: \"mediaPlayerPlayStateChange\",\n  STATE_CHANGE: \"mediaPlayerStateChange\",\n  CAPTION_DATA_CHANGE: \"mediaPlayerCaptiondataChange\",\n  FAIL_OVER_ATTEMPT: \"mediaPlayerFailoverAttempt\",\n  ELEMENT_EVENT: \"mediaPlayerElementEvent\",\n  PLAY: \"mediaPlayerResumeOrPausePlayback\",\n  BUFFERING_CHANGE: \"mediaPlayerBufferingChanged\",\n  APPLICATION_STATE_CHANGE: \"mediaPlayerApplicationStateChange\",\n  INITIALIZED: \"mediaPlayerInitialized\",\n  FULLSCREEN_CHANGE: \"mediaPlayerFullscreenChange\",\n  AUTHORIZE: \"mediaPlayerAuthenticate\",\n  CAPTIONING_REQUEST: \"mediaPlayerCaptioningRequest\",\n  CAPTION_LANG_CHANGE: \"mediaPlayerCaptionLangChange\",\n  RECOMMENDATIONS_LOADED: \"mediaPlayerRecommendationsLoaded\",\n  RECOMMENDATION_SELECTED: \"mediaPlayerRecommendationSelected\",\n  SHARE: \"mediaPlayerShare\",\n  SHARE_REQUEST: \"mediaPlayerShareRequest\",\n  AUTO_ADVANCE: \"mediaPlayerAutoAdvance\",\n  CREATE_FLASH_VARS: \"createFlashVars\",\n  CREATE_XML: \"createXML\",\n  FLASH_CREATED: \"flashCreated\",\n  PLAY_REQUEST: \"mediaPlayerPlaybackSequenceInitiated\",\n  LOAD_FEED: \"mediaPlayerDataFeedRequested\",\n  FEED_UPDATED: \"mediaPlayerDataFeedUpdated\",\n  FEED_LOADED: \"mediaPlayerFeedLoaded\",\n  TIMED_METADATA: \"mediaPlayerSendCuePoint\",\n  MEDIA_PLAYER_ID3_UPDATED: \"mediaPlayerID3Updated\"\n};\n\n/**\n * PlaybackProxy constructor.\n *\n * @constructor\n * @private\n * @extends {puremvc.Proxy}\n*/\nfunction PlaybackProxy() {\n  PlaybackProxy.__super__.constructor.call(this, PlaybackProxy.NAME);\n  this.data = {\n    core: null,\n    muted: false,\n    started: false,\n    volume: 1,\n    currentTime: 0,\n    duration: 0,\n    src: null,\n    ended: false,\n    paused: false,\n    seeking: false,\n    loading: false,\n    waiting: false,\n    keyErrored: false\n  };\n  if (Utils.getDevice() === \"desktop\") {\n    this.initialized = true;\n  }\n  this.handlers = {\n    \"timeupdate\": this.ontimeupdate.bind(this),\n    \"durationchange\": this.ondurationchange.bind(this),\n    \"play\": this.onplay.bind(this),\n    \"playing\": this.onplaying.bind(this),\n    \"pause\": this.onpause.bind(this),\n    \"loadeddata\": this.onloadeddata.bind(this),\n    \"waiting\": this.onwaiting.bind(this),\n    \"seeking\": this.onseeking.bind(this),\n    \"seeked\": this.onseeked.bind(this),\n    \"ended\": this.onended.bind(this),\n    \"progress\": this.onprogress.bind(this),\n    \"error\": this.onerror.bind(this),\n    \"loadstart\": this.onloadstart.bind(this),\n    \"canplay\": this.oncanplay.bind(this),\n    \"canplaythrough\": this.oncanplaythrough.bind(this),\n    \"loadedmetadata\": this.onloadedmetadata.bind(this),\n    \"stalled\": this.onstalled.bind(this)\n  };\n  this.resume = {\n    event: Utils.getIEVersion() === -1 || Utils.getIEVersion() === 11 ? \"loadedmetadata\" : \"canplaythrough\",\n    listener: this.resumestart.bind(this)\n  };\n  this.textTrackHandlers = {\n    \"addtrack\": this.onaddtrack.bind(this)\n  };\n  this.onneedkey = this.onneedkey.bind(this);\n}\n\n\n__extends(PlaybackProxy, puremvc.Proxy);\n\n\n/**\n * The name of the this Proxy.\n *\n * @static\n * @type {string}\n*/\nPlaybackProxy.NAME = \"PlaybackProxy\";\n\n/** @private\n*/\nPlaybackProxy.prototype.data = null;\n\nPlaybackProxy.prototype.initialized = false;\n\nPlaybackProxy.prototype.enabled = null;\n\nPlaybackProxy.prototype.handlers = null;\n\nPlaybackProxy.prototype.resume = null;\n\nPlaybackProxy.prototype.playWhenLoaded = false;\n\nPlaybackProxy.prototype.metadataloaded = false;\n\nPlaybackProxy.prototype.activeCuesIndex = 0;\n\nPlaybackProxy.prototype.id3CueType = null;\n\n/**\n * The current time of the video in seconds. Value must be between currentTime and duration.\n *\n * @param {Number} value\n *    The new currentTime value in seconds\n * @returns {Number}\n *    The currentTime value in seconds\n * @type {Number}\n*/\nPlaybackProxy.prototype.getEnabled = function() {\n  return this.enabled;\n};\n\nPlaybackProxy.prototype.setEnabled = function(value) {\n  if (value === this.enabled) {\n    return;\n  }\n  this.enabled = value;\n  if (this.enabled === true) {\n    this.load();\n  } else {\n    this.applyHandlers(false);\n  }\n  return value;\n};\n\n/** @private\n*/\nPlaybackProxy.prototype.applyHandlers = function(enabled) {\n  var action, handler, type, video, _ref;\n  if (enabled == null) {\n    enabled = true;\n  }\n  video = this.getMediaElement();\n  action = enabled ? \"addEventListener\" : \"removeEventListener\";\n  _ref = this.handlers;\n  for (type in _ref) {\n    handler = _ref[type];\n    video[action](type, handler);\n  }\n};\n\n/** @private\n*/\nPlaybackProxy.prototype.resumestart = function(event) {\n  var video,\n    _this = this;\n  video = this.getMediaElement();\n  this.handlers.durationchange(event);\n  if (this.data.currentTime > 0 && this.data.ended !== true) {\n    setTimeout(function() {\n      _this.seek(_this.data.currentTime).then(_this.resumecomplete.bind(_this));\n    }, 50);\n  } else {\n    this.resumecomplete();\n  }\n};\n\n/** @private\n*/\nPlaybackProxy.prototype.resumecomplete = function() {\n  this.data.loading = false;\n  this.applyHandlers(true);\n  if (this.playWhenLoaded === true) {\n    setTimeout(this.play.bind(this), 1);\n  }\n};\n\n/** @private\n*/\nPlaybackProxy.prototype.onaddtrack = function(event) {\n  var track,\n    _this = this;\n  track = event.track;\n  if (track.kind !== \"metadata\") {\n    return;\n  }\n  track.mode = \"hidden\";\n  track.addEventListener(\"cuechange\", function(event) {\n    var cue, previousCue, _i, _len, _ref;\n    _ref = event.target.activeCues;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      cue = _ref[_i];\n      if (!(previousCue !== cue)) {\n        continue;\n      }\n      _this.sendNotification(Notifications.TIMED_METADATA, cue);\n      previousCue = cue;\n    }\n  });\n};\n\nPlaybackProxy.prototype.ontimeupdate = function(event) {\n  var currentTime, _ref;\n  currentTime = event.target.currentTime;\n  if (((_ref = this.facade.ads) != null ? _ref.inProgress : void 0) === true) {\n    return;\n  }\n  this.data.currentTime = currentTime;\n  this.sendNotification(Notifications.TIME_CHANGE, {\n    currentTime: currentTime\n  });\n};\n\nPlaybackProxy.prototype.ondurationchange = function(event) {\n  var duration;\n  duration = event.target.duration;\n  if (duration === this.data.duration || duration === 0 || isNaN(duration)) {\n    return;\n  }\n  this.data.duration = duration;\n  if (/Android [4-7]/.test(navigator.userAgent) && this.getMediaElement().src.indexOf(\".m3u8\") !== -1 && duration === Infinity) {\n    return;\n  }\n  this.sendNotification(Notifications.CHANGE_DURATION, duration);\n};\n\nPlaybackProxy.prototype.onplay = function(event) {\n  this.data.paused = false;\n};\n\nPlaybackProxy.prototype.onplaying = function(event) {\n  this.data.paused = false;\n  this.data.seeking = false;\n  this.data.waiting = false;\n  this.sendNotification(Notifications.PLAYING);\n};\n\nPlaybackProxy.prototype.onpause = function(event) {\n  if (this.getMediaElement().ended === true || this.facade.playState === PlayState.READY) {\n    return;\n  }\n  if (this.data.waiting === true && this.playbackCoreName === \"hls\") {\n    return;\n  }\n  this.data.paused = true;\n  if (event.target.readyState > 0) {\n    this.sendNotification(Notifications.PAUSED);\n    this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PAUSED);\n  }\n};\n\nPlaybackProxy.prototype.onloadeddata = function(event) {\n  this.sendNotification(Notifications.LOADED_DATA);\n};\n\nPlaybackProxy.prototype.onwaiting = function(event) {\n  var video;\n  this.data.waiting = true;\n  this.sendNotification(Notifications.WAITING);\n  video = this.getMediaElement();\n  if (video.seeking === false && video.readyState === 2 && video.networkState === 2) {\n    video.once(\"playing\", this.sendNotification.bind(this, Notifications.BUFFERING_CHANGE, false));\n    this.sendNotification(Notifications.BUFFERING_CHANGE, true);\n  }\n};\n\nPlaybackProxy.prototype.onstalled = function(event) {\n  this.sendNotification(Notifications.STALLED);\n};\n\nPlaybackProxy.prototype.onseeking = function(event) {\n  var currentTime;\n  this.getMediaElement().removeEventListener(\"timeupdate\", this.handlers.timeupdate);\n  currentTime = event.target.currentTime;\n  this.sendNotification(Notifications.TIME_CHANGE, {\n    currentTime: currentTime\n  });\n  this.data.seeking = true;\n  this.sendNotification(Notifications.SEEKING);\n};\n\nPlaybackProxy.prototype.onseeked = function(event) {\n  this.data.seeking = false;\n  this.sendNotification(Notifications.SEEKED, event.target.currentTime);\n  this.getMediaElement().addEventListener(\"timeupdate\", this.handlers.timeupdate);\n};\n\nPlaybackProxy.prototype.onended = function(event) {\n  this.data.ended = true;\n  this.sendNotification(Notifications.ENDED);\n};\n\nPlaybackProxy.prototype.onprogress = function(event) {\n  var buffered, video;\n  try {\n    video = this.getMediaElement();\n    buffered = video.buffered;\n    this.sendNotification(Notifications.PROGRESS, buffered.end(buffered.length - 1) / video.duration);\n  } catch (error) {\n\n  }\n};\n\nPlaybackProxy.prototype.onerror = function(event) {\n  this.sendNotification(Notifications.ERROR, this.getMediaElement().error);\n};\n\nPlaybackProxy.prototype.onloadstart = function(event) {\n  this.sendNotification(Notifications.LOAD_START);\n};\n\nPlaybackProxy.prototype.oncanplay = function(event) {\n  this.sendNotification(Notifications.CAN_PLAY);\n};\n\nPlaybackProxy.prototype.oncanplaythrough = function(event) {\n  this.createTracks();\n  this.sendNotification(Notifications.CAN_PLAY_THROUGH);\n  this.sendNotification(Notifications.PROGRESS, this.getDuration());\n};\n\nPlaybackProxy.prototype.onloadedmetadata = function(event) {\n  this.metadataloaded = true;\n  this.sendNotification(Notifications.ENABLE_FULL_SCREEN);\n  this.sendNotification(Notifications.LOADED_METADATA);\n};\n\nPlaybackProxy.prototype.applyTextTrackHandlers = function(data) {\n  var action, _ref;\n  action = data === true ? \"addEventListener\" : \"removeEventListener\";\n  if ((_ref = this.getMediaElement().textTracks) != null) {\n    _ref[action](\"addtrack\", this.textTrackHandlers.addtrack);\n  }\n};\n\n/** @override\n*/\nPlaybackProxy.prototype.createTracks = function() {\n  var audio, changeEnabled, count, index, item, track, tracks, _i, _len;\n  audio = this.getMediaElement().audioTracks;\n  tracks = this.facade.retrieveProxy(TracksProxy.NAME).getAudioTracks();\n  changeEnabled = function(track, enabled) {\n    var _this = this;\n    this.facade.tracks.getAudioTracks().forEach(function(track) {\n      return track.data.enabled = false;\n    });\n    if (enabled !== true) {\n      return;\n    }\n    return this.facade.tracks.getAudioTracks()[track.id].data.enabled = true;\n  };\n  if (audio != null) {\n    count = audio.length || 0;\n    for (index = _i = 0, _len = audio.length; _i < _len; index = ++_i) {\n      item = audio[index];\n      if (Utils.fieldIsUnique(tracks, 'id', item.id) === false) {\n        continue;\n      }\n      track = new Track(item);\n      track.changeEnabled = changeEnabled.bind(this, track);\n      tracks.add(track, index + 1 === count);\n    }\n  }\n};\n\n/** @private\n*/\nPlaybackProxy.prototype.reset = function() {\n  this.data.currentTime = 0;\n  this.data.duration = 0;\n  this.data.src = null;\n  this.data.ended = false;\n  this.data.paused = false;\n  this.data.seeking = false;\n  this.data.started = false;\n  this.data.loading = false;\n  this.applyTextTrackHandlers(false);\n};\n\n/**\n * @return {boolean}\n*/\nPlaybackProxy.prototype.getStarted = function() {\n  return this.data.started;\n};\n\n/**\n * The playback core\n *\n * @param {HTMLVideoElement} value\n *    The new playback core\n * @returns {HTMLVideoElement}\n *    The playback core\n * @type {HTMLVideoElement}\n *\n * @private\n*/\nPlaybackProxy.prototype.getMediaElement = function() {\n  return this.facade.getMediaElement();\n};\n\n/**\n *\n*/\nPlaybackProxy.prototype.canPlayMedium = function(medium) {\n  return medium === \"video\";\n};\n\n/**\n *\n*/\nPlaybackProxy.prototype.canPlayTemporalType = function(temporalType) {\n  return temporalType !== \"dvr\";\n};\n\n/**\n * Determines if the core can play a given mimeType.\n *\n * @return {String} \"\" if the core can't play the mimeType\n*/\nPlaybackProxy.prototype.canPlayType = function(mimeType) {\n  var canPlay;\n  canPlay = document.createElement(\"video\").canPlayType(mimeType) || \"\";\n  if ((/Android (4\\.[1-9]|[5-6])/.test(navigator.userAgent) || /Silk\\/3/.test(navigator.userAgent)) && mimeType === Utils.mimeTypes.m3u8) {\n    canPlay = \"maybe\";\n  }\n  if (canPlay === \"probably\" && /video\\/f4m|x-flv/.test(mimeType) && /UCBrowser/.test(navigator.userAgent)) {\n    canPlay = \"\";\n  }\n  return canPlay;\n};\n\n/**\n * Indicates whether or not the video is playing.\n *\n * @returns {Boolean}\n *    The playing value\n * @type {Boolean}\n*/\nPlaybackProxy.prototype.getPaused = function() {\n  return this.data.paused;\n};\n\n/**\n * Indicates whether or not the video is playing.\n *\n * @returns {Boolean}\n *    The playing value\n * @type {Boolean}\n*/\nPlaybackProxy.prototype.getSeeking = function() {\n  return this.data.seeking;\n};\n\n/**\n * The current time of the video in seconds. Value must be between currentTime and duration.\n *\n * @param {Number} value\n *    The new currentTime value in seconds\n * @returns {Number}\n *    The currentTime value in seconds\n * @type {Number}\n*/\nPlaybackProxy.prototype.getCurrentTime = function() {\n  return this.data.currentTime;\n};\n\nPlaybackProxy.prototype.setCurrentTime = function(value) {\n  if (value === this.data.currentTime) {\n    return;\n  }\n  this.data.currentTime = value;\n  if (this.getStarted()) {\n    this.seek(value);\n  }\n  return value;\n};\n\n/** @private\n*/\nPlaybackProxy.prototype.seek = function(time) {\n  var _this = this;\n  if (time == null) {\n    time = this.data.currentTime;\n  }\n  return new Promise(function(resolve, reject) {\n    var interval, seeked, ua, video;\n    try {\n      video = _this.getMediaElement();\n      seeked = function() {\n        setTimeout(resolve, 10, time);\n      };\n      video.once(\"seeked\", seeked);\n      video.currentTime = time;\n      ua = navigator.userAgent;\n      if (/Android.*Chrome/.test(ua)) {\n        interval = setInterval(function() {\n          if (Math.round(video.currentTime) === Math.round(time)) {\n            clearInterval(interval);\n            video.dispatchEvent(new CustomEvent(\"seeked\"));\n          }\n        }, 10);\n      }\n    } catch (error) {\n      reject(error);\n    }\n  });\n};\n\n/**\n*/\nPlaybackProxy.prototype.goLive = function() {\n  var mediaElement, time;\n  mediaElement = this.getMediaElement();\n  time = mediaElement.duration === Infinity ? mediaElement.seekable.end(0) : mediaElement.duration;\n  mediaElement.currentTime = time;\n};\n\n/**\n * The current time of the video in seconds. Value must be between currentTime and duration.\n *\n * @param {Number} value\n *    The new currentTime value in seconds\n * @returns {Number}\n *    The currentTime value in seconds\n * @type {Number}\n*/\nPlaybackProxy.prototype.getVolume = function() {\n  var mediaElement;\n  mediaElement = this.getMediaElement();\n  if (mediaElement.muted === true) {\n    return 0;\n  } else {\n    return mediaElement.volume;\n  }\n};\n\nPlaybackProxy.prototype.setVolume = function(value) {\n  if (this.getMuted() && value > 0) {\n    this.setMuted(false, false);\n  } else if (!this.getMuted() && value === 0) {\n    this.setMuted(true, false);\n  }\n  this.sendNotification(Notifications.VOLUME_CHANGE, this.getMediaElement().volume = value);\n  return value;\n};\n\n/**\n*/\nPlaybackProxy.prototype.getMuted = function() {\n  return this.data.muted;\n};\n\nPlaybackProxy.prototype.setMuted = function(value, changeVolume) {\n  var volume;\n  if (changeVolume == null) {\n    changeVolume = true;\n  }\n  if (this.data.muted === value) {\n    return;\n  }\n  this.data.muted = value;\n  if (this.data.muted === true) {\n    this.data.volume = this.getVolume();\n    volume = 0;\n  } else {\n    volume = this.data.volume;\n  }\n  this.getMediaElement().muted = value;\n  if (changeVolume === true) {\n    this.sendNotification(Notifications.CHANGE_VOLUME, volume);\n    this.sendNotification(Notifications.VOLUME_CHANGE, volume);\n  }\n  this.sendNotification(Notifications.MUTE_CHANGE, this.data.muted);\n  return value;\n};\n\n/**\n * The duration of the video in seconds.\n *\n * @returns {Number}\n *    The duration of the video\n * @type {Number}\n*/\nPlaybackProxy.prototype.getDuration = function() {\n  return this.data.duration;\n};\n\n/**\n * Instructs the core to play.\n*/\nPlaybackProxy.prototype.play = function() {\n  var promise,\n    _this = this;\n  if (this.data.started !== true) {\n    this.data.started = true;\n    this.setEnabled(true);\n    this.playWhenLoaded = true;\n    if (this.metadataloaded === false) {\n      return;\n    }\n  } else if (this.data.loading === true) {\n    this.playWhenLoaded = true;\n    return;\n  }\n  if (this.getPaused()) {\n    this.sendNotification(Notifications.RESUME);\n  }\n  promise = this.getMediaElement().play();\n  if ((promise != null ? promise[\"catch\"] : void 0) != null) {\n    promise[\"catch\"](function(error) {\n      return _this.sendNotification(Notifications.AUTOPLAY_BLOCKED);\n    });\n  }\n};\n\n/**\n * Instructs the core to pause.\n*/\nPlaybackProxy.prototype.pause = function() {\n  this.data.paused = true;\n  this.getMediaElement().pause();\n};\n\nPlaybackProxy.prototype.getSrc = function() {\n  return this.facade.mediaProxy.getSrc();\n};\n\n/**\n * Instructs the core to load.\n*/\nPlaybackProxy.prototype.load = function() {\n  var element;\n  this.sendNotification(Notifications.WAITING);\n  this.data.loading = true;\n  this.playWhenLoaded = false;\n  this.metadataloaded = false;\n  element = this.getMediaElement();\n  element.once(this.resume.event, this.resume.listener);\n  element.addEventListener(\"loadedmetadata\", this.handlers.loadedmetadata);\n  element.addEventListener(\"durationchange\", this.handlers.durationchange);\n  element.addEventListener(\"canplaythrough\", this.handlers.canplaythrough);\n  element.addEventListener(\"webkitneedkey\", this.onneedkey);\n  element.addEventListener(\"error\", this.handlers.error);\n  this.applyTextTrackHandlers(true);\n  this.applySrc();\n};\n\nPlaybackProxy.prototype.applySrc = function() {\n  var element, muted, src, _ref;\n  src = this.getSrc();\n  if (!(src != null) || src === \"\") {\n    this.sendNotification(Notifications.ERROR, \"The value of src is not supported: \" + value);\n  }\n  element = this.getMediaElement();\n  element.src = src;\n  muted = element.muted;\n  if (muted === true) {\n    this.data.muted = true;\n  }\n  if (Utils.isIPad() && ((_ref = Utils.getIOSversion()) != null ? _ref[0] : void 0) < 8) {\n    setTimeout(element.load.bind(element), 100);\n  } else {\n    element.load();\n  }\n};\n\nPlaybackProxy.prototype.setQuality = function(value) {};\n\nPlaybackProxy.prototype.getQuality = function() {};\n\nPlaybackProxy.prototype.getQualityLevels = function() {\n  return [];\n};\n\nPlaybackProxy.prototype.getQualityMode = function() {};\n\nPlaybackProxy.prototype.setQualityMode = function(value) {};\n\nPlaybackProxy.prototype.destroy = function() {\n  var element, key, value, _ref, _ref1;\n  element = this.getMediaElement();\n  _ref = this.handlers;\n  for (key in _ref) {\n    value = _ref[key];\n    element.removeEventListener(key, value);\n  }\n  element.removeEventListener(this.resume.event, this.resume.listener);\n  element.removeEventListener(\"webkitneedkey\", this.onneedkey);\n  if ((_ref1 = element.textTracks) != null) {\n    _ref1.removeEventListener(\"addtrack\", this.textTrackHandlers.addtrack);\n  }\n};\n\n/**\n  The EME specification (https://dvcs.w3.org/hg/html-media/raw-file/tip/encrypted-media/encrypted-media.html)\n  is supported starting OSX 10.10 and greater.\n*/\nPlaybackProxy.prototype.onneedkey = function(event) {\n  var contentId, disallowRetries, fps, initData, keySystem, keys, serverUrl, video, _ref,\n    _this = this;\n  video = event.target;\n  keySystem = Utils.getKeySystem();\n  keys = this.facade.mediaProxy.getKeys()[keySystem];\n  fps = this.facade.fps;\n  disallowRetries = (((_ref = this.facade.config.fps) != null ? _ref.allowKeyErrorRetries : void 0) != null) && this.facade.config.fps.allowKeyErrorRetries === false;\n  if (!(keys != null) || keySystem !== \"com.apple.fps.1_0\") {\n    return;\n  }\n  if (this.keyErrored && disallowRetries) {\n    this.getMediaElement().removeEventListener(\"webkitneedkey\", this.onneedkey);\n    return;\n  }\n  initData = event.initData;\n  contentId = fps.extractContentId(initData, keys);\n  serverUrl = fps.extractServerUrl(initData, keys);\n  fps.requestCertificate(keys).then(function(cert) {\n    return fps.concatInitDataIdAndCertificate(initData, contentId, cert);\n  }).then(function(initData) {\n    var session;\n    if (!WebKitMediaKeys.isTypeSupported(keySystem, \"video/mp4\")) {\n      throw \"Key System not supported\";\n    }\n    if (!(video.webkitKeys != null)) {\n      video.webkitSetMediaKeys(new WebKitMediaKeys(keySystem));\n    }\n    if (!(video.webkitKeys != null)) {\n      throw \"Could not create MediaKeys\";\n    }\n    session = video.webkitKeys.createSession(\"video/mp4\", initData);\n    if (!(session != null)) {\n      throw \"Could not create key session\";\n    }\n    session.addEventListener(\"webkitkeymessage\", function(event) {\n      fps.requestLicense(event.message, contentId, serverUrl, keys).then(function(key) {\n        session.update(key);\n      })[\"catch\"](function(error) {\n        session.close();\n        _this.keyErrored = true;\n        _this.facade.logger.error(\"[AMP DRM] A key request error was encountered.\", error);\n      });\n    });\n    session.addEventListener(\"webkitkeyadded\", function(event) {\n      _this.facade.logger.log(\"[AMP DRM] Decryption key was added to session.\");\n    });\n    session.addEventListener(\"webkitkeyerror\", function(event) {\n      _this.sendNotification(Notifications.ERROR, {\n        message: \"A decryption key error was encountered for key system \" + keySystem,\n        detail: event\n      });\n      session.close();\n      _this.keyErrored = true;\n      _this.facade.logger.log(\"[AMP DRM] A decryption key error was encountered.\", event);\n    });\n  })[\"catch\"](function(error) {\n    _this.facade.logger.error(error);\n  });\n};\n\n/**\n * The FlashPluginsInitializedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction FlashPluginsInitializedCommand() {\n  FlashPluginsInitializedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(FlashPluginsInitializedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nFlashPluginsInitializedCommand.prototype.execute = function(notification) {\n  setTimeout(this.facade.pluginsinitialized.bind(this.facade), 0);\n};\n\n/**\n * The FlashStartCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction FlashStartCommand() {\n  FlashStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(FlashStartCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nFlashStartCommand.prototype.execute = function(notification) {\n  this.player.started = true;\n  this.sendNotification(Notifications.STARTED, notification.getBody());\n  this.sendNotification(Notifications.PLAY, notification.getBody());\n};\n\n/**\n * The WaitingCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction BufferingChangeCommand() {\n  BufferingChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(BufferingChangeCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nBufferingChangeCommand.prototype.execute = function(notification) {\n  var buffering;\n  buffering = notification.getBody();\n  if (this.applicationState.getBuffering() === buffering) {\n    return;\n  }\n  this.applicationState.setBuffering(buffering);\n  BufferingChangeCommand.__super__.execute.call(this, notification);\n};\n\nfunction LocalizationWrapper(player, config) {\n  this.player = player;\n  this.config = config;\n  LocalizationWrapper.__super__.constructor.call(this, this.constructor.NAME);\n  this.proxy = new LocalizationProxy(this.config);\n  this.player.registerProxy(this.proxy);\n}\n\n\n__extends(LocalizationWrapper, puremvc.Mediator);\n\n\nLocalizationWrapper.prototype.player = null;\n\nLocalizationWrapper.prototype.config = null;\n\nLocalizationWrapper.prototype.proxy = null;\n\nLocalizationWrapper.NAME = \"LocalizationWrapper\";\n\n/**\n*/\nLocalizationWrapper.prototype.getString = function(key, context) {\n  return this.proxy.getString(key, context);\n};\n\n/** @override\n*/\nLocalizationWrapper.prototype.listNotificationInterests = function() {\n  return [FlashNotifications.CREATE_FLASH_VARS, FlashNotifications.CREATE_XML];\n};\n\n/**\n*/\nLocalizationWrapper.prototype.handleNotification = function(notification) {\n  var application, body, config, element, flashvars, key, lang, locale, locales, name, prop, text, value, xml, _ref;\n  LocalizationWrapper.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case FlashNotifications.CREATE_FLASH_VARS:\n      flashvars = body.flashvars;\n      config = body.config;\n      flashvars.locale_setting = this.proxy.getLocaleId();\n      break;\n    case FlashNotifications.CREATE_XML:\n      xml = body.xml;\n      application = xml.firstChild;\n      locales = xml.getElementsByTagName(\"locales\")[0];\n      if (!(locales != null)) {\n        locales = xml.createElement(\"locales\");\n        application.appendChild(locales);\n      }\n      _ref = this.proxy.getLocales();\n      for (lang in _ref) {\n        locale = _ref[lang];\n        element = xml.createElement(\"locale\");\n        element.setAttribute(\"id\", lang);\n        locales.appendChild(element);\n        for (key in locale) {\n          value = locale[key];\n          prop = xml.createElement(\"property\");\n          prop.setAttribute(\"key\", key);\n          text = XMLUtils.createTextContent(xml, value);\n          prop.appendChild(text);\n          element.appendChild(prop);\n        }\n      }\n  }\n};\n\n/** \n * The ModuleMediator class.\n * \n * @param {string} name\n * @param {Object} viewComponent\n * @constructor\n * @private \n * @extends {puremvc.Mediator}\n*/\nfunction ModuleMediator(viewComponent) {\n  if (this.cssPrefix == null) {\n    this.cssPrefix = Namespace.PREFIX;\n  }\n  ModuleMediator.__super__.constructor.call(this, this.mediatorName, viewComponent);\n}\n\n\n__extends(ModuleMediator, puremvc.Mediator);\n\n\nModuleMediator.prototype.config = null;\n\nModuleMediator.prototype.cssPrefix = null;\n\nModuleMediator.prototype.classList = null;\n\n/** @override\n*/\nModuleMediator.prototype.initializeNotifier = function(key) {\n  var base;\n  ModuleMediator.__super__.initializeNotifier.call(this, key);\n  base = this.facade.player || this.facade;\n  this.config = base.retrieveProxy(ModuleProxy.NAME);\n  this.classList = this.classList = new ClassList(this.viewComponent);\n};\n\n/** \n * @constructor\n * @private\n*/\nfunction LocalizedMediator(viewComponent) {\n  LocalizedMediator.__super__.constructor.call(this, viewComponent);\n}\n\n\n__extends(LocalizedMediator, ModuleMediator);\n\n\nLocalizedMediator.prototype.localizationManager = null;\n\n/** @override\n*/\nLocalizedMediator.prototype.initializeNotifier = function(key) {\n  var target;\n  LocalizedMediator.__super__.initializeNotifier.call(this, key);\n  target = this.facade.player || this.facade;\n  this.localizationManager = target.retrieveProxy(LocalizationProxy.NAME);\n};\n\n/**\n * @constructor\n * @extends {LocalizedMediator}\n * @private\n*/\nfunction ComponentMediator(componentName, componentType, parent, element) {\n  this.componentName = componentName != null ? componentName : this.componentName;\n  this.componentType = componentType != null ? componentType : this.componentType;\n  this.parent = parent;\n  this.element = element;\n  if (this.mediatorName == null) {\n    this.mediatorName = this.createMediatorName();\n  }\n  ComponentMediator.__super__.constructor.call(this, this.viewComponent);\n}\n\n\n__extends(ComponentMediator, LocalizedMediator);\n\n\nComponentMediator.prototype.componentName = null;\n\nComponentMediator.prototype.componentType = null;\n\nComponentMediator.prototype.parent = null;\n\nComponentMediator.prototype.element = null;\n\nComponentMediator.prototype.classList = null;\n\nComponentMediator.prototype.state = null;\n\nComponentMediator.prototype.disabled = false;\n\n/**\n*/\nComponentMediator.prototype.onRegister = function() {\n  this.viewComponent = this.createViewComponent(this.parent, this.element);\n  this.classList = this.viewComponent._classList;\n  UI.bindEvents(this.viewComponent, this);\n};\n\n/**\n*/\nComponentMediator.prototype.createViewComponent = function(parent, element) {\n  var type;\n  type = this.getTypeList();\n  return UI.create(type, parent, element);\n};\n\n/**\n*/\nComponentMediator.prototype.createMediatorName = function() {\n  var type;\n  type = this.getTypeList();\n  type.push(\"mediator\");\n  type.push(Utils.createUID());\n  return type.join(\"-\");\n};\n\n/**\n*/\nComponentMediator.prototype.getTypeList = function() {\n  var type;\n  type = [];\n  if (this.componentName != null) {\n    type.push(this.componentName);\n  }\n  if (this.componentType != null) {\n    type = type.concat(this.componentType);\n  }\n  return type;\n};\n\n/**\n*/\nComponentMediator.prototype.create = function(type, parent, element, text) {\n  if (parent == null) {\n    parent = this;\n  }\n  if (parent === false) {\n    parent = null;\n  }\n  return UI.create(type, parent, element, text);\n};\n\n/**\n*/\nComponentMediator.prototype.createText = function(type, text, parent, element) {\n  if (parent == null) {\n    parent = this;\n  }\n  return UI.create(type, parent, element, text);\n};\n\n/**\n*/\nComponentMediator.prototype.setState = function(value) {\n  if (value === this.state) {\n    return;\n  }\n  if (this.state != null) {\n    this.classList.remove(this.state);\n  }\n  this.state = value;\n  if (this.state != null) {\n    this.classList.add(this.state);\n  }\n  return value;\n};\n\n/**\n*/\nComponentMediator.prototype.getState = function() {\n  return this.state;\n};\n\n/**\n*/\nComponentMediator.prototype.setDisabled = function(value) {\n  if (value === this.disabled) {\n    return;\n  }\n  this.disabled = value;\n  if (this.disabled) {\n    this.classList.add(\"disabled\");\n  } else {\n    this.classList.remove(\"disabled\");\n  }\n  return value;\n};\n\n/**\n*/\nComponentMediator.prototype.getDisabled = function() {\n  return this.disabled;\n};\n\n/** \n * @constructor\n * @private\n * @extends {ComponentMediator}\n*/\nfunction MediaElementMediator(componentName, viewComponent) {\n  this.mediatorName = \"\" + this.componentType + \"-mediator\";\n  MediaElementMediator.__super__.constructor.call(this, componentName, null, null, viewComponent);\n}\n\n\n__extends(MediaElementMediator, ComponentMediator);\n\n\nMediaElementMediator.prototype.componentType = \"media-element\";\n\nMediaElementMediator.prototype.created = false;\n\nMediaElementMediator.prototype.onRegister = function() {\n  if (this.created !== true) {\n    this.created = true;\n    MediaElementMediator.__super__.onRegister.call(this);\n  }\n};\n\n/** \n * @constructor\n * @private\n*/\nfunction LayerMediator() {\n  LayerMediator.__super__.constructor.call(this);\n}\n\n\n__extends(LayerMediator, ComponentMediator);\n\n\nLayerMediator.prototype.componentType = \"layer\";\n\n/**\n * Registers the layer\n * \n * @override\n*/\nLayerMediator.prototype.onRegister = function() {\n  LayerMediator.__super__.onRegister.call(this);\n  this.registerLayer();\n};\n\n/**\n * Removes the layer\n * \n * @override\n*/\nLayerMediator.prototype.onRemove = function() {\n  LayerMediator.__super__.onRemove.call(this);\n  this.removeLayer();\n};\n\n/**\n *\n*/\nLayerMediator.prototype.registerLayer = function() {\n  this.sendNotification(Notifications.ADD_LAYER, this.viewComponent);\n};\n\n/**\n *\n*/\nLayerMediator.prototype.removeLayer = function() {\n  this.sendNotification(Notifications.REMOVE_LAYER, this.viewComponent);\n};\n\n/**\n * @constructor\n * @extends {LayerMediator}\n * @private\n*/\nfunction VideoLayerMediator() {\n  VideoLayerMediator.__super__.constructor.call(this);\n}\n\n\n__extends(VideoLayerMediator, LayerMediator);\n\n\nVideoLayerMediator.prototype.componentName = \"video\";\n\n/** @override\n*/\nVideoLayerMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.PLAYBACK_CORE_CHANGE];\n};\n\nVideoLayerMediator.prototype.mediator = null;\n\nVideoLayerMediator.prototype.mediaElement = null;\n\n/** @override\n*/\nVideoLayerMediator.prototype.handleNotification = function(notification) {\n  var body, isMediator, name;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.PLAYBACK_CORE_CHANGE:\n      if (this.mediaElement != null) {\n        this.viewComponent.removeChild(this.mediaElement);\n      }\n      if (this.mediator != null) {\n        this.facade.removeMediator(this.mediator.getMediatorName());\n      }\n      isMediator = (body != null ? body.getViewComponent : void 0) != null;\n      if (isMediator) {\n        this.facade.registerMediator(body);\n        this.mediator = body;\n        this.mediaElement = this.mediator.getViewComponent();\n      } else {\n        this.mediator = null;\n        this.mediaElement = body;\n      }\n      if (this.mediaElement != null) {\n        this.facade.setMediaElement(this.mediaElement);\n        this.viewComponent.appendChild(this.mediaElement);\n      }\n  }\n};\n\n/**\n * @constructor\n * @private\n * @extends {ModuleMediator}\n*/\nfunction PlayerMediator(componentName, viewComponent) {\n  this.componentName = componentName;\n  this.layers = [];\n  PlayerMediator.__super__.constructor.call(this, null, null, null, viewComponent);\n}\n\n\n__extends(PlayerMediator, ComponentMediator);\n\n\nPlayerMediator.prototype.componentType = \"player\";\n\nPlayerMediator.prototype.core = null;\n\nPlayerMediator.prototype.medium = null;\n\nPlayerMediator.prototype.layers = null;\n\nPlayerMediator.prototype.ready = false;\n\n/** @override\n*/\nPlayerMediator.prototype.onRegister = function() {\n  var device;\n  PlayerMediator.__super__.onRegister.call(this);\n  device = Utils.getDevice();\n  if ((device != null)) {\n    this.classList.add(device);\n  }\n  if (Utils.isTouchDevice()) {\n    this.classList.add(\"touch\");\n  }\n};\n\n/** @override\n*/\nPlayerMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.DISPLAY_STATE_CHANGE, Notifications.ACTIVE_STATE_CHANGE, Notifications.PLAY_STATE_CHANGE, Notifications.ADD_APPLICATION_STATE, Notifications.REMOVE_APPLICATION_STATE, Notifications.MEDIUM_CHANGE, Notifications.DURATION_CHANGE, Notifications.TEMPORAL_TYPE_CHANGE, Notifications.IS_LIVE, Notifications.ADD_LAYER, Notifications.REMOVE_LAYER, Notifications.READY];\n};\n\n/** @override\n*/\nPlayerMediator.prototype.handleNotification = function(notification) {\n  var body, name, previous, state, states, value;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.ACTIVE_STATE_CHANGE:\n    case Notifications.PLAY_STATE_CHANGE:\n    case Notifications.DISPLAY_STATE_CHANGE:\n    case Notifications.MEDIUM_CHANGE:\n      states = body;\n      value = states.value;\n      previous = states.previous;\n      if ((previous != null) && this.classList.contains(previous)) {\n        this.classList.remove(previous);\n      }\n      if (value != null) {\n        this.classList.add(value);\n      }\n      break;\n    case Notifications.ADD_APPLICATION_STATE:\n      state = body;\n      this.classList.add(state);\n      break;\n    case Notifications.REMOVE_APPLICATION_STATE:\n      state = body;\n      this.classList.remove(state);\n      break;\n    case Notifications.TEMPORAL_TYPE_CHANGE:\n      if (body.previous) {\n        this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, body.previous);\n      }\n      if (body.value) {\n        this.sendNotification(Notifications.ADD_APPLICATION_STATE, body.value);\n      }\n      break;\n    case Notifications.IS_LIVE:\n      if (body === true) {\n        this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"is-live\");\n      } else {\n        this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"is-live\");\n      }\n      break;\n    case Notifications.DURATION_CHANGE:\n      if (body > 3600) {\n        this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"long-form\");\n      } else {\n        this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"long-form\");\n      }\n      break;\n    case Notifications.ADD_LAYER:\n      this.addLayer(body);\n      break;\n    case Notifications.REMOVE_LAYER:\n      this.removeLayer(body);\n      break;\n    case Notifications.READY:\n      this.initialize();\n      this.viewCreated();\n  }\n};\n\n/**\n*/\nPlayerMediator.prototype.initialize = function() {\n  var layer, _i, _len, _ref;\n  this.ready = true;\n  _ref = this.layers;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    layer = _ref[_i];\n    if (!this.viewComponent.contains(layer)) {\n      this.viewComponent.appendChild(layer);\n    }\n  }\n};\n\nPlayerMediator.prototype.viewCreated = function() {\n  this.sendNotification(Notifications.VIEW_CREATED);\n};\n\n/**\n*/\nPlayerMediator.prototype.addLayer = function(layer) {\n  this.layers.push(layer);\n  if (this.ready) {\n    this.viewComponent.appendChild(layer);\n  }\n};\n\n/**\n*/\nPlayerMediator.prototype.removeLayer = function(layer) {\n  var index;\n  if (this.viewComponent.contains(layer)) {\n    this.viewComponent.removeChild(layer);\n  }\n  index = this.layers.indexOf(layer);\n  if (index >= 0) {\n    this.layers.splice(index, 1);\n  }\n};\n\n/** \n * @param {Object} viewComponent\n * @constructor\n * @private \n * @extends {PlayerMeditator}\n*/\nfunction FlashPlayerMediator(viewComponent) {\n  FlashPlayerMediator.__super__.constructor.call(this, this.type, viewComponent);\n}\n\n\n__extends(FlashPlayerMediator, PlayerMediator);\n\n\n/**\n * The name of the this Mediator.\n * \n * @static\n * @type {String}\n*/\nFlashPlayerMediator.NAME = \"FlashPlayerMediator\";\n\nFlashPlayerMediator.prototype.type = \"flash\";\n\n/** @override\n*/\nFlashPlayerMediator.prototype.listNotificationInterests = function() {\n  return FlashPlayerMediator.__super__.listNotificationInterests.call(this).concat([PluginNotifications.PLUGINS_INITIALIZED]);\n};\n\n/** @override\n*/\nFlashPlayerMediator.prototype.handleNotification = function(notification) {\n  var body, name;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.READY:\n      this.viewCreated();\n      return;\n    case PluginNotifications.PLUGINS_INITIALIZED:\n      this.initialize();\n      return;\n  }\n  FlashPlayerMediator.__super__.handleNotification.call(this, notification);\n};\n\n/**\n * The RegisterPlaybackCoreCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction PlaybackTargetChangeCommand() {\n  PlaybackTargetChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PlaybackTargetChangeCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nPlaybackTargetChangeCommand.prototype.execute = function(notification) {\n  var note, target;\n  target = notification.getBody().value;\n  if (target === \"amp\") {\n    note = Notifications.REMOVE_APPLICATION_STATE;\n  } else {\n    note = Notifications.ADD_APPLICATION_STATE;\n  }\n  this.sendNotification(note, \"remote-playback\");\n  PlaybackTargetChangeCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The FlashAuthorizedCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction FlashAuthorizedCommand() {\n  FlashAuthorizedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(FlashAuthorizedCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nFlashAuthorizedCommand.prototype.execute = function(notification) {\n  var media;\n  FlashAuthorizedCommand.__super__.execute.call(this, notification);\n  media = Utils.clone(this.media.getData());\n  media.src = this.media.getSrc();\n  this.facade.getMediaElement().authenticationComplete({\n    media: media\n  });\n};\n\n/**\n * PlaybackCoreProxy constructor.\n *\n * @constructor\n * @private\n * @extends {PlaybackProxy}\n*/\nfunction PlaybackCoreProxy(supportedTypes, config) {\n  this.supportedTypes = supportedTypes != null ? supportedTypes : this.supportedTypes;\n  this.config = config;\n  PlaybackCoreProxy.__super__.constructor.call(this);\n  this.temporalTypes = [\"vod\", \"live\", \"ondemand\"];\n}\n\n\n__extends(PlaybackCoreProxy, PlaybackProxy);\n\n\nPlaybackCoreProxy.prototype.temporalTypes = null;\n\nPlaybackCoreProxy.prototype.supportedTypes = null;\n\nPlaybackCoreProxy.prototype.playbackCoreName = \"default\";\n\nPlaybackCoreProxy.prototype.config = null;\n\n/**\n*/\nPlaybackCoreProxy.prototype.onRegister = function() {\n  this.mediaProxy = this.facade.retrieveProxy(MediaProxy.NAME);\n};\n\n/**\n*/\nPlaybackCoreProxy.prototype.getUseMAE = function() {\n  var maeConfig;\n  maeConfig = this.config.mae;\n  return (maeConfig != null) && maeConfig.enabled !== false;\n};\n\n/**\n*/\nPlaybackCoreProxy.prototype.getPlaybackCoreName = function() {\n  return this.playbackCoreName;\n};\n\n/**\n*/\nPlaybackCoreProxy.prototype.getSupportedTypes = function() {\n  return this.supportedTypes || [];\n};\n\n/**\n*/\nPlaybackCoreProxy.prototype.setSupportedTypes = function(types) {\n  this.supportedTypes = types;\n  return types;\n};\n\n/**\n*/\nPlaybackCoreProxy.prototype.getTemporalTypes = function() {\n  return this.temporalTypes || [];\n};\n\n/**\n*/\nPlaybackCoreProxy.prototype.setTemporalTypes = function(types) {\n  this.temporalTypes = types;\n  return types;\n};\n\n/** @override\n*/\nPlaybackCoreProxy.prototype.canPlayTemporalType = function(temporalType) {\n  return this.getTemporalTypes().indexOf(temporalType) !== -1;\n};\n\n/** @override\n*/\nPlaybackCoreProxy.prototype.canPlayType = function(mimeType) {\n  if (this.supportedTypes != null) {\n    if (this.getSupportedTypes().indexOf(mimeType) !== -1) {\n      return \"maybe\";\n    } else {\n      return \"\";\n    }\n  } else {\n    return PlaybackCoreProxy.__super__.canPlayType.call(this, mimeType);\n  }\n};\n\n/**\n * ChromeCastPlaybackProxy constructor.\n * \n * @constructor\n * @extends {PlaybackCoreProxy}\n * @private\n*/\nfunction FlashPlaybackProxy(player) {\n  this.player = player;\n  FlashPlaybackProxy.__super__.constructor.call(this);\n}\n\n\n__extends(FlashPlaybackProxy, PlaybackCoreProxy);\n\n\n/**\n * The name of the this Proxy.\n * \n * @static\n * @type {string}\n*/\nFlashPlaybackProxy.NAME = PlaybackProxy.NAME;\n\nFlashPlaybackProxy.prototype.player = null;\n\nFlashPlaybackProxy.prototype.initialized = true;\n\nFlashPlaybackProxy.prototype.playbackCoreName = \"flash\";\n\nFlashPlaybackProxy.prototype.supportedTypes = [\"video/mp4\", \"video/x-flv\", \"video/f4m\", \"application/smil\", \"application/smil+xml\"];\n\n/**     \n * Indicates whether or not the video is playing.\n * \n * @returns {Boolean} \n *    The playing value\n * @type {Boolean}\n*/\nFlashPlaybackProxy.prototype.getPaused = function() {\n  return this.player.getPaused();\n};\n\n/**     \n * Indicates whether or not the video is playing.\n * \n * @returns {Boolean} \n *    The playing value\n * @type {Boolean}\n*/\nFlashPlaybackProxy.prototype.getEnded = function() {\n  return this.player.getEnded();\n};\n\n/**     \n * Indicates whether or not the video is playing.\n * \n * @returns {Boolean} \n *    The playing value\n * @type {Boolean}\n*/\nFlashPlaybackProxy.prototype.getSeeking = function() {\n  return this.player.getSeeking();\n};\n\n/**     \n * The current time of the video in seconds. Value must be between currentTime and duration.\n * \n * @param {Number} value\n *    The new currentTime value in seconds\n * @returns {Number} \n *    The currentTime value in seconds\n * @type {Number}\n*/\nFlashPlaybackProxy.prototype.getCurrentTime = function() {\n  return this.player.getCurrentTime();\n};\n\nFlashPlaybackProxy.prototype.setCurrentTime = function(value) {\n  this.player.setCurrentTime(value);\n  return value;\n};\n\n/**     \n * The current time of the video in seconds. Value must be between currentTime and duration.\n * \n * @param {Number} value\n *    The new currentTime value in seconds\n * @returns {Number} \n *    The currentTime value in seconds\n * @type {Number}\n*/\nFlashPlaybackProxy.prototype.getSrc = function() {\n  return this.player.getSrc();\n};\n\nFlashPlaybackProxy.prototype.setSrc = function(value) {\n  this.player.setSrc(value);\n  return value;\n};\n\n/**     \n * The current time of the video in seconds. Value must be between currentTime and duration.\n * \n * @param {Number} value\n *    The new currentTime value in seconds\n * @returns {Number} \n *    The currentTime value in seconds\n * @type {Number}\n*/\nFlashPlaybackProxy.prototype.getVolume = function() {\n  return this.player.getVolume();\n};\n\nFlashPlaybackProxy.prototype.setVolume = function(value) {\n  this.player.setVolume(value);\n  return value;\n};\n\n/**\n*/\nFlashPlaybackProxy.prototype.getMuted = function() {\n  return this.player.getMuted();\n};\n\nFlashPlaybackProxy.prototype.setMuted = function(value) {\n  this.player.setMuted(value);\n  return value;\n};\n\n/**\n * The duration of the video in seconds.\n *     \n * @returns {Number} \n *    The duration of the video\n * @type {Number}\n*/\nFlashPlaybackProxy.prototype.getDuration = function(value) {\n  return this.player.getDuration();\n};\n\n/**\n * Instructs the core to play.\n*/\nFlashPlaybackProxy.prototype.play = function() {\n  this.player.play();\n};\n\n/**\n * Instructs the core to pause.\n*/\nFlashPlaybackProxy.prototype.pause = function() {\n  this.player.pause();\n};\n\n/**\n * Instructs the core to load.\n*/\nFlashPlaybackProxy.prototype.load = function() {\n  this.player.load();\n};\n\n/**\n * The FlashPlayer class\n *\n * @param {Object} viewComponent\n * @constructor\n * @private\n * @extends {Player}\n*/\nfunction FlashPlayer(viewComponent) {\n  var _this = this;\n  this.flashObjectID += Date.now();\n  this.plugins = {};\n  this._displayState = DisplayState.NORMAL;\n  this.debug = /debug\\=true/.test(location.search);\n  FlashPlayer.__super__.constructor.call(this, viewComponent);\n  this.addEventListener(\"mediachange\", function(event) {\n    var item, mediaElement, textTracks, track, tracks, _i, _len;\n    tracks = event.detail.track;\n    mediaElement = _this.getMediaElement();\n    textTracks = mediaElement.textTracks = [];\n    if (!(tracks != null)) {\n      return;\n    }\n    for (_i = 0, _len = tracks.length; _i < _len; _i++) {\n      track = tracks[_i];\n      item = {\n        kind: track.kind,\n        label: track.label,\n        language: track.srclang,\n        _mode: track.mode\n      };\n      Object.defineProperty(item, \"mode\", {\n        get: function() {\n          return this._mode;\n        },\n        set: function(value) {\n          var visible;\n          this._mode = value;\n          visible = value === \"showing\";\n          if (visible) {\n            mediaElement.setTrackByLanguage(this.language);\n          }\n          mediaElement.setPlayerProperty(\"captionDisplay\", {\n            visible: visible\n          });\n        },\n        enumerable: true,\n        configurable: false\n      });\n      textTracks.push(item);\n    }\n  });\n}\n\n\n__extends(FlashPlayer, Player);\n\n\n/**\n * @override\n*/\nFlashPlayer.prototype.initialize = function(config, parentModule) {\n  var _ref, _ref1;\n  this.config = config;\n  this.parentModule = parentModule;\n  this.createDefaults();\n  this.logEvents = ((_ref = this.config.flash) != null ? _ref.logEvents : void 0) === true || ((_ref1 = QueryString[\"amp-flash-log\"]) != null ? _ref1.toLowerCase() : void 0) === \"true\";\n  FlashPlayer.__super__.initialize.call(this, this.config, this.parentModule);\n};\n\n/**\n*/\nFlashPlayer.prototype.loadModuleResources = function(resources) {\n  var _this = this;\n  return FlashPlayer.__super__.loadModuleResources.call(this, resources).then(function() {\n    var key, locales, promises, update, value;\n    locales = _this.config.locales;\n    promises = [];\n    update = function(key, resource) {\n      locales[key] = resource.data;\n    };\n    for (key in locales) {\n      value = locales[key];\n      if (typeof value === \"string\") {\n        promises.push(AMP.addResource({\n          src: _this.evaluatePaths(value),\n          type: Utils.mimeTypes.json\n        }).then(update.bind(_this, key))[\"catch\"](function(error) {\n          return Promise.resolve();\n        }));\n      }\n    }\n    return Promise.all(promises);\n  });\n};\n\n/** @override\n*/\nFlashPlayer.prototype.pluginsinitialized = function() {\n  var attributes, expressInstallSWF, flash, params, swf, swfs, version, xml, _ref;\n  flash = this.config.flash || {};\n  swfs = ((_ref = flash[\"static\"]) != null ? _ref.enabled : void 0) === true ? flash[\"static\"] : flash;\n  swf = this.debug && (swfs.debug != null) ? swfs.debug : swfs.swf || \"amp.swf\";\n  version = flash.version || \"10.1\";\n  expressInstallSWF = this.evaluatePaths(flash.expressInstallSWF) || \"playerProductInstall.swf\";\n  params = this.createParams(flash);\n  attributes = this.createAttributes(flash);\n  this.flashvars = this.createFlashVars(flash);\n  if (!(this.flashvars.settings_url != null)) {\n    xml = this.createXML(this.config);\n    if (xml != null) {\n      this.flashvars.settings_xml = xml;\n    }\n  }\n  attributes.data = this.evaluatePaths(swf);\n  this.createdHandler(Utils.createFlashObject({\n    params: params,\n    attributes: attributes,\n    vars: this.flashvars\n  }, this.getMediaElement().parentNode));\n};\n\nFlashPlayer.prototype.playerType = \"flash\";\n\nFlashPlayer.prototype.flashObjectID = \"flashObject\";\n\nFlashPlayer.prototype.loaded = false;\n\nFlashPlayer.prototype.flashvars = null;\n\nFlashPlayer.prototype._paused = false;\n\nFlashPlayer.prototype._ended = false;\n\nFlashPlayer.prototype._muted = false;\n\nFlashPlayer.prototype.plugins = null;\n\nFlashPlayer.prototype.debug = false;\n\nFlashPlayer.prototype.started = false;\n\nFlashPlayer.prototype._displayState = null;\n\nFlashPlayer.prototype.logEvents = false;\n\nFlashPlayer.prototype._loop = false;\n\nFlashPlayer.prototype.playback = null;\n\nFlashPlayer.prototype.flashPlugins = [\n  {\n    id: \"AkamaiAdvancedStreamingPlugin\",\n    src: \"//sslplayers-vh.akamaihd.net/flash/plugins/osmf/advanced-streaming-plugin/v3.10/osmf2.0/AkamaiAdvancedStreamingPlugin.swf\",\n    absolute: true,\n    host: \"osmf\",\n    main: \"com.akamai.osmf.AkamaiAdvancedStreamingPluginInfo\",\n    type: \"application/x-shockwave-flash\"\n  }, {\n    id: \"ErrorMessagingPlugin\",\n    src: '#{paths.resources}plugins/ErrorMessagingPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"ErrorMessagingPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }, {\n    id: \"VideoMetricsViewPlugin\",\n    src: '#{paths.resources}plugins/VideoMetricsViewPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"VideoMetricsViewPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }, {\n    id: \"VideoStatsInfoOverlayPlugin\",\n    src: '#{paths.resources}plugins/VideoStatsInfoOverlayPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"VideoStatsInfoOverlayPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }\n];\n\nFlashPlayer.prototype.flashView = null;\n\n/** @override\n*/\nFlashPlayer.prototype.createModel = function() {\n  FlashPlayer.__super__.createModel.call(this);\n  this.playback = new FlashPlaybackProxy(this);\n  this.registerProxy(this.playback);\n  this.appState.setRenderMode(RenderMode.FLASH);\n  this.bindings.initialize();\n};\n\n/** @override\n*/\nFlashPlayer.prototype.createView = function() {\n  FlashPlayer.__super__.createView.call(this);\n  this.mediator = new FlashPlayerMediator(this.getViewComponent());\n  this.registerMediator(this.mediator);\n  this.registerMediator(new VideoLayerMediator());\n  this.registerMediator(new OverlayLayerMediator());\n  this.registerMediator(new LocalizationWrapper(this, this.config));\n};\n\n/** @override\n*/\nFlashPlayer.prototype.createController = function() {\n  var _ref,\n    _this = this;\n  FlashPlayer.__super__.createController.call(this);\n  if (((_ref = this.config.plugins) != null ? _ref.react : void 0) != null) {\n    this.registerCommand(Notifications.CHANGE_DISPLAY_STATE, ChangeDisplayStateCommand);\n    this.getDisplayState = function() {\n      return _this.appState.getDisplayState();\n    };\n    this.setDisplayState = function(value) {\n      return _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, value);\n    };\n  }\n  this.registerCommand(PluginNotifications.PLUGINS_INITIALIZED, FlashPluginsInitializedCommand);\n  this.registerCommand(SecurityNotifications.AUTHORIZE, PlayerEventCommand);\n  this.registerCommand(SecurityNotifications.AUTHORIZED, FlashAuthorizedCommand);\n  this.registerCommand(Notifications.CHANGE_PLAY_STATE, ChangePlayStateCommand);\n  this.registerCommand(Notifications.PLAY_STATE_CHANGE, PlayerEventCommand);\n  this.registerCommand(Notifications.START, FlashStartCommand);\n  this.registerCommand(Notifications.STARTED, PlayerEventCommand);\n  this.registerCommand(Notifications.PLAY, PlayerEventCommand);\n  this.registerCommand(Notifications.PLAY_REQUEST, PlayerEventCommand);\n  this.registerCommand(FlashNotifications.FLASH_CREATED, PlayerEventCommand);\n  this.registerCommand(Notifications.PLAYBACK_TARGET_CHANGE, PlaybackTargetChangeCommand);\n  this.registerCommand(Notifications.UPDATE_DATA_BINDINGS, UpdateDataBindingsCommand);\n  this.registerCommand(Notifications.BUFFERING_CHANGE, BufferingChangeCommand);\n  this.registerCommand(FlashNotifications.CREATE_XML, PlayerEventCommand);\n  this.registerCommand(FlashNotifications.CREATE_FLASH_VARS, PlayerEventCommand);\n};\n\n/** @override\n*/\nFlashPlayer.prototype.createMediaElement = function() {\n  var video, viewComponent;\n  video = new MediaElementMediator(\"flash\", \"div\");\n  this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, video);\n  viewComponent = video.getViewComponent();\n  viewComponent.id = viewComponent.name = this.flashObjectID;\n  return viewComponent;\n};\n\n/**\n*/\nFlashPlayer.prototype.createDefaults = function() {\n  var plugin, resources, swf, _i, _len, _ref, _ref1, _ref2;\n  if (!((_ref = this.flashPlugins) != null ? _ref.length : void 0) > 0) {\n    return;\n  }\n  resources = this.config.resources || [];\n  if (((_ref1 = this.config.flash) != null ? _ref1.resources : void 0) != null) {\n    resources = resources.concat(this.config.flash.resources);\n  }\n  swf = Utils.mimeTypes.swf;\n  _ref2 = this.flashPlugins;\n  for (_i = 0, _len = _ref2.length; _i < _len; _i++) {\n    plugin = _ref2[_i];\n    if ((plugin != null) && resources.filter(function(resource) {\n      return resource.id === plugin.id;\n    }).length === 0) {\n      if (plugin.type == null) {\n        plugin.type = swf;\n      }\n      resources.push(plugin);\n    }\n  }\n  this.config.resources = resources;\n};\n\n/**\n*/\nFlashPlayer.prototype.createParams = function(flash) {\n  var params;\n  params = {\n    allowFullScreen: true,\n    allowScriptAccess: \"always\",\n    wmode: \"direct\",\n    bgColor: \"#000000\"\n  };\n  if (flash.params != null) {\n    if (flash.params.allowFullScreen != null) {\n      params.allowFullScreen = flash.params.allowFullScreen;\n    }\n    if (flash.params.allowScriptAccess != null) {\n      params.allowScriptAccess = flash.params.allowScriptAccess;\n    }\n    if (flash.params.wmode != null) {\n      params.wmode = flash.params.wmode;\n    }\n    if (flash.params.bgColor != null) {\n      params.bgColor = flash.params.bgColor;\n    }\n  }\n  if (params.wmode === \"direct\" && /MSIE/.test(navigator.userAgent)) {\n    params.wmode = \"transparent\";\n  }\n  return params;\n};\n\n/** @override\n*/\nFlashPlayer.prototype.getModules = function() {\n  return this.plugins;\n};\n\n/** @override\n*/\nFlashPlayer.prototype.createPlugins = function() {\n  var def, feature, init, key, plugin, plugins, promises, register, type, _ref,\n    _this = this;\n  type = this.getPlayerType();\n  _ref = AMP.plugins;\n  for (key in _ref) {\n    register = _ref[key];\n    if (!((key in this.config) && (this.config[key] != null) && !(this.config[key].enabled === false))) {\n      continue;\n    }\n    def = register[type];\n    if (!(def != null)) {\n      this.logger.debug(\"[AMP] Plugin could not be found: \" + key);\n      continue;\n    }\n    try {\n      plugin = this[key] = this.plugins[key] = new def(this, this.config[key]);\n      this.registerMediator(this.plugins[key]);\n      feature = typeof plugin.getFeatureName === \"function\" ? plugin.getFeatureName() : void 0;\n      if (feature != null) {\n        this[feature] = plugin;\n      }\n      if (plugin.flashView != null) {\n        this.flashView = Utils.override(this.flashView, plugin.flashView);\n      }\n      this.logger.debug(\"[AMP] Plugin registered: \" + key);\n    } catch (error) {\n      this.logger.error(\"[AMP] Plugin could not be created: \" + key + \". \" + error);\n      continue;\n    }\n  }\n  plugins = this.config.plugins || {};\n  promises = [];\n  for (key in plugins) {\n    init = plugins[key];\n    if (!((init != null) && init.enabled !== false)) {\n      continue;\n    }\n    plugin = function(player, config, key) {\n      return _this.loadResources(config.resources).then(function() {\n        def = AMP.plugins[key][type];\n        if (!(def != null)) {\n          throw new Error(\"[AMP] Plugin could not be found: \" + key);\n        }\n        return def(player, config, key).then(function(result) {\n          _this.logger.debug(\"[AMP] Plugin registered: \" + key);\n          return {\n            key: key,\n            value: result\n          };\n        });\n      })[\"catch\"](function(error) {\n        return _this.logger.error(\"[AMP] Plugin could not be created: \" + key + \". \" + error);\n      });\n    };\n    promises.push(plugin.bind(null, this, init, key));\n  }\n  promises = promises.map(function(item) {\n    return item();\n  });\n  Promise.all(promises).then(function(plugins) {\n    var plugin, _i, _len;\n    if (_this.config.flash.view != null) {\n      _this.flashView = Utils.override(_this.flashView, _this.config.flash.view);\n    }\n    for (_i = 0, _len = plugins.length; _i < _len; _i++) {\n      plugin = plugins[_i];\n      if (!(plugin != null)) {\n        continue;\n      }\n      _this[plugin.key] = plugin.value;\n      _this.plugins[plugin.key] = plugin.value;\n    }\n    return _this.sendNotification(PluginNotifications.PLUGINS_INITIALIZED, _this.plugins);\n  })[\"catch\"](function(error) {\n    return _this.logger.error(error);\n  });\n};\n\n/**\n*/\nFlashPlayer.prototype.createAttributes = function(flash) {\n  var attributes;\n  attributes = {\n    id: this.flashObjectID,\n    name: this.flashObjectID\n  };\n  if (flash.attributes != null) {\n    if (flash.attributes.id != null) {\n      attributes.id = flash.attributes.id;\n    }\n    if (flash.attributes.name != null) {\n      attributes.name = flash.attributes.name;\n    }\n  }\n  return attributes;\n};\n\n/**\n*/\nFlashPlayer.prototype.createFlashJSON = function(config, spacer) {\n  var prepJSON, prepValue;\n  if (config == null) {\n    config = this.config;\n  }\n  config = JSON.stringify(config);\n  config = this.evaluatePaths(config);\n  config = JSON.parse(config);\n  prepValue = function(config, key, value) {\n    switch (typeof value) {\n      case \"string\":\n        config[key] = escape(value);\n        break;\n      case \"object\":\n        prepJSON(value);\n    }\n  };\n  prepJSON = function(config) {\n    var key, value, _i, _len;\n    if (config instanceof Array) {\n      for (key = _i = 0, _len = config.length; _i < _len; key = ++_i) {\n        value = config[key];\n        prepValue(config, key, value);\n      }\n    } else if (typeof config === \"object\") {\n      for (key in config) {\n        value = config[key];\n        prepValue(config, key, value);\n      }\n    }\n  };\n  prepJSON(config);\n  return encodeURIComponent(JSON.stringify(config, null, spacer));\n};\n\n/**\n*/\nFlashPlayer.prototype.createFlashVars = function(flash) {\n  var flashvars, loadingViewString, prop, settings, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;\n  flashvars = {};\n  settings = Object.assign({}, this.config, this.config.plugins);\n  delete settings.plugins;\n  settings.flash = null;\n  delete settings.flash;\n  settings.locales = null;\n  delete settings.locales;\n  settings.params = null;\n  delete settings.params;\n  settings.rules = null;\n  delete settings.rules;\n  flashvars.settings_json = this.createFlashJSON(settings);\n  if (this.config.autoplay != null) {\n    flashvars.auto_play = this.config.autoplay;\n  }\n  if ((this.config.rules != null)) {\n    Utils.mergeRules(this.config.rules);\n  }\n  flashvars.hinting_rules = escape(JSON.stringify(Utils.rules));\n  if (this.config.volume != null) {\n    flashvars.volume = Utils.clamp(this.config.volume, 0, 1);\n  }\n  if ((this.config.target != null)) {\n    flashvars.external_target = this.config.target;\n  }\n  if ((this.config.name != null)) {\n    flashvars.core_player_name = this.config.name;\n  }\n  if ((this.config.domain != null)) {\n    flashvars.embed_domain = flashvars.domain = this.config.domain;\n  }\n  this._loop = flashvars.auto_replay = this.config.loop === true;\n  if (this.config.fullscreen != null) {\n    flashvars.fullscreen_enabled = this.config.fullscreen.enabled !== false && this.config.fullscreen.mode !== FullscreenMode.EXTERNAL;\n  }\n  if (this.config.titlebar != null) {\n    flashvars.titlebar_enabled = this.config.titlebar.enabled !== false;\n  }\n  if (this.config.params != null) {\n    flashvars.params = escape(JSON.stringify(this.config.params));\n  }\n  if (this.config.version != null) {\n    flashvars.context_menu_label = this.config.version;\n  }\n  if (((_ref = this.config.controls) != null ? _ref.displaySceneMarkers : void 0) != null) {\n    flashvars.displaySceneMarkers = this.config.controls.displaySceneMarkers;\n  }\n  if (this.config.media != null) {\n    this.mediaProxy.setData(this.config.media);\n    if (this.config.media.src != null) {\n      this.setSrc(this.config.media.src);\n      flashvars.video_url = escape(this.config.media.src);\n    }\n    if ((this.config.media.source != null) && this.config.media.source.length > 0) {\n      this.setSource(this.config.media.source);\n      flashvars.video_url = escape(this.mediaProxy.getSrc());\n    }\n    if (this.config.media.medium != null) {\n      this.setMedium(this.config.media.medium);\n      flashvars.medium = this.config.media.medium;\n    }\n    if (this.config.media.title != null) {\n      flashvars.title = encodeURIComponent(this.config.media.title);\n    }\n    if (this.config.media.poster != null) {\n      flashvars.poster = escape(this.config.media.poster);\n    }\n    if (this.config.media.temporalType != null) {\n      flashvars.temporalType = this.config.media.temporalType;\n    }\n  }\n  if (this.getMedium() === \"audio\") {\n    flashvars.controls = true;\n    flashvars.auto_hide = -1;\n  }\n  if (((_ref1 = this.config.ima) != null ? (_ref2 = _ref1.overlay) != null ? _ref2.delay : void 0 : void 0) != null) {\n    flashvars.overlay_ad_delay = this.config.ima.overlay.delay;\n  }\n  if ((this.config.ticker != null) && this.config.ticker.enabled !== false) {\n    if (this.config.ticker.url != null) {\n      flashvars.ticker_text_url = this.config.ticker.url;\n    }\n    if (this.config.ticker.interval != null) {\n      flashvars.ticker_polling_interval = this.config.ticker.interval;\n    }\n    if (this.config.ticker.speed != null) {\n      flashvars.ticker_speed = this.config.ticker.speed;\n    }\n  }\n  flashvars.show_play_button_overlay = false;\n  flashvars.auto_play_list = false;\n  flashvars.next_video_timer = 0;\n  if (flashvars.context_menu_mode == null) {\n    flashvars.context_menu_mode = this.debug === true ? \"long\" : \"short\";\n  }\n  if (((_ref3 = this.config.flash) != null ? (_ref4 = _ref3.view) != null ? (_ref5 = _ref4.elements) != null ? (_ref6 = _ref5.loadingView) != null ? _ref6.attributes : void 0 : void 0 : void 0 : void 0) != null) {\n    loadingViewString = \"\";\n    for (prop in this.config.flash.view.elements.loadingView.attributes) {\n      loadingViewString += prop + \":\" + this.config.flash.view.elements.loadingView.attributes[prop] + \" \";\n    }\n    flashvars.loadingView = loadingViewString;\n  }\n  this.sendNotification(FlashNotifications.CREATE_FLASH_VARS, {\n    flashvars: flashvars,\n    config: this.config\n  });\n  flashvars = Utils.override(flashvars, flash.vars);\n  return flashvars;\n};\n\n/**\n*/\nFlashPlayer.prototype.createXML = function(config) {\n  var app, element, elements, isStatic, key, mode, node, parent, parseResources, parseView, plugin, plugins, str, swf, value, viewXML, xml, _i, _j, _len, _len1, _ref, _ref1, _ref2;\n  if (!((config != null ? (_ref = config.flash) != null ? _ref.xml : void 0 : void 0) != null)) {\n    if (config.flash == null) {\n      config.flash = {};\n    }\n    config.flash.xml = \"<application></application>\";\n  }\n  xml = XMLUtils.parse(config.flash.xml);\n  if (xml.childNodes.length > 1) {\n    xml.removeChild(xml.firstChild);\n  }\n  this.sendNotification(FlashNotifications.CREATE_XML, {\n    config: config,\n    xml: xml\n  });\n  parseResources = function(config) {\n    var key, plugins, resource, resources, value, _i, _len, _ref1;\n    resources = config.resources;\n    plugins = [];\n    if ((resources instanceof Array) && ((resources != null ? resources.length : void 0) > 0)) {\n      for (_i = 0, _len = resources.length; _i < _len; _i++) {\n        resource = resources[_i];\n        if (!(resource.type === swf)) {\n          continue;\n        }\n        resource = Utils.clone(resource);\n        if (isStatic === true) {\n          if ((resource.main != null) && resource.main !== \"\") {\n            resource.src = resource.main;\n            resource.type = \"static\";\n          } else {\n            resource.type = \"dynamic\";\n          }\n        } else {\n          if ((resource.src != null) && resource.src !== \"\") {\n            resource.type = \"dynamic\";\n          } else {\n            resource.src = resource.main;\n            resource.type = \"static\";\n          }\n        }\n        delete resource.main;\n        plugins.push(resource);\n      }\n    }\n    for (key in config) {\n      value = config[key];\n      if (key !== \"flash\" && ((resources = value != null ? value.resources : void 0) != null) && (resources instanceof Array) && (resources.length > 0)) {\n        plugins = plugins.concat(parseResources(value));\n      }\n    }\n    _ref1 = config.plugins;\n    for (key in _ref1) {\n      value = _ref1[key];\n      if (((resources = value != null ? value.resources : void 0) != null) && (resources instanceof Array) && (resources.length > 0)) {\n        plugins = plugins.concat(parseResources(value));\n      }\n    }\n    return plugins;\n  };\n  swf = Utils.mimeTypes.swf;\n  plugins = parseResources(this.config);\n  isStatic = ((_ref1 = config.flash[\"static\"]) != null ? _ref1.enabled : void 0) === true;\n  if ((plugins != null ? plugins.length : void 0) > 0) {\n    parent = xml.getElementsByTagName(\"plugins\");\n    if (parent.length < 1) {\n      parent = xml.createElement(\"plugins\");\n      xml.firstChild.appendChild(parent);\n    } else {\n      parent = parent[0];\n    }\n    for (_i = 0, _len = plugins.length; _i < _len; _i++) {\n      plugin = plugins[_i];\n      if (!(plugin.enabled !== false)) {\n        continue;\n      }\n      node = xml.createElement(\"plugin\");\n      for (key in plugin) {\n        value = plugin[key];\n        if (key !== \"loaded\") {\n          if (key !== \"src\") {\n            node.setAttribute(key, \"\" + value);\n          } else {\n            if (key === \"id\" && value === \"AkamaiAdvancedStreamingPlugin\" && this.debug === true) {\n              value = value.replace(\"AkamaiAdvancedStreamingPlugin.swf\", \"AkamaiAdvancedStreamingPlugin-logging.swf\");\n            }\n            node.appendChild(XMLUtils.createTextContent(xml, value));\n          }\n        }\n      }\n      parent.appendChild(node);\n    }\n  }\n  parseView = function(view, node) {\n    var element, key, value, _ref2, _ref3, _ref4;\n    if (view.attributes != null) {\n      _ref2 = view.attributes;\n      for (key in _ref2) {\n        value = _ref2[key];\n        node.setAttribute(key, \"\" + value);\n      }\n    }\n    if (view.elements != null) {\n      _ref3 = view.elements;\n      for (key in _ref3) {\n        value = _ref3[key];\n        if (!(value != null)) {\n          continue;\n        }\n        element = xml.createElement(\"element\");\n        element.setAttribute(\"id\", key);\n        if (element.id === \"state\") {\n          continue;\n        }\n        parseView(value, element);\n        node.appendChild(element);\n      }\n    }\n    if (view.state != null) {\n      element = xml.createElement(\"state\");\n      if (view.state.attributes) {\n        _ref4 = view.state.attributes;\n        for (key in _ref4) {\n          value = _ref4[key];\n          if (value != null) {\n            element.setAttribute(key, \"\" + value);\n          }\n        }\n      }\n      node.appendChild(element);\n    }\n    return node;\n  };\n  viewXML = xml.getElementsByTagName(\"view\")[0];\n  if (!(viewXML != null)) {\n    viewXML = xml.createElement(\"view\");\n    xml.firstChild.appendChild(viewXML);\n  }\n  parseView(this.flashView, viewXML);\n  mode = (_ref2 = this.config.fullscreen) != null ? _ref2.mode : void 0;\n  if (mode != null) {\n    elements = xml.getElementsByTagName(\"element\");\n    for (_j = 0, _len1 = elements.length; _j < _len1; _j++) {\n      element = elements[_j];\n      if (element.getAttribute(\"id\") === \"fullscreenBtn\") {\n        element.setAttribute(\"action\", \"external\");\n      }\n    }\n  }\n  str = XMLUtils.serialize(xml);\n  app = str.match(/<application>[\\w\\W\\s\\S\\d\\D]*<\\/application>/)[0] || str;\n  app = app.replace(/[\\n\\r\\t]/g, \"\");\n  app = this.evaluatePaths(app);\n  return encodeURIComponent(app);\n};\n\n/**\n*/\nFlashPlayer.prototype.createdHandler = function(obj) {\n  var id, mediaElement,\n    _this = this;\n  id = this.getMediaElement().id;\n  mediaElement = document.getElementById(id);\n  this.setMediaElement(mediaElement);\n  mediaElement.className = Namespace.PREFIX + MediaElementMediator.prototype.componentType;\n  mediaElement.eventHandler = function(eventName, body) {\n    return _this.eventHandler(eventName, body);\n  };\n  this.sendNotification(FlashNotifications.FLASH_CREATED);\n  if (this.getMedium() != null) {\n    this.setMedium(this.getMedium());\n  }\n};\n\n/**\n*/\nFlashPlayer.prototype.eventHandler = function(eventName, body) {\n  var error, event, helper, media, state, type, update, _ref, _ref1, _ref2, _ref3,\n    _this = this;\n  if (this.logEvents && !this.excludedFlashEvents.test(eventName)) {\n    this.logger.log(\"[AMP FLASH EVENT] \" + eventName, body);\n  }\n  try {\n    switch (eventName) {\n      case FlashNotifications.INITIALIZED:\n        type = state = \"ready\";\n        break;\n      case FlashNotifications.RESET:\n        if (!(body != null)) {\n          state = \"ready\";\n        }\n        this.started = false;\n        break;\n      case FlashNotifications.LOADING:\n        type = \"loadstart\";\n        break;\n      case FlashNotifications.PLAYER_ERROR:\n        type = state = \"error\";\n        break;\n      case FlashNotifications.MEDIA_ERROR:\n        type = state = \"error\";\n        break;\n      case FlashNotifications.FEED_LOADED:\n        body = JSON.parse(body);\n        helper = new MRSSHelper();\n        media = (_ref = helper.createFeed(body)) != null ? (_ref1 = _ref.item) != null ? _ref1[0] : void 0 : void 0;\n        if (media != null) {\n          this.mediaProxy.setData(media);\n        }\n        break;\n      case FlashNotifications.FEED_UPDATED:\n        type = \"mediachange\";\n        body = this.getMedia();\n        update = true;\n        break;\n      case FlashNotifications.ERROR_STREAM_NOT_FOUND:\n        type = state = \"error\";\n        break;\n      case FlashNotifications.CAPABILITY_CHANGE:\n        event = body.type;\n        if (event === \"canPlayChange\" && body.enabled === true) {\n          type = \"canplay\";\n          this.loaded = true;\n        } else if (event === \"canSeekChange\" && body.enabled === true) {\n          type = \"canplaythrough\";\n        } else if (event === \"temporalChange\" && body.enabled === true) {\n          type = \"loadedmetadata\";\n          if (!this.started) {\n            this.sendNotification(Notifications.START, body);\n          }\n        }\n        break;\n      case FlashNotifications.PLAYING:\n        if (!this.started) {\n          this.sendNotification(Notifications.START, body);\n        }\n        type = state = \"playing\";\n        this._ended = false;\n        this._paused = false;\n        if (this.appState.getSeeking() === true) {\n          this.appState.setSeeking(false);\n          this.sendNotification(Notifications.SEEKED);\n          this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"seeked\"));\n        }\n        break;\n      case FlashNotifications.ELEMENT_EVENT:\n        if (body.element === \"fullscreenBtn\" && body.type === \"click\" && ((_ref2 = this.config) != null ? (_ref3 = _ref2.fullscreen) != null ? _ref3.mode : void 0 : void 0) === FullscreenMode.EXTERNAL) {\n          state = this.getDisplayState() === DisplayState.FULL_SCREEN ? DisplayState.NORMAL : DisplayState.FULL_SCREEN;\n          this.setDisplayState(state);\n        }\n        break;\n      case FlashNotifications.PLAY_REQUEST:\n        this.sendNotification(Notifications.PLAY_REQUEST);\n        this.setPlayState(\"playing\");\n        type = Notifications.MEDIA_SEQUENCE_STARTED;\n        this.loaded = true;\n        this._ended = false;\n        break;\n      case FlashNotifications.PLAY:\n        if (this.getPlayState() !== \"paused\" && this.started) {\n          this.sendNotification(Notifications.PLAY, body);\n        }\n        break;\n      case FlashNotifications.ENDED:\n        type = Notifications.ENDED;\n        break;\n      case FlashNotifications.MEDIA_SEQUENCE_ENDED:\n        type = Notifications.MEDIA_SEQUENCE_ENDED;\n        state = Notifications.ENDED;\n        this._ended = true;\n        break;\n      case FlashNotifications.PAUSED:\n        type = \"pause\";\n        state = \"paused\";\n        this._paused = true;\n        break;\n      case FlashNotifications.BUFFERING:\n        if (this.className !== \"ended\") {\n          type = state = \"waiting\";\n        }\n        break;\n      case FlashNotifications.BUFFERING_CHANGE:\n        this.sendNotification(Notifications.BUFFERING_CHANGE, body);\n        return;\n      case FlashNotifications.DURATION_CHANGE:\n        if (!isNaN(body.time)) {\n          if (body.time === 0) {\n            this.sendNotification(Notifications.MEDIA_SEQUENCE_ABORTED);\n          }\n          type = \"durationchange\";\n          body = body.time;\n          setTimeout(function() {\n            _this.setCues(_this.getCues().slice());\n          }, 0);\n        }\n        break;\n      case FlashNotifications.VOLUME_CHANGE:\n        type = \"volumechange\";\n        body = body.volume;\n        break;\n      case FlashNotifications.TIME_UPDATE:\n        type = \"timeupdate\";\n        body = body.currentTime;\n        break;\n      case FlashNotifications.SEEKING_CHANGE:\n        if (this.appState.getSeeking() === false && body.seeking === false) {\n          return;\n        }\n        type = body.seeking ? \"seeking\" : \"seeked\";\n        this.appState.setSeeking(body.seeking);\n        if (body.seeking) {\n          state = \"seeking\";\n        }\n        break;\n      case FlashNotifications.FULLSCREEN_CHANGE:\n        type = \"fullscreenchange\";\n        body = body.displayState === \"fullScreen\";\n        this.applyDisplayState(body ? DisplayState.FULL_SCREEN : DisplayState.NORMAL);\n        break;\n      case FlashNotifications.FAIL_OVER_ATTEMPT:\n        type = \"failoverattempt\";\n        body = body;\n        break;\n      case FlashNotifications.ERROR:\n        eventName = null;\n        break;\n      case FlashNotifications.AUTHORIZE:\n        type = SecurityNotifications.AUTHORIZE;\n        break;\n      case FlashNotifications.TIMED_METADATA:\n        type = Notifications.TIMED_METADATA;\n        body = {\n          startTime: body.time,\n          endTime: body.time,\n          data: body\n        };\n        break;\n      case FlashNotifications.MEDIA_PLAYER_ID3_UPDATED:\n        type = Notifications.TIMED_METADATA;\n        body = {\n          startTime: body.time,\n          endTime: body.time,\n          data: window.atob(body)\n        };\n    }\n    if ((eventName != null) && eventName !== type) {\n      event = new Event(eventName, body);\n      event.dispatcher = \"FLASH\";\n      this.sendNotification(Notifications.DISPATCH_EVENT, event);\n      this.sendNotification(eventName, body);\n    }\n    if (type != null) {\n      if (type === \"error\") {\n        error = body.error || body;\n        this.logError(\"Flash Error\", error);\n      }\n      this.sendNotification(type, body);\n      this.sendNotification(Notifications.DISPATCH_EVENT, new Event(type, body));\n    }\n    if (update != null) {\n      this.sendNotification(Notifications.UPDATE_DATA_BINDINGS);\n    }\n    if (state != null) {\n      this.setPlayState(state);\n    }\n  } catch (error) {\n    this.logError(\"Event Error: \" + eventName, error);\n  }\n};\n\nFlashPlayer.prototype.logError = function(msg, error) {\n  this.logger.error(\"[AMP FLASH ERROR]\", msg, error);\n};\n\n/**\n*/\nFlashPlayer.prototype.excludedFlashEvents = /(mediaPlayerPlayheadUpdate|mediaPlayerElementEvent|adComponentPlaybackProgress)/;\n\nFlashPlayer.prototype.logFlashEvents = false;\n\nFlashPlayer.prototype.logEvent = function(event) {\n  if ((event.dispatcher === \"FLASH\" && this.logFlashEvents === false) || this.excludedFlashEvents.test(event.type) === true) {\n    return;\n  }\n  FlashPlayer.__super__.logEvent.call(this, event);\n};\n\n/**\n * Sets the player's play state and adds CSS class to player div\n*/\nFlashPlayer.prototype.setPlayState = function(state) {\n  this.sendNotification(Notifications.CHANGE_PLAY_STATE, state);\n  return state;\n};\n\nFlashPlayer.prototype.getPlayState = function() {\n  return this.appState.getPlayState();\n};\n\n/**\n * Initializes the player to a given set of parameters\n*/\nFlashPlayer.prototype.setMedia = function(value) {\n  var _this = this;\n  if (this.getPlayState() != null) {\n    this.setPlayState(\"ready\");\n  }\n  value = this.mediaProxy.transform(value);\n  this.transform(TransformType.MEDIA, value).then(function(result) {\n    value = result;\n    _this.mediaProxy.setData(value);\n    if (value.src != null) {\n      _this.setSrc(value.src);\n    }\n    if ((value.source != null) && value.source.length > 0) {\n      _this.setSource(value.source);\n    }\n    _this.sendNotification(Notifications.MEDIA_CHANGE, value);\n    return _this.load(_this.mediaProxy.getData());\n  })[\"catch\"](function(error) {\n    return _this.sendNotification(Notifications.ERROR, error);\n  });\n  return value;\n};\n\n/**\n*/\nFlashPlayer.prototype.getMedia = function() {\n  return this.mediaProxy.getData();\n};\n\n/**\n * Loads the video.\n *\n*/\nFlashPlayer.prototype.load = function() {\n  var data, key, media, value;\n  media = this.mediaProxy.getData();\n  this.security.setMedia(media);\n  if (this.security.getAuthorized()) {\n    this.loaded = true;\n    data = Utils.clone(media);\n    if (data.autoplay == null) {\n      data.autoplay = this.config.autoplay;\n    }\n    for (key in data) {\n      value = data[key];\n      if (value === void 0) {\n        delete data[key];\n      }\n    }\n    this.getMediaElement().loadURL(this.mediaProxy.getSrc(), data);\n  } else {\n    this.sendNotification(SecurityNotifications.AUTHORIZE, {\n      media: media\n    });\n  }\n};\n\n/**\n * Plays the currently loaded video.\n *\n*/\nFlashPlayer.prototype.play = function() {\n  if (!this.loaded) {\n    this.load();\n  }\n  this.getMediaElement().unpause();\n};\n\n/**\n*/\nFlashPlayer.prototype.setMuted = function(value) {\n  this._muted = value;\n  try {\n    if (value === true) {\n      this.getMediaElement().mute();\n    } else {\n      this.getMediaElement().unmute();\n    }\n  } catch (error) {\n    this.logError(\"Flash muted error\", error);\n  }\n  return value;\n};\n\n/**\n*/\nFlashPlayer.prototype.getMuted = function() {\n  return this._muted;\n};\n\n/**\n*/\nFlashPlayer.prototype.getLoop = function() {\n  return this._loop;\n};\n\n/**\n * The source url of video.\n *\n * @param {String} value The source url of the video to play.\n*/\nFlashPlayer.prototype.getSrc = function(value) {\n  return this.getMediaElement().getURL();\n};\n\nFlashPlayer.prototype.setSrc = function(value) {\n  this.mediaProxy.setSrc(value);\n  this.loaded = false;\n  this.setMedium(Utils.getMimeType(value));\n  return value;\n};\n\n/**\n*/\nFlashPlayer.prototype.setAutoplay = function(value) {\n  this.getMediaElement().setPlayerProperty(\"autoplay\", value);\n  return value;\n};\n\nFlashPlayer.prototype.getAutoplay = function() {\n  return this.getMediaElement().getPlayerProperty(\"autoplay\");\n};\n\n/**\n * The url to the video.\n *\n * @param {String} value\n *    The new title of the video\n * @returns {Boolean}\n *    The title of the video\n * @type {String}\n*/\nFlashPlayer.prototype.getMedium = function() {\n  return this.mediaProxy.getData().medium;\n};\n\nFlashPlayer.prototype.setMedium = function(value) {\n  var media, previous;\n  media = this.mediaProxy.getData();\n  if (value === media.medium) {\n    return;\n  }\n  if (media.medium != null) {\n    previous = \"medium-\" + media.medium;\n  }\n  media.medium = /audio/.test(value) ? \"audio\" : \"video\";\n  this.sendNotification(Notifications.MEDIUM_CHANGE, {\n    value: \"medium-\" + media.medium,\n    previous: previous\n  });\n  return value;\n};\n\n/**\n * Sets the source url of video.\n *\n * @param {String} value The source url of the video to play.\n*/\nFlashPlayer.prototype.setSource = function(value) {\n  var item, media,\n    _this = this;\n  if (!(value != null) || value.length < 1) {\n    return;\n  }\n  media = this.mediaProxy.getData();\n  media.source = value;\n  this.loaded = false;\n  item = Utils.selectSource(value, function(type) {\n    return _this.canPlayType(type);\n  });\n  if (((item != null ? item.src : void 0) != null) && item.src !== \"\") {\n    this.setSrc(item.src);\n    if (typeof type !== \"undefined\" && type !== null) {\n      this.setMedium(type);\n    }\n  } else {\n    throw new Error(\"No valid source could be found\");\n  }\n  return value;\n};\n\n/**\n * Gets the source url of video.\n *\n * @return {Number} The source url of the video.\n*/\nFlashPlayer.prototype.getSource = function() {\n  return this.mediaProxy.getData().source;\n};\n\n/**\n * Gets the source url of video.\n *\n * @return {Number} The source url of the video.\n*/\nFlashPlayer.prototype.getSeeking = function() {\n  return this.appState.getSeeking();\n};\n\n/**\n * Gets the source url of video.\n *\n * @return {Number} The source url of the video.\n*/\nFlashPlayer.prototype.getPaused = function() {\n  return this._paused;\n};\n\n/**\n * Gets the source url of video.\n *\n * @return {Number} The source url of the video.\n*/\nFlashPlayer.prototype.getEnded = function() {\n  return this._ended;\n};\n\n/**\n*/\nFlashPlayer.prototype.getFlashXML = function() {\n  var doc, xml;\n  xml = decodeURIComponent(this.flashvars.settings_xml);\n  doc = XMLUtils.parse(xml);\n  try {\n    doc.toString = function() {\n      return xml;\n    };\n  } catch (error) {\n\n  }\n  return doc;\n};\n\n/**\n*/\nFlashPlayer.prototype.getFlashVars = function() {\n  return this.flashvars;\n};\n\n/**\n*/\nFlashPlayer.prototype.getFlashJSON = function() {\n  return JSON.parse(decodeURIComponent(this.flashvars.settings_json));\n};\n\nFlashPlayer.prototype.canPlayType = function(mimeType) {\n  if (__indexOf.call(Utils.flashTypes, mimeType) >= 0) {\n    return \"maybe\";\n  } else {\n    return \"\";\n  }\n};\n\nFlashPlayer.prototype.replay = function() {\n  this.getMediaElement().replay();\n};\n\nFlashPlayer.prototype.pause = function() {\n  this.getMediaElement().pause();\n};\n\nFlashPlayer.prototype.end = function() {\n  this.getMediaElement().stopPlayer();\n};\n\nFlashPlayer.prototype.getCurrentTime = function() {\n  var _base;\n  return typeof (_base = this.getMediaElement()).getCurrentTime === \"function\" ? _base.getCurrentTime() : void 0;\n};\n\nFlashPlayer.prototype.setCurrentTime = function(value) {\n  this.getMediaElement().jumpToTime(value);\n  return value;\n};\n\nFlashPlayer.prototype.getParams = function() {\n  return this.getMediaElement().getParams();\n};\n\nFlashPlayer.prototype.setParams = function(value) {\n  this.getMediaElement().setParams(value);\n  return value;\n};\n\nFlashPlayer.prototype.getVolume = function() {\n  var _ref;\n  return ((_ref = this.getMediaElement()) != null ? typeof _ref.getVolume === \"function\" ? _ref.getVolume() : void 0 : void 0) || 0;\n};\n\nFlashPlayer.prototype.setVolume = function(value, scope) {\n  this.getMediaElement().setVolume(value, scope || \"\");\n  return value;\n};\n\nFlashPlayer.prototype.getDuration = function() {\n  var _base;\n  return typeof (_base = this.getMediaElement()).getDuration === \"function\" ? _base.getDuration() : void 0;\n};\n\nFlashPlayer.prototype.getDisplayState = function() {\n  return this._displayState;\n};\n\nFlashPlayer.prototype.setDisplayState = function(value) {\n  var _ref;\n  if (value === this._displayState) {\n    return;\n  }\n  this.applyDisplayState(value);\n  if (((_ref = this.config.fullscreen) != null ? _ref.mode : void 0) === FullscreenMode.EXTERNAL) {\n    return;\n  }\n  if (this._displayState === DisplayState.FULL_SCREEN) {\n    this.getMediaElement().enterFullScreen();\n  } else {\n    this.getMediaElement().exitFullScreen();\n  }\n  return value;\n};\n\nFlashPlayer.prototype.applyDisplayState = function(value) {\n  var states;\n  if (value === this._displayState) {\n    return;\n  }\n  states = {\n    value: value,\n    previous: this._displayState\n  };\n  this._displayState = value;\n  this.sendNotification(Notifications.DISPLAY_STATE_CHANGE, states);\n  this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"fullscreenchange\", this._displayState === DisplayState.FULL_SCREEN));\n};\n\nFlashPlayer.prototype.enterFullScreen = function() {\n  this.setDisplayState(DisplayState.FULL_SCREEN);\n};\n\nFlashPlayer.prototype.exitFullScreen = function() {\n  this.setDisplayState(DisplayState.NORMAL);\n};\n\nFlashPlayer.prototype.recordContentChange = function(content) {\n  this.getMediaElement().recordContentChange(content);\n};\n\nFlashPlayer.prototype.setQuality = function(value) {\n  return this.getMediaElement().setQuality(value);\n};\n\nFlashPlayer.prototype.getQuality = function() {\n  var quality;\n  try {\n    quality = this.getMediaElement().getQuality();\n  } catch (error) {\n\n  }\n  return quality;\n};\n\nFlashPlayer.prototype.getQualityLevels = function() {\n  var levels, _base;\n  try {\n    levels = (typeof (_base = this.getMediaElement()).getQualityLevels === \"function\" ? _base.getQualityLevels() : void 0) || [];\n  } catch (error) {\n    levels = [];\n  }\n  return levels;\n};\n\n/**\n * The ModuleAdapter class.\n * \n * @param {Module} module\n * @constructor\n * @private\n * @extends {puremvc.Mediator}\n*/\nfunction ModuleAdapter(module) {\n  this.module = module;\n  ModuleAdapter.__super__.constructor.call(this, module.getModuleName(), this);\n}\n\n\n__extends(ModuleAdapter, puremvc.Mediator);\n\n\nModuleAdapter.prototype.module = null;\n\nModuleAdapter.prototype.mediator = null;\n\nModuleAdapter.prototype.initializeNotifier = function(key) {\n  var publications,\n    _this = this;\n  ModuleAdapter.__super__.initializeNotifier.call(this, key);\n  publications = this.module.listNotificationPublications();\n  if (publications != null) {\n    this.mediator = new puremvc.Mediator(this.facade.getModuleName());\n    this.mediator.listNotificationInterests = function() {\n      return publications;\n    };\n    this.mediator.handleNotification = function(notification) {\n      _this.facade.sendNotification(notification.getName(), notification.getBody(), notification.getType());\n    };\n  }\n};\n\nModuleAdapter.prototype.onRegister = function() {\n  if (this.mediator != null) {\n    this.module.registerMediator(this.mediator);\n  }\n};\n\nModuleAdapter.prototype.onRemove = function() {\n  if (this.mediator != null) {\n    this.module.removeMediator(this.mediator);\n  }\n};\n\n/**\n * Overridden so this class may subscribe to all notifications\n * @return An Array\n *\n*/\nModuleAdapter.prototype.listNotificationInterests = function() {\n  return this.module.listNotificationInterests();\n};\n\n/**\n * Handles notifications of interest to this mediator. Note that\n * the default declaration is to allow the super to handle the\n * note. This leaves the base JunctionMediator to handle things\n * like ACCEPT_INPUT_PIPE and ACCEPT_OUTPUT_PIPE  \n * @param note An INotification\n *\n*/\nModuleAdapter.prototype.handleNotification = function(notification) {\n  this.module.sendNotification(notification.getName(), notification.getBody(), notification.getType());\n};\n\nEvents = {\n  LOADED_METADATA: \"loadedmetadata\",\n  READY: \"ready\",\n  ERROR: \"error\",\n  ENDED: \"ended\",\n  STARTED: \"started\",\n  DURATION_CHANGE: \"durationchange\",\n  SEEKING: \"seeking\",\n  SEEKED: \"seeked\",\n  TIME_UPDATE: \"timeupdate\",\n  LOAD_START: \"loadstart\",\n  LOADED_DATA: \"loadeddata\",\n  CAN_PLAY: \"canplay\",\n  CAN_PLAY_THROUGH: \"canplaythrough\",\n  PROGRESS: \"progress\",\n  MEDIA_CHANGE: \"mediachange\",\n  WAITING: \"waiting\",\n  BUFFERING_CHANGE: \"bufferingchange\",\n  STALLED: \"stalled\",\n  PLAY: \"play\",\n  PLAYING: \"playing\",\n  PAUSE: \"pause\",\n  PAUSED: \"paused\",\n  PLAY_REQUEST: \"playrequest\",\n  MEDIUM_CHANGE: \"mediumchange\",\n  TEMPORAL_TYPE_CHANGE: \"temporaltypechange\",\n  VOLUME_CHANGE: \"volumechange\",\n  FAIL_OVER_ATTEMPT: \"failoverattempt\",\n  PLAYBACK_TARGET_CHANGE: \"playbacktargetchange\",\n  PLAYBACK_TARGET_AVAILABILITY_CHANGE: \"playbacktargetavailabilitychange\",\n  RECORD_CONTENT_CHANGE: \"recordcontentchange\",\n  IS_LIVE: \"islive\",\n  CONTENT_CHANGED: \"contentchanged\",\n  PLAYBACK_RATE_CHANGE: \"playbackratechange\",\n  SETTINGS_CHANGE: \"settingschange\",\n  QUALITY_CHANGE: \"qualitychange\",\n  QUALITY_CHANGING: \"qualitychanging\",\n  QUALITY_SWITCHED: \"qualityswitched\",\n  QUALITY_MODE_CHANGE: \"qualitymodechange\",\n  QUALITY_LEVELS_LOADED: \"qualitylevelsloaded\",\n  MEDIA_SEQUENCE_STARTED: \"mediasequencestarted\",\n  MEDIA_SEQUENCE_ENDED: \"mediasequenceended\",\n  MEDIA_SEQUENCE_ABORTED: \"mediasequenceaborted\",\n  AUTOPLAY_BLOCKED: \"autoplayblocked\",\n  LANGUAGE_CHANGE: \"languagechange\",\n  TIMED_METADATA: \"timedmetadata\",\n  CUES_CHANGE: \"cueschange\",\n  VIEW_CREATED: \"viewcreated\",\n  MUTE_CHANGE: \"mutechange\",\n  RESUME: \"resume\",\n  PLAY_STATE_CHANGE: \"playstatechange\",\n  FULL_SCREEN_CHANGE: \"fullscreenchange\",\n  BUSY: \"busy\",\n  DESTROY: \"destroy\",\n  init: function() {\n    var key, value;\n    this.values = [];\n    for (key in this) {\n      value = this[key];\n      if (key !== \"values\" && key !== \"init\") {\n        this.values.push(value);\n      }\n    }\n  }\n};\nEvents.init();\n\n/**\n * Creates a new Transformer\n *\n * @constructor\n * @private\n*/\nfunction Transformer(_target) {\n  this._target = _target != null ? _target : this;\n  this._transformMap = {};\n}\n\n/**\n * Adds a transform for a given type.\n *\n * @param {!string}  type  A string representing the event's type.\n * @param {!Function} transform  A function to call when the event is triggered.\n*/\nTransformer.prototype.addTransform = function(type, transform) {\n  var _base;\n  if (!(transform != null) || !(type != null)) {\n    return;\n  }\n  if ((_base = this._transformMap)[type] == null) {\n    _base[type] = [];\n  }\n  if (this._transformMap[type].indexOf(transform) !== -1) {\n    return;\n  }\n  this._transformMap[type].push(transform);\n  this.sortTransforms(type);\n};\n\n/**\n * Sorts the transform list by priority. Higher priority Transforms\n * are executed first.\n *\n * @param {!String} type The transform type\n * @param {Function=} func An optional sort function\n * @returns {Array.<Function|akamai.amp.Transform>} The sorted list\n*/\nTransformer.prototype.sortTransforms = function(type, func) {\n  var _this = this;\n  if (func == null) {\n    func = function(a, b) {\n      var aP, bP;\n      aP = a.priority || 0;\n      bP = b.priority || 0;\n      return bP - aP;\n    };\n  }\n  return this._transformMap[type].sort(func);\n};\n\n/**\n * Performs a transform for a given type\n *\n * @param {!String} type The transform type\n * @param {!Object} value The value to be transformed\n*/\nTransformer.prototype.transform = function(type, value) {\n  var transforms;\n  transforms = this._transformMap[type];\n  if (!(transforms != null)) {\n    return Promise.resolve(value);\n  }\n  return Utils.transform(value, transforms);\n};\n\n/**\n * Removes a transform for a given type.\n *\n * @param {!string}  type  A string representing the transform's type.\n * @param {!Function} transform  A function or Transform object to call when the type is triggered.\n * @return {?Function} the transform that was removed if any\n*/\nTransformer.prototype.removeTransform = function(type, transform) {\n  var index, transforms;\n  if (!(transform != null) || !(type != null)) {\n    return;\n  }\n  transforms = this._transformMap[type];\n  if (!(transforms != null)) {\n    return;\n  }\n  index = transforms.indexOf(transform);\n  if (index === -1) {\n    return;\n  }\n  return transforms.splice(index, 1);\n};\n\n/**\n * @constructor\n*/\nfunction DataBinding() {}\n\n/**\n * @private\n * @type {RegExp}\n * @const\n*/\nDataBinding.SINGLE = /^\\s*[#\\$]{([^\\$#{}]+)}\\s*$/;\n\n/**\n * @private\n * @type {RegExp}\n * @const\n*/\nDataBinding.TOKEN = /[#\\$]{([^\\$#}]*)}/g;\n\n/**\n * Evaluate a data bound string.\n *\n * @param {string} binding\n *   The data bound string.\n *\n * @param {?Object} context\n *   The context object used as \"global\" when evaluating the binding.\n *\n * @return {string}\n *   The evaluated result\n*/\nDataBinding[\"eval\"] = function(binding, context) {\n  var _this = this;\n  if (!(binding != null)) {\n    return binding;\n  }\n  if (this.SINGLE.test(binding)) {\n    try {\n      return this.exec(binding.replace(this.SINGLE, \"$1\"), context);\n    } catch (error) {\n      return binding;\n    }\n  }\n  return binding.replace(this.TOKEN, function(match, token, offset, string) {\n    try {\n      return _this.exec(token, context);\n    } catch (error) {\n      return match;\n    }\n  });\n};\n\n/**\n * Execute a data bound string.\n *\n * @param {string} binding\n *   The data bound string.\n *\n * @param {?Object} context\n *   The context object used as \"global\" when evaluating the binding.\n *\n * @return {string}\n *   The evaluated result\n*/\nDataBinding.exec = function(binding, context) {\n  return (new Function(\"with (this) { return \" + binding + \" }\")).bind(context)();\n};\n\n/**\n * Evaluate a data bound object.\n *\n * @param {Object} binding\n *   The data bound object.\n *\n * @param {Object} context\n *   The context object used as \"global\" when evaluating the binding.\n *\n * @return {Object}\n *   The evaluated result\n*/\nDataBinding.evaluateBindings = function(value, context, clone) {\n  var key,\n    _this = this;\n  if (clone == null) {\n    clone = true;\n  }\n  if (!(value != null)) {\n    return;\n  }\n  if (typeof value === \"object\") {\n    clone = clone === true ? JSON.parse(JSON.stringify(value)) : value;\n    if (value instanceof Array) {\n      return clone.map(function(item) {\n        return _this.evaluateBindings(item, context, false);\n      });\n    } else {\n      value = {};\n      for (key in clone) {\n        value[key] = this.evaluateBindings(clone[key], context, false);\n      }\n      return value;\n    }\n  } else if (typeof value === \"string\") {\n    return this[\"eval\"](value, context);\n  } else {\n    return value;\n  }\n};\n\n/**\n * The EndCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction DispatchEventCommand() {\n  DispatchEventCommand.__super__.constructor.call(this);\n}\n\n\n__extends(DispatchEventCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nDispatchEventCommand.prototype.execute = function(notification) {\n  var event;\n  event = notification.getBody();\n  event.player = this.facade.player || this.facade;\n  this.facade.dispatchEvent(event);\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar Notifications = {\n  STARTUP: \"startup\",\n  LOAD: \"load\",\n  PAUSE_REQUEST: \"pauserequest\",\n  TOGGLE_PLAY_PAUSE: \"togglePlayPause\",\n  CHANGE_PLAY_STATE: \"chageplaystate\",\n  MEDIA_ELEMENT_CHANGE: \"mediaelementchange\",\n  HIDDEN_CHANGE: \"hiddenchange\",\n  TOGGLE_FULL_SCREEN: \"toggleFullScreen\",\n  CHANGE_DISPLAY_STATE: \"chageDisplayState\",\n  DISPLAY_STATE_CHANGE: \"displayStateChange\",\n  DISABLE_FULL_SCREEN: \"disableFullScreen\",\n  ENABLE_FULL_SCREEN: \"enableFullScreen\",\n  TOGGLE_ACTIVE: \"toggleActive\",\n  CHANGE_ACTIVE_STATE: \"changeactivestate\",\n  ACTIVE_STATE_CHANGE: \"activestatechange\",\n  CHANGE_MEDIA: \"changeMedia\",\n  SET_MEDIA: \"setmedia\",\n  MEDIA_VALIDATED: \"mediavalidated\",\n  CHANGE_SETTINGS: \"changesettings\",\n  UPDATE_DATA_BINDINGS: \"updatedatabindings\",\n  CHANGE_VOLUME: \"changevolume\",\n  CHANGE_MUTED: \"changemuted\",\n  TOGGLE_MUTED: \"togglemuted\",\n  CHANGE_TIME: \"changetime\",\n  TIME_CHANGE: \"timechange\",\n  SEEK: \"seek\",\n  CHANGE_DURATION: \"changeduration\",\n  CHANGE_AUTOPLAY: \"changeAutoplay\",\n  AUTOPLAY_CHANGE: \"autoplaychange\",\n  CHANGE_LOOP: \"changeLoop\",\n  PLAYBACK_CORE_CHANGE: \"playbackCoreChange\",\n  START: \"start\",\n  END: \"end\",\n  REPLAY: \"replay\",\n  REGISTER_PLUGIN: \"registerPlugin\",\n  REGISTER_PLUGINS: \"registerPlugins\",\n  PLUGIN_REGISTERED: \"pluginRegistered\",\n  ADD_LAYER: \"addLayer\",\n  REMOVE_LAYER: \"removeLayer\",\n  ADD_OVERLAY: \"addOverlay\",\n  REMOVE_OVERLAY: \"removeOverlay\",\n  ADD_CONTROL: \"addControl\",\n  REMOVE_CONTROL: \"removeControl\",\n  ADD_CONTROL_STATE: \"addControlState\",\n  REMOVE_CONTROL_STATE: \"removeControlState\",\n  ADD_APPLICATION_STATE: \"addApplicationState\",\n  REMOVE_APPLICATION_STATE: \"removeApplicationState\",\n  DISPATCH_EVENT: \"dispatchEvent\",\n  CHANGE_PARAMS: \"changeParams\",\n  INITIALIZED: \"initialized\",\n  REGISTER_PLAYBACK_CORE: \"registerPlaybackCore\",\n  REMOVE_PLAYBACK_CORE: \"removePlaybackCore\",\n  DISPLAY_TIME: \"displaytime\",\n  IS_USER_ACTIVE: \"isUserActive\",\n  CHANGE_PLAYBACK_TARGET: \"changeplaybacktarget\",\n  LOCK: \"lock\",\n  FRAGMENT_LOAD_START: \"fragmentloadstart\",\n  FRAGMENT_LOADED: \"fragmentloaded\",\n  CHANGE_CONTENT: \"changecontent\",\n  ENABLE_VIDEO_EVENTS: \"enablevideoevents\",\n  DISABLE_VIDEO_EVENTS: \"disablevideoevents\",\n  HAS_POST_CONTENT: \"haspostcontent\",\n  AUDIO_TRACK_SWITCH: \"audiotrackswitch\",\n  init: function() {\n    var key, value;\n    for (key in Events) {\n      value = Events[key];\n      if (key !== \"values\" && key !== \"init\") {\n        this[key] = value;\n      }\n    }\n  }\n};\nNotifications.init();\n\nfunction Utilization() {}\n\nUtilization.track = function(event, data) {\n  var params, url, _ref,\n    _this = this;\n  url = \"//amp.akamaized.net/amp.gif\";\n  params = {\n    os: bowser.osname,\n    osver: bowser.osversion,\n    browser: bowser.name,\n    browserver: bowser.version,\n    prod: AMP.VERSION.replace(/^AMP/, \"\").replace(/\\sv?[0-9\\.]+$/, \"\"),\n    prodver: (_ref = AMP.VERSION.match(/[0-9\\.]+/)) != null ? _ref[0] : void 0,\n    platform: \"web\",\n    url: location.href,\n    event: event,\n    data: data\n  };\n  return Utils.request(\"\" + url + \"?\" + (QueryString.encode(params)))[\"catch\"](function(error) {\n    return Logger.instance.log(error);\n  });\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar DisplayState = {\n  /**\n   * Constant representing the normal display state\n  */\n\n  NORMAL: \"normal\",\n  /**\n   * Constant representing the full screen display state\n  */\n\n  FULL_SCREEN: \"full-screen\"\n};\n\n/**\n * The DataBoundConfigurationProxy class.\n *\n * @constructor\n * @private\n * @extends {ModuleProxy}\n * @param {Object} data\n*/\nfunction DataBoundConfigurationProxy(data) {\n  DataBoundConfigurationProxy.__super__.constructor.call(this, data);\n  this.value = {};\n}\n\n\n__extends(DataBoundConfigurationProxy, ModuleProxy);\n\n\n/** @static\n*/\nDataBoundConfigurationProxy.NAME = ModuleProxy.NAME;\n\nDataBoundConfigurationProxy.prototype.bindings = null;\n\nDataBoundConfigurationProxy.prototype.configurationName = null;\n\nDataBoundConfigurationProxy.prototype.contextName = null;\n\nDataBoundConfigurationProxy.prototype.contextData = null;\n\nDataBoundConfigurationProxy.prototype.value = null;\n\nDataBoundConfigurationProxy.prototype.getConfigurationName = function() {\n  return this.configurationName;\n};\n\nDataBoundConfigurationProxy.prototype.getConfigurationData = function() {\n  return this.value || {};\n};\n\nDataBoundConfigurationProxy.prototype.getContextName = function() {\n  return this.contextName;\n};\n\nDataBoundConfigurationProxy.prototype.getContextData = function() {\n  return this.contextData;\n};\n\nDataBoundConfigurationProxy.prototype.onRegister = function() {\n  var base;\n  base = this.facade.player || this.facade;\n  if (!(this.getConfigurationName() != null)) {\n    this.configurationName = this.facade.moduleName;\n  }\n  this.bindings = base.retrieveProxy(DataBindingProxy.NAME);\n  this.bindings.registerConfiguration(this);\n  if (!(this.getContextName() != null)) {\n    return;\n  }\n  this.bindings.registerContext(this);\n  this.value = DataBinding.evaluateBindings(this.data, this.bindings.getData());\n};\n\nDataBoundConfigurationProxy.prototype.setData = function(data) {\n  var key, value, _ref;\n  if (data == null) {\n    data = {};\n  }\n  this.data = {};\n  _ref = this.getDefaults();\n  for (key in _ref) {\n    value = _ref[key];\n    this.data[key] = key in data ? data[key] : value;\n  }\n  return this.data;\n};\n\nDataBoundConfigurationProxy.prototype.getValue = function(key) {\n  this.bindings.update();\n  this.value[key] = DataBinding.evaluateBindings(this.data[key], this.bindings.getData());\n  return this.value[key];\n};\n\nDataBoundConfigurationProxy.prototype.compile = function(context, suppressErrors) {\n  if (suppressErrors == null) {\n    suppressErrors = false;\n  }\n  if (!(context != null)) {\n    context = this.bindings.getData();\n  }\n  if ((this.contextName != null) && (this.contextData != null)) {\n    context = Utils.clone(context);\n    context[this.contextName] = this.contextData;\n  }\n  this.value = DataBinding.evaluateBindings(this.data, this.bindings.getData());\n  return this.value;\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar SecurityNotifications = {\n  AUTHORIZATION_FAILED: \"authorizationfailed\",\n  AUTHORIZE: \"authorize\",\n  AUTHORIZED: \"authorized\",\n  AUTHENTICATION_FAILED: \"authenticationfailed\",\n  AUTHENTICATE: \"authenticate\",\n  AUTHENTICATED: \"authenticated\",\n  AUTHORIZATION_EXPIRED: \"authorizationexpired\"\n};\n\n/** \n * Binds an event(s) to a handler function.\n * \n * @param {IEventDispatcher}    target  The event target\n * @param {string|Array|number} type    The event to listen for\n * @param {Function}            handler The handler function to call when the event is dispatched. \n * @constructor\n * @private\n*/\nfunction EventHandler(target, type, handler) {\n  var _ref;\n  this.target = target;\n  this.type = type;\n  this.handler = handler;\n  this.trigger = __bind(this.trigger, this);\n\n  EventHandler.instances.push(this);\n  this.types = [];\n  if (_ref = this.type, __indexOf.call(EventHandler.EVENTS, _ref) >= 0) {\n    if (Utils.isTouchDevice()) {\n      this.types.push(EventHandler.TOUCH_EVENTS[this.type]);\n      if (this.type === EventHandler.TOUCH_EVENTS[1]) {\n        this.types.push(EventHandler.TOUCH_EVENTS[4]);\n      }\n    } else {\n      this.types.push(EventHandler.MOUSE_EVENTS[this.type]);\n    }\n  } else if (this.type instanceof Array) {\n    this.types = this.type;\n  } else {\n    this.types.push(this.type);\n  }\n  this.bind();\n}\n\n/**\n * Represents the press user interaction\n * \n * @type {number}\n * @static\n * @const\n*/\nEventHandler.PRESS = 0;\n\n/**\n * Represents the release user interaction\n * \n * @type {number}\n * @static\n * @const\n*/\nEventHandler.RELEASE = 1;\n\n/**\n * Represents the move user interaction\n * \n * @type {number}\n * @static\n * @const\n*/\nEventHandler.MOVE = 2;\n\n/**\n * Represents the click user interaction\n * \n * @type {number}\n * @static\n * @const\n*/\nEventHandler.CLICK = 3;\n\n/**\n * Represents the right click (contextMenu) user interaction\n * \n * @type {number}\n * @static\n * @const\n*/\nEventHandler.CONTEXTMENU = 4;\n\n/**\n * Represents the mouse over user interaction\n * \n * @type {number}\n * @static\n * @const\n*/\nEventHandler.HOVER = 5;\n\n/**\n * Represents the mouse out user interaction\n * \n * @type {number}\n * @static\n * @const\n*/\nEventHandler.HOVEROUT = 6;\n\n/**\n * The list of user interactions\n * \n * @type {Array.<number>}\n * @static\n * @const\n*/\nEventHandler.EVENTS = [EventHandler.PRESS, EventHandler.RELEASE, EventHandler.MOVE, EventHandler.CLICK, EventHandler.CONTEXTMENU, EventHandler.HOVER, EventHandler.HOVEROUT];\n\n/**\n * The list of mouse interactions\n * \n * @type {Array.<string>}\n * @static\n * @const\n*/\nEventHandler.MOUSE_EVENTS = [\"mousedown\", \"mouseup\", \"mousemove\", \"click\", \"contextmenu\", \"mouseover\", \"mouseout\"];\n\n/**\n * The list of touch interactions\n * \n * @type {Array.<string>}\n * @static\n * @const\n*/\nEventHandler.TOUCH_EVENTS = [\"touchstart\", \"touchend\", \"touchmove\", \"click\", \"touchcancel\"];\n\n/**\n * An array of EventHandler instances.\n * \n * @type {Array.<EventHandler>}\n * @static\n*/\nEventHandler.instances = [];\n\n/**\n * Creates an EventHandler with the parameters provided.\n * \n * @param {IEventDispatcher}    target  The event target\n * @param {string|Array|number} type    The event to listen for\n * @param {Function}            handler The handler function to call when the event is dispatched. \n * @static\n * @return {EventHandler} the new EventHandler\n*/\nEventHandler.create = function(target, type, handler) {\n  return new EventHandler(target, type, handler);\n};\n\n/**\n * Binds all EventHandlers of the provided target.\n * \n * @param {IEventDispatcher} target\n * @static\n*/\nEventHandler.bind = function(target, type) {\n  var i, instance, _i, _len, _ref;\n  _ref = EventHandler.instances;\n  for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {\n    instance = _ref[i];\n    if (!(instance.target === target)) {\n      continue;\n    }\n    if ((type != null) && instance.type !== type) {\n      continue;\n    }\n    instance.bind();\n  }\n};\n\n/**\n * Unbinds all EventHandlers of the provided target.\n * \n * @param {IEventDispatcher} target\n * @static\n*/\nEventHandler.unbind = function(target, type) {\n  var i, instance, _i, _len, _ref;\n  _ref = EventHandler.instances;\n  for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {\n    instance = _ref[i];\n    if (!(instance.target === target)) {\n      continue;\n    }\n    if ((type != null) && instance.type !== type) {\n      continue;\n    }\n    instance.unbind();\n  }\n};\n\n/**\n * Clear all EventHandlers of the provided target.\n * \n * @param {IEventDispatcher} target\n * @static\n*/\nEventHandler.clear = function(target, type) {\n  var i, instance, _i, _len, _ref;\n  _ref = EventHandler.instances;\n  for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {\n    instance = _ref[i];\n    if (!((instance != null ? instance.target : void 0) === target)) {\n      continue;\n    }\n    if ((type != null) && instance.type !== type) {\n      continue;\n    }\n    instance.clear();\n    EventHandler.instances.splice(i, 1);\n  }\n};\n\n/**\n * The system event types for this EventTarget\n * \n * @type {Array.<string>}\n*/\nEventHandler.prototype.types = null;\n\n/**\n * Binds the target to the event\n*/\nEventHandler.prototype.bind = function() {\n  var type, _i, _len, _ref;\n  _ref = this.types;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    type = _ref[_i];\n    if (this.target.addEventListener != null) {\n      this.target.addEventListener(type, this.trigger, false);\n    } else if (this.target.attachEvent != null) {\n      this.target.attachEvent(\"on\" + type, this.trigger);\n    }\n  }\n};\n\n/**\n * Unbinds the target from the event\n*/\nEventHandler.prototype.unbind = function() {\n  var type, _i, _len, _ref;\n  _ref = this.types;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    type = _ref[_i];\n    if (this.target.removeEventListener != null) {\n      this.target.removeEventListener(type, this.trigger);\n    } else if (this.target.attachEvent != null) {\n      this.target.removeEvent(\"on\" + type, this.trigger);\n    }\n  }\n};\n\n/**\n * Clears the EventHandler\n*/\nEventHandler.prototype.clear = function() {\n  this.unbind();\n  this.target = null;\n  this.handler = null;\n  this.type = null;\n  this.types = null;\n};\n\n/**\n * Triggers the event handler\n*/\nEventHandler.prototype.trigger = function(event) {\n  this.handler(event);\n};\n\n/**\n * Used to track player configuration settings\n*/\n/**\n * Creates a new instance of MediaProxy.\n *\n * @constructor\n * @private\n*/\nfunction ConfigurationProxy(config) {\n  this.defaults = Config.defaults;\n  ConfigurationProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(ConfigurationProxy, ModuleProxy);\n\n\n/** @static\n*/\nConfigurationProxy.NAME = ModuleProxy.NAME;\n\n/**\n * @override\n*/\nConfigurationProxy.prototype.getContextName = function() {\n  return \"paths\";\n};\n\n/**\n * @override\n*/\nConfigurationProxy.prototype.getContextData = function() {\n  return this.getPaths();\n};\n\n/**\n*/\nConfigurationProxy.prototype.onRegister = function() {\n  this.facade.retrieveProxy(DataBindingProxy.NAME).registerContext(this);\n};\n\n/**\n * @override\n*/\nConfigurationProxy.prototype.setData = function(value) {\n  if (value.rules != null) {\n    Utils.mergeRules(value.rules);\n  }\n  ConfigurationProxy.__super__.setData.call(this, value);\n  return value;\n};\n\n/**\n * Plays iniline\n*/\nConfigurationProxy.prototype.getPlaysInline = function() {\n  return this.data.playsinline;\n};\n\n/**\n * Plays iniline\n*/\nConfigurationProxy.prototype.getMuted = function() {\n  return this.data.muted;\n};\n\nConfigurationProxy.prototype.setMuted = function(value) {\n  this.data.muted = value;\n  return value;\n};\n\n/**\n * Auto play.\n*/\nConfigurationProxy.prototype.getAutoplay = function() {\n  return this.data.autoplay;\n};\n\nConfigurationProxy.prototype.setAutoplay = function(value) {\n  this.data.autoplay = value;\n  return value;\n};\n\n/**\n * Auto play.\n*/\nConfigurationProxy.prototype.getLoop = function() {\n  return this.data.loop;\n};\n\nConfigurationProxy.prototype.setLoop = function(value) {\n  this.data.loop = value;\n  return value;\n};\n\n/**\n * End Slate.\n*/\nConfigurationProxy.prototype.getSettings = function() {\n  return this.data.settings;\n};\n\nConfigurationProxy.prototype.setSettings = function(value) {\n  this.data.settings = value;\n  return value;\n};\n\n/**\n * Domain\n*/\nConfigurationProxy.prototype.getDomain = function() {\n  return this.data.domain;\n};\n\nConfigurationProxy.prototype.setDomain = function(value) {\n  this.data.domain = value;\n  return value;\n};\n\n/**\n * Target.\n*/\nConfigurationProxy.prototype.getTarget = function() {\n  return this.data.target;\n};\n\nConfigurationProxy.prototype.setTarget = function(value) {\n  this.data.target = value;\n  return value;\n};\n\n/**\n * The player name.\n*/\nConfigurationProxy.prototype.getName = function() {\n  return this.data.name;\n};\n\nConfigurationProxy.prototype.setName = function(value) {\n  this.data.name = value;\n  return value;\n};\n\n/**\n * The player paths.\n*/\nConfigurationProxy.prototype.getPaths = function() {\n  return this.data.paths;\n};\n\nConfigurationProxy.prototype.setPaths = function(value) {\n  this.data.paths = value;\n  return value;\n};\n\n/**\n * The player version.\n*/\nConfigurationProxy.prototype.getVersion = function() {\n  return this.data.version;\n};\n\n/**\n * Controls\n*/\nConfigurationProxy.prototype.getControls = function() {\n  return this.data.controls;\n};\n\nConfigurationProxy.prototype.setControls = function(value) {\n  this.data.controls = value;\n  return value;\n};\n\n/**\n * Fullscreen configuration\n*/\nConfigurationProxy.prototype.getFullscreen = function() {\n  return this.data.fullscreen || {};\n};\n\nConfigurationProxy.prototype.setFullscreen = function(value) {\n  this.data.fullscreen = value;\n  return value;\n};\n\n/**\n * @constructor\n * @private\n * @extends {ModuleMediator}\n*/\nfunction SettingsMediator() {\n  SettingsMediator.__super__.constructor.call(this, this.NAME);\n  this.namespace = SettingsMediator.NAMESPACE;\n  this.defaults = {\n    volume: 1,\n    captions: {\n      visible: false,\n      fontFamily: \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\",\n      size: \"small\",\n      scroll: \"popout\",\n      fontColor: \"rgba(255,255,255,1)\",\n      edgeType: \"text-shadow: 0px 0px 0px\",\n      edgeColor: \"rgba(0,0,0,0)\",\n      backgroundColor: \"rgba(0,0,0,0)\",\n      windowColor: \"rgba(0,0,0,0.5)\"\n    }\n  };\n}\n\n\n__extends(SettingsMediator, puremvc.Mediator);\n\n\nSettingsMediator.NAME = \"SettingsMediator\";\n\nSettingsMediator.NAMESPACE = \"akamai_amp\";\n\nSettingsMediator.GET = function() {\n  var settings;\n  settings = localStorage.getItem(SettingsMediator.NAMESPACE);\n  try {\n    settings = JSON.parse(settings);\n  } catch (error) {\n    settings = {};\n  }\n  return settings || {};\n};\n\n/** @override\n*/\nSettingsMediator.prototype.onRegister = function() {\n  var config, data, settings;\n  config = this.facade.retrieveProxy(ModuleProxy.NAME).getSettings() || {};\n  if (config.namespace != null) {\n    this.namespace = config.namespace;\n  }\n  this.settings = Utils.override(config.defaults, this.defaults);\n  try {\n    data = localStorage.getItem(this.namespace);\n    if (data != null) {\n      settings = JSON.parse(data);\n    }\n  } catch (_error) {}\n  this.save(settings);\n};\n\n/** @override\n*/\nSettingsMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.READY, Notifications.VOLUME_CHANGE, Notifications.CHANGE_AUTOPLAY];\n};\n\n/** @override\n*/\nSettingsMediator.prototype.handleNotification = function(notification) {\n  var body, name, value;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.READY:\n      value = this.settings.volume;\n      if (value != null) {\n        this.sendNotification(Notifications.CHANGE_VOLUME, value);\n      }\n      value = this.settings.autoplay;\n      if (value != null) {\n        this.sendNotification(Notifications.CHANGE_AUTOPLAY, value);\n      }\n      break;\n    case Notifications.CHANGE_AUTOPLAY:\n      if (this.settings.autoplay === body) {\n        return;\n      }\n      this.change({\n        autoplay: body\n      });\n      break;\n    case Notifications.VOLUME_CHANGE:\n      if (this.settings.volume === body) {\n        return;\n      }\n      this.change({\n        volume: body\n      });\n  }\n};\n\n/**\n*/\nSettingsMediator.prototype.change = function(settings) {\n  var captions, changes, edgeColor, edgeType, fontFamily;\n  if (!(settings != null) || typeof settings !== \"object\" || settings instanceof Array) {\n    return;\n  }\n  changes = Utils.diff(this.settings, settings);\n  if (!(changes != null)) {\n    return;\n  }\n  captions = changes.captions;\n  if (captions != null) {\n    edgeColor = captions.edgeColor || \"\";\n    if (edgeColor === \"none\") {\n      captions.edgeColor = \"rgba(0,0,0,0)\";\n    }\n    edgeType = captions.edgeType;\n    if (edgeType != null) {\n      switch (edgeType.toLowerCase()) {\n        case \"none\":\n          edgeType = \"text-shadow: 0px 0px 0px\";\n          break;\n        case \"depressed\":\n          edgeType = \"text-shadow: 0px 1px 0px\";\n          break;\n        case \"left drop shadow\":\n          edgeType = \"text-shadow: -3px 3px 2px\";\n          break;\n        case \"raised\":\n          edgeType = \"text-shadow: 0px 1px 1px\";\n          break;\n        case \"right drop shadow\":\n          edgeType = \"text-shadow: 3px 3px 2px\";\n          break;\n        case \"uniform\":\n          edgeType = \"text-shadow: 0px 0px 4px\";\n      }\n      captions.edgeType = edgeType;\n    }\n    if (captions.fontSize != null) {\n      captions.size = captions.fontSize;\n      delete captions.fontSize;\n    }\n    fontFamily = captions.fontFamily;\n    if (fontFamily != null) {\n      if (this.fontFamily == null) {\n        this.fontFamily = {\n          \"Monospaced Serif\": \"Courier New, Courier, Nimbus Mono L, Cutive Mono, monospace\",\n          \"Proportional Serif\": \"Times New Roman, Times, Georgia, Cambria, PT Serif Caption, serif\",\n          \"Monospaced Sans-Serif\": \"Deja Vu Sans Mono, Lucida Console, Monaco, Consolas, PT Mono, monospace\",\n          \"Proportional Sans-Serif\": \"Roboto, Arial Unicode Ms, Arial, Helvetica, Verdana, PT Sans Caption, sans-serif\",\n          \"Casual\": \"Comic Sans MS, Impact, Handlee, fantasy\",\n          \"Cursive\": \"Monotype Corsiva, URW Chancery L, Apple Chancery, Dancing Script, cursive\",\n          \"Small Capitals\": \"Arial Unicode Ms, Arial, Helvetica, Verdana, Marcellus SC, sans-serif; font-variant: small-caps\"\n        };\n      }\n      if (typeof fontFamily === \"object\") {\n        this.fontFamily = Utils.override(this.fontFamily, fontFamily);\n      } else if (typeof fontFamily === \"string\") {\n        if (Object.keys(this.fontFamily).indexOf(fontFamily) !== -1) {\n          captions.fontFamily = this.fontFamily[fontFamily];\n        }\n      }\n    }\n  }\n  this.save(changes);\n  this.sendNotification(Notifications.SETTINGS_CHANGE, changes);\n};\n\n/**\n*/\nSettingsMediator.prototype.getSettings = function() {\n  return Object.freeze(Object.assign({\n    defaults: Object.assign({}, this.defaults),\n    change: this.change.bind(this)\n  }, this.settings));\n};\n\n/**\n*/\nSettingsMediator.prototype.save = function(settings) {\n  this.settings = Utils.override(this.settings, settings);\n  try {\n    localStorage.setItem(this.namespace, JSON.stringify(this.settings));\n  } catch (_error) {}\n};\n\n/**\n * The ChangeAutoplayCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangeSettingsCommand() {\n  ChangeSettingsCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeSettingsCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChangeSettingsCommand.prototype.execute = function(notification) {\n  var _ref;\n  if ((_ref = this.facade.retrieveMediator(SettingsMediator.NAME)) != null) {\n    _ref.change(notification.getBody());\n  }\n};\n\n/**\n * AudioPlaybackProxy constructor.\n *\n * @constructor\n * @private\n * @extends {PlaybackCoreProxy}\n*/\nfunction AudioPlaybackProxy() {\n  AudioPlaybackProxy.__super__.constructor.call(this);\n}\n\n\n__extends(AudioPlaybackProxy, PlaybackCoreProxy);\n\n\nAudioPlaybackProxy.prototype.playbackCoreName = \"audio\";\n\n/** @override\n*/\nAudioPlaybackProxy.prototype.onRegister = function() {\n  var mediaElement;\n  mediaElement = new MediaElementMediator(\"html5\", \"audio\");\n  this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, mediaElement);\n};\n\n/** @override\n*/\nAudioPlaybackProxy.prototype.onRemove = function() {\n  this.facade.createMediaElement();\n};\n\n/**\n *\n*/\nAudioPlaybackProxy.prototype.canPlayMedium = function(medium) {\n  return medium === \"audio\";\n};\n\n/** @override\n*/\nAudioPlaybackProxy.prototype.canPlayType = function(mimeType) {\n  if (/audio/.test(mimeType)) {\n    return \"maybe\";\n  } else if (/mpegURL/.test(mimeType) && (Utils.isIOS() || Utils.getSafariVersion() !== -1)) {\n    return \"maybe\";\n  }\n  return \"\";\n};\n\nfunction FPS() {}\n\nFPS.extractContentId = function(initData, keys) {\n  var link;\n  link = document.createElement('a');\n  link.href = Utils.arrayToString(initData);\n  return link.hostname;\n};\n\nFPS.extractServerUrl = function(initData, keys) {\n  return keys.serverURL || keys.serverUrl;\n};\n\nFPS.requestCertificate = function(keys) {\n  var request;\n  request = {\n    url: keys.cert,\n    responseType: \"arraybuffer\",\n    headers: {\n      \"Pragma\": \"Cache-Control: no-cache\",\n      \"Cache-Control\": \"max-age=0\"\n    }\n  };\n  return Utils.request(request).then(function(xhr) {\n    return new Uint8Array(xhr.response);\n  });\n};\n\nFPS.concatInitDataIdAndCertificate = function(initData, id, cert) {\n  var buffer, certArray, dataView, idArray, initDataArray, offset;\n  if (typeof id === \"string\") {\n    id = Utils.stringToArray(id);\n  }\n  offset = 0;\n  buffer = new ArrayBuffer(initData.byteLength + 4 + id.byteLength + 4 + cert.byteLength);\n  dataView = new DataView(buffer);\n  initDataArray = new Uint8Array(buffer, offset, initData.byteLength);\n  initDataArray.set(initData);\n  offset += initData.byteLength;\n  dataView.setUint32(offset, id.byteLength, true);\n  offset += 4;\n  idArray = new Uint16Array(buffer, offset, id.length);\n  idArray.set(id);\n  offset += idArray.byteLength;\n  dataView.setUint32(offset, cert.byteLength, true);\n  offset += 4;\n  certArray = new Uint8Array(buffer, offset, cert.byteLength);\n  certArray.set(cert);\n  return new Uint8Array(buffer, 0, buffer.byteLength);\n};\n\nFPS.requestLicense = function(message, contentId, serverUrl, keys) {\n  var key, request, value, _ref,\n    _this = this;\n  request = {\n    url: serverUrl,\n    method: \"POST\",\n    responseType: \"text\",\n    headers: {\n      \"Content-type\": \"application/x-www-form-urlencoded\"\n    },\n    data: \"spc=\" + (Utils.base64EncodeUint8Array(message)) + \"&assetId=\" + (encodeURIComponent(contentId))\n  };\n  if (keys.httpRequestHeaders != null) {\n    _ref = keys.httpRequestHeaders;\n    for (key in _ref) {\n      value = _ref[key];\n      request.headers[key] = value;\n    }\n  }\n  if (typeof keys.withCredentials === \"boolean\") {\n    request.withCredentials = keys.withCredentials;\n  }\n  return Utils.request(request).then(function(xhr) {\n    var keyText;\n    keyText = xhr.responseText.trim();\n    if (keyText.substr(0, 5) === \"<ckc>\" && keyText.substr(-6) === \"</ckc>\") {\n      keyText = keyText.slice(5, -6);\n    }\n    return Utils.base64DecodeUint8Array(keyText);\n  })[\"catch\"](function(error) {\n    throw \"The license request failed.\";\n  });\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction ParamsProxy(data) {\n  ParamsProxy.__super__.constructor.call(this, data);\n}\n\n\n__extends(ParamsProxy, DataBoundConfigurationProxy);\n\n\n/** @static\n*/\nParamsProxy.NAME = \"ParamsProxy\";\n\nParamsProxy.prototype.defaults = {};\n\nParamsProxy.prototype.configurationName = \"params\";\n\n/** @override\n*/\nParamsProxy.prototype.setData = function(data) {\n  var key, value;\n  this.data = {};\n  for (key in data) {\n    value = data[key];\n    this.data[key] = data[key];\n  }\n  return this.data;\n};\n\n/**\n * DVRPlaybackProxy constructor.\n *\n * @constructor\n * @private\n * @extends {PlaybackCoreProxy}\n*/\nfunction DVRPlaybackProxy() {\n  DVRPlaybackProxy.__super__.constructor.call(this);\n}\n\n\n__extends(DVRPlaybackProxy, PlaybackCoreProxy);\n\n\nDVRPlaybackProxy.prototype.playbackCoreName = \"dvr\";\n\nDVRPlaybackProxy.prototype.interval = null;\n\n/** @override\n*/\nDVRPlaybackProxy.prototype.ondurationchange = function(event) {\n  this.updateDuration();\n};\n\n/** @override\n*/\nDVRPlaybackProxy.prototype.ontimeupdate = function(event) {\n  this.updateCurrentTime();\n};\n\n/** @override\n*/\nDVRPlaybackProxy.prototype.onplay = function(event) {\n  this.stopTimer();\n  DVRPlaybackProxy.__super__.onplay.call(this, event);\n};\n\n/** @override\n*/\nDVRPlaybackProxy.prototype.onplaying = function(event) {\n  this.stopTimer();\n  DVRPlaybackProxy.__super__.onplaying.call(this, event);\n};\n\n/** @override\n*/\nDVRPlaybackProxy.prototype.onpause = function(event) {\n  this.startTimer();\n  DVRPlaybackProxy.__super__.onpause.call(this, event);\n};\n\n/** @override\n*/\nDVRPlaybackProxy.prototype.canPlayTemporalType = function(temporalType) {\n  return temporalType === \"dvr\";\n};\n\n/**\n*/\nDVRPlaybackProxy.prototype.getDuration = function() {\n  var mediaElement;\n  mediaElement = this.getMediaElement();\n  if (mediaElement.duration === Infinity) {\n    this.updateDuration();\n  }\n  return this.data.duration;\n};\n\n/**\n*/\nDVRPlaybackProxy.prototype.getStartTime = function() {\n  return this.getMediaElement().seekable.start(0);\n};\n\n/**\n*/\nDVRPlaybackProxy.prototype.getFragmentDuration = function() {\n  return 10;\n};\n\n/**\n*/\nDVRPlaybackProxy.prototype.getLiveTime = function() {\n  return this.getDuration() - this.getFragmentDuration();\n};\n\n/**\n*/\nDVRPlaybackProxy.prototype.isLive = function() {\n  return this.getStartTime() + this.getCurrentTime() >= this.getLiveTime();\n};\n\n/** @override\n*/\nDVRPlaybackProxy.prototype.seek = function(value) {\n  var _this = this;\n  return DVRPlaybackProxy.__super__.seek.call(this, value + this.getStartTime()).then(function(time) {\n    _this.sendNotification(Notifications.IS_LIVE, _this.isLive());\n  });\n};\n\n/**\n*/\nDVRPlaybackProxy.prototype.updateCurrentTime = function() {\n  var currentTime, seekable;\n  seekable = this.getMediaElement().seekable;\n  if (seekable.length === 0) {\n    return;\n  }\n  currentTime = this.getMediaElement().currentTime;\n  this.data.currentTime = currentTime - seekable.start(0);\n  this.sendNotification(Notifications.TIME_CHANGE, {\n    currentTime: this.data.currentTime\n  });\n  this.mediaProxy.setIsLive(this.isLive());\n};\n\n/**\n*/\nDVRPlaybackProxy.prototype.updateDuration = function() {\n  var seekable;\n  seekable = this.getMediaElement().seekable;\n  if (seekable.length === 0) {\n    return;\n  }\n  this.data.duration = seekable.end(0) - seekable.start(0);\n  this.sendNotification(Notifications.CHANGE_DURATION, this.data.duration);\n};\n\n/**\n*/\nDVRPlaybackProxy.prototype.startTimer = function() {\n  this.interval = setInterval(this.updateCurrentTime.bind(this), 1000);\n};\n\n/**\n*/\nDVRPlaybackProxy.prototype.stopTimer = function() {\n  if (this.interval != null) {\n    clearInterval(this.interval);\n    this.interval = null;\n    this.updateCurrentTime();\n  }\n};\n\n/**\n * Creates a new instance of Context.\n * \n * @constructor\n * @private\n * @extends {puremvc.Proxy}\n * @implements {IDataBindingContext}\n*/\nfunction DataBindingContext() {\n  DataBindingContext.__super__.constructor.call(this);\n  if (this.contextName == null) {\n    this.contextName = this.constructor.NAME;\n  }\n}\n\n\n__extends(DataBindingContext, puremvc.Proxy);\n\n\nDataBindingContext.prototype.contextName = null;\n\nDataBindingContext.prototype.contextData = null;\n\n/**\n*/\nDataBindingContext.prototype.onRegister = function() {\n  var base, bindings;\n  if (!(this.getContextName() != null)) {\n    return;\n  }\n  base = this.facade.player || this.facade;\n  bindings = base.retrieveProxy(DataBindingProxy.NAME);\n  bindings.registerContext(this);\n};\n\n/**\n*/\nDataBindingContext.prototype.getContextName = function() {\n  return this.contextName;\n};\n\n/**\n*/\nDataBindingContext.prototype.getContextData = function() {\n  return this.contextData;\n};\n\n/**\n * Creates a new instance of PlayerProxy.\n *\n * @constructor\n * @private\n * @extends {DataBindingContext}\n*/\nfunction PlayerProxy(defaultPlaybackCore, getPlaybackOrder) {\n  var _this = this;\n  this.defaultPlaybackCore = defaultPlaybackCore;\n  this.getPlaybackOrder = getPlaybackOrder;\n  PlayerProxy.__super__.constructor.call(this);\n  this.playbackCoreMap = [];\n  if (this.getPlaybackOrder == null) {\n    this.getPlaybackOrder = function(order) {\n      if (/Edge|Android/.test(navigator.userAgent)) {\n        return [\"audio\", \"hls\", \"dash\", \"dvr\", \"default\"];\n      }\n    };\n  }\n}\n\n\n__extends(PlayerProxy, DataBindingContext);\n\n\n/** @static\n*/\nPlayerProxy.NAME = \"PlayerProxy\";\n\nPlayerProxy.prototype.contextName = \"player\";\n\nPlayerProxy.prototype.getPlaybackOrder = null;\n\nPlayerProxy.prototype.playbackCoreMap = null;\n\nPlayerProxy.prototype.defaultPlaybackCore = null;\n\nPlayerProxy.prototype.activePlaybackCore = null;\n\n/**\n*/\nPlayerProxy.prototype.onRegister = function() {\n  PlayerProxy.__super__.onRegister.call(this);\n  this.registerPlaybackCore(new DVRPlaybackProxy());\n  this.registerPlaybackCore(this.defaultPlaybackCore);\n  this.registerPlaybackCore(new AudioPlaybackProxy());\n  this.activePlaybackCore = this.defaultPlaybackCore;\n};\n\nPlayerProxy.prototype.ready = function() {\n  var order,\n    _this = this;\n  order = typeof this.getPlaybackOrder === \"function\" ? this.getPlaybackOrder(this.playbackCoreMap.map(function(core) {\n    return core.getPlaybackCoreName();\n  })) : void 0;\n  if (!(order != null)) {\n    return;\n  }\n  this.playbackCoreMap = this.playbackCoreMap.sort(function(a, b) {\n    a = order.indexOf(a.getPlaybackCoreName());\n    b = order.indexOf(b.getPlaybackCoreName());\n    if (a === b) {\n      return 0;\n    }\n    if (a === -1 && b !== -1) {\n      return 1;\n    }\n    if (a !== -1 && b === -1) {\n      return -1;\n    }\n    return a - b;\n  });\n};\n\n/**\n*/\nPlayerProxy.prototype.getActivePlaybackCore = function() {\n  return this.activePlaybackCore;\n};\n\n/**\n*/\nPlayerProxy.prototype.registerPlaybackCore = function(core) {\n  var name,\n    _this = this;\n  name = core.getPlaybackCoreName();\n  if (!(core != null) || this.playbackCoreMap.some(function(item) {\n    return item.getPlaybackCoreName() === name;\n  })) {\n    return;\n  }\n  this.playbackCoreMap.push(core);\n};\n\n/**\n*/\nPlayerProxy.prototype.retrievePlaybackCore = function(name) {\n  var core, _i, _len, _ref;\n  _ref = this.playbackCoreMap;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    core = _ref[_i];\n    if (core.getPlaybackCoreName() === name) {\n      return core;\n    }\n  }\n};\n\n/**\n*/\nPlayerProxy.prototype.removePlaybackCore = function(name) {\n  var core, index;\n  core = this.retrievePlaybackCore(name);\n  if (!(core != null)) {\n    return null;\n  }\n  index = this.playbackCoreMap.indexOf(core);\n  this.playbackCoreMap.splice(index, 1);\n  return core;\n};\n\n/**\n*/\nPlayerProxy.prototype.setPlaybackCore = function(media) {\n  var core, error, playbackCore, playbackProxy, _i, _len, _ref;\n  _ref = this.playbackCoreMap;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    core = _ref[_i];\n    if (core.canPlayMedium(media.medium) === true && core.canPlayTemporalType(media.temporalType) === true && core.canPlayType(media.type) !== \"\") {\n      playbackCore = core;\n      break;\n    }\n  }\n  if (!(playbackCore != null)) {\n    error = new Error();\n    error.code = MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED;\n    throw error;\n  }\n  playbackProxy = this.facade.retrieveProxy(PlaybackProxy.NAME);\n  if (playbackProxy !== playbackCore) {\n    if (typeof playbackProxy.destroy === \"function\") {\n      playbackProxy.destroy();\n    }\n    this.facade.removeProxy(PlaybackProxy.NAME);\n    this.facade.registerProxy(playbackCore);\n    playbackCore.setData(playbackProxy.getData());\n  }\n  this.activePlaybackCore = playbackCore;\n  return media;\n};\n\n/**\n*/\nPlayerProxy.prototype.canPlayType = function(type) {\n  var canPlay, core, _i, _len, _ref;\n  _ref = this.playbackCoreMap;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    core = _ref[_i];\n    canPlay = core.canPlayType(type);\n    if (canPlay !== \"\") {\n      return canPlay;\n    }\n  }\n  return \"\";\n};\n\n/**\n * Gets the context data for this proxy.\n *\n * @returns {Object} The contenxt data for this proxy\n * @override\n*/\nPlayerProxy.prototype.getContextData = function() {\n  var configProxy, element, mediaProxy, playbackProxy;\n  configProxy = this.facade.retrieveProxy(ConfigurationProxy.NAME);\n  playbackProxy = this.facade.retrieveProxy(PlaybackProxy.NAME);\n  mediaProxy = this.facade.retrieveProxy(MediaProxy.NAME);\n  element = this.facade.getViewComponent();\n  return {\n    width: element.offsetWidth,\n    height: element.offsetHeight,\n    mode: \"html5\",\n    autoplay: configProxy.getAutoplay(),\n    domain: configProxy.getDomain(),\n    name: configProxy.getName(),\n    currentTime: playbackProxy.getCurrentTime(),\n    duration: playbackProxy.getDuration(),\n    version: configProxy.getVersion(),\n    timecode: {\n      duration: Utils.formatTimecode(mediaProxy.getDuration()),\n      currentTime: Utils.formatTimecode(playbackProxy.getCurrentTime())\n    }\n  };\n};\n\n/**\n * Creates a new instance of MediaProxy. Used to track metadata associated with the video such as src, title and duration.\n *\n * @constructor\n * @private\n * @extends {DataBindingContext}\n*/\nfunction MediaProxy(config) {\n  this.data = {\n    metadata: {}\n  };\n  MediaProxy.__super__.constructor.call(this);\n  this.transform = this.transform.bind(this);\n}\n\n\n__extends(MediaProxy, DataBindingContext);\n\n\n/** @static\n*/\nMediaProxy.NAME = \"MediaProxy\";\n\nMediaProxy.prototype.contextName = \"media\";\n\n/** @private\n*/\nMediaProxy.prototype.data = null;\n\nMediaProxy.prototype.value = null;\n\nMediaProxy.prototype.started = false;\n\nMediaProxy.prototype.authorized = true;\n\n/**\n * Gets the context data for this proxy.\n *\n * @returns {Object} The contenxt data for this proxy\n * @override\n*/\nMediaProxy.prototype.getContextData = function() {\n  return this.data;\n};\n\n/**\n * Sets the data for this proxy.\n *\n * @param {Object} value\n *    The new data for this proxy\n * @override\n*/\nMediaProxy.prototype.getData = function() {\n  var data;\n  data = Utils.clone(MediaProxy.__super__.getData.call(this));\n  if (!(data.authorization != null)) {\n    data.authorization = Utils.clone(this.facade.security.data);\n  }\n  return data;\n};\n\n/**\n * Sets the data for this proxy.\n *\n * @param {Object} value\n *    The new data for this proxy\n * @override\n*/\nMediaProxy.prototype.setData = function(value) {\n  if (this.data && this.facade.getCurrentTime() < this.facade.getDuration()) {\n    this.sendNotification(Notifications.MEDIA_SEQUENCE_ABORTED);\n  }\n  this.started = false;\n  this.setAutoplay(value.autoplay);\n  this.setType(value.type);\n  this.setIsLive(value.isLive);\n  this.setTemporalType(value.temporalType);\n  if (value.source != null) {\n    this.setSource(value.source);\n  }\n  if (value.src != null) {\n    this.setSrc(value.src);\n  }\n  this.setTitle(value.title);\n  this.setDuration(value.duration);\n  this.setPoster(value.poster);\n  this.setGUID(value.guid);\n  this.setLink(value.link);\n  this.setEmbed(value.embed);\n  this.setWidth(value.width);\n  this.setHeight(value.height);\n  this.setCategory(value.category);\n  this.setStartTime(value.startTime);\n  this.setDescription(value.description);\n  this.setStatus(value.status);\n  this.setCategory(value.category);\n  this.setMetadata(value.metadata);\n  this.setAuthorization(value.authorization);\n  this.setMedium(value.medium);\n  this.setPubDate(value.pubDate);\n  this.setTrack(value.track);\n  this.setScenes(value.scenes);\n  this.setKeys(value.keys);\n  this.setCues(value.cues);\n  this.setRestriction(value.restriction);\n  return this.data;\n};\n\n/**\n *\n*/\nMediaProxy.prototype.transform = function(media) {\n  var index, item, playerProxy, scene, time, _i, _len, _ref, _ref1,\n    _this = this;\n  if (!(media.src != null) && ((_ref = media.source) != null ? _ref.length : void 0) > 0) {\n    playerProxy = this.facade.retrieveProxy(PlayerProxy.NAME) || this.facade;\n    if (playerProxy != null) {\n      item = Utils.selectSource(media.source, function(type) {\n        return playerProxy.canPlayType(type);\n      });\n    }\n    if (((item != null ? item.src : void 0) != null) && item.src !== \"\") {\n      media.src = item.src;\n      media.type = item.type;\n    }\n  }\n  if (media.type == null) {\n    media.type = Utils.getMimeType(media.src);\n  }\n  if (!(media.medium != null)) {\n    media.medium = /audio/.test(media.type) ? \"audio\" : \"video\";\n  }\n  if (media.temporalType == null) {\n    media.temporalType = \"vod\";\n  }\n  media.isLive = media.temporalType === \"live\" || media.temporalType === \"dvr\";\n  if (media.scenes != null) {\n    _ref1 = media.scenes;\n    for (index = _i = 0, _len = _ref1.length; _i < _len; index = ++_i) {\n      scene = _ref1[index];\n      scene.start = isNaN(time = Utils.flattenTimecode(scene.sceneStartTime)) ? 0 : time;\n      scene.end = isNaN(time = Utils.flattenTimecode(scene.sceneEndTime)) ? 0 : time;\n      scene.title = scene.sceneTitle || \"\";\n      scene.description = scene.sceneDescription || \"\";\n      scene.position = index + 1;\n    }\n  }\n  if (media.startTime == null) {\n    media.startTime = 0;\n  }\n  if (media.status == null) {\n    media.status = {};\n  }\n  if (media.metadata == null) {\n    media.metadata = {};\n  }\n  media.originalSrc = media.src;\n  return media;\n};\n\n/**\n *\n*/\nMediaProxy.prototype.updateData = function(data) {\n  var key, value;\n  for (key in data) {\n    value = data[key];\n    if (key in this.data) {\n      this.data[key] = value;\n    }\n  }\n};\n\n/**\n * The global unique identifier for this to the video.\n *\n * @param {String} value\n *    The new guid of the video\n * @returns {String}\n *    The guid of the video\n * @type {String}\n*/\nMediaProxy.prototype.getGUID = function() {\n  return this.data.guid;\n};\n\nMediaProxy.prototype.setGUID = function(value) {\n  return this.data.guid = value;\n};\n\nMediaProxy.prototype.getLink = function() {\n  return this.data.link;\n};\n\nMediaProxy.prototype.setLink = function(value) {\n  return this.data.link = value;\n};\n\nMediaProxy.prototype.getStartTime = function() {\n  return this.data.startTime;\n};\n\nMediaProxy.prototype.setStartTime = function(value) {\n  return this.data.startTime = value;\n};\n\nMediaProxy.prototype.getEmbed = function() {\n  return this.data.embed;\n};\n\nMediaProxy.prototype.setEmbed = function(value) {\n  return this.data.embed = value;\n};\n\nMediaProxy.prototype.getAutoplay = function() {\n  return this.data.autoplay;\n};\n\nMediaProxy.prototype.setAutoplay = function(value) {\n  return this.data.autoplay = value;\n};\n\nMediaProxy.prototype.getPubDate = function() {\n  return this.data.pubDate;\n};\n\nMediaProxy.prototype.setPubDate = function(value) {\n  return this.data.pubDate = value;\n};\n\nMediaProxy.prototype.getCategory = function() {\n  return this.data.category;\n};\n\nMediaProxy.prototype.setCategory = function(value) {\n  return this.data.category = value;\n};\n\nMediaProxy.prototype.getStatus = function() {\n  return this.data.status;\n};\n\nMediaProxy.prototype.setStatus = function(value) {\n  if (value == null) {\n    value = {};\n  }\n  return this.data.status = value;\n};\n\n/**\n * The url to the video.\n *\n * @param {String} value\n *    The new title of the video\n * @returns {Boolean}\n *    The title of the video\n * @type {String}\n*/\nMediaProxy.prototype.getSrc = function() {\n  return this.facade.security.createURL(this.data.src);\n};\n\nMediaProxy.prototype.setSrc = function(value) {\n  return this.data.src = value;\n};\n\n/**\n * The mimeType of the video.\n*/\nMediaProxy.prototype.getType = function() {\n  return this.data.type;\n};\n\nMediaProxy.prototype.setType = function(value) {\n  return this.data.type = value;\n};\n\n/**\n * The medium the video. ie audio, video, executable\n*/\nMediaProxy.prototype.getMedium = function() {\n  return this.data.medium;\n};\n\nMediaProxy.prototype.setMedium = function(value) {\n  if (value === this.data.medium) {\n    return;\n  }\n  this.data.medium = value;\n  return this.facade.retrieveProxy(ApplicationStateProxy.NAME).setMedium(value);\n};\n\n/**\n * Additional information about the vieo\n*/\nMediaProxy.prototype.getMetadata = function() {\n  return this.data.metadata;\n};\n\nMediaProxy.prototype.setMetadata = function(value) {\n  return this.data.metadata = value;\n};\n\n/**\n * The source object of the video.\n*/\nMediaProxy.prototype.getSource = function() {\n  return this.data.source;\n};\n\nMediaProxy.prototype.setSource = function(value) {\n  return this.data.source = value;\n};\n\n/**\n * The source object of the video.\n*/\nMediaProxy.prototype.getTrack = function() {\n  return this.data.track;\n};\n\nMediaProxy.prototype.setTrack = function(value) {\n  return this.data.track = value;\n};\n\n/**\n * The title of the video.\n *\n * @param {String} value\n *    The new title of the video\n * @returns {Boolean}\n *    The title of the video\n * @type {String}\n*/\nMediaProxy.prototype.getTitle = function() {\n  return this.data.title;\n};\n\nMediaProxy.prototype.setTitle = function(value) {\n  return this.data.title = value;\n};\n\n/**\n * The native width of the video.\n*/\nMediaProxy.prototype.getWidth = function() {\n  return this.data.width;\n};\n\nMediaProxy.prototype.setWidth = function(value) {\n  return this.data.width = value;\n};\n\n/**\n * The native width of the video.\n*/\nMediaProxy.prototype.getHeight = function() {\n  return this.data.height;\n};\n\nMediaProxy.prototype.setHeight = function(value) {\n  return this.data.height = value;\n};\n\n/**\n * The description of the video.\n *\n * @param {String} value\n *    The new description of the video\n * @returns {Boolean}\n *    The description of the video\n * @type {String}\n*/\nMediaProxy.prototype.getDescription = function() {\n  return this.data.description;\n};\n\nMediaProxy.prototype.setDescription = function(value) {\n  return this.data.description = value;\n};\n\n/**\n *\n*/\nMediaProxy.prototype.getCategory = function() {\n  return this.data.category;\n};\n\nMediaProxy.prototype.setCategory = function(value) {\n  return this.data.category = value;\n};\n\n/**\n * The duration of the video. This property is used in situations where the\n * duration cannot be determined from the video (i.e. before metadata is loaded)\n *\n * @param {Number} value\n *    The new duration of the video\n * @returns {Number}\n *    The duration of the video\n * @type {Number}\n*/\nMediaProxy.prototype.getDuration = function(value) {\n  return this.data.duration;\n};\n\nMediaProxy.prototype.setDuration = function(value) {\n  var ua;\n  if (value === 0 || this.data.temporalType === \"live\") {\n    return;\n  }\n  ua = navigator.userAgent;\n  if (value === 1 && (/Android/.test(ua) && !/Android.*Chrome/.test(ua))) {\n    return;\n  }\n  if (value !== this.data.duration) {\n    this.data.duration = value;\n    this.sendNotification(Notifications.TIME_CHANGE, {\n      duration: value\n    });\n  }\n  if (value === Infinity) {\n    this.setTemporalType(\"live\");\n  }\n  return value;\n};\n\n/**\n * The poster image for the video.\n *\n * @param {String} value\n *    The url of the new poster image\n * @returns {String}\n *    The url of the poster image\n * @type {String}\n*/\nMediaProxy.prototype.getPoster = function(value) {\n  return this.data.poster;\n};\n\nMediaProxy.prototype.setPoster = function(value) {\n  this.data.poster = value;\n};\n\n/**\n *\n*/\nMediaProxy.prototype.getIsLive = function() {\n  return this.data.isLive;\n};\n\nMediaProxy.prototype.setIsLive = function(value) {\n  if (value === this.data.isLive) {\n    return;\n  }\n  this.data.isLive = value;\n  this.sendNotification(Notifications.IS_LIVE, value);\n  return value;\n};\n\n/**\n *\n*/\nMediaProxy.prototype.getTemporalType = function() {\n  return this.data.temporalType || \"vod\";\n};\n\nMediaProxy.prototype.setTemporalType = function(value) {\n  var previous;\n  if (value === this.data.temporalType) {\n    return;\n  }\n  previous = this.data.temporalType;\n  this.data.temporalType = value;\n  this.sendNotification(Notifications.TEMPORAL_TYPE_CHANGE, {\n    previous: previous,\n    value: value\n  });\n};\n\n/**\n *\n*/\nMediaProxy.prototype.getScenes = function() {\n  return this.data.scenes;\n};\n\nMediaProxy.prototype.setScenes = function(value) {\n  return this.data.scenes = value;\n};\n\n/**\n *\n*/\nMediaProxy.prototype.getCues = function() {\n  return this.data.cues;\n};\n\nMediaProxy.prototype.setCues = function(value) {\n  if (value == null) {\n    value = [];\n  }\n  if (this.data.cues === value) {\n    return;\n  }\n  this.data.cues = value;\n  this.sendNotification(Notifications.CUES_CHANGE, value);\n  return value;\n};\n\n/**\n *\n*/\nMediaProxy.prototype.getScene = function(currentTime) {\n  var index, scene, _i, _len, _ref;\n  if (!(this.data.scenes != null)) {\n    return;\n  }\n  _ref = this.data.scenes;\n  for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {\n    scene = _ref[index];\n    if ((scene.start <= currentTime && currentTime < scene.end)) {\n      return scene;\n    }\n  }\n};\n\n/**\n *\n*/\nMediaProxy.prototype.getKeys = function() {\n  return this.data.keys;\n};\n\nMediaProxy.prototype.setKeys = function(value) {\n  this.data.keys = value;\n};\n\n/**\n *\n*/\nMediaProxy.prototype.getAuthorization = function() {\n  return this.data.authorization;\n};\n\nMediaProxy.prototype.setAuthorization = function(value) {\n  this.data.authorization = value;\n};\n\n/**\n *\n*/\nMediaProxy.prototype.getRestriction = function() {\n  return this.data.restriction;\n};\n\nMediaProxy.prototype.setRestriction = function(value) {\n  if (value == null) {\n    value = [];\n  }\n  this.data.restriction = value;\n};\n\n/**\n * Creates a new instance of SecurityProxy.\n *\n * @constructor\n * @private\n * @extends {puremvc.Proxy}\n*/\nfunction SecurityProxy() {\n  SecurityProxy.__super__.constructor.call(this, this.constructor.NAME, {});\n  this.setupHDN1();\n  Object.defineProperties(this, {\n    authorized: {\n      get: this.getAuthorized,\n      enumerable: true,\n      configurable: false\n    }\n  });\n}\n\n\n__extends(SecurityProxy, puremvc.Proxy);\n\n\n/** @static\n*/\nSecurityProxy.NAME = \"SecurityProxy\";\n\nSecurityProxy.prototype.authorized = true;\n\nSecurityProxy.prototype.timeout = null;\n\n/**\n*/\nSecurityProxy.prototype.setupHDN1 = function() {\n  var _this = this;\n  return window.retrieveToken = function(guid, url) {\n    var token;\n    try {\n      _this.facade.logger.debug(\"[AMP AUTH] HDN1: Token Requested\", guid, url);\n      token = _this.getToken();\n      if (token != null) {\n        _this.facade.getMediaElement().tokenRetrievalSuccess(\"&primaryToken=\" + token);\n      } else {\n        _this.sendNotification(SecurityNotifications.AUTHORIZE);\n      }\n    } catch (error) {\n      _this.facade.logger.error(\"[AMP AUTH ERROR]: Token Retrival Error\", error);\n    }\n    return true;\n  };\n};\n\n/**\n*/\nSecurityProxy.prototype.setMedia = function(media) {\n  var authorized;\n  this.setSession(null);\n  authorized = media.status.state !== \"blocked\" && media.restriction.length === 0;\n  this.setAuthorized(authorized);\n  this.setAuthorization(media.authorization);\n};\n\n/**\n*/\nSecurityProxy.prototype.authorize = function(authorization) {\n  this.setAuthorization(authorization);\n  this.sendNotification(SecurityNotifications.AUTHORIZED, authorization);\n};\n\n/**\n*/\nSecurityProxy.prototype.getAuthorization = function() {\n  return this.data;\n};\n\nSecurityProxy.prototype.setAuthorization = function(value) {\n  if ((value != null ? value.token : void 0) != null) {\n    this.setAuthorized(true);\n  }\n  this.data = value || {};\n  if (this.data.expiration != null) {\n    this.setExpiration(this.data.expiration);\n  }\n  return value;\n};\n\n/**\n*/\nSecurityProxy.prototype.getKey = function() {\n  return this.data.key;\n};\n\nSecurityProxy.prototype.setKey = function(value) {\n  this.data.key = value;\n  return value;\n};\n\n/**\n*/\nSecurityProxy.prototype.getToken = function() {\n  return this.data.token;\n};\n\nSecurityProxy.prototype.setToken = function(value) {\n  this.data.token = value;\n  return value;\n};\n\n/**\n*/\nSecurityProxy.prototype.getExpiration = function() {\n  return this.data.expiration;\n};\n\nSecurityProxy.prototype.setExpiration = function(value) {\n  this.data.expiration = value;\n  if (this.data.expiration > Date.now()) {\n    this.startTimeout();\n  }\n  return value;\n};\n\n/**\n*/\nSecurityProxy.prototype.startTimeout = function() {\n  var _this = this;\n  Utils.getUTC().then(function(time) {\n    var timeout;\n    timeout = function() {\n      _this.sendNotification(SecurityNotifications.AUTHORIZATION_EXPIRED);\n      _this.sendNotification(SecurityNotifications.AUTHORIZE, {\n        media: _this.facade.getMedia()\n      });\n    };\n    return _this.timeout = setTimeout(timeout, _this.getExpiration() - time);\n  });\n};\n\n/**\n*/\nSecurityProxy.prototype.stopTimeout = function() {\n  clearTimeout(this.timeout);\n};\n\n/**\n*/\nSecurityProxy.prototype.getSecret = function() {\n  var secret;\n  if (!(this.data.token != null)) {\n    return null;\n  }\n  secret = \"\";\n  if (this.data.token != null) {\n    secret = \"\" + this.data.token;\n  }\n  if (this.data.key != null) {\n    secret = \"\" + this.data.key + \"=\" + secret;\n  }\n  return secret;\n};\n\n/**\n*/\nSecurityProxy.prototype.createURL = function(url) {\n  var secret;\n  secret = this.getSecret();\n  if (secret != null) {\n    url += !/\\?/.test(url) ? \"?\" : \"&\";\n    url += secret;\n  }\n  return url;\n};\n\n/**\n*/\nSecurityProxy.prototype.getAuthorized = function() {\n  return this._authorized;\n};\n\nSecurityProxy.prototype.setAuthorized = function(value) {\n  this.stopTimeout();\n  this._authorized = value;\n  return value;\n};\n\n/**\n*/\nSecurityProxy.prototype.getSession = function() {\n  return this.session;\n};\n\nSecurityProxy.prototype.setSession = function(value) {\n  this.session = value;\n  return value;\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar PlayState = {\n  /**\n   * Constant representing the playing play state\n  */\n\n  READY: \"ready\",\n  /**\n   * Constant representing the playing play state\n  */\n\n  PLAYING: \"playing\",\n  /**\n   * Constant representing the paused play state\n  */\n\n  PAUSED: \"paused\",\n  /**\n   * Constant representing the ended play state\n  */\n\n  ENDED: \"ended\",\n  /**\n   * Constant representing the waiting play state\n  */\n\n  LOADING: \"loading\",\n  /**\n   * Constant representing the waiting play state\n  */\n\n  WAITING: \"waiting\",\n  /**\n   * Constant representing the waiting play state\n  */\n\n  ERROR: \"error\"\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction DataBindingProxy() {\n  DataBindingProxy.__super__.constructor.call(this, this.constructor.NAME, {});\n  this.data = {};\n  this.contextMap = {};\n  this.configurationMap = {};\n}\n\n\n__extends(DataBindingProxy, puremvc.Proxy);\n\n\n/** @static\n*/\nDataBindingProxy.NAME = \"DataBindingProxy\";\n\nDataBindingProxy.prototype.contextMap = null;\n\nDataBindingProxy.prototype.configurationMap = null;\n\nDataBindingProxy.prototype.paramsProxy = null;\n\n/**\n*/\nDataBindingProxy.prototype.initialize = function() {\n  this.paramsProxy = this.facade.retrieveProxy(ParamsProxy.NAME);\n  this.update();\n};\n\n/**\n*/\nDataBindingProxy.prototype.registerContext = function(context) {\n  if (!(context != null)) {\n    return;\n  }\n  this.contextMap[context.getContextName()] = context;\n};\n\n/**\n*/\nDataBindingProxy.prototype.retrieveContext = function(name) {\n  return this.contextMap[name];\n};\n\n/**\n*/\nDataBindingProxy.prototype.removeContext = function(name) {\n  var context;\n  context = this.contextMap[name];\n  delete this.contextMap[name];\n  return context;\n};\n\n/**\n*/\nDataBindingProxy.prototype.registerConfiguration = function(config) {\n  if (!(config != null)) {\n    return;\n  }\n  this.configurationMap[config.getConfigurationName()] = config;\n  config.compile(this.context, true);\n};\n\n/**\n*/\nDataBindingProxy.prototype.retrieveConfiguration = function(name) {\n  return this.configurationMap[name];\n};\n\n/**\n*/\nDataBindingProxy.prototype.removeConfiguration = function(name) {\n  var config;\n  config = this.configurationMap[name];\n  delete this.configurationMap[name];\n  return config;\n};\n\n/**\n*/\nDataBindingProxy.prototype.update = function(contexts) {\n  var context, key, name, value, _ref, _ref1;\n  this.data.now = Date.now();\n  _ref = this.contextMap;\n  for (name in _ref) {\n    context = _ref[name];\n    if ((contexts != null ? typeof contexts.indexOf === \"function\" ? contexts.indexOf(name) : void 0 : void 0) === -1) {\n      continue;\n    }\n    this.data[name] = context.getContextData();\n  }\n  this.paramsProxy.compile(this.data);\n  _ref1 = this.paramsProxy.value;\n  for (key in _ref1) {\n    value = _ref1[key];\n    this.data[key] = value;\n  }\n  return this.data;\n};\n\n/**\n*/\nDataBindingProxy.prototype.compile = function(contexts, suppressErrors) {\n  var config, context, name, paramsName, _ref;\n  if (suppressErrors == null) {\n    suppressErrors = false;\n  }\n  this.update(contexts);\n  context = this.data;\n  paramsName = this.paramsProxy.getConfigurationName();\n  _ref = this.configurationMap;\n  for (name in _ref) {\n    config = _ref[name];\n    if (name !== paramsName) {\n      config.compile(context, suppressErrors);\n    }\n  }\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar RenderMode = {\n  /**\n   * Constant representing the flash renderer.\n  */\n\n  FLASH: \"flash\",\n  /**\n   * Constant representing the html renderer.\n  */\n\n  HTML: \"html\"\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar ActiveState = {\n  /**\n   * Constant representing the active state (controls on).\n  */\n\n  ACTIVE: \"active\",\n  /**\n   * Constant representing the inactive state (controls off).\n  */\n\n  INACTIVE: \"inactive\"\n};\n\n/**\n * @enum {string}\n * @const\n*/\n\nvar TransformType = {\n  /**\n   *\n  */\n\n  TIME: \"time\",\n  /**\n   *\n  */\n\n  SEEK: \"seek\",\n  /**\n   *\n  */\n\n  MEDIA: \"media\",\n  /**\n   *\n  */\n\n  AD_REQUEST: \"adrequest\",\n  /**\n   *\n  */\n\n  PLAY_STATE: \"playstate\"\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar PluginNotifications = {\n  REGISTER_PLUGINS: \"registerPlugins\",\n  PLUGIN_REGISTERED: \"pluginRegistered\",\n  PLUGINS_INITIALIZED: \"pluginsinitialized\"\n};\n\n/**\n * Used to track the various states of the player like full screen mode and active state (controls visible).\n *\n * @constructor\n * @private\n * @extends {puremvc.Proxy}\n*/\nfunction ApplicationStateProxy() {\n  ApplicationStateProxy.__super__.constructor.call(this);\n  this.device = Utils.getDevice();\n  this.time = {};\n}\n\n\n__extends(ApplicationStateProxy, puremvc.Proxy);\n\n\n/** @static\n*/\nApplicationStateProxy.NAME = \"ApplicationStateProxy\";\n\n/** @private\n*/\nApplicationStateProxy.prototype.displayState = DisplayState.NORMAL;\n\nApplicationStateProxy.prototype.playState = null;\n\nApplicationStateProxy.prototype.renderMode = null;\n\nApplicationStateProxy.prototype.activeState = null;\n\nApplicationStateProxy.prototype.seeking = false;\n\nApplicationStateProxy.prototype.seekrequested = false;\n\nApplicationStateProxy.prototype.waiting = false;\n\nApplicationStateProxy.prototype.busy = false;\n\nApplicationStateProxy.prototype.isUserActive = false;\n\nApplicationStateProxy.prototype.device = null;\n\nApplicationStateProxy.prototype.volume = 1;\n\nApplicationStateProxy.prototype.playbackTarget = \"amp\";\n\nApplicationStateProxy.prototype.hasPostContent = false;\n\nApplicationStateProxy.prototype.locked = false;\n\nApplicationStateProxy.prototype.mediaElement = null;\n\nApplicationStateProxy.prototype.hidden = false;\n\nApplicationStateProxy.prototype.ended = false;\n\nApplicationStateProxy.prototype.buffering = false;\n\nApplicationStateProxy.prototype.time = null;\n\nApplicationStateProxy.prototype.playbackRate = 1;\n\n/**\n * Flag indicating whether or not the media will have additional\n * content playback after the media playback is complete\n *\n * @param {Boolean} value\n *    The post content flag\n * @returns {Boolean}\n *    The post content flag\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getHasPostContent = function() {\n  return this.hasPostContent;\n};\n\nApplicationStateProxy.prototype.setHasPostContent = function(value) {\n  this.hasPostContent = value;\n};\n\n/**\n * Flag indicating whether or not the media playback is complete\n *\n * @param {Boolean} value\n *    The ended flag\n * @returns {Boolean}\n *    The ended flag\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getEnded = function() {\n  return this.ended;\n};\n\nApplicationStateProxy.prototype.setEnded = function(value) {\n  this.ended = value;\n  if (this.ended === true && this.seeking === true) {\n    this.seeking = false;\n  }\n};\n\n/**\n * The player's display state. Valid options are:\n *\n * ApplicationStateProxy.FULL_SCREEN\n * ApplicationStateProxy.NORMAL\n *\n * @param {String} value\n *    The new display state of the player\n * @returns {String}\n *    The display state of the player\n * @type {String}\n*/\nApplicationStateProxy.prototype.getDisplayState = function() {\n  return this.displayState;\n};\n\nApplicationStateProxy.prototype.setDisplayState = function(value) {\n  var previous;\n  if (value === this.displayState) {\n    return;\n  }\n  previous = this.displayState;\n  this.displayState = value;\n  this.sendNotification(Notifications.DISPLAY_STATE_CHANGE, {\n    previous: previous,\n    value: this.displayState\n  });\n};\n\n/**\n * The player's display state. Valid options are:\n *\n * ApplicationStateProxy.FULL_SCREEN\n * ApplicationStateProxy.NORMAL\n *\n * @param {String} value\n *    The new display state of the player\n * @returns {String}\n *    The display state of the player\n * @type {String}\n*/\nApplicationStateProxy.prototype.getPlayState = function() {\n  return this.playState;\n};\n\nApplicationStateProxy.prototype.setPlayState = function(value) {\n  var previous,\n    _this = this;\n  if (this.getWaiting() === true) {\n    this.setWaiting(false);\n  }\n  if (value === this.playState) {\n    return;\n  }\n  previous = this.playState;\n  this.playState = value;\n  this.facade.transform(TransformType.PLAY_STATE, this.playState).then(function(result) {\n    _this.sendNotification(Notifications.PLAY_STATE_CHANGE, {\n      previous: previous,\n      value: _this.playState\n    });\n    switch (value) {\n      case PlayState.PLAYING:\n        return _this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"playing\"));\n    }\n  })[\"catch\"](function(error) {\n    return _this.sendNotification(Notifications.ERROR, error);\n  });\n};\n\n/**\n * The player's device.\n *\n *\n * @returns {String}\n *    The display state of the player\n * @type {String}\n*/\nApplicationStateProxy.prototype.getDevice = function() {\n  return this.device;\n};\n\n/**\n * Indicates whether or not the player is seeking\n *\n * @param {Boolean} value\n *    The seeking flag\n * @returns {Boolean}\n *    The seeking flag\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getSeeking = function() {\n  return this.seeking;\n};\n\nApplicationStateProxy.prototype.setSeeking = function(value) {\n  if (value === this.seeking) {\n    return;\n  }\n  this.seeking = value;\n  if (this.seeking === false && this.playState === PlayState.PAUSED && this.getWaiting() === true) {\n    this.setWaiting(false);\n  }\n};\n\n/**\n * Indicates whether or not a seek has been requested.\n * This is only set when a seek is requested while\n * a previously requested seek is in progress\n *\n * @param {Boolean} value\n *    The seekrequested flag\n * @returns {Boolean}\n *    The seekrequested flag\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getSeekRequested = function() {\n  return this.seekrequested;\n};\n\nApplicationStateProxy.prototype.setSeekRequested = function(value) {\n  if (value === this.seekrequested) {\n    return;\n  }\n  this.seekrequested = value;\n};\n\n/**\n * Indicates whether or not the player is waiting\n *\n * @param {Boolean} value\n *    The waiting flag\n * @returns {Boolean}\n *    The waiting flag\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getWaiting = function() {\n  return this.waiting;\n};\n\nApplicationStateProxy.prototype.setWaiting = function(value) {\n  var handler, mediaElement, note,\n    _this = this;\n  if (value === this.waiting) {\n    return;\n  }\n  this.waiting = value;\n  note = this.waiting === true ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;\n  this.sendNotification(note, PlayState.WAITING);\n  if (this.waiting === true) {\n    mediaElement = this.facade.getMediaElement();\n    handler = function(event) {\n      _this.facade.removeEventListener(\"playing\", handler);\n      _this.facade.removeEventListener(\"canplaythrough\", handler);\n      _this.facade.removeEventListener(\"ended\", handler);\n      _this.setWaiting(false);\n    };\n    this.facade.addEventListener(\"playing\", handler);\n    this.facade.addEventListener(\"canplaythrough\", handler);\n    this.facade.addEventListener(\"ended\", handler);\n  }\n};\n\n/**\n * Indicates whether or not the player is busy\n *\n * @param {Boolean} value\n *    The busy flag\n * @returns {Boolean}\n *    The busy flag\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getBusy = function() {\n  return this.busy;\n};\n\nApplicationStateProxy.prototype.setBusy = function(value) {\n  if (value === this.busy) {\n    return;\n  }\n  this.busy = value;\n  this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"busy\", value));\n};\n\n/**\n * Indicates whether or not the player is locked.\n * A lock player will not autoplay even if configured\n * to do so.\n *\n * @param {Boolean} value\n *    The locked flag\n * @returns {Boolean}\n *    The locked flag\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getLocked = function() {\n  return this.locked;\n};\n\nApplicationStateProxy.prototype.setLocked = function(value) {\n  this.locked = value;\n};\n\n/**\n * Indicates whether or not the player is buffering.\n *\n * @param {Boolean} value\n *    The buffering flag\n * @returns {Boolean}\n *    The buffering flag\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getBuffering = function() {\n  return this.buffering;\n};\n\nApplicationStateProxy.prototype.setBuffering = function(value) {\n  this.buffering = value;\n};\n\n/**\n * Indicates whether or not the user is currently interacting with the player\n *\n * @param {Boolean} value\n *\n * @returns {Boolean}\n *\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getIsUserActive = function() {\n  return this.isUserActive;\n};\n\nApplicationStateProxy.prototype.setIsUserActive = function(value) {\n  if (value !== this.isUserActive) {\n    this.isUserActive = value;\n  }\n};\n\n/**\n * The core type used for rendering the video.\n *\n * @param {String} value\n *    The new currentTime value in seconds\n * @returns {Number}\n *    The currentTime value in seconds\n * @type {Number}\n*/\nApplicationStateProxy.prototype.getRenderMode = function() {\n  return this.renderMode;\n};\n\nApplicationStateProxy.prototype.setRenderMode = function(value) {\n  if (value !== this.renderMode) {\n    this.renderMode = value;\n  }\n};\n\n/**\n * The medium the player is currently playing. Valid options are:\n *\n * \"audio\"\n * \"video\"\n *\n * @param {String} value\n *    The new medium\n *\n * @returns {String}\n *    The current medium\n *\n * @type {String}\n*/\nApplicationStateProxy.prototype.getMedium = function() {\n  return this.medium;\n};\n\nApplicationStateProxy.prototype.setMedium = function(value) {\n  var previous;\n  if (value === this.medium) {\n    return;\n  }\n  previous = this.medium != null ? \"medium-\" + this.medium : this.medium;\n  this.medium = value;\n  this.sendNotification(Notifications.MEDIUM_CHANGE, {\n    previous: previous,\n    value: \"medium-\" + this.medium\n  });\n};\n\n/**\n * The player's volume as a value between 0 and 1.\n *\n * @param {Number} value\n *    The new volume\n *\n * @returns {Number}\n *    The current volume\n *\n * @type {Number}\n*/\nApplicationStateProxy.prototype.getVolume = function() {\n  return this.volume;\n};\n\nApplicationStateProxy.prototype.setVolume = function(value) {\n  if (value === this.volume) {\n    return;\n  }\n  return this.volume = value;\n};\n\n/**\n * The playback target. i.e. \"amp\", \"chromecast\", \"airplay\"\n *\n * @param {Number} value\n *    The new volume\n *\n * @returns {Number}\n *    The current volume\n *\n * @type {Number}\n*/\nApplicationStateProxy.prototype.getPlaybackTarget = function() {\n  return this.playbackTarget;\n};\n\nApplicationStateProxy.prototype.setPlaybackTarget = function(value) {\n  var previous;\n  if (value === this.playbackTarget) {\n    return;\n  }\n  previous = this.playbackTarget;\n  this.playbackTarget = value;\n  if (value !== \"amp\") {\n    if (this.getPlayState() !== PlayState.PAUSED) {\n      this.facade.pause();\n    }\n  } else {\n    if (this.getPlayState() === PlayState.PLAYING) {\n      this.facade.play();\n    }\n  }\n  this.sendNotification(Notifications.PLAYBACK_TARGET_CHANGE, {\n    previous: previous,\n    value: this.playbackTarget\n  });\n};\n\n/**\n * The active state of the player. Used to display controls.\n *\n * @param {Boolean} value\n *    The new active state of the video\n * @returns {Boolean}\n *    The active state of the video\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getActiveState = function() {\n  return this.activeState;\n};\n\nApplicationStateProxy.prototype.setActiveState = function(value) {\n  var previous;\n  if (value === this.activeState) {\n    return;\n  }\n  previous = this.activeState;\n  this.activeState = value;\n  this.sendNotification(Notifications.ACTIVE_STATE_CHANGE, {\n    previous: previous,\n    value: this.activeState\n  });\n};\n\n/**\n * The player's media element\n *\n * @param {HTMLElement} value\n *    The new media element\n * @returns {HTMLElement}\n *    The media element\n * @type {HTMLElement}\n*/\nApplicationStateProxy.prototype.getMediaElement = function() {\n  return this.mediaElement;\n};\n\nApplicationStateProxy.prototype.setMediaElement = function(value) {\n  var previous;\n  if (value === this.mediaElement) {\n    return;\n  }\n  previous = this.mediaElement;\n  this.mediaElement = value;\n  this.sendNotification(Notifications.MEDIA_ELEMENT_CHANGE, {\n    previous: previous,\n    value: this.mediaElement\n  });\n};\n\n/**\n * The player's hidden state\n *\n * @param {Boolean} value\n *    The new hidden state\n * @returns {Boolean}\n *    The hidden state\n * @type {Boolean}\n*/\nApplicationStateProxy.prototype.getHidden = function() {\n  return this.hidden;\n};\n\nApplicationStateProxy.prototype.setHidden = function(value) {\n  var previous;\n  if (value === this.hidden) {\n    return;\n  }\n  previous = this.hidden;\n  this.hidden = value;\n  this.sendNotification(Notifications.HIDDEN_CHANGE, {\n    previous: previous,\n    value: this.hidden\n  });\n};\n\n/**\n * The media's current time\n *\n * @param {Number} value\n *    The new current time\n * @returns {Number}\n *    The current time\n * @type {Number}\n*/\nApplicationStateProxy.prototype.getCurrentTime = function() {\n  return this.time.currentTime;\n};\n\nApplicationStateProxy.prototype.setCurrentTime = function(value) {\n  if (value === this.time.currentTime || value < 0) {\n    return;\n  }\n  this.time.currentTime = value;\n  this.sendNotification(Notifications.TIME_UPDATE, value);\n};\n\n/**\n * The media's duration\n *\n * @param {Number} value\n *    The new duration\n * @returns {Number}\n *    The duration\n * @type {Number}\n*/\nApplicationStateProxy.prototype.getDuration = function() {\n  return this.time.duration;\n};\n\nApplicationStateProxy.prototype.setDuration = function(value) {\n  if (value === this.time.duration) {\n    return;\n  }\n  this.time.duration = value;\n  this.sendNotification(Notifications.DURATION_CHANGE, value);\n};\n\n/**\n * The playback rate\n *\n * @param {Number} value\n *     The new playback rate\n * @returns {Number}\n *     The playback rate\n * @type {Number}\n*/\nApplicationStateProxy.prototype.getPlaybackRate = function() {\n  return this.playbackRate;\n};\n\nApplicationStateProxy.prototype.setPlaybackRate = function(value) {\n  if (value === this.playbackRate) {\n    return;\n  }\n  this.playbackRate = value;\n};\n\n/**\n * The ExternalMediaProxy class.\n * \n * @constructor\n * @private\n * @extends {MediaProxy}\n*/\nfunction ExternalMediaProxy() {\n  ExternalMediaProxy.__super__.constructor.call(this);\n}\n\n\n__extends(ExternalMediaProxy, MediaProxy);\n\n\n/** @static\n*/\nExternalMediaProxy.NAME = \"MediaProxy\";\n\n/**\n * The source object of the video.\n*/\nExternalMediaProxy.prototype.setSource = function(value) {\n  if (!(value != null) || value.length < 1) {\n    return;\n  }\n  value = value.filter(function(item) {\n    return item.type === \"external\";\n  });\n  return ExternalMediaProxy.__super__.setSource.call(this, value);\n};\n\n/**\n * The ExternalPlaybackProxy class.\n * \n * @constructor\n * @private\n * @extends {puremvc.Proxy}\n*/\nfunction ExternalPlaybackProxy() {\n  ExternalPlaybackProxy.__super__.constructor.call(this);\n}\n\n\n__extends(ExternalPlaybackProxy, puremvc.Proxy);\n\n\n/**\n * The name of the this Proxy.\n * \n * @static\n * @type {string}\n*/\nExternalPlaybackProxy.NAME = \"PlaybackProxy\";\n\n/** @private\n*/\nExternalPlaybackProxy.prototype.src = null;\n\n/**\n*/\nExternalPlaybackProxy.prototype.getPlaybackCoreName = function() {\n  return \"external\";\n};\n\n/**\n * Determines if the core can play a given mimeType.\n * \n * @return {String} \"\" if the core can't play the mimeType\n*/\nExternalPlaybackProxy.prototype.canPlayType = function(mimeType) {\n  return mimeType === \"external\";\n};\n\n/**\n *\n*/\nExternalPlaybackProxy.prototype.canPlayTemporalType = function(temporalType) {\n  return true;\n};\n\n/**     \n * The current time of the video in seconds. Value must be between currentTime and duration.\n * \n * @param {Number} value\n *    The new currentTime value in seconds\n * @returns {Number} \n *    The currentTime value in seconds\n * @type {Number}\n*/\nExternalPlaybackProxy.prototype.getSrc = function() {\n  return this.facade.mediaProxy.getSrc();\n};\n\n/**\n * Instructs the core to play.\n*/\nExternalPlaybackProxy.prototype.play = function() {\n  window.open(this.getSrc(), \"_blank\");\n};\n\nExternalPlaybackProxy.prototype.load = function() {};\n\nExternalPlaybackProxy.prototype.setVolume = function() {};\n\nExternalPlaybackProxy.prototype.pause = function() {};\n\nExternalPlaybackProxy.prototype.setEnabled = function() {};\n\nExternalPlaybackProxy.prototype.getCurrentTime = function() {\n  return 0;\n};\n\nExternalPlaybackProxy.prototype.setCurrentTime = function(value) {};\n\nExternalPlaybackProxy.prototype.getDuration = function() {\n  return 0;\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar UserNotifications = {\n  TOGGLE_PLAY_PAUSE: \"usertogglePlayPause\",\n  PLAY: \"userplay\",\n  PAUSE: \"userpause\",\n  SEEK: \"userseek\",\n  SEEKED: \"userseeked\",\n  GO_LIVE: \"usergolive\"\n};\n\n/**\n * The PluginProxy class.\n *\n * @param {Object} config\n * @constructor\n * @private\n * @extends {DataBoundConfigurationProxy}\n*/\nfunction PluginProxy(config) {\n  PluginProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(PluginProxy, DataBoundConfigurationProxy);\n\n\n/** @static\n*/\nPluginProxy.NAME = ModuleProxy.NAME;\n\nPluginProxy.prototype.enabled = true;\n\nPluginProxy.prototype.plugin = null;\n\nPluginProxy.prototype.appState = null;\n\n/**\n*/\nPluginProxy.prototype.getDefaults = function() {\n  var defaults;\n  defaults = PluginProxy.__super__.getDefaults.call(this);\n  if (!(defaults.debug != null)) {\n    defaults.debug = null;\n  }\n  return defaults;\n};\n\n/** @override\n*/\nPluginProxy.prototype.initializeNotifier = function(key) {\n  PluginProxy.__super__.initializeNotifier.call(this, key);\n  this.appState = this.facade.player.appState;\n};\n\n/**\n*/\nPluginProxy.prototype.getMediaElement = function() {\n  return this.facade.player.getMediaElement();\n};\n\n/**\n*/\nPluginProxy.prototype.setEnabled = function(value) {\n  this.enabled = value;\n  return value;\n};\n\nPluginProxy.prototype.getEnabled = function() {\n  return this.enabled;\n};\n\n/**\n*/\nPluginProxy.prototype.getDebug = function() {\n  if (this.value.debug != null) {\n    return this.value.debug;\n  } else {\n    return this.facade.player.getConfig().debug === true;\n  }\n};\n\n/**\n*/\nPluginProxy.prototype.createPlugin = function() {};\n\n/**\n*/\nPluginProxy.prototype.initialize = function() {\n  this.plugin = this.createPlugin();\n};\n\n/**\n*/\nPluginProxy.prototype.error = function(err) {\n  this.facade.logger.error(\"[AMP \" + (this.facade.getModuleName().toUpperCase()) + \" Error]\", err);\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar Namespace = {\n  PREFIX: \"akamai-\"\n};\n\n/**\n * The Plugin class. Acts as a base for plugins.\n *\n * @constructor\n * @private\n * @extends {Module}\n*/\nfunction Plugin() {\n  Plugin.__super__.constructor.call(this);\n}\n\n\n__extends(Plugin, Module);\n\n\nPlugin.prototype.player = null;\n\nPlugin.prototype.proxy = null;\n\n/**\n * @override\n*/\nPlugin.prototype.initialize = function(config, player) {\n  this.player = player;\n  this.logger = this.player.logger;\n  Plugin.__super__.initialize.call(this, config, player);\n};\n\n/**\n*/\nPlugin.prototype.isAvailable = function() {\n  return true;\n};\n\n/**\n*/\nPlugin.prototype.loadModuleResources = function() {\n  if (!this.isAvailable()) {\n    return Promise.resolve();\n  }\n  return Plugin.__super__.loadModuleResources.call(this);\n};\n\n/**\n * @override\n*/\nPlugin.prototype.resourcesLoaded = function() {\n  if (typeof this.oninitialized === \"function\") {\n    this.oninitialized(this);\n  }\n};\n\n/** @override\n*/\nPlugin.prototype.onRegister = function() {\n  var _ref;\n  if (this.isAvailable()) {\n    this.createFramework();\n    if ((_ref = this.retrieveProxy(PluginProxy.NAME)) != null) {\n      if (typeof _ref.initialize === \"function\") {\n        _ref.initialize();\n      }\n    }\n  }\n  this.performance.ready = Date.now();\n  this.sendNotification(PluginNotifications.PLUGIN_REGISTERED, this);\n};\n\n/** @override\n*/\nPlugin.prototype.logEvent = function(event) {\n  var prefix;\n  if (/(timeupdate|timeremaining)/.test(event.type) === true) {\n    return;\n  }\n  prefix = this.player.getModuleName().toUpperCase() + \" \" + this.getModuleName().toUpperCase();\n  if (event.dispatcher != null) {\n    prefix += \" \" + event.dispatcher;\n  }\n  this.logger.log(\"[\" + prefix + \" EVENT] \" + event.type, event);\n};\n\n/** @override\n*/\nPlugin.prototype.listNotificationPublications = function() {\n  var key, notes, value;\n  notes = [Notifications.ADD_LAYER, Notifications.REMOVE_LAYER, Notifications.ADD_OVERLAY, Notifications.REMOVE_OVERLAY, Notifications.ADD_APPLICATION_STATE, Notifications.REMOVE_APPLICATION_STATE, Notifications.IS_USER_ACTIVE, Notifications.PLAYBACK_CORE_CHANGE];\n  return notes.concat((function() {\n    var _results;\n    _results = [];\n    for (key in PluginNotifications) {\n      value = PluginNotifications[key];\n      _results.push(value);\n    }\n    return _results;\n  })());\n};\n\n/**\n * The ChangePlayStateCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangePlayStateCommand() {\n  ChangePlayStateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangePlayStateCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nChangePlayStateCommand.prototype.execute = function(notification) {\n  this.applicationState.setPlayState(notification.getBody());\n};\n\n/**\n * The ChangeMediaCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangeMediaCommand() {\n  ChangeMediaCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeMediaCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nChangeMediaCommand.prototype.execute = function(notification) {\n  var media;\n  try {\n    media = this.media.setData(notification.getBody());\n  } catch (error) {\n    this.sendNotification(Notifications.ERROR, error.message);\n    return;\n  }\n  this.sendNotification(Notifications.UPDATE_DATA_BINDINGS);\n  media = this.media.getData();\n  this.security.setMedia(media);\n  if (this.security.getAuthorized()) {\n    this.sendNotification(SecurityNotifications.AUTHORIZED, this.security.getAuthorization());\n  } else {\n    this.sendNotification(SecurityNotifications.AUTHORIZE, {\n      media: media\n    });\n  }\n};\n\n/**\n * The SetMediaCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction SetMediaCommand() {\n  SetMediaCommand.__super__.constructor.call(this);\n}\n\n\n__extends(SetMediaCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nSetMediaCommand.prototype.execute = function(notification) {\n  var media, _ref,\n    _this = this;\n  media = notification.getBody();\n  this.applicationState.setBuffering(false);\n  this.applicationState.setEnded(false);\n  this.playback.setEnabled(false);\n  this.playback.pause();\n  if ((_ref = this.tracks) != null) {\n    _ref.clear();\n  }\n  this.sendNotification(Notifications.HAS_POST_CONTENT, false);\n  this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.READY);\n  this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n  media = this.media.transform(media);\n  this.facade.transform(TransformType.MEDIA, media).then(function(result) {\n    return _this.sendNotification(Notifications.CHANGE_MEDIA, result);\n  })[\"catch\"](function(error) {\n    return _this.sendNotification(Notifications.ERROR, error);\n  });\n};\n\n/**\n * The MediaChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction MediaChangeCommand() {\n  MediaChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaChangeCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nMediaChangeCommand.prototype.execute = function(notification) {\n  var media, playback;\n  media = notification.getBody();\n  this.playerCore.setPlaybackCore(media);\n  playback = this.playerCore.getActivePlaybackCore() || this.player.playback;\n  playback.reset();\n  playback.setCurrentTime(media.startTime || 0);\n  MediaChangeCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The ChangeDurationCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangeDurationCommand() {\n  ChangeDurationCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeDurationCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChangeDurationCommand.prototype.execute = function(notification) {\n  var duration;\n  duration = notification.getBody();\n  if (this.media.getDuration() === duration) {\n    return;\n  }\n  this.media.setDuration(duration);\n};\n\n/**\n * The ErrorCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerEventCommand}\n*/\nfunction ErrorCommand() {\n  ErrorCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ErrorCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nErrorCommand.prototype.execute = function(notification) {\n  var core, error;\n  this.playback.destroy();\n  core = this.playback.getMediaElement();\n  EventHandler.clear(core);\n  error = notification.getBody();\n  this.logger.error(\"[AMP ERROR]\", error);\n  this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.ERROR);\n  this.facade.error = error;\n  ErrorCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The ReadyCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ReadyCommand() {\n  ReadyCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ReadyCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nReadyCommand.prototype.execute = function(notification) {\n  var volume, _ref,\n    _this = this;\n  volume = (_ref = this.facade.config) != null ? _ref.volume : void 0;\n  if (volume != null) {\n    this.sendNotification(Notifications.CHANGE_VOLUME, volume);\n  }\n  this.playerCore.ready();\n  if (this.facade.config.autoplay === true) {\n    this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"autoplay\");\n  }\n  this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n  this.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.READY);\n  this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n  this.facade.performance.ready = Date.now();\n  Utilization.track(\"ready\", this.facade.performance.ready - this.facade.performance.init);\n  this.dispatchEventAfterCommand(notification).then(function() {\n    var media, _ref1;\n    media = (_ref1 = _this.facade.config) != null ? _ref1.media : void 0;\n    if (media != null) {\n      return _this.sendNotification(Notifications.SET_MEDIA, media);\n    }\n  });\n};\n\n/**\n * The UpdateDataBindingsCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction UpdateDataBindingsCommand() {\n  UpdateDataBindingsCommand.__super__.constructor.call(this);\n}\n\n\n__extends(UpdateDataBindingsCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nUpdateDataBindingsCommand.prototype.execute = function(notification) {\n  var body;\n  body = notification.getBody() || {};\n  this.bindings.compile(body.contexts, body.suppressErrors);\n};\n\n/**\n * The ChangeParamsCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction ChangeParamsCommand() {\n  ChangeParamsCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeParamsCommand, PlayerCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nChangeParamsCommand.prototype.execute = function(notification) {\n  this.params.setData(notification.getBody());\n  this.sendNotification(Notifications.UPDATE_DATA_BINDINGS, {\n    suppressErrors: true\n  });\n};\n\n/**\n * The OverlayLayerMediator class.\n * \n * @constructor\n * @private\n * @extends {LayerMediator}\n*/\nfunction OverlayLayerMediator() {\n  OverlayLayerMediator.__super__.constructor.call(this);\n}\n\n\n__extends(OverlayLayerMediator, LayerMediator);\n\n\nOverlayLayerMediator.prototype.componentName = \"overlays\";\n\nOverlayLayerMediator.NAME = \"OverlayLayerMediator\";\n\n/**\n*/\nOverlayLayerMediator.prototype.createMediatorName = function() {\n  return OverlayLayerMediator.NAME;\n};\n\n/**\n * Overridden so this class may subscribe to all notifications\n * @return An Array\n * \n * @override\n*/\nOverlayLayerMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.ADD_OVERLAY, Notifications.REMOVE_OVERLAY];\n};\n\n/**\n * Handles notifications of interest to this mediator. Note that\n * the default declaration is to allow the super to handle the\n * note. This leaves the base JunctionMediator to handle things\n * like ACCEPT_INPUT_PIPE and ACCEPT_OUTPUT_PIPE  \n * \n * @param note An INotification\n * @override\n*/\nOverlayLayerMediator.prototype.handleNotification = function(notification) {\n  var name, overlay;\n  name = notification.getName();\n  overlay = notification.getBody();\n  switch (name) {\n    case Notifications.ADD_OVERLAY:\n      this.viewComponent.appendChild(overlay);\n      break;\n    case Notifications.REMOVE_OVERLAY:\n      this.viewComponent.removeChild(overlay);\n  }\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction PluginAdapter() {\n  this.plugins = [];\n  this.registered = 0;\n  PluginAdapter.__super__.constructor.call(this, this.constructor.NAME, {});\n}\n\n\n__extends(PluginAdapter, puremvc.Mediator);\n\n\nPluginAdapter.NAME = \"PluginAdapter\";\n\nPluginAdapter.prototype.plugins = null;\n\nPluginAdapter.prototype.registered = null;\n\n/**\n * Registers the appropriate pipes and listeners when\n * this class is registered\n *\n * @override\n*/\nPluginAdapter.prototype.onRegister = function() {\n  return PluginAdapter.__super__.onRegister.call(this);\n};\n\n/**\n * Overridden so this class may subscribe to all notifications\n * @return An Array\n *\n * @override\n*/\nPluginAdapter.prototype.listNotificationInterests = function() {\n  return [PluginNotifications.REGISTER_PLUGINS, PluginNotifications.PLUGIN_REGISTERED];\n};\n\n/**\n * Handles notifications of interest to this mediator. Note that\n * the default declaration is to allow the super to handle the\n * note. This leaves the base JunctionMediator to handle things\n * like ACCEPT_INPUT_PIPE and ACCEPT_OUTPUT_PIPE\n *\n * @param note An INotification\n * @override\n*/\nPluginAdapter.prototype.handleNotification = function(notification) {\n  var body, config, def, init, initialize, key, name, plugin, plugins, type, value, _ref,\n    _this = this;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case PluginNotifications.REGISTER_PLUGINS:\n      type = this.facade.getPlayerType();\n      config = body;\n      _ref = AMP.plugins;\n      for (key in _ref) {\n        value = _ref[key];\n        if (!(key in config)) {\n          continue;\n        }\n        init = config[key];\n        if (!(init != null) || init.enabled === false) {\n          continue;\n        }\n        def = value[type];\n        if (!(def != null)) {\n          this.facade.logger.debug(\"[AMP] Plugin could not be found: \" + key);\n          continue;\n        }\n        try {\n          plugin = new def();\n          plugin.oninitialized = this.onplugininitialized.bind(this, key);\n          plugin.onerror = this.onpluginerror.bind(this, key);\n          initialize = plugin.initialize.bind(plugin, init, this.facade);\n          this.plugins.push(initialize);\n        } catch (error) {\n          this.logger.error(\"[AMP] Plugin could not be created: \" + key + \". \" + error);\n          continue;\n        }\n      }\n      plugins = config.plugins || {};\n      for (key in plugins) {\n        init = plugins[key];\n        if (!((init != null) && init.enabled !== false)) {\n          continue;\n        }\n        initialize = function(player, config, key, resolve, reject) {\n          return _this.facade.loadResources(config.resources).then(function() {\n            def = AMP.plugins[key][type];\n            if (!(def != null)) {\n              reject(\"[AMP] Plugin could not be found: \" + key);\n            }\n            return def(player, config, key);\n          }).then(resolve)[\"catch\"](reject);\n        };\n        this.plugins.push(initialize.bind(null, this.facade, init, key, this.onpluginregistered.bind(this, key), this.onpluginerror.bind(this, key)));\n      }\n      this.plugins.forEach(function(item) {\n        return item();\n      });\n      break;\n    case PluginNotifications.PLUGIN_REGISTERED:\n      this.onpluginregistered(body.getModuleName(), body);\n  }\n};\n\nPluginAdapter.prototype.initializedCheck = function() {\n  if (this.registered === this.plugins.length) {\n    this.sendNotification(PluginNotifications.PLUGINS_INITIALIZED, this.plugins);\n  }\n};\n\nPluginAdapter.prototype.onplugininitialized = function(key, plugin) {\n  plugin.oninitialized = null;\n  plugin.onerror = null;\n  this.facade.registerModule(plugin);\n};\n\nPluginAdapter.prototype.onpluginerror = function(key, error) {\n  this.registered++;\n  this.facade.logger.error(\"[AMP] Plugin could not be registered: \" + key);\n  this.facade.logger.error(error);\n  this.initializedCheck();\n};\n\nPluginAdapter.prototype.onpluginregistered = function(key, plugin) {\n  var feature;\n  this.registered++;\n  this.facade.logger.debug(\"[AMP] Plugin registered: \" + key);\n  this.facade[key] = plugin;\n  feature = (typeof plugin.getFeatureName === \"function\" ? plugin.getFeatureName() : void 0) || plugin.feature;\n  if (feature != null) {\n    this.facade[feature] = plugin;\n  }\n  this.initializedCheck();\n};\n\n/**\n * The ClassList class.\n * \n * @param {!DOMElement}  element\n *    The DOM Element\n *\n * @constructor\n*/\nfunction ClassList(element) {\n  this.element = element;\n}\n\nClassList.prototype.element = null;\n\nClassList.prototype.prefix = Namespace.PREFIX;\n\n/**\n*/\nClassList.prototype.contains = function(className) {\n  return this.constructor.contains(className, this.element, this.prefix);\n};\n\n/**\n*/\nClassList.prototype.add = function(className) {\n  this.constructor.add(className, this.element, this.prefix);\n};\n\n/**\n*/\nClassList.prototype.remove = function(className) {\n  this.constructor.remove(className, this.element, this.prefix);\n};\n\n/**\n*/\nClassList.prototype.toggle = function(className) {\n  return this.constructor.contains(className, this.element, this.prefix);\n};\n\n/**\n*/\nClassList.contains = function(className, element, prefix) {\n  var css, _ref;\n  if (prefix == null) {\n    prefix = \"\";\n  }\n  css = prefix + className;\n  if (((_ref = element.classList) != null ? _ref.contains : void 0) != null) {\n    return element.classList.contains(css);\n  } else {\n    return element.className.indexOf(css) !== -1;\n  }\n};\n\n/**\n*/\nClassList.add = function(className, element, prefix) {\n  var css, _ref;\n  if (prefix == null) {\n    prefix = \"\";\n  }\n  css = prefix + className;\n  if (((_ref = element.classList) != null ? _ref.add : void 0) != null) {\n    element.classList.add(css);\n  } else {\n    if (!this.contains(className, element)) {\n      if (element.className !== \"\") {\n        element.className += \" \" + css;\n      } else {\n        element.className = css;\n      }\n    }\n  }\n};\n\n/**\n*/\nClassList.remove = function(className, element, prefix) {\n  var css, regexp, _ref;\n  if (prefix == null) {\n    prefix = \"\";\n  }\n  css = prefix + className;\n  if (((_ref = element.classList) != null ? _ref.remove : void 0) != null) {\n    element.classList.remove(css);\n  } else {\n    if (this.contains(className, element)) {\n      regexp = new RegExp(\" ?\" + css);\n      element.className = element.className.replace(regexp, \"\");\n    }\n  }\n};\n\n/**\n*/\nClassList.toggle = function(className, element, prefix) {\n  var css, _ref;\n  if (prefix == null) {\n    prefix = \"\";\n  }\n  css = prefix + className;\n  if (((_ref = element.classList) != null ? _ref.toggle : void 0) != null) {\n    element.classList.toggle(this.prefix + className);\n  } else {\n    if (this.contains(className, element)) {\n      this.remome(className, element);\n    } else {\n      this.add(className, element);\n    }\n  }\n};\n\n/**\n * The LocalizationProxy class. Used to track player localization settings.\n *\n * @constructor\n * @private\n * @extends {DataBindingContext}\n * @param {Object}  init  The configuration object.\n*/\nfunction LocalizationProxy(init) {\n  var key, lang;\n  LocalizationProxy.__super__.constructor.call(this);\n  this.data = {\n    language: navigator.language || navigator.browserLanguage,\n    locales: Config.defaults.locales\n  };\n  if (init != null) {\n    if (init.language != null) {\n      this.data.language = init.language;\n    }\n    if (init.locales != null) {\n      for (lang in init.locales) {\n        if (this.data.locales[lang] != null) {\n          for (key in init.locales[lang]) {\n            this.data.locales[lang][key] = init.locales[lang][key];\n          }\n        } else {\n          this.data.locales[lang] = init.locales[lang];\n        }\n      }\n    }\n  }\n}\n\n\n__extends(LocalizationProxy, DataBindingContext);\n\n\n/** @static\n*/\nLocalizationProxy.NAME = \"LocalizationProxy\";\n\nLocalizationProxy.prototype.contextName = \"l10n\";\n\nLocalizationProxy.prototype.locale = null;\n\nLocalizationProxy.prototype.localeId = null;\n\n/** @override\n*/\nLocalizationProxy.prototype.onRegister = function() {\n  LocalizationProxy.__super__.onRegister.call(this);\n  this.setLocale(this.data.language);\n};\n\n/**\n * Gets the context data for this proxy.\n *\n * @returns {Object} The contenxt data for this proxy\n * @override\n*/\nLocalizationProxy.prototype.getContextData = function() {\n  return this.locale;\n};\n\n/**\n *\n*/\nLocalizationProxy.prototype.getLanguage = function() {\n  return this.data.language;\n};\n\nLocalizationProxy.prototype.setLanguage = function(value) {\n  var _this = this;\n  this.setLocale(value).then(function() {\n    _this.data.language = value;\n    _this.sendNotification(Notifications.LANGUAGE_CHANGE, value);\n  });\n  return value;\n};\n\n/**\n *\n*/\nLocalizationProxy.prototype.setLocale = function(value) {\n  var _this = this;\n  return new Promise(function(resolve, reject) {\n    var complete, locale, localeId;\n    complete = function() {\n      _this.localeId = localeId;\n      _this.locale = _this.facade.l10n = _this.data.locales[localeId];\n      resolve();\n    };\n    localeId = value;\n    locale = _this.data.locales[localeId];\n    if (!(locale != null)) {\n      localeId = value.substring(0, 2);\n      locale = _this.data.locales[localeId];\n    }\n    if (typeof locale === \"string\") {\n      return AMP.addResource({\n        src: _this.facade.evaluatePaths(locale),\n        type: Utils.mimeTypes.json\n      }).then(function(resource) {\n        _this.data.locales[localeId] = resource.data;\n        return complete();\n      });\n    } else {\n      return complete();\n    }\n  });\n};\n\nLocalizationProxy.prototype.getLocaleId = function() {\n  return this.localeId;\n};\n\n/**\n *\n*/\nLocalizationProxy.prototype.getLocales = function() {\n  return this.data.locales;\n};\n\nLocalizationProxy.prototype.setLocales = function(value) {\n  this.data.locales = value;\n  return value;\n};\n\n/**\n *\n*/\nLocalizationProxy.prototype.getString = function(key, context) {\n  var locale, str;\n  try {\n    locale = this.locale || this.data.locales.en;\n    str = locale[key] || key;\n    if (context != null) {\n      str = DataBinding.evaluateBindings(str, context);\n    }\n    return str;\n  } catch (error) {\n    return \"\";\n  }\n};\n\n/**\n * Retrieves the full language name in the player's current language setting.\n *\n * @param   {string}  lang  The language code.\n * @return  {string}        The full name of the language according to the player's current language setting.\n*/\nLocalizationProxy.prototype.getLanguageString = function(lang) {\n  var key, str;\n  if (typeof lang !== \"string\" || !(lang != null) || lang === \"\") {\n    return \"\";\n  }\n  key = \"MSG_\" + (lang.toUpperCase());\n  str = this.getString(key);\n  if (str === \"\") {\n    lang = lang.split(\"-\").shift();\n    key = \"MSG_\" + (lang.toUpperCase());\n    str = this.getString(key);\n  }\n  return str;\n};\n\nfunction UI() {}\n\n/**\n * Creates an HTML element.\n *\n * @param   {?(string|Array.<string>)}  type\n * @param   {?DOMElement}  parent\n * @param   {?string|DOMElement}  element\n * @param   {?string} text\n * @return  {DOMElement}\n*/\nUI.create = function(type, parent, element, text) {\n  var classList, item, viewComponent, _i, _len;\n  if (element == null) {\n    element = \"div\";\n  }\n  if (typeof element === \"string\") {\n    element = document.createElement(element);\n  }\n  classList = new ClassList(element);\n  if (type != null) {\n    if (typeof type === \"string\") {\n      type = [type];\n    }\n    for (_i = 0, _len = type.length; _i < _len; _i++) {\n      item = type[_i];\n      classList.add(item);\n    }\n  }\n  element._classList = classList;\n  if (text != null) {\n    if (element.innerText != null) {\n      element.innerText = text;\n    } else {\n      element.textContent = text;\n    }\n  }\n  if (parent != null) {\n    if (parent.getViewComponent != null) {\n      viewComponent = parent.getViewComponent();\n    }\n    if (viewComponent != null) {\n      parent = viewComponent;\n    }\n    parent.appendChild(element);\n  }\n  return element;\n};\n\n/**\n * Binds a mediators event handlers to an element.\n *\n * @param {!DOMElement} element\n * @param {!mediator} mediator\n*/\nUI.bindEvents = function(element, handlers, exceptions) {\n  var key, value;\n  if (exceptions == null) {\n    exceptions = [\"onRemove\", \"onRegister\"];\n  }\n  for (key in handlers) {\n    value = handlers[key];\n    if (!(__indexOf.call(exceptions, key) >= 0) && /^on/.test(key) && ((value != null ? value.bind : void 0) != null)) {\n      element[key] = value.bind(handlers);\n    }\n  }\n};\n\n/**\n * The ExternalPlayCommand class.\n * \n * @constructor\n * @private\n * @extends {puremvc.MacroCommand}\n*/\nfunction ExternalPlayCommand() {\n  ExternalPlayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ExternalPlayCommand, PlayerEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nExternalPlayCommand.prototype.execute = function(notification) {\n  this.sendNotification(Notifications.PLAY_REQUEST);\n  this.playback.play();\n  ExternalPlayCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The ExternalPlayer class.\n *\n * @constructor\n * @private\n * @extends {Player}\n * @param {Object} config\n * @param {Object} viewComponent\n * @param {EventDispatcher} dispatcher\n*/\nfunction ExternalPlayer(config, viewComponent, dispatcher) {\n  ExternalPlayer.__super__.constructor.call(this, config, viewComponent, dispatcher);\n}\n\n\n__extends(ExternalPlayer, Player);\n\n\nExternalPlayer.prototype.playerType = \"external\";\n\n/** @override\n*/\nExternalPlayer.prototype.createModel = function() {\n  var playbackProxy;\n  ExternalPlayer.__super__.createModel.call(this);\n  this.registerProxy(new LocalizationProxy(this.config));\n  playbackProxy = new ExternalPlaybackProxy();\n  this.registerProxy(playbackProxy);\n  this.playerCore = new PlayerProxy(playbackProxy);\n  this.registerProxy(this.playerCore);\n  this.bindings.initialize();\n};\n\n/** @override\n*/\nExternalPlayer.prototype.createView = function() {\n  var overlay,\n    _this = this;\n  this.registerMediator(new PlayerMediator(\"external\", this.getViewComponent()));\n  this.registerMediator(new PluginAdapter());\n  overlay = new OverlayLayerMediator();\n  this.registerMediator(overlay);\n  EventHandler.create(overlay.viewComponent, EventHandler.CLICK, function() {\n    return _this.sendNotification(Notifications.TOGGLE_ACTIVE);\n  });\n};\n\n/** @override\n*/\nExternalPlayer.prototype.createController = function() {\n  ExternalPlayer.__super__.createController.call(this);\n  this.registerCommand(Notifications.UPDATE_DATA_BINDINGS, UpdateDataBindingsCommand);\n  this.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, ExternalPlayCommand);\n  this.registerCommand(Notifications.PLAY, ExternalPlayCommand);\n  this.registerCommand(Notifications.CHANGE_PLAY_STATE, ChangePlayStateCommand);\n  this.registerCommand(Notifications.SET_MEDIA, SetMediaCommand);\n  this.registerCommand(Notifications.CHANGE_MEDIA, ChangeMediaCommand);\n  this.registerCommand(Notifications.MEDIA_CHANGE, MediaChangeCommand);\n  this.registerCommand(Notifications.MEDIA_VALIDATED, MediaValidatedCommand);\n  this.registerCommand(Notifications.ERROR, ErrorCommand);\n  this.registerCommand(PluginNotifications.PLUGINS_INITIALIZED, PluginsInitializedCommand);\n  this.registerCommand(Notifications.READY, ReadyCommand);\n  this.registerCommand(Notifications.CHANGE_PARAMS, ChangeParamsCommand);\n};\n\n/** @override\n*/\nExternalPlayer.prototype.createMediaElement = function() {\n  return document.createElement(\"div\");\n};\n\nExternalPlayer.prototype.canPlayType = function(mimeType) {\n  return \"maybe\";\n};\n\nExternalPlayer.prototype.play = function() {\n  this.sendNotification(Notifications.PLAY);\n};\n\nExternalPlayer.prototype.setParams = function(value) {\n  this.sendNotification(Notifications.CHANGE_PARAMS, value);\n  return value;\n};\n\nExternalPlayer.prototype.getParams = function() {\n  return this.retrieveProxy(ParamsProxy.NAME).getData();\n};\n\nExternalPlayer.prototype.setAutoplay = function(value) {\n  return false;\n};\n\nExternalPlayer.prototype.getAutoplay = function() {\n  return false;\n};\n\nExternalPlayer.prototype.setLoop = function(value) {\n  return false;\n};\n\nExternalPlayer.prototype.getLoop = function() {\n  return false;\n};\n\nExternalPlayer.prototype.setMuted = function(value) {\n  return false;\n};\n\nExternalPlayer.prototype.getMuted = function() {\n  return false;\n};\n\nExternalPlayer.prototype.setMedia = function(value) {\n  this.sendNotification(Notifications.SET_MEDIA, value);\n  return value;\n};\n\nExternalPlayer.prototype.getMedia = function(value) {\n  var _ref;\n  return (_ref = this.retrieveProxy(MediaProxy.NAME)) != null ? _ref.getData() : void 0;\n};\n\nExternalPlayer.prototype.setCurrentTime = function(value) {\n  return 0;\n};\n\nExternalPlayer.prototype.getCurrentTime = function(value) {\n  return 0;\n};\n\nExternalPlayer.prototype.getDuration = function(value) {\n  return this.retrieveProxy(MediaProxy.NAME).getDuration();\n};\n\nExternalPlayer.prototype.setSrc = function(value) {\n  this.sendNotification(Notifications.SET_MEDIA, {\n    src: value\n  });\n  return value;\n};\n\nExternalPlayer.prototype.getSrc = function(value) {\n  return this.retrieveProxy(MediaProxy.NAME).getSrc();\n};\n\nExternalPlayer.prototype.setSource = function(value) {\n  this.sendNotification(Notifications.SET_MEDIA, {\n    source: value\n  });\n  return value;\n};\n\nExternalPlayer.prototype.getSource = function() {\n  return this.retrieveProxy(MediaProxy.NAME).getSource();\n};\n\nExternalPlayer.prototype.setVolume = function(value) {\n  return value;\n};\n\nExternalPlayer.prototype.getVolume = function(value) {\n  return 1;\n};\n\nExternalPlayer.prototype.getSeeking = function() {\n  return false;\n};\n\nExternalPlayer.prototype.getPaused = function() {\n  return false;\n};\n\nExternalPlayer.prototype.getEnded = function() {\n  return false;\n};\n\n/**\n * Event constructor.\n *\n * @param {!string}  type  A string representing the event's type.\n * @param {Object=} detail  Data to pass along with the event.\n * @constructor\n * @private\n*/\nfunction Event(type, detail) {\n  this.type = type;\n  if (detail != null) {\n    this.detail = this.data = detail;\n  }\n}\n\n/**\n * The event's type.\n * \n * @type {string}\n*/\nEvent.prototype.type = null;\n\n/**\n * The event's target\n * \n * @type {Object}\n*/\nEvent.prototype.target = null;\n\n/**\n * Collection of event specific details.\n * \n * @type {Object}\n*/\nEvent.prototype.detail = null;\n\nfunction Logger(enabled) {\n  this.enabled = enabled;\n  if (!this.enabled) {\n    this.log = this.trace = this.debug = this.info = this.warn = this.error = this.fatal = function() {};\n  }\n}\n\nLogger.prototype.log = function() {\n  try {\n    if (arguments.length > 1 && (arguments[1] != null)) {\n      console.log.apply(console, arguments);\n    } else {\n      console.log(arguments[0]);\n    }\n  } catch (error) {\n\n  }\n};\n\nLogger.prototype.trace = function() {\n  try {\n    console.trace.apply(console, arguments);\n  } catch (error) {\n\n  }\n};\n\nLogger.prototype.debug = function() {\n  try {\n    console.log.apply(console, arguments);\n  } catch (error) {\n    this.log.apply(this, arguments);\n  }\n};\n\nLogger.prototype.info = function() {\n  try {\n    console.info.apply(console, arguments);\n  } catch (error) {\n\n  }\n};\n\nLogger.prototype.warn = function() {\n  try {\n    console.warn.apply(console, arguments);\n  } catch (error) {\n\n  }\n};\n\nLogger.prototype.error = function() {\n  try {\n    console.error.apply(console, arguments);\n  } catch (error) {\n    this.log.apply(this, arguments);\n  }\n};\n\nLogger.prototype.fatal = function() {\n  try {\n    console.fatal.apply(console, arguments);\n  } catch (error) {\n\n  }\n};\n\n/**\n * Poller class\n *\n * @constructor\n * @private\n * @extends {EventDispatcher}\n * @param {string} url\n * @param {number} interval\n * @param {string} type\n * @param {Object} headers\n*/\nfunction Poller(url, interval, type, headers) {\n  this.url = url;\n  this.interval = interval != null ? interval : 10000;\n  this.type = type != null ? type : null;\n  this.headers = headers != null ? headers : null;\n  Poller.__super__.constructor.call(this);\n}\n\n\n__extends(Poller, EventDispatcher);\n\n\nPoller.prototype.timeout = null;\n\nPoller.prototype.interval = null;\n\nPoller.prototype.url = null;\n\nPoller.prototype.lastModified = null;\n\nPoller.prototype.contentLenght = null;\n\nPoller.prototype.data = null;\n\nPoller.prototype.text = null;\n\nPoller.prototype.type = null;\n\nPoller.prototype.headers = null;\n\nPoller.prototype.useHeadRequest = true;\n\nPoller.prototype.xhr = null;\n\n/**\n*/\nPoller.prototype.start = function() {\n  if ((this.url != null) && this.url !== \"\") {\n    this.poll();\n  }\n};\n\n/**\n*/\nPoller.prototype.poll = function() {\n  var xhr,\n    _this = this;\n  xhr = Utils.getXHR();\n  if (!this.useHeadRequest) {\n    this.updateData();\n  } else {\n    xhr.onload = function(event) {\n      var contentLength, lastModified;\n      if (xhr.status === 304) {\n        _this.invoke();\n        return;\n      }\n      lastModified = xhr.getResponseHeader(\"Last-Modified\");\n      contentLength = xhr.getResponseHeader(\"Content-Length\");\n      if ((!(lastModified != null) && !(contentLength != null)) || ((lastModified != null) && lastModified !== _this.lastModified) || ((contentLength != null) && contentLength !== _this.contentLength)) {\n        _this.lastModified = lastModified;\n        _this.contentLength = contentLength;\n        _this.updateData();\n      } else {\n        _this.invoke();\n      }\n    };\n    xhr.onerror = function(event) {\n      _this.error(event);\n    };\n    xhr.open(\"HEAD\", Utils.cacheBust(this.url), false);\n    this.applyHeaders();\n    if (this.lastModified != null) {\n      xhr.setRequestHeader(\"If-Modified-Since\", this.lastModified);\n    }\n    xhr.send();\n  }\n};\n\n/**\n*/\nPoller.prototype.applyHeaders = function() {\n  if (!(this.headers != null)) {\n    return;\n  }\n  this.xhr.setRequestHeaders(this.headers);\n};\n\n/**\n*/\nPoller.prototype.updateData = function() {\n  var xhr,\n    _this = this;\n  xhr = Utils.getXHR();\n  xhr.open(\"GET\", Utils.cacheBust(this.url), true);\n  xhr.onload = function(event) {\n    var text;\n    text = xhr.responseText;\n    _this.setText(text);\n    _this.invoke();\n  };\n  xhr.onerror = function(event) {\n    _this.error(event);\n  };\n  this.applyHeaders();\n  return xhr.send();\n};\n\n/**\n*/\nPoller.prototype.setText = function(value) {\n  var data;\n  if (value !== this.text) {\n    this.text = value;\n    data = this.text;\n    if (this.type === Utils.mimeTypes.json) {\n      try {\n        data = this.xhr.response;\n      } catch (error) {\n        data = this.text;\n      }\n    }\n    this.setData(data);\n  }\n  return value;\n};\n\n/**\n*/\nPoller.prototype.setData = function(value) {\n  if (value !== this.data) {\n    this.data = value;\n    this.dispatchEvent(new Event(\"datachange\", this.data));\n  }\n  return value;\n};\n\n/**\n*/\nPoller.prototype.error = function(error) {\n  Logger.error(event);\n  this.stop();\n};\n\n/**\n*/\nPoller.prototype.invoke = function() {\n  var _this = this;\n  this.stop();\n  this.timeout = setTimeout(function() {\n    _this.poll();\n  }, this.interval);\n};\n\n/**\n*/\nPoller.prototype.stop = function() {\n  clearTimeout(this.timeout);\n};\n\nfunction IdleUtil(element, timeout) {\n  this.element = element;\n  this.timeout = timeout;\n  IdleUtil.__super__.constructor.call(this);\n  this.resetHandler = this.reset.bind(this);\n}\n\n\n__extends(IdleUtil, EventDispatcher);\n\n\nIdleUtil.prototype.events = [\"mousemove\", \"mousedown\", \"keypress\", \"DOMMouseScroll\", \"mousewheel\", \"touchmove\", \"MSPointerMove\"];\n\nIdleUtil.prototype.resetHandler = null;\n\nIdleUtil.prototype.element = null;\n\nIdleUtil.prototype.timeout = null;\n\nIdleUtil.prototype.active = true;\n\nIdleUtil.prototype.timeoutId = null;\n\nIdleUtil.prototype.applyListeners = function(action) {\n  var event, _i, _len, _ref;\n  if (action == null) {\n    action = \"add\";\n  }\n  _ref = this.events;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    event = _ref[_i];\n    this.element[\"\" + action + \"EventListener\"](event, this.resetHandler);\n  }\n};\n\nIdleUtil.prototype.start = function(timeout) {\n  if (timeout != null) {\n    this.timeout = timeout;\n  }\n  this.stop();\n  this.applyListeners(\"add\");\n  this.timeoutId = setTimeout(this.setActive.bind(this, false), this.timeout);\n};\n\nIdleUtil.prototype.stop = function() {\n  this.applyListeners(\"remove\");\n  clearTimeout(this.timeoutId);\n};\n\nIdleUtil.prototype.reset = function() {\n  this.setActive(true);\n  this.start();\n};\n\nIdleUtil.prototype.setActive = function(value) {\n  if (value === this.active) {\n    return;\n  }\n  this.active = value;\n  this.dispatchEvent(new Event(\"activechange\", {\n    active: this.active\n  }));\n  return value;\n};\n\nIdleUtil.prototype.getActive = function() {\n  return this.active;\n};\n\nfunction FeedVO() {\n  this.item = [];\n  this.metadata = {};\n}\n\nFeedVO.prototype.title = null;\n\nFeedVO.prototype.link = null;\n\nFeedVO.prototype.description = null;\n\nFeedVO.prototype.category = null;\n\nFeedVO.prototype.pubDate = null;\n\nFeedVO.prototype.language = null;\n\nFeedVO.prototype.ttl = null;\n\nFeedVO.prototype.item = null;\n\nFeedVO.prototype.metadata = null;\n\nfunction Resource() {\n  this.metadata = {};\n}\n\n/**\n * The resource url.\n *\n * @type {String}\n*/\nResource.prototype.src = null;\n\n/**\n * The resource url to use in debug mode.\n *\n * @type {String}\n*/\nResource.prototype.debug = null;\n\n/**\n * The mime type.\n *\n * @type {String}\n*/\nResource.prototype.type = null;\n\n/**\n * @type {Object}\n*/\nResource.prototype.metadata = null;\n\n/**\n * @enum {string}\n * @const\n*/\n\nvar PlaybackMode = {\n  /**\n   *\n  */\n\n  AUTO: \"auto\",\n  /**\n   *\n  */\n\n  HTML: \"html\",\n  /**\n   *\n  */\n\n  FLASH: \"flash\",\n  /**\n   *\n  */\n\n  EXTERNAL: \"external\",\n  /**\n   *\n  */\n\n  NONE: \"none\",\n  /**\n   *\n  */\n\n  HTML_AUTO: \"html-auto\"\n};\n\nfunction MediaVO() {\n  return MediaVO.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(MediaVO, Resource);\n\n\nMediaVO.prototype.source = null;\n\nMediaVO.prototype.title = null;\n\nMediaVO.prototype.description = null;\n\nMediaVO.prototype.link = null;\n\nMediaVO.prototype.guid = null;\n\nMediaVO.prototype.pubDate = null;\n\nMediaVO.prototype.poster = null;\n\nMediaVO.prototype.thumbnail = null;\n\nMediaVO.prototype.embed = null;\n\nMediaVO.prototype.category = null;\n\nMediaVO.prototype.type = null;\n\nMediaVO.prototype.medium = null;\n\nMediaVO.prototype.duration = null;\n\nMediaVO.prototype.track = null;\n\nMediaVO.prototype.metadata = null;\n\nMediaVO.prototype.scenes = null;\n\nMediaVO.prototype.startTime = null;\n\nfunction ID3() {}\n\n/**\n*/\nID3.getID3 = function(id3Data) {\n  var frame, frameData, offset;\n  offset = 10;\n  frameData = this.getFrameData(id3Data.subarray(offset));\n  frame = this.decodeFrame(frameData);\n  return frame;\n};\n\n/**\n*/\nID3.getFrameData = function(data) {\n  var offset, size, type;\n  type = String.fromCharCode(data[0], data[1], data[2], data[3]);\n  size = this.readSize(data, 4);\n  offset = 10;\n  return {\n    type: type,\n    size: size,\n    data: data.subarray(offset, offset + size)\n  };\n};\n\n/**\n*/\nID3.readSize = function(data, offset) {\n  var size;\n  size = 0;\n  size = (data[offset] & 0x7f) << 21;\n  size |= (data[offset + 1] & 0x7f) << 14;\n  size |= (data[offset + 2] & 0x7f) << 7;\n  size |= data[offset + 3] & 0x7f;\n  return size;\n};\n\n/**\n*/\nID3.decodeFrame = function(frame) {\n  if (frame.type === 'PRIV') {\n    return this.decodePrivFrame(frame);\n  } else if (frame.type[0] === 'T') {\n    return this.decodeTextFrame(frame);\n  } else if (frame.type[0] === 'W') {\n    return this.decodeURLFrame(frame);\n  } else {\n    return this.decodeTextFrame(frame);\n  }\n};\n\n/**\n*/\nID3.decodePrivFrame = function(frame) {\n  var owner, privateData;\n  if (frame.size < 2) {\n    return;\n  }\n  owner = this.utf8ArrayToStr(frame.data, true);\n  privateData = new Uint8Array(frame.data.subarray(owner.length + 1));\n  return {\n    key: frame.type,\n    info: owner,\n    data: privateData.buffer\n  };\n};\n\n/**\n*/\nID3.decodeTextFrame = function(frame) {\n  var description, index, text, value;\n  if (frame.size < 2) {\n    return;\n  }\n  if (frame.type === 'TXXX') {\n    index = 1;\n    description = this.utf8ArrayToStr(frame.data.subarray(index));\n    index += description.length + 1;\n    value = this.utf8ArrayToStr(frame.data.subarray(index));\n    return {\n      key: frame.type,\n      info: description,\n      data: value\n    };\n  } else {\n    text = this.utf8ArrayToStr(frame.data.subarray(1));\n    return {\n      key: frame.type,\n      info: text,\n      data: text\n    };\n  }\n};\n\n/**\n*/\nID3.decodeURLFrame = function(frame) {\n  var description, index, url, value;\n  if (frame.type === 'WXXX') {\n    if (frame.size < 2) {\n      return;\n    }\n    index = 1;\n    description = this.utf8ArrayToStr(frame.data.subarray(index));\n    index += description.length + 1;\n    value = this.utf8ArrayToStr(frame.data.subarray(index));\n    return {\n      key: frame.type,\n      info: description,\n      data: value\n    };\n  } else {\n    url = this.utf8ArrayToStr(frame.data);\n    return {\n      key: frame.type,\n      info: url,\n      data: url\n    };\n  }\n};\n\n/**\n*/\nID3.utf8ArrayToStr = function(array, exitOnNull) {\n  var c, char2, char3, i, len, out;\n  if (exitOnNull == null) {\n    exitOnNull = false;\n  }\n  len = array.length;\n  out = '';\n  i = 0;\n  while (i < len) {\n    c = array[i++];\n    if (c === 0x00 && exitOnNull) {\n      return out;\n    } else if (c === 0x00 || c === 0x03) {\n      continue;\n    }\n    switch (c >> 4) {\n      case 0:\n      case 1:\n      case 2:\n      case 3:\n      case 4:\n      case 5:\n      case 6:\n      case 7:\n        out += String.fromCharCode(c);\n        break;\n      case 12:\n      case 13:\n        char2 = array[i++];\n        out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F));\n        break;\n      case 14:\n        char2 = array[i++];\n        char3 = array[i++];\n        out += String.fromCharCode(((c & 0x0F) << 12) | ((char2 & 0x3F) << 6) | ((char3 & 0x3F) << 0));\n    }\n  }\n  return out;\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction MRSSHelper() {}\n\n/**\n*/\nMRSSHelper.prototype.getFeed = function(url) {\n  return Utils.getFeed(url);\n};\n\n/**\n*/\nMRSSHelper.prototype.getMediaNode = function(item, name, checkItem) {\n  var base, mediaContent, mediaName, node;\n  if (checkItem == null) {\n    checkItem = true;\n  }\n  mediaName = \"media-\" + name;\n  base = item['media-group'] || item;\n  mediaContent = base['media-content'];\n  if ((mediaContent != null) && (mediaContent[mediaName] != null)) {\n    node = mediaContent[mediaName];\n  } else if (base[mediaName] != null) {\n    node = base[mediaName];\n  } else if (item[mediaName] != null) {\n    node = item[mediaName];\n  } else if ((item[name] != null) && checkItem) {\n    node = item[name];\n  }\n  return node;\n};\n\nMRSSHelper.prototype.createEmbed = function(item) {\n  var embed, embedVO, param, _i, _len, _ref;\n  try {\n    embed = this.getMediaNode(item, \"embed\");\n    if (!(embed != null)) {\n      return embedVO;\n    }\n    embedVO = {};\n    embedVO.url = embed[\"@attributes\"].url;\n    embedVO.width = embed[\"@attributes\"].width;\n    embedVO.height = embed[\"@attributes\"].height;\n    embedVO.params = {};\n    if (!(embed[\"media-param\"] instanceof Array)) {\n      embed[\"media-param\"] = [embed[\"media-param\"]];\n    }\n    _ref = embed[\"media-param\"];\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      param = _ref[_i];\n      embedVO.params[param[\"@attributes\"].name] = param[\"#text\"];\n    }\n  } catch (error) {\n    Logger.error(\"[AMP Feed Parse Error] embed parse error: \" + error.message, error);\n  }\n  return embedVO;\n};\n\n/**\n*/\nMRSSHelper.prototype.createFeed = function(json) {\n  var channel, feedVO, item, items, key, mediaVO, value, _i, _len;\n  try {\n    channel = json.channel;\n    feedVO = new FeedVO();\n    if (channel != null) {\n      feedVO.title = channel.title;\n      feedVO.description = channel.description;\n      feedVO.language = channel.language;\n      feedVO.category = channel.category;\n      feedVO.pubDate = new Date(Date.parse(channel.pubDate));\n      feedVO.ttl = channel.ttl;\n      items = channel.item instanceof Array ? channel.item : [channel.item];\n      for (_i = 0, _len = items.length; _i < _len; _i++) {\n        item = items[_i];\n        mediaVO = this.createMedia(item);\n        feedVO.item.push(mediaVO);\n      }\n      for (key in channel) {\n        value = channel[key];\n        if (!(key in feedVO)) {\n          feedVO.metadata[key] = value;\n        }\n      }\n    }\n  } catch (error) {\n    Logger.error(\"[AMP Feed Parse Error] feed parse error: \" + error.message, error);\n  }\n  return feedVO;\n};\n\n/**\n*/\nMRSSHelper.prototype.createMedia = function(item) {\n  var atts, category, content, key, label, mediaContent, mediaVO, node, restriction, source, track, value, _i, _j, _k, _l, _len, _len1, _len2, _len3, _ref, _ref1, _ref2;\n  try {\n    mediaVO = new MediaVO();\n    mediaContent = this.getMediaNode(item, 'content');\n    if (mediaContent instanceof Array) {\n      mediaVO.source = [];\n      for (_i = 0, _len = mediaContent.length; _i < _len; _i++) {\n        content = mediaContent[_i];\n        source = {\n          src: content['@attributes'].url,\n          type: content['@attributes'].type\n        };\n        category = content[\"media-category\"];\n        if (category != null) {\n          atts = category[\"@attributes\"];\n          if (atts.schema === \"http://mrss.akamai.com/user_agent_hint\") {\n            label = atts.label || category[\"#text\"];\n            if ((label != null) && label !== \"\") {\n              if (source.rules == null) {\n                source.rules = [];\n              }\n              source.rules.push(label);\n            }\n          }\n        }\n        mediaVO.source.push(source);\n        mediaVO.medium = content['@attributes'].medium;\n        mediaVO.duration = parseFloat(content['@attributes'].duration);\n      }\n    } else {\n      mediaVO.type = mediaContent['@attributes'].type;\n      mediaVO.src = mediaContent['@attributes'].url;\n      mediaVO.medium = mediaContent['@attributes'].medium;\n      mediaVO.duration = parseFloat(mediaContent['@attributes'].duration);\n    }\n    mediaVO.guid = item.guid;\n    mediaVO.title = this.getMediaNode(item, \"title\");\n    mediaVO.link = item.link;\n    mediaVO.description = this.getMediaNode(item, \"description\");\n    mediaVO.pubDate = new Date(Date.parse(item.pubDate));\n    mediaVO.thumbnail = mediaVO.poster = (_ref = this.getMediaNode(item, 'thumbnail')) != null ? (_ref1 = _ref['@attributes']) != null ? _ref1.url : void 0 : void 0;\n    mediaVO.embed = this.createEmbed(item);\n    mediaVO.scenes = (_ref2 = this.getMediaNode(item, \"scenes\")) != null ? _ref2['media-scene'] : void 0;\n    node = this.getMediaNode(item, \"status\", false);\n    if (node != null) {\n      mediaVO.status = {\n        state: node['@attributes'].state,\n        reason: node['@attributes'].reason\n      };\n    }\n    node = this.getMediaNode(item, \"restriction\", false);\n    if (node != null) {\n      if (!(node instanceof Array)) {\n        node = [node];\n      }\n      mediaVO.restriction = [];\n      for (_j = 0, _len1 = node.length; _j < _len1; _j++) {\n        restriction = node[_j];\n        mediaVO.restriction.push({\n          relationship: restriction[\"@attributes\"].relationship,\n          type: restriction[\"@attributes\"].type,\n          value: restriction[\"#text\"].split(\" \")\n        });\n      }\n    }\n    mediaVO.category = item.category;\n    if (!(mediaVO.category instanceof Array)) {\n      mediaVO.category = [mediaVO.category];\n    }\n    node = this.getMediaNode(item, \"category\", false);\n    if (node != null) {\n      for (_k = 0, _len2 = node.length; _k < _len2; _k++) {\n        category = node[_k];\n        if ((category[\"#text\"] != null) && category[\"#text\"] !== \"\") {\n          mediaVO.category.push(category[\"#text\"]);\n        }\n      }\n    }\n    if (mediaVO.category != null) {\n      mediaVO.category.sort(function(a, b) {\n        a = a.toLowerCase();\n        b = b.toLowerCase();\n        if (a > b) {\n          return 1;\n        } else if (a < b) {\n          return -1;\n        } else {\n          return 0;\n        }\n      });\n    }\n    node = this.getMediaNode(item, \"subTitle\");\n    if (node != null) {\n      if (mediaVO.track == null) {\n        mediaVO.track = [];\n      }\n      if (!(node instanceof Array)) {\n        node = [node];\n      }\n      for (_l = 0, _len3 = node.length; _l < _len3; _l++) {\n        track = node[_l];\n        if (track[\"@attributes\"] != null) {\n          mediaVO.track.push({\n            src: track[\"@attributes\"].href,\n            type: track[\"@attributes\"].type,\n            kind: \"captions\",\n            srclang: track[\"@attributes\"].lang || \"en\"\n          });\n        }\n      }\n    }\n    category = item.category;\n    if (!(category instanceof Array)) {\n      category = [category];\n    }\n    mediaVO.isLive = item.temporalType === \"live\" || ((category != null) && category.join(\",\").indexOf(\"live_stream\") !== -1);\n    mediaVO.temporalType = mediaVO.isLive ? \"live\" : item.temporalType || \"vod\";\n    for (key in item) {\n      value = item[key];\n      if (!(key in mediaVO)) {\n        mediaVO.metadata[key] = value;\n      }\n    }\n  } catch (error) {\n    Logger.error(\"[AMP Feed Parse Error] media parse error: \" + error.message, error);\n  }\n  return mediaVO;\n};\n\nfunction Cookies() {}\n\nCookies.setCookie = function(name, value, days, path, domain) {\n  var expires;\n  value = escape(value);\n  if (days != null) {\n    expires = new Date();\n    expires.setDate(expires.getDate() + days);\n    value += \"; expires=\" + expires.toUTCString();\n  }\n  if (domain != null) {\n    value += \"; domain=\" + domain;\n  }\n  if (path != null) {\n    value += \"; path=\" + path;\n  }\n  return document.cookie = name + \"=\" + value;\n};\n\nCookies.getCookie = function(name) {\n  var cookie, cookies, index, key, value, _i, _len;\n  cookies = document.cookie.split(\";\");\n  for (_i = 0, _len = cookies.length; _i < _len; _i++) {\n    cookie = cookies[_i];\n    index = cookie.indexOf(\"=\");\n    key = cookie.substr(0, index).replace(/^\\s+|\\s+$/g, \"\");\n    value = unescape(cookie.substr(index + 1));\n    if (key === name) {\n      return value;\n    }\n  }\n};\n\nCookies.deleteCookie = function(name) {\n  return this.setCookie(name, \"\", -1);\n};\n\n/**\n * @constructor\n * @private\n * @extends {EventDispatcher}\n*/\nfunction XHR() {\n  XHR.__super__.constructor.call(this);\n}\n\n\n__extends(XHR, EventDispatcher);\n\n\nXHR.prototype.xhr = null;\n\nXHR.prototype.headers = null;\n\nXHR.prototype.response = null;\n\nXHR.prototype.responseXML = null;\n\nXHR.prototype.responseText = null;\n\nXHR.prototype.responseType = null;\n\nXHR.prototype.withCredentials = false;\n\nXHR.prototype.readyState = 0;\n\nXHR.prototype.status = null;\n\nXHR.prototype.open = function(method, url) {\n  var xdr, xhr,\n    _this = this;\n  try {\n    xhr = new XMLHttpRequest();\n  } catch (error) {\n    xhr = new window.ActiveXObject(\"Microsoft.XMLHTTP\");\n  }\n  if (XHR.isCORS(url)) {\n    if (Object.prototype.hasOwnProperty.call(xhr, \"withCredentials\")) {\n      try {\n        xhr.withCredentials = this.withCredentials;\n      } catch (error) {\n        Logger.warn(\"[AMP XHR WARNING]\", \"withCredentials not properly supported in this browser.\", error);\n      }\n    } else if (typeof XDomainRequest !== \"undefined\") {\n      xdr = true;\n      xhr = new XDomainRequest();\n    }\n  }\n  if (xhr != null) {\n    if (xdr) {\n      xhr.onprogress = function() {};\n      xhr.ontimeout = function() {};\n      xhr.onerror = function() {};\n      xhr.onload = function(event) {\n        if (typeof xhr.onreadystatechange === 'function') {\n          xhr.readyState = 4;\n          xhr.status = 200;\n          if (xhr.contentType.match(/\\/xml/)) {\n            xhr.responseXML = new ActiveXObject('Microsoft.XMLDOM');\n            xhr.responseXML.async = false;\n            xhr.responseXML.loadXML(xhr.responseText);\n          }\n          xhr.onreadystatechange.call(xhr, event, false);\n        }\n      };\n    }\n    xhr.onreadystatechange = function(event) {\n      var _ref, _ref1;\n      _this.readyState = xhr.readyState;\n      _this.dispatchEvent(new Event(\"readystatechange\", xhr));\n      if (xhr.readyState === 4) {\n        _this.status = xhr.status;\n        if ((199 < (_ref = _this.status) && _ref < 400) || _this.status === 0) {\n          if (xhr.responseText == null) {\n            xhr.responseText = xhr.text;\n          }\n          _this.responseText = xhr.responseText;\n          if ((xhr.responseXML != null) && ((_ref1 = xhr.responseXML.childNodes) != null ? _ref1.length : void 0) > 0) {\n            _this.response = _this.responseXML = xhr.responseXML;\n            _this.responseType = \"document\";\n          } else {\n            try {\n              _this.response = JSON.parse(xhr.responseText);\n              _this.responseType = \"json\";\n            } catch (error) {\n              _this.response = xhr.responseText;\n              _this.responseType = \"text\";\n            }\n          }\n          _this.dispatchEvent(new Event(\"load\", _this));\n        } else {\n          if (_this.status !== 0) {\n            _this.dispatchEvent(new Event(\"error\", _this));\n          }\n        }\n      }\n    };\n    try {\n      if (typeof xhr.onerror !== \"undefined\") {\n        xhr.onerror = function(event) {\n          _this.dispatchEvent(new Event(\"error\", _this));\n        };\n      }\n    } catch (error) {\n\n    }\n    xhr.open(method, url);\n  }\n  this.xhr = xhr;\n};\n\nXHR.prototype.send = function(data) {\n  var key, value, _ref,\n    _this = this;\n  if (this.headers != null) {\n    _ref = this.headers;\n    for (key in _ref) {\n      value = _ref[key];\n      if ((key != null) && (value != null)) {\n        this.xhr.setRequestHeader(key, value);\n      }\n    }\n  }\n  setTimeout(function() {\n    _this.xhr.send(data);\n  }, 0);\n};\n\nXHR.prototype.setRequestHeader = function(key, value) {\n  if (!(key != null) || !(value != null)) {\n    return;\n  }\n  if (this.headers == null) {\n    this.headers = {};\n  }\n  this.headers[key] = value;\n};\n\nXHR.prototype.setRequestHeaders = function(headers) {\n  this.headers = headers;\n  return headers;\n};\n\nXHR.prototype.getResponseHeader = function(name) {\n  var _ref;\n  return (_ref = this.xhr) != null ? typeof _ref.getResponseHeader === \"function\" ? _ref.getResponseHeader(name) : void 0 : void 0;\n};\n\nXHR.prototype.getAllResponseHeaders = function() {\n  var _ref;\n  return (_ref = this.xhr) != null ? typeof _ref.getAllResponseHeaders === \"function\" ? _ref.getAllResponseHeaders() : void 0 : void 0;\n};\n\nXHR.isCORS = function(url) {\n  var hostname, parser, port, protocol;\n  parser = document.createElement('a');\n  parser.href = url;\n  hostname = parser.hostname !== \"\" ? parser.hostname : location.hostname;\n  port = parser.port !== \"0\" ? parser.port : location.port;\n  protocol = parser.protocol !== \":\" ? parser.protocol : location.protocol;\n  return location.protocol !== protocol || location.hostname !== hostname || location.port !== port && !(location.port === \"\" && port === \"80\");\n};\n\n/**\n * Constructs a new Timer object with the specified delay and repeatCount states.\n*/\nfunction Timer(delay, repeatCount) {\n  var _this = this;\n  this.delay = delay;\n  this.repeatCount = repeatCount != null ? repeatCount : 0;\n  Timer.__super__.constructor.call(this);\n  this._running = false;\n  this._currentCount = 0;\n  this._timeout = null;\n  this._startTime = null;\n  this._currentTime = 0;\n  this.tick = this.tick.bind(this);\n  this.next = setTimeout.bind(null, this.tick, this.delay);\n  Object.defineProperties(this, {\n    currentCount: {\n      get: function() {\n        return _this._currentCount;\n      },\n      enumerable: true,\n      configurable: false\n    },\n    running: {\n      get: function() {\n        return _this._running;\n      },\n      enumerable: true,\n      configurable: false\n    },\n    time: {\n      get: function() {\n        return _this._currentTime + (Date.now() - _this._startTime);\n      },\n      enumerable: true,\n      configurable: false\n    }\n  });\n}\n\n\n__extends(Timer, EventDispatcher);\n\n\n/**\n * Stops the timer, if it is running, and sets the currentCount property back to 0, like the reset button of a stopwatch.\n*/\nTimer.prototype.reset = function() {\n  this.stop();\n  this._currentCount = 0;\n  this._currentTime = 0;\n  this._startTime = null;\n};\n\n/**\n * Starts the timer, if it is not already running.\n*/\nTimer.prototype.start = function() {\n  var delay;\n  if (this._running === true) {\n    return;\n  }\n  delay = this.delay - (this._currentTime - (this.delay * this._currentCount));\n  this._running = true;\n  this._timeout = setTimeout(this.tick, delay);\n};\n\n/**\n * Stops the timer.\n*/\nTimer.prototype.stop = function() {\n  if (this._running === false) {\n    return;\n  }\n  clearTimeout(this._timeout);\n  this._currentTime += Date.now() - this._startTime;\n  this._timeout = null;\n  this._running = false;\n};\n\n/**\n *\n*/\nTimer.prototype.tick = function() {\n  var complete;\n  clearTimeout(this._timeout);\n  complete = this.repeatCount !== 0 && this._currentCount >= this.repeatCount;\n  this._currentCount++;\n  this._currentTime += this.delay;\n  this._startTime = Date.now();\n  if (complete === false) {\n    this._timeout = this.next();\n  }\n  this.dispatchEvent(new Event(\"timer\", this));\n  if (complete === true) {\n    this.stop();\n    this.dispatchEvent(new Event(\"complete\", this));\n  }\n};\n\nfunction Utils() {}\n\nUtils.blankImage = \"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAMAAAAoyzS7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NjI2QkJDQTBCMzQ4MTFFMUFERDJBRkRGQUQwNTcxRTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NjI2QkJDQTFCMzQ4MTFFMUFERDJBRkRGQUQwNTcxRTIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDowODg4NjdFQkIzNDgxMUUxQUREMkFGREZBRDA1NzFFMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDowODg4NjdFQ0IzNDgxMUUxQUREMkFGREZBRDA1NzFFMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pu0++ecAAAAGUExURf///wAAAFXC034AAAABdFJOUwBA5thmAAAADElEQVR42mJgAAgwAAACAAFPbVnhAAAAAElFTkSuQmCC\";\n\nUtils.mimeTypes = {\n  mp4: \"video/mp4\",\n  flv: \"video/x-flv\",\n  f4m: \"video/f4m\",\n  smil: \"application/smil\",\n  smilxml: \"application/smil+xml\",\n  m3u8: \"application/x-mpegURL\",\n  mp3: \"audio/mpeg\",\n  json: \"application/json\",\n  txt: \"text/plain\",\n  xml: \"application/xml\",\n  ogv: \"video/ogg\",\n  webm: \"video/webm\",\n  mpd: \"application/dash+xml\",\n  ism: \"application/vnd.ms-sstr+xml\",\n  js: \"text/javascript\",\n  css: \"text/css\",\n  swf: \"application/x-shockwave-flash\",\n  vtt: \"text/vtt\",\n  ttml: \"application/ttml+xml\",\n  srt: \"application/x-subrip\",\n  cea608: \"text/cea-608\",\n  cea708: \"text/cea-708\"\n};\n\nUtils.flashTypes = [Utils.mimeTypes.mp4, Utils.mimeTypes.flv, Utils.mimeTypes.f4m, Utils.mimeTypes.smil, Utils.mimeTypes.smilxml];\n\nUtils.rules = {\n  flashTablets: {\n    label: \"Android 2 & 3 or Kindle Fire 1\",\n    regexp: \"Android [23]|Silk\\/1\"\n  },\n  html5Phones: {\n    label: \"iPhone\",\n    regexp: \"iPhone\"\n  },\n  html5Tablets: {\n    label: \"HTML5 Tablets\",\n    regexp: \"iPad|Android [4-9]|Silk\\/2\"\n  },\n  desktop: {\n    label: \"Desktop\",\n    regexp: \"^((?!iPad|iPhone|Android|BlackBerry|PlayBook|Silk).)*$\"\n  }\n};\n\nUtils.getPlaybackMode = function(mode) {\n  var key, valid, value, _ref;\n  if (mode == null) {\n    mode = ((_ref = QueryString[\"amp-mode\"]) != null ? _ref.toLowerCase() : void 0) || PlaybackMode.HTML_AUTO;\n  }\n  valid = false;\n  for (key in PlaybackMode) {\n    value = PlaybackMode[key];\n    if (value === mode) {\n      valid = true;\n      break;\n    }\n  }\n  if (!valid) {\n    mode = PlaybackMode.AUTO;\n  }\n  if (mode === PlaybackMode.HTML_AUTO) {\n    mode = this.isHTMLFirst() ? PlaybackMode.HTML : PlaybackMode.AUTO;\n  }\n  if (mode !== PlaybackMode.AUTO) {\n    if (mode === PlaybackMode.FLASH && (!this.hasFlash() || typeof FlashPlayer === \"undefined\")) {\n      if (this.supportsHTML5Video()) {\n        mode = PlaybackMode.HTML;\n      } else {\n        mode = PlaybackMode.NONE;\n      }\n    }\n    return mode;\n  }\n  if (!this.hasFlash()) {\n    mode = this.supportsHTML5Video() ? PlaybackMode.HTML : PlaybackMode.NONE;\n  }\n  if (mode === PlaybackMode.AUTO) {\n    mode = this.isHTML5() ? PlaybackMode.HTML : PlaybackMode.FLASH;\n  }\n  return mode;\n};\n\nUtils.getIEVersion = function() {\n  var re, rv, ua;\n  rv = -1;\n  ua = navigator.userAgent;\n  if (navigator.appName === 'Microsoft Internet Explorer') {\n    re = new RegExp(\"MSIE ([0-9]{1,}[\\.0-9]{0,})\");\n  } else if (navigator.appName === 'Netscape') {\n    re = new RegExp(\"Trident/.*rv:([0-9]{1,}[\\.0-9]{0,})\");\n  } else if (/Edge\\/[0-9\\.]+$/.test(ua)) {\n    re = /Edge\\/([0-9\\.]+)/;\n  }\n  if ((re != null ? re.exec(ua) : void 0) != null) {\n    rv = parseFloat(RegExp.$1);\n  }\n  return rv;\n};\n\nUtils.getFFVersion = function() {\n  var rv, ua;\n  rv = -1;\n  ua = navigator.userAgent;\n  if (/Firefox\\/([0-9\\.]+)$/.exec(ua)) {\n    rv = parseFloat(RegExp.$1);\n  }\n  return rv;\n};\n\nUtils.getSafariVersion = function() {\n  var rv, ua;\n  rv = -1;\n  ua = navigator.userAgent;\n  if (/Safari\\/[0-9\\.]+$/.test(ua) && (/Version\\/([0-9]+\\.[0-9]+) Safari/.exec(ua) != null)) {\n    rv = parseFloat(RegExp.$1);\n  }\n  return rv;\n};\n\nUtils.isChrome = function() {\n  return /Chrom(e|ium)/.test(navigator.userAgent);\n};\n\nUtils.getChromeVersion = function() {\n  var rv, ua;\n  rv = -1;\n  ua = navigator.userAgent;\n  if (/Chrome( Mobile)?\\/([0-9\\.]+)/.test(ua)) {\n    rv = parseFloat(ua.match(/Chrome( Mobile)?\\/([0-9\\.]+)/)[2].split(\".\").slice(0, 2).join(\".\"));\n  }\n  return rv;\n};\n\nUtils.isHTMLFirst = function() {\n  return window.MediaSource != null;\n};\n\nUtils.mergeRules = function(rules) {\n  var id, rule, _results;\n  _results = [];\n  for (id in rules) {\n    rule = rules[id];\n    _results.push(Utils.rules[id] = rule);\n  }\n  return _results;\n};\n\nUtils.checkRules = function(rules) {\n  var id, regExp, rule, _i, _len;\n  if ((rules != null) && rules.length > 0) {\n    for (_i = 0, _len = rules.length; _i < _len; _i++) {\n      id = rules[_i];\n      if (!(rule = Utils.rules[id])) {\n        continue;\n      }\n      regExp = new RegExp(rule.regexp);\n      if (regExp.test(navigator.userAgent)) {\n        return true;\n      }\n    }\n  }\n  return false;\n};\n\nUtils.selectSource = function(sources, canPlayType) {\n  var item, _i, _j, _len, _len1;\n  for (_i = 0, _len = sources.length; _i < _len; _i++) {\n    item = sources[_i];\n    if (Utils.checkRules(item.rules)) {\n      return item;\n    }\n  }\n  for (_j = 0, _len1 = sources.length; _j < _len1; _j++) {\n    item = sources[_j];\n    if (canPlayType(item.type || Utils.getMimeType(item.src)) !== \"\") {\n      return item;\n    }\n  }\n  return null;\n};\n\nUtils.getSourceByType = function(media, type) {\n  var source, sources, _i, _len;\n  sources = media.source != null ? media.source.slice() : [];\n  if (!(media.type != null)) {\n    media.type = Utils.getMimeType(media.src);\n  }\n  sources.unshift(media);\n  for (_i = 0, _len = sources.length; _i < _len; _i++) {\n    source = sources[_i];\n    if (source.type === type) {\n      return source;\n    }\n  }\n  return null;\n};\n\nUtils.getMimeType = function(file) {\n  return this.mimeTypes[Utils.getFileExtension(file)];\n};\n\nUtils.selectTrack = function(tracks, kind) {\n  var item, track, _i, _len;\n  for (_i = 0, _len = tracks.length; _i < _len; _i++) {\n    item = tracks[_i];\n    if (!(item.kind === kind)) {\n      continue;\n    }\n    track = item;\n    break;\n  }\n  return track;\n};\n\nUtils.isIPhone = function() {\n  return /iPhone/.test(navigator.platform) || /iPhone/.test(navigator.userAgent);\n};\n\nUtils.isIPad = function() {\n  return /iPad/.test(navigator.platform) || /iPad/.test(navigator.userAgent);\n};\n\nUtils.isAndroid = function() {\n  return /Android [4-9]/.test(navigator.userAgent);\n};\n\nUtils.isKindleFireHD = function() {\n  return /Silk\\/2/.test(navigator.userAgent);\n};\n\nUtils.isKindleFire = function() {\n  return /Silk\\/1/.test(navigator.userAgent);\n};\n\nUtils.isBlackBerry = function() {\n  return /BlackBerry;|PlayBook|BB10/.test(navigator.userAgent);\n};\n\nUtils.isFirefoxOS = function() {\n  return /\\(Mobile;.*Firefox\\//.test(navigator.userAgent);\n};\n\nUtils.supportsHTML5Video = function() {\n  var video;\n  video = document.createElement(\"video\");\n  return video.canPlayType != null;\n};\n\nUtils.isHTML5 = function() {\n  return this.isIOS() || this.isAndroid() || this.isKindleFireHD() || this.isBlackBerry() || this.isFirefoxOS();\n};\n\nUtils.isIOS = function() {\n  var iOSRegEx, isIOS;\n  iOSRegEx = /iP(hone|od|ad)/i;\n  return isIOS = iOSRegEx.test(navigator.platform) || iOSRegEx.test(navigator.userAgent);\n};\n\nUtils.getIOSversion = function() {\n  var ver;\n  if (this.isIOS()) {\n    ver = navigator.appVersion.match(/OS (\\d+)_(\\d+)_?(\\d+)?/);\n    return [parseInt(ver[1], 10), parseInt(ver[2], 10), parseInt(ver[3] || 0, 10)];\n  }\n};\n\nUtils.hasFlash = function() {\n  var hasFlash;\n  try {\n    hasFlash = Boolean(new ActiveXObject(\"ShockwaveFlash.ShockwaveFlash\"));\n  } catch (error) {\n    hasFlash = \"undefined\" !== typeof navigator.mimeTypes[\"application/x-shockwave-flash\"];\n  }\n  return hasFlash;\n};\n\nUtils.isFullscreenDevice = function() {\n  return this.isKindleFireHD() || this.isIPhone();\n};\n\nUtils.getDevice = function() {\n  var device;\n  device = \"desktop\";\n  if (this.isIPhone()) {\n    device = \"iphone\";\n  } else if (this.isIPad()) {\n    device = \"ipad\";\n  } else if (/Android/.test(navigator.userAgent)) {\n    device = \"android\";\n  } else if (this.isKindleFireHD()) {\n    device = \"kindlefirehd\";\n  } else if (this.isKindleFire()) {\n    device = \"kindlefire\";\n  }\n  return device;\n};\n\nUtils.xmlToJson = function(xml) {\n  var attribute, child, element, index, nodeName, obj, _i, _j, _len, _len1, _ref, _ref1;\n  obj = {};\n  if (xml.nodeType === 9) {\n    xml = xml.firstChild;\n  }\n  if (xml.nodeType === 1) {\n    if (xml.attributes.length > 0) {\n      obj[\"@attributes\"] = {};\n      _ref = xml.attributes;\n      for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {\n        attribute = _ref[index];\n        obj[\"@attributes\"][attribute.nodeName] = attribute.nodeValue;\n      }\n    }\n  } else if (xml.nodeType === 3 || xml.nodeType === 4) {\n    obj = xml.nodeValue;\n  }\n  if (xml.hasChildNodes()) {\n    _ref1 = xml.childNodes;\n    for (index = _j = 0, _len1 = _ref1.length; _j < _len1; index = ++_j) {\n      child = _ref1[index];\n      if (child.nodeType === 3 && !/\\S/.test(child.nodeValue)) {\n        continue;\n      }\n      nodeName = child.nodeName.replace(/:/, \"-\");\n      element = this.xmlToJson(child);\n      if (!(element[\"@attributes\"] != null) && (element[\"#text\"] != null)) {\n        element = element[\"#text\"];\n      }\n      if (!(obj[nodeName] != null)) {\n        obj[nodeName] = element;\n      } else {\n        if (!(obj[nodeName] instanceof Array)) {\n          obj[nodeName] = [obj[nodeName]];\n        }\n        obj[nodeName].push(element);\n      }\n    }\n  }\n  return obj;\n};\n\n/**\n * Returns a platform specific XHR object.\n *\n * @static\n*/\nUtils.getXHR = function() {\n  return new XHR();\n};\n\n/**\n * Retrieves a remote text file\n *\n * @static\n*/\nUtils.getUTC = function() {\n  var _this = this;\n  return this.request(\"//time.akamai.com\").then(function(xhr) {\n    return parseInt(xhr.responseText) * 1000;\n  });\n};\n\n/**\n * Request an http resource\n *\n * @static\n*/\nUtils.request = function(options) {\n  var _this = this;\n  if (options == null) {\n    options = {};\n  }\n  return new Promise(function(resolve, reject) {\n    var key, value, xhr, _ref;\n    if (typeof options === \"string\") {\n      options = {\n        url: options\n      };\n    }\n    if (!(options.method != null)) {\n      options.method = \"GET\";\n    }\n    xhr = new XMLHttpRequest();\n    xhr.open(options.method, options.url);\n    xhr.onload = function() {\n      return resolve(xhr);\n    };\n    xhr.onerror = function(event) {\n      return reject(event);\n    };\n    xhr.withCredentials = options.withCredentials;\n    if (options.responseType != null) {\n      try {\n        xhr.responseType = options.responseType;\n      } catch (error) {\n\n      }\n    }\n    if (options.headers != null) {\n      _ref = options.headers;\n      for (key in _ref) {\n        value = _ref[key];\n        if ((key != null) && (value != null)) {\n          xhr.setRequestHeader(key, value);\n        }\n      }\n    }\n    return xhr.send(options.data || options.body);\n  });\n};\n\n/**\n * Request an http resource\n *\n * @static\n*/\nUtils.requestText = function(options) {\n  var _this = this;\n  if (options == null) {\n    options = {};\n  }\n  return this.request(options).then(function(xhr) {\n    return xhr.responseText;\n  });\n};\n\n/**\n * Request an http resource\n *\n * @static\n*/\nUtils.requestJson = function(options) {\n  var _this = this;\n  if (options == null) {\n    options = {};\n  }\n  return this.requestText(options).then(function(text) {\n    return JSON.parse(text);\n  });\n};\n\n/**\n * Attaches a JavaScript file to the head of the document.\n *\n * @static\n*/\nUtils.loadScript = function(src, parent) {\n  var _this = this;\n  return new Promise(function(resolve, reject) {\n    var head, script;\n    head = parent || document.getElementsByTagName(\"head\")[0];\n    script = document.createElement(\"script\");\n    script.type = 'text/javascript';\n    if (script.addEventListener) {\n      script.onload = function() {\n        resolve(script);\n      };\n      script.onerror = function(event) {\n        reject(event);\n      };\n    } else if (script.readyState) {\n      script.onreadystatechange = function(event) {\n        if (this.readyState === 'loaded' || this.readyState === 'complete') {\n          this.onreadystatechange = null;\n          resolve(script);\n        }\n      };\n    }\n    script.src = src;\n    head.appendChild(script);\n  });\n};\n\n/**\n * Attaches a CSS file to the head of the document.\n *\n * @static\n*/\nUtils.loadStyleSheet = function(href) {\n  var head, link;\n  head = document.getElementsByTagName(\"head\")[0];\n  link = document.createElement(\"link\");\n  link.rel = \"stylesheet\";\n  link.type = \"text/css\";\n  link.href = href;\n  return head.appendChild(link);\n};\n\nUtils.getFileExtension = function(url) {\n  if (url == null) {\n    url = \"\";\n  }\n  return url.replace(/\\?.*/, \"\").replace(/\\#.*/, \"\").split('.').pop();\n};\n\nUtils.getResponseHeader = function(url, header, client) {\n  var xhr;\n  if (client == null) {\n    client = {};\n  }\n  xhr = Utils.getXHR();\n  if (client.onerror != null) {\n    xhr.onerror = client.onerror;\n  }\n  xhr.open(\"HEAD\", url, false);\n  xhr.send();\n  return xhr.getResponseHeader(header);\n};\n\nUtils.getResponseHeaders = function(url, headers, client) {\n  var header, results, xhr, _i, _len;\n  if (client == null) {\n    client = {};\n  }\n  xhr = Utils.getXHR();\n  if (client.onerror != null) {\n    xhr.onerror = client.onerror;\n  }\n  xhr.open(\"HEAD\", url, false);\n  xhr.send();\n  results = {};\n  if (!(headers != null)) {\n    return xhr.getAllResponseHeaders();\n  }\n  for (_i = 0, _len = headers.length; _i < _len; _i++) {\n    header = headers[_i];\n    results[header] = xhr.getResponseHeader(header);\n  }\n  return results;\n};\n\n/**\n * Determines if the device supports touch events\n *\n * @static\n*/\nUtils.isTouch = null;\n\n/**\n * Determines if the device supports touch events\n *\n * @static\n*/\nUtils.isTouchDevice = function() {\n  if (!(this.isTouch != null)) {\n    try {\n      document.createEvent(\"TouchEvent\");\n      this.isTouch = true;\n    } catch (error) {\n      this.isTouch = false;\n    }\n  }\n  return this.isTouch;\n};\n\n/**\n * Forces a number between a min and a max\n *\n * @static\n*/\nUtils.clamp = function(value, min, max) {\n  if (value < min) {\n    value = min;\n  }\n  if (value > max) {\n    value = max;\n  }\n  return value;\n};\n\n/**\n * Beacons a url via an img tag\n *\n * @static\n*/\nUtils.beacon = function(url, beaconId) {\n  var beaconImg;\n  if (beaconId == null) {\n    beaconId = \"beaconId\";\n  }\n  beaconImg = document.getElementById(beaconId);\n  if (!(beaconImg != null)) {\n    beaconImg = document.createElement(\"img\");\n    beaconImg.setAttribute(\"id\", beaconId);\n    beaconImg.setAttribute(\"height\", 0);\n    beaconImg.setAttribute(\"width\", 0);\n    document.body.appendChild(beaconImg);\n    beaconImg.style.display = \"none\";\n  }\n  beaconImg.setAttribute(\"src\", url);\n  return beaconImg;\n};\n\n/**\n * Calculates offset Left and Top\n *\n * @static\n*/\nUtils.getElementOffset = function(element, root) {\n  var height, left, scrollLeft, scrollTop, top, width;\n  if (root == null) {\n    root = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;\n  }\n  left = 0;\n  top = 0;\n  width = element.offsetWidth;\n  height = element.offsetHeight;\n  while (element && element !== root) {\n    if (element.tagName === \"BODY\") {\n      scrollLeft = element.scrollLeft || document.documentElement.scrollLeft;\n      scrollTop = element.scrollTop || document.documentElement.scrollTop;\n      left += element.offsetLeft - scrollLeft + element.clientLeft;\n      top += element.offsetTop - scrollTop + element.clientTop;\n    } else {\n      left += element.offsetLeft - element.scrollLeft + element.clientLeft;\n      top += element.offsetTop - element.scrollTop + element.clientTop;\n    }\n    element = element.offsetParent;\n  }\n  return {\n    left: left,\n    top: top,\n    width: width,\n    height: height\n  };\n};\n\n/**\n * Override the properties of a base object with the values\n * of an override object.\n *\n * @param {Object} base     The base object.\n * @param {Object} overrides  key/value overrides\n * @return {Object}\n * @static\n*/\nUtils.override = function(base, overrides, clone) {\n  var key, value;\n  if (clone == null) {\n    clone = true;\n  }\n  if (!(base != null)) {\n    return overrides;\n  }\n  if (!(overrides != null)) {\n    return base;\n  }\n  if (clone === true) {\n    base = Utils.clone(base);\n    overrides = Utils.clone(overrides);\n  }\n  for (key in overrides) {\n    value = overrides[key];\n    if (typeof base[key] === \"object\" && typeof value === \"object\" && (value != null)) {\n      if (base[key] == null) {\n        base[key] = value instanceof Array ? [] : {};\n      }\n      base[key] = Utils.override(base[key], value, false);\n    } else {\n      base[key] = value;\n    }\n  }\n  return base;\n};\n\n/**\n * Diffs two objects.\n *\n * @param {Object} oldObj The old object.\n * @param {Object} newObj The new object.\n * @return {Object?}\n * @static\n*/\nUtils.diff = function(oldObj, newObj) {\n  var changes, diff, key, old, value;\n  if (!(newObj != null)) {\n    return null;\n  }\n  if (!(oldObj != null) && (newObj != null)) {\n    return newObj;\n  }\n  changes = {};\n  for (key in newObj) {\n    value = newObj[key];\n    if ((old = oldObj[key]) !== value) {\n      if (!(old != null)) {\n        changes[key] = value;\n      } else {\n        switch (typeof value) {\n          case \"string\":\n          case \"number\":\n          case \"boolean\":\n          case \"function\":\n            changes[key] = value;\n            break;\n          case \"object\":\n            if (value instanceof Array) {\n              if (old.length !== value.length) {\n                changes[key] = value;\n              }\n            } else {\n              diff = this.diff(old, value);\n              if (diff != null) {\n                changes[key] = diff;\n              }\n            }\n        }\n      }\n    }\n  }\n  if (Object.keys(changes).length === 0) {\n    return null;\n  }\n  return changes;\n};\n\n/**\n * Clones an object.\n *\n * @param {Object} obj The object to be cloned.\n * @return {Object}\n * @static\n*/\nUtils.clone = function(obj, deepCopy) {\n  var clone, item, k, key, v, value, _i, _len;\n  if (deepCopy == null) {\n    deepCopy = true;\n  }\n  if (!(obj != null)) {\n    return obj;\n  }\n  if (typeof obj !== \"object\") {\n    clone = obj;\n  } else {\n    if (obj instanceof Array) {\n      clone = [];\n    } else {\n      clone = {};\n    }\n    for (key in obj) {\n      value = obj[key];\n      if (typeof value === \"object\" && value !== null && deepCopy === true) {\n        if (value instanceof Array) {\n          clone[key] = [];\n          for (_i = 0, _len = value.length; _i < _len; _i++) {\n            item = value[_i];\n            clone[key].push(this.clone(item));\n          }\n        } else {\n          clone[key] = {};\n          for (k in value) {\n            v = value[k];\n            clone[key][k] = this.clone(v);\n          }\n        }\n      } else {\n        clone[key] = value;\n      }\n    }\n  }\n  return clone;\n};\n\n/**\n * Takes a time in seconds and converts it to timecode.\n *\n * @param   {Number}  time  The time in seconds to be formatted.\n * @return  {String}  A SMTP formatted string.\n*/\nUtils.formatTimecode = function(time, duration) {\n  var strTime;\n  time = parseInt(time);\n  if (isNaN(time)) {\n    return \"00:00\";\n  }\n  strTime = Utils.formatZeroFill(time % 60);\n  time = parseInt(time / 60);\n  strTime = Utils.formatZeroFill(time % 60) + \":\" + strTime;\n  time = parseInt(time / 60);\n  if (time > 0) {\n    strTime = Utils.formatZeroFill(time) + \":\" + strTime;\n  }\n  if (duration >= 3600 && strTime.length === 5) {\n    strTime = \"00:\" + strTime;\n  }\n  return strTime;\n};\n\n/**\n * Converts a time in seconds to a string and adds a zero in front of any number lower than 10.\n *\n * @param Number time The number to be zero filled.\n*/\nUtils.formatZeroFill = function(time) {\n  var str;\n  str = time.toString();\n  if (time < 10) {\n    str = \"0\" + str;\n  }\n  return str;\n};\n\n/**\n * Converts timecode to seconds.\n *\n * @param   {string}  timeCode        A SMTP formatted string.\n * @param   {number}  [framerate=30]  The frame rate. Used to calculate milliseconds.\n * @return  {number}                  The number of seconds represented by the time code\n*/\nUtils.flattenTimecode = function(timeCode, framerate) {\n  var ms, parts, pieces, time;\n  if (framerate == null) {\n    framerate = 30;\n  }\n  if (!(timeCode != null) || timeCode === \"\") {\n    return NaN;\n  }\n  pieces = timeCode.split(\":\");\n  ms = 0;\n  if (pieces.length === 4) {\n    ms = parseInt(pieces.pop()) / framerate;\n  } else if (pieces.length === 3) {\n    pieces[2] = pieces[2].replace(\",\", \".\");\n    if (pieces[2].indexOf(\".\") !== -1) {\n      parts = pieces[2].split(\".\");\n    }\n    if ((parts != null ? parts.length : void 0) > 1) {\n      pieces[2] = parts[0];\n      ms = parseInt(parts[1]) / 1000;\n    }\n  }\n  time = parseInt(pieces.pop());\n  while (pieces.length > 0) {\n    time += Math.pow(60, pieces.length) * parseInt(pieces.shift());\n  }\n  return time + ms;\n};\n\n/**\n * Adds a cache busting query string parameter to a url.\n *\n * @param String url The url.\n * @param String key The name of the query string variable\n * @param Object value The value of the query string variable\n*/\nUtils.cacheBust = function(url, key, value) {\n  var op;\n  if (key == null) {\n    key = \"cacheBust\";\n  }\n  if (value == null) {\n    value = Date.now();\n  }\n  op = url.indexOf('?') === -1 ? \"?\" : \"&\";\n  return url + op + key + \"=\" + value;\n};\n\n/**\n * Converts a camel case string in to a CSS proptery name.\n*/\nUtils.formatStyleName = function(styleName) {\n  return styleName.replace(/([A-Z])/, \"-$1\").toLowerCase();\n};\n\n/**\n * Trims whitespace from the beginning and end of a string\n*/\nUtils.trim = function(str) {\n  var trim;\n  trim = str.replace(/^\\s*(.*)/, \"$1\");\n  return trim.replace(/(.*)\\s*$/, \"$1\");\n};\n\n/**\n*/\nUtils.getFeed = function(url) {\n  var _this = this;\n  return this.request(url).then(function(xhr) {\n    if (xhr.responseType === \"document\" || /^</.test(xhr.responseText)) {\n      return Utils.xmlToJson(xhr.responseXML);\n    } else {\n      return JSON.parse(xhr.responseText);\n    }\n  });\n};\n\n/**\n*/\nUtils.getSource = function(url, onload, onerror) {\n  var feedloadedHandler, mode;\n  mode = Utils.getPlaybackMode();\n  feedloadedHandler = function(feed) {\n    var canPlayType, helper, source, _ref;\n    helper = new MRSSHelper();\n    feed = helper.createFeed(feed);\n    if ((feed != null ? (_ref = feed.item) != null ? _ref.length : void 0 : void 0) > 0) {\n      canPlayType = function(type) {\n        if ((mode === \"flash\" && Utils.flashTypes.indexOf(type) !== -1) || (mode === \"html\" && Utils.flashTypes.indexOf(type) === -1)) {\n          return \"maybe\";\n        } else {\n          return \"\";\n        }\n      };\n      source = Utils.selectSource(feed.item[0].source, canPlayType);\n    }\n    if (typeof onload === \"function\") {\n      onload(source);\n    }\n  };\n  Utils.getFeed(url).then(feedloadedHandler)[\"catch\"](onerror);\n};\n\n/**\n*/\nUtils.trackMouse = function() {\n  try {\n    if (document.addEventListener != null) {\n      document.addEventListener(\"mousemove\", this.mouseTracker);\n    } else if (document.attachEvent != null) {\n      document.attachEvent(\"mousemove\", this.mouseTracker);\n    }\n  } catch (error) {\n\n  }\n};\n\nUtils.clientX = 0;\n\nUtils.clientY = 0;\n\nUtils.pageX = 0;\n\nUtils.pageY = 0;\n\n/**\n*/\nUtils.mouseTracker = function(event) {\n  Utils.clientX = event.clientX;\n  Utils.clientY = event.clientY;\n  Utils.pageX = event.pageX;\n  Utils.pageY = event.pageY;\n};\n\n/**\n*/\nUtils.isMouseOverElement = function(element) {\n  var isOver;\n  isOver = false;\n  if (!(element != null)) {\n    return isOver;\n  }\n  try {\n    isOver = element.contains(document.elementFromPoint(Utils.clientX, Utils.clientY));\n  } catch (error) {\n    isOver = false;\n  }\n  return isOver;\n};\n\nUtils.trackMouse();\n\n/** Function to get Outer Dimensions\n*/\nUtils.getActualSize = function(element, margin) {\n  var height, style, width;\n  if (margin == null) {\n    margin = true;\n  }\n  width = element.offsetWidth;\n  height = element.offsetHeight;\n  if (margin === true) {\n    style = getComputedStyle(element);\n    width += parseInt(style.marginLeft) + parseInt(style.marginRight);\n    height += parseInt(style.marginTop) + parseInt(style.marginBottom);\n  }\n  return {\n    \"width\": width,\n    \"height\": height\n  };\n};\n\nUtils.isVolumeSettable = function() {\n  var noVolume, ua;\n  ua = navigator.userAgent.toLowerCase();\n  noVolume = /ipad|iphone|ipod|android|blackberry|windows ce|windows phone|webos|playbook/.exec(ua);\n  if (noVolume != null) {\n    if (noVolume[0] === \"android\" && /Firefox/.test(ua)) {\n      return true;\n    } else {\n      return false;\n    }\n  }\n  return true;\n};\n\n/**\n * Creates a flash object tag.\n *\n * @param {string} swf\n *    The number to be zero filled.\n *\n * @param {Object} flashvars\n *\n * @return {HTMLObjectElement}\n *    The flash object tag.\n *\n * @static\n*/\nUtils.createFlashObject = function(flash, parent) {\n  var atts, id, innerHTML, key, params, value, vars, _ref, _ref1;\n  if (!(flash != null)) {\n    return;\n  }\n  params = {\n    allowFullScreen: true,\n    allowScriptAccess: \"always\",\n    wmode: \"direct\",\n    bgColor: \"#000000\"\n  };\n  Utils.override(params, flash.params, false);\n  if (flash.vars != null) {\n    vars = [];\n    _ref = flash.vars;\n    for (key in _ref) {\n      value = _ref[key];\n      vars.push(\"\" + key + \"=\" + value);\n    }\n    params.flashvars = vars.join(\"&\");\n  }\n  id = ((_ref1 = flash.attributes) != null ? _ref1.id : void 0) || this.createUID();\n  atts = {\n    id: id,\n    name: id,\n    width: \"100%\",\n    height: \"100%\",\n    type: \"application/x-shockwave-flash\"\n  };\n  Utils.override(atts, flash.attributes, false);\n  if (this.getIEVersion() !== -1) {\n    if (params.wmode === \"direct\") {\n      params.wmode = \"transparent\";\n    }\n  }\n  innerHTML = \"<object \";\n  for (key in atts) {\n    value = atts[key];\n    innerHTML += \"\" + key + \"=\\\"\" + value + \"\\\" \";\n  }\n  innerHTML += \">\\n\";\n  for (key in params) {\n    value = params[key];\n    innerHTML += \"<param name=\\\"\" + key + \"\\\" value=\\\"\" + value + \"\\\" />\\n\";\n  }\n  innerHTML += \"</object>\";\n  parent.innerHTML = innerHTML;\n};\n\n/**\n * Creates a unique id.\n *\n * @param   {number=}   len\n *    The number of characters in the uid\n *\n * @param   {number=}   base\n *    The base to use for representing a numeric value.\n *\n * @return  {string}\n *    The unique id.\n*/\nUtils.createUID = function(len, base) {\n  var i, randomRangeInt, uid, _i, _ref,\n    _this = this;\n  if (len == null) {\n    len = 16;\n  }\n  if (base == null) {\n    base = 32;\n  }\n  randomRangeInt = function(min, max) {\n    return Math.floor(Math.random() * (max - min + 1)) + min;\n  };\n  uid = \"\";\n  for (i = _i = 0, _ref = len - 1; 0 <= _ref ? _i <= _ref : _i >= _ref; i = 0 <= _ref ? ++_i : --_i) {\n    uid += randomRangeInt(0, base - 1).toString(base).toUpperCase();\n  }\n  if (this.uids[uid] === true) {\n    return this.createUID(len, base);\n  }\n  this.uids[uid] = true;\n  return uid;\n};\n\nUtils.uids = {};\n\n/**\n * Chains an array of promises sequentially\n *\n * @param   {Array}   promises\n *    The list of promises\n *\n * @param   {Object}   data\n *    Data to be passes from promise to promise\n *\n * @return  {Promise}\n *    The promise chain\n*/\nUtils.chain = function(promises, data) {\n  var chain, promise, _i, _len;\n  chain = Promise.resolve(data);\n  for (_i = 0, _len = promises.length; _i < _len; _i++) {\n    promise = promises[_i];\n    chain = chain.then(promise);\n  }\n  return chain;\n};\n\n/**\n * Asynchronously transform an object using an array of functions\n *\n * @param   {Object}   value\n *    Data to be passes from promise to promise\n *\n * @param   {Array.<Function|Transform>}   transforms\n *    The list of transforms\n *\n * @return  {Promise.<Object>}\n *    The transformed object\n*/\nUtils.transform = function(value, transforms) {\n  var exec, index, len, next;\n  if (!(transforms != null) || transforms.length === 0) {\n    return Promise.resolve(value);\n  }\n  transforms = transforms.map(function(item) {\n    if (typeof item.transform === \"function\") {\n      return item.transform;\n    } else {\n      return item;\n    }\n  });\n  index = 0;\n  len = transforms.length - 1;\n  next = function(value) {\n    index++;\n    return exec(value);\n  };\n  exec = function(value) {\n    var transform;\n    transform = transforms[index];\n    if (typeof transform !== \"function\") {\n      throw new Error(\"Transform must be a valid function\");\n    }\n    return Promise.resolve(transform(value, next)).then(function(result) {\n      if (index < len) {\n        return next(result);\n      } else {\n        return result;\n      }\n    });\n  };\n  return exec(value);\n};\n\n/**\n * Converts an array buffer to UTF-8 string.\n *\n * @param   {ArrayBuffer}   arrayBuffer\n *    The ArrayBuffer\n *\n * @return  {String}\n *    The UTF-8 string\n*/\nUtils.arrayBufferToString = function(arrayBuffer) {\n  return String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));\n};\n\n/**\n * Parses a JSON Web Token\n *\n * @param {String} jwt\n *\n * @return {Object}\n *    The parsed JSON Web Token as an object\n*/\nUtils.parseJWT = function(jwt) {\n  var parts;\n  parts = jwt.split(\".\");\n  return {\n    header: JSON.parse(atob(parts[0])),\n    payload: JSON.parse(atob(parts[1])),\n    signature: parts[2]\n  };\n};\n\n/**\n *\n*/\nUtils.getFullScreenApi = function(container, video) {\n  var fullscreen;\n  fullscreen = {};\n  if (container.webkitRequestFullScreen != null) {\n    fullscreen.enter = container.webkitRequestFullScreen.bind(container);\n    fullscreen.exit = document.webkitExitFullscreen != null ? document.webkitExitFullscreen.bind(document) : document.webkitCancelFullScreen.bind(document);\n    fullscreen.event = \"onwebkitfullscreenchange\";\n    fullscreen.element = \"webkitFullscreenElement\";\n    fullscreen.error = \"webkitfullscreenerror\";\n  } else if (container.requestFullscreen != null) {\n    fullscreen.enter = container.requestFullscreen.bind(container);\n    fullscreen.exit = document.exitFullscreen != null ? document.exitFullscreen.bind(document) : document.cancelFullscreen.bind(document);\n    fullscreen.event = \"onfullscreenchange\";\n    fullscreen.element = \"fullscreenElement\";\n    fullscreen.error = \"fullscreenerror\";\n  } else if (container.mozRequestFullScreen != null) {\n    fullscreen.enter = container.mozRequestFullScreen.bind(container);\n    fullscreen.exit = document.mozCancelFullScreen.bind(document);\n    fullscreen.event = \"onmozfullscreenchange\";\n    fullscreen.element = \"mozFullscreenElement\";\n    fullscreen.error = \"mozfullscreenerror\";\n  } else if (container.msRequestFullscreen != null) {\n    fullscreen.enter = container.msRequestFullscreen.bind(container);\n    fullscreen.exit = document.msExitFullscreen.bind(document);\n    fullscreen.event = \"MSFullscreenChange\";\n    fullscreen.element = \"msFullscreenElement\";\n    fullscreen.error = \"MSFullscreenError\";\n  } else if (video.webkitEnterFullscreen != null) {\n    fullscreen.enter = video.webkitEnterFullscreen.bind(video);\n    fullscreen.exit = video.webkitExitFullscreen.bind(video);\n    fullscreen.event = null;\n    fullscreen.error = null;\n  }\n  return fullscreen;\n};\n\n/**\n*/\nUtils.stringToArray = function(string) {\n  var array, buffer, i, _i, _ref;\n  buffer = new ArrayBuffer(string.length * 2);\n  array = new Uint16Array(buffer);\n  for (i = _i = 0, _ref = string.length - 1; 0 <= _ref ? _i <= _ref : _i >= _ref; i = 0 <= _ref ? ++_i : --_i) {\n    array[i] = string.charCodeAt(i);\n  }\n  return array;\n};\n\n/**\n*/\nUtils.arrayToString = function(array) {\n  return String.fromCharCode.apply(null, new Uint16Array(array.buffer));\n};\n\n/**\n*/\nUtils.base64DecodeUint8Array = function(input) {\n  var array, i, raw, rawLength, _i, _ref;\n  raw = window.atob(input);\n  rawLength = raw.length;\n  array = new Uint8Array(new ArrayBuffer(rawLength));\n  for (i = _i = 0, _ref = rawLength - 1; 0 <= _ref ? _i <= _ref : _i >= _ref; i = 0 <= _ref ? ++_i : --_i) {\n    array[i] = raw.charCodeAt(i);\n  }\n  return array;\n};\n\n/**\n*/\nUtils.base64EncodeUint8Array = function(input) {\n  var keyStr = \"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\";\n    var output = \"\";\n    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;\n    var i = 0;\n\n    while (i < input.length) {\n      chr1 = input[i++];\n      chr2 = i < input.length ? input[i++] : Number.NaN; // Not sure if the index\n      chr3 = i < input.length ? input[i++] : Number.NaN; // checks are needed here\n\n      enc1 = chr1 >> 2;\n      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);\n      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);\n      enc4 = chr3 & 63;\n\n      if (isNaN(chr2)) {\n        enc3 = enc4 = 64;\n      } else if (isNaN(chr3)) {\n        enc4 = 64;\n      }\n      output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);\n    };\n  return output;\n};\n\n/**\n*/\nUtils.getKeySystem = function() {\n  var ua;\n  ua = navigator.userAgent;\n  if (/Edge/.test(ua) || /Trident/.test(ua)) {\n    return \"com.microsoft.playready\";\n  } else if (/Chrome/.test(ua) || /Firefox/.test(ua)) {\n    return \"com.widevine.alpha\";\n  } else {\n    return \"com.apple.fps.1_0\";\n  }\n};\n\n/**\n*/\nUtils.isAutoplaySupported = function() {\n  var supported;\n  supported = true;\n  if (this.isIOS()) {\n    if (this.getSafariVersion() !== -1) {\n      supported = this.getIOSversion()[0] >= 10;\n    } else if (this.isChrome()) {\n      supported = this.getChromeVersion() >= 53;\n    }\n  }\n  if (this.isChrome() && this.isAndroid()) {\n    supported = this.getChromeVersion() >= 53;\n  }\n  return supported;\n};\n\n/**\n*/\nUtils.fieldIsUnique = function(items, field, compare) {\n  var index, isUnique, item, _i, _len;\n  isUnique = true;\n  for (index = _i = 0, _len = items.length; _i < _len; index = ++_i) {\n    item = items[index];\n    if (item !== null && item !== void 0 && item[field] !== null && item[field] !== void 0 && item[field].toString().toLowerCase() === compare.toString().toLowerCase()) {\n      isUnique = false;\n      break;\n    }\n  }\n  return isUnique;\n};\n\n/**\n*/\nUtils.toCamelCase = function(str) {\n  return str.replace(/-([a-z])/g, function(g) {\n    return g[1].toUpperCase();\n  });\n};\n\n/**\n*/\nUtils.toHyphenated = function(str) {\n  return str.replace(/([A-Z])/g, function(g) {\n    return \"-\" + g[0].toLowerCase();\n  });\n};\n\n/**\n * Creates an HTML element.\n *\n * @param   {?(string|Array.<string>)}  classes\n * @param   {?DOMElement}  parent\n * @param   {?string} text\n * @param   {?string|DOMElement}  element\n * @return  {DOMElement}\n*/\nUtils.createElement = function(classes, parent, text, element) {\n  var classList, item, _i, _len;\n  if (element == null) {\n    element = \"div\";\n  }\n  if (typeof element === \"string\") {\n    element = document.createElement(element);\n  }\n  classList = element.classList;\n  if (classes != null) {\n    if (typeof classes === \"string\") {\n      classes = [classes];\n    }\n    for (_i = 0, _len = classes.length; _i < _len; _i++) {\n      item = classes[_i];\n      classList.add(item);\n    }\n  }\n  if (text != null) {\n    element.textContent = text;\n  }\n  if (parent != null) {\n    parent.appendChild(element);\n  }\n  return element;\n};\n\n/**\n * The AMPConfig class\n *\n * @constructor\n * @private\n * @extends {EventDispatcher}\n*/\nfunction AMPConfig() {\n  AMPConfig.__super__.constructor.call(this, this, false);\n}\n\n\n__extends(AMPConfig, EventDispatcher);\n\n\nAMPConfig.UNINITIALIZED = 0;\n\nAMPConfig.LOADING = 1;\n\nAMPConfig.LOADED = 2;\n\n/**\n * Converst XML to a native JS object\n *\n * @param   {Element} xml   The XML to convert\n * @return  {Object}\n * @static\n*/\nAMPConfig.parseModule = function(xml) {\n  var child, childNodes, count, i, k, node, obj, _i, _len;\n  obj = {};\n  i = 0;\n  childNodes = xml.childNodes;\n  count = childNodes.length;\n  k = 0;\n  node = null;\n  child = null;\n  for (_i = 0, _len = childNodes.length; _i < _len; _i++) {\n    node = childNodes[_i];\n    if ((node != null ? node.nodeType : void 0) === 1) {\n      obj[node.nodeName] = this.parseItem(node);\n    }\n  }\n  return obj;\n};\n\nAMPConfig.parseItem = function(node) {\n  var child, children, type, value, _i, _len;\n  type = (\"\" + (node.getAttribute('type'))).toLowerCase();\n  value = node.textContent || node.text || node.innerText;\n  if (type !== \"object\" && type !== \"array\" && /#\\{.*\\}/.test(value)) {\n    return value;\n  }\n  switch (type) {\n    case \"object\":\n      value = this.parseModule(node);\n      break;\n    case \"array\":\n      value = [];\n      children = node.childNodes;\n      for (_i = 0, _len = children.length; _i < _len; _i++) {\n        child = children[_i];\n        if (child.nodeType !== 1) {\n          continue;\n        }\n        value.push(this.parseItem(child));\n      }\n      break;\n    case \"boolean\":\n      value = value.toLowerCase() === \"true\";\n      break;\n    case \"number\":\n      value = parseFloat(value);\n  }\n  return value;\n};\n\nAMPConfig.prototype.url = null;\n\nAMPConfig.prototype.data = null;\n\nAMPConfig.prototype.xml = null;\n\nAMPConfig.prototype.readyState = AMPConfig.UNINITIALIZED;\n\nAMPConfig.prototype.loaded = false;\n\nAMPConfig.prototype.flash = {\n  PlaybackMetricsPlugin: {\n    src: '#{paths.resources}plugins/PlaybackMetricsPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"PlaybackMetricsPlugin\"\n  },\n  SubclipMonitorPlugin: {\n    src: '#{paths.resources}plugins/SubclipMonitorPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"SubclipMonitorPlugin\"\n  },\n  NetSessionClientPlugin: {\n    src: '#{paths.resources}plugins/NetSessionClientPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"NetSessionClientPlugin\"\n  }\n};\n\n/**\n*/\nAMPConfig.prototype.loadURL = function(url, withCredentials) {\n  var _this = this;\n  if (withCredentials == null) {\n    withCredentials = false;\n  }\n  this.url = url;\n  this.setReadyState(AMPConfig.LOADING);\n  Utils.request({\n    url: url,\n    withCredentials: withCredentials\n  }).then(function(xhr) {\n    var data, firstChild;\n    if (xhr.responseType === \"document\") {\n      _this.xml = xhr.responseXML;\n      firstChild = _this.xml.firstChild.nodeType !== 7 ? _this.xml.firstChild : _this.xml.childNodes[1];\n      data = AMPConfig.parseModule(firstChild);\n    } else {\n      data = xhr.response;\n      if (typeof data === \"string\") {\n        data = JSON.parse(data);\n      }\n    }\n    _this.loadData(data);\n  })[\"catch\"](function() {\n    _this.dispatchEvent(new Event(\"error\", event));\n    Logger.error(event);\n  });\n};\n\n/**\n*/\nAMPConfig.prototype.loadData = function(data) {\n  Config.defaults = data;\n  this.setReadyState(AMPConfig.LOADED);\n};\n\n/**\n*/\nAMPConfig.prototype.load = function(resource, withCredentials) {\n  if (withCredentials == null) {\n    withCredentials = false;\n  }\n  switch (typeof resource) {\n    case \"object\":\n      this.loadData(resource);\n      break;\n    case \"string\":\n      this.loadURL(resource, withCredentials);\n      break;\n    default:\n      throw new Error(\"[AMP ERROR] Invalid default configuration resource\");\n  }\n};\n\n/**\n*/\nAMPConfig.prototype.setReadyState = function(state) {\n  this.readyState = state;\n  this.dispatchEvent(new Event(\"readystatechange\", state));\n  if (state === AMPConfig.LOADED && !this.loaded) {\n    this.loaded = true;\n    this.dispatchEvent(new Event(\"load\", this.data));\n  }\n};\n\n/**\n * The CaptionCue class.\n *   \n * @constructor\n * @private\n * @param {number} startTime  The start time of the cue in seconds\n * @param {number} endTime    The end time of the cue in seconds\n * @param {number} text       The text of the cue\n*/\nfunction CaptionCue(startTime, endTime, id) {\n  this.startTime = startTime;\n  this.endTime = endTime;\n  this.id = id;\n}\n\nCaptionCue.prototype.id = null;\n\nCaptionCue.prototype.startTime = null;\n\nCaptionCue.prototype.endTime = null;\n\nCaptionCue.prototype.text = null;\n\nCaptionCue.prototype.html = null;\n\nCaptionCue.prototype.align = null;\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar FeatureNotifications = {\n  REGISTER_FEATURE: \"registerfeature\"\n};\n\nfunction SRTParser() {}\n\n/**\n * Parses a SRT (subrip) file into CaptionCue objects and attaches them to a given track.\n *\n * @param   {CaptionTrack}  track The caption track to populate\n * @param   {String}        txt   The text of the srt file\n * @return  {CaptionTrack}        The populated caption track\n*/\nSRTParser.prototype.parse = function(track, txt) {\n  var caption, captions, cue, end, index, parts, start, text, times, _i, _len;\n  txt = txt.replace(/\\r/g, '');\n  captions = txt.split(\"\\n\\n\");\n  for (_i = 0, _len = captions.length; _i < _len; _i++) {\n    caption = captions[_i];\n    parts = caption.split(\"\\n\");\n    try {\n      index = parts[0];\n      times = parts[1].match(/([0-9:\\,]+)\\s*-->\\s*([0-9:\\,]+)/).slice(1);\n      start = Utils.flattenTimecode(times[0]);\n      end = Utils.flattenTimecode(times[1]);\n      text = parts.slice(2);\n    } catch (err) {\n      Logger.instance.warn(\"SRT Parsing Warning\");\n    }\n    cue = new CaptionCue(start, end, \"cue_\" + index);\n    cue.html = \"<p>\" + text.join(\"<br />\") + \"</p>\";\n    cue.text = text.join(\"\\n\");\n    track.cues.push(cue);\n  }\n  return track;\n};\n\nfunction WebVTTParser() {}\n\n/**\n * Parses a SRT (subrip) file into CaptionCue objects and attaches them to a given track.\n *\n * @param   {CaptionTrack}  track The caption track to populate\n * @param   {String}        txt   The text of the srt file\n * @return  {CaptionTrack}        The populated caption track\n*/\nWebVTTParser.prototype.parse = function(track, txt) {\n  var caption, captions, cue, end, index, parts, settings, start, text, times, _i, _len;\n  txt = txt.replace(/\\r/g, '');\n  captions = txt.split(\"\\n\\n\");\n  index = 0;\n  if (/^WEBVTT/.test(captions[0])) {\n    captions.shift();\n  }\n  for (_i = 0, _len = captions.length; _i < _len; _i++) {\n    caption = captions[_i];\n    if (!(caption !== \"\")) {\n      continue;\n    }\n    parts = caption.trim().split(\"\\n\");\n    try {\n      index = /^[0-9]+$/.test(parts[0]) ? parts.shift() : ++index;\n      times = parts[0].match(/([0-9:\\.]+)\\s*-->\\s*([0-9:\\.]+)([^\\n]*)/).slice(1);\n      settings = times[2];\n      start = Utils.flattenTimecode(times[0]);\n      end = Utils.flattenTimecode(times[1]);\n      text = parts.slice(1);\n      cue = new CaptionCue(start, end, \"cue_\" + index);\n      cue.html = \"<p>\" + text.join(\"<br />\") + \"</p>\";\n      cue.text = text.join(\"\\n\");\n      if (settings != null) {\n        settings.replace(/\\s*([A-Za-z]+)\\s*:\\s*([\\w\\-\\%]+)/g, function(match, $1, $2) {\n          cue[$1] = $2;\n          return \"\";\n        });\n      }\n      track.cues.push(cue);\n    } catch (err) {\n      Logger.instance.error(\"WebVTT Parse Error\");\n    }\n  }\n  return track;\n};\n\nfunction SMPTETTParser() {}\n\n/**\n * Parses a SMPTETT file into CaptionCue objects and attaches them to a given track.\n * \n * @param   {CaptionTrack}  track The caption track to populate\n * @param   {XMLDocument}   xml   The SMPTETT xml document\n * @return  {CaptionTrack}        The populated caption track\n*/\nSMPTETTParser.prototype.parse = function(track, xml) {\n  var captions, lang, styledElements, styles, tt,\n    _this = this;\n  if (typeof xml === \"string\") {\n    xml = XMLUtils.parse(xml);\n  }\n  styles = Array.prototype.slice.call(xml.querySelectorAll(\"styling style\"));\n  styles.forEach(function(item, index, list) {\n    var attributes, id, style;\n    style = \"\";\n    id = item.getAttribute(\"id\") || item.getAttribute(\"xml:id\");\n    attributes = Array.prototype.slice.call(item.attributes);\n    attributes.forEach(function(item, index, array) {\n      if (item.prefix === \"tts\") {\n        return style += Utils.formatStyleName(item.localName) + \":\" + item.nodeValue + \";\";\n      }\n    });\n    track.styles[id] = style;\n  });\n  styledElements = Array.prototype.slice.call(xml.querySelectorAll(\"body [style]\"));\n  styledElements.forEach(function(item, index, array) {\n    var id;\n    id = item.getAttribute(\"style\");\n    item.setAttribute(\"style\", track.styles[id]);\n  });\n  tt = xml.querySelector(\"tt\");\n  lang = tt.getAttribute(\"lang\") || tt.getAttribute(\"xml:lang\");\n  if (track.language === void 0 || track.language === null) {\n    track.language = lang;\n  }\n  captions = Array.prototype.slice.call(xml.querySelectorAll(\"body p[begin]\"));\n  captions.forEach(function(item, index, array) {\n    var align, cue, end, start, text;\n    start = item.getAttribute(\"begin\");\n    item.removeAttribute(\"begin\");\n    if (item.getAttribute(\"end\") != null) {\n      end = item.getAttribute(\"end\");\n      item.removeAttribute(\"end\");\n    } else if (captions[index + 1] != null) {\n      end = captions[index + 1].getAttribute(\"begin\");\n    }\n    cue = new CaptionCue(Utils.flattenTimecode(start), Utils.flattenTimecode(end), \"cue_\" + index);\n    align = item.getAttributeNS(\"http://www.w3.org/ns/ttml#styling\", \"textAlign\");\n    if (align != null) {\n      cue.align = align === \"center\" ? \"middle\" : align;\n      item.removeAttributeNS(\"http://www.w3.org/ns/ttml#styling\", \"textAlign\");\n    }\n    text = XMLUtils.serialize(item);\n    text = text.replace(/\\s*xmlns=\"[^\"]*\"/, \"\");\n    cue.html = text;\n    text = text.replace(/^<p[^>]*>/, \"\");\n    text = text.replace(/<\\/p>$/, \"\");\n    text = text.replace(/<br\\/>/, \"\\n\");\n    text = text.replace(/<span style=\"([^\"]*)\"/, \"<c.$1\");\n    text = text.replace(/<\\/span>/, \"</c>\");\n    cue.text = text;\n    track.cues.push(cue);\n  });\n  return track;\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction LiveCaptionProxy() {\n  var com,\n    _this = this;\n  this.captions = [];\n  this.head = document.getElementsByTagName(\"head\")[0];\n  com = window.com || {};\n  com.akamai = com.akamai || {};\n  com.akamai.amp = com.akamai.amp || {};\n  com.akamai.amp.plugins = com.akamai.amp.plugins || {};\n  com.akamai.amp.plugins.subply = com.akamai.amp.plugins.subply || {};\n  com.akamai.amp.plugins.subply.response = function(json) {\n    _this.parse(json);\n    _this.poll();\n  };\n  if (!(window.com != null)) {\n    window.com = com;\n  }\n  LiveCaptionProxy.__super__.constructor.call(this, this.constructor.NAME);\n}\n\n\n__extends(LiveCaptionProxy, puremvc.Proxy);\n\n\n/** @static\n*/\nLiveCaptionProxy.NAME = \"LiveCaptionProxy\";\n\nLiveCaptionProxy.prototype.data = {\n  base: \"http://test.plymedia.com.s3.amazonaws.com/online/Akamai_\",\n  interval: 1000\n};\n\nLiveCaptionProxy.prototype.caption = null;\n\nLiveCaptionProxy.prototype.head = null;\n\nLiveCaptionProxy.prototype.script = null;\n\nLiveCaptionProxy.prototype.timeout = null;\n\n/**\n *\n*/\nLiveCaptionProxy.prototype.getURL = function() {\n  return this.data.url;\n};\n\nLiveCaptionProxy.prototype.setURL = function(value) {\n  this.data.url = value;\n  return value;\n};\n\nLiveCaptionProxy.prototype.start = function() {\n  this.send();\n};\n\nLiveCaptionProxy.prototype.poll = function() {\n  var timeout,\n    _this = this;\n  timeout = setTimeout(function() {\n    _this.send();\n  }, this.data.interval || 1000);\n};\n\nLiveCaptionProxy.prototype.send = function() {\n  var _this = this;\n  if (this.script != null) {\n    this.head.removeChild(this.script);\n  }\n  this.script = Utils.loadScript(this.data.base + this.data.url + \".js?nocache=\" + Date.now()).then(function(script) {\n    return _this.script = script;\n  })[\"catch\"](function(error) {\n    return _this.facade.logger.error(\"[AMP CAPTIONING ERROR]\", error);\n  });\n};\n\nLiveCaptionProxy.prototype.stop = function() {\n  clearTimeout(timeout);\n};\n\n/**\n *\n*/\nLiveCaptionProxy.prototype.parse = function(response) {\n  var html, text, _i, _len, _ref;\n  if (response.Stream !== this.data.url) {\n    return;\n  }\n  if ((this.caption != null) && this.caption.id >= response.Ticks) {\n    return;\n  }\n  this.caption = new CaptionCue(Utils.flattenTimecode(response.From), Utils.flattenTimecode(response.To), response.Ticks);\n  this.caption.text = response.Text;\n  html = \"\";\n  _ref = response.Text.split(\"\\n\");\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    text = _ref[_i];\n    if (html !== \"\") {\n      html += \"<br />\";\n    }\n    html += \"<span>\" + text + \"</span>\";\n  }\n  this.caption.html = \"<p>\" + html + \"</p>\";\n  this.sendNotification(CaptioningNotifications.CUE_CHANGE, [this.caption]);\n  return this.caption;\n};\n\n/**\n * @constructor\n*/\nfunction AMP() {}\n\n/**\n * Create a player based on the configuration object and container.\n *\n * @param {string|HTMLElement} container\n *    The id of the div the player will be attached to.\n *\n * @param {?(Object|string)} config\n *    The configuration override object.\n *\n * @param {?Function} onready\n *    Optional ready handler.\n *\n * @return {Player}\n *\n*/\nAMP.create = function(container, config, onready) {\n  var element, initTime, player, version;\n  initTime = Date.now();\n  if (typeof container === \"string\") {\n    element = document.getElementById(container);\n    if (!(element != null)) {\n      element = document.querySelector(container);\n    }\n  } else {\n    element = container;\n  }\n  if (!(element != null)) {\n    throw new Error(\"[AMP ERROR] Invalid container. Could not find DOM element: \" + container);\n  }\n  config = config instanceof Config ? config : Config.create(config);\n  Logger.instance = new Logger(config.debug);\n  version = this.getVersion();\n  if (element.dataset == null) {\n    element.dataset = {};\n  }\n  element.dataset[\"amp.version\"] = version;\n  Logger.instance.log(\"[AMP] \" + version);\n  player = this.createPlayer(config, element);\n  player.initTime = player.performance.init = initTime;\n  element.amp = player;\n  player.request = this.request.bind(this);\n  player.require = this.require.bind(this);\n  player.loadResources = player.loadModuleResources.bind(player);\n  player.onready = onready;\n  player.initialize(config);\n  Utilization.track(\"create\");\n  return player;\n};\n\n/**\n *\n*/\nAMP.createPlayer = function(config, container) {\n  var player;\n  player = this.players[config.mode];\n  if (player != null) {\n    player = new player(container);\n  }\n  return player;\n};\n\n/**\n * Returns the version string for this player library.\n *\n * @return {string} The version string.\n*/\nAMP.getVersion = function() {\n  return this.VERSION;\n};\n\n/**\n * The player version string\n *\n * @type {string}\n * @private\n * @static\n*/\nAMP.VERSION = \"AMP - Premier : WebMD v2.99.6\";\n\n/**\n * @private\n*/\nAMP.defaults = new AMPConfig();\n\n/**\n * @private\n*/\nAMP.plugins = [];\n\n/**\n * @private\n*/\nAMP.players = {};\n\n/**\n * Loads a default configuration object from a url.\n *\n * @param {string} url\n *    A url to a configuration json file to use at the defaults object.\n *\n * @param {?Function} loaded\n *    Callback function triggered when the file has been loaded and\n *    sucessfully parsed.\n *\n * @param {?Function} error\n *    Callback function triggered when the file has failed to load\n *    or cannot be parsed.\n *\n * @param {boolean} [withCredentials=false]\n *    Whether or not to use credntials when making XMLHttpRequest.\n *\n * @static\n*/\nAMP.loadDefaults = function(url, loaded, error, withCredentials) {\n  if (withCredentials == null) {\n    withCredentials = false;\n  }\n  if (loaded != null) {\n    this.defaults.addEventListener(\"load\", loaded);\n  }\n  if (error != null) {\n    this.defaults.addEventListener(\"error\", error);\n  }\n  this.defaults.load(url, withCredentials);\n};\n\n/**\n * Returns the playback mode best suited for the current environment.\n *\n * @return {PlaybackMode}\n *    The playback mode.\n *\n * @static\n*/\nAMP.getPlaybackMode = function() {\n  return Utils.getPlaybackMode();\n};\n\n/**\n * @private\n * @static\n*/\nAMP.registerPlayer = function(mode, player) {\n  this.players[mode] = player;\n};\n\n/**\n * Registers a plugin factory function. This function is\n * called when akamai.amp.AMP.create is called and the\n * config object contains the plugin key.\n *\n * @param {String} key\n *    The plugin key. Used to configure the plugin.\n *\n * @param {String|Array.<String>} mode\n *    The player mode(s) in which the plugin can be used.\n *\n * @param {Function} factory\n *\n * @static\n*/\nAMP.registerPlugin = function(id, mode, plugin) {\n  var item, _base, _i, _len, _ref;\n  if ((_base = this.plugins)[id] == null) {\n    _base[id] = {};\n  }\n  if (typeof mode === \"function\") {\n    _ref = [plugin, mode], mode = _ref[0], plugin = _ref[1];\n  }\n  if (typeof mode === \"string\") {\n    mode = [mode];\n  }\n  if (!(mode != null)) {\n    mode = [\"html\", \"flash\"];\n  }\n  for (_i = 0, _len = mode.length; _i < _len; _i++) {\n    item = mode[_i];\n    this.plugins[id][item] = plugin;\n  }\n};\n\n/**\n * @type {akamai.amp.ResourceManager}\n * @private\n*/\nAMP.resourceManager = null;\n\n/**\n * Short cut getter for the global renderer manager\n *\n * @return {akamai.amp.ResourceManager}\n *\n * @static\n * @private\n*/\nAMP.getResourceManager = function() {\n  if (!(this.resourceManager != null)) {\n    this.resourceManager = new ResourceManager();\n  }\n  return this.resourceManager;\n};\n\n/**\n * @param {akamai.amp.Resource} resource\n *    The resource definition\n *\n * @param {Function} callback\n *\n * @static\n * @private\n*/\nAMP.addResource = function(resource) {\n  return this.getResourceManager().add(resource);\n};\n\n/**\n * @param {Array.<akamai.amp.Resource>} resources\n *    The list of resources\n *\n * @param {Function} callback\n *\n * @static\n * @private\n*/\nAMP.addResources = function(resources) {\n  return this.getResourceManager().addResources(resources);\n};\n\n/**\n * Request a http resource.\n *\n * @param {String|Object} options\n *    A url string or an object containing the following properties:\n *\n * @return {Promise.<XHR>}\n *     Promise which resolves to a XHR object\n *\n * @static\n*/\nAMP.request = function(options) {\n  return Utils.request(options);\n};\n\n/**\n * Request a http json resource.\n *\n * @param {String|Object} options\n *    A url string or an object containing the following properties:\n *\n * @return {Promise.<Object>}\n *     Promise which resolves to a js object\n *\n * @static\n*/\nAMP.requestJson = function(options) {\n  return Utils.requestJson(options);\n};\n\n/**\n * Loads resource from url or cache\n *\n * @param {String} id\n *    A url or id of the resource\n *\n * @return {Promise.<Object>}\n *     Promise which resolves to an object\n *\n * @static\n*/\nAMP.require = function(id) {\n  return this.resourceManager.require(id);\n};\n\n/**\n * @param {!string} key\n *     The resource's key\n *\n * @return {akamai.amp.Resource}\n *     The resource definition\n *\n * @static\n * @private\n*/\nAMP.getResource = function(key) {\n  return this.getResourceManager().item(key);\n};\n\n/**\n * @param {!string} key\n *     The resource's key\n *\n * @return {Function}\n *     The resource's constructor\n *\n * @static\n * @private\n*/\nAMP.removeResource = function(key) {\n  return this.getResourceManager().remove(key);\n};\n\n/**\n * Evaluate a data bound object.\n *\n * @param {Object} binding\n *   The data bound object.\n *\n * @param {Object} context\n *   The context object used as \"global\" when evaluating the binding.\n *\n * @return {string}\n *   The evaluated result\n*/\nAMP.evaluateBindings = function(value, context) {\n  return DataBinding.evaluateBindings(value, context);\n};\n\n\nAMP.registerPlayer(\"html\", HTMLPlayer);\nAMP.registerPlayer(\"flash\", FlashPlayer);\nAMP.registerPlayer(\"none\", InstallPlayer);\nAMP.registerPlayer(\"external\", ExternalPlayer);\n\n/**\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction PluginCommand() {\n  PluginCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PluginCommand, PlayerCommand);\n\n\nPluginCommand.prototype.plugin = null;\n\nPluginCommand.prototype.proxy = null;\n\n/** @override\n*/\nPluginCommand.prototype.initializeNotifier = function(key) {\n  PluginCommand.__super__.initializeNotifier.call(this, key);\n  this.proxy = this.facade.retrieveProxy(ModuleProxy.NAME);\n  this.plugin = this.facade;\n};\n\n/**\n * The CaptioningChangeMediaCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction CaptioningChangeMediaCommand() {\n  CaptioningChangeMediaCommand.__super__.constructor.call(this);\n}\n\n\n__extends(CaptioningChangeMediaCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nCaptioningChangeMediaCommand.prototype.execute = function(notification) {\n  var media, track;\n  media = notification.getBody();\n  track = notification.getBody().track;\n  this.proxy.setTracks(track);\n  if (!(track != null)) {\n    this.sendNotification(CaptioningNotifications.ENABLED, false);\n    return;\n  }\n  this.proxy.selectRenderer(media);\n  this.sendNotification(CaptioningNotifications.ENABLED, true);\n};\n\n/**\n * @constructor\n * @private\n * @extends {amp.player.controller.PlayerCommand}\n*/\nfunction PluginEventCommand() {\n  PluginEventCommand.__super__.constructor.call(this);\n}\n\n\n__extends(PluginEventCommand, PluginCommand);\n\n\n/**\n *\n*/\nPluginEventCommand.prototype.dispatchEvent = function(type, detail) {\n  var event, name, _base;\n  if (typeof type !== \"string\") {\n    detail = type.getBody();\n    if (!(detail != null)) {\n      detail = {};\n    }\n    type = type.getName();\n  }\n  name = typeof (_base = this.plugin).getFeatureName === \"function\" ? _base.getFeatureName() : void 0;\n  if ((name != null) && name !== \"auth\") {\n    type = type.replace(new RegExp(\"^(\" + name + \")\"), \"\");\n  }\n  name = this.plugin.getModuleName();\n  type = type.replace(new RegExp(\"^(\" + name + \")\"), \"\");\n  event = new Event(type, detail);\n  this.sendNotification(Notifications.DISPATCH_EVENT, event);\n};\n\n/**\n *\n*/\nPluginEventCommand.prototype.dispatchEventAfterCommand = function(type, detail) {\n  setTimeout(this.dispatchEvent.bind(this, type, detail), 0);\n};\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nPluginEventCommand.prototype.execute = function(notification) {\n  this.dispatchEvent(notification);\n};\n\n/**\n * The CaptioningEnabledCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction CaptioningEnabledCommand() {\n  CaptioningEnabledCommand.__super__.constructor.call(this);\n}\n\n\n__extends(CaptioningEnabledCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nCaptioningEnabledCommand.prototype.execute = function(notification) {\n  this.proxy.setEnabled(notification.getBody());\n  CaptioningEnabledCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar UserSettingsNotifications = {\n  SETTING_CHANGE: \"settingchange\",\n  UPDATE_SETTINGS: \"updatesettings\"\n};\n\n/**\n * The ChangeVisibilityCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction CaptioningVisibilityChangeCommand() {\n  CaptioningVisibilityChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(CaptioningVisibilityChangeCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nCaptioningVisibilityChangeCommand.prototype.execute = function(notification) {\n  var hidden;\n  hidden = !notification.getBody();\n  if (hidden === this.proxy.getHidden()) {\n    return;\n  }\n  this.proxy.setHidden(hidden);\n  CaptioningVisibilityChangeCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The CaptioningTimeUpdateCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction CaptioningTimeUpdateCommand() {\n  CaptioningTimeUpdateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(CaptioningTimeUpdateCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nCaptioningTimeUpdateCommand.prototype.execute = function(notification) {\n  var active, changed, cue, cues, index, time, track, _i, _len;\n  time = notification.getBody();\n  track = this.proxy.getTrack();\n  if (!(track != null)) {\n    return;\n  }\n  active = track.activeCues;\n  cues = track.cues;\n  changed = false;\n  for (_i = 0, _len = cues.length; _i < _len; _i++) {\n    cue = cues[_i];\n    if (time >= cue.startTime && time < cue.endTime) {\n      if (!(__indexOf.call(active, cue) >= 0)) {\n        active.push(cue);\n        changed = true;\n      }\n    } else {\n      index = active.indexOf(cue);\n      if (index !== -1) {\n        active.splice(index, 1);\n        changed = true;\n      }\n    }\n  }\n  if (changed === true) {\n    this.sendNotification(CaptioningNotifications.CUE_CHANGE, active);\n  }\n};\n\n/**\n * The CaptioningStartedCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction CaptioningStartedCommand() {\n  CaptioningStartedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(CaptioningStartedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nCaptioningStartedCommand.prototype.execute = function(notification) {\n  var proxy, track, _ref;\n  proxy = this.facade.retrieveProxy(CaptioningProxy.NAME);\n  track = proxy.getTrack();\n  if (!(track != null) && ((_ref = proxy.getTracks()) != null ? _ref.length : void 0) > 0) {\n    track = proxy.autoSelectTrack();\n  }\n  if ((track != null ? track.isLive : void 0) === true) {\n    this.facade.removeCommand(Notifications.TIME_UPDATE);\n    proxy = this.facade.retrieveProxy(LiveCaptionProxy.NAME);\n    if (!(proxy != null)) {\n      proxy = new LiveCaptionProxy();\n      this.facade.registerProxy(proxy);\n    }\n    proxy.setURL(track.src);\n    proxy.start();\n  }\n};\n\n/** \n * @private\n*/\n\nCaptionParsers = {\n  \"application/ttml+xml\": new SMPTETTParser(),\n  \"application/x-subrip\": new SRTParser(),\n  \"text/vtt\": new WebVTTParser(),\n  undefined: new SMPTETTParser()\n};\n\n/** \n * @param {FlashPlayer} player\n * @param {Object} config\n * @constructor\n * @private\n * @extends {puremvc.Mediator}\n*/\nfunction PluginWrapper(player, config) {\n  this.player = player;\n  this.config = config;\n  PluginWrapper.__super__.constructor.call(this);\n  this.dispatcher = new EventDispatcher(this);\n  this.createDefaults();\n}\n\n\n__extends(PluginWrapper, puremvc.Mediator);\n\n\nPluginWrapper.NAME = \"PluginWrapper\";\n\nPluginWrapper.prototype.player = null;\n\nPluginWrapper.prototype.config = null;\n\nPluginWrapper.prototype.dispatcher = null;\n\nPluginWrapper.prototype.flashPlugins = null;\n\nPluginWrapper.prototype.createFlashVars = null;\n\nPluginWrapper.prototype.createXML = null;\n\nPluginWrapper.prototype.createDefaults = function() {\n  this.player.createDefaults.call(this);\n};\n\n/**\n*/\nPluginWrapper.prototype.addEventListener = function(type, func) {\n  this.dispatcher.addEventListener(type, func);\n};\n\nPluginWrapper.prototype.logEvent = function(event) {};\n\n/**\n*/\nPluginWrapper.prototype.dispatchEvent = function(event) {\n  if (event.type !== \"timeupdate\" && event.type !== \"timeremaining\") {\n    this.player.logger.log(\"[AMP \" + (this.constructor.NAME.replace('Wrapper', '').toUpperCase()) + \" EVENT] \" + event.type, event);\n  }\n  event.player = this.player;\n  this.dispatcher.dispatchEvent(event);\n};\n\n/**\n*/\nPluginWrapper.prototype.removeEventListener = function(type, func) {\n  this.dispatcher.removeEventListener(type, func);\n};\n\n/**\n*/\nPluginWrapper.prototype.createElement = function(xml, id, parent) {\n  var element;\n  element = xml.createElement(\"element\");\n  element.setAttribute(\"id\", id);\n  if (!(parent != null)) {\n    parent = this.getControls(xml).controls;\n  }\n  if (parent != null) {\n    parent.appendChild(element);\n  }\n  return element;\n};\n\n/**\n*/\nPluginWrapper.prototype.createProperty = function(xml, key, value, parent) {\n  var property, text, val;\n  property = xml.createElement(\"property\");\n  property.setAttribute(\"key\", key);\n  if (parent != null) {\n    parent.appendChild(property);\n  }\n  if (value != null) {\n    if (typeof value === \"object\" && !(value instanceof Array)) {\n      for (key in value) {\n        val = value[key];\n        this.createProperty(xml, key, val, property);\n      }\n    } else {\n      text = XMLUtils.createTextContent(xml, value.toString());\n      property.appendChild(text);\n    }\n  }\n  return property;\n};\n\n/** @override\n*/\nPluginWrapper.prototype.listNotificationInterests = function() {\n  return [FlashNotifications.CREATE_FLASH_VARS, FlashNotifications.CREATE_XML];\n};\n\n/**\n*/\nPluginWrapper.prototype.handleNotification = function(notification) {\n  var body, name;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case FlashNotifications.CREATE_FLASH_VARS:\n      if (typeof this.createFlashVars === \"function\") {\n        this.createFlashVars(body.flashvars);\n      }\n      break;\n    case FlashNotifications.CREATE_XML:\n      if (typeof this.createXML === \"function\") {\n        this.createXML(body.xml);\n      }\n  }\n};\n\n/**\n*/\nPluginWrapper.prototype.destroy = function() {};\n\n/**\n * The CaptionTrack class.\n *\n * @constructor\n * @private\n * @param {?Object} track A generic track object.\n*/\nfunction CaptionTrack(track, onload) {\n  var _this = this;\n  CaptionTrack.__super__.constructor.call(this, {\n    kind: track.kind,\n    label: track.label || this.srclang || this.kind,\n    language: track.srclang\n  });\n  this.src = track.src;\n  this.type = track.type;\n  this.cues = track.cues || [];\n  this.styles = track.styles || {};\n  this.activeCues = [];\n  this.isLive = /live-subply/.test(this.type);\n  if ((this.src != null) && this.src !== \"\" && !this.isLive) {\n    Utils.request(this.src).then(function(xhr) {\n      try {\n        CaptionParsers[_this.type].parse(_this, xhr.response);\n      } catch (error) {\n        Logger.instance.error(\"Could not parse caption track: \" + _this.src);\n        return;\n      }\n      if (typeof onload === \"function\") {\n        onload();\n      }\n    })[\"catch\"](function(error) {\n      Logger.instance.error(\"Could not load caption track: \" + _this.src);\n    });\n  } else {\n    setTimeout(onload, 1);\n  }\n}\n\n\n__extends(CaptionTrack, Track);\n\n\nCaptionTrack.prototype.src = null;\n\nCaptionTrack.prototype.cues = null;\n\nCaptionTrack.prototype.activeCues = null;\n\nCaptionTrack.prototype.type = null;\n\nCaptionTrack.prototype.styles = null;\n\nCaptionTrack.prototype.isLive = false;\n\n/** \n * @constructor\n * @private\n*/\nfunction OverlayMediator() {\n  OverlayMediator.__super__.constructor.call(this, null, null, null, null);\n}\n\n\n__extends(OverlayMediator, ComponentMediator);\n\n\nOverlayMediator.prototype.componentType = \"overlay\";\n\n/**\n * Registers the overlay.\n * \n * @override\n*/\nOverlayMediator.prototype.onRegister = function() {\n  OverlayMediator.__super__.onRegister.call(this);\n  this.registerOverlay();\n};\n\n/**\n * Removes the overlay.\n * \n * @override\n*/\nOverlayMediator.prototype.onRemove = function() {\n  OverlayMediator.__super__.onRemove.call(this);\n  this.removeOverlay();\n};\n\n/**\n *\n*/\nOverlayMediator.prototype.registerOverlay = function() {\n  this.sendNotification(Notifications.ADD_OVERLAY, this.viewComponent);\n};\n\n/**\n *\n*/\nOverlayMediator.prototype.removeOverlay = function() {\n  this.sendNotification(Notifications.REMOVE_OVERLAY, this.viewComponent);\n};\n\n/**\n * The CaptioningProxy class\n *\n * @constructor\n * @private\n * @extends {PluginProxy}\n * @param   {Object}  config  The configuration object.\n*/\nfunction CaptioningProxy(config) {\n  this.activeCaptions = [];\n  this.providers = {};\n  this.tracks = [];\n  this.rendererMap = [];\n  this.track = {};\n  CaptioningProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(CaptioningProxy, PluginProxy);\n\n\n/** @static\n*/\nCaptioningProxy.NAME = ModuleProxy.NAME;\n\nCaptioningProxy.TEXT_TRACK_RENDERER = \"caption-text\";\n\nCaptioningProxy.prototype.defaults = {\n  useNative: false,\n  crossorigin: null\n};\n\nCaptioningProxy.prototype.enabled = false;\n\nCaptioningProxy.prototype.hidden = true;\n\nCaptioningProxy.prototype.tracks = null;\n\nCaptioningProxy.prototype.track = null;\n\nCaptioningProxy.prototype.activeCaptions = null;\n\nCaptioningProxy.prototype.captions = null;\n\nCaptioningProxy.prototype.loaded = true;\n\nCaptioningProxy.prototype.rendererMap = null;\n\n/**\n *\n*/\nCaptioningProxy.prototype.getUseNative = function() {\n  return this.getValue(\"useNative\");\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.getCrossOrigin = function() {\n  return this.getValue(\"crossorigin\");\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.getTracks = function() {\n  return this.tracks;\n};\n\nCaptioningProxy.prototype.setTracks = function(value) {\n  var count, item, loaded, track, trackLoaded, _i, _len,\n    _this = this;\n  this.tracks = [];\n  this.track = null;\n  if (!(value != null)) {\n    return;\n  }\n  count = value.length;\n  loaded = 0;\n  trackLoaded = function() {\n    loaded++;\n    if (loaded === count) {\n      _this.sendNotification(CaptioningNotifications.TRACKS_LOADED, _this.tracks);\n      _this.autoSelectTrack();\n    }\n  };\n  for (_i = 0, _len = value.length; _i < _len; _i++) {\n    item = value[_i];\n    track = new CaptionTrack(item, trackLoaded);\n    this.tracks.push(track);\n  }\n  return value;\n};\n\n/**\n*/\nCaptioningProxy.prototype.registerRenderer = function(value) {\n  if (!(value != null)) {\n    return;\n  }\n  value.proxy = this;\n  this.rendererMap.push(value);\n};\n\n/**\n*/\nCaptioningProxy.prototype.retrieveRenderer = function(name) {\n  var value, _i, _len, _ref;\n  _ref = this.rendererMap;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    value = _ref[_i];\n    if (value.getRendererName() === name) {\n      return value;\n    }\n  }\n};\n\n/**\n*/\nCaptioningProxy.prototype.removeRenderer = function(name) {\n  var index, value;\n  value = this.retrieveRenderer(name);\n  value.proxy = null;\n  if (!(value != null)) {\n    return null;\n  }\n  index = this.rendererMap.indexOf(value);\n  this.rendererMap.splice(index, 1);\n  return value;\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.getRenderer = function() {\n  return this.renderer;\n};\n\nCaptioningProxy.prototype.setRenderer = function(value) {\n  if (value === this.renderer) {\n    return value;\n  }\n  if (this.renderer != null) {\n    this.facade.removeMediator(CaptioningProxy.TEXT_TRACK_RENDERER);\n  }\n  this.renderer = value;\n  if (this.renderer != null) {\n    this.facade.registerMediator(this.renderer);\n  }\n  return value;\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.selectRenderer = function(media) {\n  var item, renderer, track, tracks, _i, _j, _len, _len1, _ref;\n  renderer = null;\n  tracks = media.track;\n  if (!(tracks != null)) {\n    return;\n  }\n  for (_i = 0, _len = tracks.length; _i < _len; _i++) {\n    track = tracks[_i];\n    _ref = this.rendererMap;\n    for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {\n      item = _ref[_j];\n      if (!(item.canUseResource(track) === true)) {\n        continue;\n      }\n      renderer = item;\n      break;\n    }\n    if (renderer != null) {\n      break;\n    }\n  }\n  this.setRenderer(renderer);\n  return renderer;\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.getTrack = function() {\n  return this.track;\n};\n\nCaptioningProxy.prototype.setTrack = function(value) {\n  this.track = value;\n  this.captions = this.track.cues;\n  this.activeCaptions = [];\n  this.sendNotification(Notifications.CHANGE_SETTINGS, {\n    captions: {\n      track: this.track.flatten()\n    }\n  });\n  this.sendNotification(CaptioningNotifications.TRACK_SELECTED, this.track);\n  return value;\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.selectTrackByIndex = function(index) {\n  var track;\n  if ((0 <= index && index < this.tracks.length)) {\n    track = this.tracks[index];\n    this.setTrack(track);\n  }\n  return track;\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.selectTrackByLanguage = function(lang) {\n  var item, track, _i, _len, _ref;\n  _ref = this.tracks;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    item = _ref[_i];\n    if (!(item.language === lang)) {\n      continue;\n    }\n    track = item;\n    break;\n  }\n  if (track != null) {\n    this.setTrack(track);\n  }\n  return track;\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.getHidden = function() {\n  return this.hidden;\n};\n\nCaptioningProxy.prototype.setHidden = function(value) {\n  this.hidden = value;\n  return value;\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.getEnabled = function() {\n  return this.enabled;\n};\n\nCaptioningProxy.prototype.setEnabled = function(value) {\n  this.enabled = value;\n  return value;\n};\n\n/**\n *\n*/\nCaptioningProxy.prototype.autoSelectTrack = function() {\n  var lang, track, _ref;\n  lang = (_ref = this.facade.player.retrieveProxy(LocalizationProxy.NAME)) != null ? _ref.getLanguage() : void 0;\n  if (lang != null) {\n    lang = lang.split(\"-\").shift();\n    track = this.selectTrackByLanguage(lang);\n  }\n  if (!(track != null)) {\n    track = this.tracks[0];\n    this.setTrack(track);\n  }\n  return track;\n};\n\n/** \n * PluginMediator class.\n *   \n * @constructor\n * @private\n * @extends {OverlayMediator}\n*/\nfunction PluginComponentMediator(componentName, componentType, parent, element) {\n  PluginComponentMediator.__super__.constructor.call(this, componentName, componentType, parent, element);\n}\n\n\n__extends(PluginComponentMediator, ComponentMediator);\n\n\n/** @override\n*/\nPluginComponentMediator.prototype.initializeNotifier = function(key) {\n  PluginComponentMediator.__super__.initializeNotifier.call(this, key);\n  this.plugin = this.facade.retrieveProxy(ModuleProxy.NAME);\n  this.media = this.facade.player.retrieveProxy(MediaProxy.NAME);\n};\n\n/**\n * The CaptioningMediator class.\n *\n * @constructor\n * @private\n * @extends {PluginMediator}\n * @param {Object} viewComponent\n*/\nfunction CaptioningNativeMediator(viewComponent) {\n  CaptioningNativeMediator.__super__.constructor.call(this, viewComponent);\n}\n\n\n__extends(CaptioningNativeMediator, LocalizedMediator);\n\n\nCaptioningNativeMediator.prototype.video = null;\n\nCaptioningNativeMediator.prototype.index = -1;\n\nCaptioningNativeMediator.prototype.plugin = null;\n\nCaptioningNativeMediator.prototype.parallelement = null;\n\nCaptioningNativeMediator.prototype.paralleltimer = null;\n\nCaptioningNativeMediator.prototype.paddingvalue = 6;\n\nCaptioningNativeMediator.prototype.cueChangeListener = null;\n\nCaptioningNativeMediator.prototype.lineheight = 34;\n\nCaptioningNativeMediator.prototype.playerDefaultHeight = 648;\n\nCaptioningNativeMediator.NAME = CaptioningProxy.TEXT_TRACK_RENDERER;\n\n/**\n*/\nCaptioningNativeMediator.prototype.getRendererName = function() {\n  return \"native\";\n};\n\n/**\n*/\nCaptioningNativeMediator.prototype.canUseResource = function(resource) {\n  var hasNative, type, types, useNative;\n  if (!(resource != null)) {\n    return false;\n  }\n  hasNative = document.createElement(\"video\").textTracks != null;\n  if (!hasNative) {\n    return false;\n  }\n  types = [Utils.mimeTypes.vtt, Utils.mimeTypes.cea608, Utils.mimeTypes.cea708];\n  type = resource.type;\n  if (type === types[1] || type === types[2]) {\n    return true;\n  }\n  useNative = /iphone|ipad/.test(Utils.getDevice()) || this.proxy.getUseNative();\n  if (!useNative) {\n    return false;\n  }\n  return types.indexOf(resource.type) !== -1;\n};\n\n/**\n * @override\n*/\nCaptioningNativeMediator.prototype.onRegister = function() {\n  this.plugin = this.facade.retrieveProxy(CaptioningProxy.NAME);\n  this.cueChangeListener = this.cueChange.bind(this);\n  if (Utils.getSafariVersion() < 0) {\n    this.facade.player.getMediaElement().textTracks.addEventListener(\"addtrack\", this.updateTrack.bind(this));\n  }\n  this.facade.player.getMediaElement().textTracks.addEventListener(\"cuechange\", this.cueChangeListener);\n  if ((this.plugin != null) && (this.plugin.config != null) && !this.plugin.config.hasOwnProperty('useparallelrendering')) {\n    this.plugin.config.useparallelrendering = false;\n  }\n};\n\n/** @override\n*/\nCaptioningNativeMediator.prototype.onRemove = function() {\n  if ((this.viewComponent != null) && (this.parallelelment != null)) {\n    this.viewComponent.removeChild(this.parallelement);\n    this.facade.player.getMediaElement().textTracks.removeEventListener(\"addtrack\", this.updateTrack);\n    this.facade.player.getMediaElement().textTracks.removeEventListener(\"cuechange\", this.cueChangeListener);\n  }\n};\n\n/**\n * @override\n*/\nCaptioningNativeMediator.prototype.listNotificationInterests = function() {\n  return [CaptioningNotifications.VISIBILITY_CHANGE, CaptioningNotifications.TRACK_SELECTED, CaptioningNotifications.TRACKS_LOADED, Notifications.LOADED_METADATA, Notifications.CAN_PLAY_THROUGH, AdNotifications.BREAK_START];\n};\n\n/**\n * @override\n*/\nCaptioningNativeMediator.prototype.handleNotification = function(notification) {\n  var body, crossorigin, element, track, video, _i, _len, _ref;\n  body = notification.getBody();\n  switch (notification.getName()) {\n    case CaptioningNotifications.TRACKS_LOADED:\n      this.tracks = body;\n      break;\n    case CaptioningNotifications.TRACK_SELECTED:\n      if (this.facade.player.getMediaElement().textTracks.length) {\n        track = this.facade.player.getMediaElement().textTracks[this.index];\n      }\n      if (track != null) {\n        track.mode = \"hidden\";\n      }\n      this.index = this.plugin.getTracks().indexOf(body);\n      this.lang = body.language;\n      this.updateTrack();\n      break;\n    case CaptioningNotifications.VISIBILITY_CHANGE:\n    case Notifications.CAN_PLAY_THROUGH:\n      this.updateTrack();\n      break;\n    case AdNotifications.BREAK_START:\n      this.clearCaption();\n      break;\n    case Notifications.LOADED_METADATA:\n      if (!(this.tracks != null)) {\n        return;\n      }\n      video = this.facade.player.getMediaElement();\n      crossorigin = this.plugin.getCrossOrigin();\n      if (crossorigin != null) {\n        video.setAttribute(\"crossorigin\", crossorigin);\n      }\n      _ref = this.tracks;\n      for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n        track = _ref[_i];\n        if (!(track.type === Utils.mimeTypes.vtt)) {\n          continue;\n        }\n        element = document.createElement(\"track\");\n        element.src = track.src;\n        if (track.kind != null) {\n          element.kind = track.kind;\n        }\n        if (track.language != null) {\n          element.srclang = track.language;\n        }\n        if (track.label != null) {\n          element.label = track.label;\n        }\n        element[\"default\"] = \"default\" in track;\n        video.appendChild(element);\n      }\n      this.tracks = null;\n  }\n};\n\nCaptioningNativeMediator.prototype.updateTrack = function(event) {\n  var config, etrack, i, track, _i, _len, _ref, _ref1, _ref2;\n  config = this.plugin.config;\n  _ref = this.facade.player.getMediaElement().textTracks;\n  for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {\n    track = _ref[i];\n    if (!(/subtitles|captions/.test(track.kind) && (track.language === this.lang || !track.language.length))) {\n      continue;\n    }\n    if (!(track != null)) {\n      return;\n    }\n    this.index = i;\n    if (this.getTracksByKind(track.kind).length > 1) {\n      this.suppressDupeTracks(track.kind, [1]);\n      if (i === 1) {\n        track.mode = this.plugin.getHidden() ? \"hidden\" : \"showing\";\n      }\n    }\n    if (track.kind === \"subtitles\") {\n      track.mode = \"hidden\";\n    } else {\n      if (config.useparallelrendering === false) {\n        track.mode = this.plugin.getHidden() ? \"hidden\" : \"showing\";\n      }\n    }\n  }\n  if (event) {\n    if (((_ref1 = event.track) != null ? _ref1.kind : void 0) === \"metadata\") {\n      return;\n    }\n  }\n  if (this.plugin.getHidden()) {\n    if ((this.plugin != null) && this.plugin.config.useparallelrendering) {\n      if ((this.parallelement != null)) {\n        this.parallelement.style.display = \"none\";\n      }\n    } else {\n      this.clearCaption();\n    }\n  } else {\n    if ((this.plugin != null) && this.plugin.config.useparallelrendering) {\n      if ((this.parallelement != null)) {\n        this.parallelement.style.display = \"inline\";\n      }\n    }\n  }\n  if ((_ref2 = this.plugin) != null ? _ref2.config.useparallelrendering : void 0) {\n    etrack = null;\n    if (!this.parallelement) {\n      this.createParallelement();\n    }\n    if (event) {\n      etrack = event.track;\n    }\n    if (etrack && etrack.language !== null && etrack.language !== this.lang) {\n      return;\n    }\n    this.useParallelRendering(this.plugin.config.useparallelrendering, etrack);\n  }\n};\n\nCaptioningNativeMediator.prototype.createParallelement = function() {\n  if (this.parallelement) {\n    return;\n  }\n  this.parallelement = document.createElement(\"div\");\n  this.parallelement.className = \"akamai-caption-container\";\n  this.viewComponent.appendChild(this.parallelement);\n  return this.parallelement;\n};\n\nCaptioningNativeMediator.prototype.useParallelRendering = function(value, track) {\n  var _ref, _ref1;\n  if ((_ref = this.plugin) != null) {\n    _ref.config.useparallelrendering = value;\n  }\n  if (!track && ((_ref1 = this.facade.player.getMediaElement().textTracks) != null ? _ref1.length : void 0)) {\n    track = this.facade.player.getMediaElement().textTracks[this.index];\n  }\n  if (track) {\n    if (value === true) {\n      if (track.hasCueChangeListener === false || typeof track.hasCueChangeListener === 'undefined') {\n        track.hasCueChangeListener = true;\n        return track.addEventListener(\"cuechange\", this.cueChangeListener);\n      }\n    } else {\n      track.hasCueChangeListener = false;\n      return track.removeEventListener(\"cuechange\", this.cueChangeListener);\n    }\n  }\n};\n\nCaptioningNativeMediator.prototype.cueChange = function(event) {\n  var capText, captionTextContainerArray, computedFontSize, cssLh, currentHeight, delay, diff, endtime, i, isPriority, maxCueBottom, percentChanged, shouldScaleFont, starttime, stl, temp, xPos, yPos;\n  isPriority = this.proxy.track ? this.proxy.track.kind === event.target.kind : true;\n  if (this.plugin.getHidden() || !isPriority) {\n    return;\n  }\n  maxCueBottom = 0;\n  shouldScaleFont = false;\n  if (this.paralleltimer) {\n    clearTimeout(this.paralleltimer);\n    this.paralleltimer = null;\n  }\n  if (this.parallelement) {\n    this.parallelement.innerHTML = \"\";\n  }\n  captionTextContainerArray = [];\n  i = 0;\n  while (i < event.target.activeCues.length) {\n    if ((new RegExp(\"^\\{\\\".*}$\")).test(event.target.activeCues[i].text)) {\n      return;\n    }\n    this.parallelement.style.display = \"inline\";\n    captionTextContainerArray[i] = document.createElement('div');\n    captionTextContainerArray[i].className = 'akamai-caption-text';\n    this.viewComponent.getElementsByClassName('akamai-caption-container')[0].appendChild(captionTextContainerArray[i]);\n    capText = document.createElement('p');\n    captionTextContainerArray[i].appendChild(capText);\n    cssLh = window.getComputedStyle(capText).lineHeight.replace(\"px\", \"\");\n    if (cssLh) {\n      this.lineheight = cssLh;\n    }\n    xPos = void 0;\n    if (navigator.userAgent.indexOf('Firefox') !== -1) {\n      xPos = event.target.activeCues[i].position - 50 + '%';\n    } else {\n      xPos = event.target.activeCues[i].position + '%';\n    }\n    yPos = void 0;\n    currentHeight = this.facade.player.getMediaElement().getBoundingClientRect().height;\n    percentChanged = currentHeight / this.playerDefaultHeight * 100;\n    stl = event.target.activeCues[i].snapToLines;\n    if (stl !== null && (event.target.activeCues[i].snapToLines === true || typeof stl === 'undefined')) {\n      yPos = event.target.activeCues[i].line * (this.lineheight / 100 * percentChanged);\n    } else {\n      yPos = currentHeight / 100 * event.target.activeCues[i].line * 10;\n    }\n    if (i > 0 && yPos) {\n      diff = this.viewComponent.getElementsByClassName('akamai-caption-container')[0].childNodes[0].offsetHeight - (this.lineheight / 100 * percentChanged);\n      yPos = yPos + diff * i;\n    }\n    yPos = yPos + 'px';\n    captionTextContainerArray[i].style.left = xPos;\n    captionTextContainerArray[i].style.top = yPos;\n    captionTextContainerArray[i].style.textAlign = 'left';\n    captionTextContainerArray[i].style.position = 'absolute';\n    captionTextContainerArray[i].style.bottom = 'auto';\n    captionTextContainerArray[i].style.display = 'inline';\n    captionTextContainerArray[i].style.padding = this.paddingvalue + 'px';\n    captionTextContainerArray[i].style.width = 'auto';\n    captionTextContainerArray[i].style['min-height'] = '0px';\n    capText.innerHTML = event.target.activeCues[i].text;\n    capText.style.margin = '0px';\n    capText.style.display = 'block';\n    capText.style.lineHeight = \"normal\";\n    computedFontSize = null;\n    try {\n      temp = document.createElement('span');\n      temp.style.fontSize = JSON.parse(localStorage.getItem(\"akamai-captioningDefault\")).size;\n      captionTextContainerArray[i].appendChild(temp);\n      computedFontSize = window.getComputedStyle(temp).fontSize.replace(\"px\", \"\");\n      temp = null;\n    } catch (_error) {}\n    if (computedFontSize) {\n      if (shouldScaleFont) {\n        computedFontSize = computedFontSize / 100 * percentChanged;\n        capText.style.fontSize = computedFontSize + \"px\";\n      }\n      maxCueBottom = Math.max(maxCueBottom, (Number(yPos.replace(\"px\", \"\")) || 0) + captionTextContainerArray[i].getBoundingClientRect().height);\n    }\n    if (i === event.target.activeCues.length - 1) {\n      endtime = event.target.activeCues[i].endTime ? event.target.activeCues[i].endTime : 0;\n      starttime = event.target.activeCues[i].startTime ? event.target.activeCues[i].startTime : 0;\n      delay = (endtime - starttime) * 1000;\n      if (delay > 500) {\n        this.paralleltimer = setTimeout(this.clearCaption.bind(this), delay);\n      }\n    }\n    i++;\n  }\n  if (maxCueBottom > currentHeight) {\n    maxCueBottom = maxCueBottom - currentHeight;\n    i = 0;\n    while (i < captionTextContainerArray.length) {\n      captionTextContainerArray[i].style.top = (Number(captionTextContainerArray[i].style.top.replace(\"px\", \"\")) - maxCueBottom) + \"px\";\n      i++;\n    }\n  }\n};\n\nCaptioningNativeMediator.prototype.clearCaption = function() {\n  if (this.paralleltimer) {\n    clearTimeout(this.paralleltimer);\n    this.paralleltimer = null;\n  }\n  if (this.parallelement) {\n    this.parallelement.innerHTML = \"\";\n  }\n};\n\nCaptioningNativeMediator.prototype.getTracksByKind = function(kind) {\n  var stracks, track, tracks, _i, _len;\n  tracks = this.facade.player.getMediaElement().textTracks;\n  stracks = [];\n  for (_i = 0, _len = tracks.length; _i < _len; _i++) {\n    track = tracks[_i];\n    if (track.kind === kind && track.language === \"en\") {\n      stracks.push(track);\n    }\n  }\n  return stracks;\n};\n\nCaptioningNativeMediator.prototype.suppressDupeTracks = function(kind, exclude) {\n  var i, track, _i, _len, _ref;\n  _ref = this.getTracksByKind(kind);\n  for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {\n    track = _ref[i];\n    if (track.kind === kind && track.language === \"en\") {\n      if ((exclude != null) && (new RegExp(i)).test(exclude)) {\n        continue;\n      }\n      track.mode = \"hidden\";\n    }\n  }\n  return i > 0;\n};\n\n/**\n * The CaptioningHTMLMediator class.\n *\n * @constructor\n * @private\n * @extends {LocalizedMediator}\n * @param {Object} viewComponent\n*/\nfunction CaptioningHTMLMediator(viewComponent) {\n  CaptioningHTMLMediator.__super__.constructor.call(this, null, null, viewComponent, null);\n}\n\n\n__extends(CaptioningHTMLMediator, PluginComponentMediator);\n\n\nCaptioningHTMLMediator.prototype.componentName = CaptioningProxy.TEXT_TRACK_RENDERER;\n\nCaptioningHTMLMediator.prototype.captionText = null;\n\n/**\n*/\nCaptioningHTMLMediator.prototype.getRendererName = function() {\n  return \"html\";\n};\n\n/** @override\n*/\nCaptioningHTMLMediator.prototype.onRemove = function() {\n  if (this.viewComponent !== null) {\n    while (this.viewComponent.firstChild) {\n      this.viewComponent.removeChild(this.viewComponent.firstChild);\n    }\n  }\n};\n\n/**\n*/\nCaptioningHTMLMediator.prototype.canUseResource = function(resource) {\n  var types;\n  if (!(resource != null)) {\n    return false;\n  }\n  types = [Utils.mimeTypes.srt, Utils.mimeTypes.ttml, Utils.mimeTypes.vtt];\n  return types.indexOf(resource.type) !== -1;\n};\n\n/* Get Caption Container Display Height\n*/\nCaptioningHTMLMediator.prototype.getCaptionDisplayHeight = function() {\n  var height, i, length;\n  height = 0;\n  i = length = this.viewComponent.childNodes.length;\n  while (i) {\n    --i;\n    if (length === 3 && i === 0) {\n      break;\n    }\n    height += Utils.getActualSize(this.viewComponent.childNodes[i]).height;\n  }\n  return height + \"px\";\n};\n\n/* Scroll Captions\n*/\nCaptioningHTMLMediator.prototype.scrollCaptions = function(scrollHeight, scrollTop, steps) {\n  var scroll, stepSize,\n    _this = this;\n  if (scrollHeight == null) {\n    scrollHeight = this.viewComponent.scrollHeight;\n  }\n  if (scrollTop == null) {\n    scrollTop = this.viewComponent.scrollTop;\n  }\n  if (steps == null) {\n    steps = 20;\n  }\n  stepSize = (scrollHeight - scrollTop) / steps;\n  scroll = function() {\n    var _results;\n    if (scrollTop < scrollHeight) {\n      _this.viewComponent.scrollTop = scrollTop += stepSize;\n      return setTimeout(scroll, 20);\n    } else {\n      _results = [];\n      while (_this.viewComponent.childNodes.length > 2) {\n        _results.push(_this.viewComponent.removeChild(_this.viewComponent.firstChild));\n      }\n      return _results;\n    }\n  };\n  scroll();\n};\n\n/**\n * @override\n*/\nCaptioningHTMLMediator.prototype.listNotificationInterests = function() {\n  return [CaptioningNotifications.CUE_CHANGE, Notifications.CHANGE_MEDIA];\n};\n\n/**\n * @override\n*/\nCaptioningHTMLMediator.prototype.handleNotification = function(notification) {\n  var body, captions, child, childNode, cue, i, name, settings, temp, _i, _j, _k, _len, _len1, _len2, _ref, _ref1;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.CHANGE_MEDIA:\n      this.viewComponent.innerHTML = \"\";\n      break;\n    case CaptioningNotifications.CUE_CHANGE:\n      settings = this.facade.player.settings.captions || {};\n      captions = \"\";\n      settings.scroll = settings.scroll.toLowerCase().replace('-', '');\n      for (_i = 0, _len = body.length; _i < _len; _i++) {\n        cue = body[_i];\n        _ref = this.viewComponent.children;\n        for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {\n          child = _ref[_j];\n          if ((new RegExp(cue.html)).test(child.outerHTML) && settings.scroll === \"popout\") {\n            continue;\n          }\n        }\n        captions += cue.html;\n      }\n      if (settings.scroll === \"painton\") {\n        this.classList.add(\"captioning-typed\");\n      } else {\n        this.classList.remove(\"captioning-typed\");\n      }\n      switch (settings.scroll) {\n        case \"popout\":\n          this.viewComponent.innerHTML = captions;\n          break;\n        case \"rollon\":\n        case \"painton\":\n          temp = document.createElement(\"div\");\n          temp.innerHTML = captions;\n          _ref1 = temp.childNodes;\n          for (i = _k = 0, _len2 = _ref1.length; _k < _len2; i = ++_k) {\n            childNode = _ref1[i];\n            if (this.viewComponent.children.length && (new RegExp(childNode.innerText)).test(this.viewComponent.lastChild.innerText)) {\n              continue;\n            }\n            this.viewComponent.appendChild(childNode);\n          }\n          this.viewComponent.style.maxHeight = this.getCaptionDisplayHeight();\n          this.scrollCaptions();\n      }\n  }\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar CaptioningNotifications = {\n  VISIBILITY_CHANGE: \"captioningvisibilitychange\",\n  ENABLED: \"captioningenabled\",\n  TRACKS_LOADED: \"captioningtracksloaded\",\n  TRACK_SELECTED: \"captioningtrackselected\",\n  CUE_CHANGE: \"captioningcuechange\",\n  SETTINGS_VISIBILITY_CHANGE: \"captioningsettingsvisibility\",\n  TOGGLE_SETTINGS_VISIBILITY: \"togglesettingsvisibility\",\n  SETTINGS_CHANGE: \"captioningsettingschange\"\n};\n\nfunction LocalizationConstants() {}\n\nLocalizationConstants.MSG_LIVE = \"MSG_LIVE\";\n\nLocalizationConstants.MSG_REPLAY = \"MSG_REPLAY\";\n\nLocalizationConstants.MSG_BUFFERING = \"MSG_BUFFERING_TEXT\";\n\nLocalizationConstants.MSG_CC = \"MSG_CC\";\n\nLocalizationConstants.MSG_CC_TITLE = \"MSG_CC_TITLE\";\n\nLocalizationConstants.MSG_CC_LANGUAGE = \"MSG_CC_LANGUAGE\";\n\nLocalizationConstants.MSG_CC_PRESETS = \"MSG_CC_PRESETS\";\n\nLocalizationConstants.MSG_CC_FONT = \"MSG_CC_FONT\";\n\nLocalizationConstants.MSG_CC_EDGE = \"MSG_CC_EDGE\";\n\nLocalizationConstants.MSG_CC_SIZE = \"MSG_CC_SIZE\";\n\nLocalizationConstants.MSG_CC_SCROLL = \"MSG_CC_SCROLL\";\n\nLocalizationConstants.MSG_CC_COLOR = \"MSG_CC_COLOR\";\n\nLocalizationConstants.MSG_CC_BACKGROUND = \"MSG_CC_BACKGROUND\";\n\nLocalizationConstants.MSG_CC_EDGE = \"MSG_CC_EDGE\";\n\nLocalizationConstants.MSG_CC_WINDOW = \"MSG_CC_WINDOW\";\n\nLocalizationConstants.MSG_CC_OPACITY = \"MSG_CC_OPACITY\";\n\nLocalizationConstants.MSG_CC_SHOW_ADVANCED = \"MSG_CC_SHOW_ADVANCED\";\n\nLocalizationConstants.MSG_CC_HIDE_ADVANCED = \"MSG_CC_HIDE_ADVANCED\";\n\nLocalizationConstants.MSG_CC_RESET = \"MSG_CC_RESET\";\n\nLocalizationConstants.MSG_CC_CANCEL = \"MSG_CC_CANCEL\";\n\nLocalizationConstants.MSG_CC_APPLY = \"MSG_CC_APPLY\";\n\nLocalizationConstants.MSG_CC_PREVIEW_TEXT = \"MSG_CC_PREVIEW_TEXT\";\n\nLocalizationConstants.MSG_SECONDS = \"MSG_SECONDS\";\n\nLocalizationConstants.MSG_RECOMMENDATIONS_TITLE = \"MSG_RECOMMENDATIONS_TITLE\";\n\nLocalizationConstants.MSG_NEXT_VIDEO = \"MSG_NEXT_VIDEO\";\n\nLocalizationConstants.MSG_NEXT_AD = \"MSG_NEXT_AD\";\n\nLocalizationConstants.MSG_TIME_SEPARATOR = \"MSG_TIME_SEPARATOR\";\n\nLocalizationConstants.MSG_VIEW_ALL = \"MSG_VIEW_ALL\";\n\nLocalizationConstants.MSG_VIDEO = \"MSG_VIDEO\";\n\n/** \n * PluginMediator class.\n *   \n * @constructor\n * @private\n * @extends {OverlayMediator}\n*/\nfunction PluginMediator() {\n  PluginMediator.__super__.constructor.call(this);\n}\n\n\n__extends(PluginMediator, OverlayMediator);\n\n\n/** @override\n*/\nPluginMediator.prototype.initializeNotifier = function(key) {\n  PluginMediator.__super__.initializeNotifier.call(this, key);\n  this.plugin = this.facade.retrieveProxy(ModuleProxy.NAME);\n  this.media = this.facade.player.retrieveProxy(MediaProxy.NAME);\n};\n\n/** @override\n*/\nPluginMediator.prototype.onRegister = function() {\n  PluginMediator.__super__.onRegister.call(this);\n  this.facade.viewComponent = this.viewComponent;\n};\n\n/**\n * The CaptioningMediator class.\n *\n * @constructor\n * @private\n * @extends {PluginMediator}\n * @param {Object} viewComponent\n*/\nfunction CaptioningMediator(viewComponent) {\n  CaptioningMediator.__super__.constructor.call(this, viewComponent);\n}\n\n\n__extends(CaptioningMediator, PluginMediator);\n\n\nCaptioningMediator.prototype.componentName = \"captioning\";\n\n/**\n * @override\n*/\nCaptioningMediator.prototype.onRegister = function() {\n  CaptioningMediator.__super__.onRegister.call(this);\n  this.captioningStyle = this.create(null, document.getElementsByTagName(\"head\")[0], \"style\");\n  this.captioningStyle.type = \"text/css\";\n  this.applyStyles();\n};\n\n/**\n * @override\n*/\nCaptioningMediator.prototype.listNotificationInterests = function() {\n  return [CaptioningNotifications.VISIBILITY_CHANGE, CaptioningNotifications.ENABLED, CaptioningNotifications.TRACK_SELECTED, Notifications.SETTINGS_CHANGE];\n};\n\n/** @override\n*/\nCaptioningMediator.prototype.onRemove = function() {\n  var parent;\n  if (this.captioningStyle) {\n    parent = document.getElementsByTagName(\"head\")[0];\n    parent.removeChild(this.captioningStyle);\n  }\n};\n\n/**\n * @override\n*/\nCaptioningMediator.prototype.handleNotification = function(notification) {\n  var body, note, state;\n  body = notification.getBody();\n  note = body ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;\n  switch (notification.getName()) {\n    case CaptioningNotifications.TRACK_SELECTED:\n      state = \"cc-embedded\";\n      note = body.type === \"embedded\" ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;\n      break;\n    case CaptioningNotifications.VISIBILITY_CHANGE:\n      state = \"cc-active\";\n      break;\n    case CaptioningNotifications.ENABLED:\n      note = body ? Notifications.ADD_CONTROL_STATE : Notifications.REMOVE_CONTROL_STATE;\n      state = \"cc-enabled\";\n      if (!body) {\n        this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"cc-active\");\n      }\n      break;\n    case Notifications.SETTINGS_CHANGE:\n      if (body.captions != null) {\n        this.applyStyles();\n      }\n  }\n  this.sendNotification(note, state);\n};\n\nCaptioningMediator.prototype.applyStyles = function() {\n  var backgroundColor, color, containerStyle, edgeType, fontFamily, fontSize, id, styles, windowColor, windowColorValue;\n  styles = this.facade.settings;\n  if (styles.visible != null) {\n    this.facade.hidden = !styles.visible;\n  }\n  fontFamily = \"font-family: \" + styles.fontFamily + \" !important;\";\n  edgeType = \"\" + styles.edgeType + \" \" + styles.edgeColor + \" !important;\";\n  fontSize = \"font-size: \" + styles.size + \" !important;\";\n  color = \"color: \" + styles.fontColor + \" !important;\";\n  backgroundColor = \"background-color: \" + styles.backgroundColor + \" !important;\";\n  windowColor = \"background-color: \" + styles.windowColor + \" !important;\";\n  containerStyle = \"line-height:2.2em;\";\n  windowColorValue = windowColor.match(/rgba\\([^)]+\\)/g);\n  if ((windowColorValue != null) && windowColorValue instanceof Array && windowColorValue.length > 0) {\n    containerStyle = Number(windowColorValue[0].replace(/^.*, (.+)\\)/, '$1')) === 0 ? \"\" : containerStyle;\n  }\n  id = this.facade.player.viewComponent.id;\n  this.captioningStyle.innerHTML = '#' + id + ' .akamai-caption-text { ' + fontFamily + fontSize + edgeType + windowColor + ' } #' + id + ' .akamai-caption-text p { ' + color + backgroundColor + ' } ' + '#' + id + ' video::-webkit-media-text-track-display { ' + windowColor + ' } #' + id + ' video::-webkit-media-text-track-display span { ' + fontFamily + fontSize + edgeType + backgroundColor + ' } #' + id + ' video::-webkit-media-text-track-display { ' + windowColor + ' } #' + id + ' video::cue { ' + color + fontFamily + fontSize + edgeType + backgroundColor + ' } #' + id + ' video::-webkit-media-text-track-container {' + containerStyle + '} #' + id + ' video::-webkit-media-text-track-display-backdrop { background-color: rgba(0, 0, 0, 0) !important;}';\n};\n\n/**\n * The CaptioningWrapper class.\n *\n * @constructor\n * @private\n * @extends {PluginWrapper}\n * @param {FlashPlayer}     player  The FlashPlayer\n * @param {Object}          config  The plugin config\n*/\nfunction CaptioningWrapper(player, config) {\n  CaptioningWrapper.__super__.constructor.call(this, player, config);\n  Object.defineProperties(this, {\n    enabled: {\n      get: this.getEnabled,\n      set: this.setEnabled,\n      enumerable: true,\n      configurable: false\n    },\n    hidden: {\n      get: this.getHidden,\n      set: this.setHidden,\n      enumerable: true,\n      configurable: false\n    },\n    visible: {\n      get: this.getVisible,\n      set: this.setVisible,\n      enumerable: true,\n      configurable: false\n    },\n    tracks: {\n      get: this.getTracks,\n      enumerable: true,\n      configurable: false\n    },\n    track: {\n      get: this.getTrack,\n      set: this.setTrack,\n      enumerable: true,\n      configurable: false\n    }\n  });\n}\n\n\n__extends(CaptioningWrapper, PluginWrapper);\n\n\nCaptioningWrapper.NAME = \"CaptioningWrapper\";\n\nCaptioningWrapper.prototype.flashPlugins = [\n  {\n    id: \"AdobeCaptionPlugin\",\n    src: '#{paths.resources}plugins/AdobeCaptionPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"AdobeCaptionPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }, {\n    id: \"AMPCaptionPlugin\",\n    src: '#{paths.resources}plugins/AMPCaptionPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"AMPCaptionPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }, {\n    id: \"CaptionSettingsPlugin\",\n    src: '#{paths.resources}plugins/CaptionSettingsPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"CaptionSettingsPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }\n];\n\nCaptioningWrapper.prototype.flashView = {\n  elements: {\n    captionDisplay: {\n      attributes: {\n        defaultMessage: \"Sorry! No captions available for this stream\",\n        initState: \"cookie\",\n        position: \"relative\",\n        settingsEnabled: \"true\",\n        style: \"bottom: 0px; windowColor :0x000000; windowOpacity: 0; font: Monospaced Serif; fontColor: 0xffffff; fontOpacity: 1; fontBGColor: 0x000000; fontBGOpacity: 0; edgeType: none; edgeColor: 0x000000; edgeOpacity: 1; scroll: Pop-Out; fontSize: 12;\"\n      }\n    },\n    controls: {\n      elements: {\n        captionBtn: {}\n      }\n    }\n  }\n};\n\nCaptioningWrapper.prototype._hidden = true;\n\n/** @override\n*/\nCaptioningWrapper.prototype.createXML = function(xml) {\n  var application, player, subply, _ref;\n  subply = (_ref = this.config.flash) != null ? _ref.subply : void 0;\n  if (subply != null) {\n    try {\n      if (subply.timeMethod != null) {\n        player = xml.getElementsByTagName(\"player\")[0];\n        player.setAttribute(\"subply_time_method\", subply.timeMethod);\n      }\n      if (subply.plugin != null) {\n        application = xml.firstChild;\n        subply = xml.getElementsByTagName(\"subply\")[0];\n        if (!(subply != null)) {\n          subply = xml.createElement(\"subply\");\n          application.appendChild(subply);\n        }\n        this.createProperty(xml, \"SUBPLY_URL\", this.config.flash.subply.plugin, subply);\n      }\n    } catch (error) {\n      this.facade.logger.error(\"[AMP CAPTIONING ERROR]\", error);\n    }\n  }\n};\n\n/** @override\n*/\nCaptioningWrapper.prototype.createFlashVars = function(flashvars) {\n  var captionLangArr, captionUrlArr, config, track, _i, _len, _ref, _ref1;\n  config = this.player.config;\n  if (((_ref = config.media) != null ? _ref.track : void 0) != null) {\n    track = Utils.selectTrack(config.media.track, \"captions\");\n    if ((track.src != null) && track.src !== \"\") {\n      flashvars.caption_url = track.src;\n    }\n    if (config.media.track.length > 0) {\n      captionUrlArr = [];\n      captionLangArr = [];\n      _ref1 = config.media.track;\n      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {\n        track = _ref1[_i];\n        captionUrlArr.push(track.src);\n        captionLangArr.push(track.srclang);\n      }\n      flashvars.caption_url = captionUrlArr.join(\",\");\n      flashvars.caption_language = captionLangArr.join(\",\");\n    }\n    flashvars.caption_type = track.type != null ? encodeURIComponent(track.type) : \"application/ttml+xml\";\n  }\n  if (flashvars.caption_language == null) {\n    flashvars.caption_language = \"en-us\";\n  }\n};\n\n/** @override\n*/\nCaptioningWrapper.prototype.listNotificationInterests = function() {\n  return CaptioningWrapper.__super__.listNotificationInterests.apply(this, arguments).concat([Notifications.MEDIA_CHANGE, FlashNotifications.CAPTIONING_REQUEST, FlashNotifications.CAPTION_LANG_CHANGE, FlashNotifications.INITIALIZED]);\n};\n\n/**\n*/\nCaptioningWrapper.prototype.handleNotification = function(notification) {\n  var body, media, name, track, type,\n    _this = this;\n  CaptioningWrapper.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case FlashNotifications.CAPTION_LANG_CHANGE:\n      type = \"\";\n      break;\n    case FlashNotifications.CAPTIONING_REQUEST:\n      type = \"visibilitychange\";\n      body = body.enabled;\n      this.hidden = !body;\n      break;\n    case Notifications.MEDIA_CHANGE:\n      media = body;\n      if (media.track != null) {\n        this._tracks = media.track.map(function(track) {\n          return Object.assign({\n            language: track.srclang\n          }, track);\n        });\n        track = Utils.selectTrack(this._tracks, \"captions\");\n        if (!(track != null)) {\n          return;\n        }\n        if ((track.src != null) && track.src !== \"\") {\n          media.captioningUrl = track.src;\n        }\n        if (track.type != null) {\n          media.captioningType = track.type || \"application/ttml+xml\";\n        }\n        this._track = track;\n      }\n      break;\n    case FlashNotifications.INITIALIZED:\n      this.hidden = !this.player.getMediaElement().getPlayerProperty(\"isCaptionVisible\");\n  }\n  if ((type != null) && type !== \"\") {\n    this.dispatchEvent(new Event(type, body));\n  }\n};\n\n/**\n*/\nCaptioningWrapper.prototype.getHidden = function() {\n  return this._hidden;\n};\n\nCaptioningWrapper.prototype.setHidden = function(value) {\n  this._hidden = value;\n  this.facade.getMediaElement().setPlayerProperty(\"captionDisplay\", {\n    visible: !value\n  });\n  return value;\n};\n\n/**\n*/\nCaptioningWrapper.prototype.getVisible = function() {\n  return !this._hidden;\n};\n\nCaptioningWrapper.prototype.setVisible = function(value) {\n  this.setHidden(!value);\n  return value;\n};\n\n/**\n * Returns an array of caption tracks\n *\n * @return {Array.<CaptionTrack>} The list of text tracks.\n * @expose\n*/\nCaptioningWrapper.prototype.getTracks = function() {\n  return this._tracks || [];\n};\n\n/**\n * Returns the currently selected track.\n *\n * @return {CaptionTrack} The currently selected caption track.\n * @expose\n*/\nCaptioningWrapper.prototype.getTrack = function() {\n  return this._track;\n};\n\n/**\n * Selects a caption track by its index in the getTracks array.\n *\n * @param {number}        index   The index to select\n * @return {CaptionTrack}         The selected caption track.\n * @expose\n*/\nCaptioningWrapper.prototype.selectTrackByIndex = function(index) {};\n\n/**\n * Selects a caption track by it's language property.\n *\n * @param {string}        lang  The language to select\n * @return {CaptionTrack}       The selected caption track.\n * @expose\n*/\nCaptioningWrapper.prototype.selectTrackByLanguage = function(lang) {\n  this.facade.getMediaElement().setTrackByLanguage(lang);\n};\n\n/**\n * Sets a caption Settings Object (styles)\n *\n * @param {Object}  object  The caption settings object.\n * @expose\n*/\nCaptioningWrapper.prototype.changeSettings = function(object) {\n  if (((object != null ? object.fontFamily : void 0) != null) && typeof object.fontFamily === \"object\") {\n    return this.facade.getMediaElement().setPlayerProperty(\"captionSettingsUI\", object);\n  }\n  if ((object != null ? object.visible : void 0) != null) {\n    this.hidden = !object.visible;\n  }\n  this.facade.getMediaElement().setPlayerProperty(\"captionDisplay\", {\n    visible: !this.hidden,\n    style: this.parseObject(object)\n  });\n};\n\n/**\n * Parse Object\n *\n*/\nCaptioningWrapper.prototype.parseObject = function(object) {\n  var flashObject, keyString, prop, _ref;\n  flashObject = {};\n  try {\n    for (prop in object) {\n      switch (prop) {\n        case \"fontFamily\":\n          flashObject['font'] = object[prop];\n          break;\n        case \"fontColor\":\n        case \"backgroundColor\":\n        case \"edgeColor\":\n        case \"windowColor\":\n          keyString = prop === \"fontColor\" ? \"font\" : prop === \"backgroundColor\" ? \"fontBG\" : prop === \"edgeColor\" ? \"edge\" : \"window\";\n          if (((_ref = object[prop]) != null ? _ref.indexOf('rgba') : void 0) !== -1) {\n            flashObject[keyString + 'Color'] = this.parseRGBA(object[prop]);\n            flashObject[keyString + 'Opacity'] = object[prop].replace(/^.*,(.+)\\)/, '$1');\n          }\n          break;\n        default:\n          flashObject[prop] = object[prop];\n      }\n    }\n    delete flashObject['visible'];\n  } catch (error) {\n    this.facade.logger.error('Captioning Settings Parse Error', error);\n  }\n  return flashObject;\n};\n\nCaptioningWrapper.prototype.parseRGBA = function(rgb) {\n  rgb = rgb.match(/^rgba?[\\s+]?\\([\\s+]?(\\d+)[\\s+]?,[\\s+]?(\\d+)[\\s+]?,[\\s+]?(\\d+)[\\s+]?/i);\n  if (rgb && rgb.length === 4) {\n    return \"0x\" + (\"0\" + parseInt(rgb[1], 10).toString(16)).slice(-2) + (\"0\" + parseInt(rgb[2], 10).toString(16)).slice(-2) + (\"0\" + parseInt(rgb[3], 10).toString(16)).slice(-2);\n  }\n  return \"\";\n};\n\n\nAMP.registerPlugin(\"captioning\", \"flash\", CaptioningWrapper);\n\n/** \n * The Feature class. Acts as a base for features.\n *   \n * @param {Module}  app     The parent module of this plugin.\n * @param {Object}  config  The plugin's configuration object.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction Feature() {\n  Feature.__super__.constructor.call(this);\n}\n\n\n__extends(Feature, Plugin);\n\n\nFeature.NAME = \"Feature\";\n\nFeature.prototype.featureName = null;\n\n/**\n*/\nFeature.prototype.getFeatureName = function() {\n  return this.featureName;\n};\n\n/**\n*/\nFeature.prototype.registerFeature = function() {\n  if (this.getFeatureName() != null) {\n    this.player.sendNotification(FeatureNotifications.REGISTER_FEATURE, this);\n  }\n};\n\n/** @override\n*/\nFeature.prototype.onRegister = function() {\n  this.registerFeature();\n  Feature.__super__.onRegister.call(this);\n};\n\n/** @override\n*/\nFeature.prototype.listNotificationPublications = function() {\n  return Feature.__super__.listNotificationPublications.call(this).concat([FeatureNotifications.REGISTER_FEATURE]);\n};\n\n/**\n * @constructor\n * @private\n * @extends {contextMenuMediator}\n*/\nfunction contextMenuMediator() {\n  contextMenuMediator.__super__.constructor.call(this);\n}\n\n\n__extends(contextMenuMediator, OverlayMediator);\n\n\ncontextMenuMediator.prototype.componentName = \"context-menu\";\n\ncontextMenuMediator.prototype.contextMenu = null;\n\n/**\n * @override\n*/\ncontextMenuMediator.prototype.onRegister = function() {\n  var _this = this;\n  contextMenuMediator.__super__.onRegister.call(this);\n  EventHandler.create(this.facade.player.viewComponent, EventHandler.CONTEXTMENU, function(event) {\n    event.preventDefault();\n    _this.contextMenuHandler(event);\n    return false;\n  });\n};\n\n/** Context Menu Click Handler\n*/\ncontextMenuMediator.prototype.contextMenuHandler = function(event) {\n  var id, item,\n    _this = this;\n  if (this.contextMenu) {\n    this.removeContextMenu();\n  }\n  this.contextMenu = UI.create(\"context-menu\", document.body, \"ul\");\n  UI.create(\"context-item\", this.contextMenu, \"li\", this.facade.player.getVersion());\n  if (typeof akamaiGetViewerId !== \"undefined\" && akamaiGetViewerId !== null) {\n    id = akamaiGetViewerId();\n    item = UI.create(\"context-item\", this.contextMenu, \"li\", \"\" + (this.localizationManager.getString(\"MSG_VIEWER_ID\") || \"Viewer ID: \"));\n    UI.create(\"selectable\", item, \"span\", \"\" + (id != null ? id : \"N/A\"));\n  }\n  this.contextMenu.style.top = event.pageY + \"px\";\n  this.contextMenu.style.left = event.pageX + \"px\";\n  EventHandler.create(document.body, EventHandler.CLICK, function(event) {\n    if (/selectable/.test(event.target.className)) {\n      return false;\n    }\n    _this.removeContextMenu(event);\n    return false;\n  });\n};\n\n/** Remove ContextMenu Handler and DOM Object\n*/\ncontextMenuMediator.prototype.removeContextMenu = function(event) {\n  try {\n    EventHandler.clear(document.body, EventHandler.CLICK);\n    document.body.removeChild(this.contextMenu);\n    this.contextMenu = null;\n  } catch (_error) {}\n};\n\n/**\n * The IOSCursorMediator class.\n * \n * @constructor\n * @private\n * @extends {OverlayMediator}\n * @param {Object} viewComponent\n*/\nfunction IOSCursorMediator() {\n  IOSCursorMediator.__super__.constructor.call(this, this.NAME);\n}\n\n\n__extends(IOSCursorMediator, OverlayMediator);\n\n\nIOSCursorMediator.NAME = \"IOSCursorMediator\";\n\nIOSCursorMediator.prototype.componentName = \"ioscursor\";\n\nIOSCursorMediator.prototype.container = null;\n\nIOSCursorMediator.prototype.onRegister = function() {\n  IOSCursorMediator.__super__.onRegister.call(this);\n  this.container = this.create(\"ioscursor-container\");\n};\n\n/**\n * @override\n*/\nIOSCursorMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.READY];\n};\n\n/**\n * @override\n*/\nIOSCursorMediator.prototype.handleNotification = function(notification) {\n  var _this = this;\n  switch (notification.getName()) {\n    case Notifications.READY:\n      if (!Utils.isIOS()) {\n        ClassList.add(\"hidden\", this.container, Namespace.PREFIX);\n      } else if (Utils.isIOS()) {\n        EventHandler.create(this.container, EventHandler.CLICK, function() {\n          return _this.sendNotification(Notifications.TOGGLE_ACTIVE);\n        });\n      }\n  }\n};\n\n/**\n * @constructor\n * @private\n * @extends {OverlayMediator}\n*/\nfunction TitleBarMediator() {\n  TitleBarMediator.__super__.constructor.call(this);\n}\n\n\n__extends(TitleBarMediator, OverlayMediator);\n\n\nTitleBarMediator.prototype.componentName = \"title-bar\";\n\nTitleBarMediator.prototype.title = null;\n\nTitleBarMediator.prototype.description = null;\n\n/**\n * @override\n*/\nTitleBarMediator.prototype.onRegister = function() {\n  TitleBarMediator.__super__.onRegister.call(this);\n  this.title = this.create(\"title-text\");\n  this.description = this.create(\"description-text\");\n};\n\n/**\n * @override\n*/\nTitleBarMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.CHANGE_MEDIA];\n};\n\n/**\n * @override\n*/\nTitleBarMediator.prototype.handleNotification = function(notification) {\n  var metadata, title;\n  switch (notification.getName()) {\n    case Notifications.CHANGE_MEDIA:\n      metadata = notification.getBody();\n      title = this.facade.player.evaluateBindings(metadata.title);\n      if (!(title != null) || title === \"\" || title === \"undefined\") {\n        this.classList.add(\"hidden\");\n      } else {\n        this.title.innerHTML = title;\n        this.description.innerHTML = metadata.description ? metadata.description : \"\";\n        this.classList.remove(\"hidden\");\n      }\n  }\n};\n\n/**\n * The ControlsWrapper class.\n *\n * @constructor\n * @private\n * @extends {PluginWrapper}\n * @param   {FlashPlayer}   player  The FlashPlayer\n * @param   {Object}        config  The plugin config\n*/\nfunction ControlsWrapper(player, config) {\n  ControlsWrapper.__super__.constructor.call(this, player, config);\n}\n\n\n__extends(ControlsWrapper, PluginWrapper);\n\n\nControlsWrapper.NAME = \"ControlsWrapper\";\n\nControlsWrapper.prototype.mode = \"auto\";\n\nControlsWrapper.prototype.autoHide = 5;\n\nControlsWrapper.prototype.flashView = {\n  elements: {\n    controls: {\n      attributes: {\n        height: \"28\",\n        itemMargin: \"5\",\n        scrubPosition: \"inline\"\n      },\n      elements: {\n        replayBtn: {},\n        playPauseBtn: {},\n        streamTimeIndicator: {\n          attributes: {\n            exclude: \"live\"\n          },\n          elements: {\n            streamTime: {},\n            streamDuration: {}\n          }\n        },\n        rewindBtn: {},\n        scrubBar: {\n          attributes: {\n            style: \"height: 18px;\"\n          }\n        },\n        progressBar: {\n          attributes: {\n            style: \"background: linear-gradient(90deg, #FF0000, #1B1B1B);\"\n          }\n        },\n        loadedBar: {\n          attributes: {\n            style: \"background: linear-gradient(90deg, #00FF00, #1B1B1B);\"\n          }\n        },\n        liveIndicator: {},\n        timeLocationIndicator: {},\n        goLiveBtn: {},\n        statsBtn: {},\n        volumeBar: {\n          attributes: {\n            color: \"#CA2127\"\n          }\n        },\n        volumeBtn: {},\n        fullscreenBtn: {}\n      }\n    }\n  }\n};\n\n/** @override\n*/\nControlsWrapper.prototype.listNotificationInterests = function() {\n  return ControlsWrapper.__super__.listNotificationInterests.apply(this, arguments).concat([Notifications.MEDIUM_CHANGE]);\n};\n\n/**\n*/\nControlsWrapper.prototype.handleNotification = function(notification) {\n  var body, mode, name;\n  ControlsWrapper.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.MEDIUM_CHANGE:\n      mode = /audio/.test(body) ? \"persistent\" : this.mode;\n      this.setMode(mode);\n  }\n};\n\n/** @override\n*/\nControlsWrapper.prototype.createFlashVars = function(flashvars) {\n  if (this.config.mode != null) {\n    this.mode = flashvars.controls_mode = this.config.mode;\n  }\n  if ((this.config.admode != null) && this.config.admode !== this.config.mode) {\n    flashvars.ads_auto_fit = true;\n  }\n  flashvars.show_play_button_overlay = this.config.playoverlay != null ? this.config.playoverlay : true;\n  return flashvars;\n};\n\nControlsWrapper.prototype.createXML = function(xml) {\n  var controls, _ref, _ref1;\n  controls = (_ref = this.player.flashView) != null ? (_ref1 = _ref.elements) != null ? _ref1.controls : void 0 : void 0;\n  if (!(controls != null)) {\n    return;\n  }\n  if (controls.attributes[\"autoHideDelay\"] != null) {\n    this.autoHide = controls.attributes[\"autoHideDelay\"];\n  } else {\n    if (this.config.autoHide != null) {\n      this.autoHide = this.config.autoHide;\n      controls.attributes[\"autoHideDelay\"] = this.config.autoHide;\n    }\n  }\n  return xml;\n};\n\n/**\n*/\nControlsWrapper.prototype.getMode = function() {\n  return this.mode;\n};\n\nControlsWrapper.prototype.setMode = function(value) {\n  if (value === this.mode) {\n    return;\n  }\n  try {\n    this.mode = value;\n    this.player.mediaElement.setPlayerProperty(\"controlsMode\", value);\n  } catch (error) {\n    this.facade.logger.error(\"[AMP CONTROLS ERROR]\", error);\n  }\n  return value;\n};\n\nControlsWrapper.prototype.getAutoHide = function() {\n  return this.autoHide;\n};\n\n/**\n * The ControlsPlayCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ControlsPlayCommand() {\n  ControlsPlayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsPlayCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nControlsPlayCommand.prototype.execute = function(notification) {\n  var controls;\n  controls = this.facade.retrieveProxy(ControlsProxy.NAME);\n  controls.start();\n};\n\n/**\n * The ControlsPauseCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ControlsPauseCommand() {\n  ControlsPauseCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsPauseCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nControlsPauseCommand.prototype.execute = function(notification) {\n  var controls;\n  controls = this.facade.retrieveProxy(ControlsProxy.NAME);\n  controls.stop();\n};\n\n/**\n * The ControlsActiveStateChangeCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ControlsActiveStateChangeCommand() {\n  ControlsActiveStateChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsActiveStateChangeCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nControlsActiveStateChangeCommand.prototype.execute = function(notification) {\n  var app, body, controls;\n  controls = this.facade.retrieveProxy(ControlsProxy.NAME);\n  app = this.facade.player.retrieveProxy(ApplicationStateProxy.NAME);\n  body = notification.getBody();\n  if (body.value === ActiveState.ACTIVE && app.getPlayState() !== PlayState.READY && Utils.getDevice() !== \"desktop\") {\n    controls.start();\n  }\n};\n\n/**\n * The ControlsAdBreakStartCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ControlsAdBreakStartCommand() {\n  ControlsAdBreakStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsAdBreakStartCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nControlsAdBreakStartCommand.prototype.execute = function(notification) {\n  if (this.plugin.config[\"native\"] === true) {\n    this.player.getMediaElement().controls = false;\n  } else {\n    this.proxy.adBreakStart();\n  }\n};\n\n/**\n * The ControlsAdBreakEndCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ControlsAdBreakEndCommand() {\n  ControlsAdBreakEndCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsAdBreakEndCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nControlsAdBreakEndCommand.prototype.execute = function(notification) {\n  if (this.plugin.config[\"native\"] === true) {\n    this.player.getMediaElement().controls = true;\n  } else {\n    this.proxy.adBreakEnd();\n  }\n};\n\n/**\n * The ControlsMediaValidatedCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ControlsMediaValidatedCommand() {\n  ControlsMediaValidatedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsMediaValidatedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nControlsMediaValidatedCommand.prototype.execute = function(notification) {\n  var element, media, src;\n  media = notification.getBody();\n  src = media.poster;\n  element = this.facade.player.getMediaElement();\n  if ((src != null) && src !== \"\") {\n    element.poster = src;\n  }\n  element.src = media.src;\n  if (this.facade.player.getAutoplay() !== true) {\n    this.facade.applyClickHandler();\n  }\n};\n\n/**\n * The ControlsStartedCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ControlsStartedCommand() {\n  ControlsStartedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsStartedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nControlsStartedCommand.prototype.execute = function(notification) {\n  this.facade.applyClickHandler(false);\n};\n\n/**\n * The ControlsActiveStateChangeCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ControlsStartCommand() {\n  ControlsStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsStartCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nControlsStartCommand.prototype.execute = function(notification) {\n  var controls;\n  controls = this.facade.retrieveProxy(ControlsProxy.NAME);\n  controls.start();\n};\n\n/**\n * The ControlsActiveStateChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ControlsDisplayStateChangeCommand() {\n  ControlsDisplayStateChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsDisplayStateChangeCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nControlsDisplayStateChangeCommand.prototype.execute = function(notification) {\n  var controls, state;\n  state = notification.getBody().value;\n  controls = this.facade.retrieveProxy(ControlsProxy.NAME);\n  if (state === DisplayState.FULL_SCREEN) {\n    window.addEventListener(\"keypress\", controls.keypress);\n  } else if (state === DisplayState.NORMAL) {\n    window.removeEventListener(\"keypress\", controls.keypress);\n  }\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction ControlsProxy(config) {\n  ControlsProxy.__super__.constructor.call(this, config);\n  this.keypress = this.keypress.bind(this);\n}\n\n\n__extends(ControlsProxy, ModuleProxy);\n\n\nControlsProxy.NAME = ModuleProxy.NAME;\n\nControlsProxy.prototype.defaults = {\n  mode: \"auto\",\n  autoHide: 3,\n  admode: null\n};\n\nControlsProxy.prototype.timeout = null;\n\nControlsProxy.prototype.appState = null;\n\nControlsProxy.prototype.controls = null;\n\nControlsProxy.prototype.interactiveElement = null;\n\nControlsProxy.prototype.idleUtil = null;\n\nControlsProxy.prototype.initializeNotifier = function(key) {\n  ControlsProxy.__super__.initializeNotifier.call(this, key);\n  this.appState = this.facade.player.retrieveProxy(ApplicationStateProxy.NAME);\n  this.controls = this.facade.retrieveMediator(ApplicationStateProxy.NAME);\n};\n\nControlsProxy.prototype.onRegister = function() {\n  var _this = this;\n  ControlsProxy.__super__.onRegister.call(this);\n  if (this.config.mode != null) {\n    this.changeMode(this.config.mode);\n  }\n  this.interactiveElement = this.facade.player.getContainer();\n  if (Utils.getDevice() === \"desktop\") {\n    this.facade.registerMediator(new IOSCursorMediator);\n    EventHandler.create(this.interactiveElement, \"mouseenter\", function() {\n      _this.stop();\n      if (_this.appState.activeState !== ActiveState.ACTIVE) {\n        _this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n      }\n    });\n    EventHandler.create(this.interactiveElement, \"mouseleave\", function() {\n      _this.start();\n    });\n    this.idleUtil = new IdleUtil(this.facade.player.getViewComponent(), this.data.autoHide * 1000);\n    this.idleUtil.addEventListener(\"activechange\", function(event) {\n      var state;\n      state = event.detail.active !== true ? ActiveState.INACTIVE : ActiveState.ACTIVE;\n      _this.sendNotification(Notifications.CHANGE_ACTIVE_STATE, state);\n    });\n    this.idleUtil.start();\n    EventHandler.create(this.facade.player.getMediaElement(), \"click\", function() {\n      _this.sendNotification(UserNotifications.TOGGLE_PLAY_PAUSE);\n    });\n  } else {\n    if (Utils.isIOS()) {\n      this.facade.registerMediator(new IOSCursorMediator);\n    }\n    EventHandler.create(this.interactiveElement, EventHandler.CLICK, function() {\n      _this.sendNotification(Notifications.TOGGLE_ACTIVE);\n    });\n  }\n};\n\nControlsProxy.prototype.setMode = function(value) {\n  if (this.data.mode === value) {\n    return value;\n  }\n  this.changeMode(value);\n  return value;\n};\n\nControlsProxy.prototype.changeMode = function(value) {\n  if (this.data.mode === \"auto\") {\n    this.stop();\n  }\n  this.facade.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"controls-\" + this.data.mode);\n  this.data.mode = value;\n  this.facade.sendNotification(Notifications.ADD_APPLICATION_STATE, \"controls-\" + this.data.mode);\n};\n\nControlsProxy.prototype.getMode = function() {\n  return this.data.mode;\n};\n\nControlsProxy.prototype.setAutoHide = function(value) {\n  this.data.autoHide = value;\n  return value;\n};\n\nControlsProxy.prototype.getAutoHide = function() {\n  return this.data.autoHide;\n};\n\nControlsProxy.prototype.adBreakStart = function() {\n  if (this.data.admode != null) {\n    this.config.mode = this.getMode();\n    this.setMode(this.data.admode);\n  }\n};\n\nControlsProxy.prototype.adBreakEnd = function() {\n  if (this.data.admode != null) {\n    this.setMode(this.config.mode);\n  }\n};\n\nControlsProxy.prototype.start = function() {\n  this.stop();\n  if (this.data.mode !== \"auto\") {\n    return;\n  }\n  this.timeout = setTimeout(this.hide.bind(this), this.data.autoHide * 1000);\n};\n\nControlsProxy.prototype.keypress = function(event) {\n  switch (event.keyCode || event.which || event.charCode) {\n    case 27:\n      break;\n    case 32:\n      if (!this.facade.player.getEnded()) {\n        if (this.facade.player.getPaused()) {\n          this.facade.player.play();\n        } else {\n          this.facade.player.pause();\n        }\n      }\n  }\n};\n\nControlsProxy.prototype.stop = function() {\n  clearTimeout(this.timeout);\n  this.timeout = null;\n};\n\nControlsProxy.prototype.hide = function() {\n  if (this.data.mode !== \"auto\") {\n    return;\n  }\n  if ((this.appState.getIsUserActive() === true || Utils.isMouseOverElement(this.facade.viewComponent)) && this.appState.getDisplayState() !== DisplayState.FULL_SCREEN) {\n    this.start();\n    return;\n  }\n  this.facade.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.INACTIVE);\n};\n\n/**\n * @constructor\n * @private\n * @extends {OverlayMediator}\n*/\nfunction ReplayOverlayMediator() {\n  ReplayOverlayMediator.__super__.constructor.call(this);\n}\n\n\n__extends(ReplayOverlayMediator, OverlayMediator);\n\n\nReplayOverlayMediator.prototype.componentName = \"replay\";\n\nReplayOverlayMediator.prototype.replay = null;\n\nReplayOverlayMediator.prototype.icon = null;\n\nReplayOverlayMediator.prototype.label = null;\n\n/**\n * @override\n*/\nReplayOverlayMediator.prototype.onRegister = function() {\n  ReplayOverlayMediator.__super__.onRegister.call(this);\n  this.replay = this.create(\"replay-button\");\n  this.replay.onclick = this.onclick.bind(this);\n  this.icon = this.create(\"replay-icon\", this.replay);\n  this.label = this.createText(\"replay-label\", this.localizationManager.getString(LocalizationConstants.MSG_REPLAY), this.replay);\n};\n\n/**\n*/\nReplayOverlayMediator.prototype.onclick = function(event) {\n  event.stopImmediatePropagation();\n  this.sendNotification(Notifications.REPLAY);\n  return false;\n};\n\n/**\n * ErrorLayerMediator class.\n *\n * @constructor\n * @extends {LayerMediator}\n * @private\n*/\nfunction ErrorLayerMediator() {\n  ErrorLayerMediator.__super__.constructor.call(this);\n}\n\n\n__extends(ErrorLayerMediator, LayerMediator);\n\n\nErrorLayerMediator.prototype.message = null;\n\nErrorLayerMediator.prototype.componentName = \"error\";\n\n/**\n * @override\n*/\nErrorLayerMediator.prototype.onRegister = function() {\n  ErrorLayerMediator.__super__.onRegister.call(this);\n  this.message = this.create(\"error-message\");\n};\n\n/**\n * @override\n*/\nErrorLayerMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.ERROR];\n};\n\n/**\n * @override\n*/\nErrorLayerMediator.prototype.handleNotification = function(notification) {\n  var error, msg;\n  switch (notification.getName()) {\n    case Notifications.ERROR:\n      error = notification.getBody();\n      msg = /^(Error: )/.test(error.toString()) ? \"\" : \"Error: \";\n      switch (error.code) {\n        case MediaError.MEDIA_ERR_ABORTED:\n          msg += \"Media was aborted.\";\n          break;\n        case MediaError.MEDIA_ERR_DECODE:\n          msg += \"Decode Error.\";\n          break;\n        case MediaError.MEDIA_ERR_NETWORK:\n          msg += \"Network Error.\";\n          break;\n        case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:\n          msg += \"Source not supported.\";\n          break;\n        default:\n          msg += error;\n      }\n      this.message.textContent = msg;\n  }\n};\n\n/** \n * @constructor\n * @extends {OverlayMediator}\n * @private\n*/\nfunction LoadingOverlayMediator() {\n  LoadingOverlayMediator.__super__.constructor.call(this);\n}\n\n\n__extends(LoadingOverlayMediator, OverlayMediator);\n\n\nLoadingOverlayMediator.prototype.componentName = \"loading\";\n\n/**\n * @constructor\n * @private\n * @extends {OverlayMediator}\n*/\nfunction WaitingOverlayMediator() {\n  WaitingOverlayMediator.__super__.constructor.call(this);\n}\n\n\n__extends(WaitingOverlayMediator, OverlayMediator);\n\n\nWaitingOverlayMediator.prototype.componentName = \"waiting\";\n\nWaitingOverlayMediator.prototype.bar = null;\n\nWaitingOverlayMediator.prototype.text = null;\n\nWaitingOverlayMediator.prototype.onRegister = function() {\n  WaitingOverlayMediator.__super__.onRegister.call(this);\n  this.bar = this.create(\"waiting-bar\");\n  this.text = this.createText(\"waiting-text\", this.localizationManager.getString(LocalizationConstants.MSG_BUFFERING));\n};\n\n/**\n * @constructor\n * @private\n * @extends {LayerMediator}\n*/\nfunction PosterMediator() {\n  PosterMediator.__super__.constructor.call(this);\n}\n\n\n__extends(PosterMediator, OverlayMediator);\n\n\nPosterMediator.prototype.componentName = \"poster\";\n\nPosterMediator.prototype.poster = null;\n\nPosterMediator.prototype.clickHandler = null;\n\n/**\n * @override\n*/\nPosterMediator.prototype.onRegister = function() {\n  PosterMediator.__super__.onRegister.call(this);\n  this.poster = this.create(\"poster-content\");\n  this.poster.onclick = this.onclick.bind(this);\n};\n\n/**\n*/\nPosterMediator.prototype.onclick = function(event) {\n  event.stopImmediatePropagation();\n  event.preventDefault();\n  this.sendNotification(UserNotifications.TOGGLE_PLAY_PAUSE, true);\n  return false;\n};\n\n/**\n * @override\n*/\nPosterMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.SET_MEDIA];\n};\n\n/**\n * @override\n*/\nPosterMediator.prototype.handleNotification = function(notification) {\n  var html, src;\n  switch (notification.getName()) {\n    case Notifications.SET_MEDIA:\n      src = notification.getBody().poster;\n      html = (src != null) && src !== \"\" ? \"<img src=\\\"\" + src + \"\\\" class=\\\"\" + this.cssPrefix + \"poster-image\\\" />\" : \"\";\n      this.poster.innerHTML = html;\n  }\n};\n\n/**\n*/\n/**\n * @constructor\n * @private\n*/\nfunction EndSlateMediator() {\n  EndSlateMediator.__super__.constructor.call(this);\n}\n\n\n__extends(EndSlateMediator, OverlayMediator);\n\n\nEndSlateMediator.prototype.componentName = \"end-slate\";\n\n/**\n * @override\n*/\nEndSlateMediator.prototype.onRegister = function() {\n  if (this.facade.config.endslate != null) {\n    EndSlateMediator.__super__.onRegister.call(this);\n  }\n};\n\nEndSlateMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.MEDIA_CHANGE];\n};\n\nEndSlateMediator.prototype.handleNotification = function(notification) {\n  var endslate, html, media, src, viewComponent;\n  switch (notification.getName()) {\n    case Notifications.MEDIA_CHANGE:\n      media = notification.getBody();\n      endslate = this.facade.config.endslate;\n      viewComponent = this.getViewComponent();\n      html = \"\";\n      if (endslate != null) {\n        src = endslate.usePoster === true ? media.poster : endslate.url;\n        if ((src != null) && src !== \"\") {\n          html = \"<img src=\\\"\" + src + \"\\\" class=\\\"end-slate-image\\\" />\";\n        }\n      }\n      if (viewComponent != null) {\n        viewComponent.innerHTML = html;\n      }\n  }\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction ButtonMediator(labelText, parent, element, componentName, onclick) {\n  this.labelText = labelText;\n  this.onclick = onclick != null ? onclick : this.onclick;\n  ButtonMediator.__super__.constructor.call(this, componentName, null, parent, element);\n}\n\n\n__extends(ButtonMediator, ComponentMediator);\n\n\nButtonMediator.prototype.componentType = \"button\";\n\nButtonMediator.prototype.icon = null;\n\nButtonMediator.prototype.label = null;\n\nButtonMediator.prototype.onclick = null;\n\nButtonMediator.prototype.labelText = null;\n\nButtonMediator.prototype.onRegister = function() {\n  ButtonMediator.__super__.onRegister.call(this);\n  this.icon = this.create(\"icon\");\n  this.createLabel(this.labelText);\n};\n\nButtonMediator.prototype.createLabel = function(label) {\n  if (label != null) {\n    this.label = this.createText(\"label\", label);\n  }\n};\n\nButtonMediator.prototype.setLabel = function(value) {\n  if (!(this.label != null)) {\n    this.createLabel(value);\n  } else {\n    this.label.textContent = value;\n  }\n  return value;\n};\n\nButtonMediator.prototype.getLabel = function() {\n  var _ref;\n  return (_ref = this.label) != null ? _ref.textContent : void 0;\n};\n\n/**\n * The LogoMediator class.\n * \n * @constructor\n * @private\n * @extends {LocalizedMediator}\n * @param {Object} viewComponent\n*/\nfunction LogoMediator(parent) {\n  LogoMediator.__super__.constructor.call(this, null, null, parent);\n}\n\n\n__extends(LogoMediator, ComponentMediator);\n\n\n/**\n * The name of the this Mediator.\n * \n * @static\n * @type {string}\n*/\nLogoMediator.prototype.componentName = \"logo\";\n\nLogoMediator.prototype.url = null;\n\n/**\n * @override\n*/\nLogoMediator.prototype.onRegister = function() {\n  LogoMediator.__super__.onRegister.call(this);\n  this.sendNotification(Notifications.ADD_CONTROL_STATE, this.componentName + \"-enabled\");\n};\n\nLogoMediator.prototype.onclick = function(event) {\n  event.stopImmediatePropagation();\n  this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"controlsLogoClicked\"));\n  return false;\n};\n\n/**\n * The FullScreenMediator class.\n *\n * @constructor\n * @private\n * @extends {ModuleMediator}\n * @param {Object} viewComponent\n*/\nfunction FullScreenMediator(parent) {\n  FullScreenMediator.__super__.constructor.call(this, null, parent);\n}\n\n\n__extends(FullScreenMediator, ButtonMediator);\n\n\nFullScreenMediator.prototype.componentName = \"full-screen\";\n\nFullScreenMediator.prototype.onRegister = function() {\n  FullScreenMediator.__super__.onRegister.call(this);\n  this.sendNotification(Notifications.ADD_CONTROL_STATE, this.componentName + \"-enabled\");\n};\n\nFullScreenMediator.prototype.onclick = function(event) {\n  event.stopImmediatePropagation();\n  this.sendNotification(Notifications.TOGGLE_FULL_SCREEN);\n  return false;\n};\n\n/**\n * @override\n*/\nFullScreenMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.DISABLE_FULL_SCREEN, Notifications.ENABLE_FULL_SCREEN];\n};\n\n/**\n * @override\n*/\nFullScreenMediator.prototype.handleNotification = function(notification) {\n  var body, name;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.DISABLE_FULL_SCREEN:\n      this.setDisabled(true);\n      break;\n    case Notifications.ENABLE_FULL_SCREEN:\n      this.setDisabled(false);\n  }\n};\n\n/**\n * The VolumeMediator class.\n *\n * @constructor\n * @private\n * @extends {ModuleMediator}\n * @param {Object} viewComponent\n*/\nfunction SliderMediator(parent, direction) {\n  this.direction = direction != null ? direction : this.direction;\n  SliderMediator.__super__.constructor.call(this, null, null, parent);\n}\n\n\n__extends(SliderMediator, ComponentMediator);\n\n\nSliderMediator.prototype.componentType = \"slider\";\n\nSliderMediator.prototype.trackView = null;\n\nSliderMediator.prototype.handleView = null;\n\nSliderMediator.prototype.valueView = null;\n\nSliderMediator.prototype.startCapView = null;\n\nSliderMediator.prototype.endCapView = null;\n\nSliderMediator.prototype.clickView = null;\n\nSliderMediator.prototype.min = 0;\n\nSliderMediator.prototype.max = 1;\n\nSliderMediator.prototype.value = 0;\n\nSliderMediator.prototype.draggable = false;\n\nSliderMediator.prototype.dragging = false;\n\nSliderMediator.prototype.draggingInterval = null;\n\nSliderMediator.prototype.draggingDelay = 250;\n\nSliderMediator.prototype.direction = \"vertical\";\n\nSliderMediator.prototype.pressHandler = null;\n\nSliderMediator.prototype.releaseHandler = null;\n\nSliderMediator.prototype.moveHandler = null;\n\nSliderMediator.prototype.clickHandler = null;\n\n/**\n * @override\n*/\nSliderMediator.prototype.onRegister = function() {\n  SliderMediator.__super__.onRegister.call(this);\n  this.startCapView = this.create(\"start-cap\");\n  this.endCapView = this.create(\"end-cap\");\n  this.trackView = this.create(\"track\");\n  this.valueView = this.create(\"value\", this.trackView);\n  this.clickView = this.create(\"click\", this.trackView);\n  this.handleView = this.create(\"handle\", this.trackView);\n  this.pressHandler = EventHandler.create(this.handleView, EventHandler.PRESS, this.handlePressHandler.bind(this));\n  this.releaseHandler = EventHandler.create(window, EventHandler.RELEASE, this.handleReleaseHandler.bind(this));\n  this.releaseHandler.unbind();\n  this.moveHandler = EventHandler.create(window, EventHandler.MOVE, this.updateHandler.bind(this, this.draggable));\n  this.moveHandler.unbind();\n  this.clickHandler = EventHandler.create(this.clickView, EventHandler.CLICK, this.updateHandler.bind(this, true));\n};\n\n/** sets the value\n*/\nSliderMediator.prototype.setDirection = function(value) {\n  this.direction = value;\n  return value;\n};\n\nSliderMediator.prototype.getDirection = function() {\n  return this.direction;\n};\n\n/** sets the value\n*/\nSliderMediator.prototype.setValue = function(value) {\n  this.updateValue(value);\n  this.valueChanged();\n  return value;\n};\n\nSliderMediator.prototype.getValue = function() {\n  return this.value;\n};\n\nSliderMediator.prototype.setDragging = function(value) {\n  if (value === this.dragging) {\n    return;\n  }\n  this.dragging = value;\n  this.sendNotification(Notifications.IS_USER_ACTIVE, this.dragging);\n  if (this.dragging === true) {\n    this.draggingInterval = setInterval(this.valueChanged.bind(this), this.draggingDelay);\n  } else {\n    clearInterval(this.draggingInterval);\n    this.valueChanged();\n  }\n  return this.dragging;\n};\n\nSliderMediator.prototype.getDragging = function() {\n  return this.dragging;\n};\n\nSliderMediator.prototype.setDraggable = function(value) {\n  if (value === this.draggable) {\n    return;\n  }\n  this.draggable = value;\n  return value;\n};\n\nSliderMediator.prototype.getDraggable = function() {\n  return this.draggable;\n};\n\n/** updates the view\n*/\nSliderMediator.prototype.updateValue = function(value, force) {\n  var handle;\n  if (force == null) {\n    force = false;\n  }\n  if (value === this.value && force === false) {\n    return;\n  }\n  this.value = Utils.clamp(value, this.min, this.max);\n  if (this.direction === \"vertical\") {\n    value = \"height\";\n    handle = \"bottom\";\n  } else {\n    value = \"width\";\n    handle = \"left\";\n  }\n  this.valueView.style[value] = this.handleView.style[handle] = \"\" + (this.value * 100) + \"%\";\n};\n\n/** calculates the value based on mouse/touch point\n*/\nSliderMediator.prototype.calculateValue = function(event) {\n  var offset, pos, value;\n  pos = {\n    x: (event.pageX - (window.scrollX || window.pageXOffset)) || (event.targetTouches[0].pageX - window.scrollX),\n    y: (event.pageY - (window.scrollY || window.pageYOffset)) || (event.targetTouches[0].pageY - window.scrollY)\n  };\n  offset = Utils.getElementOffset(this.viewComponent);\n  if (this.getDirection() === \"vertical\") {\n    value = 1 - ((pos.y - offset.top) / offset.height);\n  } else {\n    value = (pos.x - offset.left) / offset.width;\n  }\n  return Utils.clamp(value, 0, 1);\n};\n\nSliderMediator.prototype.blockEvent = function(event) {\n  if (!(event != null)) {\n    return;\n  }\n  event.stopImmediatePropagation();\n  event.preventDefault();\n};\n\nSliderMediator.prototype.handlePressHandler = function(event) {\n  this.moveHandler.bind();\n  this.releaseHandler.bind();\n  this.clickHandler.unbind();\n  this.setDragging(true);\n  this.blockEvent(event);\n  return false;\n};\n\nSliderMediator.prototype.handleReleaseHandler = function(event) {\n  this.moveHandler.unbind();\n  this.releaseHandler.unbind();\n  this.clickHandler.bind();\n  this.setDragging(false);\n  this.blockEvent(event);\n  return false;\n};\n\nSliderMediator.prototype.updateHandler = function(setValue, event) {\n  var value;\n  this.blockEvent(event);\n  value = /click/.test(event.type) && this.classList.contains('scrubbing') ? this.getValue() : this.calculateValue(event);\n  if (setValue === true) {\n    this.setValue(value);\n  } else {\n    this.updateValue(value);\n  }\n  return false;\n};\n\nSliderMediator.prototype.valueChanged = function() {};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar PanelNotifications = {\n  ADD_PANEL: \"addPanel\",\n  REMOVE_PANEL: \"removePanel\",\n  OPEN_PANEL: \"openPanel\",\n  CLOSE_PANEL: \"closePanel\",\n  TOGGLE_PANEL: \"togglePanel\",\n  CLOSE_ALL_PANELS: \"closeAllPanels\"\n};\n\n/**\n * The TimeDisplayMediator class.\n *\n * @constructor\n * @private\n * @extends {LocalizedMediator}\n * @param {Object} viewComponent\n*/\nfunction TimeDisplayMediator(parent) {\n  TimeDisplayMediator.__super__.constructor.call(this, null, null, parent);\n}\n\n\n__extends(TimeDisplayMediator, ComponentMediator);\n\n\n/**\n * The name of the this Mediator.\n *\n * @static\n * @type {string}\n*/\nTimeDisplayMediator.prototype.componentName = \"time-display\";\n\nTimeDisplayMediator.prototype.duration = null;\n\nTimeDisplayMediator.prototype.currentTimeDisplay = null;\n\nTimeDisplayMediator.prototype.separatorDisplay = null;\n\nTimeDisplayMediator.prototype.durationDisplay = null;\n\nTimeDisplayMediator.prototype.liveDisplay = null;\n\n/**\n * @override\n*/\nTimeDisplayMediator.prototype.onRegister = function() {\n  TimeDisplayMediator.__super__.onRegister.call(this);\n  this.liveDisplay = this.createText(\"live-display\", this.localizationManager.getString(LocalizationConstants.MSG_LIVE));\n  this.currentTimeDisplay = this.createText(\"current-time-display\", \"00:00\", this, \"span\");\n  this.separatorDisplay = this.createText(\"separator-display\", this.localizationManager.getString(LocalizationConstants.MSG_TIME_SEPARATOR), this, \"span\");\n  this.durationDisplay = this.createText(\"duration-display\", \"00:00\", this, \"span\");\n};\n\n/**\n * @override\n*/\nTimeDisplayMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.PLAY, Notifications.DURATION_CHANGE, Notifications.ENDED, Notifications.DISPLAY_TIME];\n};\n\n/**\n * @override\n*/\nTimeDisplayMediator.prototype.handleNotification = function(notification) {\n  var body, name;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.PLAY:\n      this.updateDuration();\n      break;\n    case Notifications.DURATION_CHANGE:\n      this.updateCurrentTime();\n      this.updateDuration(body);\n      break;\n    case Notifications.ENDED:\n      this.updateCurrentTime(this.duration);\n      this.updateDuration();\n      break;\n    case Notifications.DISPLAY_TIME:\n      this.updateCurrentTime(body.currentTime, body.duration);\n      this.updateDuration(body.duration);\n  }\n};\n\nTimeDisplayMediator.prototype.updateCurrentTime = function(currentTime, duration) {\n  if (currentTime != null) {\n    this.currentTime = currentTime;\n  }\n  if (duration != null) {\n    this.duration = duration;\n  }\n  this.currentTimeDisplay.textContent = Utils.formatTimecode(this.currentTime, this.duration);\n};\n\nTimeDisplayMediator.prototype.updateDuration = function(duration) {\n  if (duration != null) {\n    this.duration = duration;\n  }\n  this.durationDisplay.textContent = Utils.formatTimecode(this.duration);\n};\n\n/**\n * The PlayPauseMediator class.\n *\n * @constructor\n * @private\n * @extends {ButtonMediator}\n*/\nfunction GoLiveMediator(parent) {\n  GoLiveMediator.__super__.constructor.call(this, null, parent);\n}\n\n\n__extends(GoLiveMediator, ButtonMediator);\n\n\nGoLiveMediator.prototype.componentName = \"go-live\";\n\nGoLiveMediator.prototype.onRegister = function() {\n  GoLiveMediator.__super__.onRegister.call(this);\n  this.createLabel(this.localizationManager.getString(\"MSG_LIVE\"));\n};\n\n/**\n * @override\n*/\nGoLiveMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.IS_LIVE];\n};\n\n/**\n * @override\n*/\nGoLiveMediator.prototype.handleNotification = function(notification) {\n  var body, name;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.IS_LIVE:\n      this.setLabel(body === true ? this.localizationManager.getString(\"MSG_LIVE\") : this.localizationManager.getString(\"MSG_GO_LIVE\"));\n  }\n};\n\n/**\n*/\nGoLiveMediator.prototype.onclick = function(event) {\n  event.stopImmediatePropagation();\n  event.preventDefault();\n  this.sendNotification(UserNotifications.GO_LIVE);\n  return false;\n};\n\n/**\n * @constructor\n * @private\n * @extends {OverlayMediator}\n*/\nfunction AdMediator() {\n  AdMediator.__super__.constructor.call(this);\n}\n\n\n__extends(AdMediator, OverlayMediator);\n\n\nAdMediator.prototype.duration = null;\n\nAdMediator.prototype.currentTime = null;\n\nAdMediator.prototype.container = null;\n\nAdMediator.prototype.banner = null;\n\nAdMediator.prototype.text = null;\n\nAdMediator.prototype.adText = null;\n\nAdMediator.prototype.bg = null;\n\nAdMediator.prototype.totalAds = null;\n\nAdMediator.prototype.adPosition = null;\n\nAdMediator.prototype.adContainerRequired = true;\n\nAdMediator.prototype.componentName = \"ads\";\n\n/**\n * @override\n*/\nAdMediator.prototype.onRegister = function() {\n  AdMediator.__super__.onRegister.call(this);\n  if (this.adContainerRequired) {\n    this.container = this.create(\"ad-container\");\n  }\n  this.banner = this.create(\"ad-banner\");\n  this.bg = this.create(\"ad-text-bg\", this.banner);\n  this.adText = this.create(\"ad-text-title\", this.banner);\n  this.text = this.create(\"ad-text\", this.banner);\n  if (this.adContainerRequired) {\n    this.viewComponent.container = this.container;\n  }\n  this.sendNotification(AdNotifications.AD_CONTAINER_CREATED, this.viewComponent);\n};\n\n/**\n * @override\n*/\nAdMediator.prototype.listNotificationInterests = function() {\n  return [AdNotifications.BREAK_START, AdNotifications.BREAK_END, AdNotifications.AD_TIME_REMAINING, AdNotifications.AD_STARTED];\n};\n\n/**\n * @override\n*/\nAdMediator.prototype.handleNotification = function(notification) {\n  var adVO, msg, time;\n  switch (notification.getName()) {\n    case AdNotifications.BREAK_END:\n      this.text.textContent = \"\";\n      this.adText.textContent = \"\";\n      break;\n    case AdNotifications.AD_TIME_REMAINING:\n      time = Math.round(notification.getBody());\n      if ((this.totalAds != null) && this.totalAds > 0 && (this.adPosition != null) && this.adPosition !== this.totalAds) {\n        msg = time > 0 ? \"\" + (this.localizationManager.getString(LocalizationConstants.MSG_NEXT_AD)) + time + \" \" + (this.localizationManager.getString(LocalizationConstants.MSG_SECONDS)) : \"\";\n      } else {\n        msg = time > 0 ? \"\" + (this.localizationManager.getString(LocalizationConstants.MSG_NEXT_VIDEO)) + time + \" \" + (this.localizationManager.getString(LocalizationConstants.MSG_SECONDS)) : \"\";\n      }\n      this.text.textContent = msg;\n      break;\n    case AdNotifications.AD_STARTED:\n      adVO = notification.getBody();\n      this.totalAds = adVO.totalAds;\n      this.adPosition = adVO.position;\n      msg = \"Ad \" + adVO.position + \" of \" + adVO.totalAds;\n      if ((adVO.position != null) && (adVO.totalAds != null) && adVO.totalAds >= 1) {\n        this.adText.textContent = msg;\n      }\n  }\n};\n\n/**\n * The PanelControlMediator class.\n *\n * @constructor\n * @private\n * @extends {ButtonMediator}\n*/\nfunction PanelControlMediator(componentName) {\n  PanelControlMediator.__super__.constructor.call(this, null, null, null, componentName, onclick);\n}\n\n\n__extends(PanelControlMediator, ButtonMediator);\n\n\nPanelControlMediator.prototype.panel = null;\n\nPanelControlMediator.prototype.timeout = null;\n\nPanelControlMediator.prototype.closePanelDelayed = null;\n\n/**\n * @override\n*/\nPanelControlMediator.prototype.onRegister = function() {\n  this.closePanelDelayed = this.delayedClosePanel.bind(this);\n  if (Utils.getDevice() === \"desktop\") {\n    this.onmouseleave = this.closePanelDelayed;\n    this.onmouseenter = this.openPanel;\n    this.onclick = this.clickHandler;\n  } else {\n    this.onclick = this.togglePanel;\n  }\n  PanelControlMediator.__super__.onRegister.call(this);\n  this.sendNotification(Notifications.ADD_CONTROL_STATE, \"\" + this.componentName + \"-enabled\");\n  this.sendNotification(Notifications.ADD_CONTROL, this.viewComponent);\n};\n\nPanelControlMediator.prototype.openPanel = function() {\n  clearTimeout(this.timeout);\n  this.sendNotification(PanelNotifications.OPEN_PANEL, this.panel);\n  this.panel.viewComponent.addEventListener(\"mouseleave\", this.closePanelDelayed);\n};\n\nPanelControlMediator.prototype.closePanel = function() {\n  if (Utils.isMouseOverElement(this.panel.viewComponent) || Utils.isMouseOverElement(this.viewComponent) || this.facade.player.retrieveProxy(ApplicationStateProxy.NAME).getIsUserActive()) {\n    return;\n  }\n  this.panel.viewComponent.addEventListener(\"mouseleave\", this.closePanelDelayed);\n  this.sendNotification(PanelNotifications.CLOSE_PANEL, this.panel);\n};\n\nPanelControlMediator.prototype.delayedClosePanel = function() {\n  this.timeout = setTimeout(this.closePanel.bind(this), 350);\n};\n\nPanelControlMediator.prototype.togglePanel = function(event) {\n  event.stopImmediatePropagation();\n  this.sendNotification(PanelNotifications.TOGGLE_PANEL, this.panel);\n};\n\nPanelControlMediator.prototype.clickPanel = function() {};\n\n/**\n * The PlayPauseMediator class.\n * \n * @constructor\n * @private\n * @extends {ButtonMediator}\n*/\nfunction PanelMediator(componentName) {\n  PanelMediator.__super__.constructor.call(this, componentName, null, null, null);\n}\n\n\n__extends(PanelMediator, ComponentMediator);\n\n\nPanelMediator.prototype.componentType = \"panel\";\n\nPanelMediator.prototype.control = null;\n\n/**\n * @override\n*/\nPanelMediator.prototype.onRegister = function() {\n  PanelMediator.__super__.onRegister.call(this);\n  this.sendNotification(PanelNotifications.ADD_PANEL, this);\n};\n\n/**\n * The CaptioningMediator class.\n *\n * @constructor\n * @private\n * @extends {PluginMediator}\n * @param {Object} viewComponent\n*/\nfunction CaptionsMediator(viewComponent) {\n  CaptionsMediator.__super__.constructor.call(this, viewComponent);\n}\n\n\n__extends(CaptionsMediator, PluginMediator);\n\n\nCaptionsMediator.prototype.componentName = \"captioning\";\n\nCaptionsMediator.prototype.captionButton = null;\n\n/**\n * @override\n*/\nCaptionsMediator.prototype.onRegister = function() {\n  var button;\n  this.captioning = this.facade.player.captioning;\n  button = new ButtonMediator(this.localizationManager.getString(LocalizationConstants.MSG_CC), this.viewComponent, null, \"caption\", this.onclick.bind(this));\n  this.facade.registerMediator(button);\n  this.captionButton = button.getViewComponent();\n  this.sendNotification(Notifications.ADD_CONTROL, this.captionButton);\n  CaptionsMediator.__super__.onRegister.call(this);\n};\n\n/**\n*/\nCaptionsMediator.prototype.onclick = function(event) {\n  var _ref;\n  event.stopImmediatePropagation();\n  if (((_ref = this.captioning.getTrack()) != null ? _ref.type : void 0) === \"embedded\") {\n    this.captioning.setHidden(!this.captioning.getHidden());\n  } else if (event.currentTarget === this.captionButton) {\n    this.sendNotification(CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE, this.captioning.getHidden());\n  }\n  return false;\n};\n\n/**\n * The CaptioningSettingsMediator class.\n *\n * @constructor\n * @private\n * @extends {LocalizedMediator}\n * @param {Object} viewComponent\n*/\nfunction CaptionsSettingsMediator(viewComponent) {\n  this.list = {\n    font: null,\n    language: null,\n    edge: null,\n    size: null,\n    scroll: null\n  };\n  this.picker = {\n    color: null,\n    background: null,\n    edge: null,\n    window: null\n  };\n  this.toggle = {\n    ON: null,\n    OFF: null,\n    disabled: false\n  };\n  this.captioningObject = {\n    \"default\": {\n      fontFamily: \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\",\n      size: \"small\",\n      scroll: \"popout\",\n      fontColor: \"rgba(255,255,255,1)\",\n      edgeType: \"text-shadow: 0px 0px 0px\",\n      edgeColor: \"rgba(0, 0, 0, 0)\",\n      backgroundColor: \"rgba(0,0,0,0)\",\n      windowColor: \"rgba(0,0,0,0.5)\"\n    },\n    appliedStyleText: \"\",\n    selected: {\n      fontFamily: null,\n      size: null,\n      fontColor: null,\n      edgeType: null,\n      edgeColor: null,\n      backgroundColor: null,\n      windowColor: null\n    },\n    preset1: {\n      fontFamily: \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\",\n      size: \"medium\",\n      fontColor: \"rgba(255,255,255,1)\",\n      edgeType: \"text-shadow: 0px 0px 0px\",\n      edgeColor: \"rgba(0, 0, 0, 0)\",\n      backgroundColor: \"rgba(0,0,0,0)\",\n      windowColor: \"rgba(0,0,0,0)\"\n    },\n    preset2: {\n      fontFamily: \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\",\n      size: \"medium\",\n      fontColor: \"rgba(255,255,0,1)\",\n      edgeType: \"text-shadow: 0px 0px 0px\",\n      edgeColor: \"rgba(0, 0, 0, 0)\",\n      backgroundColor: \"rgba(0,0,0,0)\",\n      windowColor: \"rgba(0,0,0,0)\"\n    },\n    preset3: {\n      fontFamily: \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\",\n      size: \"medium\",\n      fontColor: \"rgba(255,255,255,1)\",\n      edgeType: \"text-shadow: 0px 0px 0px\",\n      edgeColor: \"rgba(0, 0, 0, 0)\",\n      backgroundColor: \"rgba(0,0,0,1)\",\n      windowColor: \"rgba(0,0,0,0)\"\n    },\n    preset4: {\n      fontFamily: \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\",\n      size: \"medium\",\n      fontColor: \"rgba(255,255,0,1)\",\n      edgeType: \"text-shadow: 0px 0px 0px\",\n      edgeColor: \"rgba(0, 0, 0, 1)\",\n      backgroundColor: \"rgba(0,0,0,0)\",\n      windowColor: \"rgba(0,0,0,0.5)\"\n    },\n    instance: null\n  };\n  CaptionsSettingsMediator.__super__.constructor.call(this, null, null, viewComponent, null);\n}\n\n\n__extends(CaptionsSettingsMediator, PluginComponentMediator);\n\n\nCaptionsSettingsMediator.prototype.componentName = \"captioning-settings\";\n\nCaptionsSettingsMediator.prototype.settingsUiVisible = false;\n\nCaptionsSettingsMediator.prototype.captionningStyle = null;\n\nCaptionsSettingsMediator.prototype.swatchColorCurr = null;\n\nCaptionsSettingsMediator.prototype.swatchOpacityCurr = null;\n\nCaptionsSettingsMediator.prototype.colorPicker = null;\n\nCaptionsSettingsMediator.prototype.colorPickerOpacity = null;\n\nCaptionsSettingsMediator.prototype.advancedSettingContainer = null;\n\nCaptionsSettingsMediator.prototype.scroll = {\n  type: \"popout\",\n  typeSpeed: 5,\n  lines: 2,\n  scrollTimer: [],\n  speed: 10,\n  popout: null,\n  rollup: null,\n  painton: null\n};\n\n/**\n * @override\n*/\nCaptionsSettingsMediator.prototype.onRegister = function() {\n  var applyButton, cancelButton, captionContainer, captionLabel, clonedSwatch, color, colorArray, isDefault, preset1, preset2, preset3, preset4, previewContainer, previewPara, resetButton, swatch, titleBar, titleText, toggleAdvancedButton, _i, _len,\n    _this = this;\n  CaptionsSettingsMediator.__super__.onRegister.call(this);\n  this.captioning = this.facade.player.captioning;\n  titleBar = this.create(\"captioning-titlebar\");\n  titleText = this.create(\"captioning-title\", titleBar, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_TITLE));\n  this.toggle.OFF = this.create(\"captioning-toggle-btn\", titleBar, \"div\", \"OFF\");\n  this.toggle.ON = this.create(\"captioning-toggle-btn\", titleBar, \"div\", \"ON\");\n  EventHandler.create(this.toggle.ON, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    if (!_this.toggle.disabled) {\n      _this.toggleButtonHandler(true);\n    }\n    return false;\n  });\n  if (!this.toggle.disabled) {\n    ClassList.add(\"captioning-floater-btnselected\", this.toggle.OFF, this.classList.prefix);\n  }\n  EventHandler.create(this.toggle.OFF, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    if (!_this.toggle.disabled) {\n      _this.toggleButtonHandler(false);\n    }\n    return false;\n  });\n  captionContainer = this.create(\"captioning-row\");\n  captionLabel = this.create(\"captioning-label\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_LANGUAGE));\n  this.list.language = this.create(\"captioning-dropdown\", captionContainer, \"select\");\n  this.languageListPopulate();\n  EventHandler.create(this.list.language, \"change\", function(event) {\n    var langIsSelected;\n    event.stopImmediatePropagation();\n    langIsSelected = event.target.selectedValue !== \"None\";\n    _this.captioining.setHidden(!langIsSelected);\n    if (langIsSelected) {\n      _this.captioning.setTrack(_this.captioning.selectTrackByIndex(event.target.selectedIndex));\n    }\n    return false;\n  });\n  captionLabel = this.create(\"captioning-label\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_PRESETS));\n  preset1 = this.create([\"captioning-preset\", \"captioning-preset1\"], captionContainer, null, \"Aa\");\n  preset2 = this.create([\"captioning-preset\", \"captioning-preset2\"], captionContainer, null, \"Aa\");\n  preset3 = this.create([\"captioning-preset\", \"captioning-preset3\"], captionContainer, null, \"Aa\");\n  preset4 = this.create([\"captioning-preset\", \"captioning-preset4\"], captionContainer, null, \"Aa\");\n  EventHandler.create(preset1, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.captioningObject.selected = _this.cloneObject(_this.captioningObject.preset1);\n    _this.applyCaptioningStyle();\n    return false;\n  });\n  EventHandler.create(preset2, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.captioningObject.selected = _this.cloneObject(_this.captioningObject.preset2);\n    _this.applyCaptioningStyle();\n    return false;\n  });\n  EventHandler.create(preset3, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.captioningObject.selected = _this.cloneObject(_this.captioningObject.preset3);\n    _this.applyCaptioningStyle();\n    return false;\n  });\n  EventHandler.create(preset4, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.captioningObject.selected = _this.cloneObject(_this.captioningObject.preset4);\n    _this.applyCaptioningStyle();\n    return false;\n  });\n  this.advancedSettingContainer = this.create(\"captioning-advanced-container\");\n  captionContainer = this.create(\"captioning-row\", this.advancedSettingContainer);\n  captionLabel = this.create(\"captioning-label\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_FONT));\n  this.list.font = this.create(\"captioning-dropdown\", captionContainer, \"select\");\n  this.create(null, this.list.font, \"option\", \"Monospaced Serif\").value = \"'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace\";\n  this.create(null, this.list.font, \"option\", \"Proportional Serif\").value = \"'Times New Roman', Times, Georgia, Cambria, 'PT Serif Caption', serif\";\n  this.create(null, this.list.font, \"option\", \"Monospaced Sans-Serif\").value = \"'Deja Vu Sans Mono', 'Lucida Console', Monaco, Consolas, 'PT Mono', monospace\";\n  this.create(null, this.list.font, \"option\", \"Proportional Sans-Serif\").value = \"Roboto, 'Arial Unicode Ms', Arial, Helvetica, Verdana, 'PT Sans Caption', sans-serif\";\n  this.create(null, this.list.font, \"option\", \"Casual\").value = \"'Comic Sans MS', Impact, Handlee, fantasy\";\n  this.create(null, this.list.font, \"option\", \"Cursive\").value = \"'Monotype Corsiva', 'URW Chancery L', 'Apple Chancery', 'Dancing Script', cursive\";\n  this.create(null, this.list.font, \"option\", \"Small Capitals\").value = \"'Arial Unicode Ms', Arial, Helvetica, Verdana, 'Marcellus SC', sans-serif; font-variant: small-caps\";\n  EventHandler.create(this.list.font, \"change\", function(event) {\n    event.stopImmediatePropagation();\n    _this.captioningObject.selected.fontFamily = event.target.value;\n    _this.applyCaptioningStyle(false);\n    return false;\n  });\n  captionContainer.appendChild(this.list.font);\n  captionLabel = this.create(\"captioning-label\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_EDGE));\n  this.list.edge = this.create(\"captioning-dropdown\", captionContainer, \"select\");\n  this.create(null, this.list.edge, \"option\", \"None\").value = \"text-shadow: 0px 0px 0px\";\n  this.create(null, this.list.edge, \"option\", \"Depressed\").value = \"text-shadow: 0px 1px 0px\";\n  this.create(null, this.list.edge, \"option\", \"Left Drop Shadow\").value = \"text-shadow: -3px 3px 2px\";\n  this.create(null, this.list.edge, \"option\", \"Raised\").value = \"text-shadow: 0px 1px 1px\";\n  this.create(null, this.list.edge, \"option\", \"Right Drop Shadow\").value = \"text-shadow: 3px 3px 2px\";\n  this.create(null, this.list.edge, \"option\", \"Uniform\").value = \"text-shadow: 0px 0px 4px\";\n  EventHandler.create(this.list.edge, \"change\", function(event) {\n    event.stopImmediatePropagation();\n    _this.captioningObject.selected.edgeType = event.target.value;\n    _this.applyCaptioningStyle(false);\n    return false;\n  });\n  captionContainer = this.create(\"captioning-row\", this.advancedSettingContainer);\n  this.create(\"captioning-label\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_SIZE));\n  this.list.size = this.create(\"captioning-dropdown\", captionContainer, \"select\");\n  this.create(null, this.list.size, \"option\", \"Extra Small\").value = \"x-small\";\n  this.create(null, this.list.size, \"option\", \"Small\").value = \"small\";\n  this.create(null, this.list.size, \"option\", \"Medium\").value = \"medium\";\n  this.create(null, this.list.size, \"option\", \"Large\").value = \"large\";\n  this.create(null, this.list.size, \"option\", \"Extra Large\").value = \"x-large\";\n  this.list.size.selectedIndex = 1;\n  EventHandler.create(this.list.size, \"change\", function(event) {\n    event.stopImmediatePropagation();\n    _this.captioningObject.selected.size = event.target.value;\n    _this.applyCaptioningStyle(false);\n    return false;\n  });\n  this.create(\"captioning-label\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_SCROLL));\n  this.list.scroll = this.create(\"captioning-dropdown\", captionContainer, \"select\");\n  this.create(null, this.list.scroll, \"option\", \"Pop-Out\").value = \"popout\";\n  this.create(null, this.list.scroll, \"option\", \"Roll-On\").value = \"rollon\";\n  this.create(null, this.list.scroll, \"option\", \"Paint-On\").value = \"painton\";\n  EventHandler.create(this.list.scroll, \"change\", function(event) {\n    event.stopImmediatePropagation();\n    _this.captioningObject.selected.scroll = _this.scroll.type = event.target.value;\n    return false;\n  });\n  captionContainer = this.create(\"captioning-row\", this.advancedSettingContainer);\n  this.create(\"captioning-label-small\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_COLOR));\n  this.picker.color = this.create(\"captioning-color-picker\", captionContainer);\n  this.picker.color.style.backgroundColor = this.captioningObject[\"default\"].fontColor;\n  EventHandler.create(this.picker.color, EventHandler.CLICK, function(event) {\n    var alpha, _ref;\n    event.stopImmediatePropagation();\n    _this.colorPickerHandler();\n    _this.colorPicker.style.display = _this.colorPicker.style.display === \"block\" ? \"none\" : \"block\";\n    if (_this.colorPicker.style.display === \"block\") {\n      if ((_ref = _this.swatchColorCurr) != null) {\n        _ref.style.borderColor = \"rgba(0,0,0,0.3)\";\n      }\n      _this.colorPicker.style.left = \"152px\";\n      _this.colorPicker.name = \"fontColor\";\n      _this.captioningObject.instance = _this.picker.color;\n      if (_this.picker.color.style.backgroundColor.indexOf('rgba') !== -1) {\n        alpha = _this.picker.color.style.backgroundColor.replace(/^rgba?\\(|\\s+|\\)$/g, '').split(',')[3];\n      }\n      _this.colorPickerOpacity.value = alpha != null ? alpha : 1;\n    }\n    return false;\n  });\n  this.create(\"captioning-label-small\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_BACKGROUND));\n  this.picker.background = this.create(\"captioning-color-picker\", captionContainer);\n  this.picker.background.style.backgroundColor = this.captioningObject[\"default\"].backgroundColor;\n  EventHandler.create(this.picker.background, EventHandler.CLICK, function(event) {\n    var alpha, _ref;\n    event.stopImmediatePropagation();\n    _this.colorPickerHandler();\n    _this.colorPicker.style.display = _this.colorPicker.style.display === \"block\" ? \"none\" : \"block\";\n    if (_this.colorPicker.style.display === \"block\") {\n      if ((_ref = _this.swatchColorCurr) != null) {\n        _ref.style.borderColor = \"rgba(0,0,0,0.3)\";\n      }\n      _this.colorPicker.style.left = \"264px\";\n      _this.colorPicker.name = \"backgroundColor\";\n      _this.captioningObject.instance = _this.picker.background;\n      if (_this.picker.background.style.backgroundColor.indexOf('rgba') !== -1) {\n        alpha = _this.picker.background.style.backgroundColor.replace(/^rgba?\\(|\\s+|\\)$/g, '').split(',')[3];\n      }\n      _this.colorPickerOpacity.value = alpha != null ? alpha : 1;\n    }\n    return false;\n  });\n  this.create(\"captioning-label-small\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_EDGE));\n  this.picker.edge = this.create(\"captioning-color-picker\", captionContainer);\n  this.picker.edge.style.backgroundColor = this.captioningObject[\"default\"].edgeColor;\n  EventHandler.create(this.picker.edge, EventHandler.CLICK, function(event) {\n    var alpha, _ref;\n    event.stopImmediatePropagation();\n    _this.colorPickerHandler();\n    _this.colorPicker.style.display = _this.colorPicker.style.display === \"block\" ? \"none\" : \"block\";\n    if (_this.colorPicker.style.display === \"block\") {\n      if ((_ref = _this.swatchColorCurr) != null) {\n        _ref.style.borderColor = \"rgba(0,0,0,0.3)\";\n      }\n      _this.colorPicker.style.left = \"212px\";\n      _this.colorPicker.name = \"edgeColor\";\n      _this.captioningObject.instance = _this.picker.edge;\n      if (_this.picker.edge.style.backgroundColor.indexOf('rgba') !== -1) {\n        alpha = _this.picker.edge.style.backgroundColor.replace(/^rgba?\\(|\\s+|\\)$/g, '').split(',')[3];\n      }\n      _this.colorPickerOpacity.value = alpha != null ? alpha : 1;\n    }\n    return false;\n  });\n  this.create(\"captioning-label-small\", captionContainer, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_WINDOW));\n  this.picker.window = this.create(\"captioning-color-picker\", captionContainer);\n  this.picker.window.style.backgroundColor = this.captioningObject[\"default\"].windowColor;\n  EventHandler.create(this.picker.window, EventHandler.CLICK, function(event) {\n    var alpha, _ref;\n    event.stopImmediatePropagation();\n    _this.colorPickerHandler();\n    _this.colorPicker.style.display = _this.colorPicker.style.display === \"block\" ? \"none\" : \"block\";\n    if (_this.colorPicker.style.display === \"block\") {\n      if ((_ref = _this.swatchColorCurr) != null) {\n        _ref.style.borderColor = \"rgba(0,0,0,0.3)\";\n      }\n      _this.colorPicker.style.left = \"300px\";\n      _this.colorPicker.name = \"windowColor\";\n      _this.captioningObject.instance = _this.picker.window;\n      if (_this.picker.window.style.backgroundColor.indexOf('rgba') !== -1) {\n        alpha = _this.picker.window.style.backgroundColor.replace(/^rgba?\\(|\\s+|\\)$/g, '').split(',')[3];\n      }\n      _this.colorPickerOpacity.value = alpha != null ? alpha : 1;\n    }\n    return false;\n  });\n  previewContainer = this.create([\"caption-text\", \"caption-text-preview\"]);\n  previewPara = this.create(null, previewContainer, \"p\", this.localizationManager.getString(LocalizationConstants.MSG_CC_PREVIEW_TEXT));\n  captionContainer = this.create(\"captioning-footer-container\");\n  applyButton = this.create(\"captioning-footer-button\", captionContainer, \"div\", this.localizationManager.getString(LocalizationConstants.MSG_CC_APPLY));\n  cancelButton = this.create(\"captioning-footer-button\", captionContainer, \"div\", this.localizationManager.getString(LocalizationConstants.MSG_CC_CANCEL));\n  resetButton = this.create(\"captioning-footer-button\", captionContainer, \"div\", this.localizationManager.getString(LocalizationConstants.MSG_CC_RESET));\n  if (this.captioning.getViewComponent().clientWidth >= 0) {\n    toggleAdvancedButton = this.create(\"captioning-advanced-button\", captionContainer, \"div\", this.localizationManager.getString(LocalizationConstants.MSG_CC_SHOW_ADVANCED));\n    EventHandler.create(toggleAdvancedButton, EventHandler.CLICK, function(event) {\n      event.stopImmediatePropagation();\n      if (_this.advancedSettingContainer.style.display === \"block\") {\n        event.target.innerHTML = _this.localizationManager.getString(LocalizationConstants.MSG_CC_SHOW_ADVANCED);\n        _this.advancedSettingContainer.style.display = \"none\";\n        _this.colorPicker.style.display = \"none\";\n      } else {\n        event.target.innerHTML = _this.localizationManager.getString(LocalizationConstants.MSG_CC_HIDE_ADVANCED);\n        _this.advancedSettingContainer.style.display = \"block\";\n      }\n      return false;\n    });\n  }\n  EventHandler.create(applyButton, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.sendNotification(CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE, _this.settingsUiVisible);\n    _this.applyCaptioningStyle(false, true);\n    _this.sendNotification(CaptioningNotifications.SETTINGS_CHANGE, _this.captioningObject.selected);\n    return false;\n  });\n  EventHandler.create(cancelButton, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.sendNotification(CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE, _this.settingsUiVisible);\n    return false;\n  });\n  EventHandler.create(resetButton, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.colorPicker.style.display = \"none\";\n    _this.applyCaptioningStyle(true);\n    return false;\n  });\n  this.captionningStyle = this.create(null, document.getElementsByTagName('head')[0], \"style\");\n  this.captionningStyle.type = 'text/css';\n  colorArray = [\"#000000\", \"#660000\", \"#990000\", \"#ff0000\", \"#000066\", \"#660066\", \"#990066\", \"#ff0066\", \"#006600\", \"#666600\", \"#996600\", \"#ff6600\", \"#006666\", \"#666666\", \"#996666\", \"#ff6666\", \"#009900\", \"#669966\", \"#999900\", \"#ff9900\", \"#009966\", \"#669966\", \"#999966\", \"#ff9966\", \"#00ff00\", \"#66ff00\", \"#99ff00\", \"#ffff00\", \"#00ff66\", \"#66ff66\", \"#99ff66\", \"#ffff66\", \"#000099\", \"#660099\", \"#990099\", \"#ff0099\", \"#0000ff\", \"#6600ff\", \"#9900ff\", \"#ff00ff\", \"#006699\", \"#666699\", \"#996699\", \"#ff6699\", \"#0066ff\", \"#6666ff\", \"#9966ff\", \"#ff66ff\", \"#009999\", \"#669999\", \"#999999\", \"#ff9999\", \"#0099ff\", \"#6699ff\", \"#9999ff\", \"#ff99ff\", \"#0099ff\", \"#66ff99\", \"#99ff99\", \"#ffff99\", \"#00ffff\", \"#66ffff\", \"#99ffff\", \"#ffffff\"];\n  this.colorPicker = this.create(\"colorpicker-palette\", this.viewComponent.parentElement);\n  swatch = this.create(\"colorpicker-swatch\", false, null, \"&nbsp;\");\n  for (_i = 0, _len = colorArray.length; _i < _len; _i++) {\n    color = colorArray[_i];\n    swatch.style.backgroundColor = color;\n    clonedSwatch = swatch.cloneNode();\n    EventHandler.create(clonedSwatch, EventHandler.CLICK, function(event) {\n      event.stopImmediatePropagation();\n      if (_this.swatchColorCurr !== null) {\n        _this.swatchColorCurr.style.borderColor = \"rgba(0,0,0,0.3)\";\n      }\n      _this.swatchColorCurr = event.target;\n      _this.swatchColorCurr.style.borderColor = \"rgba(255, 50, 50, 1)\";\n      _this.captioningObject.instance.style.backgroundColor = _this.captioningObject.selected[_this.colorPicker.name] = _this.toRGBA(event.target.style.backgroundColor);\n      _this.applyCaptioningStyle(false);\n      return false;\n    });\n    this.colorPicker.appendChild(clonedSwatch);\n  }\n  this.create(\"opacity-label\", this.colorPicker, \"span\", this.localizationManager.getString(LocalizationConstants.MSG_CC_OPACITY));\n  this.colorPickerOpacity = this.create(\"colorpicker-slider\", this.colorPicker, \"input\");\n  this.colorPickerOpacity.type = \"range\";\n  this.colorPickerOpacity.min = 0;\n  this.colorPickerOpacity.max = 1;\n  this.colorPickerOpacity.step = .1;\n  this.colorPickerOpacity.value = 1;\n  EventHandler.create(this.colorPickerOpacity, \"change\", function(event) {\n    event.stopImmediatePropagation();\n    _this.captioningObject.instance.style.backgroundColor = _this.captioningObject.selected[_this.colorPicker.name] = _this.toRGBA(_this.captioningObject.instance.style.backgroundColor);\n    _this.applyCaptioningStyle(false);\n    return false;\n  });\n  this.swatchOpacityCurr = this.colorPickerOpacity;\n  try {\n    if (localStorage.getItem(Namespace.PREFIX + \"captioningDefault\") != null) {\n      this.captioningObject.selected = JSON.parse(localStorage.getItem(Namespace.PREFIX + \"captioningDefault\"));\n      this.applyCaptioningStyle(false, !this.captioning.getHidden());\n    } else {\n      isDefault = !((this.captioning.config.style != null) || this.captioning.config.style !== \"undefined\");\n      if (!isDefault) {\n        this.captioningObject.selected = this.cloneObject(this.captioning.config.style);\n      }\n      this.applyCaptioningStyle(isDefault);\n    }\n  } catch (_error) {}\n  this.setSettings(Object.keys(this.captioningObject.selected).length > 0 ? this.captioningObject.selected : this.captioningObject[\"default\"]);\n  this.toggleButtonHandler(!this.captioning.getHidden(), false);\n};\n\nCaptionsSettingsMediator.prototype.toRGBA = function(colorCode) {\n  var rbga, rgb;\n  rgb = colorCode.replace(/^rgba?\\(|\\s+|\\)$/g, '').split(',');\n  rbga = 'rgba(' + rgb[0] + \",\" + rgb[1] + \",\" + rgb[2] + \",\" + this.swatchOpacityCurr.value + ')';\n  return rbga;\n};\n\nCaptionsSettingsMediator.prototype.onScrollListChange = function(value) {\n  var _ref;\n  if (value != null) {\n    this.captioningObject.selected.scroll = this.scroll.type = value;\n  }\n  this.setSettings({\n    scroll: this.scroll.type\n  });\n  try {\n    if (((_ref = this.captioning.proxy.renderer) != null ? _ref.viewComponent : void 0) != null) {\n      if (this.scroll.type === \"painton\") {\n        ClassList.add(\"akamai-captioning-typed\", this.captioning.proxy.renderer.viewComponent);\n      } else {\n        ClassList.remove(\"akamai-captioning-typed\", this.captioning.proxy.renderer.viewComponent);\n      }\n    }\n  } catch (error) {\n    this.facade.logger.error(\"AMP Captioning Error\", error);\n  }\n};\n\nCaptionsSettingsMediator.prototype.languageListPopulate = function() {\n  var language, track, tracks, _i, _len, _ref;\n  tracks = this.captioning.getTracks();\n  if (!(tracks != null)) {\n    return;\n  }\n  this.list.language.innerHTML = \"\";\n  for (_i = 0, _len = tracks.length; _i < _len; _i++) {\n    track = tracks[_i];\n    language = track.language;\n    language = this.facade.player.retrieveProxy(LocalizationProxy.NAME).getLanguageString(language);\n    if ((language != null) && language !== \"\") {\n      this.create(null, this.list.language, \"option\", language).value = track.language;\n    }\n  }\n  this.toggle.disabled = this.list.language.childElementCount === 0;\n  if (this.toggle.disabled) {\n    this.create(null, this.list.language, \"option\", \"None\");\n  }\n  this.list.language.value = (_ref = this.captioning.getTrack()) != null ? _ref.language : void 0;\n};\n\nCaptionsSettingsMediator.prototype.colorPickerHandler = function(unbind) {\n  var _this = this;\n  if (unbind == null) {\n    unbind = false;\n  }\n  if (unbind) {\n    return EventHandler.unbind(document, EventHandler.CLICK);\n  }\n  EventHandler.create(document, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.colorPickerHandler(true);\n    if (event.target.className !== \"akamai-colorpicker-palette\" && event.target.className !== \"akamai-opacity-label\" && event.target.className !== \"akamai-colorpicker-slider\" && _this.colorPicker.style.display !== \"none\") {\n      _this.colorPicker.style.display = \"none\";\n    }\n    return false;\n  });\n};\n\nCaptionsSettingsMediator.prototype.cloneObject = function(clone) {\n  var cloned, key;\n  cloned = {};\n  for (key in clone) {\n    cloned[key] = clone[key];\n  }\n  return cloned;\n};\n\nCaptionsSettingsMediator.prototype.applyCaptioningStyle = function(isDefault, isApply, settingsDefault) {\n  var backgroundColor, color, containerStyle, edgeType, fontFamily, fontSize, id, windowColor, windowColorValue;\n  if (isDefault == null) {\n    isDefault = false;\n  }\n  if (isApply == null) {\n    isApply = false;\n  }\n  if (settingsDefault == null) {\n    settingsDefault = false;\n  }\n  if (isDefault) {\n    this.captioningObject.selected = this.cloneObject(this.captioningObject[\"default\"]);\n    this.list.font.value = this.captioningObject[\"default\"].fontFamily;\n    this.list.edge.value = this.captioningObject[\"default\"].edgeType != null ? this.captioningObject[\"default\"].edgeType : \"text-shadow: 0px 0px 0px\";\n    this.list.size.value = this.captioningObject[\"default\"].size;\n    this.list.scroll.value = this.captioningObject[\"default\"].scroll;\n    this.picker.color.style.backgroundColor = this.captioningObject[\"default\"].fontColor;\n    this.picker.background.style.backgroundColor = this.captioningObject[\"default\"].backgroundColor;\n    this.picker.edge.style.backgroundColor = this.captioningObject[\"default\"].edgeColor;\n    this.picker.window.style.backgroundColor = this.captioningObject[\"default\"].windowColor;\n  } else {\n    if ((this.captioningObject.selected.fontFamily != null) && !settingsDefault) {\n      this.list.font.value = this.captioningObject.selected.fontFamily;\n    }\n    this.list.edge.value = this.captioningObject.selected.edgeType != null ? this.captioningObject.selected.edgeType : \"text-shadow: 0px 0px 0px\";\n    if (this.captioningObject.selected.size != null) {\n      this.list.size.value = this.captioningObject.selected.size;\n    }\n    if (this.captioningObject.selected.scroll != null) {\n      this.list.scroll.value = this.captioningObject.selected.scroll;\n    } else {\n      this.captioningObject.selected.scroll = this.list.scroll.value;\n    }\n    this.picker.color.style.backgroundColor = this.captioningObject.selected.fontColor;\n    if (this.captioningObject.selected.backgroundColor != null) {\n      this.picker.background.style.backgroundColor = this.captioningObject.selected.backgroundColor;\n    }\n    if (this.captioningObject.selected.edgeColor != null) {\n      this.picker.edge.style.backgroundColor = this.captioningObject.selected.edgeColor;\n    }\n    if (this.captioningObject.selected.windowColor != null) {\n      this.picker.window.style.backgroundColor = this.captioningObject.selected.windowColor;\n    }\n  }\n  fontFamily = \"font-family: \" + (isDefault ? this.captioningObject[\"default\"].fontFamily : settingsDefault ? this.captioningObject.selected.fontFamily : this.list.font.value) + \" !important;\";\n  edgeType = (isDefault ? this.captioningObject[\"default\"].edgeType + this.captioningObject[\"default\"].edgeColor : this.list.edge.value + \" \" + this.picker.edge.style.backgroundColor) + \" !important;\";\n  fontSize = \"font-size: \" + (isDefault ? this.captioningObject[\"default\"].size : this.list.size.value) + \" !important;\";\n  color = \"color: \" + (isDefault ? this.captioningObject[\"default\"].fontColor : this.picker.color.style.backgroundColor) + \" !important;\";\n  backgroundColor = \"background-color: \" + (isDefault ? this.captioningObject[\"default\"].backgroundColor : this.picker.background.style.backgroundColor) + \" !important;\";\n  windowColor = \"background-color: \" + (isDefault ? this.captioningObject[\"default\"].windowColor : this.picker.window.style.backgroundColor) + \" !important;\";\n  containerStyle = \"line-height:2.2em;\";\n  windowColorValue = windowColor.match(/rgba\\([^)]+\\)/g);\n  if ((windowColorValue != null) && windowColorValue instanceof Array && windowColorValue.length > 0) {\n    containerStyle = Number(windowColorValue[0].replace(/^.*, (.+)\\)/, '$1')) === 0 ? \"\" : containerStyle;\n  }\n  if (isApply) {\n    this.onScrollListChange();\n    id = this.facade.player.viewComponent.id;\n    this.captionningStyle.innerHTML = this.captioningObject.appliedStyleText = '#' + id + ' .akamai-caption-text { ' + fontFamily + fontSize + edgeType + windowColor + ' } #' + id + ' .akamai-caption-text p { ' + color + backgroundColor + ' } ' + 'video::-webkit-media-text-track-display { ' + windowColor + ' } video::-webkit-media-text-track-display span { ' + fontFamily + fontSize + edgeType + backgroundColor + ' } video::-webkit-media-text-track-display { ' + windowColor + ' } video::cue { ' + color + fontFamily + fontSize + edgeType + backgroundColor + ' } video::-webkit-media-text-track-container {' + containerStyle + '} video::-webkit-media-text-track-display-backdrop { background-color: rgba(0, 0, 0, 0) !important;}';\n    try {\n      if (isDefault === false && !settingsDefault) {\n        localStorage.setItem(Namespace.PREFIX + \"captioningDefault\", JSON.stringify(this.captioningObject.selected));\n      }\n    } catch (localStorageError) {\n      this.facade.logger.error(\"LocalStorage Not Supported on this Browser\", localStorageError);\n    }\n  } else {\n    this.captionningStyle.innerHTML = this.captioningObject.appliedStyleText + '#' + id + ' .akamai-caption-text.akamai-caption-text-preview { ' + fontFamily + fontSize + edgeType + windowColor + ' } #' + id + ' .akamai-caption-text.akamai-caption-text-preview p { ' + color + backgroundColor + ' }';\n  }\n};\n\nCaptionsSettingsMediator.prototype.toggleButtonHandler = function(isON, isTargetButton) {\n  if (isON == null) {\n    isON = false;\n  }\n  if (isTargetButton == null) {\n    isTargetButton = true;\n  }\n  if (isON) {\n    ClassList.add(\"captioning-floater-btnselected\", this.toggle.ON, this.classList.prefix);\n    ClassList.remove(\"captioning-floater-btnselected\", this.toggle.OFF, this.classList.prefix);\n  } else {\n    ClassList.add(\"captioning-floater-btnselected\", this.toggle.OFF, this.classList.prefix);\n    ClassList.remove(\"captioning-floater-btnselected\", this.toggle.ON, this.classList.prefix);\n  }\n  if (isTargetButton) {\n    this.captioning.setHidden(!isON);\n  }\n  this.sendNotification(UserSettingsNotifications.UPDATE_SETTINGS, {\n    captioning: {\n      hidden: !isON\n    }\n  });\n};\n\nCaptionsSettingsMediator.prototype.setSettings = function(value) {\n  this.settings = value;\n  this.facade.player.settings.change({\n    captions: value\n  });\n  return value;\n};\n\nCaptionsSettingsMediator.prototype.getSettings = function() {\n  return this.settings;\n};\n\n/**\n * @override\n*/\nCaptionsSettingsMediator.prototype.listNotificationInterests = function() {\n  return [CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE, CaptioningNotifications.TOGGLE_SETTINGS_VISIBILITY, CaptioningNotifications.SETTINGS_CHANGE];\n};\n\n/**\n * @override\n*/\nCaptionsSettingsMediator.prototype.handleNotification = function(notification) {\n  var body, fName, fValue, i, isDefault, k, listString, name, note, option, state, v, _i, _len, _ref;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case CaptioningNotifications.SETTINGS_VISIBILITY_CHANGE:\n    case CaptioningNotifications.TOGGLE_SETTINGS_VISIBILITY:\n      if (this.settingsUiVisible) {\n        this.colorPicker.style.display = \"none\";\n      }\n      this.settingsUiVisible = !this.settingsUiVisible;\n      if (this.settingsUiVisible && this.list.language.length === 1) {\n        this.languageListPopulate();\n      }\n      note = this.settingsUiVisible ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;\n      state = \"cc-setting-active\";\n      this.toggleButtonHandler(!this.captioning.getHidden(), false);\n      this.list.language.value = this.captioning.getTrack().language;\n      this.onScrollListChange(this.captioningObject.selected.scroll);\n      this.sendNotification(note, state);\n      break;\n    case CaptioningNotifications.SETTINGS_CHANGE:\n      isDefault = false;\n      for (k in body) {\n        v = body[k];\n        switch (k) {\n          case \"fontFamily\":\n          case \"fontSize\":\n          case \"scroll\":\n          case \"edgeType\":\n            listString = k === \"fontFamily\" ? \"font\" : k === \"fontSize\" ? \"size\" : k === \"edgeType\" ? \"edge\" : \"scroll\";\n            _ref = this.list[listString].options;\n            for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {\n              option = _ref[i];\n              if (k === \"fontFamily\" && typeof v === \"object\") {\n                for (fName in v) {\n                  fValue = v[fName];\n                  if (fName === \"default\") {\n                    this.captioningObject.selected.fontFamily = fValue;\n                    isDefault = true;\n                  }\n                  if ((new RegExp(fName, \"i\")).test(option.label)) {\n                    if (!(new RegExp(\"^\" + fValue)).test(option.value)) {\n                      option.value = fValue + \",\" + option.value;\n                    }\n                    if (option.selected) {\n                      this.captioningObject.selected.fontFamily = option.value;\n                    }\n                  }\n                }\n              } else if ((new RegExp(\"^\" + v + \"$\", \"i\")).test(option.label)) {\n                this.list[listString].selectedIndex = i;\n                if (k === \"fontSize\") {\n                  k = \"size\";\n                }\n                this.captioningObject.selected[k] = option.value;\n                if (k === \"scroll\") {\n                  this.scroll.type = this.captioningObject.selected.scroll = option.value;\n                  this.setSettings({\n                    scroll: this.scroll.type\n                  });\n                  try {\n                    if (option.value === \"painton\") {\n                      ClassList.add(\"akamai-captioning-typed\", this.captioning.proxy.renderer.viewComponent);\n                    } else {\n                      ClassList.remove(\"akamai-captioning-typed\", this.captioning.proxy.renderer.viewComponent);\n                    }\n                  } catch (error) {\n                    this.facade.logger.error(\"AMP Captioning Error\", error);\n                  }\n                }\n              }\n            }\n            break;\n          case \"backgroundColor\":\n          case \"edgeColor\":\n          case \"fontColor\":\n          case \"windowColor\":\n            this.captioningObject.selected[k] = v;\n        }\n      }\n      this.applyCaptioningStyle(false, true, isDefault);\n      if ((body.visible != null) && body.visible !== !this.captioning.getHidden()) {\n        this.captioning.setHidden(!body.visible);\n      }\n  }\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction PlayOverlayMediator() {\n  PlayOverlayMediator.__super__.constructor.call(this);\n}\n\n\n__extends(PlayOverlayMediator, OverlayMediator);\n\n\nPlayOverlayMediator.prototype.componentName = \"play\";\n\nPlayOverlayMediator.prototype.onclick = function(event) {\n  event.stopImmediatePropagation();\n  event.preventDefault();\n  this.sendNotification(UserNotifications.TOGGLE_PLAY_PAUSE);\n  return false;\n};\n\nfunction VolumePanelControlMediator(componentName) {\n  VolumePanelControlMediator.__super__.constructor.call(this, componentName);\n}\n\n\n__extends(VolumePanelControlMediator, PanelControlMediator);\n\n\nVolumePanelControlMediator.prototype.clickHandler = function() {\n  this.sendNotification(Notifications.TOGGLE_MUTED);\n};\n\n/**\n * The VolumeMediator class.\n *\n * @constructor\n * @private\n * @extends {ModuleMediator}\n * @param {Object} viewComponent\n*/\nfunction VolumeMediator(parent, direction) {\n  VolumeMediator.__super__.constructor.call(this, parent, direction);\n}\n\n\n__extends(VolumeMediator, SliderMediator);\n\n\nVolumeMediator.prototype.componentName = \"volume\";\n\nVolumeMediator.prototype.draggable = true;\n\n/**\n * @override\n*/\nVolumeMediator.prototype.valueChanged = function() {\n  this.sendNotification(Notifications.CHANGE_VOLUME, this.value);\n  this.sendNotification(UserSettingsNotifications.UPDATE_SETTINGS, {\n    volume: this.value\n  });\n};\n\n/**\n * @override\n*/\nVolumeMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.VOLUME_CHANGE, Notifications.READY];\n};\n\n/**\n * @override\n*/\nVolumeMediator.prototype.handleNotification = function(notification) {\n  switch (notification.getName()) {\n    case Notifications.READY:\n      this.updateValue(this.facade.player.getVolume(), true);\n      break;\n    case Notifications.VOLUME_CHANGE:\n      this.updateValue(notification.getBody());\n  }\n};\n\n/**\n * The ControlPanelMediator class.\n *\n * @constructor\n * @private\n * @extends {PluginMediator}\n*/\nfunction ControlPanelMediator() {\n  ControlPanelMediator.__super__.constructor.call(this);\n  this.controls = {};\n}\n\n\n__extends(ControlPanelMediator, PluginMediator);\n\n\nControlPanelMediator.prototype.panel = null;\n\nControlPanelMediator.prototype.control = null;\n\nControlPanelMediator.prototype.separator = null;\n\nControlPanelMediator.prototype.controls = null;\n\nControlPanelMediator.prototype.labels = null;\n\nControlPanelMediator.prototype.closed = true;\n\nControlPanelMediator.prototype.panelClass = PanelMediator;\n\nControlPanelMediator.prototype.controlClass = PanelControlMediator;\n\n/**\n * @override\n*/\nControlPanelMediator.prototype.onRegister = function() {\n  this.panel = this.createPanel(this.componentName);\n  this.control = this.createControl(this.componentName);\n  this.separator = this.createSeparator(this.componentName);\n  this.panel.control = this.control;\n  this.control.panel = this.panel;\n  if (this.labels == null) {\n    this.labels = {};\n  }\n  this.createPanelControls(this.componentName);\n};\n\nControlPanelMediator.prototype.createControl = function(name) {\n  var control;\n  control = new this.controlClass(name);\n  this.facade.registerMediator(control);\n  return control;\n};\n\nControlPanelMediator.prototype.createPanel = function(name) {\n  var panel;\n  panel = new this.panelClass(name);\n  this.facade.registerMediator(panel);\n  return panel;\n};\n\nControlPanelMediator.prototype.createSeparator = function(name) {\n  return this.create([\"separator\", \"icon\"], this.panel);\n};\n\nControlPanelMediator.prototype.createPanelControls = function(name) {\n  var data, key, value, _base, _ref;\n  data = (typeof (_base = this.plugin).getConfigurationData === \"function\" ? _base.getConfigurationData() : void 0) || this.facade.getConfig()[this.componentName];\n  for (key in data) {\n    value = data[key];\n    if (value === true) {\n      this.controls[key] = this.addPanelControl(new ButtonMediator(this.localizationManager.getString(this.labels[key]), null, null, key, (_ref = this.panelButtonClickHandler) != null ? typeof _ref.bind === \"function\" ? _ref.bind(this, key) : void 0 : void 0));\n    }\n  }\n};\n\nControlPanelMediator.prototype.addPanelControl = function(control) {\n  this.facade.registerMediator(control);\n  this.panel.getViewComponent().appendChild(control.getViewComponent());\n  return control;\n};\n\n/**\n*/\nControlPanelMediator.prototype.panelButtonClickHandler = function() {\n  this.sendNotification(PanelNotifications.CLOSE_PANEL, this.panel);\n};\n\n/**\n * The VolumePanelMediator class.\n *\n * @constructor\n * @private\n * @extends {ControlPanelMediator}\n*/\nfunction VolumePanelMediator() {\n  VolumePanelMediator.__super__.constructor.call(this);\n}\n\n\n__extends(VolumePanelMediator, ControlPanelMediator);\n\n\nVolumePanelMediator.prototype.componentName = \"volume\";\n\nVolumePanelMediator.prototype.slider = null;\n\nVolumePanelMediator.prototype.level = null;\n\nVolumePanelMediator.prototype.controlClass = VolumePanelControlMediator;\n\n/**\n*/\nVolumePanelMediator.prototype.onRegister = function() {\n  var _ref;\n  VolumePanelMediator.__super__.onRegister.call(this);\n  this.slider = new VolumeMediator(this.panel, (_ref = this.facade.getConfig().volume) != null ? _ref.direction : void 0);\n  this.facade.registerMediator(this.slider);\n};\n\nVolumePanelMediator.prototype.updateVolumeButton = function(percent) {\n  var level;\n  level = Math.ceil(percent * 10);\n  if (level === this.level) {\n    return;\n  }\n  if (this.level != null) {\n    this.sendNotification(Notifications.REMOVE_CONTROL_STATE, \"volume-\" + this.level);\n  }\n  this.level = level;\n  this.sendNotification(Notifications.ADD_CONTROL_STATE, \"volume-\" + this.level);\n};\n\n/**\n * @override\n*/\nVolumePanelMediator.prototype.listNotificationInterests = function() {\n  return VolumePanelMediator.__super__.listNotificationInterests.apply(this, arguments).concat([Notifications.VOLUME_CHANGE]);\n};\n\n/**\n * @override\n*/\nVolumePanelMediator.prototype.handleNotification = function(notification) {\n  VolumePanelMediator.__super__.handleNotification.call(this, notification);\n  switch (notification.getName()) {\n    case Notifications.VOLUME_CHANGE:\n      this.updateVolumeButton(notification.body);\n  }\n};\n\n/**\n * The PanelsMediator class.\n * \n * @constructor\n * @private\n * @extends {LayerMediator}\n*/\nfunction PanelsMediator(parent) {\n  this.panels = [];\n  this.closeHandler = this.mouseupHandler.bind(this);\n  PanelsMediator.__super__.constructor.call(this, null, null, parent);\n}\n\n\n__extends(PanelsMediator, ComponentMediator);\n\n\nPanelsMediator.prototype.componentName = \"panels\";\n\nPanelsMediator.prototype.activePanel = null;\n\nPanelsMediator.prototype.panels = null;\n\nPanelsMediator.prototype.closeHandler = null;\n\n/**\n * @override\n*/\nPanelsMediator.prototype.listNotificationInterests = function() {\n  var key, value;\n  return ((function() {\n    var _results;\n    _results = [];\n    for (key in PanelNotifications) {\n      value = PanelNotifications[key];\n      _results.push(value);\n    }\n    return _results;\n  })()).concat([]);\n};\n\n/**\n * @override\n*/\nPanelsMediator.prototype.handleNotification = function(notification) {\n  var body, name;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case PanelNotifications.ADD_PANEL:\n      this.addPanel(body);\n      break;\n    case PanelNotifications.REMOVE_PANEL:\n      this.removePanel(body);\n      break;\n    case PanelNotifications.OPEN_PANEL:\n      this.openPanel(body);\n      break;\n    case PanelNotifications.CLOSE_PANEL:\n      this.closePanel(body);\n      break;\n    case PanelNotifications.CLOSE_ALL_PANELS:\n      this.closeAllPanels(body);\n      break;\n    case PanelNotifications.TOGGLE_PANEL:\n      this.togglePanel(body);\n  }\n};\n\nPanelsMediator.prototype.addPanel = function(panel) {\n  this.panels.push(panel);\n  this.viewComponent.appendChild(panel.getViewComponent());\n};\n\nPanelsMediator.prototype.removePanel = function(panel) {\n  this.panels.splice(this.panels.indexOf(panel), 1);\n  this.viewComponent.removeChild(panel.getViewComponent());\n};\n\nPanelsMediator.prototype.openPanel = function(panel) {\n  if (panel === this.activePanel || !(panel != null)) {\n    return;\n  }\n  this.closeAllPanels();\n  this.activePanel = panel;\n  this.activePanel.classList.add(\"active\");\n  if (Utils.getDevice() !== \"desktop\") {\n    this.sendNotification(Notifications.IS_USER_ACTIVE, true);\n  }\n  document.addEventListener(\"mouseup\", this.closeHandler);\n};\n\nPanelsMediator.prototype.closePanel = function(panel) {\n  panel.classList.remove(\"active\");\n  if (this.activePanel != null) {\n    this.activePanel = null;\n    if (Utils.getDevice() !== \"desktop\") {\n      this.sendNotification(Notifications.IS_USER_ACTIVE, false);\n    }\n    document.removeEventListener(\"mouseup\", this.closeHandler);\n  }\n};\n\nPanelsMediator.prototype.togglePanel = function(panel) {\n  if (panel === this.activePanel) {\n    this.closePanel(panel);\n  } else {\n    this.openPanel(panel);\n  }\n};\n\nPanelsMediator.prototype.closeAllPanels = function() {\n  var panel, _i, _len, _ref;\n  _ref = this.panels;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    panel = _ref[_i];\n    this.closePanel(panel);\n  }\n};\n\nPanelsMediator.prototype.mouseupHandler = function(event) {\n  var button, element, panel;\n  element = document.elementFromPoint(event.clientX, event.clientY);\n  panel = this.activePanel.getViewComponent();\n  button = this.activePanel.control.getViewComponent();\n  if (element !== panel && panel.contains(element) === false && element !== button && button.contains(element) === false) {\n    this.closeAllPanels();\n  }\n};\n\n/**\n * The ProgressMediator class.\n *\n * @constructor\n * @private\n * @extends {ModuleMediator}\n * @param {Object} viewComponent\n*/\nfunction ProgressMediator(parent) {\n  ProgressMediator.__super__.constructor.call(this, parent, \"horizontal\");\n}\n\n\n__extends(ProgressMediator, SliderMediator);\n\n\n/**\n * The name of the this Mediator.\n *\n * @static\n * @type {string}\n*/\nProgressMediator.prototype.componentName = \"progress\";\n\nProgressMediator.prototype.bufferValue = null;\n\nProgressMediator.prototype.scrubTime = null;\n\nProgressMediator.prototype.scrubTimeSeparator = null;\n\nProgressMediator.prototype.cuePoints = null;\n\nProgressMediator.prototype.cues = null;\n\nProgressMediator.prototype.duration = 0;\n\nProgressMediator.prototype.isLive = false;\n\nProgressMediator.prototype.seeking = false;\n\nProgressMediator.prototype.previewData = {\n  src: null,\n  previewWidth: null,\n  previewHeight: null,\n  imgWidth: null,\n  imgHeight: null,\n  count: null\n};\n\nProgressMediator.prototype.hoverHandler = null;\n\nProgressMediator.prototype.mouseoutHandler = null;\n\nProgressMediator.prototype.mouseMoveHandler = null;\n\nProgressMediator.prototype.previewMoveHandler = null;\n\n/**\n * @override\n*/\nProgressMediator.prototype.onRegister = function() {\n  ProgressMediator.__super__.onRegister.call(this);\n  this.bufferValue = this.create(\"buffer-value\", false);\n  this.trackView.insertBefore(this.bufferValue, this.trackView.lastChild);\n  this.cuePoints = this.create(\"cue-points\", this.trackView);\n  this.scrubTimeSeparator = this.create(\"scrub-time-separator\");\n  this.scrubTime = this.create(\"scrub-time\");\n  this.thumbPreview = this.create(\"thumb-preview\", this.trackView);\n  this.previewMoveHandler = EventHandler.create(this.clickView, EventHandler.MOVE, this.updatePreviewHandler.bind(this));\n  this.previewMoveHandler.unbind();\n  this.hoverHandler = EventHandler.create(this.clickView, EventHandler.HOVER, this.handlehoverHandler.bind(this));\n  this.mouseoutHandler = EventHandler.create(this.clickView, EventHandler.HOVEROUT, this.handlemouseoutHandler.bind(this));\n  this.mouseoutHandler.unbind();\n  EventHandler.create(this.clickView, EventHandler.HOVER, this.mouseOverHandler.bind(this));\n  EventHandler.create(this.clickView, EventHandler.HOVEROUT, this.mouseOutHandler.bind(this));\n  this.mouseMoveBinding = EventHandler.create(document, EventHandler.MOVE, this.mouseMoveHandler.bind(this));\n  this.mouseMoveBinding.unbind();\n};\n\n/**\n * @override\n*/\nProgressMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.ENDED, Notifications.MEDIA_CHANGE, Notifications.DURATION_CHANGE, Notifications.PROGRESS, Notifications.CUES_CHANGE, Notifications.DISPLAY_TIME, AdNotifications.BREAK_START];\n};\n\n/**\n * @override\n*/\nProgressMediator.prototype.handleNotification = function(notification) {\n  var body, name, value;\n  ProgressMediator.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.MEDIA_CHANGE:\n      this.isLive = body.temporalType === \"live\";\n      this.updateValue(0);\n      this.bufferValue.style.width = \"0%\";\n      this.updatePreview(body.metadata);\n      break;\n    case Notifications.PROGRESS:\n      value = Utils.clamp(body / this.duration * 100, 0, 100);\n      this.bufferValue.style.width = value + \"%\";\n      break;\n    case Notifications.DURATION_CHANGE:\n      this.duration = body;\n      this.updateCuePoints();\n      break;\n    case Notifications.ENDED:\n      this.updateValue(1.0);\n      break;\n    case Notifications.CUES_CHANGE:\n      this.cues = body;\n      this.updateCuePoints();\n      break;\n    case Notifications.DISPLAY_TIME:\n      if (this.dragging === false) {\n        this.updateValue(body.currentTime / body.duration, body.duration);\n      }\n      if (body.duration !== this.duration) {\n        this.duration = body.duration;\n      }\n      break;\n    case AdNotifications.BREAK_START:\n      if (this.getDragging()) {\n        this.handleReleaseHandler();\n      }\n  }\n};\n\nProgressMediator.prototype.updateCuePoints = function() {\n  var cue, cuePoint, _i, _len, _ref;\n  if (!(this.cues != null)) {\n    return;\n  }\n  if (this.facade.config.displaySceneMarkers === false) {\n    return;\n  }\n  this.removeCuePoints();\n  _ref = this.cues;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    cue = _ref[_i];\n    if (!(cue.startTime !== 0 && cue.startTime !== -1)) {\n      continue;\n    }\n    cuePoint = this.create(\"cue-point\", this.cuePoints);\n    cuePoint.style.left = (cue.startTime / this.duration * 100) + \"%\";\n  }\n};\n\nProgressMediator.prototype.preloadPreviewImages = function(metadata) {\n  var i, image;\n  i = 1;\n  while (i < metadata.previewThumbnailCount) {\n    image = new Image;\n    image.src = metadata.previewThumbnailSrc + \"out\" + i + \".png\";\n    i++;\n  }\n};\n\nProgressMediator.prototype.updatePreview = function(metadata) {\n  this.preloadPreviewImages(metadata);\n  this.previewData.src = metadata.previewThumbnailSrc;\n  this.previewData.previewHeight = metadata.previewThumbnailHeight;\n  this.previewData.previewWidth = metadata.previewThumbnailWidth;\n  this.previewData.count = metadata.previewThumbnailCount;\n  if (this.previewData.src === void 0) {\n    this.hoverHandler.unbind();\n  }\n};\n\nProgressMediator.prototype.handlehoverHandler = function(event) {\n  this.previewMoveHandler.bind();\n  this.mouseoutHandler.bind();\n  this.hoverHandler.unbind();\n  this.updatePreviewHandler(event);\n  event.stopImmediatePropagation();\n  return false;\n};\n\nProgressMediator.prototype.handlemouseoutHandler = function(event) {\n  this.previewMoveHandler.unbind();\n  this.mouseoutHandler.unbind();\n  this.hoverHandler.bind();\n  event.stopImmediatePropagation();\n  return false;\n};\n\nProgressMediator.prototype.mouseOverHandler = function(event) {\n  this.mouseOver = true;\n  this.classList.add(\"active\");\n  this.mouseMoveBinding.bind();\n};\n\nProgressMediator.prototype.mouseOutHandler = function(event) {\n  this.mouseOver = false;\n  if (this.getDragging() === true) {\n    return;\n  }\n  this.classList.remove(\"active\");\n  this.mouseMoveBinding.unbind();\n};\n\nProgressMediator.prototype.mouseMoveHandler = function(event) {\n  var value;\n  value = this.calculateValue(event);\n  this.scrubTime.textContent = Utils.formatTimecode(Math.round(value * this.duration));\n  this.scrubTime.style.left = this.scrubTimeSeparator.style.left = \"\" + ((value * 100).toFixed(2)) + \"%\";\n};\n\nProgressMediator.prototype.updatePreviewHandler = function(event) {\n  var thumbPreviewPos, value;\n  value = this.calculateValue(event);\n  this.previewInterval = this.duration / this.previewData.count;\n  this.previewImgIndex = Math.floor(value * this.duration / this.previewInterval);\n  if (this.previewData.src) {\n    this.thumbPreview.style.backgroundImage = \"url(\" + this.previewData.src + \"out\" + (this.previewImgIndex + 1) + \".png)\";\n  }\n  this.thumbPreview.style.width = this.previewData.previewWidth + \"px\";\n  this.thumbPreview.style.height = this.previewData.previewHeight + \"px\";\n  thumbPreviewPos = Utils.clamp(((value * 100) - 10).toFixed(2), 1, 80);\n  this.thumbPreview.style.left = \"\" + thumbPreviewPos + \"%\";\n};\n\nProgressMediator.prototype.removeCuePoints = function() {\n  if (!(this.cuePoints != null)) {\n    return;\n  }\n  this.cuePoints.innerHTML = \"\";\n};\n\n/**\n * @override\n*/\nProgressMediator.prototype.valueChanged = function() {\n  this.sendNotification(UserNotifications.SEEK, this.value * this.facade.player.retrieveProxy(PlaybackProxy.NAME).getDuration());\n};\n\n/** updates the view\n*/\nProgressMediator.prototype.updateValue = function(value) {\n  if (value === this.value) {\n    return;\n  }\n  if (this.isLive === true) {\n    value = 1;\n  }\n  if (isNaN(value) === true) {\n    value = 0;\n  }\n  ProgressMediator.__super__.updateValue.call(this, value);\n  if (this.getDragging() && this.value >= this.max) {\n    this.handleReleaseHandler();\n    this.sendNotification(Notifications.END);\n  }\n};\n\nProgressMediator.prototype.updateHandler = function(setValue, event) {\n  ProgressMediator.__super__.updateHandler.call(this, setValue, event);\n  this.mouseMoveHandler(event);\n};\n\nProgressMediator.prototype.handlePressHandler = function(event) {\n  ProgressMediator.__super__.handlePressHandler.call(this, event);\n  this.classList.add(\"scrubbing\");\n};\n\nProgressMediator.prototype.handleReleaseHandler = function(event) {\n  var self;\n  ProgressMediator.__super__.handleReleaseHandler.call(this, event);\n  self = this;\n  setTimeout(function() {\n    return self.classList.remove(\"scrubbing\");\n  }, 500);\n  if (this.mouseOver === false) {\n    this.mouseOutHandler();\n  }\n};\n\n/**\n * The PlayPauseMediator class.\n *\n * @constructor\n * @private\n * @extends {ButtonMediator}\n*/\nfunction PlayPauseMediator(parent) {\n  PlayPauseMediator.__super__.constructor.call(this, null, parent);\n}\n\n\n__extends(PlayPauseMediator, ButtonMediator);\n\n\nPlayPauseMediator.prototype.componentName = \"play-pause\";\n\nPlayPauseMediator.prototype.onclick = function(event) {\n  event.stopImmediatePropagation();\n  event.preventDefault();\n  this.sendNotification(UserNotifications.TOGGLE_PLAY_PAUSE);\n  return false;\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar AdNotifications = {\n  BREAK_START: \"adsbreakstart\",\n  BREAK_END: \"adsbreakend\",\n  BREAK_SKIPPED: \"adsbreakskipped\",\n  AD_CONTAINER_CREATED: \"adscontainercreated\",\n  AD_LOADED: \"adsloaded\",\n  AD_MANAGER_LOADED: \"adsmanagerloaded\",\n  AD_STARTED: \"adsstarted\",\n  AD_TIME_UPDATE: \"adstimeupdate\",\n  AD_TIME_REMAINING: \"adstimeremaining\",\n  AD_DURATION_CHANGE: \"adsdurationchange\",\n  AD_ENDED: \"adsended\",\n  AD_ERROR: \"adserror\",\n  AD_PLAY: \"adsplay\",\n  AD_PAUSE: \"adspause\",\n  AD_PAUSED: \"adspaused\",\n  AD_RESUME: \"adsresume\",\n  AD_CLICKED: \"adclicked\",\n  AD_COMPANION: \"adscompanion\",\n  FIRST_QUARTILE: \"adsfirstquartile\",\n  MIDPOINT: \"adsmidpoint\",\n  THIRD_QUARTILE: \"adsthirdquartile\",\n  COMPLETE: \"adscomplete\",\n  LOG: \"adslog\",\n  REQUEST: \"adsrequest\",\n  REQUEST_COMPLETE: \"adsrequestcomplete\",\n  RESPONSE: \"adsresponse\",\n  SKIPPED: \"adsskipped\",\n  IMPRESSION: \"adsimpression\"\n};\n\n/**\n * The ControlsMediator class.\n *\n * @constructor\n * @private\n * @extends {LayerMediator}\n*/\nfunction ControlsMediator(overlays) {\n  this.overlays = overlays != null ? overlays : true;\n  ControlsMediator.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsMediator, LayerMediator);\n\n\nControlsMediator.prototype.componentName = \"controls\";\n\nControlsMediator.prototype.activeControlPanel = null;\n\nControlsMediator.prototype.controlBar = null;\n\nControlsMediator.prototype.panels = null;\n\n/**\n * @override\n*/\nControlsMediator.prototype.onRegister = function() {\n  var separator, titlebar;\n  this.facade.registerMediator(new ErrorLayerMediator());\n  if (this.facade.player.config.debug !== true) {\n    if (this.facade.player.config.contextmenu && this.facade.player.config.contextmenu.enabled !== false) {\n      this.facade.registerMediator(new contextMenuMediator());\n    }\n  }\n  ControlsMediator.__super__.onRegister.call(this);\n  this.facade.viewComponent = this.viewComponent;\n  if (this.overlays !== false) {\n    this.facade.registerMediator(new PosterMediator());\n    this.facade.registerMediator(new LoadingOverlayMediator());\n    this.facade.registerMediator(new WaitingOverlayMediator());\n    this.facade.registerMediator(new ReplayOverlayMediator());\n    this.facade.registerMediator(new EndSlateMediator());\n    titlebar = this.facade.config.titlebar || this.facade.player.config.titlebar || {};\n    if (titlebar.enabled !== false) {\n      this.facade.registerMediator(new TitleBarMediator());\n    }\n  }\n  this.controlBar = this.create(\"control-bar\");\n  this.facade.registerMediator(new PanelsMediator(this.viewComponent));\n  this.facade.registerMediator(new PlayPauseMediator(this.controlBar));\n  this.facade.registerMediator(new TimeDisplayMediator(this.controlBar));\n  this.facade.registerMediator(new ProgressMediator(this.controlBar));\n  if (this.facade.config.logo != null) {\n    this.facade.registerMediator(new LogoMediator(this.controlBar));\n  }\n  this.facade.registerMediator(new GoLiveMediator(this.controlBar));\n  if (this.overlays !== false && (this.facade.player.captioning != null)) {\n    this.facade.registerMediator(new CaptionsMediator());\n    this.facade.registerMediator(new CaptionsSettingsMediator(this.viewComponent));\n  }\n  this.facade.registerMediator(new VolumePanelMediator());\n  if (this.overlays !== false) {\n    this.facade.ads = new AdMediator();\n    this.facade.registerMediator(this.facade.ads);\n    this.facade.registerMediator(new PlayOverlayMediator());\n  }\n  separator = this.create(\"separator\", this.controlBar);\n};\n\n/**\n * @override\n*/\nControlsMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.READY, Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE, Notifications.SET_MEDIA, AdNotifications.BREAK_START, AdNotifications.BREAK_END];\n};\n\n/**\n * @override\n*/\nControlsMediator.prototype.handleNotification = function(notification) {\n  var body, name, _ref;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.READY:\n      if (((_ref = body.fullscreen) != null ? _ref.enabled : void 0) !== false) {\n        this.facade.registerMediator(new FullScreenMediator(this.controlBar));\n      }\n      break;\n    case Notifications.SET_MEDIA:\n    case AdNotifications.BREAK_END:\n      this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"ad-mode\");\n      break;\n    case AdNotifications.BREAK_START:\n      this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"ad-mode\");\n      break;\n    case Notifications.ADD_CONTROL_STATE:\n      this.classList.add(body);\n      break;\n    case Notifications.REMOVE_CONTROL_STATE:\n      this.classList.remove(body);\n      break;\n    case Notifications.ADD_CONTROL:\n      this.controlBar.appendChild(body);\n      break;\n    case Notifications.REMOVE_CONTROL:\n      if (this.controlBar.contains(body)) {\n        this.controlBar.removeChild(body);\n      }\n  }\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar MediaAnalyticsNotifications = {\n  SET_DIMENSIONS: \"mediaanalytics:setDimensions\"\n};\n\n/**\n * The CaptioningPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Feature}\n*/\nfunction CaptioningPlugin() {\n  CaptioningPlugin.__super__.constructor.call(this);\n  Object.defineProperties(this, {\n    enabled: {\n      get: this.getEnabled,\n      set: this.setEnabled,\n      enumerable: true,\n      configurable: false\n    },\n    hidden: {\n      get: this.getHidden,\n      set: this.setHidden,\n      enumerable: true,\n      configurable: false\n    },\n    visible: {\n      get: this.getVisible,\n      set: this.setVisible,\n      enumerable: true,\n      configurable: false\n    },\n    tracks: {\n      get: this.getTracks,\n      enumerable: true,\n      configurable: false\n    },\n    track: {\n      get: this.getTrack,\n      set: this.setTrack,\n      enumerable: true,\n      configurable: false\n    },\n    settings: {\n      get: this.getSettings,\n      enumerable: true,\n      configurable: false\n    }\n  });\n}\n\n\n__extends(CaptioningPlugin, Feature);\n\n\nCaptioningPlugin.prototype.featureName = \"captioning\";\n\nCaptioningPlugin.prototype.moduleName = \"captioning\";\n\nCaptioningPlugin.prototype.mediatorname = \"\";\n\n/** @override\n*/\nCaptioningPlugin.prototype.createController = function() {\n  CaptioningPlugin.__super__.createController.call(this);\n  this.registerCommand(Notifications.CHANGE_MEDIA, CaptioningChangeMediaCommand);\n  this.registerCommand(Notifications.STARTED, CaptioningStartedCommand);\n  this.registerCommand(Notifications.TIME_UPDATE, CaptioningTimeUpdateCommand);\n  this.registerCommand(CaptioningNotifications.VISIBILITY_CHANGE, CaptioningVisibilityChangeCommand);\n  this.registerCommand(CaptioningNotifications.ENABLED, CaptioningEnabledCommand);\n  this.registerCommand(CaptioningNotifications.TRACK_SELECTED, PluginEventCommand);\n  this.registerCommand(CaptioningNotifications.TRACKS_LOADED, PluginEventCommand);\n  this.registerCommand(CaptioningNotifications.CUE_CHANGE, PluginEventCommand);\n};\n\n/** @override\n*/\nCaptioningPlugin.prototype.createModel = function() {\n  this.proxy = new CaptioningProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nCaptioningPlugin.prototype.createView = function() {\n  var mediator, viewComponent;\n  mediator = new CaptioningMediator();\n  this.registerMediator(mediator);\n  this.mediatorname = mediator.getMediatorName();\n  viewComponent = mediator.viewComponent;\n  this.proxy.registerRenderer(new CaptioningNativeMediator(viewComponent));\n  this.proxy.registerRenderer(new CaptioningHTMLMediator(viewComponent));\n};\n\n/** @override\n*/\nCaptioningPlugin.prototype.destroy = function() {\n  var name, renderer;\n  while (this.proxy.rendererMap.length >= 1) {\n    renderer = this.proxy.rendererMap[0];\n    name = renderer.getMediatorName();\n    this.removeMediator(name);\n    this.proxy.removeRenderer(renderer.getRendererName());\n  }\n  this.removeMediator(this.mediatorname);\n};\n\n/**\n*/\nCaptioningPlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.LOADED_METADATA, Notifications.CAN_PLAY_THROUGH, Notifications.CHANGE_MEDIA, Notifications.STARTED, Notifications.TIME_UPDATE, Notifications.SETTINGS_CHANGE, CaptioningNotifications.TRACK_SELECTED];\n};\n\n/**\n*/\nCaptioningPlugin.prototype.listNotificationPublications = function() {\n  return CaptioningPlugin.__super__.listNotificationPublications.call(this).concat([CaptioningNotifications.CUE_CHANGE, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE, Notifications.CHANGE_SETTINGS, CaptioningNotifications.VISIBILITY_CHANGE, CaptioningNotifications.SETTINGS_CHANGE]);\n};\n\n/**\n * @return {boolean} The hidden flag.\n * @expose\n*/\nCaptioningPlugin.prototype.getEnabled = function() {\n  return this.proxy.getEnabled();\n};\n\n/**\n * @param {boolean} value The hidden flag.\n * @expose\n*/\nCaptioningPlugin.prototype.setEnabled = function(value) {\n  this.sendNotification(CaptioningNotifications.ENABLED, value);\n  return value;\n};\n\n/**\n * @return {boolean} The hidden flag.\n * @expose\n*/\nCaptioningPlugin.prototype.getHidden = function() {\n  return this.proxy.getHidden();\n};\n\n/**\n * @param {boolean} value The hidden flag.\n * @expose\n*/\nCaptioningPlugin.prototype.setHidden = function(value) {\n  this.setVisible(!value);\n  return value;\n};\n\n/**\n * @return {boolean} The hidden flag.\n * @expose\n*/\nCaptioningPlugin.prototype.getVisible = function() {\n  return !this.proxy.getHidden();\n};\n\n/**\n * @param {boolean} value The hidden flag.\n * @expose\n*/\nCaptioningPlugin.prototype.setVisible = function(value) {\n  this.sendNotification(Notifications.CHANGE_SETTINGS, {\n    captions: {\n      visible: value\n    }\n  });\n  this.sendNotification(CaptioningNotifications.VISIBILITY_CHANGE, value);\n  return value;\n};\n\n/**\n * Returns an array of caption tracks\n *\n * @return {Array.<CaptionTrack>} The list of text tracks.\n * @expose\n*/\nCaptioningPlugin.prototype.getTracks = function() {\n  return this.proxy.getTracks();\n};\n\n/**\n * Returns the currently selected track.\n *\n * @return {CaptionTrack} The currently selected caption track.\n * @expose\n*/\nCaptioningPlugin.prototype.getTrack = function() {\n  return this.proxy.getTrack();\n};\n\n/**\n * Selects a caption track\n *\n * @param {CaptionTrack} value The caption track to select\n * @expose\n*/\nCaptioningPlugin.prototype.setTrack = function(value) {\n  this.proxy.setTrack(value);\n  return value;\n};\n\n/**\n * Selects a caption track by its index in the getTracks array.\n *\n * @param {number}        index   The index to select\n * @return {CaptionTrack}         The selected caption track.\n * @expose\n*/\nCaptioningPlugin.prototype.selectTrackByIndex = function(index) {\n  return this.proxy.selectTrackByIndex(index);\n};\n\n/**\n * Selects a caption track by it's language property.\n *\n * @param {string}        lang  The language to select\n * @return {CaptionTrack}       The selected caption track.\n * @expose\n*/\nCaptioningPlugin.prototype.selectTrackByLanguage = function(lang) {\n  return this.proxy.selectTrackByLanguage(lang);\n};\n\n/**\n * Sets a caption Settings Object (styles)\n *\n * @param {Object}  object  The caption settings object.\n * @expose\n*/\nCaptioningPlugin.prototype.changeSettings = function(object) {\n  this.sendNotification(Notifications.CHANGE_SETTINGS, {\n    captions: object\n  });\n  this.sendNotification(CaptioningNotifications.SETTINGS_CHANGE, object);\n  return object;\n};\n\n/**\n * Return the captions settings object\n *\n * @return {Object}       The captions settings object.\n * @expose\n*/\nCaptioningPlugin.prototype.getSettings = function() {\n  return this.player.settings.captions;\n};\n\n/**\n * Allows parallel rendering to be toggled\n *\n * @param {value}  number  The value to use.\n * @expose\n*/\nCaptioningPlugin.prototype.useParallelRendering = function(value) {\n  var renderer;\n  renderer = this.proxy.getRenderer();\n  if (renderer) {\n    renderer.useParallelRendering(value);\n  }\n  return value;\n};\n\n\nAMP.registerPlugin(\"captioning\", \"html\", CaptioningPlugin);\n\n/**\n * @constructor\n * @private\n*/\nfunction MediaAnalyticsProxy(config) {\n  MediaAnalyticsProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(MediaAnalyticsProxy, PluginProxy);\n\n\n/** @static\n*/\nMediaAnalyticsProxy.NAME = ModuleProxy.NAME;\n\nMediaAnalyticsProxy.prototype.defaults = {\n  config: null,\n  dimensions: null,\n  iplookup: true\n};\n\n/**\n*/\nMediaAnalyticsProxy.prototype.ready = function() {\n  try {\n    if (this.getDebug() === true) {\n      window.AkamaiAnalytics_debug = 1;\n    }\n    window.akamaiSetVideoObject(this.facade.player.getMediaElement());\n  } catch (error) {\n    this.facade.logger.error(\"[AMP MEDIA ANALYTICS ERROR]\", \"Could not set video tag\", error);\n  }\n  if (this.value.iplookup === false && typeof akamaiDisableServerIpLookup === \"function\") {\n    akamaiDisableServerIpLookup();\n  }\n};\n\n/**\n*/\nMediaAnalyticsProxy.prototype.setDimensions = function(value) {\n  var dimensions, key, val;\n  dimensions = this.data.dimensions;\n  for (key in value) {\n    val = value[key];\n    if (val != null) {\n      dimensions[key] = val;\n    }\n  }\n  this.applyDimensions(dimensions);\n  return value;\n};\n\n/**\n*/\nMediaAnalyticsProxy.prototype.applyDimensions = function(dimensions) {\n  var key, value;\n  if (!(window.setAkamaiMediaAnalyticsData != null)) {\n    return;\n  }\n  try {\n    for (key in dimensions) {\n      value = dimensions[key];\n      setAkamaiMediaAnalyticsData(key, value);\n    }\n  } catch (error) {\n    this.facade.logger.error(\"[AMP MEDIA ANALYTICS ERROR]\", \"Could not set dimensions:\", error);\n  }\n};\n\n/**\n*/\nMediaAnalyticsProxy.prototype.setMedia = function(media) {\n  var dimensions, viewerId, _ref;\n  if (typeof akamaiSetStreamURL === \"function\") {\n    akamaiSetStreamURL(media.src, false);\n  }\n  viewerId = this.value.viewerId || this.value.viewerID || this.value[\"std:viewerId\"];\n  if (viewerId != null) {\n    akamaiSetViewerId(viewerId);\n  }\n  if (((_ref = media.mediaanalytics) != null ? _ref.dimensions : void 0) != null) {\n    dimensions = Utils.override(this.value.dimensions, media.mediaanalytics.dimensions);\n  } else {\n    dimensions = this.value.dimensions;\n  }\n  akamaiHandleStreamSwitch();\n  this.applyDimensions(dimensions);\n  return media;\n};\n\n/**\n*/\nMediaAnalyticsProxy.prototype.udpateMedia = function(media) {\n  if (typeof akamaiHandleTitleSwitch === \"function\") {\n    akamaiHandleTitleSwitch(media);\n  }\n  return media;\n};\n\n/**\n*/\nMediaAnalyticsProxy.prototype.fragmentLoadStart = function(bitrate) {\n  if (typeof fragmentDownloadStarted === \"function\") {\n    fragmentDownloadStarted(bitrate);\n  }\n};\n\n/**\n*/\nMediaAnalyticsProxy.prototype.fragmentLoaded = function(bitrate) {\n  if (typeof fragmentDownloadCompleted === \"function\") {\n    fragmentDownloadCompleted(bitrate);\n  }\n};\n\n/**\n*/\nMediaAnalyticsProxy.prototype.bitrateSwitch = function(data) {\n  if (typeof akamaiHandleBitRateSwitch === \"function\") {\n    akamaiHandleBitRateSwitch(data.bitrate);\n  }\n};\n\n/**\n * The MediaAnalyticsReadyCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsReadyCommand() {\n  MediaAnalyticsReadyCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsReadyCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nMediaAnalyticsReadyCommand.prototype.execute = function(notification) {\n  this.facade.retrieveProxy(MediaAnalyticsProxy.NAME).ready();\n};\n\n/**\n * The MediaAnalyticsChangeMediaCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsChangeMediaCommand() {\n  MediaAnalyticsChangeMediaCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsChangeMediaCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nMediaAnalyticsChangeMediaCommand.prototype.execute = function(notification) {\n  this.proxy.setMedia(notification.getBody());\n};\n\n/**\n * The MediaAnalyticsAdBreakStartCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsAdBreakStartCommand() {\n  MediaAnalyticsAdBreakStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsAdBreakStartCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nMediaAnalyticsAdBreakStartCommand.prototype.execute = function(notification) {\n  this.facade.player.getMediaElement().dataset.isad = true;\n};\n\n/**\n * The MediaAnalyticsAdBreakEndCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsAdBreakEndCommand() {\n  MediaAnalyticsAdBreakEndCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsAdBreakEndCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nMediaAnalyticsAdBreakEndCommand.prototype.execute = function(notification) {\n  this.facade.player.getMediaElement().dataset.isad = false;\n};\n\n/**\n * The MediaAnalyticsAdLoadedCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsAdLoadedCommand() {\n  MediaAnalyticsAdLoadedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsAdLoadedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nMediaAnalyticsAdLoadedCommand.prototype.execute = function(notification) {\n  var adObject, adVO;\n  try {\n    adVO = notification.getBody();\n    adObject = {\n      adDuration: adVO.duration,\n      adPartnerId: adVO.partner,\n      adTitle: adVO.title,\n      adId: adVO.id\n    };\n    if (typeof akamaiHandleAdLoaded === \"function\") {\n      akamaiHandleAdLoaded(adObject);\n    }\n  } catch (error) {\n    this.facade.logger.error(\"[AMP MEDIA ANALYTICS ERROR]\", error);\n  }\n};\n\n/**\n * The MediaAnalyticsAdStartCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsAdStartCommand() {\n  MediaAnalyticsAdStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsAdStartCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nMediaAnalyticsAdStartCommand.prototype.execute = function(notification) {\n  try {\n    if (typeof akamaiHandleAdStarted === \"function\") {\n      akamaiHandleAdStarted();\n    }\n  } catch (error) {\n    this.facade.logger.error(\"[AMP MEDIA ANALYTICS ERROR]\", error);\n  }\n};\n\n/**\n * The MediaAnalyticsTimeUpdateCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsAdTimeUpdateCommand() {\n  MediaAnalyticsAdTimeUpdateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsAdTimeUpdateCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nMediaAnalyticsAdTimeUpdateCommand.prototype.execute = function(notification) {\n  var core, percent;\n  core = notification.getBody();\n  percent = Math.round(core.currentTime / core.duration * 100);\n  try {\n    if (percent >= 25 && this.proxy.percent < 25) {\n      this.facade.logger.debug(\"MediaAnalytics: First Quartile\");\n      if (typeof akamaiHandleAdFirstQuartile === \"function\") {\n        akamaiHandleAdFirstQuartile();\n      }\n    } else if (percent >= 50 && this.proxy.percent < 50) {\n      this.facade.logger.debug(\"MediaAnalytics: Second Quartile\");\n      if (typeof akamaiHandleAdMidpoint === \"function\") {\n        akamaiHandleAdMidpoint();\n      }\n    } else if (percent >= 75 && this.proxy.percent < 75) {\n      this.facade.logger.debug(\"MediaAnalytics: Third Quartile\");\n      if (typeof akamaiHandleAdThirdQuartile === \"function\") {\n        akamaiHandleAdThirdQuartile();\n      }\n    }\n  } catch (error) {\n    this.facade.logger.error(\"[AMP MEDIA ANALYTICS ERROR]\", error);\n  }\n  this.proxy.percent = percent;\n};\n\n/**\n * The MediaAnalyticsAdEndCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsAdEndCommand() {\n  MediaAnalyticsAdEndCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsAdEndCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nMediaAnalyticsAdEndCommand.prototype.execute = function(notification) {\n  try {\n    if (typeof akamaiHandleAdCompleted === \"function\") {\n      akamaiHandleAdCompleted();\n    }\n  } catch (error) {\n    this.facade.logger.error(\"[AMP MEDIA ANALYTICS ERROR]\", error);\n  }\n  this.facade.player.getMediaElement().dataset.isad = true;\n};\n\n/**\n * The MediaAnalyticsSetDimensionsCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsSetDimensionsCommand() {\n  MediaAnalyticsSetDimensionsCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsSetDimensionsCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nMediaAnalyticsSetDimensionsCommand.prototype.execute = function(notification) {\n  var dimensions;\n  dimensions = notification.getBody();\n  this.proxy.setDimensions(dimensions);\n};\n\n/**\n * The MediaAnalyticsContentChangedCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsContentChangedCommand() {\n  MediaAnalyticsContentChangedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsContentChangedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nMediaAnalyticsContentChangedCommand.prototype.execute = function(notification) {\n  this.proxy.updatedMedia(notification.getBody());\n};\n\n/**\n * The MediaAnalyticsFragmentLoadStartCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsFragmentLoadStartCommand() {\n  MediaAnalyticsFragmentLoadStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsFragmentLoadStartCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nMediaAnalyticsFragmentLoadStartCommand.prototype.execute = function(notification) {\n  this.proxy.fragmentLoadStart(notification.getBody());\n};\n\n/**\n * The MediaAnalyticsFragmentLoadedCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsFragmentLoadedCommand() {\n  MediaAnalyticsFragmentLoadedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsFragmentLoadedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nMediaAnalyticsFragmentLoadedCommand.prototype.execute = function(notification) {\n  this.proxy.fragmentLoaded(notification.getBody());\n};\n\n/**\n * The MediaAnalyticsBitrateSwitchCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MediaAnalyticsBitrateSwitchCommand() {\n  MediaAnalyticsBitrateSwitchCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsBitrateSwitchCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nMediaAnalyticsBitrateSwitchCommand.prototype.execute = function(notification) {\n  this.proxy.bitrateSwitch(notification.getBody());\n};\n\nfunction MediaAnalyticsWrapper(player, config) {\n  MediaAnalyticsWrapper.__super__.constructor.call(this, player, config);\n}\n\n\n__extends(MediaAnalyticsWrapper, PluginWrapper);\n\n\nMediaAnalyticsWrapper.NAME = \"MediaAnalyticsWrapper\";\n\nMediaAnalyticsWrapper.prototype.flashPlugins = [\n  {\n    id: \"OSMFCSMALoader\",\n    host: \"osmf\",\n    main: \"com.akamai.playeranalytics.osmf.OSMFCSMALoaderInfo\",\n    type: \"application/x-shockwave-flash\"\n  }\n];\n\n/** @override\n*/\nMediaAnalyticsWrapper.prototype.listNotificationInterests = function() {\n  return MediaAnalyticsWrapper.__super__.listNotificationInterests.call(this).concat([Notifications.MEDIA_CHANGE, MediaAnalyticsNotifications.SET_DIMENSIONS]);\n};\n\nMediaAnalyticsWrapper.prototype.createFlashVars = function(flashvars) {\n  var dimensions, key, value, _ref, _ref1;\n  dimensions = (_ref = this.player.config) != null ? (_ref1 = _ref.media) != null ? _ref1.mediaanalytics : void 0 : void 0;\n  if (dimensions != null) {\n    for (key in dimensions) {\n      value = dimensions[key];\n      flashvars[\"report_\" + key] = value;\n    }\n  }\n  return flashvars;\n};\n\nMediaAnalyticsWrapper.prototype.createXML = function(xml) {\n  var application, dimensions, element, key, metrics, path, value, vendor, _ref, _ref1;\n  application = xml.firstChild;\n  metrics = xml.getElementsByTagName(\"metrics\")[0];\n  if (!(metrics != null)) {\n    metrics = xml.createElement(\"metrics\");\n    application.appendChild(metrics);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"akamai\");\n  metrics.appendChild(vendor);\n  if (this.config.config != null) {\n    element = xml.createElement(\"property\");\n    element.setAttribute(\"key\", \"MEDIA_ANALYTICS_BEACON\");\n    element.appendChild(XMLUtils.createTextContent(xml, this.config.config));\n    vendor.appendChild(element);\n    path = ((_ref = this.config.plugin) != null ? _ref.swf : void 0) || \"http://79423.analytics.edgesuite.net/csma/plugin/csma.swf\";\n    element = xml.createElement(\"property\");\n    element.setAttribute(\"key\", \"MEDIA_ANALYTICS_PLUGIN_PATH\");\n    element.appendChild(XMLUtils.createTextContent(xml, path));\n    vendor.appendChild(element);\n  }\n  if (this.config.dimensions != null) {\n    dimensions = xml.createElement(\"property\");\n    dimensions.setAttribute(\"key\", \"dimensions\");\n    vendor.appendChild(dimensions);\n    _ref1 = this.config.dimensions;\n    for (key in _ref1) {\n      value = _ref1[key];\n      element = xml.createElement(\"property\");\n      element.setAttribute(\"key\", key);\n      element.appendChild(XMLUtils.createTextContent(xml, value));\n      dimensions.appendChild(element);\n    }\n  }\n  return xml;\n};\n\nMediaAnalyticsWrapper.prototype.handleNotification = function(notification) {\n  var body, key, media, name, value, _ref, _ref1;\n  MediaAnalyticsWrapper.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.MEDIA_CHANGE:\n      media = body;\n      if (((_ref = media.mediaanalytics) != null ? _ref.dimensions : void 0) != null) {\n        media.dimensions = [];\n        _ref1 = media.mediaanalytics.dimensions;\n        for (key in _ref1) {\n          value = _ref1[key];\n          media.dimensions.push({\n            key: key,\n            value: value\n          });\n        }\n      }\n      break;\n    case MediaAnalyticsNotifications.SET_DIMENSIONS:\n      this.setDimensions(body);\n  }\n};\n\n/**\n*/\nMediaAnalyticsWrapper.prototype.setDimensions = function(value) {\n  this.player.mediaElement.setPlayerProperty(\"maDimensions\", value);\n  return value;\n};\n\n/**\n * The ControlsPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction ControlsPlugin() {\n  ControlsPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(ControlsPlugin, Feature);\n\n\nControlsPlugin.prototype.moduleName = \"controls\";\n\nControlsPlugin.prototype.featureName = \"ui\";\n\n/** @override\n*/\nControlsPlugin.prototype.createFramework = function() {\n  this.registerCommand(AdNotifications.BREAK_START, ControlsAdBreakStartCommand);\n  this.registerCommand(AdNotifications.BREAK_END, ControlsAdBreakEndCommand);\n  if (this.config[\"native\"] !== true) {\n    ControlsPlugin.__super__.createFramework.call(this);\n    return;\n  }\n  this.player.getMediaElement().controls = true;\n  this.player.sendNotification(Notifications.ADD_APPLICATION_STATE, \"controls-native\");\n  this.registerCommand(Notifications.MEDIA_VALIDATED, ControlsMediaValidatedCommand);\n  this.registerCommand(Notifications.PLAY_REQUEST, ControlsStartedCommand);\n  this.createView = function() {};\n};\n\n/**\n*/\nControlsPlugin.prototype.applyClickHandler = function(apply) {\n  if (apply == null) {\n    apply = true;\n  }\n  this.player.getMediaElement().onclick = apply ? this.clickHandler.bind(this) : null;\n  this.player.getMediaElement().onplay = apply ? this.clickHandler.bind(this) : null;\n};\n\n/**\n*/\nControlsPlugin.prototype.clickHandler = function(event) {\n  this.sendNotification(UserNotifications.TOGGLE_PLAY_PAUSE, true);\n};\n\n/** @override\n*/\nControlsPlugin.prototype.createController = function() {\n  ControlsPlugin.__super__.createController.call(this);\n  this.registerCommand(Notifications.START, ControlsStartCommand);\n  this.registerCommand(Notifications.PLAY, ControlsPlayCommand);\n  this.registerCommand(Notifications.PAUSE, ControlsPauseCommand);\n  this.registerCommand(Notifications.ACTIVE_STATE_CHANGE, ControlsActiveStateChangeCommand);\n  this.registerCommand(Notifications.DISPLAY_STATE_CHANGE, ControlsDisplayStateChangeCommand);\n  this.registerCommand(AdNotifications.BREAK_START, ControlsAdBreakStartCommand);\n  this.registerCommand(AdNotifications.BREAK_END, ControlsAdBreakEndCommand);\n};\n\n/** @override\n*/\nControlsPlugin.prototype.createModel = function() {\n  this.proxy = new ControlsProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nControlsPlugin.prototype.createView = function() {\n  this.registerMediator(new ControlsMediator());\n};\n\n/**\n*/\nControlsPlugin.prototype.listNotificationInterests = function() {\n  var key, value;\n  return ((function() {\n    var _results;\n    _results = [];\n    for (key in PanelNotifications) {\n      value = PanelNotifications[key];\n      _results.push(value);\n    }\n    return _results;\n  })()).concat([Notifications.CHANGE_MEDIA, Notifications.MEDIA_CHANGE, Notifications.TIME_UPDATE, Notifications.DURATION_CHANGE, Notifications.PROGRESS, Notifications.ENDED, Notifications.CUES_CHANGE, Notifications.DISABLE_FULL_SCREEN, Notifications.ENABLE_FULL_SCREEN, Notifications.READY, Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE, Notifications.ACTIVE_STATE_CHANGE, Notifications.START, Notifications.PLAY, Notifications.PAUSE, Notifications.ERROR, AdNotifications.BREAK_START, AdNotifications.BREAK_END, AdNotifications.AD_TIME_REMAINING, AdNotifications.AD_STARTED, Notifications.SET_MEDIA, Notifications.DISPLAY_TIME, Notifications.MEDIA_VALIDATED, Notifications.STARTED, Notifications.PLAY_REQUEST, Notifications.IS_LIVE, Notifications.VOLUME_CHANGE, Notifications.DISPLAY_STATE_CHANGE, CaptioningNotifications.TOGGLE_SETTINGS_VISIBILITY]);\n};\n\n/**\n*/\nControlsPlugin.prototype.listNotificationPublications = function() {\n  return ControlsPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.CHANGE_ACTIVE_STATE, Notifications.TOGGLE_FULL_SCREEN, UserNotifications.SEEK, Notifications.TOGGLE_ACTIVE, UserNotifications.TOGGLE_PLAY_PAUSE, UserNotifications.GO_LIVE, Notifications.END, Notifications.REPLAY, AdNotifications.AD_CONTAINER_CREATED, Notifications.CHANGE_VOLUME, Notifications.TOGGLE_MUTED, UserSettingsNotifications.UPDATE_SETTINGS]);\n};\n\n/**\n * @param {string} value The contorls mode.\n * @expose\n*/\nControlsPlugin.prototype.setMode = function(value) {\n  this.proxy.setMode(value);\n  return value;\n};\n\n/**\n * @return {string} The controls mode.\n * @expose\n*/\nControlsPlugin.prototype.getMode = function() {\n  return this.proxy.getMode();\n};\n\n/**\n * @param {boolean} value The autohide flag.\n * @expose\n*/\nControlsPlugin.prototype.setAutoHide = function(value) {\n  this.proxy.setAutoHide(value);\n  return value;\n};\n\n/**\n * @return {boolean} The autohide flag.\n * @expose\n*/\nControlsPlugin.prototype.getAutoHide = function() {\n  return this.proxy.getAutoHide();\n};\n\n\nAMP.registerPlugin(\"controls\", \"html\", ControlsPlugin);\nAMP.registerPlugin(\"controls\", \"flash\", ControlsWrapper);\nAMP.registerPlugin(\"controls\", \"external\", ControlsPlugin);\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar EventManagementNotifications = {\n  EVENT_STATE_CHANGED: \"eventStateChanged\"\n};\n\nfunction EventManagementWrapper() {\n  return EventManagementWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(EventManagementWrapper, PluginWrapper);\n\n\nEventManagementWrapper.NAME = \"EventManagementWrapper\";\n\n/** @override\n*/\nEventManagementWrapper.prototype.createFlashVars = function(flashvars) {\n  if (this.config.enabled != null) {\n    flashvars.eventmanagementstates_enabled = this.config.enabled;\n  }\n  if (this.config.url != null) {\n    flashvars.eventmanagementstates_status_url = this.config.url;\n  }\n  if (this.config.interval != null) {\n    flashvars.eventmanagementstates_status_interval = this.config.interval;\n  }\n  return flashvars;\n};\n\n/** @override\n*/\nEventManagementWrapper.prototype.createXML = function(xml) {\n  var application, eventmanagementstates, node, property, state, states, _i, _len, _ref;\n  application = xml.firstChild;\n  eventmanagementstates = xml.getElementsByTagName(\"eventmanagementstates\");\n  if (!(eventmanagementstates != null) || eventmanagementstates.length === 0) {\n    eventmanagementstates = xml.createElement(\"eventmanagementstates\");\n    application.appendChild(eventmanagementstates);\n  } else {\n    eventmanagementstates = eventmanagementstates[0];\n  }\n  states = xml.createElement(\"states\");\n  eventmanagementstates.appendChild(states);\n  _ref = this.config.states;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    state = _ref[_i];\n    node = xml.createElement(\"state\");\n    states.appendChild(node);\n    property = xml.createElement(\"property\");\n    property.setAttribute(\"key\", \"ID\");\n    property.appendChild(XMLUtils.createTextContent(xml, state.id));\n    node.appendChild(property);\n    property = xml.createElement(\"property\");\n    property.setAttribute(\"key\", \"POSTER_SRC\");\n    property.appendChild(XMLUtils.createTextContent(xml, state.poster));\n    node.appendChild(property);\n    if (state.url != null) {\n      property = xml.createElement(\"property\");\n      property.setAttribute(\"key\", \"URL\");\n      property.appendChild(XMLUtils.createTextContent(xml, state.url));\n      node.appendChild(property);\n    }\n  }\n  return xml;\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction EventManagementProxy(config) {\n  var _this = this;\n  EventManagementProxy.__super__.constructor.call(this, config);\n  this.poller = new Poller();\n  this.poller.ondatachange = function(event) {\n    var id, state, _i, _len, _ref;\n    id = event.detail;\n    if (id === \"on\") {\n      state = EventManagementProxy.ON;\n    } else {\n      _ref = _this.data.states;\n      for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n        state = _ref[_i];\n        if (state.id === id) {\n          break;\n        }\n      }\n    }\n    if (state != null) {\n      return _this.setState(state);\n    }\n  };\n}\n\n\n__extends(EventManagementProxy, ModuleProxy);\n\n\nEventManagementProxy.NAME = ModuleProxy.NAME;\n\nEventManagementProxy.ON = {\n  id: \"on\"\n};\n\nEventManagementProxy.prototype.defaults = {\n  url: null,\n  interval: null,\n  states: null,\n  enabled: false\n};\n\nEventManagementProxy.prototype.poller = null;\n\nEventManagementProxy.prototype.state = null;\n\nEventManagementProxy.prototype.initialize = function() {\n  if (this.data.enabled === true) {\n    this.setURL(this.data.url);\n    this.setInterval(this.data.interval);\n    this.poller.start();\n  }\n};\n\nEventManagementProxy.prototype.setURL = function(value) {\n  this.data.url = this.poller.url = value;\n  return value;\n};\n\nEventManagementProxy.prototype.getURL = function() {\n  return this.data.url;\n};\n\n/**\n *\n*/\nEventManagementProxy.prototype.getInterval = function() {\n  return this.data.interval;\n};\n\nEventManagementProxy.prototype.setInterval = function(value) {\n  this.data.interval = this.poller.interval = value * 1000;\n  return value;\n};\n\nEventManagementProxy.prototype.setState = function(value) {\n  this.state = value;\n  this.sendNotification(EventManagementNotifications.EVENT_STATE_CHANGED, value);\n  return value;\n};\n\nEventManagementProxy.prototype.getState = function() {\n  return this.state;\n};\n\n/**\n * The EventManagementMediator class.\n * \n * @constructor\n * @private\n * @extends {OverlayMediator}\n * @param {Object} viewComponent\n*/\nfunction EventManagementMediator() {\n  EventManagementMediator.__super__.constructor.call(this);\n}\n\n\n__extends(EventManagementMediator, OverlayMediator);\n\n\nEventManagementMediator.prototype.componentName = \"event-management\";\n\nEventManagementMediator.prototype.poster = null;\n\n/**\n * @override\n*/\nEventManagementMediator.prototype.onRegister = function() {\n  EventManagementMediator.__super__.onRegister.call(this);\n  this.classList.add(\"hidden\");\n  this.poster = this.create(\"event-poster\", false, \"img\");\n};\n\n/**\n * @override\n*/\nEventManagementMediator.prototype.listNotificationInterests = function() {\n  return [EventManagementNotifications.EVENT_STATE_CHANGED];\n};\n\n/**\n * @override\n*/\nEventManagementMediator.prototype.handleNotification = function(notification) {\n  var state;\n  switch (notification.getName()) {\n    case EventManagementNotifications.EVENT_STATE_CHANGED:\n      state = notification.getBody();\n      if (state.id !== \"on\") {\n        if (state.poster != null) {\n          this.poster.src = state.poster;\n          this.viewComponent.appendChild(this.poster);\n        }\n        this.classList.remove(\"hidden\");\n        this.sendNotification(Notifications.PAUSE);\n        this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n      } else {\n        if (this.viewComponent.contains(this.poster)) {\n          this.viewComponent.removeChild(this.poster);\n        }\n        this.classList.add(\"hidden\");\n      }\n  }\n};\n\n/**\n * The EventManagementStateChangeCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction EventManagementStateChangeCommand() {\n  EventManagementStateChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(EventManagementStateChangeCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nEventManagementStateChangeCommand.prototype.execute = function(notification) {\n  var locked;\n  locked = notification.getBody().id !== EventManagementProxy.ON.id;\n  this.sendNotification(Notifications.LOCK, locked);\n  EventManagementStateChangeCommand.__super__.execute.call(this, notification);\n  if (locked === false && this.facade.player.getAutoplay() === true) {\n    this.sendNotification(Notifications.PLAY);\n  }\n};\n\n/** \n * The MediaAnalyticsPlugin class.\n *   \n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction MediaAnalyticsPlugin() {\n  MediaAnalyticsPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(MediaAnalyticsPlugin, Plugin);\n\n\nMediaAnalyticsPlugin.prototype.moduleName = \"mediaanalytics\";\n\n/** @override\n*/\nMediaAnalyticsPlugin.prototype.initialize = function(config, player) {\n  window.AKAMAI_MEDIA_ANALYTICS_CONFIG_FILE_PATH = config.config;\n  MediaAnalyticsPlugin.__super__.initialize.call(this, config, player);\n};\n\n/** @override\n*/\nMediaAnalyticsPlugin.prototype.createModel = function() {\n  this.proxy = new MediaAnalyticsProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nMediaAnalyticsPlugin.prototype.createController = function() {\n  MediaAnalyticsPlugin.__super__.createController.call(this);\n  this.registerCommand(Notifications.READY, MediaAnalyticsReadyCommand);\n  this.registerCommand(Notifications.MEDIA_CHANGE, MediaAnalyticsChangeMediaCommand);\n  this.registerCommand(AdNotifications.BREAK_START, MediaAnalyticsAdBreakStartCommand);\n  this.registerCommand(AdNotifications.BREAK_END, MediaAnalyticsAdBreakEndCommand);\n  this.registerCommand(AdNotifications.AD_LOADED, MediaAnalyticsAdLoadedCommand);\n  this.registerCommand(AdNotifications.AD_STARTED, MediaAnalyticsAdStartCommand);\n  this.registerCommand(AdNotifications.AD_TIME_UPDATE, MediaAnalyticsAdTimeUpdateCommand);\n  this.registerCommand(AdNotifications.AD_ENDED, MediaAnalyticsAdEndCommand);\n  this.registerCommand(MediaAnalyticsNotifications.SET_DIMENSIONS, MediaAnalyticsSetDimensionsCommand);\n  this.registerCommand(Notifications.CONTENT_CHANGED, MediaAnalyticsContentChangedCommand);\n  this.registerCommand(Notifications.FRAGMENT_LOAD_START, MediaAnalyticsFragmentLoadStartCommand);\n  this.registerCommand(Notifications.FRAGMENT_LOADED, MediaAnalyticsFragmentLoadedCommand);\n  this.registerCommand(Notifications.QUALITY_CHANGE, MediaAnalyticsBitrateSwitchCommand);\n};\n\n/**\n*/\nMediaAnalyticsPlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.READY, Notifications.MEDIA_CHANGE, AdNotifications.BREAK_START, AdNotifications.BREAK_END, AdNotifications.AD_LOADED, AdNotifications.AD_STARTED, AdNotifications.AD_TIME_UPDATE, AdNotifications.AD_ENDED, MediaAnalyticsNotifications.SET_DIMENSIONS, Notifications.CONTENT_CHANGED, Notifications.FRAGMENT_LOAD_START, Notifications.FRAGMENT_LOADED, Notifications.QUALITY_CHANGE];\n};\n\n/**\n * Sets the media analytics dimensions.\n * \n * @param {Object} value The hash representing dimensions.\n * @expose\n*/\nMediaAnalyticsPlugin.prototype.setDimensions = function(value) {\n  this.retrieveProxy(MediaAnalyticsProxy.NAME).setDimensions(value);\n  return value;\n};\n\n\nAMP.registerPlugin(\"mediaanalytics\", \"html\", MediaAnalyticsPlugin);\nAMP.registerPlugin(\"mediaanalytics\", \"flash\", MediaAnalyticsWrapper);\n\nfunction BrandingWrapper() {\n  return BrandingWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(BrandingWrapper, PluginWrapper);\n\n\nBrandingWrapper.NAME = \"BrandingWrapper\";\n\nBrandingWrapper.prototype.flashView = {\n  elements: {\n    logoOverlay: {\n      attributes: {\n        style: \"width: 150px; height: 53px; right: 15px; top: 15px; opacity: 0.5;\"\n      }\n    }\n  }\n};\n\nBrandingWrapper.prototype.createFlashVars = function(flashvars) {\n  if (this.config.id != null) {\n    flashvars.branding = this.config.id;\n  }\n  return flashvars;\n};\n\nBrandingWrapper.prototype.createXML = function(xml) {\n  var backgroundImage, style, view, _ref, _ref1, _ref2;\n  view = this.player.flashView;\n  if ((((_ref = this.config) != null ? _ref.logo : void 0) != null) && (view != null)) {\n    backgroundImage = \"background-image: url('\" + this.config.logo + \"');\";\n    style = ((_ref1 = view.elements.logoOverlay) != null ? (_ref2 = _ref1.attributes) != null ? _ref2.style : void 0 : void 0) || \"\";\n    if (style.indexOf(\"background-image:\") !== -1) {\n      style = style.replace(/background-image: [A-Za-z0-9_\\-\\.\\/\\\\;\\(\\)\"'#{}]+/, backgroundImage);\n    } else {\n      style = backgroundImage + style;\n    }\n    view.elements.logoOverlay.attributes.style = style;\n  }\n  return xml;\n};\n\n/**\n * The AdChoicesMediator class.\n * \n * @constructor\n * @private\n * @extends {OverlayMediator}\n * @param {Object} viewComponent\n*/\nfunction BrandingMediator() {\n  BrandingMediator.__super__.constructor.call(this);\n}\n\n\n__extends(BrandingMediator, OverlayMediator);\n\n\nBrandingMediator.prototype.componentName = \"branding\";\n\nBrandingMediator.prototype.logo = null;\n\nBrandingMediator.prototype.text = null;\n\nBrandingMediator.prototype.container = null;\n\nBrandingMediator.prototype.onRegister = function() {\n  BrandingMediator.__super__.onRegister.call(this);\n  this.container = this.create(\"branding-container\");\n  this.logo = this.create([\"branding-image\", \"hidden\"], this.container, \"img\");\n  this.text = this.create(\"branding-text\", this.container);\n};\n\n/**\n * @override\n*/\nBrandingMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.READY];\n};\n\n/**\n * @override\n*/\nBrandingMediator.prototype.handleNotification = function(notification) {\n  var branding, href,\n    _this = this;\n  switch (notification.getName()) {\n    case Notifications.READY:\n      branding = notification.getBody().branding;\n      if (!(branding != null)) {\n        return;\n      }\n      if (branding.logo != null) {\n        this.logo.src = this.facade.evaluatePaths(branding.logo);\n        this.logo.onerror = function() {\n          return ClassList.add(\"hidden\", _this.logo, Namespace.PREFIX);\n        };\n        ClassList.remove(\"hidden\", this.logo, Namespace.PREFIX);\n      } else {\n        ClassList.add(\"hidden\", this.logo, Namespace.PREFIX);\n      }\n      href = this.config.getDomain();\n      if ((href != null) && href.indexOf(\"http\") !== 0) {\n        href = location.protocol + \"//\" + href;\n        this.text.innerHTML = \"<span>\" + (this.localizationManager.getString(LocalizationConstants.MSG_VIEW_ALL)) + \"<a href=\\\"\" + href + \"\\\" target=\\\"\" + (this.config.getTarget()) + \"\\\">\" + (this.config.getDomain()) + \"</a> \" + (this.localizationManager.getString(LocalizationConstants.MSG_VIDEO)) + \".\";\n      }\n  }\n};\n\n/** \n * @constructor \n * @private\n*/\nfunction BrandingProxy(config) {\n  BrandingProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(BrandingProxy, ModuleProxy);\n\n\n/** @static\n*/\nBrandingProxy.NAME = ModuleProxy.NAME;\n\nBrandingProxy.prototype.defaults = {\n  id: null,\n  title: null,\n  link: null,\n  logo: null,\n  target: null\n};\n\n/**\n *\n*/\nBrandingProxy.prototype.getID = function() {\n  return this.data.id;\n};\n\nBrandingProxy.prototype.setID = function(value) {\n  return this.data.id = value;\n};\n\n/**\n *\n*/\nBrandingProxy.prototype.getTarget = function() {\n  return this.data.target;\n};\n\nBrandingProxy.prototype.setTarget = function(value) {\n  return this.data.target = value;\n};\n\n/**\n *\n*/\nBrandingProxy.prototype.getTitle = function() {\n  return this.data.title;\n};\n\nBrandingProxy.prototype.setTitle = function(value) {\n  return this.data.title = value;\n};\n\n/**\n *\n*/\nBrandingProxy.prototype.getLink = function() {\n  return this.data.link;\n};\n\nBrandingProxy.prototype.setLink = function(value) {\n  return this.data.link = value;\n};\n\n/**\n *\n*/\nBrandingProxy.prototype.getLogo = function() {\n  return this.data.logo;\n};\n\nBrandingProxy.prototype.setLogo = function(value) {\n  return this.data.logo = value;\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar FeedNotifications = {\n  LOAD_FEED: \"loadfeed\",\n  FEED_CHANGED: \"feedchanged\",\n  FEED_LOADED: \"feedloaded\",\n  FEED_ERROR: \"feederror\"\n};\n\n/** \n * The EventManagementPlugin class.\n *   \n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @extends {Plugin}\n * @private\n*/\nfunction EventManagementPlugin() {\n  EventManagementPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(EventManagementPlugin, Plugin);\n\n\nEventManagementPlugin.prototype.moduleName = \"eventmanagement\";\n\n/** @override\n*/\nEventManagementPlugin.prototype.createModel = function() {\n  this.registerProxy(new EventManagementProxy(this.config));\n};\n\n/** @override\n*/\nEventManagementPlugin.prototype.createController = function() {\n  EventManagementPlugin.__super__.createController.call(this);\n  this.registerCommand(EventManagementNotifications.EVENT_STATE_CHANGED, EventManagementStateChangeCommand);\n};\n\nEventManagementPlugin.prototype.createView = function() {\n  this.registerMediator(new EventManagementMediator());\n};\n\n/** @override\n*/\nEventManagementPlugin.prototype.listNotificationPublications = function() {\n  return EventManagementPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.CHANGE_DISPLAY_STATE, Notifications.PLAY, Notifications.PAUSE, Notifications.LOCK, EventManagementNotifications.EVENT_STATE_CHANGED]);\n};\n\n\nAMP.registerPlugin(\"eventmanagement\", \"html\", EventManagementPlugin);\nAMP.registerPlugin(\"eventmanagement\", \"flash\", EventManagementWrapper);\n\n/**\n * The FeedProxy class.\n *\n * @constructor\n * @private\n * @extends {ModuleProxy}\n * @param {Object} config The configuration object.\n*/\nfunction FeedProxy(config) {\n  FeedProxy.__super__.constructor.call(this, config);\n  this.helper = new MRSSHelper();\n}\n\n\n__extends(FeedProxy, ModuleProxy);\n\n\nFeedProxy.NAME = ModuleProxy.NAME;\n\nFeedProxy.prototype.defaults = {\n  url: null,\n  data: null\n};\n\nFeedProxy.prototype.feed = null;\n\nFeedProxy.prototype.helper = null;\n\nFeedProxy.prototype.setURL = function(value) {\n  var _this = this;\n  this.data.url = this.facade.evaluatePaths(value);\n  this.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"request\", this.data.url));\n  this.helper.getFeed(this.data.url).then(function(feed) {\n    _this.sendNotification(FeedNotifications.FEED_LOADED, feed);\n    _this.sendNotification(FeedNotifications.CHANGE_FEED, feed);\n  })[\"catch\"](function(error) {\n    _this.sendNotification(FeedNotifications.FEED_ERROR, {\n      error: error,\n      url: value\n    });\n    Logger.instance.error(\"[AMP Feed Load Error]\", _this.data.url, error);\n  });\n  return value;\n};\n\nFeedProxy.prototype.getURL = function() {\n  return this.data.url;\n};\n\nFeedProxy.prototype.setFeedData = function(value) {\n  this.data.data = value;\n  this.feed = this.helper.createFeed(value);\n  this.sendNotification(FeedNotifications.FEED_CHANGED, this.feed);\n  return value;\n};\n\nFeedProxy.prototype.getFeedData = function() {\n  return this.data.data;\n};\n\nFeedProxy.prototype.invoke = function() {\n  var func;\n  if ((this.data.url != null) && this.data.url !== \"\") {\n    func = this.sendNotification.bind(this, FeedNotifications.LOAD_FEED, this.data.url);\n  } else if (this.data.data != null) {\n    func = this.sendNotification.bind(this, FeedNotifications.CHANGE_FEED, this.data.data);\n  }\n  if (func != null) {\n    setTimeout(func, 1);\n  }\n};\n\n/**\n * The LoadFeedCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction LoadFeedCommand() {\n  LoadFeedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(LoadFeedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nLoadFeedCommand.prototype.execute = function(notification) {\n  var feedProxy;\n  feedProxy = this.facade.retrieveProxy(FeedProxy.NAME);\n  feedProxy.setURL(notification.getBody());\n};\n\n/**\n * The ChangeFeedCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ChangeFeedCommand() {\n  ChangeFeedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChangeFeedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nChangeFeedCommand.prototype.execute = function(notification) {\n  var feedProxy;\n  feedProxy = this.facade.retrieveProxy(FeedProxy.NAME);\n  feedProxy.setFeedData(notification.getBody());\n};\n\n/**\n * The FeedChangedCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction FeedChangedCommand() {\n  FeedChangedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(FeedChangedCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nFeedChangedCommand.prototype.execute = function(notification) {\n  var feed, mediaVO;\n  FeedChangedCommand.__super__.execute.call(this, notification);\n  this.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.READY);\n  feed = notification.getBody();\n  mediaVO = feed.item[0];\n  this.player.sendNotification(Notifications.SET_MEDIA, mediaVO);\n};\n\n/**\n * The FeedInitializedCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction FeedInitializedCommand() {\n  FeedInitializedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(FeedInitializedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nFeedInitializedCommand.prototype.execute = function(notification) {\n  var feedProxy;\n  feedProxy = this.facade.retrieveProxy(FeedProxy.NAME);\n  feedProxy.invoke();\n};\n\nfunction FeedWrapper(player, config) {\n  if (config == null) {\n    config = {};\n  }\n  FeedWrapper.__super__.constructor.call(this, player, config);\n  if (config.url != null) {\n    this.url = config.url;\n  }\n  if (config.data != null) {\n    this.data = config.data;\n  }\n  this.player.load = function() {};\n}\n\n\n__extends(FeedWrapper, PluginWrapper);\n\n\nFeedWrapper.NAME = \"FeedWrapper\";\n\nFeedWrapper.prototype.url = null;\n\nFeedWrapper.prototype.data = null;\n\nFeedWrapper.prototype.updateData = true;\n\n/** @override\n*/\nFeedWrapper.prototype.createFlashVars = function(flashvars) {\n  if ((this.url != null) && this.url !== \"\") {\n    flashvars.data_feed_url = escape(this.facade.evaluatePaths(this.url));\n  }\n};\n\n/** @override\n*/\nFeedWrapper.prototype.listNotificationInterests = function() {\n  return FeedWrapper.__super__.listNotificationInterests.apply(this, arguments).concat([FlashNotifications.READY, FlashNotifications.FEED_LOADED, FlashNotifications.LOAD_FEED]);\n};\n\n/**\n*/\nFeedWrapper.prototype.handleNotification = function(notification) {\n  var body, name, type,\n    _this = this;\n  FeedWrapper.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case FlashNotifications.FEED_LOADED:\n      this.data = body;\n      this.sendNotification(FeedNotifications.FEED_CHANGED, this.data);\n      break;\n    case FlashNotifications.LOAD_FEED:\n      type = \"request\";\n      break;\n    case FlashNotifications.READY:\n      if (this.data != null) {\n        setTimeout(function() {\n          _this.setData(_this.data);\n        }, 25);\n      } else if ((this.url != null) && this.url !== \"\") {\n        this.sendNotification(FeedNotifications.LOAD_FEED, this.url);\n      }\n  }\n  if (type != null) {\n    this.dispatchEvent(new Event(type, body));\n  }\n};\n\n/**\n*/\nFeedWrapper.prototype.setURL = function(value) {\n  if ((value != null) && value !== \"\") {\n    this.url = value;\n    this.player.mediaElement.playFile(this.url, this.player.getAutoplay());\n    this.sendNotification(FeedNotifications.LOAD_FEED, this.url);\n  }\n  return value;\n};\n\nFeedWrapper.prototype.getURL = function() {\n  return this.url;\n};\n\n/**\n*/\nFeedWrapper.prototype.setData = function(value) {\n  this.data = value;\n  this.updateData = false;\n  this.player.mediaElement.playFile(this.data, this.player.getAutoplay());\n  return value;\n};\n\nFeedWrapper.prototype.getData = function() {\n  return this.data;\n};\n\n/** \n * The BrandingPlugin class.\n *   \n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction BrandingPlugin() {\n  BrandingPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(BrandingPlugin, Plugin);\n\n\nBrandingPlugin.NAME = \"BrandingPlugin\";\n\nBrandingPlugin.prototype.moduleName = \"branding\";\n\n/** @override\n*/\nBrandingPlugin.prototype.createModel = function() {\n  this.registerProxy(new BrandingProxy(this.config));\n};\n\nBrandingPlugin.prototype.createView = function() {\n  this.registerMediator(new BrandingMediator());\n};\n\n/** @override\n*/\nBrandingPlugin.prototype.onRegister = function() {\n  if (this.config.id != null) {\n    this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"branding-\" + this.config.id);\n  }\n  BrandingPlugin.__super__.onRegister.call(this);\n};\n\n/**\n*/\nBrandingPlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.READY];\n};\n\n\nAMP.registerPlugin(\"branding\", \"html\", BrandingPlugin);\nAMP.registerPlugin(\"branding\", \"flash\", BrandingWrapper);\nAMP.registerPlugin(\"branding\", \"external\", BrandingPlugin);\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar AutoAdvanceNotifications = {\n  TIME_UPDATE: \"autoadvancetimeupdate\",\n  START: \"autoadvancestart\",\n  STOP: \"autoadvancestop\",\n  ADVANCE: \"autoadvanceadvance\"\n};\n\n/** \n * @constructor\n * @private\n*/\nfunction AutoAdvanceWrapper(player, config) {\n  if (config == null) {\n    config = {};\n  }\n  AutoAdvanceWrapper.__super__.constructor.call(this, player, config);\n  if (config.interval != null) {\n    this.interval = config.interval;\n  }\n  if (config.handler != null) {\n    this.handler = config.handler;\n  }\n}\n\n\n__extends(AutoAdvanceWrapper, PluginWrapper);\n\n\nAutoAdvanceWrapper.NAME = \"AutoAdvanceWrapper\";\n\nAutoAdvanceWrapper.prototype.interval = null;\n\nAutoAdvanceWrapper.prototype.handler = null;\n\nAutoAdvanceWrapper.prototype.getInterval = function() {\n  return this.interval;\n};\n\nAutoAdvanceWrapper.prototype.setInterval = function(value) {\n  return this.interval = value;\n};\n\nAutoAdvanceWrapper.prototype.getHandler = function() {\n  return this.handler;\n};\n\nAutoAdvanceWrapper.prototype.setHandler = function(value) {\n  return this.handler = value;\n};\n\n/** @override\n*/\nAutoAdvanceWrapper.prototype.listNotificationInterests = function() {\n  return [FlashNotifications.CREATE_FLASH_VARS, FlashNotifications.AUTO_ADVANCE];\n};\n\n/**\n*/\nAutoAdvanceWrapper.prototype.handleNotification = function(notification) {\n  var body, flashvars, name, type, _base;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case FlashNotifications.CREATE_FLASH_VARS:\n      flashvars = body.flashvars;\n      if (this.interval != null) {\n        flashvars.next_video_timer = this.interval;\n        flashvars.auto_play_list = true;\n      }\n      break;\n    case FlashNotifications.AUTO_ADVANCE:\n      if (typeof (_base = this.config).handler === \"function\") {\n        _base.handler();\n      }\n      type = \"advance\";\n  }\n  if (type != null) {\n    this.dispatchEvent(new Event(type));\n  }\n};\n\n/** \n * @constructor \n * @private\n*/\nfunction AutoAdvanceProxy(config) {\n  AutoAdvanceProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(AutoAdvanceProxy, ModuleProxy);\n\n\n/** @static\n*/\nAutoAdvanceProxy.NAME = ModuleProxy.NAME;\n\nAutoAdvanceProxy.prototype.defaults = {\n  interval: 15,\n  handler: null\n};\n\nAutoAdvanceProxy.prototype.currentTime = 0;\n\nAutoAdvanceProxy.prototype.timeout = null;\n\nAutoAdvanceProxy.prototype.start = function() {\n  var _this = this;\n  this.currentTime = this.data.interval;\n  this.timeout = setInterval(function() {\n    _this.updateTime();\n  }, 1000);\n  this.sendNotification(AutoAdvanceNotifications.TIME_UPDATE, this.currentTime);\n};\n\nAutoAdvanceProxy.prototype.stop = function() {\n  clearInterval(this.timeout);\n};\n\nAutoAdvanceProxy.prototype.updateTime = function() {\n  this.currentTime--;\n  this.sendNotification(AutoAdvanceNotifications.TIME_UPDATE, this.currentTime);\n  if (this.currentTime <= 0) {\n    this.stop();\n    this.sendNotification(AutoAdvanceNotifications.ADVANCE, this.data.handler);\n  }\n};\n\n/**\n * The AutoAdvanceStartCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction AutoAdvanceStartCommand() {\n  AutoAdvanceStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AutoAdvanceStartCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAutoAdvanceStartCommand.prototype.execute = function(notification) {\n  this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"autoadvance-mode\");\n  this.proxy.start();\n  AutoAdvanceStartCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The AutoAdvanceAdvanceCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction AutoAdvanceAdvanceCommand() {\n  AutoAdvanceAdvanceCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AutoAdvanceAdvanceCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAutoAdvanceAdvanceCommand.prototype.execute = function(notification) {\n  var handler;\n  handler = notification.getBody();\n  if ((handler != null)) {\n    if (typeof handler === \"string\") {\n      eval(\"\" + handler + \"()\");\n    } else if (typeof handler === \"function\") {\n      handler();\n    }\n  }\n  this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"autoadvance-mode\");\n  AutoAdvanceAdvanceCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The AutoAdvanceEndedCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction AutoAdvanceEndedCommand() {\n  AutoAdvanceEndedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AutoAdvanceEndedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAutoAdvanceEndedCommand.prototype.execute = function(notification) {\n  if (this.proxy.getData().interval != null) {\n    this.sendNotification(AutoAdvanceNotifications.START, notification.getBody());\n  }\n};\n\n/**\n * The AutoAdvanceStopCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction AutoAdvanceStopCommand() {\n  AutoAdvanceStopCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AutoAdvanceStopCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAutoAdvanceStopCommand.prototype.execute = function(notification) {\n  this.proxy.stop();\n};\n\n/**\n * The AutoAdvanceMediator class.\n * \n * @constructor\n * @private\n * @extends {OverlayMediator}\n * @param {Object} viewComponent\n*/\nfunction AutoAdvanceMediator() {\n  AutoAdvanceMediator.__super__.constructor.call(this);\n}\n\n\n__extends(AutoAdvanceMediator, OverlayMediator);\n\n\nAutoAdvanceMediator.prototype.componentName = \"autoadvance\";\n\nAutoAdvanceMediator.prototype.text = null;\n\nAutoAdvanceMediator.prototype.onRegister = function() {\n  AutoAdvanceMediator.__super__.onRegister.call(this);\n  this.text = this.create(\"autoadvance-text\");\n};\n\n/**\n * @override\n*/\nAutoAdvanceMediator.prototype.listNotificationInterests = function() {\n  return [AutoAdvanceNotifications.TIME_UPDATE];\n};\n\n/**\n * @override\n*/\nAutoAdvanceMediator.prototype.handleNotification = function(notification) {\n  var time;\n  switch (notification.getName()) {\n    case AutoAdvanceNotifications.TIME_UPDATE:\n      time = notification.getBody();\n      this.text.textContent = \"\" + (this.localizationManager.getString('MSG_NEXT_VIDEO')) + \" \" + time + \" \" + (this.localizationManager.getString('MSG_SECONDS'));\n  }\n};\n\n/**\n * The FeedPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction FeedPlugin() {\n  FeedPlugin.__super__.constructor.call(this);\n  try {\n    Object.defineProperties(this, {\n      url: {\n        get: this.getURL,\n        set: this.setURL,\n        enumerable: true,\n        configurable: false\n      },\n      data: {\n        get: this.getData,\n        set: this.setData,\n        enumerable: true,\n        configurable: false\n      }\n    });\n  } catch (error) {\n    console.error(error);\n  }\n}\n\n\n__extends(FeedPlugin, Plugin);\n\n\nFeedPlugin.prototype.moduleName = \"feed\";\n\n/** @override\n*/\nFeedPlugin.prototype.createModel = function() {\n  this.proxy = new FeedProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nFeedPlugin.prototype.createController = function() {\n  FeedPlugin.__super__.createController.call(this);\n  this.registerCommand(Notifications.READY, FeedInitializedCommand);\n  this.registerCommand(FeedNotifications.LOAD_FEED, LoadFeedCommand);\n  this.registerCommand(FeedNotifications.CHANGE_FEED, ChangeFeedCommand);\n  this.registerCommand(FeedNotifications.FEED_CHANGED, FeedChangedCommand);\n  this.registerCommand(FeedNotifications.FEED_LOADED, PluginEventCommand);\n  this.registerCommand(FeedNotifications.FEED_ERROR, PluginEventCommand);\n};\n\n/** @override\n*/\nFeedPlugin.prototype.listNotificationInterests = function() {\n  return FeedPlugin.__super__.listNotificationInterests.call(this).concat([Notifications.READY]);\n};\n\n/** @override\n*/\nFeedPlugin.prototype.listNotificationPublications = function() {\n  var key, value;\n  return FeedPlugin.__super__.listNotificationPublications.call(this).concat((function() {\n    var _results;\n    _results = [];\n    for (key in FeedNotifications) {\n      value = FeedNotifications[key];\n      _results.push(value);\n    }\n    return _results;\n  })());\n};\n\n/**\n * @param {string} value The url of the feed.\n * @expose\n*/\nFeedPlugin.prototype.setURL = function(value) {\n  this.sendNotification(FeedNotifications.LOAD_FEED, value);\n  return value;\n};\n\n/**\n * @return {string} The url of the feed.\n * @expose\n*/\nFeedPlugin.prototype.getURL = function() {\n  return this.proxy.getURL();\n};\n\n/**\n * @param {Object} value The MRSS feed object\n * @expose\n*/\nFeedPlugin.prototype.setData = function(value) {\n  this.sendNotification(FeedNotifications.CHANGE_FEED, value);\n  return value;\n};\n\n/**\n * @return {Object} The MRSS feed object.\n * @expose\n*/\nFeedPlugin.prototype.getData = function() {\n  return this.proxy.getFeedData();\n};\n\n\nAMP.registerPlugin(\"feed\", \"html\", FeedPlugin);\nAMP.registerPlugin(\"feed\", \"flash\", FeedWrapper);\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar RecommendationsNotifications = {\n  RECOMMENDATIONS_LOADED: \"recommendationsloaded\",\n  RECOMMENDATION_SELECTED: \"recommendationsselected\"\n};\n\nfunction RecommendationVO(guid, link, title, description, thumbnail, duration, pubDate, target, metadata) {\n  this.guid = guid;\n  this.link = link;\n  this.title = title;\n  this.description = description;\n  this.thumbnail = thumbnail;\n  this.duration = duration;\n  this.pubDate = pubDate;\n  this.target = target;\n  this.metadata = metadata != null ? metadata : {};\n}\n\nRecommendationVO.prototype.guid = null;\n\nRecommendationVO.prototype.link = null;\n\nRecommendationVO.prototype.title = null;\n\nRecommendationVO.prototype.description = null;\n\nRecommendationVO.prototype.thumbnail = null;\n\nRecommendationVO.prototype.duration = null;\n\nRecommendationVO.prototype.pubDate = null;\n\nRecommendationVO.prototype.target = null;\n\nRecommendationVO.prototype.metadata = null;\n\n/**\n * @constructor\n * @private\n * @extends {PluginWrapper}\n*/\nfunction RecommendationsWrapper(player, config) {\n  if (config == null) {\n    config = {};\n  }\n  RecommendationsWrapper.__super__.constructor.call(this, player, config);\n  if (config.url != null) {\n    this.url = config.url;\n  }\n  if (config.target != null) {\n    this.target = config.target;\n  }\n}\n\n\n__extends(RecommendationsWrapper, PluginWrapper);\n\n\nRecommendationsWrapper.NAME = \"RecommendationsWrapper\";\n\nRecommendationsWrapper.prototype.flashPlugins = [\n  {\n    id: \"RecommendationsPlugin\",\n    src: '#{paths.resources}plugins/RecommendationsPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"RecommendationsPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }\n];\n\nRecommendationsWrapper.prototype.flashView = {\n  elements: {\n    recommendationSlate: {\n      attributes: {\n        items: \"5\",\n        viewMode: \"grid\"\n      }\n    }\n  }\n};\n\nRecommendationsWrapper.prototype.url = null;\n\nRecommendationsWrapper.prototype.target = null;\n\nRecommendationsWrapper.prototype.recommendations = null;\n\n/**\n*/\nRecommendationsWrapper.prototype.getFeatureName = function() {\n  return \"recommendations\";\n};\n\n/**\n*/\nRecommendationsWrapper.prototype.getData = function() {\n  return this.recommendations;\n};\n\nRecommendationsWrapper.prototype.setData = function(value) {\n  return this.recommendations = value;\n};\n\n/**\n*/\nRecommendationsWrapper.prototype.getTarget = function() {\n  var _ref, _ref1;\n  return this.target || ((_ref = this.player) != null ? (_ref1 = _ref.config) != null ? _ref1.target : void 0 : void 0);\n};\n\n/**\n*/\nRecommendationsWrapper.prototype.getURL = function() {\n  return this.url;\n};\n\n/**\n*/\nRecommendationsWrapper.prototype.createFlashVars = function(flashvars) {\n  flashvars.recommendations_partner = \"mrss\";\n  if (this.config.target != null) {\n    flashvars.external_target = this.config.target;\n  }\n};\n\n/**\n*/\nRecommendationsWrapper.prototype.createXML = function(xml) {\n  var application, recommendations, vendor;\n  application = xml.firstChild;\n  recommendations = xml.getElementsByTagName(\"recommendations\")[0];\n  if (!(recommendations != null)) {\n    recommendations = xml.createElement(\"recommendations\");\n    application.appendChild(recommendations);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"mrss\");\n  recommendations.appendChild(vendor);\n  this.createProperty(xml, \"RECOMMENDATIONS_MRSS_URL\", this.url, vendor);\n};\n\n/** @override\n*/\nRecommendationsWrapper.prototype.listNotificationInterests = function() {\n  return RecommendationsWrapper.__super__.listNotificationInterests.apply(this, arguments).concat([FlashNotifications.RECOMMENDATION_SELECTED, FlashNotifications.RECOMMENDATIONS_LOADED]);\n};\n\n/**\n*/\nRecommendationsWrapper.prototype.handleNotification = function(notification) {\n  var body, name, type;\n  RecommendationsWrapper.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case FlashNotifications.RECOMMENDATIONS_LOADED:\n      type = \"loaded\";\n      this.recommendations = body;\n      break;\n    case FlashNotifications.RECOMMENDATION_SELECTED:\n      type = \"selected\";\n  }\n  if (type != null) {\n    this.dispatchEvent(new Event(type, body));\n  }\n};\n\n/**\n * The RecommendationsSelectedCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction RecommendationSelectedCommand() {\n  RecommendationSelectedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(RecommendationSelectedCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nRecommendationSelectedCommand.prototype.execute = function(notification) {\n  var rec;\n  RecommendationSelectedCommand.__super__.execute.call(this, notification);\n  rec = notification.getBody();\n  if (rec.target !== \"none\" && rec.target !== \"player\") {\n    window.open(rec.link, rec.target);\n  }\n};\n\n/**\n * The RecommendationsPlayCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction RecommendationsPlayCommand() {\n  RecommendationsPlayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(RecommendationsPlayCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nRecommendationsPlayCommand.prototype.execute = function(notification) {\n  this.proxy.invoke();\n};\n\n/**\n * The RecommendationsPlayStateChangeCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction RecommendationsPlayStateChangeCommand() {\n  RecommendationsPlayStateChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(RecommendationsPlayStateChangeCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nRecommendationsPlayStateChangeCommand.prototype.execute = function(notification) {\n  var recommendations, states;\n  recommendations = this.proxy.getRecommendations();\n  states = notification.getBody();\n  if (states.value === PlayState.ENDED) {\n    if ((recommendations != null ? recommendations.length : void 0) > 0) {\n      this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"recommendations-mode\");\n    }\n  } else if (states.previous === PlayState.ENDED) {\n    if ((recommendations != null ? recommendations.length : void 0) > 0) {\n      this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"recommendations-mode\");\n    }\n  }\n};\n\n/**\n * Proxy for recommendations feature\n *\n * @constructor\n * @private\n*/\nfunction RecommendationsProxy(config) {\n  RecommendationsProxy.__super__.constructor.call(this, config);\n  this.helper = new MRSSHelper();\n}\n\n\n__extends(RecommendationsProxy, PluginProxy);\n\n\n/** @static\n*/\nRecommendationsProxy.NAME = ModuleProxy.NAME;\n\nRecommendationsProxy.prototype.defaults = {\n  url: null,\n  target: \"_blank\"\n};\n\nRecommendationsProxy.prototype.loaded = true;\n\nRecommendationsProxy.prototype.recommendations = null;\n\nRecommendationsProxy.prototype.helper = null;\n\n/** Getter/Setter for RecommendationVO.\n*/\nRecommendationsProxy.prototype.getRecommendations = function() {\n  return this.recommendations;\n};\n\nRecommendationsProxy.prototype.setRecommendations = function(value) {\n  this.recommendations = value;\n  this.sendNotification(RecommendationsNotifications.RECOMMENDATIONS_LOADED, this.recommendations);\n  return value;\n};\n\nRecommendationsProxy.prototype.getURL = function() {\n  return this.getConfigurationData().url;\n};\n\nRecommendationsProxy.prototype.setURL = function(value) {\n  this.data.url = value;\n  this.invoke();\n  return value;\n};\n\nRecommendationsProxy.prototype.getTarget = function() {\n  return this.getConfigurationData().target || this.facade.player.retrieveProxy(ConfigurationProxy.NAME).getTarget();\n};\n\nRecommendationsProxy.prototype.setTarget = function(value) {\n  this.data.target = value;\n  return value;\n};\n\n/**\n *\n *\n * @param {String} value\n *    The new display state of the player\n * @returns {String}\n *    The display state of the player\n * @type {String}\n*/\nRecommendationsProxy.prototype.invoke = function() {\n  var url;\n  url = this.getURL();\n  if (!(url != null) || url === \"\") {\n    this.facade.logger.error(\"[AMP RECOMMENDATIONS ERROR]\", \"Load Error: No url provided\");\n    return;\n  }\n  Utils.getFeed(url).then(this.onload.bind(this))[\"catch\"](this.onerror.bind(this));\n};\n\nRecommendationsProxy.prototype.onload = function(json) {\n  var recs;\n  recs = this.createRecommendations(json);\n  this.setRecommendations(recs);\n};\n\nRecommendationsProxy.prototype.onerror = function(error) {\n  this.facade.logger.error(\"[AMP RECOMMENDATIONS ERROR]\", \"Load Error:\", error);\n};\n\n/**\n*/\nRecommendationsProxy.prototype.createRecommendations = function(feed) {\n  var item, rec, recs, _i, _len, _ref;\n  feed = this.helper.createFeed(feed);\n  recs = [];\n  _ref = feed.item;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    item = _ref[_i];\n    rec = new RecommendationVO(item.guid, item.link, item.title, item.description, item.thumbnail, item.duration, item.pubDate, this.getTarget(), item);\n    recs.push(rec);\n  }\n  return recs;\n};\n\n/**\n * The RecommendationsMediator class.\n * \n * @constructor\n * @private\n * @extends {OverlayMediator}\n*/\nfunction RecommendationsMediator() {\n  RecommendationsMediator.__super__.constructor.call(this);\n}\n\n\n__extends(RecommendationsMediator, OverlayMediator);\n\n\nRecommendationsMediator.prototype.componentName = \"recommendations\";\n\nRecommendationsMediator.prototype.listArea = null;\n\n/**\n * @override\n*/\nRecommendationsMediator.prototype.onRegister = function() {\n  var label;\n  RecommendationsMediator.__super__.onRegister.call(this);\n  label = this.createText(\"recommendations-label\", \"Recommended\");\n  this.listArea = this.create(\"recommendations-list-area\");\n};\n\n/**\n * @override\n*/\nRecommendationsMediator.prototype.listNotificationInterests = function() {\n  return [RecommendationsNotifications.RECOMMENDATIONS_LOADED];\n};\n\n/**\n * @override\n*/\nRecommendationsMediator.prototype.handleNotification = function(notification) {\n  var rec, recs, _i, _len;\n  switch (notification.getName()) {\n    case RecommendationsNotifications.RECOMMENDATIONS_LOADED:\n      this.listArea.innerHTML = \"\";\n      recs = notification.getBody();\n      if ((recs != null) && recs.length > 0) {\n        for (_i = 0, _len = recs.length; _i < _len; _i++) {\n          rec = recs[_i];\n          this.addElement(rec);\n        }\n      }\n  }\n};\n\nRecommendationsMediator.prototype.addElement = function(recommendation) {\n  var listItem,\n    _this = this;\n  listItem = this.create(\"recommendation\", this.listArea);\n  if (listItem.dataset == null) {\n    listItem.dataset = {};\n  }\n  listItem.dataset.link = recommendation.link;\n  listItem.dataset.target = recommendation.target;\n  listItem.innerHTML = \"<img src='\" + recommendation.thumbnail + \"' class='\" + this.cssPrefix + \"recommendation-thumbnail' /> <span class='\" + this.cssPrefix + \"recommendation-text'>\" + recommendation.description + \"</span>\";\n  listItem.onclick = function(event) {\n    event.stopImmediatePropagation();\n    _this.sendNotification(RecommendationsNotifications.RECOMMENDATION_SELECTED, event.currentTarget.dataset);\n    return false;\n  };\n};\n\n/** \n * The AutoadvancePlugin class.\n *   \n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction AutoAdvancePlugin() {\n  AutoAdvancePlugin.__super__.constructor.call(this);\n}\n\n\n__extends(AutoAdvancePlugin, Plugin);\n\n\nAutoAdvancePlugin.NAME = \"AutoAdvancePlugin\";\n\nAutoAdvancePlugin.prototype.moduleName = \"autoadvance\";\n\n/** @override\n*/\nAutoAdvancePlugin.prototype.createController = function() {\n  AutoAdvancePlugin.__super__.createController.call(this);\n  this.registerCommand(AutoAdvanceNotifications.START, AutoAdvanceStartCommand);\n  this.registerCommand(AutoAdvanceNotifications.ADVANCE, AutoAdvanceAdvanceCommand);\n  this.registerCommand(Notifications.MEDIA_SEQUENCE_ENDED, AutoAdvanceEndedCommand);\n  this.registerCommand(Notifications.CHANGE_MEDIA, AutoAdvanceStopCommand);\n  this.registerCommand(Notifications.PLAY, AutoAdvanceStopCommand);\n  this.registerCommand(Notifications.PLAYING, AutoAdvanceStopCommand);\n  this.registerCommand(Notifications.REPLAY, AutoAdvanceStopCommand);\n  this.registerCommand(Notifications.SEEK, AutoAdvanceStopCommand);\n  this.registerCommand(UserNotifications.SEEK, AutoAdvanceStopCommand);\n  this.registerCommand(Notifications.TIME_UPDATE, PluginEventCommand);\n  this.registerCommand(Notifications.STOP, PluginEventCommand);\n};\n\n/** @override\n*/\nAutoAdvancePlugin.prototype.createModel = function() {\n  this.registerProxy(new AutoAdvanceProxy(this.config));\n};\n\n/** @override\n*/\nAutoAdvancePlugin.prototype.createView = function() {\n  this.registerMediator(new AutoAdvanceMediator());\n};\n\n/** @override\n*/\nAutoAdvancePlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.CHANGE_MEDIA, Notifications.PLAY, Notifications.PLAYING, Notifications.REPLAY, Notifications.MEDIA_SEQUENCE_ENDED, Notifications.SEEK, UserNotifications.SEEK];\n};\n\n/**\n*/\nAutoAdvancePlugin.prototype.listNotificationPublications = function() {\n  var key, value;\n  return AutoAdvancePlugin.__super__.listNotificationPublications.call(this).concat((function() {\n    var _results;\n    _results = [];\n    for (key in AutoAdvanceNotifications) {\n      value = AutoAdvanceNotifications[key];\n      _results.push(value);\n    }\n    return _results;\n  })());\n};\n\n\nAMP.registerPlugin(\"autoadvance\", \"html\", AutoAdvancePlugin);\nAMP.registerPlugin(\"autoadvance\", \"flash\", AutoAdvanceWrapper);\n\n/**\n * The AdChoicesMediator class.\n * \n * @constructor\n * @private\n * @extends {LocalizedMediator}\n*/\nfunction RecommendationsGridMediator() {\n  RecommendationsGridMediator.__super__.constructor.call(this);\n}\n\n\n__extends(RecommendationsGridMediator, OverlayMediator);\n\n\nRecommendationsGridMediator.prototype.componentName = \"recommendations-grid\";\n\nRecommendationsGridMediator.prototype.grid = null;\n\nRecommendationsGridMediator.prototype.onRegister = function() {\n  var label;\n  RecommendationsGridMediator.__super__.onRegister.call(this);\n  label = this.createText(\"recommendations-grid-label\", this.localizationManager.getString(LocalizationConstants.MSG_RECOMMENDATIONS_TITLE));\n  this.grid = this.create(\"recommendations-grid-table-grid\", this, \"table\");\n};\n\n/**\n * @override\n*/\nRecommendationsGridMediator.prototype.listNotificationInterests = function() {\n  return [RecommendationsNotifications.RECOMMENDATIONS_LOADED];\n};\n\n/**\n * @override\n*/\nRecommendationsGridMediator.prototype.handleNotification = function(notification) {\n  var rec, recs, _i, _len;\n  switch (notification.getName()) {\n    case RecommendationsNotifications.RECOMMENDATIONS_LOADED:\n      this.grid.innerHTML = \"\";\n      this.create(\"recommendations-grid-row\", this.grid, \"tr\");\n      this.create(\"recommendations-grid-row\", this.grid, \"tr\");\n      recs = notification.getBody();\n      if ((recs != null) && recs.length > 0) {\n        for (_i = 0, _len = recs.length; _i < _len; _i++) {\n          rec = recs[_i];\n          this.addElement(rec, _i);\n        }\n      }\n  }\n};\n\nRecommendationsGridMediator.prototype.addElement = function(recommendation, recommendedIndex) {\n  var gridRowIndex, td,\n    _this = this;\n  gridRowIndex = (recommendedIndex % 4) < 2 ? 0 : 1;\n  td = this.create(\"recommendations-grid-item\", this.grid.childNodes[gridRowIndex], \"td\");\n  if (td.dataset == null) {\n    td.dataset = {};\n  }\n  td.dataset.link = recommendation.link;\n  td.dataset.target = this.config.getTarget();\n  td.innerHTML = \"<img src='\" + recommendation.thumbnail + \"' class='\" + this.cssPrefix + \"recommendations-grid-thumbnail' /> <span class='\" + this.cssPrefix + \"recommendations-grid-text'>\" + recommendation.description + \"</span>\";\n  td.onclick = function(event) {\n    event.stopImmediatePropagation();\n    _this.sendNotification(RecommendationsNotifications.RECOMMENDATION_SELECTED, event.currentTarget.dataset);\n    return false;\n  };\n};\n\n/**\n * The RecommendationsFluidGridMediator class.\n * \n * @constructor\n * @private\n * @extends {LocalizedMediator}\n*/\nfunction RecommendationsFluidGridMediator() {\n  RecommendationsFluidGridMediator.__super__.constructor.call(this);\n}\n\n\n__extends(RecommendationsFluidGridMediator, OverlayMediator);\n\n\nRecommendationsFluidGridMediator.prototype.componentName = \"recommendations-fluid-grid\";\n\nRecommendationsFluidGridMediator.prototype.grid = null;\n\nRecommendationsFluidGridMediator.prototype.timeout = null;\n\nRecommendationsFluidGridMediator.prototype.gridBounds = {\n  width: 0,\n  height: 0\n};\n\nRecommendationsFluidGridMediator.prototype.onRegister = function() {\n  RecommendationsFluidGridMediator.__super__.onRegister.call(this);\n  this.grid = this.viewComponent;\n  window.addEventListener(\"orientationchange\", this.delayedResizeGridHanlder.bind(this));\n};\n\n/**\n * @override\n*/\nRecommendationsFluidGridMediator.prototype.listNotificationInterests = function() {\n  return [RecommendationsNotifications.RECOMMENDATIONS_LOADED, Notifications.ENDED, Notifications.CHANGE_MEDIA, Notifications.PLAY, Notifications.PLAYING, Notifications.REPLAY];\n};\n\nRecommendationsFluidGridMediator.prototype.delayedResizeGridHanlder = function(event) {\n  try {\n    clearTimeout(this.timeout);\n  } catch (_error) {}\n  this.timeout = setTimeout(this.resizeGridHandler.bind(this, true), 100);\n};\n\nRecommendationsFluidGridMediator.prototype.resizeGridHandler = function(isOrientation) {\n  var currentGridBounds, item, _i, _j, _len, _len1, _ref, _ref1;\n  if (isOrientation == null) {\n    isOrientation = false;\n  }\n  currentGridBounds = this.grid.getBoundingClientRect();\n  if (this.gridBounds.width !== currentGridBounds.width || this.gridBounds.height !== currentGridBounds.height || isOrientation) {\n    this.grid.setAttribute(\"style\", \"align-content:flex-start; -webkit-align-content:flex-start; -ms-flex-align: flex-start;opacity:0;\");\n    this.gridBounds = currentGridBounds;\n    _ref = this.grid.childNodes;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      item = _ref[_i];\n      item.style.display = \"block\";\n    }\n    _ref1 = this.grid.childNodes;\n    for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {\n      item = _ref1[_j];\n      if (item.getBoundingClientRect().bottom > this.gridBounds.bottom) {\n        item.style.display = \"none\";\n      }\n    }\n    this.grid.setAttribute(\"style\", \"align-content:center; -webkit-align-content:center; -ms-flex-align: center;opacity:1;\");\n  }\n};\n\n/**\n * @override\n*/\nRecommendationsFluidGridMediator.prototype.handleNotification = function(notification) {\n  var rec, recs, _i, _len,\n    _this = this;\n  switch (notification.getName()) {\n    case Notifications.CHANGE_MEDIA:\n    case Notifications.PLAY:\n    case Notifications.PLAYING:\n    case Notifications.REPLAY:\n      try {\n        clearInterval(this.timeout);\n      } catch (_error) {}\n      break;\n    case Notifications.ENDED:\n      this.timeout = setInterval(function() {\n        _this.resizeGridHandler();\n      }, 500);\n      break;\n    case RecommendationsNotifications.RECOMMENDATIONS_LOADED:\n      this.grid.innerHTML = \"\";\n      recs = notification.getBody();\n      if ((recs != null) && recs.length > 0) {\n        for (_i = 0, _len = recs.length; _i < _len; _i++) {\n          rec = recs[_i];\n          this.addElement(rec, _i);\n        }\n      }\n  }\n};\n\nRecommendationsFluidGridMediator.prototype.addElement = function(recommendation, recommendedIndex) {\n  var tile, _ref, _ref1,\n    _this = this;\n  tile = this.create(\"recommendations-fluid-grid-tile\", this.grid);\n  tile.style.backgroundImage = \"url(\" + recommendation.thumbnail + \")\";\n  if (((_ref = this.facade.getConfig().responsive) != null ? _ref.rows : void 0) != null) {\n    tile.style.height = \"calc(\" + 100 / this.facade.getConfig().responsive.rows + \"%)\";\n  }\n  if (((_ref1 = this.facade.getConfig().responsive) != null ? _ref1.column : void 0) != null) {\n    tile.style.width = \"calc(\" + 100 / this.facade.getConfig().responsive.columns + \"%)\";\n  }\n  tile.dataset.link = recommendation.link;\n  tile.dataset.target = this.facade.getConfig().target;\n  EventHandler.create(tile, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.sendNotification(RecommendationsNotifications.RECOMMENDATION_SELECTED, event.currentTarget.dataset);\n    return false;\n  });\n  this.create(\"recommendations-fluid-grid-tile-caption\", tile, \"span\", recommendation.description);\n};\n\n/** \n * The RecommendationsPlugin class.\n *   \n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction RecommendationsPlugin() {\n  RecommendationsPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(RecommendationsPlugin, Feature);\n\n\nRecommendationsPlugin.prototype.featureName = \"recommendations\";\n\nRecommendationsPlugin.prototype.moduleName = \"recommendations\";\n\n/** @override\n*/\nRecommendationsPlugin.prototype.createController = function() {\n  RecommendationsPlugin.__super__.createController.call(this);\n  this.registerCommand(RecommendationsNotifications.RECOMMENDATION_SELECTED, RecommendationSelectedCommand);\n  this.registerCommand(Notifications.START, RecommendationsPlayCommand);\n  this.registerCommand(Notifications.PLAY_STATE_CHANGE, RecommendationsPlayStateChangeCommand);\n  this.registerCommand(RecommendationsNotifications.RECOMMENDATIONS_LOADED, PluginEventCommand);\n};\n\n/** @override\n*/\nRecommendationsPlugin.prototype.createModel = function() {\n  this.proxy = new RecommendationsProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nRecommendationsPlugin.prototype.createView = function() {\n  this.registerMediator(new RecommendationsMediator());\n};\n\n/**\n*/\nRecommendationsPlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.START, Notifications.PLAY_STATE_CHANGE];\n};\n\n/**\n*/\nRecommendationsPlugin.prototype.listNotificationPublications = function() {\n  var key, value;\n  return RecommendationsPlugin.__super__.listNotificationPublications.call(this).concat((function() {\n    var _results;\n    _results = [];\n    for (key in RecommendationsNotifications) {\n      value = RecommendationsNotifications[key];\n      _results.push(value);\n    }\n    return _results;\n  })());\n};\n\n/**\n * @param {string} value The url of the feed.\n * @expose\n*/\nRecommendationsPlugin.prototype.setURL = function(value) {\n  this.proxy.set(value);\n};\n\n/**\n * @return {string} The url of the feed.\n * @expose\n*/\nRecommendationsPlugin.prototype.getURL = function() {\n  return this.proxy.getURL();\n};\n\n/**\n * @return {Object} The MRSS feed object.\n * @expose\n*/\nRecommendationsPlugin.prototype.getData = function() {\n  return this.proxy.getData();\n};\n\n/**\n * @param {Object} value The MRSS feed object\n * @expose\n*/\nRecommendationsPlugin.prototype.setData = function(value) {\n  this.proxy.setData(value);\n};\n\n/**\n * @return {string} The window target for recommendations.\n * @expose\n*/\nRecommendationsPlugin.prototype.getTarget = function() {\n  return this.proxy.getTarget();\n};\n\n/**\n * @param {string} value The window target for recommendations.\n * @expose\n*/\nRecommendationsPlugin.prototype.setTarget = function(value) {\n  this.proxy.setTarget(value);\n};\n\n\nAMP.registerPlugin(\"recommendations\", \"html\", RecommendationsPlugin);\nAMP.registerPlugin(\"recommendations\", \"flash\", RecommendationsWrapper);\n\n/**\n * @constructor\n * @private\n*/\nfunction NielsenProxy(config) {\n  NielsenProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(NielsenProxy, DataBoundConfigurationProxy);\n\n\nNielsenProxy.prototype.configurationName = \"nielsen\";\n\n/** @static\n*/\nNielsenProxy.NAME = ModuleProxy.NAME;\n\nNielsenProxy.cg = \"OnDemand\";\n\nNielsenProxy.url = \"//secure-us.imrworldwide.com/cgi-bin/m\";\n\nNielsenProxy.prototype.defaults = {\n  url: null,\n  data: {\n    ci: null,\n    c6: null,\n    cg: null,\n    tl: null\n  },\n  events: null\n};\n\nNielsenProxy.prototype.getTitle = function() {\n  return this.title;\n};\n\nNielsenProxy.prototype.setTitle = function(value) {\n  return this.title = value;\n};\n\n/**\n*/\nNielsenProxy.prototype.start = function() {\n  var url;\n  url = this.constructURL(\"video\", \"started\");\n  Utils.beacon(url, \"nielsenBeacon\");\n};\n\nNielsenProxy.prototype.end = function() {\n  var url;\n  url = this.constructURL(\"video\", \"ended\");\n  Utils.beacon(url, \"nielsenBeacon\");\n};\n\nNielsenProxy.prototype.constructURL = function(target, type) {\n  var c6, cg, ci, event, events, item, tl, url, _i, _len, _ref, _ref1, _ref2, _ref3, _ref4;\n  url = this.url || NielsenProxy.url;\n  events = (_ref = this.value.events) != null ? _ref[target] : void 0;\n  if (events != null) {\n    for (_i = 0, _len = events.length; _i < _len; _i++) {\n      item = events[_i];\n      if (item.type === type) {\n        event = item;\n      }\n    }\n  }\n  ci = (event != null ? (_ref1 = event.data) != null ? _ref1.ci : void 0 : void 0) || this.value.data.ci;\n  c6 = (event != null ? (_ref2 = event.data) != null ? _ref2.c6 : void 0 : void 0) || this.value.data.c6;\n  cg = (event != null ? (_ref3 = event.data) != null ? _ref3.cg : void 0 : void 0) || this.value.data.cg || NielsenProxy.cg;\n  tl = (event != null ? (_ref4 = event.data) != null ? _ref4.tl : void 0 : void 0) || this.value.data.tl;\n  return \"\" + url + \"?ci=\" + ci + \"&c6=\" + c6 + \"&cc=1&tl=\" + tl + \"&cg=\" + cg + \"&rnd=\" + (Date.now());\n};\n\nfunction NielsenWrapper() {\n  return NielsenWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(NielsenWrapper, PluginWrapper);\n\n\nNielsenWrapper.NAME = \"NielsenWrapper\";\n\nNielsenWrapper.prototype.flashPlugins = [\n  {\n    id: \"NielsenPlugin\",\n    src: '#{paths.resources}plugins/NielsenPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"NielsenPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }\n];\n\n/** @override\n*/\nNielsenWrapper.prototype.createXML = function(xml) {\n  var application, element, event, events, map, metrics, node, prop, props, text, txtTest, type, urlElement, vendor, _i, _j, _len, _len1, _ref, _ref1, _ref2, _ref3;\n  if (!(((_ref = this.config) != null ? _ref.events : void 0) != null)) {\n    return;\n  }\n  application = xml.firstChild;\n  metrics = xml.getElementsByTagName(\"metrics\")[0];\n  if (!(metrics != null)) {\n    metrics = xml.createElement(\"metrics\");\n    application.appendChild(metrics);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"nielsen\");\n  metrics.appendChild(vendor);\n  map = {\n    ads: {\n      started: \"adStart\",\n      ended: \"adComplete\"\n    },\n    video: {\n      started: \"videoStart\",\n      ended: \"videoComplete\"\n    }\n  };\n  props = [\n    {\n      value: \"ci\",\n      key: \"NIELSEN_CI\"\n    }, {\n      value: \"cg\",\n      key: \"NIELSEN_CG\"\n    }, {\n      value: \"tl\",\n      key: \"NIELSEN_TL\"\n    }, {\n      value: \"c6\",\n      key: \"NIELSEN_C6\"\n    }\n  ];\n  if (this.config.url != null) {\n    urlElement = xml.createElement(\"property\");\n    urlElement.setAttribute(\"key\", \"serviceURL\");\n    txtTest = XMLUtils.createTextContent(xml, this.config.url.toString());\n    urlElement.appendChild(txtTest);\n    vendor.appendChild(urlElement);\n  }\n  _ref1 = this.config.events;\n  for (type in _ref1) {\n    events = _ref1[type];\n    if ((events != null) && events.length > 0) {\n      for (_i = 0, _len = events.length; _i < _len; _i++) {\n        event = events[_i];\n        node = xml.createElement(\"property\");\n        node.setAttribute(\"key\", map[type][event.type]);\n        vendor.appendChild(node);\n        for (_j = 0, _len1 = props.length; _j < _len1; _j++) {\n          prop = props[_j];\n          text = ((_ref2 = event.data) != null ? _ref2[prop.value] : void 0) || ((_ref3 = this.config.data) != null ? _ref3[prop.value] : void 0);\n          if ((text != null) && text !== \"\") {\n            element = xml.createElement(\"property\");\n            element.setAttribute(\"key\", prop.key);\n            text = XMLUtils.createTextContent(xml, text);\n            element.appendChild(text);\n            node.appendChild(element);\n          }\n        }\n      }\n    }\n  }\n  return xml;\n};\n\n/**\n * The NielsenEndCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction NielsenEndCommand() {\n  NielsenEndCommand.__super__.constructor.call(this);\n}\n\n\n__extends(NielsenEndCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nNielsenEndCommand.prototype.execute = function(notification) {\n  var nielsen;\n  nielsen = this.facade.retrieveProxy(NielsenProxy.NAME);\n  nielsen.end();\n};\n\n/**\n * The NielsenStartCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction NielsenStartCommand() {\n  NielsenStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(NielsenStartCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nNielsenStartCommand.prototype.execute = function(notification) {\n  var nielsen;\n  nielsen = this.facade.retrieveProxy(NielsenProxy.NAME);\n  nielsen.start();\n};\n\n/** \n * The RecommendationsGridPlugin class.\n *   \n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {RecommendationsPlugin}\n*/\nfunction RecommendationsGridPlugin() {\n  RecommendationsGridPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(RecommendationsGridPlugin, RecommendationsPlugin);\n\n\nRecommendationsGridPlugin.prototype.moduleName = \"recommendationsgrid\";\n\n/** @override\n*/\nRecommendationsGridPlugin.prototype.createView = function() {\n  if (this.config.view === \"tile\") {\n    this.registerMediator(new RecommendationsFluidGridMediator());\n  } else {\n    this.registerMediator(new RecommendationsGridMediator());\n  }\n};\n\n/**\n*/\nRecommendationsGridPlugin.prototype.listNotificationInterests = function() {\n  return RecommendationsGridPlugin.__super__.listNotificationInterests.call(this).concat([Notifications.ENDED, Notifications.CHANGE_MEDIA, Notifications.PLAY, Notifications.PLAYING, Notifications.REPLAY]);\n};\n\n\nAMP.registerPlugin(\"recommendationsgrid\", \"html\", RecommendationsGridPlugin);\nAMP.registerPlugin(\"recommendationsgrid\", \"flash\", RecommendationsWrapper);\n\nfunction NielsensdkWrapper() {\n  return NielsensdkWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(NielsensdkWrapper, PluginWrapper);\n\n\nNielsensdkWrapper.NAME = \"NielsensdkWrapper\";\n\nNielsensdkWrapper.prototype.flashPlugins = [\n  {\n    id: \"NielsenSDKPlugin\",\n    src: '#{paths.resources}plugins/NielsenSDKPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"NielsenSDKPlugin\"\n  }\n];\n\n/** @override\n*/\nNielsensdkWrapper.prototype.createXML = function(xml) {\n  var application, element, event, events, map, metrics, node, pluginProp, pluginProps, prop, props, text, type, vendor, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2, _ref3;\n  if (!(((_ref = this.config) != null ? _ref.events : void 0) != null)) {\n    return;\n  }\n  application = xml.firstChild;\n  metrics = xml.getElementsByTagName(\"metrics\")[0];\n  if (!(metrics != null)) {\n    metrics = xml.createElement(\"metrics\");\n    application.appendChild(metrics);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"nielsenSDK\");\n  metrics.appendChild(vendor);\n  map = {\n    ads: {\n      started: \"adStart\",\n      ended: \"adComplete\"\n    },\n    video: {\n      started: \"videoStart\",\n      resume: \"videoResume\",\n      ended: \"videoComplete\"\n    }\n  };\n  props = [\n    {\n      value: \"censusCategory\",\n      key: \"NIELSEN_CENSUS_CATEGORY\"\n    }, {\n      value: \"category\",\n      key: \"NIELSEN_CATEGORY\"\n    }, {\n      value: \"episodeTitle\",\n      key: \"NIELSEN_EPISODE_TITLE\"\n    }, {\n      value: \"videoType\",\n      key: \"NIELSEN_VIDEO_TYPE\"\n    }, {\n      value: \"length\",\n      key: \"NIELSEN_LENGTH\"\n    }, {\n      value: \"assetId\",\n      key: \"NIELSEN_ASSET_ID\"\n    }, {\n      value: \"dprFlag\",\n      key: \"NIELSEN_DPR_FLAG\"\n    }\n  ];\n  pluginProps = [\n    {\n      value: \"apid\",\n      key: \"NIELSEN_APID\"\n    }, {\n      value: \"sfcode\",\n      key: \"NIELSEN_SF_CODE\"\n    }, {\n      value: \"apn\",\n      key: \"NIELSEN_APN\"\n    }, {\n      value: \"fbTag\",\n      key: \"NIELSEN_FBTAG\"\n    }\n  ];\n  for (_i = 0, _len = pluginProps.length; _i < _len; _i++) {\n    pluginProp = pluginProps[_i];\n    if (this.config.data[pluginProp.value] != null) {\n      this.createProperty(xml, pluginProp.key, this.config.data[pluginProp.value], vendor);\n    }\n  }\n  _ref1 = this.config.events;\n  for (type in _ref1) {\n    events = _ref1[type];\n    if ((events != null) && events.length > 0) {\n      for (_j = 0, _len1 = events.length; _j < _len1; _j++) {\n        event = events[_j];\n        node = xml.createElement(\"property\");\n        node.setAttribute(\"key\", map[type][event.type]);\n        vendor.appendChild(node);\n        for (_k = 0, _len2 = props.length; _k < _len2; _k++) {\n          prop = props[_k];\n          text = ((_ref2 = event.data) != null ? _ref2[prop.value] : void 0) || ((_ref3 = this.config.data) != null ? _ref3[prop.value] : void 0);\n          if ((text != null) && text !== \"\") {\n            element = xml.createElement(\"property\");\n            element.setAttribute(\"key\", prop.key);\n            text = XMLUtils.createTextContent(xml, text);\n            element.appendChild(text);\n            node.appendChild(element);\n          }\n        }\n      }\n    }\n  }\n  return xml;\n};\n\n/** \n * @constructor \n * @private\n*/\nfunction NielsensdkProxy(config) {\n  NielsensdkProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(NielsensdkProxy, PluginProxy);\n\n\n/** @static\n*/\nNielsensdkProxy.NAME = ModuleProxy.NAME;\n\nNielsensdkProxy.prototype.defaults = {\n  data: null,\n  events: null,\n  plugin: {\n    js: \"http://secure-us.imrworldwide.com/novms/js/2/ggcmb400.js\"\n  }\n};\n\nNielsensdkProxy.prototype.nielsensdkSDK = null;\n\nNielsensdkProxy.prototype.cur_position = 0;\n\nNielsensdkProxy.prototype.timer = null;\n\nNielsensdkProxy.prototype.queryInterval = 2;\n\nNielsensdkProxy.prototype.isLive = null;\n\n/** Overrides\n*/\nNielsensdkProxy.prototype.initialize = function() {\n  NielsensdkProxy.__super__.initialize.call(this);\n  this.nielsensdkSDK = new NOLCMB.ggInitialize(this.value.data);\n};\n\n/** Populate Nielsen VO\n*/\nNielsensdkProxy.prototype.generateNielsenVO = function(adVO, eventName) {\n  var event, events, key, media, type, vo, _i, _len, _ref;\n  if (adVO == null) {\n    adVO = null;\n  }\n  if (eventName == null) {\n    eventName = null;\n  }\n  vo = new Object();\n  media = this.facade.player.getMedia();\n  this.isLive = media.isLive;\n  vo.assetid = media.guid;\n  vo.category = media.category;\n  vo.censuscategory = media.category;\n  vo.dprflag = \"true\";\n  vo.episodetitle = media.title ? media.title : episode_url;\n  vo.length = adVO != null ? adVO.duration : String(media.duration.toFixed(1)) === \"NaN\" ? 86400 : String(media.duration.toFixed(1));\n  vo.videotype = adVO != null ? adVO.type : \"content\";\n  _ref = this.value.events;\n  for (type in _ref) {\n    events = _ref[type];\n    if ((eventName != null) && (events != null) && events.length > 0) {\n      for (_i = 0, _len = events.length; _i < _len; _i++) {\n        event = events[_i];\n        if ((event != null ? event.type : void 0) === eventName) {\n          for (key in event.data) {\n            vo[key.toLowerCase()] = event.data[key];\n          }\n        }\n      }\n    }\n  }\n  return vo;\n};\n\n/** MetaData Loaded\n*/\nNielsensdkProxy.prototype.metaLoad = function() {\n  this.nielsensdkSDK.ggPM(\"15\", this.generateNielsenVO());\n  this.facade.logger.log(\"[AMP Nielsensdk Event] : loadMetadata\");\n};\n\nNielsensdkProxy.prototype.adStart = function(adVO) {\n  if ((adVO != null ? adVO.type : void 0) === \"midroll\") {\n    this.nielsensdkSDK.ggPM(\"7\", this.generateNielsenVO());\n    this.facade.logger.log(\"[AMP Nielsensdk Event] : stop\");\n  }\n  this.nielsensdkSDK.ggPM(\"15\", this.generateNielsenVO(adVO));\n  this.facade.logger.log(\"[AMP Nielsensdk Event] : Ad Start\");\n};\n\nNielsensdkProxy.prototype.adEnd = function(adVO) {\n  this.nielsensdkSDK.ggPM(\"7\", this.generateNielsenVO(adVO));\n  this.facade.logger.log(\"[AMP Nielsensdk Event] : Ad End\");\n  if ((adVO != null ? adVO.type : void 0) === \"midroll\") {\n    this.nielsensdkSDK.ggPM(\"15\", this.generateNielsenVO());\n    this.facade.logger.log(\"[AMP Nielsensdk Event] : Video Resume\");\n  }\n};\n\n/** Media Started\n*/\nNielsensdkProxy.prototype.start = function(adVO) {\n  if (adVO == null) {\n    adVO = null;\n  }\n  if ((adVO != null ? adVO.type : void 0) === \"midroll\") {\n    this.nielsensdkSDK.ggPM(\"15\", this.generateNielsenVO(adVO, 'resume'));\n    this.facade.logger.log(\"[AMP Nielsensdk Event] : Content Resume\");\n  } else {\n    this.nielsensdkSDK.ggPM(\"15\", this.generateNielsenVO(null, 'started'));\n    this.facade.logger.log(\"[AMP Nielsensdk Event] : Content Play\");\n  }\n};\n\n/** Media Ended\n*/\nNielsensdkProxy.prototype.end = function() {\n  var currentTime;\n  currentTime = this.facade.player.getCurrentTime().toFixed(1);\n  this.nielsensdkSDK.ggPM(\"57\", currentTime);\n  this.facade.logger.log(\"[AMP Nielsensdk Event] : Video Ended\");\n  this.cur_position = 0;\n};\n\n/** Time update\n*/\nNielsensdkProxy.prototype.timeupdate = function() {\n  if (this.isLive) {\n    this.nielsensdkSDK.ggPM(\"49\", Math.floor(Date.now() / 1000));\n    this.facade.logger.log(\"[AMP nielsensdk Event] : timeupdate Live\");\n  } else {\n    this.cur_position = this.facade.player.getCurrentTime().toFixed(1);\n    if (Math.abs(this.timer - this.cur_position) > this.queryInterval) {\n      this.timer = this.cur_position;\n      this.nielsensdkSDK.ggPM(\"49\", this.cur_position);\n      this.facade.logger.log(\"[AMP Nielsensdk Event] : timeupdate\", this.cur_position);\n    }\n  }\n};\n\n/**\n * The NielsensdkStartCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction NielsensdkStartCommand() {\n  NielsensdkStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(NielsensdkStartCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nNielsensdkStartCommand.prototype.execute = function(notification) {\n  var nielsensdk;\n  nielsensdk = this.facade.retrieveProxy(NielsensdkProxy.NAME);\n  nielsensdk.start();\n};\n\n/**\n * The NielsensdkAdStartCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction NielsensdkAdStartCommand() {\n  NielsensdkAdStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(NielsensdkAdStartCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nNielsensdkAdStartCommand.prototype.execute = function(notification) {\n  var nielsensdk;\n  nielsensdk = this.facade.retrieveProxy(NielsensdkProxy.NAME);\n  nielsensdk.adStart(notification.body);\n};\n\n/**\n * The NielsensdkAdEndCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction NielsensdkAdEndCommand() {\n  NielsensdkAdEndCommand.__super__.constructor.call(this);\n}\n\n\n__extends(NielsensdkAdEndCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nNielsensdkAdEndCommand.prototype.execute = function(notification) {\n  var nielsensdk;\n  nielsensdk = this.facade.retrieveProxy(NielsensdkProxy.NAME);\n  nielsensdk.adEnd(notification.body);\n};\n\n/**\n * The NielsensdkEndCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction NielsensdkEndCommand() {\n  NielsensdkEndCommand.__super__.constructor.call(this);\n}\n\n\n__extends(NielsensdkEndCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nNielsensdkEndCommand.prototype.execute = function(notification) {\n  var nielsensdk;\n  nielsensdk = this.facade.retrieveProxy(NielsensdkProxy.NAME);\n  nielsensdk.end();\n};\n\n/**\n * The NielsensdkMetaloadCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction NielsensdkMetaloadCommand() {\n  NielsensdkMetaloadCommand.__super__.constructor.call(this);\n}\n\n\n__extends(NielsensdkMetaloadCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nNielsensdkMetaloadCommand.prototype.execute = function(notification) {\n  var nielsensdk;\n  nielsensdk = this.facade.retrieveProxy(NielsensdkProxy.NAME);\n  nielsensdk.metaLoad();\n};\n\n/**\n * The NielsensdkTimeupdateCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction NielsensdkTimeupdateCommand() {\n  NielsensdkTimeupdateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(NielsensdkTimeupdateCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nNielsensdkTimeupdateCommand.prototype.execute = function(notification) {\n  var nielsensdk;\n  nielsensdk = this.facade.retrieveProxy(NielsensdkProxy.NAME);\n  nielsensdk.timeupdate();\n};\n\n/** \n * The NielsenPlugin class.\n *   \n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction NielsenPlugin() {\n  NielsenPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(NielsenPlugin, Plugin);\n\n\nNielsenPlugin.prototype.moduleName = \"nielsen\";\n\n/** @override\n*/\nNielsenPlugin.prototype.createController = function() {\n  var event, events, _i, _len, _ref, _ref1;\n  NielsenPlugin.__super__.createController.call(this);\n  events = (_ref = this.config) != null ? (_ref1 = _ref.events) != null ? _ref1.video : void 0 : void 0;\n  if (!(events != null)) {\n    return;\n  }\n  for (_i = 0, _len = events.length; _i < _len; _i++) {\n    event = events[_i];\n    if (event.type === \"started\") {\n      this.registerCommand(Notifications.STARTED, NielsenStartCommand);\n      this.registerCommand(Notifications.CONTENT_CHANGED, NielsenStartCommand);\n    }\n    if (event.type === \"ended\") {\n      this.registerCommand(Notifications.ENDED, NielsenEndCommand);\n      this.registerCommand(Notifications.CHANGE_CONTENT, NielsenEndCommand);\n    }\n  }\n};\n\n/** @override\n*/\nNielsenPlugin.prototype.createModel = function() {\n  this.registerProxy(new NielsenProxy(this.config));\n};\n\n/** @override\n*/\nNielsenPlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.STARTED, Notifications.ENDED, Notifications.CONTENT_CHANGED, Notifications.CHANGE_CONTENT];\n};\n\n\nAMP.registerPlugin(\"nielsen\", \"html\", NielsenPlugin);\nAMP.registerPlugin(\"nielsen\", \"flash\", NielsenWrapper);\n\nfunction ComscoreStreamsenseWrapper() {\n  return ComscoreStreamsenseWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(ComscoreStreamsenseWrapper, PluginWrapper);\n\n\nComscoreStreamsenseWrapper.NAME = \"ComscoreStreamsenseWrapper\";\n\nComscoreStreamsenseWrapper.prototype.flashPlugins = [\n  {\n    id: \"ComscoreStreamSensePlugin\",\n    src: '#{paths.resources}plugins/ComscoreStreamSensePlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"ComscoreStreamSensePlugin\"\n  }\n];\n\n/** @override\n*/\nComscoreStreamsenseWrapper.prototype.createXML = function(xml) {\n  var application, metrics, prop, props, vendor, _i, _len;\n  application = xml.firstChild;\n  metrics = xml.getElementsByTagName(\"metrics\")[0];\n  if (!(metrics != null)) {\n    metrics = xml.createElement(\"metrics\");\n    application.appendChild(metrics);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"comscoreStreamSense\");\n  metrics.appendChild(vendor);\n  props = [\n    {\n      value: this.config.data.clientId,\n      key: \"C2\"\n    }, {\n      value: this.config.data.publisherSecret,\n      key: \"PUBLISHER_SECRET\"\n    }, {\n      value: this.config.data.appVersion,\n      key: \"APP_VERSION\"\n    }, {\n      value: this.config.data.metadata,\n      key: \"metadata\"\n    }\n  ];\n  for (_i = 0, _len = props.length; _i < _len; _i++) {\n    prop = props[_i];\n    if (prop.value != null) {\n      this.createProperty(xml, prop.key, prop.value, vendor);\n    }\n  }\n  return xml;\n};\n\n/** \n * @constructor \n * @private\n*/\nfunction ComscoreStreamsenseProxy(config) {\n  ComscoreStreamsenseProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(ComscoreStreamsenseProxy, PluginProxy);\n\n\n/** @static\n*/\nComscoreStreamsenseProxy.NAME = ModuleProxy.NAME;\n\nComscoreStreamsenseProxy.prototype.defaults = {\n  plugin: {\n    js: null\n  },\n  data: {\n    clientId: null,\n    publisherSecret: null,\n    appVersion: null,\n    metadata: null\n  }\n};\n\nComscoreStreamsenseProxy.prototype.myStreamingTag = null;\n\nComscoreStreamsenseProxy.prototype.sdk = null;\n\n/** Overrides\n*/\nComscoreStreamsenseProxy.prototype.getScript = function() {\n  return this.config.plugin.js;\n};\n\n/** Overrides\n*/\nComscoreStreamsenseProxy.prototype.initialize = function() {\n  ComscoreStreamsenseProxy.__super__.initialize.call(this);\n  this.sdk = akamai[\"amp\"].ns_;\n  if ((this.sdk != null) && this.myStreamingTag === null) {\n    this.myStreamingTag = new this.sdk.StreamingTag({\n      customerC2: this.value.data.clientId\n    });\n  }\n};\n\nComscoreStreamsenseProxy.prototype.mediaChange = function() {\n  if (this.myStreamingTag != null) {\n    this.myStreamingTag.stop();\n  }\n  this.myStreamingTag = null;\n  this.myStreamingTag = new this.sdk.StreamingTag({\n    customerC2: this.value.data.clientId\n  });\n  this.facade.logger.log(\"[AMP ComscoreStreamsense Event] : Media Change, StreamTag ReInitialize\");\n};\n\nComscoreStreamsenseProxy.prototype.adStart = function(adVO) {\n  if (adVO == null) {\n    adVO = null;\n  }\n  this.myStreamingTag.playVideoAdvertisement(this.getMetaData(true));\n  this.facade.logger.log(\"[AMP ComscoreStreamsense Event] : Ad Start\");\n};\n\n/** Media Started\n*/\nComscoreStreamsenseProxy.prototype.start = function(adVO) {\n  var _ref;\n  if (adVO == null) {\n    adVO = null;\n  }\n  if ((_ref = this.facade.player.ads) != null ? _ref.getInProgress() : void 0) {\n    return;\n  }\n  this.myStreamingTag.playVideoContentPart(this.getMetaData());\n  this.facade.logger.log(\"[AMP ComscoreStreamsense Event] : Content Play\");\n};\n\n/** Media Stop\n*/\nComscoreStreamsenseProxy.prototype.stop = function() {\n  this.myStreamingTag.stop();\n  this.facade.logger.log(\"[AMP ComscoreStreamsense Event] : Stop\");\n};\n\n/** Media Ended\n*/\nComscoreStreamsenseProxy.prototype.ended = function() {\n  this.myStreamingTag.stop();\n  this.facade.logger.log(\"[AMP ComscoreStreamsense Event] : End\");\n  this.myStreamingTag = null;\n  this.myStreamingTag = new this.sdk.StreamingTag({\n    customerC2: this.value.data.clientId\n  });\n};\n\n/** Get MetaData\n*/\nComscoreStreamsenseProxy.prototype.getMetaData = function(ads) {\n  var key, metadata, object, value;\n  if (ads == null) {\n    ads = false;\n  }\n  metadata = {};\n  object = ads ? this.value.data.metadata.ads : this.value.data.metadata.video;\n  for (key in object) {\n    value = object[key];\n    if (value !== \"null\") {\n      metadata[key] = value;\n    }\n  }\n  return metadata;\n};\n\n/**\n * The ComscoreStreamsenseStartedCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ComscoreStreamsenseStartedCommand() {\n  ComscoreStreamsenseStartedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ComscoreStreamsenseStartedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nComscoreStreamsenseStartedCommand.prototype.execute = function(notification) {\n  var comscoreProxy;\n  comscoreProxy = this.facade.retrieveProxy(ComscoreStreamsenseProxy.NAME);\n  comscoreProxy.start(notification.body);\n};\n\n/**\n * The ComscoreStreamsenseAdStartedCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ComscoreStreamsenseAdStartedCommand() {\n  ComscoreStreamsenseAdStartedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ComscoreStreamsenseAdStartedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nComscoreStreamsenseAdStartedCommand.prototype.execute = function(notification) {\n  var comscoreProxy;\n  comscoreProxy = this.facade.retrieveProxy(ComscoreStreamsenseProxy.NAME);\n  comscoreProxy.adStart(notification.body);\n};\n\n/**\n * The ComscoreStreamsenseStopCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ComscoreStreamsenseStopCommand() {\n  ComscoreStreamsenseStopCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ComscoreStreamsenseStopCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nComscoreStreamsenseStopCommand.prototype.execute = function(notification) {\n  var comscoreProxy;\n  comscoreProxy = this.facade.retrieveProxy(ComscoreStreamsenseProxy.NAME);\n  comscoreProxy.stop(notification.body);\n};\n\n/**\n * The ComscoreStreamsenseAdErrorCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ComscoreStreamsenseAdErrorCommand() {\n  ComscoreStreamsenseAdErrorCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ComscoreStreamsenseAdErrorCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nComscoreStreamsenseAdErrorCommand.prototype.execute = function(notification) {\n  var comscoreProxy;\n  comscoreProxy = this.facade.retrieveProxy(ComscoreStreamsenseProxy.NAME);\n  comscoreProxy.adStart(notification.body);\n  comscoreProxy.stop(notification.body);\n};\n\n/**\n * The ComscoreStreamsenseChangeMediaCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ComscoreStreamsenseChangeMediaCommand() {\n  ComscoreStreamsenseChangeMediaCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ComscoreStreamsenseChangeMediaCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nComscoreStreamsenseChangeMediaCommand.prototype.execute = function(notification) {\n  var comscoreProxy;\n  comscoreProxy = this.facade.retrieveProxy(ComscoreStreamsenseProxy.NAME);\n  comscoreProxy.mediaChange();\n};\n\n/**\n * The ComscoreStreamsenseEndedCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ComscoreStreamsenseEndedCommand() {\n  ComscoreStreamsenseEndedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ComscoreStreamsenseEndedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nComscoreStreamsenseEndedCommand.prototype.execute = function(notification) {\n  var comscoreProxy;\n  comscoreProxy = this.facade.retrieveProxy(ComscoreStreamsenseProxy.NAME);\n  comscoreProxy.ended();\n};\n\n/** \n * The NielsenPlugin class.\n *   \n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction NielsensdkPlugin() {\n  NielsensdkPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(NielsensdkPlugin, Plugin);\n\n\nNielsensdkPlugin.prototype.moduleName = \"nielsensdk\";\n\n/** @override\n*/\nNielsensdkPlugin.prototype.createModel = function() {\n  this.registerProxy(new NielsensdkProxy(this.config));\n};\n\n/** @override\n*/\nNielsensdkPlugin.prototype.createController = function() {\n  NielsensdkPlugin.__super__.createController.call(this);\n  this.registerCommand(AdNotifications.BREAK_END, NielsensdkAdEndCommand);\n  this.registerCommand(AdNotifications.AD_STARTED, NielsensdkAdStartCommand);\n  this.registerCommand(Notifications.STARTED, NielsensdkStartCommand);\n  this.registerCommand(Notifications.ENDED, NielsensdkEndCommand);\n  this.registerCommand(Notifications.TIME_UPDATE, NielsensdkTimeupdateCommand);\n  this.registerCommand(AdNotifications.AD_TIME_REMAINING, NielsensdkTimeupdateCommand);\n};\n\n/** @override\n*/\nNielsensdkPlugin.prototype.listNotificationInterests = function() {\n  return [AdNotifications.AD_STARTED, AdNotifications.BREAK_END, Notifications.STARTED, Notifications.ENDED, Notifications.LOADED_METADATA, Notifications.TIME_UPDATE, Notifications.CONTENT_CHANGED, Notifications.CHANGE_CONTENT, AdNotifications.AD_TIME_REMAINING];\n};\n\n\nAMP.registerPlugin(\"nielsensdk\", \"html\", NielsensdkPlugin);\nAMP.registerPlugin(\"nielsensdk\", \"flash\", NielsensdkWrapper);\n\n/**\n * @constructor\n * @private\n*/\nfunction ComscoreProxy(config) {\n  ComscoreProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(ComscoreProxy, DataBoundConfigurationProxy);\n\n\nComscoreProxy.prototype.configurationName = \"comscore\";\n\n/** @static\n*/\nComscoreProxy.NAME = ModuleProxy.NAME;\n\nComscoreProxy.prototype.defaults = {\n  url: \"//b.scorecardresearch.com/b\",\n  events: {\n    ads: null,\n    video: null\n  },\n  data: {\n    c1: null,\n    c2: null,\n    c3: null,\n    c4: null,\n    c5: null,\n    c6: null,\n    c7: null,\n    c8: null,\n    c9: null,\n    c10: null,\n    c14: null\n  }\n};\n\n/**\n *\n*/\nComscoreProxy.prototype.adStart = function() {\n  var url;\n  url = this.constructURL(\"ads\", \"started\");\n  Utils.beacon(url);\n};\n\n/**\n *\n*/\nComscoreProxy.prototype.videoStart = function() {\n  var url;\n  url = this.constructURL(\"video\", \"started\");\n  Utils.beacon(url);\n};\n\n/**\n *\n*/\nComscoreProxy.prototype.constructURL = function(target, type) {\n  var data, event, events, item, key, query, url, value, _i, _len, _ref, _ref1, _ref2;\n  data = {};\n  events = (_ref = this.value.events) != null ? _ref[target] : void 0;\n  if (events != null) {\n    for (_i = 0, _len = events.length; _i < _len; _i++) {\n      item = events[_i];\n      if (item.type === type) {\n        event = item;\n      }\n    }\n  }\n  _ref1 = this.value.data;\n  for (key in _ref1) {\n    value = _ref1[key];\n    data[key] = (event != null ? (_ref2 = event.data) != null ? _ref2[key] : void 0 : void 0) || value;\n  }\n  if (data.c7 == null) {\n    data.c7 = document.location.href.substr(0, 512);\n  }\n  if (data.c8 == null) {\n    data.c8 = document.referrer.substr(0, 512);\n  }\n  if (data.c9 == null) {\n    data.c9 = document.title;\n  }\n  if (data.cv == null) {\n    data.cv = \"2.0\";\n  }\n  data.rn = Date.now();\n  url = this.value.url;\n  query = [];\n  for (key in data) {\n    value = data[key];\n    if ((value != null) && value !== \"\") {\n      query.push(key + \"=\" + escape(value));\n    }\n  }\n  if (query.length > 0) {\n    url += \"?\" + query.join(\"&\");\n  }\n  return url.substr(0, 2080);\n};\n\nfunction ComscoreWrapper() {\n  return ComscoreWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(ComscoreWrapper, PluginWrapper);\n\n\nComscoreWrapper.NAME = \"ComscoreWrapper\";\n\nComscoreWrapper.prototype.flashPlugins = [\n  {\n    id: \"ComscorePlugin\",\n    src: '#{paths.resources}plugins/ComscorePlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"ComscorePlugin\",\n    type: \"application/x-shockwave-flash\"\n  }\n];\n\n/** @override\n*/\nComscoreWrapper.prototype.createXML = function(xml) {\n  var application, element, event, events, map, metrics, node, prop, props, text, type, vendor, _i, _j, _len, _len1, _ref, _ref1, _ref2;\n  application = xml.firstChild;\n  metrics = xml.getElementsByTagName(\"metrics\")[0];\n  if (!(metrics != null)) {\n    metrics = xml.createElement(\"metrics\");\n    application.appendChild(metrics);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"comscore\");\n  metrics.appendChild(vendor);\n  map = {\n    ads: {\n      started: \"adStart\",\n      ended: \"adComplete\"\n    },\n    video: {\n      started: \"videoStart\",\n      ended: \"videoComplete\"\n    }\n  };\n  props = [\n    {\n      value: \"c1\",\n      key: \"COMSCORE_CSC1\"\n    }, {\n      value: \"c2\",\n      key: \"COMSCORE_CSC2\"\n    }, {\n      value: \"c3\",\n      key: \"COMSCORE_CSC3\"\n    }, {\n      value: \"c4\",\n      key: \"COMSCORE_CSC4\"\n    }, {\n      value: \"c5\",\n      key: \"COMSCORE_CSC5\"\n    }, {\n      value: \"c6\",\n      key: \"COMSCORE_CSC6\"\n    }, {\n      value: \"c7\",\n      key: \"COMSCORE_CSC7\"\n    }, {\n      value: \"c8\",\n      key: \"COMSCORE_CSC8\"\n    }, {\n      value: \"c9\",\n      key: \"COMSCORE_CSC9\"\n    }, {\n      value: \"c10\",\n      key: \"COMSCORE_CSC10\"\n    }, {\n      value: \"c11\",\n      key: \"COMSCORE_CSC14\"\n    }\n  ];\n  _ref = this.config.events;\n  for (type in _ref) {\n    events = _ref[type];\n    if ((events != null) && events.length > 0) {\n      for (_i = 0, _len = events.length; _i < _len; _i++) {\n        event = events[_i];\n        node = xml.createElement(\"property\");\n        node.setAttribute(\"key\", map[type][event.type]);\n        vendor.appendChild(node);\n        element = xml.createElement(\"property\");\n        element.setAttribute(\"key\", \"COMSCORE_CSURL\");\n        text = XMLUtils.createTextContent(xml, this.config.url);\n        element.appendChild(text);\n        node.appendChild(element);\n        for (_j = 0, _len1 = props.length; _j < _len1; _j++) {\n          prop = props[_j];\n          text = ((_ref1 = event.data) != null ? _ref1[prop.value] : void 0) || ((_ref2 = this.config.data) != null ? _ref2[prop.value] : void 0);\n          if ((text != null) && text !== \"\") {\n            element = xml.createElement(\"property\");\n            element.setAttribute(\"key\", prop.key);\n            text = XMLUtils.createTextContent(xml, text);\n            element.appendChild(text);\n            node.appendChild(element);\n          }\n        }\n      }\n    }\n  }\n  return xml;\n};\n\n/**\n * The ComscoreAdStartCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ComscoreAdStartCommand() {\n  ComscoreAdStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ComscoreAdStartCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nComscoreAdStartCommand.prototype.execute = function(notification) {\n  var comscore;\n  comscore = this.facade.retrieveProxy(ComscoreProxy.NAME);\n  comscore.adStart();\n};\n\n/**\n * The ComscoreStartCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction ComscoreStartCommand() {\n  ComscoreStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ComscoreStartCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nComscoreStartCommand.prototype.execute = function(notification) {\n  var comscore;\n  comscore = this.facade.retrieveProxy(ComscoreProxy.NAME);\n  comscore.videoStart();\n};\n\n/** \n * The ComscoreStreamsensePlugin class.\n *   \n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction ComscoreStreamsensePlugin() {\n  ComscoreStreamsensePlugin.__super__.constructor.call(this);\n}\n\n\n__extends(ComscoreStreamsensePlugin, Plugin);\n\n\nComscoreStreamsensePlugin.prototype.moduleName = \"comscorestreamsense\";\n\n/** @override\n*/\nComscoreStreamsensePlugin.prototype.createModel = function() {\n  this.registerProxy(new ComscoreStreamsenseProxy(this.config));\n};\n\n/** @override\n*/\nComscoreStreamsensePlugin.prototype.createController = function() {\n  ComscoreStreamsensePlugin.__super__.createController.call(this);\n  this.registerCommand(Notifications.MEDIA_CHANGE, ComscoreStreamsenseChangeMediaCommand);\n  this.registerCommand(AdNotifications.AD_STARTED, ComscoreStreamsenseAdStartedCommand);\n  this.registerCommand(AdNotifications.AD_ENDED, ComscoreStreamsenseStopCommand);\n  this.registerCommand(AdNotifications.SKIPPED, ComscoreStreamsenseStopCommand);\n  this.registerCommand(AdNotifications.AD_ERROR, ComscoreStreamsenseAdErrorCommand);\n  this.registerCommand(Notifications.PLAYING, ComscoreStreamsenseStartedCommand);\n  this.registerCommand(Notifications.PAUSED, ComscoreStreamsenseStopCommand);\n  this.registerCommand(Notifications.ENDED, ComscoreStreamsenseEndedCommand);\n};\n\n/** @override\n*/\nComscoreStreamsensePlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.MEDIA_CHANGE, AdNotifications.AD_STARTED, AdNotifications.AD_ENDED, AdNotifications.AD_ERROR, AdNotifications.SKIPPED, Notifications.ENDED, Notifications.PAUSED, Notifications.PLAYING];\n};\n\n\nAMP.registerPlugin(\"comscorestreamsense\", \"html\", ComscoreStreamsensePlugin);\nAMP.registerPlugin(\"comscorestreamsense\", \"flash\", ComscoreStreamsenseWrapper);\n\n/** \n * @constructor\n * @private\n * @extends {PluginWrapper}\n*/\nfunction OmnitureWrapper(player, config) {\n  if (config.heartbeat.enabled === true || config.useJS === true) {\n    this.createXML = function() {};\n    this.flashPlugins = [];\n    this.plugin = new OmniturePlugin();\n    this.plugin.oninitialized = player.registerModule.bind(player, this.plugin);\n    this.plugin.initialize(config, player);\n  }\n  OmnitureWrapper.__super__.constructor.call(this, player, config);\n}\n\n\n__extends(OmnitureWrapper, PluginWrapper);\n\n\nOmnitureWrapper.NAME = \"OmnitureWrapper\";\n\nOmnitureWrapper.prototype.flashPlugins = [\n  {\n    id: \"OmniturePlugin\",\n    src: '#{paths.resources}plugins/OmniturePlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"OmniturePlugin\"\n  }\n];\n\n/** @override\n*/\nOmnitureWrapper.prototype.createXML = function(xml) {\n  var application, contextData, contextDataMapping, event, events, intervalProp, intervalReached, intervals, key, linkTracking, linkTrackingData, media, metrics, milestone, milestones, prop, property, props, trackMilestone, trackMilestones, type, value, vendor, _i, _j, _k, _l, _len, _len1, _len2, _len3, _len4, _len5, _len6, _m, _n, _o, _ref, _ref1, _ref2;\n  if (this.config.useJS === true) {\n    return;\n  }\n  application = xml.firstChild;\n  metrics = xml.getElementsByTagName(\"metrics\")[0];\n  if (!(metrics != null)) {\n    metrics = xml.createElement(\"metrics\");\n    application.appendChild(metrics);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"omniture\");\n  metrics.appendChild(vendor);\n  props = [\n    {\n      value: this.config.channel,\n      key: \"OMNITURE_CHANNEL\"\n    }, {\n      value: this.config.account,\n      key: \"OMNITURE_ACCOUNT\"\n    }, {\n      value: this.config.debugTracking,\n      key: \"OMNITURE_DEBUG_TRACKING\"\n    }, {\n      value: this.config.trackLocal,\n      key: \"OMNITURE_TRACK_LOCAL\"\n    }, {\n      value: this.config.visitorNamespace,\n      key: \"OMNITURE_VISITOR_NAMESPACE\"\n    }, {\n      value: this.config.trackingServer,\n      key: \"OMNITURE_TRACKING_SERVER\"\n    }, {\n      value: this.config.trackingServerSecure,\n      key: \"OMNITURE_TRACKING_SERVER_SECURE\"\n    }, {\n      value: this.config.currencyCode,\n      key: \"OMNITURE_CURRENCY_CODE\"\n    }, {\n      value: this.config.trackWhilePlaying,\n      key: \"OMNITURE_TRACK_WHILE_PLAYING\"\n    }, {\n      value: this.config.trackMediaMethods,\n      key: \"OMNITURE_TRACK_MEDIA_METHODS\"\n    }, {\n      value: this.config.mediaName,\n      key: \"OMNITURE_MEDIA_NAME\"\n    }, {\n      value: this.config.playerName,\n      key: \"OMNITURE_PLAYER_NAME\"\n    }\n  ];\n  for (_i = 0, _len = props.length; _i < _len; _i++) {\n    prop = props[_i];\n    if (prop.value != null) {\n      this.createProperty(xml, prop.key, prop.value, vendor);\n    }\n  }\n  media = this.config.Media;\n  if (media != null) {\n    props = [\n      {\n        value: media.autoTrack,\n        key: \"OMNITURE_AUTO_TRACK\"\n      }, {\n        value: media.segmentByMilestones,\n        key: \"OMNITURE_SEGMENT_MILESTONES\"\n      }, {\n        value: media.trackVars,\n        key: \"OMNITURE_TRACKVARS\"\n      }, {\n        value: media.trackEvents,\n        key: \"OMNITURE_TRACKEVENTS\"\n      }, {\n        value: media.trackUsingContextData,\n        key: \"OMNITURE_TRACK_CONTEXT_DATA\"\n      }, {\n        value: media.trackSecondIntervals,\n        key: \"OMNITURE_TRACKSECOND_INTERVALS\"\n      }\n    ];\n    for (_j = 0, _len1 = props.length; _j < _len1; _j++) {\n      prop = props[_j];\n      if (prop.value != null) {\n        this.createProperty(xml, prop.key, prop.value, vendor);\n      }\n    }\n    if (media.trackMilestones != null) {\n      trackMilestones = this.createProperty(xml, \"OMNITURE_TRACK_MILESTONES\", null, vendor);\n      milestones = media.trackMilestones;\n      for (_k = 0, _len2 = milestones.length; _k < _len2; _k++) {\n        milestone = milestones[_k];\n        trackMilestone = this.createProperty(xml, milestone.percent, null, trackMilestones);\n        for (key in milestone) {\n          value = milestone[key];\n          if (key !== \"percent\") {\n            this.createProperty(xml, key, value, trackMilestone);\n          }\n        }\n      }\n    }\n    contextDataMapping = media.contextDataMapping;\n    if (contextDataMapping != null) {\n      contextData = this.createProperty(xml, \"OMNITURE_CONTEXT_DATA\", null, vendor);\n      for (key in contextDataMapping) {\n        value = contextDataMapping[key];\n        if (typeof value === \"string\") {\n          this.createProperty(xml, key, value, contextData);\n        }\n        if (value instanceof Array) {\n          property = this.createProperty(xml, key, null, contextData);\n          for (_l = 0, _len3 = value.length; _l < _len3; _l++) {\n            milestone = value[_l];\n            this.createProperty(xml, milestone.percent, milestone.events, property);\n          }\n        }\n      }\n    }\n  }\n  linkTracking = this.config.customLinkTracking;\n  if (linkTracking != null) {\n    linkTrackingData = this.createProperty(xml, \"OMNITURE_CUSTOM_LINK_TRACKING\", null, vendor);\n    for (key in linkTracking) {\n      if (key === \"intervalReached\") {\n        intervalReached = this.createProperty(xml, key, null, linkTrackingData);\n        _ref = linkTracking[key];\n        for (_m = 0, _len4 = _ref.length; _m < _len4; _m++) {\n          intervals = _ref[_m];\n          intervalProp = this.createProperty(xml, intervals.interval, null, intervalReached);\n          for (key in intervals) {\n            if (key !== \"interval\") {\n              this.createProperty(xml, key, intervals[key], intervalProp);\n            }\n          }\n        }\n      } else {\n        this.createProperty(xml, key, linkTracking[key], linkTrackingData);\n      }\n    }\n  }\n  events = (_ref1 = this.config.events) != null ? _ref1.video : void 0;\n  if (events != null) {\n    for (_n = 0, _len5 = events.length; _n < _len5; _n++) {\n      event = events[_n];\n      switch (event.type) {\n        case \"started\":\n          type = \"videoStart\";\n          break;\n        case \"ended\":\n          type = \"videoComplete\";\n          break;\n        case \"play\":\n          type = \"videoResume\";\n          break;\n        case \"pause\":\n          type = \"videoPause\";\n          break;\n        default:\n          type = event.type;\n      }\n      this.createProperty(xml, type, event.data, vendor);\n    }\n  }\n  events = (_ref2 = this.config.events) != null ? _ref2.ads : void 0;\n  if (events != null) {\n    for (_o = 0, _len6 = events.length; _o < _len6; _o++) {\n      event = events[_o];\n      type = event.type === \"started\" ? 'adStart' : event.type === \"ended\" ? 'adComplete' : event.type;\n      this.createProperty(xml, type, event.data, vendor);\n    }\n  }\n};\n\n/** \n * The OmnitureProxy class.\n *   \n * @param {Object} config\n * @constructor\n * @private\n * @extends {PluginProxy}\n*/\nfunction OmnitureProxy(config) {\n  OmnitureProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(OmnitureProxy, PluginProxy);\n\n\n/** @static\n*/\nOmnitureProxy.NAME = ModuleProxy.NAME;\n\nOmnitureProxy.prototype.defaults = {\n  main: \"s\",\n  heartbeat: null,\n  account: null,\n  playerName: null,\n  mediaName: null,\n  trackingServer: null,\n  visitorNamespace: null,\n  visitor: null,\n  visitorID: null,\n  pageName: null\n};\n\nOmnitureProxy.prototype.media = null;\n\nOmnitureProxy.prototype.started = false;\n\nOmnitureProxy.prototype.ad = null;\n\nOmnitureProxy.prototype.adCurrentTime = null;\n\nOmnitureProxy.prototype.adStarted = false;\n\nOmnitureProxy.prototype.adsEnabled = false;\n\nOmnitureProxy.prototype.getMediaName = function() {\n  return this.getConfigurationData().mediaName || this.media.getTitle();\n};\n\nOmnitureProxy.prototype.getPlayerName = function() {\n  var _ref;\n  return this.getConfigurationData().playerName || ((_ref = this.facade.player.retrieveProxy(ConfigurationProxy.NAME)) != null ? _ref.getName() : void 0) || this.facade.player.config.name || \"amp\";\n};\n\nOmnitureProxy.prototype.getPlaybackCore = function() {\n  var _ref;\n  return ((_ref = this.facade.player.retrieveProxy(PlayerProxy.NAME)) != null ? _ref.getActivePlaybackCore() : void 0) || this.facade.player.playback;\n};\n\n/**\n*/\nOmnitureProxy.prototype.initialize = function() {\n  var _ref, _ref1;\n  OmnitureProxy.__super__.initialize.call(this);\n  this.media = this.facade.player.retrieveProxy(MediaProxy.NAME);\n  this.adsEnabled = (_ref = this.facade.player.ads) != null ? _ref.getEnabled() : void 0;\n  if (this.plugin != null) {\n    try {\n      if (!(this.plugin.Media != null)) {\n        this.plugin.loadModule(\"Media\");\n      }\n    } catch (error) {\n      this.error(\"initialize\", error);\n    }\n    if (!(((_ref1 = this.plugin.Media) != null ? _ref1.openAd : void 0) != null)) {\n      this.adStart = this.adEnded = this.adPlay = this.adPause = this.adCurrentTime = function() {};\n    }\n  }\n};\n\n/**\n*/\nOmnitureProxy.prototype.createPlugin = function() {\n  return window[this.getConfigurationData().main];\n};\n\n/**\n*/\nOmnitureProxy.prototype.mediaChange = function() {\n  var _ref;\n  this.started = false;\n  this.adsEnabled = (_ref = this.facade.player.ads) != null ? _ref.getEnabled() : void 0;\n};\n\n/**\n*/\nOmnitureProxy.prototype.start = function() {\n  if (this.started === true) {\n    return;\n  }\n  try {\n    this.started = true;\n    this.plugin.Media.open(this.getMediaName(), this.media.getDuration(), this.getPlayerName());\n  } catch (error) {\n    this.error(error);\n  }\n  if (this.adsEnabled !== true) {\n    this.play();\n  }\n};\n\n/**\n*/\nOmnitureProxy.prototype.play = function() {\n  if (this.started !== true) {\n    this.start();\n    return;\n  }\n  if (this.adStarted === true) {\n    return;\n  }\n  try {\n    this.plugin.Media.play(this.getMediaName(), this.getPlaybackCore().getCurrentTime() || 0);\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nOmnitureProxy.prototype.pause = function() {\n  if (this.adStarted === true) {\n    return;\n  }\n  try {\n    this.plugin.Media.stop(this.getMediaName(), this.getPlaybackCore().getCurrentTime());\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nOmnitureProxy.prototype.seeking = function() {\n  try {\n    this.plugin.Media.stop(this.getMediaName(), this.getPlaybackCore().getCurrentTime());\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nOmnitureProxy.prototype.seeked = function() {\n  try {\n    this.plugin.Media.play(this.getMediaName(), this.getPlaybackCore().getCurrentTime());\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nOmnitureProxy.prototype.ended = function() {\n  try {\n    this.plugin.Media.stop(this.getMediaName(), this.getPlaybackCore().getCurrentTime());\n    this.plugin.Media.close(this.getMediaName());\n    this.started = false;\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/** Pluging.\n*/\nOmnitureProxy.prototype.getAd = function() {\n  return this.ad;\n};\n\nOmnitureProxy.prototype.setAd = function(value) {\n  this.adStarted = false;\n  this.adCurrentTime = 0;\n  return this.ad = value;\n};\n\n/**\n*/\nOmnitureProxy.prototype.adStart = function() {\n  try {\n    this.adStarted = true;\n    this.plugin.Media.openAd(this.ad.title, this.ad.duration, this.getPlayerName(), this.getMediaName(), this.ad.type, this.ad.position, this.ad.cpm);\n    this.adPlay();\n  } catch (error) {\n    this.error(\"ad start\", error);\n  }\n};\n\n/**\n*/\nOmnitureProxy.prototype.adPlay = function() {\n  if (this.adStarted !== true) {\n    this.adStart();\n  }\n  try {\n    this.plugin.Media.play(this.ad.title, this.adCurrentTime || 0);\n  } catch (error) {\n    this.error(\"ad play\", error);\n  }\n};\n\n/**\n*/\nOmnitureProxy.prototype.adPause = function() {\n  try {\n    this.plugin.Media.stop(this.ad.title, this.adCurrentTime);\n  } catch (error) {\n    this.error(\"ad pause\", error);\n  }\n};\n\n/**\n*/\nOmnitureProxy.prototype.adCurrentTime = function(value) {\n  this.adCurrentTime = value;\n};\n\n/**\n*/\nOmnitureProxy.prototype.adEnded = function() {\n  if (this.adStarted === false) {\n    return;\n  }\n  try {\n    this.adStarted = false;\n    this.plugin.Media.stop(this.ad.title, this.ad.duration);\n    this.plugin.Media.close(this.ad.title);\n  } catch (error) {\n    this.error(\"ad end\", error);\n  }\n  this.play();\n};\n\n/**\n * The HeartbeatProxy class.\n *\n * @param {Object} config\n * @constructor\n * @private\n * @extends {PluginProxy}\n*/\nfunction HeartbeatProxy(config) {\n  HeartbeatProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(HeartbeatProxy, OmnitureProxy);\n\n\n/** @static\n*/\nHeartbeatProxy.NAME = ModuleProxy.NAME;\n\nHeartbeatProxy.prototype.aaPlugin = null;\n\nHeartbeatProxy.prototype.playerPlugin = null;\n\nHeartbeatProxy.prototype.heartbeat = null;\n\nHeartbeatProxy.prototype.resumed = false;\n\nHeartbeatProxy.prototype.liveLinear = null;\n\n/**\n*/\nHeartbeatProxy.prototype.initialize = function() {\n  var ahPlugin, appMeasurement, config, delegate, pluginConfig, plugins, visitor,\n    _this = this;\n  HeartbeatProxy.__super__.initialize.call(this);\n  config = this.getConfigurationData();\n  if (config.heartbeat.liveLinear != null) {\n    this.calculateLiveLinear();\n  }\n  if (typeof Visitor !== \"undefined\" && Visitor !== null) {\n    visitor = new Visitor(config.visitor.marketingCloudOrgId);\n    visitor.trackingServer = config.visitor.trackingServer;\n  }\n  appMeasurement = new AppMeasurement();\n  appMeasurement.account = config.account;\n  appMeasurement.trackingServer = config.trackingServer;\n  appMeasurement.visitor = visitor;\n  appMeasurement.pageName = config.pageName;\n  appMeasurement.charSet = \"UTF-8\";\n  appMeasurement.visitorID = config.visitorID;\n  delegate = this.createDelegate();\n  this.playerPlugin = new ADB.va.plugins.videoplayer.VideoPlayerPlugin(delegate);\n  pluginConfig = new ADB.va.plugins.videoplayer.VideoPlayerPluginConfig();\n  pluginConfig.debugLogging = this.getDebug();\n  this.playerPlugin.configure(pluginConfig);\n  delegate = new ADB.va.plugins.aa.AdobeAnalyticsPluginDelegate();\n  delegate.onError = function(errorInfo) {\n    _this.facade.logger.error(\"AdobeAnalyticsPlugin error: \" + errorInfo.getMessage() + \" | \" + errorInfo.getDetails());\n  };\n  this.aaPlugin = new ADB.va.plugins.aa.AdobeAnalyticsPlugin(appMeasurement, delegate);\n  pluginConfig = new ADB.va.plugins.aa.AdobeAnalyticsPluginConfig();\n  pluginConfig.channel = config.heartbeat.channel;\n  pluginConfig.debugLogging = this.getDebug();\n  this.aaPlugin.configure(pluginConfig);\n  delegate = new ADB.va.plugins.ah.AdobeHeartbeatPluginDelegate();\n  delegate.onError = function(errorInfo) {\n    _this.facade.logger.error(\"AdobeHeartbeatPlugin error: \" + errorInfo.getMessage() + \" | \" + errorInfo.getDetails());\n  };\n  ahPlugin = new ADB.va.plugins.ah.AdobeHeartbeatPlugin(delegate);\n  pluginConfig = new ADB.va.plugins.ah.AdobeHeartbeatPluginConfig(config.heartbeat.trackingServer, config.heartbeat.publisher);\n  pluginConfig.ovp = config.heartbeat.ovp;\n  pluginConfig.sdk = config.heartbeat.sdk;\n  pluginConfig.ssl = config.heartbeat.ssl === true;\n  pluginConfig.debugLogging = this.getDebug();\n  ahPlugin.configure(pluginConfig);\n  plugins = [this.playerPlugin, this.aaPlugin, ahPlugin];\n  delegate = new ADB.va.HeartbeatDelegate();\n  delegate.onError = function(errorInfo) {\n    _this.facade.logger.error(\"Heartbeat error: \" + errorInfo.getMessage() + \" | \" + errorInfo.getDetails());\n  };\n  this.heartbeat = new ADB.va.Heartbeat(delegate, plugins);\n  pluginConfig = new ADB.va.HeartbeatConfig();\n  pluginConfig.debugLogging = this.getDebug();\n  this.heartbeat.configure(pluginConfig);\n};\n\n/**\n*/\nHeartbeatProxy.prototype.calculateLiveLinear = function() {\n  var liveLinear, start,\n    _this = this;\n  if (this.liveLinear == null) {\n    this.liveLinear = {};\n  }\n  if (this.liveLinear.updating === true) {\n    return;\n  }\n  this.liveLinear.updating = true;\n  liveLinear = {\n    updating: false\n  };\n  start = Date.now();\n  Utils.getUTC().then(function(utc) {\n    var date, day, end, timezone;\n    end = Date.now();\n    date = new Date(utc);\n    day = date.toJSON().replace(/([^T]+T).+/, \"$1\");\n    timezone = _this.getConfigurationData().heartbeat.liveLinear.timezone || \"Z\";\n    liveLinear.utc = utc;\n    date = new Date(start + ((end - start) / 2));\n    liveLinear.client = date.getTime();\n    liveLinear.offset = liveLinear.client - utc;\n    date = new Date(day + \"00:00:00.000\" + timezone);\n    liveLinear.start = date.getTime();\n    date = new Date(day + \"23:59:59.999\" + timezone);\n    liveLinear.end = date.getTime();\n    liveLinear.duration = Math.round((liveLinear.end - liveLinear.start) / 1000);\n    return _this.liveLinear = liveLinear;\n  });\n  return;\n};\n\n/**\n*/\nHeartbeatProxy.prototype.calculateLiveLinearTime = function() {\n  var now, time;\n  now = Date.now() - this.liveLinear.offset;\n  time = Math.round((now - this.liveLinear.start) / 1000);\n  if (time > this.liveLinear.duration) {\n    time = time - this.liveLinear.duration;\n    this.calculateLiveLinear();\n  }\n  return time;\n};\n\n/**\n*/\nHeartbeatProxy.prototype.createDelegate = function() {\n  var delegate,\n    _this = this;\n  delegate = new ADB.va.plugins.videoplayer.VideoPlayerPluginDelegate();\n  delegate.getVideoInfo = function() {\n    var config, playbackCore, time, videoInfo;\n    playbackCore = _this.getPlaybackCore();\n    videoInfo = new ADB.va.plugins.videoplayer.VideoInfo();\n    videoInfo.id = _this.media.getGUID() || _this.media.getTitle();\n    videoInfo.playerName = _this.getPlayerName();\n    videoInfo.name = _this.getMediaName();\n    videoInfo.resumed = _this.resumed;\n    config = _this.getConfigurationData().heartbeat;\n    if (config.liveLinear.enabled === true) {\n      videoInfo.length = _this.liveLinear.duration;\n      videoInfo.streamType = ADB.va.plugins.videoplayer.AssetType.ASSET_TYPE_LIVE;\n      videoInfo.playhead = _this.calculateLiveLinearTime();\n    } else if (_this.media.getTemporalType() === \"live\") {\n      videoInfo.length = -1;\n      videoInfo.streamType = ADB.va.plugins.videoplayer.AssetType.ASSET_TYPE_LIVE;\n      videoInfo.playhead = 0;\n    } else {\n      videoInfo.length = _this.media.getDuration();\n      videoInfo.streamType = ADB.va.plugins.videoplayer.AssetType.ASSET_TYPE_VOD;\n      time = playbackCore != null ? typeof playbackCore.getCurrentTime === \"function\" ? playbackCore.getCurrentTime() : void 0 : void 0;\n      videoInfo.playhead = !(time != null) || isNaN(time) ? 0 : time;\n    }\n    return videoInfo;\n  };\n  delegate.getAdInfo = function() {\n    var adInfo, duration;\n    adInfo = new ADB.va.plugins.videoplayer.AdInfo();\n    if (!(_this.ad != null)) {\n      return null;\n    }\n    adInfo.id = _this.ad.id;\n    duration = _this.ad.duration;\n    adInfo.length = isNaN(duration) || duration === 0 ? -1 : duration;\n    adInfo.position = _this.ad.position;\n    adInfo.name = _this.ad.title;\n    return adInfo;\n  };\n  delegate.getAdBreakInfo = function() {\n    var adBreakInfo;\n    adBreakInfo = new ADB.va.plugins.videoplayer.AdBreakInfo();\n    if (!(_this.ad != null)) {\n      return null;\n    }\n    adBreakInfo.name = _this.ad.type;\n    adBreakInfo.position = _this.ad.position;\n    adBreakInfo.playerName = _this.getPlayerName();\n    adBreakInfo.startTime = _this.getPlaybackCore().getCurrentTime();\n    return adBreakInfo;\n  };\n  delegate.getChapterInfo = function() {\n    var chapterInfo, currentScene;\n    currentScene = _this.media.getScene(_this.getPlaybackCore().getCurrentTime());\n    if (!(currentScene != null)) {\n      return null;\n    }\n    chapterInfo = new ADB.va.plugins.videoplayer.ChapterInfo();\n    chapterInfo.name = currentScene.title;\n    chapterInfo.length = currentScene.end - currentScene.start;\n    chapterInfo.position = currentScene.position;\n    chapterInfo.startTime = currentScene.start;\n    return chapterInfo;\n  };\n  delegate.onError = function(error) {\n    _this.facade.logger.error(\"Heartbeat Error:\", error);\n  };\n  delegate.getQoSInfo = function() {\n    var qosInfo;\n    qosInfo = new ADB.va.plugins.videoplayer.QoSInfo();\n    return null;\n  };\n  return delegate;\n};\n\n/**\n*/\nHeartbeatProxy.prototype.mediaChange = function() {\n  var metadata, _ref;\n  HeartbeatProxy.__super__.mediaChange.call(this);\n  this.resumed = false;\n  metadata = (_ref = this.getValue(\"heartbeat\").metadata) != null ? _ref.video : void 0;\n  if (metadata != null) {\n    this.aaPlugin.setVideoMetadata(metadata);\n  }\n};\n\n/**\n*/\nHeartbeatProxy.prototype.start = function() {\n  if (this.started === true) {\n    return;\n  }\n  try {\n    this.playerPlugin.trackVideoLoad();\n    this.started = true;\n  } catch (error) {\n    this.error(error);\n  }\n  this.play();\n};\n\n/**\n*/\nHeartbeatProxy.prototype.play = function() {\n  if (this.started !== true) {\n    this.start();\n  }\n  try {\n    this.playerPlugin.trackPlay();\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nHeartbeatProxy.prototype.pause = function() {\n  try {\n    this.playerPlugin.trackPause();\n    this.resumed = true;\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nHeartbeatProxy.prototype.seeking = function() {\n  try {\n    this.playerPlugin.trackSeekStart();\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nHeartbeatProxy.prototype.seeked = function() {\n  try {\n    this.playerPlugin.trackSeekComplete();\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nHeartbeatProxy.prototype.ended = function() {\n  try {\n    this.playerPlugin.trackComplete();\n    this.playerPlugin.trackVideoUnload();\n    this.started = false;\n    this.aaPlugin.setVideoMetadata(null);\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nHeartbeatProxy.prototype.adStart = function() {\n  var metadata, _ref;\n  if (this.started !== true) {\n    metadata = (_ref = this.getValue(\"heartbeat\").metadata) != null ? _ref.ad : void 0;\n    if (metadata != null) {\n      this.aaPlugin.setAdMetadata(metadata);\n    }\n    this.start();\n    setTimeout(this.adStart.bind(this), 0);\n    return;\n  }\n  try {\n    this.playerPlugin.trackAdStart();\n  } catch (error) {\n    this.error(error);\n  }\n};\n\n/**\n*/\nHeartbeatProxy.prototype.adEnded = function() {\n  try {\n    this.playerPlugin.trackAdComplete();\n    this.aaPlugin.setAdMetadata(null);\n  } catch (error) {\n    this.error(error);\n  }\n};\n\nHeartbeatProxy.prototype.adPlay = function() {};\n\nHeartbeatProxy.prototype.adPause = function() {};\n\n/**\n * The OmnitureStartCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureStartCommand() {\n  OmnitureStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureStartCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nOmnitureStartCommand.prototype.execute = function(notification) {\n  this.proxy.start();\n};\n\n/**\n * The OmniturePlayCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmniturePlayCommand() {\n  OmniturePlayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmniturePlayCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nOmniturePlayCommand.prototype.execute = function(notification) {\n  this.proxy.play();\n};\n\n/**\n * The OmniturePauseCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmniturePauseCommand() {\n  OmniturePauseCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmniturePauseCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nOmniturePauseCommand.prototype.execute = function(notification) {\n  this.proxy.pause();\n};\n\n/**\n * The OmnitureSeekingCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureSeekingCommand() {\n  OmnitureSeekingCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureSeekingCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nOmnitureSeekingCommand.prototype.execute = function(notification) {\n  this.proxy.seeking();\n};\n\n/**\n * The OmnitureSeekedCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureSeekedCommand() {\n  OmnitureSeekedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureSeekedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nOmnitureSeekedCommand.prototype.execute = function(notification) {\n  this.proxy.seeked();\n};\n\n/**\n * The OmnitureEndedCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureEndedCommand() {\n  OmnitureEndedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureEndedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nOmnitureEndedCommand.prototype.execute = function(notification) {\n  this.proxy.ended();\n};\n\n/**\n * The OmnitureChangeMediaCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureContentChangedCommand() {\n  OmnitureContentChangedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureContentChangedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nOmnitureContentChangedCommand.prototype.execute = function(notification) {\n  this.proxy.setMedia(notification.getBody());\n  this.proxy.start();\n};\n\n/**\n * The OmnitureAdLoadedCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureAdLoadedCommand() {\n  OmnitureAdLoadedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureAdLoadedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nOmnitureAdLoadedCommand.prototype.execute = function(notification) {\n  this.proxy.setAd(notification.getBody());\n};\n\n/**\n * The OmnitureAdStartedCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureAdStartedCommand() {\n  OmnitureAdStartedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureAdStartedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nOmnitureAdStartedCommand.prototype.execute = function(notification) {\n  this.proxy.adStart();\n};\n\n/**\n * The OmnitureAdPlayCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureAdPlayCommand() {\n  OmnitureAdPlayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureAdPlayCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nOmnitureAdPlayCommand.prototype.execute = function(notification) {\n  this.proxy.adPlay();\n};\n\n/**\n * The OmnitureAdPauseCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureAdPauseCommand() {\n  OmnitureAdPauseCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureAdPauseCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nOmnitureAdPauseCommand.prototype.execute = function(notification) {\n  this.proxy.adPause();\n};\n\n/**\n * The OmnitureAdBreakEndCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureAdBreakEndCommand() {\n  OmnitureAdBreakEndCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureAdBreakEndCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nOmnitureAdBreakEndCommand.prototype.execute = function(notification) {\n  this.proxy.adEnded();\n  this.proxy.setAd(null);\n};\n\n/**\n * The OmnitureAdTimeRemainingCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureAdTimeUpdateCommand() {\n  OmnitureAdTimeUpdateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureAdTimeUpdateCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nOmnitureAdTimeUpdateCommand.prototype.execute = function(notification) {\n  this.proxy.adCurrentTime(notification.getBody());\n};\n\n/**\n * The OmnitureMediaChangeCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction OmnitureMediaChangeCommand() {\n  OmnitureMediaChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(OmnitureMediaChangeCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nOmnitureMediaChangeCommand.prototype.execute = function(notification) {\n  this.proxy.mediaChange();\n};\n\n/** \n * The ComscorePlugin class.\n *   \n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction ComscorePlugin() {\n  ComscorePlugin.__super__.constructor.call(this);\n}\n\n\n__extends(ComscorePlugin, Plugin);\n\n\nComscorePlugin.prototype.moduleName = \"comscore\";\n\n/** @override\n*/\nComscorePlugin.prototype.createController = function() {\n  ComscorePlugin.__super__.createController.call(this);\n  this.registerCommand(Notifications.STARTED, ComscoreStartCommand);\n  this.registerCommand(Notifications.CONTENT_CHANGED, ComscoreStartCommand);\n  this.registerCommand(AdNotifications.AD_STARTED, ComscoreAdStartCommand);\n};\n\n/** @override\n*/\nComscorePlugin.prototype.createModel = function() {\n  this.registerProxy(new ComscoreProxy(this.config));\n};\n\n/** @override\n*/\nComscorePlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.STARTED, AdNotifications.AD_STARTED, Notifications.CONTENT_CHANGED];\n};\n\n\nAMP.registerPlugin(\"comscore\", \"html\", ComscorePlugin);\nAMP.registerPlugin(\"comscore\", \"flash\", ComscoreWrapper);\n\n/** \n * @constructor\n * @private\n*/\nfunction InfoWrapper(player, config) {\n  if (config == null) {\n    config = {};\n  }\n  InfoWrapper.__super__.constructor.call(this, player, config);\n}\n\n\n__extends(InfoWrapper, PluginWrapper);\n\n\nInfoWrapper.NAME = \"InfoWrapper\";\n\n/** @override\n*/\nInfoWrapper.prototype.listNotificationInterests = function() {\n  return [FlashNotifications.CREATE_FLASH_VARS, FlashNotifications.CREATE_XML, FlashNotifications.SHARE, FlashNotifications.SHARE_REQUEST];\n};\n\n/**\n*/\nInfoWrapper.prototype.handleNotification = function(notification) {\n  var application, body, data, element, elements, flashvars, info, name, property, provider, text, type, view, xml, _i, _len;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case FlashNotifications.CREATE_FLASH_VARS:\n      flashvars = body.flashvars;\n      break;\n    case FlashNotifications.CREATE_XML:\n      xml = body.xml;\n      application = xml.firstChild;\n      view = xml.getElementsByTagName(\"view\")[0];\n      elements = xml.getElementsByTagName(\"element\");\n      for (_i = 0, _len = elements.length; _i < _len; _i++) {\n        element = elements[_i];\n        if (!(element.getAttribute(\"id\") === \"infoOverlayAdvanced\")) {\n          continue;\n        }\n        info = element;\n        break;\n      }\n      if (!(view != null)) {\n        return;\n      }\n      if (!(info != null)) {\n        info = xml.createElement(\"element\");\n        info.setAttribute(\"id\", \"infoOverlayAdvanced\");\n        info.setAttribute(\"displayStates\", \"preplay,paused,ns,fs,mouseover\");\n        view.insertBefore(info, view.childNodes[0]);\n      }\n      data = xml.createElement(\"data\");\n      info.appendChild(data);\n      if (this.config.title != null) {\n        property = xml.createElement(\"property\");\n        property.setAttribute(\"key\", \"title\");\n        text = XMLUtils.createTextContent(xml, this.config.title);\n        property.appendChild(text);\n        data.appendChild(property);\n      }\n      if (this.config.description != null) {\n        property = xml.createElement(\"property\");\n        property.setAttribute(\"key\", \"description\");\n        text = XMLUtils.createTextContent(xml, this.config.description);\n        property.appendChild(text);\n        data.appendChild(property);\n      }\n      if (this.config.more != null) {\n        property = xml.createElement(\"property\");\n        property.setAttribute(\"key\", \"more\");\n        text = XMLUtils.createTextContent(xml, this.config.more);\n        property.appendChild(text);\n        data.appendChild(property);\n      }\n      if (this.config.less != null) {\n        property = xml.createElement(\"property\");\n        property.setAttribute(\"key\", \"less\");\n        text = XMLUtils.createTextContent(xml, this.config.less);\n        property.appendChild(text);\n        data.appendChild(property);\n      }\n      if (this.config.provider != null) {\n        provider = xml.createElement(\"property\");\n        provider.setAttribute(\"key\", \"provider\");\n        data.appendChild(provider);\n        if (this.config.provider.name != null) {\n          property = xml.createElement(\"property\");\n          property.setAttribute(\"key\", \"name\");\n          text = XMLUtils.createTextContent(xml, this.config.provider.name);\n          property.appendChild(text);\n          provider.appendChild(property);\n        }\n        if (this.config.provider.image != null) {\n          property = xml.createElement(\"property\");\n          property.setAttribute(\"key\", \"image\");\n          text = XMLUtils.createTextContent(xml, this.config.provider.image);\n          property.appendChild(text);\n          provider.appendChild(property);\n        }\n      }\n      break;\n    case FlashNotifications.SHARE:\n    case FlashNotifications.SHARE_REQUEST:\n      type = \"share\";\n  }\n  if (type != null) {\n    return this.dispatchEvent(new Event(type, body));\n  }\n};\n\n\nAMP.registerPlugin(\"info\", \"flash\", InfoWrapper);\n\n/**\n * The InfoMediator class.\n * \n * @constructor\n * @private\n * @extends {PluginMediator}\n*/\nfunction InfoMediator() {\n  InfoMediator.__super__.constructor.call(this);\n}\n\n\n__extends(InfoMediator, PluginMediator);\n\n\nInfoMediator.prototype.componentName = \"info\";\n\nInfoMediator.prototype.title = null;\n\nInfoMediator.prototype.shortDescription = null;\n\nInfoMediator.prototype.icon = null;\n\nInfoMediator.prototype.provider = null;\n\n/**\n * @override\n*/\nInfoMediator.prototype.onRegister = function() {\n  InfoMediator.__super__.onRegister.call(this);\n  this.title = this.create(\"info-title\");\n  this.provider = this.create(\"info-provider\");\n  this.shortDescription = this.create(\"info-short-description\");\n  this.icon = this.create(\"info-icon\", this, \"img\");\n  this.dataChangedHandler();\n};\n\n/**\n * @override\n*/\nInfoMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.MEDIA_CHANGE];\n};\n\n/**\n * @override\n*/\nInfoMediator.prototype.handleNotification = function(notification) {\n  var body, name;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.MEDIA_CHANGE:\n      this.dataChangedHandler();\n  }\n};\n\nInfoMediator.prototype.moreClicked = function(event) {\n  return this.classList.add(\"open\");\n};\n\nInfoMediator.prototype.closeClicked = function(event) {\n  return this.classList.remove(\"open\");\n};\n\nInfoMediator.prototype.dataChangedHandler = function() {\n  var styles, _ref;\n  if (this.plugin.value.title != null) {\n    this.title.textContent = this.plugin.value.title;\n  }\n  if (((_ref = this.plugin.value.provider) != null ? _ref.image : void 0) != null) {\n    this.icon.src = this.plugin.value.provider.image;\n  }\n  styles = getComputedStyle(this.title);\n  if (this.title.clientHeight > parseInt(styles.lineHeight)) {\n    this.classList.add(\"info-small\");\n    this.shortDescription.innerHTML = this.provider.innerHTML = \"\";\n    return;\n  } else {\n    this.classList.remove(\"info-small\");\n  }\n  this.truncateDescription(this.plugin.value.description, this.plugin.value.more);\n  this.provider.textContent = this.plugin.value.provider.name != null ? \"\" + this.plugin.value.provider.name : \"\";\n};\n\nInfoMediator.prototype.truncateDescription = function(desc) {\n  var character, ellp, index, text, tf, _i, _len;\n  ellp = \"...\";\n  text = \"\";\n  tf = this.shortDescription;\n  tf.textContent = \"\";\n  if (!(desc != null)) {\n    return;\n  }\n  for (index = _i = 0, _len = desc.length; _i < _len; index = ++_i) {\n    character = desc[index];\n    tf.textContent = text + character + ellp;\n    if (tf.scrollHeight > tf.clientHeight) {\n      tf.textContent = text + ellp;\n      break;\n    } else {\n      text += character;\n    }\n  }\n};\n\n/**\n * The InfoProxy class.\n *\n * @constructor\n * @private\n * @extends {DataBoundConfigurationProxy}\n * @param {Object} data\n*/\nfunction InfoProxy(data) {\n  InfoProxy.__super__.constructor.call(this, data);\n}\n\n\n__extends(InfoProxy, DataBoundConfigurationProxy);\n\n\nInfoProxy.prototype.configurationName = \"info\";\n\n/** @static\n*/\nInfoProxy.NAME = ModuleProxy.NAME;\n\nInfoProxy.prototype.defaults = {\n  title: '#{media.title}',\n  description: '#{media.description}',\n  provider: {},\n  more: \"read more\",\n  less: \"less\"\n};\n\n/** \n * The AdContentStartedCommand class.\n *   \n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdContentStartedCommand() {\n  AdContentStartedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdContentStartedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAdContentStartedCommand.prototype.execute = function(notification) {\n  this.proxy.contentStarted();\n};\n\n/** \n * The AdContentEndedCommand class.\n *   \n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdContentEndedCommand() {\n  AdContentEndedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdContentEndedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAdContentEndedCommand.prototype.execute = function(notification) {\n  this.proxy.contentEnded();\n};\n\n/** \n * The AdMediaChangeCommand class.\n *   \n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdMediaChangeCommand() {\n  AdMediaChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdMediaChangeCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAdMediaChangeCommand.prototype.execute = function(notification) {\n  if (this.proxy.getEnabled() === false) {\n    return;\n  }\n  this.proxy.mediaChanging = true;\n  this.proxy.engage(notification.getBody());\n};\n\n/** \n * The AdLoadedCommand class.\n *   \n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdLoadedCommand() {\n  AdLoadedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdLoadedCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAdLoadedCommand.prototype.execute = function(notification) {\n  this.sendNotification(Notifications.UPDATE_DATA_BINDINGS, {\n    contexts: [this.proxy.getContextName()]\n  });\n  AdLoadedCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * The AdBreakStartCommand class.\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdBreakStartCommand() {\n  AdBreakStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdBreakStartCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdBreakStartCommand.prototype.execute = function(notification) {\n  AdBreakStartCommand.__super__.execute.call(this, notification);\n  this.proxy.breakStart();\n};\n\n/**\n * The AdBreakEndCommand class.\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdBreakEndCommand() {\n  AdBreakEndCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdBreakEndCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdBreakEndCommand.prototype.execute = function(notification) {\n  var rate, _ref;\n  AdBreakEndCommand.__super__.execute.call(this, notification);\n  this.proxy.breakEnd();\n  if (((_ref = notification.getBody()) != null ? _ref.partner : void 0) === \"ima\") {\n    rate = this.applicationState.getPlaybackRate();\n    this.facade.player.setPlaybackRate(rate);\n  }\n  if (this.applicationState.getEnded() && this.applicationState.getHasPostContent() === true) {\n    this.sendNotification(Notifications.MEDIA_SEQUENCE_ENDED);\n  }\n};\n\n/** \n * The AdSeekCommand class.\n *   \n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdSeekCommand() {\n  AdSeekCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdSeekCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAdSeekCommand.prototype.execute = function(notification) {\n  this.proxy.contentSeek(notification.getBody());\n};\n\n/** \n * The AdPlayCommand class.\n *   \n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdContainerCreatedCommand() {\n  AdContainerCreatedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdContainerCreatedCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAdContainerCreatedCommand.prototype.execute = function(notification) {\n  this.proxy.container = notification.getBody();\n  AdContainerCreatedCommand.__super__.execute.call(this, notification);\n};\n\n/** \n * The AdReplayCommand class.\n * \n * Added to address ad replay workflow FLASHPLR \n *   \n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdReplayCommand() {\n  AdReplayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdReplayCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAdReplayCommand.prototype.execute = function(notification) {\n  if (typeof this.proxy.replay === \"function\" && this.facade.player.getAutoplay() === false) {\n    this.proxy.replay();\n  }\n};\n\n/** \n * @constructor\n*/\nfunction AdVO(id, title, duration, position, type, partner, advertiser, companions, request, metadata, totalAds, time) {\n  this.id = id;\n  this.title = title;\n  this.duration = duration;\n  this.position = position;\n  this.type = type;\n  this.partner = partner;\n  this.advertiser = advertiser;\n  this.companions = companions;\n  this.request = request;\n  this.metadata = metadata;\n  this.totalAds = totalAds;\n  this.time = time;\n}\n\nAdVO.prototype.id = null;\n\nAdVO.prototype.title = null;\n\nAdVO.prototype.duration = NaN;\n\nAdVO.prototype.position = NaN;\n\nAdVO.prototype.totalAds = NaN;\n\nAdVO.prototype.type = null;\n\nAdVO.prototype.partner = null;\n\nAdVO.prototype.advertiser = null;\n\nAdVO.prototype.companions = null;\n\nAdVO.prototype.metadata = null;\n\nAdVO.prototype.request = null;\n\nAdVO.prototype.error = null;\n\nAdVO.prototype.time = null;\n\n/**\n * Create an AdRequest object.\n *\n * @constructor\n * @param {Object} request The partner specific ad request object\n * @param {string} partner The partner identifier. i.e. \"ima\" or \"freewheel\"\n * @param {Object} config The plugin's configuration object\n * @param {Object} params Additional parameters to send with the ad request\n*/\nfunction AdRequest(request, partner, config, params) {\n  var key, value;\n  this.request = request;\n  this.partner = partner;\n  this.config = config;\n  if (params != null) {\n    for (key in params) {\n      value = params[key];\n      this[key] = value;\n    }\n  }\n}\n\n/**\n * Create an AdRequest object.\n *\n * @param {Object} request The partner specific ad request object\n * @param {string} partner The partner identifier. i.e. \"ima\" or \"freewheel\"\n * @param {Object} config The plugin's configuration object\n * @param {Object} params Additional parameters to send with the ad request\n * @returns {AdRequest}\n*/\nAdRequest.create = function(request, partner, config, params) {\n  return new AdRequest(request, partner, config, params);\n};\n\nAdRequest.prototype.request = null;\n\nAdRequest.prototype.partner = null;\n\nAdRequest.prototype.config = null;\n\n/** \n * The AdStartCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.MacroCommand}\n*/\nfunction AdStartCommand() {\n  AdStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdStartCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAdStartCommand.prototype.execute = function(notification) {\n  this.sendNotification(Notifications.PLAY_REQUEST);\n  if (this.playback.initialized === false) {\n    this.player.sendNotification(Notifications.INITIALIZED);\n  }\n  this.proxy.start();\n  AdStartCommand.__super__.execute.call(this, notification);\n};\n\n/** \n * The AdPlayCommand class.\n *   \n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdPlayCommand() {\n  AdPlayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdPlayCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAdPlayCommand.prototype.execute = function(notification) {\n  if (this.applicationState.getLocked() === true) {\n    return;\n  }\n  this.sendNotification(Notifications.PLAY_REQUEST);\n  if (this.proxy.getStarted() === false) {\n    this.sendNotification(Notifications.START, true);\n    return;\n  }\n  this.proxy.play();\n  this.facade.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PLAYING);\n};\n\n/**\n * The AdPauseCommand class.\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdPauseCommand() {\n  AdPauseCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdPauseCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdPauseCommand.prototype.execute = function(notification) {\n  var duration, time, transform,\n    _this = this;\n  time = this.proxy.adVO.time;\n  duration = this.proxy.adVO.duration;\n  if (time === \"undefined\" || !time || time === duration) {\n    transform = {\n      transform: function(state) {\n        if (state === Notifications.PLAYING) {\n          setTimeout(function() {\n            _this.player.removeTransform(TransformType.PLAY_STATE, transform);\n            return _this.player.sendNotification(Notifications.PAUSE);\n          }, 300);\n          return state;\n        }\n      },\n      priority: 2\n    };\n    this.player.addTransform(TransformType.PLAY_STATE, transform);\n    return;\n  }\n  this.proxy.pause();\n  this.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PAUSED);\n};\n\n/** \n * The AdTogglePlayPauseCommand class.\n *   \n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdTogglePlayPauseCommand() {\n  AdTogglePlayPauseCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdTogglePlayPauseCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAdTogglePlayPauseCommand.prototype.execute = function(notification) {\n  var note;\n  if (this.proxy.getPaused() || this.proxy.getStarted() === false) {\n    note = Notifications.PLAY;\n  } else {\n    note = Notifications.PAUSE;\n  }\n  this.sendNotification(note, true);\n};\n\n/** \n * The AdVolumeChangeCommand class.\n *   \n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdVolumeChangeCommand() {\n  AdVolumeChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdVolumeChangeCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAdVolumeChangeCommand.prototype.execute = function(notification) {\n  this.proxy.setVolume(notification.getBody());\n  AdVolumeChangeCommand.__super__.execute.call(this, notification);\n};\n\n/** \n * The AdPlayStateChangeCommand class.\n *   \n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdPlayStateChangeCommand() {\n  AdPlayStateChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdPlayStateChangeCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAdPlayStateChangeCommand.prototype.execute = function(notification) {\n  if (notification.getBody().value === \"playing\") {\n    this.dispatchEvent(\"playing\", this.proxy.adVO);\n  }\n};\n\n/** \n * The OmniturePlugin class.\n *   \n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction OmniturePlugin() {\n  OmniturePlugin.__super__.constructor.call(this);\n}\n\n\n__extends(OmniturePlugin, Plugin);\n\n\nOmniturePlugin.prototype.moduleName = \"omniture\";\n\n/** @override\n*/\nOmniturePlugin.prototype.createController = function() {\n  this.registerCommand(Notifications.MEDIA_CHANGE, OmnitureMediaChangeCommand);\n  this.registerCommand(Notifications.ENDED, OmnitureEndedCommand);\n  this.registerCommand(Notifications.STARTED, OmnitureStartCommand);\n  this.registerCommand(Notifications.PLAY, OmniturePlayCommand);\n  this.registerCommand(Notifications.PAUSE, OmniturePauseCommand);\n  this.registerCommand(Notifications.SEEKING, OmnitureSeekingCommand);\n  this.registerCommand(Notifications.SEEKED, OmnitureSeekedCommand);\n  this.registerCommand(Notifications.CHANGE_CONTENT, OmnitureEndedCommand);\n  this.registerCommand(Notifications.CONTENT_CHANGED, OmnitureContentChangedCommand);\n  this.registerCommand(AdNotifications.AD_LOADED, OmnitureAdLoadedCommand);\n  this.registerCommand(AdNotifications.AD_STARTED, OmnitureAdStartedCommand);\n  this.registerCommand(AdNotifications.AD_PLAY, OmnitureAdPlayCommand);\n  this.registerCommand(AdNotifications.AD_PAUSE, OmnitureAdPauseCommand);\n  this.registerCommand(AdNotifications.AD_TIME_UPDATE, OmnitureAdTimeUpdateCommand);\n  this.registerCommand(AdNotifications.BREAK_END, OmnitureAdBreakEndCommand);\n};\n\n/** @override\n*/\nOmniturePlugin.prototype.createModel = function() {\n  var _ref;\n  if (((_ref = this.config.heartbeat) != null ? _ref.enabled : void 0) === true) {\n    this.registerProxy(new HeartbeatProxy(this.config));\n  } else {\n    this.registerProxy(new OmnitureProxy(this.config));\n  }\n};\n\n/**\n*/\nOmniturePlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.CHANGE_MEDIA, Notifications.MEDIA_CHANGE, Notifications.CHANGE_CONTENT, Notifications.CONTENT_CHANGED, Notifications.TIME_UPDATE, Notifications.ENDED, Notifications.STARTED, Notifications.PLAY, Notifications.PAUSE, Notifications.SEEKING, Notifications.SEEKED, AdNotifications.AD_LOADED, AdNotifications.AD_STARTED, AdNotifications.AD_PLAY, AdNotifications.AD_PAUSE, AdNotifications.AD_TIME_REMAINING, AdNotifications.BREAK_START, AdNotifications.BREAK_END];\n};\n\n\nAMP.registerPlugin(\"omniture\", \"html\", OmniturePlugin);\nAMP.registerPlugin(\"omniture\", \"flash\", OmnitureWrapper);\n\n/**\n * The AdProxy class.\n *\n * @constructor\n * @private\n * @extends {PluginProxy}\n * @param {Object} config\n * @implements {IDataBindingContext}\n*/\nfunction AdProxy(config) {\n  AdProxy.__super__.constructor.call(this, config);\n  this.pods = [];\n}\n\n\n__extends(AdProxy, PluginProxy);\n\n\n/** @static\n*/\nAdProxy.NAME = PluginProxy.NAME;\n\nAdProxy.prototype.inProgress = false;\n\nAdProxy.prototype.paused = false;\n\nAdProxy.prototype.started = false;\n\nAdProxy.prototype.adVO = null;\n\nAdProxy.prototype.contextName = \"ad\";\n\nAdProxy.prototype.container = null;\n\nAdProxy.prototype.partner = null;\n\nAdProxy.prototype.pods = null;\n\nAdProxy.prototype.mediaChanging = false;\n\nAdProxy.prototype.createDefaultAdVO = function() {\n  return new AdVO(null, null, null, null, null, this.partner, null, null, null, null, null);\n};\n\n/**\n * Gets the context data for this proxy.\n *\n * @returns {Object} The contenxt data for this proxy\n*/\nAdProxy.prototype.getContextData = function() {\n  return this.adVO || {};\n};\n\n/**\n*/\nAdProxy.prototype.setCompanions = function(value) {\n  this.adVO.companions = value;\n  this.sendNotification(AdNotifications.AD_COMPANION, this.adVO);\n  return value;\n};\n\nAdProxy.prototype.getCompanions = function() {\n  var _ref;\n  return (_ref = this.adVO) != null ? _ref.companions : void 0;\n};\n\n/**\n*/\nAdProxy.prototype.getInProgress = function() {\n  return this.inProgress;\n};\n\nAdProxy.prototype.setInProgress = function(value) {\n  this.inProgress = value;\n  return value;\n};\n\n/**\n*/\nAdProxy.prototype.getStarted = function() {\n  return this.started;\n};\n\n/**\n*/\nAdProxy.prototype.setStarted = function(value) {\n  this.started = value;\n  return value;\n};\n\n/**\n*/\nAdProxy.prototype.getPaused = function() {\n  return this.paused;\n};\n\nAdProxy.prototype.setPaused = function(value) {\n  this.paused = value;\n  return value;\n};\n\nAdProxy.prototype.setCues = function(value) {\n  var cue, cues, _i, _len;\n  cues = [];\n  for (_i = 0, _len = value.length; _i < _len; _i++) {\n    cue = value[_i];\n    cues.push({\n      startTime: cue,\n      endTime: cue\n    });\n  }\n  this.facade.player.mediaProxy.setCues(cues);\n  return value;\n};\n\n/**\n*/\nAdProxy.prototype.play = function() {\n  this.setPaused(false);\n  this.sendNotification(AdNotifications.AD_PLAY, this.adVO);\n};\n\n/**\n*/\nAdProxy.prototype.pause = function() {\n  this.setPaused(true);\n  this.sendNotification(AdNotifications.AD_PAUSE, this.adVO);\n};\n\n/**\n*/\nAdProxy.prototype.breakStart = function() {\n  this.setInProgress(true);\n};\n\n/**\n*/\nAdProxy.prototype.breakEnd = function() {\n  this.setInProgress(false);\n  this.reset();\n};\n\n/**\n*/\nAdProxy.prototype.error = function(err, breakEnd) {\n  var msg;\n  if (breakEnd == null) {\n    breakEnd = true;\n  }\n  msg = (typeof err.getMessage === \"function\" ? err.getMessage() : void 0) || err.message;\n  this.facade.logger.error(\"[AMP AD ERROR]\", \"\" + msg + \" Skipping ad content.\", err);\n  if (this.adVO == null) {\n    this.adVO = {};\n  }\n  this.adVO.error = err;\n  this.sendNotification(AdNotifications.AD_ERROR, this.adVO);\n  if (breakEnd === true) {\n    this.endBreak();\n  }\n};\n\n/**\n*/\nAdProxy.prototype.engage = function(media) {\n  if (this.getEnabled() === false) {\n    return;\n  }\n  this.setStarted(false);\n  if (this.getInProgress()) {\n    this.reset();\n    this.facade.player.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"ad-mode\");\n  }\n  this.engageAds();\n};\n\n/**\n*/\nAdProxy.prototype.engageAds = function() {\n  this.facade.player.removeCommand(Notifications.START);\n  this.facade.player.removeCommand(Notifications.PLAY);\n  this.facade.player.removeCommand(Notifications.PAUSE);\n  this.facade.player.removeCommand(Notifications.ENDED);\n  this.facade.player.removeCommand(UserNotifications.PLAY);\n  this.facade.player.removeCommand(UserNotifications.PAUSE);\n  this.facade.player.removeCommand(UserNotifications.TOGGLE_PLAY_PAUSE);\n  if (this.facade.isFullscreenDevice()) {\n    this.facade.player.removeCommand(Notifications.CHANGE_DURATION);\n  }\n  this.facade.removeCommand(Notifications.STARTED);\n  this.facade.removeCommand(Notifications.ENDED);\n  this.facade.registerCommand(Notifications.START, AdStartCommand);\n  this.facade.registerCommand(Notifications.PLAY, AdPlayCommand);\n  this.facade.registerCommand(Notifications.PAUSE, AdPauseCommand);\n  this.facade.registerCommand(UserNotifications.PLAY, AdPlayCommand);\n  this.facade.registerCommand(UserNotifications.PAUSE, AdPauseCommand);\n  this.facade.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, AdTogglePlayPauseCommand);\n  this.facade.registerCommand(Notifications.VOLUME_CHANGE, AdVolumeChangeCommand);\n  this.facade.registerCommand(Notifications.PLAY_STATE_CHANGE, AdPlayStateChangeCommand);\n};\n\n/**\n*/\nAdProxy.prototype.reset = function() {\n  this.facade.removeCommand(Notifications.START);\n  this.facade.removeCommand(Notifications.PLAY);\n  this.facade.removeCommand(Notifications.PAUSE);\n  this.facade.removeCommand(UserNotifications.PLAY);\n  this.facade.removeCommand(UserNotifications.PAUSE);\n  this.facade.removeCommand(UserNotifications.TOGGLE_PLAY_PAUSE);\n  this.facade.removeCommand(Notifications.VOLUME_CHANGE);\n  this.facade.removeCommand(Notifications.PLAY_STATE_CHANGE);\n  this.facade.player.registerCommand(Notifications.START, StartCommand);\n  this.facade.player.registerCommand(Notifications.PLAY, PlayCommand);\n  this.facade.player.registerCommand(Notifications.PAUSE, PauseCommand);\n  this.facade.player.registerCommand(Notifications.ENDED, EndedCommand);\n  this.facade.player.registerCommand(UserNotifications.PLAY, PlayCommand);\n  this.facade.player.registerCommand(UserNotifications.PAUSE, PauseCommand);\n  this.facade.player.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, TogglePlayPauseCommand);\n  if (this.facade.isFullscreenDevice()) {\n    this.facade.player.registerCommand(Notifications.CHANGE_DURATION, ChangeDurationCommand);\n  }\n  this.facade.registerCommand(Notifications.STARTED, AdContentStartedCommand);\n  this.facade.registerCommand(Notifications.ENDED, AdContentEndedCommand);\n};\n\n/**\n*/\nAdProxy.prototype.processAdRequest = function(value) {\n  var _this = this;\n  return this.facade.player.transform(TransformType.AD_REQUEST, value).then(function(result) {\n    return _this.facade.transform(TransformType.AD_REQUEST, result);\n  });\n};\n\n/**\n*/\nAdProxy.prototype.requestAd = function() {\n  this.sendNotification(AdNotifications.REQUEST, this.adVO);\n};\n\n/**\n*/\nAdProxy.prototype.getPodById = function(id) {\n  var pod, _i, _len, _ref;\n  _ref = this.pods;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    pod = _ref[_i];\n    if (pod.id === id) {\n      return pod;\n    }\n  }\n};\n\n/**\n*/\nAdProxy.prototype.setPodLocks = function(pods) {\n  var pod, _i, _len, _ref;\n  for (_i = 0, _len = pods.length; _i < _len; _i++) {\n    pod = pods[_i];\n    if ((_ref = this.getPodById(pod.id)) != null) {\n      _ref.locked = pod.locked;\n    }\n  }\n};\n\n/**\n*/\nAdProxy.prototype.resize = function(state) {};\n\n/**\n*/\nAdProxy.prototype.startBreak = function(adVO) {\n  if (adVO != null) {\n    this.adVO = adVO;\n  }\n  this.setStarted(true);\n  this.sendNotification(AdNotifications.BREAK_START, this.adVO);\n  if (this.getEnabled() === false) {\n    this.endBreak();\n    return false;\n  }\n  return true;\n};\n\n/**\n*/\nAdProxy.prototype.endBreak = function() {\n  this.sendNotification(AdNotifications.BREAK_END, this.adVO);\n};\n\n/**\n*/\nAdProxy.prototype.start = function() {\n  this.mediaChanging = false;\n  this.startBreak();\n};\n\n/**\n*/\nAdProxy.prototype.contentPlay = function() {\n  this.facade.player.sendNotification(Notifications.PLAY, true);\n};\n\n/**\n*/\nAdProxy.prototype.contentPause = function() {\n  var video,\n    _this = this;\n  video = this.facade.player.mediaElement;\n  if (video.seeking === true) {\n    video.once(\"seeked\", function() {\n      video.pause();\n    });\n  } else {\n    video.pause();\n  }\n};\n\n/**\n*/\nAdProxy.prototype.contentStarted = function() {};\n\n/**\n*/\nAdProxy.prototype.contentSeek = function(time) {};\n\n/**\n*/\nAdProxy.prototype.contentEnded = function() {};\n\n/**\n*/\nAdProxy.prototype.setVolume = function(value) {};\n\n/**\n*/\nAdProxy.prototype.getVolume = function() {};\n\n/**\n*/\nAdProxy.prototype.terminateAd = function() {};\n\n/**\n*/\nAdProxy.prototype.terminateAllAds = function() {};\n\n/** \n * The InfoPlugin class.\n *   \n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction InfoPlugin() {\n  InfoPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(InfoPlugin, Plugin);\n\n\nInfoPlugin.prototype.moduleName = \"info\";\n\n/** @override\n*/\nInfoPlugin.prototype.createModel = function() {\n  this.registerProxy(new InfoProxy(this.config));\n};\n\n/** @override\n*/\n/** @override\n*/\nInfoPlugin.prototype.createView = function() {\n  this.registerMediator(new InfoMediator());\n};\n\n/** @override\n*/\nInfoPlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.MEDIA_CHANGE];\n};\n\n\nAMP.registerPlugin(\"info\", \"html\", InfoPlugin);\nAMP.registerPlugin(\"info\", \"external\", InfoPlugin);\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar FlashAdNotifications = {\n  BREAK_START: \"adComponentBreakInitiated\",\n  BREAK_END: \"adComponentBreakComplete\",\n  BREAK_SKIPPED: \"adComponentBreakSkipped\",\n  AD_LOADED: \"adComponentLoaded\",\n  AD_STARTED: \"adComponentAdBegin\",\n  AD_TIME_UPDATE: \"adComponentPlaybackProgress\",\n  AD_TIME_REMAINING: \"adComponentTimeElapsed\",\n  AD_DURATION_CHANGE: \"addurationchange\",\n  AD_ENDED: \"adComponentImpressionEnd\",\n  COMPLETE: \"adComponentAdComplete\",\n  AD_ERROR: \"adComponentInitFailed\",\n  AD_PLAY: \"adComponentPlaybackResumed\",\n  AD_PAUSE: \"adComponentPlaybackPaused\",\n  AD_LOG: \"adComponentLog\",\n  AD_COMPANION: \"adComponentCompanion\",\n  AD_PLAYBACK_FAILED: \"adComponentPlaybackFailed\",\n  AD_PLAYBACK_TERMINATED: \"adComponentPlaybackTerminated\",\n  AD_MEDIA_LOADED: \"adComponentMediaLoaded\",\n  AD_CLICKED: \"adComponentClicked\",\n  AD_FIRST_QUARTILE: \"adComponentFirstQuartile\",\n  AD_MIDPOINT: \"adComponentMidpoint\",\n  AD_THIRD_QUARTILE: \"adComponentThirdQuartile\",\n  AD_REQUEST: \"adComponentAdsRequest\",\n  AD_REQUEST_COMPLETE: \"adComponentAdsRequestComplete\",\n  AD_SKIPPED: \"adComponentAdSkipped\",\n  AD_IMPRESSION: \"adComponentImpression\"\n};\n\n/**\n * Used to trigger overlay ads for Google IMA\n *\n * @constructor\n * @private\n*/\nfunction IMAOverlayProxy(config) {\n  IMAOverlayProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(IMAOverlayProxy, DataBoundConfigurationProxy);\n\n\nIMAOverlayProxy.prototype.configurationName = \"imaoverlay\";\n\n/** @static\n*/\nIMAOverlayProxy.NAME = \"IMAOveralyProxy\";\n\nIMAOverlayProxy.prototype.defaults = {\n  adTagUrl: null,\n  duration: 15,\n  interval: 30,\n  delay: 30\n};\n\nIMAOverlayProxy.prototype.durationTimer = null;\n\nIMAOverlayProxy.prototype.intervalTimer = null;\n\nIMAOverlayProxy.prototype.delayTimer = null;\n\n/** Stops polling and clears the ad\n*/\nIMAOverlayProxy.prototype.stop = function() {\n  clearTimeout(this.durationTimer);\n  clearTimeout(this.delayTimer);\n  clearTimeout(this.intervalTimer);\n};\n\n/** Starts polling and load the first ad\n*/\nIMAOverlayProxy.prototype.play = function() {\n  var _this = this;\n  this.stop();\n  this.delayTimer = setTimeout(function() {\n    return _this.requestAd();\n  }, this.value.delay * 1000);\n};\n\n/** Retrieves an ad image from VAST XML\n*/\nIMAOverlayProxy.prototype.requestAd = function() {\n  var adTagUrl;\n  adTagUrl = this.getValue(\"adTagUrl\");\n  if (adTagUrl != null) {\n    adTagUrl = adTagUrl.replace(\"[timestamp]\", new Date().getTime());\n    adTagUrl = adTagUrl.replace(\"__random-number__\", new Date().getTime());\n  }\n  Utils.request({\n    url: adTagUrl,\n    withCredentials: true\n  }).then(this.vastLoadHandler.bind(this))[\"catch\"](this.error.bind(this));\n};\n\nIMAOverlayProxy.prototype.vastLoadHandler = function(xhr) {\n  var ad, clickThroughHref, creativeView, img, impression, xml;\n  xml = xhr.target.responseXML;\n  if (xml != null) {\n    try {\n      ad = xml.querySelector(\"NonLinear\");\n      if (ad != null) {\n        impression = xml.querySelector(\"Impression\") != null ? xml.querySelector(\"Impression\").textContent : \"\";\n        creativeView = xml.querySelector(\"Tracking[event=creativeView]\") != null ? xml.querySelector(\"Tracking[event=creativeView]\").textContent : \"\";\n        clickThroughHref = ad.querySelector(\"NonLinearClickThrough\") != null ? ad.querySelector(\"NonLinearClickThrough\").textContent : \"\";\n        img = {\n          src: ad.querySelector(\"StaticResource\").textContent,\n          width: ad.getAttribute(\"width\"),\n          height: ad.getAttribute(\"height\"),\n          tracking: [impression, creativeView],\n          href: clickThroughHref\n        };\n        this.displayAd(img);\n      } else {\n        this.error(\"No overlay was returned\");\n      }\n    } catch (error) {\n      this.error(error);\n    }\n  }\n};\n\nIMAOverlayProxy.prototype.error = function(error) {\n  this.facade.logger.error(\"[AMP IMA OVERLAY ERROR]\", error);\n  this.stop();\n};\n\n/** Notifies the application that a new overlay is ready to display\n*/\nIMAOverlayProxy.prototype.displayAd = function(ad) {\n  var _this = this;\n  this.sendNotification(IMANotifications.ADD_OVERLAY, ad);\n  this.durationTimer = setTimeout(function() {\n    _this.sendNotification(IMANotifications.REMOVE_OVERLAY);\n    return _this.intervalTimer = setTimeout(function() {\n      return _this.requestAd();\n    }, _this.value.interval * 1000);\n  }, this.value.duration * 1000);\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar IMANotifications = {\n  INITIALIZED: \"ima/initialize\",\n  ADD_OVERLAY: \"ima/addOverlay\",\n  REMOVE_OVERLAY: \"ima/removeOverlay\"\n};\n\n/**\n * The IMAProxy class.\n *\n * @constructor\n * @private\n * @extends {AdProxy}\n * @param {Object} config\n*/\nfunction IMAProxy(config) {\n  IMAProxy.__super__.constructor.call(this, config);\n  this.intervals = [];\n  this.loadedmetadata = this.onLoadedMetadata.bind(this);\n  this.adVO = this.createDefaultAdVO();\n}\n\n\n__extends(IMAProxy, AdProxy);\n\n\n/** @static\n*/\nIMAProxy.NAME = AdProxy.NAME;\n\nIMAProxy.prototype.defaults = {\n  adTagUrl: null,\n  overlay: null,\n  width: null,\n  height: null,\n  maxBitrate: -1,\n  ppid: null,\n  companions: null,\n  logEventsEnabled: false\n};\n\nIMAProxy.prototype.partner = \"ima\";\n\nIMAProxy.prototype.key = \"ima\";\n\nIMAProxy.prototype.intervals = null;\n\nIMAProxy.prototype.adDisplayContainer = null;\n\nIMAProxy.prototype.adDisplayContainerInitialized = false;\n\nIMAProxy.prototype.adsLoader = null;\n\nIMAProxy.prototype.adsRenderingSettings = null;\n\nIMAProxy.prototype.adsManagerLoaded = false;\n\nIMAProxy.prototype.adsManager = null;\n\nIMAProxy.prototype.cuepoints = null;\n\nIMAProxy.prototype.adLoaded = false;\n\nIMAProxy.prototype.playWhenLoaded = false;\n\nIMAProxy.prototype.contentHasEnded = false;\n\nIMAProxy.prototype.adTagUrl = null;\n\nIMAProxy.prototype.viewMode = null;\n\nIMAProxy.prototype.playbackCore = null;\n\nIMAProxy.prototype.loadedmetadata = null;\n\n/**\n*/\nIMAProxy.prototype.setEnabled = function(value) {\n  var _ref;\n  IMAProxy.__super__.setEnabled.call(this, value);\n  if (value === false) {\n    if ((_ref = this.adsManager) != null) {\n      if (typeof _ref.destroy === \"function\") {\n        _ref.destroy();\n      }\n    }\n    if (this.getInProgress()) {\n      this.contentPlay();\n    }\n  }\n  return value;\n};\n\n/** @override\n*/\nIMAProxy.prototype.onLoadedMetadata = function(event) {\n  if (this.canPlay() && this.playWhenLoaded === true) {\n    this.startAd();\n  }\n};\n\n/** @override\n*/\nIMAProxy.prototype.initialize = function() {};\n\n/** @override\n*/\nIMAProxy.prototype.ready = function() {\n  var isAndroidChrome, mode, userAgentMatch, _ref;\n  this.viewMode = google.ima.ViewMode.NORMAL;\n  window.addEventListener(\"resize\", this.resize.bind(this));\n  if (this.config.vpaidAllowed != null) {\n    google.ima.settings.setVpaidAllowed(this.config.vpaidAllowed);\n  }\n  if ((this.config.vpaidMode != null) && ((mode = google.ima.ImaSdkSettings.VpaidMode[this.config.vpaidMode.toUpperCase()]) != null)) {\n    google.ima.settings.setVpaidMode(mode);\n  }\n  if (this.config.disableFlashAds != null) {\n    google.ima.settings.setDisableFlashAds(this.config.disableFlashAds);\n  }\n  this.adDisplayContainer = this.createPlugin();\n  this.adsLoader = new google.ima.AdsLoader(this.adDisplayContainer);\n  userAgentMatch = navigator.userAgent.match(/Chrom(e|ium)\\/([0-9]+)\\./);\n  isAndroidChrome = userAgentMatch ? parseInt(userAgentMatch[2], 10) > 52 : false;\n  if ((((_ref = Utils.getIOSversion()) != null ? _ref[0] : void 0) >= 10 || isAndroidChrome) && this.facade.player.getConfig().playsinline !== false) {\n    google.ima.settings.setDisableCustomPlaybackForIOS10Plus(true);\n  }\n  this.adsRenderingSettings = new google.ima.AdsRenderingSettings();\n  this.adsLoader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, this.onAdsManagerLoaded.bind(this), false);\n  this.adsLoader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError.bind(this), false);\n};\n\n/** @override\n*/\nIMAProxy.prototype.createPlugin = function() {\n  return new google.ima.AdDisplayContainer(this.getContainer());\n};\n\n/** @override\n*/\nIMAProxy.prototype.engage = function(override) {\n  var _ref, _ref1;\n  if (override == null) {\n    override = true;\n  }\n  if (this.getEnabled() === false) {\n    return;\n  }\n  IMAProxy.__super__.engage.call(this);\n  if (this.adsManagerLoaded === true && this.contentHasEnded === false || this.contentHasEnded === true && ((_ref = this.adVO) != null ? _ref.type : void 0) === \"postroll\") {\n    if ((_ref1 = this.adsManager) != null) {\n      if (typeof _ref1.destroy === \"function\") {\n        _ref1.destroy();\n      }\n    }\n  }\n  this.adsManagerLoaded = false;\n  this.contentHasEnded = false;\n  this.adsManagerLoaded = false;\n  this.playWhenLoaded = false;\n};\n\n/**\n*/\nIMAProxy.prototype.setVolume = function(value) {\n  var _ref;\n  if ((_ref = this.adsManager) != null) {\n    _ref.setVolume(value);\n  }\n  return value;\n};\n\n/**\n*/\nIMAProxy.prototype.getVolume = function() {\n  var _ref;\n  return (_ref = this.adsManager) != null ? _ref.getVolume() : void 0;\n};\n\n/** @override\n*/\nIMAProxy.prototype.requestAd = function() {\n  var adsRequest, dimensions, height, settings, width, _ref, _ref1,\n    _this = this;\n  IMAProxy.__super__.requestAd.call(this);\n  dimensions = this.getDimensions();\n  width = dimensions.clientWidth;\n  height = dimensions.clientHeight;\n  adsRequest = new google.ima.AdsRequest();\n  this.adTagUrl = this.getValue(\"adTagUrl\");\n  if (typeof this.adTagUrl === \"object\") {\n    this.adTagUrl = this.buildAdTagUrl(this.adTagUrl);\n  }\n  adsRequest.adTagUrl = this.adTagUrl;\n  if (!(adsRequest.adsResponse != null) && !(adsRequest.adTagUrl != null)) {\n    this.onAdError(\"No valid adTagUrl or adsResponse provided.\");\n    return;\n  }\n  adsRequest.linearAdSlotWidth = width;\n  adsRequest.linearAdSlotHeight = height;\n  adsRequest.nonLinearAdSlotWidth = ((_ref = this.value.overlay) != null ? _ref.width : void 0) || width;\n  adsRequest.nonLinearAdSlotHeight = ((_ref1 = this.value.overlay) != null ? _ref1.height : void 0) || height;\n  settings = this.adsLoader.getSettings();\n  if (this.config.ppid != null) {\n    settings.setPpid(this.getValue(\"ppid\"));\n  }\n  Promise.resolve(AdRequest.create(adsRequest, \"ima\", this.getData(), {\n    loader: this.adsLoader\n  })).then(function(ad) {\n    var adsResponse;\n    adsResponse = _this.getValue(\"adsResponse\");\n    if ((adsResponse != null) && adsResponse !== \"\") {\n      return Utils.requestText(adsResponse).then(function(text) {\n        ad.request.adsResponse = text;\n        return ad;\n      });\n    } else {\n      return ad;\n    }\n  }).then(this.processAdRequest.bind(this)).then(function(result) {\n    return _this.adsLoader.requestAds(result.request);\n  });\n};\n\n/** @override\n*/\nIMAProxy.prototype.requestOverlay = function() {\n  var adsRequest, overlay;\n  overlay = this.value.overlay;\n  if (!(overlay != null)) {\n    return;\n  }\n  adsRequest = new google.ima.AdsRequest();\n  adsRequest.adTagUrl = overlay.adTagUrl;\n  adsRequest.nonLinearAdSlotWidth = overlay.width || 300;\n  adsRequest.nonLinearAdSlotHeight = overlay.height || 50;\n  this.adsLoader.requestAds(adsRequest);\n};\n\n/** @override\n*/\nIMAProxy.prototype.start = function(load) {\n  var video;\n  if (load == null) {\n    load = true;\n  }\n  if (load === true) {\n    this.playbackCore = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore();\n    video = this.getMediaElement();\n    video.once(\"loadedmetadata\", this.loadedmetadata);\n    this.playbackCore.setEnabled(false);\n    if (this.facade.isFullscreenDevice()) {\n      this.playbackCore.load();\n    } else {\n      video.load();\n    }\n  } else {\n    this.engage();\n  }\n  if (IMAProxy.__super__.start.call(this) === false) {\n    return false;\n  }\n  this.isLiveMidroll = (load === false) && (this.facade.player.retrieveProxy(MediaProxy.NAME).getTemporalType() === \"live\");\n  if (this.adDisplayContainerInitialized !== true) {\n    this.adDisplayContainer.initialize();\n    this.adDisplayContainerInitialized = true;\n  }\n  if (this.canPlay() === true && load === true) {\n    this.startAd();\n  } else {\n    this.playWhenLoaded = true;\n    this.requestAd();\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.canPlay = function() {\n  return this.adsManagerLoaded === true;\n};\n\n/**\n*/\nIMAProxy.prototype.startAd = function() {\n  this.playWhenLoaded = false;\n  try {\n    if (this.viewMode == null) {\n      this.viewMode = google.ima.ViewMode.NORMAL;\n    }\n    this.adsManager.init(this.facade.player.getViewComponent().clientWidth, this.facade.player.getViewComponent().clientHeight, this.viewMode);\n    this.adsManager.start();\n  } catch (adError) {\n    this.error(adError);\n  }\n};\n\nIMAProxy.prototype.resize = function(state, dimensions) {\n  var _ref;\n  if (dimensions == null) {\n    dimensions = this.getDimensions();\n  }\n  if ((this.dimensions != null) && this.dimensions.width === dimensions.width && this.dimensions.height === dimensions.height) {\n    return;\n  }\n  this.dimensions = dimensions;\n  if (state != null) {\n    this.viewMode = state === DisplayState.FULL_SCREEN ? google.ima.ViewMode.FULLSCREEN : google.ima.ViewMode.NORMAL;\n  }\n  if ((_ref = this.adsManager) != null) {\n    _ref.resize(this.dimensions.width, this.dimensions.height, this.viewMode);\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.onAdsManagerLoaded = function(adsManagerLoadedEvent) {\n  var adEventHandler, _ref;\n  this.adsRenderingSettings.bitrate = this.getValue(\"maxBitrate\");\n  this.adsRenderingSettings.autoAlign = true;\n  this.adsRenderingSettings.useStyledNonLinearAds = true;\n  if ((_ref = this.adsManager) != null) {\n    if (typeof _ref.destroy === \"function\") {\n      _ref.destroy();\n    }\n  }\n  this.adsManager = adsManagerLoadedEvent.getAdsManager(this.facade.player.mediaElement, this.adsRenderingSettings);\n  this.sendNotification(AdNotifications.AD_MANAGER_LOADED, {\n    \"adManager\": this.adsManager,\n    \"viewMode\": google.ima.ViewMode.NORMAL,\n    \"adContainer\": this.getContainer()\n  });\n  this.adsManagerLoaded = true;\n  this.cuePoints = this.adsManager.getCuePoints();\n  this.setCues(this.cuePoints);\n  if (this.cuePoints.indexOf(-1) !== -1) {\n    this.sendNotification(Notifications.HAS_POST_CONTENT, true);\n  }\n  adEventHandler = this.onAdEvent.bind(this);\n  this.adsManager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError.bind(this));\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, this.contentPause.bind(this));\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, this.contentPlay.bind(this));\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.ALL_ADS_COMPLETED, adEventHandler);\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.LOADED, adEventHandler);\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.STARTED, adEventHandler);\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.RESUMED, this.onAdResumed.bind(this));\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.PAUSED, this.onAdPaused.bind(this));\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.COMPLETE, adEventHandler);\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.CLICK, this.onAdClick.bind(this));\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.IMPRESSION, adEventHandler);\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.FIRST_QUARTILE, adEventHandler);\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.MIDPOINT, adEventHandler);\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.THIRD_QUARTILE, adEventHandler);\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.SKIPPED, adEventHandler);\n  this.adsManager.addEventListener(google.ima.AdEvent.Type.LOG, adEventHandler);\n  this.sendNotification(AdNotifications.REQUEST_COMPLETE, {\n    pods: this.cuePoints\n  });\n  this.sendNotification(AdNotifications.RESPONSE, {\n    pods: this.cuePoints,\n    response: adsManagerLoadedEvent,\n    adsManager: this.adsManager\n  });\n  if (this.canPlay() && this.playWhenLoaded === true) {\n    this.startAd();\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.onAdClick = function(adEvent) {\n  if ((adEvent != null ? adEvent.getAd().isLinear() : void 0) === false) {\n    this.facade.player.sendNotification(Notifications.PAUSE);\n    return;\n  }\n  if (!this.getPaused()) {\n    this.pause();\n  }\n  this.sendNotification(AdNotifications.AD_CLICKED, this.adVO);\n};\n\n/**\n*/\nIMAProxy.prototype.onAdPaused = function(adEvent) {\n  this.setPaused(true);\n  this.facade.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PAUSED);\n  this.facade.player.sendNotification(Notifications.CHANGE_ACTIVE_STATE, ActiveState.ACTIVE);\n  this.facade.player.sendNotification(AdNotifications.AD_PAUSED, this.adVO);\n};\n\n/**\n*/\nIMAProxy.prototype.onAdResumed = function(adEvent) {\n  this.setPaused(false);\n  this.facade.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PLAYING);\n};\n\n/**\n*/\nIMAProxy.prototype.onAdEvent = function(adEvent) {\n  var ad, companion, companions, config, pos, type, _i, _len, _ref, _ref1;\n  ad = adEvent.getAd();\n  if (this.adVO != null) {\n    if (ad != null) {\n      ad.wrapperAdIds = typeof ad.getWrapperAdIds === \"function\" ? ad.getWrapperAdIds() : void 0;\n      ad.wrapperAdSystems = typeof ad.getWrapperAdSystems === \"function\" ? ad.getWrapperAdSystems() : void 0;\n    }\n    this.adVO.metadata = ad;\n  }\n  switch (adEvent.type) {\n    case google.ima.AdEvent.Type.IMPRESSION:\n      this.sendNotification(AdNotifications.IMPRESSION, this.adVO);\n      break;\n    case google.ima.AdEvent.Type.LOADED:\n      if (ad.isLinear()) {\n        this.facade.player.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"ad-overlaymode\");\n        pos = ad.getAdPodInfo().getPodIndex();\n        type = pos === 0 ? \"preroll\" : pos === -1 ? \"postroll\" : \"midroll\";\n        this.adVO = new AdVO(ad.getAdId(), ad.getAdId(), ad.getDuration(), pos, type, \"ima\", null, null, this.adTagUrl, ad, ad.getAdPodInfo().getTotalAds(), ad.getDuration() - this.adsManager.getRemainingTime());\n        if (!this.getInProgress() && type === \"midroll\" || type === \"postroll\") {\n          this.startBreak();\n          this.engageAds();\n        }\n        this.resize();\n        this.sendNotification(AdNotifications.AD_LOADED, this.adVO);\n        this.sendNotification(AdNotifications.AD_DURATION_CHANGE, this.adVO);\n        this.setVolume(this.facade.player.retrieveProxy(ApplicationStateProxy.NAME).getVolume());\n      } else {\n        this.facade.player.sendNotification(Notifications.ADD_APPLICATION_STATE, \"ad-overlaymode\");\n        this.contentPlay();\n      }\n      break;\n    case google.ima.AdEvent.Type.STARTED:\n      if (ad.isLinear()) {\n        this.adVO.position = ad.getAdPodInfo().getAdPosition();\n        this.sendNotification(AdNotifications.AD_STARTED, this.adVO);\n        this.intervals.push(setInterval(this.onAdTimeUpdate.bind(this), 67));\n        this.facade.player.sendNotification(Notifications.CHANGE_PLAY_STATE, PlayState.PLAYING);\n        this.sendNotification(AdNotifications.AD_PLAY, this.adVO);\n      }\n      try {\n        companions = [];\n        config = (typeof this.getConfigurationData === \"function\" ? (_ref = this.getConfigurationData()) != null ? _ref.companions : void 0 : void 0) || [];\n        for (_i = 0, _len = config.length; _i < _len; _i++) {\n          companion = config[_i];\n          companions = companions.concat(ad.getCompanionAds(companion.width, companion.height));\n        }\n        if ((companions != null ? companions.length : void 0) > 0) {\n          this.setCompanions(companions);\n        }\n      } catch (error) {\n        this.facade.logger.error(\"[AMP IMA ERROR]\", \"Could not retrieve companion ads:\", error);\n      }\n      break;\n    case google.ima.AdEvent.Type.COMPLETE:\n      if (ad.isLinear()) {\n        this.sendNotification(AdNotifications.AD_ENDED, this.adVO);\n      }\n      break;\n    case google.ima.AdEvent.Type.FIRST_QUARTILE:\n      this.sendNotification(AdNotifications.FIRST_QUARTILE, this.adVO);\n      break;\n    case google.ima.AdEvent.Type.MIDPOINT:\n      this.sendNotification(AdNotifications.MIDPOINT, this.adVO);\n      break;\n    case google.ima.AdEvent.Type.THIRD_QUARTILE:\n      this.sendNotification(AdNotifications.THIRD_QUARTILE, this.adVO);\n      break;\n    case google.ima.AdEvent.Type.LOG:\n      if (this.facade.player.retrieveProxy(ApplicationStateProxy.NAME).getEnded() === true && (((_ref1 = adEvent.getAdData()) != null ? _ref1.adError : void 0) != null)) {\n        this.forceBreakEnd = true;\n      }\n      if (this.getValue(\"logEventsEnabled\") === true) {\n        this.sendNotification(AdNotifications.LOG, this.adVO);\n      }\n      break;\n    case google.ima.AdEvent.Type.SKIPPED:\n      this.sendNotification(AdNotifications.SKIPPED, this.adVO);\n      break;\n    case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:\n      if (this.getInProgress() === true || this.forceBreakEnd === true) {\n        this.forceBreakEnd = false;\n        this.endBreak();\n      }\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.getContainer = function() {\n  var _ref, _ref1;\n  return ((_ref = this.facade.player.ui) != null ? (_ref1 = _ref.ads) != null ? _ref1.container : void 0 : void 0) || this.facade.player.container;\n};\n\n/**\n*/\nIMAProxy.prototype.getDimensions = function() {\n  var container;\n  container = this.getContainer();\n  return {\n    width: container.clientWidth,\n    height: container.clientHeight\n  };\n};\n\n/**\n*/\nIMAProxy.prototype.onAdTimeUpdate = function(adEvent) {\n  var remaining, time;\n  this.resize();\n  remaining = Utils.clamp(this.adsManager.getRemainingTime(), 0, this.adVO.duration);\n  time = this.adVO.duration - remaining;\n  this.adVO.time = time;\n  this.sendNotification(AdNotifications.AD_TIME_UPDATE, time);\n  this.sendNotification(AdNotifications.AD_TIME_REMAINING, remaining);\n};\n\n/**\n*/\nIMAProxy.prototype.onAdError = function(adErrorEvent) {\n  var error;\n  error = (adErrorEvent != null ? typeof adErrorEvent.getError === \"function\" ? adErrorEvent.getError() : void 0 : void 0) || adErrorEvent;\n  this.error(error);\n  this.contentPlay();\n};\n\n/**\n*/\nIMAProxy.prototype.play = function() {\n  var _ref;\n  IMAProxy.__super__.play.call(this);\n  try {\n    if ((_ref = this.adsManager) != null) {\n      _ref.resume();\n    }\n    this.sendNotification(AdNotifications.AD_RESUME);\n  } catch (error) {\n    this.facade.logger.error(\"[AMP IMA ERROR]\", \"resume\", error);\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.pause = function() {\n  IMAProxy.__super__.pause.call(this);\n  if (this.adsManager != null) {\n    try {\n      this.adsManager.pause();\n    } catch (error) {\n      this.facade.logger.error(\"[AMP IMA ERROR]\", \"pause\", error);\n    }\n  } else {\n    this.playWhenLoaded = false;\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.clearIntervals = function() {\n  var interval, _i, _len, _ref;\n  _ref = this.intervals;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    interval = _ref[_i];\n    clearInterval(this.intervals.pop());\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.breakEnd = function() {\n  var overlayProxy;\n  this.clearIntervals();\n  IMAProxy.__super__.breakEnd.call(this);\n  overlayProxy = this.facade.retrieveProxy(IMAOverlayProxy.NAME);\n  if (overlayProxy != null) {\n    overlayProxy.play();\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.setCompanions = function(value) {\n  var companion, companions, _i, _len, _ref;\n  companions = [];\n  for (_i = 0, _len = value.length; _i < _len; _i++) {\n    companion = value[_i];\n    companions.push({\n      data: companion.getContent(),\n      type: (_ref = companion.getContentType()) != null ? _ref.toLowerCase() : void 0,\n      width: companion.getWidth(),\n      height: companion.getHeight(),\n      metadata: companion\n    });\n  }\n  IMAProxy.__super__.setCompanions.call(this, companions);\n  return value;\n};\n\n/**\n*/\nIMAProxy.prototype.contentPause = function() {\n  var events,\n    _this = this;\n  events = [\"pause\", \"waiting\", \"playing\", \"ended\", \"durationchange\", \"error\"];\n  if (this.facade.player.retrieveProxy(ApplicationStateProxy.NAME).getSeeking() === false) {\n    events.push(\"seeked\");\n  } else {\n    this.getMediaElement().once(\"seeked\", function() {\n      _this.sendNotification(Notifications.DISABLE_VIDEO_EVENTS, [\"seeked\"]);\n    });\n  }\n  this.sendNotification(Notifications.DISABLE_VIDEO_EVENTS, events);\n  if (this.isLiveMidroll === true) {\n    this.getMediaElement().volume = 0;\n    return;\n  }\n  IMAProxy.__super__.contentPause.call(this);\n};\n\n/**\n*/\nIMAProxy.prototype.contentPlay = function() {\n  var _ref, _ref1;\n  if (this.getInProgress() === true) {\n    this.endBreak();\n  }\n  this.sendNotification(Notifications.ENABLE_VIDEO_EVENTS, [\"pause\", \"seeked\", \"waiting\", \"playing\", \"ended\", \"durationchange\", \"error\"]);\n  if (((_ref = this.adVO) != null ? _ref.type : void 0) === \"postroll\") {\n    return;\n  }\n  if (this.isLiveMidroll === true) {\n    this.getMediaElement().volume = this.facade.player.retrieveProxy(ApplicationStateProxy.NAME).getVolume();\n    if (Utils.getDevice() === \"ipad\") {\n      this.getMediaElement().load();\n    } else {\n      return;\n    }\n  }\n  IMAProxy.__super__.contentPlay.call(this);\n  if (((_ref1 = this.adVO) != null ? _ref1.type : void 0) === \"midroll\" && Utils.getDevice() === \"desktop\") {\n    this.facade.player.setCurrentTime(Math.floor(this.facade.player.getCurrentTime()));\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.contentEnded = function() {\n  var _ref;\n  this.contentHasEnded = true;\n  try {\n    if ((_ref = this.adsLoader) != null) {\n      if (typeof _ref.contentComplete === \"function\") {\n        _ref.contentComplete();\n      }\n    }\n  } catch (error) {\n    this.facade.logger.error(\"[AMP IMA ERROR]\", \"contentComplete\", error);\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.terminateAd = function() {\n  var _ref;\n  try {\n    if ((_ref = this.adsManager) != null) {\n      _ref.stop();\n    }\n  } catch (error) {\n    this.facade.logger.error(\"[AMP IMA ERROR]\", \"terminateAd\", error);\n  }\n  if (this.adVO.type === \"postrol\") {\n    this.sendNotification(Notifications.HAS_POST_CONTENT, false);\n  }\n  this.endBreak();\n  this.contentPlay();\n};\n\n/**\n*/\nIMAProxy.prototype.terminateAllAds = function() {\n  var _ref;\n  try {\n    if ((_ref = this.adsManager) != null) {\n      _ref.destroy();\n    }\n  } catch (error) {\n    this.facade.logger.error(\"[AMP IMA ERROR]\", \"terminateAllAds\", error);\n  }\n  this.sendNotification(Notifications.HAS_POST_CONTENT, false);\n  this.endBreak();\n  this.contentPlay();\n};\n\n/**\n*/\nIMAProxy.prototype.destroy = function() {\n  var _ref;\n  this.clearIntervals();\n  if ((_ref = this.adsManager) != null) {\n    if (typeof _ref.destroy === \"function\") {\n      _ref.destroy();\n    }\n  }\n};\n\n/**\n*/\nIMAProxy.prototype.buildAdTagUrl = function(adTagObj) {\n  var adTagUrl;\n  adTagUrl = adTagObj.base || \"//pubads.g.doubleclick.net/gampad/ads\";\n  adTagUrl += \"?\" + this.encodeAdTagParams(adTagObj.params);\n  return adTagUrl;\n};\n\n/**\n*/\nIMAProxy.prototype.encodeAdTagParams = function(params) {\n  var adTagParams, key, value;\n  adTagParams = [];\n  for (key in params) {\n    value = params[key];\n    if (typeof value === \"object\") {\n      value = encodeURIComponent(this.encodeAdTagParams(value));\n    }\n    adTagParams.push(\"\" + key + \"=\" + value);\n  }\n  return adTagParams.join(\"&\");\n};\n\n/**\n * The IMAAddOverlayCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction IMAAddOverlayCommand() {\n  IMAAddOverlayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(IMAAddOverlayCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nIMAAddOverlayCommand.prototype.execute = function(notification) {\n  this.facade.sendNotification(Notifications.ADD_APPLICATION_STATE, \"ad-overlay-mode\");\n};\n\n/**\n * The IMARemoveOverlayCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction IMARemoveOverlayCommand() {\n  IMARemoveOverlayCommand.__super__.constructor.call(this);\n}\n\n\n__extends(IMARemoveOverlayCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nIMARemoveOverlayCommand.prototype.execute = function(notification) {\n  var proxy;\n  proxy = this.facade.retrieveProxy(IMAOverlayProxy.NAME);\n  proxy.stop();\n  this.facade.player.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"ad-overlay-mode\");\n};\n\n/**\n * The IMAOverlayMediator class.\n * \n * @constructor\n * @private\n * @extends {OverlayMediator}\n * @param {Object} viewComponent\n*/\nfunction IMAOverlayMediator() {\n  IMAOverlayMediator.__super__.constructor.call(this);\n}\n\n\n__extends(IMAOverlayMediator, OverlayMediator);\n\n\nIMAOverlayMediator.prototype.componentName = \"ad-overlay\";\n\nIMAOverlayMediator.prototype.anchor = null;\n\nIMAOverlayMediator.prototype.image = null;\n\nIMAOverlayMediator.prototype.tracker = null;\n\nIMAOverlayMediator.prototype.tracker2 = null;\n\nIMAOverlayMediator.prototype.closeButton = null;\n\nIMAOverlayMediator.prototype.closeText = null;\n\n/**\n * @override\n*/\nIMAOverlayMediator.prototype.onRegister = function() {\n  var _this = this;\n  IMAOverlayMediator.__super__.onRegister.call(this);\n  this.anchor = this.create(\"ad-overlay-anchor\");\n  this.anchor.target = \"_blank\";\n  this.image = this.create(\"ad-overlay-img\", this.anchor, \"img\");\n  this.tracker = this.create();\n  this.tracker.width = 0;\n  this.tracker.height = 0;\n  this.tracker2 = this.create(null, this, \"img\");\n  this.tracker2.width = 0;\n  this.tracker2.height = 0;\n  this.closeButton = this.create(\"ad-close-button\", this.anchor);\n  this.closeButton.onclick = function(event) {\n    event.stopImmediatePropagation();\n    _this.sendNotification(IMANotifications.REMOVE_OVERLAY);\n    return false;\n  };\n  this.closeText = this.createText(\"ad-close-text\", \"x\", this.closeButton);\n};\n\n/**\n * @override\n*/\nIMAOverlayMediator.prototype.listNotificationInterests = function() {\n  return [IMANotifications.ADD_OVERLAY, IMANotifications.REMOVE_OVERLAY];\n};\n\n/**\n * @override\n*/\nIMAOverlayMediator.prototype.handleNotification = function(notification) {\n  var ad;\n  switch (notification.getName()) {\n    case IMANotifications.ADD_OVERLAY:\n      ad = notification.getBody();\n      this.image.src = ad.src;\n      this.anchor.href = ad.href;\n      this.tracker.src = ad.tracking[0];\n      this.tracker2.src = ad.tracking[1];\n  }\n};\n\n/**\n * The IMAReadyCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction IMAReadyCommand() {\n  IMAReadyCommand.__super__.constructor.call(this);\n}\n\n\n__extends(IMAReadyCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nIMAReadyCommand.prototype.execute = function(notification) {\n  this.facade.retrieveProxy(IMAProxy.NAME).ready();\n};\n\n/**\n * The IMADisplayStateChangeCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction IMADisplayStateChangeCommand() {\n  IMADisplayStateChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(IMADisplayStateChangeCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nIMADisplayStateChangeCommand.prototype.execute = function(notification) {\n  this.facade.retrieveProxy(IMAProxy.NAME).resize(notification.getBody());\n};\n\n/**\n * The IMAActiveStateChangeCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction IMAActiveStateChangeCommand() {\n  IMAActiveStateChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(IMAActiveStateChangeCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nIMAActiveStateChangeCommand.prototype.execute = function(notification) {\n  this.facade.retrieveProxy(IMAProxy.NAME).resize(notification.getBody());\n};\n\n/**\n * The IMAFullscreenProxy class.\n *\n * @constructor\n * @private\n * @extends {IMAProxy}\n * @param   {Object}    config  The configuration object.\n*/\nfunction IMAFullscreenProxy(config) {\n  IMAFullscreenProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(IMAFullscreenProxy, IMAProxy);\n\n\n/** @static\n*/\nIMAFullscreenProxy.NAME = IMAProxy.NAME;\n\n/**\n*/\nIMAFullscreenProxy.prototype.createPlugin = function() {\n  var container, _ref, _ref1;\n  container = this.facade.player.ui.ads.container;\n  if (Utils.isIPhone() && (((_ref = Utils.getIOSversion()) != null ? _ref[0] : void 0) < 10)) {\n    return new google.ima.AdDisplayContainer(container, this.facade.player.getMediaElement(), container);\n  }\n  if (((_ref1 = Utils.getIOSversion()) != null ? _ref1[0] : void 0) >= 10) {\n    this.facade.player.getMediaElement().playsInline = this.facade.player.getConfig().playsinline != null ? this.facade.player.getConfig().playsinline : true;\n  }\n  return new google.ima.AdDisplayContainer(container, this.facade.player.getMediaElement());\n};\n\n/** @override\n*/\nIMAFullscreenProxy.prototype.engage = function(media) {\n  IMAFullscreenProxy.__super__.engage.call(this, media);\n  this.sendNotification(Notifications.DISABLE_VIDEO_EVENTS, [\"paused\", \"ended\", \"durationchange\", \"error\"]);\n};\n\n/** @override\n*/\nIMAFullscreenProxy.prototype.reset = function(media) {\n  IMAFullscreenProxy.__super__.reset.call(this, media);\n  this.sendNotification(Notifications.ENABLE_VIDEO_EVENTS, [\"paused\", \"ended\", \"durationchange\", \"error\"]);\n};\n\n/** @override\n*/\nIMAFullscreenProxy.prototype.breakStart = function() {\n  this.playbackCore = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore();\n  this.playbackCore.setEnabled(false);\n  this.setInProgress(true);\n};\n\n/** @override\n*/\nIMAFullscreenProxy.prototype.breakEnd = function() {\n  IMAFullscreenProxy.__super__.breakEnd.call(this);\n  this.playbackCore.setEnabled(true);\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction AdWrapper(player, init) {\n  AdWrapper.__super__.constructor.call(this, player, init);\n  Object.defineProperties(this, {\n    enabled: {\n      get: this.getEnabled,\n      set: this.setEnabled,\n      enumerable: true,\n      configurable: false\n    },\n    inProgress: {\n      get: this.getInProgress,\n      enumerable: true,\n      configurable: false\n    },\n    started: {\n      get: this.getStarted,\n      enumerable: true,\n      configurable: false\n    },\n    paused: {\n      get: this.getPaused,\n      enumerable: true,\n      configurable: false\n    },\n    companions: {\n      get: this.getCompanions,\n      enumerable: true,\n      configurable: false\n    },\n    currentAd: {\n      get: this.getCurrentAd,\n      enumerable: true,\n      configurable: false\n    }\n  });\n}\n\n\n__extends(AdWrapper, PluginWrapper);\n\n\nAdWrapper.NAME = \"AdWrapper\";\n\nAdWrapper.prototype.enabled = true;\n\nAdWrapper.prototype.paused = false;\n\nAdWrapper.prototype.started = false;\n\nAdWrapper.prototype.adVO = null;\n\nAdWrapper.prototype.partner = null;\n\n/**\n*/\nAdWrapper.prototype.getFeatureName = function() {\n  return \"ads\";\n};\n\nAdWrapper.prototype.getInProgress = function() {\n  return this.player.mediaElement.getPlayerProperty(\"adInProgress\");\n};\n\nAdWrapper.prototype.getStarted = function() {\n  return this.started;\n};\n\nAdWrapper.prototype.getPaused = function() {\n  return this.paused;\n};\n\nAdWrapper.prototype.getCompanions = function() {\n  var _ref;\n  return (_ref = this.adVO) != null ? _ref.companions : void 0;\n};\n\nAdWrapper.prototype.setEnabled = function(value) {\n  this.enabled = value;\n  this.player.mediaElement.setPlayerProperty(\"adsEnabled\", value);\n  return value;\n};\n\nAdWrapper.prototype.getEnabled = function() {\n  return this.enabled;\n};\n\nAdWrapper.prototype.getCurrentAd = function() {\n  return this.adVO;\n};\n\nAdWrapper.prototype.enable = function() {\n  this.setEnabled(true);\n};\n\nAdWrapper.prototype.disable = function() {\n  this.setEnabled(false);\n};\n\n/**\n*/\nAdWrapper.prototype.createFlashVars = function(flashvars) {\n  flashvars.core_ads_enabled = true;\n  return flashvars;\n};\n\n/**\n*/\nAdWrapper.prototype.listNotificationInterests = function() {\n  var key, value;\n  return AdWrapper.__super__.listNotificationInterests.call(this).concat((function() {\n    var _results;\n    _results = [];\n    for (key in FlashAdNotifications) {\n      value = FlashAdNotifications[key];\n      _results.push(value);\n    }\n    return _results;\n  })());\n};\n\n/** @override\n*/\nAdWrapper.prototype.handleNotification = function(notification) {\n  var body, cuepoints, cues, event, name, pods, remaining, scene, target, type, _i, _len, _ref,\n    _this = this;\n  AdWrapper.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  this.adVO = this.createAdVO(body);\n  target = this;\n  switch (name) {\n    case FlashAdNotifications.BREAK_START:\n      type = AdNotifications.BREAK_START;\n      this.facade.setPlayState(\"playing\");\n      if (((_ref = body.cuePoints) != null ? _ref.length : void 0) > 0) {\n        cuepoints = body.cuePoints.map(function(cue) {\n          var start;\n          start = !isNaN(cue.sceneStartSeconds) ? cue.sceneStartSeconds : cue.sceneEndSeconds;\n          return {\n            startTime: start,\n            endTime: cue.sceneEndSeconds\n          };\n        });\n        this.facade.setCues(cuepoints);\n      }\n      break;\n    case FlashAdNotifications.BREAK_END:\n      type = AdNotifications.BREAK_END;\n      break;\n    case FlashAdNotifications.BREAK_SKIPPED:\n      type = AdNotifications.BREAK_SKIPPED;\n      break;\n    case FlashAdNotifications.AD_MEDIA_LOADED:\n      type = AdNotifications.AD_LOADED;\n      this.start = false;\n      target.dispatchEvent(new Event(AdNotifications.AD_DURATION_CHANGE.replace(/^ads/, \"\"), this.adVO));\n      break;\n    case FlashAdNotifications.AD_STARTED:\n      type = AdNotifications.AD_STARTED;\n      this.started = true;\n      this.sendNotification(Notifications.ADD_APPLICATION_STATE, \"ad-mode\");\n      break;\n    case FlashAdNotifications.AD_TIME_UPDATE:\n      type = AdNotifications.AD_TIME_UPDATE;\n      remaining = body.duration - body.currentTime;\n      target.dispatchEvent(new Event(AdNotifications.AD_TIME_REMAINING.replace(/^ads/, \"\"), remaining));\n      body = body.currentTime;\n      break;\n    case FlashAdNotifications.AD_TIME_REMAINING:\n      type = AdNotifications.AD_TIME_REMAINING;\n      body = body.timeElapsed;\n      break;\n    case FlashAdNotifications.AD_ERROR:\n    case FlashAdNotifications.AD_PLAYBACK_FAILED:\n      type = AdNotifications.AD_ERROR;\n      this.start = false;\n      this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"ad-mode\");\n      break;\n    case FlashAdNotifications.COMPLETE:\n      type = AdNotifications.COMPLETE;\n      break;\n    case FlashAdNotifications.AD_ENDED:\n    case FlashAdNotifications.AD_PLAYBACK_TERMINATED:\n      type = AdNotifications.AD_ENDED;\n      this.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"ad-mode\");\n      break;\n    case FlashAdNotifications.AD_CLICKED:\n      type = AdNotifications.AD_CLICKED;\n      break;\n    case FlashAdNotifications.AD_COMPANION:\n      type = AdNotifications.AD_COMPANION;\n      if ((this.adVO != null) && (body != null)) {\n        this.adVO.companions = body;\n      }\n      break;\n    case FlashAdNotifications.AD_PAUSE:\n      type = AdNotifications.AD_PAUSE;\n      target = this.player;\n      this.paused = true;\n      this.player.setPlayState(\"paused\");\n      break;\n    case FlashAdNotifications.AD_PLAY:\n      type = AdNotifications.AD_PLAY;\n      this.paused = false;\n      this.player.setPlayState(\"playing\");\n      break;\n    case FlashAdNotifications.AD_LOG:\n      type = AdNotifications.AD_LOG;\n      break;\n    case FlashAdNotifications.AD_FIRST_QUARTILE:\n      type = AdNotifications.FIRST_QUARTILE;\n      break;\n    case FlashAdNotifications.AD_MIDPOINT:\n      type = AdNotifications.MIDPOINT;\n      break;\n    case FlashAdNotifications.AD_THIRD_QUARTILE:\n      type = AdNotifications.THIRD_QUARTILE;\n      break;\n    case FlashAdNotifications.AD_REQUEST:\n      type = AdNotifications.REQUEST;\n      break;\n    case FlashAdNotifications.AD_REQUEST_COMPLETE:\n      type = AdNotifications.REQUEST_COMPLETE;\n      pods = [];\n      cues = body.cuePoints || [];\n      for (_i = 0, _len = cues.length; _i < _len; _i++) {\n        scene = cues[_i];\n        pods.push(new AdVO(scene.sceneId, scene.sceneTitle, scene.sceneDuration, scene.scenePodIndex, scene.scenePodPosition, this.partner, null, null, null, {}, scene.sceneSubCount, scene.sceneEndSeconds));\n      }\n      this.adVO = {\n        pods: pods\n      };\n      event = new Event(\"response\", this.adVO);\n      event.player = this.player;\n      target.dispatchEvent(event);\n      break;\n    case FlashAdNotifications.AD_SKIPPED:\n      type = AdNotifications.SKIPPED;\n      break;\n    case FlashAdNotifications.AD_IMPRESSION:\n      type = AdNotifications.IMPRESSION;\n  }\n  if (type != null) {\n    this.sendNotification(type, this.adVO);\n    if (type === AdNotifications.AD_TIME_REMAINING || type === AdNotifications.AD_TIME_UPDATE) {\n      event = new Event(type.replace(/^ads/, \"\"), body);\n    } else {\n      event = new Event(type.replace(/^ads/, \"\"), this.adVO);\n    }\n    event.player = this.player;\n    target.dispatchEvent(event);\n  }\n};\n\n/**\n*/\nAdWrapper.prototype.createAdVO = function(ad) {\n  if (!(ad != null)) {\n    return null;\n  }\n  return new AdVO(ad.id, ad.title, ad.duration, ad.adIndex, ad.podPosition, ad.adPlatform, null, null, ad.requestURL, ad.metadata, ad.totalAds, ad.currentTime);\n};\n\n/**\n * @expose\n*/\nAdWrapper.prototype.setPodLocks = function(pods) {\n  var pod, scenes, _i, _len;\n  scenes = [];\n  for (_i = 0, _len = pods.length; _i < _len; _i++) {\n    pod = pods[_i];\n    scenes.push({\n      sceneId: pod.id,\n      sceneLocked: pod.locked,\n      sceneTitle: pod.title,\n      sceneStartSeconds: pod.time,\n      sceneEndSeconds: pod.duration + pod.time,\n      scenePodIndex: pod.position,\n      scenePodPosition: pod.type\n    });\n  }\n  this.player.mediaElement.setAdPodLocks(scenes);\n};\n\n/**\n * @expose\n*/\nAdWrapper.prototype.terminateAd = function() {\n  this.player.mediaElement.terminateAd();\n};\n\n/**\n * @expose\n*/\nAdWrapper.prototype.terminateAllAds = function() {\n  this.player.mediaElement.terminateAllAds();\n};\n\n/**\n * @expose\n*/\nAdWrapper.prototype.requestAd = function() {\n  this.player.mediaElement.triggerAd();\n};\n\nfunction IMAWrapper() {\n  return IMAWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(IMAWrapper, AdWrapper);\n\n\nIMAWrapper.NAME = \"IMAWrapper\";\n\nIMAWrapper.prototype.partner = \"ima\";\n\nIMAWrapper.prototype.flashPlugins = [\n  {\n    id: \"GoogleIMAPlugin\",\n    src: '#{paths.resources}plugins/GoogleIMAPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"GoogleIMAPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }, {\n    id: \"IMAOverlayAdPlugin\",\n    src: '#{paths.resources}plugins/IMAOverlayAdPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"IMAOverlayAdPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }, {\n    id: \"AdOptionsPlugin\",\n    src: '#{paths.resources}plugins/AdOptionsPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"AdOptionsPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }\n];\n\n/**\n*/\nIMAWrapper.prototype.createXML = function(xml) {\n  var admedia, application, companion, companions, ids, overlay, prop, props, vendor, _i, _j, _k, _len, _len1, _len2, _ref;\n  application = xml.firstChild;\n  admedia = xml.getElementsByTagName(\"admedia\")[0];\n  if (!(admedia != null)) {\n    admedia = xml.createElement(\"admedia\");\n    application.appendChild(admedia);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"dfp\");\n  admedia.appendChild(vendor);\n  props = [\n    {\n      value: this.config.adTagUrl,\n      key: \"DFP_AD_TAG_URL\"\n    }, {\n      value: this.config.maxBitrate,\n      key: \"DFP_MAX_BITRATE\"\n    }, {\n      value: this.config.sceneMarkers,\n      key: \"displaySceneMarkers\"\n    }, {\n      value: this.config.ppid,\n      key: \"DFP_PPID\"\n    }\n  ];\n  for (_i = 0, _len = props.length; _i < _len; _i++) {\n    prop = props[_i];\n    if (prop.value != null) {\n      this.createProperty(xml, prop.key, prop.value, vendor);\n    }\n  }\n  if (this.config.position != null) {\n    vendor.setAttribute(\"position\", this.config.position);\n  }\n  if (this.config.params != null) {\n    if (this.config.params.adTag != null) {\n      this.createProperty(xml, \"DFP_AD_TAG_PARAMS\", this.config.params.adTag, vendor);\n    }\n    if (this.config.params.manual != null) {\n      this.createProperty(xml, \"DFP_MANUAL_PARAMS\", this.config.params.manual, vendor);\n    }\n  }\n  if (this.config.companions != null) {\n    companions = [];\n    ids = [];\n    _ref = this.config.companions;\n    for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {\n      companion = _ref[_j];\n      companions.push(companion.width + \"x\" + companion.height);\n      ids.push(companion.id);\n    }\n    this.createProperty(xml, \"DFP_SIZE\", companions.join(\",\"), vendor);\n    this.createProperty(xml, \"COMPANION_ID\", ids.join(\",\"), vendor);\n  }\n  if (this.config.disableCompanionAds != null) {\n    this.createProperty(xml, \"disableCompanionAds\", this.config.disableCompanionAds, vendor);\n  }\n  if (this.config.overlay != null) {\n    if (this.config.overlay.enabled === true) {\n      overlay = xml.createElement(\"overlay\");\n      admedia.appendChild(overlay);\n    }\n    props = [\n      {\n        value: \"dfp\",\n        key: \"OVERLAY_AD_PARTNER\"\n      }, {\n        value: this.config.overlay.adTagUrl,\n        key: \"OVERLAY_AD_BASE_URL\"\n      }, {\n        value: this.config.overlay.delay,\n        key: \"OVERLAY_AD_DELAY\"\n      }, {\n        value: this.config.overlay.interval,\n        key: \"OVERLAY_AD_INTERVAL\"\n      }, {\n        value: this.config.overlay.duration,\n        key: \"OVERLAY_AD_DURATION\"\n      }, {\n        value: \"\" + this.config.overlay.width + \"x\" + this.config.overlay.height,\n        key: \"OVERLAY_AD_SIZE\"\n      }\n    ];\n    for (_k = 0, _len2 = props.length; _k < _len2; _k++) {\n      prop = props[_k];\n      if (prop.value != null) {\n        this.createProperty(xml, prop.key, prop.value, overlay);\n      }\n    }\n  }\n  return xml;\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar StatsNotifications = {\n  VISIBILITY_CHANGE: \"statsvisibilitychange\",\n  BITRATES_UPDATE: \"bitratesUpdate\"\n};\n\n/**\n * The AdPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Feature}\n*/\nfunction AdPlugin() {\n  AdPlugin.__super__.constructor.call(this);\n  Object.defineProperties(this, {\n    enabled: {\n      get: this.getEnabled,\n      set: this.setEnabled,\n      enumerable: true,\n      configurable: false\n    },\n    inProgress: {\n      get: this.getInProgress,\n      enumerable: true,\n      configurable: false\n    },\n    started: {\n      get: this.getStarted,\n      enumerable: true,\n      configurable: false\n    },\n    paused: {\n      get: this.getPaused,\n      enumerable: true,\n      configurable: false\n    },\n    companions: {\n      get: this.getCompanions,\n      enumerable: true,\n      configurable: false\n    },\n    currentAd: {\n      get: this.getCurrentAd,\n      enumerable: true,\n      configurable: false\n    }\n  });\n}\n\n\n__extends(AdPlugin, Feature);\n\n\nAdPlugin.NAME = \"AdPlugin\";\n\nAdPlugin.prototype.container = null;\n\nAdPlugin.prototype.featureName = \"ads\";\n\n/** @override\n*/\nAdPlugin.prototype.createModel = function() {\n  this.proxy = this.isFullscreenDevice() ? this.createFullscreenProxy() : this.createProxy();\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nAdPlugin.prototype.createController = function() {\n  AdPlugin.__super__.createController.call(this);\n  this.registerCommand(Notifications.MEDIA_CHANGE, AdMediaChangeCommand);\n  this.registerCommand(AdNotifications.BREAK_START, AdBreakStartCommand);\n  this.registerCommand(AdNotifications.AD_LOADED, AdLoadedCommand);\n  this.registerCommand(AdNotifications.BREAK_END, AdBreakEndCommand);\n  this.registerCommand(UserNotifications.SEEKED, AdSeekCommand);\n  this.registerCommand(AdNotifications.AD_CONTAINER_CREATED, AdContainerCreatedCommand);\n  this.registerCommand(Notifications.REPLAY, AdReplayCommand);\n  this.registerCommand(AdNotifications.AD_STARTED, PluginEventCommand);\n  this.registerCommand(AdNotifications.SKIPPED, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_MANAGER_LOADED, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_TIME_UPDATE, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_TIME_REMAINING, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_DURATION_CHANGE, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_ENDED, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_ERROR, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_COMPANION, PluginEventCommand);\n  this.registerCommand(AdNotifications.FIRST_QUARTILE, PluginEventCommand);\n  this.registerCommand(AdNotifications.MIDPOINT, PluginEventCommand);\n  this.registerCommand(AdNotifications.THIRD_QUARTILE, PluginEventCommand);\n  this.registerCommand(AdNotifications.COMPLETE, PluginEventCommand);\n  this.registerCommand(AdNotifications.LOG, PluginEventCommand);\n  this.registerCommand(AdNotifications.REQUEST, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_RESUME, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_PLAY, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_PAUSE, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_PAUSED, PluginEventCommand);\n  this.registerCommand(AdNotifications.IMPRESSION, PluginEventCommand);\n  this.registerCommand(AdNotifications.AD_CLICKED, PluginEventCommand);\n  this.registerCommand(AdNotifications.REQUEST_COMPLETE, PluginEventCommand);\n  this.registerCommand(AdNotifications.RESPONSE, PluginEventCommand);\n  this.registerCommand(AdNotifications.BREAK_SKIPPED, PluginEventCommand);\n};\n\nAdPlugin.prototype.isFullscreenDevice = function() {\n  return Utils.isFullscreenDevice();\n};\n\nAdPlugin.prototype.createProxy = function() {};\n\nAdPlugin.prototype.createFullscreenProxy = function() {};\n\n/**\n*/\nAdPlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.MEDIA_CHANGE, Notifications.REPLAY, Notifications.PLAY, Notifications.PAUSE, Notifications.PAUSED, Notifications.START, Notifications.STARTED, Notifications.ENDED, Notifications.READY, Notifications.VOLUME_CHANGE, Notifications.FULL_SCREEN_CHANGE, Notifications.CHANGE_ACTIVE_STATE, Notifications.PLAY_STATE_CHANGE, UserNotifications.PLAY, UserNotifications.PAUSE, UserNotifications.SEEKED, UserNotifications.TOGGLE_PLAY_PAUSE];\n};\n\n/**\n*/\nAdPlugin.prototype.listNotificationPublications = function() {\n  var key, value;\n  return AdPlugin.__super__.listNotificationPublications.call(this).concat((function() {\n    var _results;\n    _results = [];\n    for (key in AdNotifications) {\n      value = AdNotifications[key];\n      _results.push(value);\n    }\n    return _results;\n  })()).concat([Notifications.PLAY_REQUEST, Notifications.UPDATE_DATA_BINDINGS, Notifications.DISPLAY_TIME, Notifications.DISABLE_FULL_SCREEN, Notifications.ENABLE_VIDEO_EVENTS, Notifications.DISABLE_VIDEO_EVENTS, Notifications.HAS_POST_CONTENT, Notifications.MEDIA_SEQUENCE_ENDED, Notifications.CHANGE_PLAY_STATE, Notifications.AUTOPLAY_BLOCKED]);\n};\n\n/**\n * @param {boolean} value The enabled flag.\n * @expose\n*/\nAdPlugin.prototype.setEnabled = function(value) {\n  this.proxy.setEnabled(value);\n};\n\n/**\n * @return {boolean} The enabled flag.\n * @expose\n*/\nAdPlugin.prototype.getEnabled = function() {\n  return this.proxy.getEnabled();\n};\n\n/**\n * @return {boolean} The in progress flag.\n * @expose\n*/\nAdPlugin.prototype.getInProgress = function() {\n  return this.proxy.getInProgress();\n};\n\n/**\n * @return {boolean} The started flag.\n * @expose\n*/\nAdPlugin.prototype.getStarted = function() {\n  return this.proxy.getStarted();\n};\n\n/**\n * @return {boolean} The paused flag.\n * @expose\n*/\nAdPlugin.prototype.getPaused = function() {\n  return this.proxy.getPaused();\n};\n\n/**\n * @return {Array.<Object>} The list of companion ads.\n * @expose\n*/\nAdPlugin.prototype.getCompanions = function() {\n  return this.proxy.getCompanions();\n};\n\n/**\n * @return {Array.<Object>} The list of companion ads.\n * @expose\n*/\nAdPlugin.prototype.getCurrentAd = function() {\n  return this.proxy.adVO;\n};\n\n/**\n * @expose\n*/\nAdPlugin.prototype.setPodLocks = function(pods) {\n  this.proxy.setPodLocks(pods);\n};\n\n/**\n * @expose\n*/\nAdPlugin.prototype.resize = function(state) {\n  this.proxy.resize(state);\n};\n\n/**\n * @expose\n*/\nAdPlugin.prototype.terminateAd = function() {\n  this.proxy.terminateAd();\n};\n\n/**\n * @expose\n*/\nAdPlugin.prototype.terminateAllAds = function() {\n  this.proxy.terminateAllAds();\n};\n\n/**\n * @expose\n*/\nAdPlugin.prototype.requestAd = function() {\n  this.proxy.start(false);\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction StatsProxy(config) {\n  StatsProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(StatsProxy, ModuleProxy);\n\n\n/** @static\n*/\nStatsProxy.NAME = ModuleProxy.NAME;\n\nStatsProxy.prototype.defaults = {\n  url: null\n};\n\nStatsProxy.prototype.hidden = true;\n\nStatsProxy.prototype.getURL = function() {\n  return this.data.url;\n};\n\nStatsProxy.prototype.setURL = function(value) {\n  return this.data.url = value;\n};\n\nStatsProxy.prototype.getHidden = function() {\n  return this.hidden;\n};\n\nStatsProxy.prototype.setHidden = function(value) {\n  return this.hidden = value;\n};\n\nStatsProxy.prototype.invoke = function() {\n  var _this = this;\n  if (this.data.url != null) {\n    return Utils.request(this.data.url).then(function(xhr) {\n      return _this.sendNotification(StatsNotifications.BITRATES_UPDATE, xhr.response);\n    })[\"catch\"](function(error) {\n      return _this.sendNotification(StatsNotifications.BITRATES_UPDATE, null);\n    });\n  }\n};\n\n/**\n * The StatsVisibilityChangeCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction StatsVisibilityChangeCommand() {\n  StatsVisibilityChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(StatsVisibilityChangeCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nStatsVisibilityChangeCommand.prototype.execute = function(notification) {\n  var statsProxy;\n  statsProxy = this.facade.retrieveProxy(StatsProxy.NAME);\n  statsProxy.setHidden(notification.getBody());\n  statsProxy.setURL(\"\" + (this.facade.player.getSrc()));\n  if (notification.getBody() === false) {\n    statsProxy.invoke();\n  }\n};\n\n/**\n * The StatsMediator class.\n * \n * @constructor\n * @private\n * @extends {PluginMediator}\n * @param {Object} viewComponent\n*/\nfunction StatsMediator() {\n  StatsMediator.__super__.constructor.call(this);\n}\n\n\n__extends(StatsMediator, PluginMediator);\n\n\n/**\n * Stats Mediator\n * \n * @static\n * @type {string}\n*/\nStatsMediator.prototype.componentName = \"stats\";\n\nStatsMediator.prototype.container = null;\n\nStatsMediator.prototype.statsText = null;\n\nStatsMediator.prototype.statsButton = null;\n\nStatsMediator.prototype.bitrateText = null;\n\nStatsMediator.prototype.bitrateArr = null;\n\n/**\n * @override\n*/\nStatsMediator.prototype.onRegister = function() {\n  var _this = this;\n  StatsMediator.__super__.onRegister.call(this);\n  this.sendNotification(Notifications.ADD_CONTROL_STATE, \"stats-enabled\");\n  this.classList.add(\"hidden\");\n  this.statsFormat = this.create(\"stats-text\");\n  this.statsQuality = this.create(\"stats-text\");\n  this.statsBitRate = this.create(\"stats-text\");\n  this.statsPlayBack = this.create(\"stats-text\");\n  this.statsAnalytics = this.create(\"stats-text\");\n  this.statsButton = this.create(\"stats-button\", false);\n  EventHandler.create(this.statsButton, EventHandler.CLICK, function(event) {\n    event.stopImmediatePropagation();\n    _this.sendNotification(StatsNotifications.VISIBILITY_CHANGE, !_this.facade.getHidden());\n    return false;\n  });\n  this.sendNotification(Notifications.ADD_CONTROL, this.statsButton);\n};\n\n/**\n * @override\n*/\nStatsMediator.prototype.listNotificationInterests = function() {\n  return [StatsNotifications.VISIBILITY_CHANGE, Notifications.PLAYING, Notifications.TIME_UPDATE];\n};\n\n/**\n * @override\n*/\nStatsMediator.prototype.handleNotification = function(notification) {\n  var body, levels, name;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case StatsNotifications.VISIBILITY_CHANGE:\n      if (this.plugin.getHidden()) {\n        this.classList.add(\"hidden\");\n      } else {\n        this.classList.remove(\"hidden\");\n        this.statsBitRate.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Adaptive Bitrate Renditions</b></p><p>Loading...</p>\";\n        this.renderStats();\n      }\n      break;\n    case Notifications.TIME_UPDATE:\n      this.renderQuality();\n      break;\n    case Notifications.PLAYING:\n      levels = this.facade.player.getQualityLevels();\n      if ((levels != null ? levels.length : void 0) > 0) {\n        this.constructBitrateText(levels);\n      } else {\n        this.statsBitRate.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Adaptive Bitrate Renditions</b></p><p>Not Available</p>\";\n      }\n  }\n};\n\n/*  Render Stats UI\n*/\nStatsMediator.prototype.renderQuality = function() {\n  var quality;\n  quality = this.facade.player.getQuality();\n  if (this.quality === quality) {\n    return;\n  }\n  this.statsQuality.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Quality</b></p><p>\" + this.createBitrateText(this.facade.player.getQualityLevels()[quality], quality) + \"</p>\";\n};\n\n/*  Render Stats UI\n*/\nStatsMediator.prototype.renderStats = function() {\n  var analyticsVal, device, formatVal, isDash, playbackVal, player, urlVal, _ref;\n  try {\n    player = this.facade.player;\n    formatVal = player.getMedia() === void 0 ? \"Not Available\" : player.getMedia().type;\n    urlVal = player.getSrc() === \"\" || player.getSrc() === null ? \"Not Available\" : player.getSrc();\n    device = Utils.getDevice();\n    if (device == null) {\n      device = \"\";\n    }\n    playbackVal = this.facade.player.getConfig().mode !== \"\" && this.facade.player.getConfig().mode !== null && this.facade.player.getConfig().mode.indexOf(\"html\") !== -1 ? this.facade.player.getVersion() + \", HTML5 Video: \" + device : \"Not Available\";\n    isDash = (_ref = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore()) != null ? _ref.proxyName.indexOf(\"dash\") : void 0;\n    if (isDash > -1) {\n      playbackVal += \", dash.js\";\n    }\n    analyticsVal = this.facade.player.getConfig().mediaanalytics === void 0 || this.facade.player.getConfig().mediaanalytics.config === \"\" || this.facade.player.getConfig().mediaanalytics.config === null ? \"Not Available\" : this.facade.player.getConfig().mediaanalytics.config;\n    this.statsFormat.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Stream</b></p><p>Format: \" + formatVal + \"</p><p>URL: \" + urlVal + \"</p>\";\n    this.statsPlayBack.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Playback</b></p>\" + playbackVal;\n    this.statsAnalytics.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Analytics</b></p>\" + analyticsVal;\n  } catch (error) {\n    this.facade.logger.error(\"[AMP Stats Render Error]:\", error);\n  }\n};\n\n/*  Format Bitrate HTML Text\n*/\nStatsMediator.prototype.constructBitrateText = function(bitrateArr) {\n  var index, item, _i, _len, _ref;\n  this.bitrateArr = bitrateArr;\n  this.bitrateText = '';\n  this.bitrateArr.sort(function(a, b) {\n    var aBitrate, bBitrate;\n    aBitrate = parseInt(a.bitrate);\n    bBitrate = parseInt(b.bitrate);\n    if (aBitrate < bBitrate) {\n      return -1;\n    } else if (aBitrate > bBitrate) {\n      return 1;\n    } else {\n      return 0;\n    }\n  });\n  _ref = this.bitrateArr;\n  for (index = _i = 0, _len = _ref.length; _i < _len; index = ++_i) {\n    item = _ref[index];\n    this.bitrateText += this.createBitrateText(item, index);\n  }\n  if (this.bitrateText === \"\") {\n    this.bitrateText = \"<p>Not Available</p>\";\n  }\n  this.statsBitRate.innerHTML = \"<p><b class='\" + this.classList.prefix + \"stats-header'>Adaptive Bitrate Renditions</b></p>\" + this.bitrateText;\n};\n\n/**\n*/\nStatsMediator.prototype.createBitrateText = function(item, index) {\n  return \"<p>\" + (index + 1) + \". \" + ((item.bitrate / 1000).toFixed(0)) + \" kbps \" + item.width + \"x\" + item.height + \"</p>\";\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar AISNotifications = {\n  START_AUTHENTICATION: \"aisauthenticationstarted\",\n  AUTHENTICATED: \"aisauthenticated\",\n  AUTHENTICATING: \"aisauthenticating\",\n  AUTHENTICATION_COMPLETE: \"aisauthenticationcomplete\",\n  CHOOSE_AUTH_PROVIDER: \"aischooseprovider\",\n  CHOOSE_PLAY_OPTIONS: \"aischooseplayoptions\",\n  LAUNCH_IDP_LOGIN: \"aislaunchidplogin\",\n  PREVIEW: \"aispreview\",\n  PREVIEW_TIME_REMAINING: \"aispreviewtimeremaining\"\n};\n\n/**\n * The AISLaunchIDPLoginCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction AISLaunchIDPLoginCommand() {\n  AISLaunchIDPLoginCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AISLaunchIDPLoginCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAISLaunchIDPLoginCommand.prototype.execute = function(notification) {\n  AISLaunchIDPLoginCommand.__super__.execute.call(this, notification);\n  this.proxy.launchIDPLogin(notification.getBody());\n};\n\n/**\n * The AISChooserMediator class.\n * \n * @constructor\n * @private\n * @extends {LocalizedMediator}\n*/\nfunction AISChooserMediator(parent) {\n  AISChooserMediator.__super__.constructor.call(this, null, null, parent);\n}\n\n\n__extends(AISChooserMediator, ComponentMediator);\n\n\nAISChooserMediator.prototype.componentName = \"ais-chooser\";\n\nAISChooserMediator.prototype.menu = null;\n\nAISChooserMediator.prototype.label = null;\n\nAISChooserMediator.prototype.grid = null;\n\nAISChooserMediator.prototype.select = null;\n\nAISChooserMediator.prototype.login = null;\n\nAISChooserMediator.prototype.title = null;\n\n/**\n * @override\n*/\nAISChooserMediator.prototype.onRegister = function() {\n  var _this = this;\n  AISChooserMediator.__super__.onRegister.call(this);\n  this.classList.add(\"hidden\");\n  this.title = this.createText(\"ais-chooser-title\", \"Choose your provider\");\n  this.grid = this.create(\"ais-chooser-grid\");\n  this.menu = this.create(\"ais-chooser-menu\");\n  this.label = this.createText(\"ais-chooser-label\", \"Providers: \", this.menu);\n  this.select = this.create(\"ais-chooser-select\", this.menu, \"select\");\n  this.login = this.create(\"ais-chooser-login\", false, \"input\");\n  this.login.type = \"button\";\n  this.login.value = \"Login\";\n  EventHandler.create(this.login, EventHandler.CLICK, function(event) {\n    var idpID;\n    if (typeof event.stopImmediatePropagation === \"function\") {\n      event.stopImmediatePropagation();\n    }\n    idpID = _this.select.options[_this.select.selectedIndex].value;\n    _this.sendNotification(AISNotifications.LAUNCH_IDP_LOGIN, idpID);\n    return false;\n  });\n  this.menu.appendChild(this.login);\n};\n\n/**\n * @override\n*/\nAISChooserMediator.prototype.listNotificationInterests = function() {\n  return [AISNotifications.CHOOSE_AUTH_PROVIDER, AISNotifications.AUTHENTICATING];\n};\n\n/**\n * @override\n*/\nAISChooserMediator.prototype.handleNotification = function(notification) {\n  var baseURL, div, featuredGroup, footprints, group, groups, idp, idps, img, index, key, logos, member, option, options, proxy, resp, span, src, value, _i, _j, _k, _l, _len, _len1, _len2, _len3, _ref, _ref1,\n    _this = this;\n  switch (notification.getName()) {\n    case AISNotifications.CHOOSE_AUTH_PROVIDER:\n      resp = notification.getBody();\n      idps = resp.possible_idps;\n      footprints = resp.footprints || [];\n      groups = resp.grouped_idps || [];\n      proxy = this.facade.retrieveProxy(ModuleProxy.NAME);\n      logos = proxy.value.logos;\n      baseURL = logos != null ? logos.base : void 0;\n      this.grid.innerHTML = \"\";\n      if ((groups != null) && ((logos != null ? logos.group : void 0) != null)) {\n        for (_i = 0, _len = groups.length; _i < _len; _i++) {\n          group = groups[_i];\n          if (!(group.name === logos.group)) {\n            continue;\n          }\n          featuredGroup = group;\n          break;\n        }\n        if (featuredGroup != null) {\n          _ref = featuredGroup.members;\n          for (index = _j = 0, _len1 = _ref.length; _j < _len1; index = ++_j) {\n            member = _ref[index];\n            idp = idps[member];\n            div = this.create([\"ais-chooser-grid-item\", \"ais-chooser-grid-index-\" + (index + 1)], this.grid);\n            if (div.dataset == null) {\n              div.dataset = {};\n            }\n            div.dataset.key = member;\n            div.onclick = function(event) {\n              var idpID, target;\n              if (typeof event.stopImmediatePropagation === \"function\") {\n                event.stopImmediatePropagation();\n              }\n              target = (event.currentTarget != null) ? event.currentTarget : event.srcElement;\n              idpID = target.dataset.key;\n              _this.sendNotification(AISNotifications.LAUNCH_IDP_LOGIN, idpID);\n              return false;\n            };\n            if (((_ref1 = idps[member].logos) != null ? _ref1[logos.key] : void 0) != null) {\n              img = this.create(\"ais-chooser-grid-cell-img\", div, \"img\");\n              img.alt = idp.display_name;\n              src = idp.logos[logos.key];\n              if (src.indexOf(\"http\") === -1) {\n                src = baseURL + src;\n              }\n              img.src = src;\n              if (img.dataset == null) {\n                img.dataset = {};\n              }\n              img.dataset.key = member;\n              span = this.create(\"ais-chooser-grid-cell-label\", div, \"span\");\n              span.innerHTML = idp.display_name;\n            } else {\n              div.innerHTML = idp.display_name;\n            }\n          }\n        }\n      }\n      if (this.grid.innerHTML !== \"\") {\n        this.classList.add(\"ais-chooser-featured\");\n        this.label.textContent = \"Other \";\n      }\n      options = this.select.options;\n      for (index = _k = 0, _len2 = options.length; _k < _len2; index = ++_k) {\n        option = options[index];\n        this.select.options.remove(index);\n      }\n      if (footprints.length > 0) {\n        for (_l = 0, _len3 = footprints.length; _l < _len3; _l++) {\n          key = footprints[_l];\n          options[options.length] = new Option(\"\" + idps[key].display_name, \"\" + key);\n        }\n      }\n      for (key in idps) {\n        value = idps[key];\n        options[options.length] = new Option(\"\" + value.display_name, \"\" + key);\n      }\n      this.classList.remove(\"hidden\");\n      break;\n    case AISNotifications.AUTHENTICATING:\n      this.classList.add(\"hidden\");\n  }\n};\n\n/**\n * The AISPlayMediator class.\n * \n * @constructor\n * @private\n * @extends {LocalizedMediator}\n * @param {Object} viewComponent\n*/\nfunction AISPlayMediator(parent) {\n  AISPlayMediator.__super__.constructor.call(this, null, null, parent);\n}\n\n\n__extends(AISPlayMediator, ComponentMediator);\n\n\nAISPlayMediator.prototype.componentName = \"ais-play\";\n\nAISPlayMediator.prototype.menu = null;\n\nAISPlayMediator.prototype.restart = null;\n\nAISPlayMediator.prototype.resume = null;\n\nAISPlayMediator.prototype.resumeTime = null;\n\n/**\n * @override\n*/\nAISPlayMediator.prototype.onRegister = function() {\n  var _this = this;\n  AISPlayMediator.__super__.onRegister.call(this);\n  this.classList.add(\"hidden\");\n  this.menu = this.create(\"ais-play-menu\");\n  this.restart = this.create(\"ais-play-restart\", this.menu);\n  this.restart.type = \"button\";\n  this.restart.textContent = \"Restart\";\n  this.restart.onclick = function(event) {\n    if (typeof event.stopImmediatePropagation === \"function\") {\n      event.stopImmediatePropagation();\n    }\n    _this.play();\n    return false;\n  };\n  this.resume = this.create(\"ais-play-resume\", this.menu);\n  this.resume.type = \"button\";\n  this.resume.value = \"Resume\";\n  this.restart.onclick = function(event) {\n    if (typeof event.stopImmediatePropagation === \"function\") {\n      event.stopImmediatePropagation();\n    }\n    _this.play(_this.resumeTime);\n    return false;\n  };\n};\n\nAISPlayMediator.prototype.play = function(time) {\n  var proxy;\n  proxy = this.facade.retrieveProxy(AISProxy.NAME);\n  proxy.play(time);\n};\n\n/**\n * @override\n*/\nAISPlayMediator.prototype.listNotificationInterests = function() {\n  return [AISNotifications.CHOOSE_PLAY_OPTIONS];\n};\n\n/**\n * @override\n*/\nAISPlayMediator.prototype.handleNotification = function(notification) {\n  switch (notification.getName()) {\n    case AISNotifications.CHOOSE_PLAY_OPTIONS:\n      this.resumeTime = notification.getBody();\n      this.classList.remove(\"hidden\");\n  }\n};\n\n/**\n * The AISAuthenticateMediaCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction AISAuthorizeCommand() {\n  AISAuthorizeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AISAuthorizeCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAISAuthorizeCommand.prototype.execute = function(notification) {\n  if (this.proxy.isRestricted(this.media.getData())) {\n    this.proxy.authorize();\n  }\n};\n\n/**\n * The AISAuthenticationFailedCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction AISAuthenticationFailedCommand() {\n  AISAuthenticationFailedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AISAuthenticationFailedCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAISAuthenticationFailedCommand.prototype.execute = function(notification) {\n  AISAuthenticationFailedCommand.__super__.execute.call(this, notification);\n  if (this.proxy.isPreviewAvailable()) {\n    this.proxy.preview();\n  } else {\n    this.proxy.choose();\n  }\n};\n\n/**\n * The AISAuthorizationFailedCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction AISAuthorizationFailedCommand() {\n  AISAuthorizationFailedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AISAuthorizationFailedCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAISAuthorizationFailedCommand.prototype.execute = function(notification) {\n  AISAuthorizationFailedCommand.__super__.execute.call(this, notification);\n  if (this.proxy.isPreviewAvailable()) {\n    this.proxy.preview();\n  }\n};\n\n/**\n * The AISAuthorizationExpiredCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction AISAuthorizationExpiredCommand() {\n  AISAuthorizationExpiredCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AISAuthorizationExpiredCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAISAuthorizationExpiredCommand.prototype.execute = function(notification) {\n  AISAuthorizationExpiredCommand.__super__.execute.call(this, notification);\n  this.sendNotification(Notifications.PAUSE);\n  this.proxy.authorize();\n};\n\n/**\n * The AISChangePlayStateCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction AISChangePlayStateCommand() {\n  AISChangePlayStateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AISChangePlayStateCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAISChangePlayStateCommand.prototype.execute = function(notification) {\n  var state;\n  state = notification.getBody().value;\n  if (state === PlayState.PLAYING) {\n    this.proxy.playing();\n  } else if (state === PlayState.PAUSED) {\n    this.proxy.pause();\n  }\n};\n\n/**\n * The AISAuthenticatingMediator class.\n * \n * @constructor\n * @private\n * @extends {LocalizedMediator}\n*/\nfunction AISAuthenticatingMediator(parent) {\n  AISAuthenticatingMediator.__super__.constructor.call(this, null, null, parent);\n}\n\n\n__extends(AISAuthenticatingMediator, ComponentMediator);\n\n\nAISAuthenticatingMediator.prototype.componentName = \"ais-authenticating\";\n\nAISAuthenticatingMediator.prototype.retry = null;\n\n/**\n * @override\n*/\nAISAuthenticatingMediator.prototype.onRegister = function() {\n  AISAuthenticatingMediator.__super__.onRegister.call(this);\n  this.classList.add(\"hidden\");\n  this.retry = this.create(\"ais-authenticating-button\");\n  this.retry.type = \"button\";\n  this.retry.value = \"Back to Providers\";\n  this.retry.onclick = this.onclick.bind(this);\n};\n\n/**\n*/\nAISAuthenticatingMediator.prototype.onclick = function(event) {\n  if (typeof event.stopImmediatePropagation === \"function\") {\n    event.stopImmediatePropagation();\n  }\n  this.classList.add(\"hidden\");\n  this.sendNotification(AISNotifications.START_AUTHENTICATION);\n  return false;\n};\n\n/**\n * @override\n*/\nAISAuthenticatingMediator.prototype.listNotificationInterests = function() {\n  return [AISNotifications.AUTHENTICATING];\n};\n\n/**\n * @override\n*/\nAISAuthenticatingMediator.prototype.handleNotification = function(notification) {\n  switch (notification.getName()) {\n    case AISNotifications.AUTHENTICATING:\n      if (notification.getBody() === true) {\n        this.classList.remove(\"hidden\");\n      } else {\n        this.classList.add(\"hidden\");\n      }\n  }\n};\n\n/**\n * The AISPlayMediator class.\n *\n * @constructor\n * @private\n * @extends {LocalizedMediator}\n * @param {Object} viewComponent\n*/\nfunction AISPreviewMediator(parent) {\n  AISPreviewMediator.__super__.constructor.call(this, null, null, parent);\n}\n\n\n__extends(AISPreviewMediator, ComponentMediator);\n\n\nAISPreviewMediator.prototype.componentName = \"ais-preview\";\n\n/**\n * @override\n*/\nAISPreviewMediator.prototype.onRegister = function() {\n  var _this = this;\n  AISPreviewMediator.__super__.onRegister.call(this);\n  this.classList.add(\"hidden\");\n  this.info = this.create([\"flex-item\", \"ais-preview-info\"]);\n  this.info.textContent = this.localizationManager.getString(\"MSG_PREVIEW_INFO\");\n  this.spacer = this.create(\"spacer\");\n  this.label = this.create([\"flex-item\", \"ais-preview-label\"]);\n  this.label.textContent = this.localizationManager.getString(\"MSG_PREVIEW_EXPIRES\");\n  this.count = this.create([\"flex-item\", \"ais-preview-count\"]);\n  this.login = this.create([\"flex-item\", \"ais-preview-login\"], this, \"button\");\n  this.login.textContent = this.localizationManager.getString(\"MSG_SIGN_IN\");\n  this.login.onclick = function() {\n    _this.sendNotification(Notifications.PAUSE);\n    _this.facade.retrieveProxy(AISProxy.NAME).authorize(true);\n  };\n};\n\nAISPreviewMediator.prototype.displayTime = function(time, duration) {\n  this.count.textContent = Utils.formatTimecode(time, duration);\n};\n\n/**\n * @override\n*/\nAISPreviewMediator.prototype.listNotificationInterests = function() {\n  return [AISNotifications.START_AUTHENTICATION, AISNotifications.PREVIEW, AISNotifications.PREVIEW_TIME_REMAINING];\n};\n\n/**\n * @override\n*/\nAISPreviewMediator.prototype.handleNotification = function(notification) {\n  var data;\n  switch (notification.getName()) {\n    case AISNotifications.START_AUTHENTICATION:\n      this.classList.add(\"hidden\");\n      break;\n    case AISNotifications.PREVIEW:\n      this.classList.remove(\"hidden\");\n      break;\n    case AISNotifications.PREVIEW_TIME_REMAINING:\n      data = notification.getBody();\n      this.displayTime(data.time / 1000, data.duration / 1000);\n  }\n};\n\n/**\n * The AISStartAuthenticationCommand class.\n *\n * @constructor\n * @private\n * @extends {amp.plugins.PluginEventCommand}\n*/\nfunction AISStartAuthenticationCommand() {\n  AISStartAuthenticationCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AISStartAuthenticationCommand, PluginEventCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAISStartAuthenticationCommand.prototype.execute = function(notification) {\n  this.proxy.authenticate();\n  AISStartAuthenticationCommand.__super__.execute.call(this, notification);\n};\n\n/**\n * @constructor\n * @private\n*/\nfunction AISMediator() {\n  AISMediator.__super__.constructor.call(this);\n}\n\n\n__extends(AISMediator, OverlayMediator);\n\n\nAISMediator.prototype.componentName = \"ais\";\n\nAISMediator.prototype.chooser = null;\n\nAISMediator.prototype.auth = null;\n\nAISMediator.prototype.play = null;\n\nAISMediator.prototype.onRegister = function() {\n  var _this = this;\n  AISMediator.__super__.onRegister.call(this);\n  this.classList.add(\"hidden\");\n  setTimeout(function() {\n    _this.chooser = new AISChooserMediator(_this);\n    _this.facade.registerMediator(_this.chooser);\n    _this.auth = new AISAuthenticatingMediator(_this);\n    _this.facade.registerMediator(_this.auth);\n    _this.play = new AISPlayMediator(_this);\n    _this.facade.registerMediator(_this.play);\n    _this.preview = new AISPreviewMediator(_this);\n    return _this.facade.registerMediator(_this.preview);\n  }, 20);\n};\n\nAISMediator.prototype.listNotificationInterests = function() {\n  return [AISNotifications.START_AUTHENTICATION, AISNotifications.AUTHENTICATION_COMPLETE, AISNotifications.CHOOSE_PLAY_OPTIONS, AISNotifications.PREVIEW, Notifications.MEDIA_CHANGE];\n};\n\nAISMediator.prototype.handleNotification = function(notification) {\n  var name;\n  name = notification.getName();\n  switch (name) {\n    case AISNotifications.CHOOSE_PLAY_OPTIONS:\n    case AISNotifications.START_AUTHENTICATION:\n    case AISNotifications.PREVIEW:\n      this.classList.remove(\"hidden\");\n      if (name === AISNotifications.PREVIEW) {\n        this.classList.add(\"ais-free-preview\");\n      } else {\n        this.classList.remove(\"ais-free-preview\");\n      }\n      break;\n    case AISNotifications.AUTHENTICATION_COMPLETE:\n    case Notifications.MEDIA_CHANGE:\n      this.classList.add(\"hidden\");\n      this.facade.player.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"authenticating\");\n  }\n};\n\n/**\n * The AISPlugin class.\n *\n * @param {Module}  app\n *    The parent module of this plugin.\n *\n * @constructor\n * @private\n * @extends {Feature}\n*/\nfunction AISPlugin() {\n  AISPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(AISPlugin, Feature);\n\n\nAISPlugin.NAME = \"AISPlugin\";\n\nAISPlugin.prototype.moduleName = \"ais\";\n\nAISPlugin.prototype.featureName = \"auth\";\n\nAISPlugin.prototype.idps = null;\n\n/** @override\n*/\nAISPlugin.prototype.createController = function() {\n  AISPlugin.__super__.createController.call(this);\n  this.registerCommand(SecurityNotifications.AUTHORIZE, AISAuthorizeCommand);\n  this.registerCommand(AISNotifications.LAUNCH_IDP_LOGIN, AISLaunchIDPLoginCommand);\n  this.registerCommand(AISNotifications.START_AUTHENTICATION, AISStartAuthenticationCommand);\n  this.registerCommand(SecurityNotifications.AUTHENTICATION_FAILED, AISAuthenticationFailedCommand);\n  this.registerCommand(SecurityNotifications.AUTHORIZATION_FAILED, AISAuthorizationFailedCommand);\n  this.registerCommand(SecurityNotifications.AUTHORIZATION_EXPIRED, AISAuthorizationExpiredCommand);\n  this.registerCommand(AISNotifications.AUTHENTICATED, PluginEventCommand);\n  this.registerCommand(AISNotifications.AUTHENTICATING, PluginEventCommand);\n  this.registerCommand(AISNotifications.AUTHENTICATION_COMPLETE, PluginEventCommand);\n  this.registerCommand(AISNotifications.CHOOSE_AUTH_PROVIDER, PluginEventCommand);\n  this.registerCommand(AISNotifications.CHOOSE_PLAY_OPTIONS, PluginEventCommand);\n  this.registerCommand(AISNotifications.PREVIEW, PluginEventCommand);\n  this.registerCommand(Notifications.PLAY_STATE_CHANGE, AISChangePlayStateCommand);\n};\n\n/** @override\n*/\nAISPlugin.prototype.createModel = function() {\n  this.proxy = new AISProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nAISPlugin.prototype.createView = function() {\n  this.registerMediator(new AISMediator());\n};\n\n/** @override\n*/\nAISPlugin.prototype.createNotificationEvent = function(notificationName, body, type) {\n  var event;\n  event = Module.prototype.createNotificationEvent.call(this, notificationName, body, type);\n  if (!(event != null)) {\n    return;\n  }\n  event.type = event.type.replace(new RegExp(\"^\" + (this.getModuleName())), \"\");\n  return event;\n};\n\n/** @override\n*/\nAISPlugin.prototype.listNotificationInterests = function() {\n  return AISPlugin.__super__.listNotificationInterests.call(this).concat([Notifications.MEDIA_CHANGE, SecurityNotifications.AUTHORIZE, Notifications.PLAY_STATE_CHANGE]);\n};\n\n/**\n*/\nAISPlugin.prototype.listNotificationPublications = function() {\n  return AISPlugin.__super__.listNotificationPublications.call(this).concat([SecurityNotifications.AUTHORIZED, SecurityNotifications.AUTHENTICATION_FAILED, SecurityNotifications.AUTHORIZATION_FAILED, SecurityNotifications.AUTHORIZATION_EXPIRED, Notifications.INITIALIZED, Notifications.PLAY, Notifications.PAUSE, Notifications.SEEK, Notifications.WAITING]);\n};\n\n/**\n * @expose\n*/\nAISPlugin.prototype.authorize = function(media) {\n  this.proxy.authorize(media);\n  return media;\n};\n\n/**\n * @expose\n*/\nAISPlugin.prototype.identity = function(force) {\n  return this.proxy.identity(force);\n};\n\n/**\n * @expose\n*/\nAISPlugin.prototype.logout = function() {\n  this.proxy.logout();\n};\n\n/**\n * @return {Array.<Object>} The list of IDPs.\n * @expose\n*/\nAISPlugin.prototype.getIdps = function() {\n  return this.idps;\n};\n\n\nAMP.registerPlugin(\"ais\", \"html\", AISPlugin);\n\n/**\n * The AISFlashPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction AISFlashPlugin() {\n  AISFlashPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(AISFlashPlugin, AISPlugin);\n\n\nAISFlashPlugin.NAME = \"AISFlashPlugin\";\n\nAISFlashPlugin.prototype.proxy = null;\n\nAISFlashPlugin.prototype.startTime = null;\n\n/**\n*/\nAISFlashPlugin.prototype.setData = function(data) {\n  var proxy;\n  proxy = this.retrieveProxy(AISProxy.NAME);\n  proxy.data.platformID = data.platformID;\n  proxy.data.resourceID = data.resourceID;\n  proxy.data.contentID = data.contentID;\n};\n\n/**\n*/\nAISFlashPlugin.prototype.authorize = function(media) {\n  this.retrieveProxy(AISProxy.NAME).authorize(media);\n};\n\n/**\n * The AISTimeUpdateCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction AISTimeUpdateCommand() {\n  AISTimeUpdateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AISTimeUpdateCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAISTimeUpdateCommand.prototype.execute = function(notification) {\n  var currentTime;\n  currentTime = Math.floor(notification.getBody());\n  if (currentTime !== 0 && currentTime % 30 === 0 && currentTime !== this.proxy.currentTime) {\n    this.proxy.vcsSet(currentTime);\n  }\n  this.proxy.currentTime = currentTime;\n};\n\n/**\n * @constructor\n * @private\n * @extends {PluginWrapper}\n*/\nfunction AISWrapper(player, config) {\n  var dispatchEvent, key, value;\n  AISWrapper.__super__.constructor.call(this, player, config);\n  this.plugin = new AISFlashPlugin();\n  dispatchEvent = this.dispatcher.dispatchEvent.bind(this.dispatcher);\n  for (key in AISNotifications) {\n    value = AISNotifications[key];\n    this.plugin.addEventListener(value.replace(/^(ais)/, \"\"), dispatchEvent);\n  }\n  for (key in SecurityNotifications) {\n    value = SecurityNotifications[key];\n    this.plugin.addEventListener(value.replace(/^(auth)/, \"\"), dispatchEvent);\n  }\n  this.plugin.oninitialized = this.player.registerModule.bind(this.player, this.plugin);\n  this.plugin.initialize(config, this.player);\n}\n\n\n__extends(AISWrapper, PluginWrapper);\n\n\nAISWrapper.NAME = \"AISWrapper\";\n\nAISWrapper.prototype.plugin = null;\n\n/**\n*/\nAISWrapper.prototype.getFeatureName = function() {\n  return \"auth\";\n};\n\n/**\n*/\nAISWrapper.prototype.createXML = function(xml) {\n  var application, auth, element, prop, props, text, vendor, _i, _len;\n  application = xml.firstChild;\n  auth = xml.getElementsByTagName(\"authentication\");\n  if (!(auth != null) || auth.length === 0) {\n    auth = xml.createElement(\"authentication\");\n    application.appendChild(auth);\n  } else {\n    auth = auth[0];\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"ais\");\n  auth.appendChild(vendor);\n  props = [\n    {\n      value: this.config.platformID,\n      key: \"platformID\"\n    }, {\n      value: this.config.resourceID,\n      key: \"resourceID\"\n    }, {\n      value: this.config.contentID,\n      key: \"contentID\"\n    }\n  ];\n  for (_i = 0, _len = props.length; _i < _len; _i++) {\n    prop = props[_i];\n    if (!(prop.value != null)) {\n      continue;\n    }\n    element = xml.createElement(\"property\");\n    element.setAttribute(\"key\", prop.key);\n    text = XMLUtils.createTextContent(xml, prop.value);\n    element.appendChild(text);\n    vendor.appendChild(element);\n  }\n  return xml;\n};\n\n/**\n*/\nAISWrapper.prototype.listNotificationInterests = function() {\n  return AISWrapper.__super__.listNotificationInterests.apply(this, arguments).concat([SecurityNotifications.AUTHORIZE, FlashNotifications.TIME_UPDATE, FlashNotifications.ENDED, FlashNotifications.PAUSED, FlashNotifications.CAPABILITY_CHANGE, FlashNotifications.RESET]);\n};\n\n/**\n*/\nAISWrapper.prototype.handleNotification = function(notification) {\n  var body, mediaProxy, name;\n  AISWrapper.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case SecurityNotifications.AUTHORIZE:\n      this.plugin.startTime = null;\n      this.plugin.setData(body);\n      mediaProxy = this.player.retrieveProxy(MediaProxy.NAME);\n      if (!(mediaProxy.getSrc() != null)) {\n        mediaProxy.setSrc(body.media.src);\n      }\n      break;\n    case FlashNotifications.TIME_UPDATE:\n      this.plugin.sendNotification(Notifications.TIME_UPDATE, body);\n      break;\n    case FlashNotifications.ENDED:\n      this.plugin.sendNotification(Notifications.ENDED, body);\n      break;\n    case FlashNotifications.PAUSED:\n      this.plugin.sendNotification(Notifications.PAUSE, body);\n      break;\n    case FlashNotifications.RESET:\n      this.plugin.sendNotification(Notifications.MEDIA_CHANGE, body);\n      break;\n    case FlashNotifications.CAPABILITY_CHANGE:\n      if ((this.plugin.startTime != null) && body.type === \"canSeekChange\" && body.enabled) {\n        this.player.setCurrentTime(this.plugin.startTime);\n      }\n  }\n};\n\n/**\n * @expose\n*/\nAISWrapper.prototype.authorize = function(media) {\n  this.plugin.authorize(media);\n  return media;\n};\n\n/**\n * @expose\n*/\nAISWrapper.prototype.logout = function() {\n  this.plugin.logout();\n};\n\n/**\n * @return {Array.<Object>} The list of IDPs.\n * @expose\n*/\nAISWrapper.prototype.getIdps = function() {\n  return this.plugin.getIdps();\n};\n\n\nAMP.registerPlugin(\"ais\", \"flash\", AISWrapper);\n\n/**\n * The AISEndedCommand class.\n *   \n * @constructor\n * @private\n * @extends {amp.plugins.PluginCommand}\n*/\nfunction AISEndedCommand() {\n  AISEndedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AISEndedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nAISEndedCommand.prototype.execute = function(notification) {\n  this.proxy.vcsSet(0);\n};\n\n/**\n * The IMAPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {AdPlugin}\n*/\nfunction IMAPlugin() {\n  IMAPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(IMAPlugin, AdPlugin);\n\n\nIMAPlugin.prototype.moduleName = \"ima\";\n\nIMAPlugin.prototype.createFullscreenProxy = function() {\n  return new IMAFullscreenProxy(this.config);\n};\n\nIMAPlugin.prototype.createProxy = function() {\n  return new IMAProxy(this.config);\n};\n\nIMAPlugin.prototype.isFullscreenDevice = function() {\n  var ua;\n  ua = navigator.userAgent;\n  return this.config.fullscreen === true || Utils.isFullscreenDevice() || /Android 4\\.[0-1]/.test(ua) || /CrKey/.test(ua);\n};\n\n/** @override\n*/\nIMAPlugin.prototype.createModel = function() {\n  IMAPlugin.__super__.createModel.call(this);\n  if (this.config.overlay != null) {\n    this.registerProxy(new IMAOverlayProxy(this.config.overlay));\n  }\n};\n\n/** @override\n*/\nIMAPlugin.prototype.createController = function() {\n  IMAPlugin.__super__.createController.call(this);\n  if (this.config.overlay != null) {\n    this.registerCommand(IMANotifications.ADD_OVERLAY, IMAAddOverlayCommand);\n    this.registerCommand(IMANotifications.REMOVE_OVERLAY, IMARemoveOverlayCommand);\n  }\n  this.registerCommand(Notifications.READY, IMAReadyCommand);\n  this.registerCommand(Notifications.FULL_SCREEN_CHANGE, IMADisplayStateChangeCommand);\n  this.registerCommand(Notifications.CHANGE_ACTIVE_STATE, IMAActiveStateChangeCommand);\n};\n\n/** @override\n*/\nIMAPlugin.prototype.createView = function() {\n  IMAPlugin.__super__.createView.call(this);\n  if (this.config.overlay != null) {\n    this.registerMediator(new IMAOverlayMediator());\n  }\n};\n\n\nAMP.registerPlugin(\"ima\", \"html\", IMAPlugin);\nAMP.registerPlugin(\"ima\", \"flash\", IMAWrapper);\n\n/**\n * The AdContentPausedCommand class.\n *\n * @constructor\n * @private\n * @extends {AdCommand}\n*/\nfunction AdContentPausedCommand() {\n  AdContentPausedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(AdContentPausedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nAdContentPausedCommand.prototype.execute = function(notification) {\n  var fw;\n  fw = this.facade.retrieveProxy(AdProxy.NAME);\n  fw.contentPaused();\n};\n\n/**\n * @constructor\n * @private\n * @extends {PluginProxy}\n*/\nfunction AISProxy(config) {\n  AISProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(AISProxy, PluginProxy);\n\n\n/** @static\n*/\nAISProxy.NAME = ModuleProxy.NAME;\n\nAISProxy.prototype.client = null;\n\nAISProxy.prototype.currentTime = null;\n\nAISProxy.prototype.idps = null;\n\nAISProxy.prototype.idp = null;\n\nAISProxy.prototype.token = null;\n\nAISProxy.prototype.authz = null;\n\nAISProxy.prototype.authenticated = null;\n\nAISProxy.prototype.defaults = {\n  platformID: null,\n  resourceID: null,\n  contentID: null,\n  responseTargets: null,\n  query: \"hdnts\",\n  vcs: false,\n  preview: null,\n  uri: \"urn:protected\",\n  logos: {\n    base: null,\n    group: null,\n    key: \"full\"\n  }\n};\n\n/** @override\n*/\nAISProxy.prototype.getScript = function() {\n  return this.value.plugin;\n};\n\n/**\n*/\nAISProxy.prototype.initialize = function() {\n  this.client = window.ais_client;\n  this.client.setLogging(this.facade.logger.enabled);\n  this.client.setPlatformId(this.value.platformID);\n  this.client.setUseCache(false);\n  this.client.assignhandler(\"bounce\", this.bounceHandler.bind(this));\n  this.client.assignhandler(\"chooser\", this.chooserHandler.bind(this));\n  this.client.assignhandler(\"init\", this.initHandler.bind(this));\n  this.client.assignhandler(\"authz_query\", this.authz_queryHandler.bind(this));\n  this.client.assignhandler(\"vcs\", this.vcsHandler.bind(this));\n  window.onunload = function() {};\n};\n\n/**\n*/\nAISProxy.prototype.isRestricted = function(media) {\n  var reason, restrictions, uri,\n    _this = this;\n  reason = media.status.reason;\n  if (reason === \"ais\" || reason === \"token\") {\n    return true;\n  }\n  restrictions = media.restriction.filter(function(restriction) {\n    return restriction.relationship === \"allow\" && restriction.type === \"uri\";\n  });\n  uri = this.value.uri;\n  return restrictions.some(function(restriction) {\n    return restriction.value.indexOf(uri) !== -1;\n  });\n};\n\n/**\n*/\nAISProxy.prototype.waiting = function(value) {\n  var _this = this;\n  setTimeout(function() {\n    _this.facade.player.appState.setWaiting(value);\n  }, 10);\n};\n\n/**\n*/\nAISProxy.prototype.authorize = function(force) {\n  if (force == null) {\n    force = false;\n  }\n  this.authz = null;\n  this.token = null;\n  if (force === true) {\n    this.value.preview = null;\n  }\n  this.disengage();\n  this.waiting(true);\n  this.sendNotification(AISNotifications.START_AUTHENTICATION);\n};\n\n/**\n*/\nAISProxy.prototype.credentials = function(token) {\n  var security;\n  security = this.facade.player.security;\n  security.setAuthorization({\n    key: this.value.query || this.getDefaults().query,\n    token: token\n  });\n  this.token = security.getSecret();\n};\n\n/**\n*/\nAISProxy.prototype.authorized = function(token) {\n  if (token == null) {\n    token = this.token;\n  }\n  this.engage();\n  this.waiting(false);\n  this.sendNotification(AISNotifications.AUTHENTICATION_COMPLETE);\n  this.sendNotification(SecurityNotifications.AUTHORIZED, token);\n};\n\n/**\n*/\nAISProxy.prototype.play = function(time) {\n  this.sendNotification(Notifications.INITIALIZED);\n  this.sendNotification(Notifications.PLAY);\n  if (time != null) {\n    return this.sendNotification(Notifications.SEEK, time);\n  }\n};\n\n/**\n*/\nAISProxy.prototype.engage = function() {\n  this.facade.registerCommand(Notifications.TIME_UPDATE, AISTimeUpdateCommand);\n  this.facade.registerCommand(Notifications.ENDED, AISEndedCommand);\n};\n\n/**\n*/\nAISProxy.prototype.disengage = function() {\n  this.facade.removeCommand(Notifications.TIME_UPDATE);\n  this.facade.removeCommand(Notifications.ENDED);\n};\n\n/**\n*/\nAISProxy.prototype.logout = function() {\n  var height, method, target, width, _ref;\n  this.authenticated = null;\n  method = ((_ref = this.idp.window_display) != null ? _ref.method : void 0) || \"redirect\";\n  target = this.getTarget(method);\n  this.setRedirect(method);\n  switch (method) {\n    case \"redirect\":\n      window.open(this.client.logoutFormat(target), \"_top\");\n      break;\n    case \"popup\":\n      width = this.idp.window_display.width || 320;\n      height = this.idp.window_display.height || 240;\n      window.open(this.client.logoutFormat(target), \"ais_popup\", \"width=\" + width + \",height=\" + height);\n  }\n};\n\n/**\n*/\nAISProxy.prototype.isPreviewAvailable = function() {\n  var _ref;\n  return ((_ref = this.value.preview) != null ? _ref.duration : void 0) != null;\n};\n\n/**\n*/\nAISProxy.prototype.preview = function(refreshIdToken) {\n  var count, delay, duration, expired, preflight, remaining, startTime, windowed,\n    _this = this;\n  if (refreshIdToken == null) {\n    refreshIdToken = false;\n  }\n  duration = this.value.preview.duration * 1000;\n  windowed = this.value.preview.type === \"window\";\n  count = \"AIS_preview___\" + this.value.platformID + \"__\" + this.value.resourceID;\n  delay = 100;\n  expired = \"PREVIEW EXPIRED\";\n  if (windowed === false) {\n    startTime = localStorage.getItem(count);\n    if (!(startTime != null)) {\n      startTime = 0;\n      localStorage.setItem(count, 0);\n    }\n    startTime = parseInt(startTime);\n    remaining = duration - startTime;\n  }\n  preflight = function() {\n    return new Promise(function(resolve, reject) {\n      if (windowed === false && remaining <= 0) {\n        reject(expired);\n      } else {\n        resolve();\n      }\n    });\n  };\n  return preflight().then(function() {\n    return _this.requestIdToken(refreshIdToken);\n  }).then(function(tokenId) {\n    return _this.requestCrossToken(tokenId);\n  }).then(function(preview) {\n    _this.credentials(preview.token);\n    _this.authorized(_this.token);\n    if (windowed === true) {\n      startTime = 0;\n      remaining = preview.expires - preview.issued;\n    }\n    if (remaining <= 0) {\n      throw expired;\n    }\n    _this.timer = new Timer(delay, Math.ceil(remaining / delay));\n    _this.timer.addEventListener(\"timer\", function(event) {\n      var currentTime, remainingTime;\n      currentTime = event.target.time;\n      remainingTime = remaining - currentTime;\n      if (windowed === false) {\n        localStorage.setItem(count, startTime + currentTime);\n      }\n      _this.sendNotification(AISNotifications.PREVIEW_TIME_REMAINING, {\n        time: remainingTime,\n        duration: duration\n      });\n      if (remainingTime <= 0) {\n        _this.timer.stop();\n        _this.sendNotification(SecurityNotifications.AUTHORIZATION_EXPIRED);\n      }\n    });\n    _this.sendNotification(AISNotifications.PREVIEW, preview);\n    _this.sendNotification(AISNotifications.PREVIEW_TIME_REMAINING, {\n      time: remaining,\n      duration: duration\n    });\n  })[\"catch\"](function(error) {\n    _this.facade.logger.error(error);\n    _this.authorize(true);\n  }).then(function() {\n    _this.waiting(false);\n  });\n};\n\n/**\n*/\nAISProxy.prototype.requestGuardToken = function() {\n  var path,\n    _this = this;\n  path = \"https://idp.securetve.com/rest/security/v2/platforms/\" + this.value.platformID + \"/tokens/guard\";\n  return Utils.requestJson(path).then(function(json) {\n    return json.guard_token;\n  });\n};\n\n/**\n*/\nAISProxy.prototype.requestIdToken = function(refreshIdToken) {\n  var paths, token, tokenKey,\n    _this = this;\n  tokenKey = \"AIS_preview___\" + this.value.platformID + \"__response_cache__identity_token\";\n  if (refreshIdToken === true) {\n    localStorage.removeItem(tokenKey);\n  } else {\n    token = localStorage.getItem(tokenKey);\n    if (token != null) {\n      return Promise.resolve(token);\n    }\n  }\n  paths = [\"https://idp.securetve.com/rest/authn/v2/platforms/\" + this.value.platformID + \"/init/fingerprint\", \"https://idp.securetve.com/rest/authn/v2/platforms/\" + this.value.platformID + \"/tokens/id\"];\n  return this.requestGuardToken().then(function(guard) {\n    return Utils.requestJson({\n      url: paths[0],\n      headers: {\n        \"Akamai-Token-Guard\": guard\n      }\n    }).then(function(km) {\n      return akamai.ais.createEncryptedFingerprint(km);\n    }).then(function(fingerprint) {\n      return Utils.requestJson({\n        url: paths[1],\n        headers: {\n          \"Akamai-Token-Guard\": guard,\n          \"Akamai-Authentication\": \"fingerprint/ob \" + fingerprint\n        }\n      });\n    }).then(function(json) {\n      if (json.failure_type != null) {\n        throw json.failure_type;\n      }\n      token = json.identity_token;\n      localStorage.setItem(tokenKey, token);\n      return token;\n    });\n  });\n};\n\n/**\n*/\nAISProxy.prototype.requestCrossToken = function(tokenId) {\n  var paths,\n    _this = this;\n  paths = [\"https://idp.securetve.com/rest/authz/v2/platforms/\" + this.value.platformID + \"/resources/\" + this.value.resourceID, \"https://idp.securetve.com/rest/authz/v2/platforms/\" + this.value.platformID + \"/tokens/crossover\"];\n  return Utils.requestJson({\n    url: paths[0],\n    headers: {\n      \"Akamai-Token-Id\": tokenId\n    }\n  }).then(function(json) {\n    var error;\n    error = json.failure_type;\n    if (!(error != null)) {\n      return json;\n    }\n    switch (error) {\n      case \"INVALID_ID_TOKEN\":\n        return _this.preview(true);\n      case \"GRANTS_WINDOW_EXPIRED\":\n        return _this.requestGuardToken().then(function(guard) {\n          return Utils.requestJson({\n            url: paths[0],\n            method: \"POST\",\n            headers: {\n              \"Akamai-Token-Guard\": guard,\n              \"Akamai-Token-Id\": tokenId\n            },\n            body: '{\"action\":\"grant_extension\",\"attributes\":{\"duration\":' + _this.value.preview.duration + '}}'\n          });\n        });\n      default:\n        throw JSON.stringify(json, null, \"  \");\n    }\n  }).then(function(json) {\n    var jwt, preview;\n    if (json.failure_type != null) {\n      throw json.failure_type;\n    }\n    jwt = Utils.parseJWT(json.access_token).payload.grants[_this.value.resourceID];\n    preview = {\n      issued: jwt.issued * 1000,\n      expires: jwt.expires * 1000,\n      duration: _this.value.preview.duration\n    };\n    return Utils.requestJson({\n      url: paths[1],\n      headers: {\n        \"Akamai-Token-Access\": json.access_token\n      }\n    }).then(function(json) {\n      preview.token = json.crossover_token;\n      return preview;\n    });\n  });\n};\n\n/**\n*/\nAISProxy.prototype.playing = function() {\n  if (!(this.timer != null) || !(this.value.preview != null) || this.value.preview.type === \"window\") {\n    return;\n  }\n  this.timer.start();\n};\n\n/**\n*/\nAISProxy.prototype.pause = function() {\n  if (!(this.timer != null) || !(this.value.preview != null) || this.value.preview.type === \"window\") {\n    return;\n  }\n  this.timer.stop();\n};\n\n/**\n*/\nAISProxy.prototype.authenticate = function() {\n  if (this.authenticated === null) {\n    this.bounce();\n  } else if (this.authenticated === false) {\n    this.choose();\n  }\n};\n\n/**\n*/\nAISProxy.prototype.bounce = function(resource) {\n  this.client.bounce();\n};\n\n/**\n*/\nAISProxy.prototype.init = function(resource) {\n  this.client.init();\n};\n\n/**\n*/\nAISProxy.prototype.identity = function(force) {\n  var _this = this;\n  return new Promise(function(resolve, reject) {\n    _this.client.identity(force);\n    return _this.client.assignhandler(\"identity\", function(type, resp) {\n      var data;\n      data = resp.identity;\n      resolve(data);\n      return _this.facade.dispatchEvent(new Event(type, data));\n    });\n  });\n};\n\n/**\n*/\nAISProxy.prototype.choose = function() {\n  this.timer = null;\n  this.client.chooser();\n};\n\n/**\n*/\nAISProxy.prototype.resourceAccess = function(resource) {\n  if (resource == null) {\n    resource = this.value.resourceID;\n  }\n  this.client.resourceAccess(resource);\n};\n\n/**\n*/\nAISProxy.prototype.vcsSet = function(time) {\n  time = Utils.formatTimecode(time);\n  this.client.vcsSet(this.value.contentID, time);\n};\n\n/**\n*/\nAISProxy.prototype.bounceHandler = function(type, resp) {\n  this.authenticated = resp.authenticated.toString() === \"true\";\n  if (this.authenticated === false) {\n    this.sendNotification(SecurityNotifications.AUTHENTICATION_FAILED);\n  } else if (this.authenticated === true) {\n    this.init();\n  }\n};\n\n/**\n*/\nAISProxy.prototype.initHandler = function(type, resp) {\n  var key, key2, value, value2, _ref;\n  this.idp = resp.idps;\n  this.facade.idps = {};\n  _ref = resp.idps;\n  for (key in _ref) {\n    value = _ref[key];\n    this.facade.idps.key = key;\n    for (key2 in value) {\n      value2 = value[key2];\n      this.facade.idps[key2] = value2;\n    }\n    break;\n  }\n  for (key in resp) {\n    value = resp[key];\n    if (key !== \"idps\" && (value != null)) {\n      this.facade[key] = value;\n    }\n  }\n  if ((this.value.logos != null) && (this.facade.idps.logos != null)) {\n    this.facade.idps.logo = this.value.logos.base + this.facade.idps.logos[this.value.logos.key];\n  }\n  this.client.assignhandler('logout_result', this.logoutHandler.bind(this));\n  this.facade.player.sendNotification(Notifications.REMOVE_APPLICATION_STATE, \"authenticating\");\n  this.sendNotification(AISNotifications.AUTHENTICATED, this.facade.idps);\n  this.resourceAccess(this.value.resourceID);\n};\n\n/**\n*/\nAISProxy.prototype.chooserHandler = function(type, resp) {\n  this.waiting(false);\n  this.facade.sendNotification(Notifications.ADD_APPLICATION_STATE, \"authenticating\");\n  resp.possible_idps = this.idps = this.sort(resp.possible_idps, \"value\", \"display_name\");\n  this.sendNotification(AISNotifications.CHOOSE_AUTH_PROVIDER, resp);\n};\n\nAISProxy.prototype.launchIDPLogin = function(idp_platform_id) {\n  var height, idp, method, target, width, _ref;\n  this.sendNotification(AISNotifications.AUTHENTICATING, true);\n  idp = this.idps[idp_platform_id];\n  method = ((_ref = idp.window_display) != null ? _ref.method : void 0) || \"redirect\";\n  target = this.getTarget(method);\n  this.setRedirect(method);\n  switch (method) {\n    case \"redirect\":\n      window.open(this.client.loginFormat(idp_platform_id, target), \"_top\");\n      break;\n    case \"popup\":\n      method = idp.window_display.method || \"popup\";\n      width = idp.window_display.width || 320;\n      height = idp.window_display.height || 240;\n      window.open(this.client.loginFormat(idp_platform_id, target), \"ais_popup\", \"width=\" + width + \",height=\" + height);\n  }\n};\n\n/**\n*/\n/**\n*/\nAISProxy.prototype.authz_queryHandler = function(type, resp) {\n  var auth, dimensions, resource;\n  auth = resp.authorization.toString() === \"true\";\n  if (auth === false) {\n    this.sendNotification(SecurityNotifications.AUTHORIZATION_FAILED, resp);\n  } else if (auth === true) {\n    this.authz = resp;\n    dimensions = {\n      mvpdName: this.facade.idps.name,\n      viewerId: this.client.aisuid,\n      \"std:viewerId\": this.client.aisuid\n    };\n    this.facade.player.setParams({\n      \"mvpdname\": dimensions.mvpdName\n    });\n    this.facade.player.sendNotification(MediaAnalyticsNotifications.SET_DIMENSIONS, dimensions);\n    this.facade.viewerId = this.client.aisuid;\n    resource = resp.resource;\n    if (resource != null) {\n      this.facade.resource = resource;\n    }\n    this.credentials(resp.security_token);\n    this.sendNotification(AISNotifications.AUTHENTICATING, false);\n    if (this.value.vcs === true && (this.value.contentID != null)) {\n      this.client.vcsGet(this.value.contentID);\n    } else {\n      this.authorized(this.token);\n    }\n  }\n};\n\n/**\n*/\nAISProxy.prototype.logoutHandler = function(type, resp) {\n  top.location.href = top.location.href;\n};\n\n/**\n*/\nAISProxy.prototype.vcsHandler = function(type, resp) {\n  var pos;\n  if (resp.operation === \"get\") {\n    pos = resp.ph_pos;\n    if (pos === \"00:00:00\" || pos === \"00:00\") {\n      this.client.vcsSet(this.value.contentID, pos);\n      this.authorized(this.token);\n    } else {\n      this.sendNotification(AISNotifications.CHOOSE_PLAY_OPTIONS, Utils.flattenTimecode(pos));\n    }\n  }\n};\n\n/**\n*/\nAISProxy.prototype.sort = function(obj, sortType, valueName) {\n  var data, index, item, key, returnObj, value, _i, _len;\n  returnObj = {};\n  data = [];\n  index = 0;\n  for (key in obj) {\n    value = obj[key];\n    data[index] = {\n      key: key,\n      value: value[valueName]\n    };\n    index++;\n  }\n  data.sort(function(a, b) {\n    var valueA, valueB, _ref, _ref1, _ref2, _ref3;\n    valueA = sortType === \"value\" ? (_ref = a.value) != null ? _ref.toLowerCase() : void 0 : (_ref1 = a.key) != null ? _ref1.toLowercase() : void 0;\n    valueB = sortType === \"value\" ? (_ref2 = b.value) != null ? _ref2.toLowerCase() : void 0 : (_ref3 = b.key) != null ? _ref3.toLowercase() : void 0;\n    if (valueA < valueB) {\n      return -1;\n    } else if (valueA > valueB) {\n      return 1;\n    } else {\n      return 0;\n    }\n  });\n  for (index = _i = 0, _len = data.length; _i < _len; index = ++_i) {\n    item = data[index];\n    returnObj[item.key] = obj[item.key];\n  }\n  return returnObj;\n};\n\n/**\n*/\nAISProxy.prototype.setRedirect = function(method) {\n  var devToken, domain, loc;\n  try {\n    devToken = /\\/dev\\./;\n    loc = window.top.location.href || window.top.location;\n    domain = devToken.test(loc) ? loc.replace(devToken, \"/\") : null;\n    Cookies.setCookie(this.getTarget(method), loc, 1, \"/\", domain);\n  } catch (error) {\n\n  }\n};\n\n/**\n*/\nAISProxy.prototype.getTarget = function(method) {\n  if (method == null) {\n    method = \"redirect\";\n  }\n  return this.value.responseTargets[method];\n};\n\nfunction FreeWheelWrapper() {\n  return FreeWheelWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(FreeWheelWrapper, AdWrapper);\n\n\nFreeWheelWrapper.NAME = \"FreeWheelWrapper\";\n\nFreeWheelWrapper.prototype.partner = \"freewheel\";\n\nFreeWheelWrapper.prototype.flashPlugins = [\n  {\n    id: \"FreewheelPlugin\",\n    src: '#{paths.resources}plugins/FreewheelPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"FreewheelPlugin\"\n  }, {\n    id: \"AdOptionsPlugin\",\n    src: '#{paths.resources}plugins/AdOptionsPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"AdOptionsPlugin\",\n    type: \"application/x-shockwave-flash\"\n  }\n];\n\n/** @override\n*/\nFreeWheelWrapper.prototype.createXML = function(xml) {\n  var admedia, application, key, keyValue, prop, props, value, vendor, _i, _len, _ref;\n  application = xml.firstChild;\n  admedia = xml.getElementsByTagName(\"admedia\")[0];\n  if (!(admedia != null)) {\n    admedia = xml.createElement(\"admedia\");\n    application.appendChild(admedia);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"freewheel\");\n  admedia.appendChild(vendor);\n  props = [\n    {\n      value: this.config.plugin.swf,\n      key: \"FREEWHEEL_AD_MANAGER_URL\"\n    }, {\n      value: this.config.serverUrl,\n      key: \"FREEWHEEL_SERVER_URL\"\n    }, {\n      value: this.config.networkId,\n      key: \"FREEWHEEL_NETWORK_ID\"\n    }, {\n      value: this.config.profileId,\n      key: \"FREEWHEEL_PROFILE\"\n    }, {\n      value: this.config.siteSectionId,\n      key: \"FREEWHEEL_SITE_SECTION_ID\"\n    }, {\n      value: this.config.siteSectionFallbackId,\n      key: \"FREEWHEEL_SITE_SECTION_FALLBACK_ID\"\n    }, {\n      value: this.config.prerollSlotId,\n      key: \"FREEWHEEL_PREROLL_SLOT_ID\"\n    }, {\n      value: this.config.midrollSlotId,\n      key: \"FREEWHEEL_MIDROLL_SLOT_ID\"\n    }, {\n      value: this.config.postrollSlotId,\n      key: \"FREEWHEEL_POSTROLL_SLOT_ID\"\n    }, {\n      value: this.config.videoAssetId,\n      key: \"FREEWHEEL_VIDEO_ASSET_ID\"\n    }, {\n      value: this.config.videoAssetFallbackId,\n      key: \"FREEWHEEL_VIDEO_ASSET_FALLBACK_ID\"\n    }, {\n      value: this.config.videoAssetVideoPlayRandom,\n      key: \"FREEWHEEL_VIDEO_ASSET_VIDEO_PLAY_RANDOM\"\n    }, {\n      value: this.config.visitorId,\n      key: \"FREEWHEEL_VISITOR_ID\"\n    }, {\n      value: this.config.keyValuesString,\n      key: \"FREEWHEEL_KEY_VALUES_STRING\"\n    }, {\n      value: this.config,\n      key: \"FREEWHEEL_SITE_SECTION_PAGE_VIEW_RANDOM\"\n    }, {\n      value: \"EXACT\",\n      key: \"FREEWHEEL_VIDEO_ASSET_DURATION_TYPE\"\n    }, {\n      value: this.config.visitorHeader,\n      key: \"FREEWHEEL_VISITOR_HTTP_HEADER_KEY_VALUE\"\n    }, {\n      value: this.config.synchronizeMultipleRequests,\n      key: \"FREEWHEEL_SYNCHRONIZE_MULTIPLE_REQUESTS\"\n    }, {\n      value: this.config.subsessionToken,\n      key: \"FREEWHEEL_SUBSESSION_TOKEN\"\n    }\n  ];\n  for (_i = 0, _len = props.length; _i < _len; _i++) {\n    prop = props[_i];\n    if (prop.value != null) {\n      this.createProperty(xml, prop.key, prop.value, vendor);\n    }\n  }\n  if (this.config.position != null) {\n    vendor.setAttribute(\"position\", this.config.position);\n  }\n  if (this.config.keyValues != null) {\n    keyValue = xml.createElement(\"property\");\n    keyValue.setAttribute(\"key\", \"FREEWHEEL_KEY_VALUE\");\n    _ref = this.config.keyValues;\n    for (key in _ref) {\n      value = _ref[key];\n      if (value != null) {\n        this.createProperty(xml, key, value, keyValue);\n      }\n    }\n    vendor.appendChild(keyValue);\n  }\n};\n\nvar isOverlayDisplayed;\n\n\n\n\n\n/**\n * @constructor\n * @private\n*/\nfunction FreeWheelProxy(config) {\n  this.media = {};\n  this.handlers = {\n    onRequestComplete: this.onRequestComplete.bind(this),\n    onSlotStarted: this.onSlotStarted.bind(this),\n    onSlotEnded: this.onSlotEnded.bind(this),\n    onAdImpression: this.onAdImpression.bind(this),\n    onAdImpressionEnd: this.onAdImpressionEnd.bind(this),\n    onAdClick: this.onAdClick.bind(this),\n    onResume: this.onResume.bind(this),\n    adtimeupdate: this.adTimeupdate.bind(this),\n    timeupdate: this.midrollCheck.bind(this),\n    overlaytimeupdate: this.overlayCheck.bind(this),\n    seekupdate: this.seekingHandler.bind(this),\n    onAdEvent: this.onAdEvent.bind(this)\n  };\n  FreeWheelProxy.__super__.constructor.call(this, config);\n  this.adVO = this.createDefaultAdVO();\n}\n\n\n__extends(FreeWheelProxy, AdProxy);\n\n\n/** @static\n*/\nFreeWheelProxy.NAME = AdProxy.NAME;\n\nFreeWheelProxy.prototype.partner = \"freewheel\";\n\nFreeWheelProxy.prototype.context = null;\n\nFreeWheelProxy.prototype.prerollSlots = null;\n\nFreeWheelProxy.prototype.midrollSlots = null;\n\nFreeWheelProxy.prototype.postrollSlots = null;\n\nFreeWheelProxy.prototype.initialized = false;\n\nFreeWheelProxy.prototype.playWhenLoaded = false;\n\nFreeWheelProxy.prototype.handlers = null;\n\nFreeWheelProxy.prototype.slot = null;\n\nFreeWheelProxy.prototype.playbackCore = null;\n\nFreeWheelProxy.prototype.nextMidroll = null;\n\nFreeWheelProxy.prototype.midrollEngaged = false;\n\nFreeWheelProxy.prototype.overlayEngaged = false;\n\nFreeWheelProxy.prototype.timeout = null;\n\nFreeWheelProxy.prototype.curTime = 0;\n\nFreeWheelProxy.prototype.mediator = null;\n\nFreeWheelProxy.prototype.adPosition = 1;\n\nFreeWheelProxy.prototype.currentAd = null;\n\nisOverlayDisplayed = false;\n\nFreeWheelProxy.prototype.defaults = {\n  networkId: \"96749\",\n  serverUrl: \"http://demo.v.fwmrm.net/ad/g/1\",\n  profileId: \"global-js\",\n  siteSectionId: \"DemoSiteGroup.01\",\n  siteSectionFallbackId: null,\n  siteSectionPageViewRandom: null,\n  videoAssetId: '#{media.guid}',\n  videoAssetFallbackId: null,\n  videoAssetVideoPlayRandom: null,\n  prerollSlotId: null,\n  midrollSlotId: null,\n  postrollSlotId: null,\n  visitorId: null,\n  keyValues: null,\n  keyValuesString: null,\n  renderers: null,\n  synchronizeMultipleRequests: null,\n  subsessionToken: null,\n  creativeParameters: null,\n  parameters: null\n};\n\n/**\n*/\nFreeWheelProxy.prototype.initialize = function() {\n  var debug, level;\n  debug = this.getDebug();\n  switch (true) {\n    case debug === true:\n      level = tv.freewheel.SDK.LOG_LEVEL_INFO;\n      break;\n    case typeof debug === \"number\":\n      level = debug;\n      break;\n    default:\n      level = tv.freewheel.SDK.LOG_LEVEL_QUIET;\n  }\n  tv.freewheel.SDK.setLogLevel(level);\n  this.plugin = this.createPlugin();\n  this.plugin.setNetwork(this.value.networkId);\n  this.plugin.setServer(this.value.serverUrl);\n};\n\nFreeWheelProxy.prototype.createPlugin = function() {\n  return new tv.freewheel.SDK.AdManager();\n};\n\n/**\n*/\nFreeWheelProxy.prototype.engage = function(media) {\n  this.terminateAd(true);\n  this.media = media;\n  FreeWheelProxy.__super__.engage.call(this, media);\n  this.requestAd();\n};\n\n/**\n*/\nFreeWheelProxy.prototype.requestAd = function() {\n  var cues, index, key, keyValue, mediaElement, pair, pairs, parameter, renderer, renderers, scene, time, value, _i, _j, _k, _l, _len, _len1, _len2, _len3, _ref, _ref1, _ref2, _ref3,\n    _this = this;\n  this.terminateAllAds(true);\n  this.context = this.plugin.newContext();\n  if (this.value.synchronizeMultipleRequests != null) {\n    this.context.setCapability(\"sync\", this.value.synchronizeMultipleRequests ? tv.freewheel.SDK.CAPABILITY_STATUS_ON : tv.freewheel.SDK.CAPABILITY_STATUS_OFF);\n  }\n  this.context.registerVideoDisplayBase(this.facade.player.viewComponent.id);\n  mediaElement = this.getMediaElement();\n  if (mediaElement.nodeName.toLowerCase() !== \"video\") {\n    this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, this.facade.player.mediator);\n    this.mediator = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore().mediator;\n  }\n  this.context.setContentVideoElement(this.getMediaElement());\n  this.context.setProfile(this.value.profileId);\n  this.context.setVideoAsset(this.value.videoAssetId, this.media.duration, this.value.networkId, null, null, this.value.videoAssetVideoPlayRandom, null, this.value.videoAssetFallbackId);\n  this.context.setSiteSection(this.value.siteSectionId, this.value.networkId, this.value.siteSectionPageViewRandom, null, this.value.siteSectionFallbackId);\n  if (this.value.subsessionToken != null) {\n    this.context.startSubsession(this.value.subsessionToken);\n  }\n  if (this.value.visitorId != null) {\n    this.context.setVisitor(this.value.visitorId);\n  }\n  if (this.value.keyValues != null) {\n    _ref = this.value.keyValues;\n    for (key in _ref) {\n      value = _ref[key];\n      if (value != null) {\n        this.context.addKeyValue(key, value);\n      }\n    }\n  }\n  if (this.value.keyValuesString != null) {\n    pairs = this.value.keyValuesString.split(\"&\");\n    for (_i = 0, _len = pairs.length; _i < _len; _i++) {\n      pair = pairs[_i];\n      if (!(pair !== \"\")) {\n        continue;\n      }\n      keyValue = pair.split(\"=\");\n      this.context.addKeyValue(keyValue[0], keyValue[1]);\n    }\n  }\n  this.context.addEventListener(tv.freewheel.SDK.EVENT_REQUEST_COMPLETE, this.handlers.onRequestComplete);\n  this.context.addEventListener(tv.freewheel.SDK.EVENT_SLOT_STARTED, this.handlers.onSlotStarted);\n  this.context.addEventListener(tv.freewheel.SDK.EVENT_SLOT_ENDED, this.handlers.onSlotEnded);\n  this.context.addEventListener(tv.freewheel.SDK.EVENT_AD_IMPRESSION, this.handlers.onAdImpression);\n  this.context.addEventListener(tv.freewheel.SDK.EVENT_AD_IMPRESSION_END, this.handlers.onAdImpressionEnd);\n  this.context.addEventListener(tv.freewheel.SDK.EVENT_AD_CLICK, this.handlers.onAdClick);\n  this.context.addEventListener(tv.freewheel.SDK.EVENT_AD, this.handlers.onAdEvent);\n  this.context.addEventListener(tv.freewheel.SDK.EVENT_ERROR, this.handlers.onAdEvent);\n  this.context.setParameter(tv.freewheel.SDK.PARAMETER_RENDERER_VIDEO_START_DETECT_TIMEOUT, 10000, tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);\n  this.context.setParameter(tv.freewheel.SDK.PARAMETER_RENDERER_VIDEO_PROGRESS_DETECT_TIMEOUT, 10000, tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);\n  this.context.setParameter(tv.freewheel.SDK.PARAMETER_EXTENSION_CONTENT_VIDEO_AUTO_SOURCE_RESTORE, false, tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);\n  this.context.setParameter(tv.freewheel.SDK.PARAMETER_RENDERER_VIDEO_DISPLAY_CONTROLS_WHEN_PAUSE, false, tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);\n  this.context.setParameter(tv.freewheel.SDK.PARAMETER_EXTENSION_CONTENT_VIDEO_AUTO_SOURCE_RESTORE, false, tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);\n  if (this.value.parameters != null) {\n    _ref1 = this.value.parameters;\n    for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {\n      parameter = _ref1[_j];\n      this.context.setParameter(parameter.key, parameter.value, parameter.level || tv.freewheel.SDK.PARAMETER_LEVEL_GLOBAL);\n    }\n  }\n  if (this.value.prerollSlotId != null) {\n    this.context.addTemporalSlot(this.value.prerollSlotId, tv.freewheel.SDK.ADUNIT_PREROLL, 0);\n  }\n  if (((_ref2 = this.media.scenes) != null ? _ref2.length : void 0) > 0 && (this.value.midrollSlotId != null)) {\n    cues = [];\n    _ref3 = this.media.scenes;\n    for (index = _k = 0, _len2 = _ref3.length; _k < _len2; index = ++_k) {\n      scene = _ref3[index];\n      if (!(index > 0)) {\n        continue;\n      }\n      time = Utils.flattenTimecode(scene.sceneStartTime);\n      cues.push(time);\n      this.context.addTemporalSlot(this.value.midrollSlotId, tv.freewheel.SDK.ADUNIT_MIDROLL, time);\n    }\n    this.setCues(cues);\n  }\n  if (this.value.postrollSlotId != null) {\n    this.context.addTemporalSlot(this.value.postrollSlotId, tv.freewheel.SDK.ADUNIT_POSTROLL, this.media.duration);\n  }\n  renderers = this.value.renderers;\n  if ((renderers != null ? renderers.length : void 0) > 0) {\n    for (_l = 0, _len3 = renderers.length; _l < _len3; _l++) {\n      renderer = renderers[_l];\n      this.context.addRenderer(renderer.url, renderer.baseUnit, renderer.contentType, renderer.slotType, renderer.soAdUnit, renderer.creativeApi, renderer.parameters);\n    }\n  }\n  this.initialized = false;\n  FreeWheelProxy.__super__.requestAd.call(this);\n  this.processAdRequest(AdRequest.create(this.context, \"freewheel\", this.getData())).then(function(result) {\n    _this.context = result.request;\n    _this.context.submitRequest();\n    try {\n      return _this.facade.player.ui.ads.container.style.pointerEvents = \"none\";\n    } catch (error) {\n\n    }\n  });\n};\n\n/**\n*/\nFreeWheelProxy.prototype.reset = function() {\n  FreeWheelProxy.__super__.reset.call(this);\n  if (this.mediator != null) {\n    this.sendNotification(Notifications.PLAYBACK_CORE_CHANGE, this.mediator);\n    this.mediator = null;\n  }\n  this.facade.registerCommand(Notifications.PAUSED, AdContentPausedCommand);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.onRequestComplete = function(event) {\n  var createAdBreakVO, cues, pod, podPosition, slot, slots, _i, _j, _len, _len1, _ref,\n    _this = this;\n  cues = [];\n  this.pods = [];\n  createAdBreakVO = function(slot) {\n    return new AdVO(slot.getCustomId(), slot.getCustomId(), slot.getTotalDuration(), 0, slot.getTimePositionClass().toLowerCase(), \"freewheel\", null, null, null, slot, slot.getAdCount(), slot.getTimePosition());\n  };\n  if (event.success) {\n    slots = this.context.getTemporalSlots();\n    for (_i = 0, _len = slots.length; _i < _len; _i++) {\n      slot = slots[_i];\n      switch (slot.getTimePositionClass()) {\n        case tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL:\n          if (this.value.prerollSlotId != null) {\n            this.pods.push(createAdBreakVO(slot));\n            this.prerollSlots.push(slot);\n          }\n          break;\n        case tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL:\n          if (this.value.midrollSlotId != null) {\n            this.pods.push(createAdBreakVO(slot));\n            cues.push(slot.getTimePosition());\n            this.midrollSlots.push(slot);\n          }\n          break;\n        case tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL:\n          if (this.value.postrollSlotId != null) {\n            this.pods.push(createAdBreakVO(slot));\n            this.postrollSlots.push(slot);\n          }\n          break;\n        case tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY:\n          this.pods.push(createAdBreakVO(slot));\n          this.overlaySlotsArray.push(slot);\n      }\n    }\n  }\n  if (cues.length > 0) {\n    this.setCues(cues);\n  }\n  if (this.postrollSlots.length > 0) {\n    this.sendNotification(Notifications.HAS_POST_CONTENT, true);\n  }\n  this.initialized = true;\n  this.pods.sort(function(a, b) {\n    return a.time - b.time;\n  });\n  podPosition = -1;\n  _ref = this.pods;\n  for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {\n    pod = _ref[_j];\n    pod.position = pod.type !== \"overlay\" ? ++podPosition : podPosition;\n  }\n  this.sendNotification(AdNotifications.REQUEST_COMPLETE, {\n    pods: this.pods\n  });\n  this.sendNotification(AdNotifications.RESPONSE, {\n    pods: this.pods,\n    response: event,\n    context: this.context\n  });\n  if (this.playWhenLoaded === true) {\n    this.startAd();\n  }\n};\n\n/** @override\n*/\nFreeWheelProxy.prototype.breakStart = function() {\n  var video, _ref;\n  if (((_ref = this.adVO) != null ? _ref.type : void 0) !== \"overlay\") {\n    this.disengageOverlayCheck();\n  }\n  FreeWheelProxy.__super__.breakStart.call(this);\n  this.adPosition = 1;\n  this.playbackCore = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore();\n  this.playbackCore.setEnabled(false);\n  this.getMediaElement().removeEventListener(\"playing\", this.handlers.onResume);\n  video = this.getMediaElement();\n  video.addEventListener(\"playing\", this.playbackCore.handlers.playing);\n  video.addEventListener(\"pause\", this.playbackCore.handlers.pause);\n  video.addEventListener(\"waiting\", this.playbackCore.handlers.waiting);\n  video.addEventListener(\"seeking\", this.handlers.seekupdate);\n  this.timeout = setInterval(function() {\n    return this.curTime = video.currentTime;\n  }, 500);\n  if (this.adVO.type === \"midroll\") {\n    this.contentPause();\n  }\n  if (this.facade.player.playbackRate !== 1) {\n    this.playbackRate = this.facade.player.playbackRate;\n    this.facade.player.playbackRate = 1;\n  }\n};\n\n/** Prevent seeking during pre-roll\n*/\nFreeWheelProxy.prototype.seekingHandler = function(event) {\n  if (event.target.currentTime > this.curTime) {\n    event.target.currentTime = this.curTime;\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.onAdImpression = function(event) {\n  var adType, ctrlBrHi, curBtm, metadata, qryString, rendition, _base, _ref, _ref1, _ref2;\n  adType = (_ref = event.adInstance) != null ? typeof _ref.getSlot === \"function\" ? typeof (_base = _ref.getSlot()).getTimePositionClass === \"function\" ? _base.getTimePositionClass() : void 0 : void 0 : void 0;\n  try {\n    if (adType === tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY) {\n      qryString = '[id^=\"_fw_ad_container_iframe_' + this.slot.getCustomId();\n      curBtm = document.getElementById(document.querySelector(qryString).id).style.bottom;\n      ctrlBrHi = window.getComputedStyle(document.getElementsByClassName(\"akamai-control-bar\")[0]).height;\n      if (parseInt(curBtm, 10) < parseInt(ctrlBrHi, 10)) {\n        document.getElementById(document.querySelector(qryString).id).style.bottom = ctrlBrHi;\n      }\n    }\n  } catch (_error) {}\n  if (adType === tv.freewheel.SDK.TIME_POSITION_CLASS_DISPLAY || adType === tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY) {\n    return;\n  }\n  this.currentAd = event.adInstance;\n  this.adVO.position = this.adPosition++;\n  this.adVO.id = this.currentAd.getAdId();\n  if ((this.slot != null) === !null) {\n    metadata = {\n      adtype: this.slot.getType()\n    };\n    this.updateAdMetadata(this.slot, metadata);\n    this.adVO.metadata = metadata;\n  }\n  rendition = (_ref1 = this.currentAd) != null ? _ref1.getActiveCreativeRendition() : void 0;\n  if (rendition != null) {\n    this.adVO.duration = rendition.getDuration();\n    this.adVO.metadata.adwidth = rendition.getWidth();\n    this.adVO.metadata.adheight = rendition.getHeight();\n  } else {\n    this.adVO.duration = (_ref2 = event.adInstance) != null ? _ref2.getDuration() : void 0;\n  }\n  this.sendNotification(AdNotifications.IMPRESSION, this.adVO);\n  this.sendNotification(AdNotifications.AD_STARTED, this.adVO);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.onAdEvent = function(event) {\n  switch (event.subType) {\n    case tv.freewheel.SDK.EVENT_AD_FIRST_QUARTILE:\n      this.sendNotification(AdNotifications.FIRST_QUARTILE, this.adVO);\n      break;\n    case tv.freewheel.SDK.EVENT_AD_MIDPOINT:\n      this.sendNotification(AdNotifications.MIDPOINT, this.adVO);\n      break;\n    case tv.freewheel.SDK.EVENT_AD_THIRD_QUARTILE:\n      this.sendNotification(AdNotifications.THIRD_QUARTILE, this.adVO);\n      break;\n    case tv.freewheel.SDK.EVENT_AD_COMPLETE:\n      this.sendNotification(AdNotifications.COMPLETE, this.adVO);\n      break;\n    case tv.freewheel.SDK.EVENT_AD_AUTO_PLAY_BLOCKED:\n      this.sendNotification(Notifications.AUTOPLAY_BLOCKED);\n      break;\n    case tv.freewheel.SDK.EVENT_ERROR:\n      this.adVO.error = {};\n      this.adVO.error.errorcode = event.errorCode;\n      this.adVO.error.errorinfo = event.errorInfo;\n      this.adVO.error.errormodule = event.errorModule;\n      this.facade.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"error\", this.adVO));\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.onAdImpressionEnd = function(event) {\n  this.sendNotification(AdNotifications.AD_ENDED, this.adVO);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.onAdClick = function(event) {\n  var paused;\n  paused = this.getMediaElement().paused;\n  if (paused === false) {\n    this.pause();\n  }\n  this.sendNotification(AdNotifications.AD_CLICKED, this.adVO);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.onResume = function(event) {\n  this.context.setVideoState(tv.freewheel.SDK.VIDEO_STATE_PLAYING);\n  this.getMediaElement().removeEventListener(\"playing\", this.handlers.onResume);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.adTimeupdate = function(event) {\n  var rendition, time;\n  try {\n    if (this.slot != null) {\n      this.currentAd = this.slot.getCurrentAdInstance();\n      if (this.currentAd != null) {\n        rendition = this.currentAd.getActiveCreativeRendition();\n        if (rendition != null) {\n          this.adVO.duration = rendition.getDuration();\n        } else {\n          this.adVO.duration = this.currentAd.getDuration();\n        }\n        time = this.adVO.duration - this.currentAd.getPlayheadTime();\n        this.adVO.time = time;\n        this.sendNotification(AdNotifications.AD_TIME_UPDATE, this.currentAd.getPlayheadTime());\n        this.sendNotification(AdNotifications.AD_TIME_REMAINING, time);\n      }\n    }\n  } catch (error) {\n    this.facade.logger.error(\"[AMP FREEWHEEL ERROR]\", error);\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.onSlotStarted = function(event) {\n  var prevSlot, prevSlotType, slot;\n  prevSlot = this.slot;\n  slot = event.slot;\n  if (slot.getType() !== \"temporal\") {\n    return;\n  }\n  if (prevSlot) {\n    prevSlotType = typeof prevSlot.getTimePositionClass === \"function\" ? prevSlot.getTimePositionClass() : void 0;\n    if ((prevSlotType === tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY) && this.isOverlayDisplayed) {\n      if (typeof prevSlot.stop === \"function\") {\n        prevSlot.stop();\n      }\n    }\n  }\n  this.slot = slot;\n  this.getMediaElement().addEventListener(\"timeupdate\", this.handlers.adtimeupdate);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.onSlotEnded = function(event) {\n  var complete, index, midroll, overlay, pod, slot, slotTimePositionClass;\n  slot = event.slot;\n  complete = event.skipped === true ? this.sendNotification.bind(this, AdNotifications.BREAK_SKIPPED, slot) : this.endBreak.bind(this);\n  if (slot.getType() !== \"temporal\") {\n    return;\n  }\n  this.getMediaElement().removeEventListener(\"timeupdate\", this.handlers.adtimeupdate);\n  slotTimePositionClass = slot.getTimePositionClass();\n  pod = this.getPodById(slot.getCustomId());\n  pod.locked = true;\n  this.slot = null;\n  switch (slotTimePositionClass) {\n    case tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL:\n      if (this.prerollSlots.length) {\n        this.prerollSlots.shift();\n        if (this.prerollSlots.length) {\n          this.playAd(this.prerollSlots[0]);\n        } else {\n          complete();\n        }\n      }\n      break;\n    case tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL:\n      index = this.midrollSlots.indexOf(this.nextMidroll);\n      if (index > -1) {\n        midroll = this.midrollSlots.splice(index, 1);\n      }\n      this.nextMidroll = null;\n      complete();\n      break;\n    case tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY:\n      this.isOverlayDisplayed = false;\n      index = this.overlaySlotsArray.indexOf(this.nextOverlay);\n      if (index > -1) {\n        overlay = this.overlaySlotsArray.splice(index, 1);\n      }\n      this.nextOverlay = null;\n      break;\n    case tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL:\n      if (this.postrollSlots.length) {\n        this.postrollSlots.shift();\n        if (this.postrollSlots.length) {\n          this.playAd(this.postrollSlots[0]);\n        } else {\n          complete();\n        }\n      }\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.playAd = function(ad) {\n  var activeCreativeRendition, adId, adInstance, adType, metadata, pod, _ref;\n  pod = this.getPodById(ad.getCustomId());\n  if ((pod != null ? pod.locked : void 0) === true) {\n    this.onSlotEnded({\n      slot: pod.metadata,\n      skipped: true\n    });\n    return;\n  }\n  metadata = {\n    adtype: ad.getType()\n  };\n  adInstance = ad != null ? (_ref = ad.getAdInstances()) != null ? _ref[0] : void 0 : void 0;\n  if (adInstance != null) {\n    adId = adInstance.getAdId();\n    metadata.adunit = adInstance.getSoAdUnit();\n    activeCreativeRendition = adInstance.getActiveCreativeRendition();\n    if (activeCreativeRendition != null) {\n      this.updateAdMetadata(ad, metadata);\n    }\n  }\n  if (!(adId != null)) {\n    adId = ad.getCustomId();\n  }\n  this.adVO = new AdVO(adId, ad.getCustomId(), (activeCreativeRendition != null ? activeCreativeRendition.getDuration() : adInstance != null ? adInstance.getDuration() : void 0), this.adPosition, ad.getTimePositionClass().toLowerCase(), \"freewheel\", null, null, null, metadata, ad.getAdCount());\n  this.sendNotification(AdNotifications.AD_LOADED, this.adVO);\n  this.sendNotification(AdNotifications.AD_DURATION_CHANGE, this.adVO);\n  adType = typeof ad.getTimePositionClass === \"function\" ? ad.getTimePositionClass() : void 0;\n  if (adType !== tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY) {\n    this.context.setVideoState(tv.freewheel.SDK.VIDEO_STATE_STOPPED);\n    this.getMediaElement().load();\n  }\n  if (adType === tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY) {\n    this.isOverlayDisplayed = true;\n  }\n  ad.play();\n};\n\n/** @override\n*/\nFreeWheelProxy.prototype.start = function() {\n  this.mediaChanging = false;\n  if (this.canPlay() === true) {\n    this.startAd();\n  } else {\n    this.playWhenLoaded = true;\n  }\n  return true;\n};\n\n/**\n*/\nFreeWheelProxy.prototype.canPlay = function() {\n  return this.initialized === true;\n};\n\n/**\n*/\nFreeWheelProxy.prototype.startAd = function() {\n  var adLocked, id, slot, _i, _len, _ref, _ref1;\n  this.playWhenLoaded = false;\n  if (this.prerollSlots.length) {\n    adLocked = false;\n    _ref = this.prerollSlots;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      slot = _ref[_i];\n      id = slot.getCustomId();\n      if (((_ref1 = this.getPodById(id)) != null ? _ref1.locked : void 0) === true) {\n        adLocked = true;\n      }\n      if (adLocked) {\n        this.breakEnd();\n      } else {\n        slot = this.prerollSlots[0];\n        this.startBreak(this.getPodById(slot.getCustomId()));\n        this.playAd(slot);\n      }\n    }\n  } else {\n    this.endBreak();\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.play = function() {\n  var _ref;\n  FreeWheelProxy.__super__.play.call(this);\n  this.getMediaElement().play();\n  if ((_ref = this.slot) != null) {\n    _ref.resume();\n  }\n  if (this.terminateAdOnPlay === true) {\n    this.terminateAdOnPlay = false;\n    this.terminateAd();\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.pause = function() {\n  var video, _ref;\n  FreeWheelProxy.__super__.pause.call(this);\n  video = this.getMediaElement();\n  video.pause();\n  if ((_ref = this.slot) != null) {\n    _ref.pause();\n  }\n  setTimeout(function() {\n    return video.controls = false;\n  }, 0);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.breakEnd = function() {\n  var video,\n    _this = this;\n  FreeWheelProxy.__super__.breakEnd.call(this);\n  if (this.playbackCore == null) {\n    this.playbackCore = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore();\n  }\n  video = this.getMediaElement();\n  video.removeEventListener(\"playing\", this.playbackCore.handlers.playing);\n  video.removeEventListener(\"pause\", this.playbackCore.handlers.pause);\n  video.removeEventListener(\"waiting\", this.playbackCore.handlers.waiting);\n  video.removeEventListener(\"seeking\", this.handlers.seekupdate);\n  clearInterval(this.timeout);\n  if (this.appState.getEnded()) {\n    this.context.setVideoState(tv.freewheel.SDK.VIDEO_STATE_COMPLETED);\n  } else if (this.mediaChanging !== true) {\n    this.playbackCore.setEnabled(true);\n    setTimeout(function() {\n      _this.contentPlay();\n      if (_this.playbackRate != null) {\n        _this.facade.player.playbackRate = _this.playbackRate;\n        _this.playbackRate = null;\n      }\n      _this.getMediaElement().addEventListener(\"playing\", _this.handlers.onResume);\n    }, 1);\n    setTimeout(function() {\n      _this.engageMidrollCheck();\n      _this.engageOverlayCheck();\n    }, 500);\n    return;\n  }\n};\n\n/** @override\n*/\nFreeWheelProxy.prototype.contentStarted = function() {\n  this.engageMidrollCheck();\n  this.engageOverlayCheck();\n};\n\n/** @override\n*/\nFreeWheelProxy.prototype.contentSeek = function(time) {\n  var nextime;\n  if (this.appState.getSeekRequested() === true) {\n    return;\n  }\n  this.nextMidroll = this.getPreviousMidroll(time);\n  this.nextOverlay = this.getPreviousOverlay(time);\n  if (!(this.nextMidroll != null)) {\n    this.nextMidroll = this.getNextMidroll(time);\n    if (this.nextMidroll != null) {\n      nextime = this.nextMidroll.getTimePosition();\n      if (nextime - time < 1 || time < nextime) {\n        this.nextMidroll = null;\n      }\n    }\n    return;\n  }\n  if (!(this.nextOverlay != null)) {\n    this.nextOverlay = this.getNextOverlay(time);\n    return;\n  }\n  if (!this.midrollEngaged) {\n    this.engageMidrollCheck();\n  }\n  if (!this.overlayEngaged) {\n    this.engageOverlayCheck();\n  }\n};\n\n/** @override\n*/\nFreeWheelProxy.prototype.contentEnded = function() {\n  var _ref,\n    _this = this;\n  this.context.setVideoState(tv.freewheel.SDK.VIDEO_STATE_STOPPED);\n  if (((_ref = this.postrollSlots) != null ? _ref.length : void 0)) {\n    setTimeout(function() {\n      var slot;\n      slot = _this.postrollSlots[0];\n      _this.startBreak(_this.getPodById(slot.getCustomId()));\n      _this.playAd(slot);\n    }, 0);\n  } else {\n    this.context.setVideoState(tv.freewheel.SDK.VIDEO_STATE_COMPLETED);\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.engageMidrollCheck = function() {\n  var _ref;\n  if (((_ref = this.midrollSlots) != null ? _ref.length : void 0) === 0 || this.midrollEngaged === true) {\n    return;\n  }\n  this.midrollEngaged = true;\n  this.getMediaElement().addEventListener(\"timeupdate\", this.handlers.timeupdate);\n};\n\nFreeWheelProxy.prototype.disengageMidrollCheck = function() {\n  this.midrollEngaged = false;\n  this.getMediaElement().removeEventListener(\"timeupdate\", this.handlers.timeupdate);\n};\n\nFreeWheelProxy.prototype.engageOverlayCheck = function() {\n  var _ref;\n  if (((_ref = this.overlaySlotsArray) != null ? _ref.length : void 0) === 0 || this.overlayEngaged === true) {\n    return;\n  }\n  this.overlayEngaged = true;\n  this.getMediaElement().addEventListener(\"timeupdate\", this.handlers.overlaytimeupdate);\n};\n\nFreeWheelProxy.prototype.disengageOverlayCheck = function() {\n  this.overlayEngaged = false;\n  this.getMediaElement().removeEventListener(\"timeupdate\", this.handlers.overlaytimeupdate);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.midrollCheck = function(event) {\n  var count, cur, next, nextime, pod, time, _base;\n  if (this.getMediaElement().paused) {\n    return;\n  }\n  if (this.appState.getSeeking() === true || this.appState.getSeekRequested() === true) {\n    return;\n  }\n  time = this.playbackCore.getCurrentTime();\n  if (!(this.nextMidroll != null)) {\n    next = this.getNextMidroll(time);\n    cur = this.getPreviousMidroll(time);\n    if ((cur != null) && time >= (cur != null ? cur.getTimePosition() : void 0) && (!(next != null) || ((next != null) && time <= next.getTimePosition()))) {\n      this.nextMidroll = cur;\n    }\n    return;\n  }\n  nextime = this.nextMidroll.getTimePosition();\n  if (time < nextime) {\n    return;\n  }\n  count = typeof (_base = this.nextMidroll).getAdCount === \"function\" ? _base.getAdCount() : void 0;\n  pod = this.getPodById(this.nextMidroll.getCustomId());\n  if (!(count != null) || pod.locked) {\n    return;\n  }\n  if (count === 0) {\n    this.onSlotEnded({\n      slot: this.nextMidroll,\n      skipped: true\n    });\n    return;\n  }\n  this.disengageMidrollCheck();\n  this.disengageOverlayCheck();\n  this.adVO.type = \"midroll\";\n  this.startBreak(this.getPodById(this.nextMidroll.getCustomId()));\n  this.engageAds();\n  this.playAd(this.nextMidroll);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.getNextMidroll = function(time) {\n  var midroll, _i, _len, _ref;\n  time = time >= 0 ? time : 0;\n  _ref = this.midrollSlots;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    midroll = _ref[_i];\n    if (time < midroll.getTimePosition()) {\n      return midroll;\n    }\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.getPreviousMidroll = function(time) {\n  var midroll, pod, pods, _i, _len;\n  pods = this.pods.slice().reverse();\n  for (_i = 0, _len = pods.length; _i < _len; _i++) {\n    pod = pods[_i];\n    if (!(pod.type === \"midroll\")) {\n      continue;\n    }\n    midroll = pod.metadata;\n    if (time > midroll.getTimePosition()) {\n      if (pod.locked !== true) {\n        return midroll;\n      } else {\n        return null;\n      }\n    }\n  }\n};\n\nFreeWheelProxy.prototype.overlayCheck = function(event) {\n  var count, _base;\n  if (this.getMediaElement().paused) {\n    return;\n  }\n  if (this.appState.getSeeking() === true || this.appState.getSeekRequested() === true) {\n    return;\n  }\n  if (!(this.nextOverlay != null)) {\n    this.nextOverlay = this.getNextOverlay(this.playbackCore.getCurrentTime());\n    return;\n  }\n  if (this.playbackCore.getCurrentTime() < this.nextOverlay.getTimePosition()) {\n    return;\n  }\n  count = typeof (_base = this.nextOverlay).getAdCount === \"function\" ? _base.getAdCount() : void 0;\n  if (!(count != null)) {\n    return;\n  }\n  if (count === 0) {\n    this.onSlotEnded({\n      slot: this.nextOverlay,\n      skipped: true\n    });\n    return;\n  }\n  this.disengageOverlayCheck();\n  this.adVO.type = \"overlay\";\n  this.playAd(this.nextOverlay);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.getNextOverlay = function(time) {\n  var overlay, _i, _len, _ref;\n  time = time >= 0 ? time : 0;\n  _ref = this.overlaySlotsArray;\n  for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n    overlay = _ref[_i];\n    if (time < overlay.getTimePosition()) {\n      return overlay;\n    }\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.getPreviousOverlay = function(time) {\n  var overlay, pod, pods, _i, _len;\n  pods = this.pods.slice().reverse();\n  for (_i = 0, _len = pods.length; _i < _len; _i++) {\n    pod = pods[_i];\n    if (!(pod.type === \"overlay\")) {\n      continue;\n    }\n    overlay = pod.metadata;\n    if (time > overlay.getTimePosition()) {\n      if (pod.locked !== true) {\n        return overlay;\n      } else {\n        return null;\n      }\n    }\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.terminateAd = function(stopactive) {\n  if (stopactive === null) {\n    stopactive = false;\n  }\n  if (this.started === true && this.getMediaElement().paused === true && stopactive === false) {\n    this.terminateAdOnPlay = true;\n    return;\n  }\n  if (this.slot != null) {\n    if (this.slot.getTimePositionClass() === tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL) {\n      this.sendNotification(Notifications.HAS_POST_CONTENT, false);\n    }\n    if (stopactive === true) {\n      this.slot.stop();\n    }\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.terminateAllAds = function(listeners) {\n  if (listeners === true && (this.context != null)) {\n    this.context.removeEventListener(tv.freewheel.SDK.EVENT_REQUEST_COMPLETE, this.handlers.onRequestComplete);\n    this.context.removeEventListener(tv.freewheel.SDK.EVENT_SLOT_STARTED, this.handlers.onSlotStarted);\n    this.context.removeEventListener(tv.freewheel.SDK.EVENT_SLOT_ENDED, this.handlers.onSlotEnded);\n    this.context.removeEventListener(tv.freewheel.SDK.EVENT_AD_IMPRESSION, this.handlers.onAdImpression);\n    this.context.removeEventListener(tv.freewheel.SDK.EVENT_AD_IMPRESSION_END, this.handlers.onAdImpressionEnd);\n    this.context.removeEventListener(tv.freewheel.SDK.EVENT_ERROR, this.handlers.onAdEvent);\n  }\n  this.terminateAd();\n  this.clearSlots();\n  this.disengageMidrollCheck();\n  this.disengageOverlayCheck();\n  this.sendNotification(Notifications.HAS_POST_CONTENT, false);\n  this.isOverlayDisplayed = false;\n  /**\n  */\n};\n\nFreeWheelProxy.prototype.clearSlots = function() {\n  this.prerollSlots = [];\n  this.midrollSlots = [];\n  this.postrollSlots = [];\n  this.overlaySlotsArray = [];\n  this.slot = null;\n  this.nextMidroll = null;\n};\n\n/**\n*/\nFreeWheelProxy.prototype.getCreativeParameters = function(instance) {\n  var param, payload, value, _i, _len, _ref;\n  if (this.config.creativeParameters && instance) {\n    value = null;\n    payload = {};\n    _ref = this.config.creativeParameters;\n    for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n      param = _ref[_i];\n      value = null;\n      try {\n        value = instance.getActiveCreativeRendition().getParameter(param);\n      } catch (error) {\n        this.facade.logger.warn(\"[AMP FREEWHEEL WARNING]\", \"Could not retrieve Freewheel creative parameter: \" + param, error);\n      } finally {\n        if (value) {\n          payload[param] = value;\n        }\n      }\n    }\n  }\n  return payload;\n};\n\nFreeWheelProxy.prototype.contentPaused = function() {\n  if (!this.getInProgress()) {\n    this.context.setVideoState(tv.freewheel.SDK.VIDEO_STATE_PAUSED);\n    this.getMediaElement().addEventListener(\"playing\", this.handlers.onResume);\n  }\n};\n\n/**\n*/\nFreeWheelProxy.prototype.setVolume = function(value) {\n  var _ref;\n  if ((_ref = this.context) != null) {\n    _ref.setAdVolume(value);\n  }\n  return value;\n};\n\n/**\n*/\nFreeWheelProxy.prototype.destroy = function() {\n  this.terminateAllAds(true);\n};\n\n/**\n*/\nFreeWheelProxy.prototype.updateAdMetadata = function(ad, metadata) {\n  var creativeParameters, id, instance, key, rendition, val, _i, _len, _ref;\n  if ((ad != null) && (metadata != null)) {\n    metadata.time = ad.getTimePosition();\n    instance = ad.getCurrentAdInstance();\n    if (instance != null) {\n      rendition = instance.getActiveCreativeRendition();\n    }\n    if (rendition != null) {\n      for (key in rendition) {\n        val = rendition[key];\n        if (key.indexOf('get') === 0 && typeof val === 'function') {\n          metadata[key.substring(3).toLowerCase()] = val.call(rendition);\n        }\n      }\n      metadata.baseunit = rendition.getBaseUnit();\n      creativeParameters = this.value.creativeParameters;\n      if (creativeParameters != null) {\n        metadata.creativeparameters = {};\n        _ref = ad.getAdInstances();\n        for (_i = 0, _len = _ref.length; _i < _len; _i++) {\n          instance = _ref[_i];\n          id = instance.getAdId();\n          metadata.creativeparameters[id] = this.getCreativeParameters(instance);\n        }\n      }\n    }\n  }\n  return metadata;\n};\n\n/**\n*/\nFreeWheelProxy.prototype.replay = function() {\n  this.playWhenLoaded = true;\n};\n\n/** \n * The StatsPlugin class.\n *   \n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction StatsPlugin() {\n  StatsPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(StatsPlugin, Plugin);\n\n\nStatsPlugin.prototype.moduleName = \"stats\";\n\n/** @override\n*/\nStatsPlugin.prototype.createModel = function() {\n  this.proxy = new StatsProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nStatsPlugin.prototype.createController = function() {\n  StatsPlugin.__super__.createController.call(this);\n  this.registerCommand(StatsNotifications.VISIBILITY_CHANGE, StatsVisibilityChangeCommand);\n};\n\n/** @override\n*/\nStatsPlugin.prototype.createView = function() {\n  this.registerMediator(new StatsMediator());\n};\n\n/**\n*/\nStatsPlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.PLAYING, Notifications.TIME_UPDATE];\n};\n\n/** @override\n*/\nStatsPlugin.prototype.listNotificationPublications = function() {\n  return StatsPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE, StatsNotifications.VISIBILITY_CHANGE]);\n};\n\n/**\n * @return   {boolean}  A boolean indicating whether or not the stats are hidden.\n * @expose\n*/\nStatsPlugin.prototype.getHidden = function() {\n  return this.proxy.getHidden();\n};\n\n/**\n * \n * @param   {boolean} value A boolean indicating whether or not the stats are hidden.\n * @expose\n*/\nStatsPlugin.prototype.setHidden = function(value) {\n  this.sendNotification(StatsNotifications.VISIBILITY_CHANGE, value);\n  return value;\n};\n\n\nAMP.registerPlugin(\"stats\", \"html\", StatsPlugin);\n\n/** \n * The IMAProxy class.\n *   \n * @constructor\n * @private \n * @extends {AdProxy}\n * @param {Object} config\n*/\nfunction MOATProxy(config) {\n  MOATProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(MOATProxy, PluginProxy);\n\n\n/** @static\n*/\nMOATProxy.NAME = ModuleProxy.NAME;\n\nMOATProxy.prototype.defaults = {\n  data: {\n    partnerCode: null\n  }\n};\n\n/**\n*/\nMOATProxy.prototype.initSDK = function(adsManagerVO) {\n  var data, _ref;\n  if (typeof initMoatTracking !== \"undefined\" && initMoatTracking !== null) {\n    data = (_ref = this.getConfigurationData()) != null ? _ref.data : void 0;\n    initMoatTracking(adsManagerVO.adManager, {\n      \"partnerCode\": data.partnerCode,\n      \"viewMode\": adsManagerVO.viewMode,\n      \"slicer1\": data.slicer1,\n      \"slicer2\": data.slicer2\n    }, adsManagerVO.adContainer);\n  }\n};\n\nfunction MOATWrapper() {\n  return MOATWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(MOATWrapper, PluginWrapper);\n\n\nMOATWrapper.NAME = \"MOATWrapper\";\n\nMOATWrapper.prototype.flashPlugins = [\n  {\n    id: \"MOATAnalyticsPlugin\",\n    src: '#{paths.resources}plugins/MOATAnalyticsPlugin.swf',\n    blocking: false,\n    host: \"akamai\",\n    main: \"MOATAnalyticsPlugin\"\n  }\n];\n\n/** @override\n*/\nMOATWrapper.prototype.createXML = function(xml) {\n  var application, metrics, prop, props, vendor, _i, _len;\n  application = xml.firstChild;\n  metrics = xml.getElementsByTagName(\"metrics\")[0];\n  if (!(metrics != null)) {\n    metrics = xml.createElement(\"metrics\");\n    application.appendChild(metrics);\n  }\n  vendor = xml.createElement(\"vendor\");\n  vendor.setAttribute(\"id\", \"moat\");\n  metrics.appendChild(vendor);\n  props = [\n    {\n      value: this.config.data.partnerCode,\n      key: \"partnerCode\"\n    }, {\n      value: this.config.data.slicer1,\n      key: \"slicer1\"\n    }, {\n      value: this.config.data.slicer2,\n      key: \"slicer2\"\n    }\n  ];\n  for (_i = 0, _len = props.length; _i < _len; _i++) {\n    prop = props[_i];\n    if (prop.value != null) {\n      this.createProperty(xml, prop.key, prop.value, vendor);\n    }\n  }\n  return xml;\n};\n\n/**\n * The MOATAdManagerLoadedCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction MOATAdManagerLoadedCommand() {\n  MOATAdManagerLoadedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(MOATAdManagerLoadedCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nMOATAdManagerLoadedCommand.prototype.execute = function(notification) {\n  var moatProxy;\n  moatProxy = this.facade.retrieveProxy(MOATProxy.NAME);\n  if (notification.getBody()) {\n    moatProxy.initSDK(notification.getBody());\n  }\n};\n\n/** \n * @constructor \n * @private\n*/\nfunction FreeWheelPlugin() {\n  FreeWheelPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(FreeWheelPlugin, AdPlugin);\n\n\nFreeWheelPlugin.prototype.moduleName = \"freewheel\";\n\nFreeWheelPlugin.prototype.featureName = \"ads\";\n\n/** @override\n*/\nFreeWheelPlugin.prototype.createProxy = function() {\n  return new FreeWheelProxy(this.config);\n};\n\n/** @override\n*/\nFreeWheelPlugin.prototype.isFullscreenDevice = function() {\n  return false;\n};\n\n\nAMP.registerPlugin(\"freewheel\", \"html\", FreeWheelPlugin);\nAMP.registerPlugin(\"freewheel\", \"flash\", FreeWheelWrapper);\n\n/**\n * DASHPlaybackProxy constructor.\n *\n * @constructor\n * @private\n * @extends {PlaybackCoreProxy}\n*/\nfunction DASHPlaybackProxy(data, plugin) {\n  this.plugin = plugin;\n  DASHPlaybackProxy.__super__.constructor.call(this, data.types, data);\n  this.buffer = data.buffer;\n  this.temporalTypes = [\"vod\", \"live\", \"dvr\"];\n}\n\n\n__extends(DASHPlaybackProxy, PlaybackCoreProxy);\n\n\nDASHPlaybackProxy.SCTE = \"urn:scte:scte35:2013:xml\";\n\nDASHPlaybackProxy.prototype.playbackCoreName = \"dash\";\n\nDASHPlaybackProxy.prototype.context = null;\n\nDASHPlaybackProxy.prototype.player = null;\n\nDASHPlaybackProxy.prototype.buffer = null;\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.resumecomplete = function() {\n  var track, tracks, _ref;\n  try {\n    tracks = (_ref = this.facade.getMediaElement()) != null ? _ref.textTracks : void 0;\n    if ((tracks != null ? tracks.length : void 0) !== 0) {\n      track = tracks[0];\n      if (track != null) {\n        track.mode = \"hidden\";\n      }\n    }\n  } catch (error) {\n\n  }\n  DASHPlaybackProxy.__super__.resumecomplete.call(this);\n};\n\nDASHPlaybackProxy.prototype.onerror = function() {};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.ontimeupdate = function(event) {\n  DASHPlaybackProxy.__super__.ontimeupdate.call(this, {\n    target: {\n      currentTime: this.getCurrentTime()\n    }\n  });\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.onseeked = function(event) {\n  DASHPlaybackProxy.__super__.onseeked.call(this, {\n    target: {\n      currentTime: this.getCurrentTime()\n    }\n  });\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.onseeking = function(event) {\n  DASHPlaybackProxy.__super__.onseeking.call(this, {\n    target: {\n      currentTime: this.getCurrentTime()\n    }\n  });\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.ondurationchange = function(event) {\n  DASHPlaybackProxy.__super__.ondurationchange.call(this, {\n    target: {\n      duration: this.getDuration()\n    }\n  });\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.onloadedmetadata = function(event) {\n  DASHPlaybackProxy.__super__.onloadedmetadata.call(this, event);\n  this.sendNotification(Notifications.CHANGE_DURATION, this.getDuration());\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.oncanplaythrough = function(event) {\n  DASHPlaybackProxy.__super__.oncanplaythrough.call(this, event);\n  this.sendNotification(Notifications.CHANGE_DURATION, this.getDuration());\n};\n\n/**\n *\n*/\nDASHPlaybackProxy.prototype.canPlayMedium = function(medium) {\n  return DASHPlaybackProxy.__super__.canPlayMedium.call(this, medium) || medium === \"audio\";\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.createTracks = function() {\n  var audio, changeEnabled, count, current, index, item, track, tracks, _i, _len;\n  audio = this.player.getTracksFor(\"audio\");\n  current = this.player.getCurrentTrackFor(\"audio\");\n  tracks = this.facade.tracks.getAudioTracks();\n  count = audio.length;\n  changeEnabled = function(audio, track, enabled) {\n    var _this = this;\n    this.facade.tracks.getAudioTracks().forEach(function(item) {\n      return item.data.enabled = item === track;\n    });\n    if (enabled !== true) {\n      return;\n    }\n    this.player.setCurrentTrack(audio);\n  };\n  for (index = _i = 0, _len = audio.length; _i < _len; index = ++_i) {\n    item = audio[index];\n    if (Utils.fieldIsUnique(tracks, 'id', item.id) === false) {\n      continue;\n    }\n    track = new Track({\n      kind: item.roles.join(\" \"),\n      label: item.id,\n      language: item.lang,\n      id: item.id,\n      enabled: item === current,\n      data: item\n    });\n    track.changeEnabled = changeEnabled.bind(this, item, track);\n    tracks.add(track, index + 1 === count);\n  }\n};\n\n/**\n*/\nDASHPlaybackProxy.prototype.getUseMAE = function() {\n  return DASHPlaybackProxy.__super__.getUseMAE.call(this) && (typeof MediaAccelerationDashJsWrapper !== \"undefined\" && MediaAccelerationDashJsWrapper !== null);\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.load = function() {\n  var useMAE, _ref;\n  if (!(this.player != null)) {\n    useMAE = ((_ref = this.config.mae) != null ? _ref.enabled : void 0) !== false && (typeof MediaAccelerationDashJsWrapper !== \"undefined\" && MediaAccelerationDashJsWrapper !== null);\n    if (!this.getUseMAE()) {\n      this.player = dashjs.MediaPlayer().create();\n    } else {\n      this.facade.mae = new MediaAccelerationDashJsWrapper(this.config.mae);\n      this.player = this.facade.mae.getPlayer();\n    }\n    this.player.on(\"error\", this.onError.bind(this));\n    this.player.on(\"fragmentLoadingStarted\", this.onFragmentLoadStart.bind(this));\n    this.player.on(\"fragmentLoadingCompleted\", this.onFragmentLoaded.bind(this));\n    this.player.on(\"qualityChangeRequested\", this.onLevelSwitching.bind(this));\n    this.player.on(dashjs.MediaPlayer.events.MANIFEST_LOADED, this.onManifestLoaded.bind(this));\n    this.player.on(dashjs.Protection.events.PROTECTION_CREATED, this.onProtectionCreated.bind(this));\n    this.player.on(DASHPlaybackProxy.SCTE, this.onEmsg.bind(this));\n    this.player.getDebug().setLogToBrowserConsole(this.plugin.proxy.getDebug());\n    this.player.initialize(this.getMediaElement(), null, true);\n    if (this.config.initialBitrate != null) {\n      this.player.setInitialBitrateFor(this.facade.getMedia().medium, this.config.initialBitrate);\n    }\n  }\n  DASHPlaybackProxy.__super__.load.call(this);\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.applySrc = function() {\n  var keys;\n  keys = this.facade.getMedia().keys;\n  if (keys != null) {\n    this.player.setProtectionData(keys);\n  }\n  this.player.attachSource(this.getSrc());\n  this.getMediaElement().load();\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.seek = function(value) {\n  return Promise.resolve(this.player.seek(value));\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.getCurrentTime = function() {\n  var _ref;\n  return ((_ref = this.player) != null ? _ref.time() : void 0) || 0;\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.getDuration = function() {\n  var _ref;\n  return ((_ref = this.player) != null ? _ref.duration() : void 0) || 0;\n};\n\n/**\n*/\nDASHPlaybackProxy.prototype.getStats = function() {\n  return {};\n};\n\n/**\n*/\nDASHPlaybackProxy.prototype.onFragmentLoadStart = function(event) {\n  var bitrate;\n  bitrate = event.request.mediaInfo.bitrateList[event.request.quality].bandwidth;\n  this.sendNotification(Notifications.FRAGMENT_LOAD_START, bitrate);\n};\n\n/**\n*/\nDASHPlaybackProxy.prototype.onFragmentLoaded = function(event) {\n  var bitrate;\n  bitrate = event.request.mediaInfo.bitrateList[event.request.quality].bandwidth;\n  this.sendNotification(Notifications.FRAGMENT_LOADED, bitrate);\n};\n\n/**\n*/\nDASHPlaybackProxy.prototype.onLevelSwitching = function(event) {\n  this.sendNotification(Notifications.QUALITY_CHANGING, this.getQualityLevels()[event.newQuality]);\n};\n\nDASHPlaybackProxy.prototype.onManifestLoaded = function(event) {\n  var data;\n  data = event.data;\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(dashjs.MediaPlayer.events.MANIFEST_LOADED, data));\n};\n\nDASHPlaybackProxy.prototype.onProtectionCreated = function(event) {\n  var data;\n  data = event.data;\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(dashjs.Protection.events.PROTECTION_CREATED, data));\n};\n\nDASHPlaybackProxy.prototype.onEmsg = function(event) {\n  var Cue, cue, data, end, info, start, text;\n  data = event.event;\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(event.type, data));\n  Cue = DataCue || VTTCue;\n  start = (data.presentationTime / data.presentationTimeDelta) * 10000;\n  end = start + (data.duration / data.presentationTimeDelta) * 10000;\n  text = String.fromCharCode.apply(null, data.messageData);\n  info = XMLUtils.parse(text);\n  data.text = text;\n  cue = new Cue(start, end, {\n    key: DASHPlaybackProxy.SCTE,\n    data: data,\n    info: info\n  });\n  this.sendNotification(Notifications.TIMED_METADATA, cue);\n};\n\n/**\n*/\nDASHPlaybackProxy.prototype.onError = function(event) {\n  this.facade.logger.error(\"DASH JS Playback Error:\", event);\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.setQuality = function(value) {\n  var _ref, _ref1, _ref2;\n  if ((_ref = this.player) != null) {\n    _ref.setAutoSwitchQualityFor((_ref1 = this.facade.getMedia()) != null ? _ref1.medium : void 0, value === -1);\n  }\n  if (value === -1) {\n    return;\n  }\n  return (_ref2 = this.player) != null ? _ref2.setQualityFor(\"video\", value) : void 0;\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.getQuality = function() {\n  var _ref;\n  return (_ref = this.player) != null ? _ref.getQualityFor(\"video\") : void 0;\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.getQualityLevels = function() {\n  var _ref;\n  return ((_ref = this.player) != null ? _ref.getBitrateInfoListFor(\"video\") : void 0) || DASHPlaybackProxy.__super__.getQualityLevels.call(this);\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.getQualityMode = function() {\n  var _ref, _ref1;\n  if (((_ref = this.player) != null ? _ref.getAutoSwitchQualityFor((_ref1 = this.facade.getMedia()) != null ? _ref1.medium : void 0) : void 0) === true) {\n    return \"auto\";\n  } else {\n    return \"abr\";\n  }\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.setQualityMode = function(value) {\n  var _ref, _ref1;\n  if (value !== \"auto\") {\n    return value + \" is not a valid key\";\n  }\n  return (_ref = this.player) != null ? _ref.setAutoSwitchQualityFor((_ref1 = this.facade.getMedia()) != null ? _ref1.medium : void 0, value) : void 0;\n};\n\n/** @override\n*/\nDASHPlaybackProxy.prototype.destroy = function() {\n  if (!(this.player != null)) {\n    return;\n  }\n  this.player.reset();\n  DASHPlaybackProxy.__super__.destroy.call(this);\n};\n\n/**\n * The DASHChangeDisplayStateCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction DASHChangeDisplayStateCommand() {\n  DASHChangeDisplayStateCommand.__super__.constructor.call(this);\n}\n\n\n__extends(DASHChangeDisplayStateCommand, puremvc.SimpleCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nDASHChangeDisplayStateCommand.prototype.execute = function(notification) {\n  var core, fullscreen, playback, proxy, state, target,\n    _this = this;\n  state = notification.getBody();\n  playback = this.facade.retrieveProxy(PlaybackProxy.NAME);\n  core = this.facade.getMediaElement();\n  if (!(core != null) || !core.webkitSupportsFullscreen) {\n    return;\n  }\n  proxy = this.facade.retrieveProxy(ApplicationStateProxy.NAME);\n  proxy.setDisplayState(state);\n  fullscreen = {};\n  target = this.facade.viewComponent;\n  if (target.requestFullscreen != null) {\n    fullscreen.enter = function() {\n      return target.requestFullscreen();\n    };\n    fullscreen.exit = function() {\n      return document.cancelFullscreen();\n    };\n    fullscreen.event = \"onfullscreenchange\";\n    fullscreen.element = \"fullscreenElement\";\n  } else if (target.webkitRequestFullScreen != null) {\n    fullscreen.enter = function() {\n      return target.webkitRequestFullScreen();\n    };\n    fullscreen.exit = function() {\n      return document.webkitCancelFullScreen();\n    };\n    fullscreen.event = \"onwebkitfullscreenchange\";\n    fullscreen.element = \"webkitFullscreenElement\";\n  } else if (target.mozRequestFullScreen != null) {\n    fullscreen.enter = function() {\n      return target.mozRequestFullscreen();\n    };\n    fullscreen.exit = function() {\n      return document.mozCancelFullScreen();\n    };\n    fullscreen.event = \"onmozfullscreenchange\";\n    fullscreen.element = \"mozFullscreenElement\";\n  } else if (target.msRequestFullScreen != null) {\n    fullscreen.enter = function() {\n      return target.msRequestFullscreen();\n    };\n    fullscreen.exit = function() {\n      return document.msCancelFullScreen();\n    };\n    fullscreen.event = \"onmozfullscreenchange\";\n    fullscreen.element = \"mozFullscreenElement\";\n  }\n  if (state === DisplayState.FULL_SCREEN) {\n    fullscreen.enter();\n    if (fullscreen.event != null) {\n      core[fullscreen.event] = function(event) {\n        if (!(document[fullscreen.element] != null)) {\n          return _this.sendNotification(Notifications.CHANGE_DISPLAY_STATE, DisplayState.NORMAL);\n        }\n      };\n    }\n  } else if (state === DisplayState.NORMAL) {\n    fullscreen.exit();\n    core[fullscreen.event] = null;\n  }\n  this.facade.dispatchEvent(new Event(\"fullscreenchange\", state === DisplayState.FULL_SCREEN));\n};\n\n/** \n * @param {Object}  config  The plugin configuration object.\n * @constructor\n * @private\n * @extends {PluginProxy}\n*/\nfunction PlaybackPluginProxy(config) {\n  PlaybackPluginProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(PlaybackPluginProxy, PluginProxy);\n\n\n/** @static\n*/\nPlaybackPluginProxy.NAME = ModuleProxy.NAME;\n\nPlaybackPluginProxy.prototype.playbackProxy = null;\n\nPlaybackPluginProxy.prototype.createPlaybackProxy = function() {};\n\nPlaybackPluginProxy.prototype.initialize = function() {\n  var player;\n  this.playbackProxy = this.createPlaybackProxy();\n  if (!(this.playbackProxy != null)) {\n    return;\n  }\n  this.sendNotification(Notifications.INITIALIZED);\n  player = this.facade.player.retrieveProxy(PlayerProxy.NAME);\n  player.registerPlaybackCore(this.playbackProxy);\n};\n\nPlaybackPluginProxy.prototype.destroy = function() {\n  var _ref;\n  if ((_ref = this.playbackProxy) != null) {\n    _ref.destroy();\n  }\n};\n\n/** \n * The DASHProxy class.\n *   \n * @param {Object}  config  The plugin configuration object.\n * @constructor\n * @private\n * @extends {PluginProxy}\n*/\nfunction DASHProxy(config) {\n  DASHProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(DASHProxy, PlaybackPluginProxy);\n\n\n/** @static\n*/\nDASHProxy.NAME = ModuleProxy.NAME;\n\nDASHProxy.prototype.defaults = {\n  types: [\"application/dash+xml\"],\n  buffer: null,\n  mae: null,\n  initialBitrate: null\n};\n\nDASHProxy.prototype.createPlaybackProxy = function() {\n  var mediaSource;\n  mediaSource = window.MediaSource || window.WebKitMediaSource;\n  if (!(mediaSource != null)) {\n    return;\n  }\n  return new DASHPlaybackProxy(this.getConfigurationData(), this.facade);\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar ChromeCastConstants = {\n  CHANNEL_ID: \"urn:x-cast:com.akamai.amp.cast\",\n  APPLICATION_ID: \"CC1AD845\",\n  SUPPORTED_TYPES: [Utils.mimeTypes.m3u8, Utils.mimeTypes.mp4, Utils.mimeTypes.mpd, Utils.mimeTypes.ism, Utils.mimeTypes.webm, Utils.mimeTypes.mp3]\n};\n\n/**\n * The MOATPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {AdPlugin}\n*/\nfunction MOATPlugin() {\n  MOATPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(MOATPlugin, Plugin);\n\n\nMOATPlugin.prototype.moduleName = \"moat\";\n\n/** @override\n*/\nMOATPlugin.prototype.createModel = function() {\n  this.proxy = new MOATProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nMOATPlugin.prototype.createController = function() {\n  MOATPlugin.__super__.createController.call(this);\n  return this.registerCommand(AdNotifications.AD_MANAGER_LOADED, MOATAdManagerLoadedCommand);\n};\n\n/** @override\n*/\nMOATPlugin.prototype.listNotificationInterests = function() {\n  return [AdNotifications.AD_MANAGER_LOADED];\n};\n\n\nAMP.registerPlugin(\"moat\", \"html\", MOATPlugin);\nAMP.registerPlugin(\"moat\", \"flash\", MOATWrapper);\n\n/**\n * The ChromeCastLaunchCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastLaunchCommand() {\n  ChromeCastLaunchCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastLaunchCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nChromeCastLaunchCommand.prototype.execute = function(notification) {\n  this.proxy.launch();\n};\n\n/**\n * The ChromeCastCaptioningVisibilityChangeCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastCaptioningVisibilityChangeCommand() {\n  ChromeCastCaptioningVisibilityChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastCaptioningVisibilityChangeCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nChromeCastCaptioningVisibilityChangeCommand.prototype.execute = function(notification) {\n  this.proxy.send({\n    type: \"captioning.visibilitychange\",\n    detail: {\n      visibility: notification.getBody()\n    }\n  });\n};\n\n/**\n * The ChromeCastCaptioningSettingsChangeCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastCaptioningSettingsChangeCommand() {\n  ChromeCastCaptioningSettingsChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastCaptioningSettingsChangeCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nChromeCastCaptioningSettingsChangeCommand.prototype.execute = function(notification) {\n  this.proxy.send({\n    type: \"captioning.settingschange\",\n    detail: notification.getBody()\n  });\n};\n\n/**\n * The ChromeCastBreakStartCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastBreakStartCommand() {\n  ChromeCastBreakStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastBreakStartCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nChromeCastBreakStartCommand.prototype.execute = function(notification) {\n  var playbackCore;\n  this.facade.logger.debug(\"ChromeCastBreakStartCommand\");\n  playbackCore = this.facade.player.retrieveProxy(PlayerProxy.NAME).getActivePlaybackCore();\n  if (playbackCore.getPlaybackCoreName() === \"chromecast\") {\n    playbackCore.unload();\n    playbackCore.src = null;\n  }\n};\n\n/**\n * The ChromeCastSeekCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastMediaChangeCommand() {\n  ChromeCastMediaChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastMediaChangeCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nChromeCastMediaChangeCommand.prototype.execute = function(notification) {\n  if (this.applicationState.getPlaybackTarget() !== \"chromecast\") {\n    return;\n  }\n  this.facade.logger.debug(\"ChromeCastMediaChangeCommand\");\n  this.proxy.loadMedia();\n};\n\n/**\n * The ChromeCastChangeVolumeCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastChangeVolumeCommand() {\n  ChromeCastChangeVolumeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastChangeVolumeCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChromeCastChangeVolumeCommand.prototype.execute = function(notification) {\n  var volume;\n  volume = notification.getBody();\n  this.proxy.setVolume(volume);\n  this.sendNotification(Notifications.VOLUME_CHANGE, volume);\n};\n\n/**\n * The ChromeCastToggleMutedCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastToggleMutedCommand() {\n  ChromeCastToggleMutedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastToggleMutedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChromeCastToggleMutedCommand.prototype.execute = function(notification) {\n  this.proxy.toggleMuted();\n};\n\n/**\n * The ChromeCastSenderMediator class.\n *\n * @constructor\n * @private\n * @extends {PluginMediator}\n*/\nfunction ChromeCastSenderMediator() {\n  ChromeCastSenderMediator.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastSenderMediator, PluginMediator);\n\n\nChromeCastSenderMediator.prototype.componentName = \"chromecast\";\n\nChromeCastSenderMediator.prototype.controls = null;\n\n/**\n * @override\n*/\nChromeCastSenderMediator.prototype.onRegister = function() {\n  ChromeCastSenderMediator.__super__.onRegister.call(this);\n  this.controls = new ChromeCastControlsMediator(false);\n};\n\n/**\n * @override\n*/\nChromeCastSenderMediator.prototype.registerOverlay = function() {};\n\n/**\n * @override\n*/\nChromeCastSenderMediator.prototype.listNotificationInterests = function() {\n  return [Notifications.PLAYBACK_TARGET_CHANGE, Notifications.CHANGE_PLAY_STATE];\n};\n\n/**\n * @override\n*/\nChromeCastSenderMediator.prototype.handleNotification = function(notification) {\n  var body, name, target;\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case Notifications.PLAYBACK_TARGET_CHANGE:\n      target = body.value;\n      if (target === \"chromecast\") {\n        this.facade.registerMediator(this.controls);\n      } else {\n        this.facade.removeMediator(this.controls.getMediatorName());\n      }\n      break;\n    case Notifications.CHANGE_PLAY_STATE:\n      this.controls.setState(body);\n  }\n};\n\n/**\n * The ChromeCastSenderMediator class.\n * \n * @constructor\n * @extends {ChromeCastSenderMediator}\n * @private\n*/\nfunction ChromeCastHTMLSenderMediator() {\n  ChromeCastHTMLSenderMediator.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastHTMLSenderMediator, ChromeCastSenderMediator);\n\n\nChromeCastHTMLSenderMediator.prototype.chromeCastButton = null;\n\n/**\n * @override\n*/\nChromeCastHTMLSenderMediator.prototype.onRegister = function() {\n  ChromeCastHTMLSenderMediator.__super__.onRegister.call(this);\n  this.chromeCastButton = new ChromeCastButtonMediator();\n  this.facade.registerMediator(this.chromeCastButton);\n};\n\n/**\n * @override\n*/\nChromeCastHTMLSenderMediator.prototype.listNotificationInterests = function() {\n  return ChromeCastHTMLSenderMediator.__super__.listNotificationInterests.call(this).concat([ChromeCastNotifications.AVAILABILITY_CHANGE]);\n};\n\n/**\n * @override\n*/\nChromeCastHTMLSenderMediator.prototype.handleNotification = function(notification) {\n  var body, name;\n  ChromeCastHTMLSenderMediator.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case ChromeCastNotifications.AVAILABILITY_CHANGE:\n      if (body === true) {\n        this.sendNotification(Notifications.ADD_CONTROL_STATE, \"chromecast\");\n        this.facade.player.sendNotification(Notifications.ADD_CONTROL, this.chromeCastButton.getViewComponent());\n      } else {\n        this.sendNotification(Notifications.REMOVE_CONTROL_STATE, \"chromecast\");\n        this.facade.player.sendNotification(Notifications.REMOVE_CONTROL, this.chromeCastButton.getViewComponent());\n      }\n  }\n};\n\n/**\n * The ChromeCastFeedChangedCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastFeedChangedCommand() {\n  ChromeCastFeedChangedCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastFeedChangedCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nChromeCastFeedChangedCommand.prototype.execute = function(notification) {\n  var _base;\n  if (typeof (_base = this.proxy).setFeed === \"function\") {\n    _base.setFeed(notification.getBody());\n  }\n};\n\n/**\n * The ChromeCastSeekCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastSeekCommand() {\n  ChromeCastSeekCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastSeekCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nChromeCastSeekCommand.prototype.execute = function(notification) {\n  this.facade.logger.debug(\"ChromeCastSeekCommand\");\n  this.plugin.setCurrentTime(notification.getBody());\n};\n\n/**\n * The ChromeCastButtonMediator class.\n *\n * @constructor\n * @extends {PluginMediator}\n * @param {Object} parent\n * @private\n*/\nfunction ChromeCastButtonMediator() {\n  ChromeCastButtonMediator.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastButtonMediator, ButtonMediator);\n\n\nChromeCastButtonMediator.prototype.componentName = \"chromecast\";\n\nChromeCastButtonMediator.prototype.onclick = function(event) {\n  event.stopImmediatePropagation();\n  this.sendNotification(ChromeCastNotifications.LAUNCH);\n  return false;\n};\n\n/**\n * The ChromeCastTogglePlayPauseCommand class.\n *   \n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastTogglePlayPauseCommand() {\n  ChromeCastTogglePlayPauseCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastTogglePlayPauseCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nChromeCastTogglePlayPauseCommand.prototype.execute = function(notification) {\n  switch (this.applicationState.getPlayState()) {\n    case PlayState.ENDED:\n      this.plugin.setCurrentTime(0);\n      this.plugin.play();\n      break;\n    case PlayState.PAUSED:\n    case PlayState.READY:\n      this.plugin.play();\n      break;\n    case PlayState.PLAYING:\n    case PlayState.WAITING:\n      this.plugin.pause();\n  }\n};\n\n/**\n * The ChromeCastControlsMediator class.\n *\n * @constructor\n * @extends {PluginMediator}\n * @private\n*/\nfunction ChromeCastControlsMediator(playoverlay) {\n  ChromeCastControlsMediator.__super__.constructor.call(this, playoverlay);\n}\n\n\n__extends(ChromeCastControlsMediator, ControlsMediator);\n\n\nChromeCastControlsMediator.prototype.componentName = \"chromecast-controls\";\n\nChromeCastControlsMediator.prototype.message = null;\n\nChromeCastControlsMediator.prototype.messageContainer = null;\n\nChromeCastControlsMediator.prototype.button = null;\n\nChromeCastControlsMediator.prototype.captioningActive = false;\n\n/** @override\n*/\nChromeCastControlsMediator.prototype.onRegister = function() {\n  var button, fullscreen, _ref, _ref1;\n  ChromeCastControlsMediator.__super__.onRegister.call(this);\n  this.messageContainer = this.create(\"chromecast-message-container\");\n  this.message = this.createText(\"chromecast-message\", this.localizationManager.getString(\"MSG_CHROMECAST_MESSAGE\"), this.messageContainer);\n  this.button = new ChromeCastButtonMediator();\n  this.facade.registerMediator(this.button);\n  fullscreen = new FullScreenMediator(this.controlBar);\n  this.facade.registerMediator(fullscreen);\n  fullscreen.setDisabled(true);\n  this.sendNotification(Notifications.ADD_CONTROL, this.button.getViewComponent());\n  if (!this.viewComponent.getElementsByClassName(\"akamai-caption akamai-button\").length && ((_ref = this.facade.player.captioning) != null ? (_ref1 = _ref.config) != null ? _ref1.enabled : void 0 : void 0) === true) {\n    button = new ButtonMediator(this.localizationManager.getString(LocalizationConstants.MSG_CC), this.viewComponent.getElementsByClassName(\"akamai-control-bar\")[0], null, \"caption\", this.captionButtonClick.bind(this));\n    this.facade.registerMediator(button);\n    this.captionButton = button.getViewComponent();\n    this.sendNotification(Notifications.ADD_CONTROL, this.captionButton);\n    this.sendNotification(Notifications.ADD_CONTROL_STATE, \"cc-enabled\");\n  }\n};\n\nChromeCastControlsMediator.prototype.captionButtonClick = function() {\n  var note;\n  this.captioningActive = !this.captioningActive;\n  try {\n    this.facade.player.parent.chromecast.postMessage({\n      type: \"captioning.visibilitychange\",\n      detail: {\n        visibility: this.captioningActive\n      }\n    });\n  } catch (error) {\n    this.facade.logger.error(\"[AMP Chromecast Captioning Error]\", error);\n  }\n  note = this.captioningActive ? Notifications.ADD_APPLICATION_STATE : Notifications.REMOVE_APPLICATION_STATE;\n  this.sendNotification(note, \"cc-active\");\n};\n\n/**\n * The ChromeCastPlaybackTargetChangeCommand class.\n *\n * @constructor\n * @private\n * @extends {PluginCommand}\n*/\nfunction ChromeCastPlaybackTargetChangeCommand() {\n  ChromeCastPlaybackTargetChangeCommand.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastPlaybackTargetChangeCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n *\n * @param {puremvc.Notification} notification\n *    The notification.\n *\n * @override\n*/\nChromeCastPlaybackTargetChangeCommand.prototype.execute = function(notification) {\n  var body, currentTime, duration, target,\n    _this = this;\n  body = notification.getBody();\n  target = body.value;\n  if (target === \"chromecast\") {\n    this.player.pause();\n  } else if (target === \"amp\") {\n    currentTime = this.proxy.getCurrentTime();\n    duration = this.player.getDuration();\n    if (currentTime !== 0 && currentTime !== duration) {\n      this.player.once(\"seeked\", function(event) {\n        setTimeout(_this.sendNotification.bind(_this, Notifications.CHANGE_PLAY_STATE, PlayState.PLAYING), 0);\n      });\n      this.player.setCurrentTime(currentTime);\n    }\n  }\n};\n\n/**\n * The ChromeCastSenderProxy class.\n *\n * @param {Object}  config  The plugin configuration object.\n * @constructor\n * @private\n * @extends {PluginProxy}\n*/\nfunction ChromeCastSenderProxy(config) {\n  this.messageBus = config.messageBus || ChromeCastConstants.CHANNEL_ID;\n  ChromeCastSenderProxy.__super__.constructor.call(this, config.sender);\n}\n\n\n__extends(ChromeCastSenderProxy, PluginProxy);\n\n\n/** @static\n*/\nChromeCastSenderProxy.NAME = ModuleProxy.NAME;\n\nChromeCastSenderProxy.prototype.defaults = {\n  applicationID: ChromeCastConstants.APPLICATION_ID\n};\n\nChromeCastSenderProxy.prototype.session = null;\n\nChromeCastSenderProxy.prototype.media = null;\n\nChromeCastSenderProxy.prototype.messageBus = null;\n\nChromeCastSenderProxy.prototype.feed = null;\n\nChromeCastSenderProxy.prototype.currentTime = null;\n\nChromeCastSenderProxy.prototype.duration = null;\n\nChromeCastSenderProxy.prototype.receiverAvailable = false;\n\nChromeCastSenderProxy.prototype.currentTime = 0;\n\nChromeCastSenderProxy.prototype.duration = 0;\n\nChromeCastSenderProxy.prototype.playerState = null;\n\nChromeCastSenderProxy.prototype.displayTimeTimeout = null;\n\nChromeCastSenderProxy.prototype.volume = 1;\n\nChromeCastSenderProxy.prototype.muted = false;\n\n/** @override\n*/\nChromeCastSenderProxy.prototype.initialize = function() {\n  var _ref,\n    _this = this;\n  if (typeof chrome !== \"undefined\" && chrome !== null ? (_ref = chrome.cast) != null ? _ref.isAvailable : void 0 : void 0) {\n    this.initializeCastApi();\n  } else {\n    window['__onGCastApiAvailable'] = function(loaded, errorInfo) {\n      if (loaded === true) {\n        _this.initializeCastApi();\n      } else {\n        _this.logError(\"cast load error\", errorInfo);\n      }\n    };\n  }\n};\n\nChromeCastSenderProxy.prototype.initializeCastApi = function() {\n  var apiConfig, applicationID, autoJoin, sessionRequest;\n  applicationID = this.getConfigurationData().applicationID;\n  sessionRequest = new chrome.cast.SessionRequest(applicationID);\n  autoJoin = chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED;\n  apiConfig = new chrome.cast.ApiConfig(sessionRequest, this.sessionListener.bind(this), this.receiverListener.bind(this), autoJoin);\n  chrome.cast.initialize(apiConfig, this.onInitSuccess.bind(this), this.onInitError.bind(this));\n};\n\nChromeCastSenderProxy.prototype.onInitSuccess = function(event) {\n  this.logEvent(\"init success\", event);\n};\n\nChromeCastSenderProxy.prototype.onInitError = function(event) {\n  this.logError(\"init error\", event);\n};\n\nChromeCastSenderProxy.prototype.receiverListener = function(event) {\n  this.receiverAvailable = event === 'available';\n  this.sendNotification(ChromeCastNotifications.AVAILABILITY_CHANGE, this.receiverAvailable);\n  this.logEvent(\"receiver \" + (this.receiverAvailable ? \"found\" : \"list empty\"));\n};\n\nChromeCastSenderProxy.prototype.sessionListener = function(event) {\n  this.logEvent(\"session listener\", event);\n  if (!(this.session != null)) {\n    this.setSession(event);\n  }\n  if (this.session.media.length !== 0) {\n    this.onMediaDiscovered(this.session.media[0]);\n  } else {\n    this.onRequestSessionSuccess(event);\n  }\n};\n\nChromeCastSenderProxy.prototype.launch = function() {\n  chrome.cast.requestSession(this.onRequestSessionSuccess.bind(this), this.onLaunchError.bind(this));\n};\n\nChromeCastSenderProxy.prototype.send = function(msg) {\n  var _ref;\n  if ((_ref = this.session) != null) {\n    if (typeof _ref.sendMessage === \"function\") {\n      _ref.sendMessage(this.messageBus, msg, this.onMessageSuccess.bind(this), this.onMessageError.bind(this));\n    }\n  }\n};\n\nChromeCastSenderProxy.prototype.onLaunchError = function(event) {\n  this.logError(\"launch error.\", event);\n};\n\nChromeCastSenderProxy.prototype.setSession = function(value) {\n  this.session = value;\n  this.session.addMessageListener(this.messageBus, this.onMessage.bind(this));\n  this.session.addUpdateListener(this.onUpdate.bind(this));\n};\n\nChromeCastSenderProxy.prototype.onRequestSessionSuccess = function(event) {\n  var playbackProxy;\n  this.logEvent(\"request session success.\", event);\n  this.setSession(event);\n  this.session.sendMessage(this.messageBus, {\n    type: \"createPlayer\",\n    config: {\n      debug: this.facade.player.getConfig().debug,\n      params: this.facade.player.getParams()\n    }\n  }, this.onCreateSucess.bind(this), this.onMessageError.bind(this));\n  playbackProxy = this.facade.player.retrieveProxy(PlaybackProxy.NAME);\n  if (this.session.media.length === 0) {\n    this.loadMedia(playbackProxy.getCurrentTime());\n  }\n};\n\nChromeCastSenderProxy.prototype.onUpdate = function(isAlive) {\n  var currentTime;\n  if (!isAlive) {\n    currentTime = this.facade.player.media.isLive === true ? Infinity : this.media.currentTime;\n    this.sendNotification(Notifications.CHANGE_PLAYBACK_TARGET, \"amp\");\n    this.stopDisplayTimeUpdate();\n  }\n};\n\nChromeCastSenderProxy.prototype.onCreateSucess = function(event) {\n  this.logEvent(\"MPL created\", event);\n  this.sendNotification(Notifications.CHANGE_PLAYBACK_TARGET, \"chromecast\");\n};\n\nChromeCastSenderProxy.prototype.onMessageSuccess = function(event) {\n  this.logEvent(\"message sent\", event);\n};\n\nChromeCastSenderProxy.prototype.onMessageError = function(event) {\n  this.logError(\"message error\", event);\n};\n\nChromeCastSenderProxy.prototype.onMessage = function(namespace, message) {\n  var detail, target, type;\n  message = JSON.parse(message);\n  type = message.type;\n  detail = message.detail || {};\n  switch (type) {\n    case \"dispatchevent\":\n      target = detail.target === \"player\" ? this.facade.player : this.facade.player[detail.target];\n      if (target != null) {\n        target.dispatchEvent(detail.event);\n      }\n  }\n  this.sendNotification(Notifications.DISPATCH_EVENT, {\n    type: \"message\",\n    message: message\n  });\n};\n\nChromeCastSenderProxy.prototype.onStop = function(event) {\n  this.logEvent(\"stop\");\n  this.session.stop(this.onStopSuccess.bind(this), this.onStopError.bind(this));\n};\n\nChromeCastSenderProxy.prototype.onStopSuccess = function(event) {\n  this.logEvent(\"stop success\", event);\n};\n\nChromeCastSenderProxy.prototype.onStopError = function(event) {\n  this.logError(\"stop error\", event);\n};\n\nChromeCastSenderProxy.prototype.logEvent = function(message, data) {\n  if (message == null) {\n    message = data.type || \"\";\n  }\n  this.facade.logger.log(\"[AMP CHROMECAST] \" + message, data);\n};\n\nChromeCastSenderProxy.prototype.logError = function(message, data) {\n  this.facade.logger.error(\"[AMP CHROMECAST ERROR] \" + message, data);\n};\n\nChromeCastSenderProxy.prototype.loadMedia = function(startTime) {\n  var contentId, media, player, receiverCanPlay, request, source,\n    _this = this;\n  if (startTime == null) {\n    startTime = 0;\n  }\n  player = this.facade.player;\n  media = player.retrieveProxy(MediaProxy.NAME).getData();\n  if (!(media != null)) {\n    return;\n  }\n  if (this.media != null) {\n    source = [].concat(media.source.map(function(item) {\n      return item.src;\n    }), media.src);\n    contentId = this.media.media.contentId;\n    if (source.some(function(src) {\n      return src === contentId;\n    })) {\n      return;\n    }\n  }\n  receiverCanPlay = function(type) {\n    if (ChromeCastConstants.SUPPORTED_TYPES.indexOf(type) > -1) {\n      return \"maybe\";\n    } else {\n      return \"\";\n    }\n  };\n  source = Utils.selectSource(media.source, receiverCanPlay);\n  if (!(source != null)) {\n    return;\n  }\n  request = this.mediaToLoadRequest(media, source, startTime, {\n    media: media\n  });\n  this.session.loadMedia(request, this.onMediaDiscovered.bind(this), this.onMediaError.bind(this));\n};\n\nChromeCastSenderProxy.prototype.mediaToLoadRequest = function(media, source, startTime, customData) {\n  var index, mediaInfo, metadata, request, track, value, _i, _len, _ref, _ref1, _ref2;\n  metadata = new chrome.cast.media.GenericMediaMetadata();\n  metadata.title = media.title;\n  metadata.subtitle = media.description;\n  metadata.image = [new chrome.cast.Image(media.poster)];\n  metadata.releaseDate = (_ref = media.pubDate) != null ? typeof _ref.toISOString === \"function\" ? _ref.toISOString() : void 0 : void 0;\n  mediaInfo = new chrome.cast.media.MediaInfo(source.src, source.type);\n  mediaInfo.duration = media.duration;\n  mediaInfo.customData = customData;\n  mediaInfo.metadata = metadata;\n  if (((_ref1 = media.track) != null ? _ref1.length : void 0) > 0) {\n    mediaInfo.tracks = [];\n    _ref2 = media.track;\n    for (index = _i = 0, _len = _ref2.length; _i < _len; index = ++_i) {\n      value = _ref2[index];\n      track = new chrome.cast.media.Track(index, chrome.cast.media.TrackType.TEXT);\n      track.subtype = chrome.cast.media.TextTrackType.CAPTIONS;\n      track.name = \"Closed Captions\";\n      track.language = value.srclang;\n      track.customData = value;\n      track.trackContentId = value.src;\n      track.trackContentType = value.type;\n      mediaInfo.tracks.push(track);\n    }\n  }\n  request = new chrome.cast.media.LoadRequest(mediaInfo);\n  request.currentTime = startTime;\n  return request;\n};\n\nChromeCastSenderProxy.prototype.onMediaDiscovered = function(media) {\n  if (this.media != null) {\n    this.media.removeUpdateListener(this.mediaStatusUpdate);\n  }\n  this.media = media;\n  this.mediaStatusUpdate = this.onMediaStatusUpdate.bind(this);\n  this.media.addUpdateListener(this.mediaStatusUpdate);\n  this.sendNotification(Notifications.CHANGE_PLAYBACK_TARGET, \"chromecast\");\n};\n\nChromeCastSenderProxy.prototype.onMediaStatusUpdate = function(status) {\n  this.logEvent(\"mediastatusupdate\", status);\n  this.updatePlayerState(this.media.playerState);\n  this.updateDisplayTime();\n  if (status === false) {\n    this.stopDisplayTimeUpdate();\n  }\n};\n\nChromeCastSenderProxy.prototype.updatePlayerState = function(playerState) {\n  var state;\n  if (playerState === this.playerState) {\n    return;\n  }\n  this.playerState = playerState;\n  switch (this.playerState) {\n    case chrome.cast.media.PlayerState.BUFFERING:\n      state = PlayState.WAITING;\n      break;\n    case chrome.cast.media.PlayerState.PLAYING:\n      state = PlayState.PLAYING;\n      break;\n    case chrome.cast.media.PlayerState.PAUSED:\n      state = PlayState.PAUSED;\n  }\n  this.sendNotification(Notifications.CHANGE_PLAY_STATE, state);\n  if (this.playerState === chrome.cast.media.PlayerState.PLAYING) {\n    this.startDisplayTimeUpdate();\n  } else {\n    this.stopDisplayTimeUpdate();\n  }\n};\n\nChromeCastSenderProxy.prototype.startDisplayTimeUpdate = function() {\n  this.stopDisplayTimeUpdate();\n  this.displayTimeTimeout = setInterval(this.updateDisplayTime.bind(this), 100);\n};\n\nChromeCastSenderProxy.prototype.stopDisplayTimeUpdate = function() {\n  clearInterval(this.displayTimeTimeout);\n  this.displayTimeTimeout = null;\n};\n\nChromeCastSenderProxy.prototype.updateDisplayTime = function() {\n  var currentTime, duration, _ref;\n  currentTime = this.media.getEstimatedTime() || 0;\n  duration = ((_ref = this.media.media) != null ? _ref.duration : void 0) || currentTime;\n  if (duration !== this.duration) {\n    this.duration = duration;\n    this.sendNotification(Notifications.CHANGE_DURATION, this.duration);\n    return;\n  }\n  if (currentTime !== this.currentTime) {\n    this.currentTime = currentTime;\n    this.sendNotification(Notifications.DISPLAY_TIME, {\n      currentTime: this.currentTime,\n      duration: this.duration\n    });\n  }\n};\n\nChromeCastSenderProxy.prototype.onMediaError = function(error) {\n  this.logError(\"media error\", error);\n  this.stopDisplayTimeUpdate();\n};\n\nChromeCastSenderProxy.prototype.play = function() {\n  this.media.play();\n};\n\nChromeCastSenderProxy.prototype.pause = function() {\n  this.media.pause();\n};\n\nChromeCastSenderProxy.prototype.setCurrentTime = function(time) {\n  var request;\n  request = new chrome.cast.media.SeekRequest();\n  request.currentTime = time;\n  this.media.seek(request);\n};\n\nChromeCastSenderProxy.prototype.getCurrentTime = function() {\n  return this.currentTime;\n};\n\nChromeCastSenderProxy.prototype.isReceiverAvailable = function() {\n  return this.receiverAvailable;\n};\n\nChromeCastSenderProxy.prototype.toggleMuted = function() {\n  var request;\n  this.muted = !this.muted;\n  request = new chrome.cast.media.VolumeRequest(new chrome.cast.Volume(null, this.muted));\n  this.media.setVolume(request, this.onVolumeSuccess.bind(this), this.onVolumeError.bind(this));\n  this.sendNotification(Notifications.VOLUME_CHANGE, this.muted ? 0 : this.volume);\n};\n\nChromeCastSenderProxy.prototype.getVolume = function() {\n  return this.volume;\n};\n\nChromeCastSenderProxy.prototype.setVolume = function(value, muted) {\n  var request;\n  if (muted == null) {\n    muted = false;\n  }\n  if (value === this.volume && muted !== true) {\n    return;\n  }\n  if (muted === false) {\n    this.volume = value;\n  }\n  request = new chrome.cast.media.VolumeRequest(new chrome.cast.Volume(value, value === 0));\n  this.media.setVolume(request, this.onVolumeSuccess.bind(this), this.onVolumeError.bind(this));\n};\n\nChromeCastSenderProxy.prototype.onVolumeSuccess = function() {\n  this.facade.logger.log(\"[AMP Chromecast] Volume success\", this.media.volume);\n};\n\nChromeCastSenderProxy.prototype.onVolumeError = function() {\n  this.facade.logger.log(\"[AMP Chromecast] Volume error\");\n};\n\n/**\n * The ChromeCastPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction ChromeCastPlugin() {\n  ChromeCastPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastPlugin, Plugin);\n\n\nChromeCastPlugin.prototype.moduleName = \"chromecast\";\n\n/** @override\n*/\nChromeCastPlugin.prototype.isAvailable = function() {\n  return /Chrome/.test(navigator.userAgent);\n};\n\n/** @override\n*/\nChromeCastPlugin.prototype.createModel = function() {\n  this.proxy = new ChromeCastSenderProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nChromeCastPlugin.prototype.createController = function() {\n  ChromeCastPlugin.__super__.createController.call(this);\n  this.registerCommand(Notifications.PLAYBACK_TARGET_CHANGE, ChromeCastPlaybackTargetChangeCommand);\n  this.registerCommand(ChromeCastNotifications.LAUNCH, ChromeCastLaunchCommand);\n  this.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, ChromeCastTogglePlayPauseCommand);\n  this.registerCommand(UserNotifications.SEEK, ChromeCastSeekCommand);\n  this.registerCommand(CaptioningNotifications.VISIBILITY_CHANGE, ChromeCastCaptioningVisibilityChangeCommand);\n  this.registerCommand(CaptioningNotifications.SETTINGS_CHANGE, ChromeCastCaptioningSettingsChangeCommand);\n  this.registerCommand(Notifications.MEDIA_CHANGE, ChromeCastMediaChangeCommand);\n  this.registerCommand(Notifications.CHANGE_VOLUME, ChromeCastChangeVolumeCommand);\n  this.registerCommand(Notifications.TOGGLE_MUTED, ChromeCastToggleMutedCommand);\n  this.registerCommand(ChromeCastNotifications.AVAILABILITY_CHANGE, PluginEventCommand);\n};\n\n/** @override\n*/\nChromeCastPlugin.prototype.createView = function() {\n  this.registerMediator(new ChromeCastHTMLSenderMediator());\n};\n\n/** @override\n*/\nChromeCastPlugin.prototype.listNotificationInterests = function() {\n  return [Notifications.READY, CaptioningNotifications.VISIBILITY_CHANGE, CaptioningNotifications.SETTINGS_CHANGE, AdNotifications.BREAK_START, Notifications.PLAYBACK_TARGET_CHANGE, Notifications.MEDIA_CHANGE];\n};\n\n/** @override\n*/\nChromeCastPlugin.prototype.listNotificationPublications = function() {\n  return ChromeCastPlugin.__super__.listNotificationPublications.apply(this, arguments).concat([Notifications.INITIALIZED, Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE, Notifications.CHANGE_PLAYBACK_TARGET, Notifications.CHANGE_PLAY_STATE, ChromeCastNotifications.AVAILABILITY_CHANGE, Notifications.CHANGE_PLAY_STATE, Notifications.CHANGE_DURATION, Notifications.DISPLAY_TIME]);\n};\n\n/**\n * @expose\n*/\nChromeCastPlugin.prototype.play = function() {\n  var _base;\n  if (typeof (_base = this.proxy).play === \"function\") {\n    _base.play();\n  }\n};\n\n/**\n * @expose\n*/\nChromeCastPlugin.prototype.pause = function() {\n  var _base;\n  if (typeof (_base = this.proxy).pause === \"function\") {\n    _base.pause();\n  }\n};\n\n/**\n * @param {Number}  value   The time in seconds to seek to.\n * @expose\n*/\nChromeCastPlugin.prototype.setCurrentTime = function(value) {\n  this.proxy.setCurrentTime(value);\n  return value;\n};\n\n/**\n * Returns if The chromecast device's Availability\n * @expose\n*/\nChromeCastPlugin.prototype.isReceiverAvailable = function() {\n  var _ref;\n  return ((_ref = this.proxy) != null ? typeof _ref.isReceiverAvailable === \"function\" ? _ref.isReceiverAvailable() : void 0 : void 0) || false;\n};\n\nChromeCastPlugin.prototype.getMedia = function() {\n  return this.proxy.media;\n};\n\nChromeCastPlugin.prototype.getSession = function() {\n  return this.proxy.session;\n};\n\nChromeCastPlugin.prototype.getMediaManager = function() {\n  return this.proxy.mediaManager;\n};\n\n/**\n * sends a message across the message bus.\n *\n * @param {Object} msg\n * @expose\n*/\nChromeCastPlugin.prototype.postMessage = function(msg) {\n  this.proxy.send(msg);\n};\n\nChromeCastPlugin.prototype.launch = function() {\n  this.proxy.launch();\n};\n\n\nAMP.registerPlugin(\"chromecast\", \"html\", ChromeCastPlugin);\n\n/** \n * The ChromeCastFlashPlugin class.\n *   \n * @param {Module}  app     The parent module of this plugin.\n * @param {Object}  config  The plugin's configuration object.\n * @constructor\n * @extends {ChromeCastPlugin}\n * @private\n*/\nfunction ChromeCastFlashPlugin() {\n  ChromeCastFlashPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(ChromeCastFlashPlugin, ChromeCastPlugin);\n\n\nChromeCastFlashPlugin.NAME = \"ChromeCastFlashPlugin\";\n\n/** @override\n*/\nChromeCastFlashPlugin.prototype.createModel = function() {\n  this.proxy = new ChromeCastSenderProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/** @override\n*/\nChromeCastFlashPlugin.prototype.createController = function() {\n  ChromeCastFlashPlugin.__super__.createController.call(this);\n  this.registerCommand(Notifications.PLAYBACK_TARGET_CHANGE, ChromeCastPlaybackTargetChangeCommand);\n  this.registerCommand(ChromeCastNotifications.LAUNCH, ChromeCastLaunchCommand);\n  this.registerCommand(FeedNotifications.FEED_CHANGED, ChromeCastFeedChangedCommand);\n  this.registerCommand(UserNotifications.TOGGLE_PLAY_PAUSE, ChromeCastTogglePlayPauseCommand);\n  this.registerCommand(UserNotifications.SEEK, ChromeCastSeekCommand);\n};\n\n/** @override\n*/\nChromeCastFlashPlugin.prototype.createView = function() {\n  this.registerMediator(new ChromeCastSenderMediator());\n};\n\n/** @override\n*/\nChromeCastFlashPlugin.prototype.listNotificationInterests = function() {\n  return [FeedNotifications.FEED_CHANGED, Notifications.CHANGE_MEDIA, Notifications.PLAYBACK_TARGET_CHANGE];\n};\n\n/**\n * @enum {string}\n * @const\n * @private\n*/\n\nvar ChromeCastNotifications = {\n  LAUNCH: \"launch\",\n  AVAILABILITY_CHANGE: \"availabilitychange\"\n};\n\n/**\n * @constructor\n * @extends {PluginWrapper}\n * @private\n*/\nfunction ChromeCastWrapper(player, init) {\n  ChromeCastWrapper.__super__.constructor.call(this, player, init);\n  this.plugin = new ChromeCastFlashPlugin();\n  this.plugin.initialize(init, this.player);\n  player.registerModule(this.plugin);\n}\n\n\n__extends(ChromeCastWrapper, PluginWrapper);\n\n\nChromeCastWrapper.NAME = \"ChromeCastWrapper\";\n\nChromeCastWrapper.prototype.buttonId = \"chromecastBtn\";\n\nChromeCastWrapper.prototype.plugin = null;\n\nChromeCastWrapper.prototype.flashView = {\n  elements: {\n    controls: {\n      elements: {\n        chromecastBtn: {}\n      }\n    }\n  }\n};\n\n/**\n*/\nChromeCastWrapper.prototype.listNotificationInterests = function() {\n  return ChromeCastWrapper.__super__.listNotificationInterests.call(this).concat([FlashNotifications.ELEMENT_EVENT, FlashNotifications.LOAD_STATE_READY, FlashNotifications.LOAD_STATE_LOADING, FlashNotifications.APPLICATION_STATE_CHANGE, ChromeCastNotifications.AVAILABILITY_CHANGE]);\n};\n\n/**\n*/\nChromeCastWrapper.prototype.handleNotification = function(notification) {\n  var body, isReceiverAvailable, name, _ref;\n  ChromeCastWrapper.__super__.handleNotification.call(this, notification);\n  name = notification.getName();\n  body = notification.getBody();\n  switch (name) {\n    case FlashNotifications.ELEMENT_EVENT:\n      if (body.type === \"click\" && body.element === this.buttonId) {\n        this.plugin.sendNotification(ChromeCastNotifications.LAUNCH);\n      }\n      break;\n    case ChromeCastNotifications.AVAILABILITY_CHANGE:\n      if (((_ref = this.player.mediaElement) != null ? _ref.setPlayerProperty : void 0) != null) {\n        this.player.mediaElement.setPlayerProperty(this.buttonId, {\n          visible: body\n        });\n      }\n      break;\n    case FlashNotifications.APPLICATION_STATE_CHANGE:\n    case FlashNotifications.LOAD_STATE_READY:\n    case FlashNotifications.LOAD_STATE_LOADING:\n      isReceiverAvailable = this.plugin.isReceiverAvailable();\n      if (isReceiverAvailable) {\n        this.player.mediaElement.setPlayerProperty(this.buttonId, {\n          state: 1\n        });\n      }\n      this.player.mediaElement.setPlayerProperty(this.buttonId, {\n        visible: isReceiverAvailable\n      });\n  }\n};\n\n/**\n * @expose\n*/\nChromeCastWrapper.prototype.play = function() {\n  this.plugin.play();\n};\n\n/**\n * @expose\n*/\nChromeCastWrapper.prototype.pause = function() {\n  this.plugin.pause();\n};\n\n/**\n * @param {Number}  value   The time in seconds to seek to.\n * @expose\n*/\nChromeCastWrapper.prototype.setCurrentTime = function(value) {\n  this.plugin.setCurrentTime(value);\n  return value;\n};\n\n/**\n * Returns if The chromecast device's Availability\n * @expose\n*/\nChromeCastWrapper.prototype.isReceiverAvailable = function() {\n  return this.plugin.isReceiverAvailable();\n};\n\nChromeCastWrapper.prototype.getMedia = function() {\n  return this.plugin.getMedia();\n};\n\nChromeCastWrapper.prototype.getSession = function() {\n  return this.plugin.getSession();\n};\n\nChromeCastWrapper.prototype.getMediaManager = function() {\n  return this.plugin.getMediaManager();\n};\n\nChromeCastWrapper.prototype.getCastReceiverManager = function() {\n  return this.plugin.getCastReceiverManager();\n};\n\nChromeCastWrapper.prototype.getCastMessageBus = function() {\n  return this.plugin.getCastMessageBuses();\n};\n\n/**\n * sends a message across the message bus.\n *\n * @param {Object} msg\n * @expose\n*/\nChromeCastWrapper.prototype.postMessage = function(msg) {\n  this.plugin.postMessage(msg);\n};\n\nChromeCastWrapper.prototype.launch = function() {\n  this.plugin.launch();\n};\n\n\nAMP.registerPlugin(\"chromecast\", \"flash\", ChromeCastWrapper);\n\n/**\n * The PlaylistMediator class.\n * \n * @constructor\n * @private\n * @extends {PluginMediator}\n * @param {Object} viewComponent\n*/\nfunction PlaylistMediator(viewComponent) {\n  PlaylistMediator.__super__.constructor.call(this, viewComponent);\n}\n\n\n__extends(PlaylistMediator, PluginMediator);\n\n\n/**\n * Stats Mediator\n * \n * @static\n * @type {string}\n*/\nPlaylistMediator.prototype.componentName = \"playlist\";\n\nPlaylistMediator.prototype.playlistButton = null;\n\n/**\n * @override\n*/\nPlaylistMediator.prototype.onRegister = function() {\n  var button;\n  button = new ButtonMediator(null, this.viewComponent, null, \"playlist\", this.playlistOnClick.bind(this));\n  this.facade.registerMediator(button);\n  this.playlistButton = button.getViewComponent();\n  this.sendNotification(Notifications.ADD_CONTROL, this.playlistButton);\n  this.sendNotification(Notifications.ADD_CONTROL_STATE, \"playlist-enabled\");\n  PlaylistMediator.__super__.onRegister.call(this);\n};\n\nPlaylistMediator.prototype.playlistOnClick = function(event) {\n  this.facade.logger.debug('AMP Event: Playlist Clicked');\n};\n\n/**\n * The DASHPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction DASHPlugin() {\n  DASHPlugin.__super__.constructor.call(this);\n  Object.defineProperties(this, {\n    instance: {\n      get: this.getInstance,\n      enumerable: true,\n      configurable: false\n    }\n  });\n}\n\n\n__extends(DASHPlugin, Plugin);\n\n\nDASHPlugin.prototype.moduleName = \"dash\";\n\n/** @override\n*/\nDASHPlugin.prototype.createModel = function() {\n  this.proxy = new DASHProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\n/**\n * Returns DASH PlaybackProxy\n *\n*/\nDASHPlugin.prototype.getPlaybackProxy = function() {\n  return this.proxy.playbackProxy;\n};\n\n/**\n * Returns instance of DASH player\n *\n*/\nDASHPlugin.prototype.getInstance = function() {\n  return this.getPlaybackProxy().player;\n};\n\nDASHPlugin.prototype.registered = function() {\n  this.player.registerCommand(Notifications.CHANGE_DISPLAY_STATE, DASHChangeDisplayStateCommand);\n  DASHPlugin.__super__.registered.call(this);\n};\n\n/**\n*/\nDASHPlugin.prototype.listNotificationPublications = function() {\n  return DASHPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.FRAGMENT_LOAD_START, Notifications.FRAGMENT_LOADED]);\n};\n\n\nAMP.registerPlugin(\"dash\", \"html\", DASHPlugin);\n\nfunction AdChoicesWrapper() {\n  return AdChoicesWrapper.__super__.constructor.apply(this, arguments);\n}\n\n\n__extends(AdChoicesWrapper, PluginWrapper);\n\n\nAdChoicesWrapper.NAME = \"AdChoicesWrapper\";\n\nAdChoicesWrapper.prototype.flashView = {\n  elements: {\n    adOptions: {\n      elements: {\n        adChoices: {\n          attributes: {\n            target: \"http://www.akamai.com/\"\n          }\n        }\n      }\n    }\n  }\n};\n\n/**\n * The AdChoicesMediator class.\n * \n * @constructor\n * @extends {ComponentMediator}\n * @private\n*/\nfunction AdChoicesMediator() {\n  AdChoicesMediator.__super__.constructor.call(this);\n}\n\n\n__extends(AdChoicesMediator, ComponentMediator);\n\n\nAdChoicesMediator.prototype.componentName = \"ad-choices\";\n\nAdChoicesMediator.prototype.icon = null;\n\nAdChoicesMediator.prototype.text = null;\n\nAdChoicesMediator.prototype.container = null;\n\n/**\n * @override\n*/\nAdChoicesMediator.prototype.onRegister = function() {\n  var data;\n  AdChoicesMediator.__super__.onRegister.call(this);\n  data = this.facade.retrieveProxy(ModuleProxy.NAME);\n  this.container = this.create(\"ad-choices-link\", this, \"a\");\n  this.container.target = \"_blank\";\n  this.container.href = data.getTarget();\n  this.text = this.createText(\"ad-choices-text\", \"AdChoices\", this.container);\n  this.icon = this.create(\"ad-choices-icon\", this.container);\n};\n\n/**\n * @override\n*/\nAdChoicesMediator.prototype.listNotificationInterests = function() {\n  return [AdNotifications.AD_CONTAINER_CREATED];\n};\n\n/**\n * @override\n*/\nAdChoicesMediator.prototype.handleNotification = function(notification) {\n  var container;\n  switch (notification.getName()) {\n    case AdNotifications.AD_CONTAINER_CREATED:\n      container = notification.getBody();\n      if (container != null) {\n        container.appendChild(this.viewComponent);\n      }\n  }\n};\n\n/**\n *\n*/\n/** @constructor\n*/\nfunction AdChoicesProxy(config) {\n  AdChoicesProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(AdChoicesProxy, ModuleProxy);\n\n\n/** @static\n*/\nAdChoicesProxy.NAME = ModuleProxy.NAME;\n\nAdChoicesProxy.prototype.defaults = {\n  target: null\n};\n\n/**\n *\n*/\nAdChoicesProxy.prototype.getTarget = function() {\n  return this.data.target;\n};\n\nAdChoicesProxy.prototype.setTarget = function(value) {\n  return this.data.target = value;\n};\n\n/** \n * The PlaylistPlugin class.\n *   \n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction PlaylistPlugin() {\n  PlaylistPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(PlaylistPlugin, Plugin);\n\n\nPlaylistPlugin.prototype.moduleName = \"playlist\";\n\n/** @override\n*/\nPlaylistPlugin.prototype.createView = function() {\n  this.registerMediator(new PlaylistMediator());\n};\n\n/** @override\n*/\nPlaylistPlugin.prototype.listNotificationPublications = function() {\n  return PlaylistPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.ADD_CONTROL, Notifications.REMOVE_CONTROL, Notifications.ADD_CONTROL_STATE, Notifications.REMOVE_CONTROL_STATE]);\n};\n\n\nAMP.registerPlugin(\"playlist\", \"html\", PlaylistPlugin);\n\n/**\n * HLSPlaybackProxy constructor.\n *\n * @constructor\n * @private\n * @extends {PlaybackCoreProxy}\n*/\nfunction HLSPlaybackProxy(config, plugin) {\n  this.plugin = plugin;\n  HLSPlaybackProxy.__super__.constructor.call(this, config.types, config);\n  this.temporalTypes = [\"vod\", \"live\", \"dvr\"];\n}\n\n\n__extends(HLSPlaybackProxy, PlaybackCoreProxy);\n\n\nHLSPlaybackProxy.prototype.playbackCoreName = \"hls\";\n\nHLSPlaybackProxy.prototype.player = null;\n\nHLSPlaybackProxy.prototype.hlsConfig = null;\n\nHLSPlaybackProxy.prototype.fragErrorTime = 0;\n\nHLSPlaybackProxy.prototype.timedMedatadata = null;\n\nHLSPlaybackProxy.prototype.currentMedatadata = null;\n\nHLSPlaybackProxy.prototype.id3Track = null;\n\nHLSPlaybackProxy.prototype.manifestParsed = false;\n\nHLSPlaybackProxy.prototype.details = null;\n\nHLSPlaybackProxy.prototype.quality = -1;\n\nHLSPlaybackProxy.prototype.qualityMode = \"auto\";\n\nHLSPlaybackProxy.prototype.userSwitched = false;\n\n/**\n *\n*/\nHLSPlaybackProxy.prototype.canPlayMedium = function(medium) {\n  return HLSPlaybackProxy.__super__.canPlayMedium.call(this, medium) || medium === \"audio\";\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.getUseMAE = function() {\n  return HLSPlaybackProxy.__super__.getUseMAE.call(this) && (typeof MediaAccelerationHlsJsWrapper !== \"undefined\" && MediaAccelerationHlsJsWrapper !== null);\n};\n\nHLSPlaybackProxy.prototype.getConfig = function() {\n  var config;\n  config = Utils.clone(this.config.data);\n  if (this.config.withCredentials === true) {\n    config.xhrSetup = function(xhr, url) {\n      xhr.withCredentials = true;\n    };\n  }\n  config.debug = this.plugin.proxy.getDebug();\n  if (!this.getUseMAE()) {\n    config.enableSoftwareAES = config.enableSoftwareAES != null ? config.enableSoftwareAES : true;\n  }\n  return config;\n};\n\n/** @override\n*/\nHLSPlaybackProxy.prototype.load = function() {\n  var config, key, player, value, _ref, _ref1,\n    _this = this;\n  if (this.player != null) {\n    this.destroy();\n  }\n  this.manifestParsed = false;\n  this.userSwitched = false;\n  this.quality = -1;\n  config = this.getConfig();\n  if (!this.getUseMAE()) {\n    player = new Hls(config);\n  } else {\n    this.facade.mae = new MediaAccelerationHlsJsWrapper(this.config.mae, config);\n    player = this.facade.mae.getPlayer();\n  }\n  player.attachMedia(this.getMediaElement());\n  _ref = Hls.Events;\n  for (key in _ref) {\n    value = _ref[key];\n    player.on(value, function(event, data) {\n      _this.plugin.dispatcher.dispatchEvent(new Event(event, data));\n    });\n  }\n  player.on(Hls.Events.MANIFEST_LOADED, this.onManifestLoaded.bind(this));\n  player.on(Hls.Events.MANIFEST_PARSED, this.onManifestParsed.bind(this));\n  player.on(Hls.Events.ERROR, this.onError.bind(this));\n  player.on(Hls.Events.FRAG_PARSING_METADATA, this.onFragParsingMetadata.bind(this));\n  player.on(Hls.Events.LEVEL_LOADED, this.onLevelLoaded.bind(this));\n  player.on(Hls.Events.LEVEL_SWITCHING, this.onLevelSwitching.bind(this));\n  player.on(Hls.Events.LEVEL_SWITCHED, this.onLevelSwitched.bind(this));\n  player.on(Hls.Events.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitch.bind(this));\n  player.on(Hls.Events.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitch.bind(this));\n  player.on(Hls.Events.FRAG_LOADING, this.onFragmentLoadStart.bind(this));\n  player.on(Hls.Events.FRAG_LOADED, this.onFragmentLoaded.bind(this));\n  try {\n    _ref1 = this.config.quality;\n    for (key in _ref1) {\n      value = _ref1[key];\n      player[key] = value;\n    }\n  } catch (_error) {}\n  this.player = player;\n  this.details = null;\n  HLSPlaybackProxy.__super__.load.call(this);\n};\n\nHLSPlaybackProxy.prototype.applySrc = function() {\n  this.currentMedatadata = null;\n  this.player.loadSource(this.getSrc());\n  this.getMediaElement().load();\n};\n\nHLSPlaybackProxy.prototype.onManifestLoaded = function(event, data) {\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.MANIFEST_LOADED, {\n    event: event,\n    data: data\n  }));\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.onManifestParsed = function(event, data) {\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.MANIFEST_PARSED, {\n    event: event,\n    data: data\n  }));\n  this.manifestParsed = true;\n  this.sendNotification(Notifications.QUALITY_LEVELS_LOADED, data.levels);\n  this.player.loadLevel = -1;\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.onLevelLoaded = function(event, data) {\n  var duration;\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.LEVEL_LOADED, {\n    event: event,\n    data: data\n  }));\n  this.player.levels[data.level].level = data.level;\n  this.sendNotification(Notifications.QUALITY_CHANGE, this.player.levels[data.level]);\n  this.details = data.details;\n  duration = this.details.totalduration;\n  if (duration !== this.data.duration) {\n    this.data.duration = this.details.totalduration;\n    this.sendNotification(Notifications.CHANGE_DURATION, this.data.duration);\n  }\n  if (data.details.live === true && this.facade.mediaProxy.getTemporalType() !== \"dvr\") {\n    this.facade.mediaProxy.setTemporalType(\"live\");\n  }\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.onLevelSwitching = function(event, data) {\n  if (this.getQualityMode() === \"manual\") {\n    this.userSwitched = true;\n  }\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.LEVEL_SWITCHING, {\n    event: event,\n    data: data\n  }));\n  this.sendNotification(Notifications.QUALITY_CHANGING, this.player.levels[data.level]);\n};\n\nHLSPlaybackProxy.prototype.onLevelSwitched = function(event, data) {\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.LEVEL_SWITCHED, {\n    event: event,\n    data: data\n  }));\n  this.sendNotification(Notifications.QUALITY_SWITCHED, this.player.levels[data.level]);\n};\n\nHLSPlaybackProxy.prototype.onAudioTrackSwitch = function(event, data) {\n  var hasswitched;\n  hasswitched = event === Hls.Events.AUDIO_TRACK_SWITCHED;\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(event, {\n    event: event,\n    data: data\n  }));\n  this.sendNotification(Notifications.AUDIO_TRACK_SWITCH, {\n    switched: hasswitched\n  });\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.onseeking = function(event) {\n  if (this.getQualityMode() === \"manual\" && this.userSwitched) {\n    return;\n  }\n  HLSPlaybackProxy.__super__.onseeking.call(this, event);\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.onseeked = function(event) {\n  if (this.getQualityMode() === \"manual\" && this.userSwitched) {\n    this.userSwitched = false;\n    return;\n  }\n  HLSPlaybackProxy.__super__.onseeked.call(this, event);\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.onFragParsingMetadata = function(event, data) {\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.FRAG_PARSING_METADATA, {\n    event: event,\n    data: data\n  }));\n};\n\nHLSPlaybackProxy.prototype.onFragmentLoadStart = function(event, data) {\n  var bitrate;\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.FRAG_LOADING, {\n    event: event,\n    data: data\n  }));\n  bitrate = this.player.levels[data.frag.level].bitrate;\n  this.sendNotification(Notifications.FRAGMENT_LOAD_START, bitrate);\n};\n\nHLSPlaybackProxy.prototype.onFragmentLoaded = function(event, data) {\n  var bitrate;\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(Hls.Events.FRAG_LOADED, {\n    event: event,\n    data: data\n  }));\n  bitrate = this.player.levels[data.frag.level].bitrate;\n  this.sendNotification(Notifications.FRAGMENT_LOADED, bitrate);\n};\n\nHLSPlaybackProxy.prototype.ontimeupdate = function(event) {\n  var _ref;\n  if (((_ref = this.facade.ads) != null ? _ref.inProgress : void 0) === true) {\n    return;\n  }\n  this.data.currentTime = this.getCurrentTime();\n  this.sendNotification(Notifications.TIME_CHANGE, {\n    currentTime: this.data.currentTime\n  });\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.ondurationchange = function(event) {\n  var duration;\n  duration = this.getDetails().totalduration;\n  if (duration === this.data.duration || duration === 0 || isNaN(duration)) {\n    return;\n  }\n  this.data.duration = duration;\n  this.sendNotification(Notifications.CHANGE_DURATION, duration);\n};\n\nHLSPlaybackProxy.prototype.oncanplaythrough = function(event) {\n  this.createTracks();\n  this.sendNotification(Notifications.CAN_PLAY_THROUGH);\n  this.sendNotification(Notifications.PROGRESS, this.getDuration());\n  if (this.qualityMode === \"manual\" && this.player.currentLevel !== this.quality) {\n    this.setQuality(this.quality);\n  }\n};\n\nHLSPlaybackProxy.prototype.getCurrentTime = function() {\n  return this.getMediaElement().currentTime - this.getStartTime();\n};\n\nHLSPlaybackProxy.prototype.getDetails = function() {\n  return this.details || {};\n};\n\nHLSPlaybackProxy.prototype.getFragmentDuration = function() {\n  return this.getDetails().targetduration;\n};\n\nHLSPlaybackProxy.prototype.getUTCStart = function() {\n  return this.getDetails().startSN * 10000;\n};\n\nHLSPlaybackProxy.prototype.getUTCTime = function() {\n  return this.getUTCStart() + (this.getCurrentTime() * 1000);\n};\n\nHLSPlaybackProxy.prototype.getUTCEnd = function() {\n  return this.getDetails().endSN * 10000;\n};\n\nHLSPlaybackProxy.prototype.getStartTime = function() {\n  return this.getMediaElement().duration - this.getDuration();\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.goLive = function() {\n  this.setCurrentTime(this.getLiveTime());\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.getLiveTime = function() {\n  return this.getDuration() - this.getFragmentDuration();\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.isLive = function() {\n  return this.getStartTime() + this.getCurrentTime() >= this.getLiveTime();\n};\n\n/** @override\n*/\nHLSPlaybackProxy.prototype.seek = function(value) {\n  var _this = this;\n  return HLSPlaybackProxy.__super__.seek.call(this, value + this.getStartTime()).then(function(time) {\n    if (_this.mediaProxy.getTemporalType() === \"dvr\") {\n      _this.sendNotification(Notifications.IS_LIVE, _this.isLive());\n    }\n  });\n};\n\n/** override\n*/\nHLSPlaybackProxy.prototype.onplaying = function(event) {\n  HLSPlaybackProxy.__super__.onplaying.call(this);\n  this.retried = false;\n};\n\n/**\n*/\nHLSPlaybackProxy.prototype.onError = function(event, data) {\n  this.userSwitched = false;\n  this.plugin.sendNotification(Notifications.DISPATCH_EVENT, new Event(\"error\", {\n    event: event,\n    data: data\n  }));\n  if (this.config.ignoreErrors === true) {\n    return;\n  }\n  if (this.config.retryOnError === false || this.retried === true) {\n    this.retried = false;\n    this.error(data);\n    return;\n  }\n  if (data.fatal && data.type === Hls.ErrorTypes.MEDIA_ERROR && data.details === Hls.ErrorDetails.FRAG_LOOP_LOADING_ERROR) {\n    data.fatal = false;\n  }\n  if (data.fatal) {\n    switch (data.type) {\n      case Hls.ErrorTypes.NETWORK_ERROR:\n        this.retried = true;\n        if (this.manifestParsed) {\n          this.player.startLoad();\n        } else {\n          this.player.loadSource(this.getSrc());\n        }\n        this.facade.logger.error(\"[AMP HLS] Playback Error trying to recover:\", event);\n        break;\n      case Hls.ErrorTypes.MEDIA_ERROR:\n        this.retried = true;\n        this.player.recoverMediaError();\n        this.facade.logger.error(\"[AMP HLS] Playback Error trying to recover:\", event);\n        break;\n      default:\n        this.facade.logger.error(\"[AMP HLS] Playback Error:\", event);\n        this.error(data);\n    }\n  } else {\n    if (data.details === Hls.ErrorDetails.FRAG_LOOP_LOADING_ERROR) {\n      if (this.fragErrorTime === this.getMediaElement().currentTime) {\n        this.getMediaElement().currentTime++;\n        this.facade.logger.error(\"[AMP HLS] Frag Loop Load Error, Seeking to :\", this.getMediaElement().currentTime);\n      } else {\n        this.fragErrorTime = this.getMediaElement().currentTime;\n      }\n    }\n  }\n};\n\nHLSPlaybackProxy.prototype.error = function(data) {\n  switch (data.type) {\n    case Hls.ErrorTypes.NETWORK_ERROR:\n      data.code = MediaError.MEDIA_ERR_NETWORK;\n      break;\n    case Hls.ErrorTypes.MEDIA_ERROR:\n      data.code = MediaError.MEDIA_ERR_DECODE;\n      break;\n    default:\n      data.toString = function() {\n        return data.details;\n      };\n  }\n  this.sendNotification(Notifications.ERROR, data);\n};\n\n/** @override\n*/\nHLSPlaybackProxy.prototype.createTracks = function() {\n  var audio, changeEnabled, count, current, index, item, track, tracks, _i, _len;\n  audio = this.player.audioTracks;\n  current = this.player.audioTrack;\n  tracks = this.facade.tracks.getAudioTracks();\n  count = audio.length;\n  changeEnabled = function(track, enabled) {\n    var _this = this;\n    this.facade.tracks.getAudioTracks().forEach(function(track) {\n      return track.data.enabled = false;\n    });\n    if (enabled !== true) {\n      return;\n    }\n    this.facade.tracks.getAudioTracks()[track.id].data.enabled = true;\n    this.player.audioTrack = track.id;\n  };\n  for (index = _i = 0, _len = audio.length; _i < _len; index = ++_i) {\n    item = audio[index];\n    if (Utils.fieldIsUnique(tracks, 'id', item.id) === false) {\n      continue;\n    }\n    track = new Track({\n      kind: item.type,\n      label: item.name || item.id,\n      language: item.lang,\n      id: item.id,\n      enabled: item.id === current,\n      data: item\n    });\n    track.changeEnabled = changeEnabled.bind(this, item);\n    tracks.add(track, index + 1 === count);\n  }\n};\n\n/** @override\n*/\nHLSPlaybackProxy.prototype.setQuality = function(value) {\n  var mode, _ref;\n  mode = this.qualityMode;\n  if (value > -1) {\n    mode = \"manual\";\n  } else {\n    mode = \"auto\";\n  }\n  this.setQualityMode(mode);\n  if (value === this.player.currentLevel) {\n    this.onLevelSwitching(\"hlsLevelSwitching\", this.player.levels[value]);\n    this.onLevelSwitched(\"hlsLevelSwitched\", {\n      level: value\n    });\n    return;\n  }\n  if ((_ref = this.player) != null) {\n    _ref.currentLevel = this.quality = value;\n  }\n  return this.quality;\n};\n\n/** @override\n*/\nHLSPlaybackProxy.prototype.getQuality = function() {\n  var level, _ref, _ref1;\n  level = (_ref = this.player) != null ? _ref.currentLevel : void 0;\n  if (level === -1) {\n    level = (_ref1 = this.player) != null ? _ref1.nextLoadLevel : void 0;\n  }\n  return level;\n};\n\n/** @override\n*/\nHLSPlaybackProxy.prototype.getQualityLevels = function() {\n  var _ref;\n  return ((_ref = this.player) != null ? _ref.levels : void 0) || HLSPlaybackProxy.__super__.getQualityLevels.call(this);\n};\n\n/** @override\n*/\nHLSPlaybackProxy.prototype.getQualityMode = function() {\n  return this.qualityMode;\n};\n\n/** @override\n*/\nHLSPlaybackProxy.prototype.setQualityMode = function(value) {\n  if (value !== \"auto\" && value !== \"manual\") {\n    value += \" is not a valid key\";\n  } else {\n    this.qualityMode = value;\n  }\n  return value;\n};\n\n/** @override\n*/\nHLSPlaybackProxy.prototype.destroy = function() {\n  if (!(this.player != null)) {\n    return;\n  }\n  HLSPlaybackProxy.__super__.destroy.call(this);\n  this.player.destroy();\n  this.player = null;\n};\n\n/** \n * @constructor\n * @extends {PluginWrapper}\n * @private\n*/\nfunction HLSWrapper(player, config) {\n  HLSWrapper.__super__.constructor.call(this, player, config);\n  Utils.flashTypes.push(Utils.mimeTypes.m3u8);\n}\n\n\n__extends(HLSWrapper, PluginWrapper);\n\n\nHLSWrapper.NAME = \"HLSWrapper\";\n\nHLSWrapper.prototype.flashPlugins = [\n  {\n    id: \"flashlsOSMF\",\n    src: '#{paths.resources}plugins/flashlsOSMF.swf',\n    host: \"osmf\",\n    type: \"application/x-shockwave-flash\"\n  }\n];\n\n\nAMP.registerPlugin(\"hls\", \"flash\", HLSWrapper);\n\n/**\n * The HLSAdBreakStartCommand class.\n *   \n * @constructor\n * @private\n * @extends {puremvc.SimpleCommand}\n*/\nfunction HLSAdBreakStartCommand() {\n  HLSAdBreakStartCommand.__super__.constructor.call(this);\n}\n\n\n__extends(HLSAdBreakStartCommand, PluginCommand);\n\n\n/**\n * Executes the command.\n * \n * @param {puremvc.Notification} notification \n *    The notification.\n * \n * @override\n*/\nHLSAdBreakStartCommand.prototype.execute = function(notification) {\n  var rate, _ref;\n  if (((_ref = notification.getBody()) != null ? _ref.partner : void 0) === \"freewheel\") {\n    rate = this.facade.player.getPlaybackRate();\n    this.proxy.destroy();\n    this.facade.player.setPlaybackRate(rate);\n  }\n};\n\n/**\n * The HLSProxy class.\n *\n * @param {Object}  config  The plugin configuration object.\n * @constructor\n * @private\n * @extends {PluginProxy}\n*/\nfunction HLSProxy(config) {\n  HLSProxy.__super__.constructor.call(this, config);\n}\n\n\n__extends(HLSProxy, PlaybackPluginProxy);\n\n\n/** @static\n*/\nHLSProxy.NAME = ModuleProxy.NAME;\n\nHLSProxy.prototype.defaults = {\n  types: [\"application/x-mpegURL\"],\n  data: {\n    enableWorker: true,\n    enableCEA708Captions: true\n  },\n  mae: null,\n  buffer: null,\n  quality: null,\n  withCredentials: null,\n  retryOnError: true,\n  ignoreErrors: false\n};\n\nHLSProxy.prototype.createPlaybackProxy = function() {\n  var mediaSource;\n  mediaSource = window.MediaSource || window.WebKitMediaSource;\n  if (!(mediaSource != null) || !Hls.isSupported()) {\n    return;\n  }\n  return new HLSPlaybackProxy(this.getConfigurationData(), this.facade);\n};\n\n/** \n * The AdChoicesPlugin class.\n *   \n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction AdChoicesPlugin() {\n  AdChoicesPlugin.__super__.constructor.call(this);\n}\n\n\n__extends(AdChoicesPlugin, Plugin);\n\n\nAdChoicesPlugin.prototype.moduleName = \"adchoices\";\n\n/** @override\n*/\nAdChoicesPlugin.prototype.createModel = function() {\n  this.registerProxy(new AdChoicesProxy(this.config));\n};\n\n/** @override\n*/\nAdChoicesPlugin.prototype.createView = function() {\n  this.registerMediator(new AdChoicesMediator());\n};\n\n/**\n * @override\n*/\nAdChoicesPlugin.prototype.listNotificationInterests = function() {\n  return [AdNotifications.AD_CONTAINER_CREATED];\n};\n\n\nAMP.registerPlugin(\"adchoices\", \"html\", AdChoicesPlugin);\nAMP.registerPlugin(\"adchoices\", \"flash\", AdChoicesWrapper);\n\n/**\n * The HLSPlugin class.\n *\n * @param {Module}  app     The parent module of this plugin.\n * @constructor\n * @private\n * @extends {Plugin}\n*/\nfunction HLSPlugin() {\n  HLSPlugin.__super__.constructor.call(this);\n  Object.defineProperties(this, {\n    instance: {\n      get: this.getInstance,\n      enumerable: true,\n      configurable: false\n    }\n  });\n}\n\n\n__extends(HLSPlugin, Plugin);\n\n\nHLSPlugin.prototype.moduleName = \"hls\";\n\n/** @override\n*/\nHLSPlugin.prototype.createModel = function() {\n  this.proxy = new HLSProxy(this.config);\n  this.registerProxy(this.proxy);\n};\n\nHLSPlugin.prototype.createController = function() {\n  this.registerCommand(AdNotifications.BREAK_START, HLSAdBreakStartCommand);\n  HLSPlugin.__super__.createController.call(this);\n};\n\n/**\n*/\nHLSPlugin.prototype.logEvent = function(event) {\n  if (/(hlsFragLoading|hlsFragLoaded)/.test(event.type) === true) {\n    return;\n  }\n  HLSPlugin.__super__.logEvent.call(this, event);\n};\n\n/**\n * Returns HLS PlaybackProxy\n *\n*/\nHLSPlugin.prototype.getPlaybackProxy = function() {\n  return this.proxy.playbackProxy;\n};\n\n/**\n * Returns instance of HLS player\n *\n*/\nHLSPlugin.prototype.getInstance = function() {\n  return this.getPlaybackProxy().player;\n};\n\n/**\n*/\nHLSPlugin.prototype.listNotificationInterests = function() {\n  return HLSPlugin.__super__.listNotificationInterests.call(this).concat([AdNotifications.BREAK_START]);\n};\n\n/**\n*/\nHLSPlugin.prototype.listNotificationPublications = function() {\n  return HLSPlugin.__super__.listNotificationPublications.call(this).concat([Notifications.TIMED_METADATA, Notifications.QUALITY_LEVELS_LOADED, Notifications.QUALITY_CHANGE, Notifications.QUALITY_CHANGING, Notifications.FRAGMENT_LOAD_START, Notifications.FRAGMENT_LOADED]);\n};\n\n\nAMP.registerPlugin(\"hls\", \"html\", HLSPlugin);\n\n\nvar PromisePlugin = function (_EventDispatcher) {\n  babelHelpers.inherits(PromisePlugin, _EventDispatcher);\n\n  function PromisePlugin(player, config, key) {\n    babelHelpers.classCallCheck(this, PromisePlugin);\n\n    var _this = babelHelpers.possibleConstructorReturn(this, (PromisePlugin.__proto__ || Object.getPrototypeOf(PromisePlugin)).call(this));\n\n    _this.player = player;\n    _this.config = config || {};\n    _this.key = key;\n    _this.logger = new Logger(_this.debug)\n\n    var events = Events.values;\n    var prop = void 0,\n        event = void 0;\n\n    events.forEach(function (event) {\n      prop = _this[\"on\" + event];\n      if (prop == null || typeof prop != \"function\") return;\n\n      prop = _this[\"on\" + event] = prop.bind(_this);\n      _this.player.addEventListener(event, prop);\n    });\n    return _this;\n  }\n\n  babelHelpers.createClass(PromisePlugin, [{\n    key: \"bindHandlers\",\n    value: function bindHandlers(handlers) {\n      var _this2 = this;\n\n      if (handlers instanceof Array == false) handlers = [handlers];\n\n      handlers.forEach(function (func) {\n        _this2[func] = _this2[func].bind(_this2);\n      });\n    }\n  }, {\n    key: \"debug\",\n    get: function get() {\n      return this.config.debug != null ? this.config.debug : this.player.config.debug;\n    }\n  }, {\n    key: \"data\",\n    get: function get() {\n      return this.player.evaluateBindings(this.config);\n    }\n  }], [{\n    key: \"createFactory\",\n    value: function createFactory(def) {\n      return function (player, config, key) {\n        var _this = this;\n\n        return new Promise(function (resolve, reject) {\n          try {\n            var plugin = new _this(player, config, key);\n            resolve(plugin);\n          } catch (error) {\n            reject(error);\n          }\n        });\n      }.bind(def);\n    }\n  }]);\n\n  return PromisePlugin;\n}(EventDispatcher);\n\nvar AdPromisePlugin = function (_PromisePlugin) {\n  babelHelpers.inherits(AdPromisePlugin, _PromisePlugin);\n\n  function AdPromisePlugin(player, config) {\n    babelHelpers.classCallCheck(this, AdPromisePlugin);\n\n    return babelHelpers.possibleConstructorReturn(this, (AdPromisePlugin.__proto__ || Object.getPrototypeOf(AdPromisePlugin)).call(this, player, config));\n  }\n\n  babelHelpers.createClass(AdPromisePlugin, [{\n    key: \"dispatchEvent\",\n    value: function dispatchEvent(event) {\n      this.player.logger.log(\"[AMP AD EVENT] \" + event.type, event);\n      if (typeof this.player.sendNotification === \"function\")\n        this.player.sendNotification(\"ads\" + event.type, event.detail);\n      babelHelpers.get(AdPromisePlugin.prototype.__proto__ || Object.getPrototypeOf(AdPromisePlugin.prototype), \"dispatchEvent\", this).call(this, event);\n    }\n  }]);\n\n  return AdPromisePlugin;\n}(PromisePlugin);\n\nvar FlashPromisePlugin = function (_PromisePlugin) {\n  babelHelpers.inherits(FlashPromisePlugin, _PromisePlugin);\n\n  function FlashPromisePlugin(player, config) {\n    babelHelpers.classCallCheck(this, FlashPromisePlugin);\n\n    var _this = babelHelpers.possibleConstructorReturn(this, (FlashPromisePlugin.__proto__ || Object.getPrototypeOf(FlashPromisePlugin)).call(this, player, config));\n\n    _this.player.createDefaults.call(_this);\n    _this.player.addEventListener(\"createflashvars\", _this.createFlashVars.bind(_this));\n    _this.player.addEventListener(\"createxml\", _this.createXML.bind(_this));\n    return _this;\n  }\n\n  babelHelpers.createClass(FlashPromisePlugin, [{\n    key: \"createFlashVars\",\n    value: function createFlashVars(event) {}\n  }, {\n    key: \"createXML\",\n    value: function createXML(event) {}\n  }, {\n    key: \"createProperty\",\n    value: function createProperty(xml, key, value, parent) {\n      var property = xml.createElement(\"property\");\n      property.setAttribute(\"key\", key);\n\n      if (parent != null) {\n        parent.appendChild(property);\n      }\n\n      if (value != null) {\n        if ((typeof value === \"undefined\" ? \"undefined\" : babelHelpers.typeof(value)) === \"object\" && !(value instanceof Array)) {\n          for (var _key in value) {\n            var val = value[_key];\n            this.createProperty(xml, _key, val, property);\n          }\n        } else {\n          var text = akamai.amp.XMLUtils.createTextContent(xml, value.toString());\n          property.appendChild(text);\n        }\n      }\n      return property;\n    }\n  }, {\n    key: \"flashPlugins\",\n    get: function get() {\n      return [];\n    }\n  }]);\n\n  return FlashPromisePlugin;\n}(PromisePlugin);\n\nglobal[\"akamai\"] = {\n  \"amp\": {\n    \"AMP\": AMP,\n    \"utils\": {\n      \"Timer\": Timer,\n      \"Utils\": Utils,\n      \"QueryString\": QueryString,\n      \"Logger\": Logger.instance,\n      \"MRSSHelper\": MRSSHelper\n    },\n    \"Timer\": Timer,\n    \"Utils\": Utils,\n    \"ID3\": ID3,\n    \"Poller\": Poller,\n    \"Cookies\": Cookies,\n    \"PlayState\": PlayState,\n    \"DisplayState\": DisplayState,\n    \"PlaybackMode\": PlaybackMode,\n    \"QueryString\": QueryString,\n    \"Logger\": Logger,\n    \"Config\": Config,\n    \"XMLUtils\": XMLUtils,\n    \"IdleUtil\": IdleUtil,\n    \"chromecast\": {\n      \"ChromeCastShim\": (typeof ChromeCastShim != \"undefined\") ? ChromeCastShim.getInstance() : null\n    },\n    \"XHR\": XHR,\n    \"Resource\": Resource,\n    \"Media\": MediaVO,\n    \"Authorization\": Authorization,\n    \"Event\": Event,\n    \"Events\": Events,\n    \"EventDispatcher\": EventDispatcher,\n    \"Plugin\": PromisePlugin,\n    \"FlashPlugin\": FlashPromisePlugin,\n    \"AdPlugin\": AdPromisePlugin,\n    \"DataBinding\": DataBinding,\n    \"Logger\": Logger,\n    \"Transformer\": Transformer,\n    \"TransformType\": TransformType\n  }\n};\n\nObject.defineProperties(global[\"akamai\"][\"amp\"], {\n  \"Settings\": {get: SettingsMediator.GET, enumerable: true, configurable: false}\n});\n\nif (typeof AdVO != \"undefined\")\n  global[\"akamai\"][\"amp\"][\"AdVO\"] = AdVO\n\nif (typeof AdNotifications != \"undefined\") {\n  global[\"akamai\"][\"amp\"][\"AdEvents\"] = (function () {\n    var key, value, events = {};\n    events.values = [];\n    for (key in AdNotifications) {\n      value = AdNotifications[key].replace(/^ads/, \"\");\n      events[key.replace(/^AD_/, \"\")] = value;\n      events.values.push(value);\n    }\n    return events;\n  }())\n}\n\n  /* End JS Lib\n  */\n  window[\"AKAMAI_MEDIA_PLAYER\"].saveSDK(version, global);\n}\nwindow.AKAMAI_MEDIA_PLAYER.setVersion(version);\n})();"

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports = "<application>\n  <player core_player_name=\"amp-premier-player\"\n          volume=\".75\"\n          mbr_starting_index=\"1\"\n          inpage_bitrate_index_limit=\"3\"\n          use_last_known_bitrate=\"false\"\n          use_netsession_client=\"false\"\n          netsession_install_prompt_frequency_secs=\"-1\"\n          ad_server_timeout=\"20\"\n          ad_control_enabled=\"true\"\n          dvr_enabled=\"1\"\n          branding_preload=\"none\"\n          hds_live_low_latency=\"true\"\n          fullscreen_enabled=\"true\"\n          show_feature_bar=\"false\"\n          suppress_events=\"mediaPlayerViewInitialized\"\n          caption_language=\"en-us\"\n          hds_fragment_retry_data_gap_threshold= \"20\"\n          ads_auto_fit=\"true\"\n          auto_replay=\"false\">\n  </player>\n  <view skin=\"{baseSkinUrl}webmd.assets.swf\">\n    <element id=\"endState\" enabled=\"false\" hideElements=\"viewAll\" />\n    <element id=\"logoOverlay\" style=\"height: 45px; width: 150px; right: 15px; bottom: 15px; opacity: 1.0;\"/>\n    <element id=\"captionDisplay\"\n             initState=\"off\"\n             position=\"relative\"\n             captionWidth=\"90\"\n             enabled=\"true\"\n             settingsEnabled=\"true\"\n             style=\"width: 100%; rightMargin:0; bottom: 0; windowColor:0x000000; windowOpacity:1.0; font: Arial; fontColor:0xffffff; fontBGColor:0x000000; fontBGOpacity:0; edgeType:none; edgeColor:0x000000; edgeOpacity:0; scroll:popOut; textAlign: center; fontSize:12; fontWeight:normal;\"\n             />\n    <element id=\"bufferingView\" mode=\"loader\" tether=\"true\" style=\"fontSize:30px;\" />\n    <element id=\"endSlate\" enabled=\"false\" hideElements=\"brandingLogo|viewAll\" />\n    <element id=\"controls\" height=\"28\" scrubPosition=\"inline\" itemMargin=\"5\" />\n    <element id=\"captionBtn\" />\n    <element id=\"recommendationSlate\" viewMode=\"grid\" items=\"6\" />\n    <element id=\"replayBtn\" />\n    <element id=\"playPauseBtn\" />\n    <element id=\"rewindBtn\" />\n    <element id=\"scrubBar\" style=\"height: 18px;\" />\n    <element id=\"loadedBar\" style=\"background: linear-gradient(90deg, #00FF00, #1B1B1B);\" />\n    <element id=\"playlistBtn\" />\n    <element id=\"timeLocationIndicator\" type=\"arrow\" color=\"#FFFFFF\" />\n    <element id=\"goLiveBtn\" />\n    <element id=\"shareBtn\" />\n    <element id=\"captionBtn\" />\n    <element id=\"statsBtn\" />\n    <element id=\"hdClientBtn\" />\n    <element id=\"chromecastBtn\"/>\n    <element id=\"volumeBar\" color=\"#CA2127\" />\n    <element id=\"volumeBtn\" />\n    <element id=\"fullscreenBtn\" />\n  </view>\n</application>\n"

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = __webpack_require__(171);

var _radium2 = _interopRequireDefault(_radium);

var BurgerIcon = (function (_Component) {
  _inherits(BurgerIcon, _Component);

  function BurgerIcon(props) {
    _classCallCheck(this, BurgerIcon);

    _get(Object.getPrototypeOf(BurgerIcon.prototype), 'constructor', this).call(this, props);
    this.state = {
      hover: false
    };
  }

  _createClass(BurgerIcon, [{
    key: 'getLineStyle',
    value: function getLineStyle(index) {
      return {
        position: 'absolute',
        height: '20%',
        left: 0,
        right: 0,
        top: 20 * (index * 2) + '%',
        opacity: this.state.hover ? 0.6 : 1
      };
    }
  }, {
    key: 'handleHover',
    value: function handleHover() {
      this.setState({ hover: !this.state.hover });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var icon = undefined;
      var buttonStyle = {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        border: 'none',
        opacity: 0,
        fontSize: 8
      };

      if (this.props.customIcon) {
        var extraProps = {
          className: 'bm-icon',
          style: [{ width: '100%', height: '100%' }, this.props.styles.bmIcon]
        };
        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
      } else {
        icon = _react2['default'].createElement(
          'span',
          null,
          _react2['default'].createElement('span', { className: 'bm-burger-bars', style: [this.getLineStyle(0), this.props.styles.bmBurgerBars] }),
          _react2['default'].createElement('span', { className: 'bm-burger-bars', style: [this.getLineStyle(1), this.props.styles.bmBurgerBars] }),
          _react2['default'].createElement('span', { className: 'bm-burger-bars', style: [this.getLineStyle(2), this.props.styles.bmBurgerBars] })
        );
      }

      return _react2['default'].createElement(
        'div',
        { className: 'bm-burger-button', style: [{ zIndex: 1 }, this.props.styles.bmBurgerButton] },
        icon,
        _react2['default'].createElement(
          'button',
          { onClick: this.props.onClick,
            onMouseEnter: function () {
              return _this.handleHover();
            },
            onMouseLeave: function () {
              return _this.handleHover();
            },
            style: buttonStyle },
          'Open Menu'
        )
      );
    }
  }]);

  return BurgerIcon;
})(_react.Component);

BurgerIcon.propTypes = {
  customIcon: _propTypes2['default'].element,
  styles: _propTypes2['default'].object
};

BurgerIcon.defaultProps = {
  styles: {}
};

exports['default'] = (0, _radium2['default'])(BurgerIcon);
module.exports = exports['default'];

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = __webpack_require__(171);

var _radium2 = _interopRequireDefault(_radium);

var CrossIcon = (function (_Component) {
  _inherits(CrossIcon, _Component);

  function CrossIcon() {
    _classCallCheck(this, CrossIcon);

    _get(Object.getPrototypeOf(CrossIcon.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(CrossIcon, [{
    key: 'getCrossStyle',
    value: function getCrossStyle(type) {
      return {
        position: 'absolute',
        width: 3,
        height: 14,
        transform: type === 'before' ? 'rotate(45deg)' : 'rotate(-45deg)'
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var icon;
      var buttonWrapperStyle = {
        position: 'absolute',
        width: 24,
        height: 24,
        right: 8,
        top: 8
      };
      var buttonStyle = {
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        margin: 0,
        padding: 0,
        border: 'none',
        textIndent: -9999,
        background: 'transparent',
        outline: 'none'
      };

      if (this.props.customIcon) {
        var extraProps = {
          className: 'bm-cross',
          style: [{ width: '100%', height: '100%' }, this.props.styles.bmCross]
        };
        icon = _react2['default'].cloneElement(this.props.customIcon, extraProps);
      } else {
        icon = _react2['default'].createElement(
          'span',
          { style: [{ position: 'absolute', top: '6px', right: '14px' }] },
          _react2['default'].createElement('span', { className: 'bm-cross', style: [this.getCrossStyle('before'), this.props.styles.bmCross] }),
          _react2['default'].createElement('span', { className: 'bm-cross', style: [this.getCrossStyle('after'), this.props.styles.bmCross] })
        );
      }

      return _react2['default'].createElement(
        'div',
        { className: 'bm-cross-button', style: [buttonWrapperStyle, this.props.styles.bmCrossButton] },
        icon,
        _react2['default'].createElement(
          'button',
          { onClick: this.props.onClick, style: buttonStyle },
          'Close Menu'
        )
      );
    }
  }]);

  return CrossIcon;
})(_react.Component);

CrossIcon.propTypes = {
  customIcon: _propTypes2['default'].element,
  styles: _propTypes2['default'].object
};

CrossIcon.defaultProps = {
  styles: {}
};

exports['default'] = (0, _radium2['default'])(CrossIcon);
module.exports = exports['default'];

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
var styles = {

  overlay: function overlay(isOpen) {
    return {
      position: 'fixed',
      zIndex: 1,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.3)',
      opacity: isOpen ? 1 : 0,
      transform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      MozTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      MsTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      OTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      WebkitTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
      transition: isOpen ? 'opacity 0.3s' : 'opacity 0.3s, transform 0s 0.3s'
    };
  },

  menuWrap: function menuWrap(isOpen, width, right) {
    return {
      position: 'fixed',
      right: right ? 0 : 'inherit',
      zIndex: 2,
      width: width,
      height: '100%',
      transform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      MozTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      MsTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      OTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      WebkitTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transition: 'all 0.5s'
    };
  },

  menu: function menu() {
    return {
      height: '100%',
      boxSizing: 'border-box',
      overflow: 'auto'
    };
  },

  itemList: function itemList() {
    return {
      height: '100%'
    };
  },

  item: function item() {
    return {
      display: 'block',
      outline: 'none'
    };
  }

};

exports['default'] = styles;
module.exports = exports['default'];

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _snapsvgImporter = __webpack_require__(269);

var _snapsvgImporter2 = _interopRequireDefault(_snapsvgImporter);

var _menuFactory = __webpack_require__(55);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {

  svg: {
    lib: _snapsvgImporter2['default'],
    pathInitial: 'M-7.312,0H0c0,0,0,113.839,0,400c0,264.506,0,400,0,400h-7.312V0z',
    pathOpen: 'M-7.312,0H15c0,0,66,113.339,66,399.5C81,664.006,15,800,15,800H-7.312V0z;M-7.312,0H100c0,0,0,113.839,0,400c0,264.506,0,400,0,400H-7.312V0z',
    animate: function animate(path) {
      var pos = 0;
      var steps = this.pathOpen.split(';');
      var stepsTotal = steps.length;
      var mina = window.mina;

      var nextStep = function nextStep() {
        if (pos > stepsTotal - 1) return;

        path.animate({ path: steps[pos] }, pos === 0 ? 400 : 500, pos === 0 ? mina.easein : mina.elastic, function () {
          nextStep();
        });

        pos++;
      };

      nextStep();
    }
  },

  morphShape: function morphShape(isOpen, width, right) {
    return {
      position: 'absolute',
      width: '100%',
      height: '100%',
      right: right ? 'inherit' : 0,
      left: right ? 0 : 'inherit',
      transform: right ? 'rotateY(180deg)' : 'rotateY(0deg)'
    };
  },

  menuWrap: function menuWrap(isOpen, width, right) {
    return {
      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transition: isOpen ? 'transform 0.4s 0s' : 'transform 0.4s'
    };
  },

  menu: function menu(isOpen, width, right) {
    width -= 140;
    return {
      position: 'fixed',
      transform: isOpen ? '' : right ? 'translate3d(' + width + 'px, 0, 0)' : 'translate3d(-' + width + 'px, 0, 0)',
      transition: isOpen ? 'opacity 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
      opacity: isOpen ? 1 : 0
    };
  },

  item: function item(isOpen, width, right, nthChild) {
    width -= 140;
    return {
      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + 'px, 0, 0)' : 'translate3d(-' + width + 'px, 0, 0)',
      transition: isOpen ? 'opacity 0.3s 0.4s, transform 0.3s 0.4s' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
      opacity: isOpen ? 1 : 0
    };
  },

  closeButton: function closeButton(isOpen, width, right) {
    width -= 140;
    return {
      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + width + 'px, 0, 0)' : 'translate3d(-' + width + 'px, 0, 0)',
      transition: isOpen ? 'opacity 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
      opacity: isOpen ? 1 : 0
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _snapsvgImporter = __webpack_require__(269);

var _snapsvgImporter2 = _interopRequireDefault(_snapsvgImporter);

var _menuFactory = __webpack_require__(55);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {

  svg: {
    lib: _snapsvgImporter2['default'],
    pathInitial: 'M-1,0h101c0,0-97.833,153.603-97.833,396.167C2.167,627.579,100,800,100,800H-1V0z',
    pathOpen: 'M-1,0h101c0,0,0-1,0,395c0,404,0,405,0,405H-1V0z',
    animate: function animate(path) {
      path.animate({ path: this.pathOpen }, 400, window.mina.easeinout);
    }
  },

  morphShape: function morphShape(isOpen, width, right) {
    return {
      position: 'absolute',
      width: 120,
      height: '100%',
      right: right ? 'inherit' : 0,
      left: right ? 0 : 'inherit',
      transform: right ? 'rotateY(180deg)' : ''
    };
  },

  menuWrap: function menuWrap(isOpen, width, right) {
    return {
      transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
      transition: 'all 0.3s'
    };
  },

  menu: function menu(isOpen, width, right) {
    return {
      position: 'fixed',
      right: right ? 0 : 'inherit',
      width: 180,
      whiteSpace: 'nowrap',
      boxSizing: 'border-box',
      overflow: 'visible'
    };
  },

  itemList: function itemList(isOpen, width, right) {
    if (right) {
      return {
        position: 'relative',
        left: '-110px',
        width: '170%',
        overflow: 'auto'
      };
    }
  },

  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      transform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
      transition: isOpen ? 'all 0.3s' : 'all 0.3s 0.1s'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(55);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {

  menuWrap: function menuWrap(isOpen) {
    return {
      transform: isOpen ? '' : 'translate3d(0, -100%, 0)',
      transition: 'all 0.5s ease-in-out'
    };
  },

  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      transform: isOpen ? '' : right ? 'translate3d(-' + width + 'px, 0, 0)' : 'translate3d(' + width + 'px, 0, 0)',
      transition: 'all 0.5s'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      perspective: '1500px',
      perspectiveOrigin: '0% 50%',
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(55);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {

  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      transform: isOpen ? '' : right ? 'translate3d(-' + width + 'px, 0, 0)' : 'translate3d(' + width + 'px, 0, 0)',
      transition: 'all 0.5s'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(55);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {

  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      transform: isOpen ? '' : right ? 'translate3d(-' + width + 'px, 0, 0) rotateY(15deg)' : 'translate3d(' + width + 'px, 0, 0) rotateY(-15deg)',
      transformOrigin: right ? '100% 50%' : '0% 50%',
      transformStyle: 'preserve-3d',
      transition: 'all 0.5s'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      perspective: '1500px',
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(55);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {

  pageWrap: function pageWrap(isOpen, width) {
    return {
      transform: isOpen ? '' : 'translate3d(0, 0, -' + width + 'px)',
      transformOrigin: '100%',
      transformStyle: 'preserve-3d',
      transition: 'all 0.5s'
    };
  },

  outerContainer: function outerContainer() {
    return {
      perspective: '1500px'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(55);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {

  pageWrap: function pageWrap(isOpen, width, right) {
    return {
      transform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
      transformStyle: 'preserve-3d',
      transition: 'all 0.5s',
      overflow: isOpen ? '' : 'hidden'
    };
  },

  outerContainer: function outerContainer(isOpen) {
    return {
      perspective: '1500px',
      overflow: isOpen ? '' : 'hidden'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(55);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _menuFactory = __webpack_require__(55);

var _menuFactory2 = _interopRequireDefault(_menuFactory);

var styles = {

  menuWrap: function menuWrap(isOpen, width, right) {
    width += 20;
    return {
      transform: isOpen ? '' : right ? 'translate3d(' + width + 'px, 0, 0)' : 'translate3d(-' + width + 'px, 0, 0)',
      transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0.4s cubic-bezier(0.7, 0, 0.3, 1)'
    };
  },

  item: function item(isOpen, width, right, nthChild) {
    return {
      transform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
      transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0s 0.2s cubic-bezier(0.7, 0, 0.3, 1)'
    };
  }
};

exports['default'] = (0, _menuFactory2['default'])(styles);
module.exports = exports['default'];

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(23);

var focusNode = __webpack_require__(249);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(97);
var ExecutionEnvironment = __webpack_require__(29);
var FallbackCompositionState = __webpack_require__(757);
var SyntheticCompositionEvent = __webpack_require__(794);
var SyntheticInputEvent = __webpack_require__(797);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(271);
var ExecutionEnvironment = __webpack_require__(29);
var ReactInstrumentation = __webpack_require__(43);

var camelizeStyleName = __webpack_require__(660);
var dangerousStyleValue = __webpack_require__(803);
var hyphenateStyleName = __webpack_require__(667);
var memoizeStringOnly = __webpack_require__(670);
var warning = __webpack_require__(14);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(96);
var EventPropagators = __webpack_require__(97);
var ExecutionEnvironment = __webpack_require__(29);
var ReactDOMComponentTree = __webpack_require__(23);
var ReactUpdates = __webpack_require__(50);
var SyntheticEvent = __webpack_require__(56);

var inputValueTracking = __webpack_require__(287);
var getEventTarget = __webpack_require__(186);
var isEventSupported = __webpack_require__(187);
var isTextInputElement = __webpack_require__(289);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var DOMLazyTree = __webpack_require__(84);
var ExecutionEnvironment = __webpack_require__(29);

var createNodesFromMarkup = __webpack_require__(663);
var emptyFunction = __webpack_require__(49);
var invariant = __webpack_require__(7);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(97);
var ReactDOMComponentTree = __webpack_require__(23);
var SyntheticMouseEvent = __webpack_require__(127);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(19);

var PooledClass = __webpack_require__(77);

var getTextContentAccessor = __webpack_require__(286);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(85);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactReconciler = __webpack_require__(86);

var instantiateReactComponent = __webpack_require__(288);
var KeyEscapeUtils = __webpack_require__(178);
var shouldUpdateReactComponent = __webpack_require__(188);
var traverseAllChildren = __webpack_require__(291);
var warning = __webpack_require__(14);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(299);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(169)))

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(174);
var ReactDOMIDOperations = __webpack_require__(767);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13),
    _assign = __webpack_require__(19);

var React = __webpack_require__(87);
var ReactComponentEnvironment = __webpack_require__(180);
var ReactCurrentOwner = __webpack_require__(57);
var ReactErrorUtils = __webpack_require__(181);
var ReactInstanceMap = __webpack_require__(98);
var ReactInstrumentation = __webpack_require__(43);
var ReactNodeTypes = __webpack_require__(281);
var ReactReconciler = __webpack_require__(86);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(119);
var invariant = __webpack_require__(7);
var shallowEqual = __webpack_require__(164);
var shouldUpdateReactComponent = __webpack_require__(188);
var warning = __webpack_require__(14);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(23);
var ReactDefaultInjection = __webpack_require__(775);
var ReactMount = __webpack_require__(280);
var ReactReconciler = __webpack_require__(86);
var ReactUpdates = __webpack_require__(50);
var ReactVersion = __webpack_require__(788);

var findDOMNode = __webpack_require__(804);
var getHostComponentFromComposite = __webpack_require__(285);
var renderSubtreeIntoContainer = __webpack_require__(811);
var warning = __webpack_require__(14);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(13),
    _assign = __webpack_require__(19);

var AutoFocusUtils = __webpack_require__(750);
var CSSPropertyOperations = __webpack_require__(752);
var DOMLazyTree = __webpack_require__(84);
var DOMNamespaces = __webpack_require__(175);
var DOMProperty = __webpack_require__(85);
var DOMPropertyOperations = __webpack_require__(273);
var EventPluginHub = __webpack_require__(96);
var EventPluginRegistry = __webpack_require__(176);
var ReactBrowserEventEmitter = __webpack_require__(126);
var ReactDOMComponentFlags = __webpack_require__(274);
var ReactDOMComponentTree = __webpack_require__(23);
var ReactDOMInput = __webpack_require__(768);
var ReactDOMOption = __webpack_require__(769);
var ReactDOMSelect = __webpack_require__(275);
var ReactDOMTextarea = __webpack_require__(772);
var ReactInstrumentation = __webpack_require__(43);
var ReactMultiChild = __webpack_require__(781);
var ReactServerRenderingTransaction = __webpack_require__(786);

var emptyFunction = __webpack_require__(49);
var escapeTextContentForBrowser = __webpack_require__(129);
var invariant = __webpack_require__(7);
var isEventSupported = __webpack_require__(187);
var shallowEqual = __webpack_require__(164);
var inputValueTracking = __webpack_require__(287);
var validateDOMNesting = __webpack_require__(189);
var warning = __webpack_require__(14);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);

        // We also check that we haven't missed a value update, such as a
        // Radio group shifting the checked value to another named radio input.
        inputValueTracking.updateValueIfChanged(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var validateDOMNesting = __webpack_require__(189);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(19);

var DOMLazyTree = __webpack_require__(84);
var ReactDOMComponentTree = __webpack_require__(23);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(174);
var ReactDOMComponentTree = __webpack_require__(23);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13),
    _assign = __webpack_require__(19);

var DOMPropertyOperations = __webpack_require__(273);
var LinkedValueUtils = __webpack_require__(179);
var ReactDOMComponentTree = __webpack_require__(23);
var ReactUpdates = __webpack_require__(50);

var invariant = __webpack_require__(7);
var warning = __webpack_require__(14);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(19);

var React = __webpack_require__(87);
var ReactDOMComponentTree = __webpack_require__(23);
var ReactDOMSelect = __webpack_require__(275);

var warning = __webpack_require__(14);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(29);

var getNodeForCharacterOffset = __webpack_require__(808);
var getTextContentAccessor = __webpack_require__(286);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13),
    _assign = __webpack_require__(19);

var DOMChildrenOperations = __webpack_require__(174);
var DOMLazyTree = __webpack_require__(84);
var ReactDOMComponentTree = __webpack_require__(23);

var escapeTextContentForBrowser = __webpack_require__(129);
var invariant = __webpack_require__(7);
var validateDOMNesting = __webpack_require__(189);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13),
    _assign = __webpack_require__(19);

var LinkedValueUtils = __webpack_require__(179);
var ReactDOMComponentTree = __webpack_require__(23);
var ReactUpdates = __webpack_require__(50);

var invariant = __webpack_require__(7);
var warning = __webpack_require__(14);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var invariant = __webpack_require__(7);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(19);

var ReactUpdates = __webpack_require__(50);
var Transaction = __webpack_require__(128);

var emptyFunction = __webpack_require__(49);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(749);
var BeforeInputEventPlugin = __webpack_require__(751);
var ChangeEventPlugin = __webpack_require__(753);
var DefaultEventPluginOrder = __webpack_require__(755);
var EnterLeaveEventPlugin = __webpack_require__(756);
var HTMLDOMPropertyConfig = __webpack_require__(758);
var ReactComponentBrowserEnvironment = __webpack_require__(760);
var ReactDOMComponent = __webpack_require__(763);
var ReactDOMComponentTree = __webpack_require__(23);
var ReactDOMEmptyComponent = __webpack_require__(765);
var ReactDOMTreeTraversal = __webpack_require__(773);
var ReactDOMTextComponent = __webpack_require__(771);
var ReactDefaultBatchingStrategy = __webpack_require__(774);
var ReactEventListener = __webpack_require__(778);
var ReactInjection = __webpack_require__(779);
var ReactReconcileTransaction = __webpack_require__(784);
var SVGDOMPropertyConfig = __webpack_require__(789);
var SelectEventPlugin = __webpack_require__(790);
var SimpleEventPlugin = __webpack_require__(791);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(96);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(19);

var EventListener = __webpack_require__(248);
var ExecutionEnvironment = __webpack_require__(29);
var PooledClass = __webpack_require__(77);
var ReactDOMComponentTree = __webpack_require__(23);
var ReactUpdates = __webpack_require__(50);

var getEventTarget = __webpack_require__(186);
var getUnboundedScrollPosition = __webpack_require__(665);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(85);
var EventPluginHub = __webpack_require__(96);
var EventPluginUtils = __webpack_require__(177);
var ReactComponentEnvironment = __webpack_require__(180);
var ReactEmptyComponent = __webpack_require__(276);
var ReactBrowserEventEmitter = __webpack_require__(126);
var ReactHostComponent = __webpack_require__(278);
var ReactUpdates = __webpack_require__(50);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var adler32 = __webpack_require__(802);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var ReactComponentEnvironment = __webpack_require__(180);
var ReactInstanceMap = __webpack_require__(98);
var ReactInstrumentation = __webpack_require__(43);

var ReactCurrentOwner = __webpack_require__(57);
var ReactReconciler = __webpack_require__(86);
var ReactChildReconciler = __webpack_require__(759);

var emptyFunction = __webpack_require__(49);
var flattenChildren = __webpack_require__(805);
var invariant = __webpack_require__(7);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(13);

var invariant = __webpack_require__(7);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(19);

var CallbackQueue = __webpack_require__(272);
var PooledClass = __webpack_require__(77);
var ReactBrowserEventEmitter = __webpack_require__(126);
var ReactInputSelection = __webpack_require__(279);
var ReactInstrumentation = __webpack_require__(43);
var Transaction = __webpack_require__(128);
var ReactUpdateQueue = __webpack_require__(182);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactOwner = __webpack_require__(782);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(19);

var PooledClass = __webpack_require__(77);
var Transaction = __webpack_require__(128);
var ReactInstrumentation = __webpack_require__(43);
var ReactServerUpdateQueue = __webpack_require__(787);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(182);

var warning = __webpack_require__(14);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(97);
var ExecutionEnvironment = __webpack_require__(29);
var ReactDOMComponentTree = __webpack_require__(23);
var ReactInputSelection = __webpack_require__(279);
var SyntheticEvent = __webpack_require__(56);

var getActiveElement = __webpack_require__(250);
var isTextInputElement = __webpack_require__(289);
var shallowEqual = __webpack_require__(164);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(13);

var EventListener = __webpack_require__(248);
var EventPropagators = __webpack_require__(97);
var ReactDOMComponentTree = __webpack_require__(23);
var SyntheticAnimationEvent = __webpack_require__(792);
var SyntheticClipboardEvent = __webpack_require__(793);
var SyntheticEvent = __webpack_require__(56);
var SyntheticFocusEvent = __webpack_require__(796);
var SyntheticKeyboardEvent = __webpack_require__(798);
var SyntheticMouseEvent = __webpack_require__(127);
var SyntheticDragEvent = __webpack_require__(795);
var SyntheticTouchEvent = __webpack_require__(799);
var SyntheticTransitionEvent = __webpack_require__(800);
var SyntheticUIEvent = __webpack_require__(99);
var SyntheticWheelEvent = __webpack_require__(801);

var emptyFunction = __webpack_require__(49);
var getEventCharCode = __webpack_require__(184);
var invariant = __webpack_require__(7);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(56);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(56);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(56);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(127);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(99);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(56);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(99);

var getEventCharCode = __webpack_require__(184);
var getEventKey = __webpack_require__(806);
var getEventModifierState = __webpack_require__(185);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(99);

var getEventModifierState = __webpack_require__(185);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(56);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(127);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(271);
var warning = __webpack_require__(14);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(13);

var ReactCurrentOwner = __webpack_require__(57);
var ReactDOMComponentTree = __webpack_require__(23);
var ReactInstanceMap = __webpack_require__(98);

var getHostComponentFromComposite = __webpack_require__(285);
var invariant = __webpack_require__(7);
var warning = __webpack_require__(14);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(178);
var traverseAllChildren = __webpack_require__(291);
var warning = __webpack_require__(14);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(299);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(169)))

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var getEventCharCode = __webpack_require__(184);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(29);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(129);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactMount = __webpack_require__(280);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(10);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(3);
var DOMFactories = __webpack_require__(270);
var PropTypes = __webpack_require__(10);
var ExecutionEnvironment = __webpack_require__(819);
var ModalPortal = React.createFactory(__webpack_require__(814));
var ariaAppHider = __webpack_require__(815);
var refCount = __webpack_require__(817);
var elementClass = __webpack_require__(656);
var renderSubtreeIntoContainer = __webpack_require__(3).unstable_renderSubtreeIntoContainer;
var Assign = __webpack_require__(256);
var createReactClass = __webpack_require__(247);

var SafeHTMLElement = ExecutionEnvironment.canUseDOM ? window.HTMLElement : {};
var AppElement = ExecutionEnvironment.canUseDOM ? document.body : {appendChild: function() {}};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = createReactClass({

  displayName: 'Modal',
  statics: {
    setAppElement: function(element) {
        AppElement = ariaAppHider.setElement(element);
    },
    injectCSS: function() {
      "production" !== "production"
        && console.warn('React-Modal: injectCSS has been deprecated ' +
                        'and no longer has any effect. It will be removed in a later version');
    }
  },

  propTypes: {
    isOpen: PropTypes.bool.isRequired,
    style: PropTypes.shape({
      content: PropTypes.object,
      overlay: PropTypes.object
    }),
    portalClassName: PropTypes.string,
    bodyOpenClassName: PropTypes.string,
    appElement: PropTypes.instanceOf(SafeHTMLElement),
    onAfterOpen: PropTypes.func,
    onRequestClose: PropTypes.func,
    closeTimeoutMS: PropTypes.number,
    ariaHideApp: PropTypes.bool,
    shouldCloseOnOverlayClick: PropTypes.bool,
    parentSelector: PropTypes.func,
    role: PropTypes.string,
    contentLabel: PropTypes.string.isRequired
  },

  getDefaultProps: function () {
    return {
      isOpen: false,
      portalClassName: 'ReactModalPortal',
      bodyOpenClassName: 'ReactModal__Body--open',
      ariaHideApp: true,
      closeTimeoutMS: 0,
      shouldCloseOnOverlayClick: true,
      parentSelector: function () { return document.body; }
    };
  },

  componentDidMount: function() {
    this.node = document.createElement('div');
    this.node.className = this.props.portalClassName;

    if (this.props.isOpen) refCount.add(this);

    var parent = getParentElement(this.props.parentSelector);
    parent.appendChild(this.node);
    this.renderPortal(this.props);
  },

  componentWillUpdate: function(newProps) {
    if(newProps.portalClassName !== this.props.portalClassName) {
      this.node.className = newProps.portalClassName;
    }
  },

  componentWillReceiveProps: function(newProps) {
    if (newProps.isOpen) refCount.add(this);
    if (!newProps.isOpen) refCount.remove(this);
    var currentParent = getParentElement(this.props.parentSelector);
    var newParent = getParentElement(newProps.parentSelector);

    if(newParent !== currentParent) {
      currentParent.removeChild(this.node);
      newParent.appendChild(this.node);
    }

    this.renderPortal(newProps);
  },

  componentWillUnmount: function() {
    if (!this.node) return;

    refCount.remove(this);

    if (this.props.ariaHideApp) {
      ariaAppHider.show(this.props.appElement);
    }

    var state = this.portal.state;
    var now = Date.now();
    var closesAt = state.isOpen && this.props.closeTimeoutMS
      && (state.closesAt
        || now + this.props.closeTimeoutMS);

    if (closesAt) {
      if (!state.beforeClose) {
        this.portal.closeWithTimeout();
      }

      var that = this;
      setTimeout(function() { that.removePortal(); }, closesAt - now);
    } else {
      this.removePortal();
    }
  },

  removePortal: function() {
    ReactDOM.unmountComponentAtNode(this.node);
    var parent = getParentElement(this.props.parentSelector);
    parent.removeChild(this.node);

    if (refCount.count() === 0) {
      elementClass(document.body).remove(this.props.bodyOpenClassName);
    }
  },

  renderPortal: function(props) {
    if (props.isOpen || refCount.count() > 0) {
      elementClass(document.body).add(this.props.bodyOpenClassName);
    } else {
      elementClass(document.body).remove(this.props.bodyOpenClassName);
    }

    if (props.ariaHideApp) {
      ariaAppHider.toggle(props.isOpen, props.appElement);
    }

    this.portal = renderSubtreeIntoContainer(this, ModalPortal(Assign({}, props, {defaultStyles: Modal.defaultStyles})), this.node);
  },

  render: function () {
    return DOMFactories.noscript();
  }
});

Modal.defaultStyles = {
  overlay: {
    position        : 'fixed',
    top             : 0,
    left            : 0,
    right           : 0,
    bottom          : 0,
    backgroundColor : 'rgba(255, 255, 255, 0.75)'
  },
  content: {
    position                : 'absolute',
    top                     : '40px',
    left                    : '40px',
    right                   : '40px',
    bottom                  : '40px',
    border                  : '1px solid #ccc',
    background              : '#fff',
    overflow                : 'auto',
    WebkitOverflowScrolling : 'touch',
    borderRadius            : '4px',
    outline                 : 'none',
    padding                 : '20px'
  }
}

module.exports = Modal


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);
var DOMFactories = __webpack_require__(270);
var focusManager = __webpack_require__(816);
var scopeTab = __webpack_require__(818);
var Assign = __webpack_require__(256);
var createReactClass = __webpack_require__(247);

var div = DOMFactories.div;

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: 'ReactModal__Overlay',
  content: 'ReactModal__Content'
};

var ModalPortal = module.exports = createReactClass({

  displayName: 'ModalPortal',
  shouldClose: null,

  getDefaultProps: function() {
    return {
      style: {
        overlay: {},
        content: {}
      }
    };
  },

  getInitialState: function() {
    return {
      afterOpen: false,
      beforeClose: false
    };
  },

  componentDidMount: function() {
    // Focus needs to be set when mounting and already open
    if (this.props.isOpen) {
      this.setFocusAfterRender(true);
      this.open();
    }
  },

  componentWillUnmount: function() {
    clearTimeout(this.closeTimer);
  },

  componentWillReceiveProps: function(newProps) {
    // Focus only needs to be set once when the modal is being opened
    if (!this.props.isOpen && newProps.isOpen) {
      this.setFocusAfterRender(true);
      this.open();
    } else if (this.props.isOpen && !newProps.isOpen) {
      this.close();
    }
  },

  componentDidUpdate: function () {
    if (this.focusAfterRender) {
      this.focusContent();
      this.setFocusAfterRender(false);
    }
  },

  setFocusAfterRender: function (focus) {
    this.focusAfterRender = focus;
  },

  afterClose: function () {
    focusManager.returnFocus();
    focusManager.teardownScopedFocus();
  },

  open: function () {
    if (this.state.afterOpen && this.state.beforeClose) {
      clearTimeout(this.closeTimer);
      this.setState({ beforeClose: false });
    } else {
      focusManager.setupScopedFocus(this.node);
      focusManager.markForFocusLater();
      this.setState({isOpen: true}, function() {
        this.setState({afterOpen: true});

        if (this.props.isOpen && this.props.onAfterOpen) {
          this.props.onAfterOpen();
        }
      }.bind(this));
    }
  },

  close: function() {
    if (this.props.closeTimeoutMS > 0)
      this.closeWithTimeout();
    else
      this.closeWithoutTimeout();
  },

  focusContent: function() {
    // Don't steal focus from inner elements
    if (!this.contentHasFocus()) {
      this.refs.content.focus();
    }
  },

  closeWithTimeout: function() {
    var closesAt = Date.now() + this.props.closeTimeoutMS;
    this.setState({beforeClose: true, closesAt: closesAt}, function() {
      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.state.closesAt - Date.now());
    }.bind(this));
  },

  closeWithoutTimeout: function() {
    this.setState({
      beforeClose: false,
      isOpen: false,
      afterOpen: false,
      closesAt: null
    }, this.afterClose);
  },

  handleKeyDown: function(event) {
    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
    if (event.keyCode == 27 /*esc*/) {
      event.preventDefault();
      this.requestClose(event);
    }
  },

  handleOverlayOnClick: function (event) {
    if (this.shouldClose === null) {
      this.shouldClose = true;
    }

    if (this.shouldClose && this.props.shouldCloseOnOverlayClick) {
      if (this.ownerHandlesClose())
        this.requestClose(event);
      else
        this.focusContent();
    }
    this.shouldClose = null;
  },

  handleContentOnClick: function () {
    this.shouldClose = false;
  },

  requestClose: function(event) {
    if (this.ownerHandlesClose())
      this.props.onRequestClose(event);
  },

  ownerHandlesClose: function() {
    return this.props.onRequestClose;
  },

  shouldBeClosed: function() {
    return !this.state.isOpen && !this.state.beforeClose;
  },

  contentHasFocus: function() {
    return document.activeElement === this.refs.content || this.refs.content.contains(document.activeElement);
  },

  buildClassName: function(which, additional) {
    var classNames = (typeof additional === 'object') ? additional : {
      base: CLASS_NAMES[which],
      afterOpen: CLASS_NAMES[which] + "--after-open",
      beforeClose: CLASS_NAMES[which] + "--before-close"
    };
    var className = classNames.base;
    if (this.state.afterOpen) { className += " " + classNames.afterOpen; }
    if (this.state.beforeClose) { className += " " + classNames.beforeClose; }
    return (typeof additional === 'string' && additional) ? [className, additional].join(" ") : className;
  },

  render: function() {
    var contentStyles = (this.props.className) ? {} : this.props.defaultStyles.content;
    var overlayStyles = (this.props.overlayClassName) ? {} : this.props.defaultStyles.overlay;

    return this.shouldBeClosed() ? div() : (
      div({
        ref: "overlay",
        className: this.buildClassName('overlay', this.props.overlayClassName),
        style: Assign({}, overlayStyles, this.props.style.overlay || {}),
        onClick: this.handleOverlayOnClick
      },
        div({
          ref: "content",
          style: Assign({}, contentStyles, this.props.style.content || {}),
          className: this.buildClassName('content', this.props.className),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        },
          this.props.children
        )
      )
    );
  }
});


/***/ }),
/* 815 */
/***/ (function(module, exports) {

var _element = typeof document !== 'undefined' ? document.body : null;

function setElement(element) {
  if (typeof element === 'string') {
    var el = document.querySelectorAll(element);
    element = 'length' in el ? el[0] : el;
  }
  _element = element || _element;
  return _element;
}

function hide(appElement) {
  validateElement(appElement);
  (appElement || _element).setAttribute('aria-hidden', 'true');
}

function show(appElement) {
  validateElement(appElement);
  (appElement || _element).removeAttribute('aria-hidden');
}

function toggle(shouldHide, appElement) {
  if (shouldHide)
    hide(appElement);
  else
    show(appElement);
}

function validateElement(appElement) {
  if (!appElement && !_element)
    throw new Error('react-modal: You must set an element with `Modal.setAppElement(el)` to make this accessible');
}

function resetForTesting() {
  _element = document.body;
}

exports.toggle = toggle;
exports.setElement = setElement;
exports.show = show;
exports.hide = hide;
exports.resetForTesting = resetForTesting;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var findTabbable = __webpack_require__(292);
var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur(event) {
  needToFocus = true;
}

function handleFocus(event) {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function() {
      if (modalElement.contains(document.activeElement))
        return;
      var el = (findTabbable(modalElement)[0] || modalElement);
      el.focus();
    }, 0);
  }
}

exports.markForFocusLater = function() {
  focusLaterElements.push(document.activeElement);
};

exports.returnFocus = function() {
  var toFocus = null;
  try {
    toFocus = focusLaterElements.pop();
    toFocus.focus();
    return;
  }
  catch (e) {
    console.warn('You tried to return focus to '+toFocus+' but it is not in the DOM anymore');
  }
};

exports.setupScopedFocus = function(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener('blur', handleBlur, false);
    document.addEventListener('focus', handleFocus, true);
  } else {
    window.attachEvent('onBlur', handleBlur);
    document.attachEvent('onFocus', handleFocus);
  }
};

exports.teardownScopedFocus = function() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener('blur', handleBlur);
    document.removeEventListener('focus', handleFocus);
  } else {
    window.detachEvent('onBlur', handleBlur);
    document.detachEvent('onFocus', handleFocus);
  }
};


/***/ }),
/* 817 */
/***/ (function(module, exports) {

var modals = [];

module.exports = {
  add: function (element) {
    if (modals.indexOf(element) === -1) {
      modals.push(element);
    }
  },
  remove: function (element) {
    var index = modals.indexOf(element);
    if (index === -1) {
      return;
    }
    modals.splice(index, 1);
  },
  count: function () {
    return modals.length;
  }
};


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

var findTabbable = __webpack_require__(292);

module.exports = function(node, event) {
  var tabbable = findTabbable(node);
  if (!tabbable.length) {
      event.preventDefault();
      return;
  }
  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
  var leavingFinalTabbable = (
    finalTabbable === document.activeElement ||
    // handle immediate shift+tab after opening with mouse
    node === document.activeElement
  );
  if (!leavingFinalTabbable) return;
  event.preventDefault();
  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
  target.focus();
};


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(191);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history__["f" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(191);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(831);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(293);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(832);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(833);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(834);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(835);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(296);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(194);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(836);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(193);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(296);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(prevProps.to);
    var nextTo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(this.props.to);

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(193);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(194);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(295);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Async", function() { return Async; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncCreatable", function() { return AsyncCreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Creatable", function() { return CreatableSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Value", function() { return Value; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Option", function() { return Option; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultMenuRenderer", function() { return menuRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultArrowRenderer", function() { return arrowRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultClearRenderer", function() { return clearRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultFilterOptions", function() { return filterOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






var arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var clearRenderer = function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = isValid(value);
		var hasLabel = isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

menuRenderer.propTypes = {
	focusOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	focusedOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
	inputValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onOptionRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	removeValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	selectValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	valueArray: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuDOM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
			var pref = document.addEventListener ? '' : 'on';

			document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
			document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false,
						focusedOption: null
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen,
					focusedOption: null
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (!this.props.closeOnSelect) {
				return;
			}
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value,
							values: valueArray
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = _extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', _extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						'div',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultChildren = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator,
			    showNewOptionAtTop = _props2.showNewOptionAtTop;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					if (showNewOptionAtTop) {
						filteredOptions.unshift(this._createPlaceholderOption);
					} else {
						filteredOptions.push(this._createPlaceholderOption);
					}
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
	showNewOptionAtTop: true
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Where to show prompt/placeholder option text.
	// true: new option prompt at top of list (default)
	// false: new option prompt at bottom of list
	showNewOptionAtTop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ __webpack_exports__["default"] = (Select$1);


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(100);

var invariant = __webpack_require__(7);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(839);
var ReactElement = __webpack_require__(88);

var emptyFunction = __webpack_require__(49);
var traverseAllChildren = __webpack_require__(849);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(88);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(88),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(258);

module.exports = factory(isValidElement);

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(298),
    Component = _require.Component;

var _require2 = __webpack_require__(88),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(301);
var factory = __webpack_require__(246);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(100);

var ReactElement = __webpack_require__(88);

var invariant = __webpack_require__(7);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(100);

var ReactCurrentOwner = __webpack_require__(57);
var REACT_ELEMENT_TYPE = __webpack_require__(300);

var getIteratorFn = __webpack_require__(845);
var invariant = __webpack_require__(7);
var KeyEscapeUtils = __webpack_require__(838);
var warning = __webpack_require__(14);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bindMethods = bindMethods;
function bindMethods(store, definition) {
    for (var name in definition) {
        if (Object.getOwnPropertyDescriptor && Object.defineProperty) {
            var propertyDescriptor = Object.getOwnPropertyDescriptor(definition, name);

            if (!propertyDescriptor.value || typeof propertyDescriptor.value !== "function" || !definition.hasOwnProperty(name)) {
                continue;
            }

            store[name] = definition[name].bind(store);
        } else {
            var property = definition[name];

            if (typeof property !== "function" || !definition.hasOwnProperty(name)) {
                continue;
            }

            store[name] = property.bind(store);
        }
    }

    return store;
}

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createAction = createAction;

var _utils = __webpack_require__(51);

var _ = _interopRequireWildcard(_utils);

var _ActionMethods = __webpack_require__(303);

var ActionMethods = _interopRequireWildcard(_ActionMethods);

var _PublisherMethods = __webpack_require__(196);

var PublisherMethods = _interopRequireWildcard(_PublisherMethods);

var _Keep = __webpack_require__(195);

var Keep = _interopRequireWildcard(_Keep);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var allowed = { preEmit: 1, shouldEmit: 1 };

/**
 * Creates an action functor object. It is mixed in with functions
 * from the `PublisherMethods` mixin. `preEmit` and `shouldEmit` may
 * be overridden in the definition object.
 *
 * @param {Object} definition The action object definition
 */
function createAction(definition) {

    definition = definition || {};
    if (!_.isObject(definition)) {
        definition = { actionName: definition };
    }

    for (var a in ActionMethods) {
        if (!allowed[a] && PublisherMethods[a]) {
            throw new Error("Cannot override API method " + a + " in Reflux.ActionMethods. Use another method name or override it on Reflux.PublisherMethods instead.");
        }
    }

    for (var d in definition) {
        if (!allowed[d] && PublisherMethods[d]) {
            throw new Error("Cannot override API method " + d + " in action creation. Use another method name or override it on Reflux.PublisherMethods instead.");
        }
    }

    definition.children = definition.children || [];
    if (definition.asyncResult) {
        definition.children = definition.children.concat(["completed", "failed"]);
    }

    var i = 0,
        childActions = {};
    for (; i < definition.children.length; i++) {
        var chDef = definition.children[i];
        var chName = typeof chDef === "string" ? chDef : chDef.actionName;
        childActions[chName] = createAction(chDef);
    }

    var context = _.extend({
        eventLabel: "action",
        emitter: new _.EventEmitter(),
        _isAction: true
    }, PublisherMethods, ActionMethods, definition);

    var functor = function functor() {
        var hasChildActions = false;
        /* eslint no-unused-vars:0 */
        for (var ignore in functor.childActions) {
            hasChildActions = true;break;
        }
        var async = !functor.sync && typeof functor.sync !== "undefined" || hasChildActions;
        var triggerType = async ? "triggerAsync" : "trigger";
        return functor[triggerType].apply(functor, arguments);
    };

    _.extend(functor, childActions, context);

    Keep.addAction(functor);

    return functor;
}

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mix = mix;

var _utils = __webpack_require__(51);

var _ = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function mix(def) {
    var composed = {
        init: [],
        preEmit: [],
        shouldEmit: []
    };

    var updated = function mixDef(mixin) {
        var mixed = {};
        if (mixin.mixins) {
            mixin.mixins.forEach(function (subMixin) {
                _.extend(mixed, mixDef(subMixin));
            });
        }
        _.extend(mixed, mixin);
        Object.keys(composed).forEach(function (composable) {
            if (mixin.hasOwnProperty(composable)) {
                composed[composable].push(mixin[composable]);
            }
        });
        return mixed;
    }(def);

    if (composed.init.length > 1) {
        updated.init = function () {
            var args = arguments;
            composed.init.forEach(function (init) {
                init.apply(this, args);
            }, this);
        };
    }
    if (composed.preEmit.length > 1) {
        updated.preEmit = function () {
            return composed.preEmit.reduce(function (args, preEmit) {
                var newValue = preEmit.apply(this, args);
                return newValue === undefined ? args : [newValue];
            }.bind(this), arguments);
        };
    }
    if (composed.shouldEmit.length > 1) {
        updated.shouldEmit = function () {
            var args = arguments;
            return !composed.shouldEmit.some(function (shouldEmit) {
                return !shouldEmit.apply(this, args);
            }, this);
        };
    }
    Object.keys(composed).forEach(function (composable) {
        if (composed[composable].length === 1) {
            updated[composable] = composed[composable][0];
        }
    });

    return updated;
}

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

//
// We store our EE objects in a plain object whose properties are event names.
// If `Object.create(null)` is not supported we prefix the event names with a
// `~` to make sure that the built-in object properties are not overridden or
// used as an attack vector.
// We also assume that `Object.create(null)` is available when the event name
// is an ES6 Symbol.
//
var prefix = typeof Object.create !== 'function' ? '~' : false;

/**
 * Representation of a single EventEmitter function.
 *
 * @param {Function} fn Event handler to be called.
 * @param {Mixed} context Context for function execution.
 * @param {Boolean} [once=false] Only emit once
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal EventEmitter interface that is molded against the Node.js
 * EventEmitter interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() { /* Nothing to set */ }

/**
 * Hold the assigned EventEmitters by name.
 *
 * @type {Object}
 * @private
 */
EventEmitter.prototype._events = undefined;

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var events = this._events
    , names = []
    , name;

  if (!events) return names;

  for (name in events) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return a list of assigned event listeners.
 *
 * @param {String} event The events that should be listed.
 * @param {Boolean} exists We only need to know if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events && this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Emit an event to all registered event listeners.
 *
 * @param {String} event The name of the event.
 * @returns {Boolean} Indication if we've emitted an event.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if ('function' === typeof listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Register a new EventListener for the given event.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Add an EventListener that's only called once.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Remove event listeners.
 *
 * @param {String} event The event we want to remove.
 * @param {Function} fn The listener that we need to find.
 * @param {Mixed} context Only remove listeners matching this context.
 * @param {Boolean} once Only remove once listeners.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return this;

  var listeners = this._events[evt]
    , events = [];

  if (fn) {
    if (listeners.fn) {
      if (
           listeners.fn !== fn
        || (once && !listeners.once)
        || (context && listeners.context !== context)
      ) {
        events.push(listeners);
      }
    } else {
      for (var i = 0, length = listeners.length; i < length; i++) {
        if (
             listeners[i].fn !== fn
          || (once && !listeners[i].once)
          || (context && listeners[i].context !== context)
        ) {
          events.push(listeners[i]);
        }
      }
    }
  }

  //
  // Reset the array, or remove it completely if we have no more listeners.
  //
  if (events.length) {
    this._events[evt] = events.length === 1 ? events[0] : events;
  } else {
    delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners or only the listeners for the specified event.
 *
 * @param {String} event The event want to remove all listeners for.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  if (!this._events) return this;

  if (event) delete this._events[prefix ? prefix + event : event];
  else this._events = prefix ? {} : Object.create(null);

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {


/* globals React: false */

var Reflux = __webpack_require__(197);
Reflux.defineReact = __webpack_require__(857);

// useful utility for ES6 work, mimics the ability to extend
Reflux.utils.inherits = function(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	}
	subClass.prototype = Object.create(superClass && superClass.prototype, {
		constructor: {
			value: subClass,
			enumerable: false,
			writable: true,
			configurable: true
		}
	});
	if (superClass) {
		if (Object.setPrototypeOf) {
			Object.setPrototypeOf(subClass, superClass);
		} else {
			/* jshint proto: true */
			subClass.__proto__ = superClass;
		}
	}
};

// first try to see if there's a global React var and use it
if (typeof React !== 'undefined' && React) {
	Reflux.defineReact(React);
// otherwise we're gonna resort to 'try' stuff in case of other environments
} else {
	try {
		var R = __webpack_require__(0); // we ignore this in browserify manually (see grunt file), so it's more of a doublecheck for in node
		Reflux.defineReact(R);
	} catch (e) {}
}


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

var ListenerMethods = __webpack_require__(78),
    ListenerMixin = __webpack_require__(198),
    _ = __webpack_require__(51);

module.exports = function(listenable, key) {

    _.throwIf(typeof(key) === 'undefined', 'Reflux.connect() requires a key.');

    return {
        getInitialState: function() {
            if (!_.isFunction(listenable.getInitialState)) {
                return {};
            }

            return _.object([key],[listenable.getInitialState()]);
        },
        componentDidMount: function() {
            var me = this;

            _.extend(me, ListenerMethods);

            this.listenTo(listenable, function(v) {
                me.setState(_.object([key],[v]));
            });
        },
        componentWillUnmount: ListenerMixin.componentWillUnmount
    };
};


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

var ListenerMethods = __webpack_require__(78),
    ListenerMixin = __webpack_require__(198),
    _ = __webpack_require__(51);

module.exports = function(listenable, key, filterFunc) {

    _.throwIf(_.isFunction(key), 'Reflux.connectFilter() requires a key.');

    return {
        getInitialState: function() {
            if (!_.isFunction(listenable.getInitialState)) {
                return {};
            }

            // Filter initial payload from store.
            var result = filterFunc.call(this, listenable.getInitialState());
            if (typeof(result) !== 'undefined') {
                return _.object([key], [result]);
            } else {
                return {};
            }
        },
        componentDidMount: function() {
            var me = this;

            _.extend(this, ListenerMethods);

            this.listenTo(listenable, function(value) {
                var result = filterFunc.call(me, value);
                me.setState(_.object([key], [result]));
            });
        },
        componentWillUnmount: ListenerMixin.componentWillUnmount
    };
};


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

/* globals React: false */

var Reflux = __webpack_require__(197);

/**
 * Reflux.defineReact function where you can manually supply
 * the React object in order to create in case Reflux needs to load before
 * React or there is a modular environment where there won't be a global
 * React variable.
 * @note The third param is for internal usage only.
 */
var _react, _defined = false;
function defineReact(react, noLongerUsed, extend)
{
	var proto, _extend;
	
	// if no Reflux object is yet available then return and just wait until defineReact is called manually with it
	try {
		_react  = react  || _react  || React;
		_extend = extend || _react.Component;
	} catch (e) {
		return;
	}
	
	// if Reflux and React aren't present then ignore, wait until they are properly present
	// also ignore if it's been called before UNLESS there's manual extending happening
	if (!_react || !_extend || (_defined && !extend)) {
		return;
	}
	
	// ----------- BEGIN Reflux.Component ------------
	/**
	 * Reflux.Component:
	 * An implementation for idiomatic React.js classes that mix with
	 * Reflux stores. To utilize extend Reflux.Component instead of
	 * React.Component. Then you may hook any Reflux store that has a
	 * `this.state` property containing its state values to the component
	 * via `this.store` or an Array of Reflux stores via `this.stores` in
	 * the component's constructor (similar to how you assign initial state
	 * in the constructor in ES6 style React). The default values of the
	 * stores will automatically reflect in the component's state, and any
	 * further `trigger` calls from that store will update properties passed
	 * in the trigger into the component automatically.
	 */
	var RefluxComponent = function(props, context, updater) {
		_extend.call(this, props, context, updater);
	};
	
	// equivalent of `extends React.Component` or other class if provided via `extend` param
	Reflux.utils.inherits(RefluxComponent, _extend);
	
	proto = RefluxComponent.prototype;
	
	/**
	 * this.storeKeys
	 * When this is a falsey value (null by default) the component mixes in
	 * all properties from the stores attached to it and updates on changes
	 * from all of them. When set to an array of string keys it will only
	 * utilized state property names of those keys in any store attached. This
	 * lets you choose which parts of stores update the component on a component-
	 * by-component basis. If using this it is best set in the constructor.
	 */
	proto.storeKeys = null;
	
	// on the mounting of the component that is where the store/stores are attached and initialized if needed
	proto.componentWillMount = function () {
		// if there is a this.store then simply push it onto the this.stores array or make one if needed
		if (this.store) {
			if (Array.isArray(this.stores)) {
				this.stores.unshift(this.store);
			} else {
				this.stores = [this.store];
			}
		}
		
		if (this.stores) {
			this.__storeunsubscribes__ = this.__storeunsubscribes__ || [];
			var sS = this.setState.bind(this);
			// this handles the triggering of a store, checking what's updated if proto.storeKeys is utilized
			var onStoreTrigger = function(obj){
				var updateObj = filterByStoreKeys(this.storeKeys, obj);
				if (updateObj) {
					sS(updateObj);
				}
			}.bind(this);
			// for each store in this.stores...
			for (var i = 0, ii = this.stores.length; i < ii; i++) {
				var str = this.stores[i];
				// if's a function then we know it's a class getting passed, not an instance
				if (typeof str === 'function') {
					var storeId = str.id;
					// if there is NOT a .singleton property on the store then this store has not been initialized yet, so do so
					if (!str.singleton) {
						str.singleton = new str();
						if (storeId) {
							Reflux.stores[storeId] = str.singleton;
						}
					}
					// before we weren't sure if we were working with an instance or class, so now we know an instance is created set it
					// to the variables we were using so that we can just continue on knowing it's the instance we're working with
					this.stores[i] = str = str.singleton;
					// the instance should have an .id property as well if the class does, so set that here
					str.id = storeId;
					// if there is an id and there is a global state property for this store then merge
					// the properties from that global state into the default state of the store AND then
					// set the global state to that new state (since it may have previously been partial)
					if (storeId && Reflux.GlobalState[storeId]) {
						for (var key in Reflux.GlobalState[storeId]) {
							str.state[key] = Reflux.GlobalState[storeId][key];
						}
						Reflux.GlobalState[storeId] = str.state;
					// otherwise (if it has an id) set the global state to the default state of the store
					} else if (storeId) {
						Reflux.GlobalState[storeId] = str.state;
					}
					// if no id, then no messing with global state
				}
				// listen/subscribe for the ".trigger()" in the store, and track the unsubscribes so that we can unsubscribe on unmount
				if (!Reflux.serverMode) {
					this.__storeunsubscribes__.push(str.listen(onStoreTrigger));
				}
				// run set state so that it mixes in the props from the store with the component
				var updateObj = filterByStoreKeys(this.storeKeys, str.state);
				if (updateObj) {
					this.setState(updateObj);
				}
			}
		}
		
		// mapStoreToState needs to know if is ready to map or must wait
		this.__readytomap__ = true;
		// if there are mappings that were delayed, do them now
		var dmaps = this.__delayedmaps__;
		if (dmaps) {
			for (var j=0,jj=dmaps.length; j<jj; j++) {
				dmaps[j].func( dmaps[j].state );
			}
		}
		this.__delayedmaps__ = null;
	};
	
	// on the unmount phase of the component unsubscribe that which we subscribed earlier to keep our garbage trail clean
	proto.componentWillUnmount = function () {
		if (this.__storeunsubscribes__) {
			for (var i = 0, ii = this.__storeunsubscribes__.length; i < ii; i++) {
				this.__storeunsubscribes__[i]();
			}
		}
		this.__readytomap__ = false;
	};
	
	/**
	 * this.mapStoreToState
	 * This function allow you to supply map the state of a store to the
	 * state of this component manually via your own logic. This method
	 * is completely separate from this.store/this.stores and/or this.storeKeys.
	 * Call this function with an ES6 store (class or singleton instance) as the
	 * first argument and your filter function as the second. Your filter function
	 * will receive an object of the parts of the ES6 store being updated every
	 * time its setState is called. Your filter function then returns an object
	 * which will be merged with the component state (IF it has any properties at all,
	 * should you return a blank object the component will not rerender).
	 */
	proto.mapStoreToState = function(store, filterFunc)
	{
		// make sure we have a proper singleton instance to work with
		if (typeof store === 'function') {
			if (store.singleton) {
				store = store.singleton;
			} else {
				store = Reflux.initStore(store);
			}
		}
		
		// we need a closure so that the called function can remember the proper filter function to use, so function gets defined here
		var self = this;
		function onMapStoreTrigger(obj) {
			// get an object 
			var update = filterFunc.call(self, obj);
			// if no object returned from filter functions do nothing
			if (!update) {
				return;
			}
			// check if the update actually has any mapped props
			/*jshint unused: false */
			var hasProps = false;
			for (var check in update) {
				hasProps = true;
				break;
			}
			// if there were props mapped, then update via setState
			if (hasProps) {
				self.setState(update);
			}
		}
		
		// add the listener to know when the store is triggered
		this.__storeunsubscribes__ = this.__storeunsubscribes__ || [];
		this.__storeunsubscribes__.push(store.listen(onMapStoreTrigger));
		
		// now actually run onMapStoreTrigger with the full store state so that we immediately have all store state mapped to component state
		if (this.__readytomap__) {
			onMapStoreTrigger(store.state);
		} else {
			this.__delayedmaps__ = this.__delayedmaps__ || [];
			this.__delayedmaps__.push({func:onMapStoreTrigger, state:store.state});
		}
	};
	
	/**
	 * Reflux.Component.extend(OtherClass)
	 * This allows you to get classes that extend off of another React.Component
	 * inheriting class. For example if you're using a third party that uses
	 * components that allow `class MyComponent extends LibComponent` (where LibComponent
	 * itself extends React.Component) and you want to use that component with ES6 then
	 * you can make a class `var MyDualComponent = Reflux.Component.extend(LibComponent);`
	 * then you can use `class MyComponent extends MyDualComponent` to get the benefits
	 * of both libraries.
	 */
	RefluxComponent.extend = function(clss) {
		return defineReact(null, null, clss);
	};
	
	// if is being manually called with an `extend` argument present then just return the created class
	if (extend) {
		return RefluxComponent;
	}
	
	// otherwise set as Reflux.Component and continue with other normal definitions
	Reflux.Component = RefluxComponent;
	
	// also set Reflux.PureComponent (if it exists) using the .extend feature
	if (_react.PureComponent) {
		Reflux.PureComponent = RefluxComponent.extend(_react.PureComponent);
	}
	
	// ------------ END Reflux.Component ------------
	
	// --------- BEGIN Reflux.Store ------------
	/**
	 * Reflux.Store:
	 * Also implements optional Reflux.Store class that is idiomatic with
	 * the React ES6 style. You extend Reflux.Store and then the rest works
	 * the same as createStore, except the constructor instead of init, and
	 * it holds state in a state property, and a .setState method is available
	 * which automatically updates state and does a trigger. Then when using
	 * with this.store or this.stores in an ES6 component just plass the class,
	 * it will deal with a singleton instantiation of the class automatically.
	 */
	var RefluxStore = function() {
		// extending doesn't really work well here, so instead we create an internal instance
		// and just loop through its properties/methods and make a getter/setter for each
		// that will actually be getting and setting on that internal instance.
		this.__store__ = Reflux.createStore();
		this.state = {};
		var self = this;
		for (var key in this.__store__) {
			/*jshint loopfunc: true */
			(function (prop) {
				Object.defineProperty(self, prop, {
					get: function () { return self.__store__[prop]; },
					set: function (v) { self.__store__[prop] = v; }
				});
			})(key);
		}
	};
	
	proto = RefluxStore.prototype;
	
	// this defines the listenables property, mostly intended to be set as `this.listenables` in the constructor of the store
	// it is essentially a shortcut to the `listenToMany` method
	Object.defineProperty(proto, "listenables", {
		get: function () {
			return this.__listenables__;
		},
		set: function (v) {
			var Combined = {};
			if (Array.isArray(v)){
				v.forEach(function(obj) {
					for (var key in obj) {
						Combined[key] = obj[key];
					}
				});
			} else {
				Combined = v;
			}
			this.__listenables__ = Combined;
			this.listenToMany(Combined);
		},
		enumerable: true,
		configurable: true
	});
	
	// allows simple usage of `this.setState(obj)` within the store to both update the state and trigger the store to update
	// components that it is attached to in a simple way that is idiomatic with React
	proto.setState = function (obj) {
		// Object.assign(this.state, obj); // later turn this to Object.assign and remove loop once support is good enough
		for (var key in obj) {
			this.state[key] = obj[key];
		}
		// if there's an id (i.e. it's being tracked by the global state) then make sure to update the global state
		if (this.id) {
			Reflux.GlobalState[this.id] = this.state;
		}
		// trigger, because any component it's attached to is listening and will merge the store state into its own on a store trigger
		this.trigger(obj);
	};
	
	// this is a static property so that other code can identify that this is a Reflux.Store class
	// has issues specifically when using babel to transpile your ES6 stores for IE10 and below, not documented and shouldn't use yet
	Object.defineProperty(RefluxStore, "isES6Store", {
		get: function () {
			return true;
		},
		enumerable: true,
		configurable: true
	});
	
	// allows a shortcut for accessing MyStore.singleton.state as MyStore.state (since common usage makes a singleton)
	Object.defineProperty(RefluxStore, "state", {
		get: function () {
			if (!this.singleton) {
				throw new Error('Reflux.Store.state is inaccessible before the store has been initialized.');
			}
			return this.singleton.state;
		},
		enumerable: true,
		configurable: true
	});
	
	/* NOTE:
	If a Reflux.Store definition is given a static id property and used
	properly within a Reflux.Component or with Reflux.initStore then
	it will be added to the Reflux.GlobalState object which automatically tracks the
	current state of all such defined stores in the program. */
	
	Reflux.Store = RefluxStore;
	// ----------- END Reflux.Store -------------
	
	// --------- BEGIN Reflux Static Props/Methods ------------
	/**
	 * Reflux.GlobalState is where data is stored for any Reflux.Store that has a static id property. Each store's
	 * state will be on the Reflux.GlobalState object with the id as the key. So a store with the id "MyStore" and
	 * a state {"color":"red"} will end up with a Reflux.GlobalState of {"MyStore":{"color":"red"}}
	 * Reflux.GlobalState is an accessible part of the API. However, keep in mind that non-primitive properties you
	 * read off of it will continue to mutate and you can only manually mutate Reflux.GlobalState BEFORE any component
	 * mounting of components with ES6 stores. For more functionality look to Reflux.setGlobalState to change the global
	 * state at any point, and Reflux.getGlobalState to return a deep clone of the Reflux.GlobalState object which will
	 * not continue to mutate as Reflux.GlobalState continues to mutate.
	 */
	Reflux.GlobalState = Reflux.GlobalState || {};
	
	/**
	 * Reflux.stores
	 * All initialized stores that have an id will have a reference to their singleton stored here with the key being the id.
	 */
	Reflux.stores = {};
	
	/**
	 * Reflux.getGlobalState takes no arguments, and returns a deep clone of Reflux.GlobalState 
	 * which will not continue to mutate as Reflux.GlobalState does. It can essentially store
	 * snapshots of the global state as the program goes for saving or for in-app time travel.
	 */
	Reflux.getGlobalState = function() {
		return clone(Reflux.GlobalState);
	};
	
	/**
	 * Reflux.setGlobalState takes one argument that is a representation of the a possible
	 * global state. It updates all stores in the program to represent data in that given state.
	 * This includes triggering those stores so that that state is represented in any Reflux.Component
	 * instances they are attached to. Partial states may be given to it, and only the represented
	 * stores/state values will be updated.
	 */
	Reflux.setGlobalState = function(obj) {
		for (var storeID in obj) {
			if (Reflux.stores[storeID]) {
				Reflux.stores[storeID].setState(obj[storeID]);
			} else {
				Reflux.GlobalState[storeID] = obj[storeID];
			}
		}
	};
	
	/**
	 * Reflux.initStore takes one argument (a class that extends Reflux.Store) and returns a singleton
	 * intance of that class. Its main functionality is to be able to mimic what happens to stores attached to
	 * this.store or this.stores during the mounting phase of a component without having to actually attach the
	 * store to a component in order to work properly with the global state.
	 */
	// Reflux.initializeGlobalStore is kept for backwards compatibility, but deprecated since the function is
	// now for more broad instantiation of globally stored AND non-globally stored classes
	Reflux.initializeGlobalStore = Reflux.initStore = function(str) {
		var storeId = str.id;
		// if they're initializing something twice then we're done already, return it
		if (str.singleton) {
			return str.singleton;
		}
		// if no id then it's easy: just make new instance and set to singleton
		if (!storeId) {
			str.singleton = new str();
			return str.singleton;
		}
		// create the singleton and assign it to the class's singleton static property
		var inst = str.singleton = new str();
		// store it on the Reflux.stores array to be accessible later
		Reflux.stores[storeId] = inst;
		// the singleton instance itself should also have the id property of the class
		inst.id = storeId;
		// if the global state has something set for this id, copy it to the state and then
		// make sure to set the global state to the end result, since it may have only been partial
		if (Reflux.GlobalState[storeId]) {
			for (var key in Reflux.GlobalState[storeId]) {
				inst.state[key] = Reflux.GlobalState[storeId][key];
			}
			Reflux.GlobalState[storeId] = inst.state;
		// otherwise just set the global state to the default state of the class
		} else {
			Reflux.GlobalState[storeId] = inst.state;
		}
		// returns the singleton itself, though it will also be accessible as as `MyClass.singleton`
		return inst;
	};
	// --------- END Reflux Static Props/Methods ------------
	
	// so it knows not to redefine Reflux static stuff and stores if called again
	_defined = true;
}

// filters a state object by storeKeys array (if it exists)
// if filtering and obj contains no properties to use, returns false to let the component know not to update
function filterByStoreKeys(storeKeys, obj)
{
	// if there are not storeKeys defined then simply return the whole original object
	if (!storeKeys) {
		return obj;
	}
	// otherwise go through and only update properties that are in the storeKeys array, and return straight false if there are none
	var doUpdate = false;
	var updateObj = {};
	for (var i = 0, ii = storeKeys.length; i < ii; i++) {
		var prop = storeKeys[i];
		if (obj.hasOwnProperty(prop)) {
			doUpdate = true;
			updateObj[prop] = obj[prop];
		}
	}
	return doUpdate ? updateObj : false;
}

// this is utilized by some of the global state functionality in order to get a clone that will
// not continue to be modified as the GlobalState mutates
function clone(frm, to) {
	if (frm === null || typeof frm !== "object") {
		return frm;
	}
	if (frm.constructor !== Object && frm.constructor !== Array) {
		return frm;
	}
	if (frm.constructor === Date || frm.constructor === RegExp || frm.constructor === Function ||
		frm.constructor === String || frm.constructor === Number || frm.constructor === Boolean) {
		return new frm.constructor(frm);
	}
	to = to || new frm.constructor();
	for (var name in frm) {
		to[name] = typeof to[name] === "undefined" ? clone(frm[name], null) : to[name];
	}
	return to;
}

module.exports = defineReact;



/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

var ListenerMethods = __webpack_require__(78);

/**
 * A mixin factory for a React component. Meant as a more convenient way of using the `ListenerMixin`,
 * without having to manually set listeners in the `componentDidMount` method.
 *
 * @param {Action|Store} listenable An Action or Store that should be
 *  listened to.
 * @param {Function|String} callback The callback to register as event handler
 * @param {Function|String} defaultCallback The callback to register as default handler
 * @returns {Object} An object to be used as a mixin, which sets up the listener for the given listenable.
 */
module.exports = function(listenable,callback,initial){
    return {
        /**
         * Set up the mixin before the initial rendering occurs. Import methods from `ListenerMethods`
         * and then make the call to `listenTo` with the arguments provided to the factory function
         */
        componentDidMount: function() {
            for(var m in ListenerMethods){
                if (this[m] !== ListenerMethods[m]){
                    if (this[m]){
                        throw "Can't have other property '"+m+"' when using Reflux.listenTo!";
                    }
                    this[m] = ListenerMethods[m];
                }
            }
            this.listenTo(listenable,callback,initial);
        },
        /**
         * Cleans up all listener previously registered.
         */
        componentWillUnmount: ListenerMethods.stopListeningToAll
    };
};


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var ListenerMethods = __webpack_require__(78);

/**
 * A mixin factory for a React component. Meant as a more convenient way of using the `listenerMixin`,
 * without having to manually set listeners in the `componentDidMount` method. This version is used
 * to automatically set up a `listenToMany` call.
 *
 * @param {Object} listenables An object of listenables
 * @returns {Object} An object to be used as a mixin, which sets up the listeners for the given listenables.
 */
module.exports = function(listenables){
    return {
        /**
         * Set up the mixin before the initial rendering occurs. Import methods from `ListenerMethods`
         * and then make the call to `listenTo` with the arguments provided to the factory function
         */
        componentDidMount: function() {
            for(var m in ListenerMethods){
                if (this[m] !== ListenerMethods[m]){
                    if (this[m]){
                        throw "Can't have other property '"+m+"' when using Reflux.listenToMany!";
                    }
                    this[m] = ListenerMethods[m];
                }
            }
            this.listenToMany(listenables);
        },
        /**
         * Cleans up all listener previously registered.
         */
        componentWillUnmount: ListenerMethods.stopListeningToAll
    };
};


/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 861 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = function(src) {
	function log(error) {
		(typeof console !== "undefined")
		&& (console.error || console.log)("[Script Loader]", error);
	}

	// Check for IE =< 8
	function isIE() {
		return typeof attachEvent !== "undefined" && typeof addEventListener === "undefined";
	}

	try {
		if (typeof execScript !== "undefined" && isIE()) {
			execScript(src);
		} else if (typeof eval !== "undefined") {
			eval.call(null, src);
		} else {
			log("EvalError: No eval function available");
		}
	} catch (error) {
		log(error);
	}
}


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(861)(__webpack_require__(735))

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63), __webpack_require__(169)))

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

window.eve = __webpack_require__(657)

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var mina = (function (eve) {
    var animations = {},
    requestAnimFrame = window.requestAnimationFrame       ||
                       window.webkitRequestAnimationFrame ||
                       window.mozRequestAnimationFrame    ||
                       window.oRequestAnimationFrame      ||
                       window.msRequestAnimationFrame     ||
                       function (callback) {
                           setTimeout(callback, 16);
                       },
    isArray = Array.isArray || function (a) {
        return a instanceof Array ||
            Object.prototype.toString.call(a) == "[object Array]";
    },
    idgen = 0,
    idprefix = "M" + (+new Date).toString(36),
    ID = function () {
        return idprefix + (idgen++).toString(36);
    },
    diff = function (a, b, A, B) {
        if (isArray(a)) {
            res = [];
            for (var i = 0, ii = a.length; i < ii; i++) {
                res[i] = diff(a[i], b, A[i], B);
            }
            return res;
        }
        var dif = (A - a) / (B - b);
        return function (bb) {
            return a + dif * (bb - b);
        };
    },
    timer = Date.now || function () {
        return +new Date;
    },
    sta = function (val) {
        var a = this;
        if (val == null) {
            return a.s;
        }
        var ds = a.s - val;
        a.b += a.dur * ds;
        a.B += a.dur * ds;
        a.s = val;
    },
    speed = function (val) {
        var a = this;
        if (val == null) {
            return a.spd;
        }
        a.spd = val;
    },
    duration = function (val) {
        var a = this;
        if (val == null) {
            return a.dur;
        }
        a.s = a.s * val / a.dur;
        a.dur = val;
    },
    stopit = function () {
        var a = this;
        delete animations[a.id];
        a.update();
        eve("mina.stop." + a.id, a);
    },
    pause = function () {
        var a = this;
        if (a.pdif) {
            return;
        }
        delete animations[a.id];
        a.update();
        a.pdif = a.get() - a.b;
    },
    resume = function () {
        var a = this;
        if (!a.pdif) {
            return;
        }
        a.b = a.get() - a.pdif;
        delete a.pdif;
        animations[a.id] = a;
    },
    update = function () {
        var a = this,
            res;
        if (isArray(a.start)) {
            res = [];
            for (var j = 0, jj = a.start.length; j < jj; j++) {
                res[j] = +a.start[j] +
                    (a.end[j] - a.start[j]) * a.easing(a.s);
            }
        } else {
            res = +a.start + (a.end - a.start) * a.easing(a.s);
        }
        a.set(res);
    },
    frame = function () {
        var len = 0;
        for (var i in animations) if (animations.hasOwnProperty(i)) {
            var a = animations[i],
                b = a.get(),
                res;
            len++;
            a.s = (b - a.b) / (a.dur / a.spd);
            if (a.s >= 1) {
                delete animations[i];
                a.s = 1;
                len--;
                (function (a) {
                    setTimeout(function () {
                        eve("mina.finish." + a.id, a);
                    });
                }(a));
            }
            a.update();
        }
        len && requestAnimFrame(frame);
    },
    /*\
     * mina
     [ method ]
     **
     * Generic animation of numbers
     **
     - a (number) start _slave_ number
     - A (number) end _slave_ number
     - b (number) start _master_ number (start time in general case)
     - B (number) end _master_ number (end time in gereal case)
     - get (function) getter of _master_ number (see @mina.time)
     - set (function) setter of _slave_ number
     - easing (function) #optional easing function, default is @mina.linear
     = (object) animation descriptor
     o {
     o         id (string) animation id,
     o         start (number) start _slave_ number,
     o         end (number) end _slave_ number,
     o         b (number) start _master_ number,
     o         s (number) animation status (0..1),
     o         dur (number) animation duration,
     o         spd (number) animation speed,
     o         get (function) getter of _master_ number (see @mina.time),
     o         set (function) setter of _slave_ number,
     o         easing (function) easing function, default is @mina.linear,
     o         status (function) status getter/setter,
     o         speed (function) speed getter/setter,
     o         duration (function) duration getter/setter,
     o         stop (function) animation stopper
     o         pause (function) pauses the animation
     o         resume (function) resumes the animation
     o         update (function) calles setter with the right value of the animation
     o }
    \*/
    mina = function (a, A, b, B, get, set, easing) {
        var anim = {
            id: ID(),
            start: a,
            end: A,
            b: b,
            s: 0,
            dur: B - b,
            spd: 1,
            get: get,
            set: set,
            easing: easing || mina.linear,
            status: sta,
            speed: speed,
            duration: duration,
            stop: stopit,
            pause: pause,
            resume: resume,
            update: update
        };
        animations[anim.id] = anim;
        var len = 0, i;
        for (i in animations) if (animations.hasOwnProperty(i)) {
            len++;
            if (len == 2) {
                break;
            }
        }
        len == 1 && requestAnimFrame(frame);
        return anim;
    };
    /*\
     * mina.time
     [ method ]
     **
     * Returns the current time. Equivalent to:
     | function () {
     |     return (new Date).getTime();
     | }
    \*/
    mina.time = timer;
    /*\
     * mina.getById
     [ method ]
     **
     * Returns an animation by its id
     - id (string) animation's id
     = (object) See @mina
    \*/
    mina.getById = function (id) {
        return animations[id] || null;
    };

    /*\
     * mina.linear
     [ method ]
     **
     * Default linear easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.linear = function (n) {
        return n;
    };
    /*\
     * mina.easeout
     [ method ]
     **
     * Easeout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.easeout = function (n) {
        return Math.pow(n, 1.7);
    };
    /*\
     * mina.easein
     [ method ]
     **
     * Easein easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.easein = function (n) {
        return Math.pow(n, .48);
    };
    /*\
     * mina.easeinout
     [ method ]
     **
     * Easeinout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.easeinout = function (n) {
        if (n == 1) {
            return 1;
        }
        if (n == 0) {
            return 0;
        }
        var q = .48 - n / 1.04,
            Q = Math.sqrt(.1734 + q * q),
            x = Q - q,
            X = Math.pow(Math.abs(x), 1 / 3) * (x < 0 ? -1 : 1),
            y = -Q - q,
            Y = Math.pow(Math.abs(y), 1 / 3) * (y < 0 ? -1 : 1),
            t = X + Y + .5;
        return (1 - t) * 3 * t * t + t * t * t;
    };
    /*\
     * mina.backin
     [ method ]
     **
     * Backin easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.backin = function (n) {
        if (n == 1) {
            return 1;
        }
        var s = 1.70158;
        return n * n * ((s + 1) * n - s);
    };
    /*\
     * mina.backout
     [ method ]
     **
     * Backout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.backout = function (n) {
        if (n == 0) {
            return 0;
        }
        n = n - 1;
        var s = 1.70158;
        return n * n * ((s + 1) * n + s) + 1;
    };
    /*\
     * mina.elastic
     [ method ]
     **
     * Elastic easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.elastic = function (n) {
        if (n == !!n) {
            return n;
        }
        return Math.pow(2, -10 * n) * Math.sin((n - .075) *
            (2 * Math.PI) / .3) + 1;
    };
    /*\
     * mina.bounce
     [ method ]
     **
     * Bounce easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/
    mina.bounce = function (n) {
        var s = 7.5625,
            p = 2.75,
            l;
        if (n < (1 / p)) {
            l = s * n * n;
        } else {
            if (n < (2 / p)) {
                n -= (1.5 / p);
                l = s * n * n + .75;
            } else {
                if (n < (2.5 / p)) {
                    n -= (2.25 / p);
                    l = s * n * n + .9375;
                } else {
                    n -= (2.625 / p);
                    l = s * n * n + .984375;
                }
            }
        }
        return l;
    };
    window.mina = mina;
    return mina;
})(typeof eve == "undefined" ? function () {} : eve);
// Copyright (c) 2013 - 2015 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var Snap = (function(root) {
Snap.version = "0.4.0";
/*\
 * Snap
 [ method ]
 **
 * Creates a drawing surface or wraps existing SVG element.
 **
 - width (number|string) width of surface
 - height (number|string) height of surface
 * or
 - DOM (SVGElement) element to be wrapped into Snap structure
 * or
 - array (array) array of elements (will return set of elements)
 * or
 - query (string) CSS query selector
 = (object) @Element
\*/
function Snap(w, h) {
    if (w) {
        if (w.nodeType) {
            return wrap(w);
        }
        if (is(w, "array") && Snap.set) {
            return Snap.set.apply(Snap, w);
        }
        if (w instanceof Element) {
            return w;
        }
        if (h == null) {
            w = glob.doc.querySelector(String(w));
            return wrap(w);
        }
    }
    w = w == null ? "100%" : w;
    h = h == null ? "100%" : h;
    return new Paper(w, h);
}
Snap.toString = function () {
    return "Snap v" + this.version;
};
Snap._ = {};
var glob = {
    win: root.window,
    doc: root.window.document
};
Snap._.glob = glob;
var has = "hasOwnProperty",
    Str = String,
    toFloat = parseFloat,
    toInt = parseInt,
    math = Math,
    mmax = math.max,
    mmin = math.min,
    abs = math.abs,
    pow = math.pow,
    PI = math.PI,
    round = math.round,
    E = "",
    S = " ",
    objectToString = Object.prototype.toString,
    ISURL = /^url\(['"]?([^\)]+?)['"]?\)$/i,
    colourRegExp = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\))\s*$/i,
    bezierrg = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/,
    reURLValue = /^url\(#?([^)]+)\)$/,
    separator = Snap._.separator = /[,\s]+/,
    whitespace = /[\s]/g,
    commaSpaces = /[\s]*,[\s]*/,
    hsrg = {hs: 1, rg: 1},
    pathCommand = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig,
    tCommand = /([rstm])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig,
    pathValues = /(-?\d*\.?\d*(?:e[\-+]?\\d+)?)[\s]*,?[\s]*/ig,
    idgen = 0,
    idprefix = "S" + (+new Date).toString(36),
    ID = function (el) {
        return (el && el.type ? el.type : E) + idprefix + (idgen++).toString(36);
    },
    xlink = "http://www.w3.org/1999/xlink",
    xmlns = "http://www.w3.org/2000/svg",
    hub = {},
    URL = Snap.url = function (url) {
        return "url('#" + url + "')";
    };

function $(el, attr) {
    if (attr) {
        if (el == "#text") {
            el = glob.doc.createTextNode(attr.text || attr["#text"] || "");
        }
        if (el == "#comment") {
            el = glob.doc.createComment(attr.text || attr["#text"] || "");
        }
        if (typeof el == "string") {
            el = $(el);
        }
        if (typeof attr == "string") {
            if (el.nodeType == 1) {
                if (attr.substring(0, 6) == "xlink:") {
                    return el.getAttributeNS(xlink, attr.substring(6));
                }
                if (attr.substring(0, 4) == "xml:") {
                    return el.getAttributeNS(xmlns, attr.substring(4));
                }
                return el.getAttribute(attr);
            } else if (attr == "text") {
                return el.nodeValue;
            } else {
                return null;
            }
        }
        if (el.nodeType == 1) {
            for (var key in attr) if (attr[has](key)) {
                var val = Str(attr[key]);
                if (val) {
                    if (key.substring(0, 6) == "xlink:") {
                        el.setAttributeNS(xlink, key.substring(6), val);
                    } else if (key.substring(0, 4) == "xml:") {
                        el.setAttributeNS(xmlns, key.substring(4), val);
                    } else {
                        el.setAttribute(key, val);
                    }
                } else {
                    el.removeAttribute(key);
                }
            }
        } else if ("text" in attr) {
            el.nodeValue = attr.text;
        }
    } else {
        el = glob.doc.createElementNS(xmlns, el);
    }
    return el;
}
Snap._.$ = $;
Snap._.id = ID;
function getAttrs(el) {
    var attrs = el.attributes,
        name,
        out = {};
    for (var i = 0; i < attrs.length; i++) {
        if (attrs[i].namespaceURI == xlink) {
            name = "xlink:";
        } else {
            name = "";
        }
        name += attrs[i].name;
        out[name] = attrs[i].textContent;
    }
    return out;
}
function is(o, type) {
    type = Str.prototype.toLowerCase.call(type);
    if (type == "finite") {
        return isFinite(o);
    }
    if (type == "array" &&
        (o instanceof Array || Array.isArray && Array.isArray(o))) {
        return true;
    }
    return  (type == "null" && o === null) ||
            (type == typeof o && o !== null) ||
            (type == "object" && o === Object(o)) ||
            objectToString.call(o).slice(8, -1).toLowerCase() == type;
}
/*\
 * Snap.format
 [ method ]
 **
 * Replaces construction of type `{<name>}` to the corresponding argument
 **
 - token (string) string to format
 - json (object) object which properties are used as a replacement
 = (string) formatted string
 > Usage
 | // this draws a rectangular shape equivalent to "M10,20h40v50h-40z"
 | paper.path(Snap.format("M{x},{y}h{dim.width}v{dim.height}h{dim['negative width']}z", {
 |     x: 10,
 |     y: 20,
 |     dim: {
 |         width: 40,
 |         height: 50,
 |         "negative width": -40
 |     }
 | }));
\*/
Snap.format = (function () {
    var tokenRegex = /\{([^\}]+)\}/g,
        objNotationRegex = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g, // matches .xxxxx or ["xxxxx"] to run over object properties
        replacer = function (all, key, obj) {
            var res = obj;
            key.replace(objNotationRegex, function (all, name, quote, quotedName, isFunc) {
                name = name || quotedName;
                if (res) {
                    if (name in res) {
                        res = res[name];
                    }
                    typeof res == "function" && isFunc && (res = res());
                }
            });
            res = (res == null || res == obj ? all : res) + "";
            return res;
        };
    return function (str, obj) {
        return Str(str).replace(tokenRegex, function (all, key) {
            return replacer(all, key, obj);
        });
    };
})();
function clone(obj) {
    if (typeof obj == "function" || Object(obj) !== obj) {
        return obj;
    }
    var res = new obj.constructor;
    for (var key in obj) if (obj[has](key)) {
        res[key] = clone(obj[key]);
    }
    return res;
}
Snap._.clone = clone;
function repush(array, item) {
    for (var i = 0, ii = array.length; i < ii; i++) if (array[i] === item) {
        return array.push(array.splice(i, 1)[0]);
    }
}
function cacher(f, scope, postprocessor) {
    function newf() {
        var arg = Array.prototype.slice.call(arguments, 0),
            args = arg.join("\u2400"),
            cache = newf.cache = newf.cache || {},
            count = newf.count = newf.count || [];
        if (cache[has](args)) {
            repush(count, args);
            return postprocessor ? postprocessor(cache[args]) : cache[args];
        }
        count.length >= 1e3 && delete cache[count.shift()];
        count.push(args);
        cache[args] = f.apply(scope, arg);
        return postprocessor ? postprocessor(cache[args]) : cache[args];
    }
    return newf;
}
Snap._.cacher = cacher;
function angle(x1, y1, x2, y2, x3, y3) {
    if (x3 == null) {
        var x = x1 - x2,
            y = y1 - y2;
        if (!x && !y) {
            return 0;
        }
        return (180 + math.atan2(-y, -x) * 180 / PI + 360) % 360;
    } else {
        return angle(x1, y1, x3, y3) - angle(x2, y2, x3, y3);
    }
}
function rad(deg) {
    return deg % 360 * PI / 180;
}
function deg(rad) {
    return rad * 180 / PI % 360;
}
function x_y() {
    return this.x + S + this.y;
}
function x_y_w_h() {
    return this.x + S + this.y + S + this.width + " \xd7 " + this.height;
}

/*\
 * Snap.rad
 [ method ]
 **
 * Transform angle to radians
 - deg (number) angle in degrees
 = (number) angle in radians
\*/
Snap.rad = rad;
/*\
 * Snap.deg
 [ method ]
 **
 * Transform angle to degrees
 - rad (number) angle in radians
 = (number) angle in degrees
\*/
Snap.deg = deg;
/*\
 * Snap.sin
 [ method ]
 **
 * Equivalent to `Math.sin()` only works with degrees, not radians.
 - angle (number) angle in degrees
 = (number) sin
\*/
Snap.sin = function (angle) {
    return math.sin(Snap.rad(angle));
};
/*\
 * Snap.tan
 [ method ]
 **
 * Equivalent to `Math.tan()` only works with degrees, not radians.
 - angle (number) angle in degrees
 = (number) tan
\*/
Snap.tan = function (angle) {
    return math.tan(Snap.rad(angle));
};
/*\
 * Snap.cos
 [ method ]
 **
 * Equivalent to `Math.cos()` only works with degrees, not radians.
 - angle (number) angle in degrees
 = (number) cos
\*/
Snap.cos = function (angle) {
    return math.cos(Snap.rad(angle));
};
/*\
 * Snap.asin
 [ method ]
 **
 * Equivalent to `Math.asin()` only works with degrees, not radians.
 - num (number) value
 = (number) asin in degrees
\*/
Snap.asin = function (num) {
    return Snap.deg(math.asin(num));
};
/*\
 * Snap.acos
 [ method ]
 **
 * Equivalent to `Math.acos()` only works with degrees, not radians.
 - num (number) value
 = (number) acos in degrees
\*/
Snap.acos = function (num) {
    return Snap.deg(math.acos(num));
};
/*\
 * Snap.atan
 [ method ]
 **
 * Equivalent to `Math.atan()` only works with degrees, not radians.
 - num (number) value
 = (number) atan in degrees
\*/
Snap.atan = function (num) {
    return Snap.deg(math.atan(num));
};
/*\
 * Snap.atan2
 [ method ]
 **
 * Equivalent to `Math.atan2()` only works with degrees, not radians.
 - num (number) value
 = (number) atan2 in degrees
\*/
Snap.atan2 = function (num) {
    return Snap.deg(math.atan2(num));
};
/*\
 * Snap.angle
 [ method ]
 **
 * Returns an angle between two or three points
 > Parameters
 - x1 (number) x coord of first point
 - y1 (number) y coord of first point
 - x2 (number) x coord of second point
 - y2 (number) y coord of second point
 - x3 (number) #optional x coord of third point
 - y3 (number) #optional y coord of third point
 = (number) angle in degrees
\*/
Snap.angle = angle;
/*\
 * Snap.len
 [ method ]
 **
 * Returns distance between two points
 > Parameters
 - x1 (number) x coord of first point
 - y1 (number) y coord of first point
 - x2 (number) x coord of second point
 - y2 (number) y coord of second point
 = (number) distance
\*/
Snap.len = function (x1, y1, x2, y2) {
    return Math.sqrt(Snap.len2(x1, y1, x2, y2));
};
/*\
 * Snap.len2
 [ method ]
 **
 * Returns squared distance between two points
 > Parameters
 - x1 (number) x coord of first point
 - y1 (number) y coord of first point
 - x2 (number) x coord of second point
 - y2 (number) y coord of second point
 = (number) distance
\*/
Snap.len2 = function (x1, y1, x2, y2) {
    return (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
};
/*\
 * Snap.closestPoint
 [ method ]
 **
 * Returns closest point to a given one on a given path.
 > Parameters
 - path (Element) path element
 - x (number) x coord of a point
 - y (number) y coord of a point
 = (object) in format
 {
    x (number) x coord of the point on the path
    y (number) y coord of the point on the path
    length (number) length of the path to the point
    distance (number) distance from the given point to the path
 }
\*/
// Copied from http://bl.ocks.org/mbostock/8027637
Snap.closestPoint = function (path, x, y) {
    function distance2(p) {
        var dx = p.x - x,
            dy = p.y - y;
        return dx * dx + dy * dy;
    }
    var pathNode = path.node,
        pathLength = pathNode.getTotalLength(),
        precision = pathLength / pathNode.pathSegList.numberOfItems * .125,
        best,
        bestLength,
        bestDistance = Infinity;

    // linear scan for coarse approximation
    for (var scan, scanLength = 0, scanDistance; scanLength <= pathLength; scanLength += precision) {
        if ((scanDistance = distance2(scan = pathNode.getPointAtLength(scanLength))) < bestDistance) {
            best = scan, bestLength = scanLength, bestDistance = scanDistance;
        }
    }

    // binary search for precise estimate
    precision *= .5;
    while (precision > .5) {
        var before,
            after,
            beforeLength,
            afterLength,
            beforeDistance,
            afterDistance;
        if ((beforeLength = bestLength - precision) >= 0 && (beforeDistance = distance2(before = pathNode.getPointAtLength(beforeLength))) < bestDistance) {
            best = before, bestLength = beforeLength, bestDistance = beforeDistance;
        } else if ((afterLength = bestLength + precision) <= pathLength && (afterDistance = distance2(after = pathNode.getPointAtLength(afterLength))) < bestDistance) {
            best = after, bestLength = afterLength, bestDistance = afterDistance;
        } else {
            precision *= .5;
        }
    }

    best = {
        x: best.x,
        y: best.y,
        length: bestLength,
        distance: Math.sqrt(bestDistance)
    };
    return best;
}
/*\
 * Snap.is
 [ method ]
 **
 * Handy replacement for the `typeof` operator
 - o (…) any object or primitive
 - type (string) name of the type, e.g., `string`, `function`, `number`, etc.
 = (boolean) `true` if given value is of given type
\*/
Snap.is = is;
/*\
 * Snap.snapTo
 [ method ]
 **
 * Snaps given value to given grid
 - values (array|number) given array of values or step of the grid
 - value (number) value to adjust
 - tolerance (number) #optional maximum distance to the target value that would trigger the snap. Default is `10`.
 = (number) adjusted value
\*/
Snap.snapTo = function (values, value, tolerance) {
    tolerance = is(tolerance, "finite") ? tolerance : 10;
    if (is(values, "array")) {
        var i = values.length;
        while (i--) if (abs(values[i] - value) <= tolerance) {
            return values[i];
        }
    } else {
        values = +values;
        var rem = value % values;
        if (rem < tolerance) {
            return value - rem;
        }
        if (rem > values - tolerance) {
            return value - rem + values;
        }
    }
    return value;
};
// Colour
/*\
 * Snap.getRGB
 [ method ]
 **
 * Parses color string as RGB object
 - color (string) color string in one of the following formats:
 # <ul>
 #     <li>Color name (<code>red</code>, <code>green</code>, <code>cornflowerblue</code>, etc)</li>
 #     <li>#••• — shortened HTML color: (<code>#000</code>, <code>#fc0</code>, etc.)</li>
 #     <li>#•••••• — full length HTML color: (<code>#000000</code>, <code>#bd2300</code>)</li>
 #     <li>rgb(•••, •••, •••) — red, green and blue channels values: (<code>rgb(200,&nbsp;100,&nbsp;0)</code>)</li>
 #     <li>rgba(•••, •••, •••, •••) — also with opacity</li>
 #     <li>rgb(•••%, •••%, •••%) — same as above, but in %: (<code>rgb(100%,&nbsp;175%,&nbsp;0%)</code>)</li>
 #     <li>rgba(•••%, •••%, •••%, •••%) — also with opacity</li>
 #     <li>hsb(•••, •••, •••) — hue, saturation and brightness values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;1)</code>)</li>
 #     <li>hsba(•••, •••, •••, •••) — also with opacity</li>
 #     <li>hsb(•••%, •••%, •••%) — same as above, but in %</li>
 #     <li>hsba(•••%, •••%, •••%, •••%) — also with opacity</li>
 #     <li>hsl(•••, •••, •••) — hue, saturation and luminosity values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;0.5)</code>)</li>
 #     <li>hsla(•••, •••, •••, •••) — also with opacity</li>
 #     <li>hsl(•••%, •••%, •••%) — same as above, but in %</li>
 #     <li>hsla(•••%, •••%, •••%, •••%) — also with opacity</li>
 # </ul>
 * Note that `%` can be used any time: `rgb(20%, 255, 50%)`.
 = (object) RGB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••,
 o     error (boolean) true if string can't be parsed
 o }
\*/
Snap.getRGB = cacher(function (colour) {
    if (!colour || !!((colour = Str(colour)).indexOf("-") + 1)) {
        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
    }
    if (colour == "none") {
        return {r: -1, g: -1, b: -1, hex: "none", toString: rgbtoString};
    }
    !(hsrg[has](colour.toLowerCase().substring(0, 2)) || colour.charAt() == "#") && (colour = toHex(colour));
    if (!colour) {
        return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
    }
    var res,
        red,
        green,
        blue,
        opacity,
        t,
        values,
        rgb = colour.match(colourRegExp);
    if (rgb) {
        if (rgb[2]) {
            blue = toInt(rgb[2].substring(5), 16);
            green = toInt(rgb[2].substring(3, 5), 16);
            red = toInt(rgb[2].substring(1, 3), 16);
        }
        if (rgb[3]) {
            blue = toInt((t = rgb[3].charAt(3)) + t, 16);
            green = toInt((t = rgb[3].charAt(2)) + t, 16);
            red = toInt((t = rgb[3].charAt(1)) + t, 16);
        }
        if (rgb[4]) {
            values = rgb[4].split(commaSpaces);
            red = toFloat(values[0]);
            values[0].slice(-1) == "%" && (red *= 2.55);
            green = toFloat(values[1]);
            values[1].slice(-1) == "%" && (green *= 2.55);
            blue = toFloat(values[2]);
            values[2].slice(-1) == "%" && (blue *= 2.55);
            rgb[1].toLowerCase().slice(0, 4) == "rgba" && (opacity = toFloat(values[3]));
            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
        }
        if (rgb[5]) {
            values = rgb[5].split(commaSpaces);
            red = toFloat(values[0]);
            values[0].slice(-1) == "%" && (red /= 100);
            green = toFloat(values[1]);
            values[1].slice(-1) == "%" && (green /= 100);
            blue = toFloat(values[2]);
            values[2].slice(-1) == "%" && (blue /= 100);
            (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
            rgb[1].toLowerCase().slice(0, 4) == "hsba" && (opacity = toFloat(values[3]));
            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
            return Snap.hsb2rgb(red, green, blue, opacity);
        }
        if (rgb[6]) {
            values = rgb[6].split(commaSpaces);
            red = toFloat(values[0]);
            values[0].slice(-1) == "%" && (red /= 100);
            green = toFloat(values[1]);
            values[1].slice(-1) == "%" && (green /= 100);
            blue = toFloat(values[2]);
            values[2].slice(-1) == "%" && (blue /= 100);
            (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
            rgb[1].toLowerCase().slice(0, 4) == "hsla" && (opacity = toFloat(values[3]));
            values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
            return Snap.hsl2rgb(red, green, blue, opacity);
        }
        red = mmin(math.round(red), 255);
        green = mmin(math.round(green), 255);
        blue = mmin(math.round(blue), 255);
        opacity = mmin(mmax(opacity, 0), 1);
        rgb = {r: red, g: green, b: blue, toString: rgbtoString};
        rgb.hex = "#" + (16777216 | blue | (green << 8) | (red << 16)).toString(16).slice(1);
        rgb.opacity = is(opacity, "finite") ? opacity : 1;
        return rgb;
    }
    return {r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString};
}, Snap);
/*\
 * Snap.hsb
 [ method ]
 **
 * Converts HSB values to a hex representation of the color
 - h (number) hue
 - s (number) saturation
 - b (number) value or brightness
 = (string) hex representation of the color
\*/
Snap.hsb = cacher(function (h, s, b) {
    return Snap.hsb2rgb(h, s, b).hex;
});
/*\
 * Snap.hsl
 [ method ]
 **
 * Converts HSL values to a hex representation of the color
 - h (number) hue
 - s (number) saturation
 - l (number) luminosity
 = (string) hex representation of the color
\*/
Snap.hsl = cacher(function (h, s, l) {
    return Snap.hsl2rgb(h, s, l).hex;
});
/*\
 * Snap.rgb
 [ method ]
 **
 * Converts RGB values to a hex representation of the color
 - r (number) red
 - g (number) green
 - b (number) blue
 = (string) hex representation of the color
\*/
Snap.rgb = cacher(function (r, g, b, o) {
    if (is(o, "finite")) {
        var round = math.round;
        return "rgba(" + [round(r), round(g), round(b), +o.toFixed(2)] + ")";
    }
    return "#" + (16777216 | b | (g << 8) | (r << 16)).toString(16).slice(1);
});
var toHex = function (color) {
    var i = glob.doc.getElementsByTagName("head")[0] || glob.doc.getElementsByTagName("svg")[0],
        red = "rgb(255, 0, 0)";
    toHex = cacher(function (color) {
        if (color.toLowerCase() == "red") {
            return red;
        }
        i.style.color = red;
        i.style.color = color;
        var out = glob.doc.defaultView.getComputedStyle(i, E).getPropertyValue("color");
        return out == red ? null : out;
    });
    return toHex(color);
},
hsbtoString = function () {
    return "hsb(" + [this.h, this.s, this.b] + ")";
},
hsltoString = function () {
    return "hsl(" + [this.h, this.s, this.l] + ")";
},
rgbtoString = function () {
    return this.opacity == 1 || this.opacity == null ?
            this.hex :
            "rgba(" + [this.r, this.g, this.b, this.opacity] + ")";
},
prepareRGB = function (r, g, b) {
    if (g == null && is(r, "object") && "r" in r && "g" in r && "b" in r) {
        b = r.b;
        g = r.g;
        r = r.r;
    }
    if (g == null && is(r, string)) {
        var clr = Snap.getRGB(r);
        r = clr.r;
        g = clr.g;
        b = clr.b;
    }
    if (r > 1 || g > 1 || b > 1) {
        r /= 255;
        g /= 255;
        b /= 255;
    }

    return [r, g, b];
},
packageRGB = function (r, g, b, o) {
    r = math.round(r * 255);
    g = math.round(g * 255);
    b = math.round(b * 255);
    var rgb = {
        r: r,
        g: g,
        b: b,
        opacity: is(o, "finite") ? o : 1,
        hex: Snap.rgb(r, g, b),
        toString: rgbtoString
    };
    is(o, "finite") && (rgb.opacity = o);
    return rgb;
};
/*\
 * Snap.color
 [ method ]
 **
 * Parses the color string and returns an object featuring the color's component values
 - clr (string) color string in one of the supported formats (see @Snap.getRGB)
 = (object) Combined RGB/HSB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••,
 o     error (boolean) `true` if string can't be parsed,
 o     h (number) hue,
 o     s (number) saturation,
 o     v (number) value (brightness),
 o     l (number) lightness
 o }
\*/
Snap.color = function (clr) {
    var rgb;
    if (is(clr, "object") && "h" in clr && "s" in clr && "b" in clr) {
        rgb = Snap.hsb2rgb(clr);
        clr.r = rgb.r;
        clr.g = rgb.g;
        clr.b = rgb.b;
        clr.opacity = 1;
        clr.hex = rgb.hex;
    } else if (is(clr, "object") && "h" in clr && "s" in clr && "l" in clr) {
        rgb = Snap.hsl2rgb(clr);
        clr.r = rgb.r;
        clr.g = rgb.g;
        clr.b = rgb.b;
        clr.opacity = 1;
        clr.hex = rgb.hex;
    } else {
        if (is(clr, "string")) {
            clr = Snap.getRGB(clr);
        }
        if (is(clr, "object") && "r" in clr && "g" in clr && "b" in clr && !("error" in clr)) {
            rgb = Snap.rgb2hsl(clr);
            clr.h = rgb.h;
            clr.s = rgb.s;
            clr.l = rgb.l;
            rgb = Snap.rgb2hsb(clr);
            clr.v = rgb.b;
        } else {
            clr = {hex: "none"};
            clr.r = clr.g = clr.b = clr.h = clr.s = clr.v = clr.l = -1;
            clr.error = 1;
        }
    }
    clr.toString = rgbtoString;
    return clr;
};
/*\
 * Snap.hsb2rgb
 [ method ]
 **
 * Converts HSB values to an RGB object
 - h (number) hue
 - s (number) saturation
 - v (number) value or brightness
 = (object) RGB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••
 o }
\*/
Snap.hsb2rgb = function (h, s, v, o) {
    if (is(h, "object") && "h" in h && "s" in h && "b" in h) {
        v = h.b;
        s = h.s;
        o = h.o;
        h = h.h;
    }
    h *= 360;
    var R, G, B, X, C;
    h = (h % 360) / 60;
    C = v * s;
    X = C * (1 - abs(h % 2 - 1));
    R = G = B = v - C;

    h = ~~h;
    R += [C, X, 0, 0, X, C][h];
    G += [X, C, C, X, 0, 0][h];
    B += [0, 0, X, C, C, X][h];
    return packageRGB(R, G, B, o);
};
/*\
 * Snap.hsl2rgb
 [ method ]
 **
 * Converts HSL values to an RGB object
 - h (number) hue
 - s (number) saturation
 - l (number) luminosity
 = (object) RGB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••
 o }
\*/
Snap.hsl2rgb = function (h, s, l, o) {
    if (is(h, "object") && "h" in h && "s" in h && "l" in h) {
        l = h.l;
        s = h.s;
        h = h.h;
    }
    if (h > 1 || s > 1 || l > 1) {
        h /= 360;
        s /= 100;
        l /= 100;
    }
    h *= 360;
    var R, G, B, X, C;
    h = (h % 360) / 60;
    C = 2 * s * (l < .5 ? l : 1 - l);
    X = C * (1 - abs(h % 2 - 1));
    R = G = B = l - C / 2;

    h = ~~h;
    R += [C, X, 0, 0, X, C][h];
    G += [X, C, C, X, 0, 0][h];
    B += [0, 0, X, C, C, X][h];
    return packageRGB(R, G, B, o);
};
/*\
 * Snap.rgb2hsb
 [ method ]
 **
 * Converts RGB values to an HSB object
 - r (number) red
 - g (number) green
 - b (number) blue
 = (object) HSB object in the following format:
 o {
 o     h (number) hue,
 o     s (number) saturation,
 o     b (number) brightness
 o }
\*/
Snap.rgb2hsb = function (r, g, b) {
    b = prepareRGB(r, g, b);
    r = b[0];
    g = b[1];
    b = b[2];

    var H, S, V, C;
    V = mmax(r, g, b);
    C = V - mmin(r, g, b);
    H = (C == 0 ? null :
         V == r ? (g - b) / C :
         V == g ? (b - r) / C + 2 :
                  (r - g) / C + 4
        );
    H = ((H + 360) % 6) * 60 / 360;
    S = C == 0 ? 0 : C / V;
    return {h: H, s: S, b: V, toString: hsbtoString};
};
/*\
 * Snap.rgb2hsl
 [ method ]
 **
 * Converts RGB values to an HSL object
 - r (number) red
 - g (number) green
 - b (number) blue
 = (object) HSL object in the following format:
 o {
 o     h (number) hue,
 o     s (number) saturation,
 o     l (number) luminosity
 o }
\*/
Snap.rgb2hsl = function (r, g, b) {
    b = prepareRGB(r, g, b);
    r = b[0];
    g = b[1];
    b = b[2];

    var H, S, L, M, m, C;
    M = mmax(r, g, b);
    m = mmin(r, g, b);
    C = M - m;
    H = (C == 0 ? null :
         M == r ? (g - b) / C :
         M == g ? (b - r) / C + 2 :
                  (r - g) / C + 4);
    H = ((H + 360) % 6) * 60 / 360;
    L = (M + m) / 2;
    S = (C == 0 ? 0 :
         L < .5 ? C / (2 * L) :
                  C / (2 - 2 * L));
    return {h: H, s: S, l: L, toString: hsltoString};
};

// Transformations
/*\
 * Snap.parsePathString
 [ method ]
 **
 * Utility method
 **
 * Parses given path string into an array of arrays of path segments
 - pathString (string|array) path string or array of segments (in the last case it is returned straight away)
 = (array) array of segments
\*/
Snap.parsePathString = function (pathString) {
    if (!pathString) {
        return null;
    }
    var pth = Snap.path(pathString);
    if (pth.arr) {
        return Snap.path.clone(pth.arr);
    }

    var paramCounts = {a: 7, c: 6, o: 2, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, u: 3, z: 0},
        data = [];
    if (is(pathString, "array") && is(pathString[0], "array")) { // rough assumption
        data = Snap.path.clone(pathString);
    }
    if (!data.length) {
        Str(pathString).replace(pathCommand, function (a, b, c) {
            var params = [],
                name = b.toLowerCase();
            c.replace(pathValues, function (a, b) {
                b && params.push(+b);
            });
            if (name == "m" && params.length > 2) {
                data.push([b].concat(params.splice(0, 2)));
                name = "l";
                b = b == "m" ? "l" : "L";
            }
            if (name == "o" && params.length == 1) {
                data.push([b, params[0]]);
            }
            if (name == "r") {
                data.push([b].concat(params));
            } else while (params.length >= paramCounts[name]) {
                data.push([b].concat(params.splice(0, paramCounts[name])));
                if (!paramCounts[name]) {
                    break;
                }
            }
        });
    }
    data.toString = Snap.path.toString;
    pth.arr = Snap.path.clone(data);
    return data;
};
/*\
 * Snap.parseTransformString
 [ method ]
 **
 * Utility method
 **
 * Parses given transform string into an array of transformations
 - TString (string|array) transform string or array of transformations (in the last case it is returned straight away)
 = (array) array of transformations
\*/
var parseTransformString = Snap.parseTransformString = function (TString) {
    if (!TString) {
        return null;
    }
    var paramCounts = {r: 3, s: 4, t: 2, m: 6},
        data = [];
    if (is(TString, "array") && is(TString[0], "array")) { // rough assumption
        data = Snap.path.clone(TString);
    }
    if (!data.length) {
        Str(TString).replace(tCommand, function (a, b, c) {
            var params = [],
                name = b.toLowerCase();
            c.replace(pathValues, function (a, b) {
                b && params.push(+b);
            });
            data.push([b].concat(params));
        });
    }
    data.toString = Snap.path.toString;
    return data;
};
function svgTransform2string(tstr) {
    var res = [];
    tstr = tstr.replace(/(?:^|\s)(\w+)\(([^)]+)\)/g, function (all, name, params) {
        params = params.split(/\s*,\s*|\s+/);
        if (name == "rotate" && params.length == 1) {
            params.push(0, 0);
        }
        if (name == "scale") {
            if (params.length > 2) {
                params = params.slice(0, 2);
            } else if (params.length == 2) {
                params.push(0, 0);
            }
            if (params.length == 1) {
                params.push(params[0], 0, 0);
            }
        }
        if (name == "skewX") {
            res.push(["m", 1, 0, math.tan(rad(params[0])), 1, 0, 0]);
        } else if (name == "skewY") {
            res.push(["m", 1, math.tan(rad(params[0])), 0, 1, 0, 0]);
        } else {
            res.push([name.charAt(0)].concat(params));
        }
        return all;
    });
    return res;
}
Snap._.svgTransform2string = svgTransform2string;
Snap._.rgTransform = /^[a-z][\s]*-?\.?\d/i;
function transform2matrix(tstr, bbox) {
    var tdata = parseTransformString(tstr),
        m = new Snap.Matrix;
    if (tdata) {
        for (var i = 0, ii = tdata.length; i < ii; i++) {
            var t = tdata[i],
                tlen = t.length,
                command = Str(t[0]).toLowerCase(),
                absolute = t[0] != command,
                inver = absolute ? m.invert() : 0,
                x1,
                y1,
                x2,
                y2,
                bb;
            if (command == "t" && tlen == 2){
                m.translate(t[1], 0);
            } else if (command == "t" && tlen == 3) {
                if (absolute) {
                    x1 = inver.x(0, 0);
                    y1 = inver.y(0, 0);
                    x2 = inver.x(t[1], t[2]);
                    y2 = inver.y(t[1], t[2]);
                    m.translate(x2 - x1, y2 - y1);
                } else {
                    m.translate(t[1], t[2]);
                }
            } else if (command == "r") {
                if (tlen == 2) {
                    bb = bb || bbox;
                    m.rotate(t[1], bb.x + bb.width / 2, bb.y + bb.height / 2);
                } else if (tlen == 4) {
                    if (absolute) {
                        x2 = inver.x(t[2], t[3]);
                        y2 = inver.y(t[2], t[3]);
                        m.rotate(t[1], x2, y2);
                    } else {
                        m.rotate(t[1], t[2], t[3]);
                    }
                }
            } else if (command == "s") {
                if (tlen == 2 || tlen == 3) {
                    bb = bb || bbox;
                    m.scale(t[1], t[tlen - 1], bb.x + bb.width / 2, bb.y + bb.height / 2);
                } else if (tlen == 4) {
                    if (absolute) {
                        x2 = inver.x(t[2], t[3]);
                        y2 = inver.y(t[2], t[3]);
                        m.scale(t[1], t[1], x2, y2);
                    } else {
                        m.scale(t[1], t[1], t[2], t[3]);
                    }
                } else if (tlen == 5) {
                    if (absolute) {
                        x2 = inver.x(t[3], t[4]);
                        y2 = inver.y(t[3], t[4]);
                        m.scale(t[1], t[2], x2, y2);
                    } else {
                        m.scale(t[1], t[2], t[3], t[4]);
                    }
                }
            } else if (command == "m" && tlen == 7) {
                m.add(t[1], t[2], t[3], t[4], t[5], t[6]);
            }
        }
    }
    return m;
}
Snap._.transform2matrix = transform2matrix;
Snap._unit2px = unit2px;
var contains = glob.doc.contains || glob.doc.compareDocumentPosition ?
    function (a, b) {
        var adown = a.nodeType == 9 ? a.documentElement : a,
            bup = b && b.parentNode;
            return a == bup || !!(bup && bup.nodeType == 1 && (
                adown.contains ?
                    adown.contains(bup) :
                    a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16
            ));
    } :
    function (a, b) {
        if (b) {
            while (b) {
                b = b.parentNode;
                if (b == a) {
                    return true;
                }
            }
        }
        return false;
    };
function getSomeDefs(el) {
    var p = (el.node.ownerSVGElement && wrap(el.node.ownerSVGElement)) ||
            (el.node.parentNode && wrap(el.node.parentNode)) ||
            Snap.select("svg") ||
            Snap(0, 0),
        pdefs = p.select("defs"),
        defs  = pdefs == null ? false : pdefs.node;
    if (!defs) {
        defs = make("defs", p.node).node;
    }
    return defs;
}
function getSomeSVG(el) {
    return el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) || Snap.select("svg");
}
Snap._.getSomeDefs = getSomeDefs;
Snap._.getSomeSVG = getSomeSVG;
function unit2px(el, name, value) {
    var svg = getSomeSVG(el).node,
        out = {},
        mgr = svg.querySelector(".svg---mgr");
    if (!mgr) {
        mgr = $("rect");
        $(mgr, {x: -9e9, y: -9e9, width: 10, height: 10, "class": "svg---mgr", fill: "none"});
        svg.appendChild(mgr);
    }
    function getW(val) {
        if (val == null) {
            return E;
        }
        if (val == +val) {
            return val;
        }
        $(mgr, {width: val});
        try {
            return mgr.getBBox().width;
        } catch (e) {
            return 0;
        }
    }
    function getH(val) {
        if (val == null) {
            return E;
        }
        if (val == +val) {
            return val;
        }
        $(mgr, {height: val});
        try {
            return mgr.getBBox().height;
        } catch (e) {
            return 0;
        }
    }
    function set(nam, f) {
        if (name == null) {
            out[nam] = f(el.attr(nam) || 0);
        } else if (nam == name) {
            out = f(value == null ? el.attr(nam) || 0 : value);
        }
    }
    switch (el.type) {
        case "rect":
            set("rx", getW);
            set("ry", getH);
        case "image":
            set("width", getW);
            set("height", getH);
        case "text":
            set("x", getW);
            set("y", getH);
        break;
        case "circle":
            set("cx", getW);
            set("cy", getH);
            set("r", getW);
        break;
        case "ellipse":
            set("cx", getW);
            set("cy", getH);
            set("rx", getW);
            set("ry", getH);
        break;
        case "line":
            set("x1", getW);
            set("x2", getW);
            set("y1", getH);
            set("y2", getH);
        break;
        case "marker":
            set("refX", getW);
            set("markerWidth", getW);
            set("refY", getH);
            set("markerHeight", getH);
        break;
        case "radialGradient":
            set("fx", getW);
            set("fy", getH);
        break;
        case "tspan":
            set("dx", getW);
            set("dy", getH);
        break;
        default:
            set(name, getW);
    }
    svg.removeChild(mgr);
    return out;
}
/*\
 * Snap.select
 [ method ]
 **
 * Wraps a DOM element specified by CSS selector as @Element
 - query (string) CSS selector of the element
 = (Element) the current element
\*/
Snap.select = function (query) {
    query = Str(query).replace(/([^\\]):/g, "$1\\:");
    return wrap(glob.doc.querySelector(query));
};
/*\
 * Snap.selectAll
 [ method ]
 **
 * Wraps DOM elements specified by CSS selector as set or array of @Element
 - query (string) CSS selector of the element
 = (Element) the current element
\*/
Snap.selectAll = function (query) {
    var nodelist = glob.doc.querySelectorAll(query),
        set = (Snap.set || Array)();
    for (var i = 0; i < nodelist.length; i++) {
        set.push(wrap(nodelist[i]));
    }
    return set;
};

function add2group(list) {
    if (!is(list, "array")) {
        list = Array.prototype.slice.call(arguments, 0);
    }
    var i = 0,
        j = 0,
        node = this.node;
    while (this[i]) delete this[i++];
    for (i = 0; i < list.length; i++) {
        if (list[i].type == "set") {
            list[i].forEach(function (el) {
                node.appendChild(el.node);
            });
        } else {
            node.appendChild(list[i].node);
        }
    }
    var children = node.childNodes;
    for (i = 0; i < children.length; i++) {
        this[j++] = wrap(children[i]);
    }
    return this;
}
// Hub garbage collector every 10s
setInterval(function () {
    for (var key in hub) if (hub[has](key)) {
        var el = hub[key],
            node = el.node;
        if (el.type != "svg" && !node.ownerSVGElement || el.type == "svg" && (!node.parentNode || "ownerSVGElement" in node.parentNode && !node.ownerSVGElement)) {
            delete hub[key];
        }
    }
}, 1e4);
function Element(el) {
    if (el.snap in hub) {
        return hub[el.snap];
    }
    var svg;
    try {
        svg = el.ownerSVGElement;
    } catch(e) {}
    /*\
     * Element.node
     [ property (object) ]
     **
     * Gives you a reference to the DOM object, so you can assign event handlers or just mess around.
     > Usage
     | // draw a circle at coordinate 10,10 with radius of 10
     | var c = paper.circle(10, 10, 10);
     | c.node.onclick = function () {
     |     c.attr("fill", "red");
     | };
    \*/
    this.node = el;
    if (svg) {
        this.paper = new Paper(svg);
    }
    /*\
     * Element.type
     [ property (string) ]
     **
     * SVG tag name of the given element.
    \*/
    this.type = el.tagName || el.nodeName;
    var id = this.id = ID(this);
    this.anims = {};
    this._ = {
        transform: []
    };
    el.snap = id;
    hub[id] = this;
    if (this.type == "g") {
        this.add = add2group;
    }
    if (this.type in {g: 1, mask: 1, pattern: 1, symbol: 1}) {
        for (var method in Paper.prototype) if (Paper.prototype[has](method)) {
            this[method] = Paper.prototype[method];
        }
    }
}
   /*\
     * Element.attr
     [ method ]
     **
     * Gets or sets given attributes of the element.
     **
     - params (object) contains key-value pairs of attributes you want to set
     * or
     - param (string) name of the attribute
     = (Element) the current element
     * or
     = (string) value of attribute
     > Usage
     | el.attr({
     |     fill: "#fc0",
     |     stroke: "#000",
     |     strokeWidth: 2, // CamelCase...
     |     "fill-opacity": 0.5, // or dash-separated names
     |     width: "*=2" // prefixed values
     | });
     | console.log(el.attr("fill")); // #fc0
     * Prefixed values in format `"+=10"` supported. All four operations
     * (`+`, `-`, `*` and `/`) could be used. Optionally you can use units for `+`
     * and `-`: `"+=2em"`.
    \*/
    Element.prototype.attr = function (params, value) {
        var el = this,
            node = el.node;
        if (!params) {
            if (node.nodeType != 1) {
                return {
                    text: node.nodeValue
                };
            }
            var attr = node.attributes,
                out = {};
            for (var i = 0, ii = attr.length; i < ii; i++) {
                out[attr[i].nodeName] = attr[i].nodeValue;
            }
            return out;
        }
        if (is(params, "string")) {
            if (arguments.length > 1) {
                var json = {};
                json[params] = value;
                params = json;
            } else {
                return eve("snap.util.getattr." + params, el).firstDefined();
            }
        }
        for (var att in params) {
            if (params[has](att)) {
                eve("snap.util.attr." + att, el, params[att]);
            }
        }
        return el;
    };
/*\
 * Snap.parse
 [ method ]
 **
 * Parses SVG fragment and converts it into a @Fragment
 **
 - svg (string) SVG string
 = (Fragment) the @Fragment
\*/
Snap.parse = function (svg) {
    var f = glob.doc.createDocumentFragment(),
        full = true,
        div = glob.doc.createElement("div");
    svg = Str(svg);
    if (!svg.match(/^\s*<\s*svg(?:\s|>)/)) {
        svg = "<svg>" + svg + "</svg>";
        full = false;
    }
    div.innerHTML = svg;
    svg = div.getElementsByTagName("svg")[0];
    if (svg) {
        if (full) {
            f = svg;
        } else {
            while (svg.firstChild) {
                f.appendChild(svg.firstChild);
            }
        }
    }
    return new Fragment(f);
};
function Fragment(frag) {
    this.node = frag;
}
/*\
 * Snap.fragment
 [ method ]
 **
 * Creates a DOM fragment from a given list of elements or strings
 **
 - varargs (…) SVG string
 = (Fragment) the @Fragment
\*/
Snap.fragment = function () {
    var args = Array.prototype.slice.call(arguments, 0),
        f = glob.doc.createDocumentFragment();
    for (var i = 0, ii = args.length; i < ii; i++) {
        var item = args[i];
        if (item.node && item.node.nodeType) {
            f.appendChild(item.node);
        }
        if (item.nodeType) {
            f.appendChild(item);
        }
        if (typeof item == "string") {
            f.appendChild(Snap.parse(item).node);
        }
    }
    return new Fragment(f);
};

function make(name, parent) {
    var res = $(name);
    parent.appendChild(res);
    var el = wrap(res);
    return el;
}
function Paper(w, h) {
    var res,
        desc,
        defs,
        proto = Paper.prototype;
    if (w && w.tagName == "svg") {
        if (w.snap in hub) {
            return hub[w.snap];
        }
        var doc = w.ownerDocument;
        res = new Element(w);
        desc = w.getElementsByTagName("desc")[0];
        defs = w.getElementsByTagName("defs")[0];
        if (!desc) {
            desc = $("desc");
            desc.appendChild(doc.createTextNode("Created with Snap"));
            res.node.appendChild(desc);
        }
        if (!defs) {
            defs = $("defs");
            res.node.appendChild(defs);
        }
        res.defs = defs;
        for (var key in proto) if (proto[has](key)) {
            res[key] = proto[key];
        }
        res.paper = res.root = res;
    } else {
        res = make("svg", glob.doc.body);
        $(res.node, {
            height: h,
            version: 1.1,
            width: w,
            xmlns: xmlns
        });
    }
    return res;
}
function wrap(dom) {
    if (!dom) {
        return dom;
    }
    if (dom instanceof Element || dom instanceof Fragment) {
        return dom;
    }
    if (dom.tagName && dom.tagName.toLowerCase() == "svg") {
        return new Paper(dom);
    }
    if (dom.tagName && dom.tagName.toLowerCase() == "object" && dom.type == "image/svg+xml") {
        return new Paper(dom.contentDocument.getElementsByTagName("svg")[0]);
    }
    return new Element(dom);
}

Snap._.make = make;
Snap._.wrap = wrap;
/*\
 * Paper.el
 [ method ]
 **
 * Creates an element on paper with a given name and no attributes
 **
 - name (string) tag name
 - attr (object) attributes
 = (Element) the current element
 > Usage
 | var c = paper.circle(10, 10, 10); // is the same as...
 | var c = paper.el("circle").attr({
 |     cx: 10,
 |     cy: 10,
 |     r: 10
 | });
 | // and the same as
 | var c = paper.el("circle", {
 |     cx: 10,
 |     cy: 10,
 |     r: 10
 | });
\*/
Paper.prototype.el = function (name, attr) {
    var el = make(name, this.node);
    attr && el.attr(attr);
    return el;
};
/*\
 * Element.children
 [ method ]
 **
 * Returns array of all the children of the element.
 = (array) array of Elements
\*/
Element.prototype.children = function () {
    var out = [],
        ch = this.node.childNodes;
    for (var i = 0, ii = ch.length; i < ii; i++) {
        out[i] = Snap(ch[i]);
    }
    return out;
};
function jsonFiller(root, o) {
    for (var i = 0, ii = root.length; i < ii; i++) {
        var item = {
                type: root[i].type,
                attr: root[i].attr()
            },
            children = root[i].children();
        o.push(item);
        if (children.length) {
            jsonFiller(children, item.childNodes = []);
        }
    }
}
/*\
 * Element.toJSON
 [ method ]
 **
 * Returns object representation of the given element and all its children.
 = (object) in format
 o {
 o     type (string) this.type,
 o     attr (object) attributes map,
 o     childNodes (array) optional array of children in the same format
 o }
\*/
Element.prototype.toJSON = function () {
    var out = [];
    jsonFiller([this], out);
    return out[0];
};
// default
eve.on("snap.util.getattr", function () {
    var att = eve.nt();
    att = att.substring(att.lastIndexOf(".") + 1);
    var css = att.replace(/[A-Z]/g, function (letter) {
        return "-" + letter.toLowerCase();
    });
    if (cssAttr[has](css)) {
        return this.node.ownerDocument.defaultView.getComputedStyle(this.node, null).getPropertyValue(css);
    } else {
        return $(this.node, att);
    }
});
var cssAttr = {
    "alignment-baseline": 0,
    "baseline-shift": 0,
    "clip": 0,
    "clip-path": 0,
    "clip-rule": 0,
    "color": 0,
    "color-interpolation": 0,
    "color-interpolation-filters": 0,
    "color-profile": 0,
    "color-rendering": 0,
    "cursor": 0,
    "direction": 0,
    "display": 0,
    "dominant-baseline": 0,
    "enable-background": 0,
    "fill": 0,
    "fill-opacity": 0,
    "fill-rule": 0,
    "filter": 0,
    "flood-color": 0,
    "flood-opacity": 0,
    "font": 0,
    "font-family": 0,
    "font-size": 0,
    "font-size-adjust": 0,
    "font-stretch": 0,
    "font-style": 0,
    "font-variant": 0,
    "font-weight": 0,
    "glyph-orientation-horizontal": 0,
    "glyph-orientation-vertical": 0,
    "image-rendering": 0,
    "kerning": 0,
    "letter-spacing": 0,
    "lighting-color": 0,
    "marker": 0,
    "marker-end": 0,
    "marker-mid": 0,
    "marker-start": 0,
    "mask": 0,
    "opacity": 0,
    "overflow": 0,
    "pointer-events": 0,
    "shape-rendering": 0,
    "stop-color": 0,
    "stop-opacity": 0,
    "stroke": 0,
    "stroke-dasharray": 0,
    "stroke-dashoffset": 0,
    "stroke-linecap": 0,
    "stroke-linejoin": 0,
    "stroke-miterlimit": 0,
    "stroke-opacity": 0,
    "stroke-width": 0,
    "text-anchor": 0,
    "text-decoration": 0,
    "text-rendering": 0,
    "unicode-bidi": 0,
    "visibility": 0,
    "word-spacing": 0,
    "writing-mode": 0
};

eve.on("snap.util.attr", function (value) {
    var att = eve.nt(),
        attr = {};
    att = att.substring(att.lastIndexOf(".") + 1);
    attr[att] = value;
    var style = att.replace(/-(\w)/gi, function (all, letter) {
            return letter.toUpperCase();
        }),
        css = att.replace(/[A-Z]/g, function (letter) {
            return "-" + letter.toLowerCase();
        });
    if (cssAttr[has](css)) {
        this.node.style[style] = value == null ? E : value;
    } else {
        $(this.node, attr);
    }
});
(function (proto) {}(Paper.prototype));

// simple ajax
/*\
 * Snap.ajax
 [ method ]
 **
 * Simple implementation of Ajax
 **
 - url (string) URL
 - postData (object|string) data for post request
 - callback (function) callback
 - scope (object) #optional scope of callback
 * or
 - url (string) URL
 - callback (function) callback
 - scope (object) #optional scope of callback
 = (XMLHttpRequest) the XMLHttpRequest object, just in case
\*/
Snap.ajax = function (url, postData, callback, scope){
    var req = new XMLHttpRequest,
        id = ID();
    if (req) {
        if (is(postData, "function")) {
            scope = callback;
            callback = postData;
            postData = null;
        } else if (is(postData, "object")) {
            var pd = [];
            for (var key in postData) if (postData.hasOwnProperty(key)) {
                pd.push(encodeURIComponent(key) + "=" + encodeURIComponent(postData[key]));
            }
            postData = pd.join("&");
        }
        req.open((postData ? "POST" : "GET"), url, true);
        if (postData) {
            req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        }
        if (callback) {
            eve.once("snap.ajax." + id + ".0", callback);
            eve.once("snap.ajax." + id + ".200", callback);
            eve.once("snap.ajax." + id + ".304", callback);
        }
        req.onreadystatechange = function() {
            if (req.readyState != 4) return;
            eve("snap.ajax." + id + "." + req.status, scope, req);
        };
        if (req.readyState == 4) {
            return req;
        }
        req.send(postData);
        return req;
    }
};
/*\
 * Snap.load
 [ method ]
 **
 * Loads external SVG file as a @Fragment (see @Snap.ajax for more advanced AJAX)
 **
 - url (string) URL
 - callback (function) callback
 - scope (object) #optional scope of callback
\*/
Snap.load = function (url, callback, scope) {
    Snap.ajax(url, function (req) {
        var f = Snap.parse(req.responseText);
        scope ? callback.call(scope, f) : callback(f);
    });
};
var getOffset = function (elem) {
    var box = elem.getBoundingClientRect(),
        doc = elem.ownerDocument,
        body = doc.body,
        docElem = doc.documentElement,
        clientTop = docElem.clientTop || body.clientTop || 0, clientLeft = docElem.clientLeft || body.clientLeft || 0,
        top  = box.top  + (g.win.pageYOffset || docElem.scrollTop || body.scrollTop ) - clientTop,
        left = box.left + (g.win.pageXOffset || docElem.scrollLeft || body.scrollLeft) - clientLeft;
    return {
        y: top,
        x: left
    };
};
/*\
 * Snap.getElementByPoint
 [ method ]
 **
 * Returns you topmost element under given point.
 **
 = (object) Snap element object
 - x (number) x coordinate from the top left corner of the window
 - y (number) y coordinate from the top left corner of the window
 > Usage
 | Snap.getElementByPoint(mouseX, mouseY).attr({stroke: "#f00"});
\*/
Snap.getElementByPoint = function (x, y) {
    var paper = this,
        svg = paper.canvas,
        target = glob.doc.elementFromPoint(x, y);
    if (glob.win.opera && target.tagName == "svg") {
        var so = getOffset(target),
            sr = target.createSVGRect();
        sr.x = x - so.x;
        sr.y = y - so.y;
        sr.width = sr.height = 1;
        var hits = target.getIntersectionList(sr, null);
        if (hits.length) {
            target = hits[hits.length - 1];
        }
    }
    if (!target) {
        return null;
    }
    return wrap(target);
};
/*\
 * Snap.plugin
 [ method ]
 **
 * Let you write plugins. You pass in a function with five arguments, like this:
 | Snap.plugin(function (Snap, Element, Paper, global, Fragment) {
 |     Snap.newmethod = function () {};
 |     Element.prototype.newmethod = function () {};
 |     Paper.prototype.newmethod = function () {};
 | });
 * Inside the function you have access to all main objects (and their
 * prototypes). This allow you to extend anything you want.
 **
 - f (function) your plugin body
\*/
Snap.plugin = function (f) {
    f(Snap, Element, Paper, glob, Fragment);
};
glob.win.Snap = Snap;
return Snap;
}(window || this));

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var elproto = Element.prototype,
        is = Snap.is,
        Str = String,
        unit2px = Snap._unit2px,
        $ = Snap._.$,
        make = Snap._.make,
        getSomeDefs = Snap._.getSomeDefs,
        has = "hasOwnProperty",
        wrap = Snap._.wrap;
    /*\
     * Element.getBBox
     [ method ]
     **
     * Returns the bounding box descriptor for the given element
     **
     = (object) bounding box descriptor:
     o {
     o     cx: (number) x of the center,
     o     cy: (number) x of the center,
     o     h: (number) height,
     o     height: (number) height,
     o     path: (string) path command for the box,
     o     r0: (number) radius of a circle that fully encloses the box,
     o     r1: (number) radius of the smallest circle that can be enclosed,
     o     r2: (number) radius of the largest circle that can be enclosed,
     o     vb: (string) box as a viewbox command,
     o     w: (number) width,
     o     width: (number) width,
     o     x2: (number) x of the right side,
     o     x: (number) x of the left side,
     o     y2: (number) y of the bottom edge,
     o     y: (number) y of the top edge
     o }
    \*/
    elproto.getBBox = function (isWithoutTransform) {
        if (!Snap.Matrix || !Snap.path) {
            return this.node.getBBox();
        }
        var el = this,
            m = new Snap.Matrix;
        if (el.removed) {
            return Snap._.box();
        }
        while (el.type == "use") {
            if (!isWithoutTransform) {
                m = m.add(el.transform().localMatrix.translate(el.attr("x") || 0, el.attr("y") || 0));
            }
            if (el.original) {
                el = el.original;
            } else {
                var href = el.attr("xlink:href");
                el = el.original = el.node.ownerDocument.getElementById(href.substring(href.indexOf("#") + 1));
            }
        }
        var _ = el._,
            pathfinder = Snap.path.get[el.type] || Snap.path.get.deflt;
        try {
            if (isWithoutTransform) {
                _.bboxwt = pathfinder ? Snap.path.getBBox(el.realPath = pathfinder(el)) : Snap._.box(el.node.getBBox());
                return Snap._.box(_.bboxwt);
            } else {
                el.realPath = pathfinder(el);
                el.matrix = el.transform().localMatrix;
                _.bbox = Snap.path.getBBox(Snap.path.map(el.realPath, m.add(el.matrix)));
                return Snap._.box(_.bbox);
            }
        } catch (e) {
            // Firefox doesn’t give you bbox of hidden element
            return Snap._.box();
        }
    };
    var propString = function () {
        return this.string;
    };
    function extractTransform(el, tstr) {
        if (tstr == null) {
            var doReturn = true;
            if (el.type == "linearGradient" || el.type == "radialGradient") {
                tstr = el.node.getAttribute("gradientTransform");
            } else if (el.type == "pattern") {
                tstr = el.node.getAttribute("patternTransform");
            } else {
                tstr = el.node.getAttribute("transform");
            }
            if (!tstr) {
                return new Snap.Matrix;
            }
            tstr = Snap._.svgTransform2string(tstr);
        } else {
            if (!Snap._.rgTransform.test(tstr)) {
                tstr = Snap._.svgTransform2string(tstr);
            } else {
                tstr = Str(tstr).replace(/\.{3}|\u2026/g, el._.transform || E);
            }
            if (is(tstr, "array")) {
                tstr = Snap.path ? Snap.path.toString.call(tstr) : Str(tstr);
            }
            el._.transform = tstr;
        }
        var m = Snap._.transform2matrix(tstr, el.getBBox(1));
        if (doReturn) {
            return m;
        } else {
            el.matrix = m;
        }
    }
    /*\
     * Element.transform
     [ method ]
     **
     * Gets or sets transformation of the element
     **
     - tstr (string) transform string in Snap or SVG format
     = (Element) the current element
     * or
     = (object) transformation descriptor:
     o {
     o     string (string) transform string,
     o     globalMatrix (Matrix) matrix of all transformations applied to element or its parents,
     o     localMatrix (Matrix) matrix of transformations applied only to the element,
     o     diffMatrix (Matrix) matrix of difference between global and local transformations,
     o     global (string) global transformation as string,
     o     local (string) local transformation as string,
     o     toString (function) returns `string` property
     o }
    \*/
    elproto.transform = function (tstr) {
        var _ = this._;
        if (tstr == null) {
            var papa = this,
                global = new Snap.Matrix(this.node.getCTM()),
                local = extractTransform(this),
                ms = [local],
                m = new Snap.Matrix,
                i,
                localString = local.toTransformString(),
                string = Str(local) == Str(this.matrix) ?
                            Str(_.transform) : localString;
            while (papa.type != "svg" && (papa = papa.parent())) {
                ms.push(extractTransform(papa));
            }
            i = ms.length;
            while (i--) {
                m.add(ms[i]);
            }
            return {
                string: string,
                globalMatrix: global,
                totalMatrix: m,
                localMatrix: local,
                diffMatrix: global.clone().add(local.invert()),
                global: global.toTransformString(),
                total: m.toTransformString(),
                local: localString,
                toString: propString
            };
        }
        if (tstr instanceof Snap.Matrix) {
            this.matrix = tstr;
            this._.transform = tstr.toTransformString();
        } else {
            extractTransform(this, tstr);
        }

        if (this.node) {
            if (this.type == "linearGradient" || this.type == "radialGradient") {
                $(this.node, {gradientTransform: this.matrix});
            } else if (this.type == "pattern") {
                $(this.node, {patternTransform: this.matrix});
            } else {
                $(this.node, {transform: this.matrix});
            }
        }

        return this;
    };
    /*\
     * Element.parent
     [ method ]
     **
     * Returns the element's parent
     **
     = (Element) the parent element
    \*/
    elproto.parent = function () {
        return wrap(this.node.parentNode);
    };
    /*\
     * Element.append
     [ method ]
     **
     * Appends the given element to current one
     **
     - el (Element|Set) element to append
     = (Element) the parent element
    \*/
    /*\
     * Element.add
     [ method ]
     **
     * See @Element.append
    \*/
    elproto.append = elproto.add = function (el) {
        if (el) {
            if (el.type == "set") {
                var it = this;
                el.forEach(function (el) {
                    it.add(el);
                });
                return this;
            }
            el = wrap(el);
            this.node.appendChild(el.node);
            el.paper = this.paper;
        }
        return this;
    };
    /*\
     * Element.appendTo
     [ method ]
     **
     * Appends the current element to the given one
     **
     - el (Element) parent element to append to
     = (Element) the child element
    \*/
    elproto.appendTo = function (el) {
        if (el) {
            el = wrap(el);
            el.append(this);
        }
        return this;
    };
    /*\
     * Element.prepend
     [ method ]
     **
     * Prepends the given element to the current one
     **
     - el (Element) element to prepend
     = (Element) the parent element
    \*/
    elproto.prepend = function (el) {
        if (el) {
            if (el.type == "set") {
                var it = this,
                    first;
                el.forEach(function (el) {
                    if (first) {
                        first.after(el);
                    } else {
                        it.prepend(el);
                    }
                    first = el;
                });
                return this;
            }
            el = wrap(el);
            var parent = el.parent();
            this.node.insertBefore(el.node, this.node.firstChild);
            this.add && this.add();
            el.paper = this.paper;
            this.parent() && this.parent().add();
            parent && parent.add();
        }
        return this;
    };
    /*\
     * Element.prependTo
     [ method ]
     **
     * Prepends the current element to the given one
     **
     - el (Element) parent element to prepend to
     = (Element) the child element
    \*/
    elproto.prependTo = function (el) {
        el = wrap(el);
        el.prepend(this);
        return this;
    };
    /*\
     * Element.before
     [ method ]
     **
     * Inserts given element before the current one
     **
     - el (Element) element to insert
     = (Element) the parent element
    \*/
    elproto.before = function (el) {
        if (el.type == "set") {
            var it = this;
            el.forEach(function (el) {
                var parent = el.parent();
                it.node.parentNode.insertBefore(el.node, it.node);
                parent && parent.add();
            });
            this.parent().add();
            return this;
        }
        el = wrap(el);
        var parent = el.parent();
        this.node.parentNode.insertBefore(el.node, this.node);
        this.parent() && this.parent().add();
        parent && parent.add();
        el.paper = this.paper;
        return this;
    };
    /*\
     * Element.after
     [ method ]
     **
     * Inserts given element after the current one
     **
     - el (Element) element to insert
     = (Element) the parent element
    \*/
    elproto.after = function (el) {
        el = wrap(el);
        var parent = el.parent();
        if (this.node.nextSibling) {
            this.node.parentNode.insertBefore(el.node, this.node.nextSibling);
        } else {
            this.node.parentNode.appendChild(el.node);
        }
        this.parent() && this.parent().add();
        parent && parent.add();
        el.paper = this.paper;
        return this;
    };
    /*\
     * Element.insertBefore
     [ method ]
     **
     * Inserts the element after the given one
     **
     - el (Element) element next to whom insert to
     = (Element) the parent element
    \*/
    elproto.insertBefore = function (el) {
        el = wrap(el);
        var parent = this.parent();
        el.node.parentNode.insertBefore(this.node, el.node);
        this.paper = el.paper;
        parent && parent.add();
        el.parent() && el.parent().add();
        return this;
    };
    /*\
     * Element.insertAfter
     [ method ]
     **
     * Inserts the element after the given one
     **
     - el (Element) element next to whom insert to
     = (Element) the parent element
    \*/
    elproto.insertAfter = function (el) {
        el = wrap(el);
        var parent = this.parent();
        el.node.parentNode.insertBefore(this.node, el.node.nextSibling);
        this.paper = el.paper;
        parent && parent.add();
        el.parent() && el.parent().add();
        return this;
    };
    /*\
     * Element.remove
     [ method ]
     **
     * Removes element from the DOM
     = (Element) the detached element
    \*/
    elproto.remove = function () {
        var parent = this.parent();
        this.node.parentNode && this.node.parentNode.removeChild(this.node);
        delete this.paper;
        this.removed = true;
        parent && parent.add();
        return this;
    };
    /*\
     * Element.select
     [ method ]
     **
     * Gathers the nested @Element matching the given set of CSS selectors
     **
     - query (string) CSS selector
     = (Element) result of query selection
    \*/
    elproto.select = function (query) {
        query = Str(query).replace(/([^\\]):/g, "$1\\:");
        return wrap(this.node.querySelector(query));
    };
    /*\
     * Element.selectAll
     [ method ]
     **
     * Gathers nested @Element objects matching the given set of CSS selectors
     **
     - query (string) CSS selector
     = (Set|array) result of query selection
    \*/
    elproto.selectAll = function (query) {
        var nodelist = this.node.querySelectorAll(query),
            set = (Snap.set || Array)();
        for (var i = 0; i < nodelist.length; i++) {
            set.push(wrap(nodelist[i]));
        }
        return set;
    };
    /*\
     * Element.asPX
     [ method ]
     **
     * Returns given attribute of the element as a `px` value (not %, em, etc.)
     **
     - attr (string) attribute name
     - value (string) #optional attribute value
     = (Element) result of query selection
    \*/
    elproto.asPX = function (attr, value) {
        if (value == null) {
            value = this.attr(attr);
        }
        return +unit2px(this, attr, value);
    };
    // SIERRA Element.use(): I suggest adding a note about how to access the original element the returned <use> instantiates. It's a part of SVG with which ordinary web developers may be least familiar.
    /*\
     * Element.use
     [ method ]
     **
     * Creates a `<use>` element linked to the current element
     **
     = (Element) the `<use>` element
    \*/
    elproto.use = function () {
        var use,
            id = this.node.id;
        if (!id) {
            id = this.id;
            $(this.node, {
                id: id
            });
        }
        if (this.type == "linearGradient" || this.type == "radialGradient" ||
            this.type == "pattern") {
            use = make(this.type, this.node.parentNode);
        } else {
            use = make("use", this.node.parentNode);
        }
        $(use.node, {
            "xlink:href": "#" + id
        });
        use.original = this;
        return use;
    };
    function fixids(el) {
        var els = el.selectAll("*"),
            it,
            url = /^\s*url\(("|'|)(.*)\1\)\s*$/,
            ids = [],
            uses = {};
        function urltest(it, name) {
            var val = $(it.node, name);
            val = val && val.match(url);
            val = val && val[2];
            if (val && val.charAt() == "#") {
                val = val.substring(1);
            } else {
                return;
            }
            if (val) {
                uses[val] = (uses[val] || []).concat(function (id) {
                    var attr = {};
                    attr[name] = URL(id);
                    $(it.node, attr);
                });
            }
        }
        function linktest(it) {
            var val = $(it.node, "xlink:href");
            if (val && val.charAt() == "#") {
                val = val.substring(1);
            } else {
                return;
            }
            if (val) {
                uses[val] = (uses[val] || []).concat(function (id) {
                    it.attr("xlink:href", "#" + id);
                });
            }
        }
        for (var i = 0, ii = els.length; i < ii; i++) {
            it = els[i];
            urltest(it, "fill");
            urltest(it, "stroke");
            urltest(it, "filter");
            urltest(it, "mask");
            urltest(it, "clip-path");
            linktest(it);
            var oldid = $(it.node, "id");
            if (oldid) {
                $(it.node, {id: it.id});
                ids.push({
                    old: oldid,
                    id: it.id
                });
            }
        }
        for (i = 0, ii = ids.length; i < ii; i++) {
            var fs = uses[ids[i].old];
            if (fs) {
                for (var j = 0, jj = fs.length; j < jj; j++) {
                    fs[j](ids[i].id);
                }
            }
        }
    }
    /*\
     * Element.clone
     [ method ]
     **
     * Creates a clone of the element and inserts it after the element
     **
     = (Element) the clone
    \*/
    elproto.clone = function () {
        var clone = wrap(this.node.cloneNode(true));
        if ($(clone.node, "id")) {
            $(clone.node, {id: clone.id});
        }
        fixids(clone);
        clone.insertAfter(this);
        return clone;
    };
    /*\
     * Element.toDefs
     [ method ]
     **
     * Moves element to the shared `<defs>` area
     **
     = (Element) the element
    \*/
    elproto.toDefs = function () {
        var defs = getSomeDefs(this);
        defs.appendChild(this.node);
        return this;
    };
    /*\
     * Element.toPattern
     [ method ]
     **
     * Creates a `<pattern>` element from the current element
     **
     * To create a pattern you have to specify the pattern rect:
     - x (string|number)
     - y (string|number)
     - width (string|number)
     - height (string|number)
     = (Element) the `<pattern>` element
     * You can use pattern later on as an argument for `fill` attribute:
     | var p = paper.path("M10-5-10,15M15,0,0,15M0-5-20,15").attr({
     |         fill: "none",
     |         stroke: "#bada55",
     |         strokeWidth: 5
     |     }).pattern(0, 0, 10, 10),
     |     c = paper.circle(200, 200, 100);
     | c.attr({
     |     fill: p
     | });
    \*/
    elproto.pattern = elproto.toPattern = function (x, y, width, height) {
        var p = make("pattern", getSomeDefs(this));
        if (x == null) {
            x = this.getBBox();
        }
        if (is(x, "object") && "x" in x) {
            y = x.y;
            width = x.width;
            height = x.height;
            x = x.x;
        }
        $(p.node, {
            x: x,
            y: y,
            width: width,
            height: height,
            patternUnits: "userSpaceOnUse",
            id: p.id,
            viewBox: [x, y, width, height].join(" ")
        });
        p.node.appendChild(this.node);
        return p;
    };
// SIERRA Element.marker(): clarify what a reference point is. E.g., helps you offset the object from its edge such as when centering it over a path.
// SIERRA Element.marker(): I suggest the method should accept default reference point values.  Perhaps centered with (refX = width/2) and (refY = height/2)? Also, couldn't it assume the element's current _width_ and _height_? And please specify what _x_ and _y_ mean: offsets? If so, from where?  Couldn't they also be assigned default values?
    /*\
     * Element.marker
     [ method ]
     **
     * Creates a `<marker>` element from the current element
     **
     * To create a marker you have to specify the bounding rect and reference point:
     - x (number)
     - y (number)
     - width (number)
     - height (number)
     - refX (number)
     - refY (number)
     = (Element) the `<marker>` element
     * You can specify the marker later as an argument for `marker-start`, `marker-end`, `marker-mid`, and `marker` attributes. The `marker` attribute places the marker at every point along the path, and `marker-mid` places them at every point except the start and end.
    \*/
    // TODO add usage for markers
    elproto.marker = function (x, y, width, height, refX, refY) {
        var p = make("marker", getSomeDefs(this));
        if (x == null) {
            x = this.getBBox();
        }
        if (is(x, "object") && "x" in x) {
            y = x.y;
            width = x.width;
            height = x.height;
            refX = x.refX || x.cx;
            refY = x.refY || x.cy;
            x = x.x;
        }
        $(p.node, {
            viewBox: [x, y, width, height].join(" "),
            markerWidth: width,
            markerHeight: height,
            orient: "auto",
            refX: refX || 0,
            refY: refY || 0,
            id: p.id
        });
        p.node.appendChild(this.node);
        return p;
    };
    // animation
    function slice(from, to, f) {
        return function (arr) {
            var res = arr.slice(from, to);
            if (res.length == 1) {
                res = res[0];
            }
            return f ? f(res) : res;
        };
    }
    var Animation = function (attr, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = mina.linear;
        }
        this.attr = attr;
        this.dur = ms;
        easing && (this.easing = easing);
        callback && (this.callback = callback);
    };
    Snap._.Animation = Animation;
    /*\
     * Snap.animation
     [ method ]
     **
     * Creates an animation object
     **
     - attr (object) attributes of final destination
     - duration (number) duration of the animation, in milliseconds
     - easing (function) #optional one of easing functions of @mina or custom one
     - callback (function) #optional callback function that fires when animation ends
     = (object) animation object
    \*/
    Snap.animation = function (attr, ms, easing, callback) {
        return new Animation(attr, ms, easing, callback);
    };
    /*\
     * Element.inAnim
     [ method ]
     **
     * Returns a set of animations that may be able to manipulate the current element
     **
     = (object) in format:
     o {
     o     anim (object) animation object,
     o     mina (object) @mina object,
     o     curStatus (number) 0..1 — status of the animation: 0 — just started, 1 — just finished,
     o     status (function) gets or sets the status of the animation,
     o     stop (function) stops the animation
     o }
    \*/
    elproto.inAnim = function () {
        var el = this,
            res = [];
        for (var id in el.anims) if (el.anims[has](id)) {
            (function (a) {
                res.push({
                    anim: new Animation(a._attrs, a.dur, a.easing, a._callback),
                    mina: a,
                    curStatus: a.status(),
                    status: function (val) {
                        return a.status(val);
                    },
                    stop: function () {
                        a.stop();
                    }
                });
            }(el.anims[id]));
        }
        return res;
    };
    /*\
     * Snap.animate
     [ method ]
     **
     * Runs generic animation of one number into another with a caring function
     **
     - from (number|array) number or array of numbers
     - to (number|array) number or array of numbers
     - setter (function) caring function that accepts one number argument
     - duration (number) duration, in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function to execute when animation ends
     = (object) animation object in @mina format
     o {
     o     id (string) animation id, consider it read-only,
     o     duration (function) gets or sets the duration of the animation,
     o     easing (function) easing,
     o     speed (function) gets or sets the speed of the animation,
     o     status (function) gets or sets the status of the animation,
     o     stop (function) stops the animation
     o }
     | var rect = Snap().rect(0, 0, 10, 10);
     | Snap.animate(0, 10, function (val) {
     |     rect.attr({
     |         x: val
     |     });
     | }, 1000);
     | // in given context is equivalent to
     | rect.animate({x: 10}, 1000);
    \*/
    Snap.animate = function (from, to, setter, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = mina.linear;
        }
        var now = mina.time(),
            anim = mina(from, to, now, now + ms, mina.time, setter, easing);
        callback && eve.once("mina.finish." + anim.id, callback);
        return anim;
    };
    /*\
     * Element.stop
     [ method ]
     **
     * Stops all the animations for the current element
     **
     = (Element) the current element
    \*/
    elproto.stop = function () {
        var anims = this.inAnim();
        for (var i = 0, ii = anims.length; i < ii; i++) {
            anims[i].stop();
        }
        return this;
    };
    /*\
     * Element.animate
     [ method ]
     **
     * Animates the given attributes of the element
     **
     - attrs (object) key-value pairs of destination attributes
     - duration (number) duration of the animation in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function that executes when the animation ends
     = (Element) the current element
    \*/
    elproto.animate = function (attrs, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = mina.linear;
        }
        if (attrs instanceof Animation) {
            callback = attrs.callback;
            easing = attrs.easing;
            ms = easing.dur;
            attrs = attrs.attr;
        }
        var fkeys = [], tkeys = [], keys = {}, from, to, f, eq,
            el = this;
        for (var key in attrs) if (attrs[has](key)) {
            if (el.equal) {
                eq = el.equal(key, Str(attrs[key]));
                from = eq.from;
                to = eq.to;
                f = eq.f;
            } else {
                from = +el.attr(key);
                to = +attrs[key];
            }
            var len = is(from, "array") ? from.length : 1;
            keys[key] = slice(fkeys.length, fkeys.length + len, f);
            fkeys = fkeys.concat(from);
            tkeys = tkeys.concat(to);
        }
        var now = mina.time(),
            anim = mina(fkeys, tkeys, now, now + ms, mina.time, function (val) {
                var attr = {};
                for (var key in keys) if (keys[has](key)) {
                    attr[key] = keys[key](val);
                }
                el.attr(attr);
            }, easing);
        el.anims[anim.id] = anim;
        anim._attrs = attrs;
        anim._callback = callback;
        eve("snap.animcreated." + el.id, anim);
        eve.once("mina.finish." + anim.id, function () {
            delete el.anims[anim.id];
            callback && callback.call(el);
        });
        eve.once("mina.stop." + anim.id, function () {
            delete el.anims[anim.id];
        });
        return el;
    };
    var eldata = {};
    /*\
     * Element.data
     [ method ]
     **
     * Adds or retrieves given value associated with given key. (Don’t confuse
     * with `data-` attributes)
     *
     * See also @Element.removeData
     - key (string) key to store data
     - value (any) #optional value to store
     = (object) @Element
     * or, if value is not specified:
     = (any) value
     > Usage
     | for (var i = 0, i < 5, i++) {
     |     paper.circle(10 + 15 * i, 10, 10)
     |          .attr({fill: "#000"})
     |          .data("i", i)
     |          .click(function () {
     |             alert(this.data("i"));
     |          });
     | }
    \*/
    elproto.data = function (key, value) {
        var data = eldata[this.id] = eldata[this.id] || {};
        if (arguments.length == 0){
            eve("snap.data.get." + this.id, this, data, null);
            return data;
        }
        if (arguments.length == 1) {
            if (Snap.is(key, "object")) {
                for (var i in key) if (key[has](i)) {
                    this.data(i, key[i]);
                }
                return this;
            }
            eve("snap.data.get." + this.id, this, data[key], key);
            return data[key];
        }
        data[key] = value;
        eve("snap.data.set." + this.id, this, value, key);
        return this;
    };
    /*\
     * Element.removeData
     [ method ]
     **
     * Removes value associated with an element by given key.
     * If key is not provided, removes all the data of the element.
     - key (string) #optional key
     = (object) @Element
    \*/
    elproto.removeData = function (key) {
        if (key == null) {
            eldata[this.id] = {};
        } else {
            eldata[this.id] && delete eldata[this.id][key];
        }
        return this;
    };
    /*\
     * Element.outerSVG
     [ method ]
     **
     * Returns SVG code for the element, equivalent to HTML's `outerHTML`.
     *
     * See also @Element.innerSVG
     = (string) SVG code for the element
    \*/
    /*\
     * Element.toString
     [ method ]
     **
     * See @Element.outerSVG
    \*/
    elproto.outerSVG = elproto.toString = toString(1);
    /*\
     * Element.innerSVG
     [ method ]
     **
     * Returns SVG code for the element's contents, equivalent to HTML's `innerHTML`
     = (string) SVG code for the element
    \*/
    elproto.innerSVG = toString();
    function toString(type) {
        return function () {
            var res = type ? "<" + this.type : "",
                attr = this.node.attributes,
                chld = this.node.childNodes;
            if (type) {
                for (var i = 0, ii = attr.length; i < ii; i++) {
                    res += " " + attr[i].name + '="' +
                            attr[i].value.replace(/"/g, '\\"') + '"';
                }
            }
            if (chld.length) {
                type && (res += ">");
                for (i = 0, ii = chld.length; i < ii; i++) {
                    if (chld[i].nodeType == 3) {
                        res += chld[i].nodeValue;
                    } else if (chld[i].nodeType == 1) {
                        res += wrap(chld[i]).toString();
                    }
                }
                type && (res += "</" + this.type + ">");
            } else {
                type && (res += "/>");
            }
            return res;
        };
    }
    elproto.toDataURL = function () {
        if (window && window.btoa) {
            var bb = this.getBBox(),
                svg = Snap.format('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="{width}" height="{height}" viewBox="{x} {y} {width} {height}">{contents}</svg>', {
                x: +bb.x.toFixed(3),
                y: +bb.y.toFixed(3),
                width: +bb.width.toFixed(3),
                height: +bb.height.toFixed(3),
                contents: this.outerSVG()
            });
            return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg)));
        }
    };
    /*\
     * Fragment.select
     [ method ]
     **
     * See @Element.select
    \*/
    Fragment.prototype.select = elproto.select;
    /*\
     * Fragment.selectAll
     [ method ]
     **
     * See @Element.selectAll
    \*/
    Fragment.prototype.selectAll = elproto.selectAll;
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var objectToString = Object.prototype.toString,
        Str = String,
        math = Math,
        E = "";
    function Matrix(a, b, c, d, e, f) {
        if (b == null && objectToString.call(a) == "[object SVGMatrix]") {
            this.a = a.a;
            this.b = a.b;
            this.c = a.c;
            this.d = a.d;
            this.e = a.e;
            this.f = a.f;
            return;
        }
        if (a != null) {
            this.a = +a;
            this.b = +b;
            this.c = +c;
            this.d = +d;
            this.e = +e;
            this.f = +f;
        } else {
            this.a = 1;
            this.b = 0;
            this.c = 0;
            this.d = 1;
            this.e = 0;
            this.f = 0;
        }
    }
    (function (matrixproto) {
        /*\
         * Matrix.add
         [ method ]
         **
         * Adds the given matrix to existing one
         - a (number)
         - b (number)
         - c (number)
         - d (number)
         - e (number)
         - f (number)
         * or
         - matrix (object) @Matrix
        \*/
        matrixproto.add = function (a, b, c, d, e, f) {
            var out = [[], [], []],
                m = [[this.a, this.c, this.e], [this.b, this.d, this.f], [0, 0, 1]],
                matrix = [[a, c, e], [b, d, f], [0, 0, 1]],
                x, y, z, res;

            if (a && a instanceof Matrix) {
                matrix = [[a.a, a.c, a.e], [a.b, a.d, a.f], [0, 0, 1]];
            }

            for (x = 0; x < 3; x++) {
                for (y = 0; y < 3; y++) {
                    res = 0;
                    for (z = 0; z < 3; z++) {
                        res += m[x][z] * matrix[z][y];
                    }
                    out[x][y] = res;
                }
            }
            this.a = out[0][0];
            this.b = out[1][0];
            this.c = out[0][1];
            this.d = out[1][1];
            this.e = out[0][2];
            this.f = out[1][2];
            return this;
        };
        /*\
         * Matrix.invert
         [ method ]
         **
         * Returns an inverted version of the matrix
         = (object) @Matrix
        \*/
        matrixproto.invert = function () {
            var me = this,
                x = me.a * me.d - me.b * me.c;
            return new Matrix(me.d / x, -me.b / x, -me.c / x, me.a / x, (me.c * me.f - me.d * me.e) / x, (me.b * me.e - me.a * me.f) / x);
        };
        /*\
         * Matrix.clone
         [ method ]
         **
         * Returns a copy of the matrix
         = (object) @Matrix
        \*/
        matrixproto.clone = function () {
            return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
        };
        /*\
         * Matrix.translate
         [ method ]
         **
         * Translate the matrix
         - x (number) horizontal offset distance
         - y (number) vertical offset distance
        \*/
        matrixproto.translate = function (x, y) {
            return this.add(1, 0, 0, 1, x, y);
        };
        /*\
         * Matrix.scale
         [ method ]
         **
         * Scales the matrix
         - x (number) amount to be scaled, with `1` resulting in no change
         - y (number) #optional amount to scale along the vertical axis. (Otherwise `x` applies to both axes.)
         - cx (number) #optional horizontal origin point from which to scale
         - cy (number) #optional vertical origin point from which to scale
         * Default cx, cy is the middle point of the element.
        \*/
        matrixproto.scale = function (x, y, cx, cy) {
            y == null && (y = x);
            (cx || cy) && this.add(1, 0, 0, 1, cx, cy);
            this.add(x, 0, 0, y, 0, 0);
            (cx || cy) && this.add(1, 0, 0, 1, -cx, -cy);
            return this;
        };
        /*\
         * Matrix.rotate
         [ method ]
         **
         * Rotates the matrix
         - a (number) angle of rotation, in degrees
         - x (number) horizontal origin point from which to rotate
         - y (number) vertical origin point from which to rotate
        \*/
        matrixproto.rotate = function (a, x, y) {
            a = Snap.rad(a);
            x = x || 0;
            y = y || 0;
            var cos = +math.cos(a).toFixed(9),
                sin = +math.sin(a).toFixed(9);
            this.add(cos, sin, -sin, cos, x, y);
            return this.add(1, 0, 0, 1, -x, -y);
        };
        /*\
         * Matrix.x
         [ method ]
         **
         * Returns x coordinate for given point after transformation described by the matrix. See also @Matrix.y
         - x (number)
         - y (number)
         = (number) x
        \*/
        matrixproto.x = function (x, y) {
            return x * this.a + y * this.c + this.e;
        };
        /*\
         * Matrix.y
         [ method ]
         **
         * Returns y coordinate for given point after transformation described by the matrix. See also @Matrix.x
         - x (number)
         - y (number)
         = (number) y
        \*/
        matrixproto.y = function (x, y) {
            return x * this.b + y * this.d + this.f;
        };
        matrixproto.get = function (i) {
            return +this[Str.fromCharCode(97 + i)].toFixed(4);
        };
        matrixproto.toString = function () {
            return "matrix(" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ")";
        };
        matrixproto.offset = function () {
            return [this.e.toFixed(4), this.f.toFixed(4)];
        };
        function norm(a) {
            return a[0] * a[0] + a[1] * a[1];
        }
        function normalize(a) {
            var mag = math.sqrt(norm(a));
            a[0] && (a[0] /= mag);
            a[1] && (a[1] /= mag);
        }
        /*\
         * Matrix.determinant
         [ method ]
         **
         * Finds determinant of the given matrix.
         = (number) determinant
        \*/
        matrixproto.determinant = function () {
            return this.a * this.d - this.b * this.c;
        };
        /*\
         * Matrix.split
         [ method ]
         **
         * Splits matrix into primitive transformations
         = (object) in format:
         o dx (number) translation by x
         o dy (number) translation by y
         o scalex (number) scale by x
         o scaley (number) scale by y
         o shear (number) shear
         o rotate (number) rotation in deg
         o isSimple (boolean) could it be represented via simple transformations
        \*/
        matrixproto.split = function () {
            var out = {};
            // translation
            out.dx = this.e;
            out.dy = this.f;

            // scale and shear
            var row = [[this.a, this.c], [this.b, this.d]];
            out.scalex = math.sqrt(norm(row[0]));
            normalize(row[0]);

            out.shear = row[0][0] * row[1][0] + row[0][1] * row[1][1];
            row[1] = [row[1][0] - row[0][0] * out.shear, row[1][1] - row[0][1] * out.shear];

            out.scaley = math.sqrt(norm(row[1]));
            normalize(row[1]);
            out.shear /= out.scaley;

            if (this.determinant() < 0) {
                out.scalex = -out.scalex;
            }

            // rotation
            var sin = -row[0][1],
                cos = row[1][1];
            if (cos < 0) {
                out.rotate = Snap.deg(math.acos(cos));
                if (sin < 0) {
                    out.rotate = 360 - out.rotate;
                }
            } else {
                out.rotate = Snap.deg(math.asin(sin));
            }

            out.isSimple = !+out.shear.toFixed(9) && (out.scalex.toFixed(9) == out.scaley.toFixed(9) || !out.rotate);
            out.isSuperSimple = !+out.shear.toFixed(9) && out.scalex.toFixed(9) == out.scaley.toFixed(9) && !out.rotate;
            out.noRotation = !+out.shear.toFixed(9) && !out.rotate;
            return out;
        };
        /*\
         * Matrix.toTransformString
         [ method ]
         **
         * Returns transform string that represents given matrix
         = (string) transform string
        \*/
        matrixproto.toTransformString = function (shorter) {
            var s = shorter || this.split();
            if (!+s.shear.toFixed(9)) {
                s.scalex = +s.scalex.toFixed(4);
                s.scaley = +s.scaley.toFixed(4);
                s.rotate = +s.rotate.toFixed(4);
                return  (s.dx || s.dy ? "t" + [+s.dx.toFixed(4), +s.dy.toFixed(4)] : E) +
                        (s.scalex != 1 || s.scaley != 1 ? "s" + [s.scalex, s.scaley, 0, 0] : E) +
                        (s.rotate ? "r" + [+s.rotate.toFixed(4), 0, 0] : E);
            } else {
                return "m" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)];
            }
        };
    })(Matrix.prototype);
    /*\
     * Snap.Matrix
     [ method ]
     **
     * Matrix constructor, extend on your own risk.
     * To create matrices use @Snap.matrix.
    \*/
    Snap.Matrix = Matrix;
    /*\
     * Snap.matrix
     [ method ]
     **
     * Utility method
     **
     * Returns a matrix based on the given parameters
     - a (number)
     - b (number)
     - c (number)
     - d (number)
     - e (number)
     - f (number)
     * or
     - svgMatrix (SVGMatrix)
     = (object) @Matrix
    \*/
    Snap.matrix = function (a, b, c, d, e, f) {
        return new Matrix(a, b, c, d, e, f);
    };
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var has = "hasOwnProperty",
        make = Snap._.make,
        wrap = Snap._.wrap,
        is = Snap.is,
        getSomeDefs = Snap._.getSomeDefs,
        reURLValue = /^url\(#?([^)]+)\)$/,
        $ = Snap._.$,
        URL = Snap.url,
        Str = String,
        separator = Snap._.separator,
        E = "";
    // Attributes event handlers
    eve.on("snap.util.attr.mask", function (value) {
        if (value instanceof Element || value instanceof Fragment) {
            eve.stop();
            if (value instanceof Fragment && value.node.childNodes.length == 1) {
                value = value.node.firstChild;
                getSomeDefs(this).appendChild(value);
                value = wrap(value);
            }
            if (value.type == "mask") {
                var mask = value;
            } else {
                mask = make("mask", getSomeDefs(this));
                mask.node.appendChild(value.node);
            }
            !mask.node.id && $(mask.node, {
                id: mask.id
            });
            $(this.node, {
                mask: URL(mask.id)
            });
        }
    });
    (function (clipIt) {
        eve.on("snap.util.attr.clip", clipIt);
        eve.on("snap.util.attr.clip-path", clipIt);
        eve.on("snap.util.attr.clipPath", clipIt);
    }(function (value) {
        if (value instanceof Element || value instanceof Fragment) {
            eve.stop();
            if (value.type == "clipPath") {
                var clip = value;
            } else {
                clip = make("clipPath", getSomeDefs(this));
                clip.node.appendChild(value.node);
                !clip.node.id && $(clip.node, {
                    id: clip.id
                });
            }
            $(this.node, {
                "clip-path": URL(clip.node.id || clip.id)
            });
        }
    }));
    function fillStroke(name) {
        return function (value) {
            eve.stop();
            if (value instanceof Fragment && value.node.childNodes.length == 1 &&
                (value.node.firstChild.tagName == "radialGradient" ||
                value.node.firstChild.tagName == "linearGradient" ||
                value.node.firstChild.tagName == "pattern")) {
                value = value.node.firstChild;
                getSomeDefs(this).appendChild(value);
                value = wrap(value);
            }
            if (value instanceof Element) {
                if (value.type == "radialGradient" || value.type == "linearGradient"
                   || value.type == "pattern") {
                    if (!value.node.id) {
                        $(value.node, {
                            id: value.id
                        });
                    }
                    var fill = URL(value.node.id);
                } else {
                    fill = value.attr(name);
                }
            } else {
                fill = Snap.color(value);
                if (fill.error) {
                    var grad = Snap(getSomeDefs(this).ownerSVGElement).gradient(value);
                    if (grad) {
                        if (!grad.node.id) {
                            $(grad.node, {
                                id: grad.id
                            });
                        }
                        fill = URL(grad.node.id);
                    } else {
                        fill = value;
                    }
                } else {
                    fill = Str(fill);
                }
            }
            var attrs = {};
            attrs[name] = fill;
            $(this.node, attrs);
            this.node.style[name] = E;
        };
    }
    eve.on("snap.util.attr.fill", fillStroke("fill"));
    eve.on("snap.util.attr.stroke", fillStroke("stroke"));
    var gradrg = /^([lr])(?:\(([^)]*)\))?(.*)$/i;
    eve.on("snap.util.grad.parse", function parseGrad(string) {
        string = Str(string);
        var tokens = string.match(gradrg);
        if (!tokens) {
            return null;
        }
        var type = tokens[1],
            params = tokens[2],
            stops = tokens[3];
        params = params.split(/\s*,\s*/).map(function (el) {
            return +el == el ? +el : el;
        });
        if (params.length == 1 && params[0] == 0) {
            params = [];
        }
        stops = stops.split("-");
        stops = stops.map(function (el) {
            el = el.split(":");
            var out = {
                color: el[0]
            };
            if (el[1]) {
                out.offset = parseFloat(el[1]);
            }
            return out;
        });
        return {
            type: type,
            params: params,
            stops: stops
        };
    });

    eve.on("snap.util.attr.d", function (value) {
        eve.stop();
        if (is(value, "array") && is(value[0], "array")) {
            value = Snap.path.toString.call(value);
        }
        value = Str(value);
        if (value.match(/[ruo]/i)) {
            value = Snap.path.toAbsolute(value);
        }
        $(this.node, {d: value});
    })(-1);
    eve.on("snap.util.attr.#text", function (value) {
        eve.stop();
        value = Str(value);
        var txt = glob.doc.createTextNode(value);
        while (this.node.firstChild) {
            this.node.removeChild(this.node.firstChild);
        }
        this.node.appendChild(txt);
    })(-1);
    eve.on("snap.util.attr.path", function (value) {
        eve.stop();
        this.attr({d: value});
    })(-1);
    eve.on("snap.util.attr.class", function (value) {
        eve.stop();
        this.node.className.baseVal = value;
    })(-1);
    eve.on("snap.util.attr.viewBox", function (value) {
        var vb;
        if (is(value, "object") && "x" in value) {
            vb = [value.x, value.y, value.width, value.height].join(" ");
        } else if (is(value, "array")) {
            vb = value.join(" ");
        } else {
            vb = value;
        }
        $(this.node, {
            viewBox: vb
        });
        eve.stop();
    })(-1);
    eve.on("snap.util.attr.transform", function (value) {
        this.transform(value);
        eve.stop();
    })(-1);
    eve.on("snap.util.attr.r", function (value) {
        if (this.type == "rect") {
            eve.stop();
            $(this.node, {
                rx: value,
                ry: value
            });
        }
    })(-1);
    eve.on("snap.util.attr.textpath", function (value) {
        eve.stop();
        if (this.type == "text") {
            var id, tp, node;
            if (!value && this.textPath) {
                tp = this.textPath;
                while (tp.node.firstChild) {
                    this.node.appendChild(tp.node.firstChild);
                }
                tp.remove();
                delete this.textPath;
                return;
            }
            if (is(value, "string")) {
                var defs = getSomeDefs(this),
                    path = wrap(defs.parentNode).path(value);
                defs.appendChild(path.node);
                id = path.id;
                path.attr({id: id});
            } else {
                value = wrap(value);
                if (value instanceof Element) {
                    id = value.attr("id");
                    if (!id) {
                        id = value.id;
                        value.attr({id: id});
                    }
                }
            }
            if (id) {
                tp = this.textPath;
                node = this.node;
                if (tp) {
                    tp.attr({"xlink:href": "#" + id});
                } else {
                    tp = $("textPath", {
                        "xlink:href": "#" + id
                    });
                    while (node.firstChild) {
                        tp.appendChild(node.firstChild);
                    }
                    node.appendChild(tp);
                    this.textPath = wrap(tp);
                }
            }
        }
    })(-1);
    eve.on("snap.util.attr.text", function (value) {
        if (this.type == "text") {
            var i = 0,
                node = this.node,
                tuner = function (chunk) {
                    var out = $("tspan");
                    if (is(chunk, "array")) {
                        for (var i = 0; i < chunk.length; i++) {
                            out.appendChild(tuner(chunk[i]));
                        }
                    } else {
                        out.appendChild(glob.doc.createTextNode(chunk));
                    }
                    out.normalize && out.normalize();
                    return out;
                };
            while (node.firstChild) {
                node.removeChild(node.firstChild);
            }
            var tuned = tuner(value);
            while (tuned.firstChild) {
                node.appendChild(tuned.firstChild);
            }
        }
        eve.stop();
    })(-1);
    function setFontSize(value) {
        eve.stop();
        if (value == +value) {
            value += "px";
        }
        this.node.style.fontSize = value;
    }
    eve.on("snap.util.attr.fontSize", setFontSize)(-1);
    eve.on("snap.util.attr.font-size", setFontSize)(-1);


    eve.on("snap.util.getattr.transform", function () {
        eve.stop();
        return this.transform();
    })(-1);
    eve.on("snap.util.getattr.textpath", function () {
        eve.stop();
        return this.textPath;
    })(-1);
    // Markers
    (function () {
        function getter(end) {
            return function () {
                eve.stop();
                var style = glob.doc.defaultView.getComputedStyle(this.node, null).getPropertyValue("marker-" + end);
                if (style == "none") {
                    return style;
                } else {
                    return Snap(glob.doc.getElementById(style.match(reURLValue)[1]));
                }
            };
        }
        function setter(end) {
            return function (value) {
                eve.stop();
                var name = "marker" + end.charAt(0).toUpperCase() + end.substring(1);
                if (value == "" || !value) {
                    this.node.style[name] = "none";
                    return;
                }
                if (value.type == "marker") {
                    var id = value.node.id;
                    if (!id) {
                        $(value.node, {id: value.id});
                    }
                    this.node.style[name] = URL(id);
                    return;
                }
            };
        }
        eve.on("snap.util.getattr.marker-end", getter("end"))(-1);
        eve.on("snap.util.getattr.markerEnd", getter("end"))(-1);
        eve.on("snap.util.getattr.marker-start", getter("start"))(-1);
        eve.on("snap.util.getattr.markerStart", getter("start"))(-1);
        eve.on("snap.util.getattr.marker-mid", getter("mid"))(-1);
        eve.on("snap.util.getattr.markerMid", getter("mid"))(-1);
        eve.on("snap.util.attr.marker-end", setter("end"))(-1);
        eve.on("snap.util.attr.markerEnd", setter("end"))(-1);
        eve.on("snap.util.attr.marker-start", setter("start"))(-1);
        eve.on("snap.util.attr.markerStart", setter("start"))(-1);
        eve.on("snap.util.attr.marker-mid", setter("mid"))(-1);
        eve.on("snap.util.attr.markerMid", setter("mid"))(-1);
    }());
    eve.on("snap.util.getattr.r", function () {
        if (this.type == "rect" && $(this.node, "rx") == $(this.node, "ry")) {
            eve.stop();
            return $(this.node, "rx");
        }
    })(-1);
    function textExtract(node) {
        var out = [];
        var children = node.childNodes;
        for (var i = 0, ii = children.length; i < ii; i++) {
            var chi = children[i];
            if (chi.nodeType == 3) {
                out.push(chi.nodeValue);
            }
            if (chi.tagName == "tspan") {
                if (chi.childNodes.length == 1 && chi.firstChild.nodeType == 3) {
                    out.push(chi.firstChild.nodeValue);
                } else {
                    out.push(textExtract(chi));
                }
            }
        }
        return out;
    }
    eve.on("snap.util.getattr.text", function () {
        if (this.type == "text" || this.type == "tspan") {
            eve.stop();
            var out = textExtract(this.node);
            return out.length == 1 ? out[0] : out;
        }
    })(-1);
    eve.on("snap.util.getattr.#text", function () {
        return this.node.textContent;
    })(-1);
    eve.on("snap.util.getattr.viewBox", function () {
        eve.stop();
        var vb = $(this.node, "viewBox");
        if (vb) {
            vb = vb.split(separator);
            return Snap._.box(+vb[0], +vb[1], +vb[2], +vb[3]);
        } else {
            return;
        }
    })(-1);
    eve.on("snap.util.getattr.points", function () {
        var p = $(this.node, "points");
        eve.stop();
        if (p) {
            return p.split(separator);
        } else {
            return;
        }
    })(-1);
    eve.on("snap.util.getattr.path", function () {
        var p = $(this.node, "d");
        eve.stop();
        return p;
    })(-1);
    eve.on("snap.util.getattr.class", function () {
        return this.node.className.baseVal;
    })(-1);
    function getFontSize() {
        eve.stop();
        return this.node.style.fontSize;
    }
    eve.on("snap.util.getattr.fontSize", getFontSize)(-1);
    eve.on("snap.util.getattr.font-size", getFontSize)(-1);
});

// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var rgNotSpace = /\S+/g,
        rgBadSpace = /[\t\r\n\f]/g,
        rgTrim = /(^\s+|\s+$)/g,
        Str = String,
        elproto = Element.prototype;
    /*\
     * Element.addClass
     [ method ]
     **
     * Adds given class name or list of class names to the element.
     - value (string) class name or space separated list of class names
     **
     = (Element) original element.
    \*/
    elproto.addClass = function (value) {
        var classes = Str(value || "").match(rgNotSpace) || [],
            elem = this.node,
            className = elem.className.baseVal,
            curClasses = className.match(rgNotSpace) || [],
            j,
            pos,
            clazz,
            finalValue;

        if (classes.length) {
            j = 0;
            while ((clazz = classes[j++])) {
                pos = curClasses.indexOf(clazz);
                if (!~pos) {
                    curClasses.push(clazz);
                }
            }

            finalValue = curClasses.join(" ");
            if (className != finalValue) {
                elem.className.baseVal = finalValue;
            }
        }
        return this;
    };
    /*\
     * Element.removeClass
     [ method ]
     **
     * Removes given class name or list of class names from the element.
     - value (string) class name or space separated list of class names
     **
     = (Element) original element.
    \*/
    elproto.removeClass = function (value) {
        var classes = Str(value || "").match(rgNotSpace) || [],
            elem = this.node,
            className = elem.className.baseVal,
            curClasses = className.match(rgNotSpace) || [],
            j,
            pos,
            clazz,
            finalValue;
        if (curClasses.length) {
            j = 0;
            while ((clazz = classes[j++])) {
                pos = curClasses.indexOf(clazz);
                if (~pos) {
                    curClasses.splice(pos, 1);
                }
            }

            finalValue = curClasses.join(" ");
            if (className != finalValue) {
                elem.className.baseVal = finalValue;
            }
        }
        return this;
    };
    /*\
     * Element.hasClass
     [ method ]
     **
     * Checks if the element has a given class name in the list of class names applied to it.
     - value (string) class name
     **
     = (boolean) `true` if the element has given class
    \*/
    elproto.hasClass = function (value) {
        var elem = this.node,
            className = elem.className.baseVal,
            curClasses = className.match(rgNotSpace) || [];
        return !!~curClasses.indexOf(value);
    };
    /*\
     * Element.toggleClass
     [ method ]
     **
     * Add or remove one or more classes from the element, depending on either
     * the class’s presence or the value of the `flag` argument.
     - value (string) class name or space separated list of class names
     - flag (boolean) value to determine whether the class should be added or removed
     **
     = (Element) original element.
    \*/
    elproto.toggleClass = function (value, flag) {
        if (flag != null) {
            if (flag) {
                return this.addClass(value);
            } else {
                return this.removeClass(value);
            }
        }
        var classes = (value || "").match(rgNotSpace) || [],
            elem = this.node,
            className = elem.className.baseVal,
            curClasses = className.match(rgNotSpace) || [],
            j,
            pos,
            clazz,
            finalValue;
        j = 0;
        while ((clazz = classes[j++])) {
            pos = curClasses.indexOf(clazz);
            if (~pos) {
                curClasses.splice(pos, 1);
            } else {
                curClasses.push(clazz);
            }
        }

        finalValue = curClasses.join(" ");
        if (className != finalValue) {
            elem.className.baseVal = finalValue;
        }
        return this;
    };
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var operators = {
            "+": function (x, y) {
                    return x + y;
                },
            "-": function (x, y) {
                    return x - y;
                },
            "/": function (x, y) {
                    return x / y;
                },
            "*": function (x, y) {
                    return x * y;
                }
        },
        Str = String,
        reUnit = /[a-z]+$/i,
        reAddon = /^\s*([+\-\/*])\s*=\s*([\d.eE+\-]+)\s*([^\d\s]+)?\s*$/;
    function getNumber(val) {
        return val;
    }
    function getUnit(unit) {
        return function (val) {
            return +val.toFixed(3) + unit;
        };
    }
    eve.on("snap.util.attr", function (val) {
        var plus = Str(val).match(reAddon);
        if (plus) {
            var evnt = eve.nt(),
                name = evnt.substring(evnt.lastIndexOf(".") + 1),
                a = this.attr(name),
                atr = {};
            eve.stop();
            var unit = plus[3] || "",
                aUnit = a.match(reUnit),
                op = operators[plus[1]];
            if (aUnit && aUnit == unit) {
                val = op(parseFloat(a), +plus[2]);
            } else {
                a = this.asPX(name);
                val = op(this.asPX(name), this.asPX(name, plus[2] + unit));
            }
            if (isNaN(a) || isNaN(val)) {
                return;
            }
            atr[name] = val;
            this.attr(atr);
        }
    })(-10);
    eve.on("snap.util.equal", function (name, b) {
        var A, B, a = Str(this.attr(name) || ""),
            el = this,
            bplus = Str(b).match(reAddon);
        if (bplus) {
            eve.stop();
            var unit = bplus[3] || "",
                aUnit = a.match(reUnit),
                op = operators[bplus[1]];
            if (aUnit && aUnit == unit) {
                return {
                    from: parseFloat(a),
                    to: op(parseFloat(a), +bplus[2]),
                    f: getUnit(aUnit)
                };
            } else {
                a = this.asPX(name);
                return {
                    from: a,
                    to: op(a, this.asPX(name, bplus[2] + unit)),
                    f: getNumber
                };
            }
        }
    })(-10);
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var proto = Paper.prototype,
        is = Snap.is;
    /*\
     * Paper.rect
     [ method ]
     *
     * Draws a rectangle
     **
     - x (number) x coordinate of the top left corner
     - y (number) y coordinate of the top left corner
     - width (number) width
     - height (number) height
     - rx (number) #optional horizontal radius for rounded corners, default is 0
     - ry (number) #optional vertical radius for rounded corners, default is rx or 0
     = (object) the `rect` element
     **
     > Usage
     | // regular rectangle
     | var c = paper.rect(10, 10, 50, 50);
     | // rectangle with rounded corners
     | var c = paper.rect(40, 40, 50, 50, 10);
    \*/
    proto.rect = function (x, y, w, h, rx, ry) {
        var attr;
        if (ry == null) {
            ry = rx;
        }
        if (is(x, "object") && x == "[object Object]") {
            attr = x;
        } else if (x != null) {
            attr = {
                x: x,
                y: y,
                width: w,
                height: h
            };
            if (rx != null) {
                attr.rx = rx;
                attr.ry = ry;
            }
        }
        return this.el("rect", attr);
    };
    /*\
     * Paper.circle
     [ method ]
     **
     * Draws a circle
     **
     - x (number) x coordinate of the centre
     - y (number) y coordinate of the centre
     - r (number) radius
     = (object) the `circle` element
     **
     > Usage
     | var c = paper.circle(50, 50, 40);
    \*/
    proto.circle = function (cx, cy, r) {
        var attr;
        if (is(cx, "object") && cx == "[object Object]") {
            attr = cx;
        } else if (cx != null) {
            attr = {
                cx: cx,
                cy: cy,
                r: r
            };
        }
        return this.el("circle", attr);
    };

    var preload = (function () {
        function onerror() {
            this.parentNode.removeChild(this);
        }
        return function (src, f) {
            var img = glob.doc.createElement("img"),
                body = glob.doc.body;
            img.style.cssText = "position:absolute;left:-9999em;top:-9999em";
            img.onload = function () {
                f.call(img);
                img.onload = img.onerror = null;
                body.removeChild(img);
            };
            img.onerror = onerror;
            body.appendChild(img);
            img.src = src;
        };
    }());

    /*\
     * Paper.image
     [ method ]
     **
     * Places an image on the surface
     **
     - src (string) URI of the source image
     - x (number) x offset position
     - y (number) y offset position
     - width (number) width of the image
     - height (number) height of the image
     = (object) the `image` element
     * or
     = (object) Snap element object with type `image`
     **
     > Usage
     | var c = paper.image("apple.png", 10, 10, 80, 80);
    \*/
    proto.image = function (src, x, y, width, height) {
        var el = this.el("image");
        if (is(src, "object") && "src" in src) {
            el.attr(src);
        } else if (src != null) {
            var set = {
                "xlink:href": src,
                preserveAspectRatio: "none"
            };
            if (x != null && y != null) {
                set.x = x;
                set.y = y;
            }
            if (width != null && height != null) {
                set.width = width;
                set.height = height;
            } else {
                preload(src, function () {
                    Snap._.$(el.node, {
                        width: this.offsetWidth,
                        height: this.offsetHeight
                    });
                });
            }
            Snap._.$(el.node, set);
        }
        return el;
    };
    /*\
     * Paper.ellipse
     [ method ]
     **
     * Draws an ellipse
     **
     - x (number) x coordinate of the centre
     - y (number) y coordinate of the centre
     - rx (number) horizontal radius
     - ry (number) vertical radius
     = (object) the `ellipse` element
     **
     > Usage
     | var c = paper.ellipse(50, 50, 40, 20);
    \*/
    proto.ellipse = function (cx, cy, rx, ry) {
        var attr;
        if (is(cx, "object") && cx == "[object Object]") {
            attr = cx;
        } else if (cx != null) {
            attr ={
                cx: cx,
                cy: cy,
                rx: rx,
                ry: ry
            };
        }
        return this.el("ellipse", attr);
    };
    // SIERRA Paper.path(): Unclear from the link what a Catmull-Rom curveto is, and why it would make life any easier.
    /*\
     * Paper.path
     [ method ]
     **
     * Creates a `<path>` element using the given string as the path's definition
     - pathString (string) #optional path string in SVG format
     * Path string consists of one-letter commands, followed by comma seprarated arguments in numerical form. Example:
     | "M10,20L30,40"
     * This example features two commands: `M`, with arguments `(10, 20)` and `L` with arguments `(30, 40)`. Uppercase letter commands express coordinates in absolute terms, while lowercase commands express them in relative terms from the most recently declared coordinates.
     *
     # <p>Here is short list of commands available, for more details see <a href="http://www.w3.org/TR/SVG/paths.html#PathData" title="Details of a path's data attribute's format are described in the SVG specification.">SVG path string format</a> or <a href="https://developer.mozilla.org/en/SVG/Tutorial/Paths">article about path strings at MDN</a>.</p>
     # <table><thead><tr><th>Command</th><th>Name</th><th>Parameters</th></tr></thead><tbody>
     # <tr><td>M</td><td>moveto</td><td>(x y)+</td></tr>
     # <tr><td>Z</td><td>closepath</td><td>(none)</td></tr>
     # <tr><td>L</td><td>lineto</td><td>(x y)+</td></tr>
     # <tr><td>H</td><td>horizontal lineto</td><td>x+</td></tr>
     # <tr><td>V</td><td>vertical lineto</td><td>y+</td></tr>
     # <tr><td>C</td><td>curveto</td><td>(x1 y1 x2 y2 x y)+</td></tr>
     # <tr><td>S</td><td>smooth curveto</td><td>(x2 y2 x y)+</td></tr>
     # <tr><td>Q</td><td>quadratic Bézier curveto</td><td>(x1 y1 x y)+</td></tr>
     # <tr><td>T</td><td>smooth quadratic Bézier curveto</td><td>(x y)+</td></tr>
     # <tr><td>A</td><td>elliptical arc</td><td>(rx ry x-axis-rotation large-arc-flag sweep-flag x y)+</td></tr>
     # <tr><td>R</td><td><a href="http://en.wikipedia.org/wiki/Catmull–Rom_spline#Catmull.E2.80.93Rom_spline">Catmull-Rom curveto</a>*</td><td>x1 y1 (x y)+</td></tr></tbody></table>
     * * _Catmull-Rom curveto_ is a not standard SVG command and added to make life easier.
     * Note: there is a special case when a path consists of only three commands: `M10,10R…z`. In this case the path connects back to its starting point.
     > Usage
     | var c = paper.path("M10 10L90 90");
     | // draw a diagonal line:
     | // move to 10,10, line to 90,90
    \*/
    proto.path = function (d) {
        var attr;
        if (is(d, "object") && !is(d, "array")) {
            attr = d;
        } else if (d) {
            attr = {d: d};
        }
        return this.el("path", attr);
    };
    /*\
     * Paper.g
     [ method ]
     **
     * Creates a group element
     **
     - varargs (…) #optional elements to nest within the group
     = (object) the `g` element
     **
     > Usage
     | var c1 = paper.circle(),
     |     c2 = paper.rect(),
     |     g = paper.g(c2, c1); // note that the order of elements is different
     * or
     | var c1 = paper.circle(),
     |     c2 = paper.rect(),
     |     g = paper.g();
     | g.add(c2, c1);
    \*/
    /*\
     * Paper.group
     [ method ]
     **
     * See @Paper.g
    \*/
    proto.group = proto.g = function (first) {
        var attr,
            el = this.el("g");
        if (arguments.length == 1 && first && !first.type) {
            el.attr(first);
        } else if (arguments.length) {
            el.add(Array.prototype.slice.call(arguments, 0));
        }
        return el;
    };
    /*\
     * Paper.svg
     [ method ]
     **
     * Creates a nested SVG element.
     - x (number) @optional X of the element
     - y (number) @optional Y of the element
     - width (number) @optional width of the element
     - height (number) @optional height of the element
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     **
     = (object) the `svg` element
     **
    \*/
    proto.svg = function (x, y, width, height, vbx, vby, vbw, vbh) {
        var attrs = {};
        if (is(x, "object") && y == null) {
            attrs = x;
        } else {
            if (x != null) {
                attrs.x = x;
            }
            if (y != null) {
                attrs.y = y;
            }
            if (width != null) {
                attrs.width = width;
            }
            if (height != null) {
                attrs.height = height;
            }
            if (vbx != null && vby != null && vbw != null && vbh != null) {
                attrs.viewBox = [vbx, vby, vbw, vbh];
            }
        }
        return this.el("svg", attrs);
    };
    /*\
     * Paper.mask
     [ method ]
     **
     * Equivalent in behaviour to @Paper.g, except it’s a mask.
     **
     = (object) the `mask` element
     **
    \*/
    proto.mask = function (first) {
        var attr,
            el = this.el("mask");
        if (arguments.length == 1 && first && !first.type) {
            el.attr(first);
        } else if (arguments.length) {
            el.add(Array.prototype.slice.call(arguments, 0));
        }
        return el;
    };
    /*\
     * Paper.ptrn
     [ method ]
     **
     * Equivalent in behaviour to @Paper.g, except it’s a pattern.
     - x (number) @optional X of the element
     - y (number) @optional Y of the element
     - width (number) @optional width of the element
     - height (number) @optional height of the element
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     **
     = (object) the `pattern` element
     **
    \*/
    proto.ptrn = function (x, y, width, height, vx, vy, vw, vh) {
        if (is(x, "object")) {
            var attr = x;
        } else {
            attr = {patternUnits: "userSpaceOnUse"};
            if (x) {
                attr.x = x;
            }
            if (y) {
                attr.y = y;
            }
            if (width != null) {
                attr.width = width;
            }
            if (height != null) {
                attr.height = height;
            }
            if (vx != null && vy != null && vw != null && vh != null) {
                attr.viewBox = [vx, vy, vw, vh];
            } else {
                attr.viewBox = [x || 0, y || 0, width || 0, height || 0];
            }
        }
        return this.el("pattern", attr);
    };
    /*\
     * Paper.use
     [ method ]
     **
     * Creates a <use> element.
     - id (string) @optional id of element to link
     * or
     - id (Element) @optional element to link
     **
     = (object) the `use` element
     **
    \*/
    proto.use = function (id) {
        if (id != null) {
            if (id instanceof Element) {
                if (!id.attr("id")) {
                    id.attr({id: Snap._.id(id)});
                }
                id = id.attr("id");
            }
            if (String(id).charAt() == "#") {
                id = id.substring(1);
            }
            return this.el("use", {"xlink:href": "#" + id});
        } else {
            return Element.prototype.use.call(this);
        }
    };
    /*\
     * Paper.symbol
     [ method ]
     **
     * Creates a <symbol> element.
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     = (object) the `symbol` element
     **
    \*/
    proto.symbol = function (vx, vy, vw, vh) {
        var attr = {};
        if (vx != null && vy != null && vw != null && vh != null) {
            attr.viewBox = [vx, vy, vw, vh];
        }

        return this.el("symbol", attr);
    };
    /*\
     * Paper.text
     [ method ]
     **
     * Draws a text string
     **
     - x (number) x coordinate position
     - y (number) y coordinate position
     - text (string|array) The text string to draw or array of strings to nest within separate `<tspan>` elements
     = (object) the `text` element
     **
     > Usage
     | var t1 = paper.text(50, 50, "Snap");
     | var t2 = paper.text(50, 50, ["S","n","a","p"]);
     | // Text path usage
     | t1.attr({textpath: "M10,10L100,100"});
     | // or
     | var pth = paper.path("M10,10L100,100");
     | t1.attr({textpath: pth});
    \*/
    proto.text = function (x, y, text) {
        var attr = {};
        if (is(x, "object")) {
            attr = x;
        } else if (x != null) {
            attr = {
                x: x,
                y: y,
                text: text || ""
            };
        }
        return this.el("text", attr);
    };
    /*\
     * Paper.line
     [ method ]
     **
     * Draws a line
     **
     - x1 (number) x coordinate position of the start
     - y1 (number) y coordinate position of the start
     - x2 (number) x coordinate position of the end
     - y2 (number) y coordinate position of the end
     = (object) the `line` element
     **
     > Usage
     | var t1 = paper.line(50, 50, 100, 100);
    \*/
    proto.line = function (x1, y1, x2, y2) {
        var attr = {};
        if (is(x1, "object")) {
            attr = x1;
        } else if (x1 != null) {
            attr = {
                x1: x1,
                x2: x2,
                y1: y1,
                y2: y2
            };
        }
        return this.el("line", attr);
    };
    /*\
     * Paper.polyline
     [ method ]
     **
     * Draws a polyline
     **
     - points (array) array of points
     * or
     - varargs (…) points
     = (object) the `polyline` element
     **
     > Usage
     | var p1 = paper.polyline([10, 10, 100, 100]);
     | var p2 = paper.polyline(10, 10, 100, 100);
    \*/
    proto.polyline = function (points) {
        if (arguments.length > 1) {
            points = Array.prototype.slice.call(arguments, 0);
        }
        var attr = {};
        if (is(points, "object") && !is(points, "array")) {
            attr = points;
        } else if (points != null) {
            attr = {points: points};
        }
        return this.el("polyline", attr);
    };
    /*\
     * Paper.polygon
     [ method ]
     **
     * Draws a polygon. See @Paper.polyline
    \*/
    proto.polygon = function (points) {
        if (arguments.length > 1) {
            points = Array.prototype.slice.call(arguments, 0);
        }
        var attr = {};
        if (is(points, "object") && !is(points, "array")) {
            attr = points;
        } else if (points != null) {
            attr = {points: points};
        }
        return this.el("polygon", attr);
    };
    // gradients
    (function () {
        var $ = Snap._.$;
        // gradients' helpers
        function Gstops() {
            return this.selectAll("stop");
        }
        function GaddStop(color, offset) {
            var stop = $("stop"),
                attr = {
                    offset: +offset + "%"
                };
            color = Snap.color(color);
            attr["stop-color"] = color.hex;
            if (color.opacity < 1) {
                attr["stop-opacity"] = color.opacity;
            }
            $(stop, attr);
            this.node.appendChild(stop);
            return this;
        }
        function GgetBBox() {
            if (this.type == "linearGradient") {
                var x1 = $(this.node, "x1") || 0,
                    x2 = $(this.node, "x2") || 1,
                    y1 = $(this.node, "y1") || 0,
                    y2 = $(this.node, "y2") || 0;
                return Snap._.box(x1, y1, math.abs(x2 - x1), math.abs(y2 - y1));
            } else {
                var cx = this.node.cx || .5,
                    cy = this.node.cy || .5,
                    r = this.node.r || 0;
                return Snap._.box(cx - r, cy - r, r * 2, r * 2);
            }
        }
        function gradient(defs, str) {
            var grad = eve("snap.util.grad.parse", null, str).firstDefined(),
                el;
            if (!grad) {
                return null;
            }
            grad.params.unshift(defs);
            if (grad.type.toLowerCase() == "l") {
                el = gradientLinear.apply(0, grad.params);
            } else {
                el = gradientRadial.apply(0, grad.params);
            }
            if (grad.type != grad.type.toLowerCase()) {
                $(el.node, {
                    gradientUnits: "userSpaceOnUse"
                });
            }
            var stops = grad.stops,
                len = stops.length,
                start = 0,
                j = 0;
            function seed(i, end) {
                var step = (end - start) / (i - j);
                for (var k = j; k < i; k++) {
                    stops[k].offset = +(+start + step * (k - j)).toFixed(2);
                }
                j = i;
                start = end;
            }
            len--;
            for (var i = 0; i < len; i++) if ("offset" in stops[i]) {
                seed(i, stops[i].offset);
            }
            stops[len].offset = stops[len].offset || 100;
            seed(len, stops[len].offset);
            for (i = 0; i <= len; i++) {
                var stop = stops[i];
                el.addStop(stop.color, stop.offset);
            }
            return el;
        }
        function gradientLinear(defs, x1, y1, x2, y2) {
            var el = Snap._.make("linearGradient", defs);
            el.stops = Gstops;
            el.addStop = GaddStop;
            el.getBBox = GgetBBox;
            if (x1 != null) {
                $(el.node, {
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2
                });
            }
            return el;
        }
        function gradientRadial(defs, cx, cy, r, fx, fy) {
            var el = Snap._.make("radialGradient", defs);
            el.stops = Gstops;
            el.addStop = GaddStop;
            el.getBBox = GgetBBox;
            if (cx != null) {
                $(el.node, {
                    cx: cx,
                    cy: cy,
                    r: r
                });
            }
            if (fx != null && fy != null) {
                $(el.node, {
                    fx: fx,
                    fy: fy
                });
            }
            return el;
        }
        /*\
         * Paper.gradient
         [ method ]
         **
         * Creates a gradient element
         **
         - gradient (string) gradient descriptor
         > Gradient Descriptor
         * The gradient descriptor is an expression formatted as
         * follows: `<type>(<coords>)<colors>`.  The `<type>` can be
         * either linear or radial.  The uppercase `L` or `R` letters
         * indicate absolute coordinates offset from the SVG surface.
         * Lowercase `l` or `r` letters indicate coordinates
         * calculated relative to the element to which the gradient is
         * applied.  Coordinates specify a linear gradient vector as
         * `x1`, `y1`, `x2`, `y2`, or a radial gradient as `cx`, `cy`,
         * `r` and optional `fx`, `fy` specifying a focal point away
         * from the center of the circle. Specify `<colors>` as a list
         * of dash-separated CSS color values.  Each color may be
         * followed by a custom offset value, separated with a colon
         * character.
         > Examples
         * Linear gradient, relative from top-left corner to bottom-right
         * corner, from black through red to white:
         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
         * Linear gradient, absolute from (0, 0) to (100, 100), from black
         * through red at 25% to white:
         | var g = paper.gradient("L(0, 0, 100, 100)#000-#f00:25-#fff");
         * Radial gradient, relative from the center of the element with radius
         * half the width, from black to white:
         | var g = paper.gradient("r(0.5, 0.5, 0.5)#000-#fff");
         * To apply the gradient:
         | paper.circle(50, 50, 40).attr({
         |     fill: g
         | });
         = (object) the `gradient` element
        \*/
        proto.gradient = function (str) {
            return gradient(this.defs, str);
        };
        proto.gradientLinear = function (x1, y1, x2, y2) {
            return gradientLinear(this.defs, x1, y1, x2, y2);
        };
        proto.gradientRadial = function (cx, cy, r, fx, fy) {
            return gradientRadial(this.defs, cx, cy, r, fx, fy);
        };
        /*\
         * Paper.toString
         [ method ]
         **
         * Returns SVG code for the @Paper
         = (string) SVG code for the @Paper
        \*/
        proto.toString = function () {
            var doc = this.node.ownerDocument,
                f = doc.createDocumentFragment(),
                d = doc.createElement("div"),
                svg = this.node.cloneNode(true),
                res;
            f.appendChild(d);
            d.appendChild(svg);
            Snap._.$(svg, {xmlns: "http://www.w3.org/2000/svg"});
            res = d.innerHTML;
            f.removeChild(f.firstChild);
            return res;
        };
        /*\
         * Paper.toDataURL
         [ method ]
         **
         * Returns SVG code for the @Paper as Data URI string.
         = (string) Data URI string
        \*/
        proto.toDataURL = function () {
            if (window && window.btoa) {
                return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(this)));
            }
        };
        /*\
         * Paper.clear
         [ method ]
         **
         * Removes all child nodes of the paper, except <defs>.
        \*/
        proto.clear = function () {
            var node = this.node.firstChild,
                next;
            while (node) {
                next = node.nextSibling;
                if (node.tagName != "defs") {
                    node.parentNode.removeChild(node);
                } else {
                    proto.clear.call({node: node});
                }
                node = next;
            }
        };
    }());
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var elproto = Element.prototype,
        is = Snap.is,
        clone = Snap._.clone,
        has = "hasOwnProperty",
        p2s = /,?([a-z]),?/gi,
        toFloat = parseFloat,
        math = Math,
        PI = math.PI,
        mmin = math.min,
        mmax = math.max,
        pow = math.pow,
        abs = math.abs;
    function paths(ps) {
        var p = paths.ps = paths.ps || {};
        if (p[ps]) {
            p[ps].sleep = 100;
        } else {
            p[ps] = {
                sleep: 100
            };
        }
        setTimeout(function () {
            for (var key in p) if (p[has](key) && key != ps) {
                p[key].sleep--;
                !p[key].sleep && delete p[key];
            }
        });
        return p[ps];
    }
    function box(x, y, width, height) {
        if (x == null) {
            x = y = width = height = 0;
        }
        if (y == null) {
            y = x.y;
            width = x.width;
            height = x.height;
            x = x.x;
        }
        return {
            x: x,
            y: y,
            width: width,
            w: width,
            height: height,
            h: height,
            x2: x + width,
            y2: y + height,
            cx: x + width / 2,
            cy: y + height / 2,
            r1: math.min(width, height) / 2,
            r2: math.max(width, height) / 2,
            r0: math.sqrt(width * width + height * height) / 2,
            path: rectPath(x, y, width, height),
            vb: [x, y, width, height].join(" ")
        };
    }
    function toString() {
        return this.join(",").replace(p2s, "$1");
    }
    function pathClone(pathArray) {
        var res = clone(pathArray);
        res.toString = toString;
        return res;
    }
    function getPointAtSegmentLength(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length) {
        if (length == null) {
            return bezlen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y);
        } else {
            return findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y,
                getTotLen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length));
        }
    }
    function getLengthFactory(istotal, subpath) {
        function O(val) {
            return +(+val).toFixed(3);
        }
        return Snap._.cacher(function (path, length, onlystart) {
            if (path instanceof Element) {
                path = path.attr("d");
            }
            path = path2curve(path);
            var x, y, p, l, sp = "", subpaths = {}, point,
                len = 0;
            for (var i = 0, ii = path.length; i < ii; i++) {
                p = path[i];
                if (p[0] == "M") {
                    x = +p[1];
                    y = +p[2];
                } else {
                    l = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
                    if (len + l > length) {
                        if (subpath && !subpaths.start) {
                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
                            sp += [
                                "C" + O(point.start.x),
                                O(point.start.y),
                                O(point.m.x),
                                O(point.m.y),
                                O(point.x),
                                O(point.y)
                            ];
                            if (onlystart) {return sp;}
                            subpaths.start = sp;
                            sp = [
                                "M" + O(point.x),
                                O(point.y) + "C" + O(point.n.x),
                                O(point.n.y),
                                O(point.end.x),
                                O(point.end.y),
                                O(p[5]),
                                O(p[6])
                            ].join();
                            len += l;
                            x = +p[5];
                            y = +p[6];
                            continue;
                        }
                        if (!istotal && !subpath) {
                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
                            return point;
                        }
                    }
                    len += l;
                    x = +p[5];
                    y = +p[6];
                }
                sp += p.shift() + p;
            }
            subpaths.end = sp;
            point = istotal ? len : subpath ? subpaths : findDotsAtSegment(x, y, p[0], p[1], p[2], p[3], p[4], p[5], 1);
            return point;
        }, null, Snap._.clone);
    }
    var getTotalLength = getLengthFactory(1),
        getPointAtLength = getLengthFactory(),
        getSubpathsAtLength = getLengthFactory(0, 1);
    function findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
        var t1 = 1 - t,
            t13 = pow(t1, 3),
            t12 = pow(t1, 2),
            t2 = t * t,
            t3 = t2 * t,
            x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x + t3 * p2x,
            y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y + t3 * p2y,
            mx = p1x + 2 * t * (c1x - p1x) + t2 * (c2x - 2 * c1x + p1x),
            my = p1y + 2 * t * (c1y - p1y) + t2 * (c2y - 2 * c1y + p1y),
            nx = c1x + 2 * t * (c2x - c1x) + t2 * (p2x - 2 * c2x + c1x),
            ny = c1y + 2 * t * (c2y - c1y) + t2 * (p2y - 2 * c2y + c1y),
            ax = t1 * p1x + t * c1x,
            ay = t1 * p1y + t * c1y,
            cx = t1 * c2x + t * p2x,
            cy = t1 * c2y + t * p2y,
            alpha = (90 - math.atan2(mx - nx, my - ny) * 180 / PI);
        // (mx > nx || my < ny) && (alpha += 180);
        return {
            x: x,
            y: y,
            m: {x: mx, y: my},
            n: {x: nx, y: ny},
            start: {x: ax, y: ay},
            end: {x: cx, y: cy},
            alpha: alpha
        };
    }
    function bezierBBox(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
        if (!Snap.is(p1x, "array")) {
            p1x = [p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y];
        }
        var bbox = curveDim.apply(null, p1x);
        return box(
            bbox.min.x,
            bbox.min.y,
            bbox.max.x - bbox.min.x,
            bbox.max.y - bbox.min.y
        );
    }
    function isPointInsideBBox(bbox, x, y) {
        return  x >= bbox.x &&
                x <= bbox.x + bbox.width &&
                y >= bbox.y &&
                y <= bbox.y + bbox.height;
    }
    function isBBoxIntersect(bbox1, bbox2) {
        bbox1 = box(bbox1);
        bbox2 = box(bbox2);
        return isPointInsideBBox(bbox2, bbox1.x, bbox1.y)
            || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y)
            || isPointInsideBBox(bbox2, bbox1.x, bbox1.y2)
            || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y2)
            || isPointInsideBBox(bbox1, bbox2.x, bbox2.y)
            || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y)
            || isPointInsideBBox(bbox1, bbox2.x, bbox2.y2)
            || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y2)
            || (bbox1.x < bbox2.x2 && bbox1.x > bbox2.x
                || bbox2.x < bbox1.x2 && bbox2.x > bbox1.x)
            && (bbox1.y < bbox2.y2 && bbox1.y > bbox2.y
                || bbox2.y < bbox1.y2 && bbox2.y > bbox1.y);
    }
    function base3(t, p1, p2, p3, p4) {
        var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4,
            t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
        return t * t2 - 3 * p1 + 3 * p2;
    }
    function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
        if (z == null) {
            z = 1;
        }
        z = z > 1 ? 1 : z < 0 ? 0 : z;
        var z2 = z / 2,
            n = 12,
            Tvalues = [-.1252,.1252,-.3678,.3678,-.5873,.5873,-.7699,.7699,-.9041,.9041,-.9816,.9816],
            Cvalues = [0.2491,0.2491,0.2335,0.2335,0.2032,0.2032,0.1601,0.1601,0.1069,0.1069,0.0472,0.0472],
            sum = 0;
        for (var i = 0; i < n; i++) {
            var ct = z2 * Tvalues[i] + z2,
                xbase = base3(ct, x1, x2, x3, x4),
                ybase = base3(ct, y1, y2, y3, y4),
                comb = xbase * xbase + ybase * ybase;
            sum += Cvalues[i] * math.sqrt(comb);
        }
        return z2 * sum;
    }
    function getTotLen(x1, y1, x2, y2, x3, y3, x4, y4, ll) {
        if (ll < 0 || bezlen(x1, y1, x2, y2, x3, y3, x4, y4) < ll) {
            return;
        }
        var t = 1,
            step = t / 2,
            t2 = t - step,
            l,
            e = .01;
        l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
        while (abs(l - ll) > e) {
            step /= 2;
            t2 += (l < ll ? 1 : -1) * step;
            l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
        }
        return t2;
    }
    function intersect(x1, y1, x2, y2, x3, y3, x4, y4) {
        if (
            mmax(x1, x2) < mmin(x3, x4) ||
            mmin(x1, x2) > mmax(x3, x4) ||
            mmax(y1, y2) < mmin(y3, y4) ||
            mmin(y1, y2) > mmax(y3, y4)
        ) {
            return;
        }
        var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4),
            ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4),
            denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);

        if (!denominator) {
            return;
        }
        var px = nx / denominator,
            py = ny / denominator,
            px2 = +px.toFixed(2),
            py2 = +py.toFixed(2);
        if (
            px2 < +mmin(x1, x2).toFixed(2) ||
            px2 > +mmax(x1, x2).toFixed(2) ||
            px2 < +mmin(x3, x4).toFixed(2) ||
            px2 > +mmax(x3, x4).toFixed(2) ||
            py2 < +mmin(y1, y2).toFixed(2) ||
            py2 > +mmax(y1, y2).toFixed(2) ||
            py2 < +mmin(y3, y4).toFixed(2) ||
            py2 > +mmax(y3, y4).toFixed(2)
        ) {
            return;
        }
        return {x: px, y: py};
    }
    function inter(bez1, bez2) {
        return interHelper(bez1, bez2);
    }
    function interCount(bez1, bez2) {
        return interHelper(bez1, bez2, 1);
    }
    function interHelper(bez1, bez2, justCount) {
        var bbox1 = bezierBBox(bez1),
            bbox2 = bezierBBox(bez2);
        if (!isBBoxIntersect(bbox1, bbox2)) {
            return justCount ? 0 : [];
        }
        var l1 = bezlen.apply(0, bez1),
            l2 = bezlen.apply(0, bez2),
            n1 = ~~(l1 / 8),
            n2 = ~~(l2 / 8),
            dots1 = [],
            dots2 = [],
            xy = {},
            res = justCount ? 0 : [];
        for (var i = 0; i < n1 + 1; i++) {
            var p = findDotsAtSegment.apply(0, bez1.concat(i / n1));
            dots1.push({x: p.x, y: p.y, t: i / n1});
        }
        for (i = 0; i < n2 + 1; i++) {
            p = findDotsAtSegment.apply(0, bez2.concat(i / n2));
            dots2.push({x: p.x, y: p.y, t: i / n2});
        }
        for (i = 0; i < n1; i++) {
            for (var j = 0; j < n2; j++) {
                var di = dots1[i],
                    di1 = dots1[i + 1],
                    dj = dots2[j],
                    dj1 = dots2[j + 1],
                    ci = abs(di1.x - di.x) < .001 ? "y" : "x",
                    cj = abs(dj1.x - dj.x) < .001 ? "y" : "x",
                    is = intersect(di.x, di.y, di1.x, di1.y, dj.x, dj.y, dj1.x, dj1.y);
                if (is) {
                    if (xy[is.x.toFixed(4)] == is.y.toFixed(4)) {
                        continue;
                    }
                    xy[is.x.toFixed(4)] = is.y.toFixed(4);
                    var t1 = di.t + abs((is[ci] - di[ci]) / (di1[ci] - di[ci])) * (di1.t - di.t),
                        t2 = dj.t + abs((is[cj] - dj[cj]) / (dj1[cj] - dj[cj])) * (dj1.t - dj.t);
                    if (t1 >= 0 && t1 <= 1 && t2 >= 0 && t2 <= 1) {
                        if (justCount) {
                            res++;
                        } else {
                            res.push({
                                x: is.x,
                                y: is.y,
                                t1: t1,
                                t2: t2
                            });
                        }
                    }
                }
            }
        }
        return res;
    }
    function pathIntersection(path1, path2) {
        return interPathHelper(path1, path2);
    }
    function pathIntersectionNumber(path1, path2) {
        return interPathHelper(path1, path2, 1);
    }
    function interPathHelper(path1, path2, justCount) {
        path1 = path2curve(path1);
        path2 = path2curve(path2);
        var x1, y1, x2, y2, x1m, y1m, x2m, y2m, bez1, bez2,
            res = justCount ? 0 : [];
        for (var i = 0, ii = path1.length; i < ii; i++) {
            var pi = path1[i];
            if (pi[0] == "M") {
                x1 = x1m = pi[1];
                y1 = y1m = pi[2];
            } else {
                if (pi[0] == "C") {
                    bez1 = [x1, y1].concat(pi.slice(1));
                    x1 = bez1[6];
                    y1 = bez1[7];
                } else {
                    bez1 = [x1, y1, x1, y1, x1m, y1m, x1m, y1m];
                    x1 = x1m;
                    y1 = y1m;
                }
                for (var j = 0, jj = path2.length; j < jj; j++) {
                    var pj = path2[j];
                    if (pj[0] == "M") {
                        x2 = x2m = pj[1];
                        y2 = y2m = pj[2];
                    } else {
                        if (pj[0] == "C") {
                            bez2 = [x2, y2].concat(pj.slice(1));
                            x2 = bez2[6];
                            y2 = bez2[7];
                        } else {
                            bez2 = [x2, y2, x2, y2, x2m, y2m, x2m, y2m];
                            x2 = x2m;
                            y2 = y2m;
                        }
                        var intr = interHelper(bez1, bez2, justCount);
                        if (justCount) {
                            res += intr;
                        } else {
                            for (var k = 0, kk = intr.length; k < kk; k++) {
                                intr[k].segment1 = i;
                                intr[k].segment2 = j;
                                intr[k].bez1 = bez1;
                                intr[k].bez2 = bez2;
                            }
                            res = res.concat(intr);
                        }
                    }
                }
            }
        }
        return res;
    }
    function isPointInsidePath(path, x, y) {
        var bbox = pathBBox(path);
        return isPointInsideBBox(bbox, x, y) &&
               interPathHelper(path, [["M", x, y], ["H", bbox.x2 + 10]], 1) % 2 == 1;
    }
    function pathBBox(path) {
        var pth = paths(path);
        if (pth.bbox) {
            return clone(pth.bbox);
        }
        if (!path) {
            return box();
        }
        path = path2curve(path);
        var x = 0,
            y = 0,
            X = [],
            Y = [],
            p;
        for (var i = 0, ii = path.length; i < ii; i++) {
            p = path[i];
            if (p[0] == "M") {
                x = p[1];
                y = p[2];
                X.push(x);
                Y.push(y);
            } else {
                var dim = curveDim(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
                X = X.concat(dim.min.x, dim.max.x);
                Y = Y.concat(dim.min.y, dim.max.y);
                x = p[5];
                y = p[6];
            }
        }
        var xmin = mmin.apply(0, X),
            ymin = mmin.apply(0, Y),
            xmax = mmax.apply(0, X),
            ymax = mmax.apply(0, Y),
            bb = box(xmin, ymin, xmax - xmin, ymax - ymin);
        pth.bbox = clone(bb);
        return bb;
    }
    function rectPath(x, y, w, h, r) {
        if (r) {
            return [
                ["M", +x + (+r), y],
                ["l", w - r * 2, 0],
                ["a", r, r, 0, 0, 1, r, r],
                ["l", 0, h - r * 2],
                ["a", r, r, 0, 0, 1, -r, r],
                ["l", r * 2 - w, 0],
                ["a", r, r, 0, 0, 1, -r, -r],
                ["l", 0, r * 2 - h],
                ["a", r, r, 0, 0, 1, r, -r],
                ["z"]
            ];
        }
        var res = [["M", x, y], ["l", w, 0], ["l", 0, h], ["l", -w, 0], ["z"]];
        res.toString = toString;
        return res;
    }
    function ellipsePath(x, y, rx, ry, a) {
        if (a == null && ry == null) {
            ry = rx;
        }
        x = +x;
        y = +y;
        rx = +rx;
        ry = +ry;
        if (a != null) {
            var rad = Math.PI / 180,
                x1 = x + rx * Math.cos(-ry * rad),
                x2 = x + rx * Math.cos(-a * rad),
                y1 = y + rx * Math.sin(-ry * rad),
                y2 = y + rx * Math.sin(-a * rad),
                res = [["M", x1, y1], ["A", rx, rx, 0, +(a - ry > 180), 0, x2, y2]];
        } else {
            res = [
                ["M", x, y],
                ["m", 0, -ry],
                ["a", rx, ry, 0, 1, 1, 0, 2 * ry],
                ["a", rx, ry, 0, 1, 1, 0, -2 * ry],
                ["z"]
            ];
        }
        res.toString = toString;
        return res;
    }
    var unit2px = Snap._unit2px,
        getPath = {
        path: function (el) {
            return el.attr("path");
        },
        circle: function (el) {
            var attr = unit2px(el);
            return ellipsePath(attr.cx, attr.cy, attr.r);
        },
        ellipse: function (el) {
            var attr = unit2px(el);
            return ellipsePath(attr.cx || 0, attr.cy || 0, attr.rx, attr.ry);
        },
        rect: function (el) {
            var attr = unit2px(el);
            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height, attr.rx, attr.ry);
        },
        image: function (el) {
            var attr = unit2px(el);
            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height);
        },
        line: function (el) {
            return "M" + [el.attr("x1") || 0, el.attr("y1") || 0, el.attr("x2"), el.attr("y2")];
        },
        polyline: function (el) {
            return "M" + el.attr("points");
        },
        polygon: function (el) {
            return "M" + el.attr("points") + "z";
        },
        deflt: function (el) {
            var bbox = el.node.getBBox();
            return rectPath(bbox.x, bbox.y, bbox.width, bbox.height);
        }
    };
    function pathToRelative(pathArray) {
        var pth = paths(pathArray),
            lowerCase = String.prototype.toLowerCase;
        if (pth.rel) {
            return pathClone(pth.rel);
        }
        if (!Snap.is(pathArray, "array") || !Snap.is(pathArray && pathArray[0], "array")) {
            pathArray = Snap.parsePathString(pathArray);
        }
        var res = [],
            x = 0,
            y = 0,
            mx = 0,
            my = 0,
            start = 0;
        if (pathArray[0][0] == "M") {
            x = pathArray[0][1];
            y = pathArray[0][2];
            mx = x;
            my = y;
            start++;
            res.push(["M", x, y]);
        }
        for (var i = start, ii = pathArray.length; i < ii; i++) {
            var r = res[i] = [],
                pa = pathArray[i];
            if (pa[0] != lowerCase.call(pa[0])) {
                r[0] = lowerCase.call(pa[0]);
                switch (r[0]) {
                    case "a":
                        r[1] = pa[1];
                        r[2] = pa[2];
                        r[3] = pa[3];
                        r[4] = pa[4];
                        r[5] = pa[5];
                        r[6] = +(pa[6] - x).toFixed(3);
                        r[7] = +(pa[7] - y).toFixed(3);
                        break;
                    case "v":
                        r[1] = +(pa[1] - y).toFixed(3);
                        break;
                    case "m":
                        mx = pa[1];
                        my = pa[2];
                    default:
                        for (var j = 1, jj = pa.length; j < jj; j++) {
                            r[j] = +(pa[j] - ((j % 2) ? x : y)).toFixed(3);
                        }
                }
            } else {
                r = res[i] = [];
                if (pa[0] == "m") {
                    mx = pa[1] + x;
                    my = pa[2] + y;
                }
                for (var k = 0, kk = pa.length; k < kk; k++) {
                    res[i][k] = pa[k];
                }
            }
            var len = res[i].length;
            switch (res[i][0]) {
                case "z":
                    x = mx;
                    y = my;
                    break;
                case "h":
                    x += +res[i][len - 1];
                    break;
                case "v":
                    y += +res[i][len - 1];
                    break;
                default:
                    x += +res[i][len - 2];
                    y += +res[i][len - 1];
            }
        }
        res.toString = toString;
        pth.rel = pathClone(res);
        return res;
    }
    function pathToAbsolute(pathArray) {
        var pth = paths(pathArray);
        if (pth.abs) {
            return pathClone(pth.abs);
        }
        if (!is(pathArray, "array") || !is(pathArray && pathArray[0], "array")) { // rough assumption
            pathArray = Snap.parsePathString(pathArray);
        }
        if (!pathArray || !pathArray.length) {
            return [["M", 0, 0]];
        }
        var res = [],
            x = 0,
            y = 0,
            mx = 0,
            my = 0,
            start = 0,
            pa0;
        if (pathArray[0][0] == "M") {
            x = +pathArray[0][1];
            y = +pathArray[0][2];
            mx = x;
            my = y;
            start++;
            res[0] = ["M", x, y];
        }
        var crz = pathArray.length == 3 &&
            pathArray[0][0] == "M" &&
            pathArray[1][0].toUpperCase() == "R" &&
            pathArray[2][0].toUpperCase() == "Z";
        for (var r, pa, i = start, ii = pathArray.length; i < ii; i++) {
            res.push(r = []);
            pa = pathArray[i];
            pa0 = pa[0];
            if (pa0 != pa0.toUpperCase()) {
                r[0] = pa0.toUpperCase();
                switch (r[0]) {
                    case "A":
                        r[1] = pa[1];
                        r[2] = pa[2];
                        r[3] = pa[3];
                        r[4] = pa[4];
                        r[5] = pa[5];
                        r[6] = +pa[6] + x;
                        r[7] = +pa[7] + y;
                        break;
                    case "V":
                        r[1] = +pa[1] + y;
                        break;
                    case "H":
                        r[1] = +pa[1] + x;
                        break;
                    case "R":
                        var dots = [x, y].concat(pa.slice(1));
                        for (var j = 2, jj = dots.length; j < jj; j++) {
                            dots[j] = +dots[j] + x;
                            dots[++j] = +dots[j] + y;
                        }
                        res.pop();
                        res = res.concat(catmullRom2bezier(dots, crz));
                        break;
                    case "O":
                        res.pop();
                        dots = ellipsePath(x, y, pa[1], pa[2]);
                        dots.push(dots[0]);
                        res = res.concat(dots);
                        break;
                    case "U":
                        res.pop();
                        res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
                        r = ["U"].concat(res[res.length - 1].slice(-2));
                        break;
                    case "M":
                        mx = +pa[1] + x;
                        my = +pa[2] + y;
                    default:
                        for (j = 1, jj = pa.length; j < jj; j++) {
                            r[j] = +pa[j] + ((j % 2) ? x : y);
                        }
                }
            } else if (pa0 == "R") {
                dots = [x, y].concat(pa.slice(1));
                res.pop();
                res = res.concat(catmullRom2bezier(dots, crz));
                r = ["R"].concat(pa.slice(-2));
            } else if (pa0 == "O") {
                res.pop();
                dots = ellipsePath(x, y, pa[1], pa[2]);
                dots.push(dots[0]);
                res = res.concat(dots);
            } else if (pa0 == "U") {
                res.pop();
                res = res.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
                r = ["U"].concat(res[res.length - 1].slice(-2));
            } else {
                for (var k = 0, kk = pa.length; k < kk; k++) {
                    r[k] = pa[k];
                }
            }
            pa0 = pa0.toUpperCase();
            if (pa0 != "O") {
                switch (r[0]) {
                    case "Z":
                        x = +mx;
                        y = +my;
                        break;
                    case "H":
                        x = r[1];
                        break;
                    case "V":
                        y = r[1];
                        break;
                    case "M":
                        mx = r[r.length - 2];
                        my = r[r.length - 1];
                    default:
                        x = r[r.length - 2];
                        y = r[r.length - 1];
                }
            }
        }
        res.toString = toString;
        pth.abs = pathClone(res);
        return res;
    }
    function l2c(x1, y1, x2, y2) {
        return [x1, y1, x2, y2, x2, y2];
    }
    function q2c(x1, y1, ax, ay, x2, y2) {
        var _13 = 1 / 3,
            _23 = 2 / 3;
        return [
                _13 * x1 + _23 * ax,
                _13 * y1 + _23 * ay,
                _13 * x2 + _23 * ax,
                _13 * y2 + _23 * ay,
                x2,
                y2
            ];
    }
    function a2c(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
        // for more information of where this math came from visit:
        // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
        var _120 = PI * 120 / 180,
            rad = PI / 180 * (+angle || 0),
            res = [],
            xy,
            rotate = Snap._.cacher(function (x, y, rad) {
                var X = x * math.cos(rad) - y * math.sin(rad),
                    Y = x * math.sin(rad) + y * math.cos(rad);
                return {x: X, y: Y};
            });
        if (!recursive) {
            xy = rotate(x1, y1, -rad);
            x1 = xy.x;
            y1 = xy.y;
            xy = rotate(x2, y2, -rad);
            x2 = xy.x;
            y2 = xy.y;
            var cos = math.cos(PI / 180 * angle),
                sin = math.sin(PI / 180 * angle),
                x = (x1 - x2) / 2,
                y = (y1 - y2) / 2;
            var h = (x * x) / (rx * rx) + (y * y) / (ry * ry);
            if (h > 1) {
                h = math.sqrt(h);
                rx = h * rx;
                ry = h * ry;
            }
            var rx2 = rx * rx,
                ry2 = ry * ry,
                k = (large_arc_flag == sweep_flag ? -1 : 1) *
                    math.sqrt(abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x))),
                cx = k * rx * y / ry + (x1 + x2) / 2,
                cy = k * -ry * x / rx + (y1 + y2) / 2,
                f1 = math.asin(((y1 - cy) / ry).toFixed(9)),
                f2 = math.asin(((y2 - cy) / ry).toFixed(9));

            f1 = x1 < cx ? PI - f1 : f1;
            f2 = x2 < cx ? PI - f2 : f2;
            f1 < 0 && (f1 = PI * 2 + f1);
            f2 < 0 && (f2 = PI * 2 + f2);
            if (sweep_flag && f1 > f2) {
                f1 = f1 - PI * 2;
            }
            if (!sweep_flag && f2 > f1) {
                f2 = f2 - PI * 2;
            }
        } else {
            f1 = recursive[0];
            f2 = recursive[1];
            cx = recursive[2];
            cy = recursive[3];
        }
        var df = f2 - f1;
        if (abs(df) > _120) {
            var f2old = f2,
                x2old = x2,
                y2old = y2;
            f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
            x2 = cx + rx * math.cos(f2);
            y2 = cy + ry * math.sin(f2);
            res = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy]);
        }
        df = f2 - f1;
        var c1 = math.cos(f1),
            s1 = math.sin(f1),
            c2 = math.cos(f2),
            s2 = math.sin(f2),
            t = math.tan(df / 4),
            hx = 4 / 3 * rx * t,
            hy = 4 / 3 * ry * t,
            m1 = [x1, y1],
            m2 = [x1 + hx * s1, y1 - hy * c1],
            m3 = [x2 + hx * s2, y2 - hy * c2],
            m4 = [x2, y2];
        m2[0] = 2 * m1[0] - m2[0];
        m2[1] = 2 * m1[1] - m2[1];
        if (recursive) {
            return [m2, m3, m4].concat(res);
        } else {
            res = [m2, m3, m4].concat(res).join().split(",");
            var newres = [];
            for (var i = 0, ii = res.length; i < ii; i++) {
                newres[i] = i % 2 ? rotate(res[i - 1], res[i], rad).y : rotate(res[i], res[i + 1], rad).x;
            }
            return newres;
        }
    }
    function findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
        var t1 = 1 - t;
        return {
            x: pow(t1, 3) * p1x + pow(t1, 2) * 3 * t * c1x + t1 * 3 * t * t * c2x + pow(t, 3) * p2x,
            y: pow(t1, 3) * p1y + pow(t1, 2) * 3 * t * c1y + t1 * 3 * t * t * c2y + pow(t, 3) * p2y
        };
    }

    // Returns bounding box of cubic bezier curve.
    // Source: http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
    // Original version: NISHIO Hirokazu
    // Modifications: https://github.com/timo22345
    function curveDim(x0, y0, x1, y1, x2, y2, x3, y3) {
        var tvalues = [],
            bounds = [[], []],
            a, b, c, t, t1, t2, b2ac, sqrtb2ac;
        for (var i = 0; i < 2; ++i) {
            if (i == 0) {
                b = 6 * x0 - 12 * x1 + 6 * x2;
                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                c = 3 * x1 - 3 * x0;
            } else {
                b = 6 * y0 - 12 * y1 + 6 * y2;
                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                c = 3 * y1 - 3 * y0;
            }
            if (abs(a) < 1e-12) {
                if (abs(b) < 1e-12) {
                    continue;
                }
                t = -c / b;
                if (0 < t && t < 1) {
                    tvalues.push(t);
                }
                continue;
            }
            b2ac = b * b - 4 * c * a;
            sqrtb2ac = math.sqrt(b2ac);
            if (b2ac < 0) {
                continue;
            }
            t1 = (-b + sqrtb2ac) / (2 * a);
            if (0 < t1 && t1 < 1) {
                tvalues.push(t1);
            }
            t2 = (-b - sqrtb2ac) / (2 * a);
            if (0 < t2 && t2 < 1) {
                tvalues.push(t2);
            }
        }

        var x, y, j = tvalues.length,
            jlen = j,
            mt;
        while (j--) {
            t = tvalues[j];
            mt = 1 - t;
            bounds[0][j] = (mt * mt * mt * x0) + (3 * mt * mt * t * x1) + (3 * mt * t * t * x2) + (t * t * t * x3);
            bounds[1][j] = (mt * mt * mt * y0) + (3 * mt * mt * t * y1) + (3 * mt * t * t * y2) + (t * t * t * y3);
        }

        bounds[0][jlen] = x0;
        bounds[1][jlen] = y0;
        bounds[0][jlen + 1] = x3;
        bounds[1][jlen + 1] = y3;
        bounds[0].length = bounds[1].length = jlen + 2;


        return {
          min: {x: mmin.apply(0, bounds[0]), y: mmin.apply(0, bounds[1])},
          max: {x: mmax.apply(0, bounds[0]), y: mmax.apply(0, bounds[1])}
        };
    }

    function path2curve(path, path2) {
        var pth = !path2 && paths(path);
        if (!path2 && pth.curve) {
            return pathClone(pth.curve);
        }
        var p = pathToAbsolute(path),
            p2 = path2 && pathToAbsolute(path2),
            attrs = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
            attrs2 = {x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null},
            processPath = function (path, d, pcom) {
                var nx, ny;
                if (!path) {
                    return ["C", d.x, d.y, d.x, d.y, d.x, d.y];
                }
                !(path[0] in {T: 1, Q: 1}) && (d.qx = d.qy = null);
                switch (path[0]) {
                    case "M":
                        d.X = path[1];
                        d.Y = path[2];
                        break;
                    case "A":
                        path = ["C"].concat(a2c.apply(0, [d.x, d.y].concat(path.slice(1))));
                        break;
                    case "S":
                        if (pcom == "C" || pcom == "S") { // In "S" case we have to take into account, if the previous command is C/S.
                            nx = d.x * 2 - d.bx;          // And reflect the previous
                            ny = d.y * 2 - d.by;          // command's control point relative to the current point.
                        }
                        else {                            // or some else or nothing
                            nx = d.x;
                            ny = d.y;
                        }
                        path = ["C", nx, ny].concat(path.slice(1));
                        break;
                    case "T":
                        if (pcom == "Q" || pcom == "T") { // In "T" case we have to take into account, if the previous command is Q/T.
                            d.qx = d.x * 2 - d.qx;        // And make a reflection similar
                            d.qy = d.y * 2 - d.qy;        // to case "S".
                        }
                        else {                            // or something else or nothing
                            d.qx = d.x;
                            d.qy = d.y;
                        }
                        path = ["C"].concat(q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
                        break;
                    case "Q":
                        d.qx = path[1];
                        d.qy = path[2];
                        path = ["C"].concat(q2c(d.x, d.y, path[1], path[2], path[3], path[4]));
                        break;
                    case "L":
                        path = ["C"].concat(l2c(d.x, d.y, path[1], path[2]));
                        break;
                    case "H":
                        path = ["C"].concat(l2c(d.x, d.y, path[1], d.y));
                        break;
                    case "V":
                        path = ["C"].concat(l2c(d.x, d.y, d.x, path[1]));
                        break;
                    case "Z":
                        path = ["C"].concat(l2c(d.x, d.y, d.X, d.Y));
                        break;
                }
                return path;
            },
            fixArc = function (pp, i) {
                if (pp[i].length > 7) {
                    pp[i].shift();
                    var pi = pp[i];
                    while (pi.length) {
                        pcoms1[i] = "A"; // if created multiple C:s, their original seg is saved
                        p2 && (pcoms2[i] = "A"); // the same as above
                        pp.splice(i++, 0, ["C"].concat(pi.splice(0, 6)));
                    }
                    pp.splice(i, 1);
                    ii = mmax(p.length, p2 && p2.length || 0);
                }
            },
            fixM = function (path1, path2, a1, a2, i) {
                if (path1 && path2 && path1[i][0] == "M" && path2[i][0] != "M") {
                    path2.splice(i, 0, ["M", a2.x, a2.y]);
                    a1.bx = 0;
                    a1.by = 0;
                    a1.x = path1[i][1];
                    a1.y = path1[i][2];
                    ii = mmax(p.length, p2 && p2.length || 0);
                }
            },
            pcoms1 = [], // path commands of original path p
            pcoms2 = [], // path commands of original path p2
            pfirst = "", // temporary holder for original path command
            pcom = ""; // holder for previous path command of original path
        for (var i = 0, ii = mmax(p.length, p2 && p2.length || 0); i < ii; i++) {
            p[i] && (pfirst = p[i][0]); // save current path command

            if (pfirst != "C") // C is not saved yet, because it may be result of conversion
            {
                pcoms1[i] = pfirst; // Save current path command
                i && ( pcom = pcoms1[i - 1]); // Get previous path command pcom
            }
            p[i] = processPath(p[i], attrs, pcom); // Previous path command is inputted to processPath

            if (pcoms1[i] != "A" && pfirst == "C") pcoms1[i] = "C"; // A is the only command
            // which may produce multiple C:s
            // so we have to make sure that C is also C in original path

            fixArc(p, i); // fixArc adds also the right amount of A:s to pcoms1

            if (p2) { // the same procedures is done to p2
                p2[i] && (pfirst = p2[i][0]);
                if (pfirst != "C") {
                    pcoms2[i] = pfirst;
                    i && (pcom = pcoms2[i - 1]);
                }
                p2[i] = processPath(p2[i], attrs2, pcom);

                if (pcoms2[i] != "A" && pfirst == "C") {
                    pcoms2[i] = "C";
                }

                fixArc(p2, i);
            }
            fixM(p, p2, attrs, attrs2, i);
            fixM(p2, p, attrs2, attrs, i);
            var seg = p[i],
                seg2 = p2 && p2[i],
                seglen = seg.length,
                seg2len = p2 && seg2.length;
            attrs.x = seg[seglen - 2];
            attrs.y = seg[seglen - 1];
            attrs.bx = toFloat(seg[seglen - 4]) || attrs.x;
            attrs.by = toFloat(seg[seglen - 3]) || attrs.y;
            attrs2.bx = p2 && (toFloat(seg2[seg2len - 4]) || attrs2.x);
            attrs2.by = p2 && (toFloat(seg2[seg2len - 3]) || attrs2.y);
            attrs2.x = p2 && seg2[seg2len - 2];
            attrs2.y = p2 && seg2[seg2len - 1];
        }
        if (!p2) {
            pth.curve = pathClone(p);
        }
        return p2 ? [p, p2] : p;
    }
    function mapPath(path, matrix) {
        if (!matrix) {
            return path;
        }
        var x, y, i, j, ii, jj, pathi;
        path = path2curve(path);
        for (i = 0, ii = path.length; i < ii; i++) {
            pathi = path[i];
            for (j = 1, jj = pathi.length; j < jj; j += 2) {
                x = matrix.x(pathi[j], pathi[j + 1]);
                y = matrix.y(pathi[j], pathi[j + 1]);
                pathi[j] = x;
                pathi[j + 1] = y;
            }
        }
        return path;
    }

    // http://schepers.cc/getting-to-the-point
    function catmullRom2bezier(crp, z) {
        var d = [];
        for (var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2) {
            var p = [
                        {x: +crp[i - 2], y: +crp[i - 1]},
                        {x: +crp[i],     y: +crp[i + 1]},
                        {x: +crp[i + 2], y: +crp[i + 3]},
                        {x: +crp[i + 4], y: +crp[i + 5]}
                    ];
            if (z) {
                if (!i) {
                    p[0] = {x: +crp[iLen - 2], y: +crp[iLen - 1]};
                } else if (iLen - 4 == i) {
                    p[3] = {x: +crp[0], y: +crp[1]};
                } else if (iLen - 2 == i) {
                    p[2] = {x: +crp[0], y: +crp[1]};
                    p[3] = {x: +crp[2], y: +crp[3]};
                }
            } else {
                if (iLen - 4 == i) {
                    p[3] = p[2];
                } else if (!i) {
                    p[0] = {x: +crp[i], y: +crp[i + 1]};
                }
            }
            d.push(["C",
                  (-p[0].x + 6 * p[1].x + p[2].x) / 6,
                  (-p[0].y + 6 * p[1].y + p[2].y) / 6,
                  (p[1].x + 6 * p[2].x - p[3].x) / 6,
                  (p[1].y + 6*p[2].y - p[3].y) / 6,
                  p[2].x,
                  p[2].y
            ]);
        }

        return d;
    }

    // export
    Snap.path = paths;

    /*\
     * Snap.path.getTotalLength
     [ method ]
     **
     * Returns the length of the given path in pixels
     **
     - path (string) SVG path string
     **
     = (number) length
    \*/
    Snap.path.getTotalLength = getTotalLength;
    /*\
     * Snap.path.getPointAtLength
     [ method ]
     **
     * Returns the coordinates of the point located at the given length along the given path
     **
     - path (string) SVG path string
     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
     **
     = (object) representation of the point:
     o {
     o     x: (number) x coordinate,
     o     y: (number) y coordinate,
     o     alpha: (number) angle of derivative
     o }
    \*/
    Snap.path.getPointAtLength = getPointAtLength;
    /*\
     * Snap.path.getSubpath
     [ method ]
     **
     * Returns the subpath of a given path between given start and end lengths
     **
     - path (string) SVG path string
     - from (number) length, in pixels, from the start of the path to the start of the segment
     - to (number) length, in pixels, from the start of the path to the end of the segment
     **
     = (string) path string definition for the segment
    \*/
    Snap.path.getSubpath = function (path, from, to) {
        if (this.getTotalLength(path) - to < 1e-6) {
            return getSubpathsAtLength(path, from).end;
        }
        var a = getSubpathsAtLength(path, to, 1);
        return from ? getSubpathsAtLength(a, from).end : a;
    };
    /*\
     * Element.getTotalLength
     [ method ]
     **
     * Returns the length of the path in pixels (only works for `path` elements)
     = (number) length
    \*/
    elproto.getTotalLength = function () {
        if (this.node.getTotalLength) {
            return this.node.getTotalLength();
        }
    };
    // SIERRA Element.getPointAtLength()/Element.getTotalLength(): If a <path> is broken into different segments, is the jump distance to the new coordinates set by the _M_ or _m_ commands calculated as part of the path's total length?
    /*\
     * Element.getPointAtLength
     [ method ]
     **
     * Returns coordinates of the point located at the given length on the given path (only works for `path` elements)
     **
     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
     **
     = (object) representation of the point:
     o {
     o     x: (number) x coordinate,
     o     y: (number) y coordinate,
     o     alpha: (number) angle of derivative
     o }
    \*/
    elproto.getPointAtLength = function (length) {
        return getPointAtLength(this.attr("d"), length);
    };
    // SIERRA Element.getSubpath(): Similar to the problem for Element.getPointAtLength(). Unclear how this would work for a segmented path. Overall, the concept of _subpath_ and what I'm calling a _segment_ (series of non-_M_ or _Z_ commands) is unclear.
    /*\
     * Element.getSubpath
     [ method ]
     **
     * Returns subpath of a given element from given start and end lengths (only works for `path` elements)
     **
     - from (number) length, in pixels, from the start of the path to the start of the segment
     - to (number) length, in pixels, from the start of the path to the end of the segment
     **
     = (string) path string definition for the segment
    \*/
    elproto.getSubpath = function (from, to) {
        return Snap.path.getSubpath(this.attr("d"), from, to);
    };
    Snap._.box = box;
    /*\
     * Snap.path.findDotsAtSegment
     [ method ]
     **
     * Utility method
     **
     * Finds dot coordinates on the given cubic beziér curve at the given t
     - p1x (number) x of the first point of the curve
     - p1y (number) y of the first point of the curve
     - c1x (number) x of the first anchor of the curve
     - c1y (number) y of the first anchor of the curve
     - c2x (number) x of the second anchor of the curve
     - c2y (number) y of the second anchor of the curve
     - p2x (number) x of the second point of the curve
     - p2y (number) y of the second point of the curve
     - t (number) position on the curve (0..1)
     = (object) point information in format:
     o {
     o     x: (number) x coordinate of the point,
     o     y: (number) y coordinate of the point,
     o     m: {
     o         x: (number) x coordinate of the left anchor,
     o         y: (number) y coordinate of the left anchor
     o     },
     o     n: {
     o         x: (number) x coordinate of the right anchor,
     o         y: (number) y coordinate of the right anchor
     o     },
     o     start: {
     o         x: (number) x coordinate of the start of the curve,
     o         y: (number) y coordinate of the start of the curve
     o     },
     o     end: {
     o         x: (number) x coordinate of the end of the curve,
     o         y: (number) y coordinate of the end of the curve
     o     },
     o     alpha: (number) angle of the curve derivative at the point
     o }
    \*/
    Snap.path.findDotsAtSegment = findDotsAtSegment;
    /*\
     * Snap.path.bezierBBox
     [ method ]
     **
     * Utility method
     **
     * Returns the bounding box of a given cubic beziér curve
     - p1x (number) x of the first point of the curve
     - p1y (number) y of the first point of the curve
     - c1x (number) x of the first anchor of the curve
     - c1y (number) y of the first anchor of the curve
     - c2x (number) x of the second anchor of the curve
     - c2y (number) y of the second anchor of the curve
     - p2x (number) x of the second point of the curve
     - p2y (number) y of the second point of the curve
     * or
     - bez (array) array of six points for beziér curve
     = (object) bounding box
     o {
     o     x: (number) x coordinate of the left top point of the box,
     o     y: (number) y coordinate of the left top point of the box,
     o     x2: (number) x coordinate of the right bottom point of the box,
     o     y2: (number) y coordinate of the right bottom point of the box,
     o     width: (number) width of the box,
     o     height: (number) height of the box
     o }
    \*/
    Snap.path.bezierBBox = bezierBBox;
    /*\
     * Snap.path.isPointInsideBBox
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if given point is inside bounding box
     - bbox (string) bounding box
     - x (string) x coordinate of the point
     - y (string) y coordinate of the point
     = (boolean) `true` if point is inside
    \*/
    Snap.path.isPointInsideBBox = isPointInsideBBox;
    Snap.closest = function (x, y, X, Y) {
        var r = 100,
            b = box(x - r / 2, y - r / 2, r, r),
            inside = [],
            getter = X[0].hasOwnProperty("x") ? function (i) {
                return {
                    x: X[i].x,
                    y: X[i].y
                };
            } : function (i) {
                return {
                    x: X[i],
                    y: Y[i]
                };
            },
            found = 0;
        while (r <= 1e6 && !found) {
            for (var i = 0, ii = X.length; i < ii; i++) {
                var xy = getter(i);
                if (isPointInsideBBox(b, xy.x, xy.y)) {
                    found++;
                    inside.push(xy);
                    break;
                }
            }
            if (!found) {
                r *= 2;
                b = box(x - r / 2, y - r / 2, r, r)
            }
        }
        if (r == 1e6) {
            return;
        }
        var len = Infinity,
            res;
        for (i = 0, ii = inside.length; i < ii; i++) {
            var l = Snap.len(x, y, inside[i].x, inside[i].y);
            if (len > l) {
                len = l;
                inside[i].len = l;
                res = inside[i];
            }
        }
        return res;
    };
    /*\
     * Snap.path.isBBoxIntersect
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if two bounding boxes intersect
     - bbox1 (string) first bounding box
     - bbox2 (string) second bounding box
     = (boolean) `true` if bounding boxes intersect
    \*/
    Snap.path.isBBoxIntersect = isBBoxIntersect;
    /*\
     * Snap.path.intersection
     [ method ]
     **
     * Utility method
     **
     * Finds intersections of two paths
     - path1 (string) path string
     - path2 (string) path string
     = (array) dots of intersection
     o [
     o     {
     o         x: (number) x coordinate of the point,
     o         y: (number) y coordinate of the point,
     o         t1: (number) t value for segment of path1,
     o         t2: (number) t value for segment of path2,
     o         segment1: (number) order number for segment of path1,
     o         segment2: (number) order number for segment of path2,
     o         bez1: (array) eight coordinates representing beziér curve for the segment of path1,
     o         bez2: (array) eight coordinates representing beziér curve for the segment of path2
     o     }
     o ]
    \*/
    Snap.path.intersection = pathIntersection;
    Snap.path.intersectionNumber = pathIntersectionNumber;
    /*\
     * Snap.path.isPointInside
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if given point is inside a given closed path.
     *
     * Note: fill mode doesn’t affect the result of this method.
     - path (string) path string
     - x (number) x of the point
     - y (number) y of the point
     = (boolean) `true` if point is inside the path
    \*/
    Snap.path.isPointInside = isPointInsidePath;
    /*\
     * Snap.path.getBBox
     [ method ]
     **
     * Utility method
     **
     * Returns the bounding box of a given path
     - path (string) path string
     = (object) bounding box
     o {
     o     x: (number) x coordinate of the left top point of the box,
     o     y: (number) y coordinate of the left top point of the box,
     o     x2: (number) x coordinate of the right bottom point of the box,
     o     y2: (number) y coordinate of the right bottom point of the box,
     o     width: (number) width of the box,
     o     height: (number) height of the box
     o }
    \*/
    Snap.path.getBBox = pathBBox;
    Snap.path.get = getPath;
    /*\
     * Snap.path.toRelative
     [ method ]
     **
     * Utility method
     **
     * Converts path coordinates into relative values
     - path (string) path string
     = (array) path string
    \*/
    Snap.path.toRelative = pathToRelative;
    /*\
     * Snap.path.toAbsolute
     [ method ]
     **
     * Utility method
     **
     * Converts path coordinates into absolute values
     - path (string) path string
     = (array) path string
    \*/
    Snap.path.toAbsolute = pathToAbsolute;
    /*\
     * Snap.path.toCubic
     [ method ]
     **
     * Utility method
     **
     * Converts path to a new path where all segments are cubic beziér curves
     - pathString (string|array) path string or array of segments
     = (array) array of segments
    \*/
    Snap.path.toCubic = path2curve;
    /*\
     * Snap.path.map
     [ method ]
     **
     * Transform the path string with the given matrix
     - path (string) path string
     - matrix (object) see @Matrix
     = (string) transformed path string
    \*/
    Snap.path.map = mapPath;
    Snap.path.toString = toString;
    Snap.path.clone = pathClone;
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var mmax = Math.max,
        mmin = Math.min;

    // Set
    var Set = function (items) {
        this.items = [];
	this.bindings = {};
        this.length = 0;
        this.type = "set";
        if (items) {
            for (var i = 0, ii = items.length; i < ii; i++) {
                if (items[i]) {
                    this[this.items.length] = this.items[this.items.length] = items[i];
                    this.length++;
                }
            }
        }
    },
    setproto = Set.prototype;
    /*\
     * Set.push
     [ method ]
     **
     * Adds each argument to the current set
     = (object) original element
    \*/
    setproto.push = function () {
        var item,
            len;
        for (var i = 0, ii = arguments.length; i < ii; i++) {
            item = arguments[i];
            if (item) {
                len = this.items.length;
                this[len] = this.items[len] = item;
                this.length++;
            }
        }
        return this;
    };
    /*\
     * Set.pop
     [ method ]
     **
     * Removes last element and returns it
     = (object) element
    \*/
    setproto.pop = function () {
        this.length && delete this[this.length--];
        return this.items.pop();
    };
    /*\
     * Set.forEach
     [ method ]
     **
     * Executes given function for each element in the set
     *
     * If the function returns `false`, the loop stops running.
     **
     - callback (function) function to run
     - thisArg (object) context object for the callback
     = (object) Set object
    \*/
    setproto.forEach = function (callback, thisArg) {
        for (var i = 0, ii = this.items.length; i < ii; i++) {
            if (callback.call(thisArg, this.items[i], i) === false) {
                return this;
            }
        }
        return this;
    };
    /*\
     * Set.animate
     [ method ]
     **
     * Animates each element in set in sync.
     *
     **
     - attrs (object) key-value pairs of destination attributes
     - duration (number) duration of the animation in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function that executes when the animation ends
     * or
     - animation (array) array of animation parameter for each element in set in format `[attrs, duration, easing, callback]`
     > Usage
     | // animate all elements in set to radius 10
     | set.animate({r: 10}, 500, mina.easein);
     | // or
     | // animate first element to radius 10, but second to radius 20 and in different time
     | set.animate([{r: 10}, 500, mina.easein], [{r: 20}, 1500, mina.easein]);
     = (Element) the current element
    \*/
    setproto.animate = function (attrs, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = mina.linear;
        }
        if (attrs instanceof Snap._.Animation) {
            callback = attrs.callback;
            easing = attrs.easing;
            ms = easing.dur;
            attrs = attrs.attr;
        }
        var args = arguments;
        if (Snap.is(attrs, "array") && Snap.is(args[args.length - 1], "array")) {
            var each = true;
        }
        var begin,
            handler = function () {
                if (begin) {
                    this.b = begin;
                } else {
                    begin = this.b;
                }
            },
            cb = 0,
            set = this,
            callbacker = callback && function () {
                if (++cb == set.length) {
                    callback.call(this);
                }
            };
        return this.forEach(function (el, i) {
            eve.once("snap.animcreated." + el.id, handler);
            if (each) {
                args[i] && el.animate.apply(el, args[i]);
            } else {
                el.animate(attrs, ms, easing, callbacker);
            }
        });
    };
    setproto.remove = function () {
        while (this.length) {
            this.pop().remove();
        }
        return this;
    };
    /*\
     * Set.bind
     [ method ]
     **
     * Specifies how to handle a specific attribute when applied
     * to a set.
     *
     **
     - attr (string) attribute name
     - callback (function) function to run
     * or
     - attr (string) attribute name
     - element (Element) specific element in the set to apply the attribute to
     * or
     - attr (string) attribute name
     - element (Element) specific element in the set to apply the attribute to
     - eattr (string) attribute on the element to bind the attribute to
     = (object) Set object
    \*/
    setproto.bind = function (attr, a, b) {
        var data = {};
        if (typeof a == "function") {
            this.bindings[attr] = a;
        } else {
            var aname = b || attr;
            this.bindings[attr] = function (v) {
                data[aname] = v;
                a.attr(data);
            };
        }
        return this;
    };
    setproto.attr = function (value) {
        var unbound = {};
        for (var k in value) {
            if (this.bindings[k]) {
                this.bindings[k](value[k]);
            } else {
                unbound[k] = value[k];
            }
        }
        for (var i = 0, ii = this.items.length; i < ii; i++) {
            this.items[i].attr(unbound);
        }
        return this;
    };
    /*\
     * Set.clear
     [ method ]
     **
     * Removes all elements from the set
    \*/
    setproto.clear = function () {
        while (this.length) {
            this.pop();
        }
    };
    /*\
     * Set.splice
     [ method ]
     **
     * Removes range of elements from the set
     **
     - index (number) position of the deletion
     - count (number) number of element to remove
     - insertion… (object) #optional elements to insert
     = (object) set elements that were deleted
    \*/
    setproto.splice = function (index, count, insertion) {
        index = index < 0 ? mmax(this.length + index, 0) : index;
        count = mmax(0, mmin(this.length - index, count));
        var tail = [],
            todel = [],
            args = [],
            i;
        for (i = 2; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        for (i = 0; i < count; i++) {
            todel.push(this[index + i]);
        }
        for (; i < this.length - index; i++) {
            tail.push(this[index + i]);
        }
        var arglen = args.length;
        for (i = 0; i < arglen + tail.length; i++) {
            this.items[index + i] = this[index + i] = i < arglen ? args[i] : tail[i - arglen];
        }
        i = this.items.length = this.length -= count - arglen;
        while (this[i]) {
            delete this[i++];
        }
        return new Set(todel);
    };
    /*\
     * Set.exclude
     [ method ]
     **
     * Removes given element from the set
     **
     - element (object) element to remove
     = (boolean) `true` if object was found and removed from the set
    \*/
    setproto.exclude = function (el) {
        for (var i = 0, ii = this.length; i < ii; i++) if (this[i] == el) {
            this.splice(i, 1);
            return true;
        }
        return false;
    };
    setproto.insertAfter = function (el) {
        var i = this.items.length;
        while (i--) {
            this.items[i].insertAfter(el);
        }
        return this;
    };
    setproto.getBBox = function () {
        var x = [],
            y = [],
            x2 = [],
            y2 = [];
        for (var i = this.items.length; i--;) if (!this.items[i].removed) {
            var box = this.items[i].getBBox();
            x.push(box.x);
            y.push(box.y);
            x2.push(box.x + box.width);
            y2.push(box.y + box.height);
        }
        x = mmin.apply(0, x);
        y = mmin.apply(0, y);
        x2 = mmax.apply(0, x2);
        y2 = mmax.apply(0, y2);
        return {
            x: x,
            y: y,
            x2: x2,
            y2: y2,
            width: x2 - x,
            height: y2 - y,
            cx: x + (x2 - x) / 2,
            cy: y + (y2 - y) / 2
        };
    };
    setproto.clone = function (s) {
        s = new Set;
        for (var i = 0, ii = this.items.length; i < ii; i++) {
            s.push(this.items[i].clone());
        }
        return s;
    };
    setproto.toString = function () {
        return "Snap\u2018s set";
    };
    setproto.type = "set";
    // export
    Snap.Set = Set;
    Snap.set = function () {
        var set = new Set;
        if (arguments.length) {
            set.push.apply(set, Array.prototype.slice.call(arguments, 0));
        }
        return set;
    };
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var names = {},
        reUnit = /[a-z]+$/i,
        Str = String;
    names.stroke = names.fill = "colour";
    function getEmpty(item) {
        var l = item[0];
        switch (l.toLowerCase()) {
            case "t": return [l, 0, 0];
            case "m": return [l, 1, 0, 0, 1, 0, 0];
            case "r": if (item.length == 4) {
                return [l, 0, item[2], item[3]];
            } else {
                return [l, 0];
            }
            case "s": if (item.length == 5) {
                return [l, 1, 1, item[3], item[4]];
            } else if (item.length == 3) {
                return [l, 1, 1];
            } else {
                return [l, 1];
            }
        }
    }
    function equaliseTransform(t1, t2, getBBox) {
        t2 = Str(t2).replace(/\.{3}|\u2026/g, t1);
        t1 = Snap.parseTransformString(t1) || [];
        t2 = Snap.parseTransformString(t2) || [];
        var maxlength = Math.max(t1.length, t2.length),
            from = [],
            to = [],
            i = 0, j, jj,
            tt1, tt2;
        for (; i < maxlength; i++) {
            tt1 = t1[i] || getEmpty(t2[i]);
            tt2 = t2[i] || getEmpty(tt1);
            if ((tt1[0] != tt2[0]) ||
                (tt1[0].toLowerCase() == "r" && (tt1[2] != tt2[2] || tt1[3] != tt2[3])) ||
                (tt1[0].toLowerCase() == "s" && (tt1[3] != tt2[3] || tt1[4] != tt2[4]))
                ) {
                    t1 = Snap._.transform2matrix(t1, getBBox());
                    t2 = Snap._.transform2matrix(t2, getBBox());
                    from = [["m", t1.a, t1.b, t1.c, t1.d, t1.e, t1.f]];
                    to = [["m", t2.a, t2.b, t2.c, t2.d, t2.e, t2.f]];
                    break;
            }
            from[i] = [];
            to[i] = [];
            for (j = 0, jj = Math.max(tt1.length, tt2.length); j < jj; j++) {
                j in tt1 && (from[i][j] = tt1[j]);
                j in tt2 && (to[i][j] = tt2[j]);
            }
        }
        return {
            from: path2array(from),
            to: path2array(to),
            f: getPath(from)
        };
    }
    function getNumber(val) {
        return val;
    }
    function getUnit(unit) {
        return function (val) {
            return +val.toFixed(3) + unit;
        };
    }
    function getViewBox(val) {
        return val.join(" ");
    }
    function getColour(clr) {
        return Snap.rgb(clr[0], clr[1], clr[2]);
    }
    function getPath(path) {
        var k = 0, i, ii, j, jj, out, a, b = [];
        for (i = 0, ii = path.length; i < ii; i++) {
            out = "[";
            a = ['"' + path[i][0] + '"'];
            for (j = 1, jj = path[i].length; j < jj; j++) {
                a[j] = "val[" + (k++) + "]";
            }
            out += a + "]";
            b[i] = out;
        }
        return Function("val", "return Snap.path.toString.call([" + b + "])");
    }
    function path2array(path) {
        var out = [];
        for (var i = 0, ii = path.length; i < ii; i++) {
            for (var j = 1, jj = path[i].length; j < jj; j++) {
                out.push(path[i][j]);
            }
        }
        return out;
    }
    function isNumeric(obj) {
        return isFinite(parseFloat(obj));
    }
    function arrayEqual(arr1, arr2) {
        if (!Snap.is(arr1, "array") || !Snap.is(arr2, "array")) {
            return false;
        }
        return arr1.toString() == arr2.toString();
    }
    Element.prototype.equal = function (name, b) {
        return eve("snap.util.equal", this, name, b).firstDefined();
    };
    eve.on("snap.util.equal", function (name, b) {
        var A, B, a = Str(this.attr(name) || ""),
            el = this;
        if (isNumeric(a) && isNumeric(b)) {
            return {
                from: parseFloat(a),
                to: parseFloat(b),
                f: getNumber
            };
        }
        if (names[name] == "colour") {
            A = Snap.color(a);
            B = Snap.color(b);
            return {
                from: [A.r, A.g, A.b, A.opacity],
                to: [B.r, B.g, B.b, B.opacity],
                f: getColour
            };
        }
        if (name == "viewBox") {
            A = this.attr(name).vb.split(" ").map(Number);
            B = b.split(" ").map(Number);
            return {
                from: A,
                to: B,
                f: getViewBox
            };
        }
        if (name == "transform" || name == "gradientTransform" || name == "patternTransform") {
            if (b instanceof Snap.Matrix) {
                b = b.toTransformString();
            }
            if (!Snap._.rgTransform.test(b)) {
                b = Snap._.svgTransform2string(b);
            }
            return equaliseTransform(a, b, function () {
                return el.getBBox(1);
            });
        }
        if (name == "d" || name == "path") {
            A = Snap.path.toCubic(a, b);
            return {
                from: path2array(A[0]),
                to: path2array(A[1]),
                f: getPath(A[0])
            };
        }
        if (name == "points") {
            A = Str(a).split(Snap._.separator);
            B = Str(b).split(Snap._.separator);
            return {
                from: A,
                to: B,
                f: function (val) { return val; }
            };
        }
        var aUnit = a.match(reUnit),
            bUnit = Str(b).match(reUnit);
        if (aUnit && arrayEqual(aUnit, bUnit)) {
            return {
                from: parseFloat(a),
                to: parseFloat(b),
                f: getUnit(aUnit)
            };
        } else {
            return {
                from: this.asPX(name),
                to: this.asPX(name, b),
                f: getNumber
            };
        }
    });
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var elproto = Element.prototype,
    has = "hasOwnProperty",
    supportsTouch = "createTouch" in glob.doc,
    events = [
        "click", "dblclick", "mousedown", "mousemove", "mouseout",
        "mouseover", "mouseup", "touchstart", "touchmove", "touchend",
        "touchcancel"
    ],
    touchMap = {
        mousedown: "touchstart",
        mousemove: "touchmove",
        mouseup: "touchend"
    },
    getScroll = function (xy, el) {
        var name = xy == "y" ? "scrollTop" : "scrollLeft",
            doc = el && el.node ? el.node.ownerDocument : glob.doc;
        return doc[name in doc.documentElement ? "documentElement" : "body"][name];
    },
    preventDefault = function () {
        this.returnValue = false;
    },
    preventTouch = function () {
        return this.originalEvent.preventDefault();
    },
    stopPropagation = function () {
        this.cancelBubble = true;
    },
    stopTouch = function () {
        return this.originalEvent.stopPropagation();
    },
    addEvent = function (obj, type, fn, element) {
        var realName = supportsTouch && touchMap[type] ? touchMap[type] : type,
            f = function (e) {
                var scrollY = getScroll("y", element),
                    scrollX = getScroll("x", element);
                if (supportsTouch && touchMap[has](type)) {
                    for (var i = 0, ii = e.targetTouches && e.targetTouches.length; i < ii; i++) {
                        if (e.targetTouches[i].target == obj || obj.contains(e.targetTouches[i].target)) {
                            var olde = e;
                            e = e.targetTouches[i];
                            e.originalEvent = olde;
                            e.preventDefault = preventTouch;
                            e.stopPropagation = stopTouch;
                            break;
                        }
                    }
                }
                var x = e.clientX + scrollX,
                    y = e.clientY + scrollY;
                return fn.call(element, e, x, y);
            };

        if (type !== realName) {
            obj.addEventListener(type, f, false);
        }

        obj.addEventListener(realName, f, false);

        return function () {
            if (type !== realName) {
                obj.removeEventListener(type, f, false);
            }

            obj.removeEventListener(realName, f, false);
            return true;
        };
    },
    drag = [],
    dragMove = function (e) {
        var x = e.clientX,
            y = e.clientY,
            scrollY = getScroll("y"),
            scrollX = getScroll("x"),
            dragi,
            j = drag.length;
        while (j--) {
            dragi = drag[j];
            if (supportsTouch) {
                var i = e.touches && e.touches.length,
                    touch;
                while (i--) {
                    touch = e.touches[i];
                    if (touch.identifier == dragi.el._drag.id || dragi.el.node.contains(touch.target)) {
                        x = touch.clientX;
                        y = touch.clientY;
                        (e.originalEvent ? e.originalEvent : e).preventDefault();
                        break;
                    }
                }
            } else {
                e.preventDefault();
            }
            var node = dragi.el.node,
                o,
                next = node.nextSibling,
                parent = node.parentNode,
                display = node.style.display;
            // glob.win.opera && parent.removeChild(node);
            // node.style.display = "none";
            // o = dragi.el.paper.getElementByPoint(x, y);
            // node.style.display = display;
            // glob.win.opera && (next ? parent.insertBefore(node, next) : parent.appendChild(node));
            // o && eve("snap.drag.over." + dragi.el.id, dragi.el, o);
            x += scrollX;
            y += scrollY;
            eve("snap.drag.move." + dragi.el.id, dragi.move_scope || dragi.el, x - dragi.el._drag.x, y - dragi.el._drag.y, x, y, e);
        }
    },
    dragUp = function (e) {
        Snap.unmousemove(dragMove).unmouseup(dragUp);
        var i = drag.length,
            dragi;
        while (i--) {
            dragi = drag[i];
            dragi.el._drag = {};
            eve("snap.drag.end." + dragi.el.id, dragi.end_scope || dragi.start_scope || dragi.move_scope || dragi.el, e);
            eve.off("snap.drag.*." + dragi.el.id);
        }
        drag = [];
    };
    /*\
     * Element.click
     [ method ]
     **
     * Adds a click event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unclick
     [ method ]
     **
     * Removes a click event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.dblclick
     [ method ]
     **
     * Adds a double click event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.undblclick
     [ method ]
     **
     * Removes a double click event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.mousedown
     [ method ]
     **
     * Adds a mousedown event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmousedown
     [ method ]
     **
     * Removes a mousedown event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.mousemove
     [ method ]
     **
     * Adds a mousemove event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmousemove
     [ method ]
     **
     * Removes a mousemove event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.mouseout
     [ method ]
     **
     * Adds a mouseout event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmouseout
     [ method ]
     **
     * Removes a mouseout event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.mouseover
     [ method ]
     **
     * Adds a mouseover event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmouseover
     [ method ]
     **
     * Removes a mouseover event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.mouseup
     [ method ]
     **
     * Adds a mouseup event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.unmouseup
     [ method ]
     **
     * Removes a mouseup event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.touchstart
     [ method ]
     **
     * Adds a touchstart event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchstart
     [ method ]
     **
     * Removes a touchstart event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.touchmove
     [ method ]
     **
     * Adds a touchmove event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchmove
     [ method ]
     **
     * Removes a touchmove event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.touchend
     [ method ]
     **
     * Adds a touchend event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchend
     [ method ]
     **
     * Removes a touchend event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/

    /*\
     * Element.touchcancel
     [ method ]
     **
     * Adds a touchcancel event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    /*\
     * Element.untouchcancel
     [ method ]
     **
     * Removes a touchcancel event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/
    for (var i = events.length; i--;) {
        (function (eventName) {
            Snap[eventName] = elproto[eventName] = function (fn, scope) {
                if (Snap.is(fn, "function")) {
                    this.events = this.events || [];
                    this.events.push({
                        name: eventName,
                        f: fn,
                        unbind: addEvent(this.node || document, eventName, fn, scope || this)
                    });
                } else {
                    for (var i = 0, ii = this.events.length; i < ii; i++) if (this.events[i].name == eventName) {
                        try {
                            this.events[i].f.call(this);
                        } catch (e) {}
                    }
                }
                return this;
            };
            Snap["un" + eventName] =
            elproto["un" + eventName] = function (fn) {
                var events = this.events || [],
                    l = events.length;
                while (l--) if (events[l].name == eventName &&
                               (events[l].f == fn || !fn)) {
                    events[l].unbind();
                    events.splice(l, 1);
                    !events.length && delete this.events;
                    return this;
                }
                return this;
            };
        })(events[i]);
    }
    /*\
     * Element.hover
     [ method ]
     **
     * Adds hover event handlers to the element
     - f_in (function) handler for hover in
     - f_out (function) handler for hover out
     - icontext (object) #optional context for hover in handler
     - ocontext (object) #optional context for hover out handler
     = (object) @Element
    \*/
    elproto.hover = function (f_in, f_out, scope_in, scope_out) {
        return this.mouseover(f_in, scope_in).mouseout(f_out, scope_out || scope_in);
    };
    /*\
     * Element.unhover
     [ method ]
     **
     * Removes hover event handlers from the element
     - f_in (function) handler for hover in
     - f_out (function) handler for hover out
     = (object) @Element
    \*/
    elproto.unhover = function (f_in, f_out) {
        return this.unmouseover(f_in).unmouseout(f_out);
    };
    var draggable = [];
    // SIERRA unclear what _context_ refers to for starting, ending, moving the drag gesture.
    // SIERRA Element.drag(): _x position of the mouse_: Where are the x/y values offset from?
    // SIERRA Element.drag(): much of this member's doc appears to be duplicated for some reason.
    // SIERRA Unclear about this sentence: _Additionally following drag events will be triggered: drag.start.<id> on start, drag.end.<id> on end and drag.move.<id> on every move._ Is there a global _drag_ object to which you can assign handlers keyed by an element's ID?
    /*\
     * Element.drag
     [ method ]
     **
     * Adds event handlers for an element's drag gesture
     **
     - onmove (function) handler for moving
     - onstart (function) handler for drag start
     - onend (function) handler for drag end
     - mcontext (object) #optional context for moving handler
     - scontext (object) #optional context for drag start handler
     - econtext (object) #optional context for drag end handler
     * Additionaly following `drag` events are triggered: `drag.start.<id>` on start,
     * `drag.end.<id>` on end and `drag.move.<id>` on every move. When element is dragged over another element
     * `drag.over.<id>` fires as well.
     *
     * Start event and start handler are called in specified context or in context of the element with following parameters:
     o x (number) x position of the mouse
     o y (number) y position of the mouse
     o event (object) DOM event object
     * Move event and move handler are called in specified context or in context of the element with following parameters:
     o dx (number) shift by x from the start point
     o dy (number) shift by y from the start point
     o x (number) x position of the mouse
     o y (number) y position of the mouse
     o event (object) DOM event object
     * End event and end handler are called in specified context or in context of the element with following parameters:
     o event (object) DOM event object
     = (object) @Element
    \*/
    elproto.drag = function (onmove, onstart, onend, move_scope, start_scope, end_scope) {
        var el = this;
        if (!arguments.length) {
            var origTransform;
            return el.drag(function (dx, dy) {
                this.attr({
                    transform: origTransform + (origTransform ? "T" : "t") + [dx, dy]
                });
            }, function () {
                origTransform = this.transform().local;
            });
        }
        function start(e, x, y) {
            (e.originalEvent || e).preventDefault();
            el._drag.x = x;
            el._drag.y = y;
            el._drag.id = e.identifier;
            !drag.length && Snap.mousemove(dragMove).mouseup(dragUp);
            drag.push({el: el, move_scope: move_scope, start_scope: start_scope, end_scope: end_scope});
            onstart && eve.on("snap.drag.start." + el.id, onstart);
            onmove && eve.on("snap.drag.move." + el.id, onmove);
            onend && eve.on("snap.drag.end." + el.id, onend);
            eve("snap.drag.start." + el.id, start_scope || move_scope || el, x, y, e);
        }
        function init(e, x, y) {
            eve("snap.draginit." + el.id, el, e, x, y);
        }
        eve.on("snap.draginit." + el.id, start);
        el._drag = {};
        draggable.push({el: el, start: start, init: init});
        el.mousedown(init);
        return el;
    };
    /*
     * Element.onDragOver
     [ method ]
     **
     * Shortcut to assign event handler for `drag.over.<id>` event, where `id` is the element's `id` (see @Element.id)
     - f (function) handler for event, first argument would be the element you are dragging over
    \*/
    // elproto.onDragOver = function (f) {
    //     f ? eve.on("snap.drag.over." + this.id, f) : eve.unbind("snap.drag.over." + this.id);
    // };
    /*\
     * Element.undrag
     [ method ]
     **
     * Removes all drag event handlers from the given element
    \*/
    elproto.undrag = function () {
        var i = draggable.length;
        while (i--) if (draggable[i].el == this) {
            this.unmousedown(draggable[i].init);
            draggable.splice(i, 1);
            eve.unbind("snap.drag.*." + this.id);
            eve.unbind("snap.draginit." + this.id);
        }
        !draggable.length && Snap.unmousemove(dragMove).unmouseup(dragUp);
        return this;
    };
});

// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob) {
    var elproto = Element.prototype,
        pproto = Paper.prototype,
        rgurl = /^\s*url\((.+)\)/,
        Str = String,
        $ = Snap._.$;
    Snap.filter = {};
    /*\
     * Paper.filter
     [ method ]
     **
     * Creates a `<filter>` element
     **
     - filstr (string) SVG fragment of filter provided as a string
     = (object) @Element
     * Note: It is recommended to use filters embedded into the page inside an empty SVG element.
     > Usage
     | var f = paper.filter('<feGaussianBlur stdDeviation="2"/>'),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/
    pproto.filter = function (filstr) {
        var paper = this;
        if (paper.type != "svg") {
            paper = paper.paper;
        }
        var f = Snap.parse(Str(filstr)),
            id = Snap._.id(),
            width = paper.node.offsetWidth,
            height = paper.node.offsetHeight,
            filter = $("filter");
        $(filter, {
            id: id,
            filterUnits: "userSpaceOnUse"
        });
        filter.appendChild(f.node);
        paper.defs.appendChild(filter);
        return new Element(filter);
    };

    eve.on("snap.util.getattr.filter", function () {
        eve.stop();
        var p = $(this.node, "filter");
        if (p) {
            var match = Str(p).match(rgurl);
            return match && Snap.select(match[1]);
        }
    });
    eve.on("snap.util.attr.filter", function (value) {
        if (value instanceof Element && value.type == "filter") {
            eve.stop();
            var id = value.node.id;
            if (!id) {
                $(value.node, {id: value.id});
                id = value.id;
            }
            $(this.node, {
                filter: Snap.url(id)
            });
        }
        if (!value || value == "none") {
            eve.stop();
            this.node.removeAttribute("filter");
        }
    });
    /*\
     * Snap.filter.blur
     [ method ]
     **
     * Returns an SVG markup string for the blur filter
     **
     - x (number) amount of horizontal blur, in pixels
     - y (number) #optional amount of vertical blur, in pixels
     = (string) filter representation
     > Usage
     | var f = paper.filter(Snap.filter.blur(5, 10)),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/
    Snap.filter.blur = function (x, y) {
        if (x == null) {
            x = 2;
        }
        var def = y == null ? x : [x, y];
        return Snap.format('\<feGaussianBlur stdDeviation="{def}"/>', {
            def: def
        });
    };
    Snap.filter.blur.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.shadow
     [ method ]
     **
     * Returns an SVG markup string for the shadow filter
     **
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - blur (number) #optional amount of blur
     - color (string) #optional color of the shadow
     - opacity (number) #optional `0..1` opacity of the shadow
     * or
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - color (string) #optional color of the shadow
     - opacity (number) #optional `0..1` opacity of the shadow
     * which makes blur default to `4`. Or
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - opacity (number) #optional `0..1` opacity of the shadow
     = (string) filter representation
     > Usage
     | var f = paper.filter(Snap.filter.shadow(0, 2, 3)),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/
    Snap.filter.shadow = function (dx, dy, blur, color, opacity) {
        if (typeof blur == "string") {
            color = blur;
            opacity = color;
            blur = 4;
        }
        if (typeof color != "string") {
            opacity = color;
            color = "#000";
        }
        color = color || "#000";
        if (blur == null) {
            blur = 4;
        }
        if (opacity == null) {
            opacity = 1;
        }
        if (dx == null) {
            dx = 0;
            dy = 2;
        }
        if (dy == null) {
            dy = dx;
        }
        color = Snap.color(color);
        return Snap.format('<feGaussianBlur in="SourceAlpha" stdDeviation="{blur}"/><feOffset dx="{dx}" dy="{dy}" result="offsetblur"/><feFlood flood-color="{color}"/><feComposite in2="offsetblur" operator="in"/><feComponentTransfer><feFuncA type="linear" slope="{opacity}"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>', {
            color: color,
            dx: dx,
            dy: dy,
            blur: blur,
            opacity: opacity
        });
    };
    Snap.filter.shadow.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.grayscale
     [ method ]
     **
     * Returns an SVG markup string for the grayscale filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.grayscale = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {b} {h} 0 0 0 0 0 1 0"/>', {
            a: 0.2126 + 0.7874 * (1 - amount),
            b: 0.7152 - 0.7152 * (1 - amount),
            c: 0.0722 - 0.0722 * (1 - amount),
            d: 0.2126 - 0.2126 * (1 - amount),
            e: 0.7152 + 0.2848 * (1 - amount),
            f: 0.0722 - 0.0722 * (1 - amount),
            g: 0.2126 - 0.2126 * (1 - amount),
            h: 0.0722 + 0.9278 * (1 - amount)
        });
    };
    Snap.filter.grayscale.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.sepia
     [ method ]
     **
     * Returns an SVG markup string for the sepia filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.sepia = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {h} {i} 0 0 0 0 0 1 0"/>', {
            a: 0.393 + 0.607 * (1 - amount),
            b: 0.769 - 0.769 * (1 - amount),
            c: 0.189 - 0.189 * (1 - amount),
            d: 0.349 - 0.349 * (1 - amount),
            e: 0.686 + 0.314 * (1 - amount),
            f: 0.168 - 0.168 * (1 - amount),
            g: 0.272 - 0.272 * (1 - amount),
            h: 0.534 - 0.534 * (1 - amount),
            i: 0.131 + 0.869 * (1 - amount)
        });
    };
    Snap.filter.sepia.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.saturate
     [ method ]
     **
     * Returns an SVG markup string for the saturate filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.saturate = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feColorMatrix type="saturate" values="{amount}"/>', {
            amount: 1 - amount
        });
    };
    Snap.filter.saturate.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.hueRotate
     [ method ]
     **
     * Returns an SVG markup string for the hue-rotate filter
     **
     - angle (number) angle of rotation
     = (string) filter representation
    \*/
    Snap.filter.hueRotate = function (angle) {
        angle = angle || 0;
        return Snap.format('<feColorMatrix type="hueRotate" values="{angle}"/>', {
            angle: angle
        });
    };
    Snap.filter.hueRotate.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.invert
     [ method ]
     **
     * Returns an SVG markup string for the invert filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.invert = function (amount) {
        if (amount == null) {
            amount = 1;
        }
//        <feColorMatrix type="matrix" values="-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0" color-interpolation-filters="sRGB"/>
        return Snap.format('<feComponentTransfer><feFuncR type="table" tableValues="{amount} {amount2}"/><feFuncG type="table" tableValues="{amount} {amount2}"/><feFuncB type="table" tableValues="{amount} {amount2}"/></feComponentTransfer>', {
            amount: amount,
            amount2: 1 - amount
        });
    };
    Snap.filter.invert.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.brightness
     [ method ]
     **
     * Returns an SVG markup string for the brightness filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.brightness = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}"/><feFuncG type="linear" slope="{amount}"/><feFuncB type="linear" slope="{amount}"/></feComponentTransfer>', {
            amount: amount
        });
    };
    Snap.filter.brightness.toString = function () {
        return this();
    };
    /*\
     * Snap.filter.contrast
     [ method ]
     **
     * Returns an SVG markup string for the contrast filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/
    Snap.filter.contrast = function (amount) {
        if (amount == null) {
            amount = 1;
        }
        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}" intercept="{amount2}"/><feFuncG type="linear" slope="{amount}" intercept="{amount2}"/><feFuncB type="linear" slope="{amount}" intercept="{amount2}"/></feComponentTransfer>', {
            amount: amount,
            amount2: .5 - amount / 2
        });
    };
    Snap.filter.contrast.toString = function () {
        return this();
    };
});

// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
Snap.plugin(function (Snap, Element, Paper, glob, Fragment) {
    var box = Snap._.box,
        is = Snap.is,
        firstLetter = /^[^a-z]*([tbmlrc])/i,
        toString = function () {
            return "T" + this.dx + "," + this.dy;
        };
    /*\
     * Element.getAlign
     [ method ]
     **
     * Returns shift needed to align the element relatively to given element.
     * If no elements specified, parent `<svg>` container will be used.
     - el (object) @optional alignment element
     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
     = (object|string) Object in format `{dx: , dy: }` also has a string representation as a transformation string
     > Usage
     | el.transform(el.getAlign(el2, "top"));
     * or
     | var dy = el.getAlign(el2, "top").dy;
    \*/
    Element.prototype.getAlign = function (el, way) {
        if (way == null && is(el, "string")) {
            way = el;
            el = null;
        }
        el = el || this.paper;
        var bx = el.getBBox ? el.getBBox() : box(el),
            bb = this.getBBox(),
            out = {};
        way = way && way.match(firstLetter);
        way = way ? way[1].toLowerCase() : "c";
        switch (way) {
            case "t":
                out.dx = 0;
                out.dy = bx.y - bb.y;
            break;
            case "b":
                out.dx = 0;
                out.dy = bx.y2 - bb.y2;
            break;
            case "m":
                out.dx = 0;
                out.dy = bx.cy - bb.cy;
            break;
            case "l":
                out.dx = bx.x - bb.x;
                out.dy = 0;
            break;
            case "r":
                out.dx = bx.x2 - bb.x2;
                out.dy = 0;
            break;
            default:
                out.dx = bx.cx - bb.cx;
                out.dy = 0;
            break;
        }
        out.toString = toString;
        return out;
    };
    /*\
     * Element.align
     [ method ]
     **
     * Aligns the element relatively to given one via transformation.
     * If no elements specified, parent `<svg>` container will be used.
     - el (object) @optional alignment element
     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
     = (object) this element
     > Usage
     | el.align(el2, "top");
     * or
     | el.align("middle");
    \*/
    Element.prototype.align = function (el, way) {
        return this.transform("..." + this.getAlign(el, way));
    };
});

module.exports = Snap


/***/ }),
/* 865 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	var fixedCss = css.replace(/url *\( *(.+?) *\)/g, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(630);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(631);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(632);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(633);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(634);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(635);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(636);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(637);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(638);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(639);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(640);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(641);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(642);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(643);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!../../sass-loader/lib/loader.js!./react-select.css", function() {
			var newContent = require("!!../../css-loader/index.js!../../sass-loader/lib/loader.js!./react-select.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(646);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(647);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(648);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(650);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(651);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(652);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(653);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(654);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(655);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(16)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/lib/loader.js!./styles.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjE3cHgiIGhlaWdodD0iMThweCIgdmlld0JveD0iMCAwIDE3IDE4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy42LjEgKDI2MzEzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT4zOTkwNkJGMy1BQUVBLTQ0RTgtOUMyQy03MEEzRjRERkNGQUQ8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlBsYXllckNvbnRyb2xzLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00MDYuMDAwMDAwLCAtNTkzLjAwMDAwMCkiIGZpbGw9IiNGRkZGRkYiPgogICAgICAgICAgICA8ZyBpZD0iRW50ZXJGdWxsU2NyZWVuIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0MDYuMDAwMDAwLCA1OTMuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCwxMS4wMTAyNTcyIEwwLjAwMDY5NDc4OTA4MiwxOCBMNywxNy45OTkzMDYzIEw3LDE3LjE4Njk4MTEgTDEuMzkwMjcyOTUsMTcuMTg2OTgxMSBMNi45OTk5OTk3NSwxMS41NzUwNzkxIEw2LjQyNDAxOTYxLDExIEwwLjgxNDI5MjgwNCwxNi42MTI1OTU3IEwwLjgxNDI5MjgwNCwxMS4wMTAyNTcyIEwwLDExLjAxMDI1NzIgWiIgaWQ9IkZpbGwtMTYiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMCwxMS4wMTAyNTcyIEwxMC4wMDA2OTQ4LDE4IEwxNywxNy45OTkzMDYzIEwxNywxNy4xODY5ODExIEwxMS4zOTAyNzMsMTcuMTg2OTgxMSBMMTYuOTk5OTk5OCwxMS41NzUwNzkxIEwxNi40MjQwMTk2LDExIEwxMC44MTQyOTI4LDE2LjYxMjU5NTcgTDEwLjgxNDI5MjgsMTEuMDEwMjU3MiBMMTAsMTEuMDEwMjU3MiBaIiBpZD0iRmlsbC0xNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMuNTAwMDAwLCAxNC41MDAwMDApIHNjYWxlKC0xLCAxKSB0cmFuc2xhdGUoLTEzLjUwMDAwMCwgLTE0LjUwMDAwMCkgIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCwwLjAxMDI1NzIxODYgTDAuMDAwNjk0Nzg5MDgyLDcgTDcsNi45OTkzMDYzIEw3LDYuMTg2OTgxMDkgTDEuMzkwMjcyOTUsNi4xODY5ODEwOSBMNi45OTk5OTk3NSwwLjU3NTA3OTA3NiBMNi40MjQwMTk2MSwxLjI2NzgzMjI4ZS0xMyBMMC44MTQyOTI4MDQsNS42MTI1OTU3MiBMMC44MTQyOTI4MDQsMC4wMTAyNTcyMTg2IEwwLDAuMDEwMjU3MjE4NiBaIiBpZD0iRmlsbC0xNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy41MDAwMDAsIDMuNTAwMDAwKSBzY2FsZSgxLCAtMSkgdHJhbnNsYXRlKC0zLjUwMDAwMCwgLTMuNTAwMDAwKSAiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMCwwLjAxMDI1NzIxODYgTDEwLjAwMDY5NDgsNyBMMTcsNi45OTkzMDYzIEwxNyw2LjE4Njk4MTA5IEwxMS4zOTAyNzMsNi4xODY5ODEwOSBMMTYuOTk5OTk5OCwwLjU3NTA3OTA3NiBMMTYuNDI0MDE5NiwxLjI2NzgzMjI4ZS0xMyBMMTAuODE0MjkyOCw1LjYxMjU5NTcyIEwxMC44MTQyOTI4LDAuMDEwMjU3MjE4NiBMMTAsMC4wMTAyNTcyMTg2IFoiIGlkPSJGaWxsLTE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMy41MDAwMDAsIDMuNTAwMDAwKSBzY2FsZSgtMSwgLTEpIHRyYW5zbGF0ZSgtMTMuNTAwMDAwLCAtMy41MDAwMDApICI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjExcHgiIGhlaWdodD0iMTVweCIgdmlld0JveD0iMCAwIDExIDE1IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy42LjEgKDI2MzEzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT45NTBEOEI5MC0yNUQ5LTQ1QkMtODFEMS05MzQ0NzU4MkEyRjk8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlBsYXllckNvbnRyb2xzLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTUuMDAwMDAwLCAtMTMxLjAwMDAwMCkiIGZpbGw9IiMwMDVCODEiPgogICAgICAgICAgICA8ZyBpZD0iUGF1c2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExNS4wMDAwMDAsIDEzMS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMTE5OSIgeD0iMCIgeT0iMCIgd2lkdGg9IjQiIGhlaWdodD0iMTUiPjwvcmVjdD4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMTE5OSIgeD0iNyIgeT0iMCIgd2lkdGg9IjQiIGhlaWdodD0iMTUiPjwvcmVjdD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjExcHgiIGhlaWdodD0iMTVweCIgdmlld0JveD0iMCAwIDExIDE1IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy42LjEgKDI2MzEzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT45NTBEOEI5MC0yNUQ5LTQ1QkMtODFEMS05MzQ0NzU4MkEyRjk8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlBsYXllckNvbnRyb2xzLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTUuMDAwMDAwLCAtMTMxLjAwMDAwMCkiIGZpbGw9IiNGRkZGRkYiPgogICAgICAgICAgICA8ZyBpZD0iUGF1c2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExNS4wMDAwMDAsIDEzMS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMTE5OSIgeD0iMCIgeT0iMCIgd2lkdGg9IjQiIGhlaWdodD0iMTUiPjwvcmVjdD4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMTE5OSIgeD0iNyIgeT0iMCIgd2lkdGg9IjQiIGhlaWdodD0iMTUiPjwvcmVjdD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjE0cHgiIGhlaWdodD0iMTlweCIgdmlld0JveD0iMCAwIDE0IDE5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy42LjEgKDI2MzEzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5ERUYzRjVEQy00MzI3LTQ4RTEtQjFCRS01NEYyMzYxQzc5QUU8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlBsYXllckNvbnRyb2xzLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTUuMDAwMDAwLCAtMTI5LjAwMDAwMCkiIGZpbGw9IiMwMDVCODEiPgogICAgICAgICAgICA8cGF0aCBkPSJNMTk1LDEyOSBMMjA5LDEzOC41IEwxOTUsMTQ4IEwxOTUsMTI5IFoiIGlkPSJQbGF5Ij48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjQ2cHgiIGhlaWdodD0iNDZweCIgdmlld0JveD0iMCAwIDQ2IDQ2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy43ICgyODE2OSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+MzA5OUExMkMtNEEzQS00RjJFLTgxQTUtNEREOEU5MUI3Q0I0PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJCdXR0b25zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDg5LjAwMDAwMCwgLTExNi4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9IlBsYXlJY29uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0OTAuMDAwMDAwLCAxMTcuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZWxsaXBzZSBpZD0iT3ZhbC02MyIgc3Ryb2tlPSIjRkZGRkZGIiBmaWxsLW9wYWNpdHk9IjAuMjAwMDAwMDAzIiBmaWxsPSIjMDAwMDAwIiBjeD0iMjIuMDUwNzYxNCIgY3k9IjIyLjE2OTA3MjIiIHJ4PSIyMi4wNTA3NjE0IiByeT0iMjIuMTY5MDcyMiI+PC9lbGxpcHNlPgogICAgICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSJGaWxsLTIiIGZpbGw9IiNGRkZGRkYiIHBvaW50cz0iMTkuMjk0NDE2MiAyOS42MjUwMjQ1IDE5LjI5NDQxNjIgMTQuNDM3MzI2IDI5LjAxMTkxMTIgMjIuMDMwNTA3NyAxOS4yOTQ0MTYyIDI5LjYyNTAyNDUiPjwvcG9seWxpbmU+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjE0cHgiIGhlaWdodD0iMTlweCIgdmlld0JveD0iMCAwIDE0IDE5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgMy42LjEgKDI2MzEzKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5ERUYzRjVEQy00MzI3LTQ4RTEtQjFCRS01NEYyMzYxQzc5QUU8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIHNrZXRjaHRvb2wuPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlBsYXllckNvbnRyb2xzLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xOTUuMDAwMDAwLCAtMTI5LjAwMDAwMCkiIGZpbGw9IiNGRkZGRkYiPgogICAgICAgICAgICA8cGF0aCBkPSJNMTk1LDEyOSBMMjA5LDEzOC41IEwxOTUsMTQ4IEwxOTUsMTI5IFoiIGlkPSJQbGF5Ij48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports = "data:application/font-woff;base64,d09GRk9UVE8AAAVkAAsAAAAAB1wAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABDRkYgAAABCAAAAi4AAAKbH/pWDkZGVE0AAAM4AAAAGgAAABxt0civR0RFRgAAA1QAAAAcAAAAIAAyAARPUy8yAAADcAAAAFIAAABgUBj/rmNtYXAAAAPEAAAAUAAAAWIiC0SwaGVhZAAABBQAAAAuAAAANgABMftoaGVhAAAERAAAABwAAAAkA+UCA2htdHgAAARgAAAADgAAAA4ESgBKbWF4cAAABHAAAAAGAAAABgAFUABuYW1lAAAEeAAAANwAAAFuBSeBwnBvc3QAAAVUAAAAEAAAACAAAwABeJw9ks9vEkEUx2cpWyeUoFYgNkHi2Wt7N3rVm3cTs3UVLC4LxIWEQvi1P3i7O1tYLJDAmlgKGEhQrsajf0j7J3jYTXrQWUrMJG+++b55n5e8NwwKBhHDMLv5kxT3ATEBxKBn3qOAl9zxHgb1MAPhHQgHkyF08Gr/L8B/Eb6zWnmCJ7AJVLubQOheArXvJ1A4EXi6j4I+Zg9F0QFKvsnlBCmXeve+sFEnb/nCptdtQ4QYhVFRAT1HrF8UQK/RL/SbmUbclsvGVFXRZKDHUE38cc4qpkbAAsuwiImvro+ufcfaOIQ6szlrmjRJDaKZKnbjN3GWKIbiIzRFUfCffuxxKOL+3LDlDVvx2TdxN84qZEsnhNBa6pgm2dAsnzbLsETdsmRFxUeHV4e+I2/ptN8TyqV8T3Dt29t7EYOuajVIw2y1Wy3M86w0zg/Fz2IvawmQAUHOVrPVfLkoScVynsqsTG0MGUs4z55nh3mnOJa+li+rl9WpPIcFfDubDeaDC+fLBdYN3QADzLauGfj4B6sZmq6CCpqmtSvF0qlUl2qf5AJIUCSlTqlb7lUG+LRfGzZGzZEyBgccMu6MuqPecNDvD4Y9Kjtj4gD+DsvKVMTcMdtqtZtmkzQstQvYje7Syep0PDSAhSOeHYXYWThEF//A/0YvYV1fSQtpKU5STtrhbQ444OtpKSWJIg3pOg8cBs7maTY1EZf07aq+hjWs7IWzdCYTGhb2CtZ47x+Uhx28AAB4nGNgYGBkAIJz765vANHnCyvqYTQAWnkHswAAeJxjYGRgYOADYgkGEGBiYARCFjAG8RgABHYAN3icY2BmYmCcwMDKwMHow5jGwMDgDqW/MkgytDAwMDGwcjKAQQMDAyOQUmCAgoA01xQGB4ZExUmMD/4/YNBjvP3/NgNEDQPjbbBKBQZGADfLDgsAAHicY2BgYGaAYBkGRgYQiAHyGMF8FgYHIM3DwMHABGQzMCQqKClOUJz0/z9YHRLv/+L7D+8V3cuHmgAHjGwM6ELUByxUMIOZCmbgAAA5LQ8XeJxjYGRgYABiO68w73h+m68M3EwMIHC+sKIeTqsyqDLeZrwN5HIwgKUB/aYJUgAAeJxjYGRgYLzNwMCgx8QAAkA2IwMqYAIAMGIB7QIAAAACAAAlACUAJQAlAAAAAFAAAAUAAHicbY49asNAEIU/2ZJDfkiRIvXapUFCEqpcptABUrg3ZhEiQoKVfY9UqVLlGDlADpAT5e16IUWysMz3hjfzBrjjjQT/EjKpCy+4YhN5yZoxcirPe+SMWz4jr6S+5UzSa3VuwpTnBfc8RF7yxDZyKs9r5IxHPiKv1P9iZqDnyAvMQ39UecbScVb/gJO03Xk4CFom3XYK1clhMdQUlKo7/d9NF13RkIdfy+MV7TSe2sl11tRFaXYmJKpWTd7kdVnJ8veevZKc+n3I93t9Jnvr5n4aTVWU/0z9AI2qMkV4nGNgZkAGjAxoAAAAjgAF"

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAAAAXNSR0IArs4c6QAAAU5JREFUWAljZCAEarcYM/z/s5aQMgrk37MQ1MzMwM7wh0GeoDryFfAwka+XejpHHQELy0EREoQTphDTWYZPrAowVxNF//kTzPD3fzfDfwaiPMlIlKGkKKrbGM/w//88Yh0ANPotUS4l2g2kOwBsNPUcQdgB73F5hjqOIOQARoZ3DCzMQbRzBDEOYGB0YWDjvEwbRxDrgGb/87gcABInPzqo5ADyHUFFB5DnCCo7gHRH0MABpDmCRg4g3hE0dABxjqCxAwg7gg4OwO8IOjkAtyPo6ADsjqCzA0COQG1Z0dIBPL++MPxgTANZigoYfyBaVrR0AKqtGDyII+o2OzP8/7sLZ5MM1B4AVccEakMM04kUgNSi0pKHgJZswKqHxg4A2YmIjplnWBmePF0BbKQiWkB0cACqI0A8ZIfQyQGYjkA4ZAaQOYVWaQBkzSjAFgIAOi3GFPcP+E0AAAAASUVORK5CYII="

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(627)
var ieee754 = __webpack_require__(686)
var isArray = __webpack_require__(712)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(863);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(63)))

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(314);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// infosite.bundle.js